const foodOn = {
    "FOODON_03306978": "whiting (headless, dressed)",
    "FOODON_03401078": "10000197 - desserts (perishable) (gs1 gpc)",
    "FOODON_03401269": "USDA Standard Reference food product type",
    "FOODON_03411093": "hanasaki crab",
    "FOODON_03413961": "shortfin scad",
    "FOODON_03309648": "common whitefish (fillets and bits, raw)",
    "FOODON_03413708": "bladder campion plant",
    "FOODON_03307827": "chicken (fried)",
    "FOODON_03316711": "cheese butterkase",
    "FOODON_03305741": "prune juice (made from dried prunes)",
    "NCBITaxon_30864": "Pomatomidae",
    "UBERON_0007379": "shelled egg",
    "FOODON_03541495": "14950 - cherries and similar- (efsa foodex2)",
    "CHEBI_24532": "organic heterocyclic compound",
    "FOODON_03305240": "pineapple juice (unsweetened)",
    "FOODON_03420229": "fruit, peel removed, core, pit or seed removed",
    "FOODON_03308602": "fish flakes",
    "FOODON_03542961": "29610 - nandu eggs (efsa foodex2)",
    "FOODON_03415076": "common mallow plant",
    "NCBITaxon_264213": "Lutjanus sanguineus",
    "FOODON_03412009": "scarlet runner bean plant",
    "FOODON_03414142": "blood cockle",
    "FOODON_03413550": "mogai clam",
    "FOODON_03311310": "obsolete: salmon smoked using hot-smoking nitrite-treated",
    "FOODON_03303694": "graddost cheese (semisoft, ripened)",
    "FOODON_00002217": "sage food product",
    "FOODON_03308443": "bluefin tuna (raw)",
    "FOODON_03411769": "chilipepper (fish)",
    "FOODON_03303626": "manhatten cocktail mix (nutritively and nonnutritively sweetened)",
    "NCBITaxon_34199": "Aloe vera",
    "FOODON_03400770": "082  secondary milk products (ls) (ccpr)",
    "FOODON_03544108": "41080 - mustard, hot (efsa foodex2)",
    "NCBITaxon_106559": "Malus mandshurica",
    "FOODON_03412113": "bivalve",
    "FOODON_03305713": "meat in red wine",
    "FOODON_03542720": "27200 - milk and dairy concentrate (efsa foodex2)",
    "GO_0015979": "photosynthesis",
    "FOODON_03316733": "tomato (pieces, canned)",
    "NCBITaxon_135217": "Congrinae",
    "FOODON_03310052": "palm kernel (feed)",
    "FOODON_03411150": "malabar nightshade plant",
    "FOODON_03510114": "no preservatives claim or use",
    "NCBITaxon_7811": "Mustelus",
    "FOODON_03316438": "nougat",
    "FOODON_03401360": "50132300 - eggs/eggs extracts (industrial process) (gs1 gpc)",
    "NCBITaxon_997025": "Nematalosa vlaminghi",
    "NCBITaxon_134618": "Alepocephalus bairdii",
    "FOODON_03316594": "fruit juice (high sugar content)",
    "FOODON_03401300": "multi-mineral supplement",
    "FOODON_03413862": "galathea gizzard shad",
    "NCBITaxon_2887": "Alariaceae",
    "FOODON_03307325": "trout (frozen)",
    "FOODON_03541291": "12910 - anise seed and similar- (efsa foodex2)",
    "FOODON_03317533": "angelica (glace)",
    "FOODON_03317536": "jam (made with sulfite fruit)",
    "FOODON_03401189": "10000064 - pate (perishable) (gs1 gpc)",
    "NCBITaxon_1699513": "Myrtoideae",
    "FOODON_03305082": "chocolate-flavored pecan fudge",
    "FOODON_03315266": "bakery product (non-yeast leavened)",
    "NCBITaxon_197206": "Procambarus acutus",
    "FOODON_03470172": "food storage with refrigerating agent process",
    "FOODON_03305785": "mixed fruit jam",
    "FOODON_03542292": "22920 - eel, australian (efsa foodex2)",
    "HANCESTRO_0343": "Kyrgyzstani",
    "NCBITaxon_8843": "Anser anser",
    "FOODON_03302931": "poultry feed",
    "FOODON_03540290": "02900 - marzipan pie (efsa foodex2)",
    "FOODON_03543485": "34850 - echinacea infusion leaves (efsa foodex2)",
    "FOODON_03414458": "advantame",
    "FOODON_03401506": "10005880 - minneolas and other tangelos (gs1 gpc)",
    "FOODON_03400978": "10000045 - chocolate and chocolate/sugar candy combinations - confectionery (gs1 gpc)",
    "FOODON_03540044": "00440 - rice grain, parboiled (efsa foodex2)",
    "IAO_0000414": "mass measurement datum",
    "FOODON_03540484": "04840 - indian mustards (efsa foodex2)",
    "CHEBI_51569": "N-acyl-amino acid",
    "FOODON_03401741": "10005950 - curubas (gs1 gpc)",
    "FOODON_03413199": "ponceau 4r, cochineal red a",
    "FOODON_03302986": "longhorn cheddar cheese (semisoft, part-skim)",
    "FOODON_03413728": "leaf celery plant",
    "FOODON_00001053": "fermented dairy food product",
    "NCBITaxon_30453": "Puffinus",
    "FOODON_03460257": "obsolete: soy protein added",
    "NCBITaxon_9793": "Equus asinus",
    "FOODON_03305367": "buckwheat food product",
    "FOODON_03309327": "wahoo (raw)",
    "FOODON_00002967": "African jointfir plant",
    "FOODON_03316976": "chub cured smoked",
    "NCBITaxon_33120": "Alkekengi officinarum",
    "HANCESTRO_0566": "undefined ancestry population",
    "FOODON_00003265": "fat",
    "FOODON_03316729": "pea (mature, processed, canned)",
    "FOODON_03302586": "butter biscuit",
    "PO_0025336": "transition phyllode leaf",
    "FOODON_03305380": "soft nougat candy",
    "FOODON_03310004": "soybean mass (fermented)",
    "FOODON_03540987": "09870 - topee tambu (efsa foodex2)",
    "FOODON_03306665": "soybean oil (hydrogenated)",
    "FOODON_03307126": "red variety sweet potato (whole, raw)",
    "NCBITaxon_52902": "Scophthalmidae",
    "FOODON_03542027": "20270 - duck liver (efsa foodex2)",
    "FOODON_00003242": "tabbouleh",
    "FOODON_03414066": "bullhead",
    "HANCESTRO_0392": "Spanish",
    "FOODON_03541139": "11390 - coconuts (efsa foodex2)",
    "FOODON_03308911": "argentine sea bass (raw)",
    "FOODON_03303540": "swiss cheese from switzerland",
    "FOODON_03414265": "red crowberry plant",
    "FOODON_03460220": "food parboiling process (grain)",
    "FOODON_03540893": "08930 - lemon balm (efsa foodex2)",
    "FOODON_03301123": "grape (whole, raw)",
    "FOODON_03541341": "13410 - cinnamon bark and similar- (efsa foodex2)",
    "FOODON_00003110": "mangosteen food product",
    "FOODON_03400682": "017  stalk and stem vegetables (vs) (ccpr)",
    "FOODON_03540600": "06000 - french beans (with pods) (efsa foodex2)",
    "NCBITaxon_61084": "Plecoglossus altivelis",
    "NCBITaxon_334977": "Scorpaena cardinalis",
    "FOODON_03541242": "12420 - oil palms kernels (efsa foodex2)",
    "FOODON_03305651": "ice milk bar",
    "FOODON_03544179": "41790 - food flavourings (efsa foodex2)",
    "FOODON_03510021": "animal as food consumer",
    "FOODON_03304713": "poppyseed fruit dressing",
    "NCBITaxon_219892": "Syzygium malaccense",
    "FOODON_03316709": "cheese freise",
    "NCBITaxon_223888": "Leucoraja naevus",
    "FOODON_03306220": "juniper berry (dried)",
    "FOODON_03543609": "36090 - peony infusion flowers (efsa foodex2)",
    "FOODON_03304723": "brown sugar syrup",
    "FOODON_03460352": "food extrusion process",
    "FOODON_03308326": "sild sardine in oil (smoked)",
    "FOODON_03544141": "41410 - chilli pickle (efsa foodex2)",
    "FOODON_03311845": "broad bean (cooked, canned)",
    "FOODON_03412225": "japanese spider crab",
    "FOODON_03414873": "asian swamp eel",
    "FOODON_03460179": "food ionizing irradiation process",
    "FOODON_03315265": "gravy mix (prepared)",
    "FOODON_00001632": "barley flour food product",
    "FOODON_00001940": "guava food product",
    "FOODON_03301796": "light whipping cream",
    "FOODON_03308442": "african pompano (raw)",
    "CHEBI_37142": "organoiodine compound",
    "GENEPIO_0002240": "za'atar",
    "FOODON_03413602": "velvet lobster",
    "NCBITaxon_251532": "Solen marginatus",
    "NCBITaxon_3688": "Salicaceae",
    "FOODON_03306821": "ham fat",
    "NCBITaxon_302047": "Seriola lalandi",
    "FOODON_03460263": "vegetable fat or oil",
    "FOODON_03510056": "sugars free food",
    "FOODON_03305699": "imitation bread crumb",
    "FOODON_03542570": "25700 - sea urchins and other echinoderms (efsa foodex2)",
    "FOODON_03530025": "fore shank",
    "FOODON_03400195": "malt beverage (us cfr)",
    "NCBITaxon_72101": "Sebastes saxicola",
    "NCBITaxon_117893": "Batoidea",
    "FOODON_03307378": "imitation lowfat dry milk (vitamins a and d added)",
    "FOODON_03309313": "cisco (raw)",
    "NCBITaxon_4012": "Rhus",
    "FOODON_03411240": "turbot",
    "FOODON_03411360": "acerola plant",
    "FOODON_03415092": "siberian ginseng plant",
    "FOODON_03541437": "14370 - blood oranges (efsa foodex2)",
    "FOODON_00001812": "diluted apple beverage",
    "NCBITaxon_26005": "Elaeocarpus",
    "FOODON_03302686": "french bread (loaf)",
    "FOODON_03411120": "bluefin tuna",
    "FOODON_03413737": "perennial wallrocket plant",
    "FOODON_03317279": "italian sausage (raw)",
    "NCBITaxon_76340": "Sciaenops ocellatus",
    "FOODON_03301945": "poultry (previously frozen, cooked)",
    "FOODON_03315459": "vegetable (smoked)",
    "NCBITaxon_58445": "Randia <eudicots>",
    "FOODON_03316225": "product intended for particular nutritional uses",
    "FOODON_03541646": "16460 - figs and similar- (efsa foodex2)",
    "FOODON_03540436": "04360 - tannia leaves (efsa foodex2)",
    "FOODON_03413406": "teosinte plant",
    "FOODON_00002719": "animal (gutted)",
    "HANCESTRO_0396": "Ukrainian",
    "FOODON_03530234": "hazard 6",
    "FOODON_03311543": "legume (whole, dried)",
    "FOODON_03306143": "lemon peel",
    "FOODON_03543408": "34080 - excelsa coffee beans (efsa foodex2)",
    "FOODON_03540888": "08880 - other species and hybrids of genus mentha, not elsewhere mentioned (efsa foodex2)",
    "FOODON_00002757": "adzuki bean (whole, dried)",
    "FOODON_03304617": "fruit juice (artificially sweetened, canned)",
    "FOODON_03414062": "gila trout",
    "FOODON_03541179": "11790 - linseeds (efsa foodex2)",
    "FOODON_03317534": "citrus peel (crystallized)",
    "BFO_0000180": "BFO CLIF specification label",
    "FOODON_03541394": "13940 - pink pepper fruit (efsa foodex2)",
    "FOODON_03412023": "field mushroom",
    "FOODON_03541802": "18020 - dried bananas (efsa foodex2)",
    "FOODON_03411126": "pacific salmon",
    "FOODON_03308894": "dogfish (sliced, smoked, packed in oil)",
    "HANCESTRO_0583": "Taiwanese Han",
    "FOODON_03306933": "paprika pepper (mild-flavored, pickled)",
    "FOODON_03412209": "king crab family",
    "NCBITaxon_59011": "Typha angustifolia",
    "FOODON_03490175": "aluminum can, drum or barrel",
    "FOODON_00002270": "sprat food product",
    "FOODON_03306287": "potato chip (flash-fried)",
    "FOODON_03411534": "yellowtail",
    "GAZ_00002562": "Province of British Columbia",
    "FOODON_03316971": "malt beverage",
    "FOODON_03311253": "obsolete: food, dietetic",
    "FOODON_03301339": "rice stick",
    "FOODON_03310340": "cassava meal",
    "FOODON_03490107": "bimetal container",
    "FOODON_03303004": "chicken broth",
    "FOODON_03302228": "orange and apple beverage base (food product)",
    "FOODON_03411326": "alaska pea plant",
    "FOODON_03530053": "grade of meat, mixture",
    "FOODON_03414375": "spiral-horned bovine",
    "FOODON_03309975": "filbert meal",
    "FOODON_03414114": "leaf-scale gulper shark",
    "FOODON_03306530": "mushroom with seafood (canned)",
    "CHEBI_60004": "mixture",
    "FOODON_00003095": "lovage food product",
    "FOODON_03303529": "cold-pack cheese food with pistachio nuts",
    "UBERON_0000463": "organism substance",
    "FOODON_03311112": "skipjack tuna packed in oil",
    "FOODON_03317073": "drink milk-derivative-based (with no added sugar)",
    "FOODON_03400432": "nutrient (codex)",
    "NCBITaxon_4120": "Ipomoea batatas",
    "FOODON_03317588": "dietary food supplement, tablet form",
    "FOODON_03311750": "potato french fry (cut, raw)",
    "FOODON_00003087": "jackfruit (whole, raw)",
    "FOODON_03542977": "29770 - boiled eggs (efsa foodex2)",
    "FOODON_00001723": "chewing gum food product",
    "FOODON_03301524": "agar food product",
    "FOODON_03310418": "dairy product (fermented)",
    "FOODON_03541426": "14260 - natsudaidais (efsa foodex2)",
    "FOODON_03400661": "13  derived products of plant origin (ccpr)",
    "FOODON_00001116": "water buffalo dairy food product",
    "FOODON_03412436": "bowfin",
    "UO_0000163": "mass percentage",
    "FOODON_03414383": "alaska plaice",
    "FOODON_03542451": "24510 - mackerel, chub (efsa foodex2)",
    "FOODON_03315661": "meat by-product (loaf)",
    "FOODON_03541517": "15170 - damsons (efsa foodex2)",
    "FOODON_03306130": "beverage base (lingonberry)",
    "FOODON_03542911": "29110 - cheese, cabrales (efsa foodex2)",
    "FOODON_03490330": "paper container, treated",
    "FOODON_03304884": "tomato (mashed, canned)",
    "FOODON_03308812": "green shrimp (headless, raw)",
    "FOODON_03401749": "10006270 - snow peas (gs1 gpc)",
    "FOODON_03311877": "barley (fermented)",
    "NCBITaxon_320394": "Genyonemus",
    "FOODON_03306859": "peanut (whole, dry roasted)",
    "FOODON_03544405": "44050 - watermelon flavour (efsa foodex2)",
    "FOODON_03315282": "snack (cheese- or sour cream-flavored)",
    "CHEBI_22723": "benzoic acids",
    "FOODON_03530060": "pink fish flesh",
    "FOODON_03307032": "sweet potato (candied, whole)",
    "FOODON_03543171": "31710 - juice, apple (efsa foodex2)",
    "FOODON_03543958": "39580 - pastas and rice (or other cereal) \u0096based dishes (efsa foodex2)",
    "FOODON_03413928": "atlantic mudskipper",
    "FOODON_03302453": "gluten flour",
    "FOODON_03400737": "030  meat (from mammals other than marine mammals) (mm) (ccpr)",
    "FOODON_03542721": "27210 - evaporated milk (liquid, unsweetened) (efsa foodex2)",
    "FOODON_03414348": "peruvian peppertree",
    "FOODON_03412524": "euryale plant",
    "FOODON_03411615": "spotted seatrout",
    "FOODON_03301304": "batter",
    "NCBITaxon_3621": "Rheum rhabarbarum",
    "FOODON_03412606": "striated fusilier",
    "FOODON_03543185": "31850 - juice, lemon (efsa foodex2)",
    "NCBITaxon_976": "Bacteroidetes",
    "FOODON_03544439": "44390 - flour treatment agent (efsa foodex2)",
    "FOODON_03306692": "cream pie filling",
    "NCBITaxon_71411": "Penaeus kerathurus",
    "FOODON_03411629": "rambutan tree",
    "NCBITaxon_129912": "Syngnathiformes",
    "FOODON_03500052": "obsolete: egg shell, food contact surface",
    "FOODON_03309837": "cottonseed (shelled)",
    "FOODON_03308792": "red grouper (raw)",
    "FOODON_03311415": "sherbet (dietary)",
    "FOODON_03311704": "oriental sauce",
    "NCBITaxon_48416": "Zoarces viviparus",
    "FOODON_03400464": "CIAA foodstuffs intended for particular nutritional uses",
    "FOODON_03541486": "14860 - medlars (efsa foodex2)",
    "NCBITaxon_4039": "Daucus carota",
    "PO_0007520": "root development stage",
    "FOODON_03540238": "02380 - biscuits, sweet, plain (efsa foodex2)",
    "FOODON_03317094": "preserved food for infant and young children",
    "FOODON_03520111": "aquaculture area",
    "FOODON_03401762": "10005956 - yellow dragonfruits (gs1 gpc)",
    "FOODON_03414879": "sleeper goby",
    "FOODON_03303127": "fish (artificially colored, smoked)",
    "FOODON_03311681": "margarine spread (low fat)",
    "FOODON_03541234": "12340 - baobab seeds (efsa foodex2)",
    "FOODON_03317261": "cream type product, canned",
    "FOODON_03311032": "cheese fat",
    "FOODON_03543593": "35930 - cowslip infusion flowers (efsa foodex2)",
    "FOODON_03308600": "crabmeat (pasteurized)",
    "FOODON_03315033": "carbonated beverage syrup base",
    "FOODON_00002465": "scone",
    "FOODON_03303150": "fortune cookie",
    "ENVO_01001308": "hydroform",
    "NCBITaxon_9685": "Felis catus",
    "CHEBI_48901": "thiazoles",
    "FOODON_00001078": "fermented soybean food product",
    "FOODON_03420165": "obsolete: fruit or seed",
    "FOODON_03400640": "CCFAC ready-to-eat savories",
    "NCBITaxon_195645": "Atheresthes evermanni",
    "FOODON_03540617": "06170 - mat bean (young pods) (efsa foodex2)",
    "CHEBI_33636": "bicyclic compound",
    "FOODON_03411724": "asparagus bean plant",
    "FOODON_03305034": "bonito fillet extract (food product)",
    "FOODON_03311778": "potato (peeled, cooked, mashed, refrigerated)",
    "FOODON_03541037": "10370 - monantha vetches (without pods) (efsa foodex2)",
    "FOODON_03520132": "antarctica - inland waters (fao major fishing area 08)",
    "FOODON_03400658": "10  invertebrate animals (ccpr)",
    "NCBITaxon_75067": "Rubus crataegifolius",
    "FOODON_03306135": "green pea soup with pork",
    "FOODON_00002018": "mandarin orange food product",
    "FOODON_03413480": "common verbena plant",
    "FOODON_03307370": "rice wine vinegar (food product)",
    "FOODON_03414891": "moonsoon river prawn",
    "FOODON_03540646": "06460 - wolfberries (efsa foodex2)",
    "FOODON_03411077": "brook trout",
    "CHEBI_28384": "vitamin K",
    "FOODON_00001289": "potato salad food product",
    "CHEBI_18140": "hydrogen halide",
    "NCBITaxon_31023": "Balistoidea",
    "FOODON_03311805": "rapeseed (whole, dried, genetically modified)",
    "NCBITaxon_248137": "Scomberomorus munroi",
    "FOODON_00002554": "tzimbalo melon pear",
    "FOODON_03412862": "silver dory",
    "FOODON_03544173": "41730 - dextrin (efsa foodex2)",
    "FOODON_03316168": "vegetable (white, frozen)",
    "FOODON_03541072": "10720 - broad beans (dry) (efsa foodex2)",
    "CHEBI_26218": "potassium salt",
    "FOODON_00002251": "soft candy food product",
    "FOODON_03540664": "06640 - okra and similar- (efsa foodex2)",
    "FOODON_03542838": "28380 - cheese, oltermanni (efsa foodex2)",
    "FOODON_03542316": "23160 - whitefishes or coregonus (efsa foodex2)",
    "HANCESTRO_0488": "Maldivian",
    "FOODON_03413456": "garden nasturtium plant",
    "CHEBI_35868": "hydroxy monocarboxylic acid",
    "FOODON_00002532": "naan",
    "FOODON_03412610": "ewe",
    "GAZ_00005853": "Jan Mayen",
    "FOODON_03540715": "07150 - celeriacs and similar- (efsa foodex2)",
    "FOODON_03304498": "coffee-flavored syrup",
    "FOODON_03544028": "40280 - prepared nut salad (efsa foodex2)",
    "FOODON_03541464": "14640 - tangors (efsa foodex2)",
    "NCBITaxon_134617": "Alepocephalus",
    "FOODON_03317226": "caviar (chilled)",
    "NCBITaxon_8022": "Oncorhynchus mykiss",
    "FOODON_03302355": "cracked wheat bread",
    "FOODON_03540463": "04630 - witloofs (efsa foodex2)",
    "FOODON_03541333": "13330 - myoga (efsa foodex2)",
    "CHEBI_68452": "azole",
    "FOODON_03315575": "mustard (reconstituted from powder)",
    "FOODON_03302933": "corn meal (enriched)",
    "FOODON_03311835": "virginia peanut (whole, roasted)",
    "FOODON_03309455": "imitation chicken-flavored soup mix",
    "FOODON_03311358": "black currant juice concentrated",
    "FOODON_03305716": "zuppa di pesce",
    "OBI_0001927": "specifies value of",
    "FOODON_03317643": "obsolete: food (solid)",
    "NCBITaxon_6458": "Haliotis sorenseni",
    "FOODON_03306788": "pizza with sausage (artificially sweetened)",
    "FOODON_03540565": "05650 - peach palm hearts (efsa foodex2)",
    "NCBITaxon_62752": "Pinus sibirica",
    "NCBITaxon_6605": "Cephalopoda",
    "FOODON_03540172": "01720 - croutons (efsa foodex2)",
    "FOODON_03401347": "50250800 - pome fruits (gs1 gpc)",
    "FOODON_03412733": "mirabelle plum plant",
    "FOODON_00001149": "confectionery food product",
    "FOODON_03310352": "cheese curd",
    "FOODON_03307997": "weakfish (raw)",
    "FOODON_03301913": "aloe juice (food product)",
    "FOODON_03401156": "50122200 - aquatic plants prepared/processed (gs1 gpc)",
    "GAZ_00009721": "Cocos Islands",
    "HANCESTRO_0315": "Hutterite",
    "FOODON_03540738": "07380 - daikon (efsa foodex2)",
    "FOODON_03414773": "horsfieldia plant",
    "FOODON_03307073": "bottling syrup",
    "FOODON_00001730": "chicory vegetable food product",
    "FOODON_03303410": "beverage base (dry)",
    "FOODON_03401502": "10005884 - limes (gs1 gpc)",
    "FOODON_03311610": "pork (cooked)",
    "FOODON_00003204": "utin lap plant",
    "FOODON_03309691": "wheat powder",
    "FOODON_03542855": "28550 - cheese, toma piemontese (efsa foodex2)",
    "FOODON_03543192": "31920 - juice, pomegranate (efsa foodex2)",
    "FOODON_03317341": "curing pickle poultry",
    "FOODON_03306650": "imitation grape punch (artificially flavored)",
    "FOODON_03411130": "english walnut tree",
    "FOODON_03412079": "bluegill",
    "NCBITaxon_3906": "Vicia faba",
    "FOODON_03541196": "11960 - mustard seeds and similar- (efsa foodex2)",
    "FOODON_03530281": "gold skin",
    "FOODON_03541044": "10440 - yardlong beans (without pods) (efsa foodex2)",
    "FOODON_03411191": "black pepper plant",
    "FOODON_03305238": "tropical fruit salad (canned)",
    "FOODON_03306171": "grapefruit juice (reconstituted, canned)",
    "FOODON_03460190": "pickling",
    "FOODON_03412354": "japanese littleneck clam",
    "FOODON_03311207": "fish stick breaded raw frozen",
    "NCBITaxon_9527": "Cercopithecidae",
    "FOODON_03317612": "balanced diet for special dietary use (pregnant and nursing mothers)",
    "FOODON_03401744": "10005952 - yellow maracujas (gs1 gpc)",
    "FOODON_03411215": "obsolete: algae, bacteria or fungus",
    "FOODON_03400901": "10000118 - tea - ready to drink (gs1 gpc)",
    "FOODON_03303737": "gum drop (artificially colored and flavored)",
    "FOODON_03413604": "juan fernandez rock lobster",
    "FOODON_03309489": "skim milk (pasteurized, homogenized)",
    "FOODON_03316919": "blood sausage",
    "FOODON_03411980": "deepbody thread herring",
    "FOODON_03412241": "cactus plant",
    "FOODON_03544319": "43190 - melon flavour (efsa foodex2)",
    "FOODON_03309104": "herring fillet (smoked, and vegetables)",
    "FOODON_03309851": "tea bun",
    "FOODON_03302980": "pecalloni cheese",
    "FOODON_03316861": "cheese monterey high moisture",
    "FOODON_03305001": "meat byproduct for animal food",
    "FOODON_03542519": "25190 - krill, planktonic crustaceans (efsa foodex2)",
    "FOODON_03317377": "pork with barbecue sauce",
    "FOODON_03412927": "caryophanales",
    "FOODON_03520149": "pacific, southwest (fao major fishing area 81)",
    "FOODON_03307782": "pork rind (fried)",
    "NCBITaxon_3497": "Morus <eudicots>",
    "FOODON_03306854": "potato (stuffed)",
    "FOODON_03310307": "oat creme",
    "FOODON_03316959": "noodle product (egg, enriched)",
    "FOODON_03411907": "lake whitefish",
    "FOODON_03543850": "38500 - meat stew (efsa foodex2)",
    "FOODON_03400435": "packing gas (codex)",
    "FOODON_03460238": "component separation process",
    "FOODON_03541258": "12580 - other oil fruits (efsa foodex2)",
    "FOODON_03306655": "puff pastry shortening",
    "FOODON_03317134": "solid food (prepared, ready for consumption)",
    "FOODON_03412781": "pitaya plant",
    "ENVO_01000352": "field",
    "FOODON_03543494": "34940 - goat\u00b4s rue infusion leaves (efsa foodex2)",
    "FOODON_03412746": "european rowan plant",
    "FOODON_03414345": "winter cress plant",
    "FOODON_03540818": "08180 - scotch bonnet mushrooms (efsa foodex2)",
    "FOODON_03542787": "27870 - cheese, banon (efsa foodex2)",
    "FOODON_03306743": "sheep milk (pasteurized)",
    "FOODON_03316944": "cheese blended pasteurized",
    "FOODON_03400991": "10000206 - fruit - prepared/processed (shelf stable) (gs1 gpc)",
    "FOODON_03414342": "savory plant",
    "CHEBI_29864": "mannitol",
    "FOODON_03306407": "diabetic mayonnaise",
    "FOODON_03414323": "silverskin onion plant",
    "OBI_0001933": "value specification",
    "HANCESTRO_0348": "Belarusian",
    "FOODON_03411974": "japanese pilchard",
    "FOODON_03414942": "corn smut",
    "ENVO_00002000": "slope",
    "NCBITaxon_4070": "Solanaceae",
    "FOODON_03311271": "port wine",
    "FOODON_03490420": "inner bag",
    "FOODON_03412335": "bar jack",
    "NCBITaxon_557010": "Melicoccus bijugatus",
    "NCBITaxon_7848": "Lamna",
    "FOODON_00002986": "fish steak",
    "FOODON_03401058": "50151500 - oils edible (gs1 gpc)",
    "FOODON_03540320": "03200 - wheat rolled grains (efsa foodex2)",
    "FOODON_03543067": "30670 - quince cheese (efsa foodex2)",
    "FOODON_03310177": "glucose syrup (hydrogenated)",
    "FOODON_03302378": "potato flour",
    "NCBITaxon_170351": "Mitragyna speciosa",
    "NCBITaxon_33392": "Holometabola",
    "FOODON_03542461": "24610 - smooth hounds (efsa foodex2)",
    "FOODON_03304797": "scrambled hen egg (frozen)",
    "NCBITaxon_7928": "Elops saurus",
    "FOODON_03317396": "lamb cut (fresh)",
    "NCBITaxon_540795": "Cestrum macrophyllum",
    "FOODON_03304799": "hen egg white (pasteurized, frozen)",
    "FOODON_03543562": "35620 - yellow sweet clover infusion leaves (efsa foodex2)",
    "FOODON_03413783": "potassium ascorbate",
    "FOODON_00001193": "fonio food product",
    "FOODON_03306690": "food (organically grown)",
    "FOODON_00001888": "fruit jelly food product",
    "FOODON_03316032": "baked good, fine, with a water activity of more than .65",
    "FOODON_03303855": "bel paese cheese",
    "FOODON_03542913": "29130 - cheese, gamonedo (efsa foodex2)",
    "FOODON_03317346": "poultry salad",
    "FOODON_03543430": "34300 - cocoa beans (fermented or dried) (efsa foodex2)",
    "NCBITaxon_4236": "Lactuca sativa",
    "FOODON_03540245": "02450 - sponge biscuits (efsa foodex2)",
    "UBERON_0002371": "bone marrow",
    "FOODON_03414416": "obsolete: cellulose",
    "FOODON_03543160": "31600 - mixed fruit juice (efsa foodex2)",
    "FOODON_03315483": "ziao-z pastry (case)",
    "FOODON_03520130": "oceania - inland waters (fao major fishing areas 06)",
    "FOODON_03308430": "atlantic round herring (raw)",
    "FOODON_03305528": "honey syrup",
    "FOODON_00002758": "adzuki bean (whole, raw)",
    "FOODON_03413551": "baughman ark",
    "NCBITaxon_8167": "Perca flavescens",
    "FOODON_03541713": "17130 - giant granadillas (efsa foodex2)",
    "FOODON_03411526": "obsolete: weakfish",
    "FOODON_03490144": "laminate bag or pouch",
    "NCBITaxon_23139": "Amelanchier",
    "FOODON_03530181": "fat content < 1%",
    "FOODON_00003386": "wild harvested plant",
    "FOODON_03540448": "04480 - swiss chards (efsa foodex2)",
    "PATO_0001693": "increased viscosity",
    "FOODON_03414888": "thresher shark",
    "FOODON_03490183": "plastic container, rigid or semirigid, tin-plated steel lid",
    "FOODON_03309109": "salmon herring",
    "FOODON_00002658": "food (textured)",
    "FOODON_00002799": "hen egg (poached)",
    "FOODON_03530072": "cheese rind (washed or brushed)",
    "FOODON_00002412": "pie (baked, frozen)",
    "FOODON_03544055": "40550 - salt, iodised (efsa foodex2)",
    "FOODON_03540574": "05740 - bulb vegetables (efsa foodex2)",
    "FOODON_00001933": "great northern bean food product",
    "FOODON_03302874": "vegetable oil spread",
    "FOODON_03308376": "giant freshwater prawn (raw)",
    "FOODON_03543346": "33460 - mixed beer drinks (efsa foodex2)",
    "FOODON_03411998": "decapod",
    "FOODON_03307443": "yogurt with fruit",
    "FOODON_00003089": "hickory nut (whole)",
    "FOODON_03543617": "36170 - sweet violet infusion flowers (efsa foodex2)",
    "FOODON_03543684": "36840 - lignum vitae (infusion bark, wood) (efsa foodex2)",
    "FOODON_03414077": "boar fish",
    "FOODON_03317223": "lumpfish roe (chilled)",
    "ENVO_01001684": "interface layer",
    "FOODON_00001960": "hungarian wax pepper pickle food product",
    "FOODON_00001913": "goat powdered milk food product",
    "FOODON_03542185": "21850 - frankfurter sausage (efsa foodex2)",
    "FOODON_03304111": "shoyu chicken sauce",
    "FOODON_03302842": "puffed wheat cereal",
    "FOODON_03310376": "sartapia bean (whole)",
    "FOODON_03308070": "menhaden (raw)",
    "FOODON_03412777": "water roseapple plant",
    "NCBITaxon_35500": "Pecora",
    "NCBITaxon_198234": "Palinurus gilchristi",
    "FOODON_03304863": "iced tea mix (grape-flavored)",
    "FOODON_03490163": "aluminum tray or pan, aluminum foil cover or wrapping",
    "FOODON_00002215": "rye cracker food product",
    "FOODON_03544469": "44690 - thaumatine (efsa foodex2)",
    "FOODON_03540332": "03320 - cereal bars (efsa foodex2)",
    "FOODON_03412301": "sand perch",
    "FOODON_03401793": "10006123 - celeriac (gs1 gpc)",
    "FOODON_03301182": "hollandaise sauce",
    "FOODON_03400686": "023  oilseed (so) (ccpr)",
    "FOODON_03316043": "food (heat treated)",
    "FOODON_03304378": "milk solids from milk byproducts",
    "FOODON_03310242": "parsnip (microwaved)",
    "FOODON_03490380": "plasticized polyvinyl chloride container",
    "FOODON_03412014": "medlar plant",
    "FOODON_03530059": "red fish flesh",
    "FOODON_03530136": "cuisse",
    "NCBITaxon_8020": "Oncorhynchus masou",
    "FOODON_03301120": "obsolete: silage",
    "NCBITaxon_88677": "Cyttus australis",
    "FOODON_03400929": "10000155 - baking/cooking mixes (frozen) (gs1 gpc)",
    "FOODON_00002323": "turmeric food product",
    "FOODON_03413443": "oca plant",
    "FOODON_03542948": "29480 - eggs and egg products (efsa foodex2)",
    "FOODON_03306275": "macaroni and cheese (prepared)",
    "FOODON_00002520": "O's cereal",
    "FOODON_03301869": "fruit-flavored beverage carbonated",
    "FOODON_03412111": "gastropod",
    "FOODON_03410001": "obsolete: food source not known (deprecated)",
    "FOODON_03307479": "toaster pastry",
    "FOODON_03302815": "coconut milk drink (chocolate-flavored)",
    "FOODON_03413251": "sodium ethyl p-hydroxybenzoate",
    "FOODON_03540612": "06120 - stink beans (with pods) (efsa foodex2)",
    "FOODON_03542997": "29970 - maltose (efsa foodex2)",
    "NCBITaxon_341934": "Citrus australis",
    "FOODON_03315448": "nori",
    "FOODON_03414420": "soybean hemicellulose",
    "FOODON_03414279": "pulaka plant",
    "FOODON_00001323": "pak sean and makhua dong",
    "FOODON_03305188": "noodle (enriched)",
    "ENVO_01000933": "residential building",
    "FOODON_03540174": "01740 - pasta, doughs and similar products (efsa foodex2)",
    "FOODON_03415138": "herb bennet plant",
    "FOODON_03305535": "honey spread",
    "FOODON_00002914": "fish, spariform",
    "FOODON_03541423": "14230 - citrus fruits (efsa foodex2)",
    "HANCESTRO_0534": "Gabonese",
    "CHEBI_15674": "2,3-dihydroxybutanedioic acid",
    "ENVO_00000023": "stream",
    "FOODON_03304298": "obsolete: white sugar (granulated)",
    "FOODON_03301740": "pasteurized process cheese (food product)",
    "FOODON_03306157": "imitation grape-flavored apple juice",
    "FOODON_03304105": "shrimp scampi (instant)",
    "NCBITaxon_116960": "Ursus arctos horribilis",
    "NCBITaxon_69296": "Tragelaphus buxtoni",
    "FOODON_03411542": "oregano plant",
    "FOODON_03302239": "lemonade (frozen concentrate)",
    "IAO_0000030": "information content entity",
    "FOODON_03307987": "blue catfish (raw)",
    "NCBITaxon_65557": "Alcea rosea",
    "FOODON_03401395": "50310000 - fruits - unprepared/unprocessed (shelf stable) (gs1 gpc)",
    "FOODON_03303768": "juice candy (powdered, in plastic bottle)",
    "FOODON_03311837": "cottonseed (whole, dried, genetically modified)",
    "UBERON_0009953": "post-embryonic organism",
    "FOODON_03543961": "39610 - pasta, plain (not stuffed), cooked (efsa foodex2)",
    "FOODON_03542670": "26700 - horse milk (efsa foodex2)",
    "PO_0025496": "multi-tissue plant structure",
    "FOODON_03401382": "50260400 - peppers (gs1 gpc)",
    "FOODON_03302360": "milk bread",
    "CHEBI_28017": "starch",
    "FOODON_03411219": "common oat plant",
    "FOODON_03413257": "sodium hydrogen malate",
    "NCBITaxon_490595": "Metanephrops sibogae",
    "FOODON_03311584": "tea (decaffeinated, flavored)",
    "FOODON_03414656": "apple berry plant",
    "FOODON_00001641": "berry juice",
    "FOODON_03411398": "walleye pike",
    "FOODON_03316516": "sour cream for butter making",
    "FOODON_03413979": "korean seerfish",
    "FOODON_03306904": "peanut butter (chunky)",
    "FOODON_03414639": "sea snail",
    "FOODON_03303629": "cocktail mix (nonnutritively sweetened)",
    "FOODON_00002705": "chicken liver",
    "FOODON_03401601": "10006045 - summer savoury (gs1 gpc)",
    "FOODON_03540192": "01920 - pasta, gluten free (efsa foodex2)",
    "FOODON_03302438": "nut butter",
    "FOODON_03401728": "10006257 - vegetable juice drinks - not ready to drink (shelf stable) (gs1 gpc)",
    "FOODON_03315045": "fruit juice (ready-to-serve, nonrefrigerated, pasteurized, aseptically packaged)",
    "FOODON_00001005": "fermenting elaeis palm sap food product",
    "FOODON_03302428": "grape juice (fermented, dealcoholized)",
    "FOODON_03401538": "10006202 - in-shell nest run eggs (gs1 gpc)",
    "FOODON_03317408": "fat or oil, nonemulsified",
    "CHEBI_33692": "hydrides",
    "FOODON_03310947": "turnip greens (canned)",
    "NCBITaxon_6829": "Nephrops norvegicus",
    "FOODON_03544009": "40090 - tomato soup (efsa foodex2)",
    "FOODON_03520126": "north america - inland waters (fao major fishing areas 02)",
    "FOODON_00002156": "plant stem or spear vegetable food product",
    "NCBITaxon_233713": "Mimusops",
    "FOODON_03310182": "soybean extract powdered",
    "NCBITaxon_30857": "Nemipteridae",
    "FOODON_03541651": "16510 - chinese black olives (efsa foodex2)",
    "FOODON_03301062": "honey (partially heat treated)",
    "FOODON_03541537": "15370 - strawberries and similar- (efsa foodex2)",
    "FOODON_03316146": "pudding tapioca",
    "FOODON_03301469": "bouillon cube",
    "FOODON_03411603": "white asparagus plant",
    "FOODON_03401494": "10005886 - clementines (gs1 gpc)",
    "FOODON_03542908": "29080 - firm-ripened blue mould-veined cheese (efsa foodex2)",
    "NCBITaxon_72100": "Sebastes rufus",
    "FOODON_00002727": "parakeet",
    "FOODON_03303698": "cold-pack cheese alcohol added",
    "FOODON_03309093": "argentine hake (raw)",
    "FOODON_03400675": "010  brassica (cole or cabbage) vegetables, head cabbage, flowerhead brassicas (vb) (ccpr)",
    "FOODON_03530123": "caparacon",
    "FOODON_03305033": "marjoram-flavored vinegar",
    "FOODON_03544105": "41050 - mustard and related sauces (efsa foodex2)",
    "FOODON_03544195": "41950 - banana flavour (efsa foodex2)",
    "CHEBI_25633": "octadecatrienoic acid",
    "HANCESTRO_0480": "Tokelauan",
    "FOODON_03315930": "preserves of red fruits",
    "FOODON_03301788": "mozzarella cheese (made with whole milk, natural)",
    "GAZ_00000458": "North America",
    "NCBITaxon_1489460": "Clupeoidei",
    "FOODON_03542062": "20620 - rabbit edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "FOODON_03306161": "grape juice cocktail",
    "FOODON_03411285": "common millet plant",
    "FOODON_03530261": "fat content, oil, fats and their products (eurocode2)",
    "FOODON_03401038": "50132500 - eggs/eggs substitutes (gs1 gpc)",
    "FOODON_00002025": "mate beverage",
    "FOODON_03308217": "california yellowtail (raw)",
    "FOODON_03414592": "assai palm plant",
    "FOODON_03411256": "spot croaker",
    "FOODON_03540673": "06730 - gherkins and similar- (efsa foodex2)",
    "FOODON_03304798": "hen egg (whole, fried, frozen)",
    "FOODON_03305275": "sweet cream (frozen)",
    "FOODON_03308748": "oyster (frozen on half-shell)",
    "FOODON_03520387": "subtropical fishing area",
    "FOODON_03311172": "buffalofish raw",
    "CHEBI_50263": "2-hydroxydicarboxylic acid",
    "FOODON_03315799": "corn for degermination",
    "FOODON_03309754": "yam bean - jicama tuber (whole, raw)",
    "FOODON_03305105": "obsolete: food (liquid)",
    "FOODON_03302349": "bread (cellulose added)",
    "FOODON_03306882": "chocolate-covered wafer candy bar",
    "NCBITaxon_195612": "Glyptocephalus zachirus",
    "FOODON_03540467": "04670 - ostrich fern (efsa foodex2)",
    "FOODON_00002094": "peach butter food product",
    "FOODON_03302333": "potato (peeled, cooked, mashed)",
    "FOODON_03309444": "codfish loaf",
    "FOODON_03411993": "african lungfish family",
    "FOODON_03309306": "chilean grunt (raw)",
    "FOODON_03400139": "multicomponent meal (us cfr)",
    "FOODON_00001867": "food dressing product",
    "FOODON_03401876": "10005908 - stemless/sweet cherries (gs1 gpc)",
    "FOODON_03411711": "capon",
    "FOODON_03412876": "japanese flat oyster",
    "NCBITaxon_1437180": "Acrogymnospermae",
    "FOODON_03490423": "closing cap or lid",
    "CHEBI_26836": "sulfuric acid",
    "FOODON_03414053": "lake geneva whitefish",
    "FOODON_03305869": "banana jam",
    "FOODON_03543308": "33080 - soft drink, grapefruit flavour (efsa foodex2)",
    "FOODON_03304210": "soup base flavored with beef extract",
    "FOODON_00002651": "dinner food",
    "FOODON_03301489": "thyme (ground)",
    "FOODON_03306314": "almond macaroon",
    "FOODON_03306785": "tomato for pizza (crushed)",
    "NCBITaxon_8160": "Seriola",
    "NCBITaxon_50282": "Centaurea benedicta",
    "FOODON_03307182": "honey (orange and lemon syrup)",
    "FOODON_03414892": "oriental river prawn",
    "CHEBI_18145": "(+)-alpha-tocopherol",
    "FOODON_03310244": "beef (grilled)",
    "HANCESTRO_0555": "Arab Israeli founder",
    "FOODON_00001814": "diluted fruit beverage",
    "FOODON_03307307": "wine (nonalcoholic)",
    "FOODON_03312058": "specialty sauce",
    "FOODON_03540752": "07520 - turnips (efsa foodex2)",
    "NCBITaxon_29710": "Dioscorea cayennensis",
    "FOODON_03543858": "38580 - meat balls (efsa foodex2)",
    "FOODON_03315670": "fig marmalade with pectin",
    "FOODON_03414872": "fish, synbranchiform",
    "FOODON_03543220": "32200 - other (mixed) fruit and vegetable juices or nectars (efsa foodex2)",
    "FOODON_03400300": "flavoring or flavor enhancer (us cfr)",
    "FOODON_03303867": "swiss cheese (unsalted)",
    "FOODON_03543851": "38510 - meat in aspic (efsa foodex2)",
    "FOODON_03520319": "neutral zone",
    "FOODON_03540113": "01130 - cereal germ (efsa foodex2)",
    "FOODON_03317470": "rote grutze (food product)",
    "NCBITaxon_304153": "Physalis minima",
    "FOODON_03413684": "giant catfishes",
    "FOODON_03500028": "Cryovac bag plastic surface",
    "FOODON_03400738": "031  mammalian fats (mf) (ccpr)",
    "NCBITaxon_8797": "Rhea americana",
    "FOODON_03500053": "obsolete: mollusc shell",
    "PATO_0002367": "castrated male",
    "FOODON_03542588": "25880 - turtles (efsa foodex2)",
    "FOODON_03315736": "poultry meat (dried, cooked)",
    "FOODON_03306262": "margarine (herb-flavored)",
    "FOODON_03310939": "beef chuck (raw)",
    "FOODON_03309435": "roughscale sole (raw)",
    "FOODON_00002122": "pinto bean food product",
    "hancestro_0034": "obsolete: Northern America",
    "FOODON_03301829": "orange juice concentrate (frozen, unsweetened)",
    "FOODON_00002915": "threadfin bream family",
    "FOODON_03413541": "donkeys ear abalone",
    "FOODON_03307211": "turtle egg (raw)",
    "FOODON_03308915": "herring in wine sauce concentrate",
    "UO_0010045": "metric cup",
    "FOODON_03308982": "black rockfish (raw)",
    "FOODON_03413386": "darnel plant",
    "FOODON_03540321": "03210 - porridge (in dry form, to be diluted) (efsa foodex2)",
    "NCBITaxon_117272": "Amaranthus hybridus subsp. cruentus",
    "FOODON_03412347": "brazilian pepper tree",
    "FOODON_03412647": "lemon sole",
    "FOODON_03308777": "keyhole limpet (raw)",
    "FOODON_03541485": "14850 - medlars and similar- (efsa foodex2)",
    "FOODON_03540128": "01280 - rye bread, wholemeal (efsa foodex2)",
    "FOODON_03411939": "argentine queenfish",
    "NCBITaxon_78532": "Trigonella",
    "FOODON_03307553": "strawberry-flavored jelly mix (instant, artificially sweetened)",
    "FOODON_00001615": "apricot food product",
    "FOODON_03411036": "floret used as vegetable",
    "FOODON_03315537": "bakery product (used in a similar way to bread)",
    "HANCESTRO_0504": "Cape Verdean",
    "FOODON_03308395": "halibut steak (breaded, frozen)",
    "NCBITaxon_56735": "Trachinidae",
    "NCBITaxon_237934": "Viburnum edule",
    "FOODON_03302832": "sauerkraut juice",
    "FOODON_03400132": "meat product analog (us cfr)",
    "FOODON_03414023": "diplectrum",
    "FOODON_03543462": "34620 - alpine ladies mantle infusion leaves (efsa foodex2)",
    "FOODON_03412045": "chamomile plant",
    "FOODON_03302473": "oatmeal bread",
    "FOODON_03309193": "angel shark (raw)",
    "FOODON_03311776": "clam (quahog, canned)",
    "FOODON_03413596": "neptune lobster",
    "FOODON_03415161": "sandy everlasting plant",
    "GAZ_00000565": "Morocco",
    "FOODON_03308416": "lobster bisque with langostino",
    "FOODON_03543745": "37450 - valerian root infusion (efsa foodex2)",
    "FOODON_03401385": "50262700 - sedges (gs1 gpc)",
    "FOODON_03411089": "red snapper",
    "GAZ_00002953": "Albania",
    "FOODON_03412530": "flathead",
    "FOODON_03540769": "07690 - brown algae (efsa foodex2)",
    "FOODON_03401202": "50172000 - seasonings/preservatives/extracts variety packs (gs1 gpc)",
    "NCBITaxon_24943": "Paeoniaceae",
    "FOODON_03308232": "australian herring (raw)",
    "FOODON_00002537": "potato wedges",
    "NCBITaxon_7969": "Catostomus",
    "FOODON_03411982": "gold-striped snapper",
    "FOODON_03311014": "beef top round roast (cooked)",
    "FOODON_03460177": "plant seed or nut food product",
    "FOODON_00001603": "animal product dressing",
    "FOODON_03411238": "turnip plant",
    "NCBITaxon_555479": "Nigella sativa",
    "FOODON_03414487": "spotted seal",
    "CHEBI_25835": "hexadecanoate ester",
    "FOODON_03307109": "doughnut (frozen)",
    "FOODON_03310629": "soy milk substitute (hypoallergenic)",
    "FOODON_03400258": "breakfast cereal (us cfr)",
    "FOODON_03540497": "04970 - other leafy brassica (c) (efsa foodex2)",
    "FOODON_03541480": "14800 - ya pears (efsa foodex2)",
    "FOODON_03412132": "filefish family",
    "FOODON_03412811": "mimusops plant",
    "FOODON_03540656": "06560 - rocoto capsicum (efsa foodex2)",
    "FOODON_00002033": "milk based topping food product",
    "FOODON_03308833": "spider crab (raw)",
    "FOODON_00002724": "nutritional powder",
    "NCBITaxon_164925": "Melaleuca",
    "FOODON_03414765": "elatostema plant",
    "FOODON_03414575": "posibacteria",
    "CHEBI_35341": "steroid",
    "FOODON_03304315": "confectioner's sugar (food product)",
    "FOODON_03400194": "pancake or waffle (us cfr)",
    "FOODON_03540024": "00240 - little millet grain (efsa foodex2)",
    "FOODON_03412886": "cardinalfish family",
    "FOODON_03307336": "coffee liqueur drink mix (dry)",
    "FOODON_03414104": "starry smooth-hound",
    "FOODON_03400449": "thickening agent (codex)",
    "FOODON_00001650": "black pepper food product",
    "FOODON_03310804": "pork (sliced, cooked)",
    "NCBITaxon_13329": "Achillea millefolium",
    "FOODON_03401348": "50250900 - stone fruit (gs1 gpc)",
    "FOODON_03317239": "obsolete: olive product",
    "FOODON_03306612": "grape and apple juice drink",
    "FOODON_03510190": "infant as food consumer, 3 - 6 months",
    "FOODON_03542278": "22780 - amur pike (efsa foodex2)",
    "FOODON_03315109": "baking mix (yeast leavened)",
    "FOODON_03414113": "gulper shark",
    "FOODON_03305527": "wheat germ (honey-coated)",
    "FOODON_03306442": "shepherd's pie filling",
    "FOODON_03304876": "sesame seed (hulled)",
    "FOODON_03301811": "fruit jelly",
    "FOODON_03307633": "turnip (whole, raw)",
    "FOODON_03541101": "11010 - moringa (dry) (efsa foodex2)",
    "FOODON_03401645": "10006308 - rhea - prepared/processed (gs1 gpc)",
    "FOODON_03400209": "fruit jelly (us cfr)",
    "FOODON_03412003": "spanish sardine",
    "FOODON_03543099": "30990 - rape seed oil, edible (efsa foodex2)",
    "FOODON_00002274": "starch refined food product",
    "FOODON_03317481": "potato (pre-fried, deep-frozen)",
    "NCBITaxon_23138": "Alchemilla",
    "FOODON_03315899": "goat milk (powdered)",
    "FOODON_03311241": "anchovy (dried)",
    "NCBITaxon_8184": "Centropomidae",
    "NCBITaxon_9872": "Odocoileus hemionus",
    "FOODON_03316397": "onion (chopped)",
    "FOODON_03303919": "chinese mint oil",
    "FOODON_03415090": "arabian jasmine plant",
    "FOODON_03430108": "physical state, shape or form, multiple",
    "FOODON_03415174": "uzazi fruit",
    "FOODON_00003337": "percent daily value",
    "FOODON_00001268": "horse milk beverage",
    "FOODON_03544111": "41110 - soy sauce (efsa foodex2)",
    "NCBITaxon_443748": "Aldrichetta forsteri",
    "FOODON_00002849": "fried rice",
    "FOODON_03540564": "05640 - palm hearts (efsa foodex2)",
    "FOODON_03414479": "white-winged scoter",
    "CHEBI_37997": "homopolymer macromolecule",
    "FOODON_03544388": "43880 - tamarind flavour (efsa foodex2)",
    "FOODON_03316447": "garlic granules",
    "FOODON_03306793": "burma bean (whole)",
    "OBI_0000679": "average value",
    "FOODON_00001280": "chocolate food product",
    "FOODON_03305712": "spaghetti milanese",
    "HANCESTRO_0548": "Tanzanian",
    "FOODON_03411269": "tuna",
    "FOODON_03305714": "lepre in salmi (food product)",
    "FOODON_03303054": "chewing gum containing breath freshener",
    "FOODON_03544058": "40580 - salt, flavoured (efsa foodex2)",
    "FOODON_00002090": "pasteurized cheese spread food product",
    "NCBITaxon_13013": "Clarias gariepinus",
    "FOODON_03311115": "jack mackerel canned",
    "FOODON_03543203": "32030 - nectar, pineapple (efsa foodex2)",
    "FOODON_03542533": "25330 - oyster, pacific cupped (efsa foodex2)",
    "CHEBI_72695": "organic molecule",
    "NCBITaxon_241793": "Apieae",
    "FOODON_03414332": "glasswort plant",
    "NCBITaxon_260718": "Phyllanthus acidus",
    "FOODON_00002070": "orange spread or sauce",
    "FOODON_03302623": "cow buttermilk (churn)",
    "FOODON_03302263": "orange sherbet base",
    "FOODON_03542507": "25070 - spiny and rock lobsters (efsa foodex2)",
    "CHEBI_33356": "iron group element atom",
    "FOODON_00003410": "cauliflower (whole)",
    "FOODON_03542498": "24980 - blue crab (efsa foodex2)",
    "FOODON_00002084": "parsley food product",
    "FOODON_03541262": "12620 - balm leaves, dry (efsa foodex2)",
    "FOODON_00003082": "mountain yam (whole)",
    "FOODON_00001598": "animal-based stew or hash",
    "NCBITaxon_443806": "Pseudophycis bachus",
    "FOODON_03541140": "11400 - areca nuts (efsa foodex2)",
    "FOODON_03302452": "gluten bread",
    "FOODON_03413632": "royal red shrimp",
    "FOODON_03305670": "ice cream sundae",
    "FOODON_03401414": "10005896 - baby bananas (gs1 gpc)",
    "FOODON_03411288": "mineral water (food source)",
    "FOODON_03401596": "10006060 - pot marjoram (gs1 gpc)",
    "NCBITaxon_4345": "Ericaceae",
    "NCBITaxon_223889": "Leucoraja fullonica",
    "FOODON_03543353": "33530 - sparkling wine (efsa foodex2)",
    "FOODON_03412448": "durian tree (Durio zibethinus)",
    "FOODON_03301141": "fruit (frozen)",
    "FOODON_03306915": "pecan (whole and pieces, raw)",
    "FOODON_03490135": "glass container, aluminum lid, plastic lining",
    "FOODON_03309636": "mouthbrooder fish (raw)",
    "FOODON_03460231": "chocolate or cocoa",
    "FOODON_03302562": "hominy (white, canned)",
    "FOODON_03316223": "cocoa-based product (energy reduced)",
    "FOODON_03305395": "vegetable (frozen)",
    "FOODON_03306746": "chocolate truffle",
    "NCBITaxon_66912": "Ameiurus natalis",
    "FOODON_03412613": "redtail prawn",
    "FOODON_03315013": "snack food",
    "FOODON_03310940": "skim milk (evaporated)",
    "FOODON_03307012": "pear (pieces, canned)",
    "FOODON_03543207": "32070 - juice, tomato (efsa foodex2)",
    "FOODON_03311544": "obsolete: black tea leaves",
    "FOODON_03315247": "beverage mix",
    "ENVO_01001206": "grassland ecosystem",
    "FOODON_03317225": "caviar semi-preserved",
    "FOODON_03400719": "29  milk (efg)",
    "FOODON_03412074": "milk mushroom",
    "NCBITaxon_278734": "Menticirrhus americanus",
    "FOODON_03414381": "bovid",
    "FOODON_03304789": "poo nih tea (dry)",
    "FOODON_03540164": "01640 - rusk, wholemeal (efsa foodex2)",
    "CHEBI_32112": "Saccharin sodium",
    "FOODON_03310731": "plum wine",
    "FOODON_03401132": "10000150 - aquatic invertebrates - unprepared/unprocessed (shelf stable) (gs1 gpc)",
    "FOODON_00001036": "pont ieveque cheese food product",
    "FOODON_03304380": "cow milk (low sodium)",
    "FOODON_03510057": "low in saturated fat food",
    "FOODON_03411844": "cusk-eel family",
    "FOODON_03316868": "pasteurized process cheese food with fruits vgetables or meats",
    "FOODON_00001700": "cattle sausage food product",
    "FOODON_03307151": "white rice flour (precooked)",
    "HANCESTRO_0376": "Monegasque",
    "GAZ_00006882": "Afghanistan",
    "FOODON_03304102": "sesame chip",
    "FOODON_03542033": "20330 - bovine kidney (efsa foodex2)",
    "FOODON_03541183": "11830 - poppy seeds (efsa foodex2)",
    "FOODON_03308733": "tuna (packed in water, canned)",
    "FOODON_00002833": "duqqa",
    "FOODON_03311738": "hen egg yolk (low cholesterol, low fat)",
    "NCBITaxon_6548": "Mytilus",
    "FOODON_03315619": "figure-of-eight",
    "FOODON_03317345": "poultry product (raw)",
    "GAZ_00002533": "State of Wyoming",
    "FOODON_03304217": "infant food (in cellophane package, frozen)",
    "FOODON_03302935": "fruit sherbet (liquid)",
    "FOODON_03490412": "asbestos container",
    "FOODON_03305073": "food bar",
    "FOODON_03401751": "10006455 - winged pea (gs1 gpc)",
    "FOODON_00002712": "dog treat",
    "FOODON_03460261": "food ultraviolet radiation process",
    "FOODON_03304110": "mustard sauce (food product)",
    "PATO_0002303": "decreased object quality",
    "FOODON_03544314": "43140 - marzipan flavour (efsa foodex2)",
    "FOODON_00002659": "food (toasted)",
    "FOODON_03542683": "26830 - cream sprayable (efsa foodex2)",
    "FOODON_03302958": "cod (flaked)",
    "FOODON_03542306": "23060 - brown trout (efsa foodex2)",
    "FOODON_03301396": "pumpkin (canned)",
    "NCBITaxon_54986": "Fissurellidae",
    "FOODON_03310579": "pork sloppy joe mix",
    "FOODON_03315434": "pecan (kernel)",
    "FOODON_03317518": "hen egg product (concentrated)",
    "CHEBI_83821": "amino acid derivative",
    "FOODON_03311618": "shrimp (boiled)",
    "FOODON_03490231": "glass stopper",
    "FOODON_03413396": "yam plant",
    "NCBITaxon_9691": "Panthera pardus",
    "FOODON_00003142": "junket (dish)",
    "FOODON_00001328": "som-khai-pla",
    "FOODON_03307283": "fruit in alcohol",
    "FOODON_03542921": "29210 - cheese, amarelo (efsa foodex2)",
    "FOODON_03412973": "obsolete: other chemical food source",
    "FOODON_03542396": "23960 - anglerfish, monkfish and stargazers (efsa foodex2)",
    "FOODON_03301091": "imitation shrimp (breaded)",
    "FOODON_03411806": "humpback snapper",
    "FOODON_03317119": "apple (raw, peeled)",
    "FOODON_03307664": "anisette toast",
    "FOODON_03307787": "shrimp salad",
    "FOODON_03305885": "jelly (decorating)",
    "FOODON_03540009": "00090 - buckwheat (efsa foodex2)",
    "FOODON_03401760": "10005935 - pineapples (gs1 gpc)",
    "FOODON_03310194": "sardine frozen",
    "FOODON_03540047": "00470 - hybrid nerica\u00ae (efsa foodex2)",
    "FOODON_03540428": "04280 - bitterblad leaves (efsa foodex2)",
    "FOODON_03414374": "bovine",
    "FOODON_03317185": "dietetic food for infants and toddlers",
    "FOODON_03309553": "ptarmigan (raw)",
    "FOODON_03543731": "37310 - camomile infusion (efsa foodex2)",
    "FOODON_03304249": "mushroom soup mix",
    "FOODON_00002970": "eru soup",
    "FOODON_03317350": "poultry (comminuted, cured)",
    "FOODON_03316684": "olive oil (refined)",
    "FOODON_03306259": "imitation margarine spread",
    "FOODON_00001257": "milk or milk based food product",
    "FOODON_03541406": "14060 - paprika powder (efsa foodex2)",
    "FOODON_03309522": "eel (raw)",
    "FOODON_03530062": "color of fish flesh, mixture",
    "FOODON_03306575": "chocolate milk (nonfat, dry, instant)",
    "FOODON_03414330": "agretti plant",
    "FOODON_03305036": "imitation egg (dried)",
    "FOODON_03307693": "cheese dip (roquefort-flavored)",
    "FOODON_03540941": "09410 - fermented vegetables (efsa foodex2)",
    "FOODON_03540026": "00260 - teff grain (efsa foodex2)",
    "FOODON_03415168": "condurango plant",
    "FOODON_03305884": "fruit jelly (in tube container)",
    "FOODON_03401857": "10006131 - celery (gs1 gpc)",
    "NCBITaxon_100776": "Aequipecten opercularis",
    "FOODON_03414576": "actinobacteria",
    "NCBITaxon_34818": "Glyptocephalus",
    "FOODON_03411395": "mung bean plant",
    "NCBITaxon_3465": "Papaveraceae",
    "FOODON_03311619": "creecy greens (canned)",
    "FOODON_03543499": "34990 - hairy rupturewort infusion leaves (efsa foodex2)",
    "FOODON_03543496": "34960 - goldenrod infusion leaves (efsa foodex2)",
    "FOODON_03308504": "imitation wild cherry beverage syrup",
    "NCBITaxon_129062": "Strongylura exilis",
    "NCBITaxon_169205": "Achyranthes",
    "FOODON_03316292": "coalfish product",
    "FOODON_03412272": "wild caia plant",
    "FOODON_03541889": "18890 - goose carcase (efsa foodex2)",
    "FOODON_03307208": "turkey (raw)",
    "FOODON_03302890": "caviar (mock)",
    "FOODON_03304897": "fudge (sweetened with sorbitol)",
    "FOODON_03301268": "black olive (whole, raw)",
    "FOODON_03460394": "artificial chocolate flavoring added",
    "FOODON_00002655": "food (peeled)",
    "FOODON_03309611": "lobster meat (raw)",
    "FOODON_03306132": "cloudberry (sugared)",
    "FOODON_03411432": "wreckfish",
    "FOODON_03401535": "10006261 - edible flowers (gs1 gpc)",
    "FOODON_03317399": "vegetable (unprocessed, frozen)",
    "FOODON_03541219": "12190 - perennial honesty seeds (efsa foodex2)",
    "FOODON_03307859": "iced tea mix grape-flavored sugar added",
    "FOODON_00001963": "ice goat milk food product",
    "FOODON_03413810": "african mudfish family",
    "FOODON_03310612": "lupine bean in brine",
    "FOODON_03543708": "37080 - coffee with milk or cream (efsa foodex2)",
    "NCBITaxon_32525": "Theria <mammals>",
    "FOODON_03413839": "anchoveta",
    "FOODON_03305336": "brown gravy mix",
    "FOODON_03317044": "vegetable-based dessert with no added sugar",
    "FOODON_03304482": "wheat feed flour",
    "HANCESTRO_0574": "Pacific Islander",
    "FOODON_03411006": "fruit used as vegetable",
    "FOODON_03542009": "20090 - ratites fresh fat tissue (efsa foodex2)",
    "FOODON_03530049": "meat, poultry or fish physical quality",
    "FOODON_03543415": "34150 - liquid coffee concentrate (efsa foodex2)",
    "FOODON_03307632": "wafer bar sandwich cookie",
    "FOODON_03302907": "romano cheese (block)",
    "FOODON_03302001": "animal-derived food",
    "FOODON_03412598": "hammerhead shark",
    "FOODON_03304674": "gethsemane tea (dry)",
    "FOODON_00002115": "pigeon pea vegetable food product",
    "ENVO_00003863": "food processing building",
    "FOODON_03543344": "33440 - low-malt beers (efsa foodex2)",
    "FOODON_03412357": "owl limpet",
    "NCBITaxon_30875": "Terapontidae",
    "FOODON_03316737": "ocean perch fillet (quick-frozen)",
    "NCBITaxon_33128": "Papaver rhoeas",
    "FOODON_03306028": "orange (artificially colored)",
    "FOODON_03401006": "50102100 - vegetables - prepared/processed (gs1 gpc)",
    "FOODON_00003001": "cutlet",
    "FOODON_03542307": "23070 - cutthroat trout (efsa foodex2)",
    "NCBITaxon_6566": "Pectinidae",
    "GENEPIO_0000006": "user interface label",
    "NCBITaxon_133894": "Penaeus",
    "NCBITaxon_98819": "Pagellus bogaraveo",
    "FOODON_03412348": "barbados aloe plant",
    "FOODON_03301119": "whole wheat bread",
    "FOODON_03541687": "16870 - coco plums (efsa foodex2)",
    "GAZ_00002546": "State of Oklahoma",
    "FOODON_03310095": "sansho (food product)",
    "FOODON_03305786": "jam mix",
    "FOODON_03541095": "10950 - marrowfat pea (dry seeds) (efsa foodex2)",
    "FOODON_03413996": "aldrichetta",
    "NCBITaxon_8173": "Pagrus pagrus",
    "FOODON_03301118": "bran food product",
    "FOODON_03400795": "poultry meat (eurofir)",
    "FOODON_03309254": "crayfish concentrate (freeze-dried for fish feed)",
    "FOODON_03411503": "lake trout",
    "FOODON_03304449": "chicken cacciatore",
    "NCBITaxon_9761": "Mysticeti",
    "FOODON_00001826": "eel food product",
    "NCBITaxon_26339": "Iridaceae",
    "FOODON_03541909": "19090 - mammals and birds meat (efsa foodex2)",
    "FOODON_03304287": "tofu curry and rice pilaf (dish)",
    "FOODON_03316584": "cheese (melted)",
    "FOODON_00002826": "haggis",
    "FOODON_03540638": "06380 - pear-shaped tomatoes (efsa foodex2)",
    "FOODON_03311038": "hen egg yolk (preserved, salted)",
    "NCBITaxon_34820": "Sebastes",
    "FOODON_00002632": "tortellini",
    "FOODON_03310833": "white corn flour",
    "FOODON_03306791": "hard grating cheese (italian-style)",
    "ENVO_01000179": "desert biome",
    "FOODON_03412933": "vitex plant",
    "FOODON_03302556": "kava beverage",
    "FOODON_03315071": "potato (dehydrated, shredded)",
    "FOODON_03311480": "bean curd (dried)",
    "GAZ_00004438": "State of Iowa",
    "FOODON_03305570": "ham (boneless, skinless, canned)",
    "FOODON_03401151": "10000258 - shellfish prepared/processed (shelf stable) (gs1 gpc)",
    "NCBITaxon_359160": "BOP clade",
    "FOODON_03415051": "nanking cherry plant",
    "FOODON_03544400": "44000 - truffle flavour (efsa foodex2)",
    "FOODON_00001066": "bottled fruit food product",
    "FOODON_03401610": "10006425 - lollo rosso (gs1 gpc)",
    "FOODON_03542424": "24240 - tuna, longtail (efsa foodex2)",
    "FOODON_03413126": "karaya gum",
    "FOODON_03510216": "food allergen labelling about eggs and products thereof",
    "FOODON_03307638": "longan drink",
    "FOODON_03543872": "38720 - fish balls (efsa foodex2)",
    "FOODON_00003041": "pear (whole)",
    "FOODON_03301501": "cow buttermilk (cultured)",
    "FOODON_03316055": "cereal based food containing fat",
    "FOODON_00002074": "oriental blue crab food product",
    "NCBITaxon_7648": "Echinus esculentus",
    "FOODON_03400245": "sherbet (us cfr)",
    "FOODON_03411300": "onion plant",
    "FOODON_03302732": "cauliflower (whole, raw)",
    "FOODON_03540144": "01440 - roti (efsa foodex2)",
    "FOODON_03302902": "corn flakes (with instant bananas)",
    "FOODON_03304282": "breakfast (frozen)",
    "FOODON_03413791": "false morel",
    "FOODON_03411804": "colorado snapper",
    "FOODON_03316164": "potato (peeled, cut, cooked)",
    "FOODON_03415006": "corsican mint plant",
    "NCBITaxon_4720": "Phoenix reclinata",
    "FOODON_00001250": "fish egg food product",
    "FOODON_03311746": "passion fruit (dried)",
    "FOODON_03412892": "morid cod",
    "FOODON_03301928": "poppyseed",
    "FOODON_03304523": "rabbit meat (wild, raw)",
    "FOODON_03541496": "14960 - cherries (sweet) (efsa foodex2)",
    "FOODON_03309322": "atlantic wolffish (raw)",
    "FOODON_03310626": "beef sloppy joe filling",
    "ENVO_02000001": "textile",
    "FOODON_03315600": "meat product (mixed)",
    "FOODON_03307069": "rock cornish game bird (raw)",
    "FOODON_03315692": "cereal (precooked)",
    "GAZ_00006924": "Maldives Archipelago",
    "FOODON_03305952": "boysenberry jelly",
    "FOODON_03414110": "leopard shark genus",
    "FOODON_00003339": "food calorie datum",
    "FOODON_03542843": "28430 - cheese, prastost (efsa foodex2)",
    "FOODON_03540196": "01960 - couscous (efsa foodex2)",
    "FOODON_03543394": "33940 - chocolate liqueur (efsa foodex2)",
    "FOODON_03401417": "10005899 - red bananas (gs1 gpc)",
    "NCBITaxon_85571": "Citrus reticulata",
    "FOODON_03414293": "tufted puffin",
    "FOODON_03543904": "39040 - beans, meat, and vegetables meal (efsa foodex2)",
    "NCBITaxon_9844": "Lama glama",
    "FOODON_03540983": "09830 - arrowroots and similar- (efsa foodex2)",
    "FOODON_03316610": "vegetable-meat product",
    "FOODON_03303160": "tomato sauce (italian-style, canned)",
    "FOODON_03304333": "fruit syrup",
    "FOODON_03401242": "0610000 - tea (ec)",
    "FOODON_03316616": "sweets, fruity, powdered, pressed",
    "FOODON_03311612": "sweet corn (blanched)",
    "FOODON_03414437": "maltitols",
    "FOODON_03315369": "mandoo skin",
    "NCBITaxon_62042": "Varanus gouldii",
    "FOODON_00002968": "okazi leaf",
    "FOODON_03411730": "chayote plant",
    "FOODON_03412162": "squat lobster family",
    "NCBITaxon_215358": "Larimichthys crocea",
    "FOODON_03401195": "10000054 - other sauces dipping/condiments/savoury toppings/savoury spreads/marinades (perishable) (gs1 gpc)",
    "FOODON_03542347": "23470 - cod, atlantic (efsa foodex2)",
    "FOODON_03412818": "african ebony plant",
    "FOODON_03411292": "elk",
    "FOODON_03540749": "07490 - swedes and similar- (efsa foodex2)",
    "FOODON_03543015": "30150 - honeydew honey (efsa foodex2)",
    "FOODON_03543047": "30470 - pralines (efsa foodex2)",
    "FOODON_03414607": "gracilaria",
    "FOODON_03303348": "clam chowder",
    "FOODON_03315648": "fish (preserved)",
    "FOODON_03315747": "cheddar cheese (grated)",
    "NCBITaxon_4618": "Zingiberales",
    "FOODON_00001623": "atlantic salmon food product",
    "FOODON_03401032": "10000028 - cheese/cheese substitutes (perishable) (gs1 gpc)",
    "FOODON_03303798": "chocolate candy (liquor-filled)",
    "FOODON_00001850": "field pea vegetable food product",
    "FOODON_03412034": "ascomycetes",
    "NCBITaxon_57918": "Fragaria vesca",
    "CHEBI_35618": "aromatic ether",
    "FOODON_03540958": "09580 - potatoes (efsa foodex2)",
    "FOODON_03541497": "14970 - black cherries (efsa foodex2)",
    "FOODON_03301364": "walnut (whole)",
    "CHEBI_39203": "dibenzopyran",
    "FOODON_03308106": "scotch herring (raw)",
    "FOODON_03401232": "0250000 - leaf vegetables and herbs (ec)",
    "FOODON_03301763": "hay for animal feed",
    "FOODON_03460191": "obsolete: meat added",
    "NCBITaxon_7088": "Lepidoptera",
    "FOODON_03311713": "hen egg liquid (cholesterol-reduced)",
    "HANCESTRO_0568": "African American",
    "FOODON_03306582": "dairy topping in pressurized container",
    "FOODON_03302572": "frozen dairy dessert (artificially sweetened)",
    "FOODON_00002208": "rice starch refined food product",
    "FOODON_03401372": "50260700 - cucurbits - edible peel (gs1 gpc)",
    "FOODON_03315573": "sauce mix, dried",
    "FOODON_03541735": "17350 - bananas and similar- (efsa foodex2)",
    "FOODON_00001310": "mum",
    "PO_0005005": "shoot axis internode",
    "GAZ_00001108": "Madagascar",
    "NCBITaxon_76926": "Nemadactylus",
    "FOODON_03414497": "steller sea lion",
    "FOODON_03308592": "japanese crabmeat (canned)",
    "FOODON_03305814": "green tomato mincemeat",
    "FOODON_03305618": "kernel paste (food product)",
    "ENVO_00003031": "animal manure",
    "FOODON_03303711": "butter blend spread",
    "FOODON_03316555": "dessert (instant)",
    "FOODON_03510107": "no artificial ingredients claim or use",
    "FOODON_03306569": "chocolate drink",
    "FOODON_03307447": "chili pod (raw)",
    "FOODON_03412135": "beefsteak plant",
    "FOODON_00001090": "sour milk beverage",
    "FOODON_03540719": "07190 - dandelion roots (efsa foodex2)",
    "FOODON_03543343": "33430 - beer-like beverages (efsa foodex2)",
    "FOODON_03541018": "10180 - potato flakes (efsa foodex2)",
    "FOODON_00002064": "okra food product",
    "FOODON_03542386": "23860 - surgeonfish (efsa foodex2)",
    "FOODON_03411352": "cassava plant",
    "FOODON_03542818": "28180 - cheese, gouda (efsa foodex2)",
    "FOODON_03540398": "03980 - scurvy-grass (efsa foodex2)",
    "FOODON_03412261": "new zealand wedge clam",
    "FOODON_03530279": "pink skin",
    "FOODON_03543607": "36070 - mullein infusion flowers (efsa foodex2)",
    "NCBITaxon_32523": "Tetrapoda",
    "FOODON_03401231": "0240000 - brassica vegetables (ec)",
    "FOODON_03307572": "table syrup",
    "FOODON_03315514": "cream (uht-treated)",
    "NCBITaxon_3916": "Vigna radiata var. radiata",
    "NCBITaxon_480040": "Coregonus pidschian",
    "NCBITaxon_167488": "Asclepiadeae",
    "FOODON_03541969": "19690 - duck fresh meat (efsa foodex2)",
    "FOODON_03305473": "ice milk-filled cone with topping",
    "FOODON_03303014": "turkey skin (raw)",
    "FOODON_03304584": "shrimp fried rice",
    "ENVO_01000918": "open animal house",
    "FOODON_03304436": "gravy mix (freeze-dried)",
    "CHEBI_24835": "inorganic molecular entity",
    "NCBITaxon_13105": "Lepomis",
    "FOODON_00002857": "hydrogenated oil",
    "FOODON_03305257": "cream toffee",
    "FOODON_03411318": "cacao plant",
    "FOODON_03401763": "10005900 - apples (gs1 gpc)",
    "FOODON_03307702": "salad vegetable (packaged, refrigerated)",
    "FOODON_03400890": "10000588 - non grape fermented alcoholic beverages - still (gs1 gpc)",
    "FOODON_03308759": "top shell snail (raw)",
    "NCBITaxon_7908": "Acipenser medirostris",
    "FOODON_03541608": "16080 - blackcurrants (efsa foodex2)",
    "FOODON_03311302": "purple plum (whole, raw)",
    "FOODON_00002040": "mineral water based soft drink",
    "FOODON_03304310": "coffee sugar",
    "FOODON_03542823": "28230 - cheese, jarlsberg (efsa foodex2)",
    "FOODON_03542137": "21370 - cooked cured (or seasoned) ovine meat (efsa foodex2)",
    "FOODON_03510156": "low sodium claim or use",
    "FOODON_03542883": "28830 - cheese, mahon (efsa foodex2)",
    "FOODON_03316761": "vanilla powder",
    "FOODON_03413467": "loggerhead turtle",
    "FOODON_03413932": "knipowitschia",
    "FOODON_03315026": "essential oil",
    "FOODON_03414320": "japanese millet plant",
    "ENVO_00000856": "city",
    "FOODON_00002716": "chicken drumstick",
    "FOODON_03541677": "16770 - dracontomelon duperreanum fruits (efsa foodex2)",
    "FOODON_03400230": "water ice (us cfr)",
    "FOODON_03316340": "rhubarb (cooked)",
    "GAZ_00002942": "Austria",
    "NCBITaxon_33154": "Opisthokonta",
    "PO_0030105": "follicle fruit",
    "FOODON_03540435": "04350 - sweet potato leaves (efsa foodex2)",
    "FOODON_03307726": "butter table syrup",
    "FOODON_03303857": "cottage cheese (creamed with nonfat cream dressing)",
    "FOODON_00002985": "tuna tataki",
    "FOODON_03412682": "pipi clam",
    "FOODON_03543444": "34440 - tea leaves and stalks with fruit and flavours (efsa foodex2)",
    "FOODON_03317245": "fish roe (chilled)",
    "FOODON_03302614": "buttermilk biscuit",
    "FOODON_03307023": "poi",
    "FOODON_03541786": "17860 - other miscellaneous fruits with inedible peel, large (efsa foodex2)",
    "FOODON_00003245": "quenelle",
    "CHEBI_133354": "bentonite",
    "FOODON_03540121": "01210 - wheat bread and rolls, white with potato (efsa foodex2)",
    "FOODON_00002288": "sugar beet sweetener food product",
    "FOODON_03543555": "35550 - wild angelica infusion leaves (efsa foodex2)",
    "FOODON_03401770": "10006415 - ya pear (shandong) (gs1 gpc)",
    "FOODON_00001766": "corvina food product",
    "FOODON_03311420": "broccoli (cooked)",
    "FOODON_00002729": "pork sausage",
    "FOODON_03309172": "white bass (raw)",
    "FOODON_03543763": "37630 - follow-on formula, soya-based, powder (efsa foodex2)",
    "FOODON_03413473": "amur bitterling",
    "FOODON_03411636": "taro plant",
    "FOODON_03541499": "14990 - chokecherries (efsa foodex2)",
    "CHEBI_61266": "hemicellulose",
    "FOODON_03541383": "13830 - juniper berry and similar- (efsa foodex2)",
    "FOODON_03302863": "salad dressing (low calorie)",
    "FOODON_00001674": "butterfly mackerel food product",
    "FOODON_03315068": "caciocavallo siciliano cheese",
    "FOODON_03306436": "meat substitute (from vegetable protein)",
    "FOODON_03305401": "devonshire cream",
    "NCBITaxon_42528": "Piaractus mesopotamicus",
    "FOODON_03317537": "fruit jelly made with sulfite fruit",
    "NCBITaxon_13095": "Hypophthalmichthys molitrix",
    "FOODON_03302507": "imitation butter",
    "BFO_0000141": "immaterial entity",
    "ENVO_00002010": "saline water",
    "FOODON_03542283": "22830 - dagaas (efsa foodex2)",
    "FOODON_03413992": "oceanic bonito",
    "FOODON_03401101": "50191500 - prepared soups (gs1 gpc)",
    "NCBITaxon_1977918": "Sapindoideae",
    "HANCESTRO_0320": "Dutch",
    "FOODON_03400652": "04  nuts and seeds (ccpr)",
    "FOODON_00001006": "meat food product",
    "CHEBI_7488": "Natamycin",
    "HANCESTRO_0508": "Liberian",
    "FOODON_03400724": "01  milk and milk products (eurocode2)",
    "FOODON_03414795": "grasstree plant",
    "FOODON_03307321": "cod fillet (raw)",
    "FOODON_03316785": "obsolete: orange juice concentrated frozen reduced acid",
    "NCBITaxon_175273": "Cynoscion regalis",
    "FOODON_03542239": "22390 - mozambique tilapia (efsa foodex2)",
    "FOODON_00001253": "plant derived beverage",
    "FOODON_03310983": "parevine",
    "FOODON_03400813": "cereal or cereal-like milling products and derivatives (eurofir)",
    "FOODON_03309385": "cherry snapper (raw)",
    "FOODON_03302058": "red kidney bean (whole, dried)",
    "NCBITaxon_6775": "Geryonidae",
    "FOODON_03401697": "10006350 - melon (horned) (gs1 gpc)",
    "FOODON_03316197": "fruit juice-based concentrate with not less than 2.5% barley",
    "NCBITaxon_435271": "Parastromateus",
    "CHEBI_35313": "hexoside",
    "FOODON_03543772": "37720 - ready-to-eat meat-based meal for children (efsa foodex2)",
    "FOODON_03411881": "southern flounder",
    "FOODON_03541800": "18000 - dried figs (efsa foodex2)",
    "NCBITaxon_184449": "Stereolepis gigas",
    "FOODON_03413657": "river plata mussel",
    "FOODON_03415015": "potatobean plant",
    "GO_0015980": "energy derivation by oxidation of organic compounds",
    "FOODON_03400799": "meat dish (eurofir)",
    "FOODON_03316836": "spaghetti (egg, vegetable, enriched)",
    "CHEBI_64459": "biaryl",
    "FOODON_03316330": "seasoning substance based on lemon juice (food product)",
    "FOODON_03413836": "stet anchovy",
    "FOODON_03306510": "malted cow milk (powdered)",
    "NCBITaxon_71611": "Malpighia glabra",
    "FOODON_00002140": "plant floret vegetable food product",
    "FOODON_00002228": "sea animal soup",
    "NCBITaxon_2231382": "NPAAA clade",
    "FOODON_03309470": "reindeer meat (canned)",
    "FOODON_03540343": "03430 - processed oat-based flakes (efsa foodex2)",
    "CHEBI_7916": "pantothenic acid",
    "FOODON_03310760": "sherry",
    "FOODON_00002009": "longtail tuna food product",
    "FOODON_03301772": "apple butter",
    "FOODON_03411297": "vertebrate animal",
    "FOODON_03303390": "chufa (raw)",
    "FOODON_03541012": "10120 - other not listed sugar plants (efsa foodex2)",
    "FOODON_03544513": "45130 - glucosamine (efsa foodex2)",
    "NCBITaxon_89058": "Microstomus pacificus",
    "FOODON_03306740": "pink peppercorn (dried)",
    "FOODON_03309698": "sardine (chunk light, canned)",
    "FOODON_03544114": "41140 - fish sauce (efsa foodex2)",
    "NCBITaxon_274795": "Serraninae",
    "FOODON_03412783": "yellow sage plant",
    "FOODON_03411310": "longfin smelt",
    "FOODON_03306459": "buffalo meat (canned)",
    "FOODON_03543465": "34650 - birch infusion leaves (efsa foodex2)",
    "FOODON_03305388": "fish with peas dinner (calorie controlled, baked, frozen)",
    "FOODON_03420173": "whole animal or most parts used",
    "FOODON_00001845": "field corn food product",
    "FOODON_03307199": "protein doughnut",
    "FOODON_03311736": "turkey (smoked)",
    "FOODON_03305778": "orange drink mix",
    "FOODON_03302820": "milk chocolate (sweet)",
    "FOODON_00002769": "brown bean food product",
    "FOODON_03309430": "horse fish (raw)",
    "FOODON_03540297": "02970 - various pastry (efsa foodex2)",
    "FOODON_03542133": "21330 - cooked cured (or seasoned) poultry meat (efsa foodex2)",
    "FOODON_03315010": "cough drop",
    "NCBITaxon_3673": "Momordica charantia",
    "FOODON_03302512": "orange marmalade",
    "FOODON_03308013": "new zealand lobster tail (raw)",
    "CHEBI_87036": "benzimidazole fungicide",
    "IAO_0000115": "definition",
    "FOODON_03411502": "ugli fruit",
    "FOODON_03303891": "yorkshire pudding popover",
    "FOODON_03411057": "vegetable-producing plant, above-ground parts",
    "FOODON_03490355": "paper-plastic combination",
    "FOODON_03543164": "31640 - juice, orange-grapefruit (efsa foodex2)",
    "FOODON_03317167": "oats (hulled)",
    "FOODON_03544217": "42170 - buttermilk flavour (efsa foodex2)",
    "FOODON_03401208": "designation according to principle cheese ripening characteristics (codex)",
    "FOODON_03401405": "10005941 - bullock hearts (gs1 gpc)",
    "FOODON_03301624": "low acid food (canned)",
    "FOODON_03304599": "soy and corn bread mix",
    "FOODON_03316373": "quince (dried)",
    "FOODON_03306571": "cocoa-flavored cow milk",
    "CHEBI_24973": "ketohexose",
    "FOODON_03411845": "ocean pout",
    "GAZ_00002641": "England",
    "FOODON_03401732": "10006256 - vegetable juice drinks - ready to drink (shelf stable) (gs1 gpc)",
    "FOODON_03540536": "05360 - other edible flowers (efsa foodex2)",
    "FOODON_03542024": "20240 - poultry liver (efsa foodex2)",
    "FOODON_03303930": "ladyfinger cookie (dietetic)",
    "FOODON_03301332": "cocoa butter (food product)",
    "FOODON_03316694": "vegetable fat food product",
    "ENVO_00000294": "fish farm",
    "FOODON_03400111": "pasteurized process cheese food (us cfr)",
    "FOODON_03310962": "pancake syrup",
    "FOODON_03530225": "chimaeroid poisoning",
    "FOODON_03411561": "red banana plant (Ensete ventricosum)",
    "FOODON_03411084": "scorpionfish family",
    "FOODON_03308444": "southern bluefin tuna (raw)",
    "NCBITaxon_75099": "Rubus ulmifolius",
    "NCBITaxon_170194": "Argentinidae",
    "FOODON_03315403": "dairy based dessert",
    "NCBITaxon_548163": "Meuschenia scaber",
    "FOODON_03309958": "scotch bean (whole)",
    "FOODON_03317662": "cabbage (dehydrated)",
    "FOODON_03541679": "16790 - kaki (efsa foodex2)",
    "FOODON_03412995": "ammonia caramel",
    "FOODON_03400757": "056  dried vegetables (dv) (ccpr)",
    "GAZ_00002459": "United States of America",
    "NCBITaxon_3915": "Vigna mungo",
    "FOODON_00001975": "jack family (or carangidae) food product",
    "FOODON_03541170": "11700 - beech nuts (efsa foodex2)",
    "NCBITaxon_490275": "Polydactylus macrochir",
    "CHEBI_78299": "environmental food contaminant",
    "FOODON_03540518": "05180 - lentil sprouts (efsa foodex2)",
    "FOODON_03540651": "06510 - chili peppers (efsa foodex2)",
    "FOODON_03400255": "pectin jelly candy (us cfr)",
    "FOODON_03490297": "aluminum coextruded with paper",
    "FOODON_00002690": "turkey breast",
    "FOODON_03480016": "packed in vegetable juice",
    "FOODON_03530179": "fat content 3-4%",
    "FOODON_03540460": "04600 - water clovers (efsa foodex2)",
    "FOODON_03302336": "bread (low sodium)",
    "CHEBI_26384": "pullulans",
    "FOODON_03530254": "protected geographical status (pgs)",
    "FOODON_03311345": "orange juice (single strength, heat treated, bottled)",
    "FOODON_03304375": "cow milk (reconstituted)",
    "FOODON_03420163": "fruit, peel undetermined, core, pit or seed present",
    "FOODON_00001148": "potato food product",
    "FOODON_00001320": "pak kum dong",
    "FOODON_00002282": "strawberry food product",
    "FOODON_03301765": "imitation peanut butter",
    "FOODON_00001921": "grape alcoholic beverage analog",
    "FOODON_03311129": "oatmeal (cooked, not drained)",
    "FOODON_03308770": "mollusc (raw, frozen)",
    "NCBITaxon_700800": "Scorpaena grandicornis",
    "FOODON_03305693": "imitation scallop",
    "FOODON_03302392": "orangeade drink mix (powdered)",
    "FOODON_03460757": "obsolete: tree nut added",
    "FOODON_03542399": "23990 - alfonsinos (efsa foodex2)",
    "FOODON_03460236": "sodium removal process",
    "FOODON_03460780": "fluoride added",
    "FOODON_03414825": "coarse dodderlaurel plant",
    "FOODON_03301722": "strawberry (whole, raw)",
    "FOODON_00003374": "harvested food material",
    "FOODON_03542698": "26980 - yoghurt, sheep milk, plain (efsa foodex2)",
    "FOODON_03315754": "water represented as mineral or spring water (food product)",
    "FOODON_03317379": "whole muscle meat cut",
    "FOODON_03311832": "poultry (minced, cooked)",
    "CHEBI_495055": "beta-cyclodextrin",
    "FOODON_03540298": "02980 - dumpling, sweet (efsa foodex2)",
    "FOODON_03317125": "obsolete: potato flakes (granulated and powdered)",
    "FOODON_03543054": "30540 - jelly candies (efsa foodex2)",
    "FOODON_03307737": "potato (peeled, cut, raw)",
    "FOODON_03412424": "bigeye scads (Selar spp)",
    "FOODON_03317188": "carbonated drink starter and base substances",
    "FOODON_03310916": "gelled candy aspartame sweetened packed in cellophane bag",
    "FOODON_00002722": "corn husking process",
    "FOODON_00003070": "sacred pear (whole, raw)",
    "FOODON_03302152": "beverage tablet (effervescent, artificially sweetened)",
    "FOODON_03542550": "25500 - cockle and arkshell (efsa foodex2)",
    "FOODON_03412461": "kradon plant",
    "FOODON_03530140": "tranche grasse",
    "NCBITaxon_8065": "Batrachoididae",
    "FOODON_03413255": "sodium hydrogen acetate (sodium diacetate)",
    "FOODON_03308779": "shrimp (dried)",
    "FOODON_03306047": "imitation cinnamon-flavored jelly",
    "FOODON_03540054": "00540 - sudan grass grain (efsa foodex2)",
    "FOODON_03540766": "07660 - laver (efsa foodex2)",
    "FOODON_00002533": "nachos",
    "FOODON_03500017": "polyethylene surface",
    "FOODON_03530210": "outdoor/open-air organic plant cultivation",
    "FOODON_03310832": "yellow vetchling silage",
    "FOODON_03414768": "eremophila plant",
    "NCBITaxon_2291027": "Salvia incertae sedis",
    "CHEBI_52457": "selenium-77 atom",
    "CHEBI_15428": "glycine",
    "CHEBI_27134": "trimethylxanthine",
    "FOODON_03317056": "confectionery (with no added sugar, starch-based)",
    "FOODON_03413448": "anadromous fish",
    "FOODON_03306805": "pea (early june, dried, canned)",
    "FOODON_00002844": "bolillo",
    "FOODON_03541986": "19860 - mixed fresh fat tissue (efsa foodex2)",
    "FOODON_03414262": "crowberry plant",
    "FOODON_03542919": "29190 - cheese, valdeon (efsa foodex2)",
    "FOODON_03412632": "cone pepper plant",
    "FOODON_03310637": "macaroni dough",
    "FOODON_03303725": "candy (hot and salty)",
    "FOODON_03544011": "40110 - mushroom soup (efsa foodex2)",
    "FOODON_03317054": "fruit preparation (no added sugar)",
    "NCBITaxon_1213270": "Pleoticus robustus",
    "FOODON_03401475": "10005999 - white cabbages (gs1 gpc)",
    "FOODON_03411402": "alewife",
    "FOODON_00002873": "okara",
    "FOODON_03305853": "coffee ice cream (vanilla-flavored)",
    "FOODON_03412366": "morwong",
    "FOODON_00003030": "angelica food product",
    "FOODON_03308262": "oyster (olympia, raw)",
    "CHEBI_75228": "sodium lactate",
    "FOODON_00002872": "oheloberry",
    "NCBITaxon_94935": "Belonidae",
    "FOODON_00001947": "hard wheat food product",
    "FOODON_03316114": "beverage (water-based, flavored, nonalcoholic)",
    "FOODON_03401536": "10006204 - eggs extracts (gs1 gpc)",
    "FOODON_03315076": "dessert mix, dry",
    "FOODON_03541052": "10520 - asparagus peas (without pods) (efsa foodex2)",
    "FOODON_03401736": "10006148 - okra (gs1 gpc)",
    "FOODON_03309319": "lake superior bluefin fillet (raw)",
    "FOODON_03310254": "rice (fermented)",
    "NCBITaxon_176265": "Hylocereus undatus",
    "FOODON_03401218": "skim cheese (codex)",
    "NCBITaxon_301453": "Capparaceae",
    "FOODON_03315367": "squid smoked",
    "FOODON_03303521": "brown bean (cooked)",
    "FOODON_03544146": "41460 - salad dressing, low fat (efsa foodex2)",
    "FOODON_03414007": "pacific sand lance",
    "FOODON_03317542": "milk product (flavored)",
    "FOODON_03305166": "kim chee (refrigerated)",
    "FOODON_00002373": "food product by meal type",
    "NCBITaxon_47969": "Oreochromis aureus",
    "FOODON_03541615": "16150 - rugosa rose (efsa foodex2)",
    "FOODON_03306804": "peas (mint-flavored, dish)",
    "FOODON_03414583": "gammaproteobacteria",
    "FOODON_03530145": "rumsteck",
    "FOODON_03316556": "cow milk (powdered, instant, with sugar flavoring)",
    "GAZ_00004430": "State of Mississippi",
    "FOODON_03400256": "starch jelly candy (us cfr)",
    "FOODON_03414471": "kodiak bear",
    "FOODON_03317002": "sake compound",
    "FOODON_00002498": "chard food product",
    "FOODON_03310489": "tea bag",
    "FOODON_03400424": "fungistatic agent (codex)",
    "NCBITaxon_669897": "Vanilla x tahitensis",
    "FOODON_03303720": "cottage cheese (lowfat)",
    "FOODON_03316269": "milk-based product with fruit preparations (calorie reduced)",
    "FOODON_03414800": "northern australian snapping turtle",
    "FOODON_03543338": "33380 - ale beer (efsa foodex2)",
    "FOODON_03413176": "o-phenyl phenol",
    "FOODON_03401709": "10005961 - carambola (gs1 gpc)",
    "FOODON_03540292": "02920 - croissant from puff pastry (efsa foodex2)",
    "NCBITaxon_3662": "Cucurbita moschata",
    "FOODON_03315959": "egg-based dessert energy reduced",
    "FOODON_03413219": "potassium propionate",
    "FOODON_03544209": "42090 - bourbon flavour (efsa foodex2)",
    "FOODON_03303167": "sour cream-flavored cookie",
    "FOODON_03401157": "10000151 - aquatic plants prepared/processed (frozen) (gs1 gpc)",
    "FOODON_03307146": "rice (enriched, parboiled)",
    "FOODON_03310969": "pork shoulder (cooked, cured)",
    "FOODON_03400856": "seasoning or extract (eurofir)",
    "FOODON_03302461": "salt-rising bread",
    "FOODON_03540976": "09760 - sweet potatoes (efsa foodex2)",
    "FOODON_03303025": "chicken stew",
    "FOODON_03307957": "clam (butter, canned)",
    "FOODON_03315240": "meat (solid)",
    "FOODON_00002501": "multi-component food product",
    "FOODON_03315157": "tea (dry, instant)",
    "FOODON_03304098": "pineapple and orange juice",
    "FOODON_03306311": "pasta (frozen)",
    "FOODON_03303361": "apricot chutney",
    "FOODON_03310772": "noodles and cheese",
    "FOODON_03414635": "monodont",
    "FOODON_03544482": "44820 - vitamin b12 (cyanocobalamin, hydroxocobalamin, methylcobalamin) (efsa foodex2)",
    "FOODON_03412889": "greater burdock plant",
    "CHEBI_35311": "carotenoic acid",
    "FOODON_03540725": "07250 - parsnip roots (efsa foodex2)",
    "FOODON_03412805": "guarea plant",
    "FOODON_03307098": "chocolate pudding mix",
    "FOODON_00002162": "pomfret food product",
    "FOODON_03308457": "ocean catfish (raw)",
    "FOODON_03411301": "algae",
    "FOODON_00002272": "squat lobster food product",
    "FOODON_03460328": "food interior bacterial curing",
    "FOODON_03413942": "giant gourami",
    "UBERON_0006611": "exoskeleton",
    "FOODON_03310085": "sweet and sour onion and raisin relish (food product)",
    "FOODON_03420240": "root, tuber or bulb, without peel",
    "NCBITaxon_8232": "Sarda sarda",
    "FOODON_00001837": "fenugreek food product",
    "UO_0000036": "year",
    "FOODON_03413337": "hautbois strawberry plant",
    "FOODON_00001884": "fruit based gravy or sauce food product",
    "FOODON_03541217": "12170 - honesty seeds (efsa foodex2)",
    "FOODON_03316629": "sweets, non-crystalline water fondant",
    "FOODON_03311662": "beef (roasted)",
    "FOODON_03414653": "custard finger plant",
    "FOODON_03500032": "pliofilm surface",
    "FOODON_03307696": "potato salad (with egg)",
    "FOODON_03540249": "02490 - \u00e9clair (efsa foodex2)",
    "FOODON_00001738": "cinnamon food product",
    "FOODON_03414459": "cucumis species",
    "FOODON_03510194": "probiotic claim or use",
    "GENEPIO_0002752": "chicken thigh",
    "FOODON_03411197": "bay plant",
    "FOODON_03413040": "calcium hydrogen malate",
    "FOODON_03305318": "soursop (whole, raw)",
    "FOODON_03316252": "sausage with a starch content of more that 6%",
    "FOODON_03315424": "meat extract",
    "FOODON_03530088": "beverage base",
    "FOODON_03542138": "21380 - pastrami, lamb (efsa foodex2)",
    "FOODON_03317303": "stew (meat-based)",
    "FOODON_00001127": "cow milk cheese",
    "FOODON_03315086": "bakery product (yeast leavened, prepared mix)",
    "FOODON_03400814": "rice or other grain (eurofir)",
    "FOODON_00003068": "arrowroot (whole, raw)",
    "FOODON_00003426": "hominy grits",
    "FOODON_03411869": "butter sole",
    "FOODON_03530272": "gold flesh",
    "FOODON_03411792": "atlantic bonito",
    "FOODON_03301384": "broccoli (frozen)",
    "FOODON_03413382": "trefoil plant",
    "CHEBI_26835": "sulfur molecular entity",
    "FOODON_03411594": "fish, cypriniform",
    "FOODON_03315557": "beverage, composite, concentrate for",
    "FOODON_03540082": "00820 - rye flour, gluten free (efsa foodex2)",
    "NCBITaxon_169700": "Coryphoideae",
    "FOODON_03412345": "lichen",
    "FOODON_03308703": "snail (canned)",
    "FOODON_00002425": "stracchino cheese",
    "FOODON_03415166": "seneca snakeroot plant",
    "FOODON_03460776": "manganese added",
    "FOODON_03542879": "28790 - cheese, idiazabal (efsa foodex2)",
    "FOODON_03308338": "india sardine (raw)",
    "FOODON_03541405": "14050 - peppers, dried (efsa foodex2)",
    "FOODON_03412611": "doe (goat)",
    "FOODON_00002950": "ladyfish",
    "FOODON_03304637": "chrysanthemum tea (dry)",
    "FOODON_03306290": "yellow corn flour",
    "NCBITaxon_349640": "Parapristipoma octolineatum",
    "FOODON_03316883": "fish (quick-frozen)",
    "FOODON_03302290": "imitation cherry carbonated beverage (naturally and artificially sweetened)",
    "FOODON_03310990": "vermouth sweet",
    "FOODON_03411613": "obsolete: pea and carrot",
    "FOODON_00002350": "wheat based pastry food product",
    "FOODON_03540515": "05150 - common bean sprouts (efsa foodex2)",
    "NCBITaxon_270605": "Percophidae",
    "FOODON_00002087": "passion fruit juice",
    "FOODON_00003293": "white grapefruit juice",
    "FOODON_03309449": "dogfish shark (raw)",
    "NCBITaxon_700796": "Harengula humeralis",
    "FOODON_03540102": "01020 - wheat groats (efsa foodex2)",
    "FOODON_00002625": "Carignane wine",
    "FOODON_03412533": "duckbill eel family",
    "FOODON_03544420": "44200 - rum essence (efsa foodex2)",
    "FOODON_03316756": "dextrose monohydrate",
    "FOODON_03541320": "13200 - other spices seeds (e) (efsa foodex2)",
    "FOODON_00002637": "linguine",
    "FOODON_03411241": "okra plant",
    "GAZ_00002464": "Southwest Asia",
    "FOODON_03413561": "pacific rock crab",
    "FOODON_03490103": "plastic squeeze bottle or tube, top lined with laminate",
    "GAZ_00003706": "Territory of Guam",
    "FOODON_00001245": "tea beverage (liquid)",
    "NCBITaxon_271940": "Trachurus symmetricus",
    "FOODON_03400148": "milk or milk product (us cfr)",
    "FOODON_03304389": "cow milk (frozen)",
    "FOODON_03311309": "salmon (smoked, using hot-smoking, nitrate-treated)",
    "NCBITaxon_64152": "Channa striata",
    "FOODON_03414011": "mediterranean sandeel",
    "FOODON_03311349": "asparagus (whole, raw)",
    "FOODON_03305010": "brown sugar (light)",
    "FOODON_03315926": "meat pie food product",
    "NCBITaxon_88694": "Hemiramphidae",
    "NCBITaxon_202634": "Crateva religiosa",
    "FOODON_03411081": "penaeid shrimp family",
    "FOODON_03460286": "full alcohol removal process",
    "FOODON_03411751": "clementine plant",
    "NCBITaxon_64478": "Actinidia arguta",
    "FOODON_00003357": "pet treat",
    "FOODON_03542193": "21930 - meat spread (efsa foodex2)",
    "FOODON_03460130": "physical/chemical modification process",
    "FOODON_03301013": "wine (dealcoholized)",
    "FOODON_03413738": "levant cotton plant",
    "NCBITaxon_6470": "Potamididae",
    "HANCESTRO_0372": "Liechtensteiner",
    "FOODON_03541760": "17600 - elephant apples (efsa foodex2)",
    "FOODON_03311840": "bean (rehydrated, cooked)",
    "FOODON_03308481": "wreckfish (raw)",
    "FOODON_03541897": "18970 - goat msm (efsa foodex2)",
    "FOODON_03414258": "azarole plant",
    "NCBITaxon_387448": "Strombus alatus",
    "FOODON_03543101": "31010 - maize oil, edible (efsa foodex2)",
    "FOODON_03315765": "coffee concentrate (liquid)",
    "FOODON_03316125": "meat product (preserved)",
    "FOODON_03414810": "salt marsh snail",
    "NCBITaxon_143346": "Monacanthidae",
    "FOODON_03541014": "10140 - dried starchy roots and tuber products (efsa foodex2)",
    "FOODON_03401769": "10006173 - quinces (gs1 gpc)",
    "FOODON_00002515": "carrot cake",
    "NCBITaxon_85418": "Gobius paganellus",
    "NCBITaxon_669814": "Salix pulchra",
    "FOODON_03305972": "jam (alcohol-flavored)",
    "FOODON_03301409": "black currant jelly",
    "FOODON_03544394": "43940 - thyme flavour (efsa foodex2)",
    "NCBITaxon_4732": "Typha",
    "NCBITaxon_504567": "Coregoninae",
    "FOODON_03309493": "imitation mozzarella cheese (food product)",
    "FOODON_00003017": "pattypan squash (whole, raw)",
    "FOODON_03414088": "sharpnose skate",
    "NCBITaxon_8231": "Sarda chiliensis",
    "ENVO_00000077": "agricultural ecosystem",
    "CHEBI_51084": "inorganic nitrate salt",
    "NCBITaxon_36219": "Boops boops",
    "NCBITaxon_51435": "Arthropodium",
    "FOODON_03411801": "amarillo snapper",
    "FOODON_03306423": "candy bar",
    "FOODON_03430131": "whole",
    "FOODON_03542591": "25910 - turtle, hawksbill (efsa foodex2)",
    "UO_0000045": "base unit",
    "FOODON_03310415": "fontina cheese",
    "FOODON_03411997": "slipper lobster family",
    "FOODON_03543043": "30430 - chocolate/cocoa-based products (efsa foodex2)",
    "FOODON_00002163": "pompano food product",
    "FOODON_03414150": "magellan mussel",
    "CHEBI_33145": "boron oxoacid",
    "FOODON_03401478": "10006003 - garlic (gs1 gpc)",
    "FOODON_03543359": "33590 - other wine-like fruit drinks (efsa foodex2)",
    "FOODON_03302470": "rye crispbread",
    "FOODON_03305254": "fish pate",
    "FOODON_00002867": "mexican rice (dish)",
    "NCBITaxon_549450": "Protothaca thaca",
    "NCBITaxon_34531": "Sepiolidae",
    "FOODON_03540003": "00030 - cereal grains (and cereal-like grains) (efsa foodex2)",
    "FOODON_03412295": "prickly ash plant",
    "NCBITaxon_195617": "Isopsetta isolepis",
    "GAZ_00000582": "Djibouti",
    "FOODON_00002605": "Sauvignon blanc wine",
    "FOODON_03544279": "42790 - grenadine flavour (efsa foodex2)",
    "FOODON_03413898": "baird's smmoth-head",
    "NCBITaxon_239368": "Engraulis mordax",
    "FOODON_03400734": "11  beverages (non-milk) (eurocode2)",
    "FOODON_03311498": "soybean and cheese whey powder",
    "NCBITaxon_546497": "Allium ampeloprasum var. babingtonii",
    "FOODON_03420100": "root, tuber or bulb, with part of top",
    "FOODON_03316757": "soft sugar",
    "FOODON_03304676": "tea plant twigs",
    "FOODON_03542052": "20520 - animal edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "FOODON_03411287": "gray mullet",
    "FOODON_03541254": "12540 - american oil palm fruits (efsa foodex2)",
    "FOODON_03415150": "smooth rupturewort plant",
    "FOODON_03304016": "bearnaise sauce",
    "FOODON_03542064": "20640 - wild boar edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "NCBITaxon_507566": "Euthynnus lineatus",
    "FOODON_03303191": "corn (cream-style, canned)",
    "FOODON_03309342": "poutassou (raw)",
    "FOODON_03542871": "28710 - cheese, castelmagno (efsa foodex2)",
    "FOODON_03303015": "chicken (shredded)",
    "FOODON_03490385": "aniline-formaldehyde container",
    "FOODON_03311833": "spanish peanut (whole, roasted)",
    "FOODON_03542677": "26770 - milk from other milk producer animals (efsa foodex2)",
    "FOODON_00002516": "gravlax",
    "FOODON_03400290": "hard grating cheese (us cfr)",
    "FOODON_03500042": "aluminum surface",
    "NCBITaxon_24966": "Rubiaceae",
    "FOODON_03315101": "candy coating (soft)",
    "FOODON_03541122": "11220 - bitter almonds (efsa foodex2)",
    "FOODON_03543217": "32170 - juice, tomato-leafy vegetables (efsa foodex2)",
    "NCBITaxon_4640": "Musa",
    "FOODON_03311533": "nonfat dry milk (instant)",
    "FOODON_03304707": "coleslaw (food product)",
    "FOODON_03401150": "10000257 - shellfish prepared/processed (perishable) (gs1 gpc)",
    "NCBITaxon_85421": "Knipowitschia",
    "PATO_0001334": "diameter",
    "FOODON_03415108": "chinese amaranth plant",
    "FOODON_03315843": "vegetable oil creaming agent",
    "NCIT_C80249": "Breakfast",
    "FOODON_03530162": "sugar content > 50%",
    "FOODON_03411316": "duck",
    "FOODON_03420194": "egg or egg component",
    "CHEBI_17822": "serine",
    "FOODON_03301028": "honey (liqueur-flavored)",
    "FOODON_03412852": "spirochaetales",
    "FOODON_03309538": "peanut (whole, skin off, salted)",
    "NCBITaxon_61971": "Huso huso",
    "FOODON_03543876": "38760 - omelette with bacon (efsa foodex2)",
    "FOODON_03301839": "bean curd",
    "FOODON_03308618": "crab (deviled, with flounder flakes)",
    "FOODON_03316834": "vermicelli (egg, vegetable)",
    "FOODON_03415042": "tahitian vanilla plant",
    "FOODON_03311228": "breakfast cereal (hot-type, dry mix, sweetened with aspartame)",
    "FOODON_03415082": "blue fenugreek plant",
    "NCBITaxon_134033": "Castanea dentata",
    "NCBITaxon_4119": "Ipomoea",
    "FOODON_03312028": "cow curd food product",
    "ENVO_00000078": "farm",
    "FOODON_03413546": "red-brown ark",
    "HANCESTRO_0350": "Bermudian",
    "FOODON_03540315": "03150 - oat rolled grains, instant (efsa foodex2)",
    "FOODON_00003296": "sweet and sour dish",
    "NCBITaxon_23808": "Simaroubaceae",
    "FOODON_03541246": "12460 - argan nuts (efsa foodex2)",
    "FOODON_03530107": "extent of fat trim",
    "FOODON_03543055": "30550 - chewing gum (efsa foodex2)",
    "FOODON_03308671": "fantail shrimp (raw, breaded, frozen)",
    "NCBITaxon_3886": "Phaseolus coccineus",
    "NCBITaxon_3729": "Sisymbrium",
    "NCBITaxon_9857": "Capreolus",
    "NCBITaxon_3760": "Prunus persica",
    "FOODON_03541317": "13170 - wattleseeds (efsa foodex2)",
    "FOODON_03490391": "plastic container, combined material",
    "NCBITaxon_7847": "Isurus paucus",
    "FOODON_00001788": "cranberry preserve or jam food product",
    "FOODON_03305523": "game meat (raw)",
    "FOODON_00002421": "cambozola cheese",
    "NCBITaxon_3997": "Simmondsiaceae",
    "FOODON_00003392": "aquaculture open-pen rearing",
    "NCBITaxon_195615": "Hippoglossus stenolepis",
    "NCBITaxon_37656": "Citrus x paradisi",
    "NCBITaxon_526620": "Peltorhamphus novaezeelandiae",
    "FOODON_03411928": "brazilian duckbill",
    "FOODON_03310725": "mussel paste",
    "FOODON_03302850": "chocolate chip cookie",
    "FOODON_03316537": "cheese (maturing, rennet)",
    "FOODON_03543790": "37900 - special food for children's growth (efsa foodex2)",
    "FOODON_03414444": "sodium acetates",
    "FOODON_03414193": "eastern purple coneflower plant",
    "CHEBI_35267": "quaternary ammonium ion",
    "FOODON_03411461": "raccoon",
    "FOODON_03411916": "requiem shark family",
    "CHEBI_21241": "vitamin C",
    "RO_0000092": "disposition of",
    "PATO_0001543": "flexibility",
    "FOODON_00002410": "thickness of 1.5 cm or more",
    "FOODON_03316619": "fruit juice (fresh)",
    "FOODON_03414521": "french rose plant",
    "FOODON_03309506": "raspberry spread (artificially sweetened)",
    "FOODON_03309724": "fish (sliced, vegetable added, raw)",
    "HANCESTRO_0013": "Native American",
    "HANCESTRO_0311": "Friuli Venezia Giulia",
    "FOODON_03540999": "09990 - stalks/canes/trunk sap or similar for sugar (efsa foodex2)",
    "FOODON_03411689": "custard apple tree",
    "FOODON_03544406": "44060 - whiskey flavour (efsa foodex2)",
    "FOODON_03520511": "FAO statistical areas for fishery purposes",
    "FOODON_03307168": "fruit conserve with liqueur",
    "FOODON_00001901": "ginger food product",
    "FOODON_03542797": "27970 - cheese, baita friuli (efsa foodex2)",
    "FOODON_03543391": "33910 - liqueurs (efsa foodex2)",
    "FOODON_03303668": "lancashire cheese",
    "FOODON_03414322": "beira tronchuda cabbage plant",
    "NCBITaxon_30862": "Pomacanthidae",
    "FOODON_00001211": "pasta food product",
    "FOODON_03317474": "cheese analog, processed",
    "GAZ_00003945": "Reunion Island",
    "GENEPIO_0000162": "user interface definition",
    "FOODON_03307566": "white sugar (plantation)",
    "NCBITaxon_32224": "Eriobotrya japonica",
    "FOODON_03308276": "kahawai (raw)",
    "FOODON_03311876": "chicken (baked)",
    "FOODON_03316524": "vegetable and fruit sauce",
    "FOODON_03543814": "38140 - bee-produced formulations (efsa foodex2)",
    "BFO_0000146": "two-dimensional continuant fiat boundary",
    "FOODON_03305999": "vegetable beef soup",
    "FOODON_03542984": "29840 - sucrose (common sugar) (efsa foodex2)",
    "FOODON_03400635": "CCFAC egg and egg products",
    "FOODON_03541711": "17110 - passionfruits (efsa foodex2)",
    "FOODON_03542345": "23450 - cods, hakes, haddocks (efsa foodex2)",
    "FOODON_03541526": "15260 - other stone fruits (e) (efsa foodex2)",
    "GAZ_00000908": "Ghana",
    "FOODON_03420147": "whole animal, skinned, defeathered or scaled, not eviscerated",
    "FOODON_03460197": "food bleaching process",
    "FOODON_03306845": "papaya concentrate (nonnutritively sweetened)",
    "FOODON_03310477": "tom collins mix",
    "FOODON_03311431": "milk tea (canned)",
    "FOODON_03315991": "crustacean (marinated)",
    "FOODON_03541848": "18480 - candied fruits (efsa foodex2)",
    "FOODON_03301760": "cereal grain (unprocessed)",
    "FOODON_03303887": "vinegar and spice salad dressing (italian-style)",
    "FOODON_03401537": "10006203 - in-shell checked/dirty eggs (gs1 gpc)",
    "FOODON_03541192": "11920 - mustard seed, field (efsa foodex2)",
    "CHEBI_33704": "alpha-amino acid",
    "PO_0030099": "samara fruit",
    "FOODON_00001849": "field corn vegetable food product",
    "FOODON_03412718": "sand tiger shark",
    "FOODON_03315979": "fruit (canned, energy reduced)",
    "FOODON_03413351": "garfish",
    "FOODON_03309652": "peach and yogurt (infant food)",
    "CHEBI_65212": "polysaccharide derivative",
    "FOODON_03308665": "shrimp (japanese, deveined, canned)",
    "NCBITaxon_979180": "Acetes japonicus",
    "FOODON_03541607": "16070 - redcurrants (efsa foodex2)",
    "FOODON_03304008": "barbeque sauce (bottled)",
    "FOODON_03450044": "rotisserie roasting",
    "FOODON_03540824": "08240 - herbs and edible flowers (efsa foodex2)",
    "FOODON_03412027": "quinoa plant",
    "FOODON_03304609": "imitation fruit sherbet",
    "FOODON_03304860": "collard leaf (whole, raw)",
    "FOODON_03303926": "vermicelli",
    "FOODON_03544369": "43690 - sea buckthorn flavour (efsa foodex2)",
    "FOODON_03544389": "43890 - tandoori flavour (efsa foodex2)",
    "NCBITaxon_159053": "Limonia acidissima",
    "FOODON_03542071": "20710 - ratites edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "NCBITaxon_8475": "Chelydra serpentina",
    "GAZ_00023304": "Ross Sea",
    "FOODON_03411507": "grapefruit plant",
    "NCBITaxon_13215": "Piper",
    "FOODON_03302699": "spice extract",
    "FOODON_03303557": "beef gravy mix",
    "FOODON_03309753": "sunflower (raw)",
    "FOODON_03315757": "hop extract (preisomerized)",
    "FOODON_03413088": "disodium inosinate",
    "FOODON_03540210": "02100 - short pastry dough and similar (efsa foodex2)",
    "FOODON_00001672": "buffalofish food product",
    "FOODON_03544368": "43680 - sage flavour (efsa foodex2)",
    "FOODON_03302458": "cheddar cheese",
    "NCBITaxon_8190": "Mugil",
    "FOODON_03544070": "40700 - gravy browning (efsa foodex2)",
    "FOODON_03520501": "cool summer climatic zone",
    "GAZ_00067142": "Guadeloupe Region",
    "FOODON_03307599": "malted cereal syrup",
    "NCBITaxon_147368": "Pooideae",
    "FOODON_03308893": "spiny dogfish (raw)",
    "FOODON_00002364": "wine or wine-like food product",
    "FOODON_03541631": "16310 - phalsa fruits (efsa foodex2)",
    "FOODON_03412797": "babaco plant",
    "FOODON_03317006": "kyungyook (processed)",
    "FOODON_03401663": "10005792 - goat - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03315334": "fruit wine",
    "FOODON_03413682": "little squid",
    "FOODON_03414682": "peanut tree",
    "NCBITaxon_184443": "Diplectrum",
    "FOODON_03541932": "19320 - goat fresh meat (efsa foodex2)",
    "FOODON_03307016": "pear (baked, canned)",
    "ENVO_00002263": "garden soil",
    "FOODON_03543713": "37130 - malt coffee infusion (efsa foodex2)",
    "FOODON_03542336": "23360 - halibut, pacific (efsa foodex2)",
    "FOODON_03308551": "scallop (sea, french-fried)",
    "FOODON_03544365": "43650 - rosemary flavour (efsa foodex2)",
    "FOODON_03304763": "maritza wafer",
    "FOODON_03305199": "imitation bacon bit",
    "FOODON_03411563": "poultry or game bird",
    "FOODON_03316406": "barley (peeled)",
    "NCBITaxon_41938": "Malvales",
    "FOODON_03317081": "fruit (with no added sugar, canned)",
    "FOODON_03413397": "cush-cush yam plant",
    "NCBITaxon_34979": "Henophidia",
    "CHEBI_22712": "benzenes",
    "FOODON_03460359": "food aeration by creaming",
    "FOODON_03543201": "32010 - nectar, peach (efsa foodex2)",
    "FOODON_03411108": "cherry salmon",
    "FOODON_03310389": "blueberry preserve",
    "FOODON_03414311": "sillago-whiting family",
    "FOODON_03411497": "snow crab",
    "FOODON_03541324": "13240 - cassia buds (efsa foodex2)",
    "FOODON_03311377": "ground beef (cooked, freeze-dried)",
    "FOODON_03311874": "kombucha tea",
    "FOODON_03543671": "36710 - chinabark (infusion bark) (efsa foodex2)",
    "FOODON_03544120": "41200 - tabasco sauce (efsa foodex2)",
    "FOODON_03412842": "horned melon plant",
    "FOODON_03316833": "spaghetti (egg, vegetable)",
    "FOODON_03543890": "38900 - fries (finger chips) (efsa foodex2)",
    "FOODON_03411954": "antarctic krill",
    "FOODON_00001231": "creamy salad dressing",
    "FOODON_03303897": "vegetable soup (canned)",
    "FOODON_00002764": "shell bean pod",
    "FOODON_00002613": "Syrah grape plant",
    "FOODON_03317020": "blancmange concentrate",
    "FOODON_03412780": "sweet garcinia plant",
    "FOODON_03544383": "43830 - sultanas flavour (efsa foodex2)",
    "FOODON_03543970": "39700 - pasta, filled with vegetable mix, cooked (efsa foodex2)",
    "FOODON_03316482": "ice cream (commercial, packed)",
    "FOODON_03543002": "30020 - citrus molasses (efsa foodex2)",
    "FOODON_03303101": "coffee with anise oil added (dry, instant)",
    "FOODON_03315532": "fish product (fully preserved)",
    "FOODON_03490105": "plastic squeeze bottle or tube, top lined with cork",
    "FOODON_03412351": "rock crab family",
    "FOODON_03541946": "19460 - deer fresh meat (efsa foodex2)",
    "ENVO_01000936": "dedicated campground",
    "FOODON_03307132": "herring (smoked)",
    "NCBITaxon_217494": "Engraulis ringens",
    "FOODON_03315268": "food (starch or flour thickened)",
    "FOODON_03411568": "apple banana plant",
    "FOODON_03306563": "cocktail onion",
    "FOODON_03310575": "pork (processed, spam-type)",
    "NCBITaxon_4285": "Cornus mas",
    "FOODON_03311033": "cherry cream candy chocolate and peanut coated",
    "FOODON_03411764": "white bass",
    "FOODON_03307158": "fruit spread (frozen, uncooked)",
    "FOODON_03308216": "yellowtail flounder (raw)",
    "FOODON_03304826": "blackberry beverage syrup",
    "FOODON_03412276": "tautog",
    "FOODON_03541662": "16620 - ambarellas (efsa foodex2)",
    "FOODON_03304243": "split green pea soup with pork",
    "FOODON_03307539": "food (dried)",
    "FOODON_03544370": "43700 - sherry flavour (efsa foodex2)",
    "NCBITaxon_50557": "Insecta",
    "FOODON_03401100": "10000241 - pasta/noodles - ready to eat (shelf stable) (gs1 gpc)",
    "FOODON_03414627": "southern hemisphere crayfish family",
    "NCBITaxon_8911": "Larus",
    "NCBITaxon_735337": "Euheterodonta",
    "FOODON_03316015": "dessert fruit based",
    "NCBITaxon_259702": "Atractoscion",
    "FOODON_03302286": "imitation lemonade base (vitamin-fortified, artificially sweetened)",
    "FOODON_03309640": "gafftopsail catfish (raw)",
    "FOODON_03543045": "30450 - filled chocolate (efsa foodex2)",
    "FOODON_03543979": "39790 - milk rice (efsa foodex2)",
    "FOODON_03412941": "curled endive plant",
    "FOODON_03414746": "chaff flower plant",
    "FOODON_03510121": "not pasteurized claim or use",
    "FOODON_00001293": "shellfish food product",
    "FOODON_03310795": "heavy cream",
    "FOODON_03312057": "peanut flour (defatted)",
    "FOODON_03542861": "28610 - cheese, vacherin fribourgeois (efsa foodex2)",
    "FOODON_03309873": "kidney bean cake",
    "NCBITaxon_32201": "Carya illinoinensis",
    "FOODON_03315740": "flour (white, enriched)",
    "GAZ_00002941": "Switzerland",
    "FOODON_03304395": "skim milk (pasteurized, fortified)",
    "FOODON_03412593": "great hammerhead",
    "FOODON_03400188": "confectionery (us cfr)",
    "FOODON_03310445": "chrysanthemum beverage (instant)",
    "FOODON_03317322": "pork butt (uncooked, cured)",
    "NCBITaxon_210376": "Flacourtia indica",
    "FOODON_03304172": "cookie (french)",
    "FOODON_03401272": "USDA SR spices and herbs (0200)",
    "RO_0009005": "has primary substance added",
    "FOODON_03307441": "strawberry yogurt",
    "FOODON_03315985": "vegetable preparation (energy-reduced)",
    "FOODON_03308449": "northern bluefin tuna (raw)",
    "FOODON_03401646": "10006393 - roe deer - prepared/processed (gs1 gpc)",
    "FOODON_03530229": "hazard 1",
    "NCBITaxon_81641": "Lotidae",
    "FOODON_03301323": "reishi mushroom extract",
    "FOODON_03541252": "12520 - maripa palm fruits (efsa foodex2)",
    "FOODON_03307885": "gelatin salad",
    "FOODON_03414472": "grizzly bear",
    "FOODON_03317644": "flour (protein-increased)",
    "FOODON_03414317": "african finger millet plant",
    "FOODON_03544121": "41210 - aioli or garlic sauce (efsa foodex2)",
    "FOODON_03490400": "polyethylene (low density) - nylon 11 container",
    "ENVO_00000519": "agricultural terrace",
    "FOODON_03301560": "sage leaf (whole)",
    "FOODON_03541154": "11540 - stone pine nut kernels (efsa foodex2)",
    "FOODON_03400225": "relish (us cfr)",
    "FOODON_03401445": "10006193 - red currants (gs1 gpc)",
    "FOODON_03544505": "45050 - dietary fibre (efsa foodex2)",
    "BFO_0000004": "independent continuant",
    "FOODON_03308858": "japanese deep sea crab (raw)",
    "NCBITaxon_722433": "Conodon nobilis",
    "FOODON_03542275": "22750 - nile perch (efsa foodex2)",
    "FOODON_03304005": "sauce (old-style)",
    "FOODON_03306714": "pineapple topping",
    "FOODON_03400264": "vegetable juice (us cfr)",
    "ENVO_01000247": "rangeland biome",
    "FOODON_03317452": "sambuca",
    "PO_0025082": "reproductive shoot system",
    "HANCESTRO_0336": "Haitian",
    "FOODON_03401670": "10005796 - llama/alpaca - unprepared/unprocessed (gs1 gpc)",
    "HANCESTRO_0466": "Fijian",
    "FOODON_03308522": "cod composite fillet (skinless, breaded)",
    "FOODON_03400957": "10000247 - pies/pastries - sweet (shelf stable) (gs1 gpc)",
    "FOODON_03412572": "seahorse",
    "FOODON_03400951": "50182000 - sweet bakery products (gs1 gpc)",
    "FOODON_03414336": "eucheuma",
    "FOODON_03316276": "delicatessen salad",
    "CHEBI_32111": "saccharin",
    "FOODON_03541416": "14160 - canned or jarred legumes (efsa foodex2)",
    "FOODON_03305866": "rosemary jelly",
    "FOODON_03308882": "flounder fillet (skinless, frozen)",
    "NCBITaxon_27808": "Chlamys islandica",
    "FOODON_03308726": "yellowtail tuna (in cottonseed oil, smoked)",
    "CHEBI_35196": "nitrogen oxide",
    "FOODON_03541186": "11860 - sunflower seeds and similar- (efsa foodex2)",
    "FOODON_03304902": "wax chewing gum product",
    "CHEBI_25608": "nucleoside phosphate",
    "FOODON_03308921": "mackerel (canned)",
    "FOODON_03415029": "swiss pine plant",
    "FOODON_03542732": "27320 - fresh uncured cheese (efsa foodex2)",
    "FOODON_03401130": "10000148 - aquatic invertebrates - unprepared/unprocessed (frozen) (gs1 gpc)",
    "FOODON_03311031": "yellow corn (cracked)",
    "FOODON_03304779": "beef stew",
    "FOODON_03540458": "04580 - watercresses (efsa foodex2)",
    "FOODON_03413342": "indian lettuce plant",
    "FOODON_03401834": "10006089 - dandelion greens/lion's tooth (gs1 gpc)",
    "CHEBI_16646": "carbohydrate",
    "FOODON_03315416": "beverage mix (cow skim milk based)",
    "FOODON_03490244": "crown cap",
    "FOODON_03540185": "01850 - fresh stuffed pasta (efsa foodex2)",
    "FOODON_03540686": "06860 - patisson (efsa foodex2)",
    "FOODON_03543250": "32500 - fruit/vegetable juice powder (efsa foodex2)",
    "FOODON_03411449": "peppermint plant",
    "NCBITaxon_96888": "Sardinella longiceps",
    "FOODON_03306403": "orange marmalade (chunky)",
    "GAZ_00006898": "Montenegro",
    "NCBITaxon_1266862": "Ammodytes dubius",
    "FOODON_03309897": "seltzer water",
    "FOODON_03544512": "45120 - taurine (efsa foodex2)",
    "FOODON_00002521": "beetle larva",
    "FOODON_03412949": "virginia strawberry plant",
    "FOODON_03541663": "16630 - aonlas (efsa foodex2)",
    "NCBITaxon_58934": "Zizania latifolia",
    "FOODON_03307870": "chaparral tea (dry)",
    "FOODON_03541440": "14400 - bitter oranges (efsa foodex2)",
    "FOODON_03540359": "03590 - leafy vegetables (efsa foodex2)",
    "FOODON_03541550": "15500 - tayberries (efsa foodex2)",
    "FOODON_03302876": "peanut (whole, skin off, salted, partially defatted)",
    "FOODON_03303374": "celery (diced)",
    "FOODON_03415158": "hollyhock plant",
    "FOODON_03304549": "rice (ground)",
    "FOODON_03401359": "50132600 - dairy derivatives/by products (gs1 gpc)",
    "NCBITaxon_2607033": "Apodinae",
    "NCBITaxon_69683": "Ellobiidae",
    "FOODON_03311656": "koji",
    "FOODON_03301842": "curry powder",
    "FOODON_03414693": "drooping mistletoe plant",
    "FOODON_00001778": "cow milk hard cheese food product",
    "FOODON_03317508": "polenta",
    "FOODON_03412392": "pickhandle barracuda",
    "FOODON_03315638": "cream cheese spread",
    "HANCESTRO_0407": "Ecuadorian",
    "FOODON_03308171": "long-legged spiny lobster (raw)",
    "HANCESTRO_0344": "Albanian",
    "FOODON_03310287": "garbanzo bean (whole, dried)",
    "FOODON_03304112": "pepperoni pizza spread",
    "NCBITaxon_492050": "Xenodermichthys",
    "NCBITaxon_492024": "Alepocephalus australis",
    "FOODON_03316839": "spaghetti (egg, wheat, and soy)",
    "NCBITaxon_83906": "Boehmeria nivea",
    "FOODON_03302768": "butter pound cake",
    "FOODON_03543023": "30230 - other polyols (efsa foodex2)",
    "FOODON_03544281": "42810 - guarana flavour (efsa foodex2)",
    "GAZ_00003756": "Viet Nam",
    "FOODON_03400324": "food additive classification, european community",
    "UO_0000099": "liter",
    "FOODON_03307490": "cow milk (tuberculin-free)",
    "FOODON_03301404": "obsolete: pickle",
    "FOODON_00002992": "fresh bratwurst",
    "NCBITaxon_78534": "Trigonella foenum-graecum",
    "FOODON_03301967": "banana pulp",
    "FOODON_03306327": "oyster pacific powdered freeze-dried",
    "FOODON_03311509": "frankfurter (skinless)",
    "FOODON_03308819": "spring water lobster (raw)",
    "FOODON_03310410": "cheshire cheese",
    "FOODON_03542868": "28680 - cheese, aged graviera (efsa foodex2)",
    "FOODON_03316339": "pumpkin (cooked)",
    "FOODON_03307335": "blueberry conserve",
    "FOODON_03412485": "kingklip",
    "FOODON_03301325": "beverage (carbonated, artificially sweetened)",
    "FOODON_03401441": "10006431 - lingonberries (gs1 gpc)",
    "FOODON_03301716": "spinach (whole, raw)",
    "ENVO_01000685": "water mass",
    "FOODON_03470143": "drying under normal pressure",
    "FOODON_03305568": "bean (ham-flavored, dried)",
    "FOODON_03302280": "grape drink (carbonated, artificially flavored and colored, vitamin-fortified)",
    "FOODON_00002467": "lobster tail (shell on)",
    "FOODON_03400867": "sandwich filling (eurofir)",
    "FOODON_03510061": "sugars special claim or use",
    "FOODON_03412370": "bloch's gizzard shad",
    "FOODON_00001691": "cassava snack food product",
    "FOODON_03412505": "millet plant",
    "FOODON_03306991": "imitation raspberry preserve",
    "FOODON_00003358": "chicken thigh (debonned)",
    "FOODON_03414489": "owl order",
    "NCBITaxon_1505891": "Epinephelini",
    "FOODON_03412434": "tilapia",
    "NCBITaxon_223860": "Raja radula",
    "FOODON_03303672": "cheese loaf",
    "FOODON_03415011": "aztec sweetherb plant",
    "FOODON_03308304": "white king salmon (smoked)",
    "ENVO_01000254": "environmental system",
    "CHEBI_16199": "urea",
    "PO_0004518": "bark",
    "FOODON_03414702": "bush tomato plant",
    "FOODON_03311101": "chicken (whole, cooked)",
    "NCBITaxon_28702": "Fratercula corniculata",
    "NCBITaxon_490374": "Rhombosoleidae",
    "FOODON_03308023": "atlantic cod (raw)",
    "FOODON_03414354": "orangelo plant",
    "CHEBI_26933": "tetraric acid",
    "FOODON_03450040": "food reheating by boil-in-bag",
    "FOODON_03302377": "balloon bread",
    "FOODON_03413991": "frigate mackerel",
    "NCBITaxon_30761": "Macrouridae",
    "FOODON_03310573": "turkey sandwich",
    "FOODON_03308076": "fish stick (precooked)",
    "FOODON_03401708": "10005965 - cape gooseberries (gs1 gpc)",
    "FOODON_03412460": "red drum",
    "FOODON_03304025": "sauce galuska",
    "FOODON_03305986": "fruit pit kernel",
    "PO_0020042": "simple leaf",
    "FOODON_03400710": "20  coffee, tea, cocoa powder (efg)",
    "NCBITaxon_27766": "Coryphaenidae",
    "FOODON_03543721": "37210 - mixed coffee imitates infusion (efsa foodex2)",
    "NCBITaxon_3823": "Canavalia ensiformis",
    "FOODON_03309194": "mussel (blue, raw)",
    "FOODON_03490171": "aluminum tube, top lined with cork",
    "FOODON_03305805": "cornstarch (artificially flavored and colored)",
    "FOODON_03311477": "lemon pie filling",
    "FOODON_00002268": "spice or herb product flavoring or seasoning",
    "FOODON_03540266": "02660 - muffins (efsa foodex2)",
    "FOODON_00002083": "papaya nectar beverage",
    "GAZ_00003986": "Cayman Islands",
    "FOODON_00002077": "palinurid spiny lobster food product",
    "FOODON_03307009": "chicken-flavored rice and macaroni mix",
    "FOODON_00002216": "sablefish food product",
    "FOODON_03311783": "runner peanut (whole, raw)",
    "FOODON_03311787": "chicken breast (sliced, ready-to-eat)",
    "FOODON_03316957": "noodle product (egg, vegetable)",
    "FOODON_03541061": "10610 - yellow lupin (without pods) (efsa foodex2)",
    "FOODON_03304407": "clingstone peach (artificially sweetened)",
    "NCBITaxon_29159": "Crassostrea gigas",
    "FOODON_03401476": "10000598 - bread/bakery products variety packs (gs1 gpc)",
    "FOODON_03460324": "partial fat removal process, 50% or more remaining",
    "FOODON_03400279": "cured meat (us cfr)",
    "FOODON_03317321": "pork shoulder (uncooked, cured)",
    "FOODON_03530129": "collier",
    "FOODON_03415073": "prostrate knotweed plant",
    "FOODON_03315631": "skim milk (milk solids added)",
    "FOODON_03305780": "imitation rose petal jam",
    "FOODON_03530082": "processed in glass container",
    "FOODON_03414665": "blue quandong plant",
    "FOODON_03317448": "crustacean (whole or flesh part)",
    "FOODON_03413858": "southern african pilchard",
    "FOODON_03543356": "33560 - wine-like drinks (efsa foodex2)",
    "PATO_0001306": "decreased temperature",
    "NCBITaxon_387127": "Coccinia grandis",
    "FOODON_03308306": "salmon croquette",
    "FOODON_03316964": "macaroni product (enriched with fortified protein)",
    "FOODON_00002806": "moth bean (whole, dried)",
    "FOODON_03306542": "apricot tartlet",
    "FOODON_03413987": "broad-barred king mackerel",
    "ENVO_01000618": "lotic water body",
    "FOODON_03306525": "chinese wet noodle",
    "FOODON_03541261": "12610 - angelica, dry (efsa foodex2)",
    "FOODON_03310682": "guava nectar",
    "FOODON_03411335": "crab",
    "FOODON_03302965": "champagne biscuit",
    "FOODON_03306924": "pimiento cheese",
    "FOODON_00002486": "apricot (whole or parts)",
    "HANCESTRO_0451": "Turkish",
    "NCBITaxon_57919": "Geum urbanum",
    "CHEBI_33655": "aromatic compound",
    "FOODON_03411846": "eelpout family",
    "FOODON_03301472": "starch (thin boiling)",
    "FOODON_03414008": "raitt's sandeel",
    "FOODON_03411794": "croaker",
    "FOODON_03304796": "scrambled hen egg mix",
    "GO_0044237": "cellular metabolic process",
    "FOODON_03542414": "24140 - bonito (efsa foodex2)",
    "FOODON_03304207": "cream of lobster soup",
    "FOODON_03544088": "40880 - vinegar, wine (efsa foodex2)",
    "FOODON_03309689": "pacific ocean snapper (raw)",
    "FOODON_03315824": "carbohydrate reduced food",
    "FOODON_03414602": "badderlocks",
    "FOODON_03543158": "31580 - fruit / vegetable juices and nectars (efsa foodex2)",
    "FOODON_00001126": "bovine cheese food product",
    "FOODON_03301775": "mung bean (whole, dried)",
    "FOODON_03401894": "10006171 - vegetables - unprepared/unprocessed (fresh) variety packs (gs1 gpc)",
    "FOODON_03301149": "acorn (whole, raw)",
    "FOODON_03530193": "fat content < 30%",
    "FOODON_03303106": "imitation instant coffee",
    "FOODON_03541710": "17100 - passionfruits and similar- (efsa foodex2)",
    "FOODON_00003268": "croziflette",
    "FOODON_03540241": "02410 - biscuits, sweet, wheat wholemeal (efsa foodex2)",
    "FOODON_03413416": "kapok plant",
    "NCBITaxon_29144": "Chanos chanos",
    "BFO_0000020": "specifically dependent continuant",
    "FOODON_03316722": "strawberry (quick-frozen)",
    "FOODON_00001585": "almond candy food product",
    "NCBITaxon_48194": "Mugil curema",
    "FOODON_03308275": "harvestfish (raw)",
    "FOODON_03304571": "rose hip dessert (instant)",
    "FOODON_03306066": "apple jelly (rum-flavored)",
    "PATO_0000001": "quality",
    "FOODON_03301737": "gammelost cheese",
    "FOODON_03450046": "blind baking",
    "FOODON_03540388": "03880 - baby leaf chards (efsa foodex2)",
    "FOODON_03543423": "34230 - rye coffee ingredient (efsa foodex2)",
    "FOODON_03315642": "cheese food with added ingredients processed",
    "FOODON_03401510": "10005887 - satsuma mandarins (gs1 gpc)",
    "FOODON_03301107": "nectarine (whole, raw)",
    "HANCESTRO_0465": "Cook Islander",
    "CHEBI_48154": "sulfur oxide",
    "FOODON_03412138": "triggerfish family",
    "FOODON_03500045": "food-grade textile surface",
    "FOODON_00002355": "wheat refined food product",
    "FOODON_03308180": "rock lobster (whole, raw)",
    "FOODON_03544211": "42110 - brandy flavour (efsa foodex2)",
    "FOODON_03413345": "manchurian crabapple plant",
    "FOODON_00001939": "grouse meat food product",
    "RO_0000053": "bearer of",
    "FOODON_03310336": "food supplement tablet",
    "NCBITaxon_94237": "Mola mola",
    "GO_0006091": "generation of precursor metabolites and energy",
    "FOODON_03544029": "40290 - prepared meat salad (efsa foodex2)",
    "FOODON_03412062": "naranjilla plant",
    "FOODON_03309585": "cheese for manufacturing use",
    "IAO_0000124": "uncurated",
    "NCBITaxon_72449": "Hexagrammos",
    "FOODON_03414083": "blond ray",
    "FOODON_03301773": "artichoke (whole, raw)",
    "FOODON_03401288": "USDA SR baked products (1800)",
    "FOODON_03308060": "halibut fillet (frozen)",
    "NCBITaxon_30983": "Hexagrammidae",
    "NCBITaxon_28379": "Faxonius limosus",
    "FOODON_03400101": "cultured milk product (us cfr)",
    "FOODON_03309524": "cape spiny lobster meat (canned)",
    "NCBITaxon_147429": "Andropogoneae",
    "FOODON_03541810": "18100 - jam, currants (black) (efsa foodex2)",
    "FOODON_03542061": "20610 - asses-mules-hinnies edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "FOODON_03401625": "10006300 - elk/wapiti - prepared/processed (gs1 gpc)",
    "FOODON_03401568": "10006050 - archangel (gs1 gpc)",
    "FOODON_03412218": "coconut crab family",
    "FOODON_03306709": "pineapple pie filling",
    "NCBITaxon_83752": "Rattus argentiventer",
    "FOODON_03311730": "ricotone cheese",
    "FOODON_03308605": "crab cake (cooked)",
    "ENVO_00000000": "geographic feature",
    "FOODON_03413369": "murray cod",
    "FOODON_03309532": "capon (raw)",
    "FOODON_03413995": "bluespot mullet",
    "FOODON_03412474": "rocket plant",
    "FOODON_03543767": "37670 - follow-on formula, milk-based, liquid (efsa foodex2)",
    "FOODON_03301352": "peanut (whole, skin off)",
    "FOODON_03401872": "10005912 - peaches (gs1 gpc)",
    "FOODON_03430145": "sliced, thin, below 0.5 cm.",
    "FOODON_03401024": "obsolete: 50112100 - meat/poultry/game/batrachian variety packs (gs1 gpc)",
    "FOODON_03543268": "32680 - bottled water (efsa foodex2)",
    "FOODON_03544069": "40690 - gravy thickener (efsa foodex2)",
    "FOODON_03541113": "11130 - kersting's groundnut (dry seeds) (efsa foodex2)",
    "FOODON_03543566": "35660 - common honeybush tea (efsa foodex2)",
    "FOODON_00002792": "potato flakes",
    "FOODON_03309604": "broccoli au gratin",
    "FOODON_03460188": "obsolete: breaded or batter-coated",
    "FOODON_03308952": "rock cod (raw)",
    "FOODON_00002457": "food (fresh)",
    "FOODON_03306467": "deer meat (raw)",
    "FOODON_03543506": "35060 - ruderalis hemp infusion leaves (efsa foodex2)",
    "FOODON_03412791": "wild apricot plant",
    "ENVO_00002011": "fresh water",
    "ENVO_01000781": "public building",
    "FOODON_03413700": "antarctic flying squid",
    "FOODON_03413356": "chickling vetch plant",
    "FOODON_03309880": "red clover (raw)",
    "FOODON_03400377": "bleaching agent (codex)",
    "FOODON_03543932": "39320 - pizza and pizza-like dishes (efsa foodex2)",
    "FOODON_03544391": "43910 - tea black flavour (efsa foodex2)",
    "FOODON_03301081": "crabmeat",
    "FOODON_03411776": "widow rockfish",
    "FOODON_03542459": "24590 - thresher sharks (efsa foodex2)",
    "FOODON_03304828": "oat bar (sweetened)",
    "NCBITaxon_3277": "Matteuccia struthiopteris",
    "FOODON_03490326": "regenerated cellulose film",
    "NCBITaxon_1051068": "Doryteuthis pleii",
    "FOODON_03317308": "meat salad (refrigerated)",
    "FOODON_03543420": "34200 - malt coffee ingredient (efsa foodex2)",
    "FOODON_03414848": "rat",
    "FOODON_03301322": "water buffalo meat (raw)",
    "FOODON_03306033": "orange juice concentrate (frozen)",
    "FOODON_03490124": "plastic tray or pan, plastic cover or wrapping",
    "FOODON_03412719": "emu",
    "FOODON_03543321": "33210 - cola beverages, decaffeinated (efsa foodex2)",
    "FOODON_03306159": "rose grape juice",
    "FOODON_03543435": "34350 - cocoa powder (efsa foodex2)",
    "NCBITaxon_30854": "Mullidae",
    "FOODON_03306614": "danish roll",
    "FOODON_03305619": "herring (raw)",
    "FOODON_03307560": "sugar (fortified with vitamins and minerals)",
    "FOODON_03311625": "beverage (nonalcoholic, flavored, ready-to-serve)",
    "FOODON_03315148": "vegetable juice (processed)",
    "FOODON_03400903": "10000178 - chocolate/cocoa/malt - not ready to drink (gs1 gpc)",
    "NCBITaxon_29818": "Plantago major",
    "NCBITaxon_319752": "Allocyttus folletti",
    "FOODON_03541201": "12010 - cotton seeds and similar- (efsa foodex2)",
    "FOODON_03414687": "monkeynut plant",
    "FOODON_03500049": "husk food contact surface",
    "FOODON_03411260": "ginkgo tree",
    "FOODON_03307595": "apple (sliced, canned)",
    "FOODON_00001848": "field corn sweetener product",
    "FOODON_03311600": "mastutake mushroom",
    "FOODON_03308647": "scallop (bay, raw)",
    "FOODON_03305444": "tuna (raw)",
    "FOODON_03317590": "pork and beans",
    "FOODON_03306737": "red cayenne pepper paste",
    "GAZ_00001412": "Falkland Islands",
    "FOODON_03308946": "freshwater mullet (raw)",
    "FOODON_03400285": "custard or pudding (us cfr)",
    "FOODON_00003209": "steel cut oats",
    "FOODON_00002927": "green mole powder",
    "NCBITaxon_28478": "Xanthosoma sagittifolium",
    "NCBITaxon_30511": "Squalidae",
    "NCBITaxon_8169": "Sparidae",
    "FOODON_03413408": "canihua plant",
    "FOODON_03412866": "emperor family",
    "FOODON_03309795": "tomato catsup substitute (sweetened with honey)",
    "FOODON_03413825": "mediterranean flagfin",
    "FOODON_03316519": "culinary fat",
    "NCBITaxon_30459": "Strigidae",
    "FOODON_03540506": "05060 - ginger shoots (efsa foodex2)",
    "FOODON_03305208": "garlic (whole, raw)",
    "FOODON_03315956": "milk-derivative-based preparation (desserts and similar products) energy reduced",
    "CHEBI_47704": "ammonium salt",
    "FOODON_03315435": "chili paste",
    "FOODON_03540742": "07420 - salsifies and similar- (efsa foodex2)",
    "NCBITaxon_82407": "Grewia",
    "FOODON_03302190": "meal replacement (weight-reducing)",
    "HANCESTRO_0556": "Cilento",
    "FOODON_03304630": "frosted rich drink mix",
    "CHEBI_35748": "fatty acid ester",
    "FOODON_03540717": "07170 - horseradishes and similar- (efsa foodex2)",
    "FOODON_03411389": "squirrel",
    "FOODON_03305887": "imitation mint-flavored jelly artificially colored",
    "FOODON_03311077": "poultry infant food",
    "FOODON_03414611": "tub gurnard",
    "FOODON_03316311": "raspberry (preserved in airtight container)",
    "NCBITaxon_3646": "Malpighiales",
    "FOODON_03413383": "bermuda grass plant",
    "FOODON_03541952": "19520 - reindeer meat (efsa foodex2)",
    "FOODON_00002041": "mineral water food product",
    "FOODON_00002050": "mushroom vegetable food product",
    "FOODON_03311326": "hen egg white (raw, stabilized)",
    "FOODON_03510168": "pareve claim or use",
    "NCBITaxon_83375": "Aesculus turbinata",
    "FOODON_03401238": "0401000 - oilseeds (ec)",
    "FOODON_03490245": "metal screw cap or lid",
    "FOODON_03414680": "brush cherry plant",
    "FOODON_03544158": "41580 - gelatine (efsa foodex2)",
    "FOODON_00003093": "sorrel food product",
    "FOODON_03304655": "cheese ravioli with cheese sauce",
    "FOODON_03413809": "fish, osmeriform",
    "FOODON_03309477": "grouse in wine sauce",
    "FOODON_03400836": "sugar, honey or syrup (eurofir)",
    "FOODON_03510203": "high protein food",
    "FOODON_03540610": "06100 - rice beans (with pods) (efsa foodex2)",
    "FOODON_03304328": "papaya beverage syrup",
    "FOODON_03310991": "vermouth dry",
    "FOODON_03310909": "cream (reactivated)",
    "FOODON_03540856": "08560 - sage (efsa foodex2)",
    "FOODON_03412456": "pak kard plant",
    "FOODON_03412098": "bison",
    "FOODON_03307074": "bitter lemon drink",
    "FOODON_03520359": "europe, western",
    "FOODON_03543117": "31170 - cocoa butter (efsa foodex2)",
    "FOODON_03541892": "18920 - animal mechanically separated meat (msm) (efsa foodex2)",
    "FOODON_03302146": "biscuit (butter-flavored)",
    "FOODON_03309947": "infant food (pureed)",
    "NCBITaxon_71410": "Penaeus brasiliensis",
    "FOODON_03412473": "yellow vetchling plant",
    "FOODON_03311145": "corn (roasted)",
    "FOODON_03412844": "krill",
    "FOODON_03541962": "19620 - birds meat (efsa foodex2)",
    "NCBITaxon_43725": "Quassia amara",
    "FOODON_03411819": "black crappie",
    "FOODON_03307124": "jersey yellow sweet potato (whole, raw)",
    "FOODON_03315952": "drink milk-derivative-based (energy reduced)",
    "FOODON_03317262": "beef cut (cured)",
    "FOODON_03541628": "16280 - guelder rose berries (efsa foodex2)",
    "FOODON_03412006": "sablefish family",
    "NCBITaxon_8910": "Laridae",
    "FOODON_00001813": "diluted citrus fruit beverage",
    "FOODON_03490133": "glass container, plastic lid, laminate lining",
    "FOODON_00001793": "cucumber or gherkin pickle food product",
    "FOODON_03316541": "cheese (white)",
    "FOODON_03305308": "chicken-flavored gravy mix (dry)",
    "FOODON_03543750": "37500 - infant formulae, powder (efsa foodex2)",
    "FOODON_03412390": "yellowfin grouper",
    "RO_0000081": "role of",
    "FOODON_03400863": "dessert sauce (eurofir)",
    "FOODON_00002389": "azuki bean paste",
    "FOODON_03412794": "indian jujube plant",
    "PECO_0007034": "kharif season exposure",
    "FOODON_03309720": "amaranth seed (raw)",
    "FOODON_03544093": "40930 - mayonnaise sauce (efsa foodex2)",
    "FOODON_03543993": "39930 - onion soup, dry (efsa foodex2)",
    "FOODON_03308977": "yellowtail rockfish (raw)",
    "FOODON_03400322": "acidifier (US CFR)",
    "FOODON_03411604": "green asparagus plant",
    "FOODON_03413681": "curled octopus",
    "FOODON_03301461": "tomato powder (spray-dried)",
    "GAZ_00000843": "Iceland",
    "FOODON_00001046": "seafood product",
    "FOODON_03543723": "37230 - hot chocolate (efsa foodex2)",
    "FOODON_03303211": "saltine cracker",
    "FOODON_03311153": "breakfast cereal (oat-based)",
    "FOODON_03309486": "squash pie",
    "NCBITaxon_3567": "Amaranthus caudatus",
    "FOODON_03311147": "spinach whole leaf in brine",
    "FOODON_03401246": "0650000 - carob (ec)",
    "NCBITaxon_39296": "Dracocephalum moldavica",
    "NCBITaxon_334909": "Atractoscion aequidens",
    "CHEBI_30746": "benzoic acid",
    "FOODON_00003266": "fig (whole)",
    "FOODON_03401825": "10006321 - mustard (perishable) (gs1 gpc)",
    "FOODON_03306566": "teriyaki sauce",
    "FOODON_03307300": "imitation wine",
    "NCBITaxon_53868": "Dialium",
    "FOODON_03413375": "marrow-stem kale plant",
    "FOODON_03303651": "cottage cheese (uncreamed)",
    "FOODON_03400716": "26  offals (efg)",
    "FOODON_03543921": "39210 - sandwich with meat and vegetable topping/filling (efsa foodex2)",
    "FOODON_03540827": "08270 - chervil (efsa foodex2)",
    "FOODON_03315150": "mammalian milk product",
    "FOODON_03302007": "fruit (raw)",
    "FOODON_03541686": "16860 - carandas (efsa foodex2)",
    "FOODON_03412817": "zanha golungensis plant",
    "FOODON_03306599": "macaroni (oriental-style)",
    "FOODON_03540250": "02500 - beignets (efsa foodex2)",
    "FOODON_03544051": "40510 - seasonings and extracts (efsa foodex2)",
    "FOODON_03541690": "16900 - java apples (efsa foodex2)",
    "FOODON_03420296": "fruiting body",
    "NCBITaxon_49266": "Fucus vesiculosus",
    "FOODON_03542761": "27610 - cheese, epoisses (efsa foodex2)",
    "FOODON_03304846": "duck egg yolk (salted)",
    "FOODON_03413024": "calcium  hydrogen carbonate",
    "FOODON_03304556": "rice (precooked)",
    "FOODON_03311606": "crab (boiled)",
    "FOODON_03412918": "swollenhead conger eel",
    "FOODON_03309714": "baby ginger (thermally processed)",
    "FOODON_03400736": "13  products for special nutritional use (eurocode2)",
    "FOODON_03312032": "potato skin",
    "FOODON_03310238": "armagnac",
    "NCBITaxon_190902": "Mentha aquatica",
    "FOODON_03307001": "chestnut (ground, canned, in vanilla-flavored syrup)",
    "FOODON_03412191": "creek chub",
    "FOODON_03301964": "banana (dried)",
    "FOODON_03540920": "09200 - sassafras leaves (efsa foodex2)",
    "FOODON_03303006": "chicken ravioli",
    "NCBITaxon_78168": "Passiflora edulis",
    "GAZ_00002952": "Hungary",
    "CHEBI_66873": "C4-dicarboxylic acid",
    "FOODON_03305766": "grape juice (concentrated)",
    "FOODON_03542947": "29470 - dairy snacks (efsa foodex2)",
    "FOODON_03306369": "fruit pulp (sweetened)",
    "NCBITaxon_8162": "Percichthyidae",
    "FOODON_00002135": "plant confectionery",
    "FOODON_03530276": "purple flesh",
    "FOODON_03401258": "1010000 - meat (ec)",
    "FOODON_03305061": "soup base",
    "FOODON_03411271": "bamboo plant",
    "FOODON_03544311": "43110 - maraschino flavour (efsa foodex2)",
    "FOODON_00001765": "vegetable corn food product",
    "UBERON_0003143": "pupa",
    "CHEBI_27941": "pullulan",
    "FOODON_03460223": "phosphorus added",
    "FOODON_03415149": "tormentil plant",
    "FOODON_03543428": "34280 - cocoa ingredients (efsa foodex2)",
    "FOODON_03543778": "37780 - ready-to-eat mixed meal for children (efsa foodex2)",
    "FOODON_00001607": "obsolete: animal product stew or hash category",
    "FOODON_03303433": "norwegian-style maine sardine (canned)",
    "CHEBI_23390": "cobalt-corrinoid hexaamide",
    "FOODON_03304772": "chicken and noodles with vegetables",
    "FOODON_03540374": "03740 - dandelions (efsa foodex2)",
    "CHEBI_29067": "carboxylic acid anion",
    "FOODON_00002004": "lingonberry preserve or jam",
    "FOODON_03306485": "rabbit meat (raw)",
    "FOODON_03540658": "06580 - aubergines (efsa foodex2)",
    "FOODON_03542730": "27300 - other dairy powder (efsa foodex2)",
    "FOODON_03308439": "pacific sardine (chunk, canned)",
    "FOODON_03305365": "crab cake",
    "FOODON_03315199": "gelatin capsule (soft shell)",
    "NCBITaxon_83232": "Acrodonta",
    "FOODON_00001839": "fern vegetable food product",
    "ECOCORE_00000014": "lithotrophy",
    "FOODON_03540785": "07850 - corn smuts (efsa foodex2)",
    "NCBITaxon_98307": "Polymesoda",
    "FOODON_03306809": "pea (whole, canned)",
    "FOODON_03311244": "apple juice (diluted)",
    "FOODON_03301673": "shrimp (whole or parts)",
    "OBI_0002139": "volume value specification",
    "FOODON_03309264": "winter flounder (raw)",
    "FOODON_03315255": "fruit juice drink (fumaric acid-acidulated)",
    "NCBITaxon_150421": "Panulirus cygnus",
    "FOODON_03308199": "chub (raw)",
    "FOODON_03412000": "roughscale flounder",
    "FOODON_03315703": "beverage concentrate",
    "HANCESTRO_0341": "Afghan",
    "FOODON_03306802": "alaska peas (whole, dried)",
    "RO_0009003": "immersed in",
    "FOODON_03541828": "18280 - fruit jelly (efsa foodex2)",
    "FOODON_03542912": "29120 - cheese, fourme d'ambert (efsa foodex2)",
    "FOODON_00002324": "turnip vegetable food product",
    "FOODON_03304715": "french cheese dressing",
    "FOODON_03309428": "north pacific sole (raw)",
    "FOODON_03315529": "fish product (fresh)",
    "PO_0020045": "pinnate leaf",
    "FOODON_03306751": "dill pickle (polish-style)",
    "FOODON_03302294": "beverage (noncarbonated)",
    "FOODON_00001612": "apple preserve or jam food product",
    "FOODON_03540414": "04140 - chayote leaves (efsa foodex2)",
    "FOODON_00002191": "red bell pepper food product",
    "FOODON_00002466": "biscuit (hard) food product",
    "FOODON_03412640": "dark green nori",
    "FOODON_03542726": "27260 - milk powder, full fat (efsa foodex2)",
    "FOODON_03317560": "americano",
    "FOODON_00001159": "fermented pomaceous fruit beverage",
    "FOODON_03305168": "frog leg (raw)",
    "FOODON_03414027": "rock bass genus",
    "FOODON_03312064": "common whitefish (raw)",
    "FOODON_03411909": "milkfish",
    "NCBITaxon_7479": "Formicinae",
    "FOODON_03411929": "atlantic pomfret",
    "FOODON_03305556": "alfalfa seed (whole)",
    "FOODON_03543573": "35730 - noni infusion material (efsa foodex2)",
    "FOODON_00002071": "orange food product",
    "FOODON_03310413": "ryecorn (food product)",
    "FOODON_00001123": "cow milk beverage",
    "FOODON_03305123": "chocolate (solid, in a real egg shell)",
    "FOODON_03541971": "19710 - goose fresh meat (efsa foodex2)",
    "FOODON_03520116": "atlantic ocean and adjacent sea fishing area",
    "NCBITaxon_9903": "Bos",
    "CHEBI_32032": "Potassium gluconate",
    "FOODON_03541958": "19580 - chamois fresh meat (efsa foodex2)",
    "NCBITaxon_9767": "Balaenoptera acutorostrata",
    "FOODON_03540317": "03170 - rice rolled grains (efsa foodex2)",
    "FOODON_03414001": "canary dentex",
    "NCBITaxon_99302": "Strychnos spinosa",
    "FOODON_03301010": "honey butter",
    "HANCESTRO_0542": "Mozambican",
    "FOODON_03542243": "22430 - catfishes (freshwater) (efsa foodex2)",
    "FOODON_03401814": "10006110 - white tannia (gs1 gpc)",
    "FOODON_03510229": "food allergen labelling about corn and products thereof",
    "FOODON_03542789": "27890 - cheese, harzer (efsa foodex2)",
    "FOODON_03301739": "semisoft part skim cheese",
    "FOODON_03310719": "animal fat food product",
    "FOODON_03401451": "10006445 - bimi and other brassica interbreeds (gs1 gpc)",
    "FOODON_03411109": "rainbow trout",
    "FOODON_03413829": "red bream",
    "FOODON_03540410": "04100 - melientha grass (efsa foodex2)",
    "FOODON_03541294": "12940 - black caraway seed (efsa foodex2)",
    "FOODON_00001666": "broccoli vegetable food product",
    "FOODON_03306693": "pea flour",
    "FOODON_03413135": "lysozyme",
    "CHEBI_75769": "B vitamin",
    "NCBITaxon_121072": "Cassytha",
    "NCBITaxon_122119": "Prunus angustifolia",
    "FOODON_03308007": "bonita mackerel (raw)",
    "FOODON_03540422": "04220 - amaranth leaves (efsa foodex2)",
    "FOODON_03411820": "snake mackerel family",
    "FOODON_03309823": "shrimp paste",
    "FOODON_03302659": "coffee bean (roasted, medium ground)",
    "NCBITaxon_1804623": "Chenopodiaceae",
    "NCBITaxon_8245": "Xiphias gladius",
    "FOODON_03311124": "yellow onion (sauteed)",
    "FOODON_03541869": "18690 - canned or jarred plum (efsa foodex2)",
    "FOODON_03307698": "french dressing (honey-flavored)",
    "FOODON_00001104": "sea water fish egg food product",
    "FOODON_03303858": "colby cheese (smoke-flavored)",
    "FOODON_03540476": "04760 - red cabbages (efsa foodex2)",
    "FOODON_03541067": "10670 - bambara groundnut (fresh seeds) (efsa foodex2)",
    "FOODON_03310494": "buffalofish fillet raw",
    "FOODON_03411817": "atlantic wolffish",
    "NCBITaxon_37901": "Lepas",
    "FOODON_03401527": "10006357 - squash (opo) (gs1 gpc)",
    "FOODON_03411767": "cowcod",
    "NCBITaxon_38820": "Poales",
    "FOODON_03544221": "42210 - capsicum flavour (efsa foodex2)",
    "FOODON_03490414": "leaf fibre container",
    "FOODON_03317031": "cream jellies",
    "FOODON_03305509": "chocolate cow milk food product",
    "GAZ_00003897": "Moldova",
    "FOODON_03542199": "21990 - animal meat dried (efsa foodex2)",
    "FOODON_03309069": "bream (raw)",
    "NCBITaxon_3803": "Fabaceae",
    "UBERON_0007378": "egg yolk",
    "FOODON_03413899": "arctic smelt",
    "FOODON_03307689": "french butter sauce",
    "NCBITaxon_241782": "Pyramidoptereae",
    "FOODON_03400367": "anticaking agent (codex)",
    "NCBITaxon_215449": "Neocoleoidea",
    "FOODON_03309373": "fat substitute made from egg white and/or milk protein (food product)",
    "FOODON_03411923": "tilefish family",
    "FOODON_03311768": "sport drink (sweetened)",
    "FOODON_03401727": "10006254 - vegetable juice - not ready to drink (shelf stable) (gs1 gpc)",
    "FOODON_03510172": "unenriched claim or use",
    "FOODON_03542967": "29670 - egg yolk (efsa foodex2)",
    "FOODON_03401588": "10006076 - lemon thyme (gs1 gpc)",
    "FOODON_03301406": "vegetable (pickled)",
    "FOODON_03413937": "tubenose goby (Proterorhinus)",
    "FOODON_03460242": "obsolete: dairy product added",
    "UBERON_0000948": "heart",
    "FOODON_03302366": "butter and honey bread",
    "FOODON_03413840": "river anchoita",
    "FOODON_03540718": "07180 - horseradish roots (efsa foodex2)",
    "FOODON_03306024": "beverage fruit-flavored noncarbonated",
    "FOODON_03543912": "39120 - mixed vegetables, fried (efsa foodex2)",
    "FOODON_03510152": "sodium free claim or use",
    "FOODON_03301017": "malt beverage (alcoholic)",
    "FOODON_03490127": "laminate tube, unlined aluminum ends",
    "FOODON_03307050": "pilchard chunk-style packed in water canned",
    "FOODON_03301302": "obsolete: pickled food",
    "FOODON_03309608": "mackerel (salted)",
    "NCBITaxon_374709": "Euphrasia stricta",
    "NCBITaxon_219134": "Coreopsideae",
    "NCBITaxon_27723": "Osteoglossidae",
    "FOODON_03412041": "citron melon plant",
    "FOODON_03412374": "sea catfish",
    "FOODON_03412770": "detarium plant",
    "FOODON_03307075": "poultry (ice packed)",
    "FOODON_03303700": "black olive (whole, canned)",
    "FOODON_03460852": "obsolete: flaxseed oil",
    "FOODON_03301034": "citrus honey",
    "NCBITaxon_39993": "Terminalia catappa",
    "FOODON_03543714": "37140 - chicory coffee infusion (efsa foodex2)",
    "FOODON_03541709": "17090 - spanish limes (efsa foodex2)",
    "FOODON_03520469": "southwestern states",
    "FOODON_03400722": "32  miscellaneous foods (efg)",
    "FOODON_03414365": "california quail",
    "FOODON_03460121": "food irradiation process",
    "FOODON_03302530": "chocolate drop cookie",
    "FOODON_03317024": "dessert (jelly based, dry mix)",
    "NCBITaxon_147370": "PACMAD clade",
    "FOODON_03510179": "saturated fat free food",
    "FOODON_03316712": "cheese coulommiers",
    "FOODON_03401523": "10006349 - bitter melon (gs1 gpc)",
    "FOODON_03543859": "38590 - meat terrine (efsa foodex2)",
    "FOODON_03311588": "bacon (baked)",
    "FOODON_03303443": "canadian lobster (raw)",
    "FOODON_03401291": "USDA SR fast foods (2100)",
    "NCBITaxon_58023": "Tracheophyta",
    "FOODON_03306778": "cream pie",
    "NCBITaxon_72636": "Pachygrapsus transversus",
    "FOODON_03303767": "chocolate candy (with filled center)",
    "FOODON_03316358": "fruit jelly (calorie reduced)",
    "FOODON_03520143": "indian ocean, eastern (fao major fishing area 57)",
    "FOODON_03301921": "apple juice drink",
    "FOODON_03306553": "frozen nondairy dessert mix",
    "FOODON_03411334": "guar plant",
    "FOODON_03401852": "10006352 - water spinach /ong choy (gs1 gpc)",
    "FOODON_03401353": "50350600 - leaf vegetables - unprepared/unprocessed variety packs (gs1 gpc)",
    "FOODON_03310563": "sheep liver (raw)",
    "CHEBI_52211": "physiological role",
    "FOODON_03304865": "boysenberry juice (frozen concentrate)",
    "FOODON_03414502": "tealeaf willow plant",
    "NCBITaxon_86365": "Mobula",
    "HANCESTRO_0321": "Finnish",
    "FOODON_03541062": "10620 - andean lupin (without pods) (efsa foodex2)",
    "FOODON_03413105": "glucono-delta-lactone",
    "FOODON_03305647": "imitation ice milk (artificially sweetened)",
    "FOODON_03413798": "brewers yeast",
    "GAZ_00004421": "State of Ohio",
    "FOODON_03543058": "30580 - sweet bars and other formed sweet masses (efsa foodex2)",
    "FOODON_03309196": "herring tidbit in matjes sauce",
    "FOODON_03542889": "28890 - cheese, roncal (efsa foodex2)",
    "FOODON_03305290": "shrimp in brine (canned)",
    "FOODON_03301506": "cow milk (ultrahigh temperature)",
    "FOODON_03316566": "fruit (stewed, not hermetically packed)",
    "FOODON_03460203": "lactose conversion process",
    "FOODON_03305303": "fruit nectar (canned)",
    "FOODON_03411386": "wintergreen plant",
    "FOODON_03414022": "nassau grouper",
    "FOODON_03317494": "beverage (almond, non-alcoholic)",
    "FOODON_03414933": "rocoto capsicum plant",
    "FOODON_03310164": "frankfurter (fried)",
    "NCBITaxon_66672": "Bixa orellana",
    "FOODON_03306900": "peanut (whole, skin off, seasoned, partially defatted)",
    "FOODON_03302310": "hard roll",
    "NCBITaxon_8976": "Galliformes",
    "FOODON_03414586": "spirochaetes",
    "IAO_0000122": "ready for release",
    "FOODON_03542757": "27570 - cheese, ricotta salata (efsa foodex2)",
    "FOODON_03304660": "sassafras tea (dry)",
    "FOODON_03400231": "margarine (us cfr)",
    "HANCESTRO_0581": "Uygur Chinese",
    "CHEBI_27266": "valine",
    "ENVO_00000292": "watershed",
    "FOODON_00002528": "shish kebab",
    "FOODON_03530122": "quartier avant",
    "FOODON_00001828": "egg dessert food product",
    "NCBITaxon_1286125": "Gymnachirus melas",
    "GAZ_00005861": "Polynesia",
    "FOODON_03302695": "french toast",
    "FOODON_00003306": "blue corn flour",
    "FOODON_03302112": "apple soda",
    "FOODON_00002865": "Mashu root",
    "FOODON_03411984": "south african pilchard",
    "FOODON_03411106": "sweet potato plant",
    "FOODON_03543720": "37200 - sugar beet coffee infusion (efsa foodex2)",
    "NCBITaxon_7871": "Chimaera monstrosa",
    "FOODON_03542679": "26790 - flavoured milks (efsa foodex2)",
    "FOODON_03401614": "10005824 - meat substitutes (perishable) (gs1 gpc)",
    "FOODON_00002028": "meat salad food product",
    "FOODON_03306165": "apple and carrot juice (food product)",
    "NCBITaxon_372802": "Scomberomorus koreanus",
    "FOODON_03412482": "hogfish",
    "FOODON_03411436": "nectarine tree",
    "FOODON_03411592": "fish, salmoniform",
    "FOODON_03316063": "jam extra",
    "FOODON_03412968": "indian cress plant",
    "FOODON_03303064": "cherry cider (carbonated)",
    "FOODON_03309783": "malt root",
    "GAZ_00000463": "Australia",
    "FOODON_03400952": "10000170 - cakes - sweet (frozen) (gs1 gpc)",
    "FOODON_03308462": "sprat (raw)",
    "FOODON_00003042": "herb",
    "FOODON_00002280": "stone pine nut food product",
    "NCBITaxon_6702": "Pandalus",
    "FOODON_00002116": "pike food product",
    "FOODON_00001260": "beer beverage",
    "FOODON_03540683": "06830 - snake gourds (efsa foodex2)",
    "NCBITaxon_271942": "Trachurus novaezelandiae",
    "FOODON_03412662": "marmalade box plant",
    "FOODON_03301370": "jerusalem artichoke (whole, raw)",
    "FOODON_03305180": "papaya ball (canned)",
    "FOODON_03415034": "honesty plant",
    "FOODON_00002223": "sardine food product",
    "FOODON_03305652": "imitation ice milk sweetened with sorbitol",
    "NCBITaxon_384378": "Rastrelliger faughni",
    "FOODON_03317120": "potato product (peeled, frozen)",
    "FOODON_03412028": "banana passionfruit plant",
    "FOODON_03520134": "atlantic, northwest (fao major fishing area 21)",
    "GAZ_00233439": "South Sudan",
    "FOODON_03315479": "cuttlefish smoked",
    "FOODON_03541168": "11680 - common walnut (efsa foodex2)",
    "FOODON_03411830": "sand lance family",
    "FOODON_00002199": "reptile egg food product",
    "FOODON_00001658": "bluefin tuna food product",
    "FOODON_03315976": "beer with a minimum acidity of 30 mill.-equivalents expressed as naoh",
    "FOODON_03307088": "grape preserves",
    "NCBITaxon_47526": "Unionidae",
    "FOODON_03301644": "milk product (dry)",
    "FOODON_00002481": "fruit (sliced)",
    "FOODON_03304456": "protein meal",
    "FOODON_00002957": "lemon grass leaf",
    "FOODON_03412707": "tadpole fish",
    "FOODON_03414997": "mastic thyme plant",
    "HANCESTRO_0564": "Vis founder",
    "FOODON_03309929": "country ham",
    "FOODON_03401616": "10006230 - meat substitutes variety packs (gs1 gpc)",
    "FOODON_03543586": "35860 - bitter orange infusion flowers (efsa foodex2)",
    "FOODON_03315333": "vegetable (outer skin)",
    "FOODON_03401420": "10005980 - broad beans (gs1 gpc)",
    "FOODON_03305270": "cream (thawed)",
    "GAZ_00003171": "Commonwealth of Virginia",
    "FOODON_03401069": "10005225 - egg based products / meals - not ready to eat (perishable) (gs1 gpc)",
    "FOODON_03541528": "15280 - grapes and similar fruits (efsa foodex2)",
    "NCBITaxon_198777": "Mammea americana",
    "FOODON_03544491": "44910 - magnesium (efsa foodex2)",
    "FOODON_03542381": "23810 - yellow croaker (efsa foodex2)",
    "FOODON_00002275": "steeped beverage product",
    "FOODON_03413533": "perlemoen abalone",
    "FOODON_03541447": "14470 - buddha's hands (efsa foodex2)",
    "FOODON_03305896": "imitation raspberry jelly",
    "NCBITaxon_183260": "Hibiscus sabdariffa",
    "FOODON_03307197": "scuppernong grape juice (food product)",
    "FOODON_03317336": "obsolete: beef hamburger patty",
    "FOODON_00001316": "nham-pla",
    "FOODON_03400103": "pastry, unsweetened, filled (us cfr)",
    "CHEBI_26106": "phylloquinones",
    "FOODON_03307492": "milk shake mix (liquid)",
    "FOODON_03303168": "red potato (whole, raw)",
    "FOODON_03311306": "sablefish smoked using hot-smoking nitrate-treated",
    "FOODON_03309220": "pollock (mashed)",
    "FOODON_03315579": "dietary supplement preparation",
    "FOODON_03308294": "tasmanian small fry (raw)",
    "NCBITaxon_8465": "Cheloniidae",
    "FOODON_03308043": "fish for seafood salad",
    "FOODON_03540336": "03360 - muesli plain (efsa foodex2)",
    "NCBITaxon_201275": "Xanthosoma violaceum",
    "FOODON_03543312": "33120 - soft drink, orange flavour (efsa foodex2)",
    "FOODON_00002427": "mizuna greens (raw)",
    "NCBITaxon_6586": "Ensis",
    "FOODON_03305141": "wheat (fermented byproduct)",
    "FOODON_03308873": "mutton snapper (raw)",
    "FOODON_03411517": "hops plant",
    "FOODON_03311596": "wood apple (whole, raw)",
    "FOODON_03306912": "peanut (whole, blanched)",
    "CHEBI_53242": "vinyl polymer macromolecule",
    "FOODON_03301882": "ground beef (canned)",
    "ENVO_00010483": "environmental material",
    "FOODON_03414666": "flacourtia plant",
    "HANCESTRO_0421": "Puerto Rican",
    "FOODON_03317329": "pork carcass",
    "FOODON_03400465": "CIAA beverages",
    "FOODON_03543482": "34820 - redcurrant infusion leaves (efsa foodex2)",
    "FOODON_03301098": "mussel (frozen)",
    "FOODON_03302851": "imitation lemon-flavored cookie",
    "FOODON_03542096": "20960 - asses-mules-hinnies, other slaughtering products (efsa foodex2)",
    "IAO_0000119": "definition source",
    "FOODON_03307534": "onion dip (dry mix)",
    "FOODON_03307558": "sugar (blended)",
    "FOODON_03315417": "meat (corned)",
    "NCBITaxon_3908": "Vicia sativa",
    "FOODON_03541589": "15890 - sea buckthorns (efsa foodex2)",
    "FOODON_03303526": "cottage cheese (creamed, vegetable added)",
    "FOODON_00002604": "Sangiovese grape plant",
    "FOODON_03316101": "beverage (dairy based)",
    "FOODON_03302334": "fruit bread",
    "FOODON_03306032": "reconstituted orange juice (from concentrate, canned)",
    "FOODON_03542696": "26960 - yoghurt, cow milk, flavoured (efsa foodex2)",
    "FOODON_03301727": "celery stalk (whole, raw)",
    "FOODON_03303567": "meatball (cooked)",
    "FOODON_03413892": "european hake",
    "NCBITaxon_1154667": "Urophycis brasiliensis",
    "CHEBI_30618": "hydroxypropyl methylcellulose",
    "FOODON_03317419": "pasta (fresh)",
    "FOODON_03540782": "07820 - fungi (efsa foodex2)",
    "CHEBI_35193": "tetraterpene",
    "NCBITaxon_2068722": "Anserinae",
    "FOODON_03540654": "06540 - chinese capsicum (efsa foodex2)",
    "CHEBI_78840": "olefinic compound",
    "FOODON_03401802": "10006351 - name mapuey (gs1 gpc)",
    "FOODON_03520357": "europe, eastern",
    "FOODON_03543468": "34680 - boldu infusion leaves (efsa foodex2)",
    "FOODON_03304997": "wheat bread mix",
    "NCBITaxon_30727": "Cyprinoidei",
    "FOODON_03301345": "gefilte fish",
    "FOODON_03413713": "african plantain plant",
    "FOODON_00001684": "carp food product",
    "FOODON_03530192": "fat content 30-50%",
    "NCBITaxon_4118": "Convolvulaceae",
    "GAZ_00003955": "Turks and Caicos Islands",
    "FOODON_03543178": "31780 - juice, black currant (efsa foodex2)",
    "FOODON_03544476": "44760 - vitamin b2   (riboflavin) (efsa foodex2)",
    "FOODON_03316012": "ravioli filling",
    "FOODON_03301878": "imitation orange juice from frozen concentrate",
    "FOODON_03540864": "08640 - santolina (efsa foodex2)",
    "FOODON_03413526": "grey sharks",
    "FOODON_03541890": "18900 - turkey carcase (efsa foodex2)",
    "FOODON_03305543": "herb mixture",
    "FOODON_03544366": "43660 - rum flavour (efsa foodex2)",
    "FOODON_03414763": "flax lily plant",
    "FOODON_03302970": "water chestnut (whole, raw)",
    "FOODON_03305347": "gelatin (dehydrated)",
    "FOODON_03307007": "white snow peach (canned)",
    "CHEBI_23677": "diazole",
    "FOODON_03311135": "high meat (chicken/turkey) and vegetables (strained or junior food, in jar)",
    "FOODON_03306146": "lemon- and lime-flavored juice drink",
    "FOODON_03412396": "obsolete: cattle and lamb",
    "FOODON_03541573": "15730 - bearberries (efsa foodex2)",
    "FOODON_03411878": "european dover sole",
    "FOODON_03301152": "mustard oil",
    "FOODON_03301651": "whey (dried)",
    "FOODON_03308162": "oyster (raw, frozen)",
    "FOODON_03412108": "starfish",
    "FOODON_03309257": "european john dory (raw)",
    "GENEPIO_0002031": "ordinal tree specification",
    "FOODON_03500025": "saran surface",
    "FOODON_03411408": "abalone",
    "FOODON_03412868": "butterfly cod",
    "CHEBI_33861": "transition element coordination entity",
    "FOODON_03543669": "36690 - cherries (sweet) (infusion stems) (efsa foodex2)",
    "FOODON_03309700": "tall fescue hay",
    "FOODON_03542090": "20900 - goat other slaughtering products (efsa foodex2)",
    "FOODON_03301575": "pome fruit (whole, raw)",
    "FOODON_03411785": "redeye mullet",
    "FOODON_03411259": "conch",
    "FOODON_03308864": "red snapper fillet (frozen)",
    "FOODON_03415091": "cowslip plant",
    "NCBITaxon_184451": "Esox niger",
    "FOODON_03304160": "animal broth mix (instant)",
    "FOODON_03413925": "giant goby",
    "NCBITaxon_7940": "Anguilla australis",
    "FOODON_03317394": "coffee bean (roasted, decaffeinated)",
    "NCBITaxon_3558": "Chenopodium",
    "FOODON_03400370": "antimould and antitrope agent (codex)",
    "FOODON_00002266": "soybean food product",
    "NCBITaxon_3398": "Magnoliopsida",
    "FOODON_03306086": "artichoke in lemon water (canned)",
    "FOODON_03413870": "greek rudd",
    "FOODON_03303439": "jalapeno pepper (canned)",
    "FOODON_03308016": "snapper (raw)",
    "FOODON_03309462": "broth",
    "FOODON_03302350": "protein bread",
    "FOODON_03413568": "stone king crab",
    "FOODON_03311539": "pizza (frozen, microwavable)",
    "FOODON_03315868": "cheese varietal semi-hard",
    "FOODON_03305996": "orange (canned)",
    "FOODON_03305691": "synthetic food (food product)",
    "FOODON_03542741": "27410 - cheese, urda (efsa foodex2)",
    "FOODON_03401061": "50190000 - prepared/preserved foods (gs1 gpc)",
    "FOODON_03401597": "10006040 - ramsons (gs1 gpc)",
    "FOODON_03540169": "01690 - pretzels (efsa foodex2)",
    "FOODON_03308925": "kippered salmon",
    "FOODON_03303938": "turkey dinner (frozen)",
    "FOODON_03414200": "desert indianwheat plant",
    "FOODON_03480027": "vacuum-packed",
    "FOODON_03470148": "ultra pasteurization (up) by heat",
    "FOODON_03301751": "shark meat (raw)",
    "FOODON_03315835": "vegetable stock",
    "FOODON_00002079": "palm vegetable food product",
    "FOODON_03308115": "sardine fillet (raw)",
    "FOODON_03315974": "sandwich spread, fat-based, energy reduced",
    "FOODON_03413814": "sterlet",
    "FOODON_03305848": "chocolate ice cream",
    "NCBITaxon_360519": "Metanephrops thomsoni",
    "FOODON_03460387": "microbial gum",
    "FOODON_03401398": "50340000 - nuts/seeds - unprepared/unprocessed (shelf stable) (gs1 gpc)",
    "FOODON_03543342": "33420 - wheat beer (efsa foodex2)",
    "FOODON_03303689": "parmigiano cheese (block)",
    "FOODON_03301425": "ice cream (flavoured)",
    "FOODON_03307600": "codfish and chips",
    "FOODON_03401274": "USDA SR fats and oils (0400)",
    "FOODON_03411463": "brazil nut plant",
    "FOODON_03540099": "00990 - millet groats (efsa foodex2)",
    "FOODON_03302388": "fruit juice drink (vitamin-fortified, noncarbonated)",
    "NCBITaxon_6713": "Astacidae",
    "FOODON_03541076": "10760 - kidney bean (dry seeds) (efsa foodex2)",
    "NCBITaxon_151442": "Prunus subcordata",
    "FOODON_03411148": "white mustard plant",
    "FOODON_03541058": "10580 - lupins (without pods) (efsa foodex2)",
    "CHEBI_27171": "organic heterobicyclic compound",
    "FOODON_03543387": "33870 - brandy (efsa foodex2)",
    "FOODON_00002430": "obsolete: convenience food",
    "FOODON_03520133": "arctic sea (fao major fishing area 18)",
    "FOODON_03309009": "tuna (white, solid pack, canned)",
    "FOODON_03400932": "10000595 - baking/cooking mixes/supplies variety packs (gs1 gpc)",
    "HANCESTRO_0024": "Macanese",
    "FOODON_03302273": "imitation lemon juice beverage base (artificially sweetened, dry)",
    "FOODON_03411473": "tangelo plant",
    "FOODON_03413889": "cape hake",
    "NCBITaxon_4274": "Polygalaceae",
    "FOODON_03317237": "crab (fully preserved)",
    "FOODON_03401213": "designation according to milk fat content",
    "GAZ_00007114": "Johnston Atoll",
    "FOODON_03510235": "ethnic food claim or use",
    "FOODON_03414009": "sandeel",
    "FOODON_00001786": "cranberry food product",
    "FOODON_03411204": "freshwater drum genus",
    "FOODON_03412896": "yelloweye mullet",
    "FOODON_03309127": "pike quenelles (canned)",
    "FOODON_03307097": "pudding mix (lemon-flavored, dry)",
    "FOODON_03312051": "flour (mixed grain)",
    "NCBITaxon_256424": "Esox reichertii",
    "FOODON_03316943": "meal replacement food",
    "GAZ_00003920": "Bhutan",
    "FOODON_00002869": "Mourv\u00e8dre wine",
    "FOODON_03301955": "bacon (raw)",
    "FOODON_03307003": "chestnut (ground, canned)",
    "FOODON_03312026": "seafood (breaded)",
    "FOODON_03510199": "vegan/vegetarian or suitability for vegan/vegetarian claim or use",
    "FOODON_03414967": "silverberry plant",
    "NCBITaxon_6752": "Brachyura",
    "FOODON_03414722": "cycas plant",
    "FOODON_03310678": "tea (mixed, dry)",
    "FOODON_03414991": "great water dock plant",
    "NCBITaxon_458363": "Pediomelum esculentum",
    "FOODON_03316028": "cheese unripened",
    "FOODON_00002813": "pea food product",
    "FOODON_03530163": "sugar content 30-50%",
    "FOODON_03301705": "vinegar",
    "FOODON_03414307": "argyrosomus",
    "FOODON_03413469": "rohu",
    "FOODON_03315351": "konyakboon (food product)",
    "UO_0000095": "volume unit",
    "FOODON_03411641": "sorrel plant",
    "FOODON_03310054": "potato crisp",
    "FOODON_00001279": "cake icing food product",
    "FOODON_03309263": "sole fillet (raw)",
    "FOODON_03309571": "ground beef patty (frozen)",
    "FOODON_03401856": "10006135 - cardoons (gs1 gpc)",
    "FOODON_03411382": "partridge",
    "FOODON_03304592": "banana syrup",
    "NCBITaxon_59895": "Cynara cardunculus var. scolymus",
    "HANCESTRO_0492": "Bruneian",
    "FOODON_03401678": "10005801 - rabbit - unprepared/unprocessed (gs1 gpc)",
    "NCBITaxon_8826": "Anseriformes",
    "FOODON_03413630": "southern pink shrimp",
    "NCBITaxon_6551": "Mytilus trossulus",
    "FOODON_03400251": "fruit preserve or jam (us cfr)",
    "FOODON_03542223": "22230 - black carp (efsa foodex2)",
    "FOODON_03302959": "hake (flaked)",
    "FOODON_03414297": "sooty shearwater",
    "FOODON_03310158": "timothy fodder silage (food product)",
    "FOODON_03316878": "cheese (ripened)",
    "FOODON_03316923": "whipped topping base, dry",
    "hancestro_0004": "obsolete: ancestral group",
    "FOODON_03315254": "beverage base, dry, fumaric acid-acidulated",
    "FOODON_03542584": "25840 - frog, edible (efsa foodex2)",
    "FOODON_03308489": "sweet red bell pepper (strips, canned)",
    "NCBITaxon_10088": "Mus <genus>",
    "FOODON_03414488": "bowhead whale",
    "FOODON_03307273": "vanilla sugar",
    "FOODON_03540461": "04610 - water mimosas (efsa foodex2)",
    "FOODON_03316975": "crystallized fruit (energy reduced)",
    "FOODON_03413165": "obsolete: monosodium glutamate",
    "FOODON_03541156": "11560 - chilgoza pine nut kernels (efsa foodex2)",
    "FOODON_03411051": "chinese or celery cabbage plant",
    "FOODON_03307593": "banana-flavored syrup",
    "FOODON_03304680": "jasmine tea (dry)",
    "FOODON_03411935": "nile perch",
    "FOODON_03304834": "chia seed bread",
    "NCBITaxon_268884": "Origanum majorana",
    "GAZ_00006893": "Kyrgyzstan",
    "NCBITaxon_81368": "Lampridae",
    "FOODON_03308732": "tuna (packed in brine, canned)",
    "FOODON_03543983": "39830 - rice and vegetables meal (efsa foodex2)",
    "CHEBI_82130": "Vinylidene chloride-vinyl chloride copolymer",
    "NCBITaxon_30870": "Sciaenidae",
    "FOODON_03414190": "java-bean plant",
    "FOODON_03401768": "10005903 - pears (gs1 gpc)",
    "FOODON_03542118": "21180 - cured seasoned poultry meat (efsa foodex2)",
    "ENVO_00000447": "marine biome",
    "FOODON_03400319": "stabilizer, thickener or gelling agent (us cfr)",
    "FOODON_03304537": "chickpea flour",
    "NCBITaxon_120490": "Eupulmonata",
    "FOODON_03540763": "07630 - red algae (efsa foodex2)",
    "FOODON_03510239": "authentic ethnic food claim or use",
    "FOODON_00001135": "distilled fermented grain beverage",
    "FOODON_00003318": "echinoderm food product",
    "NCBITaxon_386614": "Amblyraja radiata",
    "FOODON_03302998": "cheese (wax-coated)",
    "FOODON_03307795": "lichees black tea (dry)",
    "FOODON_03401045": "10000026 - milk/milk substitutes (shelf stable) (gs1 gpc)",
    "FOODON_00001563": "has defining ingredient",
    "NCBITaxon_154550": "Lepidorhombus whiffiagonis",
    "FOODON_03412007": "bullhead catfish",
    "FOODON_03308153": "oyster chowder (condensed)",
    "FOODON_00002214": "rye bread food product",
    "FOODON_03301637": "alcoholic beverage (powdered)",
    "FOODON_03302770": "aluminum-coated dragee",
    "FOODON_03308021": "oyster (shucked, raw)",
    "NCBITaxon_8182": "Pomoxis nigromaculatus",
    "FOODON_03412215": "mud crab family",
    "FOODON_03306860": "peanut (green, boiled, packed in brine)",
    "NCBITaxon_36596": "Prunus armeniaca",
    "FOODON_03306892": "preserved plum",
    "FOODON_03540089": "00890 - wheat flour white (efsa foodex2)",
    "FOODON_03307312": "rice wine",
    "FOODON_03490113": "textile or fabric stocking or casing",
    "FOODON_03304656": "radish (whole, raw)",
    "NCBITaxon_8126": "Tilapia",
    "FOODON_03306100": "potato (whole, cooked)",
    "FOODON_03304528": "special k cereal",
    "FOODON_03542647": "26470 - canned seafood (efsa foodex2)",
    "NCBITaxon_94930": "Ophidiidae",
    "FOODON_03309729": "filefish (raw)",
    "FOODON_03542719": "27190 - milk and dairy powders and concentrates (efsa foodex2)",
    "FOODON_03306451": "chiffon pie filling",
    "FOODON_03544196": "41960 - barbeque flavour (efsa foodex2)",
    "FOODON_03310451": "striped snakehead (raw)",
    "NCBITaxon_181445": "Allocyttus niger",
    "FOODON_03306056": "red currant juice",
    "FOODON_00002580": "kava food product",
    "FOODON_03302583": "butterscotch candy",
    "FOODON_03413344": "chinese crabapple plant",
    "FOODON_03414400": "konjac",
    "HANCESTRO_0457": "Curacaoan",
    "CHEBI_15741": "succinic acid",
    "FOODON_03543752": "37520 - infant formula, soya-based, powder (efsa foodex2)",
    "FOODON_03305613": "herring fillet (pickled)",
    "FOODON_03317502": "rolls, buns, and pitta (pre-packed)",
    "FOODON_03317098": "soft drink concentrate, energy-containing sweetener not added",
    "FOODON_00001907": "gluten refined food product",
    "FOODON_03317291": "obsolete: beef sausage fresh",
    "FOODON_03309686": "green mussel (raw)",
    "NCBITaxon_4639": "Ensete ventricosum",
    "FOODON_03541949": "19490 - deer, red fresh meat (efsa foodex2)",
    "FOODON_03542063": "20630 - deer edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "FOODON_03303510": "blue cheese dressing",
    "FOODON_03411917": "dolphinfish",
    "FOODON_00001928": "grape vinegar food product",
    "FOODON_00003184": "Ymer",
    "FOODON_03317248": "horseradish (grated, frozen)",
    "FOODON_00001255": "nonfermented plant derived beverage product",
    "NCBITaxon_3547": "Trianthema",
    "NCBITaxon_41705": "Protacanthopterygii",
    "NCBITaxon_6712": "Astacidea",
    "NCBITaxon_40830": "Barbus barbus",
    "FOODON_03541504": "15040 - sour cherries light red (efsa foodex2)",
    "FOODON_03541856": "18560 - candied fruit, mixed fruit (efsa foodex2)",
    "GAZ_00002825": "Chile",
    "FOODON_03411805": "malabar snapper",
    "FOODON_03304076": "lobster soup",
    "NCBITaxon_2032702": "Apostichopus californicus",
    "FOODON_03490375": "biaxial oriented polypropylene container",
    "GAZ_00004441": "State of Arkansas",
    "FOODON_03420186": "spear or shoot",
    "NCBITaxon_3888": "Pisum sativum",
    "FOODON_03316045": "frying fat",
    "FOODON_03412363": "sal tree",
    "FOODON_03315287": "processed oil",
    "NCBITaxon_15949": "Zizania",
    "FOODON_03315636": "food (unstandardized)",
    "NCBITaxon_13402": "Carya",
    "FOODON_03420113": "mammalian milk or milk component",
    "GAZ_00002531": "State of Rhode Island",
    "FOODON_03401037": "10000190 - cream/cream substitutes (shelf stable) (gs1 gpc)",
    "FOODON_00002130": "plant based pastry food product",
    "FOODON_00001128": "limburger cheese food product",
    "FOODON_00001197": "bambara groundnut food product",
    "FOODON_03315386": "chewing gum, carbohydrate modified",
    "FOODON_03540684": "06840 - sopropos (efsa foodex2)",
    "FOODON_03316468": "meal (ready-to-consume)",
    "FOODON_03309949": "wheat dough (canned, refrigerated)",
    "FOODON_03412821": "uapaca plant",
    "FOODON_03540699": "06990 - winter melon (efsa foodex2)",
    "NCBITaxon_201017": "Lansium domesticum",
    "NCBITaxon_41503": "Centaurea",
    "FOODON_03309969": "pork (ground)",
    "NCBITaxon_13224": "Pomatoschistus",
    "FOODON_03303890": "glaze for cake (artificially colored)",
    "FOODON_03412734": "turnip-rooted parsley plant",
    "FOODON_03305893": "jellied mint sauce",
    "FOODON_03303149": "milk chocolate fruitie cookie",
    "FOODON_03311325": "cacao nib",
    "UBERON_0000085": "morula",
    "FOODON_03306738": "hot pepper paste",
    "FOODON_03306895": "meat (cured)",
    "FOODON_00001079": "food (pickled)",
    "FOODON_03543219": "32190 - juice, multi-vegetable (efsa foodex2)",
    "FOODON_03541106": "11060 - blue lupin (dry) (efsa foodex2)",
    "FOODON_03308614": "crab imperial (in shell)",
    "FOODON_03309473": "partridge (canned)",
    "FOODON_03307584": "teething pretzel",
    "FOODON_00001048": "meshanger cheese food product",
    "NCBITaxon_87784": "Atherina",
    "NCBITaxon_3363": "Podocarpus",
    "FOODON_03411223": "mussel",
    "FOODON_03304432": "lasagna casserole (baked)",
    "FOODON_03544466": "44660 - sucralose (efsa foodex2)",
    "FOODON_03413763": "vitamin C",
    "FOODON_03311134": "lima bean (immature, frozen, boiled)",
    "FOODON_03541214": "12140 - borage seeds (efsa foodex2)",
    "FOODON_03543990": "39900 - grains soup, dry (efsa foodex2)",
    "FOODON_03400371": "antioxidant (codex)",
    "FOODON_03400253": "pie, sweetened (us cfr)",
    "FOODON_03401223": "0120000 - tree nuts (shelled or unshelled) (ec)",
    "FOODON_03307038": "potato chip (barbecue-flavored)",
    "FOODON_03316409": "sugar (not fully refined)",
    "FOODON_03542520": "25200 - miscellaneous marine crustaceans (efsa foodex2)",
    "FOODON_03540457": "04570 - watercresses and similar- (efsa foodex2)",
    "FOODON_03307240": "chocolate",
    "FOODON_03305860": "cherry liqueur",
    "FOODON_03401245": "0640000 - cocoa (ec)",
    "FOODON_03430117": "medium ground",
    "FOODON_03309834": "cowpea (whole, raw)",
    "FOODON_03302504": "vegetable butter",
    "NCBITaxon_190224": "Rubus flagellaris",
    "FOODON_03302418": "lemon-flavored beverage base naturally and artificially sweetened",
    "PATO_0001472": "decreased depth",
    "NCBITaxon_1489845": "Gadoidei",
    "FOODON_03304941": "soup seasoning (extract of beef added)",
    "FOODON_03306469": "deer meatball (raw)",
    "FOODON_03401482": "10006005 - spring (or spanish) onions (gs1 gpc)",
    "FOODON_03302398": "lemon drink (artificially flavored)",
    "FOODON_03543419": "34190 - mixed coffee imitates (efsa foodex2)",
    "FOODON_03414326": "cornsalad plant",
    "CHEBI_18248": "iron atom",
    "FOODON_03543505": "35050 - common hemp infusion leaves (efsa foodex2)",
    "FOODON_03304918": "imitation chicken soup",
    "FOODON_03303894": "green sauce (mexican)",
    "FOODON_03302297": "intestine casings (edible)",
    "FOODON_03316937": "coffee bean (decaffeinated, roasted)",
    "FOODON_03414253": "gypsy mushroom",
    "NCBITaxon_173309": "Caranx crysos",
    "FOODON_03306509": "salmon (cured, cold process)",
    "FOODON_03541050": "10500 - marrowfat pea (fresh seeds) (efsa foodex2)",
    "CHEBI_6495": "lipoprotein",
    "FOODON_03542474": "24740 - herring roe (efsa foodex2)",
    "FOODON_03411919": "catjang bean plant",
    "CHEBI_17754": "glycerol",
    "FOODON_03317391": "black grape wine",
    "FOODON_03544103": "41030 - butter sauce (efsa foodex2)",
    "FOODON_03411359": "alfalfa plant",
    "FOODON_03413475": "european chub",
    "FOODON_00002791": "vetch seed (whole)",
    "FOODON_03307113": "wheat cracker",
    "CHEBI_33744": "iron group molecular entity",
    "FOODON_03544506": "45060 - phytochemicals (efsa foodex2)",
    "FOODON_03305501": "brewers grains (exhausted)",
    "FOODON_03542359": "23590 - norway pout (efsa foodex2)",
    "FOODON_03542521": "25210 - barnacle (efsa foodex2)",
    "FOODON_03306020": "reconstituted orange juice (from concentrate, single-strength)",
    "FOODON_03460192": "food texturing process",
    "FOODON_03540322": "03220 - barley porridge (efsa foodex2)",
    "FOODON_03414468": "american black bear",
    "NCBITaxon_7911": "Polyodontidae",
    "NCBITaxon_259381": "Blighia sapida",
    "NCBITaxon_4200": "Caprifoliaceae",
    "NCBITaxon_23283": "Ribes aureum",
    "FOODON_03302804": "wheat bun",
    "FOODON_03401065": "10000104 - baby/infant - specialised foods (shelf stable) (gs1 gpc)",
    "FOODON_03315302": "cocoa food product",
    "FOODON_03540605": "06050 - jack beans (with pods) (efsa foodex2)",
    "FOODON_03530022": "flank",
    "FOODON_03544001": "40010 - meat soup, clear (efsa foodex2)",
    "FOODON_03311223": "fish (minced, raw)",
    "FOODON_03306225": "paraguay tea (dry)",
    "FOODON_03315177": "dextrose",
    "FOODON_03301163": "slipper lobster (raw)",
    "FOODON_03307437": "chocolate-flavored milk extender",
    "FOODON_03302546": "imitation peach butter",
    "FOODON_03411821": "escolar",
    "FOODON_03400407": "extraction solvent (codex)",
    "FOODON_03414823": "green plum plant",
    "FOODON_03411009": "polysaccharide-producing plant",
    "FOODON_03542393": "23930 - conger, european (efsa foodex2)",
    "NCBITaxon_36930": "Saccostrea cucullata",
    "FOODON_03401485": "10006422 - common chicory (gs1 gpc)",
    "FOODON_03305371": "gelatin dessert (naturally and artificially sweetened)",
    "FOODON_03304886": "tamarillo (whole, raw)",
    "FOODON_03414050": "korean taimen",
    "NCBITaxon_3669": "Luffa",
    "FOODON_03490215": "jar",
    "CHEBI_32954": "sodium acetate",
    "FOODON_03306872": "potato chip (unsalted)",
    "GAZ_00009718": "Heard and McDonald islands",
    "FOODON_03309227": "atlantic pollock (raw)",
    "CHEBI_24836": "inorganic oxide",
    "FOODON_03460271": "obsolete: butter added",
    "FOODON_03303058": "apple cider (reconstituted)",
    "RO_0002207": "directly develops from",
    "FOODON_03540079": "00790 - rye flour, refined (efsa foodex2)",
    "CHEBI_36080": "protein",
    "FOODON_00001805": "deer meat food product",
    "FOODON_03415069": "cornflower plant",
    "HANCESTRO_0438": "Iranian",
    "CHEBI_18346": "vanillin",
    "CHEBI_17992": "sucrose",
    "NCBITaxon_33213": "Bilateria",
    "NCBITaxon_8511": "Iguania",
    "FOODON_03411527": "muskrat",
    "FOODON_03411791": "pacific bonito",
    "FOODON_03301127": "grape juice",
    "FOODON_03510124": "health-related claim or use",
    "FOODON_03309296": "lake salmon (raw)",
    "FOODON_03302873": "cod roe",
    "FOODON_03412388": "sea bream",
    "FOODON_03317133": "liquid food (prepared, ready for consumption)",
    "FOODON_03317609": "balanced diet for special dietary use(infants)",
    "FOODON_03400942": "10000166 - dried breads (shelf stable) (gs1 gpc)",
    "FOODON_03411371": "green bean plant",
    "FOODON_03414865": "longsnout catfish",
    "FOODON_00002168": "poultry fat or oil refined food product",
    "FOODON_03317136": "artificial sweetener (granular)",
    "FOODON_03541993": "19930 - sheep fat tissue (efsa foodex2)",
    "FOODON_03316626": "beef ham",
    "FOODON_00003351": "brown rice flour",
    "FOODON_03401363": "50193600 - meat substitutes (gs1 gpc)",
    "FOODON_03540233": "02330 - bread pre-mixes (dry) (efsa foodex2)",
    "FOODON_03412314": "butterfly mackerel",
    "FOODON_03500036": "food-grade plastic surface",
    "CHEBI_71629": "nisin",
    "FOODON_03400339": "gelling agent (ec)",
    "FOODON_00002770": "'hyacinth bean (whole, dried)'",
    "NCBITaxon_196071": "Sardinella aurita",
    "FOODON_03412908": "small scaled brown slickhead",
    "CHEBI_33285": "heteroorganic entity",
    "FOODON_03317097": "soft drink (energy-containing sweetener not added)",
    "FOODON_03309479": "guinea fowl in spiced wine sauce (dish)",
    "FOODON_03544348": "43480 - pimento flavour (efsa foodex2)",
    "FOODON_03306235": "dietetic orange and lemon muffin",
    "FOODON_03304835": "aztec marigold flower (dehydrated)",
    "FOODON_03414622": "black snake",
    "NCBITaxon_274695": "Trachyscorpia cristulata",
    "FOODON_03303682": "muenster cheese",
    "FOODON_03490291": "aluminium can, drum or barrel, plastic coated",
    "FOODON_03309767": "ginger root (whole, dried)",
    "FOODON_03543157": "31570 - fruit and vegetable juices and nectars (including concentrates) (efsa foodex2)",
    "FOODON_03400156": "seafood product analog (us cfr)",
    "FOODON_00001330": "tuaw jaew",
    "FOODON_03317251": "fungi (edible, fresh)",
    "FOODON_03541606": "16060 - currants (black, red and white) (efsa foodex2)",
    "FOODON_03540411": "04110 - pumpkin leaves (efsa foodex2)",
    "FOODON_03542669": "26690 - equine milk (efsa foodex2)",
    "NCBITaxon_186746": "Scombrini",
    "FOODON_03543532": "35320 - olive infusion leaves (efsa foodex2)",
    "NCBITaxon_3379": "Gnetaceae",
    "FOODON_03304296": "sugar (beet)",
    "FOODON_03310046": "coconut oil",
    "NCBITaxon_72098": "Sebastes ruberrimus",
    "FOODON_03302246": "tropical mix beverage base",
    "FOODON_03543692": "36920 - wild angelica (infusion fruits) (efsa foodex2)",
    "NCBITaxon_568231": "Baillonella toxisperma",
    "FOODON_03401477": "10006004 - elephant garlic (gs1 gpc)",
    "FOODON_03540495": "04950 - rape kales (efsa foodex2)",
    "FOODON_03304762": "beef pattie sandwich (cooked, frozen)",
    "FOODON_03544094": "40940 - mayonnaise, low fat (efsa foodex2)",
    "FOODON_03306016": "orange nectar (food product)",
    "FOODON_03301571": "alfalfa sprout (raw)",
    "FOODON_03544206": "42060 - blood orange flavour (efsa foodex2)",
    "HANCESTRO_0423": "Saint Lucian",
    "FOODON_03413075": "dicalcium diphosphate",
    "FOODON_03411886": "flying fish family",
    "FOODON_03541585": "15850 - lingonberries and similar (efsa foodex2)",
    "FOODON_03541673": "16730 - nonis (efsa foodex2)",
    "FOODON_03541035": "10350 - lablab beans (without pods) (efsa foodex2)",
    "FOODON_03412893": "rockfish",
    "HANCESTRO_0319": "Korculan",
    "FOODON_00002340": "water food product",
    "FOODON_03315016": "sauce, sweet",
    "FOODON_03543196": "31960 - nectar, apricot (efsa foodex2)",
    "FOODON_03544317": "43170 - meat flavour (efsa foodex2)",
    "FOODON_03411758": "persian grouper",
    "FOODON_03544026": "40260 - prepared pasta salad (efsa foodex2)",
    "FOODON_03311742": "kosher meat (raw)",
    "NCBITaxon_365581": "Pangasius sanitwongsei",
    "FOODON_00001618": "artificial sweetener food product",
    "FOODON_03413273": "sodium sesquicarbonate",
    "FOODON_03316962": "noodle (egg, wheat, and soy)",
    "FOODON_03411291": "codling",
    "FOODON_03541588": "15880 - salal (efsa foodex2)",
    "FOODON_00002345": "whale food product",
    "FOODON_03302014": "cheese stick",
    "FOODON_03542916": "29160 - cheese, roquefort (efsa foodex2)",
    "FOODON_03305876": "apple jelly (mint-flavored)",
    "hancestro_0308": "has country of origin",
    "FOODON_03308984": "speckled rockfish (raw)",
    "FOODON_00002398": "mammalian buttermilk",
    "NCBITaxon_13394": "Capparis",
    "FOODON_03544364": "43640 - rose flavour (efsa foodex2)",
    "FOODON_03315411": "vegetable yogurt (reduced fat or skim milk)",
    "NCBITaxon_14366": "Cymbidium",
    "FOODON_03400328": "antifoaming agent (ec)",
    "FOODON_03430173": "edible wafer",
    "FOODON_00001601": "animal product based dressing",
    "FOODON_03302363": "butter and egg roll (frozen)",
    "FOODON_03540138": "01380 - unleavened or flat bread and similar (efsa foodex2)",
    "FOODON_03306464": "reindeer meat (raw)",
    "FOODON_00002845": "corn nut",
    "FOODON_03400102": "prepared food product with bakery base or enclosure, unsweetened (us cfr)",
    "GAZ_00004399": "Nepal",
    "FOODON_03420300": "juice (plant derived liquid)",
    "NCBITaxon_4107": "Solanum",
    "FOODON_03315555": "marzipan",
    "FOODON_03542141": "21410 - cured pork fat (efsa foodex2)",
    "FOODON_03542054": "20540 - bovine edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "HANCESTRO_0018": "uncategorised population",
    "NCBITaxon_54556": "Alburnus alburnus",
    "FOODON_03412158": "feather cockscomb plant",
    "FOODON_03541858": "18580 - olives, processed (efsa foodex2)",
    "FOODON_03316869": "pasteurized neufchatel cheese spread with other foods",
    "FOODON_03450031": "cooking in container immersed in water or steam",
    "FOODON_03543031": "30310 - table-top sweeteners in tablets (efsa foodex2)",
    "FOODON_03308332": "california pilchard (raw)",
    "FOODON_03401215": "full fat cheese (codex)",
    "UBERON_0005079": "eggshell",
    "FOODON_03411200": "cowpea plant",
    "FOODON_03460781": "food micro-encapsulation process",
    "FOODON_03315789": "water in sealed container",
    "FOODON_03543985": "39850 - soups (dry mixture uncooked) (efsa foodex2)",
    "FOODON_03413890": "chilean hake",
    "FOODON_03544270": "42700 - garlic flavour (efsa foodex2)",
    "FOODON_03413362": "marine fish",
    "FOODON_00001051": "fermented rice beverage",
    "FOODON_03309411": "betel nut (with anise seed, flavored, sweetened)",
    "FOODON_03543202": "32020 - nectar, pear (efsa foodex2)",
    "FOODON_03400403": "dusting powder (codex)",
    "FOODON_03316331": "meat salad",
    "FOODON_03303883": "spaghetti in meat sauce (italian-style)",
    "FOODON_03316715": "cheese norvegia",
    "CHEBI_29073": "L-ascorbic acid",
    "FOODON_03309664": "tofu food product",
    "FOODON_03543826": "38260 - meat imitates (efsa foodex2)",
    "FOODON_03414128": "peruvian guitarfish",
    "FOODON_03413388": "caranda plant",
    "NCBITaxon_8261": "Pleuronectes",
    "FOODON_03315771": "spring mackerel (canned)",
    "FOODON_03542139": "21390 - other cooked cured meat (efsa foodex2)",
    "FOODON_03411906": "tench",
    "NCBITaxon_426098": "Eutrigla gurnardus",
    "FOODON_03315855": "cocktail beverage (alcoholic)",
    "NCBITaxon_557337": "Bathyraja spinicauda",
    "FOODON_03317490": "clotted cream",
    "FOODON_00002790": "winged bean (whole, dried)",
    "FOODON_03411944": "florida stone crab",
    "FOODON_03543469": "34690 - buchu infusion leaves (efsa foodex2)",
    "FOODON_03530292": "free-range food animal rearing",
    "FOODON_03401696": "10006829 - conomon melons (gs1 gpc)",
    "FOODON_03307152": "rice (instant)",
    "FOODON_03411133": "persian melon plant",
    "FOODON_00002429": "convenience food",
    "FOODON_03315965": "starch product (savory)",
    "FOODON_03302426": "citrus and guarana beverage (artiticially colored)",
    "FOODON_03317383": "meat (quick-frozen)",
    "CHEBI_83813": "proteinogenic amino acid",
    "FOODON_03540822": "08220 - icelandic mosses (efsa foodex2)",
    "FOODON_03310115": "meat and quince conserve (food product)",
    "FOODON_03304833": "grape water ice",
    "NCBITaxon_174217": "Monstera deliciosa",
    "FOODON_03544282": "42820 - guava flavour (efsa foodex2)",
    "FOODON_03400708": "18  fruit juices (efg)",
    "FOODON_03302821": "chocolate-flavored powder",
    "FOODON_03316939": "tea (instant, decaffeinated)",
    "FOODON_03542768": "27680 - cheese, wynendale (efsa foodex2)",
    "FOODON_03541982": "19820 - snipe fresh meat (efsa foodex2)",
    "FOODON_03541216": "12160 - evening primrose seeds (efsa foodex2)",
    "NCBITaxon_58324": "Phoxinus phoxinus",
    "FOODON_03315236": "cocoa product (standardized)",
    "FOODON_03540165": "01650 - bread alternative (efsa foodex2)",
    "FOODON_03411581": "fish, perciform",
    "FOODON_03414134": "helmet crab family",
    "FOODON_03520356": "europe, central",
    "FOODON_03400383": "carrier (codex)",
    "FOODON_00002607": "Semillon wine",
    "FOODON_03306716": "bittersweet chocolate candy (artificially sweetened)",
    "FOODON_03414760": "cymbonotus plant",
    "FOODON_03542412": "24120 - tunas, bonitos, billfishes (efsa foodex2)",
    "FOODON_03414886": "river lamprey",
    "CHEBI_27897": "tryptophan",
    "FOODON_03543508": "35080 - holy thistle infusion leaves (efsa foodex2)",
    "FOODON_03413701": "japanese flying squid",
    "FOODON_03544478": "44780 - vitamin b5   (pantothenic acid) (efsa foodex2)",
    "FOODON_03543968": "39680 - pasta, filled, cooked (efsa foodex2)",
    "FOODON_00002029": "melon food product",
    "FOODON_03414779": "omphalea plant",
    "FOODON_03309182": "hawkfish (raw)",
    "FOODON_03543724": "37240 - hot chocolate with added ingredients (efsa foodex2)",
    "FOODON_00002664": "lipid food product",
    "FOODON_03311762": "strawberry sherbet",
    "FOODON_03311336": "shrimp (peeled, deveined, raw)",
    "CHEBI_46774": "polyether",
    "FOODON_03315618": "salted sticks",
    "FOODON_03413140": "magnesium hydroxide carbonate",
    "FOODON_03411257": "moose",
    "FOODON_00002884": "tea seed oil",
    "FOODON_03413918": "blunt snouted mullet",
    "FOODON_03411494": "raspberry plant",
    "FOODON_03311189": "crab cake (breaded, raw)",
    "FOODON_03541774": "17740 - guayabillos (efsa foodex2)",
    "FOODON_03541877": "18770 - animal carcase (efsa foodex2)",
    "NCBITaxon_171638": "Rosoideae",
    "FOODON_03309191": "requiem shark (raw)",
    "FOODON_03303547": "cottage cheese (pasteurized)",
    "FOODON_03541286": "12860 - flower pistil spices (efsa foodex2)",
    "FOODON_03413360": "diadromous fish",
    "FOODON_03413508": "black guillemot",
    "NCBITaxon_42216": "Hamamelidaceae",
    "FOODON_03306312": "pasta (dried)",
    "FOODON_03542400": "24000 - cusk-eels (efsa foodex2)",
    "FOODON_03412025": "snow mushroom",
    "FOODON_03412520": "tayberry plant",
    "FOODON_03315632": "skim milk (milk solids added, flavored)",
    "NCBITaxon_329212": "Turnera diffusa",
    "NCBITaxon_40151": "Monodon monoceros",
    "FOODON_00001943": "ham salad food product",
    "FOODON_03304696": "cow milk (vitamin d, pasteurized, homogenized)",
    "FOODON_03541274": "12740 - rue, dry (efsa foodex2)",
    "FOODON_03411537": "white-tailed deer",
    "FOODON_03303081": "gelatin (artificially colored and flavored)",
    "FOODON_03541287": "12870 - saffron and similar- (efsa foodex2)",
    "FOODON_03414673": "cocky apple plant",
    "PO_0030097": "utricle capsule fruit",
    "FOODON_03309241": "sea trout (raw, frozen)",
    "FOODON_03302432": "alcoholic beverage mix (containing alcohol, artificially sweetened)",
    "RO_HOM0000000": "in similarity relationship with",
    "FOODON_00002851": "fully hydrogenated oil",
    "FOODON_03306419": "beef-flavored gravy mix (dry, instant)",
    "NCBITaxon_270544": "Arripis trutta",
    "FOODON_03490158": "textile or fabric bag",
    "FOODON_03308397": "haddock steak (raw)",
    "FOODON_03316570": "sorrel concentrate",
    "GAZ_00002522": "Guyana",
    "FOODON_03308422": "lobsterette soup",
    "FOODON_03412097": "zebra",
    "FOODON_03542536": "25360 - chilean mussel (efsa foodex2)",
    "NCBITaxon_185735": "Arctogadus glacialis",
    "FOODON_03542950": "29500 - whole eggs (efsa foodex2)",
    "FOODON_03301628": "animal waste (recycled for animal feed)",
    "FOODON_03412137": "dogfish shark, herbivorous",
    "FOODON_03413934": "round goby (Neogobius)",
    "FOODON_03401612": "10006426 - oakleaf lettuce (gs1 gpc)",
    "NCBITaxon_22002": "Verbena",
    "FOODON_03304861": "pineapple juice (strained)",
    "FOODON_03544444": "44440 - miscellaneous agents for food processing (efsa foodex2)",
    "FOODON_03411924": "argentine family",
    "FOODON_03309578": "distilled vinegar (diluted with spent apple cider)",
    "FOODON_00001638": "beet food product",
    "FOODON_03542143": "21430 - sausages (efsa foodex2)",
    "FOODON_03412752": "white currant plant",
    "FOODON_03540821": "08210 - mosses and lichens (efsa foodex2)",
    "NCBITaxon_66656": "Durio zibethinus",
    "FOODON_03309289": "shee fish (canned)",
    "FOODON_03301592": "smoked tuna (frozen)",
    "FOODON_03308560": "salmon (cured, smoked)",
    "FOODON_03411276": "tomato plant",
    "FOODON_03542293": "22930 - eel, european (efsa foodex2)",
    "FOODON_03400291": "grated cheese food",
    "FOODON_03309568": "peppermint tea (dry)",
    "FOODON_03541882": "18820 - goat carcase (efsa foodex2)",
    "PATO_0002198": "quality of a substance",
    "FOODON_03413152": "microcrystalline cellulose",
    "FOODON_03311709": "garlic in butter",
    "HANCESTRO_0027": "Han Chinese",
    "FOODON_03411875": "kamchatka flounder",
    "NCBITaxon_3511": "Quercus",
    "FOODON_03490384": "amin resin container",
    "FOODON_03301420": "apple juice (reconstituted)",
    "FOODON_03310837": "turkey liver (raw)",
    "FOODON_03401446": "10006354 - saskatoon berries (gs1 gpc)",
    "FOODON_03304178": "sardine (smoke-flavored, canned)",
    "FOODON_03412216": "smooth redeye crab",
    "FOODON_03401076": "10000195 - dessert sauces/toppings/fillings (shelf stable) (gs1 gpc)",
    "FOODON_03311671": "aonori",
    "NCBITaxon_219897": "Syzygium paniculatum",
    "NCBITaxon_7982": "Cobitidae",
    "FOODON_03301177": "spice seed (whole)",
    "FOODON_03542577": "25770 - frogs meat (efsa foodex2)",
    "FOODON_03401724": "10005966 - rambutan (gs1 gpc)",
    "FOODON_03401160": "50121800 - aquatic plants unprepared/unprocessed (gs1 gpc)",
    "FOODON_03542404": "24040 - sardinella or oil sardine (efsa foodex2)",
    "NCBITaxon_245700": "Allocyttus verrucosus",
    "FOODON_03412779": "sycamore fig plant",
    "GAZ_00003957": "American Samoa",
    "FOODON_03400846": "alcoholic beverage (eurofir)",
    "FOODON_03542282": "22820 - perch, golden (efsa foodex2)",
    "FOODON_03540162": "01620 - rusk (efsa foodex2)",
    "FOODON_03317642": "syrup (flavored)",
    "HANCESTRO_0481": "Tongan",
    "FOODON_03315440": "avocado puree (frozen)",
    "FOODON_03413845": "baltic sprat",
    "FOODON_03302950": "maraschino cherry (artificially colored and flavored)",
    "FOODON_03414429": "starch aluminium octenyl succinate",
    "FOODON_03306308": "imitation macaroni",
    "FOODON_03520220": "freshwater fishing area",
    "FOODON_03301530": "iced tea (liquid)",
    "FOODON_03541081": "10810 - lablab beans (dry) (efsa foodex2)",
    "FOODON_03306861": "peanut butter with coconut",
    "FOODON_03308809": "whiskey sour mix",
    "FOODON_03302088": "beef extract",
    "FOODON_03302208": "apricot pulp",
    "NCBITaxon_526614": "Psettodes bennettii",
    "FOODON_03401850": "10006427 - new-zealand spinach (gs1 gpc)",
    "FOODON_03311233": "tuna packed in brine",
    "FOODON_03307136": "green olive (in brine)",
    "FOODON_03541849": "18490 - candied fruit, apple (efsa foodex2)",
    "FOODON_03542337": "23370 - plaice (efsa foodex2)",
    "FOODON_00002587": "Chenin blanc grape plant",
    "FOODON_03542684": "26840 - whey (efsa foodex2)",
    "FOODON_00002652": "lunch food",
    "FOODON_03414042": "rhombosoleidae",
    "FOODON_03311728": "chocolate substitute",
    "NCBITaxon_576990": "Homarinus capensis",
    "FOODON_03411212": "lychee plant",
    "NCBITaxon_30533": "Moschidae",
    "FOODON_03541304": "13040 - cumin seed (efsa foodex2)",
    "FOODON_03307131": "tonic water fountain syrup",
    "FOODON_03307046": "white potato (canned)",
    "GAZ_00002567": "Province of Newfoundland and Labrador",
    "FOODON_03543874": "38740 - omelette, plain (efsa foodex2)",
    "FOODON_03412561": "pequin pepper plant",
    "FOODON_03302462": "butter cream bread",
    "FOODON_03413441": "edible canna plant",
    "FOODON_03411838": "hoki",
    "NCBITaxon_420460": "Dipturus batis",
    "FOODON_03542731": "27310 - cheese (efsa foodex2)",
    "FOODON_03542038": "20380 - goat kidney (efsa foodex2)",
    "FOODON_03543272": "32720 - bottled drinking water (efsa foodex2)",
    "NCBITaxon_630280": "Macrourinae",
    "NCBITaxon_40256": "Modiolus modiolus",
    "FOODON_03315256": "fish (cured)",
    "FOODON_03308127": "clam (soft shell, frozen)",
    "FOODON_03304022": "perigueux sauce",
    "NCBITaxon_6762": "Callinectes",
    "IAO_0100001": "term replaced by",
    "FOODON_03401361": "50330100 - nuts/seeds - unprepared/unprocessed (perishable) (gs1 gpc)",
    "FOODON_03412628": "bell pepper plant",
    "FOODON_03304035": "truffle sauce",
    "FOODON_03541927": "19270 - pig minced meat (efsa foodex2)",
    "FOODON_03460159": "mineral added",
    "NCBITaxon_381124": "Zea mays subsp. mays",
    "NCBITaxon_21819": "Mentha",
    "FOODON_00003373": "weaner pig",
    "NCBITaxon_8555": "Varanidae",
    "FOODON_03543484": "34840 - downy hemp nettle infusion leaves (efsa foodex2)",
    "NCBITaxon_4011": "Anacardiaceae",
    "FOODON_03544502": "45020 - special fatty acids (efsa foodex2)",
    "FOODON_03542122": "21220 - cooked cured (or seasoned) pork meat (efsa foodex2)",
    "FOODON_03541736": "17360 - common banana (efsa foodex2)",
    "FOODON_00002938": "horchata",
    "FOODON_03316521": "fruit half food product",
    "FOODON_03401066": "10000610 - baby/infant - foods/beverages variety packs (gs1 gpc)",
    "FOODON_03540377": "03770 - sugar loaf chicories (efsa foodex2)",
    "FOODON_03540419": "04190 - spinach-type leaves (efsa foodex2)",
    "NCBITaxon_6547": "Mytilidae",
    "FOODON_03542078": "20780 - bovine marrowbone (efsa foodex2)",
    "FOODON_03541435": "14350 - oranges (efsa foodex2)",
    "FOODON_03543103": "31030 - peanut oil, edible (efsa foodex2)",
    "FOODON_03543733": "37330 - fruit infusion (efsa foodex2)",
    "FOODON_03414227": "canary melon plant",
    "FOODON_03543894": "38940 - potato puree from potatoes (efsa foodex2)",
    "FOODON_03540590": "05900 - green onions (efsa foodex2)",
    "FOODON_03412145": "rock cod",
    "FOODON_03311120": "white bread crust",
    "FOODON_03490334": "paper container, untreated",
    "FOODON_03316819": "macaroni (vegetable, enriched)",
    "FOODON_03301477": "coffee bean (whole or ground)",
    "FOODON_00002300": "sweetener food product",
    "FOODON_03541000": "10000 - sugar canes and similar- (efsa foodex2)",
    "FOODON_03543588": "35880 - cat\u0092s foot infusion flowers (efsa foodex2)",
    "FOODON_03317521": "baked good (pre-packed, partially baked)",
    "FOODON_03413143": "magnesium silicate",
    "FOODON_00003167": "deerberry plant",
    "UO_0000031": "minute",
    "FOODON_03530156": "cut of poultry meat",
    "FOODON_00001726": "chicken pie food product",
    "FOODON_03401542": "10006211 - individually cooked eggs (gs1 gpc)",
    "FOODON_00003164": "scarlet runner bean food product",
    "CHEBI_25111": "magnesium porphyrin",
    "FOODON_03306116": "lingonberry concentrate",
    "FOODON_03305456": "gooseberry (frozen)",
    "FOODON_03411515": "poppy plant",
    "FOODON_03304645": "chocolate bar (rum- and butter-filled)",
    "UBERON_0007021": "sexually immature organism",
    "FOODON_03311122": "processed cheese sliced",
    "GAZ_00003934": "Egypt",
    "NCBITaxon_88661": "Berycidae",
    "FOODON_03310311": "food (smoked)",
    "FOODON_03305146": "imitation maraschino cherry",
    "FOODON_03306294": "spaghetti macaroni (spinach)",
    "FOODON_03311181": "passion fruit juice (raw)",
    "FOODON_00002689": "tropical fruit food product",
    "FOODON_03540358": "03580 - vegetables and vegetable products (efsa foodex2)",
    "CHEBI_33608": "hydrogen molecular entity",
    "FOODON_03414274": "whitespot giant arum plant",
    "FOODON_03414855": "bighead carp",
    "FOODON_03411746": "blue-green algae",
    "FOODON_03303619": "lemon-flavored cocktail mix",
    "NCBITaxon_117957": "Vanilla pompona",
    "NCBITaxon_241162": "Dinocardium robustum",
    "FOODON_03542159": "21590 - hungarian-type salami (efsa foodex2)",
    "FOODON_03411045": "thompson seedless grape plant",
    "FOODON_03540798": "07980 - shimeji (efsa foodex2)",
    "FOODON_03540761": "07610 - other green algae (efsa foodex2)",
    "FOODON_03307299": "cooking wine",
    "FOODON_03543707": "37070 - coffee beverage decaffeinated (efsa foodex2)",
    "CHEBI_25741": "oxide",
    "GAZ_00003092": "Region (contiguous United States of America)",
    "FOODON_03310702": "bread stuffing mix",
    "FOODON_00001001": "orange juice (liquid)",
    "NCBITaxon_165789": "Capsicum annuum var. glabriusculum",
    "FOODON_03303040": "coating mix (seasoned)",
    "FOODON_03540442": "04420 - sea asters (efsa foodex2)",
    "FOODON_03315357": "Seongge-jeot",
    "FOODON_03540366": "03660 - crisp lettuces (efsa foodex2)",
    "FOODON_03311899": "castella cake (cream filled, chocolate coated)",
    "FOODON_03401407": "10005942 - soursop (gs1 gpc)",
    "FOODON_03311111": "skipjack tuna packed in water",
    "CHEBI_17306": "maltose",
    "FOODON_03414567": "southern fulmar",
    "FOODON_00001993": "langostino food product",
    "FOODON_03460237": "dilution process to 50-99% of single strength",
    "FOODON_03414593": "canada goose",
    "FOODON_03540283": "02830 - brioche type products (efsa foodex2)",
    "FOODON_03414261": "wineberry plant",
    "NCBITaxon_6694": "Caridea",
    "FOODON_03303345": "shrimp chop suey",
    "FOODON_03308100": "sardine (raw)",
    "FOODON_03301257": "drupelet berry (frozen)",
    "FOODON_03541659": "16590 - other species and hybrids of genus fortunella, not elsewhere mentioned (efsa foodex2)",
    "NCBITaxon_56299": "Scolopax minor",
    "FOODON_03541399": "13990 - tahiti vanilla (efsa foodex2)",
    "FOODON_03315149": "corn syrup (high fructose)",
    "FOODON_03542435": "24350 - pomfret, atlantic (efsa foodex2)",
    "FOODON_03301386": "corn (sweet, canned)",
    "FOODON_00000015": "cattle bull",
    "FOODON_03302101": "ground beef patty (cooked)",
    "FOODON_03302711": "beef bouillon paste",
    "FOODON_03316161": "cephalopod (frozen)",
    "FOODON_03401362": "50340100 - nuts/seeds - unprepared/unprocessed (shelf stable) (gs1 gpc)",
    "FOODON_03540173": "01730 - bread stuffing (efsa foodex2)",
    "FOODON_03542395": "23950 - scorpion fishes (efsa foodex2)",
    "FOODON_03304681": "sauerkraut (bulk-style)",
    "FOODON_03540527": "05270 - chinese broccoli (efsa foodex2)",
    "FOODON_00001699": "cattle sandwich",
    "FOODON_03400216": "hard candy (us cfr)",
    "FOODON_03315319": "vitamin-mineral preparation containing fat-soluble vitamins and no calcium caseinate",
    "FOODON_03307971": "meat (sliced, raw)",
    "FOODON_03315200": "pudding-filled pie",
    "FOODON_03304387": "honey (jellied, diluted)",
    "FOODON_03301418": "blue-green algae food product",
    "FOODON_03540892": "08920 - holy basil (efsa foodex2)",
    "NCBITaxon_426106": "Oleeae",
    "FOODON_03310782": "black turtle bean (whole, dried)",
    "FOODON_03400876": "50202200 - alcoholic beverages (gs1 gpc)",
    "FOODON_03414467": "ascidian",
    "NCBITaxon_219879": "Syzygium eucalyptoides",
    "FOODON_03312062": "salmon (frozen)",
    "FOODON_03310203": "triggerfish (raw)",
    "FOODON_03412341": "job's tears plant",
    "FOODON_03413875": "mediterranean ling",
    "FOODON_03317283": "pizza topping (meat-based)",
    "FOODON_03308979": "chilipepper fish (raw)",
    "FOODON_03470179": "higher heat shorter time (hhst) pasteurization",
    "FOODON_03303135": "cookie (ginger- and lemon-flavored)",
    "FOODON_03420269": "skeletal meat part, without bone and skin, with separable fat",
    "FOODON_03306035": "pickle (kosher)",
    "FOODON_03401556": "10006031 - oyster mushrooms (gs1 gpc)",
    "FOODON_03540415": "04150 - blackjack leaves (efsa foodex2)",
    "FOODON_03460274": "food flaking process",
    "FOODON_03540507": "05070 - mung bean sprouts (efsa foodex2)",
    "CHEBI_24860": "iodine molecular entity",
    "NCBITaxon_980083": "Camelineae",
    "FOODON_03311005": "pork (canned)",
    "FOODON_03302111": "ale",
    "FOODON_00003096": "lovage seed",
    "FOODON_03542796": "27960 - cheese, asiago (efsa foodex2)",
    "FOODON_03540258": "02580 - cream cake (efsa foodex2)",
    "NCBITaxon_403101": "Carissa macrocarpa",
    "FOODON_03411616": "chinese preserving melon plant",
    "CHEBI_36562": "main-group coordination entity",
    "NCBITaxon_59166": "Valerianella locusta",
    "FOODON_00003129": "catjang plant",
    "FOODON_03400654": "06  mammalian products (ccpr)",
    "HANCESTRO_0520": "St. Helenian",
    "FOODON_03440003": "not heat-treated",
    "FOODON_03411693": "sapodilla plant",
    "FOODON_03520150": "pacific, southeast (fao major fishing area 87)",
    "FOODON_00003282": "hen",
    "FOODON_00001045": "ice cream food product",
    "CHEBI_113455": "sodium benzoate",
    "FOODON_03412680": "new zealand sole",
    "FOODON_03412838": "boscia plant",
    "CHEBI_31793": "magnesium carbonate",
    "FOODON_03305317": "guava (whole, raw)",
    "NCBITaxon_57936": "Rubus chamaemorus",
    "FOODON_03541527": "15270 - berries and small fruits (efsa foodex2)",
    "FOODON_03540969": "09690 - chayote roots (efsa foodex2)",
    "FOODON_03413611": "natal spiny lobster",
    "FOODON_03430149": "food (liquid, low viscosity, with solid pieces)",
    "FOODON_03303356": "cinnamon (washed, ground)",
    "FOODON_03541457": "14570 - king mandarins (efsa foodex2)",
    "FOODON_03542819": "28190 - cheese, graddost (efsa foodex2)",
    "FOODON_03543804": "38040 - nutritionally incomplete formulae (efsa foodex2)",
    "CHEBI_3962": "curcumin",
    "FOODON_03414584": "alphaproteobacteria",
    "FOODON_03412891": "slender tuna",
    "FOODON_03311878": "flour (defatted)",
    "FOODON_03414469": "polar bear",
    "FOODON_03302528": "cow buttermilk (cultured, artificially colored)",
    "FOODON_03541135": "11350 - american chestnut (efsa foodex2)",
    "CHEBI_62968": "crystalline cellulose",
    "FOODON_03414498": "ringed seal",
    "FOODON_03301377": "wax bean (cut, canned)",
    "NCBITaxon_31034": "Diodontidae",
    "FOODON_00003270": "pork ribs",
    "FOODON_00001203": "vetch seed (whole, dried)",
    "FOODON_03412428": "salt-brackish water bass",
    "NCBITaxon_7934": "Anguillidae",
    "FOODON_03400335": "firming agent (ec)",
    "FOODON_03316909": "waffle dough",
    "FOODON_03304237": "spaghetti and meatballs",
    "FOODON_03309539": "skim milk (low sodium)",
    "FOODON_03412312": "dusky smooth-hound",
    "FOODON_00002204": "rice bean food product",
    "NCBITaxon_21024": "Fagus",
    "FOODON_03316550": "vegetable juice (gassed)",
    "FOODON_00001295": "pecorino cheese",
    "NCBITaxon_91561": "Artiodactyla",
    "FOODON_03413729": "stalk celery plant",
    "FOODON_03307218": "mango melon preserve",
    "FOODON_03542708": "27080 - traditional nordic fermented milks (efsa foodex2)",
    "FOODON_03308001": "channel catfish (raw)",
    "NCBITaxon_1489841": "Zeiogadaria",
    "FOODON_03301570": "carrot root (whole, raw)",
    "FOODON_00002298": "sweet roll or sweet bun food product",
    "NCBITaxon_223142": "Diodon",
    "FOODON_03309552": "passion fruit (whole, raw)",
    "NCBITaxon_241778": "Apioideae",
    "FOODON_03315383": "obsolete: spread for food",
    "FOODON_03315997": "solid food supplement or dietary integrator",
    "FOODON_03412938": "lesser galangal plant",
    "FOODON_03540639": "06390 - cherry tomatoes (efsa foodex2)",
    "NCBITaxon_647262": "Dendrocnide",
    "FOODON_03542433": "24330 - miscellaneous pelagic marine fishes (efsa foodex2)",
    "FOODON_03411164": "fish, jawless",
    "FOODON_03540049": "00490 - rye and similar- (efsa foodex2)",
    "FOODON_03540159": "01590 - puffed wheat textured bread (efsa foodex2)",
    "FOODON_03450036": "steeping",
    "FOODON_03305708": "snail soup (food product)",
    "FOODON_03305756": "prune juice (fresh)",
    "FOODON_03303224": "fish solubles (dried)",
    "FOODON_00003032": "custard apple (whole, raw)",
    "FOODON_03310015": "filbert (whole, raw)",
    "UO_0010033": "ounce",
    "CHEBI_25681": "omega-3 fatty acid",
    "FOODON_03307161": "red raspberry (whole, raw)",
    "FOODON_03315644": "cheese spread with added ingredients processed",
    "GAZ_00006894": "Kiribati",
    "FOODON_03543375": "33750 - mixtures of beer with other alcoholic drinks (efsa foodex2)",
    "FOODON_03543385": "33850 - spirits from fruit (efsa foodex2)",
    "FOODON_03411658": "green kidney bean plant",
    "FOODON_03309704": "gingelly oil",
    "FOODON_03302734": "beef liver (raw)",
    "FOODON_03490371": "linear low density polyethylene container",
    "FOODON_03301977": "beverage food product",
    "FOODON_03510083": "low salt claim or use",
    "FOODON_03412501": "quahog",
    "GAZ_00003958": "Northern Mariana Islands",
    "FOODON_03305711": "spaghetti bolognese",
    "FOODON_03308482": "porgy (raw)",
    "FOODON_03413021": "brown ht",
    "FOODON_00001204": "yam bean food product",
    "FOODON_03542022": "20220 - deer liver (efsa foodex2)",
    "FOODON_03470145": "preservation by reducing water activity",
    "FOODON_03542865": "28650 - cheese, white stilton (efsa foodex2)",
    "NCBITaxon_8058": "Merlangius merlangus",
    "FOODON_03304338": "alaskan sea lion (raw)",
    "FOODON_03301201": "marjoram (dried)",
    "NCBITaxon_410349": "Saxidomus gigantea",
    "FOODON_03412069": "mustard plant",
    "FOODON_00002766": "green bean substance",
    "FOODON_03542623": "26230 - stockfish (efsa foodex2)",
    "FOODON_00001991": "lake herring food product",
    "FOODON_03412700": "obsolete: eel, freshwater",
    "FOODON_03542046": "20460 - chicken kidney (efsa foodex2)",
    "FOODON_00001626": "bakery food product",
    "NCBITaxon_323665": "Dioscorea esculenta",
    "FOODON_03316183": "seasoning (citrus juice based)",
    "FOODON_03540959": "09590 - potato boiled (efsa foodex2)",
    "FOODON_03540029": "00290 - maize and similar- (efsa foodex2)",
    "FOODON_03411589": "greenland halibut",
    "FOODON_03541852": "18520 - candied fruit, grape (efsa foodex2)",
    "FOODON_03543699": "36990 - derivatives of coffee, cocoa, tea, herbal infusion materials and similar rpcs (efsa foodex2)",
    "NCBITaxon_334912": "Polyprion oxygeneios",
    "FOODON_03308178": "parker's spiny lobster (raw)",
    "FOODON_03311284": "radish (preserved with chili)",
    "FOODON_03401159": "10000153 - aquatic plants prepared/processed (shelf stable) (gs1 gpc)",
    "FOODON_03310241": "obsolete: wheat bread dough",
    "FOODON_03500039": "food-grade paper product surface",
    "FOODON_03412956": "indian long pepper plant",
    "FOODON_03306765": "coconut cream pie",
    "NCBITaxon_641108": "Myzopsetta proboscidea",
    "NCBITaxon_8230": "Sarda orientalis",
    "FOODON_03306803": "pigeon pea (canned)",
    "CHEBI_33259": "elemental molecular entity",
    "GAZ_00002461": "State of California",
    "FOODON_03544333": "43330 - onion flavour (efsa foodex2)",
    "FOODON_03413668": "queen conch",
    "FOODON_03541797": "17970 - dried apricots (efsa foodex2)",
    "FOODON_03303543": "pasteurized process cheese spread with fruit or vegetable",
    "FOODON_03411979": "pacific giant oyster",
    "FOODON_03309292": "inconnu (raw)",
    "FOODON_03450014": "boiling",
    "CHEBI_35504": "addition compound",
    "RO_0002233": "has input",
    "FOODON_00002777": "food (chopped)",
    "FOODON_03540471": "04710 - brussels sprouts and similar- (efsa foodex2)",
    "CHEBI_26979": "organic heterotricyclic compound",
    "FOODON_03302975": "hard grating cheese (block)",
    "FOODON_03401456": "10006143 - chinese cabbages (gs1 gpc)",
    "FOODON_03307154": "rice (flavored with beef extract)",
    "FOODON_03308259": "cove oyster (raw)",
    "FOODON_03304030": "garlic-flavored dip",
    "FOODON_03315686": "obsolete: cider",
    "FOODON_03301753": "triticale (raw)",
    "UO_0000052": "mass density unit",
    "FOODON_03303617": "vegetable seasoning (dehydrated)",
    "FOODON_00002868": "Mourv\u00e8dre grape plant",
    "FOODON_03306470": "duck (wild, in sherry sauce)",
    "FOODON_03541549": "15490 - salmonberries (efsa foodex2)",
    "FOODON_03315422": "fruit (canned, not in contact with tin)",
    "NCBITaxon_37643": "Crassostrea rhizophorae",
    "FOODON_03412227": "hairy sponge crab",
    "FOODON_00003147": "nutritional drink",
    "FOODON_03411531": "pimiento pepper plant",
    "FOODON_03414051": "char",
    "RO_0002595": "causal relation between material entity and a process",
    "FOODON_03303355": "chili seasoning",
    "FOODON_03542086": "20860 - pig tail (efsa foodex2)",
    "FOODON_00001041": "beef food product",
    "NCBITaxon_223863": "Raja microocellata",
    "FOODON_03411202": "pawpaw plant",
    "FOODON_03302508": "butter oil",
    "FOODON_03414260": "thimbleberry plant",
    "FOODON_03412543": "fish, gonorynchiform",
    "FOODON_03544500": "45000 - bromine (efsa foodex2)",
    "NCBITaxon_52903": "Scophthalmus",
    "FOODON_03400852": "miscellaneous food product (eurofir)",
    "FOODON_00002949": "kohlrabi food product",
    "FOODON_03411620": "musk deer",
    "FOODON_03306562": "salad oil",
    "CHEBI_26833": "sulfur atom",
    "FOODON_03412362": "wheatgrass plant",
    "FOODON_00002182": "quince food product",
    "FOODON_03308691": "drum (fish, raw)",
    "FOODON_00001160": "pomaceous fruit extract",
    "FOODON_03309768": "turmeric root (whole, dried)",
    "FOODON_03309607": "sardine in olive oil (canned)",
    "FOODON_03302086": "vegetable (dehydrated)",
    "FOODON_03541542": "15420 - blackberries and similar- (efsa foodex2)",
    "FOODON_00001201": "dry bean food product",
    "FOODON_03412620": "catfish",
    "FOODON_00002692": "moth bean food product",
    "FOODON_03541887": "18870 - chicken carcase (efsa foodex2)",
    "NCBITaxon_146480": "Ammodytes marinus",
    "NCBITaxon_316161": "Dorosomatinae",
    "FOODON_03401529": "10006038 - pumpkins/winter squash (gs1 gpc)",
    "FOODON_03308501": "spanish olive (stuffed with spanish sweet pepper)",
    "NCBITaxon_7956": "Carassius",
    "NCBITaxon_81390": "Synodontidae",
    "FOODON_03311831": "beef (minced)",
    "FOODON_03401399": "50290000 - vegetables - unprepared/unprocessed (frozen) (gs1 gpc)",
    "FOODON_03412722": "satsuma orange plant",
    "FOODON_03401868": "10005910 - mirabelles (gs1 gpc)",
    "GAZ_00002521": "State of Alaska",
    "FOODON_03305218": "cinnamon raisin bread",
    "NCBITaxon_94826": "Perna perna",
    "FOODON_03411266": "common banana plant",
    "NCBITaxon_29147": "Lates niloticus",
    "FOODON_03414915": "sea lavender plant",
    "FOODON_00002026": "meal replacement food product",
    "FOODON_03311710": "garlic in margarine",
    "CHEBI_22652": "ascorbic acid",
    "NCBITaxon_1489900": "Anabantiformes",
    "NCBITaxon_85549": "Artemia salina",
    "FOODON_03315325": "soft drink (cold)",
    "FOODON_00001082": "bitter cheese food product",
    "FOODON_03543373": "33730 - alcopop and flavoured wine (efsa foodex2)",
    "FOODON_03316659": "caramel paste",
    "FOODON_00001861": "florida stone crab food product",
    "FOODON_03307809": "fish stick (frozen)",
    "FOODON_03542076": "20760 - bovine heart (efsa foodex2)",
    "NCBITaxon_50543": "Trichosanthes cucumerina",
    "FOODON_03411206": "plum plant",
    "FOODON_03310635": "bakery product",
    "FOODON_03315641": "cheese food processed",
    "FOODON_03543310": "33100 - soft drink, lime flavour (efsa foodex2)",
    "FOODON_03317234": "white corn meal (degerminated)",
    "NCBITaxon_260142": "Syzygium cumini",
    "CHEBI_25094": "lysine",
    "FOODON_03305843": "doughnut (plain)",
    "FOODON_03510018": "poultry as consumer",
    "NCBITaxon_3581": "Portulacaceae",
    "FOODON_03414528": "marrowfat pea plant",
    "FOODON_03412419": "chinese chive plant",
    "FOODON_03311305": "cream-type pie (frozen)",
    "FOODON_03542338": "23380 - plaice, alaska (efsa foodex2)",
    "FOODON_03414135": "stone crab family",
    "FOODON_03308956": "carribean red snapper (raw)",
    "NCBITaxon_61967": "Acipenser nudiventris",
    "FOODON_03542631": "26310 - canned sardines (efsa foodex2)",
    "FOODON_03420157": "white sugar",
    "FOODON_03308758": "rock shell snail (raw)",
    "FOODON_03543742": "37420 - peppermint infusion (efsa foodex2)",
    "FOODON_03413804": "nile crocodile",
    "FOODON_03543717": "37170 - wheat coffee infusion (efsa foodex2)",
    "FOODON_03308540": "calico scallop (raw)",
    "FOODON_03306174": "grapefruit juice",
    "HANCESTRO_0356": "Chilean",
    "NCBITaxon_2070381": "Brassica napus var. pabularia",
    "FOODON_03543314": "33140 - soft drink, pineapple flavour (efsa foodex2)",
    "CHEBI_33695": "information biomacromolecule",
    "FOODON_00002741": "Poultry by-product meal (PBM)",
    "FOODON_03414283": "sunset muskmallow plant",
    "FOODON_03414847": "dog",
    "FOODON_03302755": "squash (freeze-dried)",
    "FOODON_03542700": "27000 - yoghurt, goat milk (efsa foodex2)",
    "PATO_0045050": "normal size",
    "IAO_0000117": "term editor",
    "FOODON_03413997": "pacific pomfret",
    "FOODON_03305153": "vanilla bean (spent)",
    "FOODON_03542734": "27340 - mascarpone (efsa foodex2)",
    "NCBITaxon_8825": "Neognathae",
    "FOODON_03411612": "danube salmon",
    "FOODON_03301372": "pea (whole, dried)",
    "NCBITaxon_66687": "Krameriaceae",
    "FOODON_03412267": "fish, chimaeriform",
    "NCBITaxon_16123": "Hypoxis",
    "FOODON_03411569": "chanterelle",
    "NCBITaxon_137693": "Polygonum aviculare",
    "FOODON_03303395": "zante currant",
    "FOODON_00001875": "fermented milk food product",
    "FOODON_03310483": "hard candy sweetened with sorbitol",
    "FOODON_03543062": "30620 - sugar cotton (efsa foodex2)",
    "FOODON_03301591": "grapefruit juice concentrate",
    "FOODON_03413959": "oxeye scad",
    "FOODON_03530103": "solid containing medium or small particles (4-8 mm.)",
    "FOODON_03490386": "carbamide-formaldehyde container",
    "NCBITaxon_348707": "Coregonus nasus",
    "FOODON_03414742": "cowpea family",
    "FOODON_03411584": "european chestnut tree",
    "PO_0030109": "hesperidium fruit",
    "FOODON_03305353": "chicken soup concentrate",
    "FOODON_03400745": "040  freshwater fish (wf) (ccpr)",
    "FOODON_03305557": "sarsaparilla (raw)",
    "FOODON_03541990": "19900 - cattle fresh fat tissue (efsa foodex2)",
    "FOODON_03309801": "taro root (whole, raw)",
    "FOODON_03541418": "14180 - canned or jarred peas (efsa foodex2)",
    "FOODON_03310292": "queso blanco cheese",
    "FOODON_03543417": "34170 - instant coffee powder, decaffeinated (efsa foodex2)",
    "CHEBI_131927": "dicarboxylic acids and O-substituted derivatives",
    "FOODON_03317092": "confectionery (throat pastille)",
    "NCBITaxon_119695": "Calamus <bony fishes>",
    "FOODON_03308707": "snail (with shell, precooked, frozen)",
    "FOODON_00002880": "scrapple",
    "FOODON_03413197": "polyvinylpolypyrrolidone",
    "FOODON_03401830": "10000614 - seafood variety packs (gs1 gpc)",
    "FOODON_03540013": "00130 - prince of wales-feather amaranth grain (efsa foodex2)",
    "FOODON_03310956": "turnip greens (frozen)",
    "FOODON_03305453": "strawberry (unsweetened, frozen)",
    "NCBITaxon_6553": "Arcidae",
    "NCBITaxon_119951": "Eugenia uniflora",
    "FOODON_03303606": "chocolate candy (vitamin- and mineral-fortified)",
    "FOODON_03520136": "atlantic, western central (fao major fishing area 31)",
    "FOODON_03542423": "24230 - southern bluefin tuna (efsa foodex2)",
    "FOODON_03530120": "street vendor food retail process",
    "FOODON_00002403": "food material",
    "FOODON_03544188": "41880 - apple red flavour (efsa foodex2)",
    "FOODON_03301593": "melon (raw)",
    "FOODON_03544087": "40870 - vinegar (efsa foodex2)",
    "FOODON_03305800": "vanilla ice cream",
    "CHEBI_36295": "hexacyanoferrate salt",
    "UO_0000195": "degree Fahrenheit",
    "FOODON_03317614": "obsolete: cheese product",
    "FOODON_03302779": "ice milk",
    "FOODON_03543729": "37290 - tea infusion with added flavouring ingredients (efsa foodex2)",
    "FOODON_03315398": "obsolete: beverage coffee-based",
    "NCBITaxon_115587": "Palinuroidea",
    "FOODON_03302207": "kola nut pod (whole, raw)",
    "FOODON_03302362": "potato cracker",
    "FOODON_03401619": "10005767 - beef - prepared/processed (gs1 gpc)",
    "FOODON_03307526": "scampi (peeled)",
    "FOODON_03317138": "artificial sweetener (liquid)",
    "FOODON_03544361": "43610 - red orange flavour (efsa foodex2)",
    "FOODON_03308955": "humpback snapper (raw)",
    "CHEBI_17561": "L-cysteine",
    "FOODON_03312056": "soybean flour (fermented)",
    "FOODON_03401580": "10006049 - dill (gs1 gpc)",
    "FOODON_03301156": "fish (freshwater, raw)",
    "FOODON_03420236": "protein extract, concentrate or isolate",
    "FOODON_03317156": "jam (energy-containing sweetener not added)",
    "NCBITaxon_193516": "Hippophae rhamnoides",
    "FOODON_03310808": "soy gluten",
    "FOODON_03306200": "gluten noodle",
    "HANCESTRO_0351": "Bosnian or Herzegovinian",
    "FOODON_03414887": "cobia",
    "FOODON_03317478": "fish fillet (unprocessed, frozen)",
    "FOODON_03411069": "bigeye tuna",
    "FOODON_03304208": "chicken bouillon (concentrated)",
    "NCBITaxon_6594": "Macrocallista nimbosa",
    "FOODON_03411822": "snailfish family",
    "FOODON_00003136": "bayberry (whole, raw)",
    "FOODON_03542899": "28990 - cheese, grana padano (efsa foodex2)",
    "CHEBI_61995": "lecithin",
    "FOODON_03311095": "grain product",
    "NCBITaxon_490587": "Metanephrops australiensis",
    "FOODON_03302701": "honey bread",
    "FOODON_03308377": "deep sea lobster tail (raw)",
    "FOODON_03315895": "beverage (citrus-flavored)",
    "FOODON_03411144": "flyingfish",
    "NCBITaxon_215450": "Decapodiformes",
    "FOODON_03540737": "07370 - black radishes (efsa foodex2)",
    "FOODON_03544202": "42020 - bitter flavour (efsa foodex2)",
    "FOODON_03301305": "fructose food product",
    "NCBITaxon_3468": "Papaver",
    "FOODON_03541981": "19810 - mallard fresh meat (efsa foodex2)",
    "FOODON_03301460": "tomato catsup",
    "NCBITaxon_74787": "Tripolium pannonicum",
    "FOODON_03401268": "0290000 - sea weeds (ec)",
    "FOODON_03415140": "horse-chestnut plant",
    "FOODON_03543075": "30750 - fondant mass (efsa foodex2)",
    "FOODON_03302091": "beef broth",
    "FOODON_03317042": "milk-derivative-based preparations (desserts and similar products) with no added sugar",
    "FOODON_03307117": "jam (frozen)",
    "FOODON_00001574": "soybean stubble",
    "FOODON_03540918": "09180 - lemon myrtle (fresh herb) (efsa foodex2)",
    "FOODON_00001165": "solanaceous food product",
    "FOODON_03315263": "product containing gravy or sauce",
    "FOODON_03540755": "07550 - arracacha (efsa foodex2)",
    "FOODON_00001740": "citron food product",
    "FOODON_03308723": "atlantic skipjack (raw)",
    "FOODON_03306541": "brandied fruitcake (food product)",
    "FOODON_03306224": "romano cheese (grated, garlic-flavored)",
    "FOODON_03305070": "salt and pepper spray",
    "HANCESTRO_0005": "European",
    "FOODON_03420150": "whole plant or most parts used",
    "FOODON_03411697": "english holly plant",
    "FOODON_03412231": "red swamp crayfish",
    "FOODON_03530040": "jowl, trimmed",
    "FOODON_03543518": "35180 - small-leaf linden infusion leaves (efsa foodex2)",
    "FOODON_03413727": "winter turnip rape plant",
    "NCBITaxon_214908": "Grewioideae",
    "FOODON_03412686": "crawfish or crayfish",
    "FOODON_03401859": "10006130 - globe artichokes (gs1 gpc)",
    "FOODON_03307244": "honeydew melon (raw)",
    "FOODON_03316980": "lychee (canned)",
    "FOODON_03414898": "portuguese oyster",
    "FOODON_03307800": "vegetable (boiled)",
    "FOODON_03301080": "caviar",
    "FOODON_03400855": "flavouring or essence (eurofir)",
    "FOODON_03315540": "cereal flakes",
    "FOODON_03542179": "21790 - head cheese (efsa foodex2)",
    "FOODON_03303677": "pasteurized process gruyere cheese",
    "FOODON_03412681": "blackfoot abalone",
    "FOODON_03307068": "rock cornish cross chicken (raw)",
    "NCBITaxon_39292": "Cyrtosperma merkusii",
    "FOODON_03541826": "18260 - marmalade, mandarins (efsa foodex2)",
    "FOODON_03413603": "red rock lobster",
    "FOODON_03317579": "skim milk (uht-sterilized)",
    "FOODON_03302836": "chocolate-flavored topping (sweetened with sorbitol)",
    "FOODON_03303193": "corn meal (stone ground)",
    "FOODON_03304966": "imitation wild cherry drop (sweetened with sorbitol)",
    "FOODON_03315525": "ice, edible",
    "FOODON_03490331": "lacquered paper container",
    "FOODON_03520490": "tropical wet climatic zone",
    "FOODON_03310201": "ginseng tea with ginseng root (steeped)",
    "FOODON_03460141": "food modification process",
    "FOODON_03490327": "regenerated cellulose film, coated",
    "FOODON_03315064": "cheese asiago fresh",
    "FOODON_03414003": "pink dentex",
    "FOODON_03315244": "fruit and water ices",
    "RO_0002295": "results in development al progression of",
    "FOODON_03544167": "41670 - wheat starch (efsa foodex2)",
    "NCBITaxon_7869": "Chimaeridae",
    "FOODON_03316414": "glucose syrup (dried, exclusively for commercial production of sweets and candies)",
    "FOODON_03310291": "ogi",
    "FOODON_03543621": "36210 - jasmine infusion flowers and similar- (efsa foodex2)",
    "FOODON_03540386": "03860 - red mustard leaves (efsa foodex2)",
    "FOODON_03544081": "40810 - vegetable savoury extracts (efsa foodex2)",
    "NCBITaxon_34817": "Hippoglossoides platessoides",
    "NCBITaxon_267511": "Enchylaena",
    "NCBITaxon_267258": "Rosa suffulta",
    "FOODON_03307449": "zwieback toast",
    "NCBITaxon_57940": "Potentilla erecta",
    "FOODON_03304264": "spaghetti macaroni (home-style, enriched)",
    "FOODON_03305799": "diabetic frozen dessert",
    "FOODON_03301715": "pimiento (raw)",
    "FOODON_03542596": "25960 - snails (efsa foodex2)",
    "FOODON_03309941": "mustard spice",
    "PO_0009065": "hypanthium",
    "FOODON_03400206": "frozen nondairy dessert (us cfr)",
    "FOODON_03544335": "43350 - oregano flavour (efsa foodex2)",
    "FOODON_03400332": "colour (ec)",
    "FOODON_03542032": "20320 - mammals kidney (efsa foodex2)",
    "FOODON_03304486": "platano flour",
    "FOODON_00001934": "green bean food product",
    "FOODON_03315305": "sweetener (nutritive)",
    "NCBITaxon_4454": "Araceae",
    "NCBITaxon_270543": "Erilepis zonifer",
    "GAZ_00001100": "Mozambique",
    "FOODON_03317310": "meat stew (frozen)",
    "ENVO_00000266": "pasture",
    "FOODON_03303598": "milk chocolate-flavored candy bar (sweetened with sorbitol)",
    "NCBITaxon_40495": "Lutjanus analis",
    "NCBITaxon_882375": "Chenopodium pallidicaule",
    "FOODON_03306914": "spanish peanut (whole, raw)",
    "FOODON_03414099": "undulate ray",
    "FOODON_03490235": "polypropylene plug",
    "FOODON_03303845": "filled milk (liquid)",
    "FOODON_03308155": "oyster stew (canned)",
    "FOODON_03541587": "15870 - lingonberries (efsa foodex2)",
    "CHEBI_23045": "carotenol",
    "FOODON_03541941": "19410 - camel fresh meat (efsa foodex2)",
    "NCBITaxon_9837": "Camelus bactrianus",
    "FOODON_03540063": "00630 - triticale grain (efsa foodex2)",
    "FOODON_03302593": "vegetable in butter sauce (canned)",
    "FOODON_03401488": "10006423 - puntarelle (gs1 gpc)",
    "FOODON_03412694": "brownspotted rockcod",
    "FOODON_03302626": "yeast food product (dry, active)",
    "NCBITaxon_224704": "Harengula",
    "FOODON_03400453": "CIAA fats and oils",
    "FOODON_03543487": "34870 - pale echinacea infusion leaves (efsa foodex2)",
    "NCBITaxon_141999": "Carpobrotus",
    "NCBITaxon_98813": "Dentex gibbosus",
    "UO_0000186": "dimensionless unit",
    "FOODON_03302862": "eggnog pecan cake",
    "FOODON_03543869": "38690 - fish and vegetables meal (efsa foodex2)",
    "IAO_0000005": "objective specification",
    "NCBITaxon_150492": "Euphausia frigida",
    "UBERON_2002079": "leptocephalous larva",
    "CHEBI_36094": "organic chloride salt",
    "FOODON_03311663": "beef steak (raw)",
    "FOODON_03400997": "10000207 - fruit/nuts/seeds mixes - prepared/processed (shelf stable) (gs1 gpc)",
    "FOODON_03304740": "onion salt",
    "FOODON_03401305": "dietary supplement, amino acid or protein",
    "FOODON_03304945": "beef stock base (meatless)",
    "FOODON_03315826": "dessert (frozen, unstandardized)",
    "FOODON_03315465": "olive (table)",
    "FOODON_03420297": "germ oil",
    "GAZ_00000912": "Nigeria",
    "HANCESTRO_0391": "Slovene",
    "FOODON_03414767": "saltbush plant",
    "FOODON_03400437": "release agent (codex)",
    "FOODON_03543362": "33620 - raisin wine (efsa foodex2)",
    "FOODON_03310705": "pie crust mix",
    "FOODON_03542960": "29600 - emu eggs (efsa foodex2)",
    "NCBITaxon_27770": "Trichiuridae",
    "FOODON_03530201": "fat content 50-80%, > 25% pufa",
    "FOODON_03310598": "beef gravy",
    "FOODON_03411498": "king crab",
    "FOODON_03542398": "23980 - hairtails, scabbardfishes (generic) (efsa foodex2)",
    "FOODON_03490211": "wrapper, material unspecified",
    "FOODON_03414063": "biwa",
    "FOODON_03413131": "litholrubine bk",
    "FOODON_03414006": "northern sand lance",
    "FOODON_03400676": "011  fruiting vegetables, cucurbits (vc) (ccpr)",
    "NCBITaxon_320395": "Genyonemus lineatus",
    "FOODON_03317357": "poultry product (raw, packaged)",
    "FOODON_03420307": "seed oil",
    "FOODON_03520350": "Western Asia",
    "FOODON_03307295": "cooking sherry",
    "FOODON_03540722": "07220 - jerusalem artichokes (efsa foodex2)",
    "FOODON_03544490": "44900 - phosphorus (efsa foodex2)",
    "FOODON_03308688": "shrimp and fish frankfurter",
    "FOODON_03301930": "pie (sweetened)",
    "FOODON_03307732": "potato (shoestring)",
    "FOODON_03315710": "confectionery glaze for nut-based snack foods",
    "FOODON_03307143": "olive (stuffed with pimiento)",
    "FOODON_03316843": "flour (self-rising, enriched)",
    "FOODON_03305250": "imitation french dressing (artificially sweetened)",
    "FOODON_03310891": "yeast food product (dry, inactive)",
    "FOODON_03540843": "08430 - lovage leaves (efsa foodex2)",
    "NCBITaxon_39107": "Murinae",
    "NCBITaxon_7963": "Hypophthalmichthys",
    "FOODON_03542848": "28480 - cheese, saint paulin (efsa foodex2)",
    "FOODON_03301952": "apple (frozen)",
    "NCBITaxon_201697": "Pomoxis annularis",
    "FOODON_03412971": "galangal plant",
    "FOODON_03304013": "tuna casserole",
    "FOODON_03302099": "beef casing",
    "NCBITaxon_1489875": "Gobiaria",
    "FOODON_03540672": "06720 - dosakayi (efsa foodex2)",
    "FOODON_03306974": "imitation mozzarella cheese (low-moisture, part-skim)",
    "FOODON_03315407": "ice confection",
    "NCBITaxon_29158": "Mytilus galloprovincialis",
    "FOODON_03401261": "1040000 - honey (ec)",
    "NCBITaxon_268723": "Eleusine coracana subsp. africana",
    "FOODON_03305954": "grape jelly",
    "FOODON_03540480": "04800 - leafy brassica (efsa foodex2)",
    "CHEBI_38889": "tetraborate(2-)",
    "FOODON_03400894": "10000114 - coffee - ready to drink (gs1 gpc)",
    "NCBITaxon_6622": "Loligo vulgaris",
    "FOODON_03542209": "22090 - luncheon spiced ham-type tinned meat (efsa foodex2)",
    "HANCESTRO_0416": "Montserratian",
    "NCBITaxon_3758": "Prunus domestica",
    "FOODON_03540246": "02460 - biscuit with inclusions, filling or coating (efsa foodex2)",
    "FOODON_03308123": "clam (hard shell, in shell, raw)",
    "GAZ_00002518": "State of Arizona",
    "FOODON_03316107": "cereal protein-based meat analog (food product)",
    "FOODON_03401493": "10006866 - citron (gs1 gpc)",
    "FOODON_03304084": "scotch broth (food product)",
    "CHEBI_71645": "type A lantibiotic",
    "NCBITaxon_134997": "Panopea abrupta",
    "FOODON_03541425": "14250 - grapefruits (efsa foodex2)",
    "FOODON_03544050": "40500 - seasoning, sauces and condiments (efsa foodex2)",
    "FOODON_03311759": "dandelion (not further specified)",
    "FOODON_03303112": "wheat germ (defatted, roasted)",
    "FOODON_03413063": "caustic sulphite caramel",
    "CHEBI_51958": "organic polycyclic compound",
    "FOODON_03309973": "jam",
    "NCBITaxon_41084": "Polyphaga <beetles>",
    "FOODON_03411884": "silverside family",
    "FOODON_03542885": "28850 - cheese, montasio (efsa foodex2)",
    "FOODON_03304832": "dill seed (whole, dried)",
    "FOODON_03310750": "lake michigan chub raw",
    "FOODON_03411583": "deer",
    "FOODON_00001274": "egg food product",
    "FOODON_03305481": "grape beverage (less than 0.5% alcohol)",
    "NCBITaxon_136": "Spirochaetales",
    "FOODON_03304553": "rice (milled, enriched)",
    "GAZ_00002724": "Ukraine",
    "NCBITaxon_2711": "Citrus sinensis",
    "FOODON_03301499": "cow milk (flavored)",
    "FOODON_00001689": "cassava flour food product",
    "FOODON_03310944": "carrot junior food",
    "FOODON_03316424": "cod dried",
    "NCBITaxon_13451": "Corylus avellana",
    "FOODON_03315803": "meat curing compound",
    "FOODON_03317591": "bean (whole, cooked, with seasoning)",
    "FOODON_03308133": "deep sea lobster (canned)",
    "FOODON_03302702": "bread (high fiber, reduced-calorie)",
    "CHEBI_33598": "carbocyclic compound",
    "FOODON_03414353": "cleopatra orange plant",
    "FOODON_03315620": "soup (thick)",
    "FOODON_03307844": "hamburger pattie (raw, with cheese spread on bun, frozen)",
    "FOODON_03306567": "beef-flavored bouillon seasoning and broth instant",
    "FOODON_03302114": "malt and hop extract",
    "NCBITaxon_117858": "Dipturus",
    "FOODON_03540585": "05850 - shallots (efsa foodex2)",
    "FOODON_03541311": "13110 - fenugreek seed and similar- (efsa foodex2)",
    "FOODON_03413962": "mackerel scad",
    "NCBITaxon_1092587": "mammal environmental sample",
    "FOODON_03316477": "vegetable marinade",
    "NCBITaxon_7808": "Carcharhinus plumbeus",
    "FOODON_03400372": "antioxidant synergist (codex)",
    "NCBITaxon_33340": "Neoptera",
    "FOODON_03308575": "iceland scallop (raw)",
    "FOODON_03540157": "01570 - extruded rice bread (efsa foodex2)",
    "CHEBI_53251": "poly(tetrafluoroethylene)",
    "FOODON_03304974": "candy (nutritively sweetened)",
    "FOODON_03460383": "seaweed extract",
    "NCBITaxon_182230": "Osmerinae",
    "NCBITaxon_2768": "Chondrus",
    "FOODON_03540107": "01070 - rice semolina (efsa foodex2)",
    "FOODON_03308790": "sea bass (raw)",
    "CHEBI_35510": "aluminium salt",
    "NCBITaxon_117916": "Somniosidae",
    "NCBITaxon_66386": "Ficus pumila",
    "FOODON_03302065": "green bean (cut, raw)",
    "FOODON_03411733": "swamp cabbage plant",
    "FOODON_03412720": "almond, sweet (plant)",
    "FOODON_00001283": "poultry food product",
    "FOODON_03303676": "st. paulin cheese (food product)",
    "FOODON_03542593": "25930 - other amphibians and reptiles (efsa foodex2)",
    "FOODON_03317487": "vegetable preparation (canned)",
    "FOODON_03470181": "filling conditions for pasteurization",
    "FOODON_03302185": "bibingka mix",
    "FOODON_03544378": "43780 - spice mix flavour (efsa foodex2)",
    "FOODON_03316271": "sugar product",
    "FOODON_03542986": "29860 - refined beet sugar (efsa foodex2)",
    "FOODON_03317605": "yogurt (fruit flavored)",
    "NCBITaxon_7824": "Sphyrna tiburo",
    "NCBITaxon_3822": "Canavalia",
    "FOODON_03401707": "10005973 - breadfruits (gs1 gpc)",
    "FOODON_03541055": "10550 - moringa (without pods) (efsa foodex2)",
    "FOODON_03311399": "black raspberry (whole, raw)",
    "CHEBI_33308": "carboxylic ester",
    "FOODON_03542204": "22040 - turkey meat, dried (efsa foodex2)",
    "FOODON_03309235": "fantail mullet (raw)",
    "FOODON_03490190": "aluminum foil wrapper",
    "FOODON_00001240": "rennet (genetically engineered)",
    "FOODON_03301776": "cola carbonated beverage",
    "FOODON_03541010": "10100 - chilean coco palm (trunk sap) (efsa foodex2)",
    "FOODON_00003302": "beef tenderloin",
    "NCBITaxon_13493": "Diospyros virginiana",
    "NCBITaxon_9947": "Tragelaphus imberbis",
    "FOODON_00002963": "safflower flower",
    "FOODON_03308886": "gray bass (raw)",
    "FOODON_03542271": "22710 - perch, american yellow (efsa foodex2)",
    "FOODON_03541754": "17540 - paw paws (efsa foodex2)",
    "FOODON_03308615": "crab (stuffed)",
    "NCBITaxon_9014": "Colinus virginianus",
    "FOODON_03411868": "rock sole",
    "NCBITaxon_31103": "Zeidae",
    "CHEBI_25830": "p-quinones",
    "FOODON_03543229": "32290 - fruit/vegetable juice concentrate (efsa foodex2)",
    "FOODON_03542417": "24170 - tuna (efsa foodex2)",
    "FOODON_03305046": "wheat germ oil",
    "FOODON_03302240": "beverage (carbonated, artificially flavored, artificially colored)",
    "NCBITaxon_6593": "Macrocallista",
    "FOODON_03541953": "19530 - roe deer meat (efsa foodex2)",
    "FOODON_03305076": "gelato",
    "FOODON_03490234": "polyethylene plug",
    "FOODON_03307061": "black cod (cured)",
    "FOODON_03310094": "licorice root (whole)",
    "FOODON_03544057": "40570 - salt, iodised and fluoridated (efsa foodex2)",
    "FOODON_03303358": "lemon custard sandwich cookie",
    "FOODON_03305881": "imitation jelly aid (artificially flavored)",
    "RO_0002320": "evolutionarily related to",
    "FOODON_03411565": "whitefish or cisco",
    "FOODON_03308411": "fish (breaded, frozen)",
    "FOODON_03310822": "chicken bone",
    "FOODON_03540061": "00610 - einkorn wheat grain (efsa foodex2)",
    "FOODON_03310588": "apple juice (canned)",
    "FOODON_03544107": "41070 - mustard, mild (efsa foodex2)",
    "FOODON_03401593": "10006044 - mugwort (gs1 gpc)",
    "FOODON_03316681": "fish fillet (quick-frozen in blocks)",
    "FOODON_03543548": "35480 - tansy infusion leaves (efsa foodex2)",
    "FOODON_03412360": "otaheite gooseberry plant",
    "FOODON_03542265": "22650 - pacific fat sleeper (efsa foodex2)",
    "FOODON_03301942": "food (barbequed)",
    "FOODON_03315941": "obsolete: wine (aromatized)",
    "FOODON_03414808": "toothed top shell",
    "FOODON_03530172": "oil content (eurocode2)",
    "FOODON_03315361": "adzuki bean (whole)",
    "NCBITaxon_202590": "Lachnolaimus maximus",
    "NCBITaxon_430081": "Aulopus filamentosus",
    "FOODON_03542167": "21670 - cooked sausages (generic) (efsa foodex2)",
    "FOODON_03530258": "controlled origin denomination (doc)",
    "NCBITaxon_191066": "Empetrum nigrum",
    "NCBITaxon_9871": "Odocoileus",
    "FOODON_03544124": "41240 - horseradish sauce (efsa foodex2)",
    "NCBITaxon_66437": "Tragelaphus angasii",
    "FOODON_03411236": "turkey (bird)",
    "CHEBI_33300": "pnictogen",
    "FOODON_03316350": "macaroon surrogate paste",
    "FOODON_03305470": "mellorine",
    "FOODON_03542923": "29230 - cheese, buche de chevre (efsa foodex2)",
    "CHEBI_83503": "neotame",
    "FOODON_03316604": "bread lecithin",
    "FOODON_03302916": "provolone cheese",
    "FOODON_03543734": "37340 - hibiscus infusion (efsa foodex2)",
    "FOODON_00002019": "mandarin orange juice",
    "FOODON_03309450": "margarita mix (nonalcoholic)",
    "FOODON_03311050": "beverage mix (aspartame sweetened)",
    "FOODON_03542581": "25810 - frog, common (efsa foodex2)",
    "FOODON_03541925": "19250 - bovine, minced meat (efsa foodex2)",
    "FOODON_03415067": "roman wormwood plant",
    "FOODON_03412559": "poblano pepper plant",
    "NCBITaxon_138011": "Brassica napus var. napus",
    "FOODON_00001164": "tomato food product",
    "FOODON_03541299": "12990 - lovage seed (efsa foodex2)",
    "FOODON_03414107": "sleeper shark",
    "FOODON_00001119": "cervid dairy food product",
    "FOODON_03310490": "ginger (ground)",
    "FOODON_03311030": "crab claw (whole, raw)",
    "ECOCORE_00000021": "carnivory",
    "FOODON_03540140": "01400 - traditional unleavened breads (efsa foodex2)",
    "NCBITaxon_143309": "Saurida",
    "FOODON_03315972": "sandwich spread (milk-based, energy reduced)",
    "FOODON_03316842": "flour (phosphated)",
    "NCBITaxon_135518": "Ribes uva-crispa",
    "FOODON_00002620": "Frappato grape plant",
    "NCBITaxon_8798": "Struthioniformes",
    "FOODON_03301552": "turnip greens (raw)",
    "CHEBI_9405": "tartrazine",
    "CHEBI_26677": "silicon molecular entity",
    "FOODON_03543345": "33450 - shandy (efsa foodex2)",
    "FOODON_03543903": "39030 - beans and vegetables meal (efsa foodex2)",
    "FOODON_03309202": "pacific thread herring (raw)",
    "FOODON_03490406": "polyethylene - vinyl copolymer container",
    "FOODON_03316372": "zwieback dutch type",
    "FOODON_03543240": "32400 - juice concentrate, orange (efsa foodex2)",
    "FOODON_03305205": "ham omelet mix (instant)",
    "FOODON_03315295": "catsup",
    "FOODON_03543664": "36640 - carobs (efsa foodex2)",
    "FOODON_00002947": "andouille sausage",
    "FOODON_03401236": "0300000 - 3. pulses, dry (ec)",
    "FOODON_03412054": "feverfew plant",
    "FOODON_03460335": "animal fat or oil coated",
    "FOODON_00002871": "oheloberry fruit product",
    "PO_0009007": "portion of plant tissue",
    "NCBITaxon_3629": "Malvaceae",
    "FOODON_03303554": "navy bean flour",
    "FOODON_03309979": "buckwheat noodle",
    "FOODON_03315293": "jeotgal",
    "ENVO_00000109": "woodland area",
    "NCBITaxon_13757": "Viola <eudicots>",
    "FOODON_03450015": "boiling and then draining",
    "FOODON_03414529": "chinese white olive plant",
    "FOODON_03414609": "sea belt",
    "FOODON_03541310": "13100 - sweet fennel seed (efsa foodex2)",
    "NCBITaxon_461499": "Atherinopsidae",
    "FOODON_03400321": "stabilizer (us cfr)",
    "FOODON_03411022": "tropical or subtropical nut producing plant",
    "FOODON_03414394": "glyceryl diacetate (diacetin)",
    "FOODON_03302969": "chinese vegetables (mixed, raw)",
    "HANCESTRO_0385": "Romanian",
    "FOODON_03544397": "43970 - tomato flavour (efsa foodex2)",
    "FOODON_03544219": "42190 - caf\u00e9-au-lait flavour (efsa foodex2)",
    "FOODON_03301419": "obsolete: apple juice",
    "FOODON_03311270": "Beaujolais wine",
    "FOODON_03302561": "hominy (golden, with green and red pepper, canned)",
    "FOODON_03304722": "hen egg white (frozen)",
    "CHEBI_36962": "organochalcogen compound",
    "NCBITaxon_147371": "Chloridoideae",
    "NCBITaxon_75939": "Dallia pectoralis",
    "FOODON_03316961": "noodle product (egg, vegetable, enriched)",
    "ENVO_02000090": "ash",
    "NCBITaxon_346985": "Senna obtusifolia",
    "FOODON_03304654": "cheeseburger",
    "FOODON_03542253": "22530 - snakeheads(=murrels) (efsa foodex2)",
    "FOODON_03412537": "spotted pike-conger",
    "FOODON_03316546": "mammalian milk (long-life consumer)",
    "FOODON_03413412": "obsolete: japanese-green",
    "NCBITaxon_7868": "Callorhinchus milii",
    "FOODON_03302565": "lemon and lime fruit juice carbonated beverage (10% diluted)",
    "FOODON_03316946": "whey cheese",
    "FOODON_03543395": "33950 - coffee liqueur (efsa foodex2)",
    "FOODON_03306261": "corn oil margarine",
    "FOODON_03542087": "20870 - pig trotters and feet (efsa foodex2)",
    "FOODON_03308888": "freshwater drum (raw)",
    "FOODON_03303128": "eggnog mix",
    "FOODON_03304515": "snail (raw)",
    "FOODON_03307404": "chinese oyster (raw)",
    "FOODON_00002697": "apple snail",
    "NCBITaxon_8000": "Pangasius",
    "FOODON_03400136": "nonstandardized dressing (us cfr)",
    "UBERON_0000955": "brain",
    "FOODON_03317543": "tandoori",
    "FOODON_03308545": "scallop (sea, frozen)",
    "FOODON_03310925": "barley cereal (infant food, dry)",
    "FOODON_00001265": "buffalo milk beverage",
    "CHEBI_46640": "diketone",
    "FOODON_03530195": "fat content 46-60%",
    "NCBITaxon_9835": "Camelidae",
    "FOODON_03307207": "gravy mix (dry)",
    "FOODON_00002997": "okapi",
    "NCBITaxon_6690": "Penaeus aztecus",
    "FOODON_03541066": "10660 - peanuts (fresh seeds) (efsa foodex2)",
    "NCBITaxon_862507": "Mus <subgenus>",
    "NCBITaxon_29132": "Castoridae",
    "FOODON_03540839": "08390 - dill leaves (efsa foodex2)",
    "FOODON_03540259": "02590 - cream custard cake (efsa foodex2)",
    "FOODON_03543324": "33240 - isotonic and sport drinks (efsa foodex2)",
    "NCBITaxon_48038": "Foeniculum vulgare",
    "FOODON_03414501": "arctic ground squirrel",
    "FOODON_03414524": "edible-nest swiftlet",
    "FOODON_00003248": "panini",
    "FOODON_03302523": "butter-flavored candy",
    "FOODON_03000002": "zebrafish",
    "FOODON_03304603": "cheese (artificial)",
    "FOODON_03413068": "cochineal, carminic acid, carmines",
    "FOODON_03311008": "olallieberry (raw)",
    "FOODON_03530086": "controlled designation of origin (aoc)",
    "FOODON_03316854": "cheese colby low sodium",
    "FOODON_03541288": "12880 - saffron (efsa foodex2)",
    "FOODON_03315637": "wax bean (canned)",
    "FOODON_03401054": "10000574 - fats edible - animal (shelf stable) (gs1 gpc)",
    "FOODON_03413305": "thaumatin",
    "NCBITaxon_3311": "Ginkgo biloba",
    "CHEBI_67265": "beta-diketone",
    "FOODON_03310245": "tomato (freeze-dried)",
    "FOODON_03400117": "pasteurized cheese product (us cfr)",
    "FOODON_03541983": "19830 - grouse fresh meat (efsa foodex2)",
    "FOODON_03412019": "indian fig plant",
    "FOODON_03401813": "10006417 - white radish (daikon) (gs1 gpc)",
    "FOODON_03301844": "garlic powder",
    "FOODON_00002888": "yellow bean pod",
    "FOODON_03543580": "35800 - hibiscus infusion flowers and similar- (efsa foodex2)",
    "FOODON_00002911": "bratwurst",
    "FOODON_03541445": "14450 - lemons and similar- (efsa foodex2)",
    "FOODON_03413735": "tortoise shell bamboo plant",
    "FOODON_03510034": "reduced energy food claim or use",
    "FOODON_03304091": "orange wine (food product)",
    "FOODON_03303550": "petite suisse cheese",
    "FOODON_03310866": "alcoholic beverage (chinese)",
    "FOODON_03311407": "gouda cheese (smoked)",
    "NCBITaxon_1231846": "Eugenia brasiliensis",
    "FOODON_03414987": "salad burnet plant",
    "FOODON_03310297": "brick cheese",
    "FOODON_03542682": "26820 - cream with other ingredients (efsa foodex2)",
    "FOODON_03316155": "breakfast sausage (minimum cereal content of 6%)",
    "NCBITaxon_6707": "Homarus gammarus",
    "FOODON_03541204": "12040 - common cotton seeds (efsa foodex2)",
    "FOODON_03310977": "soft drink (non-cola, diet)",
    "FOODON_03311235": "skim milk (pasteurized, vitamin A and D fortified)",
    "IAO_0000412": "imported from",
    "NCBITaxon_1307796": "Chenopodioideae",
    "FOODON_03301949": "navy bean (whole, raw)",
    "FOODON_03309599": "chewing gum (artificially sweetened)",
    "FOODON_03412865": "greenland cod",
    "FOODON_00001129": "goat milk cheese food product",
    "FOODON_03317074": "beverage (fruit juice based, no added sugar)",
    "PATO_0001995": "organismal quality",
    "NCBITaxon_29019": "Penaeus stylirostris",
    "FOODON_03306946": "noodle (dried)",
    "FOODON_03301563": "pizza crust dough",
    "FOODON_03303166": "molasses cookie",
    "FOODON_00001007": "sausage food product",
    "BFO_0000019": "quality",
    "FOODON_03413554": "redfinger rubble crab",
    "FOODON_03400838": "non-chocolate confectionery or other sugar product (eurofir)",
    "FOODON_03401354": "50350300 - loose leaf/multileaf salad greens (gs1 gpc)",
    "FOODON_03542403": "24030 - european sardine (efsa foodex2)",
    "FOODON_03401216": "medium fat cheese (codex)",
    "CHEBI_114786": "sodium disulfite",
    "FOODON_03413601": "red-banded lobster",
    "FOODON_03412313": "john's snapper",
    "FOODON_03540087": "00870 - spelt flour, wholemeal (efsa foodex2)",
    "FOODON_03305133": "cream of potato soup",
    "FOODON_03308611": "crabmeat (cooked, frozen)",
    "FOODON_03309383": "fish fillet (breaded, frozen)",
    "FOODON_03414909": "sudangrass plant",
    "PO_0025498": "cardinal part of multi-tissue plant structure",
    "FOODON_03412048": "licorice plant",
    "FOODON_03412771": "sweet dattock plant",
    "FOODON_03540635": "06350 - beefsteak tomato (efsa foodex2)",
    "FOODON_03490194": "can, bottle or jar",
    "NCBITaxon_159736": "Macrobrachium nipponense",
    "FOODON_03315269": "jam and jelly, commercial, nonstandardized",
    "FOODON_03305358": "chicken giblet (raw)",
    "NCBITaxon_3781": "Crassulaceae",
    "FOODON_03460262": "obsolete: animal fat or oil added",
    "FOODON_03541843": "18430 - other fruit spreads (efsa foodex2)",
    "NCBITaxon_27705": "Micropterus",
    "FOODON_03400767": "071  by-products, used for animal feeding purposes, derived from fruit and vegetable processing (ab) (ccpr)",
    "FOODON_03303008": "chicken (canned)",
    "FOODON_03400355": "Codex Alimentarius food classification for food additives",
    "FOODON_03510033": "low energy food claim or use",
    "FOODON_03316126": "meat product (semi-preserved)",
    "FOODON_03303421": "bean (canned)",
    "NCBITaxon_57983": "Isurus oxyrinchus",
    "FOODON_03542522": "25220 - squillids (efsa foodex2)",
    "ENVO_00005749": "farm soil",
    "FOODON_00003350": "sweet onion (whole, raw)",
    "FOODON_03541024": "10240 - azuki beans (without pods) (efsa foodex2)",
    "FOODON_03401716": "10005974 - jackfruits (gs1 gpc)",
    "FOODON_03308493": "seafood salad",
    "FOODON_03306629": "honey crunch doughnut",
    "FOODON_03401603": "10006051 - tarragon (gs1 gpc)",
    "FOODON_03303438": "spaghetti sauce (italian-style)",
    "FOODON_03541894": "18940 - bovine msm (efsa foodex2)",
    "FOODON_00003211": "palm kernel oil (hydrogenated)",
    "FOODON_03412164": "caribbean spiny lobster",
    "FOODON_03307511": "saridele",
    "FOODON_03307813": "spring water",
    "NCBITaxon_8503": "Crocodylus novaeguineae",
    "FOODON_03541759": "17590 - cherimoyas (efsa foodex2)",
    "FOODON_03540568": "05680 - assai palm hearts (efsa foodex2)",
    "FOODON_03306686": "summer orange sections (canned)",
    "FOODON_03309501": "imitation prune butter",
    "FOODON_03306351": "grape flavoring (powdered)",
    "FOODON_03543500": "35000 - hawthorn infusion leaves (efsa foodex2)",
    "FOODON_03543988": "39880 - fish soup, dry (efsa foodex2)",
    "FOODON_03306973": "pizza (pepperoni)",
    "PATO_0045059": "normal thickness",
    "FOODON_03412046": "catnip plant",
    "NCBITaxon_3117": "Ulva prolifera",
    "FOODON_00003401": "excelsa coffee bean (whole)",
    "FOODON_03310727": "scallop (fried)",
    "FOODON_03411181": "yam, tropical (plant)",
    "FOODON_03510036": "very low salt or sodium claim or use",
    "FOODON_03306689": "orange (comminuted)",
    "FOODON_03311691": "tomato (sun-dried, in oil)",
    "FOODON_03310377": "guar meal (food product)",
    "FOODON_03315390": "ice confection, carbohydrate modified",
    "NCBITaxon_224703": "Alosa aestivalis",
    "HANCESTRO_0424": "Saint Vincentian",
    "FOODON_03311861": "fruit pot pie",
    "FOODON_03315032": "dairy product analog, dry base",
    "FOODON_00002474": "sheep milk (raw)",
    "FOODON_03401887": "10006161 - cherry tomatoes - oblong (gs1 gpc)",
    "FOODON_03543001": "30010 - molasses (efsa foodex2)",
    "FOODON_03520131": "former ussr area - inland waters (fao major fishing areas 07)",
    "NCBITaxon_2037": "Actinomycetales",
    "FOODON_03412221": "striped shore crab",
    "FOODON_03411136": "swine",
    "FOODON_03541001": "10010 - sugar canes (efsa foodex2)",
    "NCBITaxon_102107": "Prunus mume",
    "FOODON_03544276": "42760 - grape concord flavour (efsa foodex2)",
    "FOODON_03414240": "texas persimmon plant",
    "FOODON_03302645": "dog food",
    "NCBITaxon_43851": "Schinus molle",
    "FOODON_00002999": "Verhackert",
    "FOODON_03543455": "34550 - absinth infusion leaves (efsa foodex2)",
    "FOODON_00001081": "Bondon cheese food product",
    "FOODON_03401194": "10000577 - other sauces dipping/condiments/savoury toppings/savoury spreads/marinades (frozen) (gs1 gpc)",
    "NCBITaxon_641307": "Percinae",
    "FOODON_03311773": "foie gras (food product)",
    "NCBITaxon_71365": "Sisymbrium altissimum",
    "FOODON_03401383": "50260100 - root/tuber vegetables (gs1 gpc)",
    "NCBITaxon_8782": "Aves",
    "FOODON_03412802": "feretia plant",
    "FOODON_03411810": "bluefish family",
    "FOODON_00001772": "cow milk butter food product",
    "FOODON_00001262": "botanical fruit food product",
    "FOODON_03542313": "23130 - smelt (efsa foodex2)",
    "FOODON_03401229": "0220000 - bulb vegetables (ec)",
    "FOODON_03411468": "spanish lime plant",
    "FOODON_00001251": "avian food product",
    "FOODON_03401109": "10000177 - chips/crisps/snack mixes - natural/extruded (shelf stable) (gs1 gpc)",
    "FOODON_03414707": "sedge plant",
    "FOODON_03311040": "pastry (frozen)",
    "FOODON_03302356": "white bread (artificially sweetened)",
    "FOODON_03414700": "livistona plant",
    "FOODON_03302485": "breadstick",
    "GAZ_02000573": "Grenada",
    "NCBITaxon_4319": "Salacia <eudicots>",
    "FOODON_03542973": "29730 - hen egg mixed whole, dried (efsa foodex2)",
    "NCBITaxon_185738": "Molva dipterygia",
    "FOODON_03301701": "apricot (whole, raw)",
    "FOODON_03316551": "confectionery product (long-life, made from pectins)",
    "FOODON_03544042": "40420 - puffs/curls-type extruded snack (efsa foodex2)",
    "FOODON_03401290": "USDA SR cereal grains and pasta (2000)",
    "FOODON_03490228": "one component adhesive, water soluble",
    "NCBITaxon_22978": "Chrysobalanus icaco",
    "FOODON_03317240": "obsolete: fruit yoghurt",
    "FOODON_03543591": "35910 - clary sage infusion flowers (efsa foodex2)",
    "FOODON_03301458": "tomato (canned with tomato juice)",
    "FOODON_03470117": "heat drying process",
    "FOODON_00001762": "cookie food product",
    "FOODON_03411332": "arctic char",
    "FOODON_03542759": "27590 - soft - ripened cheese (efsa foodex2)",
    "FOODON_03303578": "mozzarella cheese",
    "FOODON_03400220": "pasta dish (us cfr)",
    "FOODON_03400639": "CCFAC beverages, excluding dairy products",
    "FOODON_03413693": "flying squid",
    "CHEBI_22888": "biphenyls",
    "FOODON_00002909": "yellow hito",
    "FOODON_03311725": "oat bran oil",
    "FOODON_03315176": "obsolete: sucrose foodon",
    "FOODON_03316989": "octopus food product",
    "FOODON_03413476": "sneep",
    "FOODON_03310286": "jowar",
    "FOODON_03412760": "aframomum plant",
    "FOODON_00002961": "chia seed (whole)",
    "GAZ_00001107": "Zambia",
    "GAZ_00002801": "North Korea",
    "GAZ_00007111": "Wake Island",
    "FOODON_00002096": "peach preserve or jam",
    "FOODON_03301854": "distilled vinegar",
    "FOODON_03307668": "tortilla",
    "FOODON_03413639": "frilled venus",
    "FOODON_03401321": "dietary supplement, multi-vitamin/mineral and amino acids",
    "FOODON_03311381": "beef with gravy",
    "FOODON_03540878": "08780 - basil (efsa foodex2)",
    "FOODON_03401532": "10005826 - dairy based products / meals - not ready to eat/drink (perishable) (gs1 gpc)",
    "FOODON_03302037": "beverage tablet",
    "FOODON_03411811": "greenling family",
    "GAZ_00002591": "State of Connecticut",
    "FOODON_03400408": "filler (codex)",
    "FOODON_03400972": "10000286 - cereal products - ready to eat (perishable) (gs1 gpc)",
    "NCBITaxon_114952": "Teredinidae",
    "NCBITaxon_360502": "Plectorhinchus pictus",
    "FOODON_03542601": "26010 - insects and arachnids (including species only consumed outside eu) (efsa foodex2)",
    "FOODON_03306448": "infant food product",
    "FOODON_03412658": "goatfish family",
    "FOODON_03541023": "10230 - beans (fresh seeds without pods) and similar- (efsa foodex2)",
    "FOODON_03305228": "cherry (sweetened with glucose and sucrose, frozen)",
    "NCBITaxon_151250": "Kali turgidum",
    "FOODON_03316935": "fish paste (salted)",
    "FOODON_00002072": "orange preserve or jam food product",
    "FOODON_03412759": "baobab plant",
    "FOODON_03490418": "polyolefine container",
    "FOODON_00001628": "banana food product",
    "FOODON_03411959": "atlantic surfclam",
    "FOODON_03317587": "beverage (cloudy, nonalcoholic, flavored)",
    "FOODON_03304029": "french onion-flavored dip",
    "FOODON_03315628": "skim milk (pasteurized, flavored)",
    "CHEBI_26650": "serine family amino acid",
    "FOODON_03401497": "10006438 - indian limes (gs1 gpc)",
    "FOODON_03304760": "peanut (whole, skin off, lightly salted)",
    "GAZ_00000907": "Gambia",
    "FOODON_03544373": "43730 - soup flavour (efsa foodex2)",
    "FOODON_03315342": "cake (sponge)",
    "NCBITaxon_76072": "Exocoetidae",
    "NCBITaxon_116704": "Eubrachyura",
    "NCBITaxon_499535": "Cynoscion striatus",
    "FOODON_00001653": "blackberry group food product",
    "FOODON_03540039": "00390 - rice grain, brown (efsa foodex2)",
    "FOODON_03309589": "teething biscuit",
    "FOODON_03543014": "30140 - honey, blended (efsa foodex2)",
    "FOODON_03414090": "brown ray",
    "FOODON_03543675": "36750 - dwarf mountain pine (infusion shoots) (efsa foodex2)",
    "FOODON_03542763": "27630 - cheese, limburger (efsa foodex2)",
    "FOODON_03543319": "33190 - diet soft drink with caffeine (efsa foodex2)",
    "FOODON_03308712": "bonito tuna (canned)",
    "FOODON_03411433": "shellfish",
    "FOODON_00002717": "fly",
    "FOODON_00001733": "chocolate candy food product",
    "FOODON_03414640": "mud whelk",
    "FOODON_03500050": "food contact surface from natural material",
    "FOODON_03540962": "09620 - new potatoes (efsa foodex2)",
    "FOODON_03543223": "32230 - juice, multi-fruit-carrot (efsa foodex2)",
    "FOODON_03541626": "16260 - che berries (efsa foodex2)",
    "FOODON_03412136": "dogfish shark, carnivorous",
    "FOODON_03414335": "yellow gentian plant",
    "FOODON_03304631": "rhubarb (canned)",
    "FOODON_03543632": "36320 - valerian infusion roots (efsa foodex2)",
    "FOODON_03301867": "saffron (ground)",
    "RO_0000057": "has participant",
    "FOODON_00002239": "shrimp food product",
    "FOODON_03400182": "milk analog (us cfr)",
    "FOODON_03490214": "bottle",
    "FOODON_03317427": "vegetable glace",
    "FOODON_03302511": "gelatin (artificially sweetened)",
    "NCBITaxon_31469": "Gracilariaceae",
    "FOODON_03543887": "38870 - potatoes and cheese meal (efsa foodex2)",
    "FOODON_03315883": "poultry meat",
    "FOODON_00003004": "animal",
    "FOODON_03303905": "nondairy creamer",
    "FOODON_03308585": "red king crab (raw)",
    "NCBITaxon_742011": "Centaureinae",
    "NCBITaxon_643729": "Procambarus alleni",
    "FOODON_03307699": "fruit salad dressing",
    "FOODON_03310562": "sardo cheese",
    "NCBITaxon_4231": "Helianthus",
    "FOODON_03541125": "11250 - canarium nuts (harveyi) (efsa foodex2)",
    "CHEBI_83631": "octyl gallate",
    "FOODON_03415112": "french grey shallot plant",
    "NCBITaxon_200993": "Fumaria officinalis",
    "FOODON_03413606": "green rock lobster",
    "FOODON_03305723": "oatcake cookie",
    "FOODON_03544236": "42360 - chocolate flavour (efsa foodex2)",
    "FOODON_03301395": "beet (pickled, canned)",
    "FOODON_03308116": "sardine in mustard sauce",
    "FOODON_03413881": "black sea whiting",
    "FOODON_03544353": "43530 - pork flavour (efsa foodex2)",
    "FOODON_03411683": "dolly varden",
    "FOODON_03317173": "shellfish (cooked)",
    "FOODON_03540509": "05090 - roman rocket sprouts (efsa foodex2)",
    "NCBITaxon_41944": "Myrtales",
    "NCBITaxon_121164": "Pelophylax",
    "NCBITaxon_8220": "Gobiidae",
    "FOODON_03470149": "preservation by adding acid",
    "FOODON_03311363": "fish meat (mechanically deboned)",
    "FOODON_03401264": "1070000 - other terrestrial animal products (ec)",
    "FOODON_03311332": "king crabmeat (glazed, frozen)",
    "FOODON_03413964": "indian scad",
    "FOODON_03304471": "white rice (beef-flavored)",
    "FOODON_03543779": "37790 - processed cereal-based food for infants and young children (efsa foodex2)",
    "FOODON_03400286": "gravy or sauce (us cfr)",
    "FOODON_03542416": "24160 - bonito, eastern pacific (efsa foodex2)",
    "FOODON_03414422": "sodium citrates",
    "NCBITaxon_99038": "Glebionis coronaria",
    "FOODON_03309877": "sweet clover (food product)",
    "FOODON_03412705": "gudgeon",
    "FOODON_03415016": "common polypody plant",
    "FOODON_03540375": "03750 - puntarelle (efsa foodex2)",
    "NCBITaxon_34587": "Katharina tunicata",
    "HANCESTRO_0496": "Malaysian",
    "NCBITaxon_50173": "Ximenia",
    "FOODON_03411779": "obsolete: california yellowtail",
    "NCBITaxon_40500": "Lutjanus vivanus",
    "CHEBI_33234": "vitamin E",
    "FOODON_03310799": "clam sauce (food product)",
    "FOODON_03540546": "05460 - florence fennels and similar- (efsa foodex2)",
    "NCBITaxon_6755": "Cancer pagurus",
    "FOODON_03317540": "beverage containing glucose syrup (nonalcoholic, flavored)",
    "NCBITaxon_198232": "Palinurus elephas",
    "FOODON_03542010": "20100 - animal liver (efsa foodex2)",
    "CHEBI_37176": "mononuclear parent hydride",
    "FOODON_03309605": "vegetable au gratin",
    "FOODON_00002044": "mollusc food product",
    "FOODON_03540247": "02470 - wafers (efsa foodex2)",
    "FOODON_03308316": "shad (canned)",
    "FOODON_03413589": "northwest lobster",
    "FOODON_03305381": "bread (stale)",
    "FOODON_03530143": "faux-filet",
    "NCBITaxon_3904": "Vicia",
    "FOODON_03413686": "mekong giant catfish",
    "FOODON_00001035": "new zealand cheddar cheese food product",
    "NCBITaxon_9863": "Cervus nippon",
    "FOODON_03543629": "36290 - other herbal infusion materials from flowers (efsa foodex2)",
    "CHEBI_39087": "sulfurous acid derivative",
    "FOODON_03307427": "grapefruit drink (diluted)",
    "FOODON_00002294": "sunflower food product",
    "FOODON_03307480": "milk (powdered, soft curd)",
    "FOODON_03400397": "density adjusting agent (codex)",
    "FOODON_03412754": "sand tiger family",
    "FOODON_03530067": "grade u, europe",
    "FOODON_03414559": "fish, osteoglossiform",
    "FOODON_00003223": "nutmeg butter",
    "FOODON_03307125": "potato (stuffed, frozen)",
    "GAZ_00002637": "United Kingdom",
    "FOODON_03316065": "tea extract",
    "FOODON_03315477": "koji pickle",
    "FOODON_03305722": "brown sugar cookie",
    "FOODON_00002442": "flounder food product",
    "FOODON_03316822": "macaroni (whole wheat)",
    "FOODON_03317453": "maraschino (food product)",
    "FOODON_03304627": "imitation eggnog mix (dry)",
    "FOODON_03302063": "lima bean (whole, dried)",
    "FOODON_03542468": "24680 - cod liver (efsa foodex2)",
    "FOODON_03541327": "13270 - saigon cinnamon buds (efsa foodex2)",
    "CHEBI_55505": "1,2-benzisothiazole",
    "FOODON_03490427": "stopper",
    "FOODON_03544174": "41740 - polydextrose (efsa foodex2)",
    "FOODON_00002506": "smetana",
    "FOODON_03301922": "apple cookie",
    "FOODON_03307066": "cornish cross chicken (raw)",
    "FOODON_03413297": "sunset yellow fcf/orange yellow s",
    "FOODON_03540727": "07270 - parsley roots (efsa foodex2)",
    "FOODON_03306050": "black walnut (whole and pieces, raw)",
    "FOODON_03302641": "butter taffy",
    "FOODON_03541905": "19050 - duck msm (efsa foodex2)",
    "FOODON_03414896": "mantis shrimp family",
    "FOODON_00002676": "cod liver food product",
    "FOODON_03304350": "scallop (cured, smoked)",
    "FOODON_03541059": "10590 - white lupin (without pods) (efsa foodex2)",
    "FOODON_03306361": "mustard (dijon)",
    "FOODON_03303831": "imitation acidified buttermilk",
    "FOODON_03307322": "haddock fillet (raw)",
    "FOODON_03317472": "crangon vulgaris (cooked)",
    "FOODON_03305763": "grape juice (reconstituted)",
    "NCBITaxon_3917": "Vigna unguiculata",
    "FOODON_03411699": "ucuhuba plant",
    "NCBITaxon_105181": "Elettaria cardamomum",
    "FOODON_03307039": "potato chip (toasted onion-flavored)",
    "FOODON_03400642": "eurocode 2 food classification",
    "NCBITaxon_4564": "Triticum",
    "FOODON_00003166": "deerberry food product",
    "NCBITaxon_8064": "Batrachoidiformes",
    "NCBITaxon_4613": "Bromeliaceae",
    "FOODON_03302566": "pemmican (meatless)",
    "FOODON_03310425": "binagol (dish)",
    "FOODON_03530217": "tenderloin",
    "FOODON_03302995": "camembert cheese",
    "FOODON_03411277": "dill plant",
    "FOODON_03315239": "oil or shortening, edible",
    "FOODON_00001291": "clam food product",
    "FOODON_03414123": "bramble shark",
    "FOODON_00001580": "alcoholic beverage analog",
    "FOODON_03412584": "sharptail mola",
    "FOODON_03541237": "12370 - other minor oilseeds (efsa foodex2)",
    "FOODON_03307034": "Irish potato (whole, raw)",
    "FOODON_03541349": "13490 - liquorice roots and similar- (efsa foodex2)",
    "FOODON_03309818": "coconut (dried, grated, smoked)",
    "FOODON_03414507": "blue corn plant",
    "NCBITaxon_8023": "Oncorhynchus nerka",
    "FOODON_03315859": "molasses (table)",
    "FOODON_03302345": "wheat bread mix (dry)",
    "NCBITaxon_551290": "Teuthida",
    "NCBITaxon_48144": "Meganyctiphanes norvegica",
    "FOODON_03302031": "cheese pizza (cooked)",
    "FOODON_03540430": "04300 - black eyed peas leaves (efsa foodex2)",
    "FOODON_03401163": "10000139 - aquatic plants unprepared/unprocessed (shelf stable) (gs1 gpc)",
    "FOODON_03317429": "hard cheese (sliced)",
    "PATO_0001827": "pseudohermaphrodite",
    "FOODON_03540694": "06940 - melons (efsa foodex2)",
    "FOODON_03301432": "beef bouillon cube",
    "GAZ_00000013": "continent",
    "NCBITaxon_387470": "Strombus pugilis",
    "FOODON_03543606": "36060 - meadow sweet infusion flowers (efsa foodex2)",
    "FOODON_03315679": "cream cheese with added ingredients",
    "FOODON_00002752": "bean (whole, dried)",
    "FOODON_03412155": "brazilian catfish",
    "NCBITaxon_30455": "Fulmarus glacialis",
    "FOODON_03400135": "bakery product, sweetened (us cfr)",
    "NCBITaxon_6756": "Cancer irroratus",
    "FOODON_03303031": "chicken (whole, barbequed, frozen)",
    "FOODON_03316653": "meat (sterilized, pickled, canned)",
    "FOODON_03401694": "10005838 - veal sausages - prepared/processed (gs1 gpc)",
    "NCBITaxon_6610": "Sepia officinalis",
    "FOODON_03400733": "10  sugar, chocolate and related products (eurocode2)",
    "FOODON_03317654": "oyster sauce",
    "NCBITaxon_182234": "Salangidae",
    "FOODON_03413446": "topee tambu plant",
    "FOODON_03412165": "ornate spiny lobster",
    "FOODON_00002423": "agave food product",
    "FOODON_03301754": "wild rice food product",
    "FOODON_03520509": "obsolete: continents, regions and countries",
    "UBERON_0003101": "male organism",
    "FOODON_03311285": "red bean paste",
    "FOODON_03400949": "10000249 - pies/pastries/pizzas/quiches - savoury (perishable) (gs1 gpc)",
    "UBERON_0000160": "intestine",
    "FOODON_03543901": "39010 - tofu salad (efsa foodex2)",
    "FOODON_03301240": "cherry (whole, raw)",
    "FOODON_03306520": "nut (whole, raw, shell off)",
    "FOODON_03303130": "infant formula",
    "FOODON_03310076": "cassia spice",
    "FOODON_03311186": "shellfish (fried)",
    "FOODON_03411914": "angel shark family",
    "FOODON_00002273": "squid food product",
    "PATO_0000599": "decreased width",
    "FOODON_03413430": "sweet cicely plant",
    "GAZ_00000457": "Africa",
    "FOODON_03412148": "golden snapper",
    "FOODON_03542735": "27350 - mozzarella (efsa foodex2)",
    "NCBITaxon_224708": "Brevoortia tyrannus",
    "FOODON_03540310": "03100 - cereal rolled grains (efsa foodex2)",
    "FOODON_03301067": "candied citron melon",
    "FOODON_03544323": "43230 - mixed berry flavour (efsa foodex2)",
    "NCBITaxon_320565": "Ponticola kessleri",
    "PATO_0001714": "increased diameter",
    "FOODON_03412915": "pale toadfish",
    "FOODON_03541083": "10830 - monantha vetches (dry) (efsa foodex2)",
    "FOODON_03302352": "honey crust bread",
    "ECOCORE_00000011": "heterotrophy",
    "FOODON_00002863": "Blaufr\u00e4nkisch grape plant",
    "FOODON_03305346": "wheat and soy bread",
    "FOODON_03541133": "11330 - chestnuts (efsa foodex2)",
    "FOODON_03490199": "envelope",
    "NCBITaxon_8226": "Katsuwonus pelamis",
    "FOODON_00001735": "chub mackerel food product",
    "NCBITaxon_54375": "Otididae",
    "FOODON_03412713": "ide",
    "FOODON_03316090": "sport drink",
    "FOODON_00001244": "coffee beverage",
    "FOODON_03315323": "gelatin dessert mix",
    "FOODON_03544184": "41840 - amaretto flavour (efsa foodex2)",
    "FOODON_03530014": "utility grade",
    "FOODON_03307094": "Christmas pudding",
    "FOODON_00002606": "Sauvignon blanc grape plant",
    "FOODON_03305605": "herbal alcoholic beverage",
    "FOODON_03306922": "pimiento (whole, canned)",
    "FOODON_03316312": "cherry preserved in airtight containers",
    "FOODON_03490132": "glass container, aluminum lid",
    "FOODON_03412604": "lunar fusilier",
    "FOODON_03316306": "fat product, mixed",
    "FOODON_03542929": "29290 - processed cheese and spreads (efsa foodex2)",
    "FOODON_03543024": "30240 - isomalt (efsa foodex2)",
    "FOODON_03413887": "offshore silver hake",
    "FOODON_03308024": "haddock (raw)",
    "FOODON_03303693": "cheese (2% milk)",
    "FOODON_03315130": "orange spread (artificially flavored)",
    "FOODON_03414334": "greater plantain plant",
    "FOODON_03304173": "griddle cake",
    "FOODON_03540788": "07880 - other cultivated mushrooms (p) (efsa foodex2)",
    "FOODON_03415136": "johnny-jump-up plant",
    "FOODON_00001180": "prepared food product",
    "FOODON_03315983": "marmalade (energy-reduced)",
    "NCBITaxon_160727": "Epinephelus striatus",
    "FOODON_03541372": "13720 - sichuan pepper fruit (efsa foodex2)",
    "FOODON_03304679": "squaw tea (dry)",
    "FOODON_03412478": "fish, gasterosteiform",
    "FOODON_03540037": "00370 - rice and similar- (efsa foodex2)",
    "FOODON_03304397": "nonfat dry milk (calcium-reduced)",
    "FOODON_03530092": "sausage casing",
    "NCBITaxon_4547": "Saccharum officinarum",
    "FOODON_00003222": "cupua\u00e7u oil",
    "NCBITaxon_116961": "Ursus arctos middendorffi",
    "NCBITaxon_270602": "Osphronemidae",
    "FOODON_03316401": "vegetable in vinegar",
    "FOODON_03315272": "pastry",
    "FOODON_03530238": "hazard 10",
    "FOODON_00002005": "liqueur food product",
    "FOODON_03306704": "noodle (french-fried)",
    "FOODON_03414679": "eucalypt eugenia plant",
    "FOODON_03310878": "bavarian cream",
    "FOODON_03530100": "solid containing medium or large chunks (>8 mm.)",
    "FOODON_03414276": "timor deer",
    "FOODON_00002862": "Fuji apple",
    "NCBITaxon_51240": "Juglans regia",
    "FOODON_03413211": "potassium hydrogen sulphite",
    "FOODON_03401087": "10000298 - dough based products / meals - ready to eat - savoury (perishable) (gs1 gpc)",
    "FOODON_03301203": "oregano (crushed)",
    "NCBITaxon_175226": "Ribes glandulosum",
    "FOODON_03413010": "beeswax, white and yellow",
    "FOODON_03411043": "mackerel",
    "FOODON_03411412": "paddlefish",
    "NCBITaxon_3656": "Cucumis melo",
    "FOODON_03543389": "33890 - unsweetened flavoured spirits (efsa foodex2)",
    "FOODON_03542107": "21070 - processed whole meat products (efsa foodex2)",
    "FOODON_03305516": "hors d'oeuvre",
    "FOODON_03414221": "true muskmelon plant",
    "FOODON_03490322": "cellulose film",
    "FOODON_03401108": "50192100 - snacks (gs1 gpc)",
    "FOODON_00003391": "aquaculture production",
    "FOODON_03542163": "21630 - linguica, sausage (efsa foodex2)",
    "FOODON_03303834": "imitation butter flavor",
    "FOODON_03302019": "cheese spread",
    "FOODON_03541300": "13000 - coriander seeds and similar- (efsa foodex2)",
    "FOODON_03310436": "milk chocolate candy (hollow)",
    "CHEBI_24978": "ketose",
    "FOODON_03415083": "white deadnettle plant",
    "FOODON_03541732": "17320 - avocados and similar- (efsa foodex2)",
    "FOODON_03400735": "12  miscellaneous foods (eurocode2)",
    "FOODON_03411012": "sugar-producing plant",
    "FOODON_03301713": "broccoli floret (whole, raw)",
    "FOODON_03400297": "wine or wine-like product, .5-24% alcohol (us cfr)",
    "FOODON_03480040": "packed in vinegar and oil",
    "FOODON_03411000": "obsolete: cattle and swine and calf",
    "FOODON_03412845": "wood apple plant",
    "FOODON_03412398": "ciruela plant",
    "FOODON_03412330": "dolichos plant",
    "FOODON_03413161": "monopotassium glutamate",
    "FOODON_00003090": "ginkgo nut (whole, raw)",
    "FOODON_03413411": "chinese box thorn plant",
    "FOODON_03306131": "berry cocktail drink",
    "FOODON_03315909": "pineapple juice (reconstituted)",
    "NCBITaxon_40029": "Rhizophoraceae",
    "NCBITaxon_1490021": "Cottales",
    "FOODON_03310346": "mafurra press cake (food product)",
    "FOODON_03543948": "39480 - finger food (efsa foodex2)",
    "FOODON_03311421": "milo maize oil",
    "FOODON_03401423": "10005982 - lima beans (gs1 gpc)",
    "FOODON_03411344": "pear plant",
    "FOODON_03543283": "32830 - fruit soft drink, currant white (efsa foodex2)",
    "FOODON_03543475": "34750 - clubmoss infusion leaves (efsa foodex2)",
    "FOODON_03311469": "vegetable protein (textured)",
    "FOODON_03520125": "africa - inland waters (fao major fishing areas 01)",
    "FOODON_03305988": "yongona drink",
    "FOODON_03542530": "25300 - oyster, european (efsa foodex2)",
    "NCBITaxon_8014": "Osmerus mordax",
    "FOODON_03401821": "10006317 - mayonnaise/mayonnaise substitutes (frozen) (gs1 gpc)",
    "NCBITaxon_41697": "Sardinops melanostictus",
    "FOODON_03530278": "color of fruit or vegetable skin",
    "IAO_0000111": "editor preferred label",
    "FOODON_00003233": "beef bourguignon",
    "FOODON_03542219": "22190 - carps (efsa foodex2)",
    "NCBITaxon_70846": "Uranoscopidae",
    "NCBITaxon_50174": "Ximenia americana",
    "FOODON_03543066": "30660 - loukoumi (efsa foodex2)",
    "CHEBI_62732": "aromatic ester",
    "FOODON_03541474": "14740 - crab apples (efsa foodex2)",
    "FOODON_03414237": "brazil cherry plant",
    "FOODON_03307744": "taco",
    "FOODON_03411688": "oheloberry plant",
    "FOODON_00001221": "sausage (raw, smoked)",
    "FOODON_03543451": "34510 - herbal infusion materials from leaves and herbs (efsa foodex2)",
    "FOODON_03412411": "dulse",
    "FOODON_03412233": "blue shrimp",
    "FOODON_03411640": "whiting",
    "CHEBI_33822": "organic hydroxy compound",
    "PO_0000003": "whole plant",
    "FOODON_03411211": "citron plant",
    "FOODON_03307044": "potato flakes (mashed potato, instant)",
    "FOODON_03541778": "17780 - breadfruits and similar- (efsa foodex2)",
    "FOODON_03510026": "human as food consumer",
    "FOODON_03542664": "26640 - water buffalo milk (efsa foodex2)",
    "FOODON_03305546": "herb and honey concentrate for making tea",
    "FOODON_03310030": "squash curry",
    "FOODON_03301906": "sandwich",
    "NCBITaxon_112001": "Zea mays subsp. huehuetenangensis",
    "FOODON_03315697": "white asparagus (canned)",
    "FOODON_03305721": "petits beurres",
    "FOODON_03413717": "sea beet plant",
    "FOODON_03302448": "butter (artificially colored)",
    "FOODON_03304134": "dog food (beef-flavored)",
    "GAZ_00004017": "Malta",
    "FOODON_03540012": "00120 - red amaranth grains (efsa foodex2)",
    "FOODON_03413808": "fish, esociform",
    "FOODON_03310288": "ugali",
    "FOODON_00002795": "red Abyssinian banana (whole, raw)",
    "FOODON_03460306": "food homogenization or emulsification process",
    "NCBITaxon_7946": "Muraenesox cinereus",
    "FOODON_03541590": "15900 - serviceberries (efsa foodex2)",
    "FOODON_03310805": "apple peel (raw)",
    "FOODON_03413160": "monopotassium citrate",
    "FOODON_03307130": "ginger ale",
    "NCBITaxon_89948": "Merluccius gayi",
    "FOODON_03415105": "red amaranth plant",
    "FOODON_03307091": "prune pastry filling",
    "CHEBI_83812": "non-proteinogenic amino acid derivative",
    "FOODON_03543718": "37180 - barley coffee infusion (efsa foodex2)",
    "UBERON_3010042": "protogynous hermaphroditic organism",
    "FOODON_03315134": "chickpea (cooked, canned)",
    "FOODON_03306254": "margarine (whipped)",
    "FOODON_00002113": "perch food product",
    "NCBITaxon_341683": "Spondias purpurea",
    "FOODON_03401452": "10006341 - black mustard (gs1 gpc)",
    "FOODON_03411737": "tumble mustard plant",
    "FOODON_03413805": "siamese crocodile",
    "FOODON_03412484": "saury",
    "FOODON_03306195": "soda water concentrate",
    "FOODON_00002285": "yokan",
    "CHEBI_38697": "anthocyanin",
    "NCBITaxon_513163": "Xanthosoma brasiliense",
    "FOODON_03301298": "jordan almond",
    "NCBITaxon_443747": "Aldrichetta",
    "FOODON_00002508": "navel orange plant",
    "NCBITaxon_9498": "Cebidae",
    "FOODON_03541842": "18420 - fruit compote, mixed fruit (efsa foodex2)",
    "FOODON_03310354": "oilseed press cake",
    "FOODON_03302661": "pepper-type carbonated beverage (decaffeinated)",
    "FOODON_03309907": "field corn kernel (dried)",
    "FOODON_03541489": "14890 - other pome fruits (efsa foodex2)",
    "NCBITaxon_349651": "Brama brama",
    "FOODON_03303221": "fruit gelatin dessert",
    "FOODON_03542778": "27780 - cheese, saga (efsa foodex2)",
    "FOODON_03302988": "cold-pack cheese spread",
    "FOODON_03305742": "citrus juice",
    "GAZ_00002936": "Guatemala",
    "NCBITaxon_4577": "Zea mays",
    "FOODON_03307625": "orange juice concentrate (frozen, acid-reduced)",
    "FOODON_00001325": "pla-jaw",
    "FOODON_03414295": "horned puffin",
    "NCBITaxon_180763": "Vaccinium myrtillus",
    "NCBITaxon_83881": "Apogonidae",
    "FOODON_03411090": "saurel",
    "FOODON_03400860": "chutney or pickle (eurofir)",
    "FOODON_03413935": "bighead goby",
    "FOODON_03306491": "mushroom paste",
    "NCBITaxon_39304": "Erignathus barbatus",
    "FOODON_03317040": "mammalian milk (nonfat)",
    "NCBITaxon_173344": "Oligoplites saurus",
    "FOODON_03400356": "European Union agency food product type",
    "NCBITaxon_6683": "Decapoda",
    "FOODON_03411831": "cichlid family",
    "CHEBI_33676": "d-block molecular entity",
    "FOODON_03544434": "44340 - acidity regulator (efsa foodex2)",
    "FOODON_03541716": "17160 - wingedstem passionflower fruits (efsa foodex2)",
    "FOODON_03301407": "quail egg (whole, pickled)",
    "FOODON_03414512": "new zealand lemon sole",
    "FOODON_00001874": "food supplement food product",
    "NCBITaxon_40248": "Chamaeleonidae",
    "FOODON_03541560": "15600 - nectar raspberries (efsa foodex2)",
    "NCBITaxon_72025": "Fabales",
    "FOODON_03316940": "cheese granular curd",
    "FOODON_03401170": "10000049 - herbs/spices (shelf stable) (gs1 gpc)",
    "FOODON_03401210": "mould ripened (codex)",
    "FOODON_03530252": "external fat trimmed to 1/8 inch",
    "FOODON_03542301": "23010 - chum salmon (efsa foodex2)",
    "NCBITaxon_50593": "Pagellus erythrinus",
    "FOODON_03541356": "13560 - galanga roots (efsa foodex2)",
    "FOODON_03311571": "dosa",
    "FOODON_03414351": "candlenut plant",
    "FOODON_00003236": "carbonara sauce",
    "FOODON_03315027": "sweetener (nonnutritive)",
    "FOODON_03304856": "japanese black tea (dry)",
    "FOODON_03304293": "spanish thyme leaf (dried)",
    "FOODON_00003317": "graham flour",
    "FOODON_03400678": "013  leafy vegetables (including brassica leafy vegetables) (vl) (ccpr)",
    "FOODON_03316967": "obsolete: ice milk goat milk",
    "UBERON_0019252": "8-cell stage embryo",
    "FOODON_03302158": "imitation grape carbonated beverage",
    "CHEBI_33402": "sulfur oxoacid",
    "FOODON_03415070": "damiana plant",
    "FOODON_03540982": "09820 - mexican yam beans (efsa foodex2)",
    "FOODON_03414606": "toothed wrack",
    "FOODON_03309197": "european turbot (raw)",
    "FOODON_03401016": "50240100 - meat/poultry/other animals - prepared/processed (gs1 gpc)",
    "FOODON_03542224": "22240 - carp, grass (efsa foodex2)",
    "NCBITaxon_68454": "Scyliorhinus stellaris",
    "FOODON_03400406": "enzyme preparation (codex)",
    "FOODON_03541718": "17180 - prickly pears (efsa foodex2)",
    "FOODON_03413900": "silverfish",
    "FOODON_03305140": "wheat (fermented)",
    "FOODON_03304791": "scrambled hen egg",
    "FOODON_03400108": "pastry shell, unsweetened (us cfr)",
    "FOODON_03544228": "42280 - cereals flavour (efsa foodex2)",
    "FOODON_03520489": "tropical climatic zone",
    "FOODON_03412361": "reishi mushroom",
    "NCBITaxon_7781": "Raja clavata",
    "CHEBI_22743": "benzyl alcohols",
    "FOODON_03301199": "horseradish root (whole, raw)",
    "FOODON_03310332": "cod bits (boneless, raw)",
    "FOODON_03541698": "16980 - davidsons plum (efsa foodex2)",
    "FOODON_03305730": "cheese and parsley spread",
    "FOODON_03401803": "10006366 - okra (chinese) (gs1 gpc)",
    "FOODON_03544043": "40430 - corn curls (efsa foodex2)",
    "FOODON_03543800": "38000 - micronutrients supplement for sports people (efsa foodex2)",
    "FOODON_03510170": "lactose reduced food",
    "FOODON_03411435": "juneberry plant",
    "FOODON_03309404": "white grape juice",
    "FOODON_03316349": "olive (preserved)",
    "FOODON_03414371": "red deer",
    "GAZ_00001087": "Rwanda",
    "FOODON_03412255": "black or white pepper plant",
    "FOODON_03401411": "10006167 - finger avocados (gs1 gpc)",
    "FOODON_03307493": "imitation lowfat milk (fortified)",
    "FOODON_03307205": "turkey croquette",
    "FOODON_03309546": "cow milk (lactose-reduced)",
    "FOODON_03311360": "cheddar cheese (reduced fat)",
    "FOODON_03307333": "cocktail sauce",
    "FOODON_03543928": "39280 - sandwich with cheese topping/filling (efsa foodex2)",
    "FOODON_03316938": "obsolete: tea leaf (decaffeinated)",
    "FOODON_03401892": "10006166 - tomatoes variety packs (gs1 gpc)",
    "FOODON_03490367": "polyethylene container",
    "FOODON_03304356": "strawberry (frozen)",
    "CHEBI_26561": "ribonucleotide",
    "FOODON_03307865": "tea (spent)",
    "FOODON_00002332": "obsolete: vegetable juice",
    "CHEBI_78298": "environmental contaminant",
    "PATO_0002042": "decreased anterior-posterior diameter",
    "FOODON_03317496": "breakfast cereal (granola-type)",
    "FOODON_03316654": "meat (tinned, pasteurized, pickled)",
    "FOODON_00002145": "plant product based flavoring or seasoning",
    "NCBITaxon_316133": "Seriolella",
    "FOODON_03401660": "10006284 - elk/wapiti - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03308813": "seafood cocktail",
    "UBERON_0018387": "cestode",
    "FOODON_03307070": "obsolete: rock cornish game hen (stuffed with wild rice and mushrooms)",
    "FOODON_03309161": "burbot (raw)",
    "FOODON_03450013": "cooking in water or water-based liquid",
    "FOODON_03412476": "sea lettuce",
    "FOODON_03414206": "blackberry plant",
    "FOODON_03541115": "11150 - tepary bean (dry seeds) (efsa foodex2)",
    "FOODON_03400650": "02  vegetables (ccpr)",
    "FOODON_03311427": "potato (precooked)",
    "FOODON_03303114": "coffee (decaffeinated, freeze-dried, instant)",
    "FOODON_03541462": "14620 - satsumas (efsa foodex2)",
    "FOODON_03541111": "11110 - black gram (dry seeds) (efsa foodex2)",
    "FOODON_03401051": "50150000 - oils/fats edible (gs1 gpc)",
    "FOODON_03544399": "43990 - tropical flavour (efsa foodex2)",
    "FOODON_03414231": "mexican avocado plant",
    "FOODON_00001326": "pla-som",
    "FOODON_03306133": "cloudberry preserve",
    "CHEBI_27786": "hydroxocobalamin",
    "FOODON_00003241": "tajine",
    "FOODON_03315339": "whale meat (frozen)",
    "FOODON_03308167": "pearl oyster (raw)",
    "NCBITaxon_8018": "Oncorhynchus keta",
    "FOODON_03543279": "32790 - soft drinks with minor amounts of fruits or flavours (efsa foodex2)",
    "NCBITaxon_70446": "Rastrelliger kanagurta",
    "FOODON_03304212": "chicken soup base and seasoning with chicken meat",
    "FOODON_03309927": "tomato (whole, raw)",
    "FOODON_03510158": "rabbit as consumer",
    "NCBITaxon_321602": "Rubus sorbifolius",
    "FOODON_00003267": "flavouring additive",
    "FOODON_00001775": "cow milk cream food product",
    "FOODON_03542149": "21490 - chipolata-type sausage (efsa foodex2)",
    "FOODON_03510178": "\"fresh frozen\" label claim",
    "FOODON_03308399": "eel in savoury jelly",
    "FOODON_03414125": "guitarfish family",
    "FOODON_03317584": "sauce (fruit-based, canned)",
    "NCBITaxon_107241": "Beryx decadactylus",
    "FOODON_03543955": "39550 - spring rolls (efsa foodex2)",
    "NCBITaxon_46146": "Claytonia perfoliata",
    "FOODON_03401583": "10006055 - garden cress (gs1 gpc)",
    "FOODON_03401617": "10005783 - alternative meat/poultry/other animals species - prepared/processed (gs1 gpc)",
    "FOODON_03542006": "20060 - turkey, fresh fat tissue (efsa foodex2)",
    "CHEBI_53339": "olefinic fatty acid",
    "FOODON_03308370": "danish lobster tail (raw)",
    "FOODON_03302652": "sheanut oil",
    "FOODON_03400350": "thickener (ec)",
    "FOODON_03315912": "filling for fine bakery wares",
    "FOODON_03316598": "confectionery pastry",
    "FOODON_03540604": "06040 - guar beans (with pods) (efsa foodex2)",
    "NCBITaxon_89462": "Bubalus bubalis",
    "FOODON_00002405": "thickness of 0.3 cm to less than 1.5 cm",
    "FOODON_03311590": "lemon cake",
    "FOODON_03541132": "11320 - chestnuts and similar- (efsa foodex2)",
    "FOODON_03309799": "cowpea for animal feed",
    "NCBITaxon_260511": "Argentina",
    "CHEBI_31344": "calcium oxide",
    "FOODON_00003200": "soy cream",
    "FOODON_03304887": "tomato concentrate",
    "FOODON_03309901": "tane-koji (food product)",
    "FOODON_03306471": "hare (jugged, with vegetables and wine sauce)",
    "NCBITaxon_69451": "Cistus",
    "FOODON_03530007": "grade of meat, u.s.",
    "FOODON_03542806": "28060 - cheese, cheshire (efsa foodex2)",
    "HANCESTRO_0545": "Rwandan",
    "FOODON_03413923": "freshwater goby",
    "FOODON_03316327": "crayfish soup powder (sterilized)",
    "NCBITaxon_3395": "Cycas",
    "FOODON_03307392": "oyster liquor (frozen)",
    "FOODON_03543797": "37970 - carbohydrate-rich energy food products for sports people (efsa foodex2)",
    "CHEBI_33619": "boron oxoanion",
    "CHEBI_33256": "primary amide",
    "FOODON_03542695": "26950 - yoghurt, cow milk, plain (efsa foodex2)",
    "FOODON_03413823": "atlantic silverside",
    "FOODON_03415098": "locust tree",
    "FOODON_03315419": "meat (salted)",
    "GAZ_00004999": "Kazakhstan",
    "CHEBI_27115": "trihydroxybenzoic acid",
    "PO_0020030": "cotyledon",
    "FOODON_03460275": "food meat liquid injection process",
    "FOODON_03414084": "sandy ray",
    "CHEBI_39474": "polyazaalkane",
    "FOODON_00003365": "food processing contact surface",
    "NCBITaxon_29073": "Ursus maritimus",
    "FOODON_03413675": "denticulate rock oyster",
    "NCBITaxon_156092": "Eriphia sebana",
    "FOODON_03315425": "vegetable extract",
    "NCBITaxon_6580": "Veneroida",
    "NCBITaxon_123369": "Euacanthomorphacea",
    "FOODON_03544054": "40540 - salt, low sodium (efsa foodex2)",
    "FOODON_03415167": "cinchona plant",
    "FOODON_03542613": "26130 - fish fingers, breaded (efsa foodex2)",
    "FOODON_00003067": "arrowroot food product",
    "HANCESTRO_0403": "Colombian",
    "FOODON_03311523": "infant formula (milk-based)",
    "FOODON_00002422": "canastrato cheese",
    "FOODON_03308991": "yellow pargo (raw)",
    "FOODON_03305419": "bread (frozen)",
    "NCBITaxon_67557": "Semotilus",
    "FOODON_03540576": "05760 - garlic (efsa foodex2)",
    "FOODON_03401071": "10005227 - dairy/egg based products / meals - ready to eat (perishable) (gs1 gpc)",
    "FOODON_03412774": "oval kumquat plant",
    "FOODON_03490397": "polyethylene (high density) - polyester container",
    "FOODON_03414158": "siberian roe deer",
    "FOODON_03400690": "european food groups (efg)",
    "FOODON_03470157": "food ultra-filtration",
    "FOODON_03413422": "burning-bush plant",
    "FOODON_03542733": "27330 - cottage cheese (efsa foodex2)",
    "FOODON_03510150": "(percent) fat free claim or use",
    "FOODON_03316795": "cherry (canned, artificially sweetened)",
    "FOODON_03308315": "red rambler salmon (raw)",
    "FOODON_03317358": "poultry product (raw, packaged, frozen)",
    "FOODON_03301565": "chocolate mousse ball",
    "FOODON_03315591": "horseradish (grated)",
    "NCBITaxon_2045261": "Rhodymeniophycidae",
    "FOODON_03301144": "cherry juice",
    "NCBITaxon_50370": "Anabantoidei",
    "FOODON_03543211": "32110 - juice, beetroot (efsa foodex2)",
    "FOODON_03302394": "orange carbonated beverage (vitamin fortified)",
    "FOODON_03304349": "eel (cured, smoked)",
    "CHEBI_35149": "magnesium hydroxide",
    "FOODON_03530098": "solid containing very small particles (<1 mm.)",
    "FOODON_03541583": "15830 - myrtle berries (efsa foodex2)",
    "FOODON_00003288": "multi-component meat product",
    "FOODON_03307311": "palm wine",
    "FOODON_03309760": "soyflake (defatted, toasted)",
    "NCBITaxon_146765": "Callinectes danae",
    "NCBITaxon_36180": "Coregonus albula",
    "FOODON_03303511": "liptauer cheese (food product)",
    "NCBITaxon_3710": "Brassica nigra",
    "FOODON_03308195": "clam (littleneck, raw)",
    "HANCESTRO_0437": "Georgian",
    "NCBITaxon_216703": "Lamioideae",
    "FOODON_00001942": "halibut food product",
    "FOODON_03310261": "german bread",
    "NCBITaxon_6740": "Paralithodes",
    "FOODON_03490257": "seal/gasket",
    "FOODON_03400924": "10000265 - sports drinks - rehydration (ready to drink) (gs1 gpc)",
    "NCBITaxon_215407": "Ranzania laevis",
    "FOODON_03414536": "forest lamb",
    "FOODON_03306152": "prune juice (concentrated)",
    "FOODON_03302094": "beef stroganoff with noodles",
    "CHEBI_17987": "benzyl alcohol",
    "FOODON_00003036": "tarragon leaf (fresh)",
    "FOODON_00001130": "sheep milk cheese food product",
    "FOODON_00003274": "coffee (liquid, no cream or sugar)",
    "FOODON_03414844": "limequat",
    "FOODON_03541866": "18660 - canned or jarred apple (efsa foodex2)",
    "FOODON_03317673": "starch syrup (hydrolyzed)",
    "FOODON_03543641": "36410 - elecampane infusion roots (efsa foodex2)",
    "FOODON_03310068": "sugar cane wine",
    "FOODON_03310781": "fruit (fermented)",
    "FOODON_03305507": "orange ice",
    "FOODON_03302115": "vegetable bouillon (naturally smoke-flavored)",
    "CHEBI_46789": "hydroxyether",
    "FOODON_03400142": "nonnutritive sweetener (us cfr)",
    "FOODON_03306410": "mayonnaise (extra-heavy)",
    "FOODON_03315779": "poultry meat product extender",
    "FOODON_03302739": "chinchilla meat (raw)",
    "FOODON_03306952": "imitation noodle",
    "FOODON_03412617": "carp",
    "FOODON_03317451": "chicory extract",
    "FOODON_03304358": "strawberry (freeze-dried)",
    "FOODON_03302219": "orangeade (food product)",
    "FOODON_03317117": "animal and vegetable fat and oil mixture",
    "FOODON_03543128": "31280 - chicken fat, processed (efsa foodex2)",
    "FOODON_03414598": "black drums",
    "FOODON_03413419": "kersting's groundnut plant",
    "FOODON_03540786": "07860 - enokitake (efsa foodex2)",
    "FOODON_00003022": "caraway food product",
    "FOODON_03430167": "syrup food supplement",
    "FOODON_03302943": "cabbage juice",
    "FOODON_03470168": "drying under over pressure",
    "FOODON_03412470": "mako shark",
    "FOODON_03303912": "pineapple marmalade",
    "FOODON_03309657": "barley flour",
    "FOODON_00002751": "cranberry bean (whole, dried)",
    "FOODON_03302475": "milk and honey bread",
    "FOODON_00003178": "Tinda plant",
    "FOODON_03306601": "abalone mushroom (raw)",
    "FOODON_00001613": "apple vinegar food product",
    "FOODON_03309097": "halibut fritter (breaded)",
    "FOODON_00002926": "mole verde",
    "FOODON_03316950": "macaroni product (nonfat milk)",
    "FOODON_03542453": "24530 - mackerel, short (efsa foodex2)",
    "FOODON_03309151": "chicken (breaded and fried, homemade)",
    "FOODON_03413074": "dicalcium citrate",
    "FOODON_03305098": "gum drop (artificially sweetened)",
    "FOODON_03316595": "rennet liquid",
    "HANCESTRO_0454": "Aruban",
    "FOODON_00001004": "fermenting sugar cane juice",
    "FOODON_03543020": "30200 - maltitol (efsa foodex2)",
    "PO_0025034": "leaf",
    "FOODON_03309006": "tuna (lemon-flavored, canned)",
    "FOODON_00001680": "cape spiny lobster food product",
    "FOODON_03303552": "green bean (french-style)",
    "FOODON_03311839": "lamb sausage (cooked)",
    "FOODON_03309707": "potato meal",
    "FOODON_03413871": "vimba bream",
    "FOODON_03414555": "spicy knight mushroom",
    "FOODON_03303411": "semolina (durum wheat)",
    "FOODON_03316744": "cauliflower (quick-frozen)",
    "FOODON_03305402": "cream of fruit beverage",
    "FOODON_03302329": "pineapple tidbits (canned)",
    "FOODON_03317649": "mammalian lactobacillus milk drink",
    "FOODON_03302823": "chocolate icing",
    "NCBITaxon_223211": "Masturus lanceolatus",
    "NCBITaxon_58666": "Ensis directus",
    "HANCESTRO_0393": "Swedish",
    "FOODON_03544101": "41010 - cheese sauce (efsa foodex2)",
    "FOODON_03460136": "obsolete: sugar or sugar syrup added",
    "FOODON_03412181": "striped bass",
    "FOODON_03316262": "soft drink (calorie reduced)",
    "FOODON_03541669": "16690 - malay pommarosas (efsa foodex2)",
    "GAZ_02000565": "Saint Vincent and the Grenadines",
    "FOODON_03308461": "yellowfin tuna (raw)",
    "NCBITaxon_1003875": "Sicyoeae",
    "NCBITaxon_392747": "Paullinia cupana",
    "FOODON_00001919": "grain based vinegar food product",
    "FOODON_00002788": "bambara groundnut (whole, dried)",
    "FOODON_03302197": "potato (boiled)",
    "NCBITaxon_7861": "Rhinobatos",
    "FOODON_03500027": "nylon surface",
    "FOODON_03400672": "005  assorted tropical and sub-tropical fruit - edible peel (ft) (ccpr)",
    "FOODON_03308659": "clam (minced, raw)",
    "NCBITaxon_115430": "Upeneus",
    "FOODON_00003104": "purple crowberry (whole)",
    "CHEBI_37445": "folic acids",
    "FOODON_03304192": "spaghetti (canned)",
    "FOODON_03530269": "color of fruit or vegetable flesh",
    "HANCESTRO_0527": "Central African",
    "FOODON_03315171": "multivitamin preparation",
    "FOODON_03414720": "bowenia plant",
    "FOODON_03540105": "01050 - maize semolina (efsa foodex2)",
    "FOODON_03306185": "rice bran",
    "GAZ_00004413": "State of Utah",
    "FOODON_00003230": "muesli",
    "NCBITaxon_9101": "Meleagris ocellata",
    "FOODON_03415017": "yacon plant",
    "FOODON_03311686": "moreton bay chestnut black bean (in oil)",
    "GAZ_00002561": "Province (Canada)",
    "FOODON_03303837": "cow butterfat food product",
    "HANCESTRO_0515": "Senegalese",
    "FOODON_03540127": "01270 - rye bread, refined flour (efsa foodex2)",
    "FOODON_03544437": "44370 - glazing agent (efsa foodex2)",
    "UBERON_0018388": "cercaria",
    "CHEBI_34247": "2,6-di-tert-butyl-4-methylphenol",
    "FOODON_00003097": "lovage root",
    "FOODON_00002784": "soybean (whole, raw)",
    "FOODON_03414893": "siberian prawn",
    "FOODON_03420123": "mammalian milk cream or cream component",
    "FOODON_00003370": "grower pig",
    "FOODON_00001599": "animal fat or oil refined food product",
    "NCBITaxon_335034": "Mustelus lenticulatus",
    "FOODON_03411407": "european blackberry plant",
    "FOODON_03315184": "whole wheat kernel",
    "FOODON_03401867": "10005914 - japanese plums (gs1 gpc)",
    "FOODON_03309055": "freshwater catfish (breaded)",
    "FOODON_03420309": "obsolete: wood",
    "HANCESTRO_0493": "Cambodian",
    "FOODON_03311872": "cumin food product",
    "NCBITaxon_3883": "Phaseolus",
    "FOODON_03306098": "citrus juice (concentrated, canned)",
    "FOODON_00001137": "obsolete: soya food product",
    "FOODON_03542545": "25450 - scallop, sea (efsa foodex2)",
    "NCBITaxon_41210": "Chionoecetes opilio",
    "FOODON_03543694": "36940 - cupua\u00e7u (efsa foodex2)",
    "FOODON_03303209": "cracker sandwich (cheese-filled)",
    "ENVO_00000063": "water body",
    "GAZ_00000559": "Southeast Asia",
    "FOODON_03414912": "bitterleaf plant",
    "FOODON_03304119": "seafood newburg (with textured soy protein added, dish)",
    "FOODON_03413537": "black abalone",
    "FOODON_03544299": "42990 - kiwi flavour (efsa foodex2)",
    "NCBITaxon_23216": "Rubus",
    "FOODON_03541617": "16170 - mulberries (black and white) (efsa foodex2)",
    "FOODON_00002549": "chicken tikki masala",
    "NCBITaxon_740707": "Raja stellulata",
    "FOODON_03302649": "illipe butter",
    "FOODON_00001737": "cichlid food product",
    "FOODON_03510115": "other ingredient- or constituent-related claim or use",
    "FOODON_03542132": "21320 - corned beef, cooked (efsa foodex2)",
    "FOODON_03411339": "orange plant",
    "PATO_0001735": "liquid configuration",
    "FOODON_03412493": "pepino plant",
    "NCBITaxon_40948": "Angelica",
    "FOODON_03311174": "milk product (enriched)",
    "FOODON_03305092": "candy made with whiskey",
    "FOODON_03400980": "10000047 - sugar candy/sugar candy substitutes confectionery (gs1 gpc)",
    "NCBITaxon_39476": "Muricidae",
    "FOODON_03530180": "fat content 1-2.9%",
    "FOODON_03315854": "coating mix, dry batter",
    "FOODON_03317599": "specialty poultry meat stew",
    "FOODON_03303574": "cheese solids product (enzyme-modified)",
    "NCBITaxon_1110386": "Rumiceae",
    "FOODON_03400338": "foaming agent (ec)",
    "FOODON_03460212": "obsolete: vegetable added",
    "FOODON_03315473": "whale meat bacon",
    "FOODON_03412934": "indian mackerel",
    "FOODON_03302328": "cinnamon raisin bun",
    "ENVO_01000246": "village biome",
    "GAZ_00001102": "Uganda",
    "FOODON_03304823": "roll (seeded)",
    "FOODON_03415081": "sweet-tea plant",
    "FOODON_03306038": "krill (antarctic, frozen)",
    "FOODON_03305328": "cottonseed oil byproduct",
    "FOODON_03541844": "18440 - other processed fruit products (excluding beverages) (efsa foodex2)",
    "FOODON_03541873": "18730 - canned or jarred table grape (efsa foodex2)",
    "FOODON_03307674": "tea (with imitation dried lemon and sugar)",
    "FOODON_03540819": "08190 - other wild fungi (efsa foodex2)",
    "FOODON_03470110": "food sterilization after filling",
    "FOODON_03304725": "omelet filler food product",
    "NCBITaxon_28509": "Glechoma hederacea",
    "GAZ_00024553": "Sulawesi",
    "FOODON_03414685": "atherton oak plant",
    "FOODON_03542654": "26540 - cow milk, natural high fat (efsa foodex2)",
    "FOODON_03304144": "sweet potato halves (orange- and pineapple-flavored, in honeybutter sauce)",
    "FOODON_03302592": "margarine (artificially colored)",
    "FOODON_03311137": "wheat sprout (raw)",
    "FOODON_03309946": "hard red spring kernel",
    "FOODON_03542116": "21160 - ham, beef (efsa foodex2)",
    "FOODON_03316624": "cheese (rennet, hard, salted, maturing in brine)",
    "FOODON_03414525": "american ginseng plant",
    "FOODON_03411949": "american lobster",
    "FOODON_03411028": "obsolete: grapefruit and orange",
    "FOODON_03316794": "youngberry canned",
    "NCBITaxon_40504": "Lutjanus buccanella",
    "NCBITaxon_54476": "Vitex",
    "NCBITaxon_8036": "Salvelinus alpinus",
    "FOODON_03302326": "fish ball (frozen)",
    "NCBITaxon_9944": "Tragelaphus",
    "FOODON_03304370": "butter biscuit and chocolate",
    "FOODON_03309898": "adzuki bean flour",
    "FOODON_03413695": "southern shortfin squid",
    "FOODON_03400704": "14  pulses (efg)",
    "FOODON_03530150": "grade a, europe",
    "FOODON_03413648": "knotted cockle",
    "FOODON_03311868": "palm kernel (ground)",
    "NCBITaxon_394691": "Sebastes fasciatus",
    "FOODON_03305370": "cracked wheat flour",
    "FOODON_03316298": "filling for fine bakery goods, fat-containing",
    "FOODON_03542458": "24580 - porbeagle (efsa foodex2)",
    "FOODON_03315312": "gelatin dessert mix sugar-based",
    "FOODON_03315436": "dip (nondairy)",
    "FOODON_03543142": "31420 - milk fat from other animals (efsa foodex2)",
    "FOODON_03412854": "rickettsiales",
    "FOODON_03301402": "ginseng",
    "FOODON_03306800": "sweet pea (canned)",
    "FOODON_03413525": "great white shark",
    "FOODON_03310546": "tea (steeped)",
    "FOODON_03309275": "seabob (raw)",
    "FOODON_03305283": "sour cream (acid-processed, sterilized)",
    "FOODON_03412443": "leucaena plant",
    "FOODON_03306300": "macaroni (nonfat milk)",
    "FOODON_03543299": "32990 - fruit soft drink, mixed fruit (efsa foodex2)",
    "FOODON_03414132": "pacific manta",
    "CHEBI_37944": "polysaccharide sulfate",
    "FOODON_03307981": "sprat (canned)",
    "FOODON_03411544": "chestnut tree",
    "FOODON_03302383": "beverage base (unsweetened)",
    "FOODON_03303690": "milwaukee cheese",
    "FOODON_03542771": "27710 - cheese, camembert (efsa foodex2)",
    "NCBITaxon_334899": "Parupeneus",
    "GO_0055114": "oxidation-reduction process",
    "FOODON_03412232": "deep sea lobster",
    "FOODON_00001747": "cocoa beverage",
    "FOODON_03411489": "scallop",
    "FOODON_03301470": "bouillon (granulated)",
    "FOODON_03543081": "30810 - florentine biscuit mass (efsa foodex2)",
    "PO_0006339": "juvenile vascular leaf",
    "FOODON_03307296": "wine (fortified)",
    "FOODON_03543016": "30160 - comb honey (efsa foodex2)",
    "FOODON_03311454": "dessert (aspartame sweetened, ready-to-eat, refrigerated)",
    "FOODON_03542745": "27450 - clotted cream (efsa foodex2)",
    "FOODON_03541555": "15550 - raspberries (red and yellow) (efsa foodex2)",
    "NCBITaxon_248136": "Scomberomorus queenslandicus",
    "FOODON_03316459": "meat (cured, low sodium)",
    "FOODON_03307811": "tuna fillet (light meat, raw)",
    "NCBITaxon_30352": "Ranoidea",
    "FOODON_03542558": "25580 - octopus, common (efsa foodex2)",
    "FOODON_03305072": "potato salad dressing",
    "FOODON_03309755": "sweet pea (whole, raw)",
    "FOODON_03316621": "starch sugar",
    "FOODON_03304838": "hen egg (freeze-dried, with emulsifier)",
    "FOODON_03305309": "cinnamon fern (salt added)",
    "ENVO_01000048": "ocean biome",
    "FOODON_03311714": "fat substitute",
    "FOODON_03315665": "meat (prepared)",
    "FOODON_03307791": "ching yuen tea (dry)",
    "FOODON_03510098": "no color added claim or use",
    "UBERON_0000323": "late embryo",
    "FOODON_03412268": "plownose chimera family",
    "FOODON_03317548": "savory coated nut (food product)",
    "FOODON_03450035": "shallow frying process",
    "NCBITaxon_241828": "Psettodes belcheri",
    "FOODON_03401549": "10006035 - cep (gs1 gpc)",
    "FOODON_00003021": "turmeric root (whole, raw)",
    "FOODON_03309431": "skilfish (raw)",
    "CHEBI_26420": "pyridinemonocarboxylic acid",
    "FOODON_03315568": "hen egg omelette mix",
    "FOODON_03541130": "11300 - cashew nuts and similar- (efsa foodex2)",
    "UBERON_0000022": "feather",
    "FOODON_03414185": "elm oyster",
    "FOODON_03304705": "sour cream blue cheese dressing",
    "FOODON_03302472": "butter and egg bread",
    "FOODON_03316904": "mushroom (salted)",
    "CHEBI_33303": "chalcogen",
    "FOODON_03401222": "0110000 - citrus fruit (ec)",
    "NCBITaxon_4637": "Musaceae",
    "FOODON_03541533": "15330 - wine grapes and similar- (efsa foodex2)",
    "NCBITaxon_204149": "Ocimum tenuiflorum",
    "FOODON_03540252": "02520 - croquembouche (efsa foodex2)",
    "FOODON_03309126": "arctic pike (raw)",
    "FOODON_03309677": "tuna in sauce",
    "FOODON_03411634": "passion fruit",
    "CHEBI_18185": "gamma-tocopherol",
    "NCBITaxon_8040": "Salvelinus namaycush",
    "NCBITaxon_85249": "Pouteria",
    "NCBITaxon_33556": "Balaenoptera bonaerensis",
    "FOODON_03308401": "mussel in brine",
    "FOODON_03310904": "crustacean (cooked)",
    "FOODON_03415120": "alpine lady's mantle plant",
    "CHEBI_17634": "D-glucose",
    "FOODON_03543360": "33600 - dessert wines (efsa foodex2)",
    "NCBITaxon_163122": "Centrolophidae",
    "NCBITaxon_396789": "Lutjanus quinquelineatus",
    "GAZ_00006935": "Commonwealth of Puerto Rico",
    "FOODON_03542666": "26660 - sheep milk (efsa foodex2)",
    "FOODON_00001662": "boysenberry food product",
    "FOODON_03308120": "american razor clam (raw)",
    "FOODON_03540543": "05430 - borage stems (efsa foodex2)",
    "FOODON_03541973": "19730 - ratites fresh meat (efsa foodex2)",
    "FOODON_00003329": "turkey thigh (skinless)",
    "FOODON_03530211": "under glass/protected plant cultivation",
    "FOODON_03304015": "spaghetti and meat sauce (dry mix)",
    "FOODON_03411035": "pacific littleneck clam",
    "FOODON_03540602": "06020 - lima beans (with pods) (efsa foodex2)",
    "NCBITaxon_40493": "Lutjanus",
    "FOODON_03541444": "14440 - other hybrids of citrus sinensis, not elsewhere mentioned (efsa foodex2)",
    "FOODON_03316885": "stockfish (quick-frozen)",
    "PATO_0000573": "increased length",
    "FOODON_03540319": "03190 - spelt rolled grains (efsa foodex2)",
    "FOODON_03400298": "low-alcohol wine, .5-7% alcohol (us cfr)",
    "FOODON_03306297": "spinach vermicelli",
    "NCBITaxon_36668": "Formicidae",
    "NCBITaxon_8016": "Oncorhynchus",
    "FOODON_03307332": "mango dairy drink",
    "FOODON_03301783": "cottage cheese (dry)",
    "NCBITaxon_8161": "Seriola quinqueradiata",
    "FOODON_03305434": "whey (lactose-modified)",
    "NCBITaxon_8052": "Gadus ogac",
    "FOODON_03308169": "obsolete: lobster (shovel, raw)",
    "NCIT_C80250": "Lunch",
    "FOODON_03317339": "poultry-based soup",
    "FOODON_03311006": "beef infant food",
    "FOODON_03311173": "cookie mix prepared from powder",
    "FOODON_03543544": "35440 - sweet blackberry infusion leaves (efsa foodex2)",
    "NCBITaxon_175811": "Trichosurus arnhemensis",
    "FOODON_00002699": "barramundi fillet",
    "HANCESTRO_0417": "Nicaraguan",
    "FOODON_03544216": "42160 - butter flavour (efsa foodex2)",
    "FOODON_03414834": "red bush apple plant",
    "FOODON_03305069": "frozen dessert (artificially sweetened)",
    "FOODON_03306380": "red currant preserve",
    "FOODON_03311250": "tomato sauce (canned)",
    "FOODON_03310564": "bacon (fried)",
    "FOODON_03542487": "24870 - freshwater crayfishes (efsa foodex2)",
    "FOODON_03490173": "paper wrapper",
    "FOODON_03411940": "australian salmon family",
    "FOODON_03400801": "seafood or related product (eurofir)",
    "FOODON_03543257": "32570 - liquid extract of plant origin (efsa foodex2)",
    "FOODON_03308889": "freshwater sheepshead (raw)",
    "FOODON_03311542": "tanok",
    "FOODON_03305392": "cauliflower (frozen)",
    "FOODON_03315428": "formula dietary food",
    "FOODON_03490153": "paperboard container, plastic coated",
    "FOODON_03541947": "19470 - deer, minced meat (efsa foodex2)",
    "FOODON_03309692": "muskmelon (food product)",
    "FOODON_03306433": "imitation ham-flavored seasoning",
    "FOODON_03310450": "elephant fish (raw)",
    "FOODON_03305710": "apple (sliced, and blackberry in syrup)",
    "HANCESTRO_0455": "Christmas Islander",
    "FOODON_03460148": "water addition process",
    "FOODON_03316927": "fat-water emulsion for use as a substitute for milk and cream in beverage coffee (mix)",
    "NCBITaxon_299522": "Erimacrus isenbeckii",
    "FOODON_03310814": "lima bean (frozen)",
    "FOODON_03510111": "no nitrite/nitrate added claim or use",
    "FOODON_03412415": "savoy cabbage plant",
    "FOODON_00001670": "brussels sprout vegetable food product",
    "FOODON_03412905": "kaiyomaru rattail",
    "FOODON_03306476": "elephant meat (raw)",
    "FOODON_00002109": "pepper product flavoring or seasoning",
    "FOODON_03306825": "chicken dumpling",
    "FOODON_03307501": "vodka liqueur",
    "FOODON_03310159": "cocksfoot fodder silage",
    "FOODON_03308619": "conger eel (raw)",
    "FOODON_00002901": "golden pompano",
    "FOODON_03316510": "obsolete: pickled food 2",
    "FOODON_03301691": "lingot cheese",
    "NCBITaxon_6637": "Todarodes pacificus",
    "FOODON_03305459": "swordfish steak (raw)",
    "FOODON_03543149": "31490 - margarines and similar (efsa foodex2)",
    "FOODON_03315634": "milk with added milk solids (partly skimmed, flavored)",
    "FOODON_03541272": "12720 - mints, dry (efsa foodex2)",
    "FOODON_03544414": "44140 - essences and extracts (efsa foodex2)",
    "FOODON_03315832": "collagen film (water soluble, edible)",
    "FOODON_03420305": "obsolete: rhizome",
    "FOODON_00002723": "mink",
    "FOODON_03307172": "potato (peeled, cooked, mashed, instant)",
    "FOODON_03301679": "youngberry (raw)",
    "FOODON_03414195": "devil's-claw plant",
    "FOODON_03414432": "triphosphates",
    "FOODON_03311432": "coffee (canned, whitened)",
    "FOODON_03412084": "butterhead lettuce plant",
    "FOODON_03303449": "italian-style rice (canned)",
    "FOODON_00002761": "kidney bean (whole)",
    "FOODON_00002365": "wine, 7-24% alcohol, food product",
    "FOODON_03401287": "USDA SR lamb, veal, and game products (1700)",
    "NCBITaxon_9852": "Alces alces",
    "CHEBI_61458": "polysiloxane polymer",
    "FOODON_03414268": "purple-flowered raspberry plant",
    "FOODON_03305998": "acidophilus cow milk",
    "FOODON_03307196": "gin and tonic cocktail",
    "NCBITaxon_33636": "Laminariaceae",
    "FOODON_03317244": "fish roe (semi-preserved)",
    "FOODON_03305293": "mango (canned)",
    "FOODON_03543657": "36570 - siberian ginseng infusion roots (efsa foodex2)",
    "FOODON_03307138": "tarragon in vinegar",
    "FOODON_00001134": "bovine meat food product",
    "FOODON_00001673": "butter product analog",
    "FOODON_03301940": "baking powder",
    "FOODON_00001675": "cabbage juice food product",
    "FOODON_03307235": "walnut catsup",
    "FOODON_03304827": "peanut butter chip oat bar (sweetened)",
    "FOODON_03305974": "freezer jam",
    "FOODON_03310496": "food supplement containing bone meal",
    "FOODON_03541972": "19720 - goose, minced meat (efsa foodex2)",
    "FOODON_03310979": "fish (cooked)",
    "FOODON_03540559": "05590 - bamboo shoots and similar- (efsa foodex2)",
    "FOODON_03305386": "popsicle (frozen)",
    "FOODON_03541637": "16370 - rowan berries (efsa foodex2)",
    "NCBITaxon_371864": "Melanitta fusca",
    "FOODON_03315049": "filling for prebaked cookie",
    "FOODON_03401289": "USDA SR sweets (1900)",
    "FOODON_00001101": "grape beverage",
    "FOODON_03311291": "soft red winter wheat kernel",
    "PO_0020043": "compound leaf",
    "FOODON_03413988": "chinese seerfish",
    "UBERON_0000922": "embryo",
    "FOODON_03303523": "dagano cheese",
    "FOODON_03311331": "cheddar cheese (mild)",
    "FOODON_03305330": "cognac",
    "NCBITaxon_94240": "Psettodes",
    "FOODON_03316797": "fig (artificially sweetened, canned)",
    "FOODON_03303089": "coconut milk (frozen)",
    "FOODON_03315593": "drink mix (citrus based)",
    "FOODON_03411942": "slimehead family",
    "FOODON_00002322": "turkey pie food product",
    "FOODON_03413517": "nursehound",
    "FOODON_00003033": "cherimoya fruit (whole, raw)",
    "FOODON_03540243": "02430 - biscuits, spelt meal (efsa foodex2)",
    "NCBITaxon_27774": "Triglidae",
    "FOODON_03316323": "herring product salted",
    "CHEBI_25704": "organic sulfate",
    "FOODON_03414833": "small-leaved watergum plant",
    "FOODON_03309309": "cockle (spiny, raw)",
    "FOODON_03316601": "flour (baking)",
    "FOODON_00002287": "sugar based vinegar food product",
    "FOODON_03305154": "lemonade drink",
    "FOODON_03543438": "34380 - coffee beverage-preparation, powder (efsa foodex2)",
    "FOODON_03413903": "northern kingfish",
    "FOODON_03302540": "potato (dehydrated)",
    "FOODON_03414806": "horned turban",
    "FOODON_03306260": "margarine (salt-free)",
    "FOODON_03412704": "sea lamprey",
    "FOODON_03541048": "10480 - peas (without pods) and similar- (efsa foodex2)",
    "FOODON_03420294": "fruit peel (anatomical part)",
    "FOODON_00003188": "wine gum",
    "FOODON_03317001": "flour paste for bread",
    "FOODON_03450033": "cooking in double boiler",
    "FOODON_03303654": "pasteurized process cheese (hickory-smoked)",
    "PO_0009005": "root",
    "NCBITaxon_8019": "Oncorhynchus kisutch",
    "FOODON_03414259": "salmonberry plant",
    "FOODON_03303516": "pasteurized process cheese (alcohol added)",
    "FOODON_03411038": "jerusalem artichoke plant",
    "FOODON_03411657": "surinam cherry plant",
    "FOODON_03401629": "10006305 - goose - prepared/processed (gs1 gpc)",
    "FOODON_03540937": "09370 - preserved concentrated tomatoes (efsa foodex2)",
    "FOODON_03301902": "beverage (fruit-flavored)",
    "FOODON_03309461": "new zealand surf clam (raw)",
    "CHEBI_33581": "boron group molecular entity",
    "FOODON_03315061": "dessert analog (frozen)",
    "FOODON_03305200": "imitation flavored beverage base (artificially sweetened)",
    "FOODON_03311164": "carp smoked",
    "FOODON_03316264": "pudding substitute",
    "FOODON_03316663": "confectionery (long-life, vitaminized)",
    "FOODON_03401465": "10006145 - pak choi (gs1 gpc)",
    "FOODON_03308486": "congor eel (raw)",
    "FOODON_03309912": "moonfish (raw)",
    "NCBITaxon_3737": "Sapotaceae",
    "FOODON_03401873": "10005915 - plumcots (gs1 gpc)",
    "FOODON_00002645": "food product by process",
    "FOODON_03540355": "03550 - rice, popped (efsa foodex2)",
    "FOODON_03306463": "elk meat (raw)",
    "FOODON_03312054": "chicken (freeze-dried)",
    "FOODON_03543137": "31370 - cod liver oil (efsa foodex2)",
    "FOODON_03311711": "catfish fillet (raw)",
    "UO_0000113": "power unit",
    "FOODON_03317525": "sauce, emulsified with a fat content less than 60%",
    "FOODON_00002352": "wheat cereal food product",
    "FOODON_03411374": "crustacean",
    "FOODON_03305726": "chocolate candy (coffee-flavored)",
    "FOODON_03307079": "strawberry spread (uncooked, frozen)",
    "NCBITaxon_490596": "Metanephrops sinensis",
    "FOODON_03411550": "parsley plant",
    "FOODON_03510241": "monounsaturated fat claim or use",
    "FOODON_03305194": "ginseng tea (instant)",
    "FOODON_00002561": "blini",
    "FOODON_03413764": "food supplements, mineral substances (ec)",
    "FOODON_03412205": "langostino colorado",
    "FOODON_03411079": "durum wheat plant",
    "FOODON_00002036": "milk product based dressing",
    "FOODON_03540490": "04900 - curly kales (efsa foodex2)",
    "FOODON_03542135": "21350 - corned turkey (efsa foodex2)",
    "FOODON_03413242": "sodium aluminium phosphate acidic",
    "FOODON_03541161": "11610 - bhutan pine nut kernels (efsa foodex2)",
    "FOODON_03302979": "caerphilly cheese",
    "FOODON_03311368": "obsolete: cooking powder, not further specified",
    "FOODON_03530009": "prime grade",
    "FOODON_03543133": "31330 - processed fat (blubber) of marine mammals (efsa foodex2)",
    "FOODON_03543396": "33960 - egg liqueur (efsa foodex2)",
    "FOODON_03317331": "bacon (whole cut or parts)",
    "FOODON_00001070": "miso food product",
    "FOODON_03301697": "pumpkin (whole, raw)",
    "FOODON_03541747": "17470 - papayas and similar- (efsa foodex2)",
    "FOODON_03301581": "cottonseed oil",
    "FOODON_03309828": "teleme cheese",
    "HANCESTRO_0563": "South Tyrolean",
    "NCBITaxon_8107": "Scorpaenoidei",
    "NCBITaxon_66911": "Ameiurus catus",
    "NCBITaxon_1489908": "Ovalentaria",
    "FOODON_03460276": "food bromination process",
    "FOODON_03541060": "10600 - blue lupin (without pods) (efsa foodex2)",
    "FOODON_03543514": "35140 - ladies mantle infusion leaves (efsa foodex2)",
    "FOODON_00001627": "bamboo vegetable food product",
    "GAZ_00004474": "Iran",
    "FOODON_03315773": "fig marmalade",
    "FOODON_03542295": "22950 - salmons, trouts, smelts (efsa foodex2)",
    "FOODON_00002341": "water ice desert food product",
    "NCBITaxon_49743": "Taraxacum",
    "FOODON_03530081": "processed in stainless steel container",
    "FOODON_03305695": "pollock (mashed, crab-flavored)",
    "CHEBI_47016": "tetrahydrofuranone",
    "FOODON_00001633": "barley vegetable food product",
    "FOODON_03303215": "cracker sandwich (peanut butter and jelly filled)",
    "FOODON_03400862": "savoury sauce (eurofir)",
    "FOODON_03307862": "cocklebur tea leaves (food product)",
    "CHEBI_33497": "transition element molecular entity",
    "FOODON_03307820": "green tea (powdered)",
    "FOODON_00003092": "roselle food product",
    "FOODON_03490352": "coextruded paper-aluminium-plastic wrapper",
    "FOODON_00001676": "obsolete: cabbage pickle food product",
    "FOODON_03401118": "10000291 - vegetable based products - not ready to eat (frozen) (gs1 gpc)",
    "FOODON_03541507": "15070 - flat peaches (efsa foodex2)",
    "FOODON_03302116": "cow milk (liquid)",
    "FOODON_03316643": "cheese (fried)",
    "FOODON_03540040": "00400 - rice grain, long-grain (efsa foodex2)",
    "FOODON_03490419": "boil-in bag",
    "FOODON_03401172": "10000579 - stock/bones (perishable) (gs1 gpc)",
    "FOODON_03304419": "gelatin dessert mix low sodium sugar-free",
    "FOODON_03315778": "meat product extender",
    "FOODON_03413706": "italian parsley plant",
    "NCBITaxon_76966": "Citrus japonica",
    "FOODON_03301274": "freestone peach (canned)",
    "FOODON_03400968": "10000599 - grains/flour variety packs (gs1 gpc)",
    "FOODON_03413607": "jasid spiny lobster",
    "NCBITaxon_39241": "Swertia",
    "FOODON_03316781": "fruit jelly (artificially sweetened)",
    "FOODON_03400668": "001  citrus fruits (fc) (ccpr)",
    "FOODON_03307711": "maple- and honey-flavored table syrup",
    "FOODON_03544003": "40030 - dairy/egg soup (efsa foodex2)",
    "FOODON_03307352": "banana cream pie",
    "FOODON_03310063": "chapati",
    "ENVO_00000011": "garden",
    "FOODON_03307164": "fruit preserves (sugar-free)",
    "NCBITaxon_7924": "Amia calva",
    "FOODON_00002337": "vitamin as food supplement food product",
    "FOODON_03317342": "poultry (raw, ground, formed)",
    "FOODON_03310109": "coffee bean (roasted, finely ground)",
    "FOODON_00001743": "clingstone peach food product",
    "FOODON_03302211": "orange juice beverage base",
    "FOODON_03304859": "kale leaf (raw)",
    "FOODON_03310230": "sumac fruit (raw)",
    "FOODON_03307110": "rolled oats",
    "FOODON_03303199": "corn meal (instant)",
    "FOODON_03302238": "lemon and barley drink mix",
    "FOODON_03303021": "chicken spread",
    "FOODON_00001622": "atlantic herring food product",
    "FOODON_00001983": "obsolete: kava beverage",
    "NCBITaxon_8247": "Labridae",
    "FOODON_03317181": "beverage (artificially flavored)",
    "FOODON_03541884": "18840 - rabbit carcase (efsa foodex2)",
    "FOODON_03316224": "bakery product, fine, energy reduced",
    "CHEBI_85248": "gellan gum",
    "FOODON_00002170": "poultry meat product analog",
    "FOODON_03470161": "preservation by electron accelerator radiation",
    "FOODON_03520147": "pacific, western central (fao major fishing area 71)",
    "FOODON_00001302": "lasagne food product",
    "FOODON_03543677": "36770 - fleawort (infusion seeds) (efsa foodex2)",
    "FOODON_03412151": "queen snapper",
    "FOODON_03413054": "calcium sulphite",
    "FOODON_03303658": "brazilian cheese",
    "FOODON_03400337": "flour treatment agent (ec)",
    "FOODON_03540557": "05570 - rhubarbs and similar- (efsa foodex2)",
    "HANCESTRO_0318": "Orcadian",
    "FOODON_03302906": "bran cereal",
    "FOODON_03310989": "cocktail peanut (whole, coated, roasted)",
    "FOODON_03301903": "french dressing",
    "HANCESTRO_0312": "Carlantino",
    "FOODON_03309779": "red kidney bean (whole)",
    "FOODON_03412897": "grenadier",
    "FOODON_03317107": "fungi (edible, canned)",
    "FOODON_03307521": "boysenberry beverage syrup",
    "ENVO_01000248": "dense settlement biome",
    "FOODON_03307610": "imitation fruit salad-flavored candy",
    "FOODON_00001728": "chicken soup food product",
    "FOODON_03311348": "field cress (raw)",
    "FOODON_03414949": "yellow pitaya plant",
    "FOODON_03307867": "tea leaf (whole)",
    "FOODON_03303431": "roast beef (oven-cooked)",
    "FOODON_03400962": "10000203 - flour - cereal/pulse (shelf stable) (gs1 gpc)",
    "FOODON_03306424": "flaxseed meal",
    "FOODON_03304867": "enrichment mix",
    "FOODON_00003359": "chicken thigh (skinless, debonned)",
    "FOODON_03311057": "farina (cooked)",
    "FOODON_00003243": "sushi",
    "FOODON_03304852": "fruit jam and jelly mix",
    "FOODON_03542464": "24640 - marine fishes not identified (efsa foodex2)",
    "FOODON_03303412": "dinner (frozen)",
    "FOODON_03317526": "cephalopod (deep-frozen)",
    "FOODON_03310849": "sorghum cereal (food product)",
    "FOODON_03310868": "obsolete: potatoes (scalloped)",
    "FOODON_03460151": "obsolete: spice or herb added",
    "FOODON_03540437": "04370 - purslanes and similar- (efsa foodex2)",
    "NCBITaxon_98815": "Dentex maroccanus",
    "FOODON_03510087": "reduced salt claim or use",
    "FOODON_00001110": "donkey dairy food product",
    "FOODON_03543760": "37600 - follow-on formulae (efsa foodex2)",
    "GAZ_00002828": "Brazil",
    "FOODON_03540075": "00750 - millet flour (efsa foodex2)",
    "FOODON_03316844": "whole durum flour",
    "FOODON_03480018": "packed in salt brine",
    "FOODON_03310671": "nut meat",
    "FOODON_03302121": "blackberry pie",
    "FOODON_03530119": "restaurant or fast food preparation process",
    "NCBITaxon_72041": "Eumalacostraca",
    "FOODON_03306794": "purple plum (canned)",
    "CHEBI_61468": "dimethicone polymer",
    "FOODON_00002667": "allspice",
    "FOODON_03310571": "rice oil",
    "FOODON_03305895": "jellied sauce",
    "FOODON_03304268": "spaghetti and meatballs (dry mix)",
    "FOODON_03400420": "formulation aid (codex)",
    "FOODON_03544435": "44350 - anti-caking agent (efsa foodex2)",
    "HANCESTRO_0463": "American",
    "CHEBI_64709": "organic acid",
    "FOODON_03540847": "08470 - maori dock (efsa foodex2)",
    "FOODON_03541841": "18410 - fruit compote, table grape (efsa foodex2)",
    "NCBITaxon_13679": "Scomberomorus cavalla",
    "FOODON_03301542": "herb (dried)",
    "NCBITaxon_8039": "Salvelinus malma",
    "FOODON_03543569": "35690 - vlei tea (efsa foodex2)",
    "FOODON_03412008": "chinese red date plant",
    "FOODON_03414115": "kitefin shark familie",
    "FOODON_03302291": "black currant drink (vitamin c added)",
    "FOODON_03401371": "50260600 - cucumbers (gs1 gpc)",
    "GAZ_00003750": "Bangladesh",
    "FOODON_00003174": "painted comber",
    "FOODON_03303750": "chocolate candy (artificially brandy-flavored)",
    "NCBITaxon_151071": "Nephelium lappaceum",
    "FOODON_03309438": "butterfish (raw)",
    "NCBITaxon_31199": "Argopecten irradians",
    "FOODON_03541719": "17190 - pitayas (efsa foodex2)",
    "FOODON_03540499": "04990 - sprouts, shoots and similar (efsa foodex2)",
    "ENVO_00000033": "pond",
    "FOODON_03311273": "catfish (cooked)",
    "NCBITaxon_90675": "Camelina sativa",
    "FOODON_03412481": "round scad",
    "FOODON_03308684": "whiting (smoked)",
    "FOODON_03541970": "19700 - duck, minced meat (efsa foodex2)",
    "BFO_0000018": "zero-dimensional spatial region",
    "FOODON_03541704": "17040 - litchis and similar- (efsa foodex2)",
    "NCBITaxon_223796": "Epigonidae",
    "FOODON_00001629": "banana passionfruit food product",
    "FOODON_03306399": "apricot marmalade",
    "FOODON_03543431": "34310 - kola nuts (efsa foodex2)",
    "CHEBI_33559": "s-block element atom",
    "FOODON_03413444": "rampion plant",
    "FOODON_03306638": "imitation dairy product (with coconut oil)",
    "FOODON_03308604": "oriental blue crabmeat (frozen)",
    "CHEBI_30563": "silicon dioxide",
    "FOODON_03543927": "39270 - sandwich with fish and vegetable topping/filling (efsa foodex2)",
    "NCBITaxon_175767": "Typhonium",
    "FOODON_03400930": "10000068 - baking/cooking mixes (perishable) (gs1 gpc)",
    "FOODON_00001154": "citrullus lanatus fruit food product",
    "NCBITaxon_1545868": "Cyttidae",
    "FOODON_03310798": "skim milk (raw)",
    "FOODON_00002874": "picnic loaf",
    "ENVO_00002258": "loam",
    "FOODON_03311163": "ice cream mix raw",
    "FOODON_03305366": "imitation cocoa butter",
    "FOODON_03541205": "12050 - pumpkin seeds and similar- (efsa foodex2)",
    "FOODON_03542277": "22770 - pike (efsa foodex2)",
    "NCBITaxon_7950": "Clupea harengus",
    "FOODON_03310141": "groundsel leaf (raw)",
    "FOODON_03544422": "44220 - food additives other than flavours, colours and artificial sweeteners (efsa foodex2)",
    "ENVO_00000012": "hydrographic feature",
    "FOODON_03541221": "12210 - purple viper's bugloss seeds (efsa foodex2)",
    "FOODON_03470111": "preservation by storage in modified atmosphere",
    "FOODON_03540221": "02210 - cake pre-mixes/batter (efsa foodex2)",
    "FOODON_03306832": "heart of palm (canned)",
    "FOODON_03317466": "cheese product (processed, flavored)",
    "FOODON_03412236": "wasabi plant",
    "NCBITaxon_139456": "Penaeus chinensis",
    "FOODON_03304184": "onion stock cube",
    "CHEBI_25899": "pentitol",
    "ECOCORE_00000020": "herbivory",
    "FOODON_03310780": "cow whole milk 3.5% fat",
    "CHEBI_33976": "magnesium coordination entity",
    "FOODON_03413423": "calamus plant",
    "FOODON_03310481": "fruit for fruit salad",
    "FOODON_03306052": "spice (whole)",
    "FOODON_03401173": "10000578 - stock/bones (shelf stable) (gs1 gpc)",
    "FOODON_03302724": "tomato chutney",
    "FOODON_03411695": "tamarind plant",
    "PO_0030111": "pepo fruit",
    "FOODON_03307379": "imitation lowfat chocolate milk (vitamins a and d added, dry)",
    "FOODON_03520141": "atlantic, antarctic (fao major fishing area 48)",
    "FOODON_03309548": "goat and cow milk",
    "FOODON_03413256": "obsolete: sodium hydrogen carbonate",
    "FOODON_00002544": "samosa",
    "FOODON_03304241": "ham soup stix",
    "FOODON_03401056": "10000042 - fats edible - vegetable or plant (shelf stable) (gs1 gpc)",
    "FOODON_03315816": "fish protein",
    "NCBITaxon_9833": "Hippopotamus amphibius",
    "FOODON_03540274": "02740 - cake marbled, with chocolate (efsa foodex2)",
    "NCBITaxon_9347": "Eutheria",
    "FOODON_03304228": "crab newburg (dish)",
    "CHEBI_33702": "polyatomic cation",
    "FOODON_03310754": "obsolete: sausage (cooked)",
    "FOODON_03305633": "infant cereal (instant, honey added)",
    "NCBITaxon_766": "Rickettsiales",
    "FOODON_03305865": "raspberry jam",
    "FOODON_03413056": "candelilla wax",
    "FOODON_00002312": "thyme food product",
    "FOODON_00002921": "green cabbage",
    "CHEBI_39024": "clathrate compound",
    "FOODON_03302536": "butter (sweet)",
    "FOODON_03301431": "chicken bouillon cube",
    "HANCESTRO_0475": "Palauan",
    "FOODON_03309702": "millet",
    "FOODON_03401203": "sandwich (eurofir)",
    "NCBITaxon_55141": "Squatina",
    "FOODON_03305536": "honey blend table syrup",
    "FOODON_03302000": "peanut brittle",
    "FOODON_03304900": "peach kernel paste",
    "FOODON_03412431": "wels catfish",
    "FOODON_03305816": "green relish",
    "FOODON_03309120": "northern puffer (raw)",
    "NCBITaxon_85293": "Viburnum opulus",
    "FOODON_03411341": "seal family",
    "FOODON_03544266": "42660 - fresh milk flavour (efsa foodex2)",
    "FOODON_03311654": "beef (cured, cooked)",
    "FOODON_03541121": "11210 - almonds sweet (efsa foodex2)",
    "FOODON_03510197": "food quality claim",
    "FOODON_03317428": "food sold in coated tablet form",
    "FOODON_03542180": "21800 - pre-cooked sausages to be cooked before consumption (efsa foodex2)",
    "FOODON_03541734": "17340 - avocados for oil production (efsa foodex2)",
    "CHEBI_72544": "flavonoids",
    "FOODON_03544465": "44650 - acesulfame k (efsa foodex2)",
    "FOODON_03412163": "spiny lobster family",
    "FOODON_00003130": "gai lan",
    "FOODON_03305267": "cream (sterilized, artificially flavored)",
    "FOODON_03311092": "infant formula milk-based ready-to-feed",
    "FOODON_03315962": "snack (ready-to-eat)",
    "FOODON_03543528": "35280 - black mulberry infusion leaves (efsa foodex2)",
    "FOODON_03540724": "07240 - parsnips and similar- (efsa foodex2)",
    "FOODON_00002685": "navy bean (whole)",
    "FOODON_03400381": "bulking agent (codex)",
    "FOODON_03460213": "vitamin a or carotenes added",
    "NCBITaxon_71243": "Oxalidales",
    "NCBITaxon_9901": "Bison bison",
    "CHEBI_38179": "monocyclic heteroarene",
    "FOODON_03541477": "14770 - pears (efsa foodex2)",
    "FOODON_00002522": "darkling beetle",
    "FOODON_03309540": "evaporated milk (canned, fortified)",
    "FOODON_03413226": "propane-1,2-diol esters of fatty acids",
    "FOODON_03540659": "06590 - antroewas (efsa foodex2)",
    "FOODON_03510010": "laboratory animal as food consumer",
    "FOODON_03317406": "mollusc (unprocessed, frozen)",
    "FOODON_03541109": "11090 - other pulses (efsa foodex2)",
    "FOODON_03541428": "14280 - pomelos (efsa foodex2)",
    "FOODON_03401444": "10005927 - raspberries (gs1 gpc)",
    "FOODON_03412782": "doum palm plant",
    "FOODON_03541134": "11340 - japanese chestnut (efsa foodex2)",
    "FOODON_03541466": "14660 - tankan mandarin (efsa foodex2)",
    "FOODON_03309458": "chicken-flavored vegetable noodle soup",
    "FOODON_03305221": "fudge powder",
    "NCBITaxon_8010": "Esox lucius",
    "FOODON_00001217": "mammalian milk beverage",
    "FOODON_03400180": "soup, thick (us cfr)",
    "FOODON_03308378": "langostino cream soup",
    "FOODON_03414026": "cutlassfish family",
    "FOODON_03303144": "garibaldi cookie",
    "CHEBI_33408": "pnictogen oxoacid",
    "FOODON_03316787": "orange juice concentrate (for manufacturing)",
    "FOODON_03315552": "juice beverage",
    "FOODON_03541752": "17520 - mangosteens (efsa foodex2)",
    "FOODON_03540154": "01540 - crisp bread, wheat, wholemeal (efsa foodex2)",
    "FOODON_03412804": "grewia plant",
    "FOODON_03305982": "reconstituted orange juice (from frozen concentrate)",
    "FOODON_03301520": "fruit (waxed)",
    "FOODON_03543853": "38530 - pork meat loaf (efsa foodex2)",
    "FOODON_03306382": "orange marmalade (cherry-flavored, with maraschino cherries)",
    "NCBITaxon_30962": "Oncorhynchus clarkii",
    "FOODON_03542467": "24670 - shark liver (efsa foodex2)",
    "CHEBI_71298": "glucan derivative",
    "NCBITaxon_9312": "Macropus",
    "FOODON_03541346": "13460 - saigon cinnamon bark (efsa foodex2)",
    "FOODON_03308964": "malabar red snapper fillet (raw)",
    "FOODON_00001817": "alcoholic beverage (distilled)",
    "FOODON_03308638": "pollock and deep sea crab blend",
    "FOODON_03414247": "northern wild rice plant",
    "FOODON_03317674": "coffee mixture",
    "FOODON_03400334": "emulsifying salt (ec)",
    "FOODON_03317306": "meat salad (canned)",
    "FOODON_03400631": "CCFAC cereals and cereal products",
    "FOODON_03414382": "chinese mud carp",
    "FOODON_00002908": "yellowtail fish",
    "FOODON_03315412": "nut yogurt (reduced fat or skim milk)",
    "FOODON_03310771": "breakfast beverage (non-carbonated)",
    "FOODON_03414178": "collared stinkhorn",
    "ENVO_01000814": "solid environmental material",
    "FOODON_03309266": "petrale sole (raw)",
    "FOODON_03414327": "italian cornsalad plant",
    "FOODON_03542126": "21260 - cooked pork tongue (efsa foodex2)",
    "FOODON_03307684": "tea (roasted, dry)",
    "FOODON_03543252": "32520 - dehydrated/powdered vegetable juice (efsa foodex2)",
    "NCBITaxon_52926": "Neritidae",
    "FOODON_00002746": "soft-shell crab",
    "FOODON_03543971": "39710 - pasta, with mixed or unspecified filling, cooked (efsa foodex2)",
    "FOODON_03413999": "common dentex",
    "FOODON_03317623": "citrus fruit (blanched, frozen)",
    "FOODON_03540922": "09220 - wintergreen leaves (efsa foodex2)",
    "FOODON_03304718": "vegetable salad mix (pre-cut, raw)",
    "NCBITaxon_8839": "Anas platyrhynchos",
    "FOODON_03542491": "24910 - giant river prawn (efsa foodex2)",
    "FOODON_03490381": "polyvinylidene chloride container",
    "GAZ_00000849": "Saint Helena",
    "FOODON_03412171": "asafoetida plant",
    "FOODON_03317651": "cream, reconstituted",
    "FOODON_00001125": "ovine cheese food product",
    "FOODON_03430163": "food supplement granules",
    "FOODON_00002558": "wonton (filled)",
    "FOODON_03411775": "speckled rockfish",
    "FOODON_03401142": "10000016 - fish - prepared/processed (perishable) (gs1 gpc)",
    "FOODON_03305132": "lemon cream sandwich wafer",
    "CHEBI_25140": "maltodextrin",
    "FOODON_03412827": "mobola plum plant",
    "FOODON_03308164": "rock oyster (raw)",
    "FOODON_03310147": "red plum (whole, raw)",
    "FOODON_03540108": "01080 - cereal bran (efsa foodex2)",
    "FOODON_03480036": "packed in gravy or sauce, meat",
    "FOODON_03412294": "california pilchard",
    "FOODON_03510069": "no or reduced fat claim or use",
    "FOODON_03306786": "pizza sauce",
    "NCBITaxon_3934": "Onagraceae",
    "NCBITaxon_78536": "Euphyllophyta",
    "NCBITaxon_3275": "Polypodiaceae",
    "FOODON_03411092": "brown mustard plant",
    "FOODON_03412073": "blusher mushroom",
    "FOODON_03510074": "no palm oil added claim or use",
    "FOODON_00002262": "soybean condiment",
    "FOODON_03544222": "42220 - caramel flavour (efsa foodex2)",
    "NCBITaxon_57937": "Sanguisorba",
    "FOODON_03306044": "ice cream biscuit",
    "FOODON_03304567": "rose hip in sugar syrup",
    "FOODON_03412110": "illipe plant",
    "FOODON_03543442": "34420 - tea leaves and stalks, fermented (efsa foodex2)",
    "FOODON_03309990": "sunflower seed (whole kernel, shell off)",
    "FOODON_03540086": "00860 - spelt flour, medium (efsa foodex2)",
    "FOODON_03302169": "orange carbonated beverage",
    "FOODON_03470113": "sterilization by irradiation",
    "FOODON_03310812": "imitation veal cutlet",
    "FOODON_03306393": "greengage preserves (food product)",
    "FOODON_03315326": "table seasoning",
    "FOODON_00002020": "mango food product",
    "FOODON_03302067": "cranberry bean (whole)",
    "FOODON_03302521": "butter (vanilla-flavored)",
    "GAZ_00002542": "Commonwealth of Pennsylvania",
    "FOODON_03414025": "acanthistius",
    "FOODON_03413866": "hickory shad",
    "FOODON_03530157": "wing (poultry meat cut)",
    "FOODON_03309766": "white corn meal",
    "FOODON_00003387": "tunnel farming",
    "FOODON_03401550": "10006033 - chanterelles (gs1 gpc)",
    "FOODON_03413739": "upland cotton plant",
    "FOODON_03308387": "shrimp bouillon (food product)",
    "FOODON_00001932": "gray mullet food product",
    "FOODON_03540736": "07360 - radishes (efsa foodex2)",
    "HANCESTRO_0331": "Sudanese",
    "FOODON_03401181": "10000244 - pickled vegetables (gs1 gpc)",
    "FOODON_03307279": "cream cheese (frozen)",
    "FOODON_00001958": "human milk based food product",
    "FOODON_00003217": "tomato seed oil",
    "FOODON_03542598": "25980 - snail, roman (efsa foodex2)",
    "FOODON_03307297": "wine sauce",
    "FOODON_03301126": "applesauce",
    "FOODON_03304273": "sparkling dry beverage (nonalcoholic)",
    "FOODON_03317265": "salami (genoa)",
    "FOODON_03316133": "cocktail cherry",
    "FOODON_03543165": "31650 - juice, peach-apricot (efsa foodex2)",
    "FOODON_03413326": "black persimmon plant",
    "NCBITaxon_71274": "asterids",
    "NCBITaxon_6697": "Macrobrachium malcolmsonii",
    "FOODON_03401166": "50171500 - herbs/spices/extracts (gs1 gpc)",
    "FOODON_03309697": "south african porgy fillet (raw)",
    "FOODON_03540860": "08600 - jam\u00e9's sage (efsa foodex2)",
    "FOODON_03302689": "soya-carob bread",
    "FOODON_03305006": "sair date (raw)",
    "FOODON_03306319": "mango (sliced, canned)",
    "NCBITaxon_21571": "Boraginaceae",
    "FOODON_03311526": "chicken parts (cooked)",
    "FOODON_03306856": "peanut (ground)",
    "FOODON_03541541": "15410 - cane fruits (efsa foodex2)",
    "FOODON_00002838": "mountain papaya plant",
    "FOODON_03411270": "mango plant",
    "FOODON_03304023": "tomacouli",
    "FOODON_03302730": "chicken noodle soup",
    "FOODON_03544441": "44410 - humectant (efsa foodex2)",
    "FOODON_03401033": "10000029 - cheese/cheese substitutes (shelf stable) (gs1 gpc)",
    "HANCESTRO_0570": "Pima Indian",
    "NCBITaxon_3740": "Manilkara",
    "FOODON_03310167": "chicken thigh (charcoal-broiled)",
    "NCBITaxon_174391": "Lithodes",
    "FOODON_03540526": "05260 - calabrese (efsa foodex2)",
    "FOODON_03309432": "spotted stargazer (raw)",
    "FOODON_00001114": "zebra dairy food product",
    "FOODON_03430104": "whole and pieces",
    "FOODON_03510035": "salt or sodium free claim or use",
    "NCBITaxon_27704": "Gobio gobio",
    "GAZ_00000448": "geographic location",
    "FOODON_03412972": "food additive",
    "NCBITaxon_153620": "Epinephelus morio",
    "FOODON_03413613": "pink spiny lobster",
    "NCBITaxon_43690": "Canarium <eudicots>",
    "FOODON_03542273": "22730 - white crappie (efsa foodex2)",
    "FOODON_03309190": "smooth dogfish (raw)",
    "FOODON_03316947": "macaroni food product",
    "FOODON_03401688": "10005833 - beef sausages - prepared/processed (gs1 gpc)",
    "FOODON_03412471": "shortfin mako shark",
    "FOODON_03414710": "sawsedge plant",
    "FOODON_03413459": "american bullfrog",
    "FOODON_03310861": "finettes cheese",
    "FOODON_03400697": "07  sugar (efg)",
    "FOODON_00002244": "snail food product",
    "FOODON_03413558": "maroon stone crab",
    "FOODON_03412857": "dentex",
    "FOODON_03301508": "skim milk (pasteurized, vitamin A and D fortified, and dehydrated milk products added)",
    "FOODON_00001998": "lettuce vegetable food product",
    "FOODON_00003275": "tiramisu",
    "NCBITaxon_43908": "Guarea",
    "FOODON_03542587": "25870 - snakes (efsa foodex2)",
    "FOODON_03401243": "0620000 - coffee beans (ec)",
    "FOODON_03544381": "43810 - strawberry flavour (efsa foodex2)",
    "FOODON_03308490": "sweet pepper (sliced, canned)",
    "FOODON_03414686": "yellownut plant",
    "FOODON_03306857": "peanut butter (vitamin a added)",
    "FOODON_03315609": "anchovy (spiced, sugar)",
    "NCBITaxon_81953": "Agamidae",
    "FOODON_03450012": "cooking by moist heat",
    "FOODON_03412605": "suez fusilier",
    "FOODON_03490220": "sealing/closing element",
    "CHEBI_32095": "retinyl acetate",
    "FOODON_03400208": "salad (us cfr)",
    "FOODON_03541064": "10640 - horse gram (fresh seeds) (efsa foodex2)",
    "CHEBI_68428": "maltitol",
    "NCBITaxon_6725": "Cambaridae",
    "NCBITaxon_349168": "Prunus avium x P. cerasus x P. canescens",
    "FOODON_03411529": "apricot tree",
    "FOODON_03413532": "giant abalone",
    "FOODON_00002584": "Chardonnay wine",
    "FOODON_03311278": "horseradish root (ground)",
    "FOODON_03315760": "infant formula based on isolated amino acids and/or protein hydrolysates",
    "FOODON_03414936": "pointed gourd plant",
    "FOODON_03309794": "table syrup (fruit-flavored)",
    "FOODON_03306936": "sweet corn relish",
    "FOODON_03302387": "citrus beverage",
    "FOODON_03317532": "angelica (crystallized)",
    "FOODON_03543237": "32370 - juice concentrate, gooseberry (efsa foodex2)",
    "FOODON_03303805": "chocolate candy (herb-filled)",
    "FOODON_03541223": "12230 - gold of pleasure seeds (efsa foodex2)",
    "FOODON_03540135": "01350 - rye-wheat bread, refined flour (efsa foodex2)",
    "FOODON_03310320": "mushroom (frozen)",
    "FOODON_03543091": "30910 - animal and vegetable fats and oils and primary derivatives thereof (efsa foodex2)",
    "ENVO_00000117": "plantation",
    "FOODON_03305232": "cocoa-flavored product",
    "FOODON_03301424": "bee pollen",
    "NCBITaxon_9479": "Platyrrhini",
    "FOODON_03301794": "half and half",
    "CHEBI_22314": "alkali metal atom",
    "FOODON_03542607": "26070 - edible insect pupae/nymphs (efsa foodex2)",
    "FOODON_03412463": "horse gram bean plant",
    "FOODON_03304622": "hen egg liquid (partially heat treated)",
    "FOODON_03541096": "10960 - field (maple) pea (dry seeds) (efsa foodex2)",
    "FOODON_03400803": "seafood product (eurofir)",
    "FOODON_03316771": "cocoa (breakfast)",
    "NCBITaxon_6615": "Loliginidae",
    "FOODON_03542642": "26420 - marinated / pickled seafood (efsa foodex2)",
    "FOODON_03544156": "41560 - whey protein (efsa foodex2)",
    "FOODON_03412284": "humpback whitefish",
    "NCBITaxon_195335": "Sphyrna zygaena",
    "FOODON_03302601": "butter-flavored table syrup",
    "FOODON_03411580": "yellow field corn plant",
    "FOODON_03544324": "43240 - mocca flavour (efsa foodex2)",
    "FOODON_03540114": "01140 - maize germ (efsa foodex2)",
    "FOODON_03510119": "processing-related claim or use",
    "FOODON_03460247": "partial fat removal process",
    "NCBITaxon_170825": "Squatina californica",
    "NCBITaxon_259987": "Opisthonema libertate",
    "FOODON_03412503": "red nutsedge plant",
    "NCBITaxon_6682": "Eucarida",
    "NCBITaxon_426484": "Mugil liza",
    "FOODON_03303646": "aperitif beverage",
    "FOODON_00003186": "leavening agent",
    "FOODON_03540905": "09050 - wild betel leaves (efsa foodex2)",
    "FOODON_03302163": "imitation black cherry carbonated beverage",
    "FOODON_03543672": "36720 - red cinchona (infusion bark) (efsa foodex2)",
    "FOODON_03302537": "peanut brittle (butter-flavored)",
    "FOODON_03541518": "15180 - gages (efsa foodex2)",
    "FOODON_03401829": "10006325 - tomato ketchup/ketchup substitutes (shelf stable) (gs1 gpc)",
    "FOODON_03305150": "cherry (pitted)",
    "GAZ_00002956": "Slovak Republic",
    "FOODON_03400700": "10  vegetable oils (efg)",
    "CHEBI_24651": "hydroxides",
    "NCBITaxon_163111": "Molva",
    "PATO_0001241": "physical object quality",
    "FOODON_03309245": "tautog (raw)",
    "FOODON_03302840": "whipping cream cake mix",
    "FOODON_03315341": "vegetable (raw, processed, simple)",
    "FOODON_03413929": "pomatoschistus",
    "FOODON_03309480": "buffalo chip",
    "FOODON_03315581": "veal (preserved, jellied)",
    "FOODON_03411201": "dairy cow",
    "FOODON_03490106": "glass container, tinless steel lid",
    "FOODON_03542469": "24690 - fish roe (efsa foodex2)",
    "FOODON_03308054": "clam (minced, water added, frozen)",
    "FOODON_03414790": "terminalia plant",
    "CHEBI_47916": "flavonoid",
    "FOODON_03401592": "10006059 - marjoram (gs1 gpc)",
    "FOODON_03401788": "10006416 - arrowroot (gs1 gpc)",
    "FOODON_03413535": "tuberculate abalone",
    "HANCESTRO_0016": "African American or Afro-Caribbean",
    "FOODON_03411911": "fish, squaliform",
    "FOODON_03411988": "trumpeter family",
    "CHEBI_18133": "hexose",
    "FOODON_03304739": "diet beverage mix (lemon-flavored, dry)",
    "FOODON_00002369": "obsolete: yeast refined food product",
    "FOODON_03306363": "fruit nectar",
    "NCBITaxon_174392": "Lithodes aequispinus",
    "CHEBI_47882": "cyclic polypyrrole",
    "FOODON_03420239": "root, tuber or bulb, with peel",
    "FOODON_03411511": "dover sole",
    "CHEBI_78295": "food component",
    "FOODON_03302147": "pheasant (raw)",
    "HANCESTRO_0360": "Estonian",
    "FOODON_03315094": "flavoring compound",
    "FOODON_03304812": "sea steak made from cod and haddock",
    "NCBITaxon_13602": "Makaira",
    "GAZ_00003940": "Metropolitan France",
    "FOODON_03316677": "fish portion (breaded, quick-frozen)",
    "NCBITaxon_6701": "Pandalidae",
    "FOODON_03520127": "south america - inland waters (fao major fishing areas 03)",
    "FOODON_03309647": "salmon spread",
    "FOODON_03542248": "22480 - amur catfish (efsa foodex2)",
    "FOODON_03542169": "21690 - liver-type sausage (efsa foodex2)",
    "FOODON_03530191": "fat content > 50%",
    "FOODON_00002326": "uncured cheese food product",
    "FOODON_03306838": "papaya (dehydrated)",
    "FOODON_00002444": "limpet food product",
    "FOODON_03316755": "dextrose anhydrous",
    "FOODON_03302124": "betel nut (whole, raw)",
    "FOODON_03310743": "cardamom ground",
    "FOODON_03540477": "04770 - savoy cabbages (efsa foodex2)",
    "FOODON_03540038": "00380 - rice grain (efsa foodex2)",
    "NCBITaxon_3977": "Euphorbiaceae",
    "FOODON_03543762": "37620 - follow-on formula, milk-based, powder (efsa foodex2)",
    "FOODON_03304996": "soybean substance",
    "CHEBI_24315": "glutamic acid derivative",
    "PO_0009047": "stem",
    "NCBITaxon_4222": "Carthamus tinctorius",
    "FOODON_03400811": "fish oils (eurofir)",
    "FOODON_03317606": "nut yogurt (flavored)",
    "FOODON_03542966": "29660 - hen egg mixed whole (efsa foodex2)",
    "CHEBI_27314": "water-soluble vitamin",
    "FOODON_03311525": "flour (unbleached)",
    "FOODON_03544006": "40060 - potato soup (efsa foodex2)",
    "FOODON_03302423": "apple drink (artificially flavored, vitamin-fortified, frozen concentrate)",
    "FOODON_03302340": "whole wheat flour",
    "FOODON_03510224": "food allergen labelling about sesame seeds and products thereof",
    "NCBITaxon_129037": "Belone belone",
    "FOODON_03302992": "farmer cheese",
    "FOODON_03412959": "black radish plant",
    "FOODON_03400730": "07  pulses, seeds, kernels, nuts and products (eurocode2)",
    "FOODON_03460755": "wheat malt",
    "RO_0002410": "causally related to",
    "FOODON_03302171": "beef bone marrow extract for flavoring",
    "FOODON_03302353": "hen egg (shell off, solids, dried, finely ground)",
    "FOODON_03303141": "shortcake biscuit",
    "FOODON_03450011": "cooking by microwave",
    "FOODON_00002234": "shallot food product",
    "FOODON_03460100": "flavoring or spice extract or concentrate",
    "FOODON_03543106": "31060 - sunflower seed oil, edible (efsa foodex2)",
    "FOODON_03400941": "10000305 - dried breads (frozen) (gs1 gpc)",
    "FOODON_03302978": "parmesan cheese (grated)",
    "FOODON_03510085": "very low salt claim or use",
    "CHEBI_36688": "heterotricyclic compound",
    "FOODON_03302789": "tomato catsup (homogenized)",
    "FOODON_03317219": "shrimp or prawn (cooked, quick-frozen)",
    "FOODON_03542766": "27660 - cheese, taleggio (efsa foodex2)",
    "FOODON_03542434": "24340 - butterfish (efsa foodex2)",
    "CHEBI_28966": "chlorophyll",
    "FOODON_03401047": "10000277 - yoghurt/yoghurt substitutes (frozen) (gs1 gpc)",
    "FOODON_03413350": "spotted wolffish",
    "FOODON_03301834": "oyster (canned)",
    "FOODON_03311784": "virginia peanut (whole, raw)",
    "FOODON_03304410": "flan (artificially sweetened)",
    "FOODON_03544293": "42930 - hot and spicy flavour (efsa foodex2)",
    "FOODON_03420264": "obsolete: bark",
    "FOODON_03411702": "rice bean plant",
    "NCBITaxon_150435": "Panulirus regius",
    "FOODON_03543350": "33500 - wine, white (efsa foodex2)",
    "CHEBI_15940": "nicotinic acid",
    "FOODON_00001098": "fermented apple beverage",
    "FOODON_03413321": "xanthan gum",
    "FOODON_03543840": "38400 - non dairy coffee creamer (efsa foodex2)",
    "FOODON_03306048": "corn cob syrup",
    "GAZ_00002557": "State of New Jersey",
    "NCBITaxon_4719": "Phoenix",
    "FOODON_03304810": "oyster (smoked)",
    "FOODON_03305971": "marmalade (artificially sweetened)",
    "HANCESTRO_0025": "Singaporean Chinese",
    "FOODON_03311552": "dough",
    "FOODON_03414141": "spinycheek crayfish",
    "NCBITaxon_195623": "Lepidopsetta bilineata",
    "FOODON_00001677": "cabbage vegetable food product",
    "NCBITaxon_8459": "Testudines",
    "NCBITaxon_304130": "Physalis philadelphica",
    "CHEBI_38702": "inorganic sodium salt",
    "FOODON_03544140": "41400 - piccalilly pickle (efsa foodex2)",
    "NCBITaxon_43714": "Acronychia",
    "FOODON_03412279": "limpet",
    "FOODON_03541371": "13710 - sichuan pepper fruit and similar- (efsa foodex2)",
    "FOODON_03411065": "butter clam",
    "FOODON_03310218": "pesto sauce",
    "FOODON_03317045": "egg-based dessert with no added sugar",
    "FOODON_03308990": "olive rockfish (raw)",
    "CHEBI_24870": "ion",
    "FOODON_03302397": "lemon-flavored beverage base (artifically sweetened, powdered)",
    "NCBITaxon_172659": "Parophrys vetulus",
    "FOODON_03544355": "43550 - pumpkin flavour (efsa foodex2)",
    "FOODON_03413567": "shaggy sponge crab",
    "FOODON_03306759": "peach pie",
    "NCBITaxon_74476": "Himanthaliaceae",
    "FOODON_03401695": "10006830 - armenian cucumber (gs1 gpc)",
    "FOODON_03530173": "oil content > 50%",
    "FOODON_03544290": "42900 - honey-cinnamon-flavored flavour (efsa foodex2)",
    "UBERON_0002385": "muscle tissue",
    "FOODON_03305520": "cream (frozen)",
    "FOODON_03414692": "amyema plant",
    "FOODON_03308571": "shrimp (breaded, frozen)",
    "FOODON_03544288": "42880 - hibyscus flavour (efsa foodex2)",
    "FOODON_00001028": "Brie cheese food product",
    "NCBITaxon_8855": "Cairina moschata",
    "FOODON_03510238": "traditional type of production and/or processing claim or use",
    "FOODON_00001161": "citrus fruit extract food product",
    "RO_0000056": "participates in",
    "NCBITaxon_51350": "Brassica rapa subsp. rapa",
    "ENVO_01001119": "composted animal manure",
    "FOODON_00002235": "shark food product",
    "ENVO_00003885": "brewery",
    "FOODON_03310163": "frankfurter (oven-baked)",
    "FOODON_03413164": "monosodium citrate",
    "FOODON_03412655": "squirrelfish family",
    "NCBITaxon_3684": "Passiflora",
    "NCBITaxon_9979": "Leporidae",
    "FOODON_03541988": "19880 - bovine and pig, fresh fat tissue (efsa foodex2)",
    "IAO_0000109": "measurement datum",
    "FOODON_00002657": "food (steamed)",
    "FOODON_03305836": "split peas (cooked, dried, coated with oil)",
    "FOODON_03411345": "yeast",
    "FOODON_03414804": "flood plain mussel",
    "ENVO_00000004": "administrative region",
    "FOODON_03542173": "21730 - mortadella-type sausage (efsa foodex2)",
    "NCBITaxon_986140": "Cyperoideae",
    "FOODON_03308185": "land crab (raw)",
    "FOODON_03317566": "cidre bouche",
    "FOODON_03542994": "29940 - mono- di-saccharides other than sucrose (efsa foodex2)",
    "FOODON_03306175": "fruit-flavored punch (canned)",
    "FOODON_00001967": "imitation food product",
    "FOODON_03305024": "cherry fruitcake",
    "FOODON_00001923": "grape based distilled spirit",
    "FOODON_00002518": "heifer",
    "CHEBI_22290": "aldaric acid",
    "FOODON_03413822": "sandsmelt",
    "FOODON_00002886": "synbiotic claim or use",
    "FOODON_03301879": "sugar cane stem (raw)",
    "FOODON_03310355": "cassava (dried)",
    "FOODON_00001061": "bacon food product",
    "FOODON_03316852": "roll or bun (whole wheat)",
    "FOODON_03308242": "little lobster (raw)",
    "FOODON_03303386": "chop suey vegetables with imitation chicken",
    "FOODON_00002080": "pancake or waffle food product",
    "FOODON_00002864": "Blaufr\u00e4nkisch wine",
    "FOODON_03303572": "pasteurized process pimiento cheese spread",
    "FOODON_03315166": "pancake mix",
    "FOODON_03542103": "21030 - chicken feet (efsa foodex2)",
    "FOODON_03400431": "neutralizing agent (codex)",
    "FOODON_03542630": "26300 - canned anchovies (efsa foodex2)",
    "FOODON_03301310": "onion ring (breaded, frozen)",
    "FOODON_03305752": "orange and tangerine juice blend (food product)",
    "FOODON_03490166": "plastic bag or pouch",
    "FOODON_03412921": "eugenia plant",
    "FOODON_03411384": "lingcod",
    "FOODON_03307275": "pasteurized process cheese spread with chive and spice",
    "FOODON_03401484": "10006271 - chickpeas (gs1 gpc)",
    "FOODON_03414494": "knotweed family",
    "FOODON_03541996": "19960 - horse, fresh fat tissue (efsa foodex2)",
    "FOODON_03543639": "36390 - pale echinacea infusion roots (efsa foodex2)",
    "FOODON_03315141": "fat of meat from animals except poultry (uncooked)",
    "FOODON_03450030": "cooking with inherent fat or oil",
    "FOODON_03542370": "23700 - groupers (efsa foodex2)",
    "FOODON_03544126": "41260 - herbs, vegetables and oil sauces (efsa foodex2)",
    "FOODON_00001085": "evaporated milk food product",
    "NCBITaxon_81635": "Micromesistius",
    "FOODON_03305749": "cactus juice (food product)",
    "FOODON_03309964": "poultry seasoning (dry)",
    "FOODON_03510019": "cattle as consumer",
    "NCBITaxon_69694": "Strombidae",
    "FOODON_03411729": "celeriac plant",
    "FOODON_03540214": "02140 - short sweet pastry doughs (pate sucree, sablee) (efsa foodex2)",
    "FOODON_03307842": "tomato (solid pack, canned)",
    "FOODON_00002236": "sheep meat food product",
    "FOODON_00002749": "brown bean (whole)",
    "FOODON_03490111": "laminate tube, ends lined with cork",
    "FOODON_03411858": "golden kingklip",
    "NCBITaxon_64108": "Zeus faber",
    "HANCESTRO_0452": "Emirati",
    "FOODON_03412418": "welsh onion plant",
    "FOODON_03411505": "lobster",
    "FOODON_03543867": "38670 - fish and potatoes meal (efsa foodex2)",
    "FOODON_03530148": "cheese rind (artificial)",
    "FOODON_03412010": "pigeon pea plant",
    "FOODON_03542476": "24760 - mullet roe (efsa foodex2)",
    "FOODON_03540335": "03350 - muesli and similar mixed breakfast cereals (efsa foodex2)",
    "FOODON_03309831": "sorghum malt",
    "FOODON_00001782": "cow milk snack",
    "FOODON_03541007": "10070 - manna ashes (trunk sap) (efsa foodex2)",
    "CHEBI_33352": "manganese group element atom",
    "FOODON_03414914": "sea aster plant",
    "FOODON_03305394": "papain (freeze-dried)",
    "FOODON_03311443": "obsolete: potato hash brown shred made from idaho burbank russet potato",
    "FOODON_03310869": "pudding mix (instant)",
    "NCBITaxon_29146": "Acanthuridae",
    "HANCESTRO_0364": "German",
    "FOODON_03301531": "tangerine (canned)",
    "NCBITaxon_224718": "Anchoa mitchilli",
    "FOODON_03302924": "smoked meat (vacuum-packed)",
    "CHEBI_33424": "sulfur oxoacid derivative",
    "NCBITaxon_173318": "Carangoides bartholomaei",
    "CHEBI_15693": "aldose",
    "NCBITaxon_179536": "Epinephelus aeneus",
    "FOODON_03305767": "grapefruit juice (artificially sweetened)",
    "FOODON_03520495": "mild climatic zone",
    "FOODON_03544080": "40800 - miscellaneous savoury extracts (efsa foodex2)",
    "FOODON_03411523": "pyrus pyrifolia",
    "FOODON_03543756": "37560 - infant formula, milk-based, liquid (efsa foodex2)",
    "GAZ_00005282": "United Arab Emirates",
    "NCBITaxon_130426": "Allium chinense",
    "NCBITaxon_31345": "Bangiaceae",
    "FOODON_03411172": "garbanzo bean plant",
    "FOODON_03316661": "edible pastes in aqueous solution",
    "FOODON_03301188": "artichoke heart",
    "FOODON_03543379": "33790 - unsweetened spirits (efsa foodex2)",
    "CHEBI_48408": "ethyl vanillin",
    "FOODON_03413803": "estuarine crocodile",
    "RO_0002216": "capable of part of",
    "FOODON_03530197": "fat content 31-45%",
    "NCBITaxon_91882": "campanulids",
    "FOODON_00002226": "saury food product",
    "FOODON_03413455": "black chokeberry plant",
    "FOODON_03304205": "chicken soup a la reine",
    "FOODON_03544263": "42630 - fennel flavour (efsa foodex2)",
    "FOODON_00003228": "plum tomato (whole, raw)",
    "FOODON_00001023": "mammalian milk butter",
    "FOODON_03310820": "gravy",
    "FOODON_03303642": "candy (vitamin-fortified)",
    "FOODON_03301579": "mustard greens (raw)",
    "FOODON_03411582": "honeydew melon plant",
    "NCBITaxon_127826": "Trachurus trecae",
    "FOODON_03400244": "fondant (us cfr)",
    "FOODON_03302567": "pimiento cheese spread",
    "FOODON_03543622": "36220 - common jasmine infusion flowers (efsa foodex2)",
    "FOODON_03490424": "closing capsule",
    "FOODON_03302267": "tom collins mix (artificially sweetened)",
    "FOODON_03303095": "coffee (roasted, ground, spent)",
    "FOODON_03401031": "10000030 - cheese/cheese substitutes (frozen) (gs1 gpc)",
    "ENVO_00000086": "plain",
    "FOODON_03415122": "european centaury plant",
    "FOODON_03544046": "40460 - potato starch-based snacks (efsa foodex2)",
    "FOODON_03308408": "abalone (canned)",
    "CHEBI_35489": "organic disulfide",
    "FOODON_03302021": "candied citrus peel",
    "FOODON_03304582": "french dressing (low calorie)",
    "FOODON_00003348": "Gala apple",
    "FOODON_03413886": "blue grenadier",
    "FOODON_03304625": "waterfly egg (canned)",
    "FOODON_03412327": "roughy",
    "FOODON_03430116": "divided into halves",
    "FOODON_03316507": "twiglet (salty biscuit)",
    "FOODON_03541968": "19680 - turkey, minced meat (efsa foodex2)",
    "FOODON_03460374": "carboxymethyl cellulose",
    "FOODON_00003169": "rambutan (whole, raw)",
    "FOODON_03414264": "purple crowberry plant",
    "FOODON_03317241": "fish (gutted, fresh)",
    "FOODON_03541456": "14560 - mandarins (efsa foodex2)",
    "FOODON_03541150": "11500 - pecans (efsa foodex2)",
    "NCBITaxon_21910": "Verbenaceae",
    "FOODON_03305007": "mole sauce",
    "FOODON_03304611": "ice cream (artificially nut flavored)",
    "FOODON_03542572": "25720 - sea-cucumbers (efsa foodex2)",
    "FOODON_03310375": "moreton bay chestnut black bean (raw)",
    "NCBITaxon_490273": "Plectorhinchus macrolepis",
    "FOODON_03413984": "kanadi kingfish",
    "FOODON_03401460": "10006342 - greens (texas mustard) (gs1 gpc)",
    "FOODON_03308122": "clam (soft shell, in shell, raw)",
    "FOODON_03310973": "ham (fried)",
    "FOODON_03307391": "oyster cocktail",
    "FOODON_03316858": "cheese (washed curd for maufacturing)",
    "FOODON_03541627": "16270 - dwarf elderberries (efsa foodex2)",
    "FOODON_03302344": "white bread (corn top, enriched)",
    "FOODON_03543114": "31140 - palm oil/fat (efsa foodex2)",
    "FOODON_03304802": "pecan cluster candy",
    "FOODON_03414878": "pacu",
    "FOODON_03301101": "orange pulpwash solids",
    "FOODON_03301946": "baked beans (dish)",
    "FOODON_00001954": "obsolete: horseradish food product",
    "NCBITaxon_39109": "Sphoeroides",
    "NCBITaxon_217037": "Vaccinioideae",
    "NCBITaxon_193309": "Pyracantha coccinea",
    "FOODON_03306014": "orange juice (sweetened, pasteurized)",
    "FOODON_03307670": "turkey roast",
    "FOODON_03302230": "grape carbonated beverage (naturally and artififically flavored)",
    "FOODON_03303186": "blackberry juice (food product)",
    "GAZ_00006900": "Nauru",
    "FOODON_03316039": "sugar topping",
    "BFO_0000001": "entity",
    "NCBITaxon_7997": "Ictalurus",
    "FOODON_03307864": "iced tea mix (artificially sweetened)",
    "FOODON_03306726": "sweet green pepper (whole, raw)",
    "FOODON_03543530": "35300 - norway spruce infusion leaves (efsa foodex2)",
    "FOODON_03413409": "black nightshade plant",
    "FOODON_03301625": "food (acidified)",
    "FOODON_03303033": "chicken back (raw)",
    "FOODON_00002763": "dry bean pod",
    "FOODON_03542769": "27690 - soft-ripened cheese with bloomy rind (white mould) (brie, camembert type) (efsa foodex2)",
    "FOODON_03311476": "wheat and milk infant cereal (iron-fortified)",
    "ENVO_00003861": "industrial building",
    "NCBITaxon_617122": "Apsilus dentatus",
    "NCBITaxon_114455": "Macrozamia",
    "CHEBI_36294": "hexacyanoferrate(4-) salt",
    "FOODON_00002434": "mushroom food product",
    "NCBITaxon_495042": "Cetengraulis",
    "FOODON_03305284": "cream (sterilized)",
    "FOODON_03310810": "nut (dried)",
    "FOODON_03413391": "tropical or subtropical fruit - inedible peel plant",
    "ENVO_0010001": "anthropogenic environmental material",
    "FOODON_03306478": "game meat (frozen)",
    "NCBITaxon_191813": "Somniosus microcephalus",
    "FOODON_03308219": "maine oyster (raw)",
    "FOODON_03540553": "05530 - banana flowers - paradisiaca cultivars (efsa foodex2)",
    "NCBITaxon_195657": "Trinectes",
    "FOODON_03543170": "31700 - juice, berry-grape (efsa foodex2)",
    "NCBITaxon_8476": "Emydidae",
    "FOODON_03303621": "lemon-flavored cocktail mix (sweet-sour)",
    "CHEBI_22918": "branched-chain amino acid",
    "FOODON_03306526": "spaghetti macaroni (oriental-style)",
    "FOODON_03540452": "04520 - other leafy vegetables (efsa foodex2)",
    "CHEBI_48232": "calcium oxides",
    "FOODON_00001625": "avocado food product",
    "FOODON_03301681": "waffle mix (chocolate-flavored)",
    "FOODON_03303216": "cracker (unsalted)",
    "FOODON_03540001": "00010 - grains and grain-based products (efsa foodex2)",
    "FOODON_03311478": "apricot (structured)",
    "NCBITaxon_9119": "Rallidae",
    "FOODON_03413616": "branchiopod",
    "FOODON_03413188": "polydextrose",
    "FOODON_03544295": "42950 - jasmine flavour (efsa foodex2)",
    "NCBITaxon_38609": "Diprotodontia",
    "FOODON_03302923": "custard powder",
    "FOODON_03315397": "beverage mix (cocoa based)",
    "NCBITaxon_6596": "Mercenaria mercenaria",
    "FOODON_03540702": "07020 - watermelons (efsa foodex2)",
    "FOODON_03543009": "30090 - sugar beet syrup (efsa foodex2)",
    "CHEBI_25186": "p-menthane monoterpenoid",
    "FOODON_00002238": "cocos fruit product",
    "NCBITaxon_67555": "Rhinichthys",
    "FOODON_03307064": "poultry (raw)",
    "FOODON_03310607": "potato hash brown",
    "NCBITaxon_3649": "Carica papaya",
    "FOODON_03315438": "dip for food",
    "HANCESTRO_0443": "Lebanese",
    "FOODON_03544492": "44920 - zinc (efsa foodex2)",
    "FOODON_00001654": "blackeyed pea vegetable food product",
    "FOODON_03543765": "37650 - follow-on formula, based on protein hydrolysates, powder (efsa foodex2)",
    "FOODON_03414346": "tucum plant",
    "CHEBI_85122": "paraben",
    "FOODON_00001303": "obsolete - has taxonomic identifier",
    "FOODON_03540997": "09970 - common polypody roots (efsa foodex2)",
    "FOODON_03411777": "yellowtail rockfish",
    "FOODON_03310039": "doliches bean (whole)",
    "FOODON_03500037": "polyvinyl chloride surface",
    "FOODON_03401119": "10000290 - vegetable based products / meals - not ready to eat (perishable) (gs1 gpc)",
    "FOODON_03530047": "cut of meat, composite",
    "FOODON_03542238": "22380 - tilapias and similar (efsa foodex2)",
    "NCBITaxon_84683": "Solenoceridae",
    "FOODON_03542123": "21230 - spalla cotta (efsa foodex2)",
    "FOODON_03541228": "12280 - castor beans and similar- (efsa foodex2)",
    "FOODON_00002504": "tualag honey",
    "FOODON_03302184": "balut",
    "FOODON_03411747": "wakame kelp",
    "FOODON_03307544": "sugar coating for doughnut",
    "FOODON_03304729": "olive oil (canned)",
    "FOODON_03306453": "meat (powdered, freeze-dried)",
    "FOODON_03530013": "commercial grade",
    "FOODON_00002338": "walnut food product",
    "FOODON_03541955": "19550 - wild boar, minced meat (efsa foodex2)",
    "FOODON_03412126": "coffee or tea plant",
    "FOODON_03460144": "sodium added",
    "FOODON_00001886": "fruit candy food product",
    "FOODON_03543244": "32440 - juice concentrate, strawberry (efsa foodex2)",
    "FOODON_00002186": "rape fat or oil refined food product",
    "FOODON_03543896": "38960 - potato croquettes (efsa foodex2)",
    "FOODON_03316723": "nectar (small fruit, pulpy)",
    "FOODON_03315865": "bacon side",
    "FOODON_03413504": "plover",
    "HANCESTRO_0384": "Moldovan",
    "FOODON_03541085": "10850 - rice beans (dry) (efsa foodex2)",
    "FOODON_03315159": "vitamin and mineral wafer",
    "FOODON_03315163": "vegetable juice (dried)",
    "FOODON_03412302": "inconnu",
    "FOODON_03311224": "scallop (freeze-dried)",
    "FOODON_03413091": "distarch phosphate",
    "FOODON_03411264": "bonito",
    "FOODON_03400272": "cacao or chocolate product (us cfr)",
    "FOODON_03306727": "pepper (sweet, pickled)",
    "FOODON_03412513": "bilimbi plant",
    "FOODON_03542362": "23620 - miscellaneous coastal marine fishes (efsa foodex2)",
    "FOODON_03544231": "42310 - cherry flavour (efsa foodex2)",
    "FOODON_03413595": "mozambique lobster",
    "FOODON_03306534": "oyster mushroom (whole)",
    "NCBITaxon_9709": "Phocidae",
    "FOODON_03308352": "bear claw lobster (raw)",
    "FOODON_03305564": "guarana nectar (food product)",
    "CHEBI_33628": "elemental aluminium",
    "FOODON_03305298": "miracle fruit (whole, raw)",
    "NCBITaxon_36609": "Cydonia",
    "FOODON_03304204": "sauce italienne",
    "FOODON_03411532": "halibut",
    "FOODON_03415095": "mugo pine plant",
    "NCBITaxon_1308840": "Salsoleae",
    "FOODON_03541723": "17230 - star apples (efsa foodex2)",
    "FOODON_03420299": "obsolete: hypocotyl",
    "FOODON_03544416": "44160 - vanilla essence (efsa foodex2)",
    "FOODON_03470155": "preservation by adding organic acids or salts",
    "FOODON_03317555": "mollusc (frozen)",
    "NCBITaxon_7782": "Leucoraja erinacea",
    "CHEBI_17608": "D-aldohexose",
    "FOODON_03303591": "chocolate-coated banana (frozen)",
    "FOODON_03308314": "coho salmon (raw)",
    "FOODON_03309992": "bacon (smoked)",
    "FOODON_03302953": "cherry in rum-flavored syrup",
    "FOODON_03307821": "coca tea leaves (food product)",
    "FOODON_03316506": "cocoa pulp",
    "FOODON_00002856": "vegetable oil (fully hydrogenated)",
    "HANCESTRO_0425": "Surinamese",
    "GAZ_00000558": "Turkey",
    "FOODON_03305561": "red grapefruit",
    "FOODON_03412741": "llama",
    "FOODON_03411072": "sultana grape plant",
    "PATO_0000570": "increased height",
    "FOODON_03510117": "caffeine free claim or use",
    "FOODON_03413976": "short mackerel",
    "FOODON_03541766": "17660 - sapodillas (efsa foodex2)",
    "GAZ_00002931": "Venezuela",
    "FOODON_03414376": "nyala",
    "FOODON_03315059": "filling (frozen, nondairy)",
    "FOODON_03414881": "pacific fat sleeper",
    "FOODON_03543276": "32760 - fortified bottled water (efsa foodex2)",
    "NCBITaxon_163742": "Trifolieae",
    "NCBITaxon_6705": "Homarus",
    "FOODON_00001299": "caprine milk beverage (raw)",
    "FOODON_03542954": "29540 - quail eggs (efsa foodex2)",
    "FOODON_03543817": "38170 - algae based formulations (e.g. spirulina, chlorella) (efsa foodex2)",
    "FOODON_03304330": "orange beverage syrup",
    "FOODON_03304424": "tomato catsup (low-sodium, sugar-free)",
    "FOODON_03540350": "03500 - extruded breakfast cereal products (efsa foodex2)",
    "FOODON_03541769": "17690 - guavas and similar- (efsa foodex2)",
    "NCBITaxon_70285": "Thymallus arcticus",
    "FOODON_00003397": "ginkgo nut",
    "FOODON_03400718": "28  eggs (efg)",
    "FOODON_03308800": "seafood gumbo mix",
    "FOODON_00001074": "barley malt vinegar",
    "FOODON_03540028": "00280 - barnyard millet (efsa foodex2)",
    "FOODON_00003376": "cell-based technology food product",
    "FOODON_03542074": "20740 - bovine other slaughtering products (efsa foodex2)",
    "FOODON_03411829": "barracuda family",
    "FOODON_03307078": "turkey (stuffed, frozen)",
    "FOODON_03543094": "30940 - olive oils (efsa foodex2)",
    "FOODON_03309389": "carrot root (raw, whole or parts)",
    "FOODON_03304512": "clam bisque soup",
    "FOODON_03540532": "05320 - romanesco cauliflowers (efsa foodex2)",
    "FOODON_03316068": "obsolete: bread wholemeal",
    "GAZ_00002474": "Syria",
    "FOODON_03540077": "00770 - rice flour (efsa foodex2)",
    "FOODON_03510246": "high polyunsaturated fat",
    "GAZ_00002912": "Ecuador",
    "FOODON_03414016": "white grouper",
    "FOODON_00003330": "chicken thigh (with skin)",
    "HANCESTRO_0486": "Bhutanese",
    "FOODON_03540618": "06180 - black gram (young pods) (efsa foodex2)",
    "FOODON_00002111": "pepper vegetable food product",
    "FOODON_03401706": "10005963 - bilimbi (gs1 gpc)",
    "FOODON_03309592": "tobacco chewing gum",
    "FOODON_03302262": "lime sherbet base",
    "FOODON_03540475": "04750 - pointed head cabbages (efsa foodex2)",
    "NCBITaxon_110925": "Jasus tristani",
    "NCBITaxon_177219": "Coenobitidae",
    "FOODON_03305445": "grains of paradise",
    "HANCESTRO_0470": "Marshallese",
    "NCBITaxon_180772": "Vaccinium vitis-idaea",
    "FOODON_03430141": "cut into long pieces",
    "HANCESTRO_0482": "Tuvaluan",
    "FOODON_03414697": "scurvy weed plant",
    "FOODON_03303505": "longhorn cheddar cheese",
    "NCBITaxon_480368": "Borassus aethiopum",
    "FOODON_03540291": "02910 - pastry based on laminated dough (efsa foodex2)",
    "NCBITaxon_721813": "Maleae",
    "FOODON_03540669": "06690 - cucumbers and similar- (efsa foodex2)",
    "FOODON_03308343": "american lobster (raw)",
    "NCBITaxon_4682": "Allium sativum",
    "FOODON_00002779": "jack-bean food product",
    "FOODON_03413751": "food supplements, vitamin substances (ec)",
    "FOODON_03541376": "13760 - caraway fruit (efsa foodex2)",
    "NCBITaxon_8041": "Hucho",
    "FOODON_03530142": "entre-cote",
    "FOODON_00001956": "hot pepper food product",
    "FOODON_03310846": "carrot (raw, diced)",
    "NCBITaxon_319776": "Paralichthys californicus",
    "NCBITaxon_9918": "Bubalus",
    "FOODON_03415146": "mullein plant",
    "FOODON_03308931": "jewfish (raw)",
    "HANCESTRO_0335": "Barbadian",
    "FOODON_03490109": "laminate tube, ends lined with laminate",
    "FOODON_03413633": "atlantic mud shrimp",
    "NCBITaxon_9860": "Cervus elaphus",
    "FOODON_03544473": "44730 - vitamins (efsa foodex2)",
    "FOODON_03317195": "cake with moist topping and filling",
    "NCBITaxon_875777": "Harengula thrissina",
    "FOODON_03520522": "aaland islands",
    "FOODON_03306258": "obsolete: beverage base",
    "FOODON_03541094": "10940 - garden peas (dry) (efsa foodex2)",
    "FOODON_00002551": "triple sec",
    "FOODON_03308099": "norwegian herring (raw)",
    "FOODON_03308905": "japanese flounder (raw)",
    "FOODON_03413120": "hydroxypropyl cellulose",
    "FOODON_00002010": "low-alcohol wine food product",
    "FOODON_03413457": "king threadfin",
    "FOODON_03310594": "raspberry (frozen)",
    "FOODON_03411524": "sea bass family",
    "FOODON_03412426": "freshwater bass",
    "NCBITaxon_117861": "Leucoraja",
    "FOODON_03309002": "colorado snapper (raw)",
    "FOODON_03414972": "custard apple family",
    "FOODON_03411848": "gulf menhaden",
    "FOODON_03308187": "snow crab (raw)",
    "FOODON_00001973": "obsolete: infant food product",
    "FOODON_03302751": "pudding (custard-flavored)",
    "FOODON_03490116": "ceramic or earthenware container",
    "FOODON_03541519": "15190 - japanese plums (efsa foodex2)",
    "FOODON_03307221": "watermelon juice cocktail (food product)",
    "FOODON_03401737": "10006147 - sweetcorn (gs1 gpc)",
    "FOODON_03308303": "salmon steak (frozen)",
    "FOODON_03401566": "10006334 - anise (gs1 gpc)",
    "FOODON_03412093": "mule",
    "FOODON_03541951": "19510 - european moose meat (efsa foodex2)",
    "FOODON_03520148": "pacific, eastern central (fao major fishing area 77)",
    "FOODON_03316443": "wafer",
    "FOODON_00002559": "Red Delicious apple tree",
    "FOODON_03413153": "mixed acetic and tartaric acid esters of  mono- and diglycerides of fatty acids",
    "ENVO_01000060": "particulate matter",
    "CHEBI_26714": "sodium salt",
    "FOODON_03310776": "fruit punch homemade prepared with fruit",
    "NCBITaxon_119949": "Myrtus communis",
    "FOODON_03301299": "peanut (whole, raw)",
    "FOODON_03310811": "meat analog",
    "FOODON_03542492": "24920 - moonsoon river prawn (efsa foodex2)",
    "FOODON_03306409": "mayonnaise analog",
    "FOODON_03301024": "honey (raw)",
    "FOODON_03401845": "10006760 - naranjilla/lulo (gs1 gpc)",
    "FOODON_03500051": "food contact surface from human-made material",
    "FOODON_00002907": "walking catfish",
    "FOODON_03543179": "31790 - juice, cassis (efsa foodex2)",
    "FOODON_03530291": "organic food production",
    "FOODON_03304003": "goulash sauce",
    "FOODON_03543526": "35260 - mulberry (black and white) infusion leaves (efsa foodex2)",
    "FOODON_03543792": "37920 - food for particular diets (efsa foodex2)",
    "FOODON_03541785": "17850 - soursops (efsa foodex2)",
    "FOODON_03490185": "plastic container, rigid or semirigid, tinless steel lid",
    "FOODON_03302996": "imitation meat from textured vegetable protein",
    "FOODON_03308988": "yelloweye rockfish (raw)",
    "FOODON_03307026": "buttery seasoning",
    "FOODON_03490411": "bass fibre container",
    "NCBITaxon_373995": "Tenualosa ilisha",
    "FOODON_03301612": "pudding (canned)",
    "FOODON_03308183": "croaker (raw)",
    "FOODON_03303134": "cream cookie",
    "FOODON_03544123": "41230 - pesto (efsa foodex2)",
    "NCBITaxon_182105": "Ficus benjamina",
    "FOODON_03413119": "hydroxy propyl starch",
    "CHEBI_33659": "organic aromatic compound",
    "NCBITaxon_172266": "Tilia cordata",
    "FOODON_03543476": "34760 - common speedwell infusion leaves (efsa foodex2)",
    "CHEBI_28946": "theobromine",
    "FOODON_03414012": "pacific sandfish",
    "FOODON_03303827": "imitation butterscotch candy",
    "FOODON_03305697": "chocolate crumb",
    "HANCESTRO_0411": "Guatemalan",
    "FOODON_03302109": "beer (concentrated)",
    "FOODON_03401544": "10006362 - ferns (royal) (gs1 gpc)",
    "FOODON_03306516": "black walnut (whole, raw)",
    "FOODON_03310169": "chicken thigh (oven-baked)",
    "NCBITaxon_283035": "Sander lucioperca",
    "NCBITaxon_126903": "Physalis peruviana",
    "FOODON_03543727": "37270 - non-fermented tea, infusion (efsa foodex2)",
    "FOODON_00001784": "cow milk processed cheese product",
    "FOODON_03413731": "giant bamboo plant",
    "NCBITaxon_8574": "Boa constrictor",
    "FOODON_03412399": "scup",
    "FOODON_03311028": "crab (whole, cooked)",
    "FOODON_03316576": "jelly, zella",
    "FOODON_03411799": "blackfin snapper",
    "FOODON_03541721": "17210 - saguaro fruits (efsa foodex2)",
    "FOODON_03301252": "cherry jam",
    "FOODON_03414922": "common bamboo plant",
    "FOODON_03543326": "33260 - beverages concentrates (efsa foodex2)",
    "NCBITaxon_396786": "Lutjanus gibbus",
    "FOODON_03311814": "wheat bread (steamed)",
    "FOODON_03541750": "17500 - feijoas (efsa foodex2)",
    "NCBITaxon_3764": "Rosa",
    "FOODON_03413524": "salmon shark",
    "NCBITaxon_174187": "Amorphophallus paeoniifolius",
    "FOODON_03401247": "0700000 - hops (dried) (ec)",
    "HANCESTRO_0575": "Yoruban",
    "FOODON_03303911": "meat gelatin with madeira wine",
    "FOODON_03412978": "acetic acid esters of mono- and diglycerides of fatty acids",
    "NCBITaxon_37850": "Parastacidae",
    "FOODON_03541860": "18600 - fruit in vinegar or brine (efsa foodex2)",
    "FOODON_03309253": "cod liver in natural oil",
    "FOODON_03309895": "celery flakes",
    "FOODON_03301358": "chestnut (unripe)",
    "FOODON_03411770": "black rockfish",
    "FOODON_03543436": "34360 - cocoa mass (efsa foodex2)",
    "FOODON_03543057": "30570 - drag\u00e9e, sugar coated (efsa foodex2)",
    "FOODON_03309170": "red kingklip (raw)",
    "FOODON_03310858": "rocket (raw)",
    "FOODON_03542415": "24150 - bonito, atlantic (efsa foodex2)",
    "NCBITaxon_7675": "Echinoida",
    "FOODON_03317247": "horseradish (grated, fresh)",
    "FOODON_03304226": "chocolate cream cake",
    "FOODON_03310207": "grapefruit juice (calcium-fortified)",
    "FOODON_03301627": "turtle meat (raw)",
    "FOODON_03411158": "sweet basil plant",
    "FOODON_03302242": "orange beverage base (naturally and artificially sweetened)",
    "FOODON_03304559": "cane sugar and dextrose blend",
    "FOODON_03311637": "apple peel",
    "FOODON_00002663": "pork food product",
    "FOODON_03541385": "13850 - peppercorn (black, green and white) and similar- (efsa foodex2)",
    "FOODON_03316615": "dessert concentrate",
    "NCBITaxon_148605": "Trichodontidae",
    "NCBITaxon_314146": "Euarchontoglires",
    "FOODON_03540865": "08650 - thyme and similar- (efsa foodex2)",
    "NCBITaxon_429256": "Carissa spinarum",
    "CHEBI_33296": "alkali metal molecular entity",
    "FOODON_03308455": "chilean plated lobster (raw)",
    "FOODON_03510268": "alaskan native food claim or use",
    "FOODON_03542860": "28600 - cheese, turunmaa (efsa foodex2)",
    "FOODON_03542674": "26740 - dromedary milk (efsa foodex2)",
    "CHEBI_17478": "aldehyde",
    "FOODON_03304260": "cream vichysoise",
    "FOODON_03307504": "peach (artificially sweetened, canned)",
    "FOODON_03413873": "brazilian codling",
    "FOODON_00003377": "food harvested by hunting",
    "FOODON_03413894": "benguela hake",
    "CHEBI_25698": "ether",
    "FOODON_03541574": "15740 - bilberries (generic) (efsa foodex2)",
    "FOODON_00002306": "swine sausage",
    "FOODON_03305375": "gelatin (iodized)",
    "GAZ_00000913": "Senegal",
    "FOODON_03312048": "grape juice (thompson, seedless)",
    "FOODON_03541047": "10470 - tepary bean (fresh seeds) (efsa foodex2)",
    "FOODON_03301350": "obsolete: peanut product",
    "FOODON_03500034": "cellulose acetate surface",
    "CHEBI_30911": "glucitol",
    "FOODON_00002281": "strawberry spread or sauce",
    "FOODON_03400340": "glazing agent (including lubricants) (ec)",
    "FOODON_03544352": "43520 - pomegranate flavour (efsa foodex2)",
    "NCBITaxon_160714": "Epinephelus analogus",
    "FOODON_03315243": "dairy product (frozen)",
    "FOODON_03542969": "29690 - egg white (efsa foodex2)",
    "FOODON_00002218": "saithe food product",
    "FOODON_00001945": "hard cheese food product",
    "FOODON_03316091": "table water (prepared)",
    "FOODON_03305097": "cat food",
    "FOODON_03401303": "multi-vitamin supplement",
    "FOODON_03540589": "05890 - spring onions (efsa foodex2)",
    "NCBITaxon_8990": "Numididae",
    "PATO_0000047": "biological sex",
    "FOODON_03306938": "bread and butter pickle",
    "FOODON_03310360": "wheat meal",
    "NCBITaxon_54703": "Angelica sylvestris",
    "FOODON_03415012": "siamese cassia plant",
    "FOODON_03415072": "narrow-leaf purple coneflower plant",
    "GAZ_00002569": "Province of Quebec",
    "GAZ_00004006": "Island of Cyprus",
    "FOODON_03305650": "ice milk (artificially sweetened)",
    "CHEBI_17579": "beta-carotene",
    "FOODON_03315368": "mandoo",
    "GAZ_00003727": "Indonesia",
    "FOODON_03541446": "14460 - lemons (efsa foodex2)",
    "FOODON_03309278": "squid fillet (breaded)",
    "FOODON_03401453": "10005988 - broccoli (gs1 gpc)",
    "FOODON_03412504": "kodo millet plant",
    "NCBITaxon_284555": "Aroideae",
    "FOODON_03307350": "clingstone peach (diced, canned)",
    "FOODON_03316499": "hen egg white hydrolysate",
    "FOODON_03311142": "green olive (stuffed with anchovies, canned)",
    "FOODON_00002670": "alfalfa sprout",
    "HANCESTRO_0426": "Trinidadian or Tobagonian",
    "PATO_0001708": "1-D extent",
    "NCBITaxon_8495": "Alligator",
    "NCBITaxon_2763": "Rhodophyta",
    "FOODON_03304650": "mustard relish (food product)",
    "FOODON_03540167": "01670 - gluten free bread, white (efsa foodex2)",
    "FOODON_03316536": "brewing malt",
    "FOODON_03305272": "cheese (whipped)",
    "NCBITaxon_9031": "Gallus gallus",
    "FOODON_03541211": "12110 - milk thistle seeds (efsa foodex2)",
    "FOODON_03541453": "14530 - sweet limes (efsa foodex2)",
    "NCBITaxon_117853": "Amblyraja",
    "NCBITaxon_3605": "Vitis aestivalis",
    "NCBITaxon_3755": "Prunus dulcis",
    "FOODON_03302774": "fruitcake (imitation rum butter-flavored)",
    "FOODON_03541369": "13690 - allspice fruit and similar- (efsa foodex2)",
    "FOODON_03415053": "beach plum plant",
    "FOODON_03542676": "26760 - reindeer milk (efsa foodex2)",
    "FOODON_03302012": "frankfurter",
    "FOODON_03302708": "dark bread",
    "FOODON_03310618": "mammalian milk (ultrapasteurized)",
    "FOODON_03420137": "fruit, peel present",
    "FOODON_03315585": "spirits (extract of)",
    "FOODON_03306231": "marzipan cookie",
    "FOODON_03310058": "great northern bean (whole)",
    "FOODON_03302577": "sapote flour (food product)",
    "FOODON_03411298": "quince plant",
    "FOODON_03543127": "31270 - horse tallow (efsa foodex2)",
    "FOODON_03412195": "searobin",
    "FOODON_00001111": "equine dairy food product",
    "FOODON_03302895": "cookie (with added fiber)",
    "FOODON_00001719": "cherry nectar beverage",
    "HANCESTRO_0489": "Nepalese",
    "FOODON_03304634": "roquefort dressing",
    "NCBITaxon_3296": "Cycadopsida",
    "FOODON_00001833": "english walnut food product",
    "FOODON_03541722": "17220 - star apples and similar- (efsa foodex2)",
    "FOODON_03412668": "stripetail rockfish",
    "GAZ_00004525": "The Philippines",
    "FOODON_00001322": "pak sean and hua plee dong",
    "FOODON_00002428": "multi-component bean product",
    "NCBITaxon_1545900": "Cirrhitioidei",
    "FOODON_03413167": "monosodium tartrate",
    "FOODON_03420135": "seed, skin present",
    "HANCESTRO_0580": "Malaysian Chinese",
    "FOODON_00003193": "soy yogurt",
    "FOODON_03301884": "biscuit (quick bread)",
    "FOODON_00002714": "turkey (ground or minced)",
    "FOODON_03541689": "16890 - hog plums (efsa foodex2)",
    "NCBITaxon_8045": "Gadidae",
    "FOODON_03430151": "food (solid)",
    "FOODON_03543533": "35330 - papaya infusion leaves (efsa foodex2)",
    "CHEBI_25710": "organophosphorus compound",
    "UO_0010028": "pint",
    "FOODON_03413377": "legume animal feed plant",
    "FOODON_03415060": "myrtle plant",
    "FOODON_03302237": "lime drink mix",
    "CHEBI_51683": "methoxybenzenes",
    "FOODON_03310773": "pie (unsweetened, served as entree)",
    "FOODON_03307715": "syrup spread",
    "FOODON_03304373": "date and carob fruit and nut mix",
    "FOODON_03412184": "cape dory",
    "NCBITaxon_137221": "Rheum palmatum",
    "FOODON_03543525": "35250 - moldavian dragonhead infusion leaves (efsa foodex2)",
    "NCBITaxon_65125": "Scophthalmus rhombus",
    "FOODON_03401351": "50350100 - chicory leaves (gs1 gpc)",
    "FOODON_03412858": "gilt headed bream",
    "FOODON_03541270": "12700 - lovage, dry (efsa foodex2)",
    "NCBITaxon_94950": "Dentex",
    "FOODON_03413291": "sucroglycerides",
    "FOODON_03413916": "mullet",
    "FOODON_03401759": "10005946 - kaki/ sharon fruits (gs1 gpc)",
    "FOODON_03542488": "24880 - red swamp crawfish (efsa foodex2)",
    "FOODON_03541521": "15210 - mirabelles (efsa foodex2)",
    "FOODON_03412697": "ptarmigan",
    "FOODON_03308497": "cauliflower au gratin (dish)",
    "FOODON_03308980": "cowcod (raw)",
    "FOODON_03411040": "bullhead catfish family",
    "FOODON_03316469": "sugar coating for candy",
    "FOODON_00002247": "snow crab food product",
    "FOODON_03315100": "caramel mass",
    "FOODON_03310232": "palm oil",
    "FOODON_03302963": "chestnut (mashed)",
    "FOODON_03302855": "whiskey sour cake",
    "FOODON_03316450": "bakery product (small)",
    "FOODON_03412090": "walrus",
    "FOODON_03510043": "low in cholesterol claim or use",
    "NCBITaxon_1586296": "Sciaena umbra",
    "FOODON_03308569": "shrimp (breaded)",
    "FOODON_03411556": "batavia cassia plant",
    "FOODON_03304190": "beef consomme",
    "GAZ_00002478": "Lebanon",
    "FOODON_03540806": "08060 - horns of plenty (efsa foodex2)",
    "NCBITaxon_93759": "Corchorus olitorius",
    "FOODON_03301124": "strawberry jam",
    "FOODON_03413267": "sodium o-phenyl phenol",
    "FOODON_03542553": "25530 - squids, cuttlefishes, octopuses (efsa foodex2)",
    "FOODON_03401265": "1100000 - 11. fish, fish products, shell fish, molluscs and other marine and freshwater food products (ec)",
    "FOODON_03542230": "22300 - catla (efsa foodex2)",
    "FOODON_03301544": "scallop (shucked, raw)",
    "FOODON_03310744": "legume (whole, cooked)",
    "FOODON_03540209": "02090 - unleavened doughs (efsa foodex2)",
    "FOODON_03307690": "rooibos tea (dry)",
    "FOODON_03542906": "29060 - cheese, ubriaco (efsa foodex2)",
    "FOODON_03315151": "soft drink (noncarbonated)",
    "FOODON_03413064": "chlorophyllins",
    "FOODON_03542746": "27460 - cheese, crescenza (efsa foodex2)",
    "FOODON_03315420": "meat (cooked, manufactured)",
    "FOODON_03301363": "mushroom (pickled, canned)",
    "FOODON_03401816": "10006217 - sandwiches/filled rolls/wraps variety packs (gs1 gpc)",
    "NCBITaxon_215351": "Brama",
    "FOODON_03308494": "truffle (whole)",
    "FOODON_03540032": "00320 - maize grain (efsa foodex2)",
    "FOODON_03303422": "jelly ginger cookie",
    "FOODON_03316315": "jellying sugar",
    "FOODON_03411871": "flathead sole",
    "FOODON_03480035": "packed in gelatin",
    "FOODON_03308578": "arctic crabmeat",
    "FOODON_03400859": "dressing, mayonnaise (eurofir)",
    "FOODON_03306502": "ocean perch (raw)",
    "FOODON_03413547": "turkey wing",
    "FOODON_03460295": "lactose removal process",
    "NCBITaxon_232347": "Magnoliidae",
    "NCBITaxon_6545": "Pteriomorphia",
    "NCBITaxon_9796": "Equus caballus",
    "NCBITaxon_59496": "Rubus parviflorus",
    "FOODON_03412592": "scalloped hammerhead",
    "CHEBI_24866": "salt",
    "FOODON_03540529": "05290 - rapini (efsa foodex2)",
    "GAZ_00002468": "Kurdistan",
    "FOODON_03541391": "13910 - cubeb fruit (efsa foodex2)",
    "FOODON_03305383": "bread (enriched, low sodium)",
    "FOODON_03413821": "smelt",
    "FOODON_03302640": "cream (sweetened, frozen)",
    "FOODON_03302082": "beef (dehydrated)",
    "FOODON_03540979": "09790 - amazonian yam beans (efsa foodex2)",
    "FOODON_00001876": "freshwater drum food product",
    "FOODON_03412300": "conger eel family",
    "FOODON_03414695": "caperbush plant",
    "FOODON_03401812": "10006418 - turnip rooted chervil (gs1 gpc)",
    "FOODON_03544275": "42750 - grape flavour (efsa foodex2)",
    "FOODON_03401059": "10000040 - oils edible - vegetable or plant (shelf stable) (gs1 gpc)",
    "FOODON_03301662": "soup (dehydrated)",
    "FOODON_00002614": "Tempranillo wine",
    "NCBITaxon_335062": "Squalus megalops",
    "FOODON_03540081": "00810 - rye flour, wholemeal (efsa foodex2)",
    "FOODON_00002443": "frog food product",
    "NCBITaxon_4733": "Typha latifolia",
    "CHEBI_63005": "sodium nitrate",
    "FOODON_03311448": "cottonseed linters",
    "FOODON_03411465": "sturgeon",
    "FOODON_03400821": "fine bakery ware (eurofir)",
    "FOODON_03412599": "killifish",
    "FOODON_03411793": "pacific sierra",
    "NCBITaxon_504568": "Salmoninae",
    "FOODON_03401011": "10000005 - vegetables - unprepared/unprocessed (frozen) (gs1 gpc)",
    "FOODON_03305610": "cow milk (canned)",
    "FOODON_03315814": "breakfast replacement food",
    "FOODON_03460239": "food rolling process",
    "FOODON_03310817": "cow buttermilk (raw)",
    "HANCESTRO_0404": "Costa Rican",
    "FOODON_03540780": "07800 - other procaryotes organisms (efsa foodex2)",
    "FOODON_00002827": "sheep liver (whole, raw)",
    "FOODON_03542685": "26850 - whey, sweet (efsa foodex2)",
    "FOODON_03542744": "27440 - cheese, chevre frais (efsa foodex2)",
    "FOODON_03470180": "ultra high temperature (uht) pasteurization",
    "FOODON_03315346": "konyak",
    "PO_0025099": "embryo plant structure",
    "FOODON_03412940": "red beet plant",
    "FOODON_03311471": "marshmallow creme",
    "FOODON_03412169": "longlegged spiny lobster",
    "NCBITaxon_585827": "Iris versicolor",
    "FOODON_03540493": "04930 - jersey kales (efsa foodex2)",
    "UBERON_0008270": "mollusc shell",
    "FOODON_03540792": "07920 - pleurotus (efsa foodex2)",
    "FOODON_03530286": "blue skin",
    "CHEBI_28934": "vitamin D2",
    "FOODON_03540282": "02820 - kringles (efsa foodex2)",
    "FOODON_03315718": "animal protein (hydrolyzed)",
    "GAZ_00005206": "New Caledonia",
    "FOODON_00001285": "goose meat food product",
    "FOODON_03311419": "frozen dairy dessert (milk-based)",
    "FOODON_00002802": "turkey egg (whole, shell on, raw)",
    "FOODON_03311655": "wheat flour dough",
    "FOODON_03540264": "02640 - cheese cream sponge cake (efsa foodex2)",
    "FOODON_03542617": "26170 - salt-preserved fish (efsa foodex2)",
    "FOODON_03542268": "22680 - snakeskin gourami (efsa foodex2)",
    "FOODON_03301220": "multer berry",
    "FOODON_03411427": "swordfish",
    "NCBITaxon_13106": "Lepomis macrochirus",
    "FOODON_03540903": "09030 - kaffir lime leaves (efsa foodex2)",
    "NCBITaxon_215439": "Todarodes angolensis",
    "FOODON_03305725": "petticoat tail cookie",
    "FOODON_03302599": "banana cake",
    "FOODON_00002380": "flavoring agent by composition",
    "NCBITaxon_521024": "Etrumeus whiteheadi",
    "FOODON_03310048": "pea meal (food product)",
    "CHEBI_33720": "carbohydrate acid",
    "FOODON_03309123": "ray's bream canned",
    "GAZ_00000585": "Niger",
    "NCBITaxon_114957": "Pharidae",
    "NCBITaxon_553066": "Oregoniidae",
    "FOODON_03420285": "skeletal meat part, with bone, without skin, with separable fat",
    "FOODON_03540620": "06200 - garden peas (with pods) (efsa foodex2)",
    "FOODON_03303080": "tangerine (whole, raw)",
    "NCBITaxon_741943": "Zeus capensis",
    "FOODON_03307879": "melon seed",
    "NCBITaxon_549391": "Alloteuthis media",
    "FOODON_03316928": "potato mix (dried)",
    "FOODON_03400110": "pasteurized process cheese (us cfr)",
    "NCBITaxon_321164": "Scomberomorus niphonius",
    "FOODON_03544310": "43100 - maple flavour (efsa foodex2)",
    "FOODON_03542131": "21310 - cooked bovine tongue (efsa foodex2)",
    "NCBITaxon_7935": "Anguilla",
    "NCBITaxon_1010792": "Isacia conceptionis",
    "FOODON_03401145": "10000281 - fish - unprepared/unprocessed (frozen) (gs1 gpc)",
    "CHEBI_33975": "magnesium salt",
    "FOODON_03315908": "vegetable drink mix",
    "FOODON_03301633": "mescal",
    "HANCESTRO_0572": "Kosraen",
    "FOODON_00002619": "Frappato wine",
    "FOODON_00002480": "apple (peeled, blanched)",
    "FOODON_03543757": "37570 - infant formula, soya-based, liquid (efsa foodex2)",
    "FOODON_03303551": "bean (artificially ham-flavored, dried)",
    "FOODON_03414169": "cape aloe plant",
    "FOODON_03316417": "jam (plum)",
    "FOODON_03543341": "33410 - stout beer (efsa foodex2)",
    "FOODON_03414867": "sorubim catfish",
    "FOODON_03310466": "marijuana seed",
    "FOODON_03310784": "fermented vegetable food product",
    "FOODON_03541725": "17250 - american persimmons (efsa foodex2)",
    "FOODON_03309509": "crabmeat (pasteurized, canned, frozen)",
    "FOODON_03316646": "cake mix concentrate",
    "FOODON_03316237": "infant food containing fat",
    "NCBITaxon_33511": "Deuterostomia",
    "FOODON_03305063": "lemon borscht",
    "FOODON_03414655": "midgen berry plant",
    "FOODON_03309323": "whiting fillet (raw)",
    "NCBITaxon_202588": "Labrus viridis",
    "NCBITaxon_303935": "Carcharhinus perezii",
    "NCBITaxon_319431": "Lutjanus argentiventris",
    "FOODON_03414675": "tallow wood",
    "FOODON_03490172": "plastic container",
    "FOODON_03310675": "luncheon meat",
    "FOODON_03415124": "clary sage plant",
    "FOODON_03400882": "10000159 - beer (gs1 gpc)",
    "FOODON_00002660": "food (fried)",
    "PATO_0002127": "scirrhous",
    "FOODON_03401575": "10006053 - chervil (gs1 gpc)",
    "FOODON_00002747": "guajillo chili food product",
    "FOODON_03411251": "grouse",
    "FOODON_03544356": "43560 - quark flavour (efsa foodex2)",
    "FOODON_03520467": "northeastern states",
    "FOODON_03317168": "oat must",
    "GAZ_00001101": "Kenya",
    "FOODON_03412649": "sanddab",
    "FOODON_03309777": "cashew nut (shell off, raw)",
    "FOODON_03413793": "black truffle",
    "NCBITaxon_225388": "Aplodinotus",
    "FOODON_03315112": "beverage with cocoa, noncarbonated",
    "FOODON_03541336": "13360 - aril spices (efsa foodex2)",
    "CHEBI_26167": "polar amino acid",
    "NCBITaxon_3309": "Ginkgoaceae",
    "NCBITaxon_44596": "Arca",
    "ENVO_02000140": "fluid environmental material",
    "FOODON_03412052": "mistletoe plant (european)",
    "FOODON_03530121": "cut of meat, french",
    "FOODON_03302731": "corn (frozen)",
    "FOODON_03411895": "fish, zeiform",
    "FOODON_03401742": "10005953 - purple maracujas (gs1 gpc)",
    "FOODON_03308837": "red crab (raw)",
    "FOODON_03306897": "potato-flavored chip (puffed)",
    "FOODON_03540207": "02070 - ingredient rich fine dough without yeast (efsa foodex2)",
    "NCBITaxon_911341": "Heliantheae alliance",
    "GENEPIO_0001763": "user interface feature",
    "FOODON_03401599": "10006353 - sage (gs1 gpc)",
    "NCBITaxon_3615": "Polygonaceae",
    "FOODON_00003179": "guarana food product",
    "NCBITaxon_3638": "Thespesia populnea",
    "FOODON_03412898": "deepsea whiptail",
    "FOODON_03510015": "food animal as consumer",
    "NCBITaxon_143315": "Saurida undosquamis",
    "FOODON_03302186": "fruit juice drink",
    "FOODON_03543808": "38080 - mixed supplements/formulations (efsa foodex2)",
    "FOODON_03530102": "casing or rind",
    "FOODON_03308137": "royal lobster (raw)",
    "FOODON_03317615": "wine (artificially carbonated)",
    "FOODON_03308663": "scampi (raw)",
    "FOODON_03544092": "40920 - mayonnaise, hollandaise and related sauces (efsa foodex2)",
    "NCBITaxon_6778": "Xanthoidea",
    "FOODON_03541455": "14550 - mandarins and similar- (efsa foodex2)",
    "FOODON_03310762": "obsolete: beefburger (shaped)",
    "GAZ_00002845": "China",
    "PATO_0002300": "increased quality",
    "FOODON_00001716": "chemical sweetener product",
    "FOODON_03302364": "lactose bread",
    "FOODON_03301515": "pasta filata cheese",
    "FOODON_03315708": "condiment",
    "FOODON_03414688": "johnstone river almond plant",
    "FOODON_03401308": "probiotic or bacteria supplement",
    "FOODON_03304188": "minestrone soup with poultry",
    "FOODON_03541787": "17870 - mammey apple (efsa foodex2)",
    "NCBITaxon_3313": "Pinidae",
    "FOODON_03400648": "e.  processed food of animal origin (ccpr)",
    "FOODON_03301055": "white bread",
    "FOODON_03306581": "cow whole milk (pasteurized)",
    "NCBITaxon_55139": "Squatiniformes",
    "FOODON_00001764": "corn snack",
    "FOODON_03414337": "sea thong",
    "FOODON_03530155": "tail",
    "CHEBI_78616": "carbohydrates and carbohydrate derivatives",
    "FOODON_03401806": "10006104 - potatoes (gs1 gpc)",
    "FOODON_03544402": "44020 - vanillin flavour (efsa foodex2)",
    "FOODON_03301248": "date (chopped, sliced or macerated)",
    "FOODON_03307285": "wine (artificially sweetened)",
    "NCBITaxon_4038": "Daucus",
    "FOODON_03540021": "00210 - african millet grain (efsa foodex2)",
    "FOODON_03303833": "butter oil (lipolyzed)",
    "NCBITaxon_31031": "Tetraodontidae",
    "FOODON_00001012": "milk formula (powdered)",
    "FOODON_00003094": "star anise food product",
    "FOODON_03307077": "chicken-flavored consomme mix (dry, instant)",
    "FOODON_03414338": "aniseed myrtle plant",
    "NCBITaxon_3250": "Lycopodiaceae",
    "OBI_0002138": "temperature value specification",
    "FOODON_03540537": "05370 - stems/stalks eaten as vegetables (efsa foodex2)",
    "FOODON_03413927": "rock goby",
    "FOODON_00003291": "tamarillo food product",
    "FOODON_03316821": "vermicelli vegetable (enriched)",
    "FOODON_03540805": "08050 - hedgehog mushrooms (efsa foodex2)",
    "FOODON_03414658": "pigface plant",
    "FOODON_03315875": "celery pepper",
    "FOODON_03540571": "05710 - celtuce (efsa foodex2)",
    "FOODON_03303212": "ginger cracker",
    "NCBITaxon_45834": "Solanum dulcamara",
    "CHEBI_46792": "hydroxypolyether",
    "FOODON_03540700": "07000 - winter squashes (efsa foodex2)",
    "GAZ_00000468": "Oceania",
    "FOODON_03411883": "summer flounder",
    "FOODON_03414391": "ethyl cellulose",
    "FOODON_03400713": "23  other alcoholic beverages (efg)",
    "FOODON_03490101": "plastic squeeze bottle or tube, top lined with foil",
    "FOODON_03411209": "date plant",
    "FOODON_03302883": "jelly bean",
    "CHEBI_24268": "glucooligosaccharide",
    "FOODON_03470137": "food brining",
    "FOODON_00002955": "lemur",
    "FOODON_03540421": "04210 - spinaches (efsa foodex2)",
    "CHEBI_38101": "organonitrogen heterocyclic compound",
    "FOODON_03412353": "japanese scallop",
    "FOODON_03411866": "arrowtooth flounder",
    "FOODON_03400746": "041  diadromoous fish (wd) (ccpr)",
    "FOODON_03310306": "sesame seed",
    "NCBITaxon_96778": "Hoplostethus atlanticus",
    "NCBITaxon_1005905": "Solenocera membranacea",
    "FOODON_03543263": "32630 - unbottled water (efsa foodex2)",
    "CHEBI_26935": "tetraterpenoid",
    "UO_0000196": "pH",
    "FOODON_03544302": "43020 - lemon myrtle flavour (efsa foodex2)",
    "NCBITaxon_4672": "Dioscorea",
    "FOODON_03510159": "other special claim or use",
    "FOODON_00003106": "sea-buckthorn food product",
    "FOODON_03510182": "aliment de disette",
    "FOODON_03302389": "soybean beverage",
    "FOODON_03490123": "plastic tray or pan, aluminum foil cover or wrapping",
    "FOODON_03540930": "09300 - garden nasturtium (efsa foodex2)",
    "FOODON_03541591": "15910 - ugniberries (efsa foodex2)",
    "FOODON_03315054": "frosting (dairy, frozen)",
    "FOODON_00001779": "cow milk pie food product",
    "FOODON_03401103": "10000261 - soups - prepared (perishable) (gs1 gpc)",
    "FOODON_03302231": "imitation grape drink base",
    "FOODON_03401718": "10006435 - longan (dragons eye) (gs1 gpc)",
    "FOODON_00002903": "Soldier river barb",
    "FOODON_03412836": "soapberry plant",
    "FOODON_03304644": "fruit (whole, raw)",
    "FOODON_03306878": "squash (peeled)",
    "FOODON_03400759": "058  milled cereal products (early milling stages) (cm) (ccpr)",
    "FOODON_03414684": "araucaria tree",
    "FOODON_03412806": "african mango plant",
    "FOODON_03542833": "28330 - cheese, morbier (efsa foodex2)",
    "PATO_0002305": "increased object quality",
    "FOODON_03412147": "african pompano",
    "NCBITaxon_8227": "Euthynnus affinis",
    "FOODON_03542527": "25270 - limpet (efsa foodex2)",
    "CHEBI_24782": "imide",
    "FOODON_03315556": "beverage, composite, dry mix for",
    "NCBITaxon_67937": "Zanthoxylum",
    "FOODON_03541706": "17060 - longans (efsa foodex2)",
    "NCBITaxon_53751": "Echinacea purpurea",
    "FOODON_03412349": "fire thorn plant",
    "FOODON_03414302": "allium species",
    "FOODON_00003013": "bell pepper",
    "FOODON_03305792": "ice cream (freeze-dried)",
    "FOODON_03530154": "domestic or cultivated food production",
    "FOODON_03544062": "40620 - curry powder (efsa foodex2)",
    "FOODON_03490155": "paperboard container with liner",
    "NCBITaxon_320146": "Chaenomeles japonica",
    "FOODON_03306058": "horsemeat (raw)",
    "FOODON_03308682": "south american abalone (raw)",
    "FOODON_03302092": "beef fat",
    "FOODON_03541215": "12150 - corn gromwell seeds (efsa foodex2)",
    "FOODON_03413156": "mono- and diglycerides of fatty acids",
    "CHEBI_32321": "alpha-Tocopherol acetate",
    "FOODON_03412510": "banana squash plant",
    "CHEBI_23217": "cholines",
    "FOODON_03301635": "fruitcake",
    "NCBITaxon_6684": "Dendrobranchiata",
    "NCBITaxon_479862": "Aluterus monoceros",
    "FOODON_03412644": "european whiting",
    "FOODON_03309776": "almond (shell off)",
    "FOODON_03303010": "chicken burger",
    "FOODON_03530171": "alcohol content < 9%",
    "NCBITaxon_147428": "Paniceae",
    "FOODON_03542136": "21360 - cooked other poultry meat (efsa foodex2)",
    "HANCESTRO_0503": "Cameroonian",
    "FOODON_03308459": "summer flounder (raw)",
    "FOODON_03541259": "12590 - spices (efsa foodex2)",
    "UBERON_6006011": "pharate adult",
    "FOODON_03308641": "imitation crabmeat from artificially-flavored pollock",
    "FOODON_03412457": "chaa phluu plant",
    "FOODON_03306862": "peanut butter with bonemeal",
    "FOODON_03540759": "07590 - algae and prokaryotes organisms (efsa foodex2)",
    "FOODON_00001576": "aerated confectionery food product",
    "FOODON_03302737": "casserole (precooked, frozen)",
    "FOODON_03400958": "10000597 - sweet bakery products variety packs (gs1 gpc)",
    "FOODON_03317013": "fruit juice (raw, unsweetened)",
    "FOODON_03306137": "lasagna casserole (frozen)",
    "FOODON_03305631": "wild honey",
    "FOODON_03304999": "tempeh",
    "FOODON_03302331": "butter roll",
    "FOODON_03309635": "butterball fish (raw)",
    "NCBITaxon_31013": "Bagridae",
    "FOODON_03411178": "muscat grape plant",
    "FOODON_00002801": "goose egg (whole, shell on, raw)",
    "GAZ_00056925": "Malay Peninsula",
    "FOODON_03305040": "fruit (candied)",
    "FOODON_03316535": "water for beermaking (food product)",
    "NCBITaxon_435239": "Valamugil",
    "FOODON_03430125": "divided into pieces, thickness more than 1.5 cm.",
    "FOODON_03308510": "mushroom (random cut, raw)",
    "FOODON_03540453": "04530 - grape leaves and similar species (efsa foodex2)",
    "NCBITaxon_7884": "Protopteridae",
    "FOODON_03413689": "pangas catfish",
    "FOODON_03480044": "packed in ink",
    "FOODON_03530093": "inedible sausage casing",
    "FOODON_03310620": "vitamin preparation",
    "FOODON_03541864": "18640 - canned fruit cocktail (efsa foodex2)",
    "FOODON_03309641": "imitation smoked salmon made from pollock",
    "FOODON_03316634": "cow milk drink (fermented, savory)",
    "CHEBI_145232": "cellulose acetate",
    "FOODON_03400365": "antibleaching agent (codex)",
    "FOODON_03541833": "18330 - fruit compote, cranberry (efsa foodex2)",
    "FOODON_03301292": "pear puree",
    "FOODON_00001906": "glaze food product",
    "FOODON_03411533": "european filbert plant",
    "FOODON_03311444": "wheat bran breakfast cereal",
    "FOODON_03430154": "food supplement form",
    "CHEBI_79323": "4-hydroxybenzoate ester",
    "NCBITaxon_1081552": "Galeopsis segetum",
    "FOODON_03305563": "beverage (carbonated, guarana-flavored)",
    "GAZ_00003745": "Mauritius",
    "FOODON_03301957": "apple juice drink (frozen concentrate)",
    "FOODON_03542235": "22350 - tench (efsa foodex2)",
    "HANCESTRO_0401": "British Virgin Islander",
    "FOODON_03315837": "fruit peel food product",
    "NCBITaxon_31024": "Balistidae",
    "FOODON_03301003": "pineapple (canned)",
    "FOODON_03316189": "pectin (liquid)",
    "FOODON_03304043": "bread flour",
    "HANCESTRO_0498": "Filipino",
    "FOODON_03414248": "european beech plant",
    "FOODON_03544280": "42800 - guanabana flavour (efsa foodex2)",
    "FOODON_03540236": "02360 - fine bakery wares (efsa foodex2)",
    "FOODON_03306761": "apple pie (baked)",
    "NCBITaxon_4113": "Solanum tuberosum",
    "FOODON_03541545": "15450 - dewberries (efsa foodex2)",
    "FOODON_03414091": "spotted ray",
    "FOODON_03301576": "cottonseed flour",
    "FOODON_03540739": "07390 - maca roots (efsa foodex2)",
    "FOODON_03317147": "topping in pressurised container",
    "FOODON_03541082": "10820 - lima beans (dry) (efsa foodex2)",
    "FOODON_03414650": "cissus grape plant",
    "FOODON_00003340": "lemon grass stalk",
    "FOODON_03412874": "common shrimp",
    "FOODON_03540647": "06470 - chinese wolfberries (efsa foodex2)",
    "FOODON_03301818": "malted cow milk",
    "NCBITaxon_3847": "Glycine max",
    "FOODON_03543668": "36680 - chamomile (infusion seeds) (efsa foodex2)",
    "FOODON_03400923": "10000232 - packaged water (gs1 gpc)",
    "ENVO_01001789": "freshwater ecosystem",
    "FOODON_03306041": "yeast food product (dry)",
    "PATO_0000591": "increased thickness",
    "FOODON_03411368": "pinto bean plant",
    "FOODON_03411530": "kumquat plant",
    "FOODON_00001056": "flour food product",
    "FOODON_03308057": "calico clam (raw)",
    "NCBITaxon_3568": "Caryophyllaceae",
    "NCBITaxon_75079": "Rubus occidentalis",
    "FOODON_03305344": "gelatin (pigskin)",
    "FOODON_03541531": "15310 - kiwiberries (efsa foodex2)",
    "FOODON_03304039": "pickle (sweetened with artificial fruit sauce)",
    "FOODON_03301360": "akee (whole, raw)",
    "FOODON_03543908": "39080 - creamed vegetable mix (efsa foodex2)",
    "FOODON_03315616": "beer (small)",
    "FOODON_03543571": "35710 - mate infusion material (efsa foodex2)",
    "FOODON_03310845": "corn fritter",
    "FOODON_03411033": "agar plant",
    "FOODON_03414331": "prickly saltwort plant",
    "FOODON_03309128": "pike fillet (raw)",
    "FOODON_03317076": "root vegetable product",
    "FOODON_03413353": "european flounder",
    "FOODON_03303876": "romano cheese (enzyme-modified)",
    "NCBITaxon_135776": "Sillaginodes punctatus",
    "FOODON_03544166": "41660 - rye starch (efsa foodex2)",
    "FOODON_03530112": "food industry preparation process",
    "HANCESTRO_0388": "Sammarinese",
    "FOODON_00001678": "calf meat food product",
    "FOODON_03301293": "fodder (animal feed)",
    "FOODON_03301534": "cranberry apple drink",
    "FOODON_03306879": "potato (french-fried, frozen)",
    "FOODON_03302222": "beverage base (artificially sweetened)",
    "NCBITaxon_55118": "Clupeidae",
    "NCBITaxon_33125": "Lepidium sativum",
    "FOODON_03411500": "deer family",
    "FOODON_03400858": "condiment (eurofir)",
    "FOODON_03541171": "11710 - paradise nut (efsa foodex2)",
    "FOODON_03413909": "finebarbel croaker",
    "FOODON_03414366": "common quail",
    "FOODON_03303520": "red kidney bean (canned)",
    "FOODON_03414296": "shearwater",
    "FOODON_03308428": "atlantic menhaden (raw)",
    "FOODON_03413811": "russian sturgeoun",
    "FOODON_03460376": "seed gum",
    "FOODON_03310841": "turmeric (ground)",
    "FOODON_03543234": "32340 - juice concentrate, black currant (efsa foodex2)",
    "FOODON_03306019": "orange juice (single strength, canned)",
    "FOODON_03308901": "pacific queen fish (raw)",
    "FOODON_00003020": "turmeric extract",
    "FOODON_00001794": "cucumber relish food product",
    "FOODON_03305415": "breakfast cereal (dry)",
    "FOODON_03413667": "milk conch",
    "FOODON_03540147": "01470 - crackers and breadsticks (efsa foodex2)",
    "FOODON_03510135": "kosher for passover claim or use",
    "FOODON_03412024": "early morel",
    "FOODON_03520494": "arid climatic zone",
    "FOODON_03401823": "10006319 - mayonnaise/mayonnaise substitutes (shelf stable) (gs1 gpc)",
    "HANCESTRO_0019": "Japanese",
    "FOODON_03542394": "23940 - ocean perch (efsa foodex2)",
    "FOODON_03540240": "02400 - biscuits, chocolate (efsa foodex2)",
    "FOODON_03541600": "16000 - black crowberries (common) (efsa foodex2)",
    "FOODON_00003025": "black olive (whole)",
    "FOODON_03304215": "crab (deviled)",
    "FOODON_00001970": "imitation nonalcoholic beverage",
    "FOODON_00003336": "food portion",
    "FOODON_03308912": "greenland turbot (raw)",
    "FOODON_03308339": "maine sardine (packed in sild sardine oil, canned)",
    "FOODON_03414252": "jasmine plant",
    "FOODON_03308595": "crab spread",
    "FOODON_03303691": "spare cheese",
    "HANCESTRO_0445": "Moroccan",
    "NCBITaxon_16733": "Schisandraceae",
    "NCBITaxon_155124": "Aspalathus linearis",
    "FOODON_03412665": "black bass",
    "NCBITaxon_30501": "Carcharias taurus",
    "FOODON_00003381": "product country-of-origin",
    "FOODON_00002736": "bird's eye chili",
    "FOODON_03311276": "yellow onion (whole, raw)",
    "FOODON_03411034": "pacific ocean perch",
    "FOODON_03305698": "imitation lowfat dry milk",
    "FOODON_03301675": "rice bean (canned)",
    "FOODON_03301639": "low alcoholic beverage (3-5% alcohol)",
    "FOODON_00002452": "invertebrate animal",
    "FOODON_03490205": "leaf wrapper",
    "FOODON_03305765": "apple and grape juice (food product)",
    "FOODON_03401278": "USDA SR breakfast cereals (0800)",
    "CHEBI_25108": "magnesium molecular entity",
    "CHEBI_63944": "macrocyclic lactone",
    "FOODON_03414589": "african elephant",
    "FOODON_03401869": "10006831 - mumes (gs1 gpc)",
    "FOODON_03303344": "purple cauliflower (raw)",
    "FOODON_03308196": "clam (quahog, raw)",
    "FOODON_03311492": "vendace (raw)",
    "FOODON_00001910": "goat milk beverage",
    "FOODON_03302249": "fruit juice (diluted)",
    "FOODON_03530005": "food datum",
    "NCBITaxon_183657": "Urophycis tenuis",
    "FOODON_03308883": "cusk eel (raw)",
    "NCBITaxon_75943": "Lactuca serriola",
    "FOODON_03530294": "neck (poultry meat cut)",
    "FOODON_03411762": "argentine sea bass",
    "NCBITaxon_443710": "Parapercis colias",
    "CHEBI_33521": "metal atom",
    "FOODON_03414324": "canadian onion plant",
    "NCBITaxon_3719": "Capsella bursa-pastoris",
    "FOODON_00001064": "bottled beer food product",
    "FOODON_03414061": "mexican golden trout",
    "FOODON_03414985": "ramsons plant",
    "FOODON_03411740": "garland chrysanthemum plant",
    "FOODON_03541538": "15380 - strawberries (efsa foodex2)",
    "FOODON_03315035": "beverage (fruit juice based, noncarbonated, refrigerated, single-strength)",
    "FOODON_03305083": "chocolate candy (sherry-filled)",
    "FOODON_03413627": "fleshy prawn",
    "FOODON_03301207": "bark tea",
    "FOODON_03541757": "17570 - granate apples (efsa foodex2)",
    "FOODON_03510013": "non-food animal as food consumer",
    "FOODON_03309334": "blue warehou (raw)",
    "FOODON_03310470": "nacho sauce",
    "FOODON_03401188": "10000576 - pate (frozen) (gs1 gpc)",
    "FOODON_00003278": "raclette (dish)",
    "FOODON_03310464": "russian tea (instant)",
    "FOODON_03304175": "animal shortening",
    "FOODON_03412875": "blue mussel",
    "FOODON_03411955": "chilean abalone",
    "FOODON_03306953": "barley egg noodle",
    "NCBITaxon_458545": "Acanthistius brasilianus",
    "FOODON_00002966": "black cumin seed",
    "NCBITaxon_39992": "Terminalia",
    "FOODON_03414701": "walking-stick palm plant",
    "FOODON_03304289": "sweet pepper (flakes)",
    "NCBITaxon_13029": "Cynoscion nebulosus",
    "FOODON_03316701": "cocoa-sugar mixture dry",
    "FOODON_03412064": "acorn squash plant",
    "FOODON_03304305": "turbinado sugar",
    "FOODON_03544048": "40480 - spoonable desserts and ice creams (generic) (efsa foodex2)",
    "FOODON_03311830": "dietary food supplement, liquid",
    "FOODON_03315429": "food for invalids",
    "FOODON_03415049": "japanese quince plant",
    "FOODON_03304128": "beverly cream candy",
    "FOODON_03420230": "fruit, peel removed, core, pit or seed present",
    "FOODON_00002229": "seafood product analog",
    "FOODON_03412238": "white trevally",
    "NCBITaxon_2774": "Gracilaria",
    "FOODON_03316258": "dietetic food for youth and adults",
    "FOODON_03490151": "metal container",
    "NCBITaxon_451864": "Dikarya",
    "FOODON_03542786": "27860 - soft-ripened cheese with natural rind and other soft-ripened cheeses (efsa foodex2)",
    "FOODON_03306124": "lasagna noodle",
    "FOODON_03413507": "common wheat plant",
    "CHEBI_25106": "macrolide",
    "FOODON_03305542": "vinegar (flavored with spices)",
    "FOODON_03413368": "white crappie",
    "FOODON_03311378": "lemon cookie",
    "FOODON_03412871": "pandora",
    "NCBITaxon_72093": "Sebastes paucispinis",
    "FOODON_03401036": "10000189 - cream/cream substitutes (perishable) (gs1 gpc)",
    "FOODON_03542978": "29780 - fried eggs (efsa foodex2)",
    "NCBITaxon_226089": "Elatostema",
    "FOODON_03308920": "pacific mackerel (raw)",
    "FOODON_03541068": "10680 - pulses (dried legume seeds) (efsa foodex2)",
    "FOODON_03543930": "39300 - sandwich with cheese, egg and vegetable topping/filling (efsa foodex2)",
    "FOODON_03414226": "sugar melon plant",
    "FOODON_03316704": "cocoa mass",
    "FOODON_03303437": "spaghetti in tomato sauce (italian-style, canned)",
    "FOODON_03304183": "clam (smoked)",
    "FOODON_03543227": "32270 - multivitamin juices (efsa foodex2)",
    "FOODON_03309825": "hungry rice",
    "FOODON_03490396": "polyethylene (high density) - nylon 11 container",
    "NCBITaxon_55710": "Cerastoderma edule",
    "FOODON_03411485": "sugar palm plant",
    "FOODON_03412816": "zanha africana plant",
    "CHEBI_81716": "Calcium propionate",
    "FOODON_03412336": "eurasian perch",
    "FOODON_03543270": "32700 - still natural mineral water (efsa foodex2)",
    "FOODON_03542105": "21050 - duck, other slaughtering products (efsa foodex2)",
    "FOODON_03302858": "peach (reduced-calorie, canned)",
    "FOODON_00002127": "plant based food product for animal",
    "FOODON_03543434": "34340 - cocoa ingredients (rpc derivatives) (efsa foodex2)",
    "FOODON_03414545": "pequi plant",
    "FOODON_03543848": "38480 - meat based dishes (efsa foodex2)",
    "NCBITaxon_156091": "Eriphia",
    "NCBITaxon_85437": "Citrus japonica var. margarita",
    "FOODON_03414251": "cabbage-leaf mustard plant",
    "FOODON_03316030": "bread (rye, prepacked, sliced)",
    "FOODON_03542420": "24200 - tuna, blackfin (efsa foodex2)",
    "FOODON_03480019": "packed in sweetened brine",
    "FOODON_03544359": "43590 - raspberry flavour (efsa foodex2)",
    "FOODON_03401863": "10006835 - sweet potato stems (gs1 gpc)",
    "FOODON_00002904": "roter fusilier",
    "FOODON_03301047": "root beer",
    "FOODON_03316305": "brandy flavored with herbs and/or spices",
    "FOODON_03303749": "candy cane",
    "NCBITaxon_8783": "Palaeognathae",
    "FOODON_03303346": "fish chowder soup mix",
    "CHEBI_10607": "n-propyl gallate",
    "FOODON_03315534": "fishery product (chilled)",
    "FOODON_03542108": "21080 - raw cured (or seasoned) meat (efsa foodex2)",
    "FOODON_03540268": "02680 - rotation cooked layered cakes (efsa foodex2)",
    "FOODON_03401819": "10006369 - sapote (black) (gs1 gpc)",
    "FOODON_03310143": "Chianti wine",
    "NCBITaxon_3647": "Caricaceae",
    "IAO_0000423": "to be replaced with external ontology term",
    "FOODON_03311570": "pink bean (cooked, canned)",
    "FOODON_03317479": "fish fillet (deep-frozen, unprocessed)",
    "FOODON_03310927": "dessert novelty (frozen, stick-type, aspartame sweetened)",
    "NCBITaxon_173333": "Trachinotus goodei",
    "HANCESTRO_0307": "Italian",
    "FOODON_03307230": "frankfurter (bourbon-flavored)",
    "FOODON_03303137": "custard cream cookie",
    "FOODON_03542873": "28730 - cheese, coolea (efsa foodex2)",
    "FOODON_00002576": "bean sprout",
    "FOODON_03411366": "carob bean plant",
    "FOODON_03305148": "fruit salad",
    "FOODON_03540219": "02190 - choux pastry dough and similar (efsa foodex2)",
    "ENVO_01001069": "metallic material",
    "FOODON_03303806": "gum drop (sweetened with sugar and artificial sweetener)",
    "FOODON_03315939": "cheese rind, edible",
    "FOODON_03543935": "39350 - pizza and similar with cheese, meat, and mushrooms (efsa foodex2)",
    "FOODON_03413020": "brown fk",
    "FOODON_03316887": "vegetable (peeled)",
    "FOODON_03317309": "meat stew (canned)",
    "FOODON_03414994": "mexican bush sage plant",
    "FOODON_03304321": "lowfat cow milk (fortified, nonfat milk solids added)",
    "FOODON_03411722": "breadnut plant",
    "FOODON_03540098": "00980 - buckwheat groats (efsa foodex2)",
    "CHEBI_48730": "aluminosilicate mineral",
    "FOODON_03302369": "rye bread (artificially colored)",
    "FOODON_03316826": "spaghetti (egg)",
    "FOODON_03307353": "turnip greens (chopped)",
    "FOODON_03413536": "green abalone",
    "ENVO_00000395": "channel of a watercourse",
    "FOODON_03311493": "fruit packed in extra heavy syrup",
    "FOODON_03541434": "14340 - oranges and similar- (efsa foodex2)",
    "UBERON_0019250": "4-8 cell stage embryo",
    "FOODON_03302655": "coffee (decaffeinated, instant)",
    "FOODON_03315170": "sugar substitute",
    "FOODON_03311800": "miniature tomato (whole, raw)",
    "FOODON_03412403": "pumpkinseed",
    "FOODON_03414470": "brown bear",
    "FOODON_03302703": "triticale bread",
    "FOODON_03310758": "raisin (dried)",
    "FOODON_03304972": "frozen dairy dessert (nutritively and nonnutritively sweetened)",
    "FOODON_03400840": "beverage (non-milk) (eurofir)",
    "FOODON_03303873": "jarlsburg cheese",
    "PATO_0001828": "male pseudohermaphrodite",
    "NCBITaxon_414735": "Citrus limetta",
    "FOODON_03543951": "39510 - fish-based canap\u00e9 (efsa foodex2)",
    "FOODON_00001227": "jam food product",
    "FOODON_03312063": "camel milk (food product)",
    "FOODON_03307013": "brandied peach",
    "FOODON_03315749": "salad dressing (unstandardized)",
    "FOODON_03541476": "14760 - pears and similar- (efsa foodex2)",
    "FOODON_03413138": "magnesium diglutamate",
    "FOODON_03530266": "fat content >10%",
    "NCBITaxon_72073": "Sebastes entomelas",
    "FOODON_03414183": "yellow brain fungus",
    "FOODON_03411364": "rhubarb plant",
    "FOODON_03310324": "ginseng tea capsule",
    "FOODON_03414683": "brown pine plant",
    "FOODON_03540202": "02020 - yeast leavened sweet doughs (efsa foodex2)",
    "FOODON_03420105": "whole animal, with skin, feathers or scales, eviscerated",
    "FOODON_00001758": "common millet food product",
    "FOODON_03412534": "pike-conger",
    "FOODON_03310080": "lizard (dried)",
    "FOODON_03316518": "baking fat",
    "FOODON_03412107": "sea urchin",
    "FOODON_03543167": "31670 - juice, mandarin-banana (efsa foodex2)",
    "NCBITaxon_6452": "Haliotis",
    "RO_0000052": "inheres in",
    "FOODON_03307127": "potato (dehydrated, vitamin c added)",
    "FOODON_03301255": "loganberry (canned)",
    "FOODON_03316170": "ginger (dried)",
    "FOODON_03317218": "shrimp or prawn (raw, quick-frozen)",
    "FOODON_03412539": "clown fig plant",
    "NCBITaxon_1760": "Actinobacteria <high GC Gram+>",
    "FOODON_03470138": "preservation by irradiation",
    "FOODON_03307134": "olive (in brine)",
    "FOODON_03316061": "hen egg (whole)",
    "FOODON_03306049": "pineapple jelly mint-flavored artificially colored",
    "FOODON_03541053": "10530 - chickling vetches (without pods) (efsa foodex2)",
    "FOODON_03316049": "nut (processed)",
    "FOODON_03305555": "herbal wine",
    "FOODON_03307508": "barbeque seasoning (liquid)",
    "FOODON_03307848": "russian tea (dry)",
    "FOODON_03310917": "black peppercorn",
    "FOODON_03301968": "barley malt flour",
    "FOODON_03411800": "silk snapper",
    "FOODON_03308972": "silk snapper (raw)",
    "FOODON_03541396": "13960 - west african pepper fruit (efsa foodex2)",
    "FOODON_03542330": "23300 - flounders (efsa foodex2)",
    "NCBITaxon_200967": "Vicia articulata",
    "FOODON_03317465": "alcoholic beverage (fortified)",
    "FOODON_03309167": "black crappie (raw)",
    "FOODON_03413306": "thermally oxidized soya bean oil interacted with mono- and diglycerides of fatty",
    "FOODON_00001086": "kefir food product",
    "FOODON_03307999": "mackerel shark (raw)",
    "NCBITaxon_9702": "Otariidae",
    "FOODON_03414495": "alaska wild rhubarb plant",
    "CHEBI_36359": "phosphorus oxoacid derivative",
    "FOODON_03540996": "09960 - chicory roots (efsa foodex2)",
    "FOODON_03302391": "soybean soda vitamin-fortified carbonated",
    "NCBITaxon_179357": "Alectis",
    "FOODON_03311292": "biscuit (mineral enriched)",
    "FOODON_03414890": "chinese mitten crab",
    "FOODON_03400953": "10000171 - cakes - sweet (perishable) (gs1 gpc)",
    "FOODON_03308356": "lobster meat (frozen)",
    "FOODON_03542758": "27580 - ripened cheese (efsa foodex2)",
    "NCBITaxon_223862": "Raja brachyura",
    "CHEBI_33859": "aromatic carboxylic acid",
    "FOODON_03543942": "39420 - pizza and similar with cheese, meat, and vegetables (efsa foodex2)",
    "FOODON_03542813": "28130 - cheese, doux de montagne (efsa foodex2)",
    "FOODON_03412442": "asiatic pennywort plant",
    "FOODON_03510262": "weight-reducer as food consumer",
    "FOODON_03542557": "25570 - octopuses (efsa foodex2)",
    "FOODON_03413312": "tricalcium citrate",
    "FOODON_03413666": "horse conch",
    "FOODON_03304831": "chili sandwich roll",
    "NCBITaxon_224858": "Horsfieldia",
    "FOODON_03303146": "nice biscuit cookie",
    "FOODON_03530006": "color of poultry meat",
    "FOODON_00001748": "coconut beverage",
    "NCBITaxon_521022": "Cetengraulis edentulus",
    "FOODON_03302030": "chili powder",
    "FOODON_03302090": "beef seasoning",
    "FOODON_03412833": "anonidium plant",
    "FOODON_03542835": "28350 - cheese, nagelkaas (efsa foodex2)",
    "FOODON_00002639": "Zakynthos Wine",
    "FOODON_03400699": "09  chocolate (efg)",
    "CHEBI_30832": "adipic acid",
    "FOODON_03316877": "mammalian milk (sour, flavored)",
    "FOODON_03316758": "bonito packed in water canned",
    "FOODON_00002824": "lung (whole, raw)",
    "FOODON_03400429": "liquid freezant (codex)",
    "FOODON_03302985": "cheese dip",
    "FOODON_03304569": "imitation rose hip jelly",
    "FOODON_03450043": "double steaming",
    "FOODON_03307535": "spinach (chopped, in butter sauce, canned)",
    "FOODON_03543461": "34610 - aloe leaf gel (pulp) (efsa foodex2)",
    "HANCESTRO_0546": "Swazi",
    "FOODON_03308374": "crayfish (raw)",
    "FOODON_03414600": "black sea bream",
    "FOODON_03305019": "dietary wafer",
    "FOODON_03309179": "southern cod (raw)",
    "FOODON_03301398": "squash seed (food product)",
    "FOODON_03306325": "raisin and nut mix",
    "FOODON_03311128": "soft drink (prepared from cherry powder)",
    "ENVO_00003884": "farmyard manure",
    "FOODON_03400999": "10000604 - fruit/nuts/seeds combination variety packs (gs1 gpc)",
    "FOODON_00003105": "java apple (whole, raw)",
    "FOODON_00001157": "pomaceous fruit juice beverage",
    "FOODON_03308295": "whitebait fish (raw)",
    "FOODON_03542298": "22980 - pacific salmon (generic) (efsa foodex2)",
    "FOODON_00001083": "sugar condiment",
    "CHEBI_35987": "diamino acid",
    "FOODON_03302488": "wheat bread (canned)",
    "FOODON_03315780": "coconut (shredded)",
    "FOODON_00002500": "spice rub",
    "NCBITaxon_8139": "Oreochromis",
    "FOODON_03307645": "candy (egg-shaped)",
    "FOODON_03400314": "soft cheese (codex)",
    "FOODON_03315742": "dessert mix, unstandardized",
    "FOODON_03311154": "chocolate icing aspartame sweetened",
    "FOODON_03309617": "liza (fish) (raw)",
    "NCBITaxon_94992": "Silurus",
    "FOODON_03311118": "breakfast cereal (fruit-flavored)",
    "FOODON_03414620": "dragon lizard",
    "FOODON_03309855": "whole oats (raw)",
    "FOODON_03307819": "ginseng and jasmine tea (instant)",
    "FOODON_03412851": "cytophagales",
    "NCBITaxon_33129": "Phaseolus acutifolius",
    "NCBITaxon_8187": "Lates calcarifer",
    "FOODON_03317462": "fruit spirit drink",
    "FOODON_03307846": "cheese (shredded)",
    "FOODON_03309249": "tapenade provencale",
    "NCBITaxon_173315": "Carangoides ruber",
    "FOODON_03309824": "khoa",
    "FOODON_03304984": "imitation ice milk (nutritively sweetened)",
    "FOODON_00002086": "passion food product",
    "FOODON_03414962": "cinnamon rose plant",
    "CHEBI_51234": "magnesium halide",
    "FOODON_03413702": "european flying squid",
    "FOODON_03401107": "10000255 - sandwiches/filled rolls/wraps (perishable) (gs1 gpc)",
    "FOODON_03414782": "poinciana plant",
    "FOODON_03540180": "01800 - fresh durum pasta (efsa foodex2)",
    "FOODON_03309676": "stewart island oyster (raw)",
    "UO_0000109": "pressure unit",
    "FOODON_03309372": "cottonseed press cake",
    "FOODON_03317617": "crab (raw, frozen)",
    "FOODON_00002990": "food (julienned)",
    "FOODON_03411714": "rooster",
    "FOODON_03305622": "diabetic ice cream",
    "NCBITaxon_76914": "Cirrhitidae",
    "FOODON_03400246": "decoration (us cfr)",
    "FOODON_03305510": "tangelo (raw)",
    "FOODON_03401317": "botanical supplement with vitamin/mineral",
    "CHEBI_18246": "(1->4)-beta-D-glucan",
    "FOODON_03304536": "malted wheat flour mix",
    "FOODON_03540756": "07560 - arrowhead (efsa foodex2)",
    "FOODON_03304788": "luk on tea (dry)",
    "FOODON_03414648": "puffball",
    "FOODON_03316721": "peach (quick-frozen)",
    "NCBITaxon_215440": "Nototodarus sloanii",
    "FOODON_03401547": "10000605 - fruits/vegetables/nuts/seeds variety packs (gs1 gpc)",
    "FOODON_00002984": "tataki",
    "FOODON_03411780": "florida pompano",
    "FOODON_03316446": "onion granules",
    "FOODON_03540913": "09130 - common nettle (efsa foodex2)",
    "NCBITaxon_69695": "Strombus",
    "NCBITaxon_6535": "Helix aspersa",
    "NCBITaxon_9785": "Loxodonta africana",
    "FOODON_03311205": "hen egg yolk (raw, sugared)",
    "FOODON_03303871": "cheese turnover",
    "FOODON_03306071": "imitation mint-flavored jelly mint leaves added",
    "FOODON_03316772": "cocoa (low-fat)",
    "FOODON_03305678": "frosting mix (naturally and artificially sweetened)",
    "FOODON_03315378": "beverage (lactobacillus, sterilized)",
    "FOODON_03310774": "breakfast cereal (fortified, hot)",
    "FOODON_00002740": "food packaging process",
    "FOODON_03541938": "19380 - asses-mules-hinnies, minced meat (efsa foodex2)",
    "FOODON_03315509": "cereal flakes for infants or young children",
    "FOODON_03000005": "Indian prawn",
    "FOODON_03542015": "20150 - pig liver (efsa foodex2)",
    "CHEBI_25048": "linolenic acid",
    "FOODON_03544032": "40320 - fruit salad (efsa foodex2)",
    "FOODON_03401220": "classification of products of plant and animal origin, european community",
    "FOODON_03301371": "asparagus (canned)",
    "FOODON_03302368": "bread stuffing (unprepared)",
    "FOODON_03316038": "confectionery (cocoa-based)",
    "FOODON_03400646": "c.  primary feed commodities (ccpr)",
    "FOODON_03315234": "topping, whipped, edible oil",
    "FOODON_03316280": "fish product (fried)",
    "FOODON_03411887": "needlefish family",
    "FOODON_00002681": "milk fat",
    "HANCESTRO_0549": "Zambian",
    "FOODON_03412932": "vangueriopsis plant",
    "FOODON_03305637": "peanut butter (hydrogenated)",
    "FOODON_03542839": "28390 - cheese, ossau-iraty (efsa foodex2)",
    "NCBITaxon_4014": "Burseraceae",
    "CHEBI_87034": "aromatic fungicide",
    "NCBITaxon_81370": "Lampris guttatus",
    "FOODON_03306697": "beet leaf (raw)",
    "FOODON_03308073": "cod fillet (frozen)",
    "FOODON_03412508": "spaghetti squash plant",
    "NCBITaxon_103351": "Vitis amurensis",
    "FOODON_00003010": "Nankin cherry",
    "FOODON_03310734": "rose wine",
    "FOODON_00003232": "bolognese sauce",
    "FOODON_03412563": "serrano pepper plant",
    "FOODON_00001873": "food spread",
    "FOODON_03308012": "east indian pomfret (raw)",
    "GAZ_00002888": "State of Florida",
    "FOODON_03520510": "salt water fishing area",
    "NCBITaxon_6479": "Neogastropoda",
    "FOODON_00003212": "confectionery fat",
    "NCBITaxon_4045": "Apium graveolens",
    "FOODON_03510209": "\"naturally/natural\" label claim",
    "FOODON_03304490": "cake flour (high ratio)",
    "FOODON_03303084": "coconut milk",
    "FOODON_03413947": "pigfish",
    "NCBITaxon_39171": "Monarda <eudicots>",
    "BFO_0000144": "process profile",
    "FOODON_03412285": "mexican flounder",
    "FOODON_03302522": "butter-flavored bakery product",
    "FOODON_03540141": "01410 - pita bread (efsa foodex2)",
    "FOODON_03317016": "sweet cream",
    "FOODON_03540156": "01560 - extruded, pressed or puffed bread (efsa foodex2)",
    "CHEBI_28838": "lutein",
    "FOODON_03308782": "mussel (raw, frozen)",
    "FOODON_03541218": "12180 - annual honesty seeds (efsa foodex2)",
    "FOODON_03401671": "10005797 - mixed species meat - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03302957": "candied cherry",
    "FOODON_03316915": "fish (smoked, vacuum packed)",
    "NCBITaxon_91888": "lamiids",
    "FOODON_03401324": "dietary supplement, vitamin(s) and fatty acids",
    "FOODON_03413410": "blackjack plant",
    "RO_0002577": "system",
    "FOODON_03400147": "milk or milk product analog (us cfr)",
    "FOODON_03414735": "greenhood orchid plant",
    "GAZ_00002733": "The Bahamas",
    "FOODON_03315137": "white potato (cut, frozen)",
    "HANCESTRO_0009": "East Asian",
    "FOODON_03542255": "22550 - striped snakehead (efsa foodex2)",
    "FOODON_03305677": "seafood (frozen)",
    "FOODON_03303098": "coffee bean meal (extracted)",
    "FOODON_03540349": "03490 - wheat bran rolled flakes (efsa foodex2)",
    "FOODON_03306678": "meat tenderizer (liquid)",
    "FOODON_03414941": "tuberous-root mustard plant",
    "FOODON_03440014": "fully heat-treated",
    "FOODON_03316460": "meat product (cured, low sodium)",
    "FOODON_00002203": "rice based alcoholic beverage",
    "FOODON_03401641": "10005781 - pork - prepared/processed (gs1 gpc)",
    "FOODON_03305829": "nut (roasted)",
    "FOODON_03540389": "03890 - baby leaf escaroles (efsa foodex2)",
    "FOODON_03303028": "chicken fricassee",
    "FOODON_03543770": "37700 - follow-on formula, based on protein hydrolysates, liquid (efsa foodex2)",
    "FOODON_03306465": "donkey meat (frozen)",
    "FOODON_00002117": "obsolete: pimiento pepper product",
    "FOODON_00002065": "olive fat or oil refined food product",
    "FOODON_03302324": "honey and egg bun",
    "FOODON_03541788": "17880 - baobab fruits (efsa foodex2)",
    "FOODON_03411521": "sailfish",
    "FOODON_00001679": "cape hake food product",
    "FOODON_03470151": "preservation of food component by heat treatment",
    "FOODON_03301661": "soup (canned)",
    "FOODON_03303788": "lollipop (vitamin-fortified)",
    "FOODON_03301286": "strawberry (sliced, frozen)",
    "FOODON_03415031": "korean pine plant",
    "CHEBI_24898": "isoleucine",
    "FOODON_03316803": "macaroni (enriched with fortified protein)",
    "FOODON_03411405": "buckwheat plant",
    "FOODON_03413583": "cape lobster",
    "FOODON_00001238": "microbial rennet food product",
    "CHEBI_32145": "sodium hydroxide",
    "FOODON_00001916": "grain based alcoholic beverage",
    "FOODON_03414652": "pygmy groundcherry plant",
    "CHEBI_33856": "aromatic amino acid",
    "FOODON_03316911": "horseradish root food product",
    "FOODON_03316789": "prune juice (canned)",
    "FOODON_03309906": "sorghum seed (raw, dried)",
    "FOODON_03413819": "neotropical silverside family",
    "FOODON_03414269": "strawberry raspberry plant",
    "FOODON_03541634": "16340 - silverberries (efsa foodex2)",
    "FOODON_03544225": "42250 - carrot flavour (efsa foodex2)",
    "FOODON_03414814": "striate mud creeper",
    "FOODON_03307850": "chinese imperial tea (dry)",
    "FOODON_03540973": "09730 - konjac roots (efsa foodex2)",
    "FOODON_03400665": "17  derived edible products of animal origin (ccpr)",
    "FOODON_03317051": "jam (with no added sugar)",
    "FOODON_03413292": "sucrose acetate isobutyrate",
    "FOODON_03414725": "bush banana plant",
    "NCBITaxon_9986": "Oryctolagus cuniculus",
    "FOODON_03541452": "14520 - kaffir limes (efsa foodex2)",
    "FOODON_03543254": "32540 - aloe vera juice (efsa foodex2)",
    "FOODON_03414434": "4-hexylresorcinol",
    "NCBITaxon_4068": "Gymnema sylvestre",
    "FOODON_03305261": "imitation cream",
    "FOODON_03303723": "lollipop (taffy apple)",
    "FOODON_03304950": "oxtail soup",
    "FOODON_03541361": "13610 - asafetida roots (efsa foodex2)",
    "FOODON_03316109": "cereal protein-based fish analog",
    "FOODON_00002002": "lime preserve or jam food product",
    "FOODON_03308289": "scrawled sole (raw)",
    "FOODON_03302339": "flour (white)",
    "FOODON_03543880": "38800 - potato based dishes (efsa foodex2)",
    "FOODON_03413097": "ethyl-p-hydroxybenzoate",
    "FOODON_00002825": "lamb kidney (whole, raw)",
    "FOODON_03305662": "juice drink (diluted)",
    "NCBITaxon_1110592": "Pseudolais micronemus",
    "NCBITaxon_6761": "Scylla serrata",
    "FOODON_03301103": "orange juice",
    "FOODON_03413339": "alpine strawberry plant",
    "FOODON_03311486": "wheat-based breakfast cereal ready-to-eat",
    "FOODON_03316865": "pasteurized blended cheese with fruits vegetables or meats",
    "FOODON_03316165": "potato (peeled)",
    "FOODON_03540369": "03690 - head lettuces (efsa foodex2)",
    "FOODON_03460371": "food additive added, usa",
    "HANCESTRO_0552": "Aboriginal Australian",
    "HANCESTRO_0419": "Paraguayan",
    "FOODON_03305002": "shrimp cracker",
    "FOODON_03420101": "stem or stalk (without leaves)",
    "NCBITaxon_3824": "Canavalia gladiata",
    "CHEBI_28044": "phenylalanine",
    "NCBITaxon_36599": "Sorbus aucuparia",
    "FOODON_03540768": "07680 - carrageen mosses (efsa foodex2)",
    "FOODON_03305292": "papaya (canned)",
    "CHEBI_59765": "boric acids",
    "FOODON_03411930": "bullet tuna",
    "NCBITaxon_224707": "Brevoortia patronus",
    "FOODON_03305471": "potato (dehydrofrozen)",
    "FOODON_03411179": "spice or flavor-producing plant",
    "FOODON_03543610": "36100 - red clover infusion flowers (efsa foodex2)",
    "NCBITaxon_544448": "Tenericutes",
    "FOODON_03311130": "shrimp (breaded, fried, homemade)",
    "FOODON_03315048": "yogurt derived product",
    "NCBITaxon_278736": "Menticirrhus littoralis",
    "ENVO_00000191": "solid astronomical body part",
    "FOODON_03306664": "vegetable oil (heat-processed)",
    "FOODON_03304221": "banana flake",
    "FOODON_03309829": "chocolate-covered peanut",
    "IAO_0000601": "has associated axiom(nl)",
    "FOODON_00002180": "pumpkin food product",
    "FOODON_03400721": "31  other milk products (efg)",
    "FOODON_03415044": "trifoliate orange plant",
    "FOODON_03401379": "50261900 - micro vegetables (gs1 gpc)",
    "IAO_0000118": "alternative term",
    "FOODON_03315074": "fruit (dried, diced, and glazed)",
    "CHEBI_53270": "polystyrene macromolecule",
    "FOODON_03540629": "06290 - lentil (young pods) (efsa foodex2)",
    "FOODON_03310684": "peanut (whole, roasted, skin off)",
    "NCBITaxon_9995": "Marmota monax",
    "FOODON_03414708": "bush onion plant",
    "FOODON_03530151": "biotechnologically derived food",
    "FOODON_03414010": "greater sandeel",
    "FOODON_00001267": "donkey milk beverage",
    "FOODON_03530132": "gite avant",
    "FOODON_03413578": "ice krill",
    "FOODON_03301457": "tomato puree",
    "FOODON_03316603": "food concentrate",
    "FOODON_03308704": "snail (in shell, canned)",
    "FOODON_03316115": "beverage flavored fruit juice based nonalcoholic",
    "FOODON_03310633": "sage rubbed",
    "FOODON_03308251": "lumpfish (raw)",
    "FOODON_03310557": "infant formula (soy-based, powdered)",
    "FOODON_03541118": "11180 - tree nuts (efsa foodex2)",
    "FOODON_03413572": "white river crayfish",
    "FOODON_03543865": "38650 - seafood salad (efsa foodex2)",
    "FOODON_03305777": "lemonade mix",
    "FOODON_03543477": "34770 - common vervain infusion leaves (efsa foodex2)",
    "FOODON_03401858": "10006272 - fennel (subspecies azoricum) (gs1 gpc)",
    "FOODON_03305521": "cookie (sweetened with sorbitol)",
    "FOODON_03301125": "blueberry jam",
    "FOODON_03303946": "butternut squash (frozen)",
    "FOODON_03317212": "beverage (dietetic)",
    "NCBITaxon_37052": "Ardenna grisea",
    "FOODON_03316522": "tomato multi-component product",
    "FOODON_00001022": "Bleu de Bresse cheese",
    "FOODON_00002137": "plant derived soft drink",
    "FOODON_03306273": "beverage (canned)",
    "FOODON_03311255": "green pea (whole, cooked)",
    "FOODON_03544489": "44890 - calcium (efsa foodex2)",
    "FOODON_03414173": "nameko mushroom",
    "FOODON_03413662": "garden snail",
    "FOODON_00002971": "food (precooked)",
    "NCBITaxon_8181": "Pomoxis",
    "GAZ_00006895": "Macedonia",
    "FOODON_03413716": "broadleaf wild leek plant",
    "FOODON_00002378": "plant product based seasoning",
    "FOODON_03540149": "01490 - crisp bread (efsa foodex2)",
    "FOODON_03308186": "eliza crab (raw)",
    "FOODON_03540528": "05280 - choi sum (efsa foodex2)",
    "FOODON_03543351": "33510 - wine, red (efsa foodex2)",
    "FOODON_03401810": "10006111 - sweet potatoes (gs1 gpc)",
    "FOODON_03302060": "seasoning mix",
    "CHEBI_35163": "cyclic carotene",
    "FOODON_03542156": "21560 - cured ripened raw sausages (efsa foodex2)",
    "FOODON_03413210": "potassium hydrogen sulphate",
    "FOODON_03308134": "langostino (without shell, canned)",
    "FOODON_03311160": "hamburger (soy-fortified, fried)",
    "FOODON_00001312": "mum-sai-pla",
    "FOODON_03413638": "pod razor",
    "FOODON_03414456": "steviol glycosides",
    "FOODON_03413385": "brome grass plant",
    "FOODON_03541319": "13190 - radhuni seed (efsa foodex2)",
    "CHEBI_23652": "dextrins",
    "FOODON_03316407": "barley groats",
    "FOODON_03412053": "coca plant",
    "PO_0004542": "rhizome",
    "FOODON_03411272": "almond tree",
    "FOODON_03412210": "blue king crab",
    "FOODON_03307308": "cherry wine (food product)",
    "FOODON_03540296": "02960 - baklava (efsa foodex2)",
    "NCBITaxon_420456": "Rostroraja alba",
    "FOODON_03302563": "cow milk (unpasteurized)",
    "FOODON_03540966": "09660 - cassava roots (efsa foodex2)",
    "FOODON_03413664": "turkish snail",
    "FOODON_03480014": "packed in gas other than air",
    "NCBITaxon_329465": "Cyclopsetta chittendeni",
    "NCBITaxon_64580": "Tilia",
    "FOODON_03311136": "mixed vegetables or garden vegetables (strained or junior food in jar)",
    "FOODON_03305382": "bread (homemade)",
    "NCBITaxon_6732": "Palinurus",
    "FOODON_03542387": "23870 - lesser sand eel (efsa foodex2)",
    "PATO_0001548": "quality of a liquid",
    "FOODON_03413592": "new zealand lobster",
    "FOODON_03401304": "single vitamin supplement",
    "FOODON_03305621": "dietetic ice cream",
    "FOODON_03310642": "breakfast cereal (high fiber)",
    "NCBITaxon_23672": "Sapindaceae",
    "FOODON_03400137": "ice cream or frozen custard (us cfr)",
    "FOODON_03544100": "41000 - bechamel sauce (efsa foodex2)",
    "FOODON_03305295": "tropical fruit (canned)",
    "FOODON_03540938": "09380 - tomato paste (efsa foodex2)",
    "FOODON_03510078": "no salt added claim or use",
    "FOODON_03544426": "44260 - modified starch (efsa foodex2)",
    "FOODON_03302457": "cheese bread",
    "FOODON_03544297": "42970 - ketchup flavour (efsa foodex2)",
    "FOODON_03414224": "muskmelon, cantaloupe group (plant)",
    "FOODON_03306018": "orange drink (vitamin c added)",
    "FOODON_03311119": "milkshake (chocolate-flavored)",
    "FOODON_03510275": "hopi food claim or use",
    "FOODON_03541611": "16110 - rose hips and similar- (efsa foodex2)",
    "FOODON_03308598": "crab finger crabmeat",
    "FOODON_03413895": "north pacific hake",
    "FOODON_03414013": "flathead sculpin",
    "FOODON_03312046": "ham (cooked)",
    "FOODON_03400276": "dressing for food (us cfr)",
    "FOODON_03542369": "23690 - gilthead seabream (efsa foodex2)",
    "FOODON_03304979": "soybean grits (mace-flavored)",
    "NCBITaxon_50190": "Sonchus",
    "FOODON_03411853": "european sardine",
    "FOODON_03543025": "30250 - mannitol (efsa foodex2)",
    "CHEBI_17151": "xylitol",
    "FOODON_03305731": "hen egg and mushroom spread",
    "FOODON_03542050": "20500 - ratites kidney (efsa foodex2)",
    "CHEBI_26416": "pyridine alkaloid",
    "FOODON_03308508": "mushroom (chef-cut, in butter sauce, canned)",
    "NCBITaxon_473319": "Macrourus berglax",
    "FOODON_03542323": "23230 - barramundi (efsa foodex2)",
    "FOODON_03412278": "european john dory",
    "FOODON_03310735": "kidney bean (whole, dried)",
    "FOODON_03310942": "peas and onions (raw)",
    "FOODON_03540432": "04320 - garland chrysanthemums leaves (efsa foodex2)",
    "FOODON_00002098": "peanut fat or oil refined food product",
    "FOODON_03302431": "beverage (vitamin- and mineral-fortified)",
    "FOODON_03411418": "hard wheat plant",
    "FOODON_03470106": "food smoking",
    "FOODON_03500015": "food-grade wax surface",
    "FOODON_03541681": "16810 - jambuls and similar- (efsa foodex2)",
    "FOODON_03315449": "kinako",
    "FOODON_03542804": "28040 - cheese, cantal (efsa foodex2)",
    "FOODON_03412213": "blue swimming crab",
    "FOODON_03411228": "common carp",
    "FOODON_03411284": "ambarella plant",
    "NCBITaxon_8070": "Lophiiformes",
    "NCBITaxon_4220": "Artemisia vulgaris",
    "FOODON_03311555": "porridge",
    "FOODON_03412187": "toadfish",
    "NCBITaxon_112726": "Polyprionidae",
    "FOODON_03308507": "mushroom (sliced, in butter sauce, canned)",
    "FOODON_03311545": "hop extract (modified)",
    "FOODON_03490288": "aluminium box, plastic-coated",
    "FOODON_03307660": "tonic water",
    "GAZ_00002945": "Greece",
    "FOODON_03311132": "chicken potato cornbread and/or vegetable frozen dinner",
    "PATO_0045057": "normal perimeter",
    "FOODON_03411290": "walnut tree",
    "FOODON_03307129": "potato chip (reduced sodium)",
    "FOODON_00001288": "cantaloupe fruit food product",
    "NCBITaxon_9823": "Sus scrofa",
    "NCBITaxon_123731": "Belonoidei",
    "FOODON_03541516": "15160 - chinese jujubes (efsa foodex2)",
    "CHEBI_27208": "unsaturated fatty acid",
    "FOODON_03310338": "chicken feed",
    "FOODON_03413880": "blue whiting (genus)",
    "FOODON_00002076": "paddlefish food product",
    "FOODON_03541075": "10750 - flageolets (dry seeds) (efsa foodex2)",
    "FOODON_03306630": "chocolate doughnut",
    "NCBITaxon_78511": "Ribes nigrum",
    "FOODON_03311131": "pork sausage (oven-cooked)",
    "FOODON_03316992": "amanatto (dry candied bean)",
    "FOODON_03541403": "14030 - tamarind (efsa foodex2)",
    "FOODON_03310136": "sago",
    "FOODON_03541025": "10250 - black eyed peas (without pods) (efsa foodex2)",
    "GAZ_00002463": "Central Asia",
    "FOODON_03305863": "imitation jam",
    "FOODON_03414341": "european pennyroyal plant",
    "FOODON_03470175": "food blanching",
    "FOODON_03543579": "35790 - german chamomile (efsa foodex2)",
    "FOODON_00002948": "kohlrabi leaf",
    "NCBITaxon_8561": "Gekkonidae",
    "FOODON_03301225": "mustard seed (ground)",
    "FOODON_03303795": "confection (cold-pressed)",
    "FOODON_03307144": "spanish olive (stuffed with pureed pimiento)",
    "FOODON_03317347": "poultry spread",
    "FOODON_03541460": "14600 - cleopatra mandarins (efsa foodex2)",
    "FOODON_03315488": "obsolete: milk beverage",
    "FOODON_03414837": "lillipilly plant",
    "FOODON_03544432": "44320 - stabiliser (efsa foodex2)",
    "FOODON_03401712": "10005972 - durian (gs1 gpc)",
    "FOODON_03413482": "common ground dove",
    "FOODON_03400398": "dietary supplement (codex)",
    "FOODON_00001033": "emmenthal cheese food product",
    "FOODON_03544136": "41360 - cucumber chutney (efsa foodex2)",
    "NCBITaxon_4557": "Sorghum",
    "NCBITaxon_3118": "Ulva",
    "FOODON_03413418": "bambara groundnut plant",
    "FOODON_03413948": "african striped grunt",
    "FOODON_03307316": "fish ball with lobster sauce (canned)",
    "FOODON_00002583": "Chardonnay grape plant",
    "FOODON_03411370": "sugar beet plant",
    "NCBITaxon_8006": "Salmoniformes",
    "FOODON_03542514": "25140 - white shrimp (efsa foodex2)",
    "FOODON_03413570": "swim crab (callinectes spp.)",
    "FOODON_03311641": "barbecue bean salad",
    "FOODON_03415010": "chameleon-plant plant",
    "FOODON_03412885": "bigeye cardinalfish",
    "FOODON_03540473": "04730 - head cabbages and similar- (efsa foodex2)",
    "FOODON_03305480": "soft drink mix (instant, artificially sweetened)",
    "FOODON_03400380": "buffering agent (codex)",
    "FOODON_03309114": "roughy (raw)",
    "FOODON_03420208": "seed, skin removed, germ removed (endosperm)",
    "FOODON_03460233": "food (fat or oil coated)",
    "NCBITaxon_58168": "Bambusa vulgaris",
    "NCBITaxon_90074": "Microchirus variegatus",
    "FOODON_03414843": "nippon orangequat",
    "FOODON_03541794": "17940 - chocolate coated dried fruit (efsa foodex2)",
    "FOODON_03543241": "32410 - juice concentrate, peach (efsa foodex2)",
    "FOODON_03415066": "mugwort plant",
    "FOODON_03540469": "04690 - vegetable fern (efsa foodex2)",
    "GAZ_00001550": "Guernsey",
    "FOODON_03301267": "olive (salt-cured)",
    "FOODON_03303884": "italian pork sausage (raw)",
    "NCBITaxon_34878": "Cervinae",
    "FOODON_03414313": "blood orange plant",
    "HANCESTRO_0491": "Sri Lankan",
    "FOODON_03541355": "13550 - lesser galangal roots (efsa foodex2)",
    "GAZ_00004941": "Azerbaijan",
    "FOODON_03304875": "marijuana seed (roasted)",
    "CHEBI_26197": "polyphosphates",
    "FOODON_03308351": "shovel nose lobster (raw)",
    "NCBITaxon_435272": "Parastromateus niger",
    "FOODON_03541861": "18610 - fruit in alcohol or spirits (efsa foodex2)",
    "NCBITaxon_466585": "Tetraoninae",
    "GAZ_00005286": "Qatar",
    "FOODON_03414597": "european sea bass",
    "FOODON_03543531": "35310 - oat infusion leaves (efsa foodex2)",
    "FOODON_03311433": "wine (low-alcohol)",
    "FOODON_03400644": "a.  primary food commodities of plant origin (ccpr)",
    "FOODON_00002962": "poult",
    "NCBITaxon_8853": "Branta canadensis",
    "FOODON_03412846": "bacteria",
    "CHEBI_26819": "sulfuric ester",
    "FOODON_03541482": "14820 - quinces (efsa foodex2)",
    "CHEBI_26395": "purine nucleotide",
    "FOODON_03540272": "02720 - chocolate cake (efsa foodex2)",
    "FOODON_03414232": "trapp avocado plant",
    "NCBITaxon_185002": "Plantago ovata",
    "NCBITaxon_7902": "Acipenser gueldenstaedtii",
    "CHEBI_27364": "zinc molecular entity",
    "FOODON_03302581": "butter nut candy",
    "NCBITaxon_13733": "Trichiurus lepturus",
    "FOODON_03412334": "chain pickerel",
    "FOODON_03303187": "corn meal (water ground)",
    "FOODON_03308022": "pacific cod (raw)",
    "FOODON_03311595": "pouchong tea (dry)",
    "FOODON_03541522": "15220 - plumcots (efsa foodex2)",
    "FOODON_00003419": "indian mustard plant",
    "FOODON_03311474": "beef shortening",
    "FOODON_03401055": "10000585 - fats edible - vegetable or plant (perishable) (gs1 gpc)",
    "FOODON_00002814": "ikajime",
    "FOODON_03315973": "sandwich spread (dried-fruit-based, energy reduced)",
    "FOODON_03542844": "28440 - cheese, provolone (efsa foodex2)",
    "NCBITaxon_54904": "Hiodon alosoides",
    "FOODON_03540760": "07600 - green algae (efsa foodex2)",
    "FOODON_03301011": "beverage (carbonated)",
    "FOODON_03415106": "spleen amaranth plant",
    "FOODON_03311521": "infant formula (milk-based, liquid, iron-fortified, concentrated)",
    "FOODON_03544503": "45030 - omega-3 fatty acids (efsa foodex2)",
    "FOODON_03311724": "seafood chowder",
    "FOODON_03311226": "tuna (freeze-dried)",
    "FOODON_03510120": "\"fresh\" label claim",
    "FOODON_03304936": "chicken bouillon mix",
    "FOODON_03306026": "plum nectar (canned)",
    "FOODON_03316391": "asparagus (dried)",
    "FOODON_03542425": "24250 - tuna, skipjack (efsa foodex2)",
    "HANCESTRO_0449": "Saudi",
    "FOODON_03309953": "fennel (food product)",
    "FOODON_03306406": "orange jelly marmalade",
    "FOODON_03415028": "chinese white olive plant",
    "FOODON_03401548": "10006263 - beech mushrooms (gs1 gpc)",
    "FOODON_03412509": "butternut squash plant",
    "FOODON_03412114": "snail",
    "FOODON_03301561": "root vegetable (whole, raw)",
    "FOODON_03308814": "shrimp newburg (dish)",
    "FOODON_03308828": "blue runner (raw)",
    "FOODON_03415079": "ribwort plantain plant",
    "FOODON_03412690": "new zealand dredge oyster",
    "FOODON_03401046": "50132100 - yoghurt/yoghurt substitutes (gs1 gpc)",
    "NCBITaxon_643373": "Cyclocheilichthys enoplos",
    "NCBITaxon_66674": "Cochlospermum",
    "FOODON_03543472": "34720 - centaury infusion leaves (efsa foodex2)",
    "FOODON_00002441": "rockfish food product",
    "UO_0000051": "concentration unit",
    "FOODON_03316583": "dessert powder (fruity)",
    "FOODON_03400368": "antifoaming agent (codex)",
    "FOODON_00003299": "grape tomato (whole, raw)",
    "GAZ_00002564": "Province of Saskatchewan",
    "FOODON_03401192": "10000055 - sauces - cooking (perishable) (gs1 gpc)",
    "FOODON_03460331": "food interior mold curing",
    "FOODON_03304591": "imitation maple-flavored syrup mix (artificially sweetened, dry)",
    "GAZ_00000587": "Sub-Saharan Africa",
    "NCBITaxon_43062": "Engraulidae",
    "FOODON_03305744": "grape juice beverage base (sweetened, powdered)",
    "FOODON_03302715": "brine",
    "FOODON_03411286": "palm plant",
    "FOODON_03302492": "rye flour",
    "FOODON_03490356": "laminate paper coextruded with plastic",
    "FOODON_03310325": "skim milk product (flavored)",
    "FOODON_00003254": "mille-feuille pastry",
    "FOODON_03316617": "fruit puree for further processing",
    "NCBITaxon_3661": "Cucurbita maxima",
    "NCBITaxon_69555": "Caenogastropoda",
    "FOODON_03540347": "03470 - processed wheat-based flakes (efsa foodex2)",
    "FOODON_03530277": "blue flesh",
    "NCBITaxon_4199": "Dipsacales",
    "FOODON_03543898": "38980 - mushy peas (efsa foodex2)",
    "FOODON_03460364": "dried or candied fruit",
    "FOODON_03309997": "food product for animal",
    "FOODON_03541141": "11410 - hazelnuts and similar- (efsa foodex2)",
    "NCBITaxon_2769": "Chondrus crispus",
    "NCBITaxon_3256": "Equisetaceae",
    "FOODON_03414869": "giant snakehead",
    "FOODON_03309868": "peanut fodder",
    "FOODON_03316547": "cream (sterilized, soft)",
    "NCBITaxon_28930": "Fagus sylvatica",
    "FOODON_03304343": "memmi",
    "NCBITaxon_308079": "Dormitator latifrons",
    "FOODON_03301620": "fish meal",
    "FOODON_03316448": "sugar (decorative type)",
    "NCBITaxon_160736": "Mycteroperca venenosa",
    "CHEBI_15705": "L-alpha-amino acid",
    "FOODON_03304406": "salmon (no salt or oil added)",
    "FOODON_03542501": "25010 - lobsters, spiny-rock lobster (efsa foodex2)",
    "FOODON_03415080": "shepherd's purse plant",
    "FOODON_03317436": "crustacean (deep-frozen)",
    "FOODON_03301821": "brazilnut (whole, raw)",
    "NCBITaxon_9900": "Bison",
    "FOODON_03316046": "poultry fat",
    "FOODON_03412217": "rough redeye crab",
    "FOODON_03413841": "baltic herring",
    "FOODON_03430147": "whole, shape achieved by forming",
    "FOODON_03400413": "flavouring agent (codex)",
    "FOODON_03315093": "vitamin preparation, dry",
    "FOODON_03411753": "obsolete: green bean and pinto bean plant",
    "FOODON_03301450": "red variety sweet potato (whole, raw, skin on)",
    "FOODON_03305241": "strawberry in syrup (canned)",
    "http://www.w3.org/2000/01/rdf-schema#label": "label",
    "FOODON_03412928": "dialium plant",
    "FOODON_03540698": "06980 - butternut squashes (efsa foodex2)",
    "FOODON_03307759": "hamburger sandwich",
    "FOODON_03305039": "infant formula (milk-based, liquid, iron-fortified)",
    "FOODON_03301634": "agave worm (preserved in alcohol)",
    "FOODON_03305115": "chocolate marshmallow candy bar",
    "NCBITaxon_8473": "Chelydridae",
    "NCBITaxon_3503": "Fagaceae",
    "FOODON_03309549": "infant formula (meat-based)",
    "FOODON_03541714": "17140 - granadillas (efsa foodex2)",
    "FOODON_03315129": "spice extraction in soluble carrier",
    "FOODON_03303707": "banana passionfruit juice (food product)",
    "FOODON_03305632": "water extract of coconut meat",
    "FOODON_03542317": "23170 - ayu sweetfish (efsa foodex2)",
    "FOODON_00001568": "food trimmings",
    "FOODON_03315643": "cheese spread (processed)",
    "FOODON_00001731": "chinook salmon food product",
    "NCBITaxon_102814": "Heliantheae",
    "FOODON_03490256": "wooden cork",
    "CHEBI_36834": "3-hydroxy steroid",
    "FOODON_03305980": "orange juice (chilled)",
    "UO_0010034": "pound",
    "FOODON_03308644": "tiger fugu fish (raw)",
    "FOODON_03540948": "09480 - candied or sugar preserved vegetables (efsa foodex2)",
    "FOODON_03401214": "high fat cheese (codex)",
    "FOODON_03411899": "channel catfish",
    "FOODON_03412193": "ocean quahog",
    "FOODON_03413067": "citric acid esters of mono- and diglycerides of fatty acids",
    "PECO_0007038": "autumn season exposure",
    "FOODON_03301265": "olive (salad, pitted, quartered)",
    "FOODON_00003333": "sow",
    "CHEBI_23849": "diterpenoid",
    "FOODON_03305237": "tropical fruit (whole, raw)",
    "FOODON_03315683": "lobster meat (canned)",
    "NCBITaxon_145754": "Malva sylvestris",
    "FOODON_03412588": "coney",
    "FOODON_03541230": "12300 - grape seeds (efsa foodex2)",
    "FOODON_03305565": "ham soup base",
    "FOODON_03400643": "Codex Alimentarius classification of food and feed commodities",
    "FOODON_03542151": "21510 - preserved or partly preserved sausages (efsa foodex2)",
    "FOODON_03414862": "sharptooth catfish",
    "FOODON_03400196": "fruit nectar (us cfr)",
    "FOODON_03411896": "paddlefish family",
    "FOODON_03542031": "20310 - animal kidney (efsa foodex2)",
    "FOODON_03303569": "orange squash beverage",
    "NCBITaxon_1489830": "Aulopoidei",
    "FOODON_03540265": "02650 - fruit cake (efsa foodex2)",
    "FOODON_00001695": "cattle broth or stock food product",
    "FOODON_03540851": "08510 - sweet cicely (efsa foodex2)",
    "FOODON_03316474": "grain seed (glazed)",
    "FOODON_03540067": "00670 - cereal and cereal-like flours (efsa foodex2)",
    "FOODON_03414504": "tahitian spinach plant",
    "NCBITaxon_21880": "Salvia",
    "FOODON_03000001": "food peeling process",
    "FOODON_03316647": "cheese (frying, low-fat)",
    "CHEBI_24471": "halogen molecular entity",
    "FOODON_03301735": "sap sago cheese",
    "FOODON_03400751": "048  frogs, lizards, snakes and turtles (ar) (ccpr)",
    "FOODON_03309936": "black gram bean (whole)",
    "FOODON_03542829": "28290 - cheese, lubelski (efsa foodex2)",
    "FOODON_03303502": "gorgonzola cheese",
    "FOODON_03544459": "44590 - probiotic cultures (efsa foodex2)",
    "FOODON_00003085": "japanese chestnut (whole, raw)",
    "FOODON_03490379": "unplasticized polyvinyl chloride container",
    "FOODON_03305287": "papaya nectar (canned)",
    "FOODON_03303213": "oat cracker",
    "FOODON_03530283": "white skin",
    "FOODON_03301752": "food (freeze-dried)",
    "FOODON_00002534": "ossobuco",
    "NCBITaxon_3449": "Caltha palustris",
    "FOODON_03401381": "50261500 - peas  (with pods) (gs1 gpc)",
    "FOODON_03543711": "37110 - iced coffee (efsa foodex2)",
    "FOODON_03460754": "obsolete: barley malt added",
    "FOODON_03530052": "ripe or mature",
    "IAO_0000231": "has obsolescence reason",
    "FOODON_03414830": "black apple plant",
    "FOODON_03450045": "searing",
    "FOODON_03490393": "metallized polyamide container",
    "FOODON_03315251": "tableted foods for special dietary use",
    "NCBITaxon_237863": "Passiflora ligularis",
    "FOODON_03306187": "imitation lemonade mix",
    "FOODON_03316413": "glucose syrup (exclusively for commercial production of sweets and candies)",
    "FOODON_03543367": "33670 - sherry (efsa foodex2)",
    "FOODON_03540936": "09360 - tomato puree (efsa foodex2)",
    "FOODON_03309286": "south atlantic whitefish (raw)",
    "FOODON_03400634": "CCFAC fish and fish products",
    "FOODON_03543439": "34390 - cocoa beverage-preparation, powder (efsa foodex2)",
    "FOODON_03413461": "agile frog",
    "FOODON_03540088": "00880 - wheat flour (efsa foodex2)",
    "NCBITaxon_16736": "Piperales",
    "FOODON_03304377": "skim milk (vegetable oil added)",
    "FOODON_03306963": "noodle (japanese-style)",
    "NCBITaxon_6448": "Gastropoda",
    "FOODON_03304394": "malted milk ball",
    "FOODON_03490225": "multicomponent adhesive, water soluble",
    "FOODON_03401152": "50121700 - shellfish unprepared/unprocessed (gs1 gpc)",
    "FOODON_03400884": "10000227 - liqueurs (gs1 gpc)",
    "FOODON_03543038": "30380 - family chocolate (efsa foodex2)",
    "CHEBI_6650": "malic acid",
    "FOODON_03307667": "french toast (frozen)",
    "FOODON_03306070": "apple jelly mint-flavored artificially colored",
    "FOODON_03500021": "polypropylene surface",
    "FOODON_03414550": "parasol mushroom",
    "FOODON_03307834": "paella valenciana (dish, precooked, frozen)",
    "FOODON_03310300": "cleome viscosa oil",
    "FOODON_03401573": "10006056 - caraway (gs1 gpc)",
    "NCBITaxon_246365": "Dacryodes edulis",
    "FOODON_03307571": "brown cane sugar and dextrose",
    "FOODON_03490376": "oriented polypropylene container",
    "FOODON_03302214": "carrot (frozen, sliced)",
    "PO_0025476": "tuberous root tuber",
    "FOODON_03540519": "05190 - millet sprouts (efsa foodex2)",
    "FOODON_03400831": "pulse or pulse product (eurofir)",
    "FOODON_03302833": "obsolete: brown sugar",
    "FOODON_03306998": "goose liver paste",
    "FOODON_03411656": "sodium chloride mixt. with potassium chloride",
    "FOODON_03510187": "halal claim or use",
    "CHEBI_12777": "vitamin A",
    "FOODON_03303924": "macaroni elbow",
    "FOODON_03307087": "cherry spread with cherry liquer",
    "NCBITaxon_1293361": "Cenchrinae",
    "FOODON_03305497": "horseradish spread (artificially flavored)",
    "FOODON_03413384": "bluegrass plant",
    "FOODON_03401302": "dietary supplement, vitamin",
    "FOODON_03304541": "corned beef (raw)",
    "FOODON_03401469": "10006000 - savoy cabbages (gs1 gpc)",
    "FOODON_03414153": "south american rock mussel",
    "NCBITaxon_1609962": "Sapotoideae",
    "NCBITaxon_721789": "Potentilleae",
    "FOODON_03304367": "wine-flavored syrup",
    "FOODON_03542625": "26250 - hake, dried (efsa foodex2)",
    "FOODON_00002816": "lima bean (whole, raw)",
    "FOODON_03310435": "asparagus bean pod",
    "FOODON_03304588": "black cod (barbequed)",
    "FOODON_03414603": "peruvian calico scallop",
    "FOODON_00003198": "shea nut (whole, raw)",
    "CHEBI_37576": "gallate ester",
    "FOODON_03540095": "00950 - cereal and cereal-like flours not separately listed (efsa foodex2)",
    "FOODON_03541819": "18190 - jam, sweet cherry (efsa foodex2)",
    "FOODON_03414660": "cordia plant",
    "FOODON_03317102": "crustacean product (chilled)",
    "FOODON_03400221": "sausage or luncheon meat (us cfr)",
    "FOODON_03543315": "33150 - soft drink, raspberry flavour (efsa foodex2)",
    "FOODON_03307444": "yogurt (lowfat)",
    "FOODON_03540561": "05610 - common bamboo (efsa foodex2)",
    "FOODON_03543882": "38820 - potato casserole (efsa foodex2)",
    "FOODON_03317332": "obsolete: meat (not further specified)",
    "NCBITaxon_37710": "Lepas anatifera",
    "NCBITaxon_411572": "Anchoa hepsetus",
    "FOODON_03311414": "gelatin fruit salad (low calorie)",
    "FOODON_03308612": "crab (canned, frozen)",
    "NCBITaxon_508657": "Hyperoplus lanceolatus",
    "FOODON_03543265": "32650 - ice from tap water (efsa foodex2)",
    "FOODON_03540791": "07910 - nameko (efsa foodex2)",
    "FOODON_00002200": "amphibian or reptile food product",
    "FOODON_03414238": "mamey sapote plant",
    "NCBITaxon_29615": "Diplazium esculentum",
    "FOODON_03541845": "18450 - citrus fruit peel (efsa foodex2)",
    "FOODON_03309265": "dab (raw)",
    "FOODON_03303002": "chicken bone (cooked)",
    "FOODON_03413620": "solenocerid shrimp family",
    "FOODON_03544313": "43130 - marsala flavour (efsa foodex2)",
    "FOODON_03542094": "20940 - horse heart (efsa foodex2)",
    "NCBITaxon_1489939": "Pempheriformes",
    "FOODON_03316635": "cheese (soft, commercial)",
    "FOODON_03414532": "bobtail squid",
    "NCBITaxon_205567": "Solanum muricatum",
    "FOODON_03303116": "orange peel (raw)",
    "FOODON_03306237": "fruit flavor paste",
    "NCBITaxon_32247": "Rubus idaeus",
    "FOODON_03304256": "turtle soup (food product)",
    "FOODON_03542895": "28950 - cheese, caciocavallo (efsa foodex2)",
    "FOODON_03412170": "morid cod family",
    "FOODON_03304355": "peperoncino food product",
    "FOODON_03520137": "atlantic, eastern central (fao major fishing area 34)",
    "FOODON_03400278": "alcoholic beverage (us cfr)",
    "FOODON_03411611": "brussels sprout plant",
    "FOODON_00003015": "golden zucchini squash (whole)",
    "NCBITaxon_7778": "Elasmobranchii",
    "FOODON_03303618": "cocktail mix (nonalcoholic)",
    "FOODON_03305021": "breakfast beverage (artificially sweetened)",
    "FOODON_03543440": "34400 - tea leaves derivatives and tea ingredients (efsa foodex2)",
    "FOODON_03301659": "cockle (frozen)",
    "FOODON_03412764": "white star apple plant",
    "FOODON_03450042": "obsolete: food scalding or blanching process",
    "FOODON_03310921": "beef ground round (cooked, frozen)",
    "FOODON_03543857": "38570 - meat burger (no sandwich) (efsa foodex2)",
    "FOODON_03411392": "sardinella",
    "FOODON_00002671": "animal tissue",
    "FOODON_03305648": "ice (crushed)",
    "FOODON_03541100": "11000 - chickpea flour (efsa foodex2)",
    "NCBITaxon_186634": "Otomorpha",
    "FOODON_03460778": "chromium added",
    "FOODON_03306484": "alligator meat (raw)",
    "FOODON_03304870": "pumpkin seed (shell off)",
    "GAZ_00002553": "State of Washington",
    "NCBITaxon_3958": "Santalaceae",
    "FOODON_03311472": "mitsumame (jelly cube)",
    "FOODON_03301567": "wine cooler",
    "NCBITaxon_30992": "Pangasianodon",
    "NCBITaxon_48168": "Thunnus atlanticus",
    "FOODON_03460391": "seed roasting",
    "NCBITaxon_2": "Bacteria",
    "NCBITaxon_119693": "Caesio",
    "FOODON_03305101": "raspberry beverage syrup",
    "UBERON_0002107": "liver",
    "FOODON_03411041": "chemical food component",
    "FOODON_03304088": "beef barley soup",
    "FOODON_03543501": "35010 - hazelnut infusion leaves (efsa foodex2)",
    "FOODON_03301294": "pear juice",
    "FOODON_03541942": "19420 - camel, bactrian fresh meat (efsa foodex2)",
    "FOODON_03430164": "edible bar",
    "FOODON_03540205": "02050 - chemically leavened doughs (efsa foodex2)",
    "FOODON_03301007": "chocolate candy",
    "CHEBI_38700": "organic sodium salt",
    "NCBITaxon_111974": "Columbina passerina",
    "NCBITaxon_1983395": "Mobula birostris",
    "FOODON_03542755": "27550 - cheese, telemea (efsa foodex2)",
    "FOODON_03544312": "43120 - marjoram flavour (efsa foodex2)",
    "BFO_0000142": "one-dimensional continuant fiat boundary",
    "FOODON_00002695": "scallion food product",
    "NCBITaxon_194253": "Brosimum alicastrum",
    "FOODON_03411627": "burbot",
    "FOODON_03420295": "fruit seed (anatomical part)",
    "FOODON_03412253": "threadfin family",
    "FOODON_03305468": "grapefruit drink (cherry-flavored, artificially colored)",
    "FOODON_03510248": "high unsaturated  fat",
    "FOODON_03490213": "box",
    "FOODON_03544191": "41910 - artichoke flavour (efsa foodex2)",
    "FOODON_03412554": "guajillo pepper plant",
    "FOODON_03302376": "black bread",
    "FOODON_03543706": "37060 - instant coffee (beverage) (efsa foodex2)",
    "FOODON_00002159": "plantain (musa) food product",
    "FOODON_03541745": "17450 - mangoes and similar- (efsa foodex2)",
    "CHEBI_145207": "13'-carboxy-alpha-tocopherol",
    "FOODON_03530061": "obsolete: color of fish flesh not known",
    "NCBITaxon_6549": "Mytilus californianus",
    "FOODON_03500011": "beverage can enamel surface",
    "FOODON_03543883": "38830 - prepared potato salad (efsa foodex2)",
    "FOODON_03510167": "no water added claim or use",
    "FOODON_03541808": "18080 - jam, blackberries (efsa foodex2)",
    "NCBITaxon_51953": "Elaeis guineensis",
    "NCBITaxon_61127": "Anguilla dieffenbachii",
    "FOODON_03401201": "10000618 - vinegars/cooking wines variety packs (gs1 gpc)",
    "FOODON_03401559": "10006266 - wild mushrooms (other) (gs1 gpc)",
    "FOODON_03530050": "degree of plant maturity",
    "FOODON_03415084": "wild angelica plant",
    "FOODON_03310668": "mineral water (fruit essence added)",
    "FOODON_03540391": "03910 - baby leaf lettuces (efsa foodex2)",
    "FOODON_03311257": "cocoa butter substitute (made from marine oil)",
    "FOODON_03413380": "lespedeza plant",
    "FOODON_03317043": "fruit based dessert with no added sugar",
    "CHEBI_33752": "hexonic acid",
    "FOODON_03308808": "shrimp cutlet (breaded, frozen)",
    "FOODON_03301403": "bean (whole, raw)",
    "FOODON_03306518": "english walnut (whole, raw)",
    "FOODON_03317512": "meat product (jelly coated, cured)",
    "FOODON_00001949": "hemp food product",
    "FOODON_03306232": "almond (ground)",
    "FOODON_03305831": "sweetmilk biscuit",
    "CHEBI_33679": "helium molecular entity",
    "FOODON_03543950": "39500 - sausage roll (efsa foodex2)",
    "CHEBI_17439": "cyanocob(III)alamin",
    "FOODON_03309186": "silverside (raw)",
    "FOODON_03308701": "fish (smoke-flavored)",
    "FOODON_03542421": "24210 - tuna, bluefin (generic) (efsa foodex2)",
    "FOODON_03301106": "cranberry concentrate",
    "FOODON_03315711": "confectionery glaze for corn-based snack foods",
    "FOODON_03510116": "no msg added claim or use",
    "FOODON_03411381": "coriander plant",
    "FOODON_03400933": "10000157 - baking/cooking supplies (frozen) (gs1 gpc)",
    "CHEBI_26217": "potassium molecular entity",
    "FOODON_03413070": "copper complexes of chlorophylls",
    "FOODON_03543615": "36150 - sunflower infusion flowers (efsa foodex2)",
    "FOODON_03316484": "fruit dessert powder",
    "FOODON_03413402": "tepary plant",
    "FOODON_00003011": "wax bean (whole)",
    "FOODON_03400638": "CCFAC foodstuffs intended for particular nutritional uses",
    "FOODON_00002032": "milk based product analog",
    "FOODON_03308413": "perch steak (raw)",
    "NCBITaxon_68520": "Macrourus",
    "FOODON_03401543": "10006361 - ferns (cinnamon) (gs1 gpc)",
    "FOODON_00001950": "herring food product",
    "CHEBI_17242": "dehydroascorbic acid",
    "FOODON_03400386": "clarifying agent (codex)",
    "FOODON_03310453": "passion fruit pulp (frozen)",
    "FOODON_03304564": "Burgundy wine",
    "NCBITaxon_8228": "Euthynnus alletteratus",
    "CHEBI_30061": "sodium hexacyanoferrate(4-)",
    "FOODON_03413376": "curly kale plant",
    "FOODON_03305099": "forcemeat (food product)",
    "FOODON_00002309": "tamarind food product",
    "FOODON_03400145": "pasteurized blended cheese (us cfr)",
    "FOODON_03543651": "36510 - tormentil infusion roots (efsa foodex2)",
    "NCBITaxon_154953": "Genypterus",
    "OBI_0001930": "categorical value specification",
    "NCBITaxon_3433": "Lauraceae",
    "FOODON_03490156": "paperboard container",
    "FOODON_03302009": "buttermint candy",
    "FOODON_03301603": "flaxseed (processed)",
    "FOODON_03401082": "10000611 - desserts/dessert toppings variety packs (gs1 gpc)",
    "FOODON_00002469": "lobster (whole or parts)",
    "FOODON_00001760": "obsolete: common oat food product",
    "FOODON_03542233": "22330 - weatherfish (efsa foodex2)",
    "FOODON_03411872": "yellowtail flounder",
    "FOODON_03305747": "lemon juice (reconstituted)",
    "FOODON_03543022": "30220 - erythritol (efsa foodex2)",
    "CHEBI_26708": "sodium atom",
    "BFO_0000040": "material entity",
    "FOODON_03315892": "tuna (flaked, canned)",
    "FOODON_03311046": "food (home-canned)",
    "FOODON_03308015": "new zealand wreckfish (raw)",
    "FOODON_03413514": "longnose spurdog",
    "FOODON_00002192": "red currant preserve or jam",
    "FOODON_03412925": "periwinkle family",
    "FOODON_03401439": "10006430 - hybrids of berries (gs1 gpc)",
    "FOODON_00002708": "food (cleaned)",
    "NCBITaxon_3746": "Fragaria",
    "FOODON_03305819": "sultana raisin (whole)",
    "FOODON_03302209": "coffee bean (roasted, medium ground, freeze-dried)",
    "NCBITaxon_173322": "Decapterus punctatus",
    "FOODON_03510252": "woman as food consumer",
    "FOODON_03401331": "biscuits, sweet and semi-sweet (eurofir)",
    "FOODON_03306633": "olive oil (virgin)",
    "FOODON_03400706": "16  starchy roots and potatoes (efg)",
    "FOODON_03542091": "20910 - equine other slaughtering products (generic) (efsa foodex2)",
    "FOODON_03411165": "muskellunge",
    "FOODON_03308879": "spiny dogfish (canned)",
    "FOODON_03303843": "corn oil spread (reduced calorie)",
    "FOODON_03311849": "pearl millet kernel (cooked)",
    "CHEBI_35175": "sulfate salt",
    "FOODON_03414798": "redbellied black snake",
    "FOODON_03308069": "halibut (smoked)",
    "NCBITaxon_3884": "Phaseolus lunatus",
    "FOODON_03401442": "10006346 - loganberries (gs1 gpc)",
    "FOODON_03306198": "root beer beverage base",
    "FOODON_03544008": "40080 - onion soup (efsa foodex2)",
    "FOODON_03301950": "apple (dried)",
    "FOODON_03307706": "german hot slaw dressing",
    "FOODON_03301380": "beet (canned)",
    "FOODON_00003075": "black radish (whole, raw)",
    "FOODON_03414041": "spiny turbot",
    "FOODON_03303019": "chicken and rice (dish)",
    "CHEBI_32029": "potassium acetate",
    "ENVO_01001199": "terrestrial environmental zone",
    "FOODON_03307059": "potato chip (homogenized)",
    "FOODON_03315563": "wine (spiced, fortified, extract for preparation of)",
    "FOODON_03309281": "devil ray (raw)",
    "CHEBI_33832": "organic cyclic compound",
    "HANCESTRO_0399": "Belizean",
    "FOODON_03306989": "apricot (dehydrofrozen)",
    "FOODON_00002411": "apple pie (baked, frozen)",
    "FOODON_03541855": "18550 - candied fruit, pineapple (efsa foodex2)",
    "FOODON_03543796": "37960 - food for sporting people (efsa foodex2)",
    "FOODON_03310603": "corn (packed in brine)",
    "FOODON_03414527": "japanese ginseng plant",
    "FOODON_00000072": "meat (ground)",
    "NCBITaxon_13353": "Auxis thazard",
    "FOODON_03308051": "clam (baby, boiled, frozen)",
    "FOODON_00002290": "sugar cane refined or partially-refined food product",
    "FOODON_03414266": "jaboticaba plant",
    "FOODON_03317260": "ham salad (canned)",
    "CHEBI_26271": "proline",
    "FOODON_03540340": "03400 - processed mixed cereal-based flakes (efsa foodex2)",
    "CHEBI_33674": "s-block molecular entity",
    "FOODON_03302534": "roll butter-flavored enriched",
    "FOODON_03306221": "pineapple juice (deionized)",
    "NCBITaxon_74478": "Himanthalia elongata",
    "FOODON_03541984": "19840 - ptarmigan fresh meat (efsa foodex2)",
    "NCBITaxon_53749": "Echinacea pallida",
    "FOODON_03306223": "garlic bread spread mix",
    "ENVO_00000070": "human construction",
    "FOODON_03414817": "eucalyptus psyllid",
    "HANCESTRO_0436": "Egyptian",
    "FOODON_03544243": "42430 - coffee flavour (efsa foodex2)",
    "FOODON_03542853": "28530 - cheese, tetilla (efsa foodex2)",
    "RO_0002352": "input of",
    "FOODON_03316145": "pudding (semolina)",
    "NCBITaxon_64185": "Oncorhynchus gilae",
    "FOODON_03301602": "coffee extender",
    "NCBITaxon_214659": "Girella tricuspidata",
    "CHEBI_23367": "molecular entity",
    "FOODON_03542127": "21270 - corned pork meat, cooked (efsa foodex2)",
    "FOODON_03413940": "grass goby",
    "FOODON_03540097": "00970 - barley groats (efsa foodex2)",
    "FOODON_03412412": "green turtle",
    "FOODON_03420289": "obsolete: bud",
    "FOODON_03307445": "frozen yogurt",
    "FOODON_03543738": "37380 - strawberry leaves infusion (efsa foodex2)",
    "CHEBI_64857": "cosmetic",
    "FOODON_03308446": "albacore (raw)",
    "FOODON_03543172": "31720 - juice, orange (efsa foodex2)",
    "NCBITaxon_3011": "Fucus",
    "FOODON_00002327": "uncured cow milk cheese food product",
    "FOODON_03401726": "10006253 - vegetable juice - not ready to drink (frozen) (gs1 gpc)",
    "FOODON_03317480": "potato (pre-fried, frozen)",
    "NCBITaxon_8912": "Larus marinus",
    "FOODON_03412926": "african locust bean plant",
    "FOODON_03316071": "sobrasada",
    "FOODON_03414807": "smooth moon turban",
    "NCBITaxon_435999": "Trachinotus blochii",
    "NCBITaxon_147380": "Oryzeae",
    "NCBITaxon_1489913": "Atherinomorphae",
    "FOODON_03315872": "cayenne pepper (dried)",
    "FOODON_03302332": "butter bread",
    "CHEBI_18059": "lipid",
    "FOODON_03311731": "impastata cheese",
    "FOODON_03310387": "oil",
    "FOODON_03307975": "durum flour (enriched)",
    "FOODON_03460368": "food stabilizer",
    "FOODON_03303524": "green bean (french-style, in butter sauce)",
    "FOODON_03540406": "04060 - salsify leaves (efsa foodex2)",
    "FOODON_03412812": "olax plant",
    "FOODON_03541352": "13520 - ginger roots (efsa foodex2)",
    "RO_0002502": "depends on",
    "FOODON_03311167": "chive (whole, raw)",
    "NCBITaxon_115466": "Euterpe oleracea",
    "FOODON_03307541": "white rice flour",
    "FOODON_00003043": "saffron food product",
    "FOODON_03411060": "phaseolus vulgaris, edible pod cultivar (plant)",
    "FOODON_03400845": "coffee, tea, cocoa or infusion (eurofir)",
    "FOODON_03412016": "tree tomato plant",
    "FOODON_03470169": "concentration by reverse osmosis",
    "FOODON_03400362": "acid (codex)",
    "FOODON_03306976": "bluefish (raw)",
    "FOODON_03400203": "cookie (us cfr)",
    "NCBITaxon_9653": "Procyon",
    "FOODON_03460106": "food noncertified color addition process",
    "FOODON_03311425": "hard red winter wheat kernel",
    "FOODON_03414319": "oat plant",
    "CHEBI_25703": "organic phosphate",
    "FOODON_00001643": "beverage base product",
    "NCBITaxon_6584": "Spisula solidissima",
    "FOODON_03544342": "43420 - peach flavour (efsa foodex2)",
    "FOODON_03306706": "bombay duck wafer",
    "FOODON_03490362": "nylon 6,6 container",
    "NCBITaxon_6657": "Crustacea",
    "FOODON_03413673": "mangrove cupped oyster",
    "FOODON_03316628": "caramel coating food product",
    "FOODON_00001057": "plant fruit food product",
    "FOODON_03411479": "brown trout",
    "FOODON_03411116": "pink salmon",
    "FOODON_03542042": "20420 - rabbit kidney (efsa foodex2)",
    "FOODON_03412275": "stargazer family",
    "FOODON_03315306": "protein hydrolyzates",
    "FOODON_00002089": "pasteurized cheese food product",
    "FOODON_03412332": "sweet clover plant",
    "FOODON_03303057": "imitation cherry drink",
    "FOODON_03317017": "blancmange",
    "FOODON_03413501": "golden perch",
    "FOODON_03301390": "greens (canned)",
    "FOODON_03541520": "15200 - klamath plums (efsa foodex2)",
    "FOODON_03303628": "martini mix (nutritively and nonnutritively sweetened)",
    "FOODON_03316433": "bread (cut)",
    "FOODON_03307123": "yellow variety sweet potato (whole, raw)",
    "FOODON_03310002": "soybean paste",
    "NCBITaxon_50384": "Ameiurus",
    "FOODON_03401865": "10005909 - damsons (gs1 gpc)",
    "FOODON_03543449": "34490 - tea extract (liquid) (efsa foodex2)",
    "FOODON_03401009": "10000272 - vegetables - prepared/processed (shelf stable) (gs1 gpc)",
    "FOODON_03412784": "african peach plant",
    "CHEBI_23333": "cob(III)alamins",
    "FOODON_03306628": "doughnut (sugar)",
    "FOODON_03310884": "tunsoy raw",
    "FOODON_03309439": "sablefish (raw)",
    "FOODON_03412536": "freckled pike-conger",
    "FOODON_03530245": "nematode infestation",
    "NCBITaxon_4650": "Zingiber",
    "FOODON_03308427": "striped mullet (raw)",
    "HANCESTRO_0352": "Brazilian",
    "FOODON_00003423": "lettuce leaf (whole)",
    "FOODON_03400440": "sealing agent (codex)",
    "FOODON_03412449": "santol plant",
    "FOODON_03304379": "milk shake mix (dry)",
    "FOODON_03400707": "17  fruits (efg)",
    "FOODON_03411670": "sauger",
    "ENVO_00003978": "potato silage",
    "FOODON_03401133": "50122500 - aquatic invertebrates/fish/shellfish/seafood combination (gs1 gpc)",
    "FOODON_03304526": "rabbit meat (frozen)",
    "NCBITaxon_245205": "Averrhoa bilimbi",
    "CHEBI_26373": "pteridines",
    "FOODON_03310161": "red clover and timothy fodder silage",
    "FOODON_03310069": "nata candy",
    "PATO_0000915": "thickness",
    "FOODON_03311319": "breakfast cereal (rice-based, ready-to-eat)",
    "FOODON_03305090": "chicken neck (raw)",
    "FOODON_00003271": "fajita",
    "FOODON_03541994": "19940 - goat fat tissue (efsa foodex2)",
    "FOODON_03305125": "fruit candy (sweetened with mannitol, dried)",
    "NCBITaxon_290332": "Sicyonia brevirostris",
    "NCBITaxon_40909": "Scandix pecten-veneris",
    "FOODON_03308787": "witch flounder (raw)",
    "FOODON_03540708": "07080 - root and tuber vegetables (excluding starchy- and sugar-) (efsa foodex2)",
    "FOODON_00001917": "grain based bakery food product",
    "FOODON_03315474": "miso pickle",
    "FOODON_03401421": "10005976 - french/wax beans (gs1 gpc)",
    "FOODON_03411768": "labrador redfish",
    "FOODON_03306639": "linseed bread",
    "FOODON_03307552": "grape sugar",
    "FOODON_03541279": "12790 - thyme, dry (efsa foodex2)",
    "FOODON_03317027": "beverage (fruit juice based, concentrated)",
    "NCBITaxon_25641": "Aloe",
    "FOODON_03540318": "03180 - rye rolled grains (efsa foodex2)",
    "FOODON_03317289": "meat and vegetable patty",
    "FOODON_03470119": "pasteurization by irradiation",
    "NCBITaxon_56993": "Araucaria bidwillii",
    "FOODON_03540977": "09770 - yams and similar- (efsa foodex2)",
    "FOODON_03303136": "tea finger cookie",
    "NCBITaxon_587144": "Crangon septemspinosa",
    "FOODON_03305319": "naranjilla (whole, raw)",
    "FOODON_03542041": "20410 - asses-mules-hinnies kidney (efsa foodex2)",
    "FOODON_03544116": "41160 - sweet and sour sauce (efsa foodex2)",
    "NCBITaxon_42527": "Piaractus",
    "NCBITaxon_6763": "Callinectes sapidus",
    "FOODON_03310357": "sunflower seed oil",
    "FOODON_03413670": "west indian fighting conch",
    "FOODON_00003045": "Myrica rubra tree",
    "FOODON_03541851": "18510 - candied fruit, cherry (efsa foodex2)",
    "FOODON_03413028": "calcium aluminium silicate",
    "FOODON_03316367": "potato product (dry, ready-to-eat)",
    "FOODON_03420178": "seed part",
    "FOODON_03301963": "bacon-flavored seasoning",
    "FOODON_03308961": "malabar red snapper (raw)",
    "FOODON_03460330": "food surface mold curing",
    "FOODON_03470132": "food quick freezing",
    "FOODON_03400853": "spice, condiment or other ingredient (eurofir)",
    "FOODON_03414339": "kaffir lime plant",
    "FOODON_00002329": "vegetable based gravy or sauce food product",
    "HANCESTRO_0588": "Jewish Israeli",
    "FOODON_00001972": "inconnu food product",
    "FOODON_03414129": "common guitarfish",
    "FOODON_03544035": "40350 - chips/crisps (efsa foodex2)",
    "FOODON_03412029": "cloudberry plant",
    "FOODON_03305447": "grape and apple drink (artificially-colored)",
    "FOODON_03317498": "mollusc (canned)",
    "FOODON_03411945": "atlantic calico scallop",
    "FOODON_03302573": "pectin (artificially grape-flavored)",
    "FOODON_03306919": "pimiento (salad, pickled)",
    "FOODON_03306027": "pineapple and grapefruit juice drink (canned, diluted)",
    "FOODON_03315758": "cow milk (evaporated, partly skimmed)",
    "FOODON_03311701": "fish stick food product",
    "FOODON_03316095": "fermented product",
    "FOODON_03301266": "olive (salad, pitted, sliced, chipped, or minced)",
    "FOODON_03303861": "leyden spiced cheese",
    "NCBITaxon_46326": "Eriophorum",
    "FOODON_03470163": "drying by radiation",
    "FOODON_00001192": "quinoa food product",
    "FOODON_03310964": "beef pie (frozen)",
    "FOODON_03544338": "43380 - paprika flavour (efsa foodex2)",
    "FOODON_03307549": "castor sugar",
    "FOODON_03540961": "09610 - main-crop potatoes (efsa foodex2)",
    "FOODON_00001756": "common banana food product",
    "FOODON_03309370": "cooking spray (nonstick)",
    "FOODON_03400711": "21  beer (efg)",
    "FOODON_03542294": "22940 - eel, japanese (efsa foodex2)",
    "FOODON_03414508": "cottongrass plant",
    "FOODON_03414451": "potassium citrates",
    "FOODON_00001020": "beer wort food product",
    "FOODON_03311056": "pecan (chopped)",
    "FOODON_03413747": "japanese mustard plant",
    "FOODON_03450018": "boiling without draining",
    "FOODON_03544004": "40040 - cereal products and grains based soup (efsa foodex2)",
    "NCBITaxon_32446": "Clupeiformes",
    "CHEBI_27093": "tricarboxylic acid",
    "FOODON_00002594": "Pinot gris wine",
    "FOODON_03543522": "35220 - marshmallow infusion leaves (efsa foodex2)",
    "FOODON_03411665": "green cardamom plant",
    "FOODON_03401818": "10006368 - sapodillo (gs1 gpc)",
    "FOODON_03400346": "raising agent (ec)",
    "NCBITaxon_75100": "Rubus ursinus",
    "FOODON_03541389": "13890 - black pepper (efsa foodex2)",
    "FOODON_03413861": "western pacific gizzard shad",
    "ENVO_01000404": "manufactured plastic",
    "FOODON_03308487": "pepper sweet strips canned",
    "RO_0002180": "has component",
    "NCBITaxon_163735": "Phaseoleae",
    "FOODON_03420132": "seed, skin removed, germ present",
    "FOODON_03542216": "22160 - silver barb (efsa foodex2)",
    "FOODON_03414098": "starry skate",
    "FOODON_03543258": "32580 - coconut milk (cocos nucifera) liquid (efsa foodex2)",
    "ENVO_00000124": "supranational geopolitical entity",
    "FOODON_03316730": "tomato (sliced, canned)",
    "FOODON_03540753": "07530 - tuberous-rooted mustards (efsa foodex2)",
    "FOODON_03510091": "no sugars added claim or use",
    "NCBITaxon_119682": "Archosargus probatocephalus",
    "FOODON_03302215": "carrot (canned, sliced, seasoned with butter)",
    "FOODON_03412532": "goby flathead",
    "FOODON_03411590": "saigon cinnamon plant",
    "FOODON_03543374": "33740 - other mixed alcoholic drinks (efsa foodex2)",
    "FOODON_03317266": "cheesefurter",
    "GAZ_00003175": "District of Columbia",
    "FOODON_03310215": "lobster meat (cooked, frozen)",
    "FOODON_03544143": "41430 - mango pickle (efsa foodex2)",
    "FOODON_03420154": "mammalian light whipping cream (30%-36%)",
    "FOODON_03305702": "edible coating",
    "FOODON_03317246": "anchovy (salted)",
    "CHEBI_16701": "nucleoside 5'-phosphate",
    "FOODON_03412767": "pineapple guava plant",
    "FOODON_03303506": "lactic cheese",
    "FOODON_03413786": "dl-alpha-tocopheryl acetate",
    "FOODON_03542376": "23760 - salema (efsa foodex2)",
    "FOODON_03302841": "puffed rice cereal",
    "FOODON_03542198": "21980 - liver cheese (efsa foodex2)",
    "FOODON_03309542": "cottage cheese (creamed, acidified)",
    "NCBITaxon_41496": "Calendula officinalis",
    "FOODON_00002336": "vitamin and mineral food supplement food product",
    "FOODON_03543741": "37410 - rooibos infusion (efsa foodex2)",
    "NCBITaxon_53173": "Betonica officinalis",
    "FOODON_00003331": "chicken thigh (skinless)",
    "FOODON_03411186": "cranberry bean plant",
    "FOODON_03411666": "jalapeno pepper plant",
    "FOODON_03306663": "vegetable oil (cold-pressed)",
    "FOODON_03307093": "prune (spent)",
    "FOODON_03308033": "jack (raw)",
    "PO_0000013": "cauline leaf",
    "CHEBI_23448": "cyclic oligosaccharide",
    "NCBITaxon_13337": "Annona muricata",
    "FOODON_03400883": "10000181 - apple/pear alcoholic beverage - sparkling (gs1 gpc)",
    "FOODON_03420133": "seed, skin present, germ present",
    "NCBITaxon_135764": "Macquaria ambigua",
    "FOODON_03309670": "gulf oyster (raw)",
    "FOODON_03414777": "melodinus plant",
    "FOODON_03307424": "yam (canned)",
    "NCBITaxon_149357": "Cissus",
    "CHEBI_33340": "zinc group element atom",
    "FOODON_03301595": "wheat germ",
    "FOODON_03311423": "tomato juice (dehydrated)",
    "FOODON_03315645": "cold-pack cheese with added ingredients",
    "FOODON_00001768": "cotton seed refined oil food product",
    "NCBITaxon_72102": "Sebastes serranoides",
    "FOODON_03315198": "sweet potato (raw)",
    "FOODON_03540306": "03060 - gingerbread (efsa foodex2)",
    "FOODON_03316275": "wafer, table",
    "NCBITaxon_7812": "Mustelus canis",
    "CHEBI_52623": "iron-57 atom",
    "FOODON_03540611": "06110 - soyabeans (with pods) (efsa foodex2)",
    "NCBITaxon_3285": "Osmunda regalis",
    "NCBITaxon_7900": "Acipenseridae",
    "FOODON_03540902": "09020 - curry leaves (efsa foodex2)",
    "FOODON_03307288": "tap water (softened)",
    "FOODON_03540545": "05450 - celeries (efsa foodex2)",
    "FOODON_03309561": "macaroni and cheese with ham",
    "FOODON_03540512": "05120 - wheatgrass (efsa foodex2)",
    "NCBITaxon_3711": "Brassica rapa",
    "FOODON_00002976": "food (powdered)",
    "FOODON_03412331": "timothy plant",
    "FOODON_03307376": "corn sugar cider vinegar",
    "FOODON_03540466": "04660 - cinnamon fern (efsa foodex2)",
    "FOODON_03540881": "08810 - bergamot mint (efsa foodex2)",
    "FOODON_03316404": "starch (dried)",
    "FOODON_03415148": "silverweed plant",
    "FOODON_03490162": "aluminum tray or pan, laminate cover or wrapping",
    "FOODON_03540058": "00580 - durum wheat grain (efsa foodex2)",
    "FOODON_03543994": "39940 - tomato soup, dry (efsa foodex2)",
    "CHEBI_2571": "aliphatic alcohol",
    "FOODON_03430105": "whole, shape achieved by forming, thickness 1.5-7 cm.",
    "FOODON_03305108": "candy drop (cigarette)",
    "FOODON_03541378": "13780 - black caraway fruit (efsa foodex2)",
    "FOODON_00003251": "ox",
    "CHEBI_17855": "triglyceride",
    "FOODON_03301229": "malt vinegar (food product)",
    "FOODON_03542007": "20070 - duck, fresh fat tissue (efsa foodex2)",
    "FOODON_03308913": "mexican flounder (raw)",
    "FOODON_03310343": "peanut whey",
    "FOODON_03412789": "governor's plum plant",
    "FOODON_03414629": "yabbie shrimp",
    "FOODON_03415003": "dwarf nasturtium plant",
    "FOODON_00002573": "beef rump cut (british)",
    "FOODON_03530048": "obsolete: cut of meat, other",
    "FOODON_03400311": "hard cheese (codex)",
    "FOODON_03542287": "22870 - sturgeons, paddlefishes (efsa foodex2)",
    "FOODON_03316636": "food (ready-to-serve)",
    "FOODON_03540953": "09530 - canned mushrooms (efsa foodex2)",
    "FOODON_03306801": "sweat peas (in butter, canned)",
    "FOODON_03542597": "25970 - snail, garden (efsa foodex2)",
    "FOODON_03400127": "fruit juice (us cfr)",
    "FOODON_03317121": "apple (peeled, frozen)",
    "FOODON_03540393": "03930 - baby leaf brassica crops (efsa foodex2)",
    "FOODON_03303555": "beer (dealcoholized)",
    "FOODON_03303584": "cheddar cheese (filled, containing margarine)",
    "FOODON_03308817": "rock shrimp (raw, headless, frozen)",
    "CHEBI_24400": "glycoside",
    "FOODON_03305569": "ham (canned)",
    "FOODON_03544212": "42120 - brandy orange flavour (efsa foodex2)",
    "FOODON_00001092": "vertebrate animal food product",
    "FOODON_03302257": "fruit punch-flavored beverage syrup",
    "FOODON_00002916": "golden threadfin bream",
    "FOODON_03490388": "epoxy resin container",
    "FOODON_03301378": "peas and carrots (canned)",
    "FOODON_03541119": "11190 - almonds and similar- (efsa foodex2)",
    "FOODON_03412798": "canthium plant",
    "FOODON_03541065": "10650 - kersting's groundnut (fresh seeds) (efsa foodex2)",
    "FOODON_03311463": "soy sauce acid hydrolyzed",
    "FOODON_03316573": "cheese maturing (semi-hard)",
    "CHEBI_33561": "d-block element atom",
    "FOODON_03316296": "sugar coating",
    "FOODON_03412167": "gilchrist spiny lobster",
    "FOODON_03542807": "28070 - cheese, chimay (efsa foodex2)",
    "FOODON_03541622": "16220 - elderberries and similar- (efsa foodex2)",
    "FOODON_03530078": "processed in metal container",
    "FOODON_03543357": "33570 - cider (efsa foodex2)",
    "FOODON_00001664": "brittle food product",
    "CHEBI_24405": "glycosylglucose",
    "FOODON_03414284": "muskmallow plant",
    "FOODON_03510227": "food allergen labelling about coriander and products thereof",
    "FOODON_03543597": "35970 - field poppy infusion flowers (efsa foodex2)",
    "FOODON_03543547": "35470 - sweet woodruff infusion leaves (efsa foodex2)",
    "NCBITaxon_248138": "Scomberomorus semifasciatus",
    "FOODON_03317384": "fish (raw, dried)",
    "FOODON_03400167": "pizza crust (us cfr)",
    "FOODON_03542422": "24220 - northern bluefin tuna (efsa foodex2)",
    "FOODON_03316403": "potato dumpling dough (raw )",
    "FOODON_03305490": "quiescently frozen dessert",
    "FOODON_03315470": "mandarin orange (canned)",
    "FOODON_03411576": "woodchuck",
    "FOODON_03413236": "shellac",
    "NCBITaxon_159421": "Passiflora foetida",
    "FOODON_03317397": "cream (low fat, pasteurized)",
    "GAZ_00002747": "Japan",
    "FOODON_03500018": "enamel surface for citrus fruit",
    "FOODON_03414449": "saccharins",
    "FOODON_03302384": "lime juice beverage base",
    "FOODON_03460367": "obsolete: salt added",
    "FOODON_03401714": "10005960 - figs (gs1 gpc)",
    "FOODON_03302040": "cow milk (bleached)",
    "FOODON_03440022": "heat-treated",
    "FOODON_00001745": "clove food product",
    "HANCESTRO_0368": "Hungrian",
    "FOODON_03311489": "peach (dried, processed)",
    "FOODON_03412661": "eucalyptus plant",
    "FOODON_00001631": "barley product flavoring",
    "FOODON_03310468": "yogurt (lowfat, sweetened with aspartame)",
    "FOODON_03309516": "apple pastry",
    "FOODON_03310034": "fish curry",
    "FOODON_03520491": "tropical dry climatic zone",
    "FOODON_03307137": "olive (stuffed with anchovy, in brine)",
    "FOODON_03302407": "cola carbonated beverage (decaffeinated, vitamin-fortified)",
    "NCBITaxon_183651": "Hippoglossina oblonga",
    "NCBITaxon_6804": "Majoidea",
    "FOODON_00002940": "instant noodle",
    "ENVO_01000922": "animal cage",
    "FOODON_03301815": "cow buttermilk (dried)",
    "FOODON_00002482": "apple (sliced)",
    "FOODON_03542622": "26220 - dab or common dab, dried (efsa foodex2)",
    "FOODON_03413539": "pink abalone",
    "FOODON_03470123": "food sterilization by heating",
    "FOODON_03306844": "papaya pulp and juice",
    "FOODON_03310432": "popcorn (caramel-coated)",
    "FOODON_03303947": "peanut (milk chocolate-coated)",
    "FOODON_03315135": "strawberry pie filling (canned)",
    "FOODON_03316788": "orange juice concentrate (with preservative)",
    "FOODON_03307224": "imitation cherry jelly with bourbon whiskey",
    "FOODON_03305783": "peach conserve",
    "FOODON_03470128": "food slow freezing",
    "CHEBI_53311": "sodium alginate",
    "FOODON_03414634": "blacklip pearl oyster",
    "FOODON_03544448": "44480 - preparations for pickling vegetables (efsa foodex2)",
    "FOODON_03401253": "0850000 - spices, buds (ec)",
    "FOODON_00001902": "ginger preserve or jam food product",
    "FOODON_03306850": "potato flakes (dehydrated)",
    "IAO_0000120": "metadata complete",
    "NCBITaxon_557237": "Chaceon granulatus",
    "FOODON_03411155": "sea catfish family",
    "FOODON_03413035": "calcium dihydrogen diphosphate",
    "FOODON_03541422": "14220 - fruit used as fruit (efsa foodex2)",
    "FOODON_03302945": "chili bean made from soy protein",
    "FOODON_03542017": "20170 - goat liver (efsa foodex2)",
    "FOODON_03308082": "fish fillet (stuffed with crabmeat and shrimp)",
    "NCBITaxon_22140": "Annonaceae",
    "FOODON_03414101": "rough skate (genus)",
    "FOODON_03301831": "pineapple (whole, raw)",
    "CHEBI_74772": "aluminium sulfate",
    "GAZ_00000563": "Algeria",
    "FOODON_03412453": "fern plant",
    "FOODON_03400789": "frozen dairy dessert (eurofir)",
    "FOODON_03309914": "neet fish (smoked)",
    "FOODON_03540709": "07090 - beetroots and similar- (efsa foodex2)",
    "FOODON_03306929": "pineapple tidbits (mixed sizes, canned)",
    "NCBITaxon_79698": "Merluccius bilinearis",
    "FOODON_03302615": "butter rum mint candy",
    "FOODON_03530031": "loin",
    "FOODON_00001080": "tape kefan food product",
    "FOODON_03316324": "fish in oil (salted)",
    "FOODON_03541544": "15440 - dewberries and similar- (efsa foodex2)",
    "FOODON_03544118": "41180 - tomato ketchup and related sauces (efsa foodex2)",
    "FOODON_03543162": "31620 - juice, apple-grape (efsa foodex2)",
    "NCBITaxon_26468": "Loganiaceae",
    "FOODON_03302218": "betel leaf (food product)",
    "FOODON_03316700": "chestnut puree (canned)",
    "FOODON_03411605": "obsolete: pea and onion",
    "CHEBI_33906": "cobalt corrinoid",
    "FOODON_03303902": "cheese (lowfat)",
    "FOODON_03306295": "spinach noodle",
    "FOODON_03304825": "buttercrunch candy",
    "BFO_0000051": "has part",
    "FOODON_00002408": "thickness of 7 cm or more",
    "FOODON_03308570": "shrimp frankfurter",
    "FOODON_03311639": "hot chocolate beverage",
    "FOODON_03306486": "kangaroo meat (frozen)",
    "UO_0000032": "hour",
    "FOODON_03311303": "yellow plum (whole, raw)",
    "FOODON_03315487": "tsukudani",
    "FOODON_03540278": "02780 - croissant, filled with chocolate (efsa foodex2)",
    "NCBITaxon_216275": "Vetigastropoda",
    "FOODON_03310260": "musli",
    "FOODON_03542754": "27540 - halloumi (efsa foodex2)",
    "FOODON_03413733": "white-fringe gigantochloa plant",
    "FOODON_03544341": "43410 - pastry flavour (efsa foodex2)",
    "FOODON_03317404": "crustacean (unprocessed, frozen)",
    "FOODON_03541331": "13310 - garden nasturtium pods (efsa foodex2)",
    "FOODON_03301973": "brown rice miso",
    "FOODON_03400805": "fat or oil (eurofir)",
    "FOODON_03401186": "10000200 - dressings/dips (shelf stable) (gs1 gpc)",
    "FOODON_03543078": "30780 - meringue mixture (efsa foodex2)",
    "FOODON_03460174": "food hydrogenation proess",
    "FOODON_03510222": "food allergen labelling about celery and products thereof",
    "NCBITaxon_6739": "Lithodidae",
    "FOODON_03414661": "assyrian plum plant",
    "FOODON_03400312": "semihard cheese (codex)",
    "FOODON_03401315": "multi-vitamin and multi-mineral supplement",
    "FOODON_03540309": "03090 - breakfast cereals, plain (efsa foodex2)",
    "FOODON_00002197": "reindeer meat food product",
    "FOODON_03413619": "knife shrimp",
    "FOODON_03543910": "39100 - mixed vegetables (efsa foodex2)",
    "FOODON_03460206": "food alkalization process",
    "FOODON_03317328": "meat (cut, raw)",
    "FOODON_03305717": "aspic jelly powder",
    "FOODON_03306640": "mackerel fillet (canned)",
    "FOODON_03307021": "codfish (salted)",
    "FOODON_03540275": "02750 - yeast leavened pastry (efsa foodex2)",
    "FOODON_03301272": "peach (frozen)",
    "FOODON_03311304": "crabmeat (cooked)",
    "FOODON_03542594": "25940 - lizards (efsa foodex2)",
    "FOODON_03309717": "palm juice (food product)",
    "FOODON_03305190": "ginseng extract with added ginseng root",
    "FOODON_03413778": "thiamin mononitrate",
    "NCBITaxon_147366": "Bambusoideae",
    "FOODON_03311208": "chicory (ground)",
    "FOODON_03401501": "10005885 - limequats (gs1 gpc)",
    "FOODON_00002107": "pecan nut food product",
    "NCBITaxon_9307": "Macropodidae",
    "FOODON_03520508": "uplands climatic zone",
    "NCBITaxon_714659": "Cetengraulis mysticetus",
    "FOODON_00001920": "grape spread or sauce",
    "NCBITaxon_206130": "Chelidonichthys lucernus",
    "NCBITaxon_37488": "Diospyros texana",
    "FOODON_03540674": "06740 - gherkins (efsa foodex2)",
    "FOODON_00002176": "prune food product",
    "FOODON_03303068": "citrus peel",
    "FOODON_03412260": "slippery jack mushroom",
    "CHEBI_46761": "dipeptide",
    "FOODON_03412405": "goosefish family",
    "FOODON_03413513": "spotted estuary smooth-hound",
    "FOODON_03460173": "food (salted)",
    "FOODON_03315657": "poultry (canned)",
    "NCBITaxon_224716": "Etrumeus teres",
    "FOODON_03542589": "25890 - turtle, green (efsa foodex2)",
    "FOODON_03412036": "star apple plant",
    "FOODON_03413184": "pentasodium triphosphate",
    "FOODON_03306139": "cheddar-flavored cheese",
    "FOODON_00003111": "mammea africana fruit product",
    "FOODON_03411496": "grouper",
    "FOODON_00002738": "meat and bone meal",
    "FOODON_00002320": "tuna food product",
    "NCBITaxon_33317": "Protostomia",
    "FOODON_03312037": "pastry (meat filled)",
    "FOODON_03542905": "29050 - cheese, sbrinz (efsa foodex2)",
    "FOODON_00003171": "tronchuda cabbage (raw)",
    "FOODON_03540456": "04560 - malabar nightshades (efsa foodex2)",
    "NCBITaxon_89950": "Merluccius paradoxus",
    "PO_0025470": "plant embryo cotyledon",
    "UBERON_0009101": "ammocoete",
    "NCBITaxon_1266879": "Menticirrhus saxatilis",
    "FOODON_03540100": "01000 - oat groats (efsa foodex2)",
    "GAZ_01000048": "Caribbean Region",
    "FOODON_03520506": "high elevations climatic zone",
    "FOODON_03542304": "23040 - sockeye salmon (efsa foodex2)",
    "FOODON_03543122": "31220 - beef tallow (including processed suet) (efsa foodex2)",
    "FOODON_03411094": "cauliflower plant",
    "FOODON_03317220": "vineger (diluted)",
    "FOODON_03450020": "cooking by simmering",
    "FOODON_03542615": "26150 - fermented fish (efsa foodex2)",
    "FOODON_03541034": "10340 - jack beans (without pods) (efsa foodex2)",
    "FOODON_03414989": "garden sorrel plant",
    "FOODON_03306515": "illipe nut (food product)",
    "NCBITaxon_241780": "apioid superclade",
    "FOODON_03541301": "13010 - coriander seed (efsa foodex2)",
    "FOODON_03305495": "wasabi (food product)",
    "FOODON_03412350": "atlantic rock crab",
    "FOODON_03401722": "10005970 - pomegranates (gs1 gpc)",
    "FOODON_03412900": "red rockfish",
    "FOODON_03401204": "pasta dish (eurofir)",
    "FOODON_00003260": "chicken curry",
    "FOODON_03415013": "rice paddy herb plant",
    "FOODON_03411161": "cattle",
    "FOODON_03316775": "nonfat dry milk (vitamin a and d fortified)",
    "FOODON_03541026": "10260 - broad beans (without pods) (efsa foodex2)",
    "FOODON_03541740": "17400 - dwarf bananas (efsa foodex2)",
    "FOODON_00003235": "meat brochette",
    "FOODON_03310107": "summer squash (whole, raw)",
    "FOODON_03310361": "wheat offal meal",
    "FOODON_03311568": "obsolete: nata de coco",
    "FOODON_03413268": "sodium polyphosphate",
    "NCBITaxon_84860": "Carissa",
    "NCBITaxon_4638": "Ensete",
    "FOODON_03401781": "10006749 - ready-made combination meals - not ready to eat (perishable) (gs1 gpc)",
    "FOODON_03460145": "obsolete: pectin added",
    "FOODON_03540697": "06970 - pumpkins (efsa foodex2)",
    "FOODON_03541758": "17580 - cherimoyas and similar- (efsa foodex2)",
    "FOODON_03311315": "beef rib (prime grade, raw)",
    "FOODON_03412773": "velvet tamarind plant",
    "FOODON_03411577": "white field corn plant",
    "FOODON_03309238": "redeye mullet (raw)",
    "FOODON_03302451": "garlic bread (frozen)",
    "FOODON_00003225": "soybean oil (partly hydrogenated)",
    "FOODON_03540560": "05600 - bamboo shoots (efsa foodex2)",
    "FOODON_03302460": "bread (salt-free)",
    "FOODON_03317461": "grape marc spirits",
    "NCBITaxon_232428": "Chionoecetes bairdi",
    "GAZ_00002560": "Canada",
    "FOODON_03307278": "imitation creamed cottage cheese",
    "FOODON_03311801": "sugar pea pod (edible, fresh)",
    "FOODON_03303060": "cider (sparkling)",
    "HANCESTRO_0432": "Armenian",
    "NCBITaxon_80835": "Portunus",
    "HANCESTRO_0522": "Angolan",
    "FOODON_03310589": "chicken roll",
    "FOODON_03315136": "white potato (frozen)",
    "FOODON_03414762": "stinging tree",
    "FOODON_03414298": "elmleaf blackberry plant",
    "FOODON_03411631": "obsolete: pineapple and orange",
    "FOODON_03540671": "06710 - armenian cucumbers (efsa foodex2)",
    "FOODON_03304847": "eggnog mix (low fat)",
    "FOODON_03305871": "calf's foot gelatin (food product)",
    "FOODON_03401060": "50151700 - oils/fats edible variety packs (gs1 gpc)",
    "FOODON_03413325": "sloe plant",
    "FOODON_03316455": "tea extract (cold-water soluble)",
    "FOODON_03303100": "coffee oil",
    "FOODON_03304623": "hen egg (whole, pickled)",
    "FOODON_03411572": "chinese cinnamon plant",
    "NCBITaxon_372321": "Patagioenas fasciata",
    "FOODON_03301756": "apricot (dried)",
    "FOODON_03301613": "lettuce (raw)",
    "FOODON_03400784": "cheese (eurofir)",
    "FOODON_03414363": "kiwi",
    "FOODON_03316006": "beverage (fruit juice based)",
    "NCBITaxon_55140": "Squatinidae",
    "FOODON_03302330": "cream (pasteurized)",
    "FOODON_03542974": "29740 - hen egg yolk, dried (efsa foodex2)",
    "FOODON_03315012": "confection (quiescently frozen)",
    "NCBITaxon_85004": "Bifidobacteriales",
    "FOODON_03413452": "boletes",
    "FOODON_00002870": "natt\u014d",
    "FOODON_03414059": "arizona trout",
    "FOODON_03308335": "portugese sardine (boneless, skinless, raw)",
    "FOODON_03542210": "22100 - tinned bulk sausages (efsa foodex2)",
    "FOODON_03317450": "coffee bean (roasted)",
    "NCBITaxon_64463": "Sicyoniidae",
    "FOODON_03411996": "moonfish family",
    "FOODON_03310226": "hominy",
    "FOODON_03315977": "brown beer oud bruin type",
    "NCBITaxon_205582": "Solanum sisymbriifolium",
    "PO_0009051": "spikelet",
    "CHEBI_47857": "ureas",
    "FOODON_03414069": "glass catfish family",
    "FOODON_03303929": "pretzel",
    "NCBITaxon_9606": "Homo sapiens",
    "FOODON_03490276": "glass container, uncoloured, strengthened",
    "FOODON_00001883": "fruit based distilled spirit",
    "FOODON_03303847": "seltzer water (flavored)",
    "FOODON_03401489": "10006421 - radicchio (redloof) (gs1 gpc)",
    "ENVO_00000062": "populated place",
    "FOODON_03542409": "24090 - herring, pacific (efsa foodex2)",
    "FOODON_03301488": "marjoram (ground)",
    "FOODON_03413906": "atractoscion",
    "FOODON_03304081": "chicken soup mix",
    "FOODON_03305334": "italian prune plum (whole, dried)",
    "HANCESTRO_0366": "Greek",
    "NCBITaxon_47605": "Hibiscus",
    "FOODON_03305964": "imitation grape jelly (whiskey-flavored)",
    "FOODON_03306239": "flavoring extract (spray-dried)",
    "FOODON_03316888": "vegetable (quick-frozen)",
    "FOODON_03401471": "10006447 - tatsoi (gs1 gpc)",
    "FOODON_03307223": "bourbon cherry jelly",
    "FOODON_03541173": "11730 - japanese horse-chestnut (efsa foodex2)",
    "NCBITaxon_55961": "Clusiaceae",
    "FOODON_03316750": "mango product (liquid, pulpy)",
    "FOODON_03540199": "01990 - yeast leavened bread doughs (efsa foodex2)",
    "FOODON_03305517": "beef carcass",
    "UO_0000000": "unit",
    "FOODON_03411525": "obsolete: peanut with other nut or seed",
    "FOODON_03411096": "red raspberry plant",
    "FOODON_03315201": "vitamin and mineral preparation",
    "FOODON_03301638": "cream liqueur",
    "FOODON_03316163": "potato (dried, granulated)",
    "FOODON_03309672": "oyster (smoked, canned)",
    "FOODON_03541652": "16520 - chinese white olives (efsa foodex2)",
    "FOODON_03316688": "babassu oil (edible)",
    "FOODON_03401012": "50260000 - vegetables (non leaf) - unprepared/unprocessed (fresh) (gs1 gpc)",
    "NCBITaxon_2794": "Rhodymenia",
    "FOODON_03412223": "grooved tanner crab",
    "FOODON_03301030": "honey (dried)",
    "GAZ_00002894": "Honduras",
    "FOODON_03543846": "38460 - dishes, incl. ready to eat meals (excluding soups and salads) (efsa foodex2)",
    "FOODON_03530271": "green flesh",
    "FOODON_03303067": "hard cider (sugar added)",
    "FOODON_03543032": "30320 - confectionery including chocolate (efsa foodex2)",
    "FOODON_03306674": "paprika bloom seasoning",
    "FOODON_03530046": "side (meat cut)",
    "FOODON_03304710": "roquefort-flavored dressing",
    "FOODON_03430162": "food supplement powder",
    "PO_0025475": "coleorhiza emergence stage",
    "FOODON_03311086": "lowfat cow milk (2%)",
    "CHEBI_29075": "mononucleotide",
    "FOODON_00002292": "sugar maple sweetener food product",
    "FOODON_03544481": "44810 - vitamin b9   (folic acid, folinic acid) (efsa foodex2)",
    "FOODON_03543843": "38430 - imitation cheese (efsa foodex2)",
    "FOODON_03317034": "caramel",
    "FOODON_03413910": "white-mouth croaker",
    "GAZ_00002570": "Province of New Brunswick",
    "FOODON_03540789": "07890 - horse mushrooms (efsa foodex2)",
    "FOODON_03412955": "chinese lantern plant",
    "FOODON_03304170": "mocha mix",
    "FOODON_03413644": "dock cockle",
    "FOODON_03490181": "laminate container",
    "FOODON_03307150": "rice (fortified)",
    "FOODON_03316585": "confectioner's shortening",
    "FOODON_03400685": "022  tree nuts (tn) (ccpr)",
    "NCBITaxon_80640": "Cynoscion arenarius",
    "FOODON_03303903": "imitation cottage cheese",
    "PO_0030104": "caryopsis fruit",
    "FOODON_03305177": "lemon and lime drink",
    "FOODON_03510134": "\"source of\" label claim",
    "NCBITaxon_28700": "Fratercula",
    "FOODON_03400939": "10000161 - biscuits/cookies (shelf stable) (gs1 gpc)",
    "FOODON_03301702": "grapefruit (whole, raw)",
    "FOODON_03412880": "common prawn",
    "FOODON_03544014": "40140 - mixed vegetables soup (efsa foodex2)",
    "FOODON_03305760": "orange spread",
    "FOODON_03542652": "26520 - cattle milk (efsa foodex2)",
    "FOODON_03540050": "00500 - rye grain (efsa foodex2)",
    "FOODON_03530011": "select grade",
    "FOODON_03311479": "tomato aspic",
    "FOODON_03304699": "goat's milk ice cream (food product)",
    "FOODON_03460851": "canola or rapeseed oil",
    "NCBITaxon_13424": "Chrysophyllum",
    "FOODON_03302553": "soy beverage (artificially flavored)",
    "FOODON_00002711": "cracker",
    "FOODON_03413403": "velvet bean plant",
    "FOODON_03544178": "41780 - artificial food colour (efsa foodex2)",
    "FOODON_03542333": "23330 - halibut (efsa foodex2)",
    "FOODON_03304225": "barbeque mix (powdered)",
    "FOODON_03301209": "rosemary (whole leaf, dried)",
    "FOODON_03306404": "orange marmalade (scotch-style)",
    "FOODON_03306945": "chicken shrimp soup with noodles",
    "FOODON_03543813": "38130 - miscellaneous supplements or nutraceuticals (efsa foodex2)",
    "FOODON_03309426": "saury fillet in olive oil (salt-cured)",
    "FOODON_03401358": "50240300 - meat/poultry/other animals sausages - prepared/processed (gs1 gpc)",
    "CHEBI_27013": "tocopherol",
    "FOODON_03411790": "atlantic mackerel",
    "FOODON_00003073": "pineapple sage",
    "FOODON_03541640": "16400 - miscellaneous fruits with edible peel (efsa foodex2)",
    "FOODON_03304513": "lemon-flavored beverage syrup",
    "FOODON_03541753": "17530 - naranjillas (efsa foodex2)",
    "FOODON_03304737": "pickling spice",
    "FOODON_03450006": "broiling or grilling",
    "CHEBI_33327": "silicon oxide",
    "FOODON_03411008": "mesogastropod",
    "NCBITaxon_355939": "Salsola soda",
    "FOODON_03413924": "golden goby",
    "FOODON_03400705": "15  vegetables, excluding potatoes (efg)",
    "FOODON_03302266": "beverage mix (dry, naturally and artificially sweetened and flavored)",
    "NCBITaxon_6779": "Xanthidae",
    "FOODON_03307035": "russet burbank potato (whole, raw)",
    "NCBITaxon_283119": "Flueggea",
    "NCBITaxon_47308": "Neogobius melanostomus",
    "FOODON_03414491": "great horned owl",
    "NCBITaxon_380164": "Chionista fluctifraga",
    "FOODON_03540597": "05970 - black eyed peas (with pods) (efsa foodex2)",
    "FOODON_03414526": "chinese ginseng plant",
    "FOODON_03302396": "sangria-flavored carbonated beverage",
    "FOODON_03543018": "30180 - other sweetening ingredients (efsa foodex2)",
    "FOODON_03411388": "youngberry plant",
    "NCBITaxon_248765": "Mora moro",
    "FOODON_03316040": "sauce (emulsified)",
    "PATO_0000587": "decreased size",
    "FOODON_03544183": "41830 - amarena cherry flavour (efsa foodex2)",
    "CHEBI_47772": "delta-tocopherol",
    "FOODON_03400677": "012  fruiting vegetables, other than cucurbits (vo) (ccpr)",
    "NCBITaxon_3818": "Arachis hypogaea",
    "NCBITaxon_8267": "Hippoglossus hippoglossus",
    "FOODON_03541491": "14910 - apricots and similar- (efsa foodex2)",
    "FOODON_03309467": "salt (low sodium)",
    "FOODON_03412979": "acetylated distarch adipate",
    "FOODON_03530109": "home food preparation process",
    "FOODON_03305781": "apricot jam",
    "NCBITaxon_9983": "Lepus europaeus",
    "FOODON_03302693": "raisin bread (enriched)",
    "FOODON_03543605": "36050 - mallow infusion flowers (efsa foodex2)",
    "FOODON_03316608": "sweets (fine pressed powder)",
    "FOODON_03541092": "10920 - lentils (dry) (efsa foodex2)",
    "FOODON_03544085": "40850 - savoury sauce dry preparation (efsa foodex2)",
    "FOODON_03411218": "potato plant",
    "CHEBI_35156": "calcium salt",
    "FOODON_03316802": "vermicelli (enriched)",
    "NCBITaxon_117982": "Palaemon",
    "CHEBI_22707": "benzenetriol",
    "FOODON_03401594": "10006066 - oregano (gs1 gpc)",
    "FOODON_03310686": "sea clam (raw)",
    "FOODON_03540420": "04200 - spinaches and similar- (efsa foodex2)",
    "FOODON_03401117": "50193100 - vegetable based products / meals (gs1 gpc)",
    "FOODON_03306781": "pecan pie",
    "FOODON_03310761": "martini cocktail",
    "FOODON_03510232": "food allergen labelling about molluscs and products thereof",
    "NCBITaxon_151069": "Litchi chinensis",
    "FOODON_03412393": "smalleye flounder",
    "FOODON_00001754": "cold-pack cheese food product",
    "FOODON_03311234": "cow whole milk (fortified, pasteurized)",
    "FOODON_03510266": "infant as food consumer",
    "FOODON_03301820": "noodle (enriched, dry)",
    "FOODON_03307966": "grouper fillet with shrimp and crab meat",
    "FOODON_03430138": "food (liquid, high viscosity, with solid pieces)",
    "FOODON_03411115": "chum salmon",
    "FOODON_00003112": "mamey amarillo",
    "FOODON_03311860": "meat filled puff",
    "FOODON_03316808": "spaghetti (milk)",
    "FOODON_03543775": "37750 - ready-to-eat cereal-based meal for children (efsa foodex2)",
    "FOODON_03311041": "hen egg (shell off, solids, dried)",
    "FOODON_03401552": "10006264 - enokitake (gs1 gpc)",
    "FOODON_03544021": "40210 - mixed green salad (efsa foodex2)",
    "FOODON_03400308": "supplemental formulation (us cfr)",
    "UO_0000191": "fraction",
    "FOODON_03540323": "03230 - cornmeal porridge (efsa foodex2)",
    "FOODON_03542147": "21470 - fresh bulk sausages (efsa foodex2)",
    "FOODON_03315852": "fat base formulation for self basting of poultry",
    "FOODON_03306992": "fruit preserves (frozen)",
    "FOODON_03400902": "50202400 - non alcoholic beverages - not ready to drink (gs1 gpc)",
    "FOODON_03510020": "infant or toddler as food consumer",
    "FOODON_00001029": "gouda cheese food product",
    "FOODON_03309820": "pear (strained)",
    "FOODON_03306282": "almond macaroon batter",
    "FOODON_03400140": "pie crust, sweetened (us cfr)",
    "FOODON_03411986": "clawed lobster family",
    "FOODON_03304082": "beef soup mix",
    "FOODON_03540642": "06420 - cape gooseberries (efsa foodex2)",
    "FOODON_03414378": "lesser kudu",
    "NCBITaxon_225387": "Ophiodon elongatus",
    "CHEBI_46663": "silicate mineral",
    "FOODON_03315441": "avocado spread (frozen)",
    "FOODON_03543656": "36560 - american ginseng infusion roots (efsa foodex2)",
    "FOODON_03301004": "macaroni pasta",
    "FOODON_03311252": "sauerkraut brine",
    "FOODON_03400399": "diluent of colour and other food additives (codex)",
    "FOODON_03302672": "milk (fermented)",
    "FOODON_03480001": "obsolete: packing medium not known",
    "FOODON_03541586": "15860 - cowberries (efsa foodex2)",
    "FOODON_03305498": "ice cream mix made with vegetable fat",
    "FOODON_03530077": "material of contact prior to food packaging",
    "FOODON_03540904": "09040 - siamese cassia (efsa foodex2)",
    "FOODON_03542964": "29640 - liquid egg products (efsa foodex2)",
    "FOODON_00002384": "baking supply product",
    "NCBITaxon_9821": "Suidae",
    "FOODON_03311141": "beef chuck (roast cooked)",
    "NCBITaxon_23204": "Potentilla",
    "FOODON_03307071": "poultry (stuffed, frozen)",
    "FOODON_03400152": "vegetable or vegetable product (us cfr)",
    "FOODON_03411110": "adzuki bean plant",
    "CHEBI_24676": "hydroxybenzoic acid",
    "FOODON_03541099": "10990 - chickpeas (dry) (efsa foodex2)",
    "FOODON_03460125": "obsolete: hemicellulose added",
    "FOODON_03542840": "28400 - cheese, passendale (efsa foodex2)",
    "NCBITaxon_8224": "Scombridae",
    "FOODON_03541908": "19080 - ratites msm (efsa foodex2)",
    "FOODON_03541325": "13250 - batavia cinnamon buds (efsa foodex2)",
    "FOODON_00001052": "amasake food product",
    "FOODON_03309457": "onion soup mix",
    "FOODON_03302155": "imitation lemon juice (dried)",
    "NCBITaxon_203015": "Rhodiola rosea",
    "FOODON_03510094": "no starch added claim or use",
    "FOODON_03401496": "10005878 - honey pomelos (gs1 gpc)",
    "FOODON_03401866": "10005913 - greengages (gs1 gpc)",
    "FOODON_03413047": "calcium polyphosphates",
    "NCBITaxon_83393": "Coelorinchus",
    "FOODON_03302359": "batter mix for frying",
    "FOODON_03311553": "carrot soup (dish)",
    "FOODON_03304196": "obsolete: soup cube",
    "PO_0009072": "plant ovary",
    "FOODON_03315564": "drink mix for the preparation of alcoholic beverage",
    "FOODON_03400452": "CIAA dairy products",
    "FOODON_03542560": "25600 - octopus, curled (efsa foodex2)",
    "FOODON_03307739": "garlic salt",
    "FOODON_03308417": "rock lobster bisque",
    "HANCESTRO_0334": "Antiguan or Barbudan",
    "FOODON_03311385": "yogurt drink",
    "FOODON_03413518": "small-spotted catshark",
    "FOODON_03414699": "nipa palm plant",
    "GAZ_00002938": "Belgium",
    "NCBITaxon_36211": "Trachurus",
    "FOODON_03541644": "16440 - awara palm fruits (efsa foodex2)",
    "GAZ_00002933": "Paraguay",
    "FOODON_03308763": "mussel (stuffed, on half shell)",
    "FOODON_03307043": "yam (whole, raw)",
    "FOODON_03316800": "pineapple (artificially sweetened, canned)",
    "FOODON_03309031": "cod fillet (smoked, frozen)",
    "FOODON_03540767": "07670 - dulse (efsa foodex2)",
    "FOODON_03317500": "fish with red skin (deep-frozen)",
    "FOODON_03308434": "european pilchard (raw)",
    "FOODON_03302884": "chocolate cake mix",
    "UBERON_0008944": "albumen",
    "NCBITaxon_58860": "Tamarindus indica",
    "FOODON_03420303": "petal",
    "FOODON_00001877": "frigate tuna food product",
    "FOODON_03530080": "processed in iron container",
    "FOODON_03306527": "okra (cut, canned)",
    "FOODON_03540950": "09500 - dried mushrooms (efsa foodex2)",
    "FOODON_03401733": "10000609 - oils/fats edible variety packs (gs1 gpc)",
    "FOODON_03401378": "50260800 - melons (gs1 gpc)",
    "FOODON_03301609": "konjacu powder",
    "FOODON_03309596": "yellow summer squash (whole, raw)",
    "FOODON_03412953": "lemon verbena plant",
    "NCBITaxon_458582": "Lycengraulis grossidens",
    "FOODON_03315543": "alimentary paste product",
    "FOODON_00002608": "Semillon grape plant",
    "NCBITaxon_64468": "Penaeus setiferus",
    "NCBITaxon_4206": "Adoxaceae",
    "FOODON_00002484": "harissa chili paste",
    "FOODON_00002593": "Pinot blanc grape plant",
    "FOODON_03316929": "snack dip mix",
    "FOODON_03460164": "obsolete: protein added",
    "FOODON_03401084": "10000301 - dough based products / meals - not ready to eat - savoury (frozen) (gs1 gpc)",
    "FOODON_03304165": "poultry shortening",
    "FOODON_03304629": "wheat flour (starch-reduced)",
    "FOODON_03315516": "cow milk (fruit-flavored)",
    "FOODON_00001819": "dogfish food product",
    "FOODON_03490370": "low density polyethylene container",
    "FOODON_03316724": "pineapple juice (concentrated, with preservatives)",
    "CHEBI_30961": "pyridoxine hydrochloride",
    "FOODON_03315331": "kochoojang (food product)",
    "FOODON_00003072": "Salvia elegans plant",
    "FOODON_03540248": "02480 - choux pastry (efsa foodex2)",
    "NCBITaxon_30409": "Lagopus",
    "FOODON_03308465": "tasselfish (raw)",
    "FOODON_03302848": "food bar (confectionery-type)",
    "FOODON_03412835": "antrocaryon plant",
    "FOODON_03305746": "berry juice (food product)",
    "FOODON_03414894": "sergestid shrimp family",
    "CHEBI_37583": "trisodium phosphate",
    "FOODON_03543755": "37550 - infant formulae, liquid (efsa foodex2)",
    "CHEBI_36807": "hydrochloride",
    "FOODON_00002612": "Syrah wine",
    "FOODON_03540504": "05040 - broccoli sprouts (efsa foodex2)",
    "FOODON_03400344": "preservative (ec)",
    "FOODON_03412228": "deep sea crab family",
    "FOODON_03414549": "terracotta hedgehog",
    "FOODON_03414628": "cherax",
    "FOODON_03304036": "mornay sauce",
    "FOODON_03307219": "vichyssoise",
    "FOODON_03311834": "virginia peanut pod (raw)",
    "FOODON_03542279": "22790 - northern pike (efsa foodex2)",
    "NCBITaxon_6627": "Illex",
    "FOODON_03542673": "26730 - bactrian camel milk (efsa foodex2)",
    "FOODON_03412553": "fish, lamniform",
    "FOODON_03304477": "whole wheat flour (bromated)",
    "FOODON_03310650": "fruit paste",
    "NCBITaxon_397937": "Chionoecetes angulatus",
    "FOODON_03411182": "southern tanner crab",
    "NCBITaxon_7921": "Amiiformes",
    "FOODON_03316668": "yogurt (flavored)",
    "NCBITaxon_214907": "Malvoideae",
    "FOODON_03310970": "ham (cooked, cured)",
    "FOODON_03305264": "coffee creamer",
    "GAZ_00002520": "State of North Carolina",
    "FOODON_03530199": "fat content > 80%, < 25% pufa",
    "FOODON_03411713": "chicken hen",
    "HANCESTRO_0453": "Yemeni",
    "FOODON_03317550": "fish analogue vegetable protein-based",
    "FOODON_03316246": "dressing, very low fat",
    "FOODON_03540191": "01910 - pasta-like products (efsa foodex2)",
    "CHEBI_26078": "phosphoric acid",
    "FOODON_03306549": "black currant nectar",
    "NCBITaxon_240830": "Hypomesus olidus",
    "FOODON_03544104": "41040 - continental european brown cooked sauce, gravy (efsa foodex2)",
    "FOODON_03315464": "food for pregnant and nursing women",
    "FOODON_03309919": "yellow dent corn (raw)",
    "FOODON_03540425": "04250 - spleen amaranth leaves (efsa foodex2)",
    "FOODON_03400387": "cloud producing agent (codex)",
    "FOODON_03317217": "lobster (cooked, quick-frozen)",
    "FOODON_03530131": "raquette",
    "NCBITaxon_490585": "Metanephrops andamanicus",
    "FOODON_03412125": "italian prune plum plant",
    "FOODON_03317603": "poultry meat product (low sodium)",
    "FOODON_03308357": "fish for seafood cocktail dip",
    "FOODON_03311076": "pork chop (raw)",
    "FOODON_03401638": "10006295 - mutton - prepared/processed (gs1 gpc)",
    "HANCESTRO_0441": "Jordanian",
    "FOODON_03305544": "papaya leaf (raw)",
    "CHEBI_60027": "polymer",
    "FOODON_03307797": "souchong-type tea (dry)",
    "FOODON_03309502": "pudding (rum-flavored)",
    "FOODON_03412546": "morwong family",
    "FOODON_03302509": "maple butter",
    "FOODON_03541532": "15320 - schisandra berries (efsa foodex2)",
    "FOODON_03301452": "tomato (canned)",
    "FOODON_03490417": "polyester container",
    "FOODON_03304539": "flour (nonwheat)",
    "NCBITaxon_264416": "Diplotaxis tenuifolia",
    "FOODON_03411748": "horseradish tree",
    "NCBITaxon_7822": "Sphyrna",
    "HANCESTRO_0346": "Australian",
    "NCBITaxon_1204434": "Brassica rapa Broccoletto Group",
    "CHEBI_33118": "boric acid",
    "FOODON_03302898": "coffee cake",
    "FOODON_03310123": "kohlrabi stem (whole, raw)",
    "FOODON_03415055": "schisandra plant",
    "FOODON_03304883": "tomato wedge (packed in tomato juice, artificially sweetened, canned)",
    "FOODON_00001304": "food fermentation",
    "NCBITaxon_8602": "Elapidae",
    "FOODON_03304890": "cheese-flavored puff",
    "HANCESTRO_0446": "Palestinian",
    "FOODON_03413770": "d-biotin",
    "FOODON_03317492": "cheese analog, dairy-based",
    "HANCESTRO_0494": "Indonesian",
    "FOODON_03541180": "11800 - peanuts and similar- (efsa foodex2)",
    "NCBITaxon_99342": "Scomberomorus concolor",
    "FOODON_03309765": "sunflower meal",
    "FOODON_03307446": "frozen yogurt mix",
    "FOODON_03301131": "apple flavoring",
    "NCBITaxon_1437183": "Mesangiospermae",
    "FOODON_03543085": "30850 - water-based desserts spoonable (efsa foodex2)",
    "FOODON_03306360": "mustard bran",
    "FOODON_03543516": "35160 - lemon verbena infusion leaves (efsa foodex2)",
    "FOODON_03315081": "tea food product",
    "FOODON_00003269": "croque monsieur",
    "FOODON_03311012": "chicken a la king (dish)",
    "PATO_0045054": "normal length",
    "FOODON_03317139": "food (packed in high pressurised containers)",
    "FOODON_03305997": "lingonberry sauce",
    "FOODON_03304607": "imitation chocolate-flavored coating",
    "FOODON_03303042": "canadian whitefish (raw)",
    "NCBITaxon_263428": "Teredo",
    "FOODON_03307242": "parsnip (whole, raw)",
    "NCBITaxon_106231": "Mactroidea",
    "FOODON_03543102": "31020 - cotton seed oil, edible (efsa foodex2)",
    "FOODON_03400301": "flavor enhancer (us cfr)",
    "GAZ_00003142": "State of Illinois",
    "FOODON_03316232": "anisette (emulsified, non-alcoholic)",
    "FOODON_03306675": "obsolete: poppy pastry filling (canned)",
    "FOODON_00001879": "frozen dairy food product",
    "FOODON_03302106": "beer (draft)",
    "FOODON_00001909": "goat evaporated milk food product",
    "FOODON_03414139": "european crayfish family",
    "FOODON_03542377": "23770 - drums (efsa foodex2)",
    "ENVO_00000106": "grassland area",
    "FOODON_03310894": "wurstel (smoked)",
    "FOODON_03413333": "florence fennel plant",
    "FOODON_03542724": "27240 - milk and dairy powders (efsa foodex2)",
    "FOODON_03414278": "swamp taro plant",
    "HANCESTRO_0402": "Caymanian",
    "FOODON_03541699": "16990 - miscellaneous fruits with inedible peel, small (efsa foodex2)",
    "FOODON_03540279": "02790 - croissant, filled with cream (efsa foodex2)",
    "FOODON_03414463": "yellow pond lily plant",
    "FOODON_03414372": "japanese horse-chestnut tree",
    "NCBITaxon_3891": "Psophocarpus tetragonolobus",
    "OBI_0001619": "specimen collection time measurement datum",
    "FOODON_03543689": "36890 - soap-bark tree (infusion bark) (efsa foodex2)",
    "FOODON_03305111": "chewy candy",
    "FOODON_03316166": "vegetable (white, dried)",
    "GAZ_00001088": "Republic of Congo",
    "FOODON_03317426": "vegetable (crystallized)",
    "FOODON_03543206": "32060 - vegetable juices (efsa foodex2)",
    "FOODON_03307448": "whole wheat food product",
    "FOODON_03310753": "ground beef (cooked)",
    "NCBITaxon_196075": "Sprattus sprattus",
    "NCBITaxon_320457": "Allothunnus fallai",
    "FOODON_00002415": "food milling process",
    "FOODON_03401528": "10006340 - gourds (gs1 gpc)",
    "FOODON_03304442": "swedish meatball dinner (food product)",
    "FOODON_03541247": "12470 - babassu palm nuts (efsa foodex2)",
    "FOODON_00002023": "marjoram food product",
    "FOODON_03411119": "pandalid shrimp family",
    "FOODON_03412237": "kahawai",
    "NCBITaxon_1203428": "Rhombosolea plebeia",
    "FOODON_03412500": "chondrus",
    "FOODON_03414794": "typhonium plant",
    "FOODON_03304354": "herb salt seasoning",
    "FOODON_00002146": "plant product dressing",
    "FOODON_03544401": "44010 - vanilla flavour (efsa foodex2)",
    "FOODON_03413080": "dipotassium guanylate",
    "FOODON_03302191": "vegetable (canned)",
    "FOODON_03315822": "cheddar cheese (for processing)",
    "FOODON_03414368": "muscovy duck",
    "FOODON_03542750": "27500 - cream cheese (efsa foodex2)",
    "FOODON_03412847": "pseudomonadales",
    "NCBITaxon_50193": "Sonchus asper",
    "FOODON_00001040": "chicken meat food product",
    "FOODON_03400773": "086  milk fats (fm) (ccpr)",
    "FOODON_03411739": "butter bur plant",
    "FOODON_03315928": "beverage (nonalcoholic, flavored)",
    "CHEBI_53310": "copolymer macromolecule",
    "FOODON_03541834": "18340 - fruit compote, mandarin (efsa foodex2)",
    "FOODON_03304818": "seaweed (raw)",
    "FOODON_00003384": "product retailed within its country-of-origin",
    "FOODON_03305503": "pet food (canned)",
    "NCBITaxon_108326": "Eriphiidae",
    "NCBITaxon_59899": "Clarias batrachus",
    "FOODON_03306186": "lemon-flavored curd",
    "FOODON_03401021": "obsolete: 10000010 - meat/poultry/game/batrachian - unprepared/unprocessed (frozen) (gs1 gpc)",
    "FOODON_00003272": "cordon bleu (dish)",
    "FOODON_03411431": "greenling",
    "RO_0002230": "ends with",
    "FOODON_03308393": "bacalao (raw)",
    "NCBITaxon_6731": "Palinuridae",
    "FOODON_03541164": "11640 - pistachios (efsa foodex2)",
    "FOODON_03540276": "02760 - buns (efsa foodex2)",
    "NCBITaxon_171414": "Paralichthyidae",
    "FOODON_03420202": "ovary, roe",
    "FOODON_03420156": "brown sugar",
    "CHEBI_35681": "secondary alcohol",
    "NCBITaxon_59237": "Arcticidae",
    "FOODON_03310615": "crustacean (frozen)",
    "NCBITaxon_314145": "Laurasiatheria",
    "NCBITaxon_183653": "Peprilus triacanthus",
    "FOODON_03315396": "beverage (cocoa based)",
    "FOODON_03412321": "top shell",
    "CHEBI_18154": "polysaccharide",
    "CHEBI_33853": "phenols",
    "FOODON_03311217": "pecan (whole, dry roasted)",
    "FOODON_03540444": "04440 - winter purslanes (efsa foodex2)",
    "FOODON_03430174": "lozenge",
    "HANCESTRO_0512": "Mahoran",
    "FOODON_03411964": "spiny cockle",
    "FOODON_03544303": "43030 - licorice flavour (efsa foodex2)",
    "FOODON_03315656": "obsolete: brawn",
    "FOODON_03315995": "complete formulae and dietary supplements for use under medical supervision",
    "FOODON_03304079": "chicken-flavored broth (instant)",
    "NCBITaxon_4734": "commelinids",
    "FOODON_00002834": "badufsuki stew",
    "FOODON_03401176": "10000586 - chutneys/relishes (frozen) (gs1 gpc)",
    "FOODON_03310593": "raspberry (canned)",
    "FOODON_03309498": "lamb (raw)",
    "FOODON_03315188": "oats",
    "FOODON_03412917": "spelt plant",
    "FOODON_03413421": "burnet plant",
    "FOODON_03315315": "custard (frozen)",
    "NCBITaxon_2172821": "Multicrustacea",
    "FOODON_03413147": "maltitol syrup",
    "GAZ_00000554": "West Africa",
    "FOODON_03301466": "pork and beans (canned)",
    "NCBITaxon_9717": "Phoca",
    "NCBITaxon_3670": "Luffa aegyptiaca",
    "FOODON_03412594": "bonnethead",
    "NCBITaxon_111522": "Sergestidae",
    "FOODON_03311245": "grape juice (diluted)",
    "FOODON_03543296": "32960 - fruit soft drink, plum (efsa foodex2)",
    "FOODON_03541964": "19640 - undefined mixed poultry fresh meat (efsa foodex2)",
    "FOODON_03316830": "spaghetti (egg, enriched)",
    "FOODON_03542822": "28220 - cheese, ibores (efsa foodex2)",
    "FOODON_03310796": "pudding mix",
    "FOODON_00002665": "quick bread",
    "FOODON_03316716": "cheese maribo",
    "FOODON_03400425": "humectant (codex)",
    "FOODON_03413288": "starch sodium octenyl succinate",
    "FOODON_03400947": "50182200 - savoury bakery products (gs1 gpc)",
    "FOODON_03543003": "30030 - sorghum molasses (efsa foodex2)",
    "FOODON_03308233": "deep sea lobster (raw)",
    "FOODON_03490261": "rubber gasket",
    "NCBITaxon_8075": "Atheriniformes",
    "FOODON_03308871": "queen snapper (raw)",
    "CHEBI_26607": "saturated fatty acid",
    "FOODON_03301502": "yogurt (plain)",
    "FOODON_03414160": "odocoileus deer",
    "GAZ_00002951": "Romania",
    "FOODON_03304914": "granadilla squash beverage",
    "FOODON_00003292": "Manzanilla olive",
    "FOODON_03470171": "food cryogenic freezing",
    "FOODON_03490160": "aluminum tray or pan, plastic cover or wrapping",
    "FOODON_03301936": "bakery product (frozen)",
    "FOODON_03542276": "22760 - largemouth black bass (efsa foodex2)",
    "FOODON_03309725": "puffer roe pickled in rice bran",
    "FOODON_03411559": "dwarf banana plant",
    "FOODON_03414097": "spiny-tail skate",
    "FOODON_03542380": "23800 - large yellow croaker (efsa foodex2)",
    "FOODON_03490387": "diciandiamide-formaldehyde container",
    "NCBITaxon_179358": "Alectis alexandrina",
    "FOODON_03542290": "22900 - river eels (efsa foodex2)",
    "FOODON_00002487": "jujube fruit (whole, raw)",
    "FOODON_03302226": "imitation lemonade (frozen concentrate)",
    "CHEBI_86478": "antibiotic antifungal agent",
    "FOODON_03307139": "spanish olive (whole, canned)",
    "FOODON_03400662": "14  manufactured foods (single ingredient) of plant origin (ccpr)",
    "FOODON_00002161": "plum fruit food product",
    "NCBITaxon_36774": "Brassica oleracea var. italica",
    "FOODON_03460221": "obsolete: fat or oil added",
    "FOODON_03316589": "sausage (canned)",
    "FOODON_03302688": "whole wheat raisin bread",
    "FOODON_03541421": "14210 - fruit and fruit products (efsa foodex2)",
    "FOODON_03307374": "herring fillet in tomato sauce",
    "FOODON_03411442": "red hake",
    "FOODON_03541049": "10490 - garden peas (without pods) (efsa foodex2)",
    "FOODON_03411121": "bramble berry plant",
    "NCBITaxon_334942": "Chelidonichthys kumu",
    "FOODON_03541737": "17370 - common banana - acuminata cultivars (efsa foodex2)",
    "FOODON_03401374": "50262000 - edible flowers (gs1 gpc)",
    "FOODON_03307072": "lemon beverage base (food product)",
    "NCBITaxon_72171": "Ziziphus",
    "FOODON_03542963": "29630 - eggs from other not listed eggs producer birds (efsa foodex2)",
    "FOODON_03413431": "tansy plant",
    "FOODON_03540929": "09290 - nasturtium flowers and leaves (efsa foodex2)",
    "FOODON_00002843": "Williams pear (whole, raw)",
    "FOODON_03311761": "hazelnut chocolate spread",
    "FOODON_03544320": "43200 - mild flavour (efsa foodex2)",
    "FOODON_03530218": "food packing medium integrity",
    "FOODON_03315957": "fruit-based dessert energy reduced",
    "FOODON_03302616": "butter (dehydrated)",
    "FOODON_03303789": "candy (artificially fruit-flavored)",
    "FOODON_03304928": "potato soup",
    "CHEBI_26288": "propanediol",
    "FOODON_03401740": "10005949 - barbadines (gs1 gpc)",
    "FOODON_03510195": "full fat claim or use",
    "FOODON_03543013": "30130 - honey, polyfloral (efsa foodex2)",
    "FOODON_03401040": "obsolete: 10000031 - eggs/eggs substitutes (perishable) (gs1 gpc)",
    "FOODON_03303695": "liver paste (canned)",
    "FOODON_03311400": "herring salted",
    "NCBITaxon_39352": "Origanum vulgare",
    "FOODON_03540175": "01750 - pasta and similar products (efsa foodex2)",
    "FOODON_03413363": "dolphin family",
    "FOODON_03540774": "07740 - kombu (efsa foodex2)",
    "FOODON_03401000": "50101800 - nuts/seeds - prepared/processed (gs1 gpc)",
    "FOODON_03303225": "syrup",
    "CHEBI_84055": "pentose phosphate",
    "FOODON_03308308": "ocean pike (breaded)",
    "FOODON_03414213": "munson's grape plant",
    "FOODON_03413520": "atlantic angel shark",
    "FOODON_03316034": "snack (potato-based)",
    "FOODON_03401491": "10006095 - sugarloaf (gs1 gpc)",
    "FOODON_03541110": "11100 - bambara groundnut (dry seeds) (efsa foodex2)",
    "FOODON_00001032": "swiss cheese food product",
    "FOODON_03301342": "alfalfa",
    "FOODON_03311810": "pepperoni flavored sausage",
    "FOODON_03401492": "10006093 - witloof (belgian endive) (gs1 gpc)",
    "FOODON_03460289": "curing or aging 2 weeks to 1 month",
    "FOODON_03542791": "27910 - firm - ripened cheeses (efsa foodex2)",
    "FOODON_00003218": "walnut oil",
    "FOODON_03540701": "07010 - watermelons and similar- (efsa foodex2)",
    "CHEBI_53426": "polysorbate 80",
    "FOODON_03542821": "28210 - cheese, hushallsost (efsa foodex2)",
    "FOODON_03311068": "monterey jack cheese made from raw milk",
    "FOODON_03302754": "green bean (freeze-dried)",
    "FOODON_03311430": "tea beverage (ready-to-drink)",
    "NCBITaxon_3676": "Trichosanthes",
    "FOODON_03413746": "frillice lettuce plant",
    "FOODON_03490347": "metalized paper wrapper",
    "FOODON_03414809": "mangrove snail",
    "NCBITaxon_182855": "Raja undulata",
    "FOODON_03308983": "vermillion rockfish (raw)",
    "FOODON_03413802": "new guinea crocodile",
    "FOODON_03306680": "chili pepper (ground)",
    "FOODON_03315405": "mammalian milk (flavor modified)",
    "FOODON_03308549": "scallop (breaded)",
    "FOODON_03414543": "trumpet chanterelle",
    "FOODON_03317207": "mammalian milk for infant",
    "FOODON_03317522": "fat emulsions with a fat content more than 60%",
    "FOODON_00002067": "onion flavouring food product",
    "FOODON_00002114": "pie food product",
    "FOODON_03413926": "black goby",
    "FOODON_03412407": "beefalo",
    "FOODON_03500026": "mylar surface",
    "FOODON_03316501": "fruit jelly (low sugar)",
    "PATO_0045055": "normal diameter",
    "FOODON_03412177": "american eel",
    "FOODON_00001820": "dolphinfish food product",
    "GAZ_00006927": "Sao Tome and Principe",
    "HANCESTRO_0015": "Greater Middle Eastern  (Middle Eastern, North African or Persian)",
    "FOODON_03460118": "obsolete: smoked by smoke infiltration",
    "GAZ_00005275": "Solomon Islands",
    "FOODON_03305751": "tangerine juice",
    "FOODON_03400373": "antioxidants solubilizer (codex)",
    "FOODON_03303935": "matzoth",
    "FOODON_03301328": "mineral water",
    "FOODON_03315605": "fungi (edible)",
    "FOODON_03401754": "10006192 - flat sweet peppers (tomato peppers) (gs1 gpc)",
    "FOODON_03315030": "sugar substitute tablet",
    "FOODON_03420293": "fruit core (anatomical part)",
    "FOODON_03413095": "ethyl ester of beta-apo-8'-carotenic acid (c 30)",
    "NCBITaxon_184439": "Centropristis",
    "FOODON_03309638": "shrimp (pacific, canned)",
    "FOODON_03412222": "spider crab family",
    "FOODON_03307964": "herring roe (in brine, canned)",
    "FOODON_03411237": "shrimp",
    "FOODON_03307357": "green peas with sauteed mushrooms (frozen)",
    "FOODON_03544438": "44380 - emulsifying salts (efsa foodex2)",
    "FOODON_03308591": "crabmeat (pasteurized, canned)",
    "FOODON_03540716": "07160 - celeriacs (efsa foodex2)",
    "NCBITaxon_48142": "Euphausia vallentini",
    "PATO_0002450": "firm",
    "NCBITaxon_6819": "Euphausia superba",
    "FOODON_03542604": "26040 - edible insect eggs (efsa foodex2)",
    "FOODON_03311007": "pork shoulder (raw)",
    "FOODON_03544165": "41650 - rice starch (efsa foodex2)",
    "CHEBI_53227": "poly(ethylene)",
    "FOODON_03541245": "12450 - american oil palm kernels (efsa foodex2)",
    "FOODON_03302997": "roquefort cheese (food product)",
    "FOODON_03542805": "28050 - cheese, carrigaline (efsa foodex2)",
    "FOODON_03544252": "42520 - cucumber flavour (efsa foodex2)",
    "FOODON_03315140": "breakfast cereal (ready-to-eat, containing dried banana)",
    "NCBITaxon_4610": "Cyperus <genus>",
    "FOODON_03401433": "10005925 - cloudberries (gs1 gpc)",
    "FOODON_03303119": "cellulose sausage casing (edible)",
    "FOODON_03308966": "west coast snapper (raw)",
    "FOODON_03308513": "muttonbird (raw)",
    "FOODON_03541293": "12930 - black caraway seed and similar- (efsa foodex2)",
    "FOODON_03303640": "cream mint",
    "FOODON_03460111": "food treatment process",
    "FOODON_03414239": "green sapote plant",
    "FOODON_03542910": "29100 - cheese, bleu de gex (efsa foodex2)",
    "FOODON_03490187": "plastic container, rigid or semirigid, plastic lid",
    "FOODON_03305135": "rice pudding",
    "NCBITaxon_110835": "Eragrostis tef",
    "CHEBI_3375": "capsanthin",
    "CHEBI_38180": "polycyclic heteroarene",
    "FOODON_03308628": "shellfish (raw)",
    "NCBITaxon_59755": "Scyllaridae",
    "FOODON_03542344": "23440 - megrims (efsa foodex2)",
    "FOODON_03304898": "chocolate (sweetened with sorbitol)",
    "PECO_0007035": "winter season exposure",
    "FOODON_03400769": "080  dried meat and fish products (md) (ccpr)",
    "HANCESTRO_0381": "Polish",
    "FOODON_03541701": "17010 - kiwi fruits (green, red, yellow) (efsa foodex2)",
    "FOODON_03311085": "bakery product (ready-to-eat)",
    "FOODON_03543570": "35700 - mate and similar- (efsa foodex2)",
    "NCBITaxon_364270": "Apiineae",
    "FOODON_03401675": "10005799 - pheasant - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03542402": "24020 - sardines and sardine-type fishes (efsa foodex2)",
    "FOODON_03412328": "orange roughy",
    "FOODON_03316720": "meat (cooked, cured, chopped)",
    "FOODON_03412293": "lizard",
    "FOODON_03542013": "20130 - beef liver (efsa foodex2)",
    "FOODON_03304262": "spaghetti macaroni (enriched)",
    "FOODON_03306324": "mistletoe tea (dry)",
    "PO_0025355": "corm",
    "FOODON_03544131": "41310 - mushrooms cooked sauce (efsa foodex2)",
    "FOODON_03309495": "port nectar",
    "FOODON_03541500": "15000 - cornelian cherries (efsa foodex2)",
    "FOODON_03412807": "landolphia rubber plant",
    "NCBITaxon_291096": "Rumex sanguineus",
    "FOODON_03309137": "perch fillet (raw, frozen)",
    "FOODON_03541820": "18200 - jam, sour cherry (efsa foodex2)",
    "FOODON_03307940": "snow crab (canned)",
    "FOODON_03411851": "atlantic thread herring",
    "FOODON_03315793": "goat milk (evaporated, partly skimmed)",
    "FOODON_03315700": "fish (minced, frozen)",
    "NCBITaxon_9906": "Bos javanicus",
    "FOODON_03542315": "23150 - smelt, rainbow (efsa foodex2)",
    "FOODON_03460358": "food aeration by whipping",
    "FOODON_03306062": "barley (pearled)",
    "FOODON_03543456": "34560 - mugwort infusion leaves (efsa foodex2)",
    "FOODON_03311035": "soup mix, with dehydrated beef",
    "FOODON_03490119": "paper bag, sack or pouch, laminate liner",
    "FOODON_03542608": "26080 - edible insect adults (efsa foodex2)",
    "FOODON_03542056": "20560 - pig edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "FOODON_00002190": "raspberry food product",
    "FOODON_03400348": "stabilizer (ec)",
    "FOODON_03401164": "50122400 - seafood variety packs (gs1 gpc)",
    "FOODON_03460181": "iron added",
    "FOODON_03414939": "maca plant",
    "PO_0030094": "coccarium capsule fruit",
    "FOODON_03500019": "milk enamel surface for milk",
    "FOODON_00002388": "sweet bean paste",
    "FOODON_03301766": "cottonseed meal",
    "FOODON_03541358": "13580 - wasabi roots (efsa foodex2)",
    "CHEBI_3311": "calcium carbonate",
    "FOODON_03303577": "trappist cheese",
    "FOODON_03541654": "16540 - kumquats and similar- (efsa foodex2)",
    "FOODON_03310359": "barley meal",
    "FOODON_03541354": "13540 - galangal roots (efsa foodex2)",
    "FOODON_03400125": "grain or starch product (us cfr)",
    "FOODON_03316574": "jam (low sugar)",
    "FOODON_03541226": "12260 - common hemp seeds (efsa foodex2)",
    "FOODON_03302934": "sweet green pepper (canned)",
    "FOODON_00001792": "crustacean food product",
    "FOODON_03401870": "10005911 - nectarines (gs1 gpc)",
    "FOODON_03413818": "pike-conger family",
    "FOODON_03412961": "dog rose plant",
    "FOODON_03317242": "fish (gutted, deep-frozen)",
    "FOODON_03400888": "10000276 - wine - still (gs1 gpc)",
    "FOODON_03413857": "picton herring",
    "FOODON_03541184": "11840 - sesame seeds and similar- (efsa foodex2)",
    "FOODON_03414208": "european dewberry plant",
    "FOODON_03400912": "50202300 - non alcoholic beverages - ready to drink (gs1 gpc)",
    "FOODON_03401345": "50251100 - pineapples (gs1 gpc)",
    "FOODON_03490239": "plastic screw cap/pilfer proof",
    "FOODON_03543474": "34740 - clary sage infusion leaves (efsa foodex2)",
    "FOODON_03411027": "great northern bean plant",
    "FOODON_03308735": "tuna salad",
    "FOODON_03317172": "prawn (peeled, deep-frozen)",
    "FOODON_03540015": "00150 - quinoa grain (efsa foodex2)",
    "NCBITaxon_117798": "Aloe ferox",
    "FOODON_03306536": "boletus mushroom",
    "FOODON_03307916": "cider vinegar",
    "FOODON_03310149": "plantain (boiled)",
    "FOODON_03303504": "cheese (natural)",
    "FOODON_00002445": "needlefish food product",
    "FOODON_03401833": "10006269 - baby leaves (gs1 gpc)",
    "CHEBI_17309": "pectin",
    "FOODON_00002733": "food (seasoned)",
    "FOODON_03412176": "peruvian menhaden",
    "FOODON_03530227": "diphyllobothrium infestation",
    "FOODON_03401143": "10000018 - fish - prepared/processed (shelf stable) (gs1 gpc)",
    "FOODON_03305666": "imitation ice cream (artificially sweetened)",
    "FOODON_00001908": "obsolete: goat dried milk food product",
    "FOODON_03544074": "40740 - stock cubes or granulate, chicken (efsa foodex2)",
    "FOODON_03315772": "hen egg yolk food product",
    "FOODON_03305151": "date (rehydrated)",
    "FOODON_03310954": "collard greens (frozen)",
    "FOODON_03540069": "00690 - amaranth flour (efsa foodex2)",
    "FOODON_03413447": "ullucu plant",
    "FOODON_03305707": "brewers rice",
    "CHEBI_76359": "butylated hydroxyanisole",
    "FOODON_03304463": "lime juice (sweetened, reconstituted)",
    "FOODON_03309980": "buckwheat flour",
    "FOODON_03413132": "locust bean gum",
    "FOODON_03401200": "10000051 - vinegars (gs1 gpc)",
    "FOODON_03308678": "fish flesh (gill area, raw)",
    "UBERON_0018379": "metacestode",
    "FOODON_03412913": "unicorn rattail",
    "FOODON_03304103": "swiss almond cookie",
    "FOODON_03400833": "fruit or fruit product (eurofir)",
    "FOODON_03311466": "beef (partially defatted, cooked)",
    "GAZ_00002928": "Argentina",
    "FOODON_03543236": "32360 - juice concentrate, cranberry (efsa foodex2)",
    "FOODON_03302444": "butterfat (hydrogenated)",
    "FOODON_03543511": "35110 - ironwort infusion leaves (efsa foodex2)",
    "FOODON_03316734": "hake fillet (quick-frozen)",
    "FOODON_03315769": "beef blood (raw)",
    "OBI_0000938": "categorical measurement datum",
    "FOODON_00003028": "bramble berry food product",
    "FOODON_03301242": "cherry (frozen)",
    "NCBITaxon_294744": "Patinopecten caurinus",
    "CHEBI_37577": "heteroatomic molecular entity",
    "FOODON_03308329": "sardine in oil (canned)",
    "FOODON_03414460": "gourd/squash family",
    "NCBITaxon_425520": "Anarhichas denticulatus",
    "FOODON_03411694": "sapote plant",
    "FOODON_03413775": "d-pantothenate, sodium",
    "FOODON_03541914": "19140 - mixed beef and mutton/lamb fresh meat (efsa foodex2)",
    "FOODON_03412910": "new zealand lanternshark",
    "FOODON_03413982": "australian spotted mackerel",
    "FOODON_03315476": "fish paste",
    "FOODON_03414863": "amur catfish",
    "GAZ_00003103": "Vatican City",
    "NCBITaxon_4050": "Araliaceae",
    "FOODON_03412673": "short-finned eel",
    "FOODON_03542959": "29590 - seagull eggs (efsa foodex2)",
    "FOODON_03308032": "searobin (raw)",
    "FOODON_03430134": "semisolid with solid pieces",
    "FOODON_03315182": "starch molding",
    "FOODON_03302830": "chocolate-flavored dairy powder (artificially sweetened)",
    "FOODON_03413531": "dusky shark",
    "FOODON_03412248": "boar",
    "FOODON_03301509": "hen egg product (unpasteurized)",
    "FOODON_03307582": "treacle",
    "FOODON_03540052": "00520 - sorghum grain (efsa foodex2)",
    "FOODON_03303370": "chestnut (ground)",
    "FOODON_03316047": "sheep fat",
    "FOODON_03401434": "10005930 - cranberries (gs1 gpc)",
    "FOODON_03411448": "sorghum plant",
    "FOODON_00003247": "parmesan cheese",
    "FOODON_03414757": "kapok tree",
    "FOODON_03542342": "23420 - turbot (efsa foodex2)",
    "NCBITaxon_30558": "Balaenidae",
    "FOODON_03308121": "conch (raw)",
    "FOODON_03415097": "fir plant",
    "FOODON_03413425": "elecampane plant",
    "FOODON_03315491": "fish product (processed)",
    "ENVO_01001480": "domestic building",
    "FOODON_03413645": "european bittersweet",
    "FOODON_00002436": "white vegetable (whole or parts)",
    "ENVO_00003071": "grass silage",
    "FOODON_03460290": "curing or aging 1 to 2 months",
    "FOODON_03316823": "spaghetti (whole wheat)",
    "FOODON_03540968": "09680 - canna (efsa foodex2)",
    "FOODON_03317123": "potato (peeled, blanched, frozen)",
    "FOODON_03540269": "02690 - pyramid cake (efsa foodex2)",
    "FOODON_03542799": "27990 - cheese, bica (efsa foodex2)",
    "FOODON_03520518": "Organization for Economic Co-operation and Development (OECD)",
    "FOODON_03542931": "29310 - processed cheese, sliceable (efsa foodex2)",
    "FOODON_03302602": "butterscotch chip (artificially-flavored)",
    "FOODON_03309454": "meat in tomato sauce",
    "FOODON_03413807": "salmonins",
    "FOODON_03307953": "clam broth",
    "FOODON_03317424": "fruit (crystallized)",
    "FOODON_03414818": "spanish cherry plant",
    "FOODON_03414435": "sodium tartrates",
    "FOODON_00003163": "chicken parts",
    "FOODON_03540867": "08670 - creeping thyme (efsa foodex2)",
    "FOODON_03530111": "fast food outlet preparation process",
    "GAZ_00005281": "Bahrain",
    "FOODON_03412667": "blue rockfish",
    "FOODON_03542657": "26570 - cow milk, skimmed (low fat) (efsa foodex2)",
    "FOODON_03460850": "Glucuronolactone",
    "FOODON_00001834": "european blackberry food product",
    "FOODON_03542505": "25050 - lobster, norway (efsa foodex2)",
    "FOODON_03306550": "cooking oil (saturated)",
    "FOODON_03413549": "mossy ark",
    "FOODON_03303012": "chicken breast (raw)",
    "FOODON_03411784": "fantail mullet",
    "CHEBI_73558": "D3 vitamins",
    "FOODON_03400112": "nonalcoholic beverage (us cfr)",
    "NCBITaxon_161934": "Beta vulgaris",
    "FOODON_00002832": "Biltong",
    "FOODON_03412525": "tope shark",
    "FOODON_03411557": "perch",
    "FOODON_03316289": "food suitable for treating of infant dyspepsia",
    "FOODON_03412758": "honey fungus",
    "FOODON_03301468": "bouillon (liquid)",
    "PATO_0002390": "radius",
    "FOODON_03316954": "macaroni product (whole wheat)",
    "FOODON_03544033": "40330 - fried or extruded cereal, seed or root-based products (efsa foodex2)",
    "FOODON_03306079": "mint julep jell",
    "NCBITaxon_8061": "Merlucciidae",
    "FOODON_03542629": "26290 - canned salmon (efsa foodex2)",
    "FOODON_03301969": "flour (unbleached, enriched)",
    "GAZ_00006890": "Dominica",
    "FOODON_03412735": "honey mushroom",
    "FOODON_03413980": "streaked seerfish",
    "FOODON_00003139": "popcorn food product",
    "FOODON_03305354": "chicken croquette",
    "FOODON_03542205": "22050 - goat meat, dried (efsa foodex2)",
    "FOODON_03401092": "10000297 - grain based products / meals - not ready to eat - savoury (shelf stable) (gs1 gpc)",
    "FOODON_03308923": "jewfish fillet (raw)",
    "FOODON_03540538": "05380 - asparagus and similar- (efsa foodex2)",
    "RO_0001001": "derives into",
    "GAZ_00003858": "Liechtenstein",
    "FOODON_03540364": "03640 - lettuces and similar- (efsa foodex2)",
    "FOODON_03316493": "obsolete: jelly fruity",
    "FOODON_03510249": "source of omega-3 fatty acids",
    "PO_0025004": "plant axis",
    "FOODON_03301790": "candied citron",
    "FOODON_03310789": "salad greens (raw)",
    "GAZ_00001103": "Tanzania",
    "FOODON_03311170": "rosemary (ground, dried)",
    "FOODON_03412391": "greater amberjack",
    "FOODON_00002333": "vegetable pickle food product",
    "FOODON_03305724": "chocolate shortbread cookie",
    "FOODON_03540150": "01500 - rye crisp bread (efsa foodex2)",
    "FOODON_03544460": "44600 - edible casings (efsa foodex2)",
    "NCBITaxon_169617": "Rubioideae",
    "FOODON_03301678": "tomato juice (canned)",
    "FOODON_00002946": "kimchi",
    "FOODON_03540887": "08870 - water mint (efsa foodex2)",
    "FOODON_03542350": "23500 - haddock (efsa foodex2)",
    "HANCESTRO_0585": "Tatar",
    "FOODON_03411413": "rutabaga plant",
    "FOODON_03542375": "23750 - bogue (efsa foodex2)",
    "FOODON_03304824": "peppermint patty",
    "FOODON_03540974": "09740 - tannias (efsa foodex2)",
    "FOODON_00001220": "sausage (smoked)",
    "FOODON_03542373": "23730 - weakfishes (efsa foodex2)",
    "NCBITaxon_30493": "Triakis semifasciata",
    "FOODON_00003061": "robusta coffee plant",
    "FOODON_03542528": "25280 - water snails, conches and whelks (efsa foodex2)",
    "FOODON_03301094": "sablefish (cured, smoked)",
    "FOODON_03306682": "edible paper",
    "FOODON_03412762": "wild custard apple plant",
    "NCBITaxon_348445": "Molva macrophthalma",
    "FOODON_03309519": "dandelion beverage (roasted, instant)",
    "FOODON_03309730": "wheat breakfast cereal",
    "FOODON_03306964": "noodle (oriental-style)",
    "FOODON_03316500": "fat (water removed)",
    "FOODON_03413650": "atlantic giant cockle",
    "FOODON_03411372": "sieva bean plant",
    "FOODON_03490134": "glass container, plastic lid or stopper",
    "FOODON_00001783": "cowpea vegetable food product",
    "FOODON_03315498": "dressing",
    "FOODON_03309836": "coffee bean (green)",
    "FOODON_03315744": "dairy product (unstandardized)",
    "NCBITaxon_95460": "Jasus",
    "HANCESTRO_0370": "Manx",
    "FOODON_03510208": "increased {name of nutrient} nutrition claim",
    "FOODON_03401020": "50240200 - meat/poultry/other animals - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03541764": "17640 - pulasans (efsa foodex2)",
    "FOODON_03510217": "food allergen labelling about fish and products thereof",
    "FOODON_03411802": "mutton snapper",
    "FOODON_00002531": "cattle steer",
    "FOODON_00001938": "grouper food product",
    "FOODON_03312045": "wheat dough (refrigerated)",
    "FOODON_03401860": "10006133 - leek (gs1 gpc)",
    "FOODON_03542957": "29570 - eggs from other eggs producer birds (efsa foodex2)",
    "FOODON_03311094": "infant formula whey-based",
    "GAZ_00002954": "Czech Republic",
    "CHEBI_33855": "arenecarbaldehyde",
    "FOODON_03543313": "33130 - soft drink, pear flavour (efsa foodex2)",
    "FOODON_03401836": "10006092 - purslane (gs1 gpc)",
    "FOODON_03301813": "mango (whole, raw)",
    "FOODON_03542688": "26880 - buttermilk (efsa foodex2)",
    "FOODON_03540316": "03160 - oat rolled grains, wholemeal (efsa foodex2)",
    "FOODON_03520146": "pacific, northeast (fao major fishing area 67)",
    "FOODON_03540679": "06790 - bottle gourds (efsa foodex2)",
    "BFO_0000028": "three-dimensional spatial region",
    "FOODON_03420270": "skeletal meat part, without bone and skin, without separable fat",
    "FOODON_03307932": "torula yeast (artificially smoke-flavored, dried)",
    "FOODON_03490170": "aluminum tube, top lined with foil",
    "NCBITaxon_13393": "Cananga odorata",
    "FOODON_03315732": "beef fatty tissue (partially defatted)",
    "FOODON_03301195": "kelp (whole or parts)",
    "FOODON_03541568": "15680 - northern highbush blueberry (efsa foodex2)",
    "NCBITaxon_291982": "Strombus gigas",
    "FOODON_03304620": "fig juice",
    "FOODON_03541570": "15700 - aronia berries (red) (efsa foodex2)",
    "FOODON_03309574": "rutabaga (whole, raw)",
    "FOODON_03400916": "10000201 - drinks flavoured - ready to drink (gs1 gpc)",
    "NCBITaxon_111784": "Reinhardtius hippoglossoides",
    "FOODON_03401500": "10005882 - lemons (gs1 gpc)",
    "NCBITaxon_307936": "Pachygrapsus crassipes",
    "FOODON_03311052": "cabbage (boiled)",
    "FOODON_03302480": "wheat bread mix (liquid)",
    "FOODON_03414356": "rabbiteye blueberry plant",
    "FOODON_03309602": "orange yogurt",
    "FOODON_00003252": "omelette",
    "FOODON_03309330": "jack salmon (raw)",
    "FOODON_03460751": "leavening agent addition process",
    "FOODON_03541303": "13030 - cumin seed and similar- (efsa foodex2)",
    "FOODON_03311503": "iguana egg (raw)",
    "CHEBI_33661": "monocyclic compound",
    "NCBITaxon_491138": "Crangon crangon",
    "FOODON_03540051": "00510 - sorghum and similar- (efsa foodex2)",
    "FOODON_03543553": "35530 - common walnut infusion leaves (efsa foodex2)",
    "FOODON_03544207": "42070 - blue cheese flavour (efsa foodex2)",
    "FOODON_03302033": "chili pepper (raw)",
    "FOODON_03301355": "almond (whole, raw)",
    "FOODON_03317015": "fruit juice concentrate (unsweetened)",
    "FOODON_03303192": "corn meal mix",
    "FOODON_03430123": "food (liquid, low viscosity, with no visible particles)",
    "FOODON_03310211": "corsaro sauce",
    "FOODON_03315531": "shellfish (deep-frozen, boiled)",
    "FOODON_03301313": "meat tenderizer",
    "FOODON_03401515": "10006311 - coffee substitutes - instant (gs1 gpc)",
    "FOODON_03306691": "herring (marinated)",
    "FOODON_03304985": "imitation jam (sweetened with sorbitol)",
    "CHEBI_37826": "sulfuric acid derivative",
    "NCBITaxon_39350": "Ocimum basilicum",
    "FOODON_03401255": "0870000 - spices, aril (ec)",
    "FOODON_03414087": "shagreen ray",
    "NCBITaxon_27405": "Penaeus japonicus",
    "NCBITaxon_79772": "Verbena officinalis",
    "FOODON_03316586": "meat-vegetable conserve",
    "NCBITaxon_35875": "Allium fistulosum",
    "FOODON_03308177": "gilchrist's spiny lobster (raw)",
    "FOODON_03317368": "beverage (nonalcoholic, noncarbonated)",
    "FOODON_03306272": "oat flakes",
    "FOODON_03540772": "07720 - other brown algae (efsa foodex2)",
    "FOODON_03541643": "16430 - a\u00e7a\u00ed berries (efsa foodex2)",
    "FOODON_03309016": "albacore (solid-pack, canned)",
    "FOODON_03310166": "chicken thigh (raw)",
    "NCBITaxon_661134": "Sphyrna tudes",
    "FOODON_03542164": "21640 - snack sausages (like cabanos and landj\u00e4ger) (efsa foodex2)",
    "FOODON_03315572": "bouillon mix (dried)",
    "FOODON_03541338": "13380 - mace aril (efsa foodex2)",
    "FOODON_00003137": "elliott's blueberry",
    "NCBITaxon_84348": "Squillidae",
    "GAZ_00002563": "Province of Ontario",
    "FOODON_03541730": "17300 - other miscellaneous fruits with inedible peel, small (efsa foodex2)",
    "FOODON_00002459": "red currant food product",
    "FOODON_03309478": "grouse meat (raw)",
    "FOODON_03530064": "grade of meat",
    "FOODON_03308129": "mussel in shell (raw)",
    "NCBITaxon_137220": "Rheum officinale",
    "FOODON_00003321": "yuzu tree",
    "UO_0010027": "gill",
    "FOODON_03310806": "oatmeal (cooked)",
    "GAZ_00003959": "United States Virgin Islands",
    "NCBITaxon_238744": "Menidia menidia",
    "FOODON_03412189": "striped bonito",
    "FOODON_03411030": "diphos sanguin",
    "FOODON_03308601": "chilean king crab (raw)",
    "HANCESTRO_0517": "Sierra Leonean",
    "FOODON_03542856": "28560 - cheese, tomme de savoie (efsa foodex2)",
    "FOODON_03412160": "groundsel plant",
    "FOODON_03301777": "butter (unsalted)",
    "FOODON_03412157": "chinaberry plant",
    "FOODON_00001904": "ginseng food product",
    "FOODON_03540588": "05880 - spring onions and similar- (efsa foodex2)",
    "FOODON_03543602": "36020 - horse-chestnut infusion flowers (efsa foodex2)",
    "FOODON_00001746": "cockle food product",
    "FOODON_03400843": "soft drink (eurofir)",
    "CHEBI_22728": "benzopyrrole",
    "FOODON_03305627": "coconut (flaked)",
    "NCBITaxon_110741": "Diospyros digyna",
    "FOODON_03401750": "10005985 - sugar snap peas (gs1 gpc)",
    "FOODON_03412121": "european grape plant",
    "FOODON_03411558": "sardine",
    "FOODON_03460230": "single component food fermentation",
    "NCBITaxon_29722": "Amaranthus tricolor",
    "FOODON_03317364": "corn starch hydrolyzate",
    "FOODON_03542125": "21250 - cooked pork ham (efsa foodex2)",
    "FOODON_03307543": "potato starch (food product)",
    "UBERON_0003100": "female organism",
    "FOODON_03414442": "polyvinyl alcohol (pva)",
    "FOODON_03304519": "anise-flavored syrup",
    "FOODON_03308797": "shrimp log (breaded)",
    "FOODON_03541041": "10410 - soyabeans (without pods) (efsa foodex2)",
    "FOODON_03540692": "06920 - cucurbits with inedible peel (efsa foodex2)",
    "FOODON_03310877": "castilla cake",
    "FOODON_00002037": "milkfish food product",
    "FOODON_03304096": "chocolate chip",
    "FOODON_03302159": "imitation strawberry carbonated beverage",
    "FOODON_03316378": "melon (dried)",
    "FOODON_03542353": "23530 - tusk (efsa foodex2)",
    "FOODON_03542429": "24290 - seerfish (efsa foodex2)",
    "OBI_0000443": "analyte assay",
    "NCBITaxon_337730": "Marmotini",
    "FOODON_03414121": "humantin",
    "FOODON_03490122": "plastic tray or pan, laminate cover or wrapping",
    "GAZ_00006886": "Belarus",
    "FOODON_03540396": "03960 - radish leaves (including radish tops) (efsa foodex2)",
    "FOODON_03304844": "egg roll or bun",
    "FOODON_03510045": "energy special claim or use",
    "FOODON_03412291": "weeverfish family",
    "FOODON_03305327": "ginger snap cookie",
    "FOODON_03307422": "wheat fiber",
    "FOODON_03311519": "infant formula (milk-based, liquid, concentrated)",
    "FOODON_03412397": "mustard cabbage plant",
    "FOODON_03306331": "fish sausage",
    "FOODON_03306939": "pickle (polish)",
    "FOODON_03305348": "melba toast",
    "NCBITaxon_9858": "Capreolus capreolus",
    "NCBITaxon_106232": "Solenoidea",
    "NCBITaxon_72055": "Sebastes alutus",
    "FOODON_03544095": "40950 - hollandaise type sauce (efsa foodex2)",
    "FOODON_03540284": "02840 - flat bread-based pastry (efsa foodex2)",
    "FOODON_00003303": "beef top loin steak",
    "FOODON_03541825": "18250 - marmalade, oranges (efsa foodex2)",
    "FOODON_03307409": "spring water (bottled)",
    "FOODON_03310711": "corn snack (puffed, cheese-flavored)",
    "FOODON_03542039": "20390 - equine kidney (efsa foodex2)",
    "FOODON_03540261": "02610 - nut cream cake (efsa foodex2)",
    "FOODON_03542318": "23180 - pond smelt (efsa foodex2)",
    "FOODON_03543226": "32260 - fruit smoothies (efsa foodex2)",
    "FOODON_03541703": "17030 - golden kiwifruit (efsa foodex2)",
    "GO_0008152": "metabolic process",
    "FOODON_03309100": "herring (fried)",
    "FOODON_03302927": "papaw and mango chutney",
    "FOODON_03308270": "bonito tuna (light meat, raw)",
    "FOODON_03308660": "shellfish (frozen)",
    "NCBITaxon_186626": "Otophysi",
    "FOODON_03420192": "tripe",
    "FOODON_03490309": "steel plate container tinned both sides",
    "FOODON_03401780": "10006748 - ready-made combination meals - not ready to eat (frozen) (gs1 gpc)",
    "FOODON_03414191": "wild senna plant",
    "CHEBI_27136": "triol",
    "FOODON_03544148": "41480 - fruit sauce (efsa foodex2)",
    "FOODON_03542357": "23570 - whiting (efsa foodex2)",
    "BFO_0000179": "BFO OWL specification label",
    "PO_0025597": "ear infructescence",
    "FOODON_03316326": "crayfish preparation (unsterilized)",
    "FOODON_03541881": "18810 - sheep carcase (efsa foodex2)",
    "CHEBI_29016": "arginine",
    "FOODON_03400800": "meat analogue (eurofir)",
    "FOODON_03544127": "41270 - salsa (efsa foodex2)",
    "FOODON_03411854": "anchovy",
    "CHEBI_35366": "fatty acid",
    "FOODON_03310441": "red raspberry preserves (sweetened with fruit juice)",
    "FOODON_03540523": "05230 - flowering brassica (efsa foodex2)",
    "FOODON_03543136": "31360 - sardine oil (efsa foodex2)",
    "FOODON_03541818": "18180 - jam, peaches (efsa foodex2)",
    "FOODON_03305833": "english muffin",
    "FOODON_03306412": "shorts (grain product)",
    "FOODON_03414151": "date shell",
    "FOODON_03304530": "scampi (peeled, quick-frozen)",
    "FOODON_03541795": "17950 - dried prunes (efsa foodex2)",
    "FOODON_03540840": "08400 - fennel leaves (efsa foodex2)",
    "FOODON_03544326": "43260 - muscat grapes flavour (efsa foodex2)",
    "FOODON_03316908": "coconut food product",
    "FOODON_03310949": "vichyssoise canned",
    "ENVO_00000123": "political entity",
    "NCBITaxon_183220": "Abelmoschus manihot",
    "FOODON_03309530": "muffin",
    "FOODON_03401070": "10005226 - egg based products / meals - not ready to eat (shelf stable) (gs1 gpc)",
    "FOODON_03413983": "japanese spanish mackerel",
    "FOODON_03400866": "prepared salad (eurofir)",
    "FOODON_03316767": "milk chocolate and vegetable oil coating",
    "FOODON_03311719": "swine carcass",
    "FOODON_03411375": "wild rice plant",
    "FOODON_03414758": "costus plant",
    "FOODON_03414109": "smooth-hound genus",
    "CHEBI_17883": "hydrogen chloride",
    "FOODON_03414857": "catla",
    "FOODON_03460753": "yeast addition process",
    "NCBITaxon_50519": "Dynastinae",
    "UO_0010013": "foot",
    "FOODON_03543877": "38770 - omelette with vegetables (efsa foodex2)",
    "FOODON_03413314": "triethyl citrate",
    "NCBITaxon_209541": "Trichodon trichodon",
    "FOODON_03412071": "white cabbage plant",
    "PATO_0002066": "crystal configuration",
    "FOODON_03414119": "angel shark",
    "FOODON_03311091": "lamb chop (raw)",
    "FOODON_03541131": "11310 - cashew nuts (efsa foodex2)",
    "HANCESTRO_0389": "Serb",
    "FOODON_03316310": "strawberry (preserved in airtight container)",
    "FOODON_03400664": "16  secondary food commodities of animal origin (ccpr)",
    "FOODON_03542490": "24900 - freshwater shrimps or prawns (efsa foodex2)",
    "FOODON_03543529": "35290 - mullein infusion leaves (efsa foodex2)",
    "FOODON_03310371": "rice meal",
    "PATO_0000921": "width",
    "FOODON_03542499": "24990 - tanner crabs (generic) (efsa foodex2)",
    "FOODON_00002385": "baking soda product",
    "FOODON_03305307": "goose liver (raw)",
    "FOODON_03401752": "10006102 - chilli peppers (gs1 gpc)",
    "FOODON_00002597": "Pinot noir grape plant",
    "FOODON_03308093": "round herring (raw)",
    "FOODON_03411074": "yellowfin tuna",
    "PATO_0045061": "normal width",
    "CHEBI_26513": "quinolines",
    "FOODON_03301146": "cucumber pickle",
    "FOODON_03307796": "keemun black tea (dry)",
    "FOODON_03306739": "black pepper (ground)",
    "FOODON_00002609": "Glera wine",
    "FOODON_03316236": "rusks containing fat",
    "NCBITaxon_39395": "Cancer borealis",
    "PO_0025001": "cardinal organ part",
    "FOODON_03304153": "sesame milk beverage base",
    "FOODON_03414610": "atlantic thornyhead",
    "FOODON_03304770": "coffee bean (drip-grind)",
    "NCBITaxon_36594": "Aronia arbutifolia",
    "FOODON_03401183": "50171800 - sauces/spreads/dips/condiments (gs1 gpc)",
    "FOODON_03414086": "little skate",
    "FOODON_03302569": "distillers grain solubles",
    "HANCESTRO_0509": "Malagasy",
    "FOODON_00002015": "mackerel food product",
    "HANCESTRO_0541": "Malian",
    "FOODON_03544362": "43620 - rhubarb flavour (efsa foodex2)",
    "FOODON_03305661": "iodized water for livestock",
    "FOODON_03414186": "tiger saw-gill",
    "FOODON_03311034": "kale (frozen)",
    "FOODON_03307763": "imitation fruit-flavored candy drop",
    "FOODON_03302010": "bakery product (mix)",
    "NCBITaxon_16718": "Juglans",
    "FOODON_03470120": "heat treatment food preservation",
    "NCBITaxon_50592": "Pagellus",
    "FOODON_03543952": "39520 - cheese-based canap\u00e9 (efsa foodex2)",
    "FOODON_03510205": "source of fibre",
    "NCBITaxon_50417": "Mimachlamys varia",
    "NCBITaxon_6592": "Veneridae",
    "FOODON_03540871": "08710 - marjoram (efsa foodex2)",
    "FOODON_03430115": "divided into pieces, thickness 0.3-1.5 cm.",
    "FOODON_03306440": "oxtail stew",
    "FOODON_03400998": "obsolete: 10000209 - fruit/nuts/seeds mixes - unprepared/unprocessed (shelf stable) (gs1 gpc)",
    "FOODON_03304840": "hen egg white food product",
    "FOODON_03401123": "50193400 - prepared/preserved foods variety packs (gs1 gpc)",
    "FOODON_03510174": "gluten free claim or use",
    "FOODON_03415093": "jengkol plant",
    "FOODON_03306072": "apple jelly (mint-flavored, with green pepper)",
    "FOODON_03315522": "animal fat or oil",
    "FOODON_03311546": "beverage (fruit juice based, nonrefrigerated, pasteurized, aseptically packaged, ready-to-serve)",
    "NCBITaxon_72083": "Sebastes levis",
    "FOODON_03317319": "pork ham (uncooked, cured)",
    "FOODON_03400133": "flavoring or seasoning (us cfr)",
    "FOODON_00003438": "black rice",
    "FOODON_03430150": "whole, natural shape",
    "FOODON_03317544": "chutney",
    "FOODON_03541209": "12090 - safflower seeds and similar- (efsa foodex2)",
    "FOODON_03541837": "18370 - fruit compote, pineapple (efsa foodex2)",
    "CHEBI_33240": "coordination entity",
    "FOODON_03306439": "steak and kidney pudding",
    "FOODON_03543715": "37150 - minor coffee imitates infusions (efsa foodex2)",
    "FOODON_03308928": "mullet (smoked)",
    "FOODON_03541492": "14920 - apricots (efsa foodex2)",
    "FOODON_03308391": "fish (deboned)",
    "OBI_0200079": "arithmetic mean calculation",
    "FOODON_03543538": "35380 - ribwort plantain infusion leaves (efsa foodex2)",
    "FOODON_03311286": "black bean sauce",
    "NCBITaxon_116706": "Heterotremata",
    "FOODON_03544240": "42400 - citron flavour (efsa foodex2)",
    "FOODON_03460200": "acidification process",
    "FOODON_03301018": "barley malt powder",
    "FOODON_03308789": "butter sole (raw)",
    "FOODON_03305635": "honey (vitamin added)",
    "FOODON_03414723": "lepidozamia plant",
    "FOODON_03540312": "03120 - barley rolled grains (efsa foodex2)",
    "UBERON_0001264": "pancreas",
    "FOODON_03415065": "absinthe plant",
    "NCBITaxon_52935": "Glycymerididae",
    "FOODON_03303414": "fruit juice (frozen)",
    "FOODON_03303943": "shredded wheat breakfast cereal",
    "FOODON_00002815": "lowfat cow milk (1% fat)",
    "FOODON_00002263": "soybean dressing food product",
    "FOODON_03310554": "brewers yeast (dry)",
    "FOODON_03317312": "chili with beans (canned)",
    "FOODON_03413967": "cobblerfish",
    "FOODON_03542935": "29350 - cheese powder (efsa foodex2)",
    "PO_0020038": "petiole",
    "FOODON_00002553": "triticale flour",
    "FOODON_03302035": "sugar beet fiber (food product)",
    "FOODON_03310913": "decorating sugar",
    "NCBITaxon_119195": "Galeoidea",
    "FOODON_03542841": "28410 - cheese, piacentinu (efsa foodex2)",
    "FOODON_03480012": "packed in heavily sweetened liquid",
    "FOODON_03309390": "bulk grain",
    "FOODON_03316728": "cheese danablu",
    "FOODON_03541269": "12690 - lavender, dry (efsa foodex2)",
    "NCBITaxon_4180": "Pedaliaceae",
    "FOODON_03401127": "10000146 - aquatic invertebrates - prepared/processed (perishable) (gs1 gpc)",
    "NCBITaxon_34989": "Colubroidea",
    "CHEBI_33595": "cyclic compound",
    "FOODON_03311294": "long grain rice (whole, raw)",
    "FOODON_03412292": "eelpout",
    "NCBITaxon_9776": "Trichechus",
    "FOODON_03309529": "club cracker",
    "FOODON_00002574": "cut of beef",
    "ENVO_00000309": "depression",
    "NCBITaxon_91742": "Cephalopholis",
    "NCBITaxon_92921": "Silybum marianum",
    "FOODON_03542454": "24540 - sharks, rays, chimaeras (efsa foodex2)",
    "FOODON_03412207": "fan lobster",
    "FOODON_03305617": "almond paste",
    "FOODON_03542638": "26380 - smoked herring (efsa foodex2)",
    "NCBITaxon_4511": "Eleusine coracana",
    "NCBITaxon_97729": "Boesenbergia rotunda",
    "FOODON_03542261": "22610 - pirapatinga (efsa foodex2)",
    "FOODON_03414577": "actinobacteridae",
    "FOODON_03412552": "cascabel pepper plant",
    "FOODON_03303765": "toffee",
    "FOODON_03306063": "flavoring syrup (alcoholic)",
    "FOODON_03411510": "snapper",
    "FOODON_03305817": "mincemeat (brandied)",
    "FOODON_03543402": "34020 - coffee, cocoa, tea and infusions (efsa foodex2)",
    "FOODON_03301833": "potato chip",
    "NCBITaxon_742010": "Carduinae",
    "FOODON_03400159": "ice cream product analog (us cfr)",
    "FOODON_03301232": "white bean (whole)",
    "FOODON_03411328": "goat",
    "FOODON_03414579": "bacteroidetes",
    "FOODON_03311455": "prebaked cookie filling",
    "FOODON_03401682": "10006293 - squab/pigeon - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03414925": "devil rattan plant",
    "NCBITaxon_72092": "Sebastes ovalis",
    "FOODON_03411450": "opossum",
    "FOODON_03541821": "18210 - jam, oranges (efsa foodex2)",
    "FOODON_00003175": "nut (whole, raw, shell on)",
    "FOODON_03310246": "sausage (mold-ripened, dry)",
    "HANCESTRO_0390": "Slovak",
    "FOODON_00002852": "Granny Smith apple tree",
    "NCBITaxon_215350": "Bramidae",
    "FOODON_03530012": "standard grade",
    "FOODON_03414861": "clarias catfish",
    "FOODON_03308158": "oyster (molded, breaded)",
    "FOODON_03306957": "noodle (egg, dumpling)",
    "NCBITaxon_119374": "Haemulon",
    "FOODON_03412580": "northern pink shrimp",
    "FOODON_03306909": "rice (crisped)",
    "FOODON_03316703": "cocoa dust",
    "GAZ_00006913": "Timor-Leste",
    "FOODON_03540361": "03610 - lamb's lettuces and similar- (efsa foodex2)",
    "FOODON_03317626": "meat (cured, comminuted)",
    "FOODON_03543685": "36850 - parsley (infusion fruits) (efsa foodex2)",
    "HANCESTRO_0394": "Swiss",
    "NCBITaxon_1906129": "Esomus danrica",
    "NCBITaxon_8671": "Pseudechis porphyriacus",
    "NCBITaxon_109171": "Pachyrhizus erosus",
    "FOODON_03530236": "hazard 8",
    "FOODON_03317281": "beef sausage (raw)",
    "NCBITaxon_4144": "Oleaceae",
    "FOODON_03412103": "camel",
    "FOODON_03303624": "tom collins",
    "FOODON_03401062": "50193000 - baby/infant - foods/beverages (gs1 gpc)",
    "FOODON_03315678": "meat (marinated or similar, cold-processed, packaged)",
    "FOODON_03308222": "chum salmon (raw)",
    "FOODON_03510196": "trans fat claim or use",
    "FOODON_00003221": "cupua\u00e7u fruit food product",
    "FOODON_03315037": "fruit flavored drinks and ades (noncarbonated, refrigerated, single-strength)",
    "NCBITaxon_8501": "Crocodylus niloticus",
    "FOODON_03542254": "22540 - snakehead (efsa foodex2)",
    "FOODON_03311798": "longtail tuna (canned)",
    "GAZ_00005917": "Coral Sea Islands Territory",
    "FOODON_03307082": "lemon (chopped)",
    "FOODON_03413584": "andaman lobster",
    "FOODON_03414188": "indian frankincense plant",
    "FOODON_03309967": "pork tenderloin (raw)",
    "FOODON_03311188": "fish cake (raw, breaded)",
    "FOODON_03310755": "sausage (cured)",
    "NCBITaxon_195334": "Sphyrna mokarran",
    "FOODON_03401005": "10000008 - nuts/seeds - unprepared/unprocessed (shelf stable) (gs1 gpc)",
    "FOODON_03301556": "cinnamon (ground)",
    "FOODON_03412049": "nevada jointfir plant",
    "FOODON_03490279": "glass container, coloured, light weight",
    "FOODON_03541363": "13630 - zedoary roots (efsa foodex2)",
    "FOODON_03309293": "humpback whitefish (raw)",
    "NCBITaxon_303921": "Atherina presbyter",
    "FOODON_03543667": "36670 - blond psyllium (infusion seeds, husks) (efsa foodex2)",
    "FOODON_03543095": "30950 - olive oil, virgin or extra-virgin (efsa foodex2)",
    "FOODON_03315839": "low calorie food",
    "FOODON_03412856": "hyphomicrobiales",
    "FOODON_03315741": "fish (frozen, glazed)",
    "FOODON_03303046": "split peas (cooked, dried)",
    "FOODON_03542110": "21100 - ham, pork (efsa foodex2)",
    "FOODON_03543447": "34470 - tea extract (powder) (efsa foodex2)",
    "FOODON_03540045": "00450 - rice grain, glutinous (efsa foodex2)",
    "FOODON_03542067": "20670 - chicken edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "FOODON_03412931": "swartzia plant",
    "FOODON_03306012": "orange juice concentrate (sweetened)",
    "FOODON_03412496": "grasshopper",
    "FOODON_00002477": "game animal food product",
    "FOODON_03304181": "salmon (hard smoked)",
    "FOODON_03460396": "marinading",
    "NCBITaxon_196674": "Neptunia oleracea",
    "FOODON_03412384": "yellow jack",
    "FOODON_03540197": "01970 - asian-style noodles other than glass noodles (efsa foodex2)",
    "FOODON_03301487": "marjoram (crushed)",
    "NCBITaxon_7065": "Tenebrionidae",
    "NCBITaxon_98812": "Dentex canariensis",
    "FOODON_00001994": "leguminous vegetable food product",
    "FOODON_03307616": "scampi and lobster newburg (dish)",
    "FOODON_03301503": "cow milk (concentrated)",
    "NCBITaxon_190544": "Vaccinium ovalifolium",
    "FOODON_03412654": "eulachon",
    "FOODON_03311053": "hen egg (whole, shell on, soft boiled)",
    "CHEBI_32139": "sodium hydrogencarbonate",
    "FOODON_03412004": "perch family",
    "NCBITaxon_189212": "Emilia",
    "PATO_0000998": "viscous",
    "FOODON_00002316": "tomato juice food product",
    "FOODON_03400689": "028  spices (hs) (codex)",
    "FOODON_03543660": "36600 - herbal infusion extracts (powder) (efsa foodex2)",
    "FOODON_03542668": "26680 - goat milk (efsa foodex2)",
    "UO_0000001": "length unit",
    "FOODON_03311261": "margarine, low calorie",
    "FOODON_03303780": "hard candy",
    "FOODON_03301213": "star anise seed (whole, dried)",
    "FOODON_03540933": "09330 - processed tomato products (efsa foodex2)",
    "FOODON_03411355": "vanilla plant",
    "FOODON_03420171": "invert sugar",
    "FOODON_03316440": "pudding powder substitute",
    "FOODON_00002829": "multi-component wheat pasta dish",
    "FOODON_03303003": "chicken and dumplings",
    "FOODON_03302373": "bread (artificially colored)",
    "FOODON_03400726": "03  meat and meat products (eurocode2)",
    "FOODON_03309240": "trout fillet (raw)",
    "FOODON_03301606": "creme de menthe liqueur",
    "FOODON_03307481": "fruit crush drink",
    "NCBITaxon_109273": "Ambloplites rupestris",
    "FOODON_00002910": "wild harvested animal",
    "ECOCORE_00000009": "autotrophy",
    "FOODON_03311084": "soft drink mix (unsweetened, powdered)",
    "FOODON_03413289": "stearyl tartrate",
    "NCBITaxon_9765": "Balaenopteridae",
    "FOODON_03542495": "24950 - crabs, sea-spiders (efsa foodex2)",
    "FOODON_03301320": "peanut meal",
    "FOODON_03306009": "obsolete: fruit juice from concentrate",
    "FOODON_03414236": "tamarind plum plant",
    "FOODON_03301494": "sour cream dressing",
    "NCBITaxon_3524": "Caryophyllales",
    "FOODON_03310632": "formulated concentrated food",
    "FOODON_03302289": "soft drink powder (artificially sweetened)",
    "FOODON_03306054": "pineapple (crushed)",
    "NCBITaxon_213384": "Leucoraja circularis",
    "CHEBI_26255": "prenylquinone",
    "FOODON_03304595": "ravioli pasta",
    "FOODON_00002548": "tikka masala sauce",
    "FOODON_03303697": "pasteurized process colby cheese",
    "FOODON_03412499": "bombay duck",
    "FOODON_03308103": "sea herring (raw)",
    "FOODON_03307396": "pike (raw)",
    "FOODON_03307956": "seaworm (fried)",
    "FOODON_03540890": "08900 - greek bush basil (efsa foodex2)",
    "FOODON_03316891": "berry (dried)",
    "FOODON_03412828": "gray plum plant",
    "FOODON_03413157": "monoammonium glutamate",
    "FOODON_03305259": "sour cream cookie",
    "NCBITaxon_7802": "Odontaspididae",
    "FOODON_03307944": "tortilla flour",
    "FOODON_03543027": "30270 - sorbitol (efsa foodex2)",
    "FOODON_03413379": "kudzu plant",
    "NCBITaxon_3593": "Cactaceae",
    "FOODON_03414969": "camu-camu plant",
    "FOODON_03542701": "27010 - yoghurt, goat milk, plain (efsa foodex2)",
    "FOODON_03530091": "beverage base, liquid",
    "FOODON_03309290": "alaska white salmon (raw)",
    "FOODON_03411313": "rye plant",
    "FOODON_03540579": "05790 - onions (efsa foodex2)",
    "FOODON_03510077": "no or reduced salt or sodium claim or use",
    "FOODON_03540293": "02930 - puff-pastry croissant, filled with chocolate (efsa foodex2)",
    "FOODON_03542145": "21450 - italian-style sausage (efsa foodex2)",
    "FOODON_03414643": "green tree ant",
    "NCBITaxon_283036": "Sander vitreus",
    "FOODON_03400130": "fruit juice, diluted (us cfr)",
    "FOODON_03542920": "29200 - firm-ripened bloomy (white mould) or washed rind cheese (efsa foodex2)",
    "FOODON_00001853": "fig preserve or jam food product",
    "NCBITaxon_198537": "Chaceon quinquedens",
    "FOODON_03490354": "paper-paper combination",
    "FOODON_03311318": "breakfast cereal (corn-based, ready-to-eat)",
    "FOODON_03316650": "sausage (pickled)",
    "NCBITaxon_1437201": "Pentapetalae",
    "NCBITaxon_48141": "Euphausia crystallorophias",
    "NCBITaxon_4232": "Helianthus annuus",
    "FOODON_03303415": "ice cream cone (food product)",
    "FOODON_03500054": "latex surface",
    "FOODON_03304734": "chive (freeze-dried)",
    "FOODON_03530023": "rib (meat cut)",
    "FOODON_03412427": "smallmouth bass",
    "NCBITaxon_7995": "Siluriformes",
    "FOODON_03414448": "riboflavins",
    "FOODON_03413944": "porkfish",
    "FOODON_03309576": "table spread",
    "FOODON_03413868": "swamp minnow",
    "FOODON_00002124": "obsolete: plant based animal feed food product",
    "FOODON_03317317": "pork butt (cooked, cured)",
    "GAZ_00000581": "Eritrea",
    "FOODON_03308156": "oyster (breaded, frozen)",
    "FOODON_03412281": "white croaker",
    "FOODON_03401219": "semisoft part skim cheese (us cfr)",
    "GAZ_00002958": "Latvia",
    "FOODON_03411890": "pacific saury",
    "FOODON_00001062": "fermented millet food product",
    "FOODON_03306877": "squash (cut)",
    "FOODON_03470131": "food chilling",
    "FOODON_03412528": "beluga",
    "FOODON_03316731": "tomato (wedged, canned)",
    "NCBITaxon_3435": "Persea americana",
    "CHEBI_38418": "1,3-thiazoles",
    "FOODON_03414352": "obsolete: grains-of-paradise",
    "FOODON_00001100": "orange fruit beverage",
    "FOODON_00001739": "citric acid soft drink",
    "HANCESTRO_0447": "Omani",
    "HANCESTRO_0383": "Irish",
    "FOODON_03310865": "cocktail beverage (frozen, alcoholic)",
    "FOODON_03414270": "banana plant",
    "HANCESTRO_0483": "Ni-Vanuato",
    "FOODON_03307227": "bourbon and rum cake (chocolate-covered)",
    "FOODON_03500047": "food-grade ash",
    "FOODON_03400266": "pasteurized cheese spread (us cfr)",
    "FOODON_03413086": "disodium diphosphate",
    "FOODON_03411098": "brown rock shrimp",
    "FOODON_03317046": "breakfast-cereal (no added sugar)",
    "NCBITaxon_348046": "Kathetostoma giganteum",
    "FOODON_03401719": "10005964 - lychees (litchi) (gs1 gpc)",
    "FOODON_03317276": "animal fat (rendered)",
    "FOODON_03315492": "shellfish product (processed)",
    "FOODON_03401015": "50240000 - meat/poultry/other animals (gs1 gpc)",
    "FOODON_00001955": "hot pepper spice food product",
    "FOODON_00002417": "apple (raw, sliced)",
    "FOODON_03412379": "obsolete: carmine cusk-eel",
    "FOODON_03311312": "shad smoked using hot-smoking nitrite-treated",
    "CHEBI_33745": "copper group molecular entity",
    "FOODON_03541315": "13150 - annatto seed (efsa foodex2)",
    "FOODON_03542727": "27270 - milk powder, skimmed (efsa foodex2)",
    "CHEBI_32879": "propane",
    "FOODON_03302716": "imitation hamburger pattie",
    "NCBITaxon_41773": "Berberidaceae",
    "NCBITaxon_80365": "Laminaria digitata",
    "FOODON_03411818": "sunfish family",
    "NCBITaxon_41209": "Chionoecetes",
    "FOODON_00002919": "bhuna chana",
    "FOODON_00001124": "caprine cheese food product",
    "FOODON_03542509": "25090 - squat lobsters (efsa foodex2)",
    "FOODON_03309019": "blackfin tuna (raw)",
    "FOODON_03315308": "vegetable (whole or parts)",
    "FOODON_03308034": "cusk (raw)",
    "FOODON_03316142": "nut coating (food product)",
    "NCBITaxon_7901": "Acipenser",
    "FOODON_03303804": "candy (alcoholic beverage-flavored)",
    "FOODON_03301583": "grain product (cooked)",
    "FOODON_03315971": "sandwich spread (cocoa-based, energy reduced)",
    "FOODON_03530104": "external fat trimmed to 1/2 inch",
    "FOODON_03543803": "38030 - nutritionally complete formulae (efsa foodex2)",
    "NCBITaxon_205524": "Solanum aethiopicum",
    "HANCESTRO_0358": "Czech",
    "FOODON_03544286": "42860 - herbal blend flavour (efsa foodex2)",
    "FOODON_03306521": "macadamia nut (whole, raw)",
    "FOODON_03544454": "44540 - starter cultures (efsa foodex2)",
    "FOODON_03302778": "soft drink base (dry)",
    "FOODON_00002648": "food scalding",
    "FOODON_03540431": "04310 - cassava leaves (efsa foodex2)",
    "FOODON_03306076": "lemon spread (food product)",
    "FOODON_03543214": "32140 - juice, cucumber (efsa foodex2)",
    "IAO_0000114": "has curation status",
    "FOODON_00001141": "wheat food product",
    "FOODON_03413651": "greenland cockle",
    "HANCESTRO_0340": "Uzbekistani",
    "NCBITaxon_233880": "Phyllanthaceae",
    "NCBITaxon_9359": "Dasypodidae",
    "FOODON_03305012": "pudding mix (powdered)",
    "NCBITaxon_210060": "Maranta arundinacea",
    "RO_0002323": "mereotopologically related to",
    "FOODON_03414595": "argan plant",
    "FOODON_03304663": "ground beef patty (raw)",
    "FOODON_03317622": "fruit (pickled)",
    "NCBITaxon_3608": "Rhamnaceae",
    "FOODON_03301956": "apple (caramel-coated)",
    "FOODON_03310638": "noodle (egg, dough)",
    "FOODON_03400886": "10000273 - wine - fortified (gs1 gpc)",
    "FOODON_03309918": "duckling mash",
    "FOODON_03542723": "27230 - other dairy concentrate (efsa foodex2)",
    "FOODON_03305623": "shrimp stuffed with deviled crab meat (breaded)",
    "FOODON_03401081": "10000216 - ice cream/ice novelties (shelf stable) (gs1 gpc)",
    "FOODON_03302777": "irish whiskey cake",
    "FOODON_03542753": "27530 - cheese, feta (efsa foodex2)",
    "FOODON_03301230": "sugar vinegar",
    "NCBITaxon_78525": "Argopecten gibbus",
    "HANCESTRO_0472": "Nauruan",
    "FOODON_03542633": "26330 - canned herring (efsa foodex2)",
    "CHEBI_26375": "pterins",
    "FOODON_03541397": "13970 - vanilla and similar- (efsa foodex2)",
    "FOODON_03412901": "chilean horse mackerel",
    "FOODON_03541614": "16140 - cinnamon rose (efsa foodex2)",
    "FOODON_03400768": "078  manufactured multi-ingredient cereal products (cp) (ccpr)",
    "FOODON_03541093": "10930 - peas (dry) and similar- (efsa foodex2)",
    "FOODON_00003079": "chinese yam plant",
    "FOODON_00002241": "skipjack tuna food product",
    "FOODON_03540331": "03310 - porridge water based (ready to eat) (efsa foodex2)",
    "FOODON_03413372": "brassica species",
    "FOODON_00002536": "potato waffle",
    "FOODON_03305209": "garlic dressing",
    "FOODON_03411735": "borage plant",
    "FOODON_03414552": "golden oyster mushroom",
    "PATO_0000383": "female",
    "FOODON_03510273": "northern plains food claim or use",
    "FOODON_03510039": "low fat food",
    "FOODON_03306744": "obsolete: liquid cow milk",
    "FOODON_03301385": "brussels sprout (whole, frozen)",
    "FOODON_03304969": "marmalade (nutritively sweetened)",
    "FOODON_03401773": "10006316 - soup additions (shelf stable) (gs1 gpc)",
    "FOODON_03543795": "37950 - single meal replacement for weight reduction (efsa foodex2)",
    "NCBITaxon_204141": "Ocimum americanum",
    "FOODON_03544265": "42650 - fish flavour (efsa foodex2)",
    "FOODON_03301387": "corn on the cob (canned)",
    "FOODON_03304638": "rattlesnake meat (raw)",
    "FOODON_03414147": "variegated scallop",
    "FOODON_03414769": "bushweed plant",
    "FOODON_03413955": "cunene horse mackerel",
    "NCBITaxon_233737": "Pouteria campechiana",
    "NCBITaxon_4479": "Poaceae",
    "FOODON_03543093": "30930 - vegetable fats and oils, edible (efsa foodex2)",
    "FOODON_03543587": "35870 - black locust infusion flowers (efsa foodex2)",
    "FOODON_03310474": "cream (pasteurized, sweetened)",
    "FOODON_03490308": "steel plate container tinned one side",
    "FOODON_03542890": "28900 - cheese, samsoe (efsa foodex2)",
    "FOODON_03303710": "egg sesame bread",
    "FOODON_03411254": "clover plant",
    "NCBITaxon_13396": "Carcharodon",
    "http://www.geneontology.org/formats/oboInOwl#hasSynonym": "has synonym",
    "FOODON_03315932": "baked good (fine)",
    "NCBITaxon_301959": "Mytilinae",
    "FOODON_03411350": "peach plant",
    "FOODON_03308811": "shrimpburger made from fish (frozen)",
    "FOODON_03544273": "42730 - ginger flavour (efsa foodex2)",
    "FOODON_00003435": "multi-component rice food product",
    "FOODON_03541225": "12250 - hemp seeds (efsa foodex2)",
    "FOODON_03311397": "shrimp (headless, raw, frozen, glazed)",
    "FOODON_03530168": "alcohol content 1-3%",
    "FOODON_03414071": "slender sunfish",
    "CHEBI_26948": "thiamine",
    "FOODON_03316736": "haddock fillet (quick-frozen)",
    "FOODON_03309222": "sauger pike (raw)",
    "CHEBI_140785": "alkylcob(III)alamin",
    "FOODON_03310584": "lime-flavored gelatin dessert",
    "FOODON_03315400": "custard mix",
    "FOODON_03316399": "garlic (chopped)",
    "FOODON_00003379": "food (not genetically-modified)",
    "FOODON_03307372": "grape wine vinegar",
    "FOODON_00002882": "beef short ribs",
    "FOODON_00003388": "food animal rearing",
    "FOODON_03401330": "cereal bar (eurofir)",
    "NCBITaxon_160963": "Acanthopagrus australis",
    "FOODON_03316983": "sprat pickled",
    "FOODON_03414388": "diphosphates",
    "FOODON_03412834": "antidesma plant",
    "FOODON_03400100": "pie, unsweetened, or pizza (us cfr)",
    "FOODON_03401376": "50261700 - fungi (gs1 gpc)",
    "FOODON_03302632": "butterfat (lipolyzed, deodorized)",
    "FOODON_03311707": "corn bran cereal",
    "FOODON_03400971": "10000284 - cereals products - ready to eat (shelf stable) (gs1 gpc)",
    "FOODON_03307382": "whey butter",
    "NCBITaxon_7776": "Gnathostomata <vertebrates>",
    "FOODON_03540830": "08300 - chinese chives (efsa foodex2)",
    "FOODON_03302372": "wheat germ bread",
    "FOODON_03311339": "frozen nondairy dessert, chocolate, chilzert",
    "FOODON_03302317": "wheat bread dough",
    "FOODON_03310604": "cream (pasteurized, high temperature, short time)",
    "FOODON_03304954": "mushroom soup (liquid)",
    "NCBITaxon_160715": "Epinephelus areolatus",
    "FOODON_03544099": "40990 - white sauces (efsa foodex2)",
    "FOODON_03543774": "37740 - ready-to-eat dairy-based meal for children (efsa foodex2)",
    "FOODON_03301200": "apricot (canned)",
    "NCBITaxon_3743": "Synsepalum dulcificum",
    "NCBITaxon_7524": "Hemiptera",
    "FOODON_03304635": "water chestnut (canned)",
    "NCBITaxon_221251": "Chrysophyllum cainito",
    "FOODON_03544163": "41630 - maize starch (efsa foodex2)",
    "FOODON_03540223": "02230 - mixture/mass for baumkuchen (efsa foodex2)",
    "NCBITaxon_174549": "Polygala senega",
    "NCBITaxon_43363": "Aesculus",
    "FOODON_03414784": "rhodamnia plant",
    "FOODON_00001233": "nut oil food product",
    "NCBITaxon_9895": "Bovidae",
    "FOODON_03541054": "10540 - chickpeas (without pods) (efsa foodex2)",
    "FOODON_03315144": "fish protein isolate",
    "FOODON_03303923": "green bean (french-style, frozen)",
    "FOODON_00003334": "serving size",
    "FOODON_03541038": "10380 - mung beans (without pods) (efsa foodex2)",
    "FOODON_03315988": "sweet-sour fish preserves",
    "FOODON_03411549": "caraway plant",
    "FOODON_03305203": "sugar maple cake mix",
    "FOODON_03310021": "fundu nut",
    "FOODON_03411738": "jicama plant",
    "FOODON_03307000": "imitation ice cream mix (artificially sweetened)",
    "PATO_0000069": "deviation(from_normal)",
    "CHEBI_24266": "gluconic acid",
    "ENVO_01001483": "surface of an astronomical body",
    "FOODON_03309861": "coconut (whole or parts)",
    "FOODON_03412032": "morel",
    "FOODON_03317196": "shrimp or prawn (canned)",
    "FOODON_03414750": "spiderling plant",
    "FOODON_03317099": "soft drink mix, powdered, energy-containing sweetener not added",
    "NCBITaxon_43861": "Spondias dulcis",
    "FOODON_03400421": "freezant (codex)",
    "FOODON_03316322": "fish product (boiled)",
    "FOODON_03309712": "chocolate-flavored syrup",
    "FOODON_03311202": "jellied fruit candy",
    "FOODON_03310341": "pumpkin leaf (raw)",
    "FOODON_03400271": "vegetable pickle (us cfr)",
    "FOODON_03310116": "seafood (raw)",
    "FOODON_03316892": "vegetable puree",
    "FOODON_03542743": "27430 - cheese, burrata (efsa foodex2)",
    "FOODON_03411649": "strawberry guava plant",
    "FOODON_03420181": "husk",
    "FOODON_03304487": "flour middlings",
    "NCBITaxon_79331": "Cordia",
    "FOODON_03301270": "olive (stuffed with minced pimiento)",
    "FOODON_03411626": "armadillo",
    "FOODON_03302578": "canola oil",
    "FOODON_03311022": "chinook salmon (canned)",
    "FOODON_03510059": "general label claim",
    "FOODON_03306092": "chicken salad",
    "FOODON_03414911": "puntarelle plant",
    "FOODON_03308300": "japanese chum salmon (canned)",
    "ENVO_01000018": "gravel",
    "FOODON_03401554": "10006836 - lingzhi mushrooms (gs1 gpc)",
    "ENVO_00000111": "forested area",
    "FOODON_03316389": "fruit-based jellying agent (liquid)",
    "FOODON_03307362": "green bean and mushroom",
    "FOODON_03310334": "bakers yeast",
    "FOODON_00003258": "strained yogurt",
    "FOODON_03420271": "sugar syrup or syrup solids",
    "FOODON_03302831": "fruit and nut cake (containing alcohol)",
    "FOODON_03412439": "monkey",
    "FOODON_03412317": "african mudfish",
    "FOODON_03400945": "10000164 - bread (perishable) (gs1 gpc)",
    "NCBITaxon_371729": "Palinurus charlestoni",
    "FOODON_03411049": "protein-producing plant",
    "FOODON_00001567": "animal meat primal cut",
    "FOODON_03303070": "citrus pulp",
    "FOODON_03309505": "fruit preserves (artificially sweetened)",
    "FOODON_00002969": "okazi tuber",
    "NCBITaxon_186745": "Scombrinae",
    "FOODON_03412182": "largemouth bass",
    "FOODON_03415086": "witch-hazel plant",
    "NCBITaxon_8193": "Zoarcidae",
    "FOODON_03542702": "27020 - yoghurt, goat milk, flavoured (efsa foodex2)",
    "FOODON_03301297": "red meat (raw)",
    "FOODON_03540074": "00740 - maize meal (efsa foodex2)",
    "CHEBI_16236": "ethanol",
    "FOODON_03316804": "spaghetti (enriched, with fortified protein)",
    "FOODON_03490177": "wood box",
    "FOODON_03540363": "03630 - italian corn salads (efsa foodex2)",
    "FOODON_03400162": "jelly candy (us cfr)",
    "FOODON_00001896": "garbanzo bean substance",
    "FOODON_03541891": "18910 - ratites carcase (efsa foodex2)",
    "FOODON_03307734": "angel food cake",
    "FOODON_00002367": "wood apple food product",
    "FOODON_03316751": "carrot (quick frozen)",
    "FOODON_03420139": "fruit, peel present, core, pit or seed removed",
    "FOODON_00002529": "masa",
    "FOODON_03414709": "fimbry plant",
    "NCBITaxon_1927087": "Annoneae",
    "FOODON_03541388": "13880 - white pepper (efsa foodex2)",
    "FOODON_03543008": "30080 - corn syrup (efsa foodex2)",
    "FOODON_00002310": "taro food product",
    "NCBITaxon_36606": "Cormus domestica",
    "FOODON_00002212": "rosemary food product",
    "FOODON_03311739": "obsolete: beans (canned)",
    "FOODON_03510213": "food allergen labelling",
    "NCBITaxon_135197": "Citrus junos",
    "NCBITaxon_3655": "Cucumis",
    "FOODON_03541661": "16610 - carambolas (efsa foodex2)",
    "FOODON_03541553": "15530 - other species and hybrids of genus rubus, not elsewhere mentioned (efsa foodex2)",
    "FOODON_03311541": "wheat cereal (cooked)",
    "CHEBI_4194": "D-hexose",
    "FOODON_03315478": "western cake",
    "FOODON_03310271": "buffalo milk (raw)",
    "FOODON_03308077": "crabmeat au gratin (dish)",
    "FOODON_03304780": "mutton curry",
    "FOODON_03490413": "cotton container",
    "FOODON_03411520": "tilefish",
    "NCBITaxon_51593": "Aponogeton",
    "PATO_0001894": "phenotypic sex",
    "CHEBI_62946": "ammonium sulfate",
    "FOODON_03303542": "pasteurized process cheese food with fruit or vegetable",
    "FOODON_03413658": "green mussel",
    "FOODON_03315630": "cow milk (semi-skimmed, flavored)",
    "FOODON_03311428": "haddock (frozen)",
    "FOODON_03530161": "sugar content (eurocode2)",
    "NCBITaxon_27771": "Limanda limanda",
    "FOODON_00002307": "swordfish food product",
    "HANCESTRO_0551": "genetically homogenous Irish",
    "FOODON_03401068": "10005224 - egg based products / meals - not ready to eat (frozen) (gs1 gpc)",
    "FOODON_03541885": "18850 - deer carcase (efsa foodex2)",
    "FOODON_00001663": "brazil nut food product",
    "CHEBI_36820": "ring assembly",
    "FOODON_03543100": "31000 - soya bean oil, refined (efsa foodex2)",
    "FOODON_03541682": "16820 - jambuls (efsa foodex2)",
    "NCBITaxon_16752": "Houttuynia cordata",
    "FOODON_03303384": "catfish (raw)",
    "FOODON_03306145": "flavoring extract",
    "FOODON_03415101": "couch grass plant",
    "FOODON_03316427": "plant fiber (compressed)",
    "CHEBI_33768": "titanium group molecular entity",
    "FOODON_03401875": "10005907 - sour cherries (gs1 gpc)",
    "FOODON_03412884": "alfonsino family",
    "FOODON_03544227": "42270 - celery flavour (efsa foodex2)",
    "FOODON_03311633": "collard greens (canned)",
    "FOODON_03411567": "bean plant",
    "FOODON_03302221": "beverage tablet (effervescent, naturally and artificially sweetened)",
    "FOODON_03305393": "papaya milk (freeze-dried)",
    "NCBITaxon_135761": "Maccullochella peelii",
    "FOODON_03414362": "ratite",
    "FOODON_03543626": "36260 - small-leaf linden infusion flowers (efsa foodex2)",
    "FOODON_03540368": "03680 - lollo rosso (efsa foodex2)",
    "FOODON_03412602": "fusilier family",
    "FOODON_03305224": "obsolete: glace fruit",
    "FOODON_03500056": "edible casing",
    "FOODON_03400914": "10000191 - dairy/dairy substitute based drinks - ready to drink (perishable) (gs1 gpc)",
    "FOODON_00002526": "hoisin sauce",
    "NCBITaxon_9718": "Pusa hispida",
    "NCBITaxon_13489": "Dicentrarchus labrax",
    "FOODON_00002943": "Jersey cattle",
    "NCBITaxon_504414": "Eriphia gonagra",
    "FOODON_03414072": "burrfish family",
    "NCBITaxon_586844": "Parupeneus cyclostomus",
    "FOODON_03306574": "chocolate-flavored drink (instant)",
    "FOODON_03317096": "fruit syrup (energy-containing sweeteners not added)",
    "FOODON_03543446": "34460 - tea powder ingredients and extracts (efsa foodex2)",
    "FOODON_03412095": "asian water buffalo",
    "FOODON_03414465": "obsolete: chordate",
    "FOODON_03460298": "clotting enzyme addition process",
    "CHEBI_63036": "potassium dihydrogen phosphate",
    "FOODON_03400797": "preserved meat (eurofir)",
    "FOODON_03542900": "29000 - cheese, manchego (efsa foodex2)",
    "RO_0000080": "quality of",
    "FOODON_03308524": "sardine in soybean oil (canned)",
    "FOODON_03305016": "imitation jelly (artificially sweetened)",
    "ENVO_01000001": "mud",
    "FOODON_03315262": "obsolete: cheese product substitute or imitation",
    "FOODON_03303036": "chicken giblet gravy",
    "FOODON_03542300": "23000 - chinook salmon (efsa foodex2)",
    "ENVO_01000752": "area of barren land",
    "FOODON_03311078": "infant formula (soy-based, liquid, concentrated)",
    "FOODON_03317118": "potato (peeled, raw)",
    "FOODON_03415133": "ground ivy plant",
    "GAZ_00002852": "Mexico",
    "FOODON_03543246": "32460 - juice concentrate, apple (efsa foodex2)",
    "HANCESTRO_0579": "Jingpo Chinese",
    "FOODON_03305875": "mint jelly",
    "FOODON_03306426": "water (bottled, minerals added)",
    "FOODON_03510173": "no vitamin or mineral added claim or use",
    "FOODON_03311161": "clam (asiatic, raw)",
    "FOODON_03317126": "potato flakes (granulated and powdered)",
    "NCBITaxon_71412": "Penaeus merguiensis",
    "FOODON_03543647": "36470 - pimpernel infusion roots (efsa foodex2)",
    "FOODON_03315730": "citrus oil",
    "NCBITaxon_29150": "Scomber australasicus",
    "FOODON_03305368": "chocolate coating (food product)",
    "FOODON_03306557": "cooking oil (unsaturated)",
    "FOODON_03305797": "frozen dessert made from vegetable fat",
    "CHEBI_26764": "steroid hormone",
    "NCBITaxon_115429": "Pseudupeneus prayensis",
    "FOODON_03542944": "29440 - milkshakes (efsa foodex2)",
    "NCBITaxon_999584": "Mammea africana",
    "FOODON_03440018": "partially heat-treated",
    "FOODON_03307843": "tomato (sliced, frozen)",
    "FOODON_03542299": "22990 - cherry salmon (efsa foodex2)",
    "FOODON_03304769": "italian bread (enriched)",
    "FOODON_03303745": "rock candy",
    "FOODON_03542192": "21920 - meat based spreadable-textured specialities (efsa foodex2)",
    "FOODON_03317655": "hen egg jam",
    "FOODON_03305646": "imitation water ice",
    "FOODON_03309772": "liver (whole, raw)",
    "HANCESTRO_0538": "Bissau-Guinean",
    "NCBITaxon_722570": "Trinectes inscriptus",
    "FOODON_03308197": "clam (ocean quahog, raw)",
    "NCBITaxon_81361": "Aulopidae",
    "FOODON_03540946": "09460 - garlic puree (efsa foodex2)",
    "FOODON_03401432": "10005924 - boysenberries (gs1 gpc)",
    "FOODON_00001306": "Hom dong",
    "FOODON_03307451": "codfish stick (frozen)",
    "NCBITaxon_21472": "Gentianaceae",
    "NCBITaxon_6455": "Haliotis cracherodii",
    "FOODON_03530222": "anisakis infestation",
    "NCBITaxon_30724": "Clupea pallasii",
    "UO_0000111": "energy unit",
    "FOODON_00001039": "cured meat food product",
    "FOODON_03315504": "tarako",
    "NCBITaxon_327815": "Acanthistius",
    "FOODON_03541879": "18790 - pig carcase (efsa foodex2)",
    "CHEBI_35724": "carbohydrate sulfate",
    "FOODON_03400210": "cake (us cfr)",
    "FOODON_03542834": "28340 - cheese, morski (efsa foodex2)",
    "FOODON_03540092": "00920 - wheat wholemeal flour (efsa foodex2)",
    "FOODON_03413052": "calcium stearoyl-2-lactylate",
    "FOODON_03317486": "fruit preparation (canned)",
    "NCBITaxon_128608": "Cinnamomum verum",
    "FOODON_03315309": "beverage mix (nonalcoholic)",
    "FOODON_03542040": "20400 - horse kidney (efsa foodex2)",
    "FOODON_03311873": "cheesecake batter",
    "FOODON_03411446": "obsolete: escarole plant",
    "FOODON_03490373": "polymethylmethacrylate container",
    "NCBITaxon_6645": "Octopus vulgaris",
    "FOODON_03306061": "malted wheat (coarse ground)",
    "FOODON_03510220": "food allergen labelling about milk and products thereof, including lactose",
    "FOODON_00003396": "cumin seed (whole)",
    "FOODON_03317316": "pork product (cured)",
    "FOODON_03401516": "10006312 - coffee substitutes - ready to drink (gs1 gpc)",
    "FOODON_03307868": "japanese green tea (dry)",
    "FOODON_03304547": "harpago tea (dry)",
    "FOODON_03306353": "breakfast beverage (dry, instant)",
    "FOODON_03540285": "02850 - fried dough sweet (efsa foodex2)",
    "FOODON_03542215": "22150 - barbs (efsa foodex2)",
    "FOODON_03412591": "hammerhead shark family",
    "FOODON_03316248": "filling for desserts",
    "FOODON_03541621": "16210 - azaroles (efsa foodex2)",
    "NCBITaxon_334908": "Larimichthys polyactis",
    "FOODON_03305423": "coffee (instant, spray-dried)",
    "NCBITaxon_30988": "Anoplopomatidae",
    "HANCESTRO_0514": "Sao Tomean",
    "FOODON_03540016": "00160 - common millet and similar- (efsa foodex2)",
    "FOODON_03530262": "obsolete: food content range, other",
    "FOODON_03412883": "alfonsinos",
    "FOODON_03541867": "18670 - canned or jarred pear (efsa foodex2)",
    "FOODON_00003123": "oregon yampa plant",
    "FOODON_03450016": "boiling in large amount of liquid",
    "FOODON_03490219": "pail",
    "FOODON_03400131": "poultry-based sausage or luncheon meat (us cfr)",
    "FOODON_03543481": "34810 - blackcurrant infusion leaves (efsa foodex2)",
    "FOODON_03307287": "water (processed)",
    "FOODON_03303508": "brie cheese",
    "FOODON_03414594": "greylag goose",
    "FOODON_03543135": "31350 - herring oil (efsa foodex2)",
    "FOODON_03301296": "fruit juice (liquid)",
    "NCBITaxon_16719": "Juglans nigra",
    "FOODON_03316660": "oil (refined)",
    "FOODON_03317589": "dietary food supplement, coated tablet form",
    "FOODON_03401079": "10000312 - desserts (shelf stable) (gs1 gpc)",
    "FOODON_03415094": "pine family",
    "FOODON_03307303": "ginger wine",
    "FOODON_03305126": "cream of asparagus soup",
    "NCBITaxon_44929": "Gnetum africanum",
    "FOODON_03412679": "ruff family",
    "CHEBI_33888": "cobalt molecular entity",
    "FOODON_03306902": "peanut (whole, oil-roasted)",
    "FOODON_03542583": "25830 - bullfrog, indian (efsa foodex2)",
    "FOODON_00002721": "food dehulling process",
    "FOODON_00003287": "peppercorn food product",
    "FOODON_03317387": "corn (whole)",
    "NCBITaxon_60419": "Castanea mollissima",
    "CHEBI_63018": "potassium L-tartrate",
    "NCBITaxon_374122": "Guaiacum officinale",
    "FOODON_03412855": "chlamydobacteriales",
    "FOODON_03316614": "marmalade sweets (food product)",
    "FOODON_00002058": "nondairy dessert food product",
    "NCBITaxon_7953": "Cyprinidae",
    "GAZ_00003767": "Trinidad and Tobago",
    "FOODON_00002034": "milk beverage analog",
    "NCBITaxon_8001": "Pangasius pangasius",
    "CHEBI_38443": "1-benzopyran",
    "FOODON_03304878": "tea mix (instant)",
    "FOODON_03310156": "obsolete: linseed meal",
    "FOODON_03302974": "grated cheese (lowfat)",
    "FOODON_00001927": "grape preserve or jam food product",
    "FOODON_03540891": "08910 - hoary basil (efsa foodex2)",
    "FOODON_03420214": "nut milk",
    "FOODON_03301111": "cookie dough (frozen)",
    "FOODON_03316696": "animal and vegetable fat product (mixed)",
    "FOODON_03414678": "scrub cherry plant",
    "FOODON_03315879": "hen egg mix (albumen and yolk, dried)",
    "NCBITaxon_57935": "Rosa majalis",
    "FOODON_00002173": "powdered cow milk food product",
    "FOODON_03303757": "candy (filled, fruit-flavored)",
    "FOODON_03544152": "41520 - mixed and other not listed condiments (efsa foodex2)",
    "FOODON_03311051": "infant formula (fortified)",
    "FOODON_03543665": "36650 - jengkols (efsa foodex2)",
    "NCBITaxon_82655": "Conger conger",
    "FOODON_03306835": "pawpaw (raw)",
    "CHEBI_23456": "cyclodextrin",
    "FOODON_03542058": "20580 - goat edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "FOODON_00002279": "stone pine product flavoring",
    "OBI_0200181": "center calculation data transformation",
    "FOODON_03413582": "isada krill",
    "NCBITaxon_8492": "Archosauria",
    "GAZ_00001091": "Equatorial Guinea",
    "FOODON_03412743": "chickasaw plum plant",
    "FOODON_03540002": "00020 - cereals and cereal primary derivatives (efsa foodex2)",
    "FOODON_03543181": "31810 - juice, citrus (efsa foodex2)",
    "NCBITaxon_74632": "Rosa gallica",
    "FOODON_03415110": "hybrid rice plant",
    "FOODON_03305567": "hamburger pattie (precooked, in a roll, frozen)",
    "FOODON_03301115": "soy sauce",
    "FOODON_03400428": "leavening agent (codex)",
    "FOODON_03490129": "paperboard tray with wrapper",
    "FOODON_03311404": "calf liver (raw)",
    "NCBITaxon_7984": "Misgurnus fossilis",
    "NCBITaxon_303943": "Carcharhinus signatus",
    "NCBITaxon_59761": "Panulirus longipes",
    "FOODON_03543777": "37770 - ready-to-eat vegetable-based meal for children (efsa foodex2)",
    "FOODON_03306468": "deer meat (frozen)",
    "FOODON_03413434": "snake gourd plant",
    "FOODON_03414928": "ervil plant",
    "NCBITaxon_13364": "Bowenia",
    "FOODON_03412710": "megrim",
    "FOODON_03315285": "obsolete: nutritional food, special",
    "FOODON_00002754": "food (comminuted)",
    "FOODON_03541129": "11290 - brazil nuts (efsa foodex2)",
    "NCBITaxon_27769": "Sphyraenidae",
    "FOODON_03450022": "steaming with pressure",
    "FOODON_03490125": "plastic tray or pan, paper wrapping",
    "FOODON_00002956": "game meat",
    "FOODON_03544130": "41300 - vegetables-based cooked sauce (efsa foodex2)",
    "NCBITaxon_196072": "Sardinella maderensis",
    "FOODON_03310602": "ravioli in brine",
    "FOODON_00001707": "cephalopod food product",
    "GAZ_00002721": "Russia",
    "FOODON_03317505": "meat product (minced or diced, canned)",
    "FOODON_00001821": "doughnut food product",
    "FOODON_03400908": "10000309 - juice drinks - not ready to drink (shelf stable) (gs1 gpc)",
    "FOODON_03543661": "36610 - herbal infusion extracts (liquid) (efsa foodex2)",
    "FOODON_00002458": "black currant food product",
    "CHEBI_38631": "aminoalkylindole",
    "FOODON_03315041": "confections and novelties (stick type, frozen)",
    "FOODON_03307931": "salt-rising bread starter",
    "FOODON_00001247": "mate food product",
    "FOODON_03542566": "25660 - miscellaneous marine molluscs (efsa foodex2)",
    "FOODON_03401669": "10005795 - land snail - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03303194": "corn flour (stone ground)",
    "FOODON_03413852": "whitehead's round herring",
    "FOODON_03541451": "14510 - indian sweet limes (efsa foodex2)",
    "FOODON_03415046": "persian lime plant",
    "NCBITaxon_37690": "Citrus trifoliata",
    "FOODON_03540488": "04880 - turnip tops (efsa foodex2)",
    "FOODON_03540732": "07320 - comon nettle roots (efsa foodex2)",
    "NCBITaxon_117781": "Apium graveolens Dulce Group",
    "FOODON_03541329": "13290 - capers buds (efsa foodex2)",
    "ENVO_00000020": "lake",
    "FOODON_03316117": "pulse (canned)",
    "FOODON_03542455": "24550 - sharks (efsa foodex2)",
    "FOODON_03542857": "28570 - cheese, torta del casar (efsa foodex2)",
    "NCBITaxon_8254": "Paralichthys",
    "FOODON_03541342": "13420 - cinnamon bark (efsa foodex2)",
    "FOODON_03412507": "enokitake",
    "FOODON_03304785": "shui sen tea (dry)",
    "FOODON_03412589": "gulf coney",
    "FOODON_03302775": "whiskey",
    "FOODON_03540190": "01900 - dried stuffed durum pasta (efsa foodex2)",
    "GAZ_00004431": "State of Missouri",
    "FOODON_03401792": "10006108 - cassava (gs1 gpc)",
    "FOODON_03401581": "10006052 - fennel  (subspecies dulce) (gs1 gpc)",
    "FOODON_03414587": "obsolete: unclassified bacteria",
    "FOODON_03400790": "egg or egg product (eurofir)",
    "FOODON_03306547": "ginger nectar",
    "FOODON_03543335": "33350 - beer, regular (efsa foodex2)",
    "FOODON_03306494": "mushroom powder",
    "NCBITaxon_143308": "Harpadontinae",
    "FOODON_03414299": "spinu sowthistle plant",
    "NCBITaxon_8009": "Esox",
    "FOODON_03306144": "imitation flavoring",
    "FOODON_03400422": "fumigant (codex)",
    "FOODON_03308728": "tuna in jelly (canned)",
    "FOODON_00001981": "kale vegetable food product",
    "CHEBI_27570": "histidine",
    "FOODON_03543139": "31390 - cow milk fat (not emulsified) (efsa foodex2)",
    "FOODON_03540307": "03070 - puddings based on cereal products and/or nuts/fruits and similar (efsa foodex2)",
    "FOODON_00002149": "plant relish food product",
    "FOODON_03304267": "spaghetti in tomato and cheese sauce",
    "FOODON_03307688": "imitation hollandaise sauce",
    "FOODON_03540908": "09080 - aztec sweet herb (efsa foodex2)",
    "FOODON_03540445": "04450 - chards and similar- (efsa foodex2)",
    "FOODON_03542247": "22470 - african catfish (efsa foodex2)",
    "FOODON_03308502": "olive (stuffed)",
    "FOODON_03308365": "northern lobster (raw)",
    "FOODON_03543959": "39590 - pasta-based dishes, uncooked (efsa foodex2)",
    "FOODON_03302232": "imitation strawberry carbonated beverage (artificially sweetened)",
    "FOODON_03311393": "potato patty (frozen)",
    "FOODON_03315562": "wine (spiced, fortified)",
    "FOODON_03306383": "imitation cherry-flavored orange marmalade",
    "CHEBI_33447": "phospho sugar",
    "FOODON_03305022": "dietetic topping",
    "FOODON_03542803": "28030 - cheese, caerphilly (efsa foodex2)",
    "FOODON_03307745": "dairy topping, whipped",
    "FOODON_03540139": "01390 - pizza base, cooked (efsa foodex2)",
    "CHEBI_23042": "carotene",
    "FOODON_03309562": "frankfurter on a stick batter-dipped cooked",
    "NCBITaxon_2806": "Florideophyceae",
    "FOODON_03490159": "paperboard or paper container",
    "FOODON_03317130": "obsolete: blood",
    "FOODON_03401855": "10006137 - bamboo shoots (gs1 gpc)",
    "FOODON_03400164": "dairy product (us cfr)",
    "FOODON_03305748": "cranberry juice concentrate",
    "FOODON_00002224": "sauger food product",
    "FOODON_03310339": "cassava leaf (raw)",
    "FOODON_03305758": "wheat bread (thin-sliced)",
    "FOODON_03414364": "northern bobwhite",
    "NCBITaxon_31101": "Oreosomatidae",
    "FOODON_03544023": "40230 - ceasar salad (efsa foodex2)",
    "CHEBI_24432": "biological role",
    "FOODON_03543107": "31070 - almond oil (efsa foodex2)",
    "NCBITaxon_36603": "Chaenomeles",
    "FOODON_03315073": "dessert prepared from dry mix",
    "FOODON_03544271": "42710 - gianduia flavour (efsa foodex2)",
    "FOODON_03413491": "eastern king prawn",
    "FOODON_03301186": "mustard (prepared)",
    "FOODON_03311664": "lamb (roasted)",
    "FOODON_03414726": "yam daisy plant",
    "FOODON_03412015": "mexican ground cherry plant",
    "FOODON_03544016": "40160 - mixed vegetables soup, clear (efsa foodex2)",
    "GAZ_00005908": "Territory of Norfolk Island",
    "FOODON_03309743": "duckling",
    "FOODON_03400762": "066  teas (dt) (ccpr)",
    "FOODON_03401090": "10000296 - grain based products / meals - not ready to eat - savoury (frozen) (gs1 gpc)",
    "CHEBI_26127": "phytylnaphthoquinone",
    "PATO_0000048": "hardness",
    "FOODON_03309324": "new zealand pompano (raw)",
    "FOODON_03450005": "food baking",
    "FOODON_03301589": "sugar beet pulp",
    "FOODON_03316618": "vegetable puree (for further processing)",
    "CHEBI_76224": "aromatic ketone",
    "FOODON_03306322": "apple jelly mint-flavored mint leaves added",
    "FOODON_00001025": "camembert cheese food product",
    "FOODON_03401162": "10000137 - aquatic plants unprepared/unprocessed (perishable) (gs1 gpc)",
    "FOODON_03544449": "44490 - preparations for food flavouring (efsa foodex2)",
    "FOODON_03544199": "41990 - beef flavour (efsa foodex2)",
    "FOODON_00002936": "asafoetida",
    "FOODON_03415129": "filed horsetail plant",
    "FOODON_03542021": "20210 - rabbit liver (efsa foodex2)",
    "FOODON_03315808": "confection (soft-centered)",
    "FOODON_03542220": "22200 - carp, common (efsa foodex2)",
    "FOODON_03530253": "organic plant cultivation",
    "CHEBI_27432": "alpha-linolenic acid",
    "FOODON_03302304": "cassava (whole, raw)",
    "NCBITaxon_129043": "Cololabis saira",
    "NCBITaxon_7713": "Ascidiacea",
    "FOODON_03315911": "cereal based food gluten free",
    "FOODON_03411504": "breadfruit plant",
    "CHEBI_35479": "alkali metal salt",
    "FOODON_00002383": "mizu y\u014dkan",
    "NCBITaxon_191812": "Somniosus",
    "GAZ_00002943": "Republic of Ireland",
    "FOODON_03411743": "red algae",
    "NCBITaxon_301703": "Annona glabra",
    "NCBITaxon_147949": "Micropterus dolomieu",
    "NCBITaxon_1489894": "Scombriformes",
    "FOODON_03309268": "rex sole (raw)",
    "FOODON_03544102": "41020 - cream sauce (efsa foodex2)",
    "FOODON_03413128": "lactic acid esters of mono- and diglycerides of fatty acids",
    "FOODON_03308235": "langostino amarillo (raw)",
    "FOODON_03411385": "collard plant",
    "FOODON_00003115": "pine nut food product",
    "HANCESTRO_0006": "South Asian",
    "CHEBI_2877": "aspartame",
    "FOODON_03412490": "palometa",
    "FOODON_03302635": "butter-flavored roll",
    "NCBITaxon_94231": "Epinephelus",
    "FOODON_03414923": "peach palm plant",
    "FOODON_00002110": "green or red pepper pickle food product",
    "FOODON_03413956": "green-back horse mackerel",
    "NCBITaxon_8111": "Perciformes",
    "FOODON_03510095": "vitamin- or mineral-related claim or use",
    "FOODON_03315903": "goat milk (powdered, partly skimmed)",
    "FOODON_03315313": "pudding mix (sugar-based)",
    "FOODON_03411320": "pecan tree",
    "FOODON_03305164": "corn muffin mix",
    "FOODON_03309762": "pink grapefruit juice",
    "FOODON_03305064": "cow whey",
    "FOODON_03303634": "cola carbonated beverage (caffeine-free)",
    "FOODON_03542775": "27750 - cheese, dunbarra (efsa foodex2)",
    "FOODON_00002271": "squash food product",
    "FOODON_03304881": "cardamom seed (candy-coated)",
    "NCBITaxon_146143": "Decapterus macarellus",
    "FOODON_03542773": "27730 - cheese, chevre mould ripened (efsa foodex2)",
    "FOODON_03543163": "31630 - juice, apple-cherry (efsa foodex2)",
    "FOODON_03411302": "fig plant",
    "FOODON_03307459": "filled milk (dried)",
    "FOODON_03304231": "pierogie (cottage cheese-filled)",
    "FOODON_03311693": "tomato (dried in sunflower oil)",
    "FOODON_03540449": "04490 - other spinaches and similar leaves (efsa foodex2)",
    "FOODON_03411447": "persimmon plant",
    "NCBITaxon_34773": "Alosa sapidissima",
    "NCBITaxon_49225": "Triticum dicoccon",
    "NCBITaxon_8049": "Gadus morhua",
    "FOODON_03530083": "processed in plastic container",
    "CHEBI_3992": "cyclic ketone",
    "FOODON_03317541": "confectionery (glucose-syrup based)",
    "FOODON_03304329": "pineapple beverage syrup",
    "FOODON_03544171": "41710 - maltodextrins and similars (efsa foodex2)",
    "FOODON_03490392": "metallized polymer container",
    "FOODON_03411329": "grape plant",
    "FOODON_03540367": "03670 - cutting lettuces (efsa foodex2)",
    "NCBITaxon_13894": "Cocos nucifera",
    "FOODON_03412542": "true goby",
    "GAZ_00003924": "Sri Lanka",
    "HANCESTRO_0414": "Martinican",
    "FOODON_03400874": "GS1 Global Product Classification (GPC)",
    "FOODON_00002416": "food canning process",
    "FOODON_03307028": "pork rind (cooked in vegetable fat)",
    "FOODON_03414715": "wild parsnip plant",
    "FOODON_03530087": "status of food name",
    "FOODON_03308027": "grouper (raw)",
    "FOODON_00003076": "daikon (whole, raw)",
    "FOODON_03308336": "river herring (canned)",
    "FOODON_00003362": "chicken thigh (with bone)",
    "FOODON_03412557": "mulato pepper plant",
    "FOODON_03530066": "grade e, europe",
    "FOODON_03543090": "30900 - granita (efsa foodex2)",
    "FOODON_03401572": "10006071 - burnet saxifrage (gs1 gpc)",
    "FOODON_03311240": "margarine (diet, soft)",
    "PATO_0001899": "decreased circumference",
    "FOODON_03413972": "australian bonito",
    "FOODON_03311262": "sablefish smoked",
    "NCBITaxon_8192": "Zoarcales",
    "FOODON_03414850": "banteng",
    "FOODON_03311342": "spanish peanut (raw, ground)",
    "FOODON_03311585": "herbal tea",
    "FOODON_03400695": "05  bakery products (efg)",
    "FOODON_03412831": "mountain apple plant",
    "FOODON_03316982": "beer (low alcohol)",
    "FOODON_00001895": "garlic food product",
    "FOODON_03310972": "sturgeon raw",
    "FOODON_03316486": "cake concentrates",
    "FOODON_03316215": "meat product (cured, dried, non-heat treated)",
    "FOODON_03306151": "lime juice (reconstituted)",
    "FOODON_03316492": "seasoning product (concentrate, loose)",
    "FOODON_03543654": "36540 - ginseng infusion roots (efsa foodex2)",
    "FOODON_00002624": "Gew\u00fcrztraminer grape plant",
    "FOODON_03305522": "scallop (frozen)",
    "FOODON_03400911": "10000311 - stimulants/energy drinks - not ready to drink (gs1 gpc)",
    "FOODON_03544133": "41330 - chutneys (efsa foodex2)",
    "FOODON_03490212": "edible container",
    "FOODON_03470004": "obsolete: preservation by other method",
    "GAZ_00004432": "State of Louisiana",
    "FOODON_03544358": "43580 - raisins flavour (efsa foodex2)",
    "FOODON_03510200": "no pork added claim",
    "FOODON_03305389": "orange juice (frozen)",
    "FOODON_03311676": "corn (sweet, frozen)",
    "FOODON_03304468": "imitation half and half",
    "FOODON_03420112": "pod with seeds removed",
    "FOODON_03541222": "12220 - gold of pleasure seeds and similar- (efsa foodex2)",
    "FOODON_03309892": "palm kernel oil press cake",
    "FOODON_00003385": "local food",
    "FOODON_03543300": "33000 - soft drink, flavoured, no fruit (efsa foodex2)",
    "FOODON_03543743": "37430 - fennel infusion (efsa foodex2)",
    "FOODON_03414946": "batavia lettuce plant",
    "FOODON_00001968": "imitation fruit juice",
    "FOODON_03311785": "valencia peanut (whole, raw)",
    "FOODON_03307280": "feta cheese",
    "FOODON_03306851": "potato granules (dehydrated)",
    "NCBITaxon_283210": "Malus pumila",
    "FOODON_00003122": "oregon yampah root",
    "FOODON_03542259": "22590 - characins (efsa foodex2)",
    "FOODON_03543628": "36280 - silver linden infusion flowers (efsa foodex2)",
    "FOODON_03415002": "nasturtium plant",
    "FOODON_03401298": "dietary supplement",
    "FOODON_03411411": "needlefish",
    "FOODON_03302767": "pound cake",
    "FOODON_03315916": "drink powder",
    "FOODON_03411618": "black raspberry plant",
    "FOODON_03530270": "pink flesh",
    "NCBITaxon_7998": "Ictalurus punctatus",
    "FOODON_00002562": "chocolate brownie",
    "FOODON_00001761": "condiment sauce",
    "NCBITaxon_476919": "Osmerus mordax dentex",
    "FOODON_03309108": "milkfish (raw)",
    "FOODON_03306338": "pasta (canned)",
    "FOODON_03401284": "USDA SR beverages (1400)",
    "NCBITaxon_3009": "Fucales",
    "FOODON_03401756": "10006190 - square sweet peppers (blunt) (gs1 gpc)",
    "FOODON_03307282": "fruit syrup with alcohol",
    "FOODON_03530250": "chlorinated biphenyl",
    "FOODON_03540581": "05810 - pearl onion (efsa foodex2)",
    "FOODON_00002453": "apple (raw)",
    "FOODON_03542603": "26030 - insects (efsa foodex2)",
    "FOODON_03540379": "03790 - land cresses and similar- (efsa foodex2)",
    "FOODON_03412173": "scaled sardine",
    "FOODON_03414219": "common quince plant",
    "ENVO_00002186": "contaminated water",
    "FOODON_03304700": "lowfat cow milk (sterilized, long-life, nonrefrigerated)",
    "FOODON_03543920": "39200 - sandwich with processed meat topping/filling (efsa foodex2)",
    "FOODON_03400993": "10000002 - fruit - unprepared/unprocessed (frozen) (gs1 gpc)",
    "FOODON_03302794": "tomato catsup (no salt added)",
    "FOODON_03414250": "japanese beech plant",
    "FOODON_00001200": "cowpea (pulse) food product",
    "CHEBI_46430": "(-)-alpha-tocopherol",
    "FOODON_00001800": "dairy dessert food product",
    "FOODON_03317252": "fungi (edible, frozen)",
    "FOODON_03401023": "obsolete: 10000011 - meat/poultry/game/batrachian - unprepared/unprocessed (shelf stable) (gs1 gpc)",
    "FOODON_03401861": "10006136 - palm hearts (gs1 gpc)",
    "FOODON_03400995": "10000003 - fruit - unprepared/unprocessed (shelf stable) (gs1 gpc)",
    "FOODON_03460137": "demineralizing process",
    "FOODON_03311690": "garlic in water",
    "GAZ_00006922": "The Seychelles",
    "FOODON_03412050": "devil's claw plant",
    "FOODON_00001239": "vegetable rennet food product",
    "FOODON_03401831": "10000619 - seasonings/preservatives/extracts variety packs (gs1 gpc)",
    "FOODON_03401309": "dietary supplement, metabolite, constituent, extract or isolate",
    "FOODON_03309835": "taro leaf (whole, raw)",
    "FOODON_03308693": "fish pudding",
    "CHEBI_32159": "sucralose",
    "NCBITaxon_7904": "Acipenser transmontanus",
    "FOODON_03430110": "semiliquid with solid pieces",
    "CHEBI_31206": "ammonium chloride",
    "FOODON_03401840": "10005822 - caramel/toffee apples (gs1 gpc)",
    "FOODON_03400771": "084  crustaceans, processed (sc) (ccpr)",
    "CHEBI_35962": "sorbic acid",
    "FOODON_03543113": "31130 - coconut oil/fat (efsa foodex2)",
    "FOODON_03414036": "northern wolffish",
    "NCBITaxon_3329": "Picea abies",
    "NCBITaxon_3705": "Brassica",
    "FOODON_03309066": "hake fillet (breaded)",
    "FOODON_03310960": "soft drink (artificially sweetened)",
    "FOODON_03412577": "oreo dory",
    "FOODON_03317348": "poultry (cured)",
    "FOODON_03304057": "soup mix (dry)",
    "NCBITaxon_4305": "Celastraceae",
    "FOODON_03316415": "taffy hard",
    "FOODON_00002147": "food product by consumer group",
    "FOODON_03308904": "indian ocean flounder (raw)",
    "FOODON_03411519": "wolffish",
    "CHEBI_36586": "carbonyl compound",
    "NCBITaxon_1874405": "Lithospermeae",
    "FOODON_03401609": "10006424 - lollo bionda (gs1 gpc)",
    "FOODON_03544334": "43340 - orange flavour (efsa foodex2)",
    "FOODON_03530231": "hazard 3",
    "FOODON_03308568": "shrimp (peeled, cooked, frozen)",
    "NCBITaxon_28697": "Cepphus grylle",
    "FOODON_00001688": "cashew nut food product",
    "FOODON_03317091": "sauce powder",
    "GAZ_00003952": "Dominican Republic",
    "FOODON_03544447": "44470 - preparations for gelling home-made food (efsa foodex2)",
    "FOODON_00001941": "haddock food product",
    "UBERON_0000945": "stomach",
    "FOODON_03543567": "35670 - mountain tea (efsa foodex2)",
    "GAZ_00005070": "State of Nebraska",
    "FOODON_03307060": "oyster-flavored sauce",
    "FOODON_03544109": "41090 - barbecue or steak sauces (efsa foodex2)",
    "FOODON_00001272": "zebra milk beverage",
    "FOODON_03540496": "04960 - portuguese kales (efsa foodex2)",
    "FOODON_03309401": "chicken soup with matzo balls",
    "FOODON_03310685": "gaspergou raw",
    "FOODON_03544061": "40610 - mixed herbs and spices (efsa foodex2)",
    "NCBITaxon_114289": "Scorzonera hispanica",
    "FOODON_03401827": "10006323 - tomato ketchup/ketchup substitutes (frozen) (gs1 gpc)",
    "NCBITaxon_6685": "Penaeidae",
    "FOODON_03316174": "garlic pulp",
    "FOODON_03401717": "10006434 - jambolan (gs1 gpc)",
    "NCBITaxon_192602": "Trachurus murphyi",
    "FOODON_03308215": "abalone (raw)",
    "NCBITaxon_7864": "Chimaeriformes",
    "FOODON_03316505": "beverage concentrate (powdered)",
    "FOODON_03305413": "whipping cream (sterilized)",
    "FOODON_03540619": "06190 - peas (with pods) and similar- (efsa foodex2)",
    "FOODON_03541977": "19770 - pheasant fresh meat (efsa foodex2)",
    "FOODON_03316481": "fruit juice (raw, semi-finished)",
    "FOODON_03413014": "beta-apo-8'-carotenal (c 30)",
    "FOODON_03302888": "oatmeal (instant, dry)",
    "FOODON_03311039": "hen egg liquid (shell off)",
    "FOODON_03309904": "grain mash",
    "GAZ_00001097": "Botswana",
    "FOODON_03541806": "18060 - jam, strawberries (efsa foodex2)",
    "FOODON_03302618": "butter (hydrogenated)",
    "FOODON_00001796": "cultural food product",
    "FOODON_03543074": "30740 - marshmallow mass (efsa foodex2)",
    "NCBITaxon_51371": "Todarodes filippovae",
    "FOODON_03412922": "ficus spp. plant",
    "NCBITaxon_195624": "Limanda aspera",
    "FOODON_03540522": "05220 - rice sprouts (efsa foodex2)",
    "FOODON_03413328": "date plum plant",
    "FOODON_00002502": "ham food product",
    "NCBITaxon_316134": "Seriolella caerulea",
    "FOODON_03302265": "beverage syrup concentrate",
    "FOODON_03543540": "35400 - shepherd\u0092s purse infusion leaves (efsa foodex2)",
    "FOODON_03415077": "common marshmallow plant",
    "FOODON_03420249": "seed shell",
    "FOODON_03412211": "red king crab",
    "FOODON_00003074": "sweet rowanberry",
    "NCBITaxon_183824": "Eucalyptus gamophylla",
    "FOODON_03413720": "ruvo kale plant",
    "FOODON_00001841": "infant formula with corn syrup",
    "FOODON_03317504": "mostarda di frutta",
    "FOODON_03308092": "sardine in tomato sauce (canned)",
    "FOODON_03414986": "spiritweed plant",
    "NCBITaxon_238709": "Atherina hepsetus",
    "ENVO_00002001": "waste water",
    "FOODON_03400796": "offal (eurofir)",
    "FOODON_03401758": "10005948 - american persimmon (gs1 gpc)",
    "FOODON_03540813": "08130 - p\u00e9rigord black truffles (efsa foodex2)",
    "FOODON_03540797": "07970 - shiitake (efsa foodex2)",
    "FOODON_03543682": "36820 - juniper (infusion bark, wood, shoots) (efsa foodex2)",
    "FOODON_03401346": "50251800 - pitayas (gs1 gpc)",
    "FOODON_03542196": "21960 - pate, chicken liver (efsa foodex2)",
    "NCBITaxon_3499": "Urticaceae",
    "HANCESTRO_0554": "Silk Road founder",
    "FOODON_03542686": "26860 - whey, sour (efsa foodex2)",
    "FOODON_03401672": "10006285 - moose/elk - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03543780": "37800 - cereals with an added high protein food which have to be reconstituted with water or other protein-free liquid (efsa foodex2)",
    "FOODON_03411279": "kola tree",
    "FOODON_03317003": "black pepper powder",
    "FOODON_03308535": "spiny lobster tail (raw)",
    "NCBITaxon_32084": "Dennstaedtiaceae",
    "FOODON_03311210": "almond (dry, roasted)",
    "FOODON_00002035": "milk dessert food product",
    "FOODON_03301336": "infant cereal",
    "FOODON_03309101": "holland herring",
    "FOODON_00001075": "mammalian milk (nonfat, dry)",
    "FOODON_03400816": "breakfast cereal (eurofir)",
    "FOODON_03541924": "19240 - zebu fresh meat (efsa foodex2)",
    "FOODON_03301397": "sauerkraut",
    "FOODON_00001215": "cacao food product",
    "FOODON_03541344": "13440 - batavia cinnamon bark (efsa foodex2)",
    "HANCESTRO_0323": "Dutch founder",
    "FOODON_03306285": "spinach macaroni (enriched)",
    "FOODON_03317528": "potato (deep-frozen)",
    "FOODON_03401285": "USDA SR finfish and shellfish products (1500)",
    "FOODON_03543327": "33270 - drink mixes (efsa foodex2)",
    "FOODON_03414659": "cassytha plant",
    "FOODON_03544375": "43750 - sour cream flavour (efsa foodex2)",
    "NCBITaxon_29135": "Dugongidae",
    "FOODON_03308114": "sardine fillet (salt-cured)",
    "FOODON_00003361": "chicken (whole, butchered)",
    "FOODON_03543235": "32350 - juice concentrate, red currant (efsa foodex2)",
    "FOODON_03307607": "vegetable fat shake (food product)",
    "FOODON_03543967": "39670 - pasta, cooked, with mushroom sauce (efsa foodex2)",
    "FOODON_03542346": "23460 - cod (efsa foodex2)",
    "FOODON_03411296": "anise plant",
    "FOODON_03311468": "beef sirloin steak (cooked)",
    "FOODON_03540145": "01450 - chapati (efsa foodex2)",
    "FOODON_03316490": "seasoning, powdered",
    "CHEBI_36683": "organochlorine compound",
    "FOODON_03307847": "pickled green tomato (food product)",
    "FOODON_03301303": "mushroom (whole)",
    "FOODON_03311854": "chocolate roll",
    "FOODON_03316176": "onions in vinegar",
    "FOODON_03420242": "seed on cob, with or without husk",
    "FOODON_03544395": "43950 - tiramisu' flavour (efsa foodex2)",
    "FOODON_03316820": "spaghetti (vegetable, enriched)",
    "FOODON_03301647": "drinking water (purified)",
    "NCBITaxon_1489906": "Istiophoriformes",
    "NCBITaxon_52904": "Scophthalmus maximus",
    "FOODON_03400227": "ice cream (us cfr)",
    "CHEBI_33670": "heteromonocyclic compound",
    "FOODON_00003185": "crispbread",
    "FOODON_03544066": "40660 - extracts (efsa foodex2)",
    "FOODON_03301527": "layer cake",
    "FOODON_03305396": "shrimp (freeze-dried)",
    "FOODON_03310478": "breakfast cereal (whole grain)",
    "HANCESTRO_0387": "Saint-Pierrais or Miquelonnais",
    "PATO_0001315": "mild increased temperature",
    "FOODON_03542867": "28670 - hard cheese (cheddar, emmental type) (efsa foodex2)",
    "FOODON_03541649": "16490 - table olives (efsa foodex2)",
    "FOODON_03311020": "pacific salmon (canned)",
    "FOODON_03411745": "laver",
    "FOODON_03540980": "09800 - american groundnuts tubers (efsa foodex2)",
    "FOODON_03306645": "woodcock meat (raw)",
    "FOODON_03540885": "08850 - peppermint (efsa foodex2)",
    "ENVO_01001788": "marine ecosystem",
    "FOODON_03401784": "10006751 - ready-made combination meals - ready to eat (perishable) (gs1 gpc)",
    "FOODON_00002899": "goby",
    "FOODON_03301291": "peach puree",
    "FOODON_03309171": "california sea bass (raw)",
    "FOODON_03310212": "tomato (sun-dried, in olive oil)",
    "FOODON_03302307": "anchovy in olive oil",
    "ENVO_01000417": "house",
    "FOODON_03301447": "hen egg liquid (frozen)",
    "FOODON_03308283": "snoek (raw)",
    "HANCESTRO_0377": "Montenegrin",
    "FOODON_03415018": "birch plant",
    "FOODON_03510218": "food allergen labelling about peanuts and products thereof",
    "FOODON_03310214": "black ligurian olive",
    "NCBITaxon_169733": "Calameae",
    "FOODON_03541490": "14900 - stone fruits (efsa foodex2)",
    "NCBITaxon_47307": "Neogobius",
    "FOODON_03490274": "glass container, uncoloured, light weight",
    "FOODON_03301562": "thyme leaf (whole)",
    "FOODON_03470108": "preservation by treatment with chemicals",
    "FOODON_03470160": "ultra high pressure sterilization",
    "FOODON_03401839": "10006048 - watercress (gs1 gpc)",
    "HANCESTRO_0342": "Kazakhstani",
    "FOODON_03414721": "burrawong plant",
    "FOODON_00002546": "Iberian ham",
    "FOODON_03401624": "10005771 - duck - prepared/processed (gs1 gpc)",
    "FOODON_03490407": "polyvinyl chloride - polyvinylidene chloride container",
    "PATO_0001547": "quality of a gas",
    "FOODON_03401030": "50131800 - cheese/cheese substitutes (gs1 gpc)",
    "FOODON_03308939": "white croaker (raw)",
    "FOODON_03304177": "sardine (smoked, canned)",
    "FOODON_03543889": "38890 - pan-fried potato (efsa foodex2)",
    "FOODON_03304940": "cream soup mix",
    "CHEBI_32234": "titanium dioxide",
    "FOODON_03311804": "jam or preserve (dietetic)",
    "FOODON_00002339": "water based soft drink food product",
    "FOODON_03543322": "33220 - functional drinks (efsa foodex2)",
    "FOODON_03540729": "07290 - burnet saxifrage roots (efsa foodex2)",
    "FOODON_03544007": "40070 - legume (beans) soup (efsa foodex2)",
    "NCBITaxon_29151": "Osmerus eperlanus",
    "FOODON_03311457": "sweet cherry (whole, raw)",
    "FOODON_03543466": "34660 - bitter orange infusion leaves (efsa foodex2)",
    "FOODON_03411813": "grunt",
    "NCBITaxon_3741": "Manilkara zapota",
    "FOODON_03309916": "yam flour (food product)",
    "NCBITaxon_30762": "Phractolaeminae",
    "NCBITaxon_8007": "Esociformes",
    "FOODON_03301971": "obsolete: miso (food product)",
    "FOODON_03412630": "red bell pepper plant",
    "FOODON_03412633": "pungent pepper variety plant",
    "FOODON_03542886": "28860 - cheese, monte veronese (efsa foodex2)",
    "FOODON_03306350": "onion (dried)",
    "BFO_0000002": "continuant",
    "NCBITaxon_3827": "Cicer arietinum",
    "FOODON_03415037": "randhuni plant",
    "FOODON_03544223": "42230 - cardamom flavour (efsa foodex2)",
    "FOODON_03490227": "one component adhesive, organic solvent",
    "FOODON_03541798": "17980 - dried vine fruits (raisins etc.) (efsa foodex2)",
    "NCBITaxon_59626": "Vigna vexillata",
    "FOODON_03414068": "greek sheatfish",
    "FOODON_03520512": "inland water fishing area",
    "FOODON_03303641": "chocolate candy (made with alcohol)",
    "FOODON_00002662": "food (batter-coated)",
    "FOODON_03401240": "0500000 - 5. cereals (ec)",
    "FOODON_03309374": "cellulose filler",
    "FOODON_03304341": "lobster tail (raw)",
    "IAO_0000112": "example of usage",
    "NCBITaxon_334896": "Monodactylus argenteus",
    "FOODON_03306127": "romaine lettuce (raw)",
    "FOODON_03412161": "sumac plant",
    "FOODON_03411333": "guava plant",
    "FOODON_03307933": "torula yeast (smoked)",
    "NCBITaxon_983550": "Lamioideae incertae sedis",
    "FOODON_00003005": "pickled cucumber",
    "FOODON_03302918": "monterey cheese",
    "FOODON_03413938": "tubenose goby",
    "FOODON_03411039": "tonka bean plant",
    "FOODON_03541850": "18500 - candied fruit, bananas (efsa foodex2)",
    "GAZ_00009159": "Anguilla",
    "FOODON_03401777": "10006756 - quark products (frozen) (gs1 gpc)",
    "FOODON_03301130": "banana (whole, raw)",
    "FOODON_03412737": "red boletus",
    "FOODON_03543893": "38930 - potato puree (efsa foodex2)",
    "FOODON_03302081": "jojoba bean oil",
    "FOODON_03401767": "10005902 - nashi (gs1 gpc)",
    "FOODON_03304199": "cream of chicken soup (condensed)",
    "NCBITaxon_22663": "Punica granatum",
    "FOODON_00001581": "alewife food product",
    "FOODON_03316042": "salad",
    "FOODON_03302225": "imitation grape-flavored beverage base",
    "NCBITaxon_443809": "Rhombosolea",
    "NCBITaxon_7996": "Ictaluridae",
    "FOODON_03415153": "yarrow plant",
    "FOODON_03311175": "sashimi prepared from sea bass",
    "ENVO_01000177": "grassland biome",
    "FOODON_00002571": "squash flower",
    "CHEBI_31346": "calcium sulfate",
    "FOODON_03542237": "22370 - tilapias and other cichlids (efsa foodex2)",
    "FOODON_03304017": "tartar sauce",
    "CHEBI_81048": "Ferrous lactate",
    "FOODON_03307398": "blue pike (raw)",
    "UBERON_0012641": "body of tubeworm",
    "FOODON_03540795": "07950 - paddy straw mushroom (efsa foodex2)",
    "NCBITaxon_186628": "Characiphysae",
    "FOODON_00001242": "spice or herb",
    "FOODON_03412820": "trichoscypha plant",
    "FOODON_03543980": "39800 - nasi goreng (efsa foodex2)",
    "FOODON_03311110": "instant shake mix",
    "FOODON_03413498": "european smelt",
    "FOODON_03308597": "crabmeat (dressed, artificially colored)",
    "FOODON_03542658": "26580 - american buffalo milk (efsa foodex2)",
    "FOODON_03414651": "ampelocissus grape plant",
    "FOODON_03317072": "drink milk-based (with no added sugar)",
    "FOODON_00002683": "mixed vegetables",
    "FOODON_03304829": "meat pie (frozen)",
    "FOODON_03316299": "sweet dish",
    "FOODON_00002514": "blue corn meal",
    "FOODON_03306537": "morel (canned)",
    "FOODON_03307442": "yogurt (artificially flavored)",
    "FOODON_03305311": "gravy (country-style)",
    "FOODON_03543946": "39460 - cheese savoury pie (efsa foodex2)",
    "FOODON_03308818": "rock shrimp (raw)",
    "FOODON_03401224": "0130000 - pome fruit (ec)",
    "FOODON_03307020": "poppadum",
    "FOODON_03304000": "pepper sauce",
    "FOODON_03302909": "white chocolate coating",
    "FOODON_03460354": "sugar coating or covering process",
    "FOODON_03541635": "16350 - sorb fruits (efsa foodex2)",
    "FOODON_03414958": "salal plant",
    "FOODON_03530284": "red skin",
    "FOODON_03311743": "rainbow trout baked",
    "FOODON_03413206": "obsolete: potassium chloride",
    "FOODON_03414085": "thornback ray",
    "FOODON_03414751": "bottletree plant",
    "FOODON_03306763": "fruit pie filling",
    "FOODON_03316981": "salt-preserved lemon (sliced, bottled)",
    "RO_0002222": "temporally related to",
    "IAO_0000121": "organizational term",
    "FOODON_03412359": "liza",
    "FOODON_03542747": "27470 - cheese, juustoleipa (efsa foodex2)",
    "FOODON_03543802": "38020 - dietary foods for special medical purposes (efsa foodex2)",
    "GAZ_00000588": "Central Africa",
    "FOODON_03316291": "pastry (low in protein)",
    "NCBITaxon_108881": "Theobroma grandiflorum",
    "GAZ_00005809": "JIle uan de Nova",
    "FOODON_00002331": "vegetable dessert food product",
    "FOODON_03305260": "cream cracker",
    "FOODON_03310363": "alfalfa meal for animal feed",
    "FOODON_03540524": "05240 - broccoli and similar- (efsa foodex2)",
    "FOODON_03302550": "cow buttermilk (instant)",
    "FOODON_03315731": "pork fatty tissue (partially defatted)",
    "NCBITaxon_942859": "Etrumeus micropus",
    "FOODON_03310907": "obsolete: soup, not further specified",
    "FOODON_03541032": "10320 - ervils (without pods) (efsa foodex2)",
    "FOODON_03309070": "golden snapper (raw)",
    "FOODON_03400349": "sweetener (ec)",
    "FOODON_03544138": "41380 - mixed chutney (efsa foodex2)",
    "FOODON_03460777": "selenium added",
    "NCBITaxon_38874": "Fraxinus ornus",
    "FOODON_03542862": "28620 - cheese, vasterbotten (efsa foodex2)",
    "FOODON_03543726": "37260 - fermented tea infusion (efsa foodex2)",
    "FOODON_03301533": "cranberry juice cocktail",
    "FOODON_03305112": "chocolate candy (liquid-filled)",
    "FOODON_03310882": "alcohol-free beer",
    "ENVO_01001305": "vegetated area",
    "FOODON_03310613": "walnut meat (dried)",
    "GAZ_00002729": "Sweden",
    "HANCESTRO_0505": "Chadian",
    "FOODON_03544329": "43290 - nougat flavour (efsa foodex2)",
    "HANCESTRO_0373": "Lithuanian",
    "FOODON_03301819": "chow mein noodle (canned)",
    "FOODON_03542030": "20300 - ratites liver (efsa foodex2)",
    "FOODON_03309954": "table salt",
    "FOODON_03400172": "prepared food product (us cfr)",
    "FOODON_03400629": "CCFAC fruits and vegetables",
    "CHEBI_75323": "lactitol",
    "FOODON_03311522": "infant formula (milk-based, iron-fortified, powdered)",
    "FOODON_03420145": "organ meat, urogenital system",
    "FOODON_03309279": "devilfish (raw)",
    "FOODON_03304873": "papaya seed (dried)",
    "FOODON_03542888": "28880 - cheese, pecorino toscano (efsa foodex2)",
    "FOODON_03543749": "37490 - infant formulae (efsa foodex2)",
    "FOODON_03310710": "tortilla chip",
    "NCBITaxon_483417": "Eriphia verrucosa",
    "PO_0030100": "legume fruit",
    "FOODON_03460196": "chloride added",
    "FOODON_03540372": "03720 - escaroles (efsa foodex2)",
    "FOODON_03309634": "sunshine snapper (raw)",
    "FOODON_03303416": "grape juice (frozen)",
    "CHEBI_23334": "cobalamins",
    "FOODON_03305846": "ice cream (homemade)",
    "FOODON_03430102": "food (liquid, high viscosity)",
    "FOODON_00001799": "cuttlefish food product",
    "FOODON_00003019": "shallot (whole, raw)",
    "FOODON_03310943": "zucchini squash (whole)",
    "FOODON_03411837": "blue whiting",
    "FOODON_03306417": "ham (sliced, raw)",
    "OBI_0001755": "selection criterion",
    "FOODON_03311386": "rice milk beverage (food product)",
    "FOODON_03310110": "shrimp (powdered)",
    "CHEBI_88061": "polyamine",
    "FOODON_03542319": "23190 - clearhead icefish (efsa foodex2)",
    "FOODON_03400160": "pie crust, unsweetened (us cfr)",
    "FOODON_03543642": "36420 - fragrant sumac infusion roots (efsa foodex2)",
    "FOODON_03413678": "common cuttlefish",
    "NCBITaxon_99346": "Scomberomorus sierra",
    "FOODON_03540455": "04550 - climbing wattle (efsa foodex2)",
    "FOODON_03303125": "maraschino cherry (green)",
    "FOODON_03401025": "50130000 - milk/butter/cream/yoghurts/cheese/eggs/substitutes (gs1 gpc)",
    "FOODON_03541370": "13700 - allspice fruit (efsa foodex2)",
    "HANCESTRO_0442": "Kuwaiti",
    "FOODON_03414277": "southern queen scallop",
    "CHEBI_24868": "organic salt",
    "FOODON_03543221": "32210 - mixed fruit and vegetable juices (efsa foodex2)",
    "NCBITaxon_6650": "Polyplacophora",
    "NCBITaxon_4540": "Panicum miliaceum",
    "FOODON_03414824": "inland pigface plant",
    "NCBITaxon_2231390": "Pterocarpus clade",
    "FOODON_00003140": "stew",
    "FOODON_03302917": "chocolate-flavored beverage mix dry instant",
    "FOODON_03301239": "cherry (brined)",
    "FOODON_03414081": "mediterranean starry ray",
    "FOODON_03450004": "cooking by dry heat",
    "FOODON_03301375": "spinach (canned)",
    "FOODON_03414835": "acmena plant",
    "FOODON_03543524": "35240 - mistletoe infusion leaves (efsa foodex2)",
    "FOODON_03310639": "milk (dry)",
    "FOODON_03307401": "oyster liquor",
    "FOODON_03303615": "milk chocolate (artificially sweetened)",
    "FOODON_03315356": "fish ham (food product)",
    "FOODON_03401683": "10005803 - turkey - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03308142": "lobster newburg (dish)",
    "FOODON_03543822": "38220 - enzyme-based formulations (efsa foodex2)",
    "FOODON_03303153": "butter cookie (artificially flavored)",
    "FOODON_03530219": "food packing medium drained",
    "FOODON_03530147": "cheese rind (natural)",
    "FOODON_03306208": "safflower oil margarine",
    "FOODON_03541565": "15650 - southern blueberry (efsa foodex2)",
    "ENVO_01000219": "anthropogenic terrestrial biome",
    "FOODON_03306379": "red currant marmalade",
    "FOODON_03306866": "peanut butter with wheat germ oil",
    "FOODON_03540184": "01840 - filled (stuffed) pastas (efsa foodex2)",
    "FOODON_03412381": "obsolete: lutjanus silla",
    "FOODON_03311003": "pepperoni",
    "HANCESTRO_0528": "Comoran",
    "NCBITaxon_9639": "Ursus",
    "FOODON_03308151": "eastern oyster (raw)",
    "FOODON_03420127": "animal body or body part",
    "FOODON_03317264": "meat food product (cured, comminuted)",
    "OBI_0200170": "averaging data transformation",
    "FOODON_03540744": "07440 - burdock, greater or edible (efsa foodex2)",
    "FOODON_03305788": "cherries in vanilla ice cream",
    "FOODON_03309665": "obsolete: fish cutlet (raw)",
    "FOODON_00002395": "moromi",
    "NCBITaxon_69266": "Vaccinium corymbosum",
    "FOODON_03542934": "29340 - cheese rind (efsa foodex2)",
    "FOODON_03401553": "10006265 - eryngii (gs1 gpc)",
    "FOODON_03303138": "cookie (lemon-flavored puff)",
    "FOODON_03430148": "divided into quarters",
    "FOODON_03530015": "cutter grade",
    "FOODON_03414906": "foxtail amaranth plant",
    "FOODON_03414801": "yabby",
    "CHEBI_28757": "fructose",
    "FOODON_03541005": "10050 - other sugar plants (efsa foodex2)",
    "GAZ_00005852": "Metropolitan Denmark",
    "NCBITaxon_30520": "Bos frontalis",
    "FOODON_03309716": "colza (food product)",
    "FOODON_03490150": "paperboard molded pack",
    "FOODON_03490164": "aluminum tray or pan, paper wrapping",
    "FOODON_03530027": "sirloin",
    "FOODON_00003311": "rawhide snack",
    "FOODON_03414014": "mycteroperca",
    "FOODON_03302800": "frozen dessert",
    "FOODON_03542008": "20080 - goose, fresh fat tissue (efsa foodex2)",
    "NCBITaxon_8112": "Percoidei",
    "FOODON_03308048": "clam (cherrystone, raw)",
    "FOODON_03543739": "37390 - mat\u00e9 infusion (efsa foodex2)",
    "FOODON_03480029": "packed in vinegar",
    "FOODON_03401412": "10006273 - baby/infant - specialised foods (frozen) (gs1 gpc)",
    "FOODON_03411304": "pigeon",
    "FOODON_03542953": "29530 - geese eggs (efsa foodex2)",
    "GAZ_00010832": "Paracel Islands",
    "FOODON_03304938": "chicken noodle soup mix",
    "FOODON_03306370": "wheat cereal with tomato",
    "GAZ_00003901": "Brunei Darussalam",
    "FOODON_03306652": "pear juice (fermented)",
    "HANCESTRO_0501": "Timorese",
    "FOODON_03414714": "wombat berry plant",
    "FOODON_03303893": "shrimp gel (freeze-dried, for fish food)",
    "FOODON_03306626": "garlic (dehydrated)",
    "FOODON_03307700": "coleslaw dressing",
    "NCBITaxon_1728962": "Amyridoideae",
    "FOODON_03305572": "ham (sodium restricted, canned)",
    "NCBITaxon_6728": "Procambarus clarkii",
    "FOODON_03412089": "romaine plant",
    "FOODON_03541712": "17120 - banana passionfruits (efsa foodex2)",
    "FOODON_03544430": "44300 - thickener (efsa foodex2)",
    "FOODON_03412641": "hijiki kelp",
    "FOODON_03470121": "food filtration",
    "FOODON_03310014": "kidney bean (whole, raw)",
    "FOODON_03303027": "chicken heart (raw)",
    "FOODON_03316968": "gelatin refrigerated ready-to-serve",
    "FOODON_03460117": "flavor or taste ingredient",
    "FOODON_03310547": "soft drink (dietetic)",
    "FOODON_03490363": "polycarbonate container",
    "FOODON_03301959": "potato (french-fried)",
    "GAZ_00005279": "Saudi Arabia",
    "NCBITaxon_105667": "Prunus tomentosa",
    "FOODON_03415137": "heather plant",
    "FOODON_03413671": "chilean flat oyster",
    "FOODON_03540439": "04390 - agretti (efsa foodex2)",
    "FOODON_03530202": "fat content < 50%, > 35% pufa",
    "FOODON_03308830": "crabmeat (claw)",
    "FOODON_03311001": "corn (shelled)",
    "FOODON_03411676": "cherry plum plant",
    "FOODON_03540211": "02110 - short pastry dough (pate brisee) (efsa foodex2)",
    "FOODON_03500055": "teflon surface",
    "FOODON_00003207": "peanut pod (roasted)",
    "FOODON_00002650": "food (colored)",
    "FOODON_03301825": "pistachio nut (whole, raw)",
    "NCBITaxon_3318": "Pinaceae",
    "NCBITaxon_9647": "Procyonidae",
    "FOODON_03411744": "kelp",
    "FOODON_00001195": "obsolete: lentil food product",
    "FOODON_03470144": "artificial heat drying",
    "GAZ_00007118": "Jarvis Island",
    "FOODON_03307037": "potato chip (cheese-flavored)",
    "FOODON_00002165": "organ meat product",
    "NCBITaxon_27065": "Theaceae",
    "FOODON_03310807": "corn (chopped, raw)",
    "FOODON_03414306": "australian sunrise lime plant",
    "FOODON_03542800": "28000 - cheese, bra (efsa foodex2)",
    "FOODON_03540093": "00930 - wheat flour, durum (efsa foodex2)",
    "FOODON_03307727": "potato syrup",
    "FOODON_03310247": "meat (mold-fermented)",
    "CHEBI_27956": "L-dehydroascorbic acid",
    "NCBITaxon_91835": "fabids",
    "NCBITaxon_102312": "Pteriidae",
    "FOODON_03308107": "horse mackerel (raw)",
    "FOODON_00002570": "pork loin",
    "FOODON_00003002": "boa",
    "FOODON_03541991": "19910 - buffalo fresh fat tissue (efsa foodex2)",
    "FOODON_03543429": "34290 - cocoa beans and similar- (efsa foodex2)",
    "RO_0000085": "has function",
    "FOODON_03542830": "28300 - cheese, maasdam (efsa foodex2)",
    "ENVO_01000180": "tundra biome",
    "FOODON_03412843": "chrysophyllum plant",
    "FOODON_03541917": "19170 - calf fresh meat (efsa foodex2)",
    "NCBITaxon_46259": "Morone chrysops",
    "FOODON_00003305": "porterhouse steak",
    "FOODON_03308729": "tuna (spiced in jelly, canned)",
    "FOODON_03430153": "whole, shape achieved by forming, thickness <0.3 cm.",
    "FOODON_03306211": "molasses (blackstrap)",
    "HANCESTRO_0357": "Croatian",
    "FOODON_03413264": "sodium methyl p-hydroxybenzoate",
    "FOODON_03305158": "barley malt and rice (spent)",
    "FOODON_03301483": "lowfat cow milk",
    "FOODON_03540575": "05750 - garlic and similar- (efsa foodex2)",
    "FOODON_03304348": "marlin (cured, smoked)",
    "FOODON_00001864": "food base product",
    "FOODON_03317229": "wheat (crushed)",
    "FOODON_03413884": "basketweave cusk-eel",
    "FOODON_03542288": "22880 - sturgeon (efsa foodex2)",
    "NCBITaxon_3469": "Papaver somniferum",
    "FOODON_03541610": "16100 - gooseberries (green, red and yellow) (efsa foodex2)",
    "FOODON_03543801": "38010 - carnitine or creatine-based supplement for sports people (efsa foodex2)",
    "FOODON_03542385": "23850 - bombay-duck (efsa foodex2)",
    "FOODON_03414981": "african eggplant plant",
    "FOODON_03304783": "iced tea mix (lime-flavored)",
    "NCBITaxon_60698": "Macadamia integrifolia",
    "FOODON_03543184": "31840 - juice, guava (efsa foodex2)",
    "CHEBI_33635": "polycyclic compound",
    "FOODON_03309659": "haddock croquette",
    "FOODON_03411545": "jackfruit tree",
    "FOODON_03510104": "no artificial sweeteners claim or use",
    "NCBITaxon_43691": "Canarium ovatum",
    "FOODON_03510176": "alcohol free claim or use",
    "FOODON_03308609": "hairy crab (raw)",
    "FOODON_03414616": "australian bustard",
    "NCBITaxon_163743": "Fabeae",
    "FOODON_03542475": "24750 - mackerel roe (efsa foodex2)",
    "FOODON_03412775": "round kumquat plant",
    "FOODON_03306684": "onion ring (cooked)",
    "FOODON_03414321": "oriental wheat plant",
    "FOODON_03544214": "42140 - brown sugar flavour (efsa foodex2)",
    "NCBITaxon_379584": "Caniformia",
    "FOODON_00002362": "whitefish (genus Coregonus) food product",
    "FOODON_03316783": "lemonade (frozen concentrate, colored)",
    "FOODON_03420280": "obsolete: carbohydrate or related compound",
    "CHEBI_78618": "L-alpha-D-Hepp-(1->7)-L-alpha-D-Hepp-(1->3)-L-alpha-D-Hepp-(1->5)-alpha-Kdo",
    "FOODON_03316356": "dough (semi-moist, ready-to-use)",
    "GAZ_00000906": "Cote d'Ivoire",
    "FOODON_03541280": "12800 - wintergreen leaves, dry (efsa foodex2)",
    "BFO_0000182": "history",
    "FOODON_03413335": "green strawberry plant",
    "FOODON_03307748": "imitation tamale",
    "FOODON_03542452": "24520 - mackerel, indian (efsa foodex2)",
    "FOODON_03490176": "tin plate container",
    "FOODON_03317071": "drink with no added sugar (flavored, water-based)",
    "FOODON_03400463": "CIAA salts and spices, soups, sauces and salads, protein products etc.",
    "FOODON_03400965": "10000211 - grains/cereal - not ready to eat - (shelf stable) (gs1 gpc)",
    "FOODON_03412307": "striped snakehead",
    "CHEBI_81862": "potassium hydrogencarbonate",
    "FOODON_03316759": "confectionery (tablet)",
    "FOODON_00003298": "sunflower seed (whole kernel, shell off, roasted)",
    "FOODON_03414983": "turkey berry plant",
    "FOODON_03316319": "sugar product similar to candy",
    "FOODON_03400781": "processed milk (eurofir)",
    "NCBITaxon_233744": "Pouteria sapota",
    "FOODON_00002021": "mango nectar beverage",
    "FOODON_03400447": "taste removing agent (codex)",
    "FOODON_03311575": "flounder (stuffed)",
    "FOODON_03414671": "geebung plant",
    "FOODON_03510226": "food allergen labelling about cocoa and products thereof",
    "FOODON_00001822": "duck egg food product",
    "FOODON_00003380": "food product from culture",
    "FOODON_03316425": "hen egg (preserved)",
    "FOODON_00002933": "hazelnut",
    "FOODON_03306391": "black currant jelly (dietetic)",
    "FOODON_03315110": "salt (cooking only)",
    "FOODON_03400441": "seasoning agent (codex)",
    "FOODON_03540644": "06440 - tomatillos (efsa foodex2)",
    "FOODON_03544357": "43570 - raffaello flavour (efsa foodex2)",
    "FOODON_03540244": "02440 - speculaas (efsa foodex2)",
    "FOODON_03530051": "unripe or immature",
    "NCBITaxon_45179": "Coccoloba uvifera",
    "FOODON_03543209": "32090 - other vegetable juices (efsa foodex2)",
    "FOODON_03304524": "slippery elm cereal",
    "FOODON_03544398": "43980 - tonic flavour (efsa foodex2)",
    "FOODON_03542117": "21170 - corned beef, uncooked (efsa foodex2)",
    "FOODON_03413680": "common octopus",
    "FOODON_03311067": "orange juice (freshly squeezed)",
    "NCBITaxon_2085": "Mycoplasmatales",
    "NCBITaxon_8253": "Bothidae",
    "FOODON_03543884": "38840 - potatoes and vegetables meal (efsa foodex2)",
    "FOODON_03302795": "cookie (artificially sweetened)",
    "FOODON_03311311": "shad smoked using hot-smoking nitrate-treated",
    "FOODON_03541814": "18140 - jam, blueberries (efsa foodex2)",
    "FOODON_03541172": "11720 - butter nut (efsa foodex2)",
    "FOODON_03302287": "beverage (carbonated, naturally and artificially sweetened)",
    "FOODON_03316784": "orange juice concentrate (canned)",
    "FOODON_03301840": "anise seed (whole, dried)",
    "FOODON_00002618": "Zinfandel grape plant",
    "FOODON_03544292": "42920 - hot flavour (efsa foodex2)",
    "FOODON_03310695": "hen egg (hard-cooked by microwave, cubed)",
    "FOODON_03306762": "cherry pie (baked, frozen)",
    "CHEBI_28972": "(R)-propane-1,2-diol",
    "FOODON_03306634": "cooking oil (seasoned)",
    "FOODON_03305357": "chicken gizzard (raw)",
    "FOODON_03310850": "manchego cheese",
    "FOODON_03460133": "food certified color addition process",
    "FOODON_03542662": "26620 - yak (domestic) milk (efsa foodex2)",
    "NCBITaxon_309358": "Saccharina latissima",
    "FOODON_03311016": "glucose syrup (dried)",
    "FOODON_03541913": "19130 - mixed pork and mutton/lamb fresh meat (efsa foodex2)",
    "FOODON_03411018": "vegetable-producing plant, root, tuber or bulb",
    "NCBITaxon_76930": "Nemadactylus douglasii",
    "FOODON_03316113": "follow-up formula",
    "FOODON_03543582": "35820 - rose infusion flowers and similar- (efsa foodex2)",
    "HANCESTRO_0353": "Bulgarian",
    "FOODON_03413358": "plant used as fodder",
    "FOODON_03541120": "11200 - almonds (efsa foodex2)",
    "FOODON_03309619": "escabesche sauce",
    "FOODON_03308238": "chiquita crabmeat",
    "FOODON_00001714": "food product component",
    "FOODON_03411540": "barracuda",
    "ENVO_00000015": "ocean",
    "FOODON_03414971": "oroblanco plant",
    "FOODON_03490273": "glass container, uncoloured",
    "GAZ_00002519": "State of Maryland",
    "FOODON_00001588": "american dewberry food product",
    "NCBITaxon_241789": "Scandiceae",
    "NCBITaxon_3804": "Caesalpinioideae",
    "NCBITaxon_9775": "Trichechidae",
    "FOODON_03315993": "bakery product, fine, for special nutritional uses",
    "FOODON_00002348": "wheat based cake food product",
    "FOODON_03401332": "pastries and cakes (eurofir)",
    "FOODON_03302677": "cream of wheat (artificially caramel malt-flavored, dry, instant)",
    "NCBITaxon_8067": "Opsanus",
    "FOODON_03315120": "obsolete: lima beans cooked canned dried",
    "FOODON_03543432": "34320 - abata cola nuts (efsa foodex2)",
    "FOODON_03541911": "19110 - bovine and pig fresh meat (efsa foodex2)",
    "FOODON_03307204": "stuffing for turkey",
    "FOODON_03304206": "lobster sauce",
    "FOODON_03543827": "38270 - textured soy protein (efsa foodex2)",
    "FOODON_00002905": "sillago",
    "FOODON_03543783": "37830 - simple cereals for infants or children, reconstituted (efsa foodex2)",
    "NCBITaxon_39089": "Phoca groenlandica",
    "FOODON_03541922": "19220 - buffalo, american fresh meat (efsa foodex2)",
    "FOODON_03415126": "common speedwell plant",
    "FOODON_03306789": "cheese pizza kit",
    "FOODON_03543693": "36930 - witch hazel (infusion bark) (efsa foodex2)",
    "FOODON_03307025": "popcorn (colored)",
    "NCBITaxon_7915": "Lepisosteidae",
    "FOODON_00001770": "dried cow milk food product",
    "FOODON_03412967": "bigleaf linden plant",
    "FOODON_03414546": "caju-docerrado plant",
    "FOODON_03302187": "imitation chicken salad sandwich spread",
    "FOODON_03413315": "tripotassium citrate",
    "FOODON_03500044": "food-grade steel surface",
    "FOODON_03542842": "28420 - cheese, podlaski (efsa foodex2)",
    "FOODON_03412149": "pacific snapper",
    "FOODON_03411684": "cape gooseberry plant",
    "FOODON_03414288": "odacidae",
    "FOODON_03540500": "05000 - cresses (efsa foodex2)",
    "FOODON_03305299": "miracle fruit concentrate",
    "FOODON_03510108": "no artificial additives claim or use",
    "CHEBI_30769": "citric acid",
    "NCBITaxon_669136": "Artemisia pontica",
    "FOODON_03311514": "roast beef bottom round (cooked)",
    "FOODON_03310606": "clam (whole or part)",
    "FOODON_03530124": "bavette",
    "FOODON_03541987": "19870 - mammals fat tissue (efsa foodex2)",
    "FOODON_00002205": "rice cereal food product",
    "CHEBI_26562": "ribose phosphate",
    "FOODON_03413730": "oldham's bamboo plant",
    "FOODON_03310240": "beef (fried)",
    "NCBITaxon_51952": "Elaeis",
    "FOODON_03541373": "13730 - japanese pepper fruit (efsa foodex2)",
    "FOODON_03411414": "herring",
    "NCBITaxon_163117": "Raniceps raninus",
    "FOODON_03540863": "08630 - rosemary (efsa foodex2)",
    "FOODON_03544115": "41150 - british islands brown sauce (efsa foodex2)",
    "FOODON_03305145": "produce (raw)",
    "FOODON_03480004": "obsolete: packing medium, other",
    "NCBITaxon_58024": "Spermatophyta",
    "FOODON_03544125": "41250 - mint sauce (efsa foodex2)",
    "FOODON_03306728": "hot pepper (pulverized, juiced)",
    "FOODON_03307187": "raisin filling for pastry",
    "FOODON_03414871": "african bonytongue",
    "FOODON_03420261": "root, tuber or bulb, peel only",
    "FOODON_03309418": "korean red ginseng drink",
    "FOODON_03542308": "23080 - rainbow trout (efsa foodex2)",
    "FOODON_03401487": "10006097 - endive (curled) (gs1 gpc)",
    "FOODON_03413041": "calcium hydrogen sulphite",
    "FOODON_03310946": "chicken vegetable soup",
    "FOODON_00001163": "solanaceous fruit food product",
    "FOODON_03401642": "10006307 - quail - prepared/processed (gs1 gpc)",
    "FOODON_03543292": "32920 - fruit soft drink, papaya (efsa foodex2)",
    "NCBITaxon_270329": "Lepomis gibbosus",
    "FOODON_03307106": "nut (salted)",
    "NCBITaxon_217509": "Carassius carassius",
    "FOODON_03412822": "sclerocarya plant",
    "FOODON_03307233": "belgian waffle",
    "FOODON_03401093": "10000293 - grain based products / meals - ready to eat - savoury (perishable) (gs1 gpc)",
    "UBERON_3010039": "protandrous hermaphroditic organism",
    "FOODON_03540875": "08750 - syrian oregano (efsa foodex2)",
    "FOODON_03302481": "sourdough bread",
    "FOODON_03308460": "yellowtail (raw)",
    "NCBITaxon_173042": "Leucoraja ocellata",
    "GAZ_00001098": "Lesotho",
    "FOODON_03510049": "fiber special claim or use",
    "FOODON_03305374": "gelatin fruit salad (artificially sweetened)",
    "HANCESTRO_0408": "Salvadoran",
    "FOODON_03400760": "059  miscellaneaous secondary food commodities of plant origin (sm) (ccpr)",
    "FOODON_03400281": "semisoft cheese (us cfr)",
    "FOODON_03540539": "05390 - asparagus (efsa foodex2)",
    "FOODON_03308432": "sardine (scaled)",
    "CHEBI_27568": "selenium atom",
    "HANCESTRO_0365": "Gibraltarian",
    "FOODON_03541616": "16160 - mulberries (black and white) and similar- (efsa foodex2)",
    "PO_0020142": "stem internode",
    "FOODON_03400366": "antibrowning agent (codex)",
    "FOODON_03316952": "macaroni product (vegetable)",
    "FOODON_03412464": "brine shrimp",
    "FOODON_03303030": "brunswick stew",
    "FOODON_03413617": "painted river prawn",
    "UO_0000193": "purity percentage",
    "FOODON_03541470": "14700 - other miscellaneous citrus fruit (efsa foodex2)",
    "FOODON_03316912": "cereal-based product",
    "NCBITaxon_8821": "Apteryx",
    "NCBITaxon_2822": "Palmaria palmata",
    "FOODON_03303201": "white corn (raw)",
    "FOODON_03414359": "bactrian camel",
    "NCBITaxon_549311": "Ulva limnetica",
    "FOODON_03411642": "purslane plant",
    "FOODON_03306182": "cranberry juice drink",
    "FOODON_03304024": "pepino sauce",
    "CHEBI_63017": "sodium L-tartrate",
    "FOODON_03413400": "jack-bean plant",
    "NCBITaxon_645159": "Palaemon serratus",
    "FOODON_03414748": "aponogeton plant",
    "CHEBI_24436": "guanidines",
    "FOODON_00002897": "calamari",
    "FOODON_03309459": "chicken vegetable soup mix",
    "FOODON_03303148": "milk chocolate finger cookie",
    "BFO_0000029": "site",
    "FOODON_03307606": "chocolate-flavored mint sandwich cookie",
    "FOODON_03543413": "34130 - coffee ground, roasted (efsa foodex2)",
    "FOODON_03541957": "19570 - moufflon fresh meat (efsa foodex2)",
    "FOODON_03544411": "44110 - yoghurt flavour (efsa foodex2)",
    "FOODON_03414793": "tylophora plant",
    "FOODON_03510157": "game as consumer",
    "CHEBI_22823": "beta-alanine derivative",
    "NCBITaxon_416196": "Citrus australasica",
    "FOODON_03543753": "37530 - infant formula, milk and soya-based, powder (efsa foodex2)",
    "FOODON_03306443": "meat braising sauce mix with mushrooms (dry)",
    "RO_0002351": "has member",
    "FOODON_03542639": "26390 - smoked mackerel (efsa foodex2)",
    "FOODON_03316508": "shortbread cake small",
    "FOODON_03412642": "amberjack",
    "GAZ_00006891": "Fiji",
    "FOODON_03305798": "ice cream mix (powdered)",
    "FOODON_03303515": "cheese (blended)",
    "FOODON_03305801": "vienna wafer (wheat-free)",
    "FOODON_03308175": "cape lobster (raw)",
    "FOODON_03401428": "10005928 - bilberries (gs1 gpc)",
    "FOODON_03411114": "winter savory plant",
    "FOODON_03305405": "cream (sterilized, acidified)",
    "FOODON_00003312": "snow leopard",
    "FOODON_03542471": "24710 - cod roe (efsa foodex2)",
    "FOODON_00003125": "Malus group",
    "FOODON_03543604": "36040 - lavender infusion flowers (efsa foodex2)",
    "FOODON_03541612": "16120 - rose hips (efsa foodex2)",
    "FOODON_03309584": "tomatillo (whole, raw)",
    "FOODON_03301231": "glucose vinegar",
    "FOODON_03530188": "fat content 1-3%",
    "ENVO_00003096": "tap water",
    "FOODON_03301221": "chervil food product",
    "CARO_0000000": "anatomical entity",
    "FOODON_03305161": "skim milk drink",
    "NCBITaxon_41768": "Ranunculales",
    "FOODON_03302250": "orange juice drink",
    "FOODON_03303760": "mint candy",
    "FOODON_03311372": "spinach (chopped, frozen)",
    "FOODON_03401561": "10006419 - batavia (gs1 gpc)",
    "FOODON_03543636": "36360 - cowslip infusion roots (efsa foodex2)",
    "FOODON_03311151": "peach (sliced, canned)",
    "NCBITaxon_3488": "Artocarpus",
    "FOODON_03303559": "citrus pulpwash solids",
    "FOODON_03400393": "colour stabilizer (codex)",
    "CHEBI_53700": "quinoline yellow",
    "FOODON_03311579": "yogurt mix",
    "FOODON_03414281": "sea chub family",
    "FOODON_03414255": "goitenyo plant",
    "FOODON_03316699": "chestnut (canned)",
    "FOODON_03317574": "cheese (red marbled)",
    "FOODON_03541182": "11820 - poppy seeds and similar- (efsa foodex2)",
    "FOODON_03310748": "bacon fat (cooked)",
    "FOODON_03541160": "11600 - yunnan pine nut kernels (efsa foodex2)",
    "FOODON_03302272": "imitation orange juice beverage base (artificially sweetened, dry)",
    "FOODON_03542311": "23110 - brook trout (efsa foodex2)",
    "ENVO_01001476": "body of liquid",
    "FOODON_03316552": "cow milk (powdered, instant, with cocoa flavoring)",
    "NCBITaxon_114937": "Prunus spinosa",
    "FOODON_03540126": "01260 - rye only bread and rolls (efsa foodex2)",
    "FOODON_03302264": "grape drink beverage base",
    "FOODON_03304246": "scottish lobster soup",
    "ENVO_01000017": "sand",
    "FOODON_03413039": "calcium guanylate",
    "FOODON_03309012": "tuna fillet (raw)",
    "FOODON_03415061": "chilean guava plant",
    "FOODON_00001948": "heavy wine, 14-24% alcohol, food product",
    "FOODON_03414496": "pangium edule plant",
    "FOODON_03543885": "38850 - potatoes and meat meal (efsa foodex2)",
    "FOODON_00001187": "sorghum food product",
    "FOODON_03315862": "sausage (semi-dried)",
    "FOODON_00001282": "ground beef food product",
    "FOODON_03401430": "10005923 - blackberries (gs1 gpc)",
    "FOODON_03543601": "36010 - hollyhock infusion flowers (efsa foodex2)",
    "FOODON_03510106": "artificial ingredient-related claim or use",
    "FOODON_03542281": "22810 - cod, murray (efsa foodex2)",
    "FOODON_03414694": "queensland nutmeg plant",
    "FOODON_03414386": "giant snail",
    "FOODON_03308041": "fish sausage (smoked)",
    "FOODON_03460853": "obsolete: fish oil added",
    "FOODON_03414029": "pumpkin-seed",
    "FOODON_03303908": "mammalian milk (cultured)",
    "NCBITaxon_3618": "Rumex",
    "FOODON_03411484": "pineapple plant",
    "PATO_0001736": "solid configuration",
    "FOODON_03411852": "blueback herring",
    "FOODON_00003307": "shell removal process",
    "FOODON_03510110": "preservative-related claim or use",
    "FOODON_03308298": "tasmanian lovettia (raw)",
    "FOODON_03412340": "cascara buckthorn plant",
    "FOODON_03542619": "26190 - dried fish (efsa foodex2)",
    "FOODON_03543082": "30820 - oil seed mass (efsa foodex2)",
    "FOODON_03306473": "rabbit meat (canned)",
    "FOODON_03316827": "vermicelli (wheat and soy)",
    "FOODON_03412974": "liquid",
    "FOODON_00002022": "margarine food product",
    "NCBITaxon_1489928": "Labriformes",
    "FOODON_03540666": "06660 - other solanacea (efsa foodex2)",
    "CHEBI_52206": "biochemical role",
    "FOODON_00001229": "processed cheese food product",
    "FOODON_00002877": "sofrito",
    "FOODON_03301554": "allspice (ground)",
    "FOODON_03304726": "fruit juice (sterilized)",
    "FOODON_03542513": "25130 - prawn, northern (efsa foodex2)",
    "FOODON_03401689": "10005834 - chicken sausages - prepared/processed (gs1 gpc)",
    "FOODON_03543855": "38550 - meat loaf with cheese, vegetables or other (efsa foodex2)",
    "CHEBI_33241": "oxoacid derivative",
    "FOODON_03543459": "34590 - agrimony infusion leaves (efsa foodex2)",
    "FOODON_03412433": "california sea cucumber",
    "NCBITaxon_64144": "Anabas testudineus",
    "NCBITaxon_333970": "Taraxacum kok-saghyz",
    "FOODON_03412324": "western australian gizzard shad",
    "FOODON_03303423": "butterscotch chip cookie (artificially colored and flavored)",
    "FOODON_03510212": "reduced {name of nutrient} nutrition claim",
    "FOODON_03306188": "lemon curd",
    "FOODON_00002093": "pea soup food product",
    "FOODON_03306837": "tropical health drink (diluted)",
    "FOODON_03541277": "12770 - sweet cicely, dry (efsa foodex2)",
    "FOODON_03520135": "atlantic, northeast (fao major fishing area 27)",
    "FOODON_03301269": "green olive (whole)",
    "FOODON_03306724": "sweet pepper (peeled, canned)",
    "FOODON_03411026": "chinese waterchestnut plant",
    "FOODON_03316213": "cereal (dry)",
    "FOODON_03530257": "traditional speciality guaranteed (tsg)",
    "FOODON_03412674": "sand flounder",
    "FOODON_03542432": "24320 - other billfishes (efsa foodex2)",
    "FOODON_03302024": "beef dog food (canned)",
    "HANCESTRO_0379": "Norfolk Islander",
    "FOODON_03305970": "imitation wild cherry jam",
    "FOODON_03311485": "lard (hardened)",
    "FOODON_03307309": "imitation prepared mustard",
    "FOODON_03306496": "obsolete: chicken-flavored soup cube",
    "FOODON_03315318": "vitamin-mineral preparation containing calcium caseinate in the absence of fat-soluble vitamins",
    "FOODON_03542084": "20840 - pig stomach (efsa foodex2)",
    "FOODON_03543638": "36380 - narrow-leaf echinacea infusion roots (efsa foodex2)",
    "FOODON_03413310": "tragacanth",
    "FOODON_00003009": "kabocha squash plant",
    "FOODON_03309476": "meat and bone scrap",
    "FOODON_03540783": "07830 - cultivated fungi and similar- (efsa foodex2)",
    "FOODON_03305074": "shrimp (raw, stuffed, breaded, frozen)",
    "FOODON_03414263": "black crowberry plant",
    "FOODON_03304843": "eggnog with alcohol",
    "FOODON_03400715": "25  poultry and poultry products (efg)",
    "FOODON_03309090": "greenland turbot fillet (raw)",
    "FOODON_03542186": "21860 - wiener sausage (efsa foodex2)",
    "FOODON_03510269": "apache food claim or use",
    "FOODON_03306214": "confectioner's glaze",
    "FOODON_03310737": "great northern bean (whole, dried)",
    "FOODON_03543132": "31320 - fats and oils from marine animals (efsa foodex2)",
    "FOODON_03543784": "37840 - biscuits, rusks and cookies for children (efsa foodex2)",
    "FOODON_03401692": "10005840 - pork sausages - prepared/processed (gs1 gpc)",
    "FOODON_03303758": "chocolate ice cream drop candy",
    "FOODON_03543364": "33640 - noble rot wine (efsa foodex2)",
    "FOODON_03301436": "almond dragee (food product)",
    "FOODON_03316211": "beverage (water-based, carbonated, with added sweeteners and flavorings)",
    "CHEBI_23509": "cysteine derivative",
    "FOODON_03308258": "pacific ocean perch (raw)",
    "FOODON_03412462": "chinese swamp cabbage plant",
    "FOODON_03315586": "vermouth (extract of)",
    "FOODON_03303062": "apple cider (fermented)",
    "FOODON_03310079": "hot pepper relish",
    "FOODON_03412706": "european eel",
    "FOODON_03303385": "fruit juice (sparkling)",
    "FOODON_03544153": "41530 - major isolated ingredients, additives, flavours, baking and processing aids (efsa foodex2)",
    "FOODON_03303856": "colby cheese",
    "NCBITaxon_1082757": "Origanum syriacum",
    "FOODON_00002284": "sturgeon food product",
    "FOODON_03540757": "07570 - ullucu (efsa foodex2)",
    "FOODON_03317079": "obsolete: fruit food product",
    "FOODON_03303746": "toffee (fruit-flavored)",
    "FOODON_03302579": "imitation sour cream",
    "FOODON_03413045": "calcium malate",
    "FOODON_03412013": "bilberry plant",
    "FOODON_03303836": "butter oil (hydrogenated)",
    "FOODON_03303627": "old fashioned cocktail mix (nutritively and nonnutritively sweetened)",
    "FOODON_03310694": "hen egg (whole, shell on, iodine enriched)",
    "FOODON_03414690": "native ginger plant",
    "FOODON_03316890": "fruit (quick-frozen)",
    "HANCESTRO_0316": "Amish",
    "FOODON_03401312": "phytoestrogen supplement",
    "FOODON_03540850": "08500 - bloodwort dock (efsa foodex2)",
    "FOODON_03544132": "41320 - relishes (efsa foodex2)",
    "FOODON_03413303": "tetrapotassium diphosphate",
    "FOODON_03413891": "argentine hake",
    "FOODON_03306589": "cereal flour",
    "FOODON_03302915": "filled cheese",
    "FOODON_03414387": "glycine and its sodium salt",
    "NCBITaxon_39338": "Melissa officinalis",
    "NCBITaxon_112818": "Flacourtia",
    "FOODON_03500043": "food-grade tin surface",
    "CHEBI_35875": "imidazopyrimidine",
    "FOODON_03304301": "invert sugar syrup (from sugar cane)",
    "FOODON_03307096": "vanilla pudding mix",
    "FOODON_03307184": "aloe honey",
    "FOODON_03540253": "02530 - gougere (efsa foodex2)",
    "FOODON_00002952": "leftover",
    "FOODON_03305436": "grenadine syrup",
    "FOODON_03543284": "32840 - fruit soft drink, gooseberry (efsa foodex2)",
    "NCBITaxon_147369": "Panicoideae",
    "FOODON_03543860": "38600 - offal based dishes (efsa foodex2)",
    "FOODON_03311293": "neufchatel cheese spread",
    "FOODON_03311447": "obsolete: cheese made from cow's milk",
    "FOODON_03308341": "cuban lobster tail (raw)",
    "FOODON_03401658": "10005789 - deer, other than roe deer - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03307155": "rice (flavored with chicken extract)",
    "FOODON_03541438": "14380 - cara caras (efsa foodex2)",
    "FOODON_00001054": "fermented fish or seafood food product",
    "FOODON_03413564": "toothed rock crab",
    "FOODON_03302440": "nut spread",
    "NCBITaxon_41475": "Antennaria <eudicots>",
    "FOODON_00002566": "focaccia",
    "FOODON_03543937": "39370 - pizza and similar with fish/seafood topping (efsa foodex2)",
    "NCIT_C14212": "Hamster",
    "FOODON_03400434": "oxidizing agent (codex)",
    "FOODON_03311582": "rye bran",
    "NCBITaxon_8108": "Scorpaenidae",
    "FOODON_00002656": "food (puffed)",
    "FOODON_03304047": "burgundy sauce",
    "FOODON_00002647": "food (broiled or grilled)",
    "FOODON_03541398": "13980 - vanilla (efsa foodex2)",
    "FOODON_03411123": "summer savory plant",
    "ENVO_00003074": "manufactured product",
    "FOODON_03541289": "12890 - other flower pistil spices (efsa foodex2)",
    "FOODON_03311494": "lactose-free non-dairy beverage",
    "NCBITaxon_150425": "Panulirus homarus",
    "FOODON_03301000": "starch food product",
    "FOODON_03301147": "pepper (pickled)",
    "FOODON_00001844": "field corn distinctive distilled spirit",
    "NCBITaxon_34814": "Coryphaena hippurus",
    "FOODON_03308767": "cockle (common, raw)",
    "FOODON_03400786": "uncured cheese (eurofir)",
    "FOODON_03412219": "coconut crab",
    "FOODON_03303774": "chocolate bon bon (containing bourbon whiskey)",
    "FOODON_03310597": "onion flake (dried)",
    "FOODON_03414998": "lemon thyme plant",
    "FOODON_03413511": "smooth-hound",
    "FOODON_03540412": "04120 - jew's mallow leaves (efsa foodex2)",
    "FOODON_03415025": "siberian kale plant",
    "FOODON_03315070": "whey (annatto colored)",
    "NCBITaxon_224711": "Opisthonema oglinum",
    "FOODON_03401197": "10000617 - sauces/spreads/dips/condiments variety packs (gs1 gpc)",
    "FOODON_03413271": "sodium propyl p-hydroxybenzoate",
    "FOODON_03308944": "peruvian fish (raw)",
    "FOODON_03544245": "42450 - cookies and cream flavour (efsa foodex2)",
    "FOODON_00003335": "food label serving",
    "FOODON_03490224": "multicomponent adhesive, organic solvent",
    "CHEBI_25848": "pantothenic acids",
    "FOODON_03415113": "persian shallot plant",
    "FOODON_03303734": "popcorn with peanuts (candy-coated)",
    "FOODON_03306236": "flavoring (natural)",
    "FOODON_03305424": "imitation ice cream",
    "FOODON_00002718": "ginger root",
    "FOODON_03543938": "39380 - pizza and similar with cheese topping (efsa foodex2)",
    "FOODON_03317531": "angelica (candied)",
    "FOODON_03301108": "fruit jam",
    "FOODON_03415104": "solanum plant",
    "FOODON_03413203": "potassium aluminium silicate",
    "FOODON_03304951": "golden onion soup",
    "FOODON_03317169": "root vegetable (dried)",
    "FOODON_03306649": "vegetable soup mix (chunky, dried)",
    "FOODON_03413724": "jew's ear",
    "FOODON_03301721": "prune (whole, dehydrated)",
    "FOODON_00001065": "blue cheese food product",
    "FOODON_00002209": "river herring food product",
    "PO_0025571": "multi-tissue plant structure development stage",
    "FOODON_03400753": "050  legume animal feeds (al) (ccpr)",
    "FOODON_03460101": "lactic acid fermentation",
    "FOODON_03316641": "confectionery biscuit",
    "NCBITaxon_6604": "Mya arenaria",
    "FOODON_03413519": "fish, squantiniform",
    "FOODON_03411210": "cotton plant",
    "NCBITaxon_243926": "Bagre marinus",
    "GAZ_00260188": "Tokelau",
    "CHEBI_24041": "flavin mononucleotide",
    "FOODON_03540662": "06620 - thorn apples (efsa foodex2)",
    "FOODON_03544145": "41450 - salad dressing (efsa foodex2)",
    "FOODON_03411356": "allspice plant",
    "FOODON_03412614": "argentine red shrimp",
    "FOODON_03543418": "34180 - coffee imitate ingredients (efsa foodex2)",
    "FOODON_00002101": "pear food product",
    "FOODON_03540817": "08170 - saint george's mushrooms (efsa foodex2)",
    "FOODON_03309633": "lake perch (raw)",
    "FOODON_03414612": "possum",
    "FOODON_03308389": "fish food (food product)",
    "FOODON_03308967": "emperor snapper (raw)",
    "NCBITaxon_3885": "Phaseolus vulgaris",
    "FOODON_03412863": "meagre",
    "FOODON_03420275": "whole animal, with skin, feathers or scales, not eviscerated",
    "FOODON_03490383": "alkyd resin container",
    "FOODON_03490409": "natural textile container",
    "FOODON_03401120": "10000292 - vegetable based products / meals - not ready to eat (shelf stable) (gs1 gpc)",
    "NCBITaxon_1968429": "Gardenieae complex",
    "FOODON_03400817": "bread and similar products (eurofir)",
    "FOODON_03316314": "fruit product (coated with sugar)",
    "FOODON_03490146": "paperboard container with plastic liner",
    "FOODON_03411422": "sheepshead",
    "NCBITaxon_4442": "Camellia sinensis",
    "FOODON_03414144": "sword razor",
    "FOODON_03540909": "09090 - epazote (efsa foodex2)",
    "FOODON_03400848": "cider, perry or similar drink (eurofir)",
    "FOODON_03400192": "pudding, starch (us cfr)",
    "FOODON_03304116": "white sauce mix",
    "NCBITaxon_84005": "Arbutus unedo",
    "FOODON_03309162": "lingcod (raw)",
    "FOODON_00003192": "hushpuppy",
    "FOODON_03301285": "strawberry (whole, frozen)",
    "FOODON_03414357": "sorbus plant",
    "FOODON_03415165": "ratany plant",
    "NCBITaxon_72045": "Syngnathidae",
    "NCBITaxon_691795": "Ethmidium maculatum",
    "FOODON_03306572": "chocolate milk (sterilized, sweetened)",
    "FOODON_03543140": "31400 - butter oil (efsa foodex2)",
    "NCBITaxon_94243": "Stromateidae",
    "FOODON_03411400": "pokeweed plant",
    "FOODON_03310855": "rapeseed oil press cake",
    "FOODON_03307769": "frankfurter (cooked, in bun, frozen)",
    "FOODON_03413259": "sodium hydrogen sulphite",
    "FOODON_03306917": "pecan (whole, raw, shell on)",
    "FOODON_03411566": "leafy vegetable",
    "FOODON_00001669": "brown trout food product",
    "FOODON_03401630": "10006306 - guinea fowl - prepared/processed (gs1 gpc)",
    "FOODON_03315538": "bakery product (mix, used in a similar way to bread)",
    "FOODON_03307697": "sweet and sour dressing",
    "FOODON_03311045": "nonfat dry milk (reconstituted)",
    "FOODON_03309152": "australian sea bream (raw)",
    "FOODON_03401621": "10005768 - bison/buffalo - prepared/processed (gs1 gpc)",
    "FOODON_03543073": "30730 - nougat raw mass (efsa foodex2)",
    "FOODON_03308794": "grouper fillet (raw)",
    "FOODON_03541755": "17550 - tamarillos (efsa foodex2)",
    "FOODON_00001604": "animal product sandwich",
    "FOODON_03413506": "einkorn plant",
    "FOODON_03411643": "hot pepper plant",
    "NCBITaxon_490590": "Metanephrops challengeri",
    "FOODON_03541074": "10740 - field beans (dry seeds) (efsa foodex2)",
    "FOODON_03541224": "12240 - hemp seeds and similar- (efsa foodex2)",
    "FOODON_03310791": "corn (on-the-cob, kernel or parts)",
    "FOODON_03306435": "ham-style vegetarian entree",
    "CHEBI_39418": "straight-chain saturated fatty acid",
    "FOODON_03310029": "fish (fermented)",
    "FOODON_00002840": "plant ash food product",
    "NCBITaxon_6579": "Pecten maximus",
    "FOODON_03541313": "13130 - nutmeg seed and similar- (efsa foodex2)",
    "FOODON_03308515": "game meat stock",
    "HANCESTRO_0531": "Djiboutian",
    "NCBITaxon_157791": "Vigna radiata",
    "FOODON_00002599": "Pinotage grape plant",
    "CHEBI_33860": "aromatic amine",
    "NCIT_C45305": "Mixture",
    "FOODON_00002634": "tortiglioni",
    "FOODON_03540925": "09250 - dwarf marigold (efsa foodex2)",
    "FOODON_03303881": "cranberry sauce (canned)",
    "FOODON_03308938": "scotch kipper fillet",
    "FOODON_03544467": "44670 - cyclamate (efsa foodex2)",
    "NCBITaxon_5192": "Morchellaceae",
    "FOODON_03305412": "filled sour cream",
    "FOODON_03310829": "green olive (whole, canned)",
    "FOODON_00002823": "sheep lung (whole, raw)",
    "FOODON_03401841": "10006746 - doodles/ puffs (gs1 gpc)",
    "NCBITaxon_3617": "Fagopyrum esculentum",
    "FOODON_03542047": "20470 - turkey kidney (efsa foodex2)",
    "FOODON_00001858": "obsolete: flax nut food product",
    "NCBITaxon_225060": "Micropterus punctulatus",
    "FOODON_03542858": "28580 - cheese, trappist (efsa foodex2)",
    "FOODON_03301349": "obsolete: molasses",
    "CHEBI_33839": "macromolecule",
    "HANCESTRO_0471": "Micronesian",
    "FOODON_03414187": "st. george's mushroom",
    "FOODON_03315893": "asparagus packed in glass containers or fully lined cans",
    "FOODON_03304244": "scottish hare soup (food product)",
    "FOODON_03316746": "corn (whole kernel, quick-frozen)",
    "NCBITaxon_134471": "Stramonita haemastoma",
    "FOODON_03301970": "hen egg liquid (pasteurized)",
    "CHEBI_36853": "hydroxy seco-steroid",
    "FOODON_00001854": "fish food product analog",
    "NCBITaxon_7815": "Prionace glauca",
    "UBERON_0019251": "4-cell stage embryo",
    "FOODON_03302057": "great northern bean (canned)",
    "FOODON_00002420": "has ingredient",
    "FOODON_03413489": "red huckleberry plant",
    "FOODON_03306517": "pine nut (whole, raw)",
    "FOODON_00002783": "soybean (whole, dried)",
    "NCBITaxon_3440": "Ranunculaceae",
    "FOODON_03308361": "lobster (stuffed)",
    "NCBITaxon_203262": "Epinephelus tauvina",
    "ENVO_00003859": "horse manure",
    "FOODON_03301393": "mushroom mycelium",
    "NCBITaxon_7586": "Echinodermata",
    "FOODON_03412629": "green bell pepper plant",
    "FOODON_03413367": "zebu",
    "NCBITaxon_278164": "Alosa alosa",
    "FOODON_03316649": "tea biscuit",
    "FOODON_03304885": "tomato (diced, canned)",
    "FOODON_00002505": "dairy cattle",
    "FOODON_03413698": "wellington flying squid",
    "GAZ_00006918": "Vanuatu",
    "NCBITaxon_984867": "Consolida regalis",
    "FOODON_03401730": "10006252 - vegetable juice - ready to drink (shelf stable) (gs1 gpc)",
    "FOODON_03541390": "13900 - brazilian pepper fruit (efsa foodex2)",
    "FOODON_03520142": "indian ocean, western (major fishing area 51)",
    "FOODON_03414719": "cycad plant",
    "NCBITaxon_9265": "Didelphidae",
    "FOODON_00002179": "pufferfish food product",
    "FOODON_03307609": "spaghetti sauce mix (italian-style, dry)",
    "FOODON_03301262": "olive (salad, pitted)",
    "FOODON_03543828": "38280 - textured fungal proteins (efsa foodex2)",
    "FOODON_03490100": "food packaging",
    "FOODON_03541484": "14840 - japanese quinces (efsa foodex2)",
    "ENVO_01001222": "commercial building",
    "FOODON_00002906": "whisker sheatfish",
    "FOODON_03308676": "freshwater shrimp (raw)",
    "FOODON_03542152": "21520 - cured unripened raw sausages (efsa foodex2)",
    "FOODON_03460366": "food flattening process",
    "FOODON_03412185": "snake mackerel",
    "FOODON_03311023": "coho salmon (canned)",
    "FOODON_03400451": "yeast food (codex)",
    "FOODON_03400809": "butter (eurofir)",
    "FOODON_00003071": "skunk currant (whole)",
    "FOODON_03412044": "chokecherry plant",
    "NCBITaxon_195609": "Eopsetta jordani",
    "FOODON_00001648": "black olive food product",
    "NCBITaxon_637930": "Aframomum melegueta",
    "FOODON_03302791": "mushroom-flavored sauce",
    "FOODON_03305433": "frozen custard (food product)",
    "FOODON_03305363": "chicken dinner",
    "FOODON_03500024": "food-grade enamel-coated surface",
    "FOODON_03414785": "rhyncharrhena plant",
    "FOODON_03316533": "kvas",
    "FOODON_03414530": "indian gooseberry tree",
    "FOODON_03543365": "33650 - fortified and liqueur wines (efsa foodex2)",
    "RO_0002215": "capable of",
    "FOODON_03302425": "frozen nondairy dessert (artificially sweetened)",
    "FOODON_03540181": "01810 - dried pasta (efsa foodex2)",
    "FOODON_03411539": "stone fruit",
    "NCBITaxon_13443": "Coffea arabica",
    "FOODON_03400459": "CIAA meat and meat products",
    "FOODON_03543513": "35130 - knotgrass infusion leaves (efsa foodex2)",
    "FOODON_03490359": "polyamide container",
    "FOODON_03306190": "lemonade (frozen concentrate, artificially sweetened)",
    "FOODON_03490267": "ceramic or earthenware jar, uncoloured",
    "FOODON_03304323": "coffee syrup",
    "FOODON_03305217": "garlic paste",
    "FOODON_00002024": "marlin food product",
    "FOODON_03414165": "pinniped group",
    "FOODON_03413359": "plant for medicinal use",
    "NCBITaxon_26496": "Strychnos",
    "FOODON_03306359": "mustard powder",
    "NCBITaxon_117915": "Oxynotidae",
    "BFO_0000016": "disposition",
    "FOODON_00002045": "moreton bay chestnut (vegetable) food product",
    "FOODON_03306519": "nut (whole, shell on)",
    "NCBITaxon_9608": "Canidae",
    "FOODON_03540849": "08490 - garden sorrel (efsa foodex2)",
    "FOODON_03303864": "dietetic cheese",
    "FOODON_03542093": "20930 - horse tongue (efsa foodex2)",
    "FOODON_03401534": "10006222 - dough based products / meals variety packs (gs1 gpc)",
    "NCBITaxon_1213707": "Rhinobatos rhinobatos",
    "FOODON_03301279": "plum (canned)",
    "FOODON_03305538": "clover honey",
    "FOODON_03301038": "cheese (mexican-style soft white)",
    "FOODON_03540394": "03940 - rape greens (efsa foodex2)",
    "FOODON_03490120": "paper bag, sack or pouch",
    "FOODON_03310930": "danbo cheese",
    "FOODON_00002797": "potato prepared food",
    "FOODON_03302236": "peppermint drink mix",
    "FOODON_03306125": "head lettuce (whole, raw)",
    "FOODON_03316969": "pudding (refrigerated, ready-to-serve)",
    "FOODON_03305181": "pear (halves, canned)",
    "FOODON_03530070": "grade p, europe",
    "FOODON_03412518": "fuzzy melon plant",
    "FOODON_03306713": "coffee cake filling",
    "FOODON_03544318": "43180 - medium hot flavour (efsa foodex2)",
    "FOODON_00003138": "dulce de leche",
    "FOODON_03308366": "blue crab (raw)",
    "FOODON_03414877": "pirapitinga",
    "FOODON_03510073": "no tropical oils added claim or use",
    "FOODON_03305515": "white bread mix (enriched)",
    "FOODON_03315245": "sugar cane juice (raw)",
    "FOODON_03311307": "sablefish smoked using hot-smoking nitrite-treated",
    "FOODON_03315430": "dripping from food",
    "FOODON_03302735": "pork (raw)",
    "FOODON_03308311": "fish (portion cut)",
    "FOODON_03415177": "actinidia plant",
    "FOODON_03310438": "plantain chip",
    "FOODON_03540048": "00480 - indian rice grain (efsa foodex2)",
    "FOODON_00002000": "lima bean food product",
    "FOODON_00001072": "obsolete: yeast cake food product",
    "FOODON_03411863": "petrale sole",
    "NCBITaxon_52619": "Chondrostoma nasus",
    "FOODON_03301196": "acidophilus lowfat milk",
    "FOODON_03305197": "ginseng (liquid extract)",
    "NCBITaxon_1579336": "Americhelydia",
    "FOODON_03401569": "10006061 - balm (gs1 gpc)",
    "NCBITaxon_48193": "Mugil cephalus",
    "FOODON_00002346": "whale meat food product",
    "FOODON_03400461": "CIAA egg and egg products",
    "PATO_0001544": "flexible",
    "FOODON_03541417": "14170 - canned or jarred common beans (efsa foodex2)",
    "FOODON_00003322": "yuzu food product",
    "FOODON_03304459": "high protein tablet",
    "FOODON_03415099": "sweet osmanthus plant",
    "CHEBI_36364": "alkaline earth salt",
    "FOODON_03301410": "grain byproduct",
    "FOODON_03311148": "mushroom whole in brine",
    "NCBITaxon_630654": "Coelorinchus aspercephalus",
    "FOODON_03304158": "barbeque seasoning (dry)",
    "FOODON_03413704": "gould's flying squid",
    "FOODON_03544445": "44450 - home-preparation aids (efsa foodex2)",
    "FOODON_03544289": "42890 - honey flavour (efsa foodex2)",
    "FOODON_03414993": "greek sage plant",
    "FOODON_03420180": "casein",
    "FOODON_00001721": "cherry preserve or jam food product",
    "NCBITaxon_381606": "Barbonymus gonionotus",
    "FOODON_03540193": "01930 - gnocchi (efsa foodex2)",
    "FOODON_03540707": "07070 - other fruiting vegetables (efsa foodex2)",
    "FOODON_03400400": "dispersing agent (codex)",
    "FOODON_03544390": "43900 - tangerine flavour (efsa foodex2)",
    "FOODON_03302662": "coffee-type beverage base (caffeine-free)",
    "CHEBI_32036": "potassium sulfate",
    "FOODON_03302910": "imitation cheese",
    "FOODON_03311216": "filbert nut (dry roasted)",
    "FOODON_03303154": "banana sugar wafer (artificially sweetened)",
    "NCBITaxon_4143": "Lamiales",
    "FOODON_03543242": "32420 - juice concentrate, plum (efsa foodex2)",
    "FOODON_03309033": "fish stick in armoricaine sauce",
    "FOODON_00001959": "hungarian wax pepper food product",
    "NCBITaxon_8257": "Limanda",
    "FOODON_03542260": "22600 - cachama (efsa foodex2)",
    "FOODON_03412101": "obsolete: sheep and goat",
    "FOODON_03316592": "gelatin for making artificial guts",
    "FOODON_00001044": "caprine milk beverage",
    "NCBITaxon_1489341": "Osteoglossocephalai",
    "NCBITaxon_23211": "Pyrus communis",
    "FOODON_03310809": "wheat gluten",
    "FOODON_03311632": "cake yellow",
    "FOODON_03544298": "42980 - kirsch flavour (efsa foodex2)",
    "FOODON_03542048": "20480 - duck kidney (efsa foodex2)",
    "FOODON_03530212": "conventional under glass/protected cultivation",
    "FOODON_03541853": "18530 - candied fruit, orange peel (efsa foodex2)",
    "CHEBI_26385": "purine alkaloid",
    "FOODON_03302467": "date nut bar",
    "NCBITaxon_29965": "Metacarcinus magister",
    "FOODON_03413920": "golden-striped goatfish",
    "FOODON_03411190": "summer squash plant",
    "FOODON_03412472": "longfin mako shark",
    "FOODON_03541783": "17830 - durians (efsa foodex2)",
    "FOODON_03309026": "mussel (sea, raw)",
    "FOODON_03400802": "fish or related organism (eurofir)",
    "FOODON_03420158": "pod or seed",
    "FOODON_03301738": "hard cheese",
    "FOODON_03490323": "acetate cellulose film",
    "FOODON_03460278": "food phosphating process",
    "FOODON_03400388": "cloud producing agent in non-alcoholic beverages (codex)",
    "FOODON_03542479": "24790 - shad roe (efsa foodex2)",
    "FOODON_00003046": "softneck garlic",
    "GAZ_00000566": "Libya",
    "FOODON_03316525": "malt extract used for baking",
    "NCBITaxon_4513": "Hordeum vulgare",
    "FOODON_00002240": "siluriform fish food product",
    "FOODON_03315990": "fish marinade",
    "FOODON_03301801": "akee (canned)",
    "FOODON_03309583": "pear tomato (canned)",
    "FOODON_03543914": "39140 - mixed vegetables, boiled (efsa foodex2)",
    "PATO_0001777": "decreased flexibility",
    "FOODON_03401685": "10006286 - water buffalo - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03304458": "spaghetti (wheat and soy)",
    "FOODON_03401169": "10000048 - herbs/spices (perishable) (gs1 gpc)",
    "FOODON_03311105": "konbu (whole or parts)",
    "FOODON_03308221": "sea salmon in oil (canned)",
    "FOODON_03540558": "05580 - rhubarbs (efsa foodex2)",
    "FOODON_03302486": "communion wafer",
    "FOODON_00002507": "taurine cattle",
    "FOODON_03305008": "salt (iodized)",
    "FOODON_03309587": "shrimp (tiny, peeled, cooked, frozen)",
    "NCBITaxon_40959": "Pimpinella saxifraga",
    "NCBITaxon_283034": "Sander canadensis",
    "FOODON_03311437": "almond oil",
    "FOODON_03544384": "43840 - sundried tomato flavour (efsa foodex2)",
    "NCBITaxon_59762": "Scyllarides",
    "FOODON_00001713": "chemical product based flavoring",
    "CHEBI_26397": "purine ribonucleoside monophosphate",
    "CHEBI_30768": "propionic acid",
    "FOODON_03316920": "sausage stuffed with pearl barley",
    "FOODON_03510096": "color-related claim or use",
    "NCBITaxon_1307774": "Atripliceae",
    "FOODON_03541275": "12750 - sage, dry (efsa foodex2)",
    "FOODON_03302252": "noncarbonated beverage (less than 10% fruit juice)",
    "FOODON_03540403": "04030 - pepper leaves (efsa foodex2)",
    "FOODON_03301344": "arak",
    "FOODON_00001989": "krill food product",
    "CHEBI_33284": "nutrient",
    "FOODON_00002523": "mealworm beetle",
    "FOODON_03414402": "fatty acid esters of ascorbic acid",
    "GAZ_00003987": "Gibraltar",
    "FOODON_03530018": "obsolete: cut of meat not known",
    "FOODON_03540915": "09150 - russian tarragon (efsa foodex2)",
    "NCBITaxon_533031": "Canarium schweinfurthii",
    "FOODON_03420310": "stamen",
    "FOODON_03414243": "foxtail millet plant",
    "FOODON_03411393": "strawberry plant",
    "FOODON_03543700": "37000 - hot drinks and similar (coffee, cocoa, tea and herbal infusions) (efsa foodex2)",
    "GAZ_00004414": "State of West Virginia",
    "FOODON_00002243": "nata de coco",
    "FOODON_03309508": "hero sandwich",
    "FOODON_03311863": "tater tot",
    "FOODON_03306302": "macaroni elbow (enriched, precooked)",
    "FOODON_03310790": "white bean (whole, dried)",
    "FOODON_03304066": "soda water (artifically sweetened)",
    "FOODON_03414349": "west african pebber plant",
    "NCBITaxon_3633": "Gossypium",
    "FOODON_03301498": "cow milk (homogenized)",
    "FOODON_03543053": "30530 - gum drops (efsa foodex2)",
    "FOODON_03544025": "40250 - prepared legume (beans) salad (efsa foodex2)",
    "FOODON_03414596": "north atlantic rockweed",
    "FOODON_03544034": "40340 - chips, crisps, fries and dough-based analogues (efsa foodex2)",
    "CHEBI_24555": "hexadienoic acid",
    "FOODON_03490277": "glass container, uncoloured, covered/protected",
    "NCBITaxon_31198": "Argopecten",
    "NCBITaxon_84620": "Ammodytes",
    "FOODON_03541593": "15930 - other species and hybrids of genera ribes and vaccinium, not elsewhere mentioned (efsa foodex2)",
    "FOODON_00001047": "obsolete: jeotgal food product",
    "FOODON_03316313": "shrimp (big, in airtight container)",
    "FOODON_03301548": "spice (ground)",
    "FOODON_03306304": "macaroni (egg)",
    "FOODON_03411898": "bergamot orange plant",
    "FOODON_03316966": "food for special dietary use",
    "FOODON_03401474": "10006120 - turnips (gs1 gpc)",
    "FOODON_03303611": "chocolate-coated candy",
    "FOODON_03308783": "flatfish (raw)",
    "FOODON_03413124": "iron oxides and hydroxides",
    "CHEBI_33969": "gold molecular entity",
    "CHEBI_50733": "nutraceutical",
    "FOODON_03302673": "pasteurized process cheese (artificially colored, spray-dried)",
    "FOODON_03302837": "icing mix",
    "FOODON_00001661": "bony fish food product",
    "FOODON_03317647": "fish ball",
    "FOODON_03543194": "31940 - juice, red currant (efsa foodex2)",
    "FOODON_03530089": "beverage base, dry",
    "FOODON_03310978": "chestnut (whole, raw)",
    "FOODON_03411948": "painted spiny lobster",
    "NCBITaxon_52121": "Calonectris",
    "FOODON_03306149": "cranberry juice (color added)",
    "NCBITaxon_39684": "Chitonidae",
    "FOODON_03307918": "imitation vinegar",
    "FOODON_03520502": "subarctic climatic zone",
    "FOODON_03412159": "yellow nutsedge plant",
    "FOODON_03540814": "08140 - piemont white truffles (efsa foodex2)",
    "FOODON_03413883": "cusk-eel",
    "FOODON_03543888": "38880 - roesti (efsa foodex2)",
    "FOODON_03540857": "08570 - borage (efsa foodex2)",
    "FOODON_03412203": "common spiny lobster",
    "NCBITaxon_9935": "Ovis",
    "FOODON_03542802": "28020 - cheese, butterkase (efsa foodex2)",
    "FOODON_03543304": "33040 - soft drink, apricot flavour (efsa foodex2)",
    "FOODON_03530239": "ichthyoallyeinotoxic poisoning",
    "FOODON_03316343": "hip-pulp (food product)",
    "FOODON_00001903": "ginseng tea",
    "HANCESTRO_0476": "Papua New Guinean",
    "FOODON_03307428": "vegetable juice (canned)",
    "HANCESTRO_0507": "Kenyan",
    "FOODON_03311599": "salmon oil",
    "CHEBI_38925": "benzopteridine",
    "FOODON_03309759": "pinto bean (whole)",
    "FOODON_03310935": "taleggio cheese",
    "FOODON_03303022": "ham stick",
    "CHEBI_31345": "Calcium pantothenate",
    "FOODON_03411207": "obsolete: prune",
    "FOODON_03301835": "oyster (frozen)",
    "FOODON_03304485": "wheat flour (agglomerated)",
    "FOODON_03414217": "tangerine plant",
    "FOODON_03304773": "plantain (fried)",
    "NCBITaxon_3498": "Morus alba",
    "FOODON_03542036": "20360 - pig kidney (efsa foodex2)",
    "FOODON_03317360": "poultry roll (cooked)",
    "FOODON_03309178": "golden kingklip (raw)",
    "FOODON_03304546": "root beer beverage syrup",
    "FOODON_03540951": "09510 - canned/jarred vegetables (efsa foodex2)",
    "NCBITaxon_8165": "Percidae",
    "FOODON_00002283": "strawberry preserve or jam",
    "NCBITaxon_4681": "Allium ampeloprasum",
    "FOODON_03490357": "plastic container, according to type of plastic",
    "FOODON_03414626": "scylla serrata",
    "FOODON_03316366": "potato product (dehydrated, made from cooked potatoes)",
    "ENVO_00010625": "zoological garden",
    "FOODON_03541429": "14290 - sweeties (efsa foodex2)",
    "FOODON_03541414": "14140 - sesame paste (tahini) (sesamus indicum) (efsa foodex2)",
    "FOODON_03411562": "fordhook lima bean plant",
    "FOODON_03543666": "36660 - herbal infusion materials from any other parts of the plant (efsa foodex2)",
    "FOODON_03317228": "wheat (cracked)",
    "NCBITaxon_3954": "Combretaceae",
    "FOODON_03306373": "ginger marmalade",
    "FOODON_03542555": "25550 - cuttlefish, common (efsa foodex2)",
    "FOODON_03310040": "lupine seed meal",
    "FOODON_03304956": "chicken consomme (condensed)",
    "FOODON_03543732": "37320 - jasmine infusion (efsa foodex2)",
    "FOODON_03411958": "olympia flat oyster",
    "FOODON_03413142": "magnesium salts of fatty acids",
    "FOODON_03401067": "50193500 - dairy/egg based products / meals (gs1 gpc)",
    "FOODON_00002836": "lamb neck",
    "FOODON_00002396": "synthetic vanilla extract",
    "FOODON_03303927": "chocolate-coated cherry",
    "FOODON_03308892": "schillerlocken",
    "FOODON_03316245": "dressing, lowfat",
    "FOODON_03412400": "arrowroot plant",
    "FOODON_03414904": "helicidae",
    "FOODON_03303885": "hoagie sandwich",
    "FOODON_03307040": "potato (french fry cut, canned)",
    "FOODON_03541943": "19430 - dromedary fresh meat (efsa foodex2)",
    "FOODON_03304774": "banana and mackerel (frozen)",
    "FOODON_03541265": "12650 - borage, dry (efsa foodex2)",
    "FOODON_03302120": "blueberry (frozen)",
    "FOODON_03414126": "white-spotted guitarfish",
    "FOODON_03401791": "10006122 - carrots (gs1 gpc)",
    "FOODON_03490126": "plastic tray or pan",
    "CHEBI_31794": "magnesium oxide",
    "FOODON_00002399": "mammalian milk cream (18%+)",
    "FOODON_03540901": "09010 - laurel (efsa foodex2)",
    "FOODON_03309073": "turbot fillet (raw)",
    "FOODON_03302466": "panettone",
    "FOODON_03543758": "37580 - infant formula, milk and soya-based, liquid (efsa foodex2)",
    "FOODON_00002978": "vegetable patty",
    "FOODON_03316004": "beverage (flavored, wine-based)",
    "FOODON_03540649": "06490 - peppers and similar- (efsa foodex2)",
    "CHEBI_38251": "magnesium tetrapyrrole",
    "FOODON_03413460": "indian bullfrog",
    "FOODON_03401848": "10006451 - tomatillos (gs1 gpc)",
    "FOODON_03307457": "skim milk (pasteurized, reconstituted)",
    "NCBITaxon_86204": "Periophthalmus",
    "NCBITaxon_31212": "Littorinidae",
    "FOODON_03400987": "50100000 - fruits/vegetables/nuts/seeds prepared/processed (gs1 gpc)",
    "FOODON_03301089": "shrimp (raw, breaded)",
    "FOODON_03302968": "chestnut puree",
    "FOODON_03490108": "glass container, plastic lid, paper lining",
    "FOODON_03309974": "jam (reduced sugar)",
    "FOODON_03301121": "chicken (raw)",
    "FOODON_03315721": "meat (cut)",
    "FOODON_03308441": "jack mackerel (raw)",
    "FOODON_03413707": "garden parley plant",
    "FOODON_03412475": "teff plant",
    "HANCESTRO_0433": "Azerbaijani",
    "FOODON_03305025": "cherry genoa cake",
    "FOODON_00002252": "soft cheese food product",
    "FOODON_00002158": "food (preserved)",
    "FOODON_03305804": "dessert powder (food product)",
    "FOODON_03306347": "pasta",
    "HANCESTRO_0020": "Taiwanese",
    "FOODON_03304597": "hare (jugged, in wine sauce)",
    "FOODON_03413530": "carribean reef shark",
    "NCBITaxon_490311": "Brachydeuterus auritus",
    "FOODON_00002471": "prepared seafood product",
    "NCBITaxon_13749": "Vaccinium",
    "FOODON_03302316": "butter pecan roll",
    "FOODON_03412878": "ratfish",
    "FOODON_03460160": "alcoholization process",
    "FOODON_03412675": "yellowbelly flounder",
    "FOODON_00001657": "blueberry preserve or jam food product",
    "FOODON_03420213": "fruit, peel undetermined, core, pit or seed removed",
    "FOODON_03309581": "smoked meat",
    "FOODON_03308697": "mahi mahi (raw)",
    "FOODON_03315121": "hen egg tube",
    "FOODON_03401161": "10000138 - aquatic plants unprepared/unprocessed (frozen) (gs1 gpc)",
    "NCBITaxon_3481": "Cannabaceae",
    "FOODON_03414662": "davidson plum plant",
    "FOODON_03309113": "slime head (raw)",
    "FOODON_03306150": "prune juice (fabricated, artificially sweetened)",
    "PO_0009049": "inflorescence",
    "FOODON_03544479": "44790 - vitamin b6   (pyridoxine, pyridoxamine, pyridoxal) (efsa foodex2)",
    "NCBITaxon_6737": "Panulirus argus",
    "FOODON_03414752": "wilcannia lily plant",
    "FOODON_03316282": "anchovy (whole)",
    "FOODON_03307343": "meat hash",
    "FOODON_03311587": "pork (processed)",
    "FOODON_03311071": "potato (whole, freeze dried)",
    "FOODON_03411044": "jack",
    "FOODON_03470178": "high temperature short time (htst) pasteurization",
    "FOODON_03303026": "chicken parts (frozen)",
    "FOODON_03309211": "red hake (raw)",
    "NCBITaxon_3726": "Raphanus sativus",
    "FOODON_00001324": "pla-chom",
    "FOODON_00002538": "quesadilla",
    "FOODON_03400938": "10000160 - biscuits/cookies (perishable) (gs1 gpc)",
    "FOODON_03307798": "hipberry tea mix (dry)",
    "FOODON_03316895": "infant gruel (powdered)",
    "FOODON_03317142": "food for invalids, liquid",
    "FOODON_03540036": "00360 - oat grain, red (efsa foodex2)",
    "CHEBI_53226": "polyethylene macromolecule",
    "NCBITaxon_46328": "Gahnia",
    "FOODON_03420120": "whole animal, skinned, defeathered or scaled, eviscerated",
    "CHEBI_22470": "alpha-tocopherol",
    "NCBITaxon_6703": "Pandalus borealis",
    "FOODON_03543809": "38090 - vitamin and mineral supplements (efsa foodex2)",
    "FOODON_00001962": "ice cream product analog",
    "FOODON_03306814": "lathyrus pea (whole, raw)",
    "FOODON_03414105": "patagonian smooth-hound",
    "FOODON_03304497": "edible seed food product",
    "FOODON_03305182": "curry (instant)",
    "FOODON_03311755": "cauliflower (pickled)",
    "FOODON_03411680": "obsolete: sugar cane and field corn",
    "FOODON_03543686": "36860 - purging cassia (infusion fruits) (efsa foodex2)",
    "FOODON_03543725": "37250 - tea beverages (efsa foodex2)",
    "FOODON_03309525": "cream of potato-flavor soup mix",
    "FOODON_03306732": "sweet red bell pepper (whole, raw)",
    "FOODON_03543141": "31410 - ghee (efsa foodex2)",
    "FOODON_03541633": "16330 - saskatoons (efsa foodex2)",
    "FOODON_03304724": "confectionery coating",
    "FOODON_03530255": "protected designation of origin (pdo)",
    "FOODON_03460847": "taurine",
    "FOODON_03413069": "copper complexes of chlorophyllins",
    "NCBITaxon_1940530": "Brassica juncea subsp. integrifolia",
    "FOODON_03470114": "food sterilization by hot filling and cooling",
    "FOODON_03542129": "21290 - cooked cured (or seasoned) bovine meat (efsa foodex2)",
    "FOODON_03309523": "potato (sliced, dehydrated)",
    "NCBITaxon_3559": "Chenopodium album",
    "FOODON_03543997": "39970 - fruit soup, dry (efsa foodex2)",
    "FOODON_00001774": "cow milk cheese cake food product",
    "FOODON_03304038": "fruit sauce",
    "FOODON_03302085": "beef protein (hydrolyzed)",
    "NCBITaxon_4028": "Geranium",
    "NCBITaxon_30092": "Psyllidae",
    "GAZ_00002699": "Kingdom of Norway",
    "FOODON_03307081": "almond preserves",
    "FOODON_03304764": "pecan (whole or parts)",
    "FOODON_03307512": "grape beverage syrup",
    "NCBITaxon_8496": "Alligator mississippiensis",
    "FOODON_03310379": "silk worm pupae for animal feed",
    "NCBITaxon_360518": "Metanephrops rubellus",
    "FOODON_03540754": "07540 - additional not listed root and tuber vegetables (excluding starchy- and sugar-) (efsa foodex2)",
    "FOODON_03542660": "26600 - european buffalo milk (efsa foodex2)",
    "FOODON_03302089": "beef stew seasoning",
    "FOODON_03411865": "slender sole",
    "FOODON_00001935": "green bell pepper food product",
    "FOODON_03307503": "apricot (artificially sweetened, canned)",
    "FOODON_03309597": "apple apricot spread",
    "NCBITaxon_79629": "Fulmarus glacialoides",
    "FOODON_00002993": "cooked bratwurst",
    "HANCESTRO_0355": "Channel Islander",
    "FOODON_03543620": "36200 - ylang-ylang infusion flowers (efsa foodex2)",
    "FOODON_00003006": "filled milk food product",
    "FOODON_03420262": "pod containing full-size seeds",
    "FOODON_03540985": "09850 - lotus roots (efsa foodex2)",
    "FOODON_03411438": "black sea bass",
    "FOODON_03309088": "whiting (raw)",
    "FOODON_00003345": "banana (overripe, raw)",
    "FOODON_03315539": "confectionery flour",
    "FOODON_00002254": "soft wheat food product",
    "FOODON_03541655": "16550 - kumquats (efsa foodex2)",
    "NCBITaxon_110284": "Eleocharis dulcis",
    "FOODON_03305345": "gelatin dessert (prepared)",
    "NCBITaxon_1489931": "Spariformes",
    "FOODON_03411709": "obsolete: orange and apricot",
    "FOODON_03301733": "samsoe cheese",
    "NCBITaxon_218797": "Lutjanus malabaricus",
    "NCBITaxon_4042": "Petroselinum",
    "FOODON_03541748": "17480 - papayas (efsa foodex2)",
    "FOODON_03414953": "purple chokeberry plant",
    "FOODON_03301774": "asparagus (raw)",
    "FOODON_03413952": "cape horse mackerel",
    "FOODON_03530146": "cut of meat",
    "NCBITaxon_69291": "Gasterosteidae",
    "FOODON_03411294": "chive plant",
    "FOODON_03412005": "drum family",
    "FOODON_03412814": "tooth-brush tree",
    "FOODON_03302657": "chewing gum (caffeinated, vitamin-fortified)",
    "FOODON_03541340": "13400 - bark spices (efsa foodex2)",
    "FOODON_03315819": "sweetener, table-top, containing aspartame, tablet form",
    "FOODON_03412603": "fusilier",
    "FOODON_03303920": "peppermint",
    "FOODON_03315680": "fish and meat blend (prepared)",
    "FOODON_00002483": "ricefield rat",
    "FOODON_03301071": "cocoa bean (whole, raw)",
    "FOODON_03542497": "24970 - indo-pacific swamp crab (efsa foodex2)",
    "FOODON_03530273": "yellow flesh",
    "FOODON_03411755": "Carangidae family",
    "FOODON_03311389": "pizza (frozen)",
    "FOODON_03304657": "creole roux and gravy mix (instant)",
    "FOODON_03411728": "celtuce plant",
    "FOODON_03401721": "10005968 - mangosteen (gs1 gpc)",
    "FOODON_03400185": "uncured cheese (us cfr)",
    "FOODON_03317395": "beef cut (fresh)",
    "FOODON_03401458": "10006339 - gai choy (mustard greens) (gs1 gpc)",
    "FOODON_03413438": "alocasia plant",
    "PATO_0000117": "size",
    "FOODON_03541239": "12390 - olives for oil production and similar- (efsa foodex2)",
    "FOODON_03414828": "thin leaved plum plant",
    "FOODON_03540277": "02770 - croissant (efsa foodex2)",
    "FOODON_03301557": "oregano leaf (whole)",
    "FOODON_03304469": "butter and margarine mixture",
    "FOODON_03304065": "club soda (food product)",
    "FOODON_00002360": "white asparagus vegetable food product",
    "FOODON_03544250": "42500 - cream flavour (efsa foodex2)",
    "GAZ_00002935": "El Salvador",
    "FOODON_03530074": "formulated mix",
    "FOODON_03304973": "chewing gum (nutritively sweetened)",
    "FOODON_03411593": "peach, clingstone (plant)",
    "CHEBI_37015": "ribonucleoside 5'-phosphate",
    "FOODON_03316465": "bakery good (lye treated)",
    "NCBITaxon_490586": "Metanephrops arafurensis",
    "FOODON_03430168": "spray supplement",
    "FOODON_03306411": "ova (hen)",
    "FOODON_03308989": "bank rockfish (raw)",
    "FOODON_03309900": "kidney bean flour",
    "FOODON_03311745": "pepper (dehydrated)",
    "FOODON_03401571": "10006047 - borage (gs1 gpc)",
    "FOODON_03305850": "jackfruit (canned)",
    "FOODON_00001807": "devilfish food product",
    "NCBITaxon_129061": "Scomberesox saurus",
    "FOODON_03316953": "macaroni product (vegetable, enriched)",
    "NCBITaxon_107376": "Gallinago",
    "FOODON_00002937": "soursop",
    "FOODON_03414149": "south atlantic scallop",
    "FOODON_03500046": "food-grade cork surface",
    "FOODON_03544197": "41970 - barley flavour (efsa foodex2)",
    "FOODON_03310342": "balsam apple leaf food product",
    "FOODON_03411607": "nut or edible seed producing plant",
    "FOODON_03411340": "skate",
    "FOODON_03308695": "clam (stuffed)",
    "FOODON_03542269": "22690 - climbing perch (efsa foodex2)",
    "OBI_0001885": "specimen repository organization",
    "NCBITaxon_140311": "Prunus cerasus",
    "FOODON_03303592": "chocolate cream pie mix",
    "FOODON_00002349": "wheat based gravy or sauce food product",
    "FOODON_03308499": "game bird meat (raw)",
    "FOODON_03302518": "nut and seed butter (food product)",
    "NCBITaxon_76931": "Nemadactylus macropterus",
    "NCBITaxon_123366": "Eurypterygia",
    "FOODON_03309711": "butterfly mackerel (raw)",
    "FOODON_03413806": "green iguana",
    "FOODON_03311673": "carrot (peeled)",
    "CHEBI_50744": "citrate salt",
    "FOODON_03400703": "13  nuts (efg)",
    "FOODON_03306905": "virginia peanut (whole, skin off, salted)",
    "FOODON_03414992": "kitchen sage plant",
    "FOODON_03305079": "pineapple (immature, sliced, in brine)",
    "FOODON_03401632": "10005774 - horse - prepared/processed (gs1 gpc)",
    "FOODON_03541088": "10880 - stink beans (dry) (efsa foodex2)",
    "FOODON_03542816": "28160 - cheese, fontina (efsa foodex2)",
    "FOODON_03316144": "liquer (egg based)",
    "FOODON_03306962": "japanese noodle",
    "FOODON_03400299": "light wine, 7-14% alcohol (us cfr)",
    "FOODON_03304616": "hen egg (whole, shell on, raw)",
    "FOODON_00002512": "blueberry juice",
    "NCBITaxon_8180": "Centrarchidae",
    "FOODON_03530249": "tetrodotoxic poisoning",
    "NCBITaxon_133204": "Prunus virginiana",
    "FOODON_00002230": "semihard cheese product",
    "FOODON_03414271": "ensete plant",
    "FOODON_03401294": "3500 ethnic foods (usda sr)",
    "FOODON_03309654": "mushroom (debrined)",
    "FOODON_03414599": "brown meagre",
    "FOODON_03541668": "16680 - jaboticabas (efsa foodex2)",
    "FOODON_03544424": "44240 - antioxidant (efsa foodex2)",
    "FOODON_03301885": "potato (whole, canned)",
    "FOODON_03311896": "madeira cake",
    "NCIT_C25464": "Country",
    "NCBITaxon_41946": "Saxifragales",
    "FOODON_03309083": "atlantic halibut (raw)",
    "NCBITaxon_316135": "Seriolella brama",
    "ENVO_00003900": "rye grass silage",
    "FOODON_03316066": "tea infusion",
    "FOODON_03543378": "33780 - unsweetened spirits and liqueurs (efsa foodex2)",
    "FOODON_03543187": "31870 - juice, mango (efsa foodex2)",
    "FOODON_03401392": "50260300 - tomatoes (gs1 gpc)",
    "FOODON_03540080": "00800 - rye flour, medium (efsa foodex2)",
    "FOODON_03309656": "finnan haddie",
    "NCBITaxon_141541": "Carissa carandas",
    "FOODON_03544452": "44520 - enzymes for food manufacture (efsa foodex2)",
    "FOODON_03411192": "black currant plant",
    "FOODON_03302206": "beef bouillon concentrate",
    "NCBITaxon_147389": "Triticeae",
    "FOODON_03541567": "15670 - lowbush blueberry (efsa foodex2)",
    "FOODON_03310077": "squid raw",
    "NCBITaxon_40949": "Angelica archangelica",
    "FOODON_03414379": "greater kudu",
    "FOODON_03308218": "oyster (korean, cooked, frozen)",
    "FOODON_03310114": "linseed seed",
    "FOODON_03414572": "northern minke whale",
    "FOODON_03541980": "19800 - wild goose fresh meat (efsa foodex2)",
    "FOODON_03414646": "plant louse",
    "FOODON_03542302": "23020 - coho salmon (efsa foodex2)",
    "FOODON_03543191": "31910 - juice, pear (efsa foodex2)",
    "FOODON_03541312": "13120 - fenugreek seed (efsa foodex2)",
    "FOODON_03315444": "flavoring oil or concentrate",
    "FOODON_03430160": "hard gelatin capsule",
    "ENVO_00003030": "silage",
    "FOODON_03414182": "coral tooth mushroom",
    "FOODON_03305791": "butter pecan ice cream",
    "FOODON_03304462": "grape juice (artificially sweetened)",
    "FOODON_03542814": "28140 - cheese, edam (efsa foodex2)",
    "FOODON_00002031": "milk based gravy or sauce food product",
    "FOODON_03317464": "ouzo",
    "FOODON_03400333": "emulsifier (ec)",
    "FOODON_03302479": "egg raisin bread",
    "FOODON_03411669": "lamb",
    "FOODON_03304695": "imitation milk base",
    "FOODON_03411404": "cucumber plant",
    "FOODON_03411166": "atlantic horse mackerel",
    "FOODON_03413990": "lesser tuna",
    "FOODON_03311495": "candy bar (snack-sized)",
    "NCBITaxon_6753": "Cancridae",
    "FOODON_03542928": "29280 - firm-ripened cheese with added herbs, spices or other ingredients (efsa foodex2)",
    "FOODON_03411551": "salsify plant",
    "FOODON_03307890": "crustacean (canned)",
    "CHEBI_83811": "proteinogenic amino acid derivative",
    "CHEBI_32035": "potassium hydroxide",
    "FOODON_03401367": "50261400 - beans (with pods) (gs1 gpc)",
    "FOODON_03412055": "cocklebur plant",
    "FOODON_03310716": "fish paste (fried)",
    "FOODON_03544203": "42030 - black tea flavour (efsa foodex2)",
    "FOODON_03310801": "pork (barbequed)",
    "FOODON_03401820": "10006370 - sapote (white) (gs1 gpc)",
    "FOODON_03412423": "croaking gourami",
    "FOODON_03543052": "30520 - liquorice candies (efsa foodex2)",
    "NCBITaxon_3642": "Lecythidaceae",
    "FOODON_03543747": "37470 - food products for young population (efsa foodex2)",
    "FOODON_03414774": "star grass plant",
    "FOODON_03315451": "wakame",
    "FOODON_03540681": "06810 - ivy gourds (efsa foodex2)",
    "FOODON_03310417": "lychee fruit (peeled, raw)",
    "FOODON_03413597": "urugavian lobster",
    "FOODON_03414654": "small-leaved tamarind plant",
    "NCBITaxon_39173": "Ocimum",
    "FOODON_03411239": "thread herring",
    "ENVO_00000043": "wetland area",
    "FOODON_03312059": "corn bread product",
    "FOODON_03309556": "tamari sauce",
    "FOODON_03305131": "cream substitute",
    "FOODON_03315415": "beverage (skim milk based)",
    "FOODON_00001697": "cattle product based flavoring or seasoning",
    "FOODON_03413901": "southern kingfish",
    "FOODON_03309482": "water buffalo (ground, pattie)",
    "FOODON_03304853": "peach jam",
    "FOODON_03401072": "10005228 - dairy/egg based products / meals - ready to eat (shelf stable) (gs1 gpc)",
    "CHEBI_50860": "organic molecular entity",
    "FOODON_03543198": "31980 - other fruit nectars (efsa foodex2)",
    "FOODON_00002541": "quesa chihuahua",
    "NCBITaxon_1442372": "Eriphia smithii",
    "NCBITaxon_22274": "Myristicaceae",
    "FOODON_03544315": "43150 - masala hot flavour (efsa foodex2)",
    "FOODON_03490296": "aluminium foil-paper wrapper",
    "FOODON_03309398": "coffee (instant, with natural chicory flavor extract)",
    "FOODON_03414167": "ocellated turkey",
    "NCBITaxon_384382": "Scomberomorus sinensis",
    "FOODON_03301376": "spinach (frozen)",
    "FOODON_03542972": "29720 - egg powder (efsa foodex2)",
    "FOODON_03544425": "44250 - flavour enhancer (efsa foodex2)",
    "FOODON_00002468": "lobster (whole)",
    "FOODON_03490196": "ampul",
    "FOODON_03415141": "ironwort plant",
    "FOODON_03316596": "dessert soft cheese",
    "FOODON_03510149": "no or reduced cholesterol claim or use",
    "FOODON_00001977": "jelly candy food product",
    "FOODON_03412607": "yellow bullhead",
    "FOODON_03307269": "peanut cluster (artificially vanilla- and maple-flavored)",
    "FOODON_03311083": "capsicum pepper (chopped)",
    "FOODON_03543467": "34670 - blackberry infusion leaves (efsa foodex2)",
    "FOODON_03303801": "candy (liquor-filled)",
    "ENVO_00003860": "pig manure",
    "NCBITaxon_9963": "Caprinae",
    "FOODON_03470158": "pasteurization by heat after filling",
    "FOODON_03400411": "flavour adjunct (codex)",
    "FOODON_03413361": "freshwater fish",
    "FOODON_03430175": "edible gel",
    "NCBITaxon_55708": "Cardiidae",
    "FOODON_03541260": "12600 - dried herbs (efsa foodex2)",
    "FOODON_03412618": "killifish family",
    "FOODON_03316375": "guava (dried)",
    "FOODON_03543972": "39720 - rice based dishes dry, uncooked (efsa foodex2)",
    "FOODON_03411101": "bitter melon plant",
    "FOODON_03542221": "22210 - silver carp (efsa foodex2)",
    "FOODON_03543949": "39490 - meat-based canap\u00e9 (efsa foodex2)",
    "FOODON_03414544": "baru plant",
    "FOODON_03316638": "beef bacon",
    "FOODON_03306758": "paprika pepper (pickled)",
    "NCBITaxon_36610": "Cydonia oblonga",
    "FOODON_03400280": "cold-pack cheese (us cfr)",
    "FOODON_00001763": "coriander food product",
    "FOODON_03304255": "spring soup",
    "FOODON_03303740": "fruit bonbon",
    "NCBITaxon_26000": "Elaeocarpaceae",
    "FOODON_03542264": "22640 - marble goby (efsa foodex2)",
    "FOODON_03315447": "whale meat (fresh)",
    "FOODON_03510270": "navajo food claim or use",
    "FOODON_03413761": "vitamin b12",
    "FOODON_03316023": "fish roe product",
    "FOODON_03413815": "fringe-barbel sturgeon",
    "FOODON_03400181": "food additive (us cfr)",
    "FOODON_03304011": "brandy sauce",
    "FOODON_03306227": "maraschino-flavored pineapple pieces",
    "FOODON_03000004": "green mud crab",
    "FOODON_03541781": "17810 - other species of genus artocarpus, not elsewhere mentioned (efsa foodex2)",
    "FOODON_03542439": "24390 - cobia (efsa foodex2)",
    "CHEBI_23982": "ethanols",
    "FOODON_03412516": "ayu",
    "FOODON_03304678": "cow milk (vitamin d, homogenized)",
    "CHEBI_25384": "monocarboxylic acid",
    "FOODON_03309386": "pudding sugar-free instant",
    "FOODON_03305514": "imitation sour rye bread flavor",
    "FOODON_03413703": "lesser flying squid",
    "FOODON_03308045": "fish skin",
    "FOODON_03520388": "subtropical reef fishing area",
    "FOODON_03414649": "transwaal red milkwood plant",
    "NCBITaxon_207598": "Homininae",
    "FOODON_00002418": "food (canned)",
    "FOODON_03311390": "fudge cake",
    "FOODON_03308852": "south atlantic king crab (raw)",
    "FOODON_03540912": "09120 - mexican oregano (efsa foodex2)",
    "FOODON_03305502": "ice milk mix",
    "FOODON_03304916": "chicken-flavored soup",
    "CHEBI_27306": "vitamin B6",
    "FOODON_03412970": "bog bilberry plant",
    "FOODON_03415159": "forking larkspur plant",
    "FOODON_03542250": "22500 - yellow catfish (efsa foodex2)",
    "FOODON_03303747": "butter-flavored mint",
    "FOODON_03307557": "sugar and invert sugar syrup",
    "FOODON_03490430": "polyethylene terephthalate (pet) container",
    "FOODON_03412985": "allura red ac",
    "PO_0009086": "endocarp",
    "FOODON_03415155": "beebalm plant",
    "FOODON_03307771": "tuna salad sandwich",
    "FOODON_03520128": "asia - inland waters (fao major fishing areas 04)",
    "FOODON_03317559": "bitter vino",
    "FOODON_03414713": "native turmeric plant",
    "NCBITaxon_225389": "Aplodinotus grunniens",
    "FOODON_03543551": "35510 - walnut infusion leaves (efsa foodex2)",
    "FOODON_03510099": "flavor- or taste-related claim or use",
    "FOODON_03317222": "lumpfish roe semi-preserved",
    "FOODON_03307014": "peach (spice and flavoring added, canned)",
    "FOODON_03316074": "vegetable protein",
    "GO_0009987": "cellular process",
    "FOODON_03302829": "diabetic chocolate",
    "FOODON_03315165": "shortening, liquid",
    "FOODON_03315242": "obsolete: potato (any form excluding frozen, canned, or dehydrated)",
    "FOODON_03311598": "mutton (minced, cooked)",
    "FOODON_03302560": "hominy (golden, canned)",
    "FOODON_03400847": "beer or beer-like beverage (eurofir)",
    "GAZ_00002929": "Colombia",
    "FOODON_00003173": "Lacinato kale",
    "FOODON_03542430": "24300 - spanish mackerel (efsa foodex2)",
    "NCBITaxon_1489923": "Eupercaria incertae sedis",
    "FOODON_03411232": "Zia mays plant",
    "FOODON_03308764": "clam (whole, raw)",
    "FOODON_00001167": "amaranthaceous food product",
    "FOODON_03305343": "gelatin dessert (naturally and artificially flavored)",
    "FOODON_00002249": "sodium chloride flavoring or seasoning food product",
    "FOODON_03315811": "beverage base for addition to milk, flavored",
    "FOODON_03413082": "dipotassium phosphate",
    "NCBITaxon_42526": "Colossoma macropomum",
    "FOODON_03304437": "mexican dinner",
    "FOODON_03500029": "Polyvinylidene chloride surface",
    "NCBITaxon_2231385": "core genistoids",
    "FOODON_03412615": "gecko",
    "CHEBI_33317": "boron group element atom",
    "FOODON_00002194": "red snapper food product",
    "FOODON_03400698": "08  sugar products, excluding chocolate (efg)",
    "GAZ_00003152": "State of Michigan",
    "FOODON_03541876": "18760 - meat and meat products (efsa foodex2)",
    "RO_0000086": "has quality",
    "NCBITaxon_186623": "Actinopteri",
    "FOODON_03400764": "068  vegetable oils, edible (or refined) (or) (ccpr)",
    "FOODON_03307030": "potato (whole, peeled, raw)",
    "NCBITaxon_6652": "Chitonida",
    "FOODON_00003304": "T-bone steak",
    "FOODON_03311405": "sweet sake",
    "FOODON_03510267": "native american food claim or use",
    "FOODON_03542897": "28970 - cheese, fiore sardo (efsa foodex2)",
    "NCBITaxon_8915": "Larus fuscus",
    "NCBITaxon_8917": "Scolopacidae",
    "FOODON_03415008": "holy basil plant",
    "FOODON_03310924": "confectionery (frozen)",
    "FOODON_03414015": "cephalopholis",
    "FOODON_03311117": "cream of celery soup (condensed, canned)",
    "ENVO_00000009": "national geopolitical entity",
    "NCBITaxon_4751": "Fungi",
    "FOODON_03316682": "fish flesh (minced, quick-frozen in blocks)",
    "FOODON_03401459": "10006823 - gai lan (gs1 gpc)",
    "FOODON_03304034": "bloody mary mix (food product)",
    "FOODON_03309107": "sucker (raw)",
    "FOODON_03311856": "tripe lamb",
    "FOODON_03316097": "liqueur (emulsified)",
    "FOODON_00002293": "sugar palm sweetener food product",
    "FOODON_03413502": "salema",
    "FOODON_03544113": "41130 - teriyaki sauce (efsa foodex2)",
    "FOODON_03490004": "obsolete: container or wrapping, other",
    "FOODON_03541116": "11160 - other pulses (e) (efsa foodex2)",
    "ENVO_00000300": "scrubland area",
    "FOODON_03530247": "paralytic shellfish poisoning",
    "NCBITaxon_129788": "Ruditapes philippinarum",
    "PO_0009084": "pericarp",
    "FOODON_03543854": "38540 - beef loaf (efsa foodex2)",
    "NCBITaxon_122399": "Boerhavia",
    "FOODON_03543036": "30360 - bitter-sweet chocolate (efsa foodex2)",
    "FOODON_00003382": "single country-of-origin product",
    "FOODON_03301960": "bacon (canned)",
    "FOODON_03414880": "marble goby",
    "FOODON_03530085": "processed in wood container",
    "PO_0030096": "circumscissile capsule fruit",
    "FOODON_03460268": "food puffing process",
    "FOODON_03413856": "harengula",
    "FOODON_03309841": "citrus waste (dried)",
    "NCBITaxon_251531": "Ensis siliqua",
    "FOODON_03308451": "little tunny tuna (raw)",
    "FOODON_03411847": "obsolete: pacific sardine",
    "FOODON_03541835": "18350 - fruit compote, peach (efsa foodex2)",
    "FOODON_03544224": "42240 - carob flavouring (efsa foodex2)",
    "FOODON_03308719": "skipjack tuna (raw)",
    "NCBITaxon_7865": "Callorhinchidae",
    "FOODON_00002917": "gorilla",
    "FOODON_03301093": "tuna (cured, smoked)",
    "FOODON_03542811": "28110 - cheese, derby (efsa foodex2)",
    "FOODON_03543991": "39910 - potato soup, dry (efsa foodex2)",
    "FOODON_03308655": "sea snail (raw)",
    "FOODON_03540586": "05860 - french grey shallots (efsa foodex2)",
    "FOODON_03411336": "crambe plant",
    "FOODON_03412815": "sorindeia plant",
    "FOODON_03316453": "seasoning substance",
    "FOODON_03309911": "african mudfish (raw)",
    "FOODON_03305639": "marshmallow",
    "FOODON_03311079": "noodle (egg, cooked)",
    "FOODON_03544210": "42100 - boysenberry flavour (efsa foodex2)",
    "FOODON_03311780": "largemouth bass (raw)",
    "FOODON_00003201": "landjaeger",
    "FOODON_00002866": "Medjool date",
    "IAO_0000232": "curator note",
    "FOODON_03301717": "sweet potato (whole, raw)",
    "FOODON_00002725": "pabda fish",
    "FOODON_03400712": "22  wine (efg)",
    "FOODON_03310591": "beef round steak (raw)",
    "FOODON_03543120": "31200 - fats and oils from terrestrial animals (efsa foodex2)",
    "FOODON_03301880": "kidney (chopped)",
    "FOODON_03301931": "wheat roll or bun",
    "FOODON_03544155": "41550 - milk protein (efsa foodex2)",
    "FOODON_03304893": "romano cheese (grated)",
    "FOODON_03301329": "white chocolate",
    "FOODON_03541208": "12080 - other seeds of species of familia cucurbitaceae, not elsewhere mentioned (efsa foodex2)",
    "FOODON_03412841": "cordyla plant",
    "NCBITaxon_3268": "Polypodiales",
    "FOODON_03308616": "crab imperial (dish)",
    "NCBITaxon_472369": "Vaccinium angustifolium",
    "FOODON_03543046": "30460 - chocolate coated confectionery (efsa foodex2)",
    "FOODON_03317608": "dairy product (nut flavored)",
    "FOODON_03542706": "27060 - kefir (efsa foodex2)",
    "FOODON_03460351": "chemical leavening agent addition process",
    "FOODON_03301961": "bacon puff",
    "RO_0002328": "functionally related to",
    "FOODON_03412230": "horse crab family",
    "FOODON_03544423": "44230 - preservative (efsa foodex2)",
    "FOODON_03414839": "bunya pine tree",
    "FOODON_03542170": "21700 - braunschweiger (efsa foodex2)",
    "FOODON_03510123": "unbleached claim or use",
    "FOODON_03315060": "malt beverage containing fruit juice less than 7% ethanol by volume",
    "CHEBI_36141": "quinone",
    "NCBITaxon_53747": "Echinacea <eudicots>",
    "FOODON_03540059": "00590 - emmer wheat grain (efsa foodex2)",
    "FOODON_03413497": "japanese eel",
    "NCBITaxon_4313": "Dichapetalaceae",
    "FOODON_03414054": "lake neuch\u00e2tel whitefish",
    "FOODON_03414477": "black katy chiton",
    "FOODON_03490112": "paperboard tube with lid or ends",
    "FOODON_03315376": "kelp (dried)",
    "FOODON_03305350": "beef bone",
    "UBERON_0002547": "tadpole",
    "FOODON_03317604": "obsolete: liver paste",
    "FOODON_03540577": "05770 - twistedleaf garlic (efsa foodex2)",
    "CHEBI_35742": "tetracarboxylic acid",
    "FOODON_03301626": "guarana seed paste",
    "FOODON_03310197": "andes salmon (raw)",
    "FOODON_03315982": "jelly energy-reduced",
    "FOODON_03303786": "candy (nut-flavored)",
    "FOODON_03304697": "kefir (fruit)",
    "FOODON_03316710": "cheese svecia",
    "FOODON_00002069": "onion food product",
    "FOODON_03543986": "39860 - meat/poultry soup, dry (efsa foodex2)",
    "FOODON_03306005": "corn cob jelly",
    "FOODON_00001608": "animal soup food product",
    "FOODON_00001777": "cow milk dessert",
    "FOODON_03304642": "rum coconut pattie candy",
    "NCBITaxon_171004": "Quillajaceae",
    "FOODON_03306942": "pickled fruit in oil",
    "FOODON_03316297": "product similar to marzipan made from oil-bearing kernels",
    "FOODON_00002860": "Irish soda bread",
    "FOODON_03541577": "15770 - european barberries (efsa foodex2)",
    "FOODON_00001276": "apple cider (alcoholic)",
    "FOODON_03315745": "dry cure",
    "ENVO_00002008": "dust",
    "FOODON_00000073": "cereal food fines (byproduct)",
    "FOODON_03543248": "32480 - juice concentrate, pomegranate (efsa foodex2)",
    "NCBITaxon_1206914": "Bembrops gobioides",
    "FOODON_03301271": "peach (canned)",
    "FOODON_00001170": "grape fruit food product",
    "FOODON_03301901": "anchovy fillet (raw)",
    "FOODON_03540027": "00270 - white fonio grain (efsa foodex2)",
    "FOODON_03415078": "meadowsweet plant",
    "FOODON_03304714": "western dressing",
    "FOODON_03304901": "cherry-flavored carbonated beverage base (artificially sweetened)",
    "FOODON_03310653": "chocolate milk (lowfat, vitamin a and d added, aspartame sweetened)",
    "FOODON_03413904": "macdonald's weakfish",
    "BFO_0000006": "spatial region",
    "NCBITaxon_119488": "Siniperca chuatsi",
    "FOODON_03400106": "prepared grain or starch product (us cfr)",
    "FOODON_03540807": "08070 - other wild mushrooms (efsa foodex2)",
    "FOODON_03541514": "15140 - cherry plums (efsa foodex2)",
    "FOODON_03301021": "doughnut (honey-dipped)",
    "NCBITaxon_115624": "Herniaria glabra",
    "FOODON_03315783": "pinto bean (canned)",
    "FOODON_03412175": "porcupinefish",
    "FOODON_03316782": "jam (fruit, artificially sweetened)",
    "FOODON_03413462": "common frog",
    "FOODON_03309260": "common sole (raw)",
    "FOODON_03304652": "mixed fruit spread",
    "FOODON_03540670": "06700 - cucumbers (efsa foodex2)",
    "BFO_0000038": "one-dimensional temporal region",
    "FOODON_03316035": "confectionery (sugar-based)",
    "FOODON_03309785": "field corn (raw)",
    "FOODON_03303079": "clementine (whole, raw)",
    "FOODON_03311212": "cashew nut (shell off, oil roasted)",
    "NCBITaxon_215352": "Brama japonica",
    "NCBITaxon_4609": "Cyperaceae",
    "FOODON_03540134": "01340 - mixed wheat and rye bread and rolls (efsa foodex2)",
    "FOODON_03542150": "21500 - fresh bratwurst (efsa foodex2)",
    "FOODON_03412799": "african fan palm plant",
    "FOODON_03543793": "37930 - food for weight reduction (efsa foodex2)",
    "FOODON_03411250": "green or red pepper plant",
    "CHEBI_31577": "ethylenediamine derivative",
    "FOODON_03541564": "15640 - blueberries (efsa foodex2)",
    "FOODON_03415027": "chinese black olive plant",
    "FOODON_03308552": "skate (raw)",
    "FOODON_00002895": "kratom",
    "FOODON_03414821": "wild grape plant",
    "FOODON_03302762": "honey cake (dietetic)",
    "FOODON_03304164": "shortening (high emulsifying, artificially flavored)",
    "NCBITaxon_24646": "Lycium",
    "FOODON_03306672": "blueberry pie filling",
    "FOODON_03540163": "01630 - rusk, refined flour (efsa foodex2)",
    "FOODON_03530274": "white flesh",
    "FOODON_00003155": "sweatbread food product",
    "FOODON_03540464": "04640 - dandelion leaves (forced) (efsa foodex2)",
    "FOODON_03413691": "cape hope squid",
    "FOODON_03304921": "chicken-flavored noodle soup",
    "NCBITaxon_57917": "Filipendula ulmaria",
    "FOODON_03311269": "beverage (nonalcoholic, chilled or frozen, with or without fruit juice, aspartame sweetened)",
    "FOODON_03414410": "cyclamates",
    "FOODON_03308496": "shrimp (butterflied, breaded)",
    "FOODON_03309920": "copra meal",
    "FOODON_03317067": "mollusc product (fully preserved)",
    "NCBITaxon_7938": "Anguilla rostrata",
    "FOODON_03306487": "armadillo meat (raw)",
    "FOODON_03308147": "oyster (japanese, frozen)",
    "FOODON_03413637": "california bay shrimp",
    "FOODON_03304998": "ground beef (soy-extended)",
    "NCBITaxon_700795": "Harengula clupeola",
    "NCBITaxon_7757": "Petromyzon marinus",
    "FOODON_03317581": "saucisses de strasbourg",
    "FOODON_03311215": "filbert nut (oil roasted)",
    "FOODON_03400268": "steeped beverage (us cfr)",
    "FOODON_03543441": "34410 - teas leaves, dry and/or fermented, and similar (efsa foodex2)",
    "NCBITaxon_78064": "Cetraria islandica",
    "CHEBI_36908": "argon molecular entity",
    "FOODON_00002370": "yellow perch food product",
    "FOODON_03400943": "50181900 - bread (gs1 gpc)",
    "NCBITaxon_7903": "Acipenser stellatus",
    "FOODON_03308327": "norwegian sardine in oil",
    "FOODON_03309010": "tuna frankfurter",
    "NCBITaxon_194251": "Artocarpus altilis",
    "FOODON_03510274": "southwest plains food claim or use",
    "FOODON_03414480": "velvet scoter",
    "FOODON_03306166": "apple juice (carbonated)",
    "FOODON_03412220": "shore, marsh and talon crab family",
    "FOODON_03305461": "bread mix (low gluten)",
    "FOODON_03414740": "portia tree",
    "FOODON_03307618": "fruit butter (artificially sweetened)",
    "FOODON_03317658": "aromatic wine",
    "NCBITaxon_8062": "Merluccius",
    "FOODON_03490216": "drawn can",
    "FOODON_03316277": "fish salad (food product)",
    "FOODON_03413490": "caramote prawn",
    "ENVO_00000097": "desert area",
    "FOODON_03305855": "bakers jelly",
    "PO_0000055": "bud",
    "FOODON_03411122": "marine mammal",
    "FOODON_03412367": "sandperch",
    "FOODON_03411554": "argentine anchovy",
    "FOODON_03542609": "26090 - earthworms (including species only consumed outside eu) (efsa foodex2)",
    "FOODON_03541859": "18590 - table olives ready for consumption (efsa foodex2)",
    "FOODON_03316881": "blood food product (dried)",
    "FOODON_03308179": "cape spiny lobster (raw)",
    "FOODON_03316815": "vermicelli (nonfat milk, enriched)",
    "FOODON_03510102": "no flavor added claim or use",
    "NCBITaxon_174403": "Paralithodes brevipes",
    "FOODON_03302053": "lima bean (whole)",
    "FOODON_03544463": "44630 - saccharine (efsa foodex2)",
    "NCBITaxon_1192867": "Chroicocephalus ridibundus",
    "FOODON_03540661": "06610 - pepinos (efsa foodex2)",
    "FOODON_03303517": "pasteurized process cheese food",
    "FOODON_03540158": "01580 - puffed cereals textured bread (efsa foodex2)",
    "FOODON_03310433": "palm sugar syrup",
    "FOODON_03316132": "cherry in syrup",
    "FOODON_03413230": "quillaia extract",
    "FOODON_03305210": "rye bread (enriched)",
    "FOODON_03412609": "olallieberry plant",
    "UBERON_0006860": "swim bladder",
    "HANCESTRO_0412": "Guyanese",
    "FOODON_03304816": "pimiento cheese sandwich roll",
    "PO_0025173": "spine leaf",
    "FOODON_03541566": "15660 - rabbiteye blueberry (efsa foodex2)",
    "FOODON_03304232": "chow mein mix",
    "FOODON_03316591": "obsolete: sausage food product",
    "FOODON_03470177": "food micro-filtration",
    "NCBITaxon_57926": "Potentilla anserina",
    "NCBITaxon_59688": "Sardinops ocellatus",
    "FOODON_03311098": "infant formula (home prepared)",
    "FOODON_00002569": "hibiscus tea (dry)",
    "FOODON_03414780": "paloverde plant",
    "FOODON_00002054": "naranjilla juice product",
    "NCBITaxon_349652": "Dentex angolensis",
    "FOODON_03305252": "full cream milk (dry)",
    "FOODON_03309928": "pepper (raw)",
    "FOODON_03415022": "common hazel plant",
    "NCBITaxon_8930": "Columbidae",
    "FOODON_03301654": "cream (dried)",
    "FOODON_03307065": "poultry parts (raw)",
    "FOODON_03541348": "13480 - root and rhizome spices (efsa foodex2)",
    "NCBITaxon_198229": "Scyllarus arctus",
    "FOODON_03306768": "cheese pie",
    "FOODON_03544294": "42940 - jackfruit flavour (efsa foodex2)",
    "FOODON_03302736": "peanut hay",
    "FOODON_03306532": "mushroom stems and pieces (canned)",
    "FOODON_03301072": "cocoa",
    "FOODON_03412772": "tallow tree (detarium) plant",
    "FOODON_03414924": "american oil palm plant",
    "FOODON_00002431": "adzuki bean food product",
    "FOODON_03412425": "fish, amiiform",
    "CHEBI_33680": "elemental helium",
    "NCBITaxon_13452": "Corylus cornuta",
    "FOODON_03540965": "09650 - cassava roots and similar- (efsa foodex2)",
    "FOODON_03401772": "10006315 - soup additions (perishable) (gs1 gpc)",
    "FOODON_03543956": "39560 - vol au vent (efsa foodex2)",
    "FOODON_03317601": "fish product (low sodium)",
    "FOODON_03412487": "yellow croaker",
    "FOODON_00003279": "Cornichon pickle",
    "FOODON_03306421": "ravioli (stuffed with meat)",
    "FOODON_03400837": "jam or marmalade (eurofir)",
    "FOODON_03306082": "lemon peel infusion (dried)",
    "FOODON_00002841": "juniper ash",
    "FOODON_03411331": "clam",
    "FOODON_03542564": "25640 - squid, japanese flying (efsa foodex2)",
    "NCBITaxon_33637": "Laminaria",
    "FOODON_03400466": "CIAA ready-to-eat savories",
    "FOODON_03311418": "soft candy",
    "FOODON_03541165": "11650 - walnuts and similar- (efsa foodex2)",
    "FOODON_03413030": "calcium benzoate",
    "FOODON_00003366": "food (spoiled)",
    "FOODON_00002296": "sweet pea food product",
    "FOODON_03414604": "fucus",
    "FOODON_03315098": "cocoa cream",
    "NCBITaxon_3400": "Magnoliales",
    "FOODON_03542055": "20550 - buffalo edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "FOODON_03304400": "half and half cow milk (sterilized)",
    "FOODON_03307331": "mango shake",
    "FOODON_03413576": "river crayfish",
    "FOODON_03308066": "cod (smoked)",
    "FOODON_03460356": "obsolete: other substance coated or covered",
    "FOODON_03401410": "10006169 - avocados - smooth peel (gs1 gpc)",
    "FOODON_03400647": "d.  processed food of plant origin (ccpr)",
    "FOODON_03306250": "imitation maple-flavored cake mix",
    "FOODON_00001183": "bread food product",
    "FOODON_03414744": "zombi pea plant",
    "FOODON_03411184": "temperate bass families",
    "FOODON_03415047": "mexican hawthorn plant",
    "CHEBI_27470": "folic acid",
    "NCBITaxon_112863": "Lycium barbarum",
    "FOODON_03543764": "37640 - follow-on formula, milk and soya-based, powder (efsa foodex2)",
    "OBI_0000437": "analyte measurement objective",
    "FOODON_03308404": "ocean perch fillet (raw)",
    "NCBITaxon_4018": "Tropaeolaceae",
    "NCBITaxon_27588": "Raja montagui",
    "FOODON_03540510": "05100 - soyabeans sprouts (efsa foodex2)",
    "FOODON_03541534": "15340 - wine grapes (efsa foodex2)",
    "FOODON_03317661": "vitamin oils and concentration containing more than 100,000 i.u. of vitamin a per gram",
    "FOODON_03411042": "pea plant, smooth wrinkled crosses",
    "NCBITaxon_32524": "Amniota",
    "FOODON_03400134": "salt or salt substitute (us cfr)",
    "FOODON_03400983": "10000043 - sugar/sugar substitutes (shelf stable) (gs1 gpc)",
    "FOODON_03304132": "meat sauce",
    "NCBITaxon_47083": "Melilotus officinalis",
    "FOODON_03412250": "salmo",
    "FOODON_03401739": "10005954 - papayas formosa (gs1 gpc)",
    "FOODON_03411075": "palinurid spiny lobster",
    "FOODON_03540376": "03760 - radicchio (efsa foodex2)",
    "FOODON_03302811": "chocolate-flavored skim milk",
    "FOODON_03541979": "19790 - quail fresh meat (efsa foodex2)",
    "NCBITaxon_568884": "Nematalosa nasus",
    "FOODON_03541123": "11230 - apricot kernels (efsa foodex2)",
    "FOODON_03411757": "red grouper",
    "FOODON_03540418": "04180 - baobab leaves (efsa foodex2)",
    "FOODON_03411185": "baby lima bean plant",
    "FOODON_03317524": "sauce, emulsified with a fat content of 60% or more",
    "NCBITaxon_7777": "Chondrichthyes",
    "FOODON_03412271": "bandtail puffer",
    "NCBITaxon_64149": "Channa micropeltes",
    "FOODON_03301132": "whole rye bread (loaf)",
    "FOODON_03411007": "fish, cartilaginous",
    "FOODON_03309000": "labrador redfish (raw)",
    "FOODON_03304614": "vegetable (sodium-free, artificially sweetened)",
    "CHEBI_36818": "seco-cholestane",
    "FOODON_03510192": "toddler as food consumer, 12 months and onwards",
    "FOODON_03304037": "riviera sauce",
    "RO_0002220": "adjacent to",
    "FOODON_03304518": "imitation orangeade beverage syrup",
    "FOODON_03411159": "ribes berry plant",
    "FOODON_03414511": "north european kelp",
    "FOODON_03542354": "23540 - pollack, pollock (efsa foodex2)",
    "FOODON_00001258": "food (fermented)",
    "FOODON_03543630": "36300 - roots used for herbal infusions (efsa foodex2)",
    "FOODON_03315874": "red bell pepper (whole, raw)",
    "FOODON_00001605": "animal product sausage",
    "NCBITaxon_49825": "Genista tinctoria",
    "FOODON_03490169": "aluminum tube, top lined with laminate",
    "FOODON_03542232": "22320 - goldfish (efsa foodex2)",
    "FOODON_03311511": "cake flour",
    "FOODON_03315494": "takuan-zuke (food product)",
    "FOODON_03401102": "10000260 - soups - prepared (frozen) (gs1 gpc)",
    "FOODON_03304089": "minestrone soup with meat",
    "FOODON_03414786": "sandalwood plant",
    "FOODON_03413338": "chilean strawberry plant",
    "NCBITaxon_79674": "Macrobrachium rosenbergii",
    "FOODON_03400691": "01  bread and rolls (efg)",
    "FOODON_03401779": "10006758 - quark products (shelf stable) (gs1 gpc)",
    "FOODON_03310709": "falafel (whole, cooked)",
    "FOODON_03543298": "32980 - fruit soft drink, raspberry (efsa foodex2)",
    "FOODON_03544053": "40530 - salt (efsa foodex2)",
    "FOODON_03400878": "10000143 - alcohol making supplies (gs1 gpc)",
    "FOODON_03304929": "beef soup",
    "FOODON_03411889": "atlantic saury",
    "NCBITaxon_184585": "Engraulis encrasicolus",
    "FOODON_00001060": "awamori food product",
    "FOODON_03412134": "spanish thyme plant",
    "FOODON_03541368": "13680 - fruit spices (efsa foodex2)",
    "FOODON_03413941": "giant gourami family",
    "FOODON_03400254": "egg product analog (us cfr)",
    "FOODON_03309852": "croissant",
    "FOODON_03301656": "lowfat milk (dry)",
    "FOODON_03401393": "50261800 - vegetables - unprepared/unprocessed (fresh) variety packs (gs1 gpc)",
    "FOODON_03305624": "candy crunch ice cream",
    "CHEBI_26537": "retinoid",
    "FOODON_03303570": "lemon squash beverage",
    "FOODON_03412872": "barramundi",
    "UO_0000164": "mass volume percentage",
    "FOODON_00001785": "crab food product",
    "FOODON_03542781": "27810 - cheese, bavarian blue (efsa foodex2)",
    "FOODON_03543183": "31830 - juice, grape (efsa foodex2)",
    "FOODON_03306017": "imitation orange juice drink",
    "NCBITaxon_28793": "Notropis",
    "FOODON_03540777": "07770 - spirulina (maxima) (efsa foodex2)",
    "FOODON_03411700": "flax plant",
    "FOODON_03304154": "sesame seed paste",
    "FOODON_03307162": "mixed fruit preserves",
    "FOODON_03411648": "blue crab",
    "FOODON_03411443": "broccoli plant",
    "FOODON_03310181": "cream of cauliflower soup",
    "FOODON_03540465": "04650 - fern group (efsa foodex2)",
    "FOODON_03301077": "fish (whole or parts)",
    "FOODON_03315571": "soup mix",
    "FOODON_03401879": "10006371 - sugar cane (gs1 gpc)",
    "FOODON_03540060": "00600 - khorasan wheat grain (efsa foodex2)",
    "FOODON_03540580": "05800 - onion bulbs for fresh consumption (efsa foodex2)",
    "HANCESTRO_0354": "Canadian",
    "FOODON_03412451": "lily plant",
    "FOODON_00003176": "European rabbit",
    "FOODON_03308368": "louisiana crayfish (raw)",
    "FOODON_03412547": "sheatfish family",
    "FOODON_03311159": "bone meal used in animal feed",
    "FOODON_03490402": "polyethylene (low density) - polyethylene (high density) container",
    "FOODON_03414315": "red oat plant",
    "FOODON_03316431": "fruit preparation (used with milk products, calorie-reduced)",
    "FOODON_03317090": "bouillon powder",
    "FOODON_03413453": "noble crayfish",
    "FOODON_03544392": "43920 - tea green flavour (efsa foodex2)",
    "FOODON_03304534": "flour (all purpose)",
    "FOODON_03308189": "korean crab (raw)",
    "HANCESTRO_0395": "Macedonian",
    "FOODON_03414485": "bearded seal",
    "FOODON_03317033": "fruit juice drink (from concentrate)",
    "FOODON_03317216": "lobster (raw, quick-frozen)",
    "NCBITaxon_26867": "Plantago",
    "FOODON_00001305": "hoi-dong",
    "NCBITaxon_716545": "saccharomyceta",
    "FOODON_03303633": "cola carbonated beverage (decaffeinated)",
    "FOODON_03401089": "50193200 - grain based products / meals (gs1 gpc)",
    "FOODON_03310553": "soy protein isolate",
    "FOODON_03315888": "cream based liquor (unstandardized)",
    "FOODON_03304474": "coffee whitener (frozen)",
    "FOODON_03530065": "grade of meat, europe",
    "NCBITaxon_107257": "Chaceon",
    "FOODON_03303545": "cheddar cheese (filled)",
    "GAZ_00000557": "Anatolia",
    "FOODON_03543069": "30690 - marzipan raw mass (efsa foodex2)",
    "NCBITaxon_46474": "Aerodramus",
    "FOODON_03315409": "nut yogurt",
    "FOODON_03301726": "bubble gum",
    "FOODON_03411230": "barley plant",
    "FOODON_03490210": "glass container, metal lid",
    "FOODON_03413669": "spider conch",
    "FOODON_03544031": "40310 - mushroom salad (efsa foodex2)",
    "FOODON_03315782": "lima bean (ripe, canned)",
    "NCBITaxon_30910": "Channidae",
    "FOODON_03540341": "03410 - processed barley-based flakes (efsa foodex2)",
    "FOODON_03411087": "human as milk source",
    "FOODON_00002876": "pumpkin pie spice",
    "FOODON_03309250": "rouille marseillaise",
    "FOODON_03311512": "banana (whole, unripe, green)",
    "FOODON_03540598": "05980 - broad beans (with pods) (efsa foodex2)",
    "FOODON_03311848": "malt beverage (fruit flavored)",
    "FOODON_03414074": "black-bellied angler",
    "FOODON_03543033": "30330 - chocolate and chocolate products (efsa foodex2)",
    "FOODON_03302078": "green bean with dehydrated onions and peppers (canned)",
    "FOODON_03304517": "imitation lemonade beverage syrup",
    "FOODON_00002479": "orange (whole or parts)",
    "GAZ_00000469": "New Zealand",
    "FOODON_03542504": "25040 - lobster, european (efsa foodex2)",
    "FOODON_03412094": "nutria",
    "FOODON_03411971": "blackback flounder",
    "FOODON_03541231": "12310 - sea buckthorn seeds (efsa foodex2)",
    "FOODON_03540910": "09100 - hyssop (efsa foodex2)",
    "FOODON_03543585": "35850 - bee balm infusion flowers (efsa foodex2)",
    "NCBITaxon_1176516": "Rosoideae incertae sedis",
    "FOODON_03541238": "12380 - oil fruits (efsa foodex2)",
    "FOODON_03301440": "mayonnaise",
    "NCBITaxon_4418": "Nymphaea",
    "FOODON_03304675": "chamomile tea (dry)",
    "FOODON_03412899": "grenadier family",
    "FOODON_03317520": "hen egg product (deep-frozen)",
    "FOODON_03301183": "hops (dried)",
    "FOODON_03540508": "05080 - peas shoots and sprouts (efsa foodex2)",
    "UBERON_0001913": "milk",
    "FOODON_03543347": "33470 - root beer (efsa foodex2)",
    "NCBITaxon_32443": "Teleostei",
    "FOODON_03540525": "05250 - broccoli (efsa foodex2)",
    "FOODON_03315958": "vegetable-based dessert energy reduced",
    "FOODON_03306896": "garlic and onion puree",
    "FOODON_03460105": "obsolete: nutritive sweetener added",
    "FOODON_03307057": "potato chip (onion- and garlic-flavored)",
    "FOODON_03311609": "whiting cooked",
    "FOODON_03413274": "sodium stearoyl-2-lactylate",
    "FOODON_03543847": "38470 - dishes excluding pasta or rice dishes, sandwiches and pizza (efsa foodex2)",
    "FOODON_03317253": "beetroot (canned)",
    "FOODON_00002143": "plant leaf vegetable food product",
    "FOODON_00002958": "beef sausage",
    "FOODON_03543773": "37730 - ready-to-eat fish-based meal for children (efsa foodex2)",
    "NCBITaxon_670798": "Benthophilinae",
    "FOODON_03401235": "0280000 - fungi (ec)",
    "FOODON_03542296": "22960 - salmons (efsa foodex2)",
    "FOODON_03544274": "42740 - ginseng flavour (efsa foodex2)",
    "FOODON_03430169": "parenteral preparation",
    "FOODON_03301742": "cold-pack cheese",
    "FOODON_03309846": "coconut oil press cake",
    "NCBITaxon_48399": "Crocodylus acutus",
    "FOODON_03414836": "cassowary gum plant",
    "NCBITaxon_8284": "Squalius cephalus",
    "FOODON_00001191": "barley food product",
    "FOODON_03301382": "sweet red bell pepper (canned)",
    "FOODON_03541039": "10390 - rice beans (without pods) (efsa foodex2)",
    "FOODON_03413061": "carnauba wax",
    "FOODON_03301441": "lemon (whole, raw)",
    "FOODON_03541974": "19740 - ratites, minced meat (efsa foodex2)",
    "FOODON_03301295": "pear jam",
    "FOODON_03542936": "29360 - dairy dessert and similar (efsa foodex2)",
    "FOODON_00002563": "chipotle",
    "FOODON_03401648": "10005784 - turkey - prepared/processed (gs1 gpc)",
    "FOODON_03308661": "alaskan shrimp (breaded)",
    "NCBITaxon_169642": "Gardenieae",
    "FOODON_03412123": "muscadine grape plant",
    "FOODON_03305464": "gelatin dessert (imitation concord grape flavor)",
    "CHEBI_52634": "sodium-23 atom",
    "FOODON_03412200": "fish, batrachoidiform",
    "CHEBI_33937": "macronutrient",
    "FOODON_00002674": "chicken wing",
    "FOODON_03315102": "hen egg substance",
    "FOODON_03540091": "00910 - wheat flour, brown (efsa foodex2)",
    "FOODON_03544160": "41600 - hyaluronic acid (efsa foodex2)",
    "FOODON_03304252": "tortellini with meat soup mix (frozen)",
    "FOODON_03307341": "milk chocolate with rice crispies",
    "FOODON_03306479": "deer meat jerky",
    "FOODON_03301668": "tuna (canned)",
    "FOODON_03541768": "17680 - wild sweetsops (efsa foodex2)",
    "FOODON_03411472": "cinnamon plant",
    "FOODON_03305065": "bullfrog (raw)",
    "FOODON_03401050": "50132200 - milk/butter/cream/yoghurts/cheese/eggs/substitutes variety packs (gs1 gpc)",
    "FOODON_03304927": "pea soup",
    "FOODON_03307345": "sugar (refined)",
    "FOODON_03305729": "sardine and tomato spread",
    "FOODON_03400869": "product for special nutritional use or dietary supplement (eurofir)",
    "FOODON_03414571": "minke whale",
    "FOODON_03415007": "water mint plant",
    "FOODON_03414754": "cartonema plant",
    "FOODON_00002913": "gambier powder",
    "FOODON_03541772": "17720 - cattley guavas (efsa foodex2)",
    "FOODON_00003352": "glutinous rice",
    "FOODON_03315138": "gefilte fish ball in packing medium",
    "FOODON_03544068": "40680 - gravy ingredients (efsa foodex2)",
    "UO_0000027": "degree Celsius",
    "FOODON_03414021": "malabar grouper",
    "FOODON_03304801": "dilly bread",
    "FOODON_03401880": "10006848 - honey substitutes (gs1 gpc)",
    "FOODON_03307871": "sunflower seed flour",
    "FOODON_03413284": "sorbitan tristearate",
    "FOODON_00003313": "pear tomato (whole, raw)",
    "FOODON_03412365": "obsolete european hake",
    "FOODON_00002975": "thalipeeth",
    "FOODON_03413867": "black sea shad",
    "NCBITaxon_362788": "Senna tora",
    "FOODON_03542486": "24860 - chinese mitten crab (efsa foodex2)",
    "NCBITaxon_3707": "Brassica juncea",
    "FOODON_03309499": "candied cherry on a wire",
    "FOODON_00003084": "Chenopodium berlandieri",
    "FOODON_03401074": "10000193 - dessert sauces/toppings/fillings (frozen) (gs1 gpc)",
    "NCBITaxon_41711": "Osmeriformes",
    "FOODON_03312052": "peanut milk",
    "FOODON_03542171": "21710 - sliceable or firm cooked sausages (efsa foodex2)",
    "FOODON_03304150": "bread (special formula, enriched)",
    "FOODON_03317576": "cow milk (semi-skimmed, pasteurized)",
    "FOODON_03311603": "plum juice",
    "NCBITaxon_136690": "Galatheidae",
    "UO_0000173": "gram per milliliter",
    "FOODON_03301604": "corn (detreated for animal feed)",
    "FOODON_03310887": "pistachio pudding (artificially flavored, instant)",
    "FOODON_00002673": "chicken skin",
    "FOODON_03304071": "barbeque seasoning (salt-free)",
    "FOODON_03302589": "mushroom in buttered sauce",
    "FOODON_03401419": "10006336 - beans (winged) (gs1 gpc)",
    "FOODON_03414242": "wild barley plant",
    "FOODON_03541143": "11430 - acorns (efsa foodex2)",
    "FOODON_00001835": "european blackberry preserve or jam food product",
    "FOODON_00003196": "shea fruit (whole, raw)",
    "FOODON_03413163": "monopotassium tartrate",
    "FOODON_03303560": "cheese whey (from cow milk)",
    "FOODON_03309520": "bullhead (raw)",
    "FOODON_03543124": "31240 - camel tallow (efsa foodex2)",
    "FOODON_03312070": "cottonseed oil (genetically modified)",
    "NCBITaxon_4731": "Typhaceae",
    "FOODON_03302210": "orange drink beverage base (food product)",
    "FOODON_03306870": "peanut butter with imitation bacon",
    "FOODON_03413734": "poring bamboo plant",
    "FOODON_03541415": "14150 - peanut butter (efsa foodex2)",
    "NCBITaxon_13732": "Trichiurus",
    "NCBITaxon_29727": "Eruca vesicaria subsp. sativa",
    "FOODON_03304751": "white bread (enriched)",
    "FOODON_03542506": "25060 - slipper lobster (efsa foodex2)",
    "FOODON_03414858": "goldfish",
    "FOODON_00003314": "white bean food product",
    "FOODON_03303580": "gouda cheese (baby)",
    "UO_0000002": "mass unit",
    "FOODON_03411156": "pod or seed vegetable plant",
    "FOODON_03543676": "36760 - fir (infusion shoots) (efsa foodex2)",
    "PATO_0045052": "normal depth",
    "FOODON_03302061": "baby lima bean (whole)",
    "FOODON_03413939": "zosterisessor",
    "FOODON_03401530": "10006728 - dairy by-products (gs1 gpc)",
    "FOODON_03401057": "10000608 - fats edible variety packs (gs1 gpc)",
    "NCBITaxon_44685": "Panax japonicus",
    "FOODON_03542715": "27150 - sour cream products (efsa foodex2)",
    "FOODON_03311072": "red winter wheat kernel",
    "FOODON_03490233": "plastic stopper",
    "FOODON_00001659": "bluefish food product",
    "FOODON_03490237": "plastic screw cap or lid",
    "FOODON_03401010": "50101500 - vegetables - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03304434": "dinner (freeze-dried)",
    "FOODON_03303683": "pasteurized process cheese spread with imitation meat",
    "FOODON_03317062": "bakery product (with no added sugar, fine)",
    "FOODON_03315846": "confectionery (moulded, unstandardized)",
    "ENVO_00002191": "animal litter",
    "FOODON_03540924": "09240 - marigold flowers (efsa foodex2)",
    "FOODON_03541501": "15010 - nanking cherries (efsa foodex2)",
    "FOODON_03308576": "japanese snow crab meat",
    "FOODON_03310787": "pink bean (whole, dried)",
    "FOODON_03542444": "24440 - horse jack (efsa foodex2)",
    "FOODON_03414614": "manatee",
    "FOODON_03412047": "chaparral plant",
    "FOODON_03544497": "44970 - fluorine (efsa foodex2)",
    "FOODON_03307577": "chicken pie",
    "FOODON_03414017": "golden grouper",
    "FOODON_00002669": "anchovy fillet",
    "ENVO_01001243": "forest ecosystem",
    "FOODON_03400427": "green: nutrient, diet supplement, anti-caking agent (codex)",
    "FOODON_03414799": "northern snake-necked turtle",
    "NCBITaxon_9996": "Spermophilus",
    "FOODON_03306163": "garlic juice",
    "FOODON_03302526": "rum flavor",
    "FOODON_03542648": "26480 - smoked seafood (efsa foodex2)",
    "FOODON_03413190": "polyglycerol polyricinoleate",
    "FOODON_03540940": "09400 - fermented or pickled vegetables (efsa foodex2)",
    "FOODON_03306685": "orange ice on a stick",
    "FOODON_00001572": "corn stubble",
    "FOODON_03311574": "cloudberry (frozen)",
    "FOODON_03400289": "USA agency food product type",
    "FOODON_03400409": "filtering aid (codex)",
    "FOODON_03401026": "50131900 - butter/butter substitutes (gs1 gpc)",
    "FOODON_03316320": "fish product (marinated)",
    "FOODON_03400442": "sequestrant (codex)",
    "FOODON_03543881": "38810 - shepherd's pie (efsa foodex2)",
    "NCBITaxon_89057": "Microstomus achne",
    "FOODON_03309547": "lowfat cow milk (fortified, ultrapasteurized)",
    "FOODON_03460123": "alcohol-acetic acid fermentation",
    "FOODON_03400728": "05  fats and oils (eurocode2)",
    "FOODON_03413529": "smalltail shark",
    "FOODON_03460756": "rye malt",
    "FOODON_03310609": "rice cereal",
    "FOODON_03316811": "spaghetti (nonfat, milk)",
    "GAZ_00005860": "Melanesia",
    "FOODON_03541006": "10060 - birches (trunk sap) (efsa foodex2)",
    "FOODON_03310823": "acerola (whole, raw)",
    "FOODON_03303143": "bourbon biscuit",
    "FOODON_03308081": "common whitefish (gutted, raw)",
    "NCBITaxon_8801": "Struthio camelus",
    "FOODON_03315770": "onion (canned)",
    "FOODON_03311534": "egyptian balady bread",
    "FOODON_03414935": "armenian cucumber plant",
    "FOODON_03400731": "08  vegetables and vegetable products (eurocode2)",
    "FOODON_03541558": "15580 - korean black raspberries (efsa foodex2)",
    "FOODON_03413966": "shortjaw leatherjacket",
    "FOODON_03460375": "gum stabilizer",
    "FOODON_03411171": "turnip greens plant",
    "FOODON_03490204": "can (container)",
    "FOODON_03301926": "ice food product",
    "FOODON_03541207": "12070 - watermelon seeds (efsa foodex2)",
    "GAZ_00002515": "State of Oregon",
    "FOODON_00001686": "carrot juice food product",
    "FOODON_03490262": "steel solder",
    "NCBITaxon_13677": "Scomber scombrus",
    "NCBITaxon_3635": "Gossypium hirsutum",
    "NCBITaxon_28683": "Alcidae",
    "NCBITaxon_4432": "Nelumbo nucifera",
    "NCBITaxon_8906": "Charadriiformes",
    "FOODON_03311744": "rainbow trout smoked",
    "FOODON_03412990": "aluminium silicate (kaolin)",
    "NCBITaxon_59946": "Rexea solandri",
    "FOODON_03414513": "ceylon sago palm plant",
    "NCBITaxon_7001": "Caelifera",
    "FOODON_03302386": "lemon beverage",
    "FOODON_03543213": "32130 - juice, potato (efsa foodex2)",
    "FOODON_03411305": "arabica coffee plant",
    "FOODON_03316410": "dextrose containing crystallization water",
    "UBERON_0007010": "cleaving embryo",
    "FOODON_00001171": "cruciferous inflorescence food product",
    "FOODON_03543497": "34970 - ground ivy infusion leaves (efsa foodex2)",
    "FOODON_03304072": "gefilte fish (canned)",
    "FOODON_03306081": "imitation lemonade drink",
    "FOODON_03309156": "sand perch (raw)",
    "FOODON_03311481": "brown rice cream",
    "FOODON_03400966": "10000316 - grains/cereal - ready to eat - (perishable) (gs1 gpc)",
    "FOODON_03543595": "35950 - dyer\u0092s broom infusion flowers (efsa foodex2)",
    "FOODON_03543834": "38340 - oats drink (efsa foodex2)",
    "FOODON_03540584": "05840 - shallots and similar- (efsa foodex2)",
    "ENVO_01000617": "lentic water body",
    "FOODON_03412672": "new zealand long-finned eel",
    "FOODON_03310233": "jojoba meal",
    "FOODON_03305013": "gluten soya bread",
    "FOODON_03540188": "01880 - dried stuffed pasta (efsa foodex2)",
    "FOODON_03420255": "organ meat, other systems",
    "NCBITaxon_55581": "Dioscorea trifida",
    "FOODON_03412466": "snow pea plant",
    "FOODON_03309932": "tamarind (whole, raw)",
    "GAZ_00003923": "Singapore",
    "FOODON_03411922": "redbelly dace",
    "FOODON_03304882": "tomato wedge (artificially sweetened, canned)",
    "FOODON_00001868": "food filling product",
    "FOODON_03400402": "drying agent (codex)",
    "NCBITaxon_8043": "Gadiformes",
    "FOODON_03309833": "field corn (ground)",
    "FOODON_03301449": "potato (whole, raw)",
    "FOODON_03544041": "40410 - rice chips (efsa foodex2)",
    "FOODON_03307589": "pomegranate-flavored beverage syrup",
    "FOODON_03310634": "capsicum pepper (ground)",
    "FOODON_03400104": "fruit juice or related product (us cfr)",
    "FOODON_03543486": "34860 - narrow-leaf echinacea infusion leaves (efsa foodex2)",
    "FOODON_03309987": "rice bean (whole)",
    "FOODON_03544283": "42830 - ham flavour (efsa foodex2)",
    "FOODON_03302071": "green kidney bean (whole)",
    "FOODON_03401655": "10006283 - beefalo/cattalo - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03414161": "european hare",
    "HANCESTRO_0439": "Iraqi",
    "FOODON_03306274": "mango (not further specified)",
    "FOODON_03316838": "macaroni (egg, wheat, and soy)",
    "FOODON_03540535": "05350 - courgette (edible flowers) (efsa foodex2)",
    "NCBITaxon_12953": "Asimina triloba",
    "FOODON_03307509": "gelatin dessert (artificially sweetened)",
    "FOODON_03301911": "beverage (nonalcoholic, naturally effervescent)",
    "FOODON_00001131": "poultry meat food product",
    "FOODON_03303571": "cottage cheese (vegetable added)",
    "NCBITaxon_2759": "Eukaryota",
    "FOODON_03414004": "large-eyed dentex",
    "FOODON_03310938": "beef tongue (raw)",
    "NCBITaxon_61674": "Acipenser sturio",
    "FOODON_03412569": "sandfish family",
    "FOODON_03510041": "cholesterol special claim or use",
    "FOODON_03414961": "rugosa rose plant",
    "FOODON_03304276": "sparkling grape juice",
    "FOODON_03310651": "oats (ground)",
    "FOODON_03540110": "01100 - rye bran (efsa foodex2)",
    "NCBITaxon_4642": "Zingiberaceae",
    "FOODON_03305428": "lemon juice",
    "FOODON_03401187": "10000581 - food glazes (shelf stable) (gs1 gpc)",
    "FOODON_03401447": "10005921 - strawberries (gs1 gpc)",
    "FOODON_03401096": "10000318 - pasta/noodles - not ready to eat (frozen) (gs1 gpc)",
    "NCBITaxon_301693": "Annona squamosa",
    "FOODON_03411690": "akee plant",
    "FOODON_00003349": "white onion (whole, raw)",
    "FOODON_03412254": "silver carp",
    "FOODON_03420237": "floret or flower",
    "FOODON_00003250": "paella",
    "FOODON_03302245": "cherry and apple beverage base (dry)",
    "FOODON_03315866": "cheese powder (industrial spray-dried)",
    "PO_0009025": "vascular leaf",
    "FOODON_03542792": "27920 - firm/semi-hard cheese (gouda and edam type) (efsa foodex2)",
    "FOODON_03543852": "38520 - meat loaf (efsa foodex2)",
    "FOODON_03414759": "curculigo plant",
    "FOODON_03413341": "six row barley plant",
    "FOODON_03308730": "tuna (pressed)",
    "FOODON_03541011": "10110 - canary date palm (trunk sap) (efsa foodex2)",
    "FOODON_03411146": "horseradish plant",
    "FOODON_03401373": "50260900 - cucurbits - inedible peel (gs1 gpc)",
    "CHEBI_46793": "poly(ethylene glycol)",
    "NCBITaxon_271941": "Trachurus declivis",
    "FOODON_03543815": "38150 - fiber supplements (efsa foodex2)",
    "GAZ_00004427": "State of New Mexico",
    "FOODON_03301944": "raisin bread",
    "NCBITaxon_270110": "Cochlearia officinalis",
    "GAZ_00005841": "Saint Martin",
    "NCBITaxon_245824": "Valerianella eriocarpa",
    "FOODON_03412548": "milkfish family",
    "NCBITaxon_38009": "Artemiidae",
    "FOODON_03306771": "orange marmalade-flavored pie filling",
    "FOODON_03305540": "herb blend seasoning",
    "FOODON_03302044": "black raspberry (canned)",
    "NCBITaxon_59501": "Rubus idaeus subsp. idaeus",
    "FOODON_03305867": "wine jelly",
    "FOODON_03541904": "19040 - chicken msm (efsa foodex2)",
    "FOODON_03306281": "macaroni noodle-shaped",
    "FOODON_03540663": "06630 - turkey berries (efsa foodex2)",
    "NCBITaxon_4677": "Liliaceae",
    "FOODON_03309865": "bajra millet meal (food product)",
    "FOODON_03303733": "candy (bourbon whiskey-flavored)",
    "FOODON_03309858": "rhubarb stalk (whole, raw)",
    "GAZ_00052477": "Isle of Man",
    "ENVO_00002222": "food shop",
    "PO_0004543": "shoot axis tuber",
    "FOODON_03400723": "33  products for special nutritional use (efg)",
    "FOODON_03490180": "plastic container, molded or bubble pack",
    "FOODON_03414642": "honeypot ant",
    "FOODON_00002995": "ancho powder",
    "FOODON_03414218": "myrtle-leaf orange plant",
    "FOODON_00001890": "fruit pie food product",
    "NCBITaxon_511543": "Piper guineense",
    "FOODON_03412637": "konjac plant",
    "FOODON_03306251": "maple spread",
    "FOODON_03315385": "soft drink (brewed)",
    "FOODON_03543089": "30890 - sorbet (efsa foodex2)",
    "NCBITaxon_23159": "Crataegus",
    "NCBITaxon_212737": "Centrophorus granulosus",
    "FOODON_03450024": "cooking with fat or oil",
    "CHEBI_134179": "volatile organic compound",
    "FOODON_03302973": "cottage cheese (creamed)",
    "RO_0002224": "starts with",
    "NCBITaxon_24921": "Violaceae",
    "FOODON_03543603": "36030 - larkspur infusion flowers (efsa foodex2)",
    "FOODON_03310222": "chicken thigh (retorted)",
    "FOODON_03317458": "barley malt product",
    "FOODON_03317198": "shrimp or prawn (quick frozen)",
    "FOODON_03543836": "38360 - rye drink (efsa foodex2)",
    "NCBITaxon_163729": "Genisteae",
    "FOODON_03307904": "skim milk (pasteurized, vitamin A and D fortified, nonfat milk solids added)",
    "FOODON_03316590": "meat (tinned)",
    "FOODON_03307506": "citrus fruit (canned)",
    "FOODON_03414043": "mud dab",
    "IAO_0000602": "has associated axiom(fol)",
    "FOODON_03315085": "bakery product (yeast leavened)",
    "FOODON_03413677": "penshell",
    "CHEBI_132502": "fatty acid 18:3",
    "FOODON_03304669": "field corn (whole kernel, dried)",
    "FOODON_03543366": "33660 - vermouth (efsa foodex2)",
    "FOODON_03315348": "bakkoji",
    "FOODON_00002983": "Aj\u00ed dulce pepper plant",
    "NCBITaxon_34272": "Atriplex hortensis",
    "FOODON_03308841": "blue swimmer crab (raw)",
    "FOODON_03411280": "barrow",
    "NCBITaxon_8255": "Paralichthys olivaceus",
    "FOODON_03302166": "imitation lemon juice base",
    "FOODON_03309910": "silver catfish (raw)",
    "FOODON_03401086": "10000302 - dough based products / meals - not ready to eat - savoury (shelf stable) (gs1 gpc)",
    "FOODON_03542153": "21530 - mettwurst-type sausage (efsa foodex2)",
    "FOODON_03490280": "glass container, coloured, normal weight",
    "FOODON_03542523": "25230 - molluscs (efsa foodex2)",
    "CHEBI_23114": "chloride salt",
    "FOODON_03317386": "corn malt",
    "FOODON_03542174": "21740 - bologna-type sausage (efsa foodex2)",
    "FOODON_03544254": "42540 - currant flavour (efsa foodex2)",
    "GAZ_00002473": "Jordan",
    "FOODON_03311660": "salad dressing, low fat",
    "FOODON_03401551": "10006157 - common cultivated mushroom (agaricus) (gs1 gpc)",
    "GAZ_00002537": "Commonwealth of Massachusetts",
    "FOODON_03317349": "poultry product (cured, comminuted)",
    "NCBITaxon_31216": "Littorina littorea",
    "FOODON_03310628": "chicken (strained)",
    "NCBITaxon_149348": "Cayratia",
    "FOODON_00001964": "mammalian ice milk food product",
    "FOODON_03306034": "potato chip (blended)",
    "FOODON_03401659": "10005790 - duck - unprepared/unprocessed (gs1 gpc)",
    "NCBITaxon_490592": "Metanephrops japonicus",
    "FOODON_03305519": "carrot (canned)",
    "FOODON_03542525": "25250 - abalones, winkles, conchs (efsa foodex2)",
    "NCBITaxon_173691": "Dacryodes",
    "NCBITaxon_10060": "Ondatra zibethicus",
    "FOODON_03401679": "10006287 - reindeer/caribou - unprepared/unprocessed (gs1 gpc)",
    "GAZ_00005820": "Comoros",
    "FOODON_03412882": "shortnose chimaera family",
    "FOODON_03413426": "horehound plant",
    "FOODON_03540816": "08160 - other species of genus tuber, not elsewhere mentioned (efsa foodex2)",
    "ENVO_01000921": "closed animal house",
    "FOODON_03310847": "mixed vegetables (frozen)",
    "FOODON_03400725": "02  egg and egg products (eurocode2)",
    "FOODON_03311537": "white asparagus (cooked)",
    "FOODON_03543535": "35350 - plantain infusion leaves (efsa foodex2)",
    "FOODON_03311659": "topping, aerosol, low fat",
    "FOODON_03305390": "cheese pizza (cooked, frozen)",
    "FOODON_03304977": "soybean curd dessert (frozen)",
    "FOODON_03308159": "oyster (pan fry, breaded)",
    "NCBITaxon_7879": "Lepidosireniformes",
    "FOODON_03411426": "mackerel family",
    "FOODON_03304031": "blue cheese-flavored dip",
    "FOODON_03317580": "cow milk (semi-skimmed, uht-sterilized)",
    "NCBITaxon_8407": "Rana temporaria",
    "FOODON_03304388": "malted milk shake",
    "FOODON_03315413": "ice cream (lowfat)",
    "FOODON_03302314": "honey bun",
    "FOODON_03543231": "32310 - juice concentrate, apricots (efsa foodex2)",
    "FOODON_03316864": "cheese nuworld",
    "FOODON_03543614": "36140 - st. john's wort infusion flowers (efsa foodex2)",
    "FOODON_03542384": "23840 - pacific sandlance (efsa foodex2)",
    "NCBITaxon_376648": "Sphyrnidae",
    "FOODON_03315693": "brewers mash",
    "FOODON_03543608": "36080 - orange infusion flowers (efsa foodex2)",
    "NCBITaxon_148607": "Arctoscopus japonicus",
    "FOODON_03311484": "pizza with meat topping",
    "FOODON_00003360": "chicken carcass (whole)",
    "FOODON_03542884": "28840 - cheese, majorero (efsa foodex2)",
    "FOODON_03302872": "diet meal (liquid)",
    "FOODON_03401846": "10006453 - pepino (gs1 gpc)",
    "FOODON_03413374": "tsai shim plant",
    "FOODON_03317163": "citrus fruit syrup",
    "NCBITaxon_248764": "Macruronus novaezelandiae",
    "NCBITaxon_19953": "Valeriana officinalis",
    "FOODON_03414542": "golden chanterelle",
    "NCBITaxon_2653789": "Whippomorpha",
    "FOODON_03400202": "pastry, sweetened (us cfr)",
    "FOODON_03543844": "38440 - imitation yoghurt, non soy (efsa foodex2)",
    "FOODON_03411574": "fish, anguilliform",
    "FOODON_03542240": "22400 - nile tilapia (efsa foodex2)",
    "FOODON_03543293": "32930 - fruit soft drink, peach (efsa foodex2)",
    "FOODON_03308358": "hake (raw)",
    "FOODON_03316494": "confectionery (long-life)",
    "FOODON_03308527": "striped bass (raw)",
    "FOODON_03490192": "paperboard container with foil or liner overwrap",
    "FOODON_03316899": "nutritive preparation for clinical use",
    "FOODON_03315914": "dessert (jelly-like)",
    "FOODON_03540667": "06670 - cucurbits fruiting vegetables (efsa foodex2)",
    "FOODON_03400656": "08  aquatic animal products (ccpr)",
    "FOODON_03308452": "kawakawa tuna (raw)",
    "FOODON_00001594": "animal based food product for animal",
    "FOODON_03317435": "breakfast cereal (puffed)",
    "FOODON_03310142": "food made from wheat",
    "FOODON_03414350": "cubeb plant",
    "FOODON_03543458": "34580 - southernwood infusion leaves (efsa foodex2)",
    "FOODON_03401662": "10005791 - frog - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03414474": "alaska blueberry plant",
    "NCBITaxon_216285": "Trochoidea <superfamily>",
    "FOODON_00003276": "red velvet cake",
    "FOODON_03430103": "food (semiliquid)",
    "FOODON_03460398": "rind removal process",
    "FOODON_00001182": "pickled cruciferous food product",
    "FOODON_03311185": "shellfish (smoked)",
    "FOODON_03303104": "molasses (dried)",
    "FOODON_03542448": "24480 - scad (efsa foodex2)",
    "NCBITaxon_497223": "Gobiinae",
    "FOODON_03309790": "olive (whole, canned)",
    "FOODON_03411587": "atlantic salmon",
    "FOODON_03411173": "thyme, wild (plant)",
    "FOODON_03542227": "22270 - labeo carps (generic) (efsa foodex2)",
    "FOODON_03303032": "cream of potato soup (onion- and chicken-flavored)",
    "FOODON_03542109": "21090 - cured seasoned pork meat (efsa foodex2)",
    "FOODON_03400931": "10000156 - baking/cooking mixes (shelf stable) (gs1 gpc)",
    "FOODON_03302575": "caper in vinegar",
    "FOODON_03301663": "licorice candy",
    "FOODON_03544090": "40900 - vinegar, apple (efsa foodex2)",
    "NCBITaxon_179360": "Carangoides",
    "FOODON_03315181": "hen egg white (solid)",
    "FOODON_03490350": "metalized paper laminated with treated paper",
    "FOODON_03530204": "semidomestic or semiwild food production",
    "FOODON_03302535": "cake mix (dry)",
    "NCBITaxon_123368": "Acanthomorphata",
    "NCBITaxon_4219": "Artemisia",
    "FOODON_03543913": "39130 - mixed vegetables, braised (efsa foodex2)",
    "FOODON_03414860": "weatherfish",
    "FOODON_03401507": "10006343 - orangelos (gs1 gpc)",
    "FOODON_00001671": "buffalo meat food product",
    "FOODON_03303766": "milk chocolate-flavored candy bar",
    "HANCESTRO_0380": "Norwegian",
    "FOODON_03304429": "chicken and dumplings with vegetables (canned)",
    "FOODON_03541744": "17440 - plantains - paradisiaca cultivars (efsa foodex2)",
    "FOODON_03414564": "harp seal",
    "FOODON_03304118": "onion (grilled)",
    "FOODON_03301535": "apple juice (concentrated)",
    "FOODON_03414945": "broccolini plant",
    "FOODON_03401128": "10000147 - aquatic invertebrates - prepared/processed (shelf stable) (gs1 gpc)",
    "FOODON_03315072": "beverage prepared from dry mix",
    "FOODON_03420272": "high fructose syrup",
    "FOODON_03540066": "00660 - other cereals (efsa foodex2)",
    "FOODON_03316539": "bean in brine (tinned)",
    "FOODON_03400889": "10003689 - non grape fermented alcoholic beverages - sparkling (gs1 gpc)",
    "FOODON_03307685": "iced tea (lemon-flavored)",
    "NCBITaxon_13012": "Clarias",
    "FOODON_03543550": "35500 - toadflax infusion leaves (efsa foodex2)",
    "FOODON_03310090": "dill spice",
    "FOODON_03302807": "chocolate candy (cordial-filled)",
    "CHEBI_37947": "benzothiazoles",
    "FOODON_03414718": "long yam plant",
    "FOODON_03307294": "mineral water (carbonated)",
    "FOODON_03544239": "42390 - cinnamon flavour (efsa foodex2)",
    "FOODON_03311461": "beef eye round (roasted)",
    "FOODON_03401636": "10005778 - mixed species meat/poultry/other animal - alternative meat - prepared/processed (gs1 gpc)",
    "FOODON_03317023": "confectionery jelly product",
    "NCBITaxon_87759": "Sarpa salpa",
    "FOODON_03317202": "flavor concentrate in tablet form",
    "FOODON_03541684": "16840 - arbutus berries (efsa foodex2)",
    "FOODON_03311488": "raisin (seedless)",
    "FOODON_03301189": "seasoning",
    "PATO_0001316": "moderate increased temperature",
    "FOODON_03302027": "beet powder",
    "FOODON_03541975": "19750 - guinea-fowl fresh meat (efsa foodex2)",
    "FOODON_03400794": "red meat (eurofir)",
    "FOODON_03302277": "imitation grape drink mix (vitamin-fortified, artificially sweetened)",
    "FOODON_03401577": "10006075 - common thyme (gs1 gpc)",
    "FOODON_03306112": "lingonberry (sugared)",
    "CHEBI_33261": "organosulfur compound",
    "FOODON_03420220": "obsolete: cellulose",
    "FOODON_00002706": "chicken giblet",
    "FOODON_03460256": "carbohydrate fermentation",
    "CHEBI_36009": "omega-6 fatty acid",
    "FOODON_03412326": "american razor clam",
    "FOODON_03414406": "basic methacrylate copolymer",
    "FOODON_03305653": "beef (frozen)",
    "FOODON_03490202": "container or wrapping by material",
    "FOODON_03543331": "33310 - beer and beer-like beverage (efsa foodex2)",
    "FOODON_03412879": "razor shell clam",
    "FOODON_03542903": "29030 - cheese, ragusano (efsa foodex2)",
    "FOODON_03412156": "prickly poppy plant",
    "FOODON_03304561": "brown sugar replacement (granular, artificially sweetened)",
    "FOODON_03301139": "obsolete: food (canned)",
    "CHEBI_33978": "alkali metal hydroxide",
    "NCBITaxon_161923": "Penaeus esculentus",
    "PO_0009010": "seed",
    "FOODON_03543704": "37040 - coffee (average strength) beverage (efsa foodex2)",
    "FOODON_03400287": "sweet sauce or topping (us cfr)",
    "FOODON_03411063": "boysenberry plant",
    "FOODON_03307337": "watermelon jelly",
    "FOODON_03306425": "imitation strawberry preserves",
    "FOODON_03413483": "pod or seed vegetable, poisonous cultivars",
    "GAZ_00002947": "Luxembourg",
    "FOODON_03544205": "42050 - blackcurrant flavour (efsa foodex2)",
    "FOODON_03401567": "10006063 - apple mint (gs1 gpc)",
    "FOODON_00002535": "pain au chocolat",
    "FOODON_03317007": "meat product (processed)",
    "FOODON_03510211": "high {name of vitamin/s} and/or {name of mineral/s} nutrition claim",
    "FOODON_00002626": "Carignane grape plant",
    "FOODON_03305754": "acerola juice (food product)",
    "FOODON_03317093": "chocolate drink (with no added energy-containing, sweeteners, powders used to prepare)",
    "FOODON_03315503": "ikura",
    "GAZ_00006899": "Myanmar",
    "FOODON_03310321": "mushroom soup (canned)",
    "FOODON_00002794": "red banana (genus Musa, whole)",
    "FOODON_03306168": "fruit juice drink (diluted)",
    "FOODON_00002960": "macaroni and cheese",
    "FOODON_00003109": "hyssop food product",
    "FOODON_03307454": "lake michigan chub (smoked)",
    "FOODON_03306970": "chocolate milk (instant)",
    "FOODON_03541763": "17630 - marmaladedos (efsa foodex2)",
    "CHEBI_53249": "poly(vinylidene)",
    "FOODON_03411163": "palaemonid shrimp family",
    "FOODON_03413417": "chinese onion plant",
    "CHEBI_33694": "biomacromolecule",
    "FOODON_03413049": "calcium saccharin",
    "FOODON_03542599": "25990 - other edible snails not belonging to the genus helix (efsa foodex2)",
    "NCBITaxon_121025": "Arca imbricata",
    "FOODON_03411622": "mule deer",
    "NCBITaxon_8048": "Gadus",
    "CHEBI_25481": "naphthoquinone",
    "CHEBI_30527": "flavin",
    "CHEBI_22985": "calcium molecular entity",
    "FOODON_00001569": "high moisture corn (food product)",
    "FOODON_03400776": "092  manufactured milk products (multi-ingredient) of animal origin (lm) (ccpr)",
    "FOODON_00002198": "relish food product",
    "FOODON_03302248": "lemon and lime carbonated beverage (artificially sweetened)",
    "FOODON_00002964": "Kapchunka fish",
    "FOODON_03411861": "european plaice",
    "FOODON_03540161": "01610 - puffed corn textured bread (efsa foodex2)",
    "FOODON_03305694": "pollock mashed scallop-flavored",
    "FOODON_03540632": "06320 - tomatoes and similar- (efsa foodex2)",
    "FOODON_03544471": "44710 - steviol glucoside (efsa foodex2)",
    "FOODON_03412355": "cipollini plant",
    "FOODON_03306126": "loose leaf lettuce (raw)",
    "FOODON_03317646": "sausage meat",
    "FOODON_03544468": "44680 - neo-hesperidine (efsa foodex2)",
    "FOODON_03543918": "39180 - sandwiches, pizza and other stuffed bread-like cereal products (efsa foodex2)",
    "FOODON_00002059": "norway lobster food product",
    "NCBITaxon_29719": "Mentha spicata",
    "FOODON_03540939": "09390 - sun-dried tomatoes (efsa foodex2)",
    "FOODON_03306543": "wiesbadner tartlet",
    "FOODON_03414663": "elaeocarpus plant",
    "FOODON_03401225": "0140000 - stone fruit (ec)",
    "FOODON_03310005": "soybean paste (fermented)",
    "FOODON_03310322": "alfalfa tablet (food product)",
    "FOODON_03411416": "pistachio plant",
    "FOODON_03543159": "31590 - fruit juices (100% from named source) (efsa foodex2)",
    "FOODON_03542783": "27830 - cheese, blue de graven (efsa foodex2)",
    "FOODON_03541647": "16470 - figs (efsa foodex2)",
    "FOODON_03400229": "beverage (us cfr)",
    "FOODON_00003024": "cumin seed (whole, dried)",
    "FOODON_03414312": "king george whiting",
    "NCBITaxon_71275": "rosids",
    "FOODON_00002374": "flavoring syrup",
    "NCBITaxon_8256": "Pleuronectidae",
    "FOODON_03414706": "potato bean plant",
    "GAZ_00009572": "West Bank",
    "FOODON_03311004": "beef (canned)",
    "FOODON_03543886": "38860 - potatoes, meat, and vegetables meal (efsa foodex2)",
    "FOODON_03413985": "queensland school mackerel",
    "FOODON_03317144": "sauce in pressurised container",
    "FOODON_03413450": "amphidromous fish",
    "FOODON_03317519": "hen egg product (frozen)",
    "FOODON_03401116": "10000621 - sweet spreads variety packs (gs1 gpc)",
    "FOODON_03411918": "dolphinfish family",
    "FOODON_00002043": "mixed fruit beverage",
    "NCBITaxon_75034": "Pomatomus saltatrix",
    "NCBITaxon_22063": "Monimiaceae",
    "CHEBI_33484": "chalcogen oxoacid",
    "FOODON_03541743": "17430 - plantains - balbisiana cultivars (efsa foodex2)",
    "FOODON_03412498": "lizardfish family",
    "FOODON_03413710": "opium poppy plant",
    "FOODON_03460234": "dilution process to 15-49% of single strength",
    "FOODON_03541603": "16030 - partridge berries (efsa foodex2)",
    "FOODON_03540607": "06070 - lablab beans (with pods) (efsa foodex2)",
    "FOODON_03540115": "01150 - wheat germ (efsa foodex2)",
    "NCBITaxon_58880": "Phyllanthus <eudicots>",
    "FOODON_03414171": "south polar fungus",
    "FOODON_03543568": "35680 - heidelberg tea (efsa foodex2)",
    "FOODON_03414168": "plant used for dietary supplements",
    "FOODON_03308049": "clam strip (breaded, frozen)",
    "FOODON_00002923": "black cardamom plant",
    "FOODON_00002001": "acerola food product",
    "FOODON_03308325": "pacific sardine (raw)",
    "NCBITaxon_21621": "Heliotropium",
    "FOODON_03305664": "fruit juice (canned)",
    "FOODON_03315691": "fruit juice (single strength)",
    "FOODON_03308152": "french oyster (raw)",
    "FOODON_03310619": "imitation dairy product",
    "NCBITaxon_8893": "Apodidae",
    "FOODON_03510185": "iodized claim or use",
    "FOODON_03317463": "fruit spirits",
    "FOODON_03413122": "indigotine, indigo carmine",
    "NCBITaxon_9643": "Ursus americanus",
    "NCBITaxon_173342": "Trachinotus carolinus",
    "FOODON_03412043": "fonio plant",
    "FOODON_03530260": "fat content, milk and milk products (eurocode2)",
    "FOODON_03414562": "muskox",
    "FOODON_03412937": "cultivated mushroom",
    "FOODON_03541104": "11040 - lupins (dry) (efsa foodex2)",
    "FOODON_03316579": "multi-component plant food product",
    "FOODON_03412809": "white rubber vine plant",
    "FOODON_03411477": "sweetsop plant",
    "FOODON_00002390": "shiro an",
    "FOODON_03543504": "35040 - hemp infusion leaves (efsa foodex2)",
    "FOODON_03413169": "montan acid esters",
    "FOODON_03400004": "obsolete: product type, other",
    "FOODON_03303162": "creme-filled cookie",
    "FOODON_03307497": "coffee- and chicory-flavored syrup",
    "NCBITaxon_76071": "Beloniformes",
    "FOODON_00002661": "food (breaded)",
    "FOODON_03460194": "nutrient or dietary substance addition process",
    "FOODON_03305179": "tropical white banana (canned)",
    "NCBITaxon_387452": "Strombus costatus",
    "FOODON_03541966": "19660 - chicken, minced meat (efsa foodex2)",
    "FOODON_03308000": "porbeagle (raw)",
    "FOODON_03311047": "amberjack (raw)",
    "FOODON_03302408": "malt carbonated beverage (vitamin-fortified)",
    "FOODON_03315104": "lemon (whole)",
    "FOODON_03304316": "roll (starch-reduced)",
    "FOODON_03510017": "fat special claim or use",
    "FOODON_03308706": "snail shell",
    "FOODON_03541694": "16940 - water apples (efsa foodex2)",
    "NCBITaxon_4498": "Avena sativa",
    "FOODON_00002206": "rice product flavoring",
    "FOODON_03541561": "15610 - wineberries (efsa foodex2)",
    "FOODON_03411856": "righteye flounder family",
    "FOODON_00001621": "atlantic halibut food product",
    "FOODON_03301918": "anchovy (raw)",
    "FOODON_03540330": "03300 - porridge milk based (ready to eat) (efsa foodex2)",
    "NCBITaxon_160721": "Epinephelus itajara",
    "FOODON_03400458": "CIAA bakery wares",
    "FOODON_03309839": "peanut meal (raw)",
    "FOODON_03301069": "candy (pill-shaped)",
    "FOODON_03542635": "26350 - canned tunas and similar (efsa foodex2)",
    "FOODON_03310622": "minnow (raw)",
    "FOODON_03414734": "potato orchid plant",
    "FOODON_03460288": "curing or aging < 2 weeks",
    "FOODON_03301142": "aspic",
    "FOODON_03304466": "cream (sterilized, sour cream flavored)",
    "FOODON_00002550": "tostada (tortilla)",
    "FOODON_00001256": "dairy food product",
    "N2c137d7d7730479d848e9b3efa18c505": "acid",
    "FOODON_03420119": "seed, skin present, germ removed",
    "FOODON_00001712": "cheese product analog",
    "NCBITaxon_103480": "Castanea crenata",
    "FOODON_03414040": "spot-tail spiny turbot",
    "FOODON_03317199": "green pea (whole)",
    "FOODON_03530295": "foot (poultry meat cut)",
    "FOODON_03541400": "14000 - tonka bean (efsa foodex2)",
    "FOODON_03542343": "23430 - brill (efsa foodex2)",
    "FOODON_03311280": "lettuce (shredded)",
    "FOODON_03307289": "imitation mustard flour",
    "FOODON_03541271": "12710 - marjoram, dry (efsa foodex2)",
    "FOODON_03414739": "pepperweed plant",
    "FOODON_03411564": "food product organismal source",
    "CHEBI_45979": "thiabendazole",
    "FOODON_03305282": "whipped cream substitute",
    "NCBITaxon_249022": "Engraulis anchoita",
    "NCBITaxon_112883": "Lycium chinense",
    "FOODON_03540084": "00840 - spelt flour (efsa foodex2)",
    "FOODON_03306501": "hamburger seasoning",
    "HANCESTRO_0459": "Northern Mariana Islander",
    "NCBITaxon_72446": "Labeo catla",
    "FOODON_03543768": "37680 - follow-on formula, soya-based, liquid (efsa foodex2)",
    "FOODON_03306073": "lemon and marjoram jelly",
    "NCBITaxon_8669": "Pseudechis",
    "NCBITaxon_28974": "Averrhoa carambola",
    "FOODON_03400115": "cheese or cheese product (us cfr)",
    "FOODON_03306354": "pecan roll",
    "FOODON_03414826": "nanchee plant",
    "FOODON_00001318": "noa mai dong",
    "FOODON_03309481": "rattlesnake meat (smoked, canned)",
    "NCBITaxon_44598": "Pterioida",
    "FOODON_03542012": "20120 - bovine liver (efsa foodex2)",
    "NCBITaxon_6550": "Mytilus edulis",
    "FOODON_03401311": "enzyme supplement",
    "FOODON_03540858": "08580 - curry herb (efsa foodex2)",
    "FOODON_03541865": "18650 - canned or jarred mandarin (efsa foodex2)",
    "FOODON_03414000": "angola dentex",
    "FOODON_03306823": "pea (whole, early june)",
    "FOODON_03401725": "10006436 - salak (snake fruit) (gs1 gpc)",
    "FOODON_03414732": "boat orchid plant",
    "FOODON_03301434": "beef-flavored bouillon cube",
    "FOODON_00001773": "cow milk cheese analog",
    "FOODON_03311227": "tamarind juice (raw)",
    "FOODON_03306696": "beet (whole, raw)",
    "FOODON_03305300": "fruit juice beverage (diluted, noncarbonated)",
    "FOODON_03308547": "scallop (russian, raw)",
    "FOODON_03302519": "butter-flavored roll (frozen)",
    "ENVO_01000245": "cropland biome",
    "FOODON_03540148": "01480 - sticks, salty (efsa foodex2)",
    "NCBITaxon_30976": "Psychrolutidae",
    "FOODON_03412568": "sailfin sandfish",
    "FOODON_00001976": "jalapeno pepper food product",
    "FOODON_03530095": "obsolete: sausage casing not known",
    "FOODON_03544150": "41500 - fudge sauce (efsa foodex2)",
    "FOODON_03413189": "polyglycerol esters of fatty acids",
    "FOODON_03311737": "processed food product",
    "FOODON_03309784": "star anise fruit (whole)",
    "NCBITaxon_872808": "Polypodium virginianum",
    "FOODON_03401598": "10006072 - rosemary (gs1 gpc)",
    "NCBITaxon_87148": "Fucus serratus",
    "FOODON_03412776": "black mulberry plant",
    "FOODON_03309579": "imitation wine vinegar",
    "NCBITaxon_154467": "Bactris gasipaes",
    "FOODON_03315232": "pecan (whole, raw)",
    "FOODON_03542378": "23780 - meagre (efsa foodex2)",
    "FOODON_03411091": "sweet cherry plant",
    "CHEBI_3435": "carrageenan",
    "NCBITaxon_96885": "Sardinella",
    "NCBITaxon_7041": "Coleoptera",
    "FOODON_03414148": "australian scallop",
    "FOODON_03304163": "shortening (colored added)",
    "FOODON_00001264": "legume food product",
    "FOODON_03316886": "potato (quick-frozen)",
    "GAZ_00004021": "Curacao Island",
    "FOODON_03541028": "10280 - field bean (fresh seeds) (efsa foodex2)",
    "FOODON_03306043": "rice (spent)",
    "FOODON_03543173": "31730 - juice, cranberry (efsa foodex2)",
    "FOODON_03414644": "moth",
    "FOODON_03541151": "11510 - hickory nuts (efsa foodex2)",
    "FOODON_00001952": "horse meat food product",
    "FOODON_03520199": "obsolete: czechoslovakia",
    "FOODON_00003016": "orange bell pepper (whole, raw)",
    "FOODON_03540784": "07840 - common mushrooms (efsa foodex2)",
    "FOODON_03301391": "mushroom (canned)",
    "FOODON_03414089": "painted ray",
    "CHEBI_25585": "nonmetal atom",
    "NCBITaxon_30917": "Polynemidae",
    "FOODON_03540582": "05820 - rakkyo (efsa foodex2)",
    "FOODON_03311398": "illipe oil",
    "FOODON_03310890": "apple compote",
    "FOODON_03301070": "chocolate liquor",
    "FOODON_03307550": "applesauce (canned)",
    "FOODON_00002119": "pineapple food product",
    "NCBITaxon_3502": "Fagales",
    "FOODON_03303448": "rock lobster tail meat (raw)",
    "FOODON_03401519": "10000622 - confectionery/sugar sweetening products variety packs (gs1 gpc)",
    "FOODON_03311355": "grass protein concentrate powdered",
    "FOODON_03411843": "alaska pollock",
    "FOODON_03400680": "015  pulses (vd) (ccpr)",
    "FOODON_03543316": "33160 - soft drink, mango flavour (efsa foodex2)",
    "FOODON_03400257": "fruit or vegetable product (us cfr)",
    "FOODON_03309673": "oyster in brine (canned)",
    "FOODON_03307174": "pineapple and orange juice (strained)",
    "FOODON_03401053": "10000041 - fats edible - animal (perishable) (gs1 gpc)",
    "FOODON_03542291": "22910 - eel, american (efsa foodex2)",
    "FOODON_03520363": "pacific ocean islands",
    "FOODON_03302776": "soybean oil",
    "FOODON_03541559": "15590 - korean raspberries (efsa foodex2)",
    "NCBITaxon_235595": "Phyllantheae",
    "FOODON_03542460": "24600 - requiem shark (efsa foodex2)",
    "FOODON_03411892": "sucker family",
    "FOODON_03309175": "corvina (raw)",
    "FOODON_03308700": "pacific blue marlin (raw)",
    "FOODON_03316428": "sweets",
    "FOODON_03540828": "08280 - chives and similar- (efsa foodex2)",
    "NCBITaxon_9722": "Odontoceti",
    "FOODON_03306874": "peanut (whole, roasted, partially defatted)",
    "FOODON_03544267": "42670 - fruit flavour (efsa foodex2)",
    "FOODON_00002132": "plant based salad food product",
    "FOODON_03541159": "11590 - siberian dwarf pine nut kernels (efsa foodex2)",
    "FOODON_03317208": "dairy food for infant",
    "FOODON_03306955": "butter and egg noodle",
    "FOODON_03411905": "atlantic rainbow smelt",
    "FOODON_00001317": "noa mai",
    "FOODON_03401844": "10006128 - aubergines (gs1 gpc)",
    "GAZ_00006888": "Cambodia",
    "FOODON_03541926": "19260 - pig fresh meat (efsa foodex2)",
    "CHEBI_46662": "mineral",
    "FOODON_03305038": "obsolete: infant formula (liquid, milk-based, canned)",
    "NCBITaxon_8277": "Beryciformes",
    "FOODON_03543372": "33720 - cocktail drink (efsa foodex2)",
    "FOODON_03311104": "hijiki",
    "FOODON_03305078": "olive oil (seasoned with basil oil)",
    "FOODON_03305091": "chicken fat",
    "NCBITaxon_1016941": "Oxynotus centrina",
    "NCBITaxon_9263": "Metatheria",
    "FOODON_03307027": "pork and beans with tomato sauce (canned)",
    "NCBITaxon_4555": "Setaria italica",
    "FOODON_03530174": "oil content 25-50%",
    "FOODON_03530221": "haccp guide food safety term",
    "FOODON_03304440": "meat goulash",
    "FOODON_03306616": "cupcake",
    "FOODON_03310296": "peanut candy",
    "FOODON_03543411": "34110 - coffee beans, roasted (efsa foodex2)",
    "FOODON_03301426": "whey (spray-dried)",
    "FOODON_03311708": "garlic in oil",
    "FOODON_03302797": "marshmallow syrup (artificially colored and flavored)",
    "FOODON_03540750": "07500 - swedes (efsa foodex2)",
    "FOODON_03317351": "poultry product (cured)",
    "FOODON_03412639": "enteromorpha",
    "FOODON_03305530": "honey (with butter and spice)",
    "FOODON_03413072": "cyclamic acid",
    "FOODON_03301022": "honey (crystallized)",
    "NCBITaxon_42345": "Phoenix dactylifera",
    "FOODON_03540516": "05160 - chickpea sprouts (efsa foodex2)",
    "FOODON_03480022": "packed in acidified salt brine",
    "FOODON_03301065": "barley sugar",
    "FOODON_03460228": "flavoring added, artificial",
    "CHEBI_42191": "ethylenediaminetetraacetic acid",
    "FOODON_03301900": "cotton candy",
    "NCBITaxon_43873": "Zygophyllaceae",
    "NCBITaxon_7813": "Mustelus antarcticus",
    "FOODON_03306427": "fruit ade",
    "FOODON_03411421": "soft wheat plant",
    "FOODON_00002426": "arugula greens (raw)",
    "FOODON_03460272": "obsolete: margarine added",
    "RO_0002131": "overlaps",
    "FOODON_03413390": "java-almond plant",
    "CHEBI_63551": "carbohydrate acid derivative anion",
    "FOODON_03401747": "10006454 - lentils (gs1 gpc)",
    "FOODON_03490203": "bottle or jar",
    "FOODON_03301174": "capsicum pepper (whole, raw)",
    "FOODON_03304806": "iced tea mix (dry)",
    "FOODON_03310885": "frigate mackerel (steamed)",
    "NCBITaxon_45650": "Anseranatidae",
    "FOODON_03411973": "white sturgeon",
    "IAO_0000102": "data about an ontology part",
    "FOODON_00003319": "langostino lobster product (sensu USA)",
    "FOODON_03413185": "phosphated distarch phosphate",
    "FOODON_03413776": "dexpantothenol",
    "FOODON_03316777": "field corn (canned)",
    "FOODON_03414397": "hydrogenated poly-1-decene",
    "FOODON_03544474": "44740 - vitamin a     (retinol, carotenoids) (efsa foodex2)",
    "FOODON_03412769": "dacryodes plant",
    "FOODON_00001798": "cusk food product",
    "FOODON_03311642": "fat or oil, reclaimed",
    "FOODON_03303787": "candy (raspberry-flavored)",
    "FOODON_03540810": "08100 - gypsy mushroom (efsa foodex2)",
    "FOODON_03308796": "lichen (food product)",
    "FOODON_03412622": "brown durra plant",
    "FOODON_00001953": "horseradish plant food product",
    "FOODON_00002060": "nut candy",
    "FOODON_03401470": "10006118 - swedish turnips (rutabagas) (gs1 gpc)",
    "NCBITaxon_454057": "Pampus cinereus",
    "FOODON_03400990": "10000205 - fruit - prepared/processed (perishable) (gs1 gpc)",
    "FOODON_03544291": "42910 - horseradish flavour (efsa foodex2)",
    "FOODON_03304362": "apple and apricot (dried)",
    "FOODON_03540866": "08660 - thyme (efsa foodex2)",
    "FOODON_03400963": "10000314 - grains/cereal - not ready to eat - (frozen) (gs1 gpc)",
    "NCBITaxon_3394": "Cycadaceae",
    "CHEBI_22916": "boron molecular entity",
    "FOODON_00001184": "algal food product",
    "FOODON_03401048": "10000278 - yoghurt/yoghurt substitutes (perishable) (gs1 gpc)",
    "FOODON_03316127": "fish product (preserved)",
    "NCBITaxon_232378": "Proteales",
    "NCBITaxon_8103": "Cyclopterus lumpus",
    "FOODON_03470140": "drum-drying",
    "FOODON_03414990": "maori dock plant",
    "FOODON_00002490": "carrot root (whole or parts)",
    "FOODON_03510063": "low fiber food",
    "FOODON_03470134": "shelf-drying under normal pressure",
    "FOODON_03540337": "03370 - mixed breakfast cereals (efsa foodex2)",
    "FOODON_03543125": "31250 - sheep tallow (efsa foodex2)",
    "FOODON_03411253": "goose",
    "GAZ_00052663": "[Former] Yugoslavia",
    "NCBITaxon_16360": "Alismatales",
    "FOODON_00001655": "blue runner food product",
    "FOODON_03307673": "tuna and mushroom sauce (food product)",
    "FOODON_03413503": "gull",
    "FOODON_03301238": "dewberry (whole, raw)",
    "FOODON_03308816": "shrimp roe (raw)",
    "NCBITaxon_45949": "Corbicula fluminea",
    "FOODON_03411306": "cherry plant",
    "NCBITaxon_55119": "Alosinae",
    "FOODON_03401702": "10006827 - winter melons or odourless muskmelons (gs1 gpc)",
    "FOODON_03543210": "32100 - juice, celery (efsa foodex2)",
    "FOODON_03541937": "19370 - asses-mules-hinnies fresh meat (efsa foodex2)",
    "FOODON_03311790": "persimmon (whole, raw)",
    "FOODON_03541562": "15620 - other cane fruits (efsa foodex2)",
    "FOODON_03542320": "23200 - shads (efsa foodex2)",
    "FOODON_03412417": "japanese chestnut tree",
    "FOODON_03412895": "black ruff",
    "FOODON_03411309": "beet plant",
    "FOODON_03411778": "blue runner",
    "CHEBI_16526": "carbon dioxide",
    "FOODON_03540513": "05130 - adzuki bean sprouts (efsa foodex2)",
    "FOODON_03543964": "39640 - pasta, cooked, with vegetables (efsa foodex2)",
    "FOODON_03411014": "hemicellulose-producing plant",
    "FOODON_03301041": "rye grain",
    "FOODON_00001651": "black raspberry food product",
    "FOODON_03310484": "minitrout raw",
    "FOODON_03304393": "cow buttermilk and butter oil (reconstituted)",
    "FOODON_03400818": "leavened bread (eurofir)",
    "UO_0000190": "ratio",
    "FOODON_03543409": "34090 - robusta coffee beans (efsa foodex2)",
    "NCBITaxon_72113": "Scorpaena",
    "FOODON_00002105": "pearl millet food product",
    "IAO_0000408": "length measurement datum",
    "FOODON_03306375": "bitter orange marmalade",
    "FOODON_03541198": "11980 - black mustard seeds (efsa foodex2)",
    "FOODON_03542586": "25860 - frog, pool (efsa foodex2)",
    "FOODON_03400352": "international agency food product type",
    "FOODON_03543576": "35760 - chamomile and similar- (efsa foodex2)",
    "FOODON_03520493": "semiarid climatic zone",
    "FOODON_03316832": "macaroni (egg, vegetable)",
    "FOODON_03301758": "praline",
    "NCBITaxon_1300979": "Nematalosa come",
    "FOODON_00002925": "black cardamom",
    "FOODON_03542575": "25750 - amphibians and reptiles (efsa foodex2)",
    "FOODON_03540793": "07930 - pearl oyster mushrooms (efsa foodex2)",
    "FOODON_03411535": "agave plant",
    "FOODON_03413081": "dipotassium inosinate",
    "FOODON_03317629": "poultry product (cooked)",
    "FOODON_03401443": "10006347 - madrona (gs1 gpc)",
    "CHEBI_51721": "alpha,beta-unsaturated ketone",
    "FOODON_03541177": "11770 - oilseeds (efsa foodex2)",
    "GAZ_00008744": "Mongolia",
    "FOODON_03542470": "24700 - bluefish roe (efsa foodex2)",
    "FOODON_03307349": "strawberry bar cookie (food product)",
    "FOODON_03316769": "cocoa and vegetable fat coating sweet",
    "FOODON_03316000": "baked good (fine, small product, coated with chocolate)",
    "FOODON_03306108": "lingonberry preserves",
    "FOODON_03540762": "07620 - sea lettuce (efsa foodex2)",
    "FOODON_03541702": "17020 - fuzzy kiwifruit (efsa foodex2)",
    "GAZ_00000567": "Ethiopia",
    "FOODON_03414380": "short-horned water buffalo",
    "NCBITaxon_3563": "Amaranthaceae",
    "FOODON_03414899": "terrestrial invertebrate",
    "FOODON_03411249": "papaya plant",
    "FOODON_03543004": "30040 - sugar cane molasses (efsa foodex2)",
    "NCBITaxon_291371": "Atelecyclidae",
    "FOODON_03412527": "spiny eel",
    "FOODON_03301475": "corn sugar",
    "FOODON_03304365": "confectioner's sugar with dextrose (food product)",
    "FOODON_03414569": "lesser black-backed gull",
    "FOODON_03302337": "white bread (unsalted, enriched)",
    "FOODON_03412447": "ramie plant",
    "FOODON_03309139": "brazilian pompano (raw)",
    "FOODON_03307373": "vinegar (powdered)",
    "FOODON_03311829": "tea (ready to drink)",
    "FOODON_03315870": "cheese (varietal, soft)",
    "FOODON_00002524": "mealworm",
    "FOODON_03412687": "common whitefish",
    "FOODON_03412389": "wrasse",
    "FOODON_03530054": "meat color, mixture",
    "FOODON_00002258": "soup mix product",
    "NCBITaxon_75727": "Zizania aquatica",
    "FOODON_03303670": "ilchester cheese (beer-flavored)",
    "FOODON_03544201": "42010 - berries flavour (efsa foodex2)",
    "FOODON_03306429": "meat (raw)",
    "FOODON_03309400": "gefilte fish in jelled broth (canned)",
    "FOODON_03540991": "09910 - sugar plants (efsa foodex2)",
    "CHEBI_28803": "pyridoxine 5'-phosphate",
    "FOODON_03414162": "arctic hare",
    "FOODON_03544328": "43280 - mustard flavour (efsa foodex2)",
    "FOODON_03301459": "tomato powder",
    "FOODON_03306021": "imitation orange juice (vitamin c added, frozen concentrate)",
    "FOODON_03304147": "french dressing (low sodium)",
    "ENVO_00001999": "marine water body",
    "NCBITaxon_861789": "Coregonus wartmanni",
    "FOODON_03401634": "10005776 - land snail - prepared/processed (gs1 gpc)",
    "FOODON_03302313": "wheat bread dough (frozen)",
    "FOODON_03310835": "breakfast cereal (fortified, ready-to-eat)",
    "FOODON_03542181": "21810 - knackwurst-type sausage (efsa foodex2)",
    "FOODON_03414668": "nonda plum plant",
    "GAZ_00006887": "Bosnia and Herzegovina",
    "FOODON_03304545": "turkey (frozen)",
    "FOODON_00002152": "plant seed cereal food product",
    "FOODON_03303932": "chocolate mint candy bar",
    "FOODON_03305518": "vodka",
    "FOODON_00002642": "food (chilled)",
    "NCBITaxon_195626": "Lyopsetta exilis",
    "NCBITaxon_445224": "Parapenaeus longirostris",
    "FOODON_03301031": "honey (decharacterized)",
    "FOODON_00001736": "chum salmon food product",
    "FOODON_03310681": "tapioca flour",
    "FOODON_00002739": "food (packaged)",
    "FOODON_03540468": "04680 - bracken (efsa foodex2)",
    "CHEBI_35605": "carbon oxoacid",
    "NCBITaxon_6704": "Nephropidae",
    "FOODON_03412479": "black cherry plant",
    "GAZ_00002511": "Bolivia",
    "FOODON_03317361": "poultry roll (raw)",
    "NCBITaxon_7906": "Acipenser ruthenus",
    "FOODON_03317573": "liqueur wine",
    "FOODON_03307159": "fruit jelly (uncooked, frozen)",
    "FOODON_03305449": "cherry ice (naturally-flavored)",
    "FOODON_03542917": "29170 - cheese, shropshire blue (efsa foodex2)",
    "FOODON_03304171": "cookie (sugar-free)",
    "FOODON_00001630": "barley alcoholic beverage analog",
    "FOODON_03541257": "12570 - other minor oilfruit (efsa foodex2)",
    "FOODON_03309988": "obsolete: food made from maize (food product)",
    "FOODON_03307313": "field pea (dried, canned)",
    "FOODON_03540726": "07260 - parsley roots and similar- (efsa foodex2)",
    "NCBITaxon_13363": "Borago officinalis",
    "NCBITaxon_214697": "Musa acuminata AAA Group",
    "FOODON_03309557": "cabbage (pickled)",
    "NCBITaxon_290984": "Paullinia pinnata",
    "FOODON_03305316": "fruit pulp (frozen)",
    "FOODON_03411358": "triticale plant",
    "FOODON_03543111": "31110 - walnut oil (efsa foodex2)",
    "NCBITaxon_102809": "Astereae",
    "FOODON_03411538": "shallot plant",
    "NCBITaxon_397978": "Pandalus montagui",
    "FOODON_03315169": "vitamin and mineral dietary supplement",
    "FOODON_00002027": "meat product analog",
    "FOODON_03411915": "mackerel shark family",
    "FOODON_03510029": "pet animal as consumer",
    "FOODON_00001656": "blueberry food product",
    "FOODON_03543334": "33340 - beer, strong (efsa foodex2)",
    "FOODON_03305256": "table cream (whipped)",
    "FOODON_03316669": "yogurt product (heat treated after fermentation)",
    "CHEBI_51082": "nitrate salt",
    "FOODON_03315338": "shellfish (salted)",
    "ENVO_00010504": "surface layer",
    "FOODON_03305673": "ice cream soda (instant)",
    "FOODON_03420177": "gluten",
    "IAO_0010000": "has axiom label",
    "CHEBI_25413": "monounsaturated fatty acid",
    "FOODON_00001102": "fermented grain beverage",
    "FOODON_03401766": "10006414 - medlar (gs1 gpc)",
    "FOODON_03316421": "citrus juice concentrates for further commercial processing",
    "FOODON_03540879": "08790 - mints (efsa foodex2)",
    "ENVO_00002259": "agricultural soil",
    "NCBITaxon_212017": "Lethocerus indicus",
    "CHEBI_33597": "homocyclic compound",
    "FOODON_03540837": "08370 - coriander leaves (efsa foodex2)",
    "NCBITaxon_345840": "Palaemon modestus",
    "FOODON_03306460": "caribou meat (raw)",
    "FOODON_03411055": "red currant plant",
    "FOODON_00001863": "fondant food product",
    "FOODON_03309747": "sweet potato chip",
    "FOODON_03317272": "blood food product (fresh, livestock)",
    "FOODON_03317058": "sandwich spread with no added sugar (cocoa-based)",
    "FOODON_03544204": "42040 - blackberry flavour (efsa foodex2)",
    "FOODON_03401418": "10006834 - adzuki beans (gs1 gpc)",
    "FOODON_03309821": "pea (strained)",
    "FOODON_03412446": "beefsteak morel",
    "FOODON_03542620": "26200 - flat-fishes, dried (efsa foodex2)",
    "FOODON_03302587": "cow buttermilk (cultured, dried)",
    "FOODON_03540751": "07510 - turnips and similar- (efsa foodex2)",
    "FOODON_03540262": "02620 - cheese cake (efsa foodex2)",
    "FOODON_03309909": "fish (dried)",
    "FOODON_00001566": "post-evisceration carcass",
    "FOODON_03311884": "compressed yeast food product",
    "FOODON_03542037": "20370 - sheep kidney (efsa foodex2)",
    "FOODON_03305128": "cream of mushroom soup",
    "FOODON_03415032": "siberian pine plant",
    "GAZ_00007117": "Baker Island",
    "FOODON_03540613": "06130 - african locust bean (with pods) (efsa foodex2)",
    "NCBITaxon_39174": "Origanum",
    "FOODON_03543368": "33680 - madeira (efsa foodex2)",
    "NCBITaxon_1489938": "Terapontoidei",
    "FOODON_03307701": "herb dressing",
    "NCBITaxon_3674": "Momordica cochinchinensis",
    "FOODON_03305230": "fruit drink (artificially sweetened)",
    "FOODON_03301036": "coffee (liquid drink)",
    "FOODON_03306095": "goat milk (powdered, canned)",
    "FOODON_03413586": "velvet fan lobster",
    "FOODON_03542788": "27880 - cheese, fleur de maquis (efsa foodex2)",
    "FOODON_03308556": "pink salmon (raw)",
    "NCBITaxon_40505": "Lutjanus campechanus",
    "FOODON_03411177": "yellow perch",
    "FOODON_03540501": "05010 - garden cress sprouts (efsa foodex2)",
    "FOODON_03304012": "piquant sauce",
    "FOODON_03413472": "bleak",
    "PO_0020100": "hypocotyl",
    "FOODON_03304180": "sea herring (boneless, hard-smoked)",
    "FOODON_03542602": "26020 - arachnids (efsa foodex2)",
    "FOODON_03304533": "rice (coated, fortified)",
    "FOODON_03510253": "pregnant or lactating woman as food consumer",
    "FOODON_03302062": "barbeque sauce",
    "FOODON_00001645": "beverage analog",
    "FOODON_00002893": "Flying barb fish",
    "FOODON_03542297": "22970 - atlantic salmon (efsa foodex2)",
    "FOODON_03306240": "beef fat (hydrolyzed)",
    "FOODON_03411308": "leek plant",
    "FOODON_03543978": "39780 - dolma (efsa foodex2)",
    "FOODON_03308583": "rock crab (raw)",
    "FOODON_03401849": "10006420 - hin choy (gs1 gpc)",
    "FOODON_03540160": "01600 - puffed rice textured bread (efsa foodex2)",
    "FOODON_00002082": "papaya leaf food product",
    "FOODON_03311712": "potato (sliced, raw, vaccum-packed)",
    "FOODON_00002289": "sugar beet food product",
    "FOODON_03310112": "rapeseed (whole, dried)",
    "FOODON_03315639": "cream cheese spread (with added ingredients)",
    "NCBITaxon_86973": "Okapia johnstoni",
    "OBI_0001929": "mass value specification",
    "FOODON_03311178": "scallop made from surimi",
    "FOODON_03304138": "cocoa mix (instant)",
    "FOODON_03460140": "decaffeination process",
    "FOODON_03540187": "01870 - fresh stuffed durum pasta (efsa foodex2)",
    "FOODON_03317355": "muscle tissue (raw)",
    "NCBITaxon_178174": "Syzygium",
    "FOODON_03401661": "10006288 - emu - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03540302": "03020 - meringue (efsa foodex2)",
    "FOODON_00002883": "fermented salmon",
    "FOODON_03540339": "03390 - cereal flakes and similar (efsa foodex2)",
    "FOODON_03315858": "molasses (refiner's)",
    "FOODON_03541108": "11080 - andean lupin (dry) (efsa foodex2)",
    "FOODON_03309484": "dough (frozen)",
    "FOODON_03544084": "40840 - yeast extract (efsa foodex2)",
    "FOODON_03400395": "decolourizing agent (codex)",
    "NCBITaxon_6695": "Palaemonidae",
    "FOODON_03302105": "cereal beverage",
    "FOODON_03401513": "10006442 - tangor (gs1 gpc)",
    "NCBITaxon_8235": "Thunnus alalunga",
    "FOODON_03315840": "l-lysine tablet",
    "FOODON_00002470": "food object quality",
    "CHEBI_78320": "2-hydroxypropanoic acid",
    "FOODON_03530105": "external fat trimmed to 1/4 inch",
    "FOODON_03307384": "confectioner's whey (sweetened, dried)",
    "FOODON_03301849": "sorghum syrup (food product)",
    "FOODON_03305332": "consomme",
    "FOODON_00001885": "fruit butter food product",
    "FOODON_03510243": "high monounsaturated fat",
    "FOODON_03414557": "greater rhea",
    "FOODON_00002945": "kibble",
    "FOODON_03413917": "golden goatfish",
    "NCBITaxon_1489926": "Uranoscopiformes",
    "GAZ_00005915": "Christmas Island",
    "FOODON_03530251": "food (genetically-modified)",
    "FOODON_03414677": "syzygium plant",
    "FOODON_03306775": "cream-filled pastry",
    "NCBITaxon_1699523": "Myrteae",
    "FOODON_03301481": "shrimp (cooked)",
    "FOODON_03510071": "saturated fat-related claim or use",
    "FOODON_03301324": "shiitake mushroom extract",
    "FOODON_00001278": "cake food product",
    "FOODON_03540303": "03030 - waffles (efsa foodex2)",
    "FOODON_03412766": "common kaki plant",
    "FOODON_03414764": "dichapetalum plant",
    "FOODON_03303017": "chicken stick",
    "FOODON_03311087": "beef liver (frozen)",
    "FOODON_03542450": "24500 - mackerel, atlantic (efsa foodex2)",
    "NCBITaxon_429176": "Glycymeris glycymeris",
    "FOODON_03305681": "incaparina flour",
    "FOODON_03301521": "vegetable (waxed)",
    "FOODON_03530069": "grade o, europe",
    "FOODON_03544321": "43210 - milk flavour (efsa foodex2)",
    "FOODON_00003156": "meat spread",
    "FOODON_03315020": "fruit (processed)",
    "FOODON_03412468": "king orange plant",
    "FOODON_03530213": "under glass/protected organic plant cultivation",
    "FOODON_03400417": "food colour (codex)",
    "FOODON_03540119": "01190 - wheat bread and rolls, white (refined flour) (efsa foodex2)",
    "FOODON_03302212": "carrot (home-canned)",
    "PO_0009066": "anther",
    "NCBITaxon_183656": "Urophycis chuss",
    "IAO_0000600": "elucidation",
    "FOODON_03400243": "soup, thin (us cfr)",
    "FOODON_03301155": "clam (canned)",
    "FOODON_03412902": "silver scabbardfish",
    "FOODON_03302338": "wheat bread (artificially colored)",
    "FOODON_03544480": "44800 - vitamin b7   (biotin) (efsa foodex2)",
    "FOODON_00002640": "Cabernet Sauvignon grape plant",
    "FOODON_03540746": "07460 - scorzonera (efsa foodex2)",
    "FOODON_03543026": "30260 - xylitol (efsa foodex2)",
    "HANCESTRO_0422": "Kittitian or Nevisian",
    "FOODON_03542144": "21440 - fresh raw sausages (efsa foodex2)",
    "FOODON_03317127": "root vegetable (flakes, granulated, powdered)",
    "CARO_0030000": "biological entity",
    "FOODON_03415171": "red sandalwood plant",
    "FOODON_03305399": "sour cream (cultured, flavored)",
    "FOODON_03413521": "pacific angel shark",
    "FOODON_03411095": "belgian carrot plant",
    "FOODON_03304610": "chocolate chip ice cream",
    "FOODON_03400641": "CCFAC composite foods",
    "FOODON_03540988": "09880 - goa bean root (efsa foodex2)",
    "FOODON_03544073": "40730 - stock cubes or granulate, meat (efsa foodex2)",
    "FOODON_03315381": "food glaze, frozen",
    "FOODON_03311789": "tripe (scalded)",
    "FOODON_03430111": "cut into short pieces",
    "FOODON_03310900": "crabmeat (pasteurized, cooked)",
    "FOODON_03316667": "cheese preparation processed",
    "FOODON_03541469": "14690 - australian finger lime (efsa foodex2)",
    "FOODON_03541685": "16850 - camu camus (efsa foodex2)",
    "NCBITaxon_169618": "Ixoroideae",
    "FOODON_00001209": "pulse food product",
    "FOODON_03414716": "polynesian arrowrrot plant",
    "FOODON_03304908": "watermelon sherbet",
    "FOODON_03420292": "obsolete: cotyledon",
    "NCBITaxon_32561": "Sauria",
    "HANCESTRO_0017": "Oceanian",
    "NCBITaxon_84009": "Arctostaphylos uva-ursi",
    "FOODON_03308485": "anchovy-flavored black olive spread",
    "FOODON_03305095": "cinnamon fern (raw)",
    "NCBITaxon_40958": "Pimpinella",
    "FOODON_00002565": "elderflower",
    "FOODON_03540714": "07140 - baby carrots (efsa foodex2)",
    "FOODON_03309616": "kanda (raw)",
    "FOODON_03311897": "baumkuchen",
    "FOODON_03414370": "mulard duck",
    "FOODON_03401884": "10006458 - sea kale (gs1 gpc)",
    "FOODON_03541493": "14930 - japanese apricots (efsa foodex2)",
    "FOODON_00001836": "european filbert nut food product",
    "FOODON_03543197": "31970 - nectar, apple (efsa foodex2)",
    "FOODON_03311037": "skim milk (condensed)",
    "FOODON_00002402": "castor bean food product",
    "FOODON_03540640": "06400 - ground cherries (physalis etc.) (efsa foodex2)",
    "FOODON_03430176": "gummy",
    "NCBITaxon_107322": "Coregonus peled",
    "FOODON_03302335": "butter and egg bread (artificially colored)",
    "FOODON_03400742": "037  poultry fats (pf) (ccpr)",
    "FOODON_03540995": "09950 - chicory roots and similar- (efsa foodex2)",
    "FOODON_03310966": "pineapple danish pastry",
    "FOODON_03317314": "gravy (meat based)",
    "FOODON_03412819": "rubus plant",
    "FOODON_03315790": "ice (prepackaged)",
    "NCBITaxon_9707": "Odobenus rosmarus",
    "FOODON_03303763": "chocolate cream candy (dietetic)",
    "NCBITaxon_490588": "Metanephrops binghami",
    "FOODON_03309177": "barnacle (giant, raw)",
    "FOODON_03540353": "03530 - popcorn (maize, popped) (efsa foodex2)",
    "FOODON_03543786": "37860 - other food for infants and children (efsa foodex2)",
    "FOODON_03470130": "freeze-drying",
    "NCBITaxon_2068716": "Anatinae",
    "NCBITaxon_85427": "Zosterisessor",
    "FOODON_03415103": "lycium plant",
    "FOODON_03308125": "clam (soft shell, shucked, raw)",
    "FOODON_00001911": "goat dairy food product",
    "FOODON_03310335": "green bean (frozen)",
    "FOODON_03306586": "soy protein (spray-dried)",
    "FOODON_03400241": "soft drink (us cfr)",
    "NCBITaxon_8266": "Hippoglossus",
    "GAZ_00000460": "Eurasia",
    "NCBITaxon_37334": "Citrus maxima",
    "FOODON_03317405": "crustacean (unprocessed, deep-frozen)",
    "NCBITaxon_34772": "Alosa",
    "FOODON_03413552": "goose barnacle",
    "FOODON_03500040": "food-grade glass surface",
    "FOODON_03470150": "sous vide cooking",
    "FOODON_03541624": "16240 - bayberries (efsa foodex2)",
    "FOODON_03543735": "37350 - rose infusion (efsa foodex2)",
    "NCBITaxon_109170": "Pachyrhizus",
    "FOODON_03308785": "california halibut (raw)",
    "FOODON_03315155": "tripe food product",
    "FOODON_03309626": "shark (raw)",
    "FOODON_03309381": "florida lake perch (raw)",
    "GAZ_00003102": "San Marino",
    "FOODON_03317153": "icicle, no sugar added except lactose",
    "RO_0009001": "has substance added",
    "GAZ_00004440": "Commonwealth of Kentucky",
    "FOODON_03309688": "mussel (north island, raw)",
    "FOODON_03470107": "food preservation process",
    "FOODON_03306008": "orange and grapefruit juice (frozen concentrate)",
    "FOODON_03301019": "honey (jellied)",
    "NCBITaxon_109628": "Illex coindetii",
    "FOODON_03412873": "land cress plant",
    "FOODON_03303159": "macaroon (artificially sweetened)",
    "FOODON_03304240": "oyster (breaded)",
    "FOODON_03400687": "024  seed for beverages and sweets (sb) (ccpr)",
    "FOODON_03301105": "paprika",
    "FOODON_03303607": "hot chocolate mix (instant)",
    "FOODON_03302148": "food (frozen)",
    "FOODON_03541343": "13430 - cassia bark (generic) (efsa foodex2)",
    "FOODON_03400316": "cheese hardness class (us cfr)",
    "FOODON_03304535": "second clears",
    "FOODON_03412130": "hippopotamus",
    "FOODON_00003215": "winterization of oil",
    "FOODON_00001096": "fermented elaeis palm beverage",
    "FOODON_03400323": "food additive regulatory classification",
    "FOODON_03540731": "07310 - nettle roots (efsa foodex2)",
    "PATO_0000600": "increased width",
    "FOODON_03540591": "05910 - welsh onions (efsa foodex2)",
    "FOODON_03411681": "lamb's quarter plant",
    "FOODON_03413414": "marsh marigold plant",
    "FOODON_03308668": "shrimp (raw, peeled, deveined, frozen)",
    "FOODON_03412450": "bracken fern plant",
    "BFO_0000017": "realizable entity",
    "FOODON_03304360": "strawberry (sliced)",
    "FOODON_03510131": "\"less\" label claim",
    "FOODON_03542940": "29400 - dairy ice creams and similar (efsa foodex2)",
    "FOODON_03470146": "preservation by adding sugar",
    "FOODON_03540454": "04540 - grape leaves (efsa foodex2)",
    "NCBITaxon_9053": "Phasianus",
    "FOODON_03412401": "monkfish",
    "FOODON_00001150": "cucurbit fruit food product",
    "NCBITaxon_5268": "Ustilaginaceae",
    "FOODON_03301826": "olive oil",
    "FOODON_03542351": "23510 - hakes (efsa foodex2)",
    "FOODON_03412368": "sandperch family",
    "GAZ_00002514": "State of New York",
    "FOODON_03305987": "knish",
    "NCBITaxon_864893": "Menippidae",
    "FOODON_03411754": "lamb's lettuce plant",
    "FOODON_03460848": "guarana seed",
    "UO_0000008": "meter",
    "FOODON_03420116": "part of organism",
    "FOODON_03303622": "whiskey sour cocktail mix (low calorie, sugar-free)",
    "FOODON_03304845": "sea turtle egg (raw)",
    "NCBITaxon_267067": "Enteroctopus dofleini",
    "FOODON_03541374": "13740 - uzazi fruit (efsa foodex2)",
    "FOODON_03316426": "nutmeg seed",
    "FOODON_03530055": "color of fish flesh",
    "FOODON_03301348": "cane sugar",
    "FOODON_03315311": "soft drink mix, powdered",
    "FOODON_03316259": "obsolete: dietetic food used for specific physiological-nutritional and dietetic purposes intended for infants and toddlers",
    "FOODON_03414854": "wuchang bream",
    "FOODON_03317630": "veal steak (raw, fabricated)",
    "FOODON_03311367": "lowfat cow milk (1% fat, vitamin a and d added)",
    "FOODON_03303708": "acidified cow milk dairy product",
    "FOODON_03311611": "chicken (battered, deep-fried)",
    "FOODON_03315614": "berry product",
    "NCBITaxon_4112": "Solanum nigrum",
    "FOODON_03315399": "beverage mix (coffee based)",
    "FOODON_03541717": "17170 - prickly pears and similar- (efsa foodex2)",
    "CHEBI_17716": "lactose",
    "FOODON_03542958": "29580 - turkey eggs (efsa foodex2)",
    "FOODON_03304396": "cow milk (sterilized)",
    "FOODON_03411796": "freshwater drum",
    "NCBITaxon_52273": "Scorpaenichthys marmoratus",
    "FOODON_03306398": "apricot preserves",
    "FOODON_03401357": "50350700 - stem lettuce (gs1 gpc)",
    "FOODON_03414934": "solanaceae plant",
    "FOODON_03307339": "watermelon rind (pickled)",
    "FOODON_03309369": "nondairy dessert topping (in pressurized container)",
    "CHEBI_53424": "polysorbate 20",
    "CHEBI_33673": "zinc group molecular entity",
    "FOODON_03304254": "lobster bisque",
    "FOODON_03310185": "ghee",
    "FOODON_03310187": "spinach pasta",
    "FOODON_00002166": "potato soup food product",
    "FOODON_03420148": "root, stem, leaf or flower",
    "FOODON_03400976": "50160000 - confectionery/sugar sweetening products (gs1 gpc)",
    "FOODON_03401687": "10005832 - alternative meat/poultry/other animal sausages - prepared/processed (gs1 gpc)",
    "FOODON_03305537": "honey with added butter",
    "FOODON_03307359": "herring tidbit in sherry sauce",
    "FOODON_03543416": "34160 - instant coffee powder (efsa foodex2)",
    "FOODON_03308753": "select oyster (raw)",
    "FOODON_03543791": "37910 - products for non-standard diets, food imitates and food supplements (efsa foodex2)",
    "FOODON_03541916": "19160 - cow, ox or bull fresh meat (efsa foodex2)",
    "FOODON_03540765": "07650 - other red algae (efsa foodex2)",
    "FOODON_03420288": "seed bran",
    "FOODON_03316922": "hen egg white mass (quick-frozen)",
    "FOODON_00002328": "vanilla bean food product",
    "FOODON_03543598": "35980 - great mullein infusion flowers (efsa foodex2)",
    "NCBITaxon_1579277": "Mobula mobular",
    "FOODON_03411031": "pea plant edible pod cultivars",
    "FOODON_03411591": "Rock Cornish game hen",
    "NCBITaxon_181394": "Ophidiinae",
    "FOODON_03301050": "lemon-flavored beverage mix (dry)",
    "FOODON_03302054": "lima bean (canned)",
    "NCBITaxon_58933": "Triticum spelta",
    "FOODON_03413573": "florida crayfish",
    "FOODON_03542484": "24840 - freshwater crustaceans (efsa foodex2)",
    "NCBITaxon_212736": "Centrophorus",
    "PO_0025007": "collective plant organ structure",
    "FOODON_03460266": "carbohydrate removal process",
    "FOODON_00001752": "coho salmon food product",
    "UO_0000165": "volume percentage",
    "FOODON_03315682": "dry mix, unstandardized",
    "FOODON_03544440": "44400 - firming agent (efsa foodex2)",
    "NCBITaxon_136225": "Zingiber mioga",
    "FOODON_03400667": "19  manufactured food (multi-ingredient) of animal origin (ccpr)",
    "FOODON_03543369": "33690 - port (efsa foodex2)",
    "FOODON_03412394": "puffer",
    "FOODON_00002785": "marrow bean (whole)",
    "FOODON_03316942": "obsolete: pectin",
    "FOODON_03310560": "cream of celery soup",
    "FOODON_03316268": "gelatin-type dessert substitute",
    "FOODON_03543328": "33280 - liquid drink bases (including concentrates and home-made preparations) (efsa foodex2)",
    "FOODON_03460329": "mold food-curing process",
    "FOODON_03543182": "31820 - juice, elderberry (efsa foodex2)",
    "FOODON_03510090": "no or reduced sugar claim or use",
    "FOODON_00002577": "grape wine by region",
    "FOODON_03305430": "white corn (frozen)",
    "FOODON_03315651": "poultry meat (preserved)",
    "NCBITaxon_45204": "Gobius",
    "FOODON_03542925": "29250 - cheese, livarot (efsa foodex2)",
    "FOODON_00001898": "garlic product flavoring or seasoning",
    "FOODON_03302591": "white sauce dry mix (butter-flavored)",
    "FOODON_03530280": "green skin",
    "CHEBI_48299": "butane-1,2,3,4-tetrol",
    "FOODON_03307171": "guava (pulp)",
    "FOODON_03400284": "prepared egg dish (us cfr)",
    "FOODON_03413223": "powdered cellulose",
    "PO_0020127": "primary root",
    "NCBITaxon_8342": "Anura",
    "FOODON_03412183": "white catfish",
    "FOODON_00002635": "fusilli",
    "FOODON_03302684": "middle east bread",
    "FOODON_03306462": "game meat (canned)",
    "FOODON_03309752": "safflower seed (whole, raw)",
    "FOODON_00001640": "berry food product",
    "FOODON_03411759": "greasy rockcod",
    "FOODON_03311168": "clove ground",
    "FOODON_00002638": "penne",
    "FOODON_03541762": "17620 - mammey sapotes (efsa foodex2)",
    "FOODON_00002831": "cannelloni",
    "FOODON_03420306": "obsolete: root",
    "FOODON_00001668": "broth or stock food product",
    "CHEBI_36357": "polyatomic entity",
    "FOODON_03303539": "cheddar cheese (salt-free)",
    "FOODON_03541921": "19210 - buffalo, cape fresh meat (efsa foodex2)",
    "FOODON_03542898": "28980 - cheese, formai de mut (efsa foodex2)",
    "FOODON_03315576": "garnishing paste",
    "FOODON_03304169": "shortening (whipped)",
    "ENVO_01001479": "fluid astronomical body part",
    "FOODON_03308172": "japanese spiny lobster (raw)",
    "FOODON_03311658": "beef (electrically stimulated)",
    "FOODON_03412491": "slipper lobster",
    "FOODON_03302241": "imitation carbonated beverage base (artificially flavored and colored)",
    "FOODON_03540482": "04820 - chinese cabbages (efsa foodex2)",
    "FOODON_03400684": "021  grasses for sugar and syrup production (gs) (ccpr)",
    "NCBITaxon_47310": "Proterorhinus marmoratus",
    "FOODON_03317423": "food for infants or young children",
    "FOODON_03302517": "butter (seasoned)",
    "NCBITaxon_9526": "Catarrhini",
    "FOODON_03541998": "19980 - rabbit, fresh fat tissue (efsa foodex2)",
    "ENVO_01000044": "marine pelagic feature",
    "FOODON_03540130": "01300 - bread and rolls with special ingredients added (efsa foodex2)",
    "FOODON_03309028": "pollock (smoked)",
    "FOODON_03315792": "beverage mix (fruit-flavored)",
    "FOODON_00002188": "rasberry spread or sauce",
    "FOODON_03543929": "39290 - sandwich with cheese and vegetable topping/filling (efsa foodex2)",
    "FOODON_00001178": "honey food product",
    "NCBITaxon_443802": "Percophis brasiliensis",
    "NCBITaxon_16748": "Saururaceae",
    "FOODON_03430119": "semisolid with smooth consistency",
    "HANCESTRO_0400": "Bolivian",
    "FOODON_03542870": "28700 - cheese, canestrato pugliese (efsa foodex2)",
    "FOODON_03541107": "11070 - yellow lupin (dry) (efsa foodex2)",
    "FOODON_03305642": "yellow corn meal",
    "FOODON_03543238": "32380 - juice concentrate, grape (efsa foodex2)",
    "NCBITaxon_145700": "Attalea speciosa",
    "FOODON_03542742": "27420 - cheese, boilie (efsa foodex2)",
    "FOODON_00001155": "watermelon plant",
    "FOODON_03305868": "imitation cherry jelly (whisky-flavored)",
    "FOODON_03309622": "striped spiny lobster (raw)",
    "NCBITaxon_9072": "Phasianinae",
    "FOODON_03540572": "05720 - kohlrabies and similar- (efsa foodex2)",
    "FOODON_03310388": "torula yeast (dry)",
    "FOODON_00002013": "macaroni or noodle food product",
    "FOODON_03316565": "vegetable product in sour pickle",
    "FOODON_03544316": "43160 - mascarpone flavour (efsa foodex2)",
    "FOODON_03542548": "25480 - clams (efsa foodex2)",
    "FOODON_03544451": "44510 - processing aids (efsa foodex2)",
    "PO_0030103": "drupe fruit",
    "RO_0003001": "produced by",
    "CHEBI_59230": "acetate salt",
    "FOODON_03413634": "atlantic jackknife",
    "FOODON_03317205": "vitamin and mineral concentrate, liquid form",
    "FOODON_00002053": "mustard vegetable food product",
    "FOODON_03420291": "obsolete: corm",
    "FOODON_03315088": "obsolete: dessert dairy frozen",
    "FOODON_03401427": "10006759 - acai berries (gs1 gpc)",
    "FOODON_03309453": "oxtail soup (thickened)",
    "FOODON_03311535": "amaranth grain (cereal)",
    "FOODON_03302854": "sherbet",
    "FOODON_00001882": "fruit based alcoholic beverage",
    "FOODON_03540042": "00420 - rice grain, red (efsa foodex2)",
    "FOODON_03305679": "corn in butter sauce (canned)",
    "FOODON_03310083": "quiche lorraine",
    "FOODON_03316977": "white heart cherry (bottled)",
    "NCBITaxon_3685": "Passiflora quadrangularis",
    "FOODON_03303097": "chipped beef",
    "GAZ_00007144": "Line Islands",
    "FOODON_03460149": "obsolete: honey added",
    "FOODON_03307163": "peach preserve",
    "FOODON_03315008": "obsolete: fats or oils",
    "FOODON_00003133": "medlar (whole, raw)",
    "FOODON_03306129": "lingonberry juice (food product)",
    "FOODON_03310688": "kamaboko (raw)",
    "FOODON_03302564": "ice cream bar",
    "FOODON_03316119": "legume (canned)",
    "BFO_0000008": "temporal region",
    "FOODON_03302605": "butter-flavored seasoning",
    "FOODON_03306307": "macaroni and cheese mix (cooked, frozen)",
    "NCBITaxon_44588": "Panax quinquefolius",
    "IAO_0000136": "is about",
    "FOODON_03308542": "scallop (sea, raw)",
    "FOODON_03450041": "food reheating in pan or cooking utensil",
    "NCBITaxon_27787": "Eretmochelys imbricata",
    "FOODON_03412558": "new mexico red pepper plant",
    "FOODON_03401809": "10006200 - scorzonera (gs1 gpc)",
    "FOODON_03543424": "34240 - wheat coffee ingredient (efsa foodex2)",
    "FOODON_03306710": "tea cookie",
    "FOODON_03305872": "jelly base (instant)",
    "FOODON_03310797": "red bell pepper (dried)",
    "NCBITaxon_334903": "Argyrosomus hololepidotus",
    "FOODON_03311586": "tea (artificial flavored)",
    "FOODON_03310608": "oatmeal cereal for infants (dry)",
    "FOODON_03307329": "shrimp (peeled, precooked, frozen)",
    "FOODON_03540660": "06600 - ethiopian eggplants (efsa foodex2)",
    "NCBITaxon_3932": "Eucalyptus",
    "FOODON_03541439": "14390 - bergamots (efsa foodex2)",
    "FOODON_00003341": "brassica vegetable food product",
    "FOODON_03411187": "white seabass",
    "FOODON_03304058": "doughnut mix",
    "FOODON_03305305": "guava jelly",
    "FOODON_03542678": "26780 - human milk (efsa foodex2)",
    "FOODON_00001094": "fermented beverage",
    "FOODON_03308227": "escolar (raw)",
    "PO_0030092": "loculicidal capsule fruit",
    "FOODON_03543392": "33920 - fruit liqueur (efsa foodex2)",
    "FOODON_03412309": "snakehead family",
    "FOODON_03308488": "pimiento (sliced, canned)",
    "FOODON_03310148": "spice grains (food product)",
    "FOODON_03414267": "carissa plant",
    "CHEBI_33576": "sulfur-containing carboxylic acid",
    "FOODON_03414959": "worcesterberry plant",
    "FOODON_03411862": "american plaice",
    "FOODON_03401029": "10000169 - butter/butter substitutes (shelf stable) (gs1 gpc)",
    "FOODON_03411113": "kidney bean plant",
    "FOODON_03543492": "34920 - field horsetail infusion leaves (efsa foodex2)",
    "FOODON_03543924": "39240 - hot dog with bread (efsa foodex2)",
    "FOODON_03401801": "10006364 - lotus root (gs1 gpc)",
    "FOODON_00003181": "loquat (whole, raw)",
    "PATO_0001545": "inflexible",
    "FOODON_03401479": "10006007 - kurrat (gs1 gpc)",
    "PO_0009085": "exocarp",
    "FOODON_03309491": "gin",
    "FOODON_03315044": "beverage tea (liquid, concentrate)",
    "FOODON_03317053": "marmalade (with no added sugar)",
    "FOODON_03540142": "01420 - matzo (efsa foodex2)",
    "FOODON_03530243": "lead poisoning",
    "NCBITaxon_318457": "Palinurus mauritanicus",
    "FOODON_03543542": "35420 - smooth rupturewort infusion leaves (efsa foodex2)",
    "FOODON_03480024": "packed in extra heavily sweetened liquid",
    "CHEBI_33767": "cobalt group molecular entity",
    "FOODON_03303824": "citrus and guarana beverage concentrate (artificially colored)",
    "NCBITaxon_3555": "Beta vulgaris subsp. vulgaris",
    "NCBITaxon_7832": "Echinorhinidae",
    "NCBITaxon_59836": "Leiostomus",
    "FOODON_03307315": "fish fillet (smoked)",
    "FOODON_03303566": "meatball (raw)",
    "FOODON_03316531": "fruit produce",
    "FOODON_03305075": "sorbetto",
    "FOODON_03317625": "pork picnic (uncooked, cured)",
    "FOODON_03310370": "coriander (whole)",
    "FOODON_03412683": "arrow squid",
    "FOODON_03303605": "chocolate-flavored topping",
    "FOODON_03544256": "42560 - egg yolk flavour (efsa foodex2)",
    "FOODON_03543962": "39620 - lasagna (efsa foodex2)",
    "FOODON_03543126": "31260 - goat tallow (efsa foodex2)",
    "FOODON_03541430": "14300 - tangelolos (efsa foodex2)",
    "FOODON_00002828": "multi-component pasta product",
    "FOODON_03304416": "lemon hard candy (artificially sweetened)",
    "FOODON_03543771": "37710 - ready-to-eat meal for infants and young children (efsa foodex2)",
    "FOODON_03541424": "14240 - grapefruits and similar- (efsa foodex2)",
    "FOODON_03541471": "14710 - pome fruits (efsa foodex2)",
    "FOODON_00002600": "Reserve wine",
    "FOODON_03316578": "milk pudding",
    "FOODON_03308555": "chinook salmon (raw)",
    "FOODON_03301168": "grape leaf (raw)",
    "FOODON_03317284": "meatball",
    "FOODON_03490258": "cork wood gasket",
    "FOODON_03317624": "fish fillet (deep-frozen)",
    "FOODON_03541771": "17710 - brazilian guavas (efsa foodex2)",
    "FOODON_03544517": "45170 - other edible apiculture products (efsa foodex2)",
    "FOODON_03315984": "fruit preparation (energy reduced)",
    "FOODON_03401644": "10006303 - reindeer/caribou - prepared/processed (gs1 gpc)",
    "FOODON_03414775": "northern beantree plant",
    "NCBITaxon_490597": "Metanephrops velutinus",
    "FOODON_03307062": "limeade",
    "FOODON_00002178": "pudding food product",
    "FOODON_03303692": "baker's cheese (food product)",
    "NCBITaxon_93744": "Brachychiton",
    "FOODON_00003371": "finisher pig",
    "FOODON_03530026": "short loin",
    "FOODON_03541671": "16710 - maprangs (efsa foodex2)",
    "FOODON_03414443": "potassium sulphates",
    "FOODON_03317337": "ground beef patty",
    "FOODON_03306600": "strawberry jam (canned)",
    "FOODON_03308230": "dover sole (raw)",
    "FOODON_03306679": "lemon pie",
    "FOODON_03302999": "gelatin from fish",
    "FOODON_03306718": "imitation cherry juice (dehydrated)",
    "FOODON_03304502": "date sugar syrup",
    "FOODON_03412506": "morello cherry plant",
    "FOODON_03542941": "29410 - ice cream, milk-based (efsa foodex2)",
    "FOODON_03306694": "pea protein concentrate",
    "FOODON_03316741": "cheese (extra hard, grating)",
    "FOODON_03316611": "obsolete: seasoning product, loose, concentrate",
    "FOODON_03542059": "20590 - equine edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "FOODON_03316360": "citrus peel (dried)",
    "FOODON_03412808": "hairy landolphia plant",
    "HANCESTRO_0485": "Bangladeshi",
    "FOODON_03305417": "chocolate cake",
    "FOODON_03307574": "canadian sockeye salmon (canned)",
    "FOODON_03510240": "modified ethnic food claim or use",
    "FOODON_03411716": "arrowhead plant",
    "FOODON_03542559": "25590 - octopus, musky (efsa foodex2)",
    "FOODON_03542493": "24930 - oriental river prawn (efsa foodex2)",
    "FOODON_03310899": "heart (raw)",
    "FOODON_03302993": "pasteurized process cheddar cheese",
    "PATO_0001715": "decreased diameter",
    "FOODON_03315964": "snack (dry)",
    "FOODON_03317415": "gehakt",
    "NCBITaxon_316130": "Centrolophus niger",
    "FOODON_03315038": "fruit flavored drinks and ades, frozen concentrate",
    "NCBITaxon_69450": "Cistaceae",
    "FOODON_03411199": "thyme plant",
    "FOODON_03303553": "pinto refried beans (instant)",
    "FOODON_03303522": "sour cream (cheddar cheese-flavored)",
    "FOODON_03306916": "imitation cinnamon (made from pecan shells)",
    "FOODON_03542671": "26710 - ass milk (efsa foodex2)",
    "FOODON_03307831": "cold-pack cheese food with wine",
    "FOODON_03401466": "10006197 - pointed cabbage (gs1 gpc)",
    "FOODON_03400114": "frozen dairy dessert (us cfr)",
    "FOODON_03302256": "soft drink base (naturally and artificially sweetened, dry)",
    "FOODON_03540489": "04890 - kales and similar- (efsa foodex2)",
    "CHEBI_53225": "poly(alkylene) macromolecule",
    "FOODON_03542225": "22250 - mud carp (efsa foodex2)",
    "FOODON_03411803": "spotted rose snapper",
    "FOODON_03401584": "10006456 - herbs variety pack (gs1 gpc)",
    "NCBITaxon_1648004": "Bambusinae",
    "FOODON_03309763": "grapefruit juice (diluted)",
    "FOODON_03530289": "orange skin",
    "FOODON_03315122": "beverage fermented malt",
    "FOODON_03309201": "white hake (raw)",
    "FOODON_03400457": "CIAA cereals and cereal products",
    "FOODON_03412127": "barnacle",
    "FOODON_03541158": "11580 - siberian pine nut kernels (efsa foodex2)",
    "FOODON_03411849": "atlantic menhaden",
    "NCBITaxon_53852": "Cassia fistula",
    "CHEBI_63367": "monosaccharide derivative",
    "FOODON_03490137": "plastic shrink-pack",
    "FOODON_03310621": "lobster meat (cooked)",
    "FOODON_03302048": "blackberry preserve",
    "FOODON_03306430": "meat in wine sauce",
    "FOODON_03543168": "31680 - juice, apricot-orange (efsa foodex2)",
    "UBERON_0001474": "bone element",
    "FOODON_00002308": "tableted food product",
    "FOODON_03414852": "japanese quail",
    "FOODON_03308309": "oyster (breaded, pan-fried)",
    "FOODON_03460758": "obsolete: gluten added",
    "CHEBI_63037": "triammonium citrate",
    "FOODON_03541359": "13590 - turmeric roots and similar- (efsa foodex2)",
    "FOODON_03460224": "obsolete: corn syrup added",
    "FOODON_03542270": "22700 - perch (efsa foodex2)",
    "FOODON_03304505": "fruit cocktail (artificially sweetened, canned)",
    "FOODON_00003210": "soybean oil (low linolenic)",
    "FOODON_03414189": "true senna plant",
    "FOODON_00002255": "sole food product",
    "FOODON_00002377": "plant product based flavoring",
    "FOODON_03309737": "beef (raw)",
    "FOODON_03302612": "butter sauce seasoning mix",
    "FOODON_03544331": "43310 - nutmeg flavour (efsa foodex2)",
    "FOODON_03310344": "bean leaf (raw)",
    "FOODON_03460131": "obsolete: artificially sweetened fruit jelly added",
    "NCBITaxon_200963": "Trigonella caerulea",
    "FOODON_03540630": "06300 - fruiting vegetables (efsa foodex2)",
    "FOODON_03543879": "38790 - eggs benedict (efsa foodex2)",
    "CHEBI_33977": "metallic base",
    "FOODON_03411454": "popcorn plant",
    "FOODON_03315915": "dessert (fruit-flavored)",
    "FOODON_03305247": "blueberry pie filling (artificially colored)",
    "FOODON_00001647": "black currant nectar beverage",
    "FOODON_03510214": "food allergen labelling about cereals containing gluten and products thereof",
    "FOODON_03411149": "northern white shrimp",
    "CHEBI_25367": "molecule",
    "CHEBI_25693": "organic heteromonocyclic compound",
    "FOODON_03510237": "traditional composition claim or use",
    "FOODON_03315712": "sweetened seasoning for snack food",
    "FOODON_03541360": "13600 - turmeric roots (efsa foodex2)",
    "RO_0002353": "output of",
    "FOODON_03414044": "freshwater sole",
    "UBERON_0001630": "muscle organ",
    "FOODON_03301215": "thyme (dried)",
    "FOODON_03304435": "beef (steak, freeze-dried)",
    "FOODON_03309110": "spanish mackerel (raw)",
    "FOODON_00001026": "obsolete: cane sugar",
    "FOODON_03311594": "bonito dried",
    "FOODON_03411512": "bluefish",
    "FOODON_03542541": "25410 - scallop, giant pacific (efsa foodex2)",
    "NCBITaxon_262399": "Chionoecetes tanneri",
    "FOODON_03543199": "31990 - nectar, banana (efsa foodex2)",
    "FOODON_03413357": "plant according to family",
    "FOODON_03530220": "food packing medium not drained",
    "FOODON_03303655": "goat milk cheese",
    "FOODON_00001586": "almond cookie food product",
    "FOODON_03304839": "turkey egg food product",
    "FOODON_03414192": "pale purple cone-flower plant",
    "FOODON_00002643": "food (dehydrated)",
    "FOODON_03544304": "43040 - lime flavour (efsa foodex2)",
    "FOODON_03304848": "eggplant (breaded)",
    "FOODON_03305824": "mince pie",
    "FOODON_03412382": "rainbow runner",
    "FOODON_03315735": "vitamin d preparations for addition to food, dry",
    "FOODON_03542812": "28120 - cheese, double gloucester (efsa foodex2)",
    "NCBITaxon_4747": "Orchidaceae",
    "FOODON_03401141": "10000017 - fish - prepared/processed (frozen) (gs1 gpc)",
    "FOODON_03315969": "confectionery (dried-fruit-based, energy reduced)",
    "FOODON_03542440": "24400 - amberjack (efsa foodex2)",
    "FOODON_00002602": "Riesling grape plant",
    "FOODON_03420227": "seed(s) in shell or hull",
    "FOODON_03543488": "34880 - purple echinacea infusion leaves (efsa foodex2)",
    "UBERON_0002548": "larva",
    "FOODON_00001271": "yak milk beverage",
    "FOODON_00002837": "blood food product",
    "NCBITaxon_169655": "Morindeae",
    "FOODON_03310205": "orange juice (calcium-fortified)",
    "FOODON_03412249": "bluefin searobin",
    "NCBITaxon_8063": "Merluccius merluccius",
    "FOODON_03413641": "sunray venus",
    "NCBITaxon_62062": "Hucho hucho",
    "FOODON_03542168": "21680 - spreadable cooked sausages (efsa foodex2)",
    "FOODON_03542321": "23210 - hilsa shad (efsa foodex2)",
    "NCBITaxon_30848": "Lethrinidae",
    "GAZ_00004483": "Iraq",
    "FOODON_03310968": "sheep milk cheese",
    "FOODON_03306641": "cooking oil (spent)",
    "FOODON_03543810": "38100 - vitamin only supplements (efsa foodex2)",
    "FOODON_03316945": "macaroni product (nonfat milk, enriched)",
    "FOODON_03541961": "19610 - marine mammals meat (efsa foodex2)",
    "NCBITaxon_85428": "Zosterisessor ophiocephalus",
    "FOODON_03308385": "pan trout (raw)",
    "NCBITaxon_156152": "Plantaginaceae",
    "FOODON_00002382": "neri y\u014dkan",
    "FOODON_03311741": "crabmeat (cooked, vacuum-packed)",
    "NCBITaxon_29154": "Micropogonias undulatus",
    "FOODON_03303202": "yellow corn (raw)",
    "FOODON_03400810": "other animal fats (eurofir)",
    "FOODON_03540603": "06030 - ervils (with pods) (efsa foodex2)",
    "FOODON_03316027": "cheese (sliced, prepacked)",
    "FOODON_03306842": "potato (whipped)",
    "FOODON_03310580": "gum drop candy",
    "FOODON_00003259": "B\u00e9chamel sauce",
    "FOODON_03412063": "guarana plant",
    "FOODON_03303951": "papaya preserves (food product)",
    "FOODON_03542650": "26500 - milk, whey and cream (efsa foodex2)",
    "FOODON_03315039": "imitation fruit flavored drinks and ades (noncarbonated, refrigerated single-strength)",
    "FOODON_00001614": "apple wine food product",
    "FOODON_03413370": "bogue",
    "FOODON_00001860": "flax vegetable food product",
    "NCBITaxon_36184": "Thymallus",
    "FOODON_03304786": "gun jam tea (dry)",
    "FOODON_00001750": "cod food product",
    "NCBITaxon_72085": "Sebastes melanops",
    "FOODON_00002449": "zebra food product",
    "FOODON_03413741": "lowbush blueberry plant",
    "FOODON_03315414": "ice cream (reduced fat)",
    "FOODON_03430157": "non-chewable tablet",
    "FOODON_03414058": "blue whitefish",
    "FOODON_03540873": "08730 - oregano (efsa foodex2)",
    "FOODON_03543460": "34600 - alfalfa infusion leaves (efsa foodex2)",
    "FOODON_03309921": "peanut (press cake)",
    "NCBITaxon_1527200": "Beta vulgaris subsp. cicla",
    "FOODON_03490130": "glass container",
    "FOODON_03414988": "great burnet plant",
    "FOODON_03306447": "mold-ripened cheese",
    "FOODON_03305114": "candy (rum-filled)",
    "FOODON_03412562": "rocotillo pepper plant",
    "FOODON_03401113": "10000187 - confectionery based spreads (shelf stable) (gs1 gpc)",
    "FOODON_00002463": "food (pan-fried)",
    "FOODON_00003202": "beverage",
    "FOODON_03412850": "beggiatoales",
    "FOODON_03413527": "sandbar shark",
    "FOODON_03301577": "squash (whole, raw)",
    "FOODON_03302365": "sour dough starter culture",
    "FOODON_03414047": "danube salmon genus",
    "FOODON_03543816": "38160 - herbal formulations and plant extracts (efsa foodex2)",
    "FOODON_00002003": "lingonberry food product",
    "FOODON_03414079": "warty dory",
    "FOODON_03309085": "halibut (raw)",
    "FOODON_03305807": "potato doughnut",
    "FOODON_03411365": "fish, bony",
    "FOODON_03414755": "cayratia plant",
    "FOODON_00002735": "sole fillet",
    "FOODON_03316235": "biscuit (containing fat)",
    "FOODON_03542368": "23680 - sea bream (efsa foodex2)",
    "FOODON_03311438": "avocado oil",
    "FOODON_03317018": "dessert made from curd cheese",
    "FOODON_03304166": "meat fat shortening",
    "FOODON_03316779": "skim milk (acidified)",
    "GAZ_00000590": "Oceans and Seas",
    "FOODON_03401227": "0200000 - 2. vegetables fresh or frozen (ec)",
    "FOODON_03544520": "45200 - enzymes for fortification (efsa foodex2)",
    "FOODON_03401731": "10006255 - vegetable juice drinks - ready to drink (perishable) (gs1 gpc)",
    "CHEBI_30059": "potassium hexacyanoferrate(4-)",
    "FOODON_03490332": "saturated (immersed) paper container",
    "FOODON_03400248": "doughnut (us cfr)",
    "FOODON_03302574": "grapefruit juice (pink, artificially colored)",
    "FOODON_03301614": "rum",
    "FOODON_03540990": "09900 - chinese water chestnut (efsa foodex2)",
    "FOODON_03317158": "fruit pulp (no energy-containing sweetener added)",
    "FOODON_03302991": "pasteurized process swiss cheese",
    "FOODON_03411912": "dogfish shark family",
    "FOODON_03414476": "polyplacophoran",
    "CHEBI_15356": "cysteine",
    "FOODON_03411969": "long whiskered catfish family",
    "FOODON_03306776": "apple pie filling (artificially sweetened)",
    "FOODON_03308771": "clam (soft shell, raw)",
    "FOODON_03308112": "sild (raw)",
    "IAO_0000577": "centrally registered identifier symbol",
    "FOODON_03309213": "pacific whiting (raw)",
    "NCBITaxon_126735": "Esox masquinongy",
    "FOODON_03306271": "coconut piece (raw)",
    "FOODON_03307487": "skim milk (calcium-reduced)",
    "NCBITaxon_314147": "Glires",
    "FOODON_03311752": "cutthroat trout (raw)",
    "FOODON_03542956": "29560 - japanese quail eggs (efsa foodex2)",
    "FOODON_03315961": "fat-based dessert (energy reduced)",
    "FOODON_03309056": "cabezon (raw)",
    "UBERON_0005052": "gizzard",
    "FOODON_03310892": "apricot infant food",
    "FOODON_00002596": "Pinot noir wine",
    "CHEBI_18422": "sulfur dioxide",
    "FOODON_03309077": "cape hake fillet (raw)",
    "FOODON_03401775": "10000613 - prepared/preserved foods variety packs (gs1 gpc)",
    "FOODON_03302049": "loganberry (whole, raw)",
    "FOODON_03301290": "apricot puree",
    "FOODON_03309148": "ocean pout (raw)",
    "FOODON_03414943": "fusarium venenatum",
    "FOODON_03413973": "seerfish",
    "FOODON_03420125": "skeletal meat part, without bone or shell",
    "FOODON_03304626": "hen egg yolk (frozen)",
    "FOODON_03413618": "aesop shrimp",
    "FOODON_03400834": "processed fruit product (eurofir)",
    "NCBITaxon_30532": "Dama dama",
    "FOODON_03316387": "citrus peel (grated for commercial bakery use)",
    "FOODON_03543337": "33370 - beer, alcohol-free (efsa foodex2)",
    "FOODON_03317197": "fish sauce",
    "FOODON_03542809": "28090 - cheese, cream havarti (efsa foodex2)",
    "FOODON_03311061": "cream sherry wine",
    "FOODON_03412793": "bitterwood plant",
    "FOODON_03543007": "30070 - barley malt syrup (efsa foodex2)",
    "CHEBI_6824": "hexamethylenetetramine",
    "ENVO_00002030": "aquatic biome",
    "FOODON_03400374": "antitrope agent (codex)",
    "FOODON_03460229": "flavoring, spice or herb, natural",
    "FOODON_03303377": "cauliflower soup mix",
    "FOODON_00002321": "turbot food product",
    "FOODON_03400305": "seed or seed product (us cfr)",
    "FOODON_03311088": "poultry (raw, ground)",
    "FOODON_03311439": "brazilnut oil (food product)",
    "FOODON_03309339": "southern blue whiting (raw)",
    "FOODON_03307310": "wine cooler (margarita-flavored)",
    "FOODON_03541657": "16570 - nagami kumquats (efsa foodex2)",
    "FOODON_03308200": "capelin (raw)",
    "FOODON_03412075": "fenugreek milkcap",
    "FOODON_03412031": "vegetable marrow plant",
    "FOODON_03401198": "50171700 - vinegars/cooking wines (gs1 gpc)",
    "FOODON_03411342": "shark",
    "FOODON_03411798": "snapper family",
    "FOODON_03412810": "mammea africana tree",
    "FOODON_03530152": "agricultural food production",
    "FOODON_03412153": "shortfin corvina",
    "FOODON_03307120": "wild strawberry preserve",
    "NCBITaxon_654836": "Momordica dioica",
    "FOODON_03312068": "tea (decaffeinated)",
    "FOODON_03303373": "caper (canned)",
    "FOODON_03542431": "24310 - king mackerel (efsa foodex2)",
    "FOODON_03301435": "vegetable protein bouillon cube",
    "FOODON_03412235": "searobin family",
    "FOODON_03310585": "black raspberry-flavored gelatin dessert mix",
    "FOODON_03540942": "09420 - sauerkraut (efsa foodex2)",
    "FOODON_03414073": "goosefish",
    "FOODON_03301198": "food (artificially colored)",
    "FOODON_03541420": "14200 - canned or jarred chickpea (efsa foodex2)",
    "FOODON_03309663": "soybean and cheese whey blend (powdered)",
    "FOODON_03315613": "fish roe (salt treated)",
    "FOODON_03543251": "32510 - dehydrated/powdered fruit juice (efsa foodex2)",
    "FOODON_03303785": "chocolate-flavored candy",
    "FOODON_03540721": "07210 - jerusalem artichokes and similar- (efsa foodex2)",
    "NCBITaxon_97750": "Kaempferia galanga",
    "FOODON_03304201": "chicken egg drop soup",
    "FOODON_03412469": "temple orange plant",
    "FOODON_03316753": "fish of the gadidae family dried salted",
    "FOODON_03540677": "06770 - courgettes (efsa foodex2)",
    "FOODON_03303198": "cornbread mix",
    "FOODON_03303597": "bittersweet chocolate (nutritively and nonnutritively sweetened)",
    "NCBITaxon_13323": "Acanthocybium solandri",
    "FOODON_03540685": "06850 - summer squashes (efsa foodex2)",
    "FOODON_03542554": "25540 - cuttlefishes (efsa foodex2)",
    "NCBITaxon_147538": "Pezizomycotina",
    "FOODON_03541777": "17770 - pineapples (efsa foodex2)",
    "FOODON_03542850": "28500 - cheese, scamorza (efsa foodex2)",
    "FOODON_03304952": "minestrone soup",
    "FOODON_03400326": "acidity regulator (EC)",
    "NCBITaxon_1432686": "Decapoda sp. BOLD:AAE2717",
    "FOODON_03317324": "pork (cut fresh)",
    "NCBITaxon_5230": "Auricularia",
    "FOODON_03542245": "22450 - pangas catfishes (efsa foodex2)",
    "FOODON_03540743": "07430 - salsifies (efsa foodex2)",
    "FOODON_03305289": "soybean milk",
    "ENVO_00003041": "cow shed",
    "FOODON_00002542": "cotija cheese",
    "FOODON_03310350": "pine nut pudding",
    "FOODON_03490182": "aluminum container",
    "FOODON_03305560": "grapefruit peel",
    "FOODON_03311626": "beverage tea (liquid)",
    "FOODON_03401014": "50102200 - fruits/vegetables/nuts/seeds variety packs (gs1 gpc)",
    "NCBITaxon_30451": "Procellariidae",
    "NCBITaxon_500316": "Artemesia longinaris",
    "FOODON_03413118": "hydroxy propyl distarch phosphate",
    "FOODON_03490338": "imitation grease proof paper container",
    "NCBITaxon_224706": "Brevoortia",
    "FOODON_03411894": "fish, semionotiformes",
    "FOODON_03542115": "21150 - cured seasoned bovine meat (efsa foodex2)",
    "CHEBI_38295": "azabicycloalkane",
    "FOODON_03540998": "09980 - yacon roots (efsa foodex2)",
    "FOODON_03303528": "cottage cheese (artificially flavored)",
    "FOODON_03302502": "butter (whipped)",
    "GAZ_00005810": "Ile Bassas da India",
    "FOODON_03306618": "doughnut (artificially flavored)",
    "FOODON_03315372": "yookpo",
    "FOODON_03413722": "banana pepper plant",
    "FOODON_03315128": "shrimp (cooked, canned)",
    "FOODON_03544429": "44290 - other regulated additives (efsa foodex2)",
    "FOODON_03412612": "giant tiger prawn",
    "FOODON_03310367": "cellulose powder",
    "FOODON_03401895": "efsa food classification and description system for exposure assessment (efsa foodex2)",
    "FOODON_03414951": "chokeberry plant",
    "FOODON_03311416": "potato patty",
    "FOODON_03310154": "carp raw",
    "FOODON_03308717": "swordfish (frozen)",
    "FOODON_03301191": "jerusalem artichoke flour",
    "FOODON_03304912": "cream of carrot soup",
    "FOODON_03301564": "champagne",
    "FOODON_03311139": "chicken drumstick (cooked)",
    "FOODON_03542672": "26720 - other milks (efsa foodex2)",
    "NCBITaxon_3918": "Vigna aconitifolia",
    "FOODON_03490410": "animal hair container",
    "FOODON_03311281": "seaweed (dessicated)",
    "CHEBI_24780": "imidazoles",
    "FOODON_03317048": "cereal-based-product (with no added sugar)",
    "FOODON_03309023": "tuna (packed in water, seasoned with oil, canned)",
    "NCBITaxon_13484": "Dianella <monocots>",
    "FOODON_03301208": "artichoke heart (quartered)",
    "FOODON_00002944": "kelp meal",
    "FOODON_03306792": "pizza (sausage with cheese, mix)",
    "FOODON_03460178": "food aeration process",
    "FOODON_03305183": "orange-flavored drink mix (vitamin c fortified)",
    "CHEBI_24833": "oxoacid",
    "PO_0009011": "plant structure",
    "FOODON_03308839": "alaska snow crab (raw)",
    "FOODON_03541433": "14330 - other hybrids of citrus paradisi, not elsewhere mentioned (efsa foodex2)",
    "FOODON_00003226": "rice bran oil",
    "NCBITaxon_375274": "Psidium cattleyanum",
    "NCBITaxon_23129": "Pittosporum",
    "FOODON_03316990": "obsolete: whale meat product",
    "CHEBI_26195": "polyphenol",
    "FOODON_00002920": "grana padano",
    "FOODON_03414095": "tarry skate",
    "FOODON_03303121": "fruit (sugared)",
    "FOODON_03411493": "sassafras plant",
    "FOODON_03542366": "23660 - sea bass (efsa foodex2)",
    "FOODON_03303666": "derby cheese",
    "FOODON_03307393": "oyster (pearl, canned)",
    "FOODON_03540224": "02240 - laminated doughs (efsa foodex2)",
    "FOODON_03307963": "fish stick (breaded, cooked, frozen)",
    "NCBITaxon_29760": "Vitis vinifera",
    "FOODON_00001147": "plant root food product",
    "NCBITaxon_41945": "Ericales",
    "NCBITaxon_8030": "Salmo salar",
    "FOODON_00002822": "lung food product",
    "FOODON_03413801": "american crocodile",
    "NCBITaxon_7858": "Rajiformes",
    "FOODON_03400275": "macaroni or noodle product (us cfr)",
    "FOODON_03411061": "phaseolus vulgaris, edible seed cultivar (plant)",
    "FOODON_03316903": "pastry filling product",
    "FOODON_03490378": "polyvinyl chloride container",
    "FOODON_03315608": "cottage cheese type spread",
    "FOODON_03541540": "15400 - wild strawberries (efsa foodex2)",
    "FOODON_03542025": "20250 - chicken liver (efsa foodex2)",
    "FOODON_03311337": "almond kernel (whole, raw)",
    "FOODON_03541667": "16670 - indian jujubes (efsa foodex2)",
    "FOODON_03306392": "orange marmalade with cointreau liqueur",
    "FOODON_03540831": "08310 - ramson (efsa foodex2)",
    "FOODON_03413394": "ilama plant",
    "FOODON_03301264": "olive (salad, pitted, halved)",
    "FOODON_03316662": "seasoning product (concentrate)",
    "FOODON_00001275": "hen egg food product",
    "FOODON_03303525": "cottage cheese (creamed, fruit added)",
    "FOODON_03500022": "polystyrene surface",
    "FOODON_00003008": "red currant (whole, raw)",
    "FOODON_00001979": "jerusalem artichoke vegetable food product",
    "FOODON_03543552": "35520 - eastern black walnut infusion leaves (efsa foodex2)",
    "FOODON_03542494": "24940 - siberian prawn (efsa foodex2)",
    "FOODON_03309609": "soybean oil (flavored with extract from lobster shell)",
    "FOODON_03411324": "grain plant",
    "FOODON_03414730": "orchid plant",
    "NCBITaxon_102804": "Asteroideae",
    "FOODON_03411487": "sweet pea plant",
    "FOODON_03305167": "frog leg (frozen)",
    "FOODON_03460285": "alcohol removal process",
    "FOODON_03540462": "04620 - witloofs and similar- (efsa foodex2)",
    "NCBITaxon_303946": "Squatina dumeril",
    "FOODON_03541625": "16250 - buffalo berries (efsa foodex2)",
    "PO_0025333": "ensiform vascular leaf",
    "FOODON_03317457": "obsolete: zurra",
    "FOODON_03316642": "whey (condensed)",
    "FOODON_03541013": "10130 - starchy root and tuber products (efsa foodex2)",
    "FOODON_03310108": "green garlic powder",
    "FOODON_03308415": "langostino bisque",
    "FOODON_03308951": "brazilian corvina (raw)",
    "FOODON_03540710": "07100 - beetroots (efsa foodex2)",
    "FOODON_03543255": "32550 - coconut water (efsa foodex2)",
    "FOODON_00001084": "obsolete: brown sugar",
    "NCBITaxon_75287": "Pylodictis",
    "NCBITaxon_173313": "Caranx caballus",
    "NCBITaxon_202602": "Tautoga onitis",
    "FOODON_00001946": "hard grating cheese food product",
    "FOODON_03302843": "pecan cake",
    "FOODON_03308918": "blue runner fillet (raw)",
    "FOODON_03311551": "malt beverage less than 3% alcohol by volume",
    "FOODON_03316893": "marmalade fruit",
    "FOODON_03308801": "remoulade mix (instant)",
    "FOODON_00002448": "zucchini food product",
    "FOODON_03415157": "dyer's broom plant",
    "FOODON_03316665": "green pea (canned)",
    "GAZ_00002572": "Province of Prince Edward Island",
    "FOODON_03543028": "30280 - table-top sweeteners formulations (efsa foodex2)",
    "FOODON_03540868": "08680 - cretan oregano (efsa foodex2)",
    "FOODON_00002896": "king weakfish",
    "FOODON_03520151": "pacific,  antarctic (fao major fishing area 88)",
    "FOODON_03302606": "vegetable oil (artificially butter-flavor)",
    "FOODON_03401327": "dietary supplement, electrolyte",
    "FOODON_03311608": "haddock (cooked)",
    "FOODON_03307912": "bamboo shoot (raw)",
    "CHEBI_25806": "oxygen molecular entity",
    "FOODON_00002175": "prepared hen egg product",
    "HANCESTRO_0428": "Virgin Islander",
    "FOODON_03490275": "glass container, uncoloured, normal weight",
    "FOODON_00002539": "muscovado",
    "FOODON_03303696": "salame cheese",
    "FOODON_03307902": "brown rice (whole, enriched)",
    "NCBITaxon_85422": "Knipowitschia panizzae",
    "FOODON_03541494": "14940 - nectacots (efsa foodex2)",
    "FOODON_03302223": "beverage (carbonated, caffeinated)",
    "FOODON_03315391": "ice cream (carbohydrate modified)",
    "FOODON_00001997": "lentil vegetable food product",
    "FOODON_03303391": "fruit conserve",
    "FOODON_03400791": "fresh or processed egg (eurofir)",
    "FOODON_03414184": "cauliflower fungus",
    "FOODON_03305337": "gravy mix (italian-style, dry)",
    "FOODON_03316335": "fruit for further processing in the confectionery and beverages industries",
    "FOODON_03400827": "vegetable product (eurofir)",
    "FOODON_03401585": "10006042 - holy basil (gs1 gpc)",
    "FOODON_03311317": "beef hash",
    "FOODON_03541708": "17080 - salaks (efsa foodex2)",
    "FOODON_03310982": "fruit juice (fortified)",
    "PO_0009012": "plant structure development stage",
    "FOODON_03540485": "04850 - komatsuna (efsa foodex2)",
    "FOODON_03302903": "corn flakes (with instant peaches)",
    "FOODON_03310368": "soy protein",
    "FOODON_03411552": "chicory plant",
    "FOODON_03450017": "boiling in small amount of liquid",
    "FOODON_03315349": "starch syrup",
    "FOODON_03307594": "apple preserve",
    "FOODON_03303218": "cranberry sauce (jellied)",
    "FOODON_00001008": "liver paste",
    "FOODON_03401463": "10006116 - may turnips (gs1 gpc)",
    "FOODON_03308225": "crab lobster (raw)",
    "FOODON_03470162": "disinfection by irradiation",
    "FOODON_03310611": "poultry food product (whole or parts)",
    "ENVO_00002297": "obsolete environmental feature",
    "FOODON_03307515": "imitation grenadine beverage syrup",
    "FOODON_03542477": "24770 - salmon roe, pacific (efsa foodex2)",
    "FOODON_03303859": "kuminost cheese",
    "FOODON_00001208": "hyacinth bean food product",
    "FOODON_03414510": "wracks",
    "FOODON_00002055": "navy bean food product",
    "FOODON_00002334": "vegetable salad food product",
    "FOODON_03541190": "11900 - radish seeds (efsa foodex2)",
    "FOODON_03411423": "cod",
    "CHEBI_26392": "purine nucleoside monophosphate",
    "NCBITaxon_943305": "Pachira insignis",
    "CHEBI_27325": "xanthophyll",
    "FOODON_03414712": "bulbine-lily plant",
    "NCBITaxon_4684": "Allium ursinum",
    "NCBITaxon_80338": "Spondias mombin",
    "N70568a8d367b4d87b754cf913f1ca01b": "acidity regulator",
    "FOODON_03315696": "pie filling mix",
    "FOODON_03401853": "10006761 - celtuce (gs1 gpc)",
    "CHEBI_26820": "sulfates",
    "NCBITaxon_400996": "Solanum ellipticum",
    "FOODON_00001076": "sake food product",
    "FOODON_03543309": "33090 - soft drink, lemon flavour (efsa foodex2)",
    "FOODON_03544181": "41810 - mint-chocolate flavour (efsa foodex2)",
    "FOODON_03302416": "strawberry wine (food product)",
    "FOODON_03411322": "rice plant",
    "FOODON_03411672": "prickly pear plant",
    "FOODON_03400950": "10000250 - pies/pastries/pizzas/quiches - savoury (shelf stable) (gs1 gpc)",
    "FOODON_03309926": "california valencia orange (whole, raw)",
    "FOODON_03490382": "thermosetting polymer container",
    "FOODON_03412204": "scalloped spiny lobster",
    "FOODON_03317203": "nonnutritive sweetener concentrate, liquid form",
    "FOODON_03413523": "carcharodon",
    "NCBITaxon_1459830": "Hoplunnis macrura",
    "FOODON_03309291": "arctic white salmon (raw)",
    "FOODON_03308085": "herring (packed in brine, canned)",
    "FOODON_03541112": "11120 - horse gram (dry seeds) (efsa foodex2)",
    "FOODON_03542500": "25000 - edible crab (efsa foodex2)",
    "NCBITaxon_41665": "Neopterygii",
    "FOODON_03470109": "chemical food preservation process",
    "FOODON_03316679": "grape juice (sweetened, concentrated, labrusca type)",
    "NCBITaxon_1329799": "Archelosauria",
    "FOODON_03308383": "fish stick (french-fried)",
    "NCBITaxon_886714": "Artemisiinae",
    "FOODON_03400780": "liquid milk (eurofir)",
    "FOODON_03543953": "39530 - egg-based canap\u00e9 (efsa foodex2)",
    "FOODON_03302667": "tomato paste (canned)",
    "FOODON_03316247": "ice, edible, water-based",
    "FOODON_03543079": "30790 - nut mass (efsa foodex2)",
    "FOODON_03400283": "quick bread, unsweetened (us cfr)",
    "FOODON_03311256": "coho salmon (frozen)",
    "FOODON_03309485": "ginseng root (raw)",
    "FOODON_03414179": "rooting shank",
    "FOODON_00003152": "brain food product",
    "FOODON_03311791": "tomato (whole, raw, genetically modified)",
    "FOODON_00001099": "apple beverage",
    "FOODON_03302510": "butter-flavored cookie",
    "FOODON_03309668": "tuna (solid pack, canned in oil)",
    "FOODON_03413487": "tree onion plant",
    "FOODON_03305873": "gelatin dessert mix (dry)",
    "FOODON_03311775": "cola carbonated beverage (low-calorie)",
    "FOODON_03306646": "white sugar (superfine)",
    "FOODON_03310006": "fermented bean product",
    "FOODON_03317047": "cereal based-desserts with no added sugar",
    "FOODON_03541630": "16300 - midland hawberries (efsa foodex2)",
    "FOODON_03308205": "blueback herring (raw)",
    "FOODON_00002151": "plant seed based bakery food product",
    "FOODON_03544036": "40360 - potato crisps or sticks (efsa foodex2)",
    "FOODON_03303426": "buttermilk-flavored cookie",
    "FOODON_03540325": "03250 - rice porridge (efsa foodex2)",
    "FOODON_03411124": "herring family",
    "NCBITaxon_41522": "Centaurea cyanus",
    "FOODON_03307323": "biscuit meal",
    "FOODON_03420142": "germ and bran",
    "FOODON_03401179": "10000238 - olives (perishable) (gs1 gpc)",
    "FOODON_03309210": "herring fillet (pickled, skinless)",
    "FOODON_03306114": "beverage syrup (lingonberry-flavored)",
    "FOODON_00001140": "fruit juice food product",
    "FOODON_03311770": "hen egg (semiliquid, pasteurized)",
    "FOODON_03412224": "triangle tanner crab",
    "FOODON_03317592": "vegetable stew with meat",
    "FOODON_03540552": "05520 - banana flowers - balbisiana cultivars (efsa foodex2)",
    "FOODON_03310898": "kidney (whole, raw)",
    "FOODON_03542946": "29460 - baked milk and similar (efsa foodex2)",
    "FOODON_03311267": "blue rockfish (raw)",
    "FOODON_03301247": "date (pitted)",
    "FOODON_03400779": "milk (eurofir)",
    "NCBITaxon_7810": "Carcharhinus porosus",
    "FOODON_03308689": "california corbina (raw)",
    "FOODON_03543730": "37300 - herbal and other non-tea infusions (efsa foodex2)",
    "CHEBI_24384": "glycogens",
    "NCBITaxon_66688": "Krameria",
    "FOODON_03412244": "obsolete: cattle and sheep",
    "NCBITaxon_3603": "Vitis",
    "FOODON_03311895": "spinach (creamed, canned, baby food)",
    "FOODON_03420169": "pod containing small, immature seed",
    "FOODON_03411812": "grunt family",
    "FOODON_03305410": "imitation whipped cream",
    "FOODON_03400806": "vegetable fat or oil (eurofir)",
    "FOODON_03401018": "obsolete: 10000012 - meat/poultry/game/batrachian - prepared/processed (perishable) (gs1 gpc)",
    "FOODON_03317069": "fruit jelly (powdered dessert concentration)",
    "FOODON_03542574": "25740 - amphibians, reptiles, snails, insects (efsa foodex2)",
    "FOODON_03303575": "cottage cheese (partially creamed)",
    "FOODON_03401149": "10000256 - shellfish prepared/processed (frozen) (gs1 gpc)",
    "FOODON_03543144": "31440 - camel milk fat (efsa foodex2)",
    "FOODON_03308247": "chilean lobster (raw)",
    "FOODON_00003354": "flour (unenriched, unbleached)",
    "FOODON_03541408": "14080 - processed legumes, nuts, oilseeds and spices (efsa foodex2)",
    "FOODON_03310803": "meatloaf (cooked)",
    "NCBITaxon_42495": "Serrasalmidae",
    "FOODON_03412325": "blue marlin",
    "FOODON_03540109": "01090 - oat bran (efsa foodex2)",
    "FOODON_03401105": "50192500 - sandwiches/filled rolls/wraps (gs1 gpc)",
    "NCBITaxon_8074": "Lophius piscatorius",
    "FOODON_03544157": "41570 - soya proteins (efsa foodex2)",
    "FOODON_03307954": "clam (butter, raw)",
    "FOODON_03510125": "tooth decay-related claim or use",
    "FOODON_03308080": "shrimp pieces (raw)",
    "NCBITaxon_72078": "Sebastes goodei",
    "NCBITaxon_1489793": "Siluroidei",
    "FOODON_03540131": "01310 - sandwich bread (hamburger roll-type) (efsa foodex2)",
    "FOODON_03490226": "one component adhesive",
    "FOODON_03311204": "candy with cereal filler",
    "FOODON_03414361": "mouflon",
    "FOODON_03414982": "ethiopian eggplant plant",
    "FOODON_03304194": "spaghetti and tomato sauce (dry mix)",
    "FOODON_03316917": "pressed mint candy",
    "FOODON_03307712": "green bean (canned)",
    "FOODON_03305990": "kava coffee (instant)",
    "FOODON_03542035": "20350 - veal kidney (efsa foodex2)",
    "FOODON_03301862": "celery seed",
    "FOODON_03310895": "salami (smoked)",
    "NCBITaxon_41447": "Seriola dumerili",
    "FOODON_03541954": "19540 - wild boar fresh meat (efsa foodex2)",
    "FOODON_03412146": "leatherjacket genus",
    "FOODON_03544354": "43540 - prune flavour (efsa foodex2)",
    "FOODON_03543835": "38350 - rice drink (efsa foodex2)",
    "FOODON_03311554": "rapeseed protein isolate",
    "FOODON_03414866": "yellow catfish",
    "FOODON_03309650": "tea (caffeine-reduced, dry)",
    "FOODON_03520010": "obsolete: geographic places and regions",
    "FOODON_03311018": "chocolate bar (artificially sweetened)",
    "FOODON_03540994": "09940 - sugar beet roots (efsa foodex2)",
    "FOODON_03414805": "angas' mussel",
    "FOODON_03306207": "margarine (nondairy)",
    "FOODON_03415085": "garden angelica plant",
    "CHEBI_25676": "oligopeptide",
    "OBI_0000011": "planned process",
    "FOODON_03411107": "pear tomato plant",
    "NCBITaxon_260140": "Psidium guineense",
    "FOODON_03303354": "chow mein noodle",
    "FOODON_03415001": "signet marigold plant",
    "FOODON_03460150": "food color addition process",
    "FOODON_03301929": "pastry (sweetened)",
    "FOODON_03310733": "raspberry wine",
    "FOODON_03542585": "25850 - frog, marsh (efsa foodex2)",
    "FOODON_03311864": "chicken (breaded)",
    "FOODON_03543188": "31880 - juice, nectarine (efsa foodex2)",
    "FOODON_03303688": "provolone cheese (smoked)",
    "FOODON_03316651": "meat product (pickled)",
    "FOODON_03542258": "22580 - asian swamp eel (efsa foodex2)",
    "FOODON_03301658": "cockle (raw)",
    "FOODON_03316799": "pear (artificially sweetened, canned)",
    "FOODON_03317338": "beef steak (fabricated)",
    "FOODON_03311396": "caramel candy with white centers",
    "FOODON_03411086": "sicyoniid shrimp family",
    "UO_0000003": "time unit",
    "FOODON_03303181": "white roll",
    "FOODON_03413398": "white guinea yam plant",
    "FOODON_03430170": "solution for injection",
    "FOODON_03413723": "cloud ear fungus",
    "FOODON_03301088": "crustacean (raw)",
    "FOODON_03315887": "batter mix",
    "FOODON_03315471": "prawn (shelled)",
    "FOODON_03316846": "yellow corn meal (self-rising)",
    "FOODON_03411952": "new zealand rock oyster",
    "FOODON_03400828": "vegetable dish (eurofir)",
    "FOODON_03543275": "32750 - flavoured bottled water (efsa foodex2)",
    "FOODON_03542202": "22020 - horse meat, dried (efsa foodex2)",
    "FOODON_03413510": "hound shark family",
    "FOODON_03305762": "wheat cereal with apple",
    "FOODON_03543200": "32000 - nectar, orange (efsa foodex2)",
    "FOODON_03316770": "milk chocolate (skim)",
    "FOODON_03411478": "scallion plant",
    "NCBITaxon_217026": "Auxis rochei",
    "FOODON_03317243": "fish (gutted, fully preserved)",
    "FOODON_03400981": "10000602 - confectionery products variety packs (gs1 gpc)",
    "FOODON_03530233": "hazard 5",
    "FOODON_03303906": "cow buttermilk (acidified)",
    "FOODON_03315666": "fish (prepared)",
    "FOODON_03317302": "meat-based soup",
    "FOODON_03541940": "19400 - rabbit, minced meat (efsa foodex2)",
    "FOODON_03302956": "cherry (mint-flavored)",
    "FOODON_03543398": "33980 - other liqueurs (efsa foodex2)",
    "FOODON_03541365": "13650 - horseradish roots spice (efsa foodex2)",
    "FOODON_03542100": "21000 - poultry other slaughtering products (efsa foodex2)",
    "FOODON_03306819": "field pea (canned)",
    "FOODON_03315580": "nutritional preparation, unstandardized",
    "NCBITaxon_89952": "Merluccius productus",
    "FOODON_03315907": "vegetable drink base",
    "FOODON_03510250": "human as food consumer, four years and above",
    "FOODON_03400868": "savoury snack (eurofir)",
    "FOODON_00002414": "food solvent extraction process",
    "FOODON_03411913": "dogfish",
    "NCBITaxon_7840": "Triakis",
    "FOODON_03460108": "obsolete: nonnutritive sweetener added",
    "FOODON_03401666": "10006281 - hare - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03540628": "06280 - lentils and similar- (efsa foodex2)",
    "FOODON_03301910": "chamomile tea (steeped)",
    "NCBITaxon_9335": "Phalangeridae",
    "FOODON_03301824": "pili nut (whole, raw)",
    "FOODON_03420134": "seed, skin removed",
    "FOODON_03302108": "beer (freeze-concentrated)",
    "FOODON_03411137": "pacific whiting",
    "FOODON_03400128": "cheese product analog (us cfr)",
    "NCBITaxon_700652": "Mugil trichodon",
    "FOODON_03315345": "obsolete: ice cream product",
    "FOODON_00003120": "durian tree",
    "FOODON_03400126": "cold-pack cheese food (us cfr)",
    "FOODON_03541857": "18570 - fermented fruit products (efsa foodex2)",
    "FOODON_03306189": "iced tea mix (instant, lemon-flavored, sugar added)",
    "FOODON_03415111": "blumea plant",
    "FOODON_03307783": "hero sandwich (frozen)",
    "FOODON_03480011": "packed in edible medium",
    "FOODON_03542511": "25110 - shrimps and prawns (efsa foodex2)",
    "FOODON_03315533": "fishery product (semi-preserved)",
    "PATO_0045067": "normal temperature",
    "FOODON_03307926": "apple wine vinegar",
    "NCBITaxon_13814": "Marsileaceae",
    "HANCESTRO_0349": "Belgian",
    "NCBITaxon_69811": "Leuciscus idus",
    "FOODON_03414038": "four-spot flounder",
    "FOODON_03304054": "tomato-based hot sauce",
    "FOODON_03541166": "11660 - walnuts (efsa foodex2)",
    "FOODON_03411125": "guinea fowl",
    "CHEBI_22315": "alkaloid",
    "FOODON_03544516": "45160 - royal jelly (efsa foodex2)",
    "FOODON_03414203": "blessed milkthistle plant",
    "FOODON_03305104": "fig (whole, dried)",
    "NCBITaxon_6457": "Haliotis kamtschatkana",
    "FOODON_03414919": "royal fern plant",
    "NCBITaxon_169697": "Arecoideae",
    "NCBITaxon_75288": "Pylodictis olivaris",
    "NCBITaxon_7965": "Hypophthalmichthys nobilis",
    "FOODON_03541278": "12780 - tansy and related species, dry (efsa foodex2)",
    "FOODON_03311275": "bluefish fillet (raw)",
    "FOODON_03306841": "papaya juice (canned)",
    "FOODON_03304361": "mango nectar",
    "GAZ_00002957": "Serbia",
    "NCBITaxon_1239141": "Vitis rotundifolia var. munsoniana",
    "ENVO_02000055": "plant feed",
    "FOODON_00001759": "common oat cereal food product",
    "FOODON_03490336": "kraft or brown paper container",
    "FOODON_03411766": "vermilion rockfish",
    "FOODON_03305849": "cocoa ice cream",
    "FOODON_03412243": "obsolete: cattle and swine and sheep",
    "FOODON_03304555": "rice (parboiled)",
    "FOODON_03301179": "chicken liver (raw)",
    "FOODON_03544071": "40710 - gravy instant granules (efsa foodex2)",
    "FOODON_03412277": "wrasse family",
    "FOODON_03401600": "10006064 - spearmint (gs1 gpc)",
    "FOODON_03541511": "15110 - plums (efsa foodex2)",
    "FOODON_03411452": "soybean plant",
    "FOODON_03307923": "imitation vinegar (powdered)",
    "FOODON_03316847": "brick cheese for manufacturing",
    "FOODON_03308354": "rock lobster tail (frozen)",
    "FOODON_03543333": "33330 - lager beer (efsa foodex2)",
    "FOODON_03540842": "08420 - herb of grace (efsa foodex2)",
    "FOODON_03542427": "24270 - bullet tuna (efsa foodex2)",
    "NCBITaxon_6784": "Dromiidae",
    "FOODON_03500048": "leaf food contact surface",
    "FOODON_03401002": "10000236 - nuts/seeds - prepared/processed (shelf stable) (gs1 gpc)",
    "FOODON_03544185": "41850 - anise flavour (efsa foodex2)",
    "FOODON_03310434": "papain",
    "FOODON_03309771": "coco bread",
    "FOODON_03400755": "052  miscellaneous fodder and forage crops (am) (ccpr)",
    "FOODON_03316384": "lemon peel (candied)",
    "FOODON_03301845": "onion powder",
    "FOODON_03308714": "tuna in agar jelly (diced, canned)",
    "FOODON_00003383": "American-made product",
    "FOODON_03309272": "arrowtooth flounder (raw)",
    "FOODON_03542770": "27700 - cheese, brie (efsa foodex2)",
    "FOODON_03315672": "fruit jam with pectin",
    "FOODON_03315967": "confectionery (with no added sugar)",
    "FOODON_03401391": "50262100 - tidal sea vegetables (gs1 gpc)",
    "FOODON_03543077": "30770 - truffle mass (efsa foodex2)",
    "FOODON_03543193": "31930 - juice, prune (efsa foodex2)",
    "FOODON_03541854": "18540 - candied fruit, pear (efsa foodex2)",
    "NCBITaxon_89953": "Merluccius senegalensis",
    "FOODON_03413654": "korean mussel",
    "FOODON_00002953": "chow mein",
    "FOODON_03542828": "28280 - cheese, leicester (efsa foodex2)",
    "FOODON_03400986": "50161900 - confectionery/sugar sweetening products variety packs (gs1 gpc)",
    "FOODON_03541510": "15100 - plums and similar- (efsa foodex2)",
    "FOODON_03401483": "10000601 - cereal/grain/pulse products variety packs (gs1 gpc)",
    "FOODON_03412338": "reed fescue plant",
    "FOODON_03305806": "green bean pod",
    "FOODON_03315233": "walnut (whole, raw)",
    "FOODON_03542257": "22570 - arapaima (efsa foodex2)",
    "FOODON_03542437": "24370 - bluefish (efsa foodex2)",
    "FOODON_03311308": "sablefish smoked using hot-smoking nitrite- and nitrate-treated",
    "CHEBI_70411": "dehydro-gamma-tocopherol",
    "FOODON_03542098": "20980 - deer, other slaughtering products (efsa foodex2)",
    "FOODON_03412440": "alligator",
    "FOODON_03305042": "hen egg yolk (dried)",
    "FOODON_03308622": "flying fish (raw)",
    "FOODON_03303376": "chow chow",
    "FOODON_03414903": "shads",
    "FOODON_03414669": "fetid passionflower",
    "NCBITaxon_13691": "Sphyraena",
    "NCBITaxon_4217": "Arctium lappa",
    "FOODON_03301369": "globe artichoke (raw)",
    "FOODON_03412318": "neet (fish)",
    "FOODON_03302284": "black raspberry beverage base (artificially sweetened, vitamin-fortified)",
    "FOODON_03311221": "fish stick made from cod coated raw",
    "FOODON_03544325": "43250 - muesli flavour (efsa foodex2)",
    "FOODON_00002644": "food (filled)",
    "CHEBI_52217": "pharmaceutical",
    "FOODON_03412698": "chamois",
    "NCBITaxon_768495": "Genypterus maculatus",
    "FOODON_03302653": "cooking oil",
    "FOODON_03500041": "food-grade metal surface",
    "FOODON_03317089": "nutritional preparation",
    "FOODON_03540691": "06910 - gac (efsa foodex2)",
    "NCBITaxon_1338369": "Dipnotetrapodomorpha",
    "FOODON_03413921": "doublebar goatfish",
    "FOODON_03543984": "39840 - soups and salads (efsa foodex2)",
    "FOODON_03401627": "10005772 - frog - prepared/processed (gs1 gpc)",
    "FOODON_03540239": "02390 - butter biscuits (efsa foodex2)",
    "FOODON_03544371": "43710 - shrimp flavour (efsa foodex2)",
    "FOODON_03414980": "sticky nightshade",
    "FOODON_03316752": "gudbrandsdalsost cheese",
    "FOODON_03460748": "mammalian milk protein",
    "FOODON_03307306": "mead wine",
    "FOODON_03308769": "mollusc (raw)",
    "NCBITaxon_53873": "Dipteryx odorata",
    "FOODON_03400782": "cream (eurofir)",
    "FOODON_03303544": "grated cheese (italian-style)",
    "FOODON_03308974": "taiwan red snapper (raw)",
    "FOODON_03541791": "17910 - dried fruit (efsa foodex2)",
    "FOODON_03540123": "01230 - wheat bread and rolls, white with soya (efsa foodex2)",
    "FOODON_03311865": "chicken (whole, raw)",
    "FOODON_03414401": "acetylated oxidised starch",
    "NCBITaxon_3860": "Lathyrus sativus",
    "FOODON_03305050": "whiskey (blended)",
    "FOODON_03308384": "fish cocktail spread",
    "FOODON_03317129": "shellfish-like product (fully preserved)",
    "FOODON_03543737": "37370 - lime blossoms infusion (efsa foodex2)",
    "FOODON_03412684": "toheroa wedge clam",
    "FOODON_03540324": "03240 - oat porridge (efsa foodex2)",
    "FOODON_03305665": "imitation ice cream mix",
    "FOODON_03420170": "broth or stock",
    "FOODON_03305110": "candy (effervescent, artificially-colored)",
    "FOODON_03541031": "10310 - navy bean (fresh seeds) (efsa foodex2)",
    "FOODON_03411464": "star anise plant",
    "FOODON_03412702": "kid",
    "FOODON_03304738": "celery salt",
    "FOODON_03420238": "root, tuber or bulb",
    "FOODON_00002547": "shell bean",
    "FOODON_03414037": "turbot family",
    "NCBITaxon_108096": "Coregonus pollan",
    "FOODON_03309425": "atlantic saury (raw)",
    "NCBITaxon_94936": "Strongylura",
    "FOODON_03415000": "muster john henry plant",
    "FOODON_03303424": "cookie (grainless)",
    "FOODON_03307756": "plain pizza (cooked)",
    "NCBITaxon_3562": "Spinacia oleracea",
    "FOODON_03306949": "shrimp noodle",
    "NCBITaxon_241355": "Odacidae",
    "FOODON_03413599": "siboga lobster",
    "FOODON_03541212": "12120 - niger seeds (efsa foodex2)",
    "FOODON_03310701": "bluefin tuna (canned)",
    "FOODON_03543637": "36370 - echinacea infusion roots (efsa foodex2)",
    "FOODON_03400361": "agency food product type",
    "FOODON_03307181": "honey and maple syrup",
    "FOODON_03530057": "light fish flesh",
    "FOODON_03542736": "27360 - quark (efsa foodex2)",
    "FOODON_03411832": "blue tilapia",
    "FOODON_03413037": "calcium ferrocyanide",
    "FOODON_03543410": "34100 - coffee ingredients (rpc derivatives) (efsa foodex2)",
    "FOODON_03306377": "marmalade",
    "FOODON_00002432": "mint food product",
    "FOODON_03540655": "06550 - tabasco capsicum (efsa foodex2)",
    "NCBITaxon_46260": "Morone americana",
    "NCBITaxon_320396": "Menticirrhus undulatus",
    "FOODON_00001582": "alfalfa food product",
    "NCBITaxon_22666": "Trapa natans",
    "FOODON_03414133": "lamprey family",
    "FOODON_03306985": "popcorn (french-fried)",
    "FOODON_03413204": "potassium benzoate",
    "FOODON_03310126": "plantain (whole, raw)",
    "NCBITaxon_10090": "Mus musculus",
    "FOODON_03401790": "10006115 - black radishes (gs1 gpc)",
    "FOODON_03308079": "hawaiian shrimp with pineapple (dish)",
    "FOODON_03317677": "flour confectionery (sugar coated)",
    "FOODON_03306607": "naranjilla juice",
    "FOODON_03302594": "vegetable (seasoned with butter, canned)",
    "FOODON_03317101": "crustacean product (semi-preserved)",
    "FOODON_03414377": "mountain nyala",
    "FOODON_00001757": "common bean food product",
    "FOODON_03311687": "chili-garlic in oil",
    "FOODON_03309968": "veal stew",
    "FOODON_03413096": "ethyl methyl cellulose",
    "FOODON_03541409": "14090 - primary derivatives from nuts and similar seeds (efsa foodex2)",
    "FOODON_03520001": "obsolete: geographic place or region not known",
    "FOODON_03317278": "sausage brown and serve",
    "FOODON_03304152": "sesame oil",
    "FOODON_03460300": "acetic acid fermentation",
    "NCBITaxon_244852": "Pseudocyttus maculatus",
    "FOODON_03412565": "striped pargo",
    "FOODON_03544072": "40720 - stock cubes or granulate (bouillon base) (efsa foodex2)",
    "FOODON_00003273": "sp\u00e4tzle",
    "FOODON_03412943": "coffee chicory plant",
    "FOODON_00003048": "potato puff (dish)",
    "FOODON_03307669": "orange beverage concentrate",
    "FOODON_03530106": "external fat trimmed to 0 inch",
    "NCBITaxon_232192": "Lutjanus sebae",
    "FOODON_03301615": "sardine (canned)",
    "FOODON_03414131": "giant oceanic manta ray",
    "FOODON_03401129": "50122300 - aquatic invertebrates - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03302814": "chocolate-flavored drink",
    "FOODON_03315951": "drink milk-based (energy reduced)",
    "FOODON_03530113": "commissary food preparation process",
    "FOODON_00002372": "youngberry food product",
    "NCBITaxon_219865": "Syzygium aqueum",
    "NCBITaxon_59239": "Arctica islandica",
    "FOODON_03309180": "south american catfish (raw)",
    "FOODON_03303444": "maine lobster (raw)",
    "FOODON_00001175": "plant stem food product",
    "FOODON_03304942": "soup seasoning (chicken fat added)",
    "FOODON_03540255": "02550 - plain cakes (efsa foodex2)",
    "FOODON_00002495": "kiwi food product",
    "FOODON_03411195": "spiny dogfish",
    "FOODON_03303352": "beef chow mein",
    "FOODON_03544382": "43820 - strawberry yoghurt flavour (efsa foodex2)",
    "FOODON_03315371": "obsolete: awpo",
    "CHEBI_37622": "carboxamide",
    "FOODON_03305384": "chicken cacciatore (canned)",
    "FOODON_03411630": "wahoo",
    "GAZ_00002802": "South Korea",
    "FOODON_03411721": "sponge gourd plant",
    "FOODON_03400907": "10000308 - juice - not ready to drink (shelf stable) (gs1 gpc)",
    "FOODON_03310655": "dessert mix (instant, dry)",
    "FOODON_03316231": "meat product (heat treated)",
    "FOODON_03543925": "39250 - hamburger with bread (efsa foodex2)",
    "FOODON_03311359": "citrus fruit nectar",
    "FOODON_03540971": "09710 - dasheen taros (efsa foodex2)",
    "FOODON_03309631": "salmon (raw)",
    "NCBITaxon_9789": "Equus <genus>",
    "FOODON_03413614": "australian spiny lobster",
    "FOODON_00001808": "devils tongue food product",
    "FOODON_03308827": "shrimp (cooked, frozen)",
    "FOODON_00000075": "pea substance",
    "FOODON_00003263": "fondue savoyarde",
    "FOODON_00001219": "sausage (cooked, smoked)",
    "FOODON_00001734": "chocolate product analog",
    "FOODON_03315271": "shortening, plastic",
    "NCBITaxon_8400": "Lithobates catesbeianus",
    "FOODON_03317488": "instant powder for fruit based drink",
    "FOODON_03544056": "40560 - salt, fluoridated (efsa foodex2)",
    "RO_0002206": "expressed in",
    "FOODON_03302229": "orange carbonated beverage (naturally and artificially flavored)",
    "FOODON_03544190": "41900 - apricot - peach flavour (efsa foodex2)",
    "NCBITaxon_547151": "Sciaena",
    "FOODON_03542142": "21420 - ciccioli and similar (efsa foodex2)",
    "FOODON_00002641": "Bordeaux wine",
    "FOODON_00001957": "huckleberry food product",
    "FOODON_03305326": "guava (paste)",
    "FOODON_03412960": "little radish plant",
    "FOODON_03530235": "hazard 7",
    "FOODON_03302016": "cherry (processed)",
    "FOODON_03307024": "plantain chip (green, deep-fried)",
    "FOODON_03317618": "tapioca starch for syrup",
    "FOODON_03411873": "indian ocean flounder",
    "FOODON_03302274": "imitation grape juice beverage base (artificially sweetened, dry)",
    "FOODON_03541660": "16600 - carambolas and similar- (efsa foodex2)",
    "FOODON_03413877": "european pollock",
    "FOODON_00003158": "poultry sandwich",
    "NCBITaxon_59165": "Valerianella",
    "FOODON_03414500": "ground squirrel",
    "FOODON_03413349": "pulasan plant",
    "FOODON_03413621": "argentine stiletto shrimp",
    "FOODON_00002890": "heron",
    "NCBITaxon_48042": "Levisticum officinale",
    "FOODON_03544192": "41920 - avocado flavour (efsa foodex2)",
    "FOODON_03310061": "pork liver (frozen)",
    "FOODON_03303000": "swiss cheese (filled, containing butter)",
    "FOODON_03317049": "fat-based dessert (no added sugar)",
    "FOODON_03543029": "30290 - table-top sweeteners in liquid form (efsa foodex2)",
    "FOODON_03541782": "17820 - durians and similar- (efsa foodex2)",
    "NCBITaxon_29964": "Cancroidea",
    "FOODON_03401384": "50262500 - sapote (gs1 gpc)",
    "FOODON_03317296": "obsolete: frank",
    "FOODON_03413544": "flat abalone",
    "FOODON_03309756": "loquat food product",
    "FOODON_03510060": "high energy food claim or use",
    "NCBITaxon_6454": "Haliotis rufescens",
    "FOODON_03542943": "29430 - frozen yoghurt (efsa foodex2)",
    "CHEBI_15889": "sterol",
    "FOODON_03430114": "food (liquid, low viscosity, with small particles)",
    "FOODON_03305761": "imitation buttermilk",
    "FOODON_03311683": "sweet green pepper (freeze-dried)",
    "NCBITaxon_9592": "Gorilla",
    "PO_0009087": "mesocarp",
    "FOODON_03303110": "walnut shell",
    "FOODON_03317012": "fruit juice (raw, sweetened)",
    "FOODON_03310578": "ham (deviled)",
    "FOODON_03541080": "10800 - jack beans (dry) (efsa foodex2)",
    "FOODON_03544379": "43790 - spinach flavour (efsa foodex2)",
    "FOODON_03303428": "tapioca cookie",
    "FOODON_03310666": "custard-type product sweetened with aspartame frozen light",
    "FOODON_03412939": "pond apple plant",
    "FOODON_03541276": "12760 - savory, dry (efsa foodex2)",
    "FOODON_03302162": "lemon beverage base (instant, powdered)",
    "FOODON_03542242": "22420 - miscellaneous freshwater fishes (efsa foodex2)",
    "FOODON_03305364": "food (irradiated)",
    "NCBITaxon_13678": "Scomberomorus",
    "FOODON_03411495": "rosemary plant",
    "FOODON_00001900": "gelatin refined food product",
    "FOODON_03414868": "mandarin fish",
    "ENVO_01000253": "freshwater river biome",
    "NCBITaxon_2233855": "indigoferoid/millettioid clade",
    "FOODON_03510097": "no artificial colors claim or use",
    "FOODON_03311069": "obsolete: orange juice product, not further specified",
    "NCBITaxon_169725": "Attaleinae",
    "CHEBI_62984": "zinc acetate",
    "NCBITaxon_4581": "Bambusa",
    "FOODON_03412372": "ricefish family",
    "FOODON_03414146": "great scallop",
    "FOODON_03307962": "perch fillet (raw)",
    "FOODON_03411440": "saithe",
    "FOODON_03415071": "purple coneflower plant",
    "FOODON_03308491": "sweet green pepper (sliced, canned)",
    "FOODON_00003355": "pastry flour",
    "FOODON_03301947": "castor bean oil",
    "CHEBI_9679": "tricalcium bis(phosphate)",
    "FOODON_03302650": "cow buttermilk (bulgarian)",
    "FOODON_03542044": "20440 - wild boar kidney (efsa foodex2)",
    "NCBITaxon_4210": "Asteraceae",
    "FOODON_03302835": "yellow cake mix",
    "FOODON_03316623": "honey glucose (crystalline)",
    "GAZ_00002892": "Panama",
    "FOODON_03306868": "potato peeling",
    "FOODON_00001235": "soy sauce food product",
    "FOODON_03301685": "vegetable juice (diluted)",
    "FOODON_03540562": "05620 - moso bamboo (efsa foodex2)",
    "FOODON_03430161": "soft gelatin capsule",
    "FOODON_03544017": "40170 - meat and vegetable soup (efsa foodex2)",
    "FOODON_03542201": "22010 - bovine meat, dried (efsa foodex2)",
    "FOODON_03304142": "curry sauce mix",
    "NCBITaxon_7823": "Sphyrna lewini",
    "NCBITaxon_2886": "Laminariales",
    "FOODON_00001634": "bass food product",
    "NCBITaxon_88123": "Prunus salicina",
    "FOODON_03490360": "acryl-nitrile container",
    "FOODON_03306420": "cannelloni roll with meat in sauce",
    "FOODON_03544187": "41870 - apple green flavour (efsa foodex2)",
    "FOODON_03301287": "apricot nectar (food product)",
    "FOODON_03412965": "chinese artichoke plant",
    "FOODON_03302627": "butter sauce",
    "FOODON_03412174": "gafftopsail catfish",
    "FOODON_03305493": "horseradish cream dressing",
    "NCBITaxon_8258": "Myzopsetta ferruginea",
    "FOODON_03411573": "fish, atheriniform",
    "NCBITaxon_482919": "Orthopristis chrysoptera",
    "FOODON_03510132": "\"light\" label claim",
    "NCBITaxon_77327": "Leptospron adenanthum",
    "FOODON_00002257": "soup food product",
    "NCBITaxon_169746": "Borasseae",
    "FOODON_03401094": "10000294 - grain based products / meals - ready to eat - savoury (shelf stable) (gs1 gpc)",
    "FOODON_03306158": "grape juice (vinifera)",
    "FOODON_03315114": "beverage cocoa",
    "FOODON_03309543": "cow buttermilk flake",
    "FOODON_03401042": "50131700 - milk/milk substitutes (gs1 gpc)",
    "FOODON_03305093": "chicken (boneless, canned)",
    "FOODON_03540503": "05030 - chinese chives sprouts (efsa foodex2)",
    "FOODON_03543900": "39000 - dal (efsa foodex2)",
    "FOODON_03542361": "23610 - alaska pollock (efsa foodex2)",
    "FOODON_03304915": "egg drop soup",
    "FOODON_03541936": "19360 - horse, minced meat (efsa foodex2)",
    "FOODON_03306760": "chocolate cream pie",
    "FOODON_03302725": "mango chutney",
    "FOODON_00001824": "durum wheat pasta food product",
    "FOODON_00003037": "mugwort leaves and buds",
    "NCBITaxon_7711": "Chordata",
    "FOODON_03544238": "42380 - chocolate milk flavour (efsa foodex2)",
    "FOODON_03401426": "10006158 - yardlong beans (gs1 gpc)",
    "FOODON_03413240": "sodium adipate",
    "FOODON_03541443": "14430 - chironjas (efsa foodex2)",
    "HANCESTRO_0386": "Russian",
    "FOODON_03305155": "maple danish pastry",
    "FOODON_03400774": "087  derived milk products (ld) (ccpr)",
    "FOODON_03540555": "05550 - leeks (efsa foodex2)",
    "NCBITaxon_66670": "Bixaceae",
    "FOODON_03414039": "olive flounder",
    "CHEBI_37586": "sodium phosphate",
    "FOODON_03307189": "pineapple and apricot jam",
    "NCBITaxon_4722": "Serenoa repens",
    "FOODON_00003078": "nopal pad",
    "FOODON_03308301": "sei (canned)",
    "FOODON_03315987": "sweet-sour vegetable preserves",
    "FOODON_00001859": "flaxseed food product",
    "FOODON_00001143": "fungal food product",
    "NCBITaxon_233715": "Mimusops elengi",
    "FOODON_03302733": "corn (ammoniated)",
    "FOODON_03541902": "19020 - wild boar msm (efsa foodex2)",
    "FOODON_03542549": "25490 - razor clam (efsa foodex2)",
    "UBERON_0001013": "adipose tissue",
    "FOODON_03414670": "passionflower plant",
    "FOODON_03306160": "lime juice",
    "NCBITaxon_455479": "Lutjanus guttatus",
    "FOODON_00002875": "jiaozi",
    "FOODON_03413989": "albacore and tuna",
    "FOODON_03400959": "50182300 - bread/bakery products variety packs (gs1 gpc)",
    "FOODON_03411999": "common bean plant",
    "NCBITaxon_229630": "Citrus x tangelo",
    "FOODON_03316461": "red beet powder",
    "PATO_0000586": "increased size",
    "FOODON_03543748": "37480 - infant and follow-on formulae (efsa foodex2)",
    "FOODON_03301686": "spice (dried)",
    "FOODON_03541386": "13860 - peppercorn (black, green and white) (efsa foodex2)",
    "FOODON_03540413": "04130 - blumea leaves (efsa foodex2)",
    "FOODON_03307461": "tomato juice drink",
    "FOODON_00001936": "green olive food product",
    "FOODON_03412566": "painted sweetlips",
    "FOODON_03401135": "10000627 - aquatic invertebrates/fish/shellfish/seafood mixes - prepared/processed (perishable) (gs1 gpc)",
    "FOODON_03308810": "shrimp log (breaded, frozen)",
    "FOODON_00001030": "halloumi cheese food product",
    "NCBITaxon_294740": "Mentha requienii",
    "FOODON_03414921": "romanesco plant",
    "FOODON_00002636": "conchiglie",
    "FOODON_03304325": "apple beverage syrup (vermont red apple variety)",
    "NCBITaxon_9726": "Delphinidae",
    "FOODON_00002603": "Sangiovese wine",
    "FOODON_03412944": "padang cassia plant",
    "FOODON_03311080": "human milk (powdered)",
    "FOODON_00002989": "broccoli sprout",
    "FOODON_00003363": "chicken thigh (with skin, with bone)",
    "FOODON_03413796": "oyster mushroom",
    "NCBITaxon_34274": "Gossypium herbaceum",
    "FOODON_03401545": "10006824 - fiddlehead ferns (gs1 gpc)",
    "FOODON_03401301": "single mineral supplement",
    "FOODON_03460165": "obsolete: gelatin added",
    "FOODON_03540357": "03570 - wheat, popped (efsa foodex2)",
    "FOODON_03414436": "potassium tartrates",
    "FOODON_03542325": "23250 - perch, white (efsa foodex2)",
    "FOODON_03316613": "cheese (maturing)",
    "FOODON_03414674": "burdekin plum plant",
    "FOODON_03400826": "vegetable (excluding potato) (eurofir)",
    "NCBITaxon_8259": "Platichthys",
    "FOODON_03302501": "plastic cream",
    "FOODON_03411637": "straw mushroom",
    "UBERON_0007366": "ruminant stomach",
    "FOODON_03303956": "mango (pulp)",
    "GAZ_00001089": "Central African Republic",
    "FOODON_03302625": "butter mix product (dehydrated)",
    "HANCESTRO_0440": "Israeli",
    "FOODON_03400839": "chocolate or chocolate product (eurofir)",
    "NCBITaxon_6585": "Solenidae",
    "FOODON_03411575": "pacific herring",
    "FOODON_03303394": "potato mix",
    "FOODON_03414466": "tunicate",
    "NCBITaxon_84561": "Oecophylla smaragdina",
    "FOODON_03305427": "fruit sherbet (artificially sweetened)",
    "HANCESTRO_0374": "Luxembourgish",
    "FOODON_03412573": "pipefish family",
    "FOODON_03302552": "salmon (smoked, canned)",
    "FOODON_03413792": "white truffle",
    "FOODON_03412497": "fish, aulopiform",
    "FOODON_03414979": "bitterblad",
    "FOODON_03470170": "sun drying",
    "FOODON_03414948": "sweet granadilla plant",
    "CHEBI_23230": "chromanes",
    "FOODON_03304010": "pinto refried beans",
    "FOODON_03309598": "apple-strawberry spread",
    "FOODON_03304752": "swiss and ham roll",
    "FOODON_03540068": "00680 - flour mix (like wheat/rye/barley/oats and other) (efsa foodex2)",
    "FOODON_03302371": "soya bread",
    "NCBITaxon_7952": "Cypriniformes",
    "FOODON_03305616": "herbal tea mixture (dry)",
    "FOODON_03540540": "05400 - hop sprouts (efsa foodex2)",
    "FOODON_03302295": "chocolate-flavored carbonated beverage",
    "FOODON_03310437": "potato (whole, frozen)",
    "FOODON_03411486": "field pea plant",
    "FOODON_03413696": "northern shortfin squid",
    "NCBITaxon_9224": "Psittacidae",
    "FOODON_03301029": "honey (freeze-dried)",
    "NCBITaxon_102211": "Benincasa hispida",
    "FOODON_03412432": "arkshells",
    "FOODON_03490342": "paperboard container, surface treated both sides",
    "FOODON_03414309": "grunter family",
    "FOODON_03542322": "23220 - miscellaneous diadromous fishes (efsa foodex2)",
    "FOODON_03305263": "vegetable oil",
    "FOODON_03309713": "otaheite gooseberry (raw)",
    "FOODON_00002017": "barley malt beverage",
    "FOODON_03302395": "sangria-flavored nonalcoholic beverage base",
    "FOODON_03542904": "29040 - cheese, san simon (efsa foodex2)",
    "NCBITaxon_3587": "Basellaceae",
    "FOODON_00002693": "alpaca",
    "FOODON_03540314": "03140 - oat rolled grains (efsa foodex2)",
    "ENVO_00000428": "biome",
    "NCBITaxon_3487": "Moraceae",
    "NCBITaxon_85417": "Gobius niger",
    "FOODON_03315512": "beverage (vegetable base, preserved, for infants and young children)",
    "PATO_0000122": "length",
    "NCBITaxon_195656": "Achiridae",
    "NCBITaxon_42229": "Prunus avium",
    "FOODON_03490198": "drum (container)",
    "FOODON_00001565": "pre-evisceration carcass",
    "FOODON_03411138": "angel shark genus",
    "FOODON_03310183": "almond (silver-coated)",
    "FOODON_00003261": "hachis parmentier",
    "FOODON_03315845": "confectionery coating, unstandardized",
    "FOODON_03541609": "16090 - gooseberries and similar- (efsa foodex2)",
    "HANCESTRO_0367": "Greenlander",
    "FOODON_03309105": "herring tidbit (raw)",
    "FOODON_03401196": "10000280 - other sauces dipping/condiments/savoury toppings/savoury spreads/marinades (shelf stable) (gs1 gpc)",
    "FOODON_03411963": "new zealand green mussel",
    "ENVO_00002221": "shop",
    "FOODON_03316780": "skim milk (cultured)",
    "FOODON_03412112": "mollusc",
    "ENVO_00000014": "canal",
    "FOODON_03414413": "calcium phosphates",
    "FOODON_03540124": "01240 - wheat bread and rolls, semi-brown (efsa foodex2)",
    "FOODON_03301233": "spirit vinegar and cider mixture",
    "FOODON_03541572": "15720 - aronia berries (purple) (efsa foodex2)",
    "FOODON_03315389": "confectionery (carbohydrate modified)",
    "FOODON_03414913": "rock samphire plant",
    "FOODON_03411686": "carambola tree",
    "FOODON_03411361": "succotash",
    "NCBITaxon_3807": "mimosoid clade",
    "FOODON_03490139": "aluminum tube, unlined plastic top",
    "FOODON_03414753": "billabong tree",
    "NCBITaxon_630680": "Macrourus carinatus",
    "FOODON_03412994": "amidated pectin",
    "FOODON_03310036": "fish sauce (fermented)",
    "FOODON_03540696": "06960 - pumpkins and similar- (efsa foodex2)",
    "FOODON_03315505": "sujiko",
    "FOODON_03543307": "33070 - soft drink, flavoured with herbs (efsa foodex2)",
    "FOODON_03411704": "jojoba plant",
    "FOODON_03490310": "varnished tin-plate container",
    "FOODON_03317565": "aperitif wine",
    "FOODON_03302513": "orange butter (food product)",
    "FOODON_03411295": "snake",
    "FOODON_03316304": "liqueur (flavored with herbs and/or spices)",
    "NCBITaxon_6706": "Homarus americanus",
    "FOODON_00002700": "canola plant food product",
    "FOODON_03540094": "00940 - chapatti flour (efsa foodex2)",
    "NCBITaxon_3282": "Osmundaceae",
    "FOODON_03413085": "disodium citrate",
    "FOODON_03307680": "coffee (instant, dried dairy product added)",
    "FOODON_00001703": "cauliflower vegetable food product",
    "FOODON_03315442": "tea concentrate (liquid)",
    "FOODON_03530166": "alcohol content > 5%",
    "NCBITaxon_173330": "Trachinotus",
    "CHEBI_35162": "acyclic carotene",
    "FOODON_03420277": "stigma",
    "UO_0000016": "millimeter",
    "FOODON_03302028": "beet (sliced, canned)",
    "FOODON_00002678": "fish cake",
    "FOODON_03414318": "little millet plant",
    "FOODON_03302949": "cherry (pitted, canned)",
    "NCBITaxon_516948": "Vaccinium oxycoccos",
    "FOODON_00001988": "konbu vegetable food product",
    "CHEBI_51689": "enone",
    "FOODON_03541773": "17730 - costarican guavas (efsa foodex2)",
    "FOODON_03306372": "seville orange (whole, raw)",
    "GAZ_00002839": "India",
    "FOODON_03540416": "04160 - marsh marigold leaves (efsa foodex2)",
    "FOODON_03542018": "20180 - equine liver (efsa foodex2)",
    "FOODON_03543701": "37010 - coffee beverages (efsa foodex2)",
    "FOODON_03542134": "21340 - cooked turkey meat (efsa foodex2)",
    "FOODON_03542005": "20050 - chicken, fresh fat tissue (efsa foodex2)",
    "FOODON_03413304": "tetrasodium diphosphate",
    "FOODON_03316058": "mammalian milk (preserved)",
    "FOODON_03308534": "north atlantic lobster (raw)",
    "FOODON_03412930": "strychnos plant",
    "NCBITaxon_27292": "Saccharomyces pastorianus",
    "FOODON_03544475": "44750 - vitamin b1   (thiamine) (efsa foodex2)",
    "FOODON_03306729": "jalapeno pepper (pickled)",
    "FOODON_03316365": "relish (dried)",
    "FOODON_03311456": "olive oil (solvent-extracted)",
    "FOODON_03542535": "25350 - blue mussel (efsa foodex2)",
    "FOODON_03302897": "whipped cream",
    "FOODON_03306006": "fruit juice concentrate (frozen)",
    "NCBITaxon_7830": "Scyliorhinus canicula",
    "GAZ_00002602": "State of Maine",
    "FOODON_03412288": "naked sole",
    "FOODON_03302879": "crab roe (raw)",
    "FOODON_03543189": "31890 - juice, passion fruit (efsa foodex2)",
    "NCBITaxon_476922": "Osmerus mordax mordax",
    "FOODON_03414484": "giant pacific octopus",
    "FOODON_03401652": "10005802 - alternative meat/poultry/other animal species - unprepared/unprocessed (gs1 gpc)",
    "NCBITaxon_56866": "Luffa acutangula",
    "FOODON_03411934": "hawkfish family",
    "FOODON_03401837": "10006088 - rocket (gs1 gpc)",
    "FOODON_03541155": "11550 - swiss pine nut kernels (efsa foodex2)",
    "NCBITaxon_44599": "Pinnidae",
    "FOODON_03541976": "19760 - partridge fresh meat (efsa foodex2)",
    "FOODON_03301309": "tonka bean extract",
    "FOODON_03400295": "alcoholic beverage analog (us cfr)",
    "NCBITaxon_691794": "Ethmidium",
    "FOODON_03301312": "oat flour",
    "FOODON_03412907": "large scaled brown slickhead",
    "FOODON_00002447": "nutsedge food product",
    "FOODON_03412020": "roseapple plant",
    "FOODON_03400871": "food for special nutritional use (eurofir)",
    "NCBITaxon_286537": "Coilia mystus",
    "FOODON_03304327": "papaya-flavored beverage syrup",
    "FOODON_03310180": "cream of broccoli soup",
    "FOODON_03309715": "eggplant (cooked)",
    "FOODON_03308334": "norwegian sardine (raw)",
    "FOODON_03540334": "03340 - cereal bars mixed (efsa foodex2)",
    "FOODON_03411015": "cellulose-producing plant",
    "FOODON_03306603": "naranjilla and pineapple juice concentrate",
    "FOODON_03541105": "11050 - white lupin (dry) (efsa foodex2)",
    "FOODON_03413590": "caribbean lobster",
    "FOODON_03414729": "cattail plant",
    "FOODON_03540346": "03460 - processed rye-based flakes (efsa foodex2)",
    "FOODON_03310028": "lotus seed (whole, dried)",
    "IAO_0000428": "requires discussion",
    "FOODON_03412455": "climbing wattle plant",
    "FOODON_03308580": "zuwai crab (raw)",
    "FOODON_03510031": "pet dog as consumer",
    "FOODON_03530164": "sugar content < 30%",
    "FOODON_03310864": "yellow nutsedge tuber (raw)",
    "NCBITaxon_112232": "Mustelus asterias",
    "FOODON_00002900": "scad",
    "NCBITaxon_3514": "Betulaceae",
    "FOODON_03304910": "tender mushroom soup",
    "FOODON_03400655": "07  poultry products (ccpr)",
    "FOODON_03303647": "candy substitute",
    "FOODON_03309466": "wild duck consomm\u00e9 with sherry wine",
    "NCBITaxon_8793": "Rheidae",
    "CHEBI_83163": "molasses",
    "FOODON_03544458": "44580 - mould or micro-fungal cultures (efsa foodex2)",
    "FOODON_03302913": "runesten cheese",
    "FOODON_03420122": "nonmeat part of animal",
    "FOODON_03303952": "coconut preserves",
    "CHEBI_50906": "role",
    "FOODON_03306913": "red skin peanut (whole, with skin, raw)",
    "FOODON_03315286": "health supplement food",
    "FOODON_03541950": "19500 - wapiti elk meat (efsa foodex2)",
    "NCBITaxon_121770": "Echinochloa esculenta",
    "PATO_0000574": "decreased length",
    "FOODON_03309464": "game soup",
    "NCBITaxon_190548": "Vaccinium uliginosum",
    "FOODON_03316369": "potato product (pre-fried)",
    "FOODON_03310428": "gardiniera (food product)",
    "FOODON_03310186": "spinach powder",
    "NCBITaxon_21563": "Averrhoa",
    "FOODON_03401835": "10006086 - lambs lettuce (gs1 gpc)",
    "NCBITaxon_98814": "Dentex macrophthalmus",
    "FOODON_03420267": "skeletal meat part, without bone, with skin",
    "FOODON_00002472": "fruit (fresh)",
    "FOODON_03544412": "44120 - zabaglione flavour (efsa foodex2)",
    "FOODON_03308941": "red snapper (raw)",
    "FOODON_03540695": "06950 - kiwanos (efsa foodex2)",
    "FOODON_03411458": "eggplant plant",
    "NCBITaxon_37858": "Ostrea",
    "FOODON_03413665": "florida fighting conch",
    "FOODON_03301467": "bean substance",
    "FOODON_03541309": "13090 - bitter fennel seed (efsa foodex2)",
    "FOODON_03401299": "dietary supplement, mineral",
    "FOODON_03316687": "grape seed oil (edible)",
    "FOODON_03542358": "23580 - grenadiers (efsa foodex2)",
    "FOODON_03304593": "artichoke (canned)",
    "FOODON_03411056": "california valencia orange plant",
    "FOODON_03305312": "mushroom gravy",
    "FOODON_03315446": "fish (fresh)",
    "FOODON_03415096": "norway spruce plant",
    "FOODON_03540400": "04000 - box thorn (efsa foodex2)",
    "FOODON_00001292": "oyster food product",
    "NCBITaxon_30989": "Siluridae",
    "FOODON_03411059": "shellfish or crustacean",
    "FOODON_03543635": "36350 - couch grass infusion roots (efsa foodex2)",
    "FOODON_03520358": "europe, southern",
    "FOODON_03315296": "red pepper powder (hot)",
    "NCBITaxon_185702": "Apios americana",
    "FOODON_03310963": "pancake syrup, artificially sweetened",
    "FOODON_03400714": "24  red meat and meat products (efg)",
    "FOODON_03302972": "cheese powder (concentrated)",
    "FOODON_03308997": "yellowstreaked snapper (raw)",
    "FOODON_03316686": "mixtures of refined olive oil and refined olive oil residue",
    "FOODON_03315610": "herring spiced sugar",
    "FOODON_03411571": "atlantic spanish mackerel",
    "FOODON_03412861": "atlantic cutlassfish",
    "FOODON_03303047": "pasteurized process cheese spread",
    "HANCESTRO_0011": "Sub-Saharan African",
    "FOODON_03412787": "natal orange plant",
    "HANCESTRO_0310": "Val Borbera",
    "FOODON_03540853": "08530 - parsley (efsa foodex2)",
    "NCBITaxon_19955": "Ebenaceae",
    "FOODON_03302541": "candy corn",
    "FOODON_03411741": "black fungus",
    "FOODON_03317619": "fruit juice for confectionery",
    "FOODON_00002088": "pasteurized blended cheese food product",
    "NCBITaxon_27706": "Micropterus salmoides",
    "FOODON_00001610": "apple condiment",
    "FOODON_03309693": "fish sauce (phillipine)",
    "FOODON_03540408": "04080 - sowthistle leaves (efsa foodex2)",
    "NCBITaxon_8243": "Xiphiidae",
    "FOODON_03414473": "california golden bear",
    "FOODON_03530020": "brisket",
    "FOODON_03450007": "charcoal broiling",
    "FOODON_03411490": "american dewberry plant",
    "FOODON_03460107": "lactic acid-other agent fermentation",
    "NCBITaxon_49992": "Thymus vulgaris",
    "FOODON_03308437": "gulf sardine (raw)",
    "FOODON_03415172": "soapbark plant",
    "FOODON_03305956": "whiskey jelly",
    "FOODON_03510257": "calcium and osteoporosis related claim or use",
    "NCBITaxon_7089": "Bombycidae",
    "FOODON_00002996": "mrigal carp",
    "FOODON_03304858": "balut (canned)",
    "FOODON_03530226": "clupeotoxic poisoning",
    "NCBITaxon_7933": "Anguilliformes",
    "FOODON_03540682": "06820 - pointed gourds (efsa foodex2)",
    "NCBITaxon_6744": "Paguroidea",
    "FOODON_03544076": "40760 - stock cubes or granulate, vegetables (efsa foodex2)",
    "FOODON_00003099": "lychee fruit (whole)",
    "FOODON_00002809": "edamame",
    "FOODON_03317320": "pork loin (uncooked, cured)",
    "FOODON_03543450": "34500 - herbal infusion materials (generic) (efsa foodex2)",
    "FOODON_03412795": "christ's thorn plant",
    "FOODON_03309545": "rat meat (canned)",
    "FOODON_03544147": "41470 - dessert sauces/toppings (efsa foodex2)",
    "NCBITaxon_145711": "Salacca zalacca",
    "FOODON_03543546": "35460 - sweet trefoil infusion leaves (efsa foodex2)",
    "FOODON_03544308": "43080 - mandarin flavour (efsa foodex2)",
    "FOODON_03414078": "oxeye oreo",
    "FOODON_03308596": "crab paste",
    "FOODON_03401329": "obsolete: dietary supplement, not specified",
    "NCBITaxon_4268": "Malpighiaceae",
    "FOODON_03301972": "barley miso",
    "FOODON_03317137": "artificial sweetener (powder)",
    "HANCESTRO_0468": "Guamanian",
    "FOODON_03540773": "07730 - wakame (efsa foodex2)",
    "FOODON_03310912": "montasio cheese",
    "NCBITaxon_42148": "Moronidae",
    "GAZ_00003781": "Jamaica",
    "FOODON_03317162": "citrus nectar",
    "FOODON_03530073": "cheese rind (moldy)",
    "FOODON_03306388": "lime preserves",
    "NCBITaxon_458597": "Pinguipes",
    "NCBITaxon_9946": "Tragelaphus strepsiceros",
    "FOODON_00002878": "S\u014dmen",
    "FOODON_03309332": "hake fillet (frozen)",
    "FOODON_03413598": "sculpted lobster",
    "FOODON_03307747": "chili bean tamale (food product)",
    "FOODON_03401604": "10006046 - winter savoury (gs1 gpc)",
    "FOODON_03400222": "dessert (us cfr)",
    "FOODON_03411756": "jewfish",
    "FOODON_03540438": "04380 - purslanes (efsa foodex2)",
    "CHEBI_30411": "cobalamin",
    "FOODON_03317025": "sweet cream (sterilized)",
    "FOODON_03414558": "lesser rhea",
    "CHEBI_36819": "seco-ergostane",
    "FOODON_03302856": "coffee royal cake",
    "FOODON_03317227": "cream cheese (processed)",
    "FOODON_03316167": "vegetable white (processed)",
    "NCBITaxon_4298": "Ilex aquifolium",
    "HANCESTRO_0524": "Motswana",
    "NCBITaxon_378008": "Curcuma australasica",
    "FOODON_03304615": "hen egg (whole, shell on, hard boiled)",
    "FOODON_03316286": "sauce (spicy)",
    "NCBITaxon_32244": "Quillaja saponaria",
    "FOODON_03414499": "arctic dock plant",
    "FOODON_00002710": "cow lung (whole, raw)",
    "FOODON_03310834": "obsolete: food, fermented",
    "FOODON_03305649": "imitation vanilla-flavored ice milk mix",
    "FOODON_03400627": "CCFAC fats and oils, and fat emulsions (type water-in-oil)",
    "FOODON_00001087": "vegetable oil food product",
    "FOODON_03414944": "scotch bonnet",
    "FOODON_03413346": "paradise apple plant",
    "CHEBI_34683": "disodium hydrogenphosphate",
    "NCBITaxon_30945": "Hippoglossoides elassodon",
    "FOODON_03540271": "02710 - chocolate-based cakes (efsa foodex2)",
    "FOODON_03411879": "lefteye flounder family",
    "FOODON_03542503": "25030 - lobster, american (efsa foodex2)",
    "FOODON_03311435": "strawberry spread low-sugar",
    "FOODON_03543812": "38120 - combination of vitamin and mineral only supplements (efsa foodex2)",
    "FOODON_03401401": "50251300 - annona (gs1 gpc)",
    "FOODON_03490157": "textile or fabric container",
    "ENVO_00000073": "building",
    "FOODON_00002066": "olive food product",
    "FOODON_03311362": "fruit-flavored syrup",
    "NCBITaxon_641111": "Pleuronectes quadrituberculatus",
    "FOODON_03306301": "macaroni (real italian)",
    "FOODON_03543534": "35340 - passion flower infusion leaves (efsa foodex2)",
    "FOODON_03306926": "pineapple chunk (artificially sweetened, canned)",
    "FOODON_03490358": "thermoplastic sheet or container",
    "FOODON_03315360": "choonjang",
    "FOODON_03308268": "sea salmon (raw)",
    "FOODON_00003083": "veal",
    "FOODON_03306827": "wheat dough (enriched, frozen)",
    "FOODON_03301064": "orgeat syrup",
    "FOODON_03304006": "hot sauce",
    "NCBITaxon_52863": "Tylophora",
    "FOODON_03530096": "no sausage casing",
    "FOODON_03541900": "19000 - rabbit msm (efsa foodex2)",
    "FOODON_03317664": "flavoring emulsion",
    "NCBITaxon_185881": "Pterois",
    "FOODON_03305084": "imitation tomato catsup",
    "FOODON_03308053": "clam (bay, raw)",
    "FOODON_03400812": "grain or grain product (eurofir)",
    "FOODON_03430133": "divided into halves, quarters or segments",
    "FOODON_03305753": "tomato juice cocktail",
    "FOODON_00002401": "cactus food product",
    "FOODON_03413679": "white octopus",
    "FOODON_03315738": "egg simulated product (whole)",
    "FOODON_03490167": "laminate tube",
    "FOODON_03520366": "European Union",
    "FOODON_03543370": "33700 - marsala (efsa foodex2)",
    "NCBITaxon_27767": "Gempylidae",
    "FOODON_03542627": "26270 - pollock, dried (efsa foodex2)",
    "CHEBI_33560": "p-block element atom",
    "FOODON_03500004": "obsolete: food contact surface, other",
    "NCBITaxon_7914": "Semionotiformes",
    "FOODON_03307489": "imitation milkshake mix (dry)",
    "BFO_0000050": "part of",
    "FOODON_03302962": "shrimp egg roll",
    "FOODON_03304544": "chicken (frozen)",
    "FOODON_03540381": "03810 - winter cress (efsa foodex2)",
    "FOODON_03415119": "golden shower tree",
    "HANCESTRO_0500": "Thai",
    "FOODON_03411231": "berry plant",
    "RO_0003302": "causes or contributes to condition",
    "FOODON_03412198": "kingfish",
    "HANCESTRO_0535": "Gambian",
    "FOODON_03303660": "hollaender cheese",
    "GAZ_00005808": "Glorioso Islands",
    "FOODON_03414280": "parore",
    "FOODON_00002302": "swine fat or oil refined food product",
    "FOODON_03542893": "28930 - cheese, afuega'l pitu (efsa foodex2)",
    "FOODON_03308037": "dogfish (raw)",
    "FOODON_03540712": "07120 - carrots (efsa foodex2)",
    "FOODON_03303007": "chicken pot pie (frozen)",
    "NCBITaxon_6757": "Portunidae",
    "FOODON_03414067": "flathead catfish genus",
    "FOODON_03542352": "23520 - ling (efsa foodex2)",
    "NCBITaxon_90071": "Buglossidium luteum",
    "FOODON_03420155": "obsolete: seed (anatomical part)",
    "FOODON_03401234": "0270000 - stem vegetables (ec)",
    "FOODON_00001313": "nam-budu",
    "NCBITaxon_183655": "Urophycis",
    "NCBITaxon_118162": "Muraenesox bagio",
    "NCBITaxon_9784": "Loxodonta",
    "FOODON_03401826": "10006322 - mustard (shelf stable) (gs1 gpc)",
    "FOODON_03308286": "sole (raw)",
    "FOODON_03302279": "imitation grape drink",
    "FOODON_03401622": "10005769 - chicken - prepared/processed (gs1 gpc)",
    "FOODON_03317552": "cider (aromatized)",
    "FOODON_03414535": "horse mushroom",
    "FOODON_03305851": "gelatin dessert mix (imitation cherry flavor, dry)",
    "FOODON_03301648": "tea (dry)",
    "FOODON_03307175": "pretzel (salt-free)",
    "FOODON_03400433": "odour removing agent (codex)",
    "FOODON_03543819": "38190 - formulations containing special fatty acids (e.g. omega-3, essential fatty acids) (efsa foodex2)",
    "FOODON_03305571": "kangaroo meat (raw)",
    "CHEBI_39166": "tetramine",
    "FOODON_03542206": "22060 - marinated meat (efsa foodex2)",
    "FOODON_03307008": "ham (sodium restricted, cooked)",
    "FOODON_03450032": "cooking using heating container",
    "FOODON_03305329": "imitation apricot liqueur flavoring",
    "FOODON_03411105": "obsolete: cattle and swine",
    "FOODON_03540235": "02350 - pancake pre-mixes (dry) (efsa foodex2)",
    "FOODON_00003214": "filling fat",
    "FOODON_03400720": "30  cheese (efg)",
    "FOODON_03307383": "whey (swiss, dried)",
    "FOODON_00003050": "empanada",
    "FOODON_03306119": "lingonberry (canned)",
    "FOODON_03412337": "orchard grass plant",
    "FOODON_03311373": "raspberry preserve",
    "FOODON_03500023": "enamel surface for seafood",
    "ENVO_01000625": "manufactured cage",
    "FOODON_03317539": "beer with a second fermentation in cask",
    "FOODON_03540046": "00460 - african rice grain (efsa foodex2)",
    "FOODON_03430165": "liquid, supplement form",
    "FOODON_03543452": "34520 - strawberry infusion leaves and similar- (efsa foodex2)",
    "http://www.geneontology.org/formats/oboInOwl#hasNarrowSynonym": "has narrow synonym",
    "FOODON_03310175": "goat cheese sauce (food product)",
    "FOODON_03540370": "03700 - romaines (efsa foodex2)",
    "FOODON_03470102": "food sterilization before filling",
    "NCBITaxon_8113": "Cichlidae",
    "FOODON_03315191": "fat-water emulsion for use as a substitute for milk and cream in beverage coffee",
    "FOODON_03306673": "peach pie filling",
    "FOODON_03305628": "coconut (dried)",
    "FOODON_03316853": "colby cheese (for manufacturing)",
    "NCBITaxon_337687": "Muroidea",
    "FOODON_03315382": "skim milk powder mixture used to prepare liquid food",
    "FOODON_03540056": "00560 - wheat and similar- (efsa foodex2)",
    "FOODON_00001811": "dill food product",
    "FOODON_03541042": "10420 - stink beans (without pods) (efsa foodex2)",
    "FOODON_03413442": "obsolete: kurrat plant",
    "NCBITaxon_8469": "Chelonia mydas",
    "UBERON_0008265": "echinopluteus larva",
    "FOODON_03316050": "beverage vegetable based",
    "GAZ_00002901": "Costa Rica",
    "NCBITaxon_9870": "Rangifer tarandus",
    "FOODON_03543097": "30970 - olive pomace oil (efsa foodex2)",
    "NCBITaxon_471255": "Gallinula mortierii",
    "NCBITaxon_6781": "Menippe mercenaria",
    "NCBITaxon_210139": "Eleutheronema tetradactylum",
    "FOODON_03542099": "20990 - wild boar, other slaughtering products (efsa foodex2)",
    "FOODON_03541387": "13870 - green pepper (efsa foodex2)",
    "NCBITaxon_1538097": "Boraginales",
    "FOODON_03306815": "pigeon pea (whole, raw)",
    "FOODON_03304776": "stew peas (dish)",
    "FOODON_03413340": "two row barley plant",
    "FOODON_03304114": "bearnaise sauce mix",
    "FOODON_03543190": "31900 - juice, peach (efsa foodex2)",
    "FOODON_03302141": "biscuit (quick bread, ready-to-bake)",
    "FOODON_03308626": "shrimp (peeled, raw)",
    "FOODON_03308624": "wrasse (raw)",
    "FOODON_03411145": "bush basil",
    "FOODON_03540932": "09320 - processed or preserved vegetables and similar (efsa foodex2)",
    "CHEBI_63019": "potassium sodium L-tartrate",
    "FOODON_00003187": "chocolate spread",
    "FOODON_03310031": "ridge gourd (whole, raw)",
    "ENVO_01000252": "freshwater lake biome",
    "FOODON_03316480": "mushroom produce in sour pickle",
    "FOODON_03305983": "reconstituted orange juice (chilled)",
    "FOODON_03414234": "jewish plum plant",
    "FOODON_03412410": "rhodymenia",
    "FOODON_03542551": "25510 - arkshell (efsa foodex2)",
    "UBERON_0000307": "blastula",
    "HANCESTRO_0444": "Libyan",
    "FOODON_03541256": "12560 - kapok (efsa foodex2)",
    "NCBITaxon_55153": "Sciuridae",
    "FOODON_03304475": "spanish olive (stuffed with minced pimiento)",
    "FOODON_03303613": "chocolate chip (semisweet)",
    "FOODON_03315288": "beverage, lactobacillus",
    "FOODON_03317080": "pudding, dry mix",
    "FOODON_03530287": "black skin",
    "NCBITaxon_693794": "Onocleaceae",
    "GAZ_00002471": "East Asia",
    "FOODON_03412118": "ostrich",
    "FOODON_00001266": "camel milk beverage",
    "FOODON_03315506": "banana flesh",
    "FOODON_03315092": "vitamin and mineral tablet",
    "FOODON_03540945": "09450 - mashed vegetable puree (efsa foodex2)",
    "CHEBI_35990": "bridged compound",
    "FOODON_03308637": "imitation crab leg",
    "FOODON_03412416": "chinese chestnut tree",
    "CHEBI_26082": "phosphorus molecular entity",
    "FOODON_03401807": "10006114 - radishes (gs1 gpc)",
    "FOODON_03307561": "glutinous rice food product",
    "FOODON_03303669": "wensleydale cheese",
    "FOODON_03490320": "natural polymer container",
    "FOODON_03400927": "50180000 - bread/bakery products (gs1 gpc)",
    "FOODON_03413608": "st.paul rock lobster",
    "FOODON_03311352": "brazilnut (shell off)",
    "FOODON_03413355": "pointed headed cabbage plant",
    "FOODON_03315776": "meat product, simulated",
    "FOODON_03301354": "tree nut",
    "FOODON_03309364": "hay (baled)",
    "FOODON_00001771": "cow milk based food product",
    "FOODON_03414290": "velvet leatherjacket",
    "CHEBI_15409": "(-)-menthol",
    "FOODON_03540531": "05310 - cauliflowers (efsa foodex2)",
    "FOODON_03400633": "CCFAC meat and meat products",
    "FOODON_03311230": "peach (freeze-dried)",
    "FOODON_03540592": "05920 - tree onions (efsa foodex2)",
    "FOODON_00001019": "wort food product",
    "FOODON_03541989": "19890 - bovine fat tissue (efsa foodex2)",
    "FOODON_03540758": "07580 - oca (efsa foodex2)",
    "NCBITaxon_289702": "Dracontomelon",
    "NCBITaxon_282414": "Squaliformes",
    "FOODON_03540963": "09630 - andigena (efsa foodex2)",
    "FOODON_03411808": "porgy family",
    "FOODON_03540010": "00100 - amaranth grains (efsa foodex2)",
    "NCBITaxon_111520": "Penaeoidea",
    "FOODON_03302798": "bread (diet)",
    "FOODON_03544162": "41620 - starches (efsa foodex2)",
    "FOODON_03310896": "provola cheese (food product)",
    "FOODON_03316022": "fish product (semi-preserved)",
    "NCBITaxon_93760": "Cola acuminata",
    "GAZ_00005018": "Turkmenistan",
    "FOODON_03400657": "09  amphibians and reptiles (ccpr)",
    "FOODON_00001729": "chicken stew or hash",
    "FOODON_03542827": "28270 - cheese, lappi (efsa foodex2)",
    "FOODON_03412438": "rattlesnake",
    "FOODON_03308685": "spotted fish (fried, canned)",
    "NCBITaxon_47757": "Adrianichthyidae",
    "FOODON_03315316": "fruit sherbet (viscous)",
    "FOODON_00003194": "vegetarian food product",
    "FOODON_03301175": "cinnamon",
    "HANCESTRO_0577": "Dai Chinese",
    "FOODON_03308128": "mussel (shucked, raw)",
    "FOODON_03542765": "27650 - cheese, serpa (efsa foodex2)",
    "FOODON_03302459": "bread (diet, sliced)",
    "FOODON_00002160": "pleuronectiform fish food product",
    "FOODON_03460127": "lipolytic fermentation",
    "FOODON_03540735": "07350 - radishes and similar- (efsa foodex2)",
    "FOODON_00003356": "pet food (raw)",
    "FOODON_03301664": "cocoa press cake",
    "FOODON_03302201": "milk cookie",
    "NCBITaxon_68455": "Crocodylus siamensis",
    "FOODON_03306323": "bavarian mousse",
    "FOODON_03530144": "filet",
    "FOODON_03304784": "oolong tea (dry)",
    "FOODON_03543166": "31660 - juice, strawberry-cherry (efsa foodex2)",
    "FOODON_00002861": "Fuji apple tree",
    "FOODON_03542355": "23550 - coalfish (efsa foodex2)",
    "FOODON_03311567": "beiju",
    "GAZ_00002946": "The Netherlands",
    "FOODON_03540687": "06870 - other cucurbits with edible peel (efsa foodex2)",
    "FOODON_03413842": "gizzard shad",
    "FOODON_03412192": "chilean pilchard",
    "FOODON_03311156": "kidney bean (canned)",
    "FOODON_03413543": "australian abalone",
    "FOODON_03414210": "small cranberry plant",
    "FOODON_03401052": "50151600 - fats edible (gs1 gpc)",
    "FOODON_03315867": "cheese (varietal, hard)",
    "FOODON_03311203": "candy with ground nutmeats",
    "NCBITaxon_211520": "Myrmecocystus",
    "FOODON_03530138": "semelle",
    "FOODON_03311504": "beef flavor",
    "FOODON_03540547": "05470 - florence fennels (efsa foodex2)",
    "FOODON_03540470": "04700 - head brassica (efsa foodex2)",
    "FOODON_03510277": "phytosterol claim or use",
    "FOODON_03542222": "22220 - bighead carp (efsa foodex2)",
    "FOODON_03401680": "10006292 - rhea - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03542172": "21720 - polish-type cooked sausage (efsa foodex2)",
    "FOODON_03412304": "blue warehou",
    "FOODON_03543825": "38250 - meat and dairy imitates (efsa foodex2)",
    "FOODON_03315684": "bakery product (unstandardized)",
    "FOODON_03306863": "peanut butter with yeast",
    "FOODON_03401248": "0800000 - spices (ec)",
    "FOODON_03401064": "10000105 - baby/infant - specialised beverages (shelf stable) (gs1 gpc)",
    "FOODON_03311859": "pot pie (meat)",
    "FOODON_00003297": "turkey sausage",
    "FOODON_03307695": "vegetable salad",
    "FOODON_03311491": "shortnose cisco (raw)",
    "PO_0030123": "panicle inflorescence",
    "NCBITaxon_175228": "Ribes rubrum",
    "PO_0025334": "terete vascular leaf",
    "NCBITaxon_13390": "Camponotus",
    "GAZ_00002539": "State of Minnesota",
    "CHEBI_26986": "threonine",
    "FOODON_03543841": "38410 - tofu (efsa foodex2)",
    "CHEBI_18291": "manganese atom",
    "FOODON_03307828": "shrimp (jumbo, french-fried)",
    "FOODON_03460152": "obsolete: grain added",
    "FOODON_03414215": "sweet lime plant",
    "FOODON_03400391": "colour fixative (codex)",
    "FOODON_03307976": "flour (self-rising)",
    "FOODON_03540380": "03800 - land cresses (efsa foodex2)",
    "FOODON_03414282": "mallows plant",
    "FOODON_03401263": "1060000 - snails (ec)",
    "FOODON_03302144": "biscuit (cheese-flavored)",
    "NCBITaxon_4543": "Cenchrus americanus",
    "FOODON_03411311": "jujube plant",
    "FOODON_00002233": "sesame coated nut (snack)",
    "FOODON_03315992": "mollusc marinade",
    "NCBITaxon_169607": "Tagetes minuta",
    "NCBITaxon_38851": "Gentiana lutea",
    "FOODON_03302946": "custard",
    "FOODON_03542876": "28760 - cheese, gruyere (efsa foodex2)",
    "FOODON_03414689": "red ginger plant",
    "FOODON_03305883": "imitation orange jelly",
    "FOODON_03400887": "10000275 - wine - sparkling (gs1 gpc)",
    "FOODON_03303023": "cornish chicken (broad-breasted, raw)",
    "FOODON_03309310": "clam (venus, raw)",
    "NCBITaxon_365580": "Pangasius larnaudii",
    "FOODON_03302442": "butter gravy",
    "FOODON_03301228": "wine vinegar",
    "FOODON_03401063": "10000575 - baby/infant - formula (shelf stable) (gs1 gpc)",
    "FOODON_03540601": "06010 - runner beans (with pods) (efsa foodex2)",
    "FOODON_03310961": "seafood (whole or parts)",
    "FOODON_03305279": "supercream candy",
    "FOODON_03308150": "oyster (frozen, chemically treated)",
    "NCBITaxon_147022": "Tropaeolum minus",
    "NCBITaxon_7067": "Tenebrio molitor",
    "FOODON_03317656": "soybean milk (flavored)",
    "FOODON_03306458": "nutria meat (raw)",
    "FOODON_03541335": "13350 - other spices buds (e) (efsa foodex2)",
    "FOODON_03413896": "senegalese hake",
    "ENVO_00002264": "waste material",
    "FOODON_03414996": "common thyme plant",
    "FOODON_03309380": "african freshwater cichlid (raw)",
    "CHEBI_36970": "vitamin B6 phosphate",
    "FOODON_03301719": "peach (whole, raw)",
    "FOODON_03308708": "yellowtail (canned)",
    "FOODON_00002062": "oat flour food product",
    "FOODON_03304503": "melba toast (unsalted)",
    "FOODON_03304124": "sardine in mustard sauce (canned)",
    "FOODON_03543789": "37890 - fruit and vegetable juices and nectars specific for infants and young children (efsa foodex2)",
    "FOODON_03414534": "hon-shimeji",
    "NCBITaxon_29137": "Dugong dugon",
    "FOODON_03307629": "pie crust dough",
    "FOODON_03460293": "curing or aging 6 to 12 months",
    "FOODON_03542106": "21060 - goose, other slaughtering products (efsa foodex2)",
    "FOODON_03400679": "014  legume vegetables (vp) (ccpr)",
    "FOODON_03309047": "catfish fillet (frozen)",
    "FOODON_03311036": "soup mix, with dehydrated chicken",
    "NCBITaxon_134520": "Lonicera caerulea",
    "FOODON_03460779": "molybdenum added",
    "RO_0002214": "has prototype",
    "FOODON_00001132": "swine food product",
    "FOODON_03309551": "white potato (whole, raw)",
    "GAZ_00005901": "Territory of Ashmore and Cartier Islands",
    "FOODON_03510234": "traditional food claim or use",
    "FOODON_00003406": "cabbage (whole)",
    "FOODON_03412120": "ogen melon plant",
    "CHEBI_18310": "alkane",
    "NCBITaxon_75562": "Pagrus auratus",
    "FOODON_03317122": "apple (peeled, blanched, frozen)",
    "FOODON_03305465": "grape carbonated beverage (artificially colored)",
    "NCBITaxon_57865": "Gymnocephalus cernua",
    "NCBITaxon_225164": "Lottia gigantea",
    "FOODON_03312030": "rice (baked)",
    "UBERON_0006314": "bodily fluid",
    "FOODON_03413625": "witch prawn",
    "FOODON_03306893": "berry (whole, raw)",
    "FOODON_00002610": "Glera grape plant",
    "NCBITaxon_37006": "Mullus",
    "FOODON_03510236": "traditional ingredient claim or use",
    "NCBITaxon_3526": "Phytolacca",
    "FOODON_00002817": "moth bean (whole, raw)",
    "FOODON_03490289": "aluminium box, varnished",
    "FOODON_03308899": "big scale mackerel (raw)",
    "FOODON_03450028": "stir-frying",
    "FOODON_03411903": "capelin",
    "FOODON_00002756": "bean (rehydrated)",
    "FOODON_03308328": "norwegian sardine (smoked, packed in oil)",
    "FOODON_03304133": "dog food (liver-flavored)",
    "FOODON_03414845": "citrofortunella hybrids plant",
    "FOODON_03543766": "37660 - follow-on formulae, liquid (efsa foodex2)",
    "FOODON_03412829": "gingerbread plum plant",
    "NCBITaxon_6628": "Illex argentinus",
    "FOODON_03304736": "hen egg white (dried, whipping aid added)",
    "FOODON_03543619": "36190 - yarrow infusion flowers (efsa foodex2)",
    "HANCESTRO_0456": "Cocos Islander",
    "FOODON_03302293": "ginger ale (artificially sweetened)",
    "FOODON_03309728": "leatherjacket (raw)",
    "FOODON_00002709": "cod fillet",
    "FOODON_03401805": "10006126 - parsnips (gs1 gpc)",
    "FOODON_03541697": "16970 - other miscellaneous fruits with edible peel (efsa foodex2)",
    "FOODON_03304894": "coconut milk drink",
    "FOODON_03305129": "cream soup",
    "FOODON_03542028": "20280 - goose liver (efsa foodex2)",
    "FOODON_03305248": "peach pie filling (artificially sweetened)",
    "NCBITaxon_40548": "Dioscoreales",
    "FOODON_03309469": "reindeer steak (chopped)",
    "FOODON_03310813": "imitation sausage",
    "FOODON_03401239": "0402000 - oilfruits (ec)",
    "NCBITaxon_201498": "Hucho taimen",
    "FOODON_03411021": "fish or lower water animal",
    "NCBITaxon_99344": "Scomberomorus maculatus",
    "HANCESTRO_0347": "Austrian",
    "FOODON_00003199": "filo",
    "FOODON_03542092": "20920 - horse, other slaughtering products (efsa foodex2)",
    "CHEBI_24843": "inosine phosphate",
    "FOODON_03541316": "13160 - candlenut seeds (efsa foodex2)",
    "FOODON_03311694": "ham (sliced, cooked)",
    "FOODON_03413908": "cilus",
    "NCBITaxon_86063": "Galeorhinus galeus",
    "FOODON_03411910": "tarakihi",
    "FOODON_00001974": "insect refined food product",
    "FOODON_03530267": "fat content <=10%",
    "NCBITaxon_880343": "Peprilus paru",
    "FOODON_03413195": "polyoxyethylene (20) sorbitan tristearate (polysorbate 65)",
    "FOODON_03540070": "00700 - barley flour (efsa foodex2)",
    "FOODON_03541235": "12350 - chia seeds (efsa foodex2)",
    "FOODON_03304100": "grapefruit section in syrup (frozen)",
    "FOODON_03544349": "43490 - pineapple flavour (efsa foodex2)",
    "FOODON_03307858": "tea (with maltodextrin, instant)",
    "FOODON_03541114": "11140 - mat bean (dry seeds) (efsa foodex2)",
    "UBERON_0004734": "gastrula",
    "FOODON_03301710": "apple (whole, raw)",
    "FOODON_03490351": "paper-aluminium foil-plastic wrapper",
    "FOODON_03543703": "37030 - coffee (strong) beverage (efsa foodex2)",
    "FOODON_03308780": "oyster (korean, frozen)",
    "FOODON_03543977": "39770 - paella (efsa foodex2)",
    "FOODON_03420266": "skeletal meat part, with bone, without skin",
    "FOODON_03414431": "tertiary-butyl hydroquinone (tbhq)",
    "FOODON_03303776": "candy mix",
    "FOODON_03303359": "saltine cracker (rye, thin)",
    "FOODON_03540505": "05050 - daikon sprouts (efsa foodex2)",
    "FOODON_00002720": "food (hulled)",
    "FOODON_03540005": "00050 - barley and similar- (efsa foodex2)",
    "FOODON_03305157": "oatmeal cookie",
    "FOODON_03542612": "26120 - structured/textured fish meat products or fish paste (efsa foodex2)",
    "FOODON_00001142": "maize (corn) food product",
    "FOODON_03309138": "paddlefish (raw)",
    "FOODON_03302687": "french bread (enriched)",
    "NCBITaxon_42892": "Engraulis japonicus",
    "FOODON_03510184": "fortified claim or use",
    "GAZ_00002930": "Uruguay",
    "NCBITaxon_112727": "Polyprion",
    "FOODON_03401338": "50250600 - citrus (gs1 gpc)",
    "FOODON_00003160": "orange mint",
    "FOODON_03542704": "27040 - yoghurt drinks, including sweetened and/or flavoured variants (efsa foodex2)",
    "FOODON_03308039": "sea herring (salted, smoked)",
    "FOODON_03304250": "oxtail soup mix",
    "FOODON_03400937": "10000304 - biscuits/cookies (frozen) (gs1 gpc)",
    "FOODON_03500001": "obsolete: food contact surface not known",
    "FOODON_03412716": "margin jackknife",
    "FOODON_03305239": "pineapple (sliced, canned)",
    "NCBITaxon_30960": "Mallotus villosus",
    "FOODON_03540594": "05940 - legumes with pod (efsa foodex2)",
    "FOODON_03544249": "42490 - cranberry flavour (efsa foodex2)",
    "CHEBI_38835": "xanthenes",
    "FOODON_03315871": "dessert preparation (milk-based, unstandardized)",
    "FOODON_03309195": "mussel (common, raw)",
    "FOODON_03411546": "kawakawa",
    "FOODON_03411763": "bream",
    "FOODON_00003424": "soft white wheat kernel",
    "HANCESTRO_0378": "New Zealandish",
    "FOODON_03413719": "waterchestnut plant",
    "FOODON_03415050": "japanese apricot plant",
    "FOODON_03542462": "24620 - spiny dogfish (efsa foodex2)",
    "FOODON_00001711": "channel catfish food product",
    "FOODON_00002357": "noodle based soup",
    "FOODON_03316368": "potato product (deep-frozen)",
    "FOODON_00002713": "food (ground)",
    "FOODON_00002830": "multi-component durum wheat pasta dish",
    "FOODON_03301362": "polish sausage (pickled)",
    "FOODON_03301051": "candy",
    "FOODON_03317333": "bacon (immersion cured)",
    "FOODON_03303840": "fruit jelly (low calorie)",
    "FOODON_03540952": "09520 - sweet corn canned (efsa foodex2)",
    "FOODON_03305991": "kelp pickle",
    "FOODON_03543282": "32820 - fruit soft drink, currant red (efsa foodex2)",
    "FOODON_00001014": "yogurt food product",
    "FOODON_03316099": "beverage powder for preparation of hot beverage",
    "FOODON_03540541": "05410 - cardoons and similar- (efsa foodex2)",
    "FOODON_03543267": "32670 - well water (efsa foodex2)",
    "FOODON_03310243": "parsnip (boiled)",
    "FOODON_03305223": "zucca melon (whole, raw)",
    "FOODON_03542252": "22520 - mandarine fish (efsa foodex2)",
    "FOODON_03415173": "european goldenrod plant",
    "FOODON_03541838": "18380 - fruit compote, plum (efsa foodex2)",
    "FOODON_03415038": "mioga ginger plant",
    "NCBITaxon_1072472": "Dipturus linteus",
    "NCBITaxon_4020": "Tropaeolum majus",
    "FOODON_03413591": "bight lobster",
    "FOODON_03542326": "23260 - river lamprey (efsa foodex2)",
    "FOODON_03307114": "cherry spread",
    "NCBITaxon_316136": "Seriolella punctata",
    "FOODON_03401782": "10006750 - ready-made combination meals - not ready to eat (shelf stable) (gs1 gpc)",
    "PATO_0045001": "normal object quality",
    "FOODON_03307015": "prawn (raw)",
    "FOODON_03412420": "ivy gourd plant",
    "FOODON_03413652": "nuttall cockle",
    "FOODON_03302548": "peach fruit spread",
    "FOODON_03414605": "bladder wrack",
    "FOODON_03316882": "whole meat product",
    "FOODON_03317189": "artificial flavored drink starter and base substances",
    "FOODON_00002183": "rabbit meat food product",
    "FOODON_03414664": "quandong plant",
    "NCBITaxon_150436": "Panulirus versicolor",
    "FOODON_03302709": "imitation margarine",
    "FOODON_03543169": "31690 - juice, orange-peach (efsa foodex2)",
    "FOODON_03414849": "equine animal",
    "FOODON_03304661": "sauerkraut (canned)",
    "FOODON_03304988": "shoyu sauce",
    "FOODON_03301927": "bakery product dry mix",
    "FOODON_03304080": "beef-flavored soup mix",
    "GAZ_00001095": "Angola",
    "FOODON_03304947": "chicken stock base (fat removed)",
    "FOODON_03544168": "41680 - wheat starch, gluten free (efsa foodex2)",
    "FOODON_03305100": "sugar cane (powdered)",
    "FOODON_03510038": "low salt or sodium claim or use",
    "NCBITaxon_290260": "Jubaea chilensis",
    "NCBITaxon_3869": "Lupinus",
    "FOODON_03540441": "04410 - rock samphires (efsa foodex2)",
    "FOODON_03543230": "32300 - fruit juice concentrates (efsa foodex2)",
    "FOODON_00001017": "commercial yogurt",
    "FOODON_03542438": "24380 - pompanos (efsa foodex2)",
    "FOODON_03415074": "silver linden plant",
    "FOODON_03412981": "acetylated starch",
    "NCBITaxon_6724": "Astacoidea",
    "FOODON_00001223": "sausage (dried, fermented)",
    "FOODON_03301607": "konjacu tuber (raw)",
    "FOODON_03490197": "bag, sack or pouch",
    "FOODON_03510070": "no fat added claim or use",
    "FOODON_03301338": "wine beverage (less than 7% alcohol)",
    "FOODON_03510259": "athlete as food consumer",
    "NCBITaxon_51089": "Myristica fragrans",
    "FOODON_03305266": "nondairy cream",
    "FOODON_03413258": "sodium hydrogen sulphate",
    "NCBITaxon_1783272": "Terrabacteria group",
    "FOODON_03544277": "42770 - grapefruit flavour (efsa foodex2)",
    "FOODON_03307951": "clam (minced, canned)",
    "FOODON_03309049": "catfish stick",
    "FOODON_03306091": "ham salad",
    "CHEBI_24828": "indoles",
    "NCBITaxon_215357": "Larimichthys",
    "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl#C103180": "data standard",
    "NCBITaxon_96479": "Malva",
    "FOODON_03413912": "genyonemus",
    "FOODON_03401570": "10006041 - basil (gs1 gpc)",
    "FOODON_03308292": "naked sole (raw)",
    "FOODON_03541380": "13800 - cardamom fruit (efsa foodex2)",
    "FOODON_03311820": "salmon ground (raw)",
    "FOODON_00003205": "peanut substance",
    "FOODON_03530001": "obsolete: adjunct characteristics of food not known",
    "NCBITaxon_3864": "Lens culinaris",
    "FOODON_03309722": "bar jack (raw)",
    "FOODON_03544230": "42300 - cheesecake flavour (efsa foodex2)",
    "FOODON_03309261": "english sole (raw)",
    "FOODON_03412669": "splitnose rockfish",
    "FOODON_03316334": "butter (half-fat)",
    "FOODON_03317620": "fruit paste for confectionery",
    "FOODON_03543503": "35030 - heather infusion leaves (efsa foodex2)",
    "NCBITaxon_400990": "Solanum centrale",
    "FOODON_03303065": "apple drink mix (artificially flavored)",
    "FOODON_03544246": "42460 - coriander flavour (efsa foodex2)",
    "FOODON_03302322": "yellow cake (made with butter)",
    "FOODON_03414056": "houting",
    "FOODON_03540852": "08520 - parsley and similar- (efsa foodex2)",
    "FOODON_03310356": "rapeseed (whole, raw)",
    "FOODON_03530265": "fat content, meat",
    "FOODON_00002211": "rose food product",
    "FOODON_03304601": "imitation horseradish (prepared)",
    "FOODON_03302161": "beverage (vitamin-fortified)",
    "FOODON_03510136": "food consumer group",
    "FOODON_03490189": "steel plate container",
    "FOODON_03530167": "alcohol content 3.1-5%",
    "FOODON_03301728": "fudge",
    "CHEBI_53243": "poly(vinyl chloride)",
    "FOODON_00001103": "fermented agave beverage",
    "FOODON_03301859": "pineapple in light syrup (canned)",
    "FOODON_03308290": "striped sole (raw)",
    "FOODON_03401366": "50320100 - vegetables - unprepared/unprocessed (shelf stable) (gs1 gpc)",
    "FOODON_03301600": "pear brandy",
    "FOODON_03304842": "duck egg (preserved in salt)",
    "FOODON_03543382": "33820 - rum (efsa foodex2)",
    "FOODON_03306077": "fruit jelly (wine-flavored)",
    "FOODON_03543600": "36000 - heather infusion flowers (efsa foodex2)",
    "FOODON_03305709": "wedding cake",
    "FOODON_03315810": "beverage mix for addition to milk (flavored)",
    "FOODON_03303892": "potato croquette",
    "FOODON_03413930": "canestrini's goby",
    "FOODON_03430135": "semiliquid with smooth consistency",
    "FOODON_03541901": "19010 - deer msm (efsa foodex2)",
    "FOODON_03305995": "onion (boiled, whole, canned)",
    "FOODON_03400669": "002  pome fruits (fp) (ccpr)",
    "UO_0000112": "joule",
    "NCBITaxon_173849": "Paspalum scrobiculatum",
    "FOODON_03315289": "obsolete: beverage fruit",
    "FOODON_03413736": "thailand bamboo plant",
    "UBERON_0002097": "skin of body",
    "FOODON_03307555": "imitation sugar",
    "FOODON_03542703": "27030 - strained yoghurt (efsa foodex2)",
    "FOODON_03542837": "28370 - cheese, nokkelost (efsa foodex2)",
    "FOODON_03540011": "00110 - foxtail amaranth grain (efsa foodex2)",
    "FOODON_03400696": "06  rice and other cereal products (efg)",
    "FOODON_03540775": "07750 - micro-phyte (efsa foodex2)",
    "FOODON_03413429": "rue plant",
    "FOODON_00001825": "durum wheat product catgeory",
    "FOODON_03401864": "10005905 - apricots (gs1 gpc)",
    "FOODON_03303869": "cheese substitute",
    "FOODON_00002335": "vegetable soup food product",
    "FOODON_03311199": "cake (cream-filled)",
    "FOODON_03301694": "canola oil (partially hydrogenated)",
    "FOODON_03308673": "shrimp creole with buttered rice",
    "FOODON_03305811": "suet (raw)",
    "FOODON_00002250": "sodium chloride food product",
    "FOODON_03311082": "cream pie (frozen)",
    "FOODON_03542740": "27400 - miscellaneous fresh uncured cheeses (efsa foodex2)",
    "FOODON_03303056": "apple cider (cherry-flavored)",
    "FOODON_00001109": "caprine dairy food product",
    "FOODON_03304646": "crab (deviled, packed in crab shell)",
    "FOODON_03308272": "sea bream (raw)",
    "NCBITaxon_28503": "Sambucus ebulus",
    "FOODON_00002154": "plant sherbet",
    "FOODON_03541676": "16760 - santols (efsa foodex2)",
    "NCBITaxon_334879": "Sarda australis",
    "FOODON_03309832": "orange (whole, raw)",
    "HANCESTRO_0511": "Mauritian",
    "FOODON_03401424": "10005979 - runner beans (gs1 gpc)",
    "FOODON_00001682": "caramel candy food product",
    "FOODON_03317509": "olive (whole)",
    "CHEBI_13643": "glycol",
    "FOODON_03542992": "29920 - flavoured sugar (efsa foodex2)",
    "NCBITaxon_54477": "Vitex agnus-castus",
    "FOODON_00002454": "food product by quality",
    "CHEBI_26284": "propane-1,2-diols",
    "FOODON_03542546": "25460 - yesso scallop (efsa foodex2)",
    "FOODON_03411723": "chia plant",
    "CHEBI_28659": "phosphorus atom",
    "FOODON_03414681": "australian millet plant",
    "NCBITaxon_30874": "Sillaginidae",
    "FOODON_03540947": "09470 - salted vegetables (efsa foodex2)",
    "FOODON_03510256": "child as food consumer, less than four years",
    "FOODON_03543982": "39820 - risotto (efsa foodex2)",
    "FOODON_03308453": "rainbow trout (raw)",
    "GAZ_00003096": "West Region",
    "FOODON_03542081": "20810 - pig other slaughtering products (efsa foodex2)",
    "FOODON_03401602": "10006065 - sweet cicely (gs1 gpc)",
    "FOODON_03541648": "16480 - table olives and similar- (efsa foodex2)",
    "FOODON_00002174": "powdered milk food product",
    "FOODON_03540022": "00220 - foxtail millet grain (efsa foodex2)",
    "ENVO_01001275": "solid layer",
    "NCBITaxon_44108": "Penaeus notialis",
    "FOODON_03542579": "25790 - bullfrog (efsa foodex2)",
    "HANCESTRO_0510": "Mauritanian",
    "FOODON_03302351": "buttermilk bread",
    "FOODON_03304758": "tamale",
    "CHEBI_86477": "sodium sulfite",
    "FOODON_03413826": "greater lizardfish",
    "FOODON_03301187": "nutmeg seed (whole)",
    "FOODON_03540395": "03950 - rutabaga greens (efsa foodex2)",
    "NCBITaxon_1003877": "Benincaseae",
    "FOODON_03311026": "codfish cooked",
    "FOODON_03420129": "organ meat, cardiovascular system",
    "FOODON_00002922": "red cabbage",
    "FOODON_03400404": "emulsifier (codex)",
    "NCBITaxon_195658": "Trinectes maculatus",
    "FOODON_03542445": "24450 - garfish (efsa foodex2)",
    "CHEBI_63161": "glycosyl compound",
    "FOODON_03530125": "flanchet",
    "FOODON_00001290": "salad dressing",
    "NCBITaxon_62618": "Lepus arcticus",
    "CHEBI_33260": "elemental hydrogen",
    "FOODON_03301513": "chop suey",
    "FOODON_03306415": "squash (canned)",
    "PO_0030110": "pome fruit",
    "FOODON_03302145": "chicken-flavored bouillon (powdered or granulated)",
    "FOODON_03400792": "egg dish (eurofir)",
    "FOODON_00001314": "fermented meat product",
    "FOODON_03541619": "16190 - black mulberries (efsa foodex2)",
    "FOODON_03315720": "vegetable protein, hydrolyzed",
    "FOODON_03413993": "pintadilla",
    "FOODON_03307366": "grain vinegar",
    "FOODON_03412695": "hare",
    "FOODON_00003240": "tartiflette",
    "FOODON_00002121": "pineapple preserve or jam",
    "FOODON_03306937": "sweet mustard pickle",
    "FOODON_03530215": "obsolete: production environment not known",
    "NCBITaxon_274692": "Sebastidae",
    "FOODON_03310680": "beef round roast (boneless, raw)",
    "NCBITaxon_445213": "Pleoticus muelleri",
    "FOODON_03401043": "10000027 - milk/milk substitutes (frozen) (gs1 gpc)",
    "FOODON_03311672": "radish root (japanese)",
    "CHEBI_33913": "corrinoid",
    "FOODON_00002413": "bean flour",
    "FOODON_03401158": "10000152 - aquatic plants prepared/processed (perishable) (gs1 gpc)",
    "FOODON_03401111": "10000612 - snacks variety packs (gs1 gpc)",
    "NCBITaxon_93934": "Coturnix japonica",
    "FOODON_03401212": "in brine",
    "FOODON_03317070": "fruit kisiels dessert concentration",
    "FOODON_03400176": "chewing gum (us cfr)",
    "FOODON_03540626": "06260 - pigeon peas (with pods) (efsa foodex2)",
    "FOODON_03305750": "pineapple juice (canned)",
    "FOODON_03307080": "fruit (concentrated)",
    "FOODON_03411773": "yelloweye rockfish",
    "NCBITaxon_42529": "Piaractus brachypomus",
    "FOODON_03305119": "candy made with alcohol",
    "HANCESTRO_0578": "Hui Chinese",
    "NCBITaxon_28528": "Pinus mugo",
    "FOODON_03306298": "manicotti macaroni",
    "FOODON_03541401": "14010 - west indian vanilla (efsa foodex2)",
    "FOODON_03316637": "food (ready-to-cook)",
    "FOODON_03490195": "container or wrapping by form",
    "NCBITaxon_660624": "Jasminum sambac",
    "NCIT_C944": "Vitamin",
    "FOODON_03412650": "goatfish",
    "FOODON_00003007": "saskatoon berry",
    "FOODON_03413659": "northern blue mussel",
    "FOODON_03310818": "sour half and half dressing",
    "FOODON_03310616": "beef pot pie",
    "NCBITaxon_83875": "Trachurus japonicus",
    "FOODON_03415123": "felwort plant",
    "FOODON_03540251": "02510 - profiterole (efsa foodex2)",
    "FOODON_03310605": "cow buttermilk (pasteurized high-temperature short-time)",
    "NCBITaxon_482916": "Sphoeroides maculatus",
    "FOODON_03490188": "plastic container, rigid or semirigid, aluminum lid",
    "NCBITaxon_58041": "Pinus cembra",
    "FOODON_03308130": "clam (baby, raw)",
    "FOODON_03317558": "bitter soda",
    "FOODON_03310998": "walnut meat",
    "FOODON_03542563": "25630 - squid, european flying (efsa foodex2)",
    "FOODON_03310730": "blackberry wine",
    "FOODON_03303029": "chicken wing (raw)",
    "FOODON_03311274": "bluefish fillet (cooked)",
    "FOODON_03308579": "japanese crabmeat",
    "FOODON_00002494": "narangilla food product",
    "FOODON_03543864": "38640 - seafood-based meals (efsa foodex2)",
    "NCBITaxon_7805": "Carcharhinidae",
    "FOODON_03317577": "obsolete: skim milk (sterilized)",
    "HANCESTRO_0431": "Algerian",
    "CHEBI_46686": "azaalkane",
    "FOODON_03543352": "33520 - wine, ros\u00e9 (efsa foodex2)",
    "FOODON_03317194": "bakery product (fine)",
    "FOODON_03316265": "jelly dessert",
    "FOODON_00003053": "chocolate mousse",
    "FOODON_03309318": "common whitefish fillet (raw)",
    "FOODON_03305088": "lemon-flavored beverage carbonated",
    "GAZ_00024383": "Java",
    "FOODON_03541145": "11450 - macadamias and similar- (efsa foodex2)",
    "FOODON_03414314": "yellow onion plant",
    "FOODON_03317535": "citrus peel glace",
    "FOODON_03316279": "fish product (pickled)",
    "NCBITaxon_125896": "Ibacus",
    "FOODON_03301805": "salmon (smoked)",
    "FOODON_03307452": "ocean perch fish stick (frozen)",
    "FOODON_03543556": "35560 - wild strawberry infusion leaves (efsa foodex2)",
    "FOODON_03307474": "kelp relish",
    "FOODON_03401435": "10006432 - elderberries (gs1 gpc)",
    "FOODON_03543498": "34980 - gymnema infusion leaves (efsa foodex2)",
    "FOODON_03411379": "field corn plant",
    "FOODON_03411307": "hog plum plant",
    "FOODON_03302651": "whole wheat cracker",
    "FOODON_00002744": "food (roasted)",
    "NCBITaxon_184140": "Sechium edule",
    "FOODON_03420276": "calyx",
    "FOODON_03541939": "19390 - rabbit fresh meat (efsa foodex2)",
    "ENVO_01000575": "wax",
    "FOODON_03401649": "10005785 - veal - prepared/processed (gs1 gpc)",
    "FOODON_03304744": "meat tenderizer (salt-free, frozen)",
    "FOODON_03304384": "sweetened condensed milk",
    "FOODON_03543702": "37020 - coffee espresso (beverage) (efsa foodex2)",
    "FOODON_03543092": "30920 - animal and vegetable fats/oils (efsa foodex2)",
    "FOODON_03413740": "andean potato plant",
    "NCBITaxon_314293": "Simiiformes",
    "FOODON_03541243": "12430 - maripa palm kernels (efsa foodex2)",
    "HANCESTRO_0409": "French Guianese",
    "NCBITaxon_89946": "Merluccius australis",
    "FOODON_03306711": "chocolate-covered cookie",
    "FOODON_03540829": "08290 - chives (efsa foodex2)",
    "FOODON_03541839": "18390 - fruit compote, sweet cherry (efsa foodex2)",
    "FOODON_03541091": "10910 - lentils (dry) and similar- (efsa foodex2)",
    "FOODON_03315876": "lobster (frozen)",
    "CHEBI_33672": "heterobicyclic compound",
    "FOODON_03312033": "pastry (filled)",
    "NCBITaxon_137457": "Sanguisorba officinalis",
    "FOODON_03510023": "dietary claim or use",
    "FOODON_03540645": "06450 - gojiberry (efsa foodex2)",
    "FOODON_03530016": "canner grade",
    "NCBITaxon_173324": "Elagatis bipinnulata",
    "NCBITaxon_307728": "Opuntia polyacantha",
    "FOODON_00001174": "plant lipid food product",
    "FOODON_03413837": "european anchovy",
    "FOODON_03430101": "medium ground and sifted (bolted)",
    "FOODON_03310007": "romadur cheese",
    "NCBITaxon_206137": "Pinguipedidae",
    "FOODON_03470133": "spray-drying",
    "GENEPIO_0001342": "data standard component",
    "FOODON_03412574": "crangonid shrimp family",
    "FOODON_03310649": "fruit puree",
    "GAZ_00002580": "State of Texas",
    "FOODON_03543572": "35720 - gingko infusion material (efsa foodex2)",
    "FOODON_03301027": "honey extract",
    "FOODON_03317213": "low sodium food",
    "FOODON_03541792": "17920 - mixed dried fruits (efsa foodex2)",
    "NCBITaxon_183652": "Peprilus",
    "NCBITaxon_64467": "Penaeus semisulcatus",
    "NCBITaxon_9892": "Giraffidae",
    "CHEBI_17593": "maltooligosaccharide",
    "NCBITaxon_1489905": "Carangaria incertae sedis",
    "FOODON_03400274": "meal replacement (us cfr)",
    "FOODON_03542610": "26100 - fish and seafood processed (efsa foodex2)",
    "FOODON_03401125": "50122000 - aquatic invertebrates - prepared/processed (gs1 gpc)",
    "FOODON_03542023": "20230 - wild boar liver (efsa foodex2)",
    "FOODON_03316098": "sugar confectionery",
    "FOODON_03305604": "herbal candy",
    "FOODON_03304051": "seafood sauce",
    "FOODON_03413225": "propane-1,2-diol alginate",
    "FOODON_03302463": "whole wheat kernel (raw)",
    "FOODON_03414590": "african forest elephant",
    "FOODON_03400877": "10000142 - alcohol making kits (gs1 gpc)",
    "FOODON_00003310": "rawhide dog chew",
    "FOODON_03400979": "obsolete: 10000046 - chocolate/sugar candy combination - confectionery (gs1 gpc)",
    "NCBITaxon_4447": "Liliopsida",
    "FOODON_03541767": "17670 - sweetsops (efsa foodex2)",
    "FOODON_03309838": "peanut meal (deoiled)",
    "FOODON_03411424": "obsolete: blue pike",
    "FOODON_03400226": "brittle (us cfr)",
    "NCBITaxon_4550": "Secale cereale",
    "FOODON_03302766": "cake decoration",
    "FOODON_03401283": "USDA SR beef products (1300)",
    "FOODON_03411732": "new zealand spinach plant",
    "FOODON_03400418": "food preservative (codex)",
    "FOODON_03303342": "custard pastry filling",
    "FOODON_03310815": "soft drink",
    "NCBITaxon_6687": "Penaeus monodon",
    "FOODON_03412129": "elephant",
    "FOODON_03530214": "hydroponic cultivation",
    "FOODON_03301114": "ham (cured)",
    "FOODON_03542942": "29420 - ice cream, milk-imitate based (efsa foodex2)",
    "NCBITaxon_68510": "Aulopiformes",
    "FOODON_03544309": "43090 - mango flavour (efsa foodex2)",
    "FOODON_03400756": "055  dried fruits (df) (ccpr)",
    "GAZ_00002937": "Finland",
    "FOODON_03542859": "28590 - cheese, tronchon (efsa foodex2)",
    "NCBITaxon_69676": "Lottiidae",
    "NCBITaxon_186622": "Acipenseroidei",
    "FOODON_03543406": "34060 - coffee beans, green (efsa foodex2)",
    "NCBITaxon_307031": "Crangon franciscorum",
    "NCBITaxon_4328": "Proteaceae",
    "FOODON_03411825": "common snook",
    "NCBITaxon_35492": "Chlorophyta incertae sedis",
    "NCBITaxon_173078": "Arca zebra",
    "FOODON_03530068": "grade r, europe",
    "NCBITaxon_77594": "Gobius cobitis",
    "FOODON_00003039": "roman chamomile",
    "FOODON_03302825": "brownie fudge cookie",
    "NCBITaxon_1489907": "Carangiformes",
    "HANCESTRO_0317": "Erasmus Rucphen",
    "FOODON_03317663": "chocolate concentrate drink (food product)",
    "NCBITaxon_390297": "Agonostomus",
    "FOODON_03304574": "orange-flavored beverage base",
    "NCBITaxon_558553": "Crassostrea angulata",
    "FOODON_03316671": "cream (pasteurized, whipped)",
    "NCBITaxon_219121": "Cichorieae",
    "NCBITaxon_4930": "Saccharomyces",
    "CHEBI_46648": "nitrite salt",
    "FOODON_03400777": "eurofir food classification",
    "FOODON_03315310": "gelatin dessert mix artificially sweetened",
    "FOODON_03413715": "annual sowthistle plant",
    "FOODON_03316361": "coating cream for bakery product",
    "FOODON_03308679": "fish tail (raw)",
    "FOODON_03309280": "squid (giant, raw)",
    "CHEBI_35310": "carotenone",
    "HANCESTRO_0540": "Malawian",
    "NCBITaxon_6675": "Cirripedia",
    "FOODON_03411970": "northern shrimp",
    "FOODON_03305658": "cherry (sulfured)",
    "NCBITaxon_50225": "Taraxacum officinale",
    "FOODON_03544186": "41860 - apple flavour (efsa foodex2)",
    "FOODON_03544005": "40050 - corn semolina based thick soup (efsa foodex2)",
    "FOODON_03412946": "cornelian cherry plant",
    "FOODON_03401862": "10006134 - rhubarb (gs1 gpc)",
    "BFO_0000147": "zero-dimensional continuant fiat boundary",
    "FOODON_03412740": "saffron milkcap",
    "FOODON_03308629": "shellfish (raw, frozen)",
    "FOODON_03540423": "04230 - purple amaranth leaves (efsa foodex2)",
    "FOODON_03315921": "fat emulsion",
    "NCBITaxon_8032": "Salmo trutta",
    "FOODON_03301732": "granular cheese",
    "FOODON_00001570": "rolled grain",
    "FOODON_03544045": "40450 - mixed cereal-based snacks (efsa foodex2)",
    "FOODON_03543943": "39430 - pizza and similar with cheese, and mushrooms (efsa foodex2)",
    "FOODON_00003080": "Dioscorea japonica",
    "FOODON_03304759": "carrot (frozen)",
    "HANCESTRO_0474": "Niuean",
    "FOODON_03310959": "roast beef (frozen)",
    "NCBITaxon_7936": "Anguilla anguilla",
    "FOODON_03301804": "fig (whole, raw)",
    "FOODON_03304920": "beef-flavored noodle soup",
    "FOODON_03490405": "polyethylene - regenerated cellulose container",
    "FOODON_03302447": "egg butter",
    "FOODON_03317204": "nonnutritive sweetener concentrate, tablet form",
    "NCBITaxon_3716": "Brassica oleracea var. capitata",
    "ENVO_01001790": "terrestrial ecosystem",
    "FOODON_03304381": "cow milk (modified)",
    "FOODON_03414727": "waterlily plant",
    "FOODON_03316672": "fungus (pickled)",
    "FOODON_03315192": "cheese spread pasteurized",
    "NCBITaxon_58039": "Juniperus communis",
    "FOODON_03310644": "chicken parts (marinated, raw)",
    "FOODON_03543625": "36250 - lime infusion flowers (efsa foodex2)",
    "CHEBI_38166": "organic heteropolycyclic compound",
    "FOODON_03301771": "veal (raw)",
    "NCBITaxon_4740": "Commelinaceae",
    "FOODON_00003367": "food (adulterated)",
    "FOODON_03414355": "tankan mandarin plant",
    "FOODON_00003316": "giraffe",
    "ENVO_00003040": "animal house",
    "CHEBI_22715": "benzimidazoles",
    "FOODON_03316309": "capsules based on gelatin",
    "FOODON_03540733": "07330 - other urtica roots (efsa foodex2)",
    "FOODON_03542896": "28960 - cheese, comte (efsa foodex2)",
    "FOODON_03490398": "polyethylene (high density) - polypropylene container",
    "NCBITaxon_24079": "Bignoniaceae",
    "UBERON_0019248": "early embryo",
    "FOODON_03411509": "reindeer",
    "FOODON_03450038": "food reheating by microwave",
    "FOODON_03414220": "galia melon plant",
    "FOODON_03316958": "noodle (egg, vegetable)",
    "FOODON_03309065": "fish fillet (breaded)",
    "FOODON_03302692": "italian bread",
    "FOODON_03307631": "potato (sliced, raw)",
    "FOODON_03490263": "tin solder",
    "NCBITaxon_186625": "Clupeocephala",
    "FOODON_03302327": "shortbread cookie",
    "FOODON_03307085": "raspberry spread with cognac",
    "FOODON_03302914": "skim milk cheese",
    "IAO_0000125": "pending final vetting",
    "CHEBI_27732": "caffeine",
    "FOODON_03540201": "02010 - naturally leavened bread dough (efsa foodex2)",
    "FOODON_03412329": "mafurra plant",
    "FOODON_03520140": "atlantic, southeast (fao major fishing area 47)",
    "HANCESTRO_0526": "Burundian",
    "CHEBI_33579": "main group molecular entity",
    "FOODON_00001315": "nham",
    "FOODON_03412894": "white warehou",
    "FOODON_03414781": "cheesewood plant",
    "FOODON_03315768": "cereal product (solid, infant)",
    "FOODON_00002680": "mahi mahi fillet",
    "FOODON_03400628": "CCFAC edible ices, including sherbet and sorbet",
    "FOODON_03543655": "36550 - asian ginseng infusion roots (efsa foodex2)",
    "FOODON_03460280": "obsolete: sugar syrup or sugar syrup solids added",
    "FOODON_03315530": "fish product (deep-frozen)",
    "FOODON_03309600": "mint candy (artificially sweetened)",
    "IAO_0000002": "example to be eventually removed",
    "FOODON_03401591": "10006057 - lovage (gs1 gpc)",
    "FOODON_03306876": "duck (canned)",
    "FOODON_03411097": "pot marjoram plant",
    "FOODON_03306529": "onion base (food product)",
    "FOODON_03400758": "057 dried herbs (dh) (ccpr)",
    "FOODON_03544453": "44530 - live microorganisms for food production (efsa foodex2)",
    "NCBITaxon_46104": "Salicornia",
    "FOODON_03305682": "cow milk (sterilized, long-life, nonrefrigerated)",
    "FOODON_03544386": "43860 - sweet and sour flavour (efsa foodex2)",
    "FOODON_03400850": "liqueur or spirits (eurofir)",
    "FOODON_03301578": "vegetable (leafy, raw)",
    "NCBITaxon_1412984": "Brama dussumieri",
    "FOODON_03411731": "nalta jute plant",
    "FOODON_03311408": "chipped beef (smoked)",
    "FOODON_03304851": "citron melon jam (food product)",
    "CHEBI_5291": "gelatin",
    "FOODON_03400197": "fruit spread or sauce (us cfr)",
    "FOODON_03400419": "formulation agent (codex)",
    "HANCESTRO_0530": "Ivoirian",
    "GAZ_00002950": "Bulgaria",
    "NCBITaxon_214912": "Sterculioideae",
    "FOODON_03306299": "obsolete: macaroni from non-fat milk enriched",
    "FOODON_03301273": "clingstone peach (canned)",
    "CHEBI_16811": "methionine",
    "FOODON_03544164": "41640 - oat starch (efsa foodex2)",
    "FOODON_03307945": "macaroni (corn, soy and wheat)",
    "GAZ_00001086": "Democratic Republic of the Congo",
    "FOODON_03460216": "vitamin B",
    "NCBITaxon_7849": "Lamna nasus",
    "FOODON_03302493": "bread stuffing (unprepared, seasoned with herbs)",
    "NCBITaxon_489417": "Tordylium apulum",
    "FOODON_00001965": "icing or frosting food product",
    "NCBITaxon_195639": "Psettichthys melanostictus",
    "FOODON_03302621": "farina",
    "FOODON_03411437": "sablefish",
    "FOODON_03306779": "pie (frozen)",
    "FOODON_03544493": "44930 - iron (efsa foodex2)",
    "FOODON_03301005": "spaghetti macaroni",
    "FOODON_00001190": "rye food product",
    "FOODON_03543005": "30050 - sugar beet molasses (efsa foodex2)",
    "FOODON_03411406": "cabbage plant",
    "FOODON_03490200": "tube",
    "FOODON_03413615": "pelagic red crab",
    "PO_0020046": "palmate leaf",
    "FOODON_03317037": "dessert (no added sugar, flavored, water-based)",
    "FOODON_03541595": "15950 - cranberries (efsa foodex2)",
    "FOODON_03317059": "sandwich spread (with no added sugar, milk-based)",
    "FOODON_03301528": "nutmeg seed (ground)",
    "IAO_0000100": "data set",
    "NCBITaxon_23121": "Pittosporaceae",
    "NCBITaxon_31090": "Hiodontidae",
    "FOODON_03315431": "confection (masticatory)",
    "FOODON_03412659": "fleawort plant",
    "FOODON_03400186": "hard cheese (us cfr)",
    "FOODON_03542709": "27090 - l\u00e5ngfil (efsa foodex2)",
    "FOODON_03541442": "14420 - trifoliate oranges (efsa foodex2)",
    "FOODON_03541536": "15360 - muscadine grapes (efsa foodex2)",
    "NCBITaxon_89151": "Musa x paradisiaca",
    "FOODON_03411809": "flathead family",
    "FOODON_00001252": "animal derived beverage",
    "NCBITaxon_106221": "Arcoidea",
    "FOODON_03401761": "10005957 - sweet pitayas (gs1 gpc)",
    "UO_0000009": "kilogram",
    "FOODON_03305810": "mincemeat",
    "FOODON_03541022": "10220 - legumes fresh seeds (beans, peas etc.) (efsa foodex2)",
    "FOODON_03540178": "01780 - fresh pasta (efsa foodex2)",
    "FOODON_03309555": "mushroom (creamed)",
    "FOODON_03401140": "50121900 - fish - prepared/processed (gs1 gpc)",
    "FOODON_03414619": "monitor lizard",
    "FOODON_03520361": "indian ocean islands",
    "CHEBI_52632": "potassium-39 atom",
    "FOODON_03401765": "10005901 - japanese medlars (gs1 gpc)",
    "FOODON_03301757": "rhubarb jam",
    "FOODON_03307133": "olive (ripe, in brine)",
    "FOODON_03413512": "gummy shark",
    "FOODON_03490264": "ceramic or earthenware bottle, coloured",
    "NCBITaxon_13718": "Tetrapturus",
    "FOODON_03490140": "glass container, plastic lid, aluminum foil lining",
    "FOODON_03411141": "white pepper plant",
    "GENEPIO_0000106": "draft data standard",
    "FOODON_03411247": "caper plant",
    "NCBITaxon_8262": "Pleuronectes platessa",
    "FOODON_03411662": "damson plum plant",
    "FOODON_03307048": "shrimp cocktail (curried, canned)",
    "FOODON_00001595": "animal based refined or partially-refined food product",
    "FOODON_03542314": "23140 - smelt, european (efsa foodex2)",
    "FOODON_03542952": "29520 - duck eggs (efsa foodex2)",
    "NCBITaxon_7991": "Characiformes",
    "FOODON_03413949": "biglip grunt",
    "FOODON_03412262": "oregano, mexican (plant)",
    "FOODON_03543376": "33760 - punch (efsa foodex2)",
    "FOODON_03316948": "macaroni product (enriched)",
    "FOODON_03460760": "food animal rendering",
    "FOODON_03530205": "obsolete: maturity or ripeness unknown",
    "FOODON_03413714": "shepherd's needle plant",
    "FOODON_03415164": "tobacco root plant",
    "NCBITaxon_182852": "Raja asterias",
    "FOODON_03400666": "18  manufactured food (single-ingredient) of animal origin (ccpr)",
    "FOODON_03542482": "24820 - other fish offal (efsa foodex2)",
    "FOODON_03414328": "narrowfruit cornsalad plant",
    "FOODON_03401562": "10006079 - head lettuce (butterhead) (gs1 gpc)",
    "NCBITaxon_33533": "Chelidonichthys",
    "FOODON_03542068": "20680 - turkey edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "FOODON_03302216": "carrot (whole, canned)",
    "FOODON_03543824": "38240 - other common supplements (efsa foodex2)",
    "FOODON_03302013": "food containing alcohol",
    "FOODON_03412551": "arbol pepper plant",
    "FOODON_03543976": "39760 - rice, fish/seafood and vegetable based dishes (efsa foodex2)",
    "FOODON_03412022": "inky cap mushroom",
    "FOODON_03306790": "hard grating cheese blend (grated)",
    "FOODON_03413709": "corn poppy plant",
    "FOODON_03543653": "36530 - ginseng and similar- (efsa foodex2)",
    "FOODON_03541727": "17270 - green sapotes (efsa foodex2)",
    "FOODON_00001241": "processed pork meat food product",
    "FOODON_03302164": "imitation cherry cola",
    "FOODON_03414907": "canary grass plant",
    "FOODON_03490229": "thermoplastic adhesive",
    "NCBITaxon_3683": "Passifloraceae",
    "FOODON_03311697": "crabmeat (processed)",
    "NCBITaxon_38869": "Salvia sclarea",
    "CHEBI_33709": "amino acid",
    "FOODON_03413299": "tara gum",
    "FOODON_03316434": "sweetener tablets, artificial",
    "FOODON_03412881": "comb penshell",
    "FOODON_03490300": "laminated aluminum combination with paper",
    "FOODON_03400896": "10000119 - fruit herbal infusions - bags/loose (gs1 gpc)",
    "FOODON_03542687": "26870 - flavoured whey (efsa foodex2)",
    "NCBITaxon_303741": "Sphoeroides spengleri",
    "FOODON_03305977": "macaroon",
    "FOODON_00002591": "Merlot grape plant",
    "FOODON_03400804": "seafood dish (eurofir)",
    "FOODON_03542640": "26400 - other smoked fishes (efsa foodex2)",
    "FOODON_03414065": "lake trout (brown trout variety)",
    "FOODON_03520405": "tropical reef fishing area",
    "UO_0000022": "milligram",
    "FOODON_03316707": "cocoa butter confectionery",
    "FOODON_03303401": "chewing gum (sugarless)",
    "GAZ_00000562": "Tunisia",
    "FOODON_03411071": "black walnut tree",
    "FOODON_03412521": "blewit",
    "FOODON_03414254": "yam bean plant",
    "FOODON_03542847": "28470 - cheese, saint nectaire (efsa foodex2)",
    "FOODON_03414075": "devil anglerfish",
    "FOODON_03543464": "34640 - bilberry infusion leaves (efsa foodex2)",
    "FOODON_03541618": "16180 - white mulberries (efsa foodex2)",
    "FOODON_03541232": "12320 - other seeds (including elsewhere non-listed oilseeds and other seeds) (efsa foodex2)",
    "FOODON_03305891": "apple and honey jelly",
    "FOODON_03401104": "10000262 - soups - prepared (shelf stable) (gs1 gpc)",
    "CHEBI_2509": "agar",
    "FOODON_03400232": "mellorine (us cfr)",
    "FOODON_03413732": "taiwan giant bamboo plant",
    "NCBITaxon_438424": "Limnophila aromatica",
    "FOODON_00002762": "bean (cooked)",
    "FOODON_03411877": "atlantic halibut",
    "FOODON_00001246": "hot chocolate food product",
    "FOODON_03305899": "jelly roll",
    "NCBITaxon_270604": "Osphronemus goramy",
    "FOODON_03317009": "powdered milk with flavoring",
    "FOODON_03490131": "plastic tray or pan, cardboard cover",
    "NCBITaxon_294125": "Palaemon vulgaris",
    "FOODON_03302319": "hamburger bun",
    "FOODON_03305077": "beet slices with garlic (pickled)",
    "FOODON_03401440": "10005934 - jostaberries (gs1 gpc)",
    "FOODON_03540055": "00550 - other species of genus sorghum, not elsewhere mentioned (efsa foodex2)",
    "FOODON_03450008": "griddle cooking",
    "GAZ_00006910": "Samoa",
    "FOODON_03413352": "norway haddock",
    "FOODON_03304641": "chocolate-covered wafer (egg-shaped)",
    "FOODON_03542915": "29150 - cheese, monje picon (efsa foodex2)",
    "FOODON_03490321": "casein resin",
    "FOODON_03306564": "onion and lox mixture (precooked, frozen)",
    "FOODON_03308559": "salmon trout (raw)",
    "FOODON_03542663": "26630 - zebu milk (efsa foodex2)",
    "FOODON_03540542": "05420 - cardoons (efsa foodex2)",
    "UO_0010040": "teaspoon",
    "FOODON_03542712": "27120 - flavoured traditional sour milk products (efsa foodex2)",
    "FOODON_00001214": "candy food product",
    "FOODON_03412333": "red clover plant",
    "FOODON_03308020": "mullet (raw)",
    "FOODON_03305222": "fruit mix",
    "FOODON_03401244": "0630000 - herbal infusions (ec)",
    "GAZ_00004942": "Georgia",
    "FOODON_03412283": "red porgy",
    "FOODON_03541284": "12840 - flowers or parts of flower used as spices or similar (efsa foodex2)",
    "FOODON_03460162": "calcium added",
    "FOODON_03401259": "1020000 - milk and milk products (ec)",
    "FOODON_03542466": "24660 - fish liver (efsa foodex2)",
    "FOODON_00001880": "frozen nondairy dessert food product",
    "NCBITaxon_41241": "Rumex acetosa",
    "FOODON_03304399": "condensed cow skim milk",
    "CHEBI_26214": "porphyrins",
    "FOODON_03315569": "filling mix, dry",
    "FOODON_03315590": "lumpfish roe",
    "NCBITaxon_306578": "Epinephelus chlorostigma",
    "FOODON_03540745": "07450 - rampion roots (efsa foodex2)",
    "FOODON_00001635": "bean food product",
    "FOODON_03304709": "salad dressing (dry)",
    "HANCESTRO_0543": "Nigerien",
    "FOODON_03420144": "plant above surface, excluding fruit and seed",
    "FOODON_03411428": "dandelion plant",
    "FOODON_03317362": "beet sugar juice",
    "FOODON_03540919": "09190 - evening primrose leaves (efsa foodex2)",
    "FOODON_03311465": "protein food analog",
    "FOODON_03303013": "turkey pot pie (frozen)",
    "FOODON_03411880": "fantail sole",
    "FOODON_03530165": "alcohol content (eurocode2)",
    "FOODON_03413474": "crucian carp",
    "HANCESTRO_0537": "Guinean",
    "FOODON_03430124": "sliced, thick, between 0.5 and 1.5 cm.",
    "FOODON_03311316": "beef hash (barbequed)",
    "FOODON_03541350": "13500 - liquorice roots (efsa foodex2)",
    "FOODON_03412867": "grass carp",
    "FOODON_03305958": "currant jelly",
    "FOODON_03543448": "34480 - tea extract (powder) decaffeinated (efsa foodex2)",
    "CHEBI_61466": "polydimethylsiloxane polymer",
    "FOODON_03306772": "cream pie made with synthetic topping or filling",
    "FOODON_03541920": "19200 - buffalo, african fresh meat (efsa foodex2)",
    "PO_0025339": "plant organ development stage",
    "NCBITaxon_28381": "Sardinops sagax",
    "CHEBI_18186": "tyrosine",
    "FOODON_03540186": "01860 - fresh stuffed egg pasta (efsa foodex2)",
    "FOODON_03400717": "27  fish and seafood (efg)",
    "FOODON_03311808": "sausage crumbles with pepperoni flavoring frozen",
    "CEPH_0000256": "tentacle",
    "NCBITaxon_151436": "Prunus maritima",
    "FOODON_03543934": "39340 - pizza and similar with meat, and vegetables (efsa foodex2)",
    "FOODON_03411127": "black mustard plant",
    "CHEBI_35350": "hydroxy steroid",
    "FOODON_03480017": "packed in water",
    "FOODON_03413471": "black fonio plant",
    "CHEBI_23818": "dimethylxanthine",
    "FOODON_00002371": "yellowfin tuna food product",
    "FOODON_03412035": "basidiomycetes",
    "FOODON_00003403": "common bean seed",
    "FOODON_03413034": "calcium diglutamate",
    "FOODON_03412586": "mola family",
    "HANCESTRO_0484": "Wallis and Futuna Islander",
    "FOODON_03315694": "dressing (unstandardized)",
    "FOODON_03316575": "cream jelly (with a low sugar content)",
    "FOODON_03540631": "06310 - solanacea (efsa foodex2)",
    "FOODON_03490287": "aluminum box",
    "FOODON_00001259": "non-fruit wine food product",
    "FOODON_03413538": "red abalone",
    "FOODON_03414367": "mallard",
    "NCBITaxon_372806": "Pseudocaranx chilensis",
    "FOODON_03530290": "orange flesh",
    "FOODON_00002510": "burrito",
    "FOODON_00002011": "lumpfish food product",
    "FOODON_00002859": "partly hydrogenated oil",
    "FOODON_03414136": "black stone crab",
    "FOODON_03305674": "ice cream bar (chocolate-covered)",
    "FOODON_03401431": "10005929 - blueberries (gs1 gpc)",
    "FOODON_03540796": "07960 - pom-pom blancs (efsa foodex2)",
    "FOODON_03542590": "25900 - turtle, snapping (efsa foodex2)",
    "FOODON_00002855": "vegetable oil (hydrogenated)",
    "FOODON_03400204": "candy (us cfr)",
    "FOODON_03401690": "10005835 - lamb/mutton sausages - prepared/processed (gs1 gpc)",
    "FOODON_03540182": "01820 - dried egg pasta (efsa foodex2)",
    "FOODON_03543875": "38750 - cheese omelette (efsa foodex2)",
    "FOODON_03414118": "shortnose spurdog",
    "FOODON_03412517": "oriental cashew plant",
    "FOODON_00001169": "cruciferous food product",
    "FOODON_00002295": "surfclam food product",
    "FOODON_03305306": "ginger (green)",
    "FOODON_03414163": "eared seal family",
    "FOODON_03309360": "pine nut (whole, raw, shell off)",
    "FOODON_00001978": "jelly condiment",
    "FOODON_03310596": "coffee bean (green, decaffeinated)",
    "UO_0010043": "australian metric tablespoon",
    "FOODON_03413029": "calcium ascorbate",
    "NCBITaxon_53922": "Senna",
    "FOODON_03310047": "coconut meal",
    "FOODON_03310106": "radish leaf (raw)",
    "FOODON_03414560": "mooneye family",
    "FOODON_03540637": "06370 - oxheart tomato (efsa foodex2)",
    "NCBITaxon_418454": "Protosalanx hyalocranius",
    "FOODON_03411960": "edible rock crab",
    "FOODON_03306839": "whey (swiss liquid)",
    "FOODON_03540848": "08480 - water dock (efsa foodex2)",
    "FOODON_03541366": "13660 - other root and rhizome spices (efsa foodex2)",
    "FOODON_03543056": "30560 - hard candies (efsa foodex2)",
    "FOODON_03540573": "05730 - kohlrabies (efsa foodex2)",
    "FOODON_00002611": "Prosecco wine",
    "FOODON_03413794": "chinese truffle",
    "FOODON_03317403": "fish (unprocessed, deep-frozen)",
    "FOODON_03315873": "chili pepper",
    "FOODON_03310195": "dextrose (liquid)",
    "FOODON_03401085": "10000300 - dough based products / meals - not ready to eat - savoury (perishable) (gs1 gpc)",
    "CHEBI_36360": "phosphorus oxoacids and derivatives",
    "FOODON_03311099": "pork chow mein",
    "NCBITaxon_76442": "Fimbristylis",
    "FOODON_03412375": "weakfish",
    "FOODON_03540916": "09160 - stevia (efsa foodex2)",
    "FOODON_03401389": "50262300 - succulent (gs1 gpc)",
    "ENVO_00003064": "drinking water",
    "FOODON_03303764": "hard candy (fruit-flavored)",
    "FOODON_00003183": "jojoba bean (whole, dried)",
    "FOODON_03543537": "35370 - red clover infusion leaves (efsa foodex2)",
    "FOODON_03310646": "legume (whole)",
    "FOODON_03309029": "bonito (packed in oil, canned)",
    "RO_0002163": "spatially disjoint from",
    "FOODON_03307276": "imitation colby cheese",
    "FOODON_03543355": "33550 - red or ros\u00e9 sparkling wine (efsa foodex2)",
    "FOODON_03541571": "15710 - aronia berries (black) (efsa foodex2)",
    "FOODON_00002540": "a\u00f1ejo cheese",
    "CHEBI_49105": "thiamine hydrochloride",
    "FOODON_03543348": "33480 - wine and wine-like drinks (efsa foodex2)",
    "FOODON_03412441": "crocodile",
    "FOODON_03306935": "hot dog relish",
    "FOODON_03411274": "cumin plant",
    "FOODON_03306812": "peas (whole, rehydrated, canned)",
    "FOODON_00002972": "Tango apple tree",
    "FOODON_03400273": "poultry or poultry product (us cfr)",
    "FOODON_03543380": "33800 - spirits not from fruit (efsa foodex2)",
    "FOODON_03411153": "redfish or ocean perch",
    "FOODON_03411019": "lingonberry plant",
    "FOODON_03303664": "limburger cheese",
    "FOODON_03411632": "oyster mushroom genus",
    "FOODON_03411950": "european lobster",
    "FOODON_03315795": "ham (prepared)",
    "CHEBI_38263": "2-amino-3-hydroxybutanoic acid",
    "FOODON_03540008": "00080 - buckwheat and other pseudo-cereals and similar- (efsa foodex2)",
    "FOODON_03543118": "31180 - shea butter (efsa foodex2)",
    "FOODON_03301852": "turnip greens (leaf and stem, raw)",
    "NCBITaxon_4571": "Triticum turgidum",
    "FOODON_03540085": "00850 - spelt flour, refined (efsa foodex2)",
    "FOODON_03317288": "pie (baked)",
    "FOODON_03304447": "beef jardiniere mix (dry)",
    "FOODON_03541960": "19600 - rat meat (efsa foodex2)",
    "FOODON_03412954": "white mulberry plant",
    "FOODON_03310919": "beef (charcoal broiled)",
    "FOODON_03412962": "black salsify plant",
    "FOODON_03541929": "19290 - sheep (adult) fresh meat (efsa foodex2)",
    "NCBITaxon_35973": "Santalum",
    "FOODON_03541733": "17330 - avocados (efsa foodex2)",
    "FOODON_03490118": "paper bag, sack or pouch, foil liner",
    "FOODON_03543336": "33360 - beer, light (efsa foodex2)",
    "FOODON_03510030": "pet bird as consumer",
    "FOODON_03420138": "fruit, peel removed",
    "FOODON_03540906": "09060 - tarragon and similar- (efsa foodex2)",
    "NCBITaxon_98082": "Crangon",
    "CHEBI_31835": "methylparaben",
    "FOODON_00002796": "potato substance",
    "FOODON_03316873": "cheese skim milk for manufacturing",
    "CHEBI_82431": "Cyclamate",
    "FOODON_03315690": "breakfast cereal (dry, malt-flavored)",
    "FOODON_03315709": "confectionery glaze for grain-based snack foods",
    "FOODON_00002847": "demerara sugar",
    "FOODON_03301687": "chocolate-flavored cookie",
    "NCBITaxon_3645": "Bertholletia excelsa",
    "FOODON_03542772": "27720 - cheese, chaource (efsa foodex2)",
    "PATO_0005022": "uniform diameter",
    "CHEBI_37163": "glucan",
    "FOODON_03413860": "japanese sardinella",
    "CHEBI_48199": "sulfamate ester",
    "FOODON_03530134": "marcreuse",
    "NCBITaxon_4668": "Amaryllidaceae",
    "FOODON_03543839": "38390 - imitation cream (efsa foodex2)",
    "NCBITaxon_160705": "Cephalopholis fulva",
    "NCBITaxon_52471": "Ferula assa-foetida",
    "NCBITaxon_227978": "Macrodon ancylodon",
    "FOODON_03542891": "28910 - cheese, schabziger (efsa foodex2)",
    "FOODON_03307426": "sardine in oil",
    "FOODON_03490278": "glass container, coloured",
    "FOODON_00002201": "amphibian or reptile meat food product",
    "NCBITaxon_139271": "Pinus <subgenus>",
    "FOODON_03308550": "scallop (breaded, fried, frozen)",
    "FOODON_03530099": "solid containing small particles (1-4 mm.)",
    "FOODON_00001897": "garbanzo bean (vegetable) food product",
    "FOODON_03414308": "southern meagre",
    "FOODON_03400743": "038 - poultry, edible offal of (po) (ccpr)",
    "FOODON_03305448": "grape beverage (artificially flavored)",
    "FOODON_03311011": "artificial sweetener (liquid concentrate)",
    "NCBITaxon_28806": "Centropomus undecimalis",
    "FOODON_03306204": "roll-in margarine",
    "FOODON_03542794": "27940 - cheese, appenzeller (efsa foodex2)",
    "NCBITaxon_63671": "Turbinidae",
    "FOODON_03306384": "apple jam",
    "FOODON_00003145": "chimichanga",
    "FOODON_03302346": "diabetic bread",
    "FOODON_03543035": "30350 - bitter chocolate (efsa foodex2)",
    "FOODON_03544407": "44070 - wild berry flavour (efsa foodex2)",
    "NCBITaxon_109630": "Todaropsis eblanae",
    "FOODON_03306658": "cooking oil (blended)",
    "FOODON_00002497": "persimmon food product",
    "FOODON_03307672": "peanut butter cup",
    "FOODON_03302824": "chocolate fudge cookie",
    "FOODON_03401137": "10000629 - aquatic invertebrates/fish/shellfish/seafood mixes - unprepared/unprocessed (frozen) (gs1 gpc)",
    "FOODON_03541357": "13570 - greater galangal roots (efsa foodex2)",
    "FOODON_03302464": "sesame egg twist bread",
    "FOODON_03400946": "10000165 - bread (shelf stable) (gs1 gpc)",
    "FOODON_03420203": "obsolete: starch",
    "FOODON_03540967": "09670 - blue taros (efsa foodex2)",
    "FOODON_03543266": "32660 - filtered tap water (efsa foodex2)",
    "FOODON_03307779": "chicken and turkey salad",
    "FOODON_03311786": "peanut butter and chocolate chip cookie dough",
    "FOODON_03414249": "american beech plant",
    "FOODON_03306156": "cherry and apple juice drink",
    "NCBITaxon_6715": "Astacus astacus",
    "FOODON_03306609": "ice cream novelty (chocolate coated)",
    "FOODON_03412813": "paulinia plant",
    "FOODON_03309460": "vegetable soup mix (dried)",
    "FOODON_03542124": "21240 - porchetta (efsa foodex2)",
    "FOODON_03510161": "label claim in food name",
    "FOODON_03412480": "grass shrimp",
    "FOODON_03542072": "20720 - animal other slaughtering products (efsa foodex2)",
    "GAZ_00000555": "North Africa",
    "FOODON_03542875": "28750 - cheese, evora (efsa foodex2)",
    "PO_0004547": "subterranean shoot axis tuber",
    "GAZ_00000560": "Sudan",
    "FOODON_03411017": "oil-producing plant",
    "FOODON_03302597": "mushroom sauce with sliced mushrooms",
    "FOODON_03304261": "beef soup stix (concentrated)",
    "FOODON_03303739": "fruit drop (naturally flavored)",
    "FOODON_03413854": "false herring",
    "FOODON_00003262": "shepherd's pie",
    "FOODON_03542993": "29930 - sugar, icing - powder (efsa foodex2)",
    "FOODON_03306719": "chocolate filling",
    "ENVO_00000114": "agricultural field",
    "FOODON_03305640": "corn meal (degerminated, enriched)",
    "FOODON_03542095": "20950 - horse marrowbone (efsa foodex2)",
    "NCBITaxon_288641": "Metanephrops armatus",
    "FOODON_03413437": "tropical almond plant",
    "NCBITaxon_1489892": "Anabantaria",
    "NCBITaxon_145745": "Althaea officinalis",
    "CHEBI_38260": "pyrrolidines",
    "FOODON_03420164": "part of animal",
    "NCBITaxon_4033": "Oxalidaceae",
    "FOODON_03308613": "atlantic queen crab (raw)",
    "FOODON_03412526": "spiny eel family",
    "FOODON_03305484": "herb (powdered)",
    "FOODON_00003064": "watercress",
    "FOODON_03310170": "seed (treated)",
    "HANCESTRO_0479": "Solomon Islander",
    "FOODON_03306213": "molasses (barbados)",
    "NCBITaxon_7971": "Catostomus commersonii",
    "FOODON_03541117": "11170 - nuts, oilseeds and oilfruits (efsa foodex2)",
    "FOODON_03480010": "packed in vinegar with sugar",
    "FOODON_03400936": "50182100 - biscuits/cookies (gs1 gpc)",
    "FOODON_03307414": "water (carbonated, vitamin c added, bottled)",
    "FOODON_03540704": "07040 - sweet corn and similar- (efsa foodex2)",
    "FOODON_03540776": "07760 - spirulina (efsa foodex2)",
    "PATO_0000387": "soft",
    "FOODON_03544198": "41980 - basil flavour (efsa foodex2)",
    "FOODON_03305385": "fowl (frozen)",
    "FOODON_00001698": "cattle product stew or hash",
    "FOODON_03543781": "37810 - cereals with an added high protein food reconstituted (efsa foodex2)",
    "FOODON_03411325": "beaver",
    "FOODON_03401795": "10006833 - ginseng (gs1 gpc)",
    "FOODON_03542930": "29300 - processed cheese wedges and similar (efsa foodex2)",
    "FOODON_03540229": "02290 - gingerbread dough (efsa foodex2)",
    "FOODON_03306256": "margarine with garlic",
    "FOODON_03310480": "pickle relish",
    "FOODON_00001294": "goat milk cheese (unpasteurized)",
    "FOODON_03401533": "10006229 - dairy/egg based products / meals variety packs (gs1 gpc)",
    "FOODON_03414174": "monkeyhead mushroom",
    "FOODON_03308865": "red spotted snapper (raw)",
    "FOODON_03315676": "lobster paste",
    "FOODON_03301412": "prune butter",
    "FOODON_03304522": "table syrup with 4% wine (food product)",
    "FOODON_03311370": "garlic in oil mixture",
    "FOODON_03540563": "05630 - palm hearts and similar- (efsa foodex2)",
    "FOODON_03401124": "50120000 - seafood (gs1 gpc)",
    "FOODON_03414117": "velvet belly",
    "FOODON_03414623": "snake-necked turtle",
    "FOODON_03470153": "preservation by adding spices or extracts",
    "FOODON_03308518": "inky cap mushroom (raw)",
    "FOODON_03304813": "okra seed press cake",
    "FOODON_03542102": "21020 - chicken, other slaughtering products (efsa foodex2)",
    "FOODON_03412877": "giant stargazer",
    "NCBITaxon_435155": "Harpadon nehereus",
    "FOODON_03302192": "common whitefish (smoked)",
    "FOODON_03310378": "sesame oil press cake",
    "FOODON_00003126": "crab apple plant",
    "FOODON_03411235": "sprat",
    "FOODON_00003177": "Vegegarian burger",
    "FOODON_03302499": "bread (honey meal)",
    "FOODON_03302712": "lemon juice concentrate",
    "FOODON_03315358": "peanut butter (processed)",
    "FOODON_03317653": "cream (thickened)",
    "FOODON_03540884": "08840 - pennyroyal (efsa foodex2)",
    "FOODON_03301677": "crabmeat (frozen)",
    "FOODON_03400000": "obsolete: langual thesaurus root",
    "FOODON_03308198": "creek chub (raw)",
    "FOODON_03544128": "41280 - tzatziki (efsa foodex2)",
    "NCBITaxon_3380": "Gnetum",
    "FOODON_03542121": "21210 - cooked cured (or seasoned) meat (efsa foodex2)",
    "FOODON_03413864": "twaite shad",
    "FOODON_03540781": "07810 - fungi, mosses and lichens (efsa foodex2)",
    "FOODON_03301160": "european lobster (raw)",
    "FOODON_03312034": "churro",
    "FOODON_03412226": "sponge crab family",
    "ENVO_02000054": "bone meal",
    "NCBITaxon_206147": "Pentanemus quinquarius",
    "FOODON_03544063": "40630 - bouquet garni (efsa foodex2)",
    "FOODON_03302312": "potato roll",
    "NCBITaxon_1053340": "Cyperus esculentus",
    "GAZ_00002891": "Central America",
    "FOODON_03543594": "35940 - daisy infusion flowers (efsa foodex2)",
    "FOODON_03401472": "10006119 - teltow turnips (gs1 gpc)",
    "FOODON_03542707": "27070 - kumis (efsa foodex2)",
    "FOODON_03414289": "new zealand butterfish",
    "FOODON_03543649": "36490 - sarsaparilla infusion roots (efsa foodex2)",
    "FOODON_03413465": "pool frog",
    "FOODON_00003324": "citrus fruit (whole)",
    "FOODON_03316454": "beverage containing caffeine",
    "FOODON_03311507": "pork trimmings",
    "HANCESTRO_0560": "Northern Finnish founder",
    "NCBITaxon_74645": "Rosa rugosa",
    "FOODON_03302275": "beverage base (artifically colored)",
    "NCBITaxon_9091": "Coturnix coturnix",
    "FOODON_03305737": "fig juice (canned)",
    "FOODON_03308599": "crab (in shell, cooked, frozen)",
    "NCBITaxon_6626": "Ommastrephidae",
    "PO_0030102": "nut fruit",
    "FOODON_03541997": "19970 - asses-mules-hinnies, fresh fat tissue (efsa foodex2)",
    "FOODON_03306959": "ramen noodle",
    "CHEBI_139120": "carotenoid beta-end group",
    "CHEBI_50967": "non-covalently-bound molecular entity",
    "FOODON_03301943": "flour (enriched)",
    "NCBITaxon_224313": "Odontophoridae",
    "NCBITaxon_89945": "Merluccius albidus",
    "UO_0010011": "inch",
    "FOODON_03301855": "boysenberry (unsweetened, canned)",
    "NCBITaxon_9446": "Lemur",
    "FOODON_03411151": "white popcorn plant",
    "FOODON_03414520": "prairie rose plant",
    "FOODON_03310482": "rapeseed oil",
    "FOODON_00001870": "food mix product",
    "NCBITaxon_6456": "Haliotis fulgens",
    "FOODON_03301608": "konjacu flour",
    "CHEBI_60979": "alpha-glucoside",
    "FOODON_03316630": "dessert, powdered topping",
    "FOODON_03541724": "17240 - american persimmons and similar- (efsa foodex2)",
    "CHEBI_86463": "potassium aluminium sulfate",
    "FOODON_03490333": "waxed paper container",
    "UO_0000114": "watt",
    "FOODON_03415181": "arenga palm plant",
    "FOODON_03307579": "chicken tamale",
    "FOODON_03412150": "caribbean red snapper",
    "FOODON_03306647": "indian chutney",
    "FOODON_03315723": "sugar wafer",
    "FOODON_03543931": "39310 - sandwich with vegetable topping/filling (efsa foodex2)",
    "FOODON_03307903": "tankage (food product)",
    "NCBITaxon_103355": "Vitis labrusca",
    "FOODON_03401576": "10006074 - chives (gs1 gpc)",
    "FOODON_00001003": "fermented agave juice",
    "CHEBI_17015": "riboflavin",
    "FOODON_03413493": "green tiger prawn",
    "FOODON_03316831": "vermicelli (egg, enriched)",
    "NCBITaxon_70445": "Rastrelliger",
    "FOODON_03311103": "lime filling (aspartame sweetened)",
    "FOODON_03540835": "08350 - burnet (efsa foodex2)",
    "FOODON_03317483": "bread (pre-packed)",
    "hancestro_0001": "obsolete: major area",
    "FOODON_03309276": "pacific saury (raw)",
    "FOODON_03304821": "onion soup",
    "FOODON_03411349": "cattle calf",
    "NCBITaxon_185739": "Pollachius pollachius",
    "UO_0010029": "quart",
    "FOODON_03316274": "nougat product",
    "FOODON_03316325": "coalfish product in oil",
    "FOODON_03304682": "tea blend (dry)",
    "FOODON_03307794": "loong tsing tea (dry)",
    "FOODON_03412717": "common periwinkle",
    "FOODON_03520324": "pacific ocean fishing area",
    "FOODON_03306717": "butterscotch creme pudding",
    "FOODON_00001769": "cow buttermilk food product",
    "FOODON_03306167": "grapefruit juice (artificially sweetened, frozen concentrate)",
    "FOODON_03304136": "corn (sweet, golden, whole kernel, canned)",
    "FOODON_03315495": "soy sauce pickle",
    "FOODON_03301343": "cellulose",
    "FOODON_03415169": "pink trumpet-tree plant",
    "FOODON_03307188": "pumpkin custard pie filling",
    "FOODON_00002622": "Gamay grape plant",
    "FOODON_03311524": "bologna genoa",
    "FOODON_03311152": "fruit punch (canned)",
    "FOODON_03400173": "caramel candy (us cfr)",
    "FOODON_03411225": "rose plant",
    "CHEBI_37164": "homopolysaccharide",
    "NCBITaxon_98081": "Crangonidae",
    "FOODON_03310235": "hen egg white (browned)",
    "FOODON_03450027": "saut\u00e9ing",
    "FOODON_03310189": "belgian carrot (raw, cut)",
    "FOODON_03400864": "dessert (eurofir)",
    "FOODON_03541459": "14590 - clementines (efsa foodex2)",
    "FOODON_03310826": "meat (processed)",
    "FOODON_03401578": "10006054 - coriander (gs1 gpc)",
    "FOODON_03401436": "10006832 - five-flavor berries (gs1 gpc)",
    "FOODON_03310273": "white wine",
    "FOODON_03401889": "10006163 - tomatoes - oblong (gs1 gpc)",
    "IAO_0000032": "scalar measurement datum",
    "NCBITaxon_141886": "Paralichthys lethostigma",
    "FOODON_03303206": "may wine",
    "FOODON_03541692": "16920 - sea grapes (efsa foodex2)",
    "FOODON_03316850": "roll or bun (milk)",
    "PO_0030106": "silique fruit",
    "FOODON_03542211": "22110 - fish, seafood, amphibians, reptiles and invertebrates (efsa foodex2)",
    "FOODON_03510251": "man as food consumer",
    "FOODON_03401888": "10006162 - cherry tomatoes - round (gs1 gpc)",
    "FOODON_03543728": "37280 - tea, decaffeinated, infusion (efsa foodex2)",
    "FOODON_03540195": "01950 - noodle, rice (efsa foodex2)",
    "FOODON_03490404": "polyethylene (low density) - polypropylene container",
    "FOODON_03400740": "033  milks (ml) (ccpr)",
    "FOODON_03412560": "pasilla pepper plant",
    "FOODON_03412621": "lemon balm plant",
    "FOODON_03311459": "soybean flour (defatted)",
    "CHEBI_33302": "pnictogen molecular entity",
    "FOODON_03412061": "grains-of-paradise plant",
    "FOODON_03315223": "acorn squash (whole, raw)",
    "FOODON_03309091": "halibut fillet (raw)",
    "FOODON_03316934": "fish paste (smoked)",
    "BFO_0000140": "continuant fiat boundary",
    "FOODON_03310765": "greens (raw)",
    "FOODON_03411956": "norway lobster",
    "FOODON_03413201": "potassium adipate",
    "GAZ_00000465": "Asia",
    "FOODON_03413846": "round herring",
    "FOODON_03414856": "black carp",
    "FOODON_03316949": "macaroni product (milk)",
    "FOODON_03315040": "imitation fruit flavored drinks and ades (frozen concentrates)",
    "CHEBI_25549": "nitrites",
    "FOODON_03307910": "green bean (sliced, in sauce, frozen)",
    "FOODON_03301585": "cookie",
    "FOODON_03316273": "marzipan analog",
    "NCBITaxon_260145": "Ugni molinae",
    "FOODON_03401342": "50251700 - papayas (gs1 gpc)",
    "FOODON_03316956": "noodle product (egg)",
    "FOODON_03302706": "chicken tetrazzini mix",
    "NCBITaxon_7913": "Polyodon spathula",
    "FOODON_03310928": "rice pudding (creamy, reduced calorie, sucrose free)",
    "FOODON_03412590": "hen clam",
    "FOODON_03401098": "10000242 - pasta/noodles - not ready to eat (shelf stable) (gs1 gpc)",
    "FOODON_03309013": "tuna (solid pack, canned in olive oil)",
    "FOODON_03315363": "fruit with twoenjang (preserved)",
    "FOODON_03309661": "shrimp (dried, canned)",
    "FOODON_03543288": "32880 - fruit soft drink, mango (efsa foodex2)",
    "FOODON_03543640": "36400 - purple echinacea infusion roots (efsa foodex2)",
    "FOODON_03303888": "shrimp (headless, in shell, frozen)",
    "FOODON_03303635": "cola carbonated beverage (caffeine-free, low calorie)",
    "FOODON_03414630": "goolwa donax",
    "FOODON_03302951": "maraschino cherry in sugar syrup",
    "FOODON_03543557": "35570 - willow herb infusion leaves (efsa foodex2)",
    "FOODON_03411827": "butterfish family",
    "FOODON_03544234": "42340 - chilli flavour (efsa foodex2)",
    "FOODON_03317282": "beef and pork sausage (raw)",
    "FOODON_03303687": "cottage cheese (dry curd, creamed)",
    "FOODON_03490154": "paperboard container with window",
    "FOODON_03411170": "black olive plant",
    "FOODON_03542716": "27160 - sour cream, plain (efsa foodex2)",
    "FOODON_03304480": "flour (treated with nitric acid)",
    "FOODON_03400653": "05  herbs and spices (ccpr)",
    "FOODON_03401310": "fatty acid or fat/oil supplement",
    "FOODON_03303644": "candy lipstick",
    "FOODON_03302477": "flavoring (natural sour)",
    "FOODON_03315753": "fruit juice (carbonated)",
    "FOODON_03540711": "07110 - carrots and similar- (efsa foodex2)",
    "FOODON_03306538": "wild mushroom (whole)",
    "FOODON_00003000": "flatbread",
    "FOODON_03302142": "soybean flour",
    "NCBITaxon_395311": "Rumex arcticus",
    "FOODON_03307084": "strawberry spread with cognac",
    "FOODON_03411471": "european cantaloupe plant",
    "FOODON_03541824": "18240 - marmalade (efsa foodex2)",
    "FOODON_03307775": "pimiento cheese and pickle sandwich spread",
    "NCBITaxon_1110380": "Polygonoideae",
    "FOODON_00003153": "nelma",
    "CHEBI_52763": "magnesium-25 atom",
    "FOODON_03413373": "komatsuma plant",
    "FOODON_03543471": "34710 - catmint infusion leaves (efsa foodex2)",
    "FOODON_00002811": "broad bean pod",
    "FOODON_03302515": "sour cream",
    "NCBITaxon_81392": "Synodus saurus",
    "FOODON_03540451": "04510 - roselle leaves (efsa foodex2)",
    "FOODON_03411278": "eel",
    "FOODON_03400973": "10000287 - cereal/muesli bars (gs1 gpc)",
    "FOODON_03420258": "cap, button",
    "NCBITaxon_166264": "Decapterus macrosoma",
    "FOODON_03307284": "banana passionfruit (whole, raw)",
    "NCBITaxon_170989": "Citrus hystrix",
    "FOODON_03544515": "45150 - pollen (residues of vegetal pollens) (efsa foodex2)",
    "NCBITaxon_129327": "Liasis fuscus",
    "NCBITaxon_42043": "Silene vulgaris",
    "FOODON_03414385": "snapping turtle",
    "FOODON_00001690": "obsolete: cassava food product",
    "FOODON_03309397": "vegetable burger mix",
    "FOODON_03400832": "pulse dish (eurofir)",
    "FOODON_03540494": "04940 - kohlrabi leaves (efsa foodex2)",
    "FOODON_03305211": "stone ground flour",
    "FOODON_03311209": "roasted almond oil",
    "FOODON_03302235": "imitation orange carbonated beverage (artificially sweetened)",
    "FOODON_03315901": "goat milk (partly skimmed)",
    "FOODON_03304185": "mushroom stock cube",
    "FOODON_03530003": "obsolete: meat color, undesignated or unknown",
    "FOODON_03414412": "cross-linked sodium carboxy methyl cellulose, cross linked cellulose gum",
    "FOODON_03301935": "dough (ready-to-bake, commercially prepared)",
    "NCBITaxon_3671": "Momordica",
    "FOODON_03413957": "japanese jack mackerel",
    "NCBITaxon_8852": "Branta",
    "FOODON_03412060": "kava plant",
    "FOODON_03520492": "dry climatic zone",
    "FOODON_03303548": "anfrom cheese",
    "FOODON_03411082": "field cress plant",
    "FOODON_03540031": "00310 - teosinte grain (efsa foodex2)",
    "FOODON_03543301": "33010 - diet soft drinks with flavours (efsa foodex2)",
    "FOODON_03315005": "candy soft",
    "FOODON_03307919": "distilled cider vinegar",
    "NCBITaxon_103762": "Zizania palustris",
    "NCBITaxon_53845": "Caesalpinia",
    "FOODON_00003378": "food harvested by gathering",
    "FOODON_03310345": "piri piri",
    "NCBITaxon_43171": "Linaria vulgaris",
    "FOODON_03305321": "fruit juice concentrate",
    "UBERON_0000468": "multicellular organism",
    "NCBITaxon_8265": "Pseudopleuronectes americanus",
    "FOODON_00003244": "souffl\u00e9",
    "FOODON_03302261": "imitation orange juice beverage base",
    "FOODON_03302450": "butter (renovated)",
    "FOODON_03541402": "14020 - tamarind and similar- (efsa foodex2)",
    "NCBITaxon_31028": "Tetraodontoidei",
    "FOODON_03411601": "fish, clupeiform",
    "FOODON_03543509": "35090 - horehound infusion leaves (efsa foodex2)",
    "FOODON_03544154": "41540 - isolated proteins and other protein products (efsa foodex2)",
    "FOODON_00002885": "blue crabmeat",
    "FOODON_03543519": "35190 - big-leaf linden infusion leaves (efsa foodex2)",
    "FOODON_03307102": "bavarian pudding",
    "FOODON_03309413": "shark meat (frozen)",
    "NCBITaxon_42219": "Cornaceae",
    "FOODON_03400969": "50221200 - processed cereal products (gs1 gpc)",
    "FOODON_03543662": "36620 - materials for infusions or hot drinks of miscellaneous origin (efsa foodex2)",
    "FOODON_03542034": "20340 - beef kidney (efsa foodex2)",
    "FOODON_03311532": "potatoes gratin\u00e9 (dish)",
    "FOODON_03540078": "00780 - rye flour (efsa foodex2)",
    "FOODON_03310902": "crab (steamed)",
    "FOODON_03541169": "11690 - other tree nuts (efsa foodex2)",
    "FOODON_03411434": "spearmint plant",
    "FOODON_03414698": "tree fern plant",
    "FOODON_03308773": "korean oyster (raw)",
    "FOODON_03540914": "09140 - other urtica species (efsa foodex2)",
    "FOODON_03305418": "dietetic hard candy (artificially coffee-flavored)",
    "CHEBI_33250": "atom",
    "FOODON_00001042": "bovine milk beverage",
    "FOODON_03305359": "chicken neck (raw, ground)",
    "FOODON_03450023": "steaming without pressure",
    "FOODON_03304578": "barbeque sandwich",
    "FOODON_03310583": "spearmint candy",
    "FOODON_03413697": "sharptail shortfin squid",
    "FOODON_03542111": "21110 - tiroler speck (efsa foodex2)",
    "FOODON_03302529": "butter granule or flake (artificially colored)",
    "FOODON_03540146": "01460 - fried bread dough (efsa foodex2)",
    "FOODON_03316768": "chocolate and vegetable fat coating sweet",
    "NCBITaxon_122118": "Prunus americana",
    "FOODON_00001145": "microbial food product",
    "FOODON_03302165": "imitation fruit-flavored carbonated beverage",
    "FOODON_03400895": "10000592 - coffee/tea/substitutes variety packs (gs1 gpc)",
    "CHEBI_30879": "alcohol",
    "FOODON_03400996": "50101900 - fruit/nuts/seeds combination (gs1 gpc)",
    "FOODON_03412404": "fish, lophiiform",
    "FOODON_03304018": "sandwich spread",
    "FOODON_03450047": "pressure frying process",
    "FOODON_03541827": "18270 - marmalade, mixed citrus fruit (efsa foodex2)",
    "FOODON_03316714": "cheese hushallsost",
    "FOODON_03311843": "mayonnaise (homemade)",
    "FOODON_03309943": "parsley flake",
    "FOODON_03542155": "21550 - fresh kolbasz (efsa foodex2)",
    "FOODON_03310993": "root vegetable (cooked)",
    "FOODON_03309696": "salmon (cured, unsmoked)",
    "FOODON_03543473": "34730 - chiretta infusion leaves (efsa foodex2)",
    "FOODON_03317258": "baltic herring filet fully preserved",
    "FOODON_03317238": "spice (capsicum-based)",
    "FOODON_03490299": "aluminum combined with regenerated cellulose",
    "FOODON_03542780": "27800 - soft-ripened cheese veined with blue mould (blue bavarian, blue de graven type ) (efsa foodex2)",
    "FOODON_00002394": "moromi of sake",
    "FOODON_03543291": "32910 - fruit soft drink, orange (efsa foodex2)",
    "FOODON_00003172": "welsh onion",
    "FOODON_03401282": "USDA SR nut and seed products (1200)",
    "FOODON_03542000": "20000 - deer, fresh fat tissue (efsa foodex2)",
    "FOODON_03307540": "coffee substitute (made from fruit and vegetable peels)",
    "HANCESTRO_0587": "Martu Australian Aboriginal",
    "FOODON_03307193": "sugar stick",
    "FOODON_03542356": "23560 - pollack (efsa foodex2)",
    "FOODON_03304259": "scampi soup",
    "FOODON_03305827": "sweet potato (canned, dehydrated)",
    "NCBITaxon_8172": "Pagrus",
    "FOODON_03303435": "sardine (smoked)",
    "NCBITaxon_3928": "Lythraceae",
    "FOODON_03401075": "10000194 - dessert sauces/toppings/fillings (perishable) (gs1 gpc)",
    "FOODON_03304583": "chili sauce",
    "GAZ_00001106": "Zimbabwe",
    "FOODON_03305696": "imitation milk (liquid)",
    "FOODON_00002046": "mung bean food product",
    "FOODON_03413392": "annatto plant",
    "FOODON_03411599": "pome fruit plant",
    "NCBITaxon_59837": "Leiostomus xanthurus",
    "FOODON_03460273": "zinc added",
    "GAZ_00002566": "Province of Alberta",
    "FOODON_03490431": "polyolefin container",
    "FOODON_03305435": "lobster tail (frozen)",
    "NCBITaxon_4069": "Solanales",
    "NCBITaxon_30850": "Lutjanidae",
    "FOODON_03400956": "10000246 - pies/pastries - sweet (perishable) (gs1 gpc)",
    "FOODON_03530010": "choice grade",
    "NCBITaxon_13750": "Vaccinium macrocarpon",
    "FOODON_03301611": "pear (canned)",
    "PO_0009001": "fruit",
    "NCBITaxon_370613": "Illex cf. oxygonius DBC-2006",
    "FOODON_03520139": "atlantic, southwest (fao major fishing area 41)",
    "FOODON_03530184": "fat content > 30%",
    "NCBITaxon_126747": "Cynanchum",
    "FOODON_03460222": "obsolete: wheat germ added",
    "FOODON_00002051": "mussel food product",
    "FOODON_03542801": "28010 - cheese, bundnerkase (efsa foodex2)",
    "NCBITaxon_61362": "Acanthopleura",
    "UBERON_0010899": "synchronous hermaphroditic organism",
    "FOODON_03540213": "02130 - french pie pastry dough (efsa foodex2)",
    "NCBITaxon_1521262": "Polypodiidae <ferns>",
    "FOODON_03310267": "oilseed meal (food product)",
    "FOODON_03510028": "pet cat as consumer",
    "FOODON_03401027": "10000167 - butter/butter substitutes (frozen) (gs1 gpc)",
    "PO_0025328": "unifacial vascular leaf",
    "NCBITaxon_2233839": "IRL clade",
    "FOODON_03540112": "01120 - rice bran (efsa foodex2)",
    "FOODON_03540804": "08040 - chanterelles (efsa foodex2)",
    "NCBITaxon_115490": "Livistona",
    "RO_0002314": "inheres in part of",
    "FOODON_03308716": "tuna (frozen)",
    "FOODON_03510191": "infant as food consumer, 6 - 12 months",
    "FOODON_03401704": "10006260 - sprouts (gs1 gpc)",
    "FOODON_03310236": "sassafras oil",
    "FOODON_03305782": "damson plum jam (food product)",
    "FOODON_03306346": "rigatoni macaroni (enriched)",
    "FOODON_03308998": "pacific snapper (raw)",
    "FOODON_03543769": "37690 - follow-on formula, milk and soya-based, liquid (efsa foodex2)",
    "FOODON_03401557": "10006034 - shiitake mushrooms (gs1 gpc)",
    "FOODON_03540378": "03780 - wild chicories (efsa foodex2)",
    "GAZ_00003942": "Saint-Pierre and Miquelon",
    "FOODON_03411795": "atlantic croaker",
    "GAZ_00000911": "Liberia",
    "NCBITaxon_81636": "Micromesistius poutassou",
    "FOODON_03316743": "tomato concentrate (processed)",
    "FOODON_00002164": "porgy food product",
    "FOODON_03420151": "head (plant)",
    "GAZ_00002571": "Province of Manitoba",
    "FOODON_03400228": "snack food (us cfr)",
    "FOODON_03540345": "03450 - processed rice-based flakes (efsa foodex2)",
    "FOODON_03316018": "potato dough",
    "FOODON_00002368": "yam food product",
    "FOODON_03412544": "fish, albuliform",
    "FOODON_03510263": "infant as food consumer, 0 - 6 months",
    "FOODON_03310062": "horsemeat (frozen)",
    "FOODON_03304230": "halibut in cheese sauce",
    "FOODON_03544278": "42780 - green tea flavour (efsa foodex2)",
    "FOODON_03310353": "italian cheese",
    "FOODON_03413653": "chilean blue mussel",
    "FOODON_03400113": "spice or herb (us cfr)",
    "FOODON_03542999": "29990 - fructose (efsa foodex2)",
    "FOODON_03530246": "neurotoxic shellfish poisoning",
    "NCBITaxon_49986": "Satureja",
    "CHEBI_51438": "D-isoascorbic acid",
    "FOODON_00001031": "gorgonzola cheese food product",
    "NCBITaxon_171637": "Amygdaloideae",
    "FOODON_03542177": "21770 - cooked salami (efsa foodex2)",
    "FOODON_03401139": "10000631 - aquatic invertebrates/fish/shellfish/seafood mixes - unprepared/unprocessed (shelf stable) (gs1 gpc)",
    "FOODON_00002998": "ivy gourd food product",
    "FOODON_03412859": "emperor",
    "FOODON_03414325": "beefsteak tomato plant",
    "FOODON_03543871": "38710 - fish p\u00e2t\u00e9 (efsa foodex2)",
    "FOODON_03543012": "30120 - honey, monofloral (efsa foodex2)",
    "FOODON_03413936": "round goby",
    "NCBITaxon_8202": "Anarhichadidae",
    "FOODON_03412206": "langostino amarillo",
    "FOODON_03401337": "50251000 - berries/small fruit (gs1 gpc)",
    "FOODON_03311171": "vegetable (flakes)",
    "FOODON_03540373": "03730 - curly endives (efsa foodex2)",
    "FOODON_03490401": "polyethylene (low density) - polyester container",
    "FOODON_03306712": "coffee cake mix",
    "FOODON_03302772": "whipped topping",
    "FOODON_03311113": "yellowfin tuna (packed in water)",
    "NCBITaxon_32519": "Ostariophysi",
    "NCBITaxon_8237": "Thunnus thynnus",
    "FOODON_03401230": "0230000 - fruiting vegetables (ec)",
    "FOODON_03401871": "10006443 - paraguaya (gs1 gpc)",
    "FOODON_03543644": "36440 - herb bennet infusion roots (efsa foodex2)",
    "NCBITaxon_2233838": "Hologalegina",
    "FOODON_03309819": "green bean (strained)",
    "CHEBI_26823": "sulfites",
    "FOODON_03311000": "seedless white grape (whole, raw)",
    "NCBITaxon_1170222": "Abelmoschus moschatus",
    "FOODON_03306477": "hippopotamus meat (raw)",
    "FOODON_03307140": "olive (stuffed with anchovies)",
    "FOODON_03544264": "42640 - figs dried flavour (efsa foodex2)",
    "FOODON_03544464": "44640 - aspartame (efsa foodex2)",
    "FOODON_03401811": "10006107 - taro (gs1 gpc)",
    "GAZ_00006291": "State of Idaho",
    "FOODON_03309727": "unicorn filefish (raw)",
    "FOODON_03541664": "16640 - babacos (efsa foodex2)",
    "FOODON_03412067": "muskmelon plant",
    "FOODON_03309048": "cusk fillet (frozen)",
    "FOODON_03302857": "daquiri cake",
    "FOODON_03311182": "custard pie",
    "FOODON_03315627": "porter",
    "FOODON_00002104": "pear preserve or jam",
    "FOODON_03302554": "chili pepper (dried)",
    "FOODON_00001816": "diluted orange beverage",
    "FOODON_03414198": "purple passionflower plant",
    "FOODON_03305686": "coconut (grated, in coconut oil)",
    "FOODON_03542655": "26550 - cow milk, whole (efsa foodex2)",
    "FOODON_03301079": "pollock (raw)",
    "FOODON_03301954": "candied apple base",
    "FOODON_03412096": "donkey",
    "FOODON_00002942": "parsley leaf",
    "NCBITaxon_9881": "Odocoileinae",
    "FOODON_03413566": "mottled shore crab",
    "GAZ_00005838": "Clipperton Island",
    "FOODON_03411024": "tropical or subtropical fruit producing plant",
    "GAZ_00006902": "Niue Fekai",
    "NCBITaxon_6805": "Majidae",
    "FOODON_03310042": "sheep kidney (whole, raw)",
    "FOODON_00002141": "plant fruit vegetable food product",
    "UBERON_0018382": "second instar larva",
    "FOODON_03315238": "confection coating (sugar type)",
    "FOODON_03304009": "barbeque sauce (canned)",
    "NCBITaxon_45318": "Tetragonia tetragonoides",
    "FOODON_03310986": "corn (cracked)",
    "NCBITaxon_175193": "Ribes divaricatum",
    "FOODON_03308421": "lobsterette (raw)",
    "FOODON_03304711": "vinegar and oil dressing",
    "FOODON_03540200": "02000 - yeast bread \u0096 pizza dough (efsa foodex2)",
    "FOODON_03540073": "00730 - maize flour (efsa foodex2)",
    "FOODON_03315664": "meat by-product (potted)",
    "FOODON_03415039": "rotund boesenbergia plant",
    "FOODON_03305355": "chicken (boneless, raw)",
    "FOODON_03411456": "pumpkin plant",
    "FOODON_03543006": "30060 - syrups (efsa foodex2)",
    "FOODON_03544387": "43870 - sweet chilli flavour (efsa foodex2)",
    "ENVO_01000486": "building floor",
    "NCBITaxon_365067": "Engraulinae",
    "FOODON_03541650": "16500 - chinese olives, black, white (efsa foodex2)",
    "FOODON_03543349": "33490 - wine (efsa foodex2)",
    "NCBITaxon_25664": "Araucariaceae",
    "GAZ_00004411": "State of Tennessee",
    "FOODON_03315427": "milk substitute of vegetable origin",
    "FOODON_03413933": "lagoon goby",
    "FOODON_03304830": "italian sandwich roll",
    "FOODON_03309761": "obsolete: spring water with white chardonnay wine (food product)",
    "FOODON_03414637": "cassidula",
    "NCBITaxon_28502": "Amaranthus hypochondriacus",
    "FOODON_03413797": "baker's yeast",
    "FOODON_03309106": "flounder fillet (raw)",
    "FOODON_03411717": "amaranth plant",
    "NCBITaxon_4081": "Solanum lycopersicum",
    "FOODON_03400875": "50200000 - beverages (gs1 gpc)",
    "FOODON_03414223": "muskmelon, inodorus group (plant)",
    "FOODON_03306596": "citron (whole, raw)",
    "FOODON_03302400": "isotonic beverage",
    "FOODON_03411659": "red kidney bean plant",
    "FOODON_03414395": "copper complexes of chlorophylls, chlorophyllins",
    "FOODON_03401028": "10000168 - butter/butter substitutes (perishable) (gs1 gpc)",
    "FOODON_03412180": "sea bass",
    "NCBITaxon_6817": "Euphausiidae",
    "NCBITaxon_146139": "Selar",
    "FOODON_03543289": "32890 - fruit soft drink, mulberry (efsa foodex2)",
    "NCBITaxon_329779": "Solanum incanum",
    "FOODON_03315896": "beverage (spruce flavored)",
    "FOODON_03400904": "10000310 - dairy/dairy substitute based drinks - not ready to drink (shelf stable) (gs1 gpc)",
    "FOODON_03541931": "19310 - sheep, minced meat (efsa foodex2)",
    "FOODON_03411255": "clove plant",
    "FOODON_03310027": "oilseed (food product)",
    "FOODON_03400913": "10000179 - chocolate/cocoa/malt - ready to drink (gs1 gpc)",
    "FOODON_03544060": "40600 - seasoning mixes (efsa foodex2)",
    "NCBITaxon_8073": "Lophius americanus",
    "FOODON_03490145": "plastic boil-in-bag",
    "FOODON_03306608": "naranjilla juice drink",
    "FOODON_00003216": "poppyseed oil",
    "NCBITaxon_30483": "Carcharhiniformes",
    "FOODON_03301260": "olive (whole, raw)",
    "NCBITaxon_270608": "Bembrops",
    "FOODON_03302194": "pepper (home-canned)",
    "FOODON_03316828": "vermicelli (egg)",
    "FOODON_03510113": "no artificial preservatives claim or use",
    "HANCESTRO_0532": "Equatorial Guinean",
    "HANCESTRO_0427": "Turks and Caicos Islander",
    "FOODON_03309014": "tuna pate in sherry wine",
    "FOODON_03400872": "medical food (eurofir)",
    "FOODON_03309200": "thread herring (raw)",
    "FOODON_03304223": "infant cereal with fruit",
    "FOODON_00001720": "cherry pie",
    "FOODON_03401336": "50250700 - bananas (gs1 gpc)",
    "FOODON_03303675": "parmesan cheese (block)",
    "FOODON_03411242": "turtle",
    "FOODON_03400242": "cracker (us cfr)",
    "FOODON_03315842": "cream mix, dry, imitation",
    "FOODON_03490221": "adhesive",
    "FOODON_03411553": "hickory tree",
    "FOODON_03301288": "peach nectar",
    "FOODON_03307928": "puerto rican yam (whole, raw)",
    "FOODON_03306310": "macaroni (short cut)",
    "FOODON_03311727": "spread, low calorie",
    "FOODON_03301545": "cucumber (whole, raw)",
    "FOODON_03543479": "34790 - cowberry infusion leaves (efsa foodex2)",
    "FOODON_03304398": "calf milk replacer",
    "FOODON_00002653": "food (hydrolized)",
    "FOODON_03301938": "doughnut",
    "FOODON_03413827": "brushtooth lizardfish",
    "FOODON_03302860": "butter cream pecan cake",
    "FOODON_03460208": "fat substitution process",
    "FOODON_03411010": "neogastropod",
    "NCBITaxon_1489878": "Gobiiformes",
    "NCBITaxon_34984": "Pythonidae",
    "FOODON_03301109": "fruit pulp",
    "NCBITaxon_349311": "Engraulis australis",
    "FOODON_03541073": "10730 - borlotti or other common beans (dry) (efsa foodex2)",
    "FOODON_03401313": "dietary supplement, combination",
    "FOODON_00003055": "greenthread plant",
    "NCBITaxon_3367": "Cupressaceae",
    "FOODON_00003227": "soybean oil (fully hydrogenated)",
    "FOODON_03317307": "meat salad (frozen)",
    "NCBITaxon_3988": "Ricinus communis",
    "FOODON_03540955": "09550 - starchy roots or tubers and products thereof, sugar plants (efsa foodex2)",
    "ECOCORE_00000017": "phototrophy",
    "OBI_0200184": "descriptive statistical calculation data transformation",
    "FOODON_03541535": "15350 - amur river grapes (efsa foodex2)",
    "FOODON_03309445": "codfish loaf (minced)",
    "FOODON_03540387": "03870 - baby leaf crops (including brassica species) and similar- (efsa foodex2)",
    "CHEBI_23014": "carbon oxide",
    "FOODON_03415128": "eyebright plant",
    "FOODON_03306374": "imitation orange marmalade",
    "NCBITaxon_1437010": "Boreoeutheria",
    "NCBITaxon_145123": "Cantareus apertus",
    "FOODON_03301134": "apple wine",
    "FOODON_03304420": "chocolate creme pudding",
    "FOODON_03308514": "quail meat (raw)",
    "FOODON_03303595": "chocolate-flavored icing",
    "FOODON_03544330": "43300 - nutella flavour (efsa foodex2)",
    "FOODON_03414926": "maripa palm plant",
    "FOODON_03542634": "26340 - canned mackerel (efsa foodex2)",
    "FOODON_03411824": "snook family",
    "FOODON_03316600": "fish product (in sour pickle)",
    "FOODON_03311346": "sugar cane syrup",
    "FOODON_03411132": "chinook salmon",
    "FOODON_00001718": "cherry juice food product",
    "FOODON_03470100": "preservation by adding chemicals",
    "FOODON_03412792": "gumvine plant",
    "FOODON_00002517": "food packing medium compromised",
    "FOODON_03311581": "grape brandy",
    "NCBITaxon_43698": "Synbranchidae",
    "FOODON_03412042": "mango melon plant",
    "FOODON_03309274": "pacific sole (raw)",
    "CHEBI_33306": "carbon group element atom",
    "FOODON_03541629": "16290 - hawberries (efsa foodex2)",
    "FOODON_03543564": "35640 - rooibos (efsa foodex2)",
    "FOODON_03543507": "35070 - herb bennet infusion leaves (efsa foodex2)",
    "FOODON_03510088": "naturally sodium-free food",
    "HANCESTRO_0322": "Finnish founder",
    "FOODON_03316078": "soda bread",
    "FOODON_03315131": "lemon spread (artificially flavored)",
    "FOODON_00003023": "caraway seed (whole)",
    "FOODON_03411855": "northern anchovy",
    "NCBITaxon_8158": "Caranx",
    "RO_0001025": "located in",
    "NCBITaxon_115623": "Herniaria",
    "NCBITaxon_7215": "Drosophila <flies,genus>",
    "FOODON_00003414": "cowpea (whole)",
    "FOODON_03480047": "packed in vinegar with sugar and salt",
    "ENVO_01000927": "day care building",
    "FOODON_00002068": "onion soup food product",
    "FOODON_00002301": "pork cured meat food product",
    "FOODON_03414938": "sweet gourd plant",
    "FOODON_03540176": "01760 - pasta, plain (not stuffed), uncooked (efsa foodex2)",
    "FOODON_03490149": "tinless steel plate container",
    "FOODON_03301074": "obsolete: hen egg product (not further specified)",
    "FOODON_03304478": "durum flour",
    "NCBITaxon_216706": "Nepetoideae",
    "FOODON_03430107": "divided into segments or wedges",
    "FOODON_03301455": "tomato paste",
    "NCBITaxon_7955": "Danio rerio",
    "FOODON_03304809": "prune juice (unsweetened)",
    "FOODON_03305599": "obsolete: beef hamburger (raw)",
    "FOODON_03411644": "cuttlefish",
    "FOODON_03301040": "watermelon (whole, raw)",
    "FOODON_03542605": "26050 - edible insect larvae (efsa foodex2)",
    "FOODON_03540550": "05500 - banana flowers (efsa foodex2)",
    "FOODON_03308506": "mushroom (home-canned)",
    "FOODON_03315022": "pimento ribbon",
    "FOODON_00002771": "hyacinth bean pod",
    "NCBITaxon_148714": "Parkia speciosa",
    "FOODON_03311387": "sloppy joe (frozen)",
    "FOODON_00001715": "chemical soft drink",
    "FOODON_03306255": "toast",
    "FOODON_03307368": "blackeyed peas flavored with ham (cooked)",
    "FOODON_03315521": "tallow (edible)",
    "FOODON_03540665": "06650 - okra (efsa foodex2)",
    "CHEBI_28260": "galactose",
    "FOODON_03411180": "dungeness crab",
    "FOODON_00001327": "pu dong",
    "FOODON_03306110": "lingonberry (swedish, raw)",
    "NCBITaxon_3337": "Pinus <genus>",
    "FOODON_03544296": "42960 - juniper flavour (efsa foodex2)",
    "GAZ_00000915": "Togo",
    "NCBITaxon_66703": "Barbatia cancellaria",
    "FOODON_03317263": "pork cut (cured)",
    "FOODON_03541411": "14110 - dried nuts and related flours and powders (efsa foodex2)",
    "FOODON_03301035": "coffee (instant)",
    "NCBITaxon_154954": "Genypterus blacodes",
    "FOODON_03305845": "ice cream (french-fried)",
    "FOODON_03400214": "glaze (us cfr)",
    "FOODON_03308029": "bluefin searobin (raw)",
    "UO_0010044": "united states customary tablespoon",
    "FOODON_03540256": "02560 - sponge cake (efsa foodex2)",
    "FOODON_03412059": "mate plant",
    "FOODON_03413436": "sapucaia-nut plant",
    "FOODON_03317501": "olive (darkened by oxidation)",
    "FOODON_03400748": "043  fish roe (including milt = soft roe) and edible offal of fish (wr) (ccpr)",
    "FOODON_03301438": "hen egg (shell off, solids, dried, ground)",
    "FOODON_03302542": "butter cream",
    "FOODON_03400857": "herb or spice (eurofir)",
    "FOODON_03414172": "white oyster mushroom",
    "FOODON_03302889": "food (charcoal-broiled)",
    "FOODON_03541728": "17280 - white sapotes (efsa foodex2)",
    "FOODON_03309463": "lentil soup",
    "FOODON_03401333": "cake (eurofir)",
    "FOODON_03543017": "30170 - minor honey types (efsa foodex2)",
    "FOODON_03543973": "39730 - rice based dishes, cooked (efsa foodex2)",
    "FOODON_03412414": "yellow field pea plant",
    "FOODON_00001992": "lamb meat food product",
    "FOODON_03309989": "swine feed",
    "FOODON_03316879": "egg cheese",
    "NCBITaxon_158453": "Trichopsis",
    "FOODON_03543280": "32800 - soft drink, with fruit juice (fruit content below the minimum for nectars) (efsa foodex2)",
    "CHEBI_37716": "mixed diacylamine",
    "FOODON_03309119": "blow fish (raw)",
    "FOODON_00002691": "great northern bean substance",
    "FOODON_00003052": "pupusa (dish)",
    "FOODON_03305794": "cherry ice cream",
    "FOODON_03414565": "fulmar",
    "FOODON_03301920": "apple (canned)",
    "FOODON_03413610": "panulirid spiny lobster",
    "FOODON_03311841": "cocktail mix (dry)",
    "FOODON_03540116": "01160 - bread and similar products (efsa foodex2)",
    "FOODON_03411343": "whale",
    "GAZ_00006906": "Saint Kitts-Nevis",
    "FOODON_03530126": "hampe",
    "FOODON_03316152": "milk analog",
    "FOODON_03411506": "albacore",
    "FOODON_03315777": "poultry meat product, simulated",
    "FOODON_03301923": "applesauce cookie",
    "FOODON_03317273": "fat (rendered)",
    "FOODON_03411410": "American butterfish",
    "FOODON_03480045": "packed in gravy or sauce, fruit",
    "FOODON_03411513": "chinese radish plant",
    "FOODON_03310162": "frankfurter (charcoal-broiled)",
    "FOODON_03542413": "24130 - tuna and bonito (generic) (efsa foodex2)",
    "FOODON_03543981": "39810 - rice pudding (efsa foodex2)",
    "FOODON_03542112": "21120 - bacon (efsa foodex2)",
    "FOODON_03540823": "08230 - other mosses and lichens (efsa foodex2)",
    "NCBITaxon_65561": "Hypericum perforatum",
    "FOODON_03301009": "silver dragee candy",
    "FOODON_03310086": "salsa",
    "FOODON_03306670": "imitation french dressing",
    "FOODON_03304765": "gelatin (unflavored)",
    "FOODON_03301276": "pineapple juice (liquid)",
    "FOODON_03412245": "obsolete: cattle and goat",
    "FOODON_00002492": "sarsaparilla food product",
    "FOODON_03540556": "05560 - kurrat (efsa foodex2)",
    "FOODON_03308018": "shark flake",
    "FOODON_03414120": "rough shark family",
    "FOODON_03304202": "green turtle soup",
    "FOODON_03306197": "green tomato relish",
    "FOODON_03544336": "43360 - oyster flavour (efsa foodex2)",
    "FOODON_03309298": "snook (raw)",
    "FOODON_03400822": "savoury cereal dish (eurofir)",
    "FOODON_00002858": "Hohoysi tea",
    "FOODON_03311384": "breath mint candy sweetened with aspartame",
    "GAZ_00007161": "Marshall Islands",
    "NCBITaxon_477288": "Bassanago bulbiceps",
    "FOODON_03413060": "carboxy methyl cellulose",
    "CHEBI_35788": "seco-steroid",
    "FOODON_00003170": "herbal tea (liquid)",
    "FOODON_03401698": "10006828 - netted muskmelons (gs1 gpc)",
    "FOODON_03460291": "curing or aging 2 to 4 months",
    "FOODON_03310104": "chinese cabbage (whole, raw)",
    "FOODON_03543558": "35580 - witch hazel infusion leaves (efsa foodex2)",
    "FOODON_00001105": "avian egg food product",
    "FOODON_03301486": "light cream",
    "FOODON_03303686": "gruyere cheese",
    "FOODON_03470147": "food sterilization at ultra high temperature (uht)",
    "FOODON_03308047": "clam (steamed)",
    "FOODON_03412202": "pronghorn spiny lobster",
    "FOODON_03414207": "california blackberry plant",
    "FOODON_03541674": "16740 - pommarosas (efsa foodex2)",
    "FOODON_03303380": "spice",
    "FOODON_03530097": "particle size in solid formed products",
    "FOODON_03310270": "cotton-bract",
    "FOODON_03304570": "rose hip tea (dry)",
    "FOODON_03308681": "chilean abalone (raw)",
    "OBI_0000245": "organization",
    "FOODON_03305408": "milk substitute",
    "FOODON_03301537": "farfel",
    "UO_0010030": "gallon",
    "FOODON_03543945": "39450 - quiche (efsa foodex2)",
    "FOODON_03414816": "bogong moth",
    "FOODON_03309393": "fast food (fried)",
    "FOODON_03309646": "eastern halibut fillet (raw)",
    "FOODON_03306155": "grapefruit juice (reconstituted)",
    "FOODON_03310081": "goat milk (ultra-pasteurized)",
    "CHEBI_26178": "polyester macromolecule",
    "FOODON_03542236": "22360 - gobies, freshwater (efsa foodex2)",
    "FOODON_03308456": "south pacific plated lobster (raw)",
    "FOODON_03415130": "common fumitory plant",
    "FOODON_03543243": "32430 - juice concentrate, raspberry (efsa foodex2)",
    "PATO_0001985": "frozen",
    "FOODON_03316529": "fruit pulp semi-finished",
    "FOODON_03530063": "belly meat",
    "FOODON_03306723": "sweet red bell pepper (peeled, canned)",
    "FOODON_03303730": "fruit-filled candy",
    "NCBITaxon_8128": "Oreochromis niloticus",
    "FOODON_03400749": "044  marine mammals (wm) (ccpr)",
    "FOODON_03411189": "winter squash plant",
    "FOODON_03413971": "juan fernandez trevally",
    "FOODON_03301858": "loganberry (frozen)",
    "FOODON_03540198": "01980 - raw doughs and pre-mixes (efsa foodex2)",
    "FOODON_03316639": "caramels frothing",
    "FOODON_03411606": "triple succotash",
    "FOODON_03308804": "gumbo base (shrimp-flavored)",
    "FOODON_03510175": "egg free claim or use",
    "CHEBI_78074": "tin(II) chloride dihydrate",
    "FOODON_03400879": "10000591 - alcoholic beverages variety packs (gs1 gpc)",
    "FOODON_03415178": "kiwifruit plant (A. deliciosa)",
    "FOODON_00003280": "soup (liquid)",
    "FOODON_03304706": "imitation maple syrup",
    "FOODON_03542303": "23030 - pink salmon (efsa foodex2)",
    "NCBITaxon_30998": "Pimelodidae",
    "FOODON_03542166": "21660 - matured charcuterie products for cooking (efsa foodex2)",
    "FOODON_03541799": "17990 - dried dates (efsa foodex2)",
    "FOODON_03543249": "32490 - vegetable juice concentrate (efsa foodex2)",
    "FOODON_03305847": "carob and vanilla ice cream",
    "FOODON_03544151": "41510 - alcoholic sweet sauce (efsa foodex2)",
    "FOODON_03480037": "packed in gravy or sauce, vegetable",
    "FOODON_03542263": "22630 - gudgeons (efsa foodex2)",
    "ENVO_01000935": "campground",
    "FOODON_00002677": "crab claw",
    "FOODON_03411936": "bastard trumpeter",
    "FOODON_03400948": "10000248 - pies/pastries/pizzas/quiches - savoury (frozen) (gs1 gpc)",
    "FOODON_03401190": "10000306 - pate (shelf stable) (gs1 gpc)",
    "FOODON_03412459": "bay scallop",
    "FOODON_03401013": "10000006 - vegetables - unprepared/unprocessed (shelf stable) (gs1 gpc)",
    "FOODON_00001309": "Miang",
    "NCBITaxon_216294": "Littorinimorpha",
    "FOODON_03309483": "water buffalo jerky",
    "FOODON_03540981": "09810 - andean yam beans (efsa foodex2)",
    "FOODON_03413413": "mallow plant",
    "NCBITaxon_72094": "Sebastes pinniger",
    "CHEBI_23824": "diol",
    "FOODON_03400430": "moisture retaining agent (codex)",
    "FOODON_03544082": "40820 - meat extract (efsa foodex2)",
    "FOODON_03305425": "imitation ice milk",
    "FOODON_03413389": "sea-grape plant",
    "FOODON_03305770": "imitation cherry-apple juice",
    "FOODON_03311593": "lamb (ground)",
    "FOODON_03317340": "poultry fat (rendered)",
    "HANCESTRO_0398": "Bahamian",
    "FOODON_03400982": "50161500 - sugars/sugar substitute products (gs1 gpc)",
    "FOODON_03302217": "carrot (strained, baby food)",
    "FOODON_03304216": "infant formula (milk-based, liquid, canned)",
    "GAZ_00000904": "Benin",
    "NCBITaxon_55433": "Aponogetonaceae",
    "FOODON_03303145": "lincoln biscuit cookie",
    "FOODON_03414984": "thorn-apple plant",
    "FOODON_03401286": "USDA SR legumes and legume products (1600)",
    "FOODON_03310392": "garbanzo bean flour",
    "ECOCORE_00000013": "photoautotrophy",
    "FOODON_00001925": "grape based wine or wine-like food product",
    "FOODON_03401786": "10006753 - ready-made combination meals - ready to eat variety packs (gs1 gpc)",
    "FOODON_03307029": "potato (whole, raw, green)",
    "FOODON_03311206": "hen egg yolk (raw, salted)",
    "FOODON_03412270": "garden cress plant",
    "FOODON_03401364": "50193800 - ready-made combination meals (gs1 gpc)",
    "FOODON_03311502": "chayote (whole, raw)",
    "FOODON_03540747": "07470 - skirrets (efsa foodex2)",
    "FOODON_03308907": "tuna (white, canned)",
    "FOODON_00001573": "cottonseed hull",
    "NCBITaxon_6754": "Cancer",
    "FOODON_03311049": "spirulina seaweed (raw)",
    "FOODON_03304766": "banana-flavored candy roll (food product)",
    "FOODON_03301046": "pepper-type beverage (carbonated)",
    "PATO_0000146": "temperature",
    "FOODON_03301714": "brussels sprout (whole, raw)",
    "FOODON_03400673": "006  assorted tropical and sub-tropical fruit - inedible peel (fi) (ccpr)",
    "FOODON_03306210": "margarine substitute",
    "FOODON_03316471": "jelly candy",
    "FOODON_03316333": "margarine (half-fat)",
    "FOODON_03307411": "mineral water (bottled)",
    "FOODON_03317232": "yellow corn grits",
    "FOODON_03302871": "rye cracker",
    "FOODON_03305870": "tangerine jelly",
    "FOODON_03316745": "corn on the cob (quick-frozen)",
    "NCBITaxon_310915": "Pangasianodon hypophthalmus",
    "FOODON_03540129": "01290 - pumpernickel (efsa foodex2)",
    "FOODON_03400915": "10000192 - dairy/dairy substitute based drinks - ready to drink (shelf stable) (gs1 gpc)",
    "FOODON_03316429": "fruit product similar to jam (calorie-reduced)",
    "FOODON_03540025": "00250 - pearl millet grain (efsa foodex2)",
    "FOODON_03543957": "39570 - mushroom crostini (efsa foodex2)",
    "FOODON_03413112": "greens s",
    "CHEBI_33245": "organic fundamental parent",
    "FOODON_03303623": "whiskey sour",
    "FOODON_00001281": "custard dessert food product",
    "FOODON_03413893": "deepwater hake",
    "FOODON_03414417": "chlorophylls and chlorophyllins",
    "FOODON_03412290": "blue cod",
    "NCBITaxon_36181": "Coregonus artedi",
    "ENVO_00000139": "irrigation ditch",
    "CHEBI_36054": "benzoate ester",
    "FOODON_03540407": "04070 - senna leaves (efsa foodex2)",
    "FOODON_03305897": "imitation raspberry jelly base",
    "FOODON_03401241": "0600000 - 6. tea, coffee, herbal infusions and cocoa (ec)",
    "FOODON_00001043": "ovine milk beverage",
    "FOODON_03412109": "evening primrose plant",
    "FOODON_03401279": "USDA SR fruits and fruit juices (0900)",
    "FOODON_03412088": "lollo rosso plant",
    "FOODON_03310485": "remoulade",
    "FOODON_03401039": "obsolete: 10000582 - eggs/eggs substitutes (frozen) (gs1 gpc)",
    "NCBITaxon_3767": "Pyrus pyrifolia",
    "FOODON_03414820": "giant water vine plant",
    "FOODON_03310929": "seafood product surimi-based",
    "FOODON_03420106": "organ meat, digestive system",
    "FOODON_03413463": "edible frog",
    "FOODON_03470112": "drying under reduced pressure",
    "ENVO_00001998": "soil",
    "FOODON_03542699": "26990 - yoghurt, sheep milk, flavoured (efsa foodex2)",
    "FOODON_03301876": "quail egg (whole, shell on, raw)",
    "NCBITaxon_690869": "Pseudobatos percellens",
    "FOODON_03307111": "flavoring (volatile)",
    "FOODON_03540845": "08450 - salad burnet (efsa foodex2)",
    "FOODON_03543072": "30720 - white nougat mass (efsa foodex2)",
    "FOODON_03315058": "frozen nondairy topping",
    "FOODON_03304097": "pineapple and orange juice (frozen concentrate)",
    "FOODON_03304550": "paddy rice",
    "CHEBI_77635": "calcium phosphate",
    "FOODON_00003323": "yuzu (whole, raw)",
    "HANCESTRO_0290": "genetically isolated population",
    "FOODON_03305107": "orange candy drop (sweetened with sorbitol)",
    "FOODON_03541700": "17000 - kiwi fruits and similar- (efsa foodex2)",
    "FOODON_03315719": "mammalian milk protein (hydrolyzed)",
    "NCBITaxon_4530": "Oryza sativa",
    "FOODON_03311395": "chocolate vanilla and strawberry ice cream",
    "FOODON_03317669": "starch (hydrolyzed, solid)",
    "FOODON_03400739": "032  edible offal (mammalian) (mo) (ccpr)",
    "FOODON_03543936": "39360 - pizza and similar with cheese, meat, mushrooms, and vegetables (efsa foodex2)",
    "NCBITaxon_50207": "Sonchus oleraceus",
    "FOODON_03401276": "USDA SR soups, sauces, and gravies (0600)",
    "FOODON_03412264": "toadfish family",
    "FOODON_03304382": "cow milk (low sodium, dried)",
    "CHEBI_26834": "sulfur-containing amino acid",
    "FOODON_03302029": "harvard beet",
    "NCIT_C14191": "Cat",
    "FOODON_03413672": "european oyster",
    "FOODON_03306722": "pepper (liquid)",
    "FOODON_03308360": "langostino (cooked, peeled, frozen)",
    "FOODON_03413812": "european sturgeon",
    "FOODON_03490104": "plastic squeeze bottle or tube, unlined top",
    "FOODON_03412643": "obsolete chilean hake",
    "FOODON_03400146": "jap or agar jelly candy (us cfr)",
    "FOODON_03542531": "25310 - oyster, portuguese cupped (efsa foodex2)",
    "NCBITaxon_6630": "Nototodarus",
    "FOODON_03413974": "chub mackerel (Rastrelliger genus)",
    "NCBITaxon_57577": "Trifolium pratense",
    "FOODON_03400211": "frozen yogurt (us cfr)",
    "NCBITaxon_186265": "Cactoideae",
    "FOODON_03541599": "15990 - black crowberries (tetraploid) (efsa foodex2)",
    "FOODON_03510181": "reduced sugars food",
    "FOODON_03544247": "42470 - corn flavour (efsa foodex2)",
    "FOODON_03400910": "10000264 - sports drinks - rehydration (not ready to drink) (gs1 gpc)",
    "CHEBI_27300": "vitamin D",
    "FOODON_03413254": "sodium glycinate",
    "FOODON_03401199": "10000052 - cooking wines (gs1 gpc)",
    "FOODON_03301704": "onion (whole, raw)",
    "NCBITaxon_9850": "Cervidae",
    "HANCESTRO_0469": "I-Kiribati",
    "FOODON_00002237": "sheep milk beverage",
    "FOODON_03301660": "pudding",
    "FOODON_03301400": "pickled vegetable relish (canned)",
    "NCBITaxon_334875": "Hyperoglyphe antarctica",
    "FOODON_03542070": "20700 - goose edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "NCBITaxon_87757": "Mullus surmuletus",
    "FOODON_00002629": "Barbera wine",
    "FOODON_03543652": "36520 - angelica root, dry (efsa foodex2)",
    "FOODON_03315439": "avocado pulp (frozen)",
    "FOODON_00002330": "multi-component corn food product",
    "FOODON_00002588": "Malbec wine",
    "FOODON_03303034": "chicken loaf lunch meat",
    "NCBITaxon_84645": "Labeo rohita",
    "NCBITaxon_320393": "Cynoscion parvipinnis",
    "FOODON_03304850": "imitation jelly",
    "FOODON_03303945": "milk chocolate peanut cluster candy",
    "FOODON_03542901": "29010 - cheese, parmigiano reggiano (efsa foodex2)",
    "FOODON_03544477": "44770 - vitamin b3   (niacin, niacinamide) (efsa foodex2)",
    "FOODON_03411376": "skipjack tuna",
    "FOODON_03420102": "germinated or sprouted seed",
    "NCBITaxon_160511": "Veronica officinalis",
    "FOODON_03306389": "lime marmalade",
    "FOODON_03510047": "salt or sodium special claim or use",
    "FOODON_03544385": "43850 - sweet flavour (efsa foodex2)",
    "FOODON_03401083": "50193300 - dough based products / meals (gs1 gpc)",
    "FOODON_03317200": "sugar solution",
    "FOODON_03303775": "chocolate-flavored candy (dietetic)",
    "FOODON_03312036": "cheese sandwich",
    "FOODON_03540071": "00710 - buckwheat flour (efsa foodex2)",
    "FOODON_03400651": "03  grasses (ccpr)",
    "FOODON_03302580": "butter pecan coffee cake",
    "FOODON_03309112": "orange roughy (raw)",
    "FOODON_03304214": "grape punch",
    "FOODON_03413718": "northern mountain cranberry plant",
    "NCBITaxon_862827": "Etmopterus baxteri",
    "FOODON_03315900": "goat milk (skimmed)",
    "NCBITaxon_86197": "Eleotridae",
    "FOODON_03542710": "27100 - filmj\u00f6lk (efsa foodex2)",
    "FOODON_03400787": "processed cheese (eurofir)",
    "FOODON_03412303": "surgeonfish family",
    "FOODON_03302806": "milk chocolate",
    "FOODON_00001639": "belgian carrot food product",
    "FOODON_03305962": "hawthorne jelly",
    "FOODON_03307052": "food (deep-fried)",
    "FOODON_03401368": "50261100 - brassica vegetables (gs1 gpc)",
    "FOODON_03411001": "pea plant edible seed cultivars",
    "FOODON_03413642": "california venus",
    "FOODON_03541268": "12680 - hyssop, dry (efsa foodex2)",
    "FOODON_03304869": "sunflower seed (whole kernel, raw)",
    "FOODON_03305369": "gelatin drink (instant)",
    "FOODON_03309086": "haddock tail (raw)",
    "FOODON_03305862": "rose jam (food product)",
    "FOODON_03316829": "macaroni (egg, enriched)",
    "FOODON_03306773": "pie crust",
    "FOODON_03541620": "16200 - azaroles and similar- (efsa foodex2)",
    "FOODON_00002702": "chicken (boneless)",
    "FOODON_03306873": "peanut butter with jelly",
    "FOODON_03411623": "tea plant",
    "FOODON_03412975": "gum arabic",
    "GAZ_00001507": "Greenland",
    "FOODON_03317152": "fruit yogurt (no added sugar, energy 2.0 mj or less)",
    "CHEBI_15904": "long-chain fatty acid",
    "FOODON_03400694": "04  pasta (efg)",
    "NCBITaxon_296036": "Phyllanthus emblica",
    "PECO_0007286": "dry season exposure",
    "FOODON_03307939": "king crab (canned)",
    "FOODON_03414347": "peppertree plant",
    "FOODON_03302254": "cola carbonated beverage (artificially sweetened)",
    "FOODON_03413565": "northern lemon rock crab",
    "NCBITaxon_1489100": "Holostei",
    "FOODON_00002057": "nonalcoholic beverage",
    "FOODON_03541413": "14130 - chestnut puree (castanea vulgaris) (efsa foodex2)",
    "FOODON_03310150": "plantain (green)",
    "FOODON_03303123": "grape marc",
    "FOODON_03400310": "extra hard cheese (codex)",
    "FOODON_03315364": "vegetable with twoenjang (preserved)",
    "FOODON_03520503": "polar climatic zone",
    "FOODON_03301092": "chub (smoked, hot process)",
    "FOODON_03541638": "16380 - other not listed other small fruits and berries (efsa foodex2)",
    "FOODON_03544251": "42510 - cream brulee flavour (efsa foodex2)",
    "FOODON_03401746": "10006825 - black eyed peas (gs1 gpc)",
    "FOODON_03412119": "woodcock",
    "FOODON_03316705": "chocolate composite",
    "FOODON_03315267": "cereal for cooking (processed)",
    "FOODON_03541543": "15430 - blackberries (efsa foodex2)",
    "FOODON_03309655": "job's tears (food product)",
    "FOODON_03305643": "yellow corn meal (degerminated)",
    "FOODON_03308305": "salmon pattie",
    "NCBITaxon_862826": "Echinorhinus brucus",
    "FOODON_03412657": "weakfish group",
    "FOODON_03401582": "10006199 - flat parsley (italian) (gs1 gpc)",
    "FOODON_03414245": "canadian wild rice plant",
    "FOODON_03401637": "10006301 - moose/elk - prepared/processed (gs1 gpc)",
    "FOODON_03414137": "murray king crab",
    "FOODON_03400375": "antispattering agent (codex)",
    "NCBITaxon_8033": "Salvelinus",
    "FOODON_03490115": "ceramic or earthenware crock or jar",
    "FOODON_03500016": "enamel surface for fruit (f-enamel)",
    "FOODON_03305715": "spezzatino di vitello",
    "FOODON_03307960": "clam (breaded)",
    "FOODON_03530019": "obsolete: grade of meat not known",
    "NCBITaxon_27697": "Sardina pilchardus",
    "FOODON_03540794": "07940 - other species of genus pleurotus, not elsewhere mentioned (efsa foodex2)",
    "FOODON_03311569": "obsolete: red bean (cooked, canned)",
    "NCBITaxon_662062": "Paratrachichthys trailli",
    "FOODON_03541581": "15810 - jostaberries (efsa foodex2)",
    "FOODON_03413824": "flagfin family",
    "FOODON_03316918": "pastilles",
    "FOODON_00002276": "stew or hash",
    "FOODON_03310951": "hen egg (whole, boiled, shell off, salted)",
    "FOODON_03420290": "obsolete: bulb",
    "FOODON_03542391": "23910 - wolffish (efsa foodex2)",
    "FOODON_03543611": "36110 - sacred lotus infusion flowers (efsa foodex2)",
    "FOODON_00001112": "ovine dairy food product",
    "FOODON_03414080": "white skate",
    "FOODON_03401008": "10000271 - vegetables - prepared/processed (perishable) (gs1 gpc)",
    "FOODON_03307017": "peach cherry-flavored canned",
    "FOODON_03304781": "beef ball in sauce",
    "FOODON_03530137": "gite arriere",
    "FOODON_03544345": "43450 - pear flavour (efsa foodex2)",
    "FOODON_03307405": "red oyster (raw)",
    "NCBITaxon_43311": "Fratercula cirrhata",
    "NCBITaxon_410350": "Clinocardium nuttallii",
    "NCBITaxon_113544": "Arapaima gigas",
    "FOODON_03305993": "fruit pie filling (artificially sweetened)",
    "NCBITaxon_88209": "Cancer productus",
    "FOODON_03306164": "prune juice (date concentrate added)",
    "FOODON_00002881": "short grain rice (whole)",
    "FOODON_03316070": "chorizo",
    "FOODON_03543407": "34070 - arabian coffee beans (efsa foodex2)",
    "FOODON_03412385": "speckled flounder",
    "FOODON_00002954": "standing rib roast",
    "FOODON_03315751": "brown bread",
    "FOODON_03544012": "40120 - fruit soup (efsa foodex2)",
    "FOODON_03303755": "milk chocolate (vitamin- and mineral-fortified)",
    "NCBITaxon_214053": "Viola tricolor",
    "GAZ_00002467": "Arabian Peninsula",
    "FOODON_03541008": "10080 - maples (trunk sap) (efsa foodex2)",
    "FOODON_03400870": "dietary supplement (eurofir)",
    "FOODON_03302052": "corn chip",
    "FOODON_03307212": "potato (vacuum-packed)",
    "NCBITaxon_31017": "Ariidae",
    "FOODON_03400626": "CCFAC dairy products, excluding fats and oils, fat emulsions",
    "FOODON_03540486": "04860 - mizuna (efsa foodex2)",
    "NCBITaxon_170817": "Dalatias licha",
    "FOODON_03541738": "17380 - cavendishes - balbisiana cultivars (efsa foodex2)",
    "FOODON_03530002": "dark meat",
    "FOODON_03413371": "silver bream",
    "FOODON_03306780": "cherry pie mix",
    "FOODON_03309102": "rollmop (artificially sweetened)",
    "NCBITaxon_13676": "Scomber japonicus",
    "NCBITaxon_75356": "Mylopharyngodon piceus",
    "FOODON_03412077": "bok choy plant",
    "FOODON_03541176": "11760 - other tree nuts (e) (efsa foodex2)",
    "FOODON_03306774": "pie filling (artificially flavored, colored, canned)",
    "FOODON_03543306": "33060 - soft drink, cherry flavour (efsa foodex2)",
    "FOODON_03305442": "grasshopper (chocolate-covered)",
    "FOODON_00003049": "hummus",
    "FOODON_03302813": "chocolate syrup (artificially flavored with vanillin and colored)",
    "FOODON_03311740": "chicken (mechanically deboned)",
    "FOODON_03543975": "39750 - rice, meat, and vegetables meal (efsa foodex2)",
    "FOODON_00003141": "heart of palm",
    "FOODON_03510244": "omega-3 fatty acids claim or use",
    "FOODON_03544019": "40190 - meat and vegetable soup, clear (efsa foodex2)",
    "NCBITaxon_36185": "Thymallus thymallus",
    "FOODON_03530169": "alcohol content < 1%",
    "FOODON_03510100": "no artificial flavors claim or use",
    "FOODON_03308572": "shrimp meal",
    "FOODON_00001332": "rice powder (roasted)",
    "HANCESTRO_0547": "Togolese",
    "FOODON_03412092": "kangaroo",
    "FOODON_03541351": "13510 - ginger roots and similar- (efsa foodex2)",
    "FOODON_03315139": "gefilte fish patty in packing medium",
    "FOODON_03543354": "33540 - champagne-like wine (efsa foodex2)",
    "FOODON_03541813": "18130 - jam, cranberries (efsa foodex2)",
    "NCBITaxon_110923": "Jasus frontalis",
    "FOODON_03413432": "woodruff plant",
    "FOODON_03541707": "17070 - marulas (efsa foodex2)",
    "FOODON_03541353": "13530 - fingerrot roots (efsa foodex2)",
    "FOODON_03305052": "hen egg yolk (cooked)",
    "FOODON_03307704": "shrimp cocktail sauce",
    "FOODON_03411234": "porgy",
    "FOODON_03400155": "fruit butter, jelly, preserve or related product (us cfr)",
    "FOODON_03413366": "roe deer",
    "FOODON_03303742": "candy (fruit-type)",
    "NCBITaxon_376657": "Mustelus schmitti",
    "FOODON_03413687": "spot pangasius",
    "FOODON_00003249": "pancetta",
    "FOODON_03302056": "vanilla bean (whole, raw)",
    "FOODON_03541872": "18720 - canned or jarred peach (efsa foodex2)",
    "FOODON_03414096": "rough ray",
    "FOODON_03301649": "grape jelly (artificially sweetened)",
    "FOODON_03541051": "10510 - field (maple) pea (fresh seeds) (efsa foodex2)",
    "FOODON_03460259": "rehydration process",
    "FOODON_00001286": "turkey meat food product",
    "FOODON_03414797": "gould's goanna",
    "NCBITaxon_173323": "Elagatis",
    "FOODON_03310707": "chocolate cake mix, devil's food",
    "NCBITaxon_78060": "Parmeliaceae",
    "FOODON_03541036": "10360 - lima beans (without pods) (efsa foodex2)",
    "FOODON_03308138": "langostino (canned)",
    "HANCESTRO_0461": "Syrian",
    "NCBITaxon_3525": "Phytolaccaceae",
    "FOODON_03542178": "21780 - blood and tongue sausage (efsa foodex2)",
    "FOODON_03304948": "fish chowder soup base",
    "CHEBI_17522": "alditol",
    "FOODON_03401217": "partially skimmed cheese (codex)",
    "PO_0009064": "receptacle",
    "FOODON_03304557": "rice (talc-coated)",
    "ENVO_01000815": "liquid environmental material",
    "FOODON_03306847": "papaya leaf (dried)",
    "FOODON_03308006": "herring roe (raw)",
    "FOODON_03541200": "12000 - canola seeds (efsa foodex2)",
    "CHEBI_38106": "organosulfur heterocyclic compound",
    "FOODON_03414304": "australian round lime plant",
    "FOODON_03306385": "ginger and lemon marmalade",
    "FOODON_03401789": "10006121 - beetroot (gs1 gpc)",
    "FOODON_03542646": "26460 - dried cephalopods (efsa foodex2)",
    "FOODON_03311184": "herring creamed",
    "FOODON_03542191": "21910 - meat specialties (efsa foodex2)",
    "FOODON_03543148": "31480 - butter (efsa foodex2)",
    "FOODON_03303537": "port salut cheese",
    "NCBITaxon_8166": "Perca",
    "NCBITaxon_424573": "Physaleae",
    "NCBITaxon_54906": "Albuliformes",
    "FOODON_03542161": "21610 - pepperoni/paprika-type sausage (efsa foodex2)",
    "FOODON_03544194": "41940 - balsamic vinegar flavour (efsa foodex2)",
    "CHEBI_51959": "organic tricyclic compound",
    "FOODON_03544110": "41100 - sauces from fermented/hydrolised sources and similar (efsa foodex2)",
    "FOODON_00001016": "cabbage food product",
    "FOODON_03411243": "marlin",
    "FOODON_03412422": "climbing perch family",
    "FOODON_03401369": "50260200 - bulb vegetables (gs1 gpc)",
    "FOODON_03411774": "canary rockfish",
    "NCBITaxon_13587": "Lepidocybium flavobrunneum",
    "FOODON_03315667": "formulated liquid diets",
    "FOODON_03543399": "33990 - coconut cream liqueur (efsa foodex2)",
    "FOODON_03306148": "black currant juice",
    "FOODON_00003135": "mulberry (whole, raw)",
    "FOODON_03303432": "beef brisket (pit barbeque cooked)",
    "FOODON_03306154": "grapefruit juice (sweetened)",
    "FOODON_03316171": "tomato (dried)",
    "FOODON_03411624": "amphibian",
    "FOODON_03544139": "41390 - pickles (efsa foodex2)",
    "NCBITaxon_306945": "Annona senegalensis",
    "FOODON_03430140": "whole, shape achieved by forming, thickness 0.3-1.5 cm.",
    "FOODON_03401558": "10006036 - truffles (gs1 gpc)",
    "FOODON_03302268": "lemon and lime carbonated beverage (vitamin-fortified)",
    "FOODON_03317280": "ground beef patty (pregrilled)",
    "FOODON_03414316": "finger millet plant",
    "NCBITaxon_2889": "Alaria esculenta",
    "FOODON_00001071": "grape must",
    "FOODON_03307375": "distilled vinegar (apple-flavored)",
    "FOODON_03308330": "maine sardine (packed in oil)",
    "NCBITaxon_150431": "Panulirus ornatus",
    "FOODON_03540365": "03650 - lettuces (generic) (efsa foodex2)",
    "FOODON_03510129": "\"free\" label claim",
    "FOODON_03308756": "count oyster (raw)",
    "FOODON_03415154": "yellow bedstraw plant",
    "NCBITaxon_369968": "Micromesistius australis",
    "FOODON_03460294": "curing or aging 12 months or over",
    "FOODON_00001089": "corn flour food product",
    "FOODON_03540730": "07300 - lovage roots (efsa foodex2)",
    "FOODON_03317318": "pork picnic (cooked, cured)",
    "FOODON_03413155": "mono- and diacetyl tartaric acid esters of mono- and diglycerides of fatty acids",
    "HANCESTRO_0405": "Cuban",
    "FOODON_03412352": "common rye plant",
    "FOODON_03305349": "mustard made with beer (prepared)",
    "FOODON_00002286": "sugar based cacao food product",
    "NCBITaxon_48169": "Thunnus tonggol",
    "FOODON_03544272": "42720 - gin flavour (efsa foodex2)",
    "FOODON_03307578": "turkey pie",
    "FOODON_03413915": "southern yellow croaker",
    "FOODON_00002139": "plant fat or oil refined food product",
    "FOODON_03302103": "beef jerky",
    "FOODON_03401155": "10000021 - shellfish - unprepared/unprocessed (shelf stable) (gs1 gpc)",
    "FOODON_03303353": "chicken chow mein",
    "FOODON_03543286": "32860 - fruit soft drink, grape white (efsa foodex2)",
    "FOODON_03530275": "red flesh",
    "FOODON_03310075": "wheat starch",
    "FOODON_03401626": "10006304 - emu - prepared/processed (gs1 gpc)",
    "NCBITaxon_103819": "Mycteroperca",
    "NCBITaxon_34816": "Morone saxatilis",
    "NCBITaxon_155231": "Sideritis",
    "FOODON_03301729": "cheesecake",
    "FOODON_03412286": "harvestfish",
    "NCBITaxon_9689": "Panthera leo",
    "FOODON_03411380": "vegetable corn plant",
    "FOODON_03301002": "whole wheat kernel (raw, dried)",
    "FOODON_03309354": "pearl millet kernel (raw)",
    "NCBITaxon_3625": "Actinidia chinensis",
    "FOODON_03414523": "swift",
    "FOODON_03412860": "arctic grayling",
    "FOODON_03310290": "kefir",
    "FOODON_03400120": "neutral distilled spirits (us cfr)",
    "FOODON_03541893": "18930 - mammals msm (efsa foodex2)",
    "NCBITaxon_95602": "Eriocheir sinensis",
    "FOODON_03543722": "37220 - cocoa beverages (efsa foodex2)",
    "FOODON_03316362": "coating cream for zwieback",
    "FOODON_03412608": "plumed scorpionfish",
    "FOODON_03542481": "24810 - lumpfish roe (efsa foodex2)",
    "FOODON_03544421": "44210 - liquorice extract (efsa foodex2)",
    "FOODON_00001744": "cloudberry food product",
    "FOODON_03411760": "japan sea bass",
    "HANCESTRO_0021": "Chinese",
    "FOODON_03412057": "rooibos plant",
    "FOODON_03414901": "arachnid",
    "FOODON_03315292": "muk",
    "FOODON_03543823": "38230 - yeast based formulations (efsa foodex2)",
    "FOODON_03307675": "pea soup mix",
    "FOODON_03304427": "chicken and noodles (canned)",
    "FOODON_03400345": "propellant (ec)",
    "NCBITaxon_648166": "Etmopterus spinax",
    "FOODON_03317343": "poultry (ground, formed, cooked)",
    "FOODON_03541653": "16530 - desert dates (efsa foodex2)",
    "FOODON_00002435": "dandelion food product",
    "FOODON_03543445": "34450 - non-fermented tea leaves (green or white tea) (efsa foodex2)",
    "FOODON_00002759": "adzuki bean substance",
    "FOODON_00003148": "pork steak",
    "NCBITaxon_128017": "Dimocarpus longan",
    "FOODON_03530194": "fat content > 60%",
    "FOODON_03304317": "crispbread (starch-reduced)",
    "NCBITaxon_8516": "Iguana",
    "FOODON_00001186": "buckewheat food product",
    "FOODON_03542561": "25610 - squids (efsa foodex2)",
    "FOODON_03305684": "imitation food (dish)",
    "NCBITaxon_458610": "Seriolella porosa",
    "FOODON_00001037": "vacherin mont dor cheese food product",
    "FOODON_03541233": "12330 - tucum seeds (efsa foodex2)",
    "FOODON_03306901": "peanut (whole, roasted)",
    "FOODON_03543156": "31560 - shortening and similar baking fats (efsa foodex2)",
    "FOODON_03413113": "guanylic acid",
    "FOODON_03413975": "island mackerel",
    "FOODON_03543386": "33860 - spirits made from fruits other than stone fruits (efsa foodex2)",
    "CHEBI_15948": "lycopene",
    "CHEBI_51026": "macrocycle",
    "FOODON_03315724": "pan coating (vegetable oil-based)",
    "FOODON_03301136": "brown rice food product",
    "FOODON_03413213": "potassium lactate",
    "FOODON_03302403": "beverage (carbonated, amino acid-fortified)",
    "FOODON_03543403": "34030 - ingredients for coffee, cocoa, tea, and herbal infusions (efsa foodex2)",
    "FOODON_03541502": "15020 - sour cherries (efsa foodex2)",
    "FOODON_03302685": "wheat bread (cellulose added, enriched)",
    "NCBITaxon_8175": "Sparus aurata",
    "FOODON_03413309": "tocopherol-rich extract",
    "FOODON_03305494": "horseradish (prepared)",
    "CHEBI_27081": "transition element atom",
    "FOODON_03308791": "sea bass fillet (raw)",
    "FOODON_03543340": "33400 - dark ale beer (efsa foodex2)",
    "FOODON_03305089": "food bar (caffeine added)",
    "FOODON_03311583": "mate (liquid)",
    "FOODON_03544097": "40970 - alcoholic sauce (efsa foodex2)",
    "FOODON_03543539": "35390 - rock rose infusion leaves (efsa foodex2)",
    "FOODON_03400881": "10000144 - alcoholic pre-mixed drinks (gs1 gpc)",
    "FOODON_03544377": "43770 - spearmint flavour (efsa foodex2)",
    "FOODON_03400815": "pasta and similar products (eurofir)",
    "FOODON_03541524": "15240 - sloes (efsa foodex2)",
    "NCBITaxon_139272": "Strobus",
    "NCBITaxon_320587": "Prionotus",
    "FOODON_00001705": "celery vegetable food product",
    "FOODON_03317206": "vitamin and mineral concentrate, tablet form",
    "FOODON_03301569": "alfalfa flour",
    "FOODON_03540382": "03820 - roman rocket and similar- (efsa foodex2)",
    "CHEBI_88184": "metal allergen",
    "FOODON_03541449": "14490 - limes and similar- (efsa foodex2)",
    "FOODON_03543042": "30420 - gianduja chocolate (efsa foodex2)",
    "FOODON_03315827": "sandwich spread (unstandardized)",
    "FOODON_03542918": "29180 - cheese, stilton (efsa foodex2)",
    "FOODON_03510193": "low alcohol claim or use",
    "FOODON_03312069": "ham (boneless)",
    "FOODON_03309345": "pacific silver hake (raw)",
    "NCBITaxon_94328": "Zingiber officinale",
    "UO_0000110": "pascal",
    "FOODON_03470115": "surface pasteurization or disinfection by ultraviolet irradiation",
    "FOODON_03401318": "botanical supplement with mineral(s)",
    "FOODON_03309580": "vinegar blend",
    "NCBITaxon_171969": "Carnegiea gigantea",
    "FOODON_03304961": "cream of toheroa soup",
    "PO_0025471": "seedling cotyledon",
    "FOODON_03540402": "04020 - nightshade, black (efsa foodex2)",
    "FOODON_03307036": "idaho russet potato (whole, raw)",
    "FOODON_03411441": "haddock",
    "ENVO_01001244": "cropland ecosystem",
    "FOODON_03542779": "27790 - cheese, saint marcellin (efsa foodex2)",
    "FOODON_03414812": "giant mangrove whelk",
    "FOODON_03309259": "silver carp (raw)",
    "FOODON_03311705": "obsolete: cereal not further specified",
    "FOODON_03530004": "light meat",
    "FOODON_03305041": "sweet potato flakes",
    "FOODON_03316329": "obsolete: mayonnaise substitute",
    "FOODON_03541847": "18470 - fruit dessert thickened (efsa foodex2)",
    "FOODON_03310326": "cooking oil (polyunsaturated)",
    "NCBITaxon_1579337": "Durocryptodira",
    "FOODON_00002433": "citron melon food product",
    "FOODON_03401664": "10006289 - goose - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03303579": "mozzarella cheese (low-moisture, part-skim)",
    "FOODON_03543121": "31210 - pork lard (efsa foodex2)",
    "FOODON_03411216": "lotus plant",
    "NCBITaxon_210590": "Ophidion <bony fishes>",
    "FOODON_03411528": "edible currant plant",
    "FOODON_03413246": "sodium calcium polyphosphate",
    "FOODON_03303072": "lime juice (frozen)",
    "FOODON_03316809": "vermicelli (milk)",
    "FOODON_03510065": "nutrition-related claim or use",
    "FOODON_03413000": "ammonium phosphatides",
    "FOODON_03310663": "mayonnaise-type product (reduced calorie)",
    "FOODON_03311631": "baked good",
    "FOODON_03541473": "14730 - apples (efsa foodex2)",
    "NCBITaxon_2231393": "50 kb inversion clade",
    "FOODON_03311054": "cherry soft drink",
    "FOODON_00001856": "fish soup",
    "FOODON_00003102": "star fruit food product",
    "NCBITaxon_24663": "Physalis",
    "NCBITaxon_84644": "Labeo",
    "FOODON_03301909": "mint tea (dry)",
    "FOODON_03308543": "scallop (calico bay, raw)",
    "FOODON_03401832": "10006372 - water chestnuts (gs1 gpc)",
    "FOODON_03301479": "prawn (frozen)",
    "FOODON_00002621": "Gamay noir wine",
    "FOODON_03306855": "peanut butter (unsalted)",
    "FOODON_03413454": "danube crayfish",
    "FOODON_03544149": "41490 - chocolate sauce (efsa foodex2)",
    "FOODON_03411947": "iceland scallop",
    "NCBITaxon_42662": "Phoxinus",
    "FOODON_03400467": "CIAA other foods",
    "FOODON_03542120": "21200 - other cured meat (efsa foodex2)",
    "FOODON_03412299": "conger eel",
    "FOODON_03315303": "chocolate (imitation)",
    "FOODON_03306288": "spaghettini macaroni",
    "FOODON_00002511": "navel orange (whole, raw)",
    "FOODON_03530130": "basses-cotes",
    "FOODON_03414519": "western chokeberry plant",
    "FOODON_03302707": "vegetable oil or fat for animal feed",
    "FOODON_03306339": "pasta (wet-packed)",
    "HANCESTRO_0464": "American Samoan",
    "FOODON_03307824": "ham and cheese sandwich",
    "FOODON_03309118": "limpet (raw)",
    "FOODON_03308548": "scallop (deep sea, fried)",
    "FOODON_03302624": "bakery product (containing buttermilk)",
    "FOODON_03309125": "northern pike (raw)",
    "FOODON_03315935": "crustacean paste",
    "FOODON_03302097": "beef tea",
    "FOODON_03414970": "langsat plant",
    "NCBITaxon_515231": "Seriphus politus",
    "ENVO_00002149": "sea water",
    "FOODON_03309723": "seafood sushi",
    "FOODON_03414954": "jostaberry plant",
    "FOODON_03307365": "grape vinegar",
    "hancestro_0003": "obsolete: country",
    "NCBITaxon_86965": "Anguilla nebulosa",
    "FOODON_03460146": "obsolete: starch added",
    "FOODON_03306296": "spinach macaroni",
    "FOODON_03306329": "meat stock (food product)",
    "FOODON_03540354": "03540 - oat popped (efsa foodex2)",
    "PO_0006320": "ear spikelet",
    "FOODON_03302773": "fruitcake (rum butter)",
    "FOODON_03315681": "oil soluble annatto",
    "NCBITaxon_4718": "Nypa fruticans",
    "FOODON_03510075": "rich in fiber claim or use",
    "RO_0009004": "has consumer",
    "BFO_0000030": "object",
    "FOODON_00002988": "white nectarine tree",
    "FOODON_03317108": "root vegetable (canned)",
    "FOODON_03541613": "16130 - dog rose (efsa foodex2)",
    "FOODON_03530008": "cut of meat, u.s.",
    "FOODON_03542049": "20490 - goose kidney (efsa foodex2)",
    "FOODON_03303784": "apple (candied)",
    "FOODON_03301476": "corn dextrin",
    "CHEBI_33966": "elemental silver",
    "FOODON_03540832": "08320 - celery leaves and similar- (efsa foodex2)",
    "FOODON_03302047": "blackberry jelly (food product)",
    "NCBITaxon_2135392": "Myzopsetta",
    "NCBITaxon_40255": "Modiolus",
    "FOODON_03411013": "plant used for producing extract or concentrate",
    "FOODON_00003368": "food contact material",
    "FOODON_00001616": "apricot preserve or jam food product",
    "FOODON_03414211": "elderberry plant",
    "FOODON_03317000": "konbu (dried)",
    "FOODON_03540689": "06890 - kakrol (efsa foodex2)",
    "FOODON_03411214": "nutmeg plant",
    "FOODON_03308755": "oyster (standard, raw)",
    "FOODON_03304754": "swiss cheeseburger",
    "CHEBI_3312": "calcium dichloride",
    "NCBITaxon_4619": "Marantaceae",
    "PO_0009008": "plant organ",
    "FOODON_03542200": "22000 - mammals or birds dried meat (efsa foodex2)",
    "FOODON_03304558": "brewers' grain flavor (natural)",
    "FOODON_03543421": "34210 - chicory coffee ingredient (efsa foodex2)",
    "FOODON_03301366": "asparagus (frozen)",
    "NCBITaxon_1476529": "Cyclostomata",
    "FOODON_00001791": "cream product analog",
    "FOODON_00002793": "red banana plant (genus Musa)",
    "FOODON_03316896": "infant porridge (powdered)",
    "FOODON_03304311": "chocolate (for cooking)",
    "NCBITaxon_99572": "Jasus lalandii",
    "FOODON_03542140": "21400 - preserved/processed fat tissues (efsa foodex2)",
    "NCBITaxon_163127": "Arripidae",
    "FOODON_03301085": "shrimp (canned)",
    "FOODON_03309131": "rockfish fillet (raw)",
    "FOODON_03412072": "red cabbage plant",
    "FOODON_03305626": "herbal honey",
    "FOODON_03304446": "beef pepperpot (dry mix)",
    "FOODON_03301281": "prune (pitted, uncooked, dehydrated)",
    "FOODON_03420228": "extract, concentrate or isolate of plant or animal",
    "FOODON_03304266": "butter and egg noodle (new england-style)",
    "FOODON_03309288": "argentine fish fillet (raw)",
    "FOODON_03317353": "pie dough (fresh)",
    "NCBITaxon_630662": "Coelorinchus kaiyomaru",
    "FOODON_03307314": "blackeyed peas with ham (ham fat, and ham broth)",
    "FOODON_03490208": "multicontainer package",
    "FOODON_03305529": "honey (artificially flavored)",
    "NCBITaxon_376534": "Triticum turgidum subsp. turanicum",
    "FOODON_03412708": "brill",
    "FOODON_03541345": "13450 - chinese cassia bark (efsa foodex2)",
    "NCBITaxon_245079": "Lepas anserifera",
    "FOODON_03301443": "lima bean (fresh, frozen)",
    "FOODON_03544182": "41820 - almond flavour (efsa foodex2)",
    "HANCESTRO_0008": "Asian",
    "FOODON_03400880": "10000589 - alcoholic cordials/syrups (gs1 gpc)",
    "FOODON_03544508": "45080 - polyphenols (efsa foodex2)",
    "FOODON_03542411": "24110 - menhaden (efsa foodex2)",
    "FOODON_03412308": "snakehead",
    "FOODON_03543527": "35270 - white mulberry infusion leaves (efsa foodex2)",
    "FOODON_03303360": "chestnut (pieces, canned, in vanilla-flavored syrup)",
    "FOODON_03308799": "okra shrimp gumbo mix",
    "FOODON_03401148": "50122100 - shellfish prepared/processed (gs1 gpc)",
    "FOODON_03542854": "28540 - cheese, tilsit (efsa foodex2)",
    "FOODON_03413051": "calcium sorbate",
    "FOODON_03541862": "18620 - canned or jarred fruit (efsa foodex2)",
    "FOODON_03412575": "sand shrimp",
    "FOODON_03542442": "24420 - capelin (efsa foodex2)",
    "FOODON_03414772": "heliotrope plant",
    "FOODON_03309586": "shrimp (whole and broken, canned)",
    "FOODON_03544255": "42550 - curry flavour (efsa foodex2)",
    "FOODON_00001878": "frozen dairy dessert",
    "FOODON_03540401": "04010 - papaya leaves (efsa foodex2)",
    "CHEBI_25529": "pyridinecarboxamide",
    "FOODON_03305466": "grape drink (artificially colored)",
    "HANCESTRO_0473": "New Caledonian",
    "FOODON_03315626": "pickle mustard",
    "FOODON_03413401": "sword-bean plant",
    "FOODON_03543123": "31230 - buffalo tallow (efsa foodex2)",
    "FOODON_00003398": "food (harvested)",
    "FOODON_03541523": "15230 - prunus nadia\u00ae (efsa foodex2)",
    "FOODON_03541639": "16390 - miscellaneous fruits (generic) (efsa foodex2)",
    "FOODON_03530259": "food content range (eurocode2)",
    "FOODON_03302784": "nondairy coffee creamer",
    "FOODON_03411508": "american cranberry plant",
    "FOODON_00002786": "velvet bean (whole)",
    "FOODON_03413077": "dimethyl dicarbonate",
    "FOODON_03316129": "jams, jellies, and marmalades, product similar to",
    "FOODON_03412848": "eubacteriales",
    "FOODON_00002406": "thickness of 0.3 cm or less",
    "FOODON_03530110": "restaurant food preparation process",
    "FOODON_03308731": "tuna loaf",
    "FOODON_03412247": "obsolete: cattle and sheep and goat",
    "FOODON_03303533": "esrom cheese",
    "FOODON_03411961": "kegani crab",
    "NCBITaxon_52969": "Ascophyllum nodosum",
    "FOODON_03306994": "raspberry spread (frozen)",
    "CHEBI_33964": "silver molecular entity",
    "NCBITaxon_1000425": "Pimpinella major",
    "FOODON_03540616": "06160 - goa bean (young pods) (efsa foodex2)",
    "FOODON_03542187": "21870 - cooked bratwurst-type sausage (efsa foodex2)",
    "FOODON_03542945": "29450 - other ice cream and similar (efsa foodex2)",
    "FOODON_03302233": "imitation grape carbonated beverage (artificially sweetened)",
    "FOODON_03304749": "meatloaf sandwich",
    "FOODON_03311338": "rockfish raw",
    "FOODON_03541147": "11470 - macadamia integrifolia (efsa foodex2)",
    "FOODON_03304600": "horseradish (powdered)",
    "FOODON_03544241": "42410 - citrus flavour (efsa foodex2)",
    "FOODON_03307597": "maple-flavored sugar syrup",
    "FOODON_03401003": "50101700 - nuts/seeds - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03541836": "18360 - fruit compote, pear (efsa foodex2)",
    "FOODON_03301491": "sour cream (acidified)",
    "FOODON_03315336": "tahkjoo",
    "FOODON_03542251": "22510 - sorubim catfish (efsa foodex2)",
    "FOODON_03411451": "macadamia plant",
    "FOODON_03317489": "instant tea powder",
    "CHEBI_17188": "nucleoside 5'-monophosphate",
    "FOODON_03316793": "huckleberry (canned)",
    "FOODON_03411675": "greengage plum plant",
    "FOODON_03306051": "copra",
    "FOODON_03310174": "whole grain rye bread",
    "NCBITaxon_73496": "Asparagales",
    "FOODON_03544242": "42420 - coconut flavour (efsa foodex2)",
    "FOODON_03411367": "broad bean plant",
    "FOODON_03412570": "plaice",
    "FOODON_03412377": "black pomfret",
    "FOODON_03316374": "star fruit (dried)",
    "FOODON_00001115": "reindeer dairy food product",
    "NCBITaxon_91896": "Orobanchaceae",
    "FOODON_03310717": "fish (fried)",
    "FOODON_03540342": "03420 - processed maize-based flakes (efsa foodex2)",
    "FOODON_03315715": "whey product (dried)",
    "FOODON_03311635": "mustard greens (canned)",
    "FOODON_03316283": "fish product (in jelly)",
    "FOODON_03413540": "white abalone",
    "FOODON_03411425": "turmeric plant",
    "FOODON_03541330": "13300 - nasturtium pods (efsa foodex2)",
    "FOODON_03510126": "religion- or customs-related claim or use",
    "FOODON_00002253": "soft drink food product",
    "FOODON_03301619": "beer",
    "FOODON_03400893": "10000115 - coffee - instant (gs1 gpc)",
    "FOODON_03413569": "southern king crab",
    "FOODON_03542517": "25170 - akiami paste shrimp (efsa foodex2)",
    "FOODON_03414461": "golden-spoon plant",
    "FOODON_03412541": "mudskipper",
    "FOODON_03540218": "02180 - sweet almond pastry mass (efsa foodex2)",
    "FOODON_03307538": "potato peeling (cooked in corn oil)",
    "NCBITaxon_7959": "Ctenopharyngodon idella",
    "FOODON_00001620": "asparagus vegetable food product",
    "FOODON_03303822": "malt beverage (nonalcoholic)",
    "FOODON_03309242": "sea trout fillet (raw)",
    "FOODON_03311260": "lobster meat (canned, drained)",
    "FOODON_03302068": "blackeyed pea (whole, raw)",
    "HANCESTRO_0362": "Falkland Islander",
    "HANCESTRO_0516": "Seychellois",
    "FOODON_03401386": "50260500 - solanacea/others (gs1 gpc)",
    "NCBITaxon_72901": "Blumea",
    "FOODON_03317344": "poultry (cooked)",
    "FOODON_03542752": "27520 - soft brined cheese (feta type) (efsa foodex2)",
    "FOODON_03542510": "25100 - king crabs (efsa foodex2)",
    "FOODON_03308934": "mullet fillet (canned)",
    "FOODON_03309528": "potato dumpling mix",
    "FOODON_03303573": "manteca cheese",
    "FOODON_03308836": "antarctic centolla crab (raw)",
    "NCBITaxon_290247": "Lutjanus peru",
    "FOODON_03315748": "cheese preparation (grated, unstandardized)",
    "FOODON_03305156": "moreton bay chestnut black bean paste (sweetened)",
    "FOODON_03530182": "fat content > 5%",
    "FOODON_03540615": "06150 - yardlong beans (with pods) (efsa foodex2)",
    "FOODON_03302015": "chicken crackling",
    "FOODON_03541229": "12290 - castor beans (efsa foodex2)",
    "FOODON_03541789": "17890 - arenga westerhoutii fruits (efsa foodex2)",
    "FOODON_03541377": "13770 - ajowan fruit (efsa foodex2)",
    "CHEBI_25409": "monoterpenoid",
    "FOODON_03310125": "cassava flour",
    "FOODON_03470173": "inert atmosphere storage process",
    "NCBITaxon_77113": "Nuphar lutea",
    "FOODON_03303182": "crab (raw)",
    "FOODON_03541321": "13210 - bud spices (efsa foodex2)",
    "FOODON_03303782": "candy made with bourbon whiskey",
    "FOODON_03541967": "19670 - turkey fresh meat (efsa foodex2)",
    "FOODON_03540498": "04980 - sea kale (efsa foodex2)",
    "FOODON_03306249": "maple-flavored cereal",
    "FOODON_03308229": "frigate mackerel (raw)",
    "FOODON_03543634": "36340 - calamus infusion roots (efsa foodex2)",
    "FOODON_00001185": "rice food product",
    "NCBITaxon_44497": "Elseya dentata",
    "NCBITaxon_6741": "Paralithodes camtschaticus",
    "FOODON_00001162": "grape extract",
    "FOODON_03543563": "35630 - rooibos and similar- (efsa foodex2)",
    "FOODON_03315314": "pudding mix (artificially sweetened)",
    "NCBITaxon_7937": "Anguilla japonica",
    "FOODON_03302904": "corn flakes",
    "FOODON_03305142": "poultry (frozen)",
    "FOODON_03543030": "30300 - table-top sweeteners in powder form (efsa foodex2)",
    "FOODON_03400829": "starchy root or potato (eurofir)",
    "FOODON_03315791": "beverage concentrate (fruit-flavored)",
    "NCBITaxon_114287": "Scolymus hispanicus",
    "FOODON_03310025": "persipan",
    "FOODON_03413557": "gulf stone crab",
    "NCBITaxon_4006": "Linum usitatissimum",
    "FOODON_03413050": "calcium silicate",
    "FOODON_03412653": "angelfish",
    "FOODON_03412631": "yellow bell pepper plant",
    "FOODON_03304911": "vegetable soup",
    "FOODON_03310493": "greater amberjack (raw)",
    "FOODON_03401073": "50192300 - desserts/dessert sauces/toppings (gs1 gpc)",
    "FOODON_03541410": "14100 - candied or sugar preserved nuts (efsa foodex2)",
    "FOODON_03305313": "brown gravy",
    "FOODON_03541739": "17390 - common banana - paradisiaca cultivars (efsa foodex2)",
    "FOODON_00002181": "quail egg food product",
    "FOODON_03542571": "25710 - sea urchins (efsa foodex2)",
    "FOODON_03411736": "sesbania plant",
    "NCBITaxon_6818": "Euphausia",
    "NCBITaxon_189389": "Trachurus picturatus",
    "NCBITaxon_260143": "Syzygium samarangense",
    "CHEBI_47778": "glyceride",
    "FOODON_00001319": "pak kard dong",
    "FOODON_03308228": "barracuda (raw)",
    "HANCESTRO_0478": "Samoan",
    "FOODON_03401757": "10006191 - square tapering sweet peppers (peg top) (gs1 gpc)",
    "FOODON_03308078": "shrimp creole (dish)",
    "FOODON_03302449": "butter substitute",
    "FOODON_03315906": "vegetable drink",
    "FOODON_00002304": "swine snack food",
    "FOODON_03520507": "highlands climatic zone",
    "FOODON_03415059": "korean bramble plant",
    "FOODON_03414731": "dainty-bird orchid plant",
    "FOODON_03420174": "obsolete: part of plant",
    "FOODON_03316790": "boysenberry (canned)",
    "FOODON_03311340": "scallion (whole, raw)",
    "FOODON_03305608": "pollock fillet (raw)",
    "FOODON_03460110": "smoke concentrate",
    "FOODON_03315066": "cheese asiago medium",
    "FOODON_00003338": "daily nutrient value",
    "FOODON_00001207": "jack bean (whole, dried)",
    "FOODON_03542693": "26930 - yoghurt (efsa foodex2)",
    "FOODON_00003040": "fruit (whole)",
    "FOODON_03530183": "fat content < 5%",
    "FOODON_03412753": "fish, petromyzontiform",
    "FOODON_03304113": "tomato solids in tomato sauce (salt-free)",
    "FOODON_03307802": "tempeh (dehydrated)",
    "FOODON_03520499": "continental climatic zone",
    "FOODON_03414155": "european bison",
    "FOODON_03315146": "glaze",
    "FOODON_03540183": "01830 - dried durum pasta (efsa foodex2)",
    "FOODON_03316825": "macaroni (wheat and soy)",
    "FOODON_00001196": "pigeon pea (whole, dried)",
    "FOODON_03310843": "bread coating from frozen food",
    "FOODON_03301731": "washed curd cheese",
    "FOODON_00002615": "Tempranillo grape plant",
    "CHEBI_22984": "calcium atom",
    "FOODON_03316041": "sauce (non-emulsified)",
    "CHEBI_26020": "phosphate",
    "NCBITaxon_9893": "Giraffa",
    "FOODON_03544096": "40960 - tartar sauce (efsa foodex2)",
    "FOODON_03302790": "sauce (walnut-flavored)",
    "FOODON_03305454": "black currant (frozen)",
    "FOODON_03309517": "herring fillet (raw)",
    "FOODON_03401486": "10006155 - endive (broad leaf) (gs1 gpc)",
    "NCBITaxon_8204": "Anarhichas lupus",
    "FOODON_03309347": "whiting fillet (frozen)",
    "NCBITaxon_376798": "Phalaris canariensis",
    "FOODON_03305559": "grapefruit juice (canned)",
    "NCBITaxon_7945": "Muraenesox",
    "FOODON_03316818": "vermicelli (vegetable)",
    "FOODON_03543966": "39660 - pasta, cooked, with vegetables and cheese/cream (efsa foodex2)",
    "FOODON_03413978": "indo-pacific king mackerel",
    "FOODON_00002556": "wagyu steak",
    "FOODON_03301193": "fish (raw)",
    "FOODON_03303752": "candy (vitamin- and mineral-fortified)",
    "FOODON_03540514": "05140 - barley sprouts (efsa foodex2)",
    "FOODON_03414947": "chinese pear plant",
    "FOODON_03542846": "28460 - cheese, raschera (efsa foodex2)",
    "FOODON_03543153": "31530 - blended fat and oils (efsa foodex2)",
    "GAZ_00003985": "British Indian Ocean Territory",
    "FOODON_03411701": "lupine bean plant",
    "FOODON_00001248": "fish food product",
    "FOODON_03304735": "flounder (raw)",
    "FOODON_03412306": "japan pepper plant",
    "FOODON_03544044": "40440 - snacks other than chips and similar (efsa foodex2)",
    "FOODON_03544501": "45010 - chromium (efsa foodex2)",
    "CHEBI_16449": "alanine",
    "FOODON_03415062": "muntry plant",
    "ENVO_01000928": "fish processing building",
    "FOODON_03303665": "gloucester cheese",
    "NCBITaxon_6453": "Haliotis corrugata",
    "FOODON_03542537": "25370 - green mussel (efsa foodex2)",
    "FOODON_03540194": "01940 - glass noodle (efsa foodex2)",
    "FOODON_03420301": "liver oil",
    "GAZ_00002284": "North Sea",
    "FOODON_03413674": "sydney cupped oyster",
    "FOODON_03414209": "cranberry plant",
    "FOODON_03541283": "12830 - other dried herbs (efsa foodex2)",
    "FOODON_03480021": "packed in vegetable oil",
    "FOODON_03307369": "field peas with snap beans (canned)",
    "FOODON_03510219": "food allergen labelling about soybeans and products thereof",
    "FOODON_03460372": "cellulose derivative",
    "FOODON_03541729": "17290 - yellow sapotes (efsa foodex2)",
    "ENVO_00000027": "spring",
    "FOODON_03411020": "fish, acipenseriform",
    "FOODON_03309639": "king crab (frozen)",
    "FOODON_03415014": "purplestem taro plant",
    "FOODON_03541079": "10790 - guar beans (dry) (efsa foodex2)",
    "FOODON_03544340": "43400 - passion fruit flavour (efsa foodex2)",
    "FOODON_03413087": "disodium guanylate",
    "FOODON_03401252": "0840000 - spices, roots or rhizome (ec)",
    "FOODON_03415145": "moldavian dragonhead plant",
    "FOODON_03542234": "22340 - roaches (efsa foodex2)",
    "FOODON_03541546": "15460 - boysenberries (efsa foodex2)",
    "FOODON_03413981": "papuan seerfish",
    "GAZ_00011337": "Kosovo",
    "FOODON_03317159": "lemon tea (no added energy-containing sweetener, powdered)",
    "FOODON_03310430": "nutritional drink mix, lowfat, freeze-dried",
    "FOODON_03307477": "malt-flavored syrup",
    "FOODON_03401674": "10005798 - ostrich - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03301905": "grape beverage (sparkling, less than 3% alcohol)",
    "FOODON_03310889": "obsolete: yeast pressed",
    "FOODON_00002939": "horn and hoof meal",
    "FOODON_03542836": "28360 - cheese, nisa (efsa foodex2)",
    "ENVO_00002006": "liquid water",
    "NCBITaxon_13397": "Carcharodon carcharias",
    "HANCESTRO_0382": "Portugese",
    "FOODON_03301167": "yellowfin tuna (canned)",
    "FOODON_03316569": "vegetable (pickled in barrels)",
    "FOODON_03304488": "flour (granular)",
    "CHEBI_59698": "phosphoric acids",
    "FOODON_03543323": "33230 - energy drinks (efsa foodex2)",
    "FOODON_03309163": "red porgy (raw)",
    "CHEBI_24913": "isoprenoid",
    "FOODON_03510092": "starch-related claim or use",
    "FOODON_03540313": "03130 - millet rolled grains (efsa foodex2)",
    "NCBITaxon_8059": "Pollachius",
    "FOODON_03414140": "american crayfish family",
    "FOODON_03413248": "sodium carboxy methyl cellulose",
    "FOODON_03411951": "eastern oyster",
    "FOODON_03315734": "confection mix, dry",
    "NCBITaxon_67771": "Callipepla californica",
    "FOODON_03510242": "polyunsaturated fat claim or use",
    "FOODON_03540035": "00350 - oat grain (efsa foodex2)",
    "FOODON_03411362": "rock bass",
    "FOODON_03301695": "shrimp (packaged)",
    "FOODON_03541379": "13790 - cardamom fruit and similar- (efsa foodex2)",
    "NCBITaxon_6544": "Bivalvia",
    "FOODON_03543426": "34260 - fig coffee ingredient (efsa foodex2)",
    "NCBITaxon_3251": "Lycopodium",
    "FOODON_03411327": "acacia (genus) plant",
    "FOODON_03542473": "24730 - flounder roe (efsa foodex2)",
    "NCBITaxon_436001": "Alectis indica",
    "FOODON_03303347": "navy bean chowder",
    "FOODON_03317557": "cornmeal porridge (processed, canned)",
    "CHEBI_17154": "nicotinamide",
    "FOODON_03304742": "cheesecake (frozen)",
    "FOODON_03540949": "09490 - dried vegetables (efsa foodex2)",
    "FOODON_03480015": "packed with aerosol propellant",
    "FOODON_03544077": "40770 - taste enhancing rpc extracts (efsa foodex2)",
    "FOODON_03415176": "dracontomelon plant",
    "ENVO_01000924": "plumbing drain",
    "FOODON_00002438": "elk food product",
    "FOODON_03304366": "brown sugar and dextrose",
    "FOODON_03520514": "southern ocean fishing area",
    "FOODON_03544037": "40370 - potato crisps from potato slices (efsa foodex2)",
    "FOODON_03310712": "potato (cooked, refrigerated, commercially prepared)",
    "NCBITaxon_69128": "Atherinidae",
    "FOODON_03490206": "husk wrapper",
    "FOODON_03304415": "cheese thin cracker (dietetic)",
    "HANCESTRO_0477": "Pitcairn Islander",
    "FOODON_00003289": "tonka bean food product",
    "FOODON_03420182": "seed germ",
    "FOODON_03302227": "beverage base (lime)",
    "FOODON_03542272": "22720 - perch, european (efsa foodex2)",
    "FOODON_03510153": "very low sodium claim or use",
    "FOODON_03317469": "fruit porridge",
    "FOODON_03315142": "liver and fat of poultry (uncooked)",
    "FOODON_03413144": "magnesium trisilicate",
    "NCBITaxon_452416": "Origanum onites",
    "FOODON_03317014": "fruit juice concentrate (sweetened)",
    "FOODON_03413405": "pachira tree",
    "FOODON_03316383": "candied plant parts",
    "FOODON_03542285": "22850 - bluegill sunfish, or bluegill bream (efsa foodex2)",
    "HANCESTRO_0338": "Tajikistani",
    "FOODON_03317066": "crustacean product (fully preserved)",
    "FOODON_03304004": "mongolian sauce",
    "FOODON_03490345": "paper combined material",
    "FOODON_00003308": "winged bean pod",
    "FOODON_03306441": "steak and kidney pie filling",
    "NCBITaxon_55513": "Pistacia vera",
    "FOODON_03306635": "imitation olive oil",
    "NCBITaxon_171294": "Penaeus californiensis",
    "FOODON_03310636": "obsolete: light cream",
    "FOODON_03317269": "knockwurst",
    "CHEBI_23888": "drug",
    "FOODON_03301289": "pear nectar",
    "FOODON_03315675": "pineapple marmalade with pectin",
    "FOODON_03310665": "vanilla frozen dessert reduced calorie with aspartame",
    "FOODON_03307955": "clam (fried)",
    "FOODON_03412864": "blue ling",
    "FOODON_03311380": "peanut butter sandwich (freeze-dried)",
    "FOODON_03302168": "beverage base (fruit-flavored)",
    "NCBITaxon_50595": "Spondyliosoma cantharus",
    "FOODON_03304981": "frozen dairy dessert (nutritively sweetened)",
    "RO_0002500": "causal agent in process",
    "NCBITaxon_571675": "Kunzea pomifera",
    "FOODON_03540706": "07060 - baby corn (efsa foodex2)",
    "FOODON_03400974": "10000600 - processed cereal products variety packs (gs1 gpc)",
    "FOODON_03543146": "31460 - sheep milk fat (efsa foodex2)",
    "FOODON_03510169": "noncarbonated claim or use",
    "FOODON_00001578": "albacore food product",
    "FOODON_03543820": "38200 - protein and amino acids supplements (efsa foodex2)",
    "FOODON_03315677": "fish marinated or similar (cold-processed, packaged)",
    "FOODON_03308532": "sea snail (canned)",
    "NCBITaxon_241364": "Odax pullus",
    "FOODON_00002672": "chicken nugget",
    "FOODON_03306843": "papaya concentrate",
    "FOODON_03412082": "hibiscus plant",
    "FOODON_00001866": "food concentrate product",
    "FOODON_03305322": "pear juice (concentrated)",
    "NCBITaxon_37036": "Larus dominicanus",
    "FOODON_03460156": "obsolete: molasses added",
    "FOODON_03412957": "hard-fleshed cherry plant",
    "FOODON_03304146": "tomato catsup (low-sodium)",
    "FOODON_03309095": "hake fillet (raw)",
    "FOODON_03412785": "giant granadilla plant",
    "FOODON_03301061": "corn syrup",
    "FOODON_03310875": "almond butter",
    "FOODON_03317115": "confectionery (cocoa-based, no added sugar)",
    "FOODON_03540895": "08950 - lesser calamint (efsa foodex2)",
    "FOODON_03543281": "32810 - diet soft drinks with fruit juice (efsa foodex2)",
    "FOODON_03520466": "midwestern states",
    "FOODON_03301631": "herbal tea (dry)",
    "FOODON_03412115": "echinoderm",
    "FOODON_03414973": "abyssinian mustard plant",
    "FOODON_03317171": "shrimp (peeled, deep-frozen)",
    "FOODON_03301246": "date (whole)",
    "FOODON_03542340": "23400 - sole (efsa foodex2)",
    "FOODON_03542810": "28100 - cheese, danbo (efsa foodex2)",
    "FOODON_00001152": "melon fruit food product",
    "FOODON_03316462": "fruit powder",
    "FOODON_03305609": "cow milk (pasteurized)",
    "NCBITaxon_9005": "Phasianidae",
    "FOODON_03544253": "42530 - cumin flavour (efsa foodex2)",
    "NCBITaxon_278733": "Menticirrhus",
    "FOODON_03544237": "42370 - chocolate dark flavour (efsa foodex2)",
    "FOODON_03305739": "grape drink mix (dry)",
    "FOODON_03414257": "gold-of-pleasure plant",
    "FOODON_03411614": "vaccinium berry plant",
    "NCBITaxon_255893": "Eremophila <eudicots>",
    "FOODON_03412179": "red cod",
    "FOODON_03460225": "food component addition process",
    "FOODON_03307413": "mineral water (alkaline, bottled)",
    "FOODON_03414045": "grayling genus",
    "CHEBI_53276": "poly(styrene)",
    "FOODON_03412550": "ancho pepper plant",
    "FOODON_03307620": "fruit (freeze-dried)",
    "FOODON_03542711": "27110 - viili (efsa foodex2)",
    "NCBITaxon_92049": "Macruronus",
    "FOODON_03541040": "10400 - runner beans (without pods) (efsa foodex2)",
    "FOODON_03306094": "cola fountain syrup",
    "FOODON_03540155": "01550 - crisp bread, wheat, refined flour (efsa foodex2)",
    "FOODON_03490374": "polypropylene container",
    "FOODON_03411183": "sheep",
    "FOODON_03542529": "25290 - oysters (efsa foodex2)",
    "NCBITaxon_115588": "Galatheoidea",
    "RO_0002219": "surrounded by",
    "FOODON_03413343": "curled lettuce plant",
    "FOODON_03413084": "disodium 5'-ribonucleotides",
    "NCBITaxon_19952": "Valeriana",
    "FOODON_03414340": "lemon myrtle plant",
    "FOODON_03316388": "apple (raw, peeled, pieces, for commercial bakery use)",
    "FOODON_03460355": "chocolate coating or covering process",
    "NCBITaxon_30944": "Hippoglossoides",
    "FOODON_03315689": "distiller's mash",
    "NCBITaxon_141264": "Rachycentron canadum",
    "ENVO_00003864": "bakery",
    "FOODON_03413600": "china lobster",
    "NCBITaxon_4055": "Gentianales",
    "FOODON_03304880": "melon seed (dried)",
    "FOODON_03305005": "tomato pulp",
    "NCBITaxon_72430": "Cambarinae",
    "FOODON_03304814": "mountain water (food product)",
    "FOODON_03542189": "21890 - bockwurst (efsa foodex2)",
    "FOODON_03302093": "beef turnover",
    "FOODON_03542748": "27480 - cheese, mizithra (efsa foodex2)",
    "GAZ_00002939": "Poland",
    "FOODON_03543303": "33030 - soft drink, apple flavour (efsa foodex2)",
    "FOODON_03401525": "10006355 - squash (calabaza) (gs1 gpc)",
    "FOODON_03414831": "bungadinnia plant",
    "FOODON_03301032": "corn relish",
    "FOODON_03307986": "eelpout (raw)",
    "NCBITaxon_3699": "Brassicales",
    "FOODON_03542971": "29710 - processed eggs (efsa foodex2)",
    "FOODON_03542767": "27670 - cheese, vacherin mont d'or (efsa foodex2)",
    "GAZ_00003202": "Macau",
    "FOODON_03304511": "seafood newburg (dish)",
    "FOODON_03543856": "38560 - moussaka (efsa foodex2)",
    "FOODON_03544065": "40650 - pickling spice (efsa foodex2)",
    "FOODON_03413332": "climbing fig plant",
    "FOODON_03303832": "butterfat (lipolyzed)",
    "FOODON_03308658": "clam (surf, raw)",
    "FOODON_03305864": "imitation strawberry jam",
    "FOODON_03411667": "sheanut tree",
    "FOODON_03304455": "protein loaf",
    "FOODON_03540006": "00060 - barley grains (efsa foodex2)",
    "FOODON_03543627": "36270 - big-leaf linden infusion flowers (efsa foodex2)",
    "FOODON_03542324": "23240 - milkfish (efsa foodex2)",
    "FOODON_03305745": "apple juice (artificially colored, canned)",
    "CHEBI_61120": "nucleobase-containing molecular entity",
    "FOODON_03316444": "candy type product (compressed)",
    "FOODON_03415142": "jiaogulan plant",
    "FOODON_03315809": "confection (liquid-centered)",
    "FOODON_03541746": "17460 - mangoes (efsa foodex2)",
    "FOODON_03541579": "15790 - haskaps (efsa foodex2)",
    "FOODON_03413631": "pacific seabob",
    "FOODON_03310592": "beef patty with mushroom (raw)",
    "FOODON_03543807": "38070 - food supplements and similar preparations (efsa foodex2)",
    "NCBITaxon_58327": "Rhodeus sericeus",
    "FOODON_03543260": "32600 - coconut milk powder (efsa foodex2)",
    "FOODON_03315117": "clam (cooked, canned)",
    "FOODON_03540231": "02310 - suet pastry (p\u00e2te a grasse de boeuf) dough (efsa foodex2)",
    "FOODON_03400898": "10000313 - fruit herbal infusions - ready to drink (gs1 gpc)",
    "FOODON_03412131": "triggerfish",
    "FOODON_03401798": "10006125 - jerusalem artichokes (gs1 gpc)",
    "FOODON_03411771": "olive rockfish",
    "FOODON_03304531": "chocolate malted milk",
    "RO_0002350": "member of",
    "FOODON_03303632": "prune juice",
    "FOODON_03302853": "mung bean sprout (canned)",
    "NCBITaxon_38010": "Lepadidae",
    "FOODON_03490416": "polyamide container",
    "GAZ_00002959": "Estonia",
    "NCBITaxon_159738": "Macrobrachium australiense",
    "NCBITaxon_115715": "Vigna subterranea",
    "FOODON_03400849": "wine, fortified wine or wine-like beverage (eurofir)",
    "http://www.geneontology.org/formats/oboInOwl#hasDbXref": "database cross reference",
    "FOODON_03302247": "fountain syrup (artificially sweetened)",
    "FOODON_03540521": "05210 - radish sprouts (efsa foodex2)",
    "FOODON_03315194": "cheese spread with fruits vegetables or meats pasteurized",
    "HANCESTRO_0023": "Mongolian",
    "FOODON_03309236": "lisita (raw)",
    "FOODON_03412837": "desert date plant",
    "FOODON_03413676": "kumamoto oyster",
    "FOODON_03316735": "cod fillet (quick-frozen)",
    "NCBITaxon_26766": "Myricaceae",
    "FOODON_03305106": "tomato catsup (artificially-sweetened)",
    "FOODON_03305220": "chocolate fudge sandwich cookie",
    "FOODON_03308425": "lobster meat (cooked, frozen in can)",
    "FOODON_03420298": "gum (plant derived substance)",
    "FOODON_03304953": "vegetable soup (thick)",
    "FOODON_03542729": "27290 - whey powder (efsa foodex2)",
    "FOODON_03317553": "perry (aromatized)",
    "FOODON_03412186": "unicorn filefish",
    "FOODON_03412998": "ammonium hydrogen carbonate",
    "NCBITaxon_1008370": "Amomum subulatum",
    "FOODON_03302788": "glucose syrup",
    "FOODON_00002184": "radish food product",
    "FOODON_03317376": "beef with barbecue sauce",
    "FOODON_03401628": "10005773 - goat - prepared/processed (gs1 gpc)",
    "NCBITaxon_71610": "Hedychium coronarium",
    "FOODON_03414415": "cassia gum",
    "FOODON_03541680": "16800 - chinese persimmons (efsa foodex2)",
    "FOODON_00002780": "pigeon pea food product",
    "FOODON_03411203": "dove",
    "FOODON_03302154": "imitation lemon juice beverage base (food product)",
    "FOODON_03308407": "fish fillet (in tomato sauce)",
    "FOODON_03308847": "crabmeat (flaked)",
    "FOODON_03412495": "ant (insect)",
    "FOODON_03540096": "00960 - groats (efsa foodex2)",
    "FOODON_03542628": "26280 - canned/jarred fish (efsa foodex2)",
    "NCBITaxon_118175": "Nettastomatidae",
    "FOODON_03540627": "06270 - winged pea (young pods) (efsa foodex2)",
    "FOODON_03543131": "31310 - turkey fat, processed (efsa foodex2)",
    "FOODON_03543663": "36630 - carobs and similar- (efsa foodex2)",
    "FOODON_03540472": "04720 - brussels sprouts (efsa foodex2)",
    "FOODON_03316376": "kumquat dried",
    "FOODON_03450039": "food reheating by dry heat",
    "FOODON_03315615": "fruit food product",
    "FOODON_03306209": "margarine (soft)",
    "FOODON_03540171": "01710 - breadcrumbs (efsa foodex2)",
    "GAZ_00002719": "Croatia",
    "FOODON_03301518": "sweet potato (canned)",
    "FOODON_03301014": "grape wine",
    "NCBITaxon_88676": "Cyttus",
    "FOODON_03310851": "peanut (whole, dried)",
    "FOODON_03311715": "comfrey root",
    "FOODON_03311684": "giardiniere pickle",
    "NCBITaxon_472403": "Allium canadense",
    "FOODON_03305193": "ginseng candy",
    "NCBITaxon_33090": "Viridiplantae",
    "FOODON_03301169": "shrimp (frozen)",
    "NCBITaxon_91836": "malvids",
    "FOODON_03411891": "dory family",
    "FOODON_03540986": "09860 - other tropical root and tuber vegetables (efsa foodex2)",
    "FOODON_03308429": "gulf menhaden (raw)",
    "FOODON_03411925": "roach (fish)",
    "FOODON_03306337": "meat (packaged)",
    "FOODON_03305450": "imitation rainbow ice lemon- and cherry-flavored frozen",
    "CHEBI_37808": "butane",
    "FOODON_03307952": "clam juice",
    "FOODON_03306466": "buffalo meat (raw)",
    "FOODON_03490148": "paperboard container with paper liner",
    "FOODON_00001263": "bu-du",
    "FOODON_00001741": "citrus nectar beverage",
    "FOODON_03301353": "peanut pod",
    "FOODON_03304572": "rose hip jelly",
    "FOODON_03302744": "cucumber (canned)",
    "FOODON_03541144": "11440 - filberts (efsa foodex2)",
    "FOODON_03541017": "10170 - potato flour (efsa foodex2)",
    "FOODON_03541807": "18070 - jam, raspberries (efsa foodex2)",
    "FOODON_00003253": "moussaka",
    "FOODON_03302170": "carob powder",
    "FOODON_03401613": "10005823 - meat substitutes  (frozen) (gs1 gpc)",
    "GAZ_00005285": "Kuwait",
    "FOODON_03413855": "redear sardine",
    "FOODON_03541454": "14540 - tahiti limes (efsa foodex2)",
    "FOODON_03401365": "50290100 - vegetables - unprepared/unprocessed (frozen) (gs1 gpc)",
    "NCBITaxon_4329": "Macadamia",
    "NCBITaxon_94993": "Silurus glanis",
    "FOODON_00002102": "pear juice food product",
    "FOODON_03301224": "cinnamon stick",
    "FOODON_03303188": "corn grits (enriched)",
    "FOODON_03304422": "vanilla creme pudding",
    "FOODON_03420111": "skin or bran (pericarp)",
    "FOODON_00002887": "yellow bean plant",
    "FOODON_03541322": "13220 - cloves buds and similar- (efsa foodex2)",
    "FOODON_03540103": "01030 - bulgur (efsa foodex2)",
    "FOODON_03543926": "39260 - sandwich with fish topping/filling (efsa foodex2)",
    "FOODON_03413790": "palmaria",
    "FOODON_03310775": "pizza food product",
    "FOODON_03541592": "15920 - worcesterberries (efsa foodex2)",
    "FOODON_03413649": "california cockle",
    "FOODON_03317143": "dessert in pressurised container",
    "FOODON_03413743": "king oyster mushroom",
    "FOODON_00003101": "star fruit (whole)",
    "NCBITaxon_19205": "Lepidium",
    "FOODON_03414999": "marigold plant (Tagetes)",
    "FOODON_03411850": "pacific round herring",
    "FOODON_00002686": "spiny lobster",
    "FOODON_03310023": "tapioca chip",
    "FOODON_03412840": "incense tree",
    "FOODON_00002805": "turkey (whole, raw)",
    "FOODON_03311218": "pecan meal",
    "FOODON_03414761": "swallow wort plant",
    "FOODON_03311300": "black grape (whole, raw)",
    "FOODON_03315024": "beet sugar",
    "FOODON_00001887": "fruit dessert food product",
    "FOODON_00002951": "patty",
    "CHEBI_47622": "acetate ester",
    "NCBITaxon_38654": "Alligator sinensis",
    "FOODON_03543754": "37540 - infant formula, based on protein hydrolysates, powder (efsa foodex2)",
    "FOODON_03301066": "infant formula (powdered)",
    "FOODON_03540329": "03290 - porridge (ready to eat) (efsa foodex2)",
    "FOODON_00002446": "donkey food product",
    "FOODON_03400632": "CCFAC bakery wares",
    "FOODON_03414369": "pekin duck",
    "CHEBI_33229": "vitamin",
    "FOODON_00001961": "ice cow milk food product",
    "UO_0000035": "month",
    "FOODON_03400766": "070  fruit juices (jf) (ccpr)",
    "FOODON_03304265": "spaghetti macaroni (protein-enriched)",
    "NCBITaxon_59861": "Coregonus clupeaformis",
    "FOODON_03305889": "apple jelly",
    "FOODON_03543705": "37050 - coffee (weak strength) beverage (efsa foodex2)",
    "FOODON_03317578": "cow milk (semi-skimmed, sterilized)",
    "FOODON_03315660": "meat binder",
    "FOODON_03544396": "43960 - toffee flavour (efsa foodex2)",
    "FOODON_03305130": "bakery product (creme-filled)",
    "FOODON_03310746": "mace (ground)",
    "UBERON_0000970": "eye",
    "FOODON_03310327": "onion (frozen)",
    "FOODON_03541899": "18990 - asses-mules-hinnies msm (efsa foodex2)",
    "FOODON_03412030": "miracle fruit",
    "PO_0025356": "bulb",
    "FOODON_03306995": "cherry preserves",
    "FOODON_03414783": "indigoberry plant",
    "NCBITaxon_72069": "Sebastes diploproa",
    "FOODON_00003420": "mustard seed (whole)",
    "NCBITaxon_4294": "Aquifoliaceae",
    "FOODON_03541870": "18700 - canned or jarred sweet cherry (efsa foodex2)",
    "FOODON_03543086": "30860 - dessert halva (efsa foodex2)",
    "FOODON_03306242": "beverage base (lemonade-flavored, dry)",
    "FOODON_03541297": "12970 - celery seed (efsa foodex2)",
    "FOODON_03540352": "03520 - barley popped (efsa foodex2)",
    "FOODON_03316317": "jam substitute",
    "FOODON_03316338": "fruit (cooked)",
    "FOODON_03544067": "40670 - savoury extracts and sauce ingredients (efsa foodex2)",
    "FOODON_03414143": "razor shell family",
    "FOODON_03307605": "fruit (packed in fruit juice)",
    "FOODON_03307399": "walleye (raw)",
    "NCBITaxon_68535": "Casimiroa edulis",
    "FOODON_03310669": "candy (artificially colored)",
    "FOODON_03400313": "obsolete: semisoft cheese (codex)",
    "CHEBI_33405": "hydracid",
    "FOODON_03401260": "1030000 - birds eggs (ec)",
    "FOODON_03312027": "turnover not further specified",
    "FOODON_03400919": "10000220 - juice - ready to drink (shelf stable) (gs1 gpc)",
    "FOODON_03307996": "atlantic salmon (raw)",
    "FOODON_03401091": "10000295 - grain based products / meals - not ready to eat - savoury (perishable) (gs1 gpc)",
    "FOODON_00001986": "kidney bean food product",
    "FOODON_03414305": "australian finger lime plant",
    "FOODON_03303796": "pastille (artificially fruit-flavored, dietetic)",
    "FOODON_03543051": "30510 - foamed sugar products (marshmallows) (efsa foodex2)",
    "FOODON_03510188": "adult human as food consumer",
    "FOODON_03303387": "french endive (raw)",
    "FOODON_03311508": "beef trim",
    "FOODON_03540675": "06750 - bur gherkins (efsa foodex2)",
    "FOODON_03307002": "chestnut (canned, in water)",
    "FOODON_03415143": "prostrate knotweed plant",
    "FOODON_03411346": "quail",
    "FOODON_03543175": "31750 - juice, grapefruit (efsa foodex2)",
    "FOODON_03413327": "lesser yam plant",
    "NCBITaxon_9980": "Lepus",
    "NCBITaxon_4429": "Nelumbonaceae",
    "FOODON_03304495": "sorghum flour (food product)",
    "FOODON_00002171": "poultry product based flavoring or seasoning",
    "PO_0025075": "non-vascular leaf",
    "FOODON_03307055": "beef feet (raw)",
    "FOODON_03540787": "07870 - fusarium venenatum (efsa foodex2)",
    "NCBITaxon_8728": "Crotalus",
    "FOODON_03400444": "suspending agent (codex)",
    "FOODON_03413043": "calcium inosinate",
    "FOODON_03306891": "natal plum (whole, raw)",
    "FOODON_03317467": "juice (sweetened)",
    "FOODON_00002133": "vegetarian sandwich",
    "NCBITaxon_47101": "Galega officinalis",
    "FOODON_03310697": "broad bean cake (fried)",
    "FOODON_03413874": "european ling",
    "NCBITaxon_38527": "Abramis brama",
    "FOODON_03302607": "cream (cultured)",
    "FOODON_03302456": "bread made from milk, butter and egg",
    "FOODON_03510011": "food fish as consumer",
    "FOODON_03401041": "obsolete: 10000032 - eggs/eggs substitutes (shelf stable) (gs1 gpc)",
    "FOODON_03310037": "plaa tuu",
    "FOODON_03540263": "02630 - cream cheese cake (efsa foodex2)",
    "FOODON_03310690": "ragi (raw)",
    "FOODON_03317327": "pizza crust",
    "FOODON_03415107": "prince of wales-feather amaranth plant",
    "FOODON_03306667": "imitation maple syrup (artificially sweetened)",
    "GAZ_00005396": "Svalbard Archipelago",
    "FOODON_03541308": "13080 - fennel seed (efsa foodex2)",
    "FOODON_00001254": "plant derived fermented beverage",
    "NCBITaxon_160712": "Hyporthodus acanthistius",
    "FOODON_03411548": "safflower plant",
    "ENVO_02000047": "animal feed",
    "FOODON_03309591": "onion (fried, dehydrated)",
    "FOODON_03540877": "08770 - basils and mints (efsa foodex2)",
    "FOODON_03301212": "savory (dried)",
    "FOODON_03400183": "quick bread, sweetened (us cfr)",
    "FOODON_03310140": "milk (powdered, freeze-dried)",
    "FOODON_03311288": "corn (raw, wet)",
    "FOODON_03543999": "39990 - meat soup (efsa foodex2)",
    "FOODON_03414737": "signalgrass plant",
    "FOODON_00002892": "meringue (dish)",
    "FOODON_03401828": "10006324 - tomato ketchup/ketchup substitutes (perishable) (gs1 gpc)",
    "FOODON_03414874": "fish, characiform",
    "FOODON_03414717": "air potato plant",
    "FOODON_03414457": "cupua\u00e7u plant",
    "FOODON_03401168": "10000212 - herbs/spices (frozen) (gs1 gpc)",
    "FOODON_03311811": "pepperoni spice mix",
    "FOODON_03540570": "05700 - other stem vegetables (efsa foodex2)",
    "FOODON_03306688": "fruit solids",
    "FOODON_03308447": "big-eyed tuna (raw)",
    "NCBITaxon_240832": "Thaleichthys pacificus",
    "FOODON_03401022": "obsolete: 10000009 - meat/poultry/game/batrachian - unprepared/unprocessed (perishable) (gs1 gpc)",
    "FOODON_03303585": "chocolate-flavored dairy drink (artificially sweetened)",
    "FOODON_03310487": "pyracantha berry (raw)",
    "OBI_0000070": "assay",
    "NCBITaxon_7624": "Echinozoa",
    "FOODON_03542793": "27930 - cheese, abondance (efsa foodex2)",
    "FOODON_03541206": "12060 - pumpkin seeds (efsa foodex2)",
    "FOODON_03413214": "potassium malate",
    "FOODON_03309710": "king mackerel (raw)",
    "FOODON_03401044": "10000025 - milk/milk substitutes (perishable) (gs1 gpc)",
    "CHEBI_33836": "benzenoid aromatic compound",
    "FOODON_03412969": "common cranberry plant",
    "CHEBI_26216": "potassium atom",
    "FOODON_03400750": "045  crustaceans (wc) (ccpr)",
    "FOODON_03316263": "soup (sweet)",
    "FOODON_03470126": "aseptic filling and sealing of food",
    "FOODON_03315933": "vegetable in vinegar brine or oil",
    "FOODON_03315541": "breakfast product made from cereals",
    "FOODON_03414019": "dogtooth grouper",
    "FOODON_03308880": "icelandic lichen (food product)",
    "FOODON_03520496": "marina west coast climatic zone",
    "FOODON_03307587": "banana chip",
    "FOODON_03414724": "parakeelya plant",
    "FOODON_03510228": "food allergen labelling about lupine and products thereof",
    "NCBITaxon_260508": "Spirinchus thaleichthys",
    "FOODON_03541509": "15090 - other hybrids of persica vulgaris or prunus persica, not elsewhere mentioned (efsa foodex2)",
    "FOODON_00002728": "Kielbasa",
    "FOODON_03315640": "cheese with added ingredients processed",
    "FOODON_03311296": "pink grapefruit",
    "FOODON_03414421": "sodium carbonates",
    "HANCESTRO_0448": "Qatari",
    "FOODON_03530228": "diarrhetic shellfish poisoning",
    "CHEBI_36358": "polyatomic ion",
    "CHEBI_6636": "magnesium dichloride",
    "NCBITaxon_200939": "Todarodes sagittatus",
    "FOODON_03316676": "fish stick (in batter, quick-frozen)",
    "FOODON_03309511": "fountain syrup",
    "FOODON_03543811": "38110 - mineral only supplements (efsa foodex2)",
    "NCBITaxon_4037": "Apiaceae",
    "FOODON_00003294": "oatmeal raisin cookie",
    "FOODON_03303846": "milk beverage (fermented)",
    "FOODON_03400630": "CCFAC confectionary",
    "FOODON_03401295": "USDA SR restaurant foods (3600)",
    "FOODON_03415023": "filbert plant",
    "FOODON_03510186": "unfortified claim or use",
    "FOODON_00003081": "chinese yam (whole)",
    "FOODON_03315455": "potato (peeled, cooked, mashed, dried)",
    "FOODON_03414955": "golden currant plant",
    "NCBITaxon_120290": "Psidium guajava",
    "FOODON_03401035": "10000188 - cream/cream substitutes (frozen) (gs1 gpc)",
    "FOODON_03301590": "animal feed (processed)",
    "FOODON_03304278": "applesauce (instant)",
    "FOODON_03412133": "moreton bay chestnut plant",
    "FOODON_03401110": "10000252 - popcorn (shelf stable) (gs1 gpc)",
    "FOODON_03401883": "10006460 - glasswort (gs1 gpc)",
    "FOODON_03460202": "obsolete: sweetener added",
    "FOODON_03301185": "mace (dried)",
    "FOODON_03308464": "cooktown salmon (raw)",
    "FOODON_03413354": "norway pout",
    "FOODON_03400977": "50161800 - confectionery products (gs1 gpc)",
    "FOODON_03306457": "mule meat (raw)",
    "GAZ_00004979": "Uzbekistan",
    "FOODON_03543414": "34140 - coffee ground, roasted and decaffeinated (efsa foodex2)",
    "FOODON_03460379": "plant exudate gum",
    "CHEBI_25248": "methyl ester",
    "CHEBI_53448": "methyl cellulose",
    "FOODON_03415144": "lady's mantle plant",
    "NCBITaxon_1184124": "Fragariinae",
    "FOODON_03306755": "piccalilli (food product)",
    "FOODON_03304643": "rhubarb (frozen)",
    "NCBITaxon_8101": "Cyclopteridae",
    "NCBITaxon_8461": "Chelidae",
    "FOODON_03316593": "dinner concentrate",
    "FOODON_00003027": "pomelo fruit",
    "FOODON_03307624": "pear juice (concentrated, acid-reduced)",
    "FOODON_03307304": "wine (homemade)",
    "FOODON_03306416": "pork (smoked)",
    "FOODON_03540972": "09720 - eddoe taros (efsa foodex2)",
    "NCBITaxon_3776": "Cunoniaceae",
    "FOODON_03306286": "chicken soup",
    "FOODON_03542229": "22290 - roho labeo (efsa foodex2)",
    "FOODON_03414696": "copper laurel plant",
    "FOODON_03411596": "stone pine tree",
    "FOODON_03315174": "poultry product",
    "FOODON_03543902": "39020 - beans and meat meal (efsa foodex2)",
    "FOODON_03301610": "sandwich (packaged with nitrogen)",
    "NCBITaxon_9838": "Camelus dromedarius",
    "NCBITaxon_4053": "Panax",
    "FOODON_03542636": "26360 - smoked fish (efsa foodex2)",
    "FOODON_03411977": "fish, tetraodontiform",
    "FOODON_03540189": "01890 - dried stuffed egg pasta (efsa foodex2)",
    "FOODON_03316786": "orange juice with preservative",
    "FOODON_03316605": "milk sweets",
    "FOODON_03530282": "yellow skin",
    "NCBITaxon_8168": "Perca fluviatilis",
    "NCBITaxon_37623": "Ostrea edulis",
    "NCBITaxon_6738": "Anomura",
    "FOODON_00002297": "sweet potato vegetable food product",
    "UBERON_0000178": "blood",
    "FOODON_03305844": "vanilla ice cream (artificially flavored)",
    "FOODON_03541915": "19150 - bovine fresh meat (efsa foodex2)",
    "FOODON_03411262": "fennel plant",
    "NCBITaxon_179534": "Epinephelus caninus",
    "GAZ_00002978": "Nicaragua",
    "FOODON_03312053": "pork (dehydrated)",
    "FOODON_00002379": "flavoring agent by taste",
    "FOODON_03540960": "09600 - potato baked (efsa foodex2)",
    "FOODON_03411213": "nut producing plant",
    "FOODON_03305727": "chocolate cream peppermint",
    "FOODON_03412638": "konbu",
    "NCBITaxon_43707": "Meliaceae",
    "FOODON_03309518": "digestive biscuit",
    "FOODON_03304200": "chicken soup base",
    "FOODON_03543794": "37940 - total daily diet replacement for weight reduction (efsa foodex2)",
    "FOODON_03520500": "warm summer climatic zone",
    "FOODON_03310920": "beef ground round (cooked, freeze-dried)",
    "FOODON_03544393": "43930 - tequila flavour (efsa foodex2)",
    "FOODON_03542547": "25470 - clams, cockles, arkshells (efsa foodex2)",
    "FOODON_03301484": "skim milk food product",
    "FOODON_03309930": "polkudu",
    "FOODON_03307709": "blueberry beverage syrup",
    "FOODON_00001575": "abalone food product",
    "FOODON_03310127": "kola nut (whole, raw)",
    "FOODON_03413301": "tartaric acid esters of mono- and diglycerides of fatty acids",
    "FOODON_03414300": "yellowtail horse mackerel",
    "FOODON_03401847": "10006358 - tamarillo (gs1 gpc)",
    "FOODON_03413466": "hawksbill turtle",
    "FOODON_03401450": "10000623 - beverages variety packs (gs1 gpc)",
    "FOODON_03301068": "ham cure (food product)",
    "FOODON_03309273": "slender sole (raw)",
    "NCBITaxon_13470": "Cyathea",
    "FOODON_03304297": "sugar (raw, unrefined)",
    "FOODON_03315759": "cow milk (concentrated, partly skimmed)",
    "FOODON_03310088": "refried beans (dish)",
    "FOODON_00002103": "pear nectar beverage",
    "FOODON_03400109": "pasteurized process cheese spread (us cfr)",
    "FOODON_03316347": "onion (whole)",
    "FOODON_03540007": "00070 - barley grain, pearled (efsa foodex2)",
    "FOODON_03305143": "fish fillet (frozen)",
    "NCBITaxon_42337": "Bidens pilosa",
    "FOODON_00001206": "lupin seed food product",
    "FOODON_03411134": "mammal",
    "FOODON_00001951": "hops product flavoring",
    "FOODON_03542665": "26650 - ovine milk (efsa foodex2)",
    "FOODON_03420260": "essential oil, oleoresin or other flavoring substance",
    "FOODON_03541563": "15630 - blueberries and similar- (efsa foodex2)",
    "FOODON_03301837": "shrimp (raw)",
    "FOODON_03530141": "aloyau",
    "FOODON_03310677": "mushroom (puree)",
    "FOODON_00002575": "Arborio rice",
    "FOODON_03530079": "processed in copper container",
    "FOODON_03411765": "giant sea bass",
    "FOODON_03303113": "turkish coffee",
    "FOODON_03411975": "slime flounder",
    "FOODON_03541043": "10430 - vetches (without pods) (efsa foodex2)",
    "GAZ_00002878": "State of Delaware",
    "FOODON_03413635": "southern quahog",
    "FOODON_03308863": "chilean stone crab (raw)",
    "FOODON_03308340": "langostino (raw)",
    "FOODON_03542228": "22280 - labeo calbasu (efsa foodex2)",
    "FOODON_03411023": "fish, pleuronectiform",
    "FOODON_03400926": "50202500 - beverages variety packs (gs1 gpc)",
    "FOODON_03411957": "pinkspotted shrimp",
    "FOODON_03307178": "flan",
    "FOODON_03411860": "longhead dab",
    "FOODON_00003290": "multi-component fruit product",
    "FOODON_03307776": "pimiento cheese with olives",
    "FOODON_03401555": "10006032 - morels (gs1 gpc)",
    "FOODON_03542544": "25440 - scallop, queen (efsa foodex2)",
    "FOODON_00003077": "red rice",
    "FOODON_03541290": "12900 - seed spices (efsa foodex2)",
    "FOODON_03460248": "full fat removal process",
    "FOODON_03308768": "cockle (european, raw)",
    "NCBITaxon_2024539": "Lutjaniformes",
    "FOODON_00001881": "frozen yogurt food product",
    "FOODON_03543216": "32160 - mixed vegetable juice (efsa foodex2)",
    "FOODON_03414908": "flint corn plant",
    "FOODON_03412339": "aztec marigold plant",
    "FOODON_03411483": "parsnip plant",
    "FOODON_03304727": "mushroom (sliced, canned)",
    "NCBITaxon_22973": "Chrysobalanaceae",
    "FOODON_03315566": "cream-like product",
    "FOODON_03316234": "cereal containing fat",
    "FOODON_03414957": "native currant plant",
    "FOODON_03480033": "packed in gravy or sauce, dairy or egg component",
    "FOODON_03413220": "potassium saccharin",
    "FOODON_00001665": "broad bean food product",
    "FOODON_00002056": "nevada jointfir beverage",
    "NCBITaxon_7091": "Bombyx mori",
    "GAZ_00002640": "Wales",
    "FOODON_03414952": "red chokeberry plant",
    "FOODON_03544129": "41290 - meat sauce (efsa foodex2)",
    "FOODON_00003353": "glutinous rice flour",
    "FOODON_03302922": "celery heart (raw)",
    "FOODON_03309628": "scallop (canned)",
    "FOODON_03315801": "sausage (dried)",
    "HANCESTRO_0571": "Plains American Indian",
    "FOODON_03301798": "medium cream",
    "FOODON_03315796": "shoulder (prepared)",
    "CHEBI_37578": "halide",
    "NCBITaxon_58501": "Canthium",
    "GAZ_00002635": "Kingdom of Denmark",
    "FOODON_03413577": "norwegian krill",
    "FOODON_03307418": "wheat sprout (juice)",
    "FOODON_03305823": "mince pie filling (frozen)",
    "FOODON_00002560": "Red Delicious apple",
    "FOODON_03309053": "fish and chips",
    "FOODON_03401314": "dietary supplement, multi-vitamin/mineral",
    "FOODON_03401322": "single vitamin and multi-mineral supplement",
    "FOODON_03301802": "eggnog",
    "FOODON_03412549": "anaheim pepper plant",
    "FOODON_03315069": "reggiano cheese (block)",
    "FOODON_03400410": "firming agent (codex)",
    "CHEBI_15956": "biotin",
    "FOODON_03302987": "endive (raw)",
    "FOODON_03316645": "cheese (scalded, caroway)",
    "FOODON_03542212": "22120 - fish (meat) (efsa foodex2)",
    "FOODON_03401184": "10000583 - dressing/dips (frozen) (gs1 gpc)",
    "FOODON_03490344": "paperboard container, surface treated outside",
    "NCBITaxon_90893": "Laminaria hyperborea",
    "HANCESTRO_0363": "French",
    "FOODON_03317381": "cream (pasteurized, fresh)",
    "NCBITaxon_82096": "Eleutherococcus senticosus",
    "FOODON_03308823": "freshwater shrimp (frozen)",
    "FOODON_00002219": "salad food product",
    "FOODON_03543740": "37400 - lemon verbena infusion (efsa foodex2)",
    "FOODON_03311822": "cow whole milk (spray-dried)",
    "FOODON_03543616": "36160 - sweet olive infusion flowers (efsa foodex2)",
    "FOODON_03414883": "icefish",
    "FOODON_03304033": "tomato sauce (with dehydrated chopped onions)",
    "FOODON_03311297": "white grapefruit",
    "FOODON_03307722": "rice syrup (food product)",
    "FOODON_03305047": "fat (enzyme-modified)",
    "PATO_0001018": "physical quality",
    "CHEBI_26188": "polyketide",
    "FOODON_03302989": "cold-pack cheese food",
    "FOODON_03541448": "14480 - citrons (efsa foodex2)",
    "FOODON_00001652": "black walnut food product",
    "FOODON_03540569": "05690 - cabbage palm heart (efsa foodex2)",
    "FOODON_03304412": "cracker (artificially sweetened)",
    "CHEBI_113451": "sodium ascorbate",
    "FOODON_00001982": "kangaroo meat food product",
    "NCBITaxon_53159": "Lamium album",
    "FOODON_03543878": "38780 - omelette with mushrooms (efsa foodex2)",
    "NCBITaxon_179535": "Epinephelus marginatus",
    "FOODON_03303770": "sunflower seed bark (artificially sweetened)",
    "FOODON_03311482": "barley plus grain mixture",
    "NCBITaxon_30759": "Moridae",
    "FOODON_03413725": "fireweed plant",
    "FOODON_03541569": "15690 - aronia berries (efsa foodex2)",
    "NCBITaxon_9925": "Capra hircus",
    "FOODON_03414034": "royal threadfin",
    "FOODON_03307627": "apple (sliced, frozen)",
    "NCBITaxon_6486": "Fasciolariidae",
    "CHEBI_35701": "ester",
    "NCBITaxon_4565": "Triticum aestivum",
    "FOODON_03401608": "10006428 - leaf vegetables - unprepared/unprocessed variety packs (gs1 gpc)",
    "NCBITaxon_97441": "Viola odorata",
    "FOODON_03411193": "sour orange plant",
    "FOODON_03411920": "moth bean plant",
    "FOODON_03542241": "22410 - blue tilapia (efsa foodex2)",
    "FOODON_03316862": "mozzarella cheese (low moisture)",
    "FOODON_03542927": "29270 - cheese, reblochon (efsa foodex2)",
    "RO_0002254": "has developmental contribution from",
    "FOODON_03415020": "chile cocopalm plant",
    "FOODON_03303656": "samsoe cheese (baby)",
    "FOODON_03542146": "21460 - fresh spiced sausages in casing (efsa foodex2)",
    "CHEBI_27027": "micronutrient",
    "FOODON_03315864": "cheese (mold-ripened, packed in hermetically sealed container)",
    "FOODON_03415056": "amur grape plant",
    "NCBITaxon_7949": "Clupea",
    "FOODON_03316824": "vermicelli (whole wheat)",
    "FOODON_03311640": "bon bon",
    "FOODON_03541098": "10980 - chickling vetches (dry) (efsa foodex2)",
    "FOODON_00002732": "food seasoning process",
    "FOODON_03541956": "19560 - hare fresh meat (efsa foodex2)",
    "FOODON_03315067": "asiago cheese (old, block)",
    "FOODON_03305718": "mousse mix (dry)",
    "FOODON_03541582": "15820 - juneberries (efsa foodex2)",
    "FOODON_03317650": "cream (homogenized)",
    "FOODON_03306233": "mint julep",
    "FOODON_03400307": "frozen tofu dessert (us cfr)",
    "FOODON_00001987": "king crab food product",
    "FOODON_03543071": "30710 - chocolate mass (efsa foodex2)",
    "FOODON_03303190": "corn grits (degerminated, enriched)",
    "FOODON_00002128": "plant based gravy or sauce food product",
    "FOODON_00001776": "cow milk cured cheese food product",
    "GAZ_00005811": "Ile Europa",
    "FOODON_03307950": "clam (razor, whole, canned)",
    "FOODON_03305116": "chocolate candy (brandy-filled)",
    "CHEBI_87113": "antibiotic antifungal drug",
    "FOODON_03315970": "confectionery (starch-based, energy reduced)",
    "FOODON_03420183": "sprout",
    "FOODON_00002679": "fish fillet",
    "FOODON_03317491": "meat product (canned)",
    "FOODON_03309234": "white mullet (raw)",
    "FOODON_03310155": "hen egg white (raw)",
    "FOODON_03541015": "10150 - dried potato products (efsa foodex2)",
    "HANCESTRO_0518": "Somali",
    "FOODON_03544521": "45210 - creatine-creatinine (efsa foodex2)",
    "FOODON_03542998": "29980 - glucose (efsa foodex2)",
    "FOODON_03316033": "snack cereal based",
    "FOODON_03301433": "chicken-flavored bouillon cube",
    "ENVO_01000175": "woodland biome",
    "FOODON_03309166": "atlantic croaker (raw)",
    "FOODON_03540405": "04050 - pokeweed (efsa foodex2)",
    "FOODON_03541992": "19920 - pig fat tissue (efsa foodex2)",
    "FOODON_03542053": "20530 - mammals edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "FOODON_03309645": "starry flounder (raw)",
    "FOODON_03315989": "sweet-sour fish (semipreserved)",
    "FOODON_03543218": "32180 - juice, tomato-carrot (efsa foodex2)",
    "FOODON_03540338": "03380 - processed and mixed breakfast cereals (efsa foodex2)",
    "FOODON_03302436": "lemon butter",
    "FOODON_03530056": "white fish flesh",
    "FOODON_03302281": "imitation orange beverage base (vitamin-fortified, artificially-sweetened)",
    "FOODON_03543186": "31860 - juice, lime (efsa foodex2)",
    "FOODON_03543907": "39070 - vegetable based dishes (efsa foodex2)",
    "FOODON_03510206": "source of protein",
    "FOODON_00002246": "snapper food product",
    "NCBITaxon_243120": "Valeriana edulis",
    "FOODON_03303115": "coffee bean (unroasted)",
    "FOODON_03542968": "29680 - hen egg yolk (efsa foodex2)",
    "FOODON_03543050": "30500 - soft candies and analogues (efsa foodex2)",
    "FOODON_03316588": "field corn (grain, glazed)",
    "FOODON_00001830": "eggplant food product",
    "FOODON_03413407": "west indian gherkin plant",
    "FOODON_03411841": "pacific cod",
    "FOODON_03400702": "12  butter and animal fats (efg)",
    "FOODON_03411481": "antelope",
    "GAZ_00059206": "Faroe Islands",
    "BFO_0000024": "fiat object",
    "FOODON_03303363": "chili beans and franks with sauce (food product)",
    "FOODON_03490138": "laminate tube, unlined plastic ends",
    "FOODON_03544112": "41120 - oyster sauce (efsa foodex2)",
    "FOODON_03460795": "obsolete: cellulose added",
    "FOODON_00002935": "venison",
    "GAZ_00003744": "Thailand",
    "FOODON_03305020": "nonfat dry milk (artificially sweetened and flavored)",
    "FOODON_03414838": "illawara plum plant",
    "FOODON_03308394": "fish steak (raw)",
    "FOODON_03302075": "blackeyed pea (canned)",
    "FOODON_03411882": "california halibut",
    "FOODON_03400292": "standardized dressing (us cfr)",
    "NCBITaxon_270551": "Epigonus",
    "FOODON_03306767": "pumpkin pie (baked)",
    "FOODON_03470129": "food sterilization by hot filling, held hot and cooling",
    "FOODON_03309894": "straw",
    "FOODON_03540019": "00190 - canary grass grain (efsa foodex2)",
    "FOODON_03310821": "corn mash (canned)",
    "FOODON_03307507": "citrus juice (canned)",
    "CHEBI_87117": "erythrosin",
    "FOODON_03400107": "bakery product, unsweetened (us cfr)",
    "NCBITaxon_172057": "Centaurium erythraea",
    "FOODON_03412465": "artemiidae shrimp family",
    "FOODON_03306279": "macaroon paste",
    "FOODON_03317538": "marmelade (made with sulfite fruit)",
    "NCBITaxon_4202": "Sambucus nigra",
    "FOODON_03413950": "island jack",
    "FOODON_03301907": "wheat bread crumbs",
    "FOODON_03317250": "root vegetable (frozen)",
    "FOODON_03308766": "cockle (new zealand, raw)",
    "FOODON_03541375": "13750 - caraway fruit and similar- (efsa foodex2)",
    "FOODON_03430137": "sliced",
    "CHEBI_38077": "polypyrrole",
    "FOODON_03306474": "buffalo roast in gravy",
    "FOODON_03450026": "cooking in small amount of fat or oil",
    "FOODON_03304598": "orange juice (unsweetened)",
    "FOODON_03317145": "dip (dairy)",
    "FOODON_03317370": "lemon oil",
    "NCBITaxon_146144": "Decapterus russelli",
    "FOODON_03543400": "34000 - milk liqueur (efsa foodex2)",
    "FOODON_03305431": "frozen dairy dessert mix (instant)",
    "FOODON_03541332": "13320 - dwarf nasturtium pods (efsa foodex2)",
    "FOODON_03400443": "stabilizer (codex)",
    "FOODON_03302631": "butterfat (anhydrous)",
    "FOODON_03301171": "fish (hot process, smoked)",
    "FOODON_03310165": "frankfurter (boiled)",
    "FOODON_03401776": "10006250 - cereals products - not ready to eat (frozen) (gs1 gpc)",
    "FOODON_00003128": "catjang pea (whole, raw)",
    "CHEBI_37010": "ribonucleoside 5'-monophosphate",
    "FOODON_03315880": "hen egg yolk mix (dried)",
    "FOODON_03311869": "peanut sauce",
    "FOODON_03542406": "24060 - herrings (efsa foodex2)",
    "FOODON_03541465": "14650 - mediterranean mandarins (efsa foodex2)",
    "FOODON_03412140": "pearl millet plant",
    "FOODON_03411742": "irish moss",
    "FOODON_03301383": "blackeyed pea (dried)",
    "FOODON_03302524": "butter-flavored cake",
    "FOODON_03303222": "wine product category",
    "ENVO_00000446": "terrestrial biome",
    "FOODON_03308145": "langostino (frozen)",
    "NCBITaxon_13352": "Auxis",
    "FOODON_03401273": "USDA SR baby foods (0300)",
    "FOODON_00001767": "cotton seed food product",
    "FOODON_03540836": "08360 - caraway leaves (efsa foodex2)",
    "FOODON_03305429": "lemon sherbet",
    "PO_0009006": "shoot system",
    "FOODON_03305376": "biscuit (quick bread) mix",
    "FOODON_03510204": "natural source of vitamins and or minerals",
    "CHEBI_28984": "aluminium atom",
    "FOODON_00001583": "alfalfa pellet",
    "FOODON_03303875": "lorraine cheese",
    "FOODON_03317455": "sangria",
    "FOODON_03315966": "nut (coated)",
    "FOODON_03301540": "fruit filling",
    "FOODON_00001011": "milk formula food product",
    "FOODON_03303214": "cracker sandwich (peanut butter and imitation jelly filled)",
    "FOODON_03400928": "50181700 - baking/cooking mixes/supplies (gs1 gpc)",
    "FOODON_03301925": "cod liver (whole, raw)",
    "FOODON_03316111": "cereal protein-based crustacean analog",
    "NCBITaxon_31089": "Osteoglossomorpha",
    "GAZ_00002524": "State of South Carolina",
    "FOODON_00001829": "egg product analog",
    "NCBITaxon_72630": "Pachygrapsus",
    "FOODON_03400819": "unleavened bread, crisp bread and rusk (eurofir)",
    "FOODON_03543247": "32470 - juice concentrate, pineapple (efsa foodex2)",
    "FOODON_03317639": "goat milk (powdered, skimmed)",
    "CHEBI_35186": "terpene",
    "FOODON_03420175": "skeletal meat part",
    "NCBITaxon_8484": "Malaclemys",
    "FOODON_03400394": "contaminant (codex)",
    "FOODON_00002134": "plant based seafood product analog",
    "FOODON_03315829": "raisin (seeded)",
    "NCBITaxon_7860": "Rhinobatidae",
    "FOODON_03543646": "36460 - mexican valerian infusion roots (efsa foodex2)",
    "FOODON_03414060": "golden trout",
    "FOODON_03301087": "salmon (canned)",
    "FOODON_03542019": "20190 - horse liver (efsa foodex2)",
    "FOODON_03414538": "pine bolete",
    "FOODON_03541020": "10200 - legumes, nuts, oilseeds and spices (efsa foodex2)",
    "FOODON_03400357": "CIAA food classification for food additives",
    "NCBITaxon_346999": "Senna siamea",
    "FOODON_03315622": "bakers margarine",
    "FOODON_03304484": "flour (instantized)",
    "FOODON_03401175": "50171900 - pickles/relishes/chutneys/olives (gs1 gpc)",
    "FOODON_03309872": "soya press cake",
    "FOODON_03542410": "24100 - sprat (efsa foodex2)",
    "FOODON_03412409": "coelenterate",
    "FOODON_03310643": "chewing gum",
    "FOODON_00002291": "sugar cane food product",
    "NCBITaxon_172268": "Argyrosomus",
    "FOODON_03306548": "raspberry nectar",
    "FOODON_03310689": "cookie dough",
    "FOODON_03542645": "26450 - dried shrimps and prawns (efsa foodex2)",
    "FOODON_03302098": "corned beef hash",
    "FOODON_03315752": "jenever gin",
    "FOODON_03303109": "imitation coffee substitute",
    "NCBITaxon_224270": "Diplectrum formosum",
    "FOODON_03543695": "36950 - other herbal infusion materials from any other parts of the plant (efsa foodex2)",
    "FOODON_03302643": "butter (salted)",
    "FOODON_03401323": "multi-vitamin and single mineral supplement",
    "FOODON_03415116": "lemon savory plant",
    "FOODON_03304046": "curry sauce",
    "NCBITaxon_7957": "Carassius auratus",
    "FOODON_03412021": "black morel",
    "FOODON_03460114": "water removal to reconstitution ratio 1 plus 1",
    "FOODON_03400649": "01  fruits (ccpr)",
    "FOODON_03401738": "10005955 - babacos (gs1 gpc)",
    "NCBITaxon_319435": "Caulolatilus",
    "NCBITaxon_4414": "Euryale ferox",
    "FOODON_03401540": "10006212 - eggs products/substitutes (gs1 gpc)",
    "FOODON_03412124": "onderdonk grape plant",
    "FOODON_03414832": "johnson's satinash plant",
    "CHEBI_32149": "sodium sulfate",
    "FOODON_00001243": "animal lipid food product",
    "FOODON_03540270": "02700 - baumkuchen and similar (efsa foodex2)",
    "FOODON_03400783": "fermented milk product (eurofir)",
    "FOODON_03490329": "rubber container",
    "NCBITaxon_7899": "Acipenseriformes",
    "FOODON_03510265": "structure/function claim",
    "PATO_0002301": "decreased quality",
    "FOODON_03544301": "43010 - lemon flavour (efsa foodex2)",
    "FOODON_03414094": "long-nosed skate",
    "NCBITaxon_180766": "Vaccinium parvifolium",
    "FOODON_03303087": "coconut (sweetened, dried)",
    "FOODON_03302576": "sugar (artificially vanilla-flavored)",
    "FOODON_03542305": "23050 - trouts (efsa foodex2)",
    "FOODON_03401877": "10005916 - stonefruit hybrids (gs1 gpc)",
    "GO_0008150": "biological_process",
    "FOODON_03302343": "cornbread",
    "CHEBI_17623": "cyclomaltodextrin",
    "FOODON_03302118": "berry (frozen)",
    "FOODON_03542989": "29890 - brown beet sugar (efsa foodex2)",
    "ENVO_01000155": "organic material",
    "FOODON_00002979": "wild turkey",
    "FOODON_03401328": "dietary supplement, fibre",
    "FOODON_03414070": "ocean sunfish",
    "FOODON_03305825": "corned beef (canned)",
    "FOODON_03307770": "egg salad sandwich",
    "FOODON_03401651": "10006296 - wild boar - prepared/processed (gs1 gpc)",
    "FOODON_03420225": "egg (without shell)",
    "NCBITaxon_59756": "Metanephrops",
    "PO_0030091": "capsule fruit",
    "FOODON_03401710": "10006437 - cassia (gs1 gpc)",
    "CHEBI_22958": "butenedioic acid",
    "FOODON_03414303": "native rosella plant",
    "FOODON_03413395": "java apple plant",
    "FOODON_03400994": "50250000 - fruits - unprepared/unprocessed (fresh) (gs1 gpc)",
    "FOODON_03490425": "screw cap or lid",
    "FOODON_03309705": "niger seed (food product)",
    "FOODON_03401745": "10006219 - pasta/noodles variety packs (gs1 gpc)",
    "FOODON_03490348": "metalized paper coextruded with plastic",
    "FOODON_03411953": "obsolete: ocean quahog",
    "FOODON_03541458": "14580 - calamondins (efsa foodex2)",
    "FOODON_03543560": "35600 - yarrow infusion leaves (efsa foodex2)",
    "GAZ_00002611": "State of Georgia",
    "FOODON_00001287": "mushroom",
    "FOODON_03460277": "food hydrolyzation process",
    "FOODON_03540778": "07780 - spirulina (platensis) (efsa foodex2)",
    "FOODON_03315484": "flour paste for confectioneries",
    "FOODON_00002315": "tomato condiment",
    "FOODON_03306002": "cow milk (powdered)",
    "FOODON_03310105": "cauliflower leaf (raw)",
    "FOODON_03500035": "food-grade wood surface",
    "FOODON_03401560": "10006228 - grain based products / meals variety packs (gs1 gpc)",
    "NCBITaxon_45181": "Mitchella repens",
    "CHEBI_35741": "glycerolipid",
    "NCBITaxon_39414": "Plantago lanceolata",
    "FOODON_03401034": "50132000 - cream/cream substitutes (gs1 gpc)",
    "FOODON_03401753": "10006100 - elongated sweet peppers (pointed) (gs1 gpc)",
    "FOODON_03414373": "common vetch plant",
    "FOODON_03315337": "shellfish (dried)",
    "FOODON_03316910": "beverage made with wine and cider",
    "FOODON_03311803": "fruit jelly (dietetic)",
    "FOODON_03542653": "26530 - cow milk (efsa foodex2)",
    "NCBITaxon_1235682": "Glebocarcinus amphioetus",
    "FOODON_03401878": "10006360 - aloe vera (gs1 gpc)",
    "FOODON_03411283": "melon plant",
    "HANCESTRO_0458": "Kosovar",
    "FOODON_03544175": "41750 - inulin and other polyfructoses (efsa foodex2)",
    "FOODON_03311369": "popcorn (microwave with real butter and natural flavors)",
    "FOODON_03311844": "buttermilk ranch salad dressing",
    "NCBITaxon_3663": "Cucurbita pepo",
    "UBERON_0003142": "prepupa",
    "FOODON_00001121": "equine milk beverage",
    "FOODON_03308917": "swedish herring in wine sauce",
    "FOODON_03401394": "50270000 - fruits - unprepared/unprocessed (frozen) (gs1 gpc)",
    "FOODON_03316437": "wheat milling product",
    "FOODON_03544510": "45100 - algae based fortifying agents (e.g. spirulina, chlorella) (efsa foodex2)",
    "FOODON_03412444": "neem plant",
    "NCBITaxon_7806": "Carcharhinus",
    "FOODON_03307983": "anchovy in brine",
    "FOODON_03543899": "38990 - hummus (efsa foodex2)",
    "FOODON_00002898": "king crabmeat",
    "NCBITaxon_48560": "Capreolus pygargus",
    "FOODON_03500012": "noncarbonated beverage can enamel surface",
    "FOODON_03304576": "beverage (carbonated, frozen)",
    "NCBITaxon_3983": "Manihot esculenta",
    "FOODON_00003315": "green field pea plant",
    "FOODON_00003295": "marinara sauce",
    "HANCESTRO_0529": "Congolese",
    "NCBITaxon_179359": "Alectis ciliaris",
    "CHEBI_36963": "organooxygen compound",
    "FOODON_03543613": "36130 - sandy everlasting infusion flowers (efsa foodex2)",
    "FOODON_03317325": "bacon (made with dry curing material)",
    "FOODON_03412234": "whiteleg shrimp",
    "FOODON_03413712": "plantain plant",
    "FOODON_03316134": "cereal and potato-based snack food",
    "FOODON_03304596": "salmi of ring-neck dove (food product)",
    "NCBITaxon_93977": "Osmanthus fragrans",
    "FOODON_03540399": "03990 - balsam pear leaves (efsa foodex2)",
    "FOODON_03415043": "west indian vanilla plant",
    "FOODON_03414522": "swiftlet",
    "FOODON_03530206": "food production",
    "FOODON_03411664": "kiwifruit plant (A. chinensis)",
    "FOODON_03310721": "beechnut (whole, raw)",
    "FOODON_03544030": "40300 - prepared mixed egg/meat/fish/vegetable salad (efsa foodex2)",
    "FOODON_03309243": "turbot fillet (raw, skinless)",
    "NCBITaxon_6595": "Mercenaria",
    "FOODON_03316773": "buttermilk chocolate",
    "FOODON_03420302": "peel oil",
    "FOODON_03303041": "sausage made from meat and poultry (raw)",
    "FOODON_03309991": "food made from cottonseed",
    "FOODON_03470152": "ingredient preservation by irradiation",
    "FOODON_03305720": "shark fin (dried)",
    "FOODON_03411455": "land snail",
    "FOODON_03317367": "beet sugar liquor",
    "FOODON_03308509": "mushroom (sliced, with butter and sherry)",
    "FOODON_03541248": "12480 - jojoba nuts (efsa foodex2)",
    "FOODON_03315281": "gelatin product",
    "FOODON_03543262": "32620 - drinking water (efsa foodex2)",
    "FOODON_03414127": "chola guitarfish",
    "FOODON_03315388": "milk chocolate (carbohydrate modified)",
    "FOODON_03411968": "fish, rajiform",
    "FOODON_03317271": "pork (fresh)",
    "FOODON_03302714": "egg bagel",
    "NCBITaxon_6692": "Pleocyemata",
    "FOODON_03307317": "fish ball with shrimp sauce (canned)",
    "FOODON_03401352": "50350200 - head lettuce (gs1 gpc)",
    "FOODON_03316972": "obsolete: nut food product (unspecified variety)",
    "FOODON_03543311": "33110 - soft drink, mixed flavours (efsa foodex2)",
    "NCBITaxon_34886": "Eumetopias jubatus",
    "FOODON_00001189": "oat food product",
    "FOODON_03304117": "barbeque sauce (western-style)",
    "NCBITaxon_6631": "Nototodarus gouldi",
    "FOODON_03415048": "chinese quince plant",
    "FOODON_03470122": "preservation by ionizing radiation",
    "CHEBI_48857": "sulfite salt",
    "NCBITaxon_113446": "Echium plantagineum",
    "FOODON_03306472": "deer meat with wine sauce",
    "FOODON_03544322": "43220 - mint flavour (efsa foodex2)",
    "FOODON_03310419": "obsolete: algae (food product)",
    "FOODON_03413853": "pilchard",
    "FOODON_03316998": "mitsumame (packed in can)",
    "NCBITaxon_9740": "Phocoenidae",
    "BFO_0000145": "relational quality",
    "FOODON_03540289": "02890 - fruit pie-tarts (efsa foodex2)",
    "NCBITaxon_66913": "Ictalurus furcatus",
    "FOODON_03510037": "reduced salt or sodium claim or use",
    "FOODON_03303679": "cottage cheese with cream dressing",
    "FOODON_03311748": "broccoflower (food product)",
    "FOODON_03309403": "rice krispies cereal",
    "FOODON_03543068": "30680 - basic sweet masses (efsa foodex2)",
    "FOODON_03317610": "balanced diet for special dietary use (children up to 12 years)",
    "FOODON_03540993": "09930 - sugar beet roots and similar- (efsa foodex2)",
    "FOODON_03315743": "hen egg white (delysozymized)",
    "FOODON_03310552": "cherry pepper (hot, raw)",
    "FOODON_03414273": "potassium hydrogen tartrate",
    "FOODON_03305764": "green tomato juice",
    "FOODON_03310137": "millet flour",
    "FOODON_03411807": "skilfish",
    "PO_0030095": "poricidal capsule fruit",
    "FOODON_03303639": "lollipop",
    "NCBITaxon_9970": "Syncerus caffer",
    "FOODON_03400462": "CIAA sugar and honey",
    "CHEBI_3362": "canthaxanthin",
    "FOODON_03541138": "11380 - coconuts and similar- (efsa foodex2)",
    "FOODON_03307615": "vegetable (steamed)",
    "FOODON_03309507": "fruit (raw, frozen)",
    "FOODON_03304285": "red pepper (crushed)",
    "NCBITaxon_703407": "Montiaceae",
    "FOODON_00002455": "food (sliced)",
    "FOODON_03414950": "skunk currant plant",
    "FOODON_03301026": "honey (flavored)",
    "FOODON_03315559": "table salt with reduced sodium content",
    "FOODON_03490260": "plastic gasket",
    "FOODON_03316157": "butilarra fresca",
    "FOODON_00003208": "miso",
    "FOODON_03412242": "obsolete: swine and calf",
    "GAZ_00002586": "State of Wisconsin",
    "NCBITaxon_3728": "Sinapis alba",
    "FOODON_03305607": "herbal beverage",
    "FOODON_03315145": "olive (whole, ripe)",
    "FOODON_03540876": "08760 - winter savory (efsa foodex2)",
    "FOODON_03413705": "keyhole limpet",
    "FOODON_03460326": "bacterial food-curing process",
    "FOODON_03316926": "green bean (canned, spiced)",
    "FOODON_03542051": "20510 - animal blood (efsa foodex2)",
    "FOODON_03530268": "food plant physical quality",
    "FOODON_03302073": "mullet roe salted air-dried",
    "FOODON_03490366": "linear polyester container",
    "FOODON_03316563": "gherkin pickle",
    "FOODON_03307934": "torula yeast (artificially bacon-flavored, smoked, dried)",
    "FOODON_03540117": "01170 - leavened bread and similar (efsa foodex2)",
    "FOODON_03412997": "ammonium carbonate",
    "FOODON_03315359": "twoenjang",
    "FOODON_03308307": "whiting (breaded)",
    "FOODON_03302803": "grated cheese",
    "FOODON_03540057": "00570 - common wheat grain (efsa foodex2)",
    "FOODON_03309560": "spaghetti sauce with meatballs",
    "FOODON_03413468": "obsolete: amphibian or reptile as food source",
    "FOODON_03307484": "imitation blue cheese",
    "FOODON_03301482": "oregano (ground)",
    "FOODON_03308349": "rock lobster (whole, cooked)",
    "FOODON_03311177": "cream puff",
    "FOODON_03302427": "beverage (carbonated, vitamin, mineral and amino acid fortified)",
    "FOODON_03411394": "gooseberry plant",
    "FOODON_03450019": "cooking by braising",
    "FOODON_03304224": "chicken (whole, barbequed)",
    "FOODON_03301755": "distilled vinegar (apple cider-flavored)",
    "FOODON_03303582": "dog biscuit",
    "FOODON_03308302": "rock salmon (raw)",
    "FOODON_03302414": "sparkling beverage",
    "FOODON_03303918": "human milk (raw)",
    "FOODON_03309415": "white kidney bean (whole)",
    "FOODON_03301256": "maraschino cherry",
    "FOODON_03317286": "breading mix (meat-based)",
    "FOODON_03305779": "lemon puree",
    "FOODON_03411070": "blackfin tuna",
    "FOODON_03540944": "09440 - vegetable puree or paste (efsa foodex2)",
    "FOODON_03542690": "26900 - cultured buttermilk (efsa foodex2)",
    "FOODON_03401490": "10006094 - radicchio rosso (gs1 gpc)",
    "FOODON_03301217": "tomato sauce",
    "FOODON_03304045": "white pepper (ground)",
    "FOODON_03303910": "imitation vitamin d milk",
    "FOODON_03401699": "10006826 - non-netted cantaloupe melons (gs1 gpc)",
    "FOODON_03542991": "29910 - brown palm sugar (efsa foodex2)",
    "FOODON_03307105": "animal cookie",
    "FOODON_03544488": "44880 - potassium (efsa foodex2)",
    "FOODON_03543224": "32240 - other mixed fruit and vegetable juices (efsa foodex2)",
    "FOODON_03411067": "lime (citrus) plant",
    "FOODON_00002812": "edible bean pod",
    "FOODON_03310227": "taco shell",
    "FOODON_03542331": "23310 - witch flounder (efsa foodex2)",
    "FOODON_03541796": "17960 - dried apples (efsa foodex2)",
    "FOODON_00002601": "Riesling wine",
    "CHEBI_59554": "medium-chain fatty acid",
    "FOODON_03413594": "japanese lobster",
    "FOODON_03307455": "cow milk (raw)",
    "FOODON_03544346": "43460 - pepper flavour (efsa foodex2)",
    "FOODON_03302549": "zwieback",
    "CHEBI_63409": "pentose derivative",
    "FOODON_03304085": "cream of tomato soup",
    "FOODON_03305886": "chokecherry jelly",
    "FOODON_03311558": "oncom (food product)",
    "NCBITaxon_6534": "Helix",
    "FOODON_03401639": "10005779 - ostrich - prepared/processed (gs1 gpc)",
    "CHEBI_82411": "Brilliant Blue",
    "FOODON_03316318": "bakery product, fine, flat",
    "FOODON_03413869": "pink minnow",
    "FOODON_03305644": "obsolete: beverage (fermented)",
    "NCBITaxon_3297": "Cycadales",
    "FOODON_03308132": "crayfish tail (raw)",
    "CHEBI_35286": "iminium ion",
    "FOODON_03414756": "glorybower plant",
    "GAZ_00005867": "Pitcairn, Henderson, Ducie and Oeno Islands",
    "FOODON_03309228": "snowfish (raw)",
    "NCBITaxon_4724": "Pandanaceae",
    "NCBITaxon_80265": "Elaeis oleifera",
    "GAZ_00002934": "Belize",
    "NCBITaxon_68410": "Moschus",
    "NCBITaxon_7826": "Scyliorhinidae",
    "NCBITaxon_205481": "Pachyrhizus tuberosus",
    "FOODON_03311782": "fish product (asian, containing spice)",
    "FOODON_03301924": "apple (baked)",
    "FOODON_03542267": "22670 - giant gourami (efsa foodex2)",
    "FOODON_03414870": "arapaima",
    "NCBITaxon_217033": "Arbutoideae",
    "NCBITaxon_8056": "Melanogrammus aeglefinus",
    "FOODON_03315647": "gelatin (solid)",
    "FOODON_03460175": "carbonation process",
    "FOODON_03510025": "horse as consumer",
    "FOODON_03317571": "grappa invecchiata",
    "FOODON_03306179": "white grape juice (carbonated)",
    "FOODON_03303909": "cultured dairy product",
    "FOODON_03308775": "giant owl limpet (raw)",
    "FOODON_03414241": "white sapote plant",
    "NCBITaxon_4071": "Capsicum",
    "FOODON_00003026": "drupelet berry food product",
    "FOODON_03302107": "ginger beer soft drink",
    "FOODON_03411128": "sockeye salmon",
    "FOODON_03543034": "30340 - chocolate and similar (efsa foodex2)",
    "FOODON_00002120": "pineapple juice food product",
    "FOODON_03542932": "29320 - processed cheese, spreadable (efsa foodex2)",
    "NCBITaxon_591258": "Nemapteryx nenga",
    "FOODON_03308617": "queen crab (raw)",
    "FOODON_03411444": "chervil plant",
    "FOODON_03305060": "salmon roe (raw)",
    "FOODON_03414776": "tea tree",
    "FOODON_03540882": "08820 - corsican mint (efsa foodex2)",
    "NCBITaxon_9747": "Monodontidae",
    "FOODON_03401377": "50261300 - herbs (gs1 gpc)",
    "FOODON_03541578": "15780 - golden currant (efsa foodex2)",
    "FOODON_03542162": "21620 - chorizo and similar (efsa foodex2)",
    "FOODON_03414287": "porae",
    "FOODON_03301465": "antipasto",
    "FOODON_00002703": "chicken breast",
    "FOODON_03310217": "wheatgrass juice (food product)",
    "FOODON_03543155": "31550 - butter and margarine/oil blends (efsa foodex2)",
    "FOODON_03311753": "obsolete: broiler chicken (not further specified)",
    "FOODON_03304579": "salad cream",
    "FOODON_03542328": "23280 - flounders, halibuts, soles (efsa foodex2)",
    "FOODON_03414064": "river trout",
    "ENVO_01001784": "compound astronomical body part",
    "FOODON_03308256": "atlantic mackerel (raw)",
    "FOODON_03540854": "08540 - root parsley leaves (efsa foodex2)",
    "FOODON_03542101": "21010 - poultry skin (efsa foodex2)",
    "FOODON_03414166": "domestic turkey",
    "FOODON_03307628": "peach (dried)",
    "FOODON_03306715": "fruit (canned, artificially sweetened)",
    "ENVO_00000022": "river",
    "FOODON_03305397": "orange juice (freeze-dried)",
    "FOODON_03411635": "shiitake mushroom",
    "FOODON_03309680": "salmon (end cuts and pieces, raw)",
    "FOODON_03306648": "curry (dish)",
    "FOODON_03304299": "sugar (colored)",
    "FOODON_03413294": "sulphite ammonia caramel",
    "FOODON_03541181": "11810 - peanuts (efsa foodex2)",
    "FOODON_03542914": "29140 - cheese, gorgonzola (efsa foodex2)",
    "FOODON_03411645": "abalone mushroom",
    "NCBITaxon_233707": "Manilkara kauki",
    "UO_0000015": "centimeter",
    "FOODON_03305472": "ice cream sandwich",
    "FOODON_03544106": "41060 - mustard, sweet (efsa foodex2)",
    "FOODON_03400336": "flavour enhancer (ec)",
    "FOODON_03414124": "fish, rhinobatiform",
    "NCBITaxon_87785": "Atherina boyeri",
    "FOODON_03415118": "salvation jane plant",
    "FOODON_03401413": "10005895 - apple bananas (gs1 gpc)",
    "FOODON_03310747": "caraway seed (ground)",
    "FOODON_03302932": "salt block for livestock",
    "FOODON_03400385": "chewing gum base (codex)",
    "FOODON_00003191": "horned melon (whole, raw)",
    "FOODON_03412748": "sea buckthorn plant",
    "FOODON_03303085": "coconut (whole, raw)",
    "FOODON_03316230": "coffee (canned, liquid)",
    "FOODON_03541097": "10970 - asparagus peas (dry) (efsa foodex2)",
    "FOODON_00002265": "soybean seed (field) food product",
    "FOODON_00003246": "prosciutto",
    "FOODON_03510044": "reduced cholesterol claim or use",
    "FOODON_03310870": "corn-based snack food",
    "FOODON_03303620": "imitation lemon juice",
    "FOODON_03414905": "purple amaranth plant",
    "FOODON_03411048": "carbohydrate-producing plant",
    "FOODON_03541959": "19590 - dog meat (efsa foodex2)",
    "NCBITaxon_114280": "Cichorium endivia",
    "FOODON_03308932": "mussel (iceland, raw)",
    "GAZ_00001093": "Cameroon",
    "FOODON_00001915": "gourd food product",
    "FOODON_03460172": "food (smoked or smoke-flavored)",
    "FOODON_03412945": "scurvy-grass plant",
    "FOODON_03301006": "noodle (egg)",
    "GAZ_00000459": "South America",
    "NCBITaxon_476914": "Ammodytes hexapterus",
    "FOODON_03301623": "reconstituted orange juice (pasteurized, from concentrate)",
    "FOODON_03309871": "rice powder",
    "FOODON_03510103": "sweetener-related claim or use",
    "FOODON_03306475": "buffalo goulash (food product)",
    "FOODON_03305051": "pinto bean (whole, dried)",
    "FOODON_03401631": "10006297 - hare - prepared/processed (gs1 gpc)",
    "FOODON_03413486": "great-headed garlic plant",
    "UBERON_0007197": "hermaphroditic organism",
    "FOODON_03540650": "06500 - sweet peppers (efsa foodex2)",
    "FOODON_00001009": "hot dog",
    "FOODON_03307141": "olive (greek-style)",
    "FOODON_03315526": "meat minced",
    "FOODON_03305067": "fenugreek tea (dry)",
    "FOODON_00002694": "canola meal",
    "FOODON_03541432": "14320 - ugli fruits (efsa foodex2)",
    "NCBITaxon_3501": "Urtica dioica",
    "FOODON_00002491": "neet fish food product",
    "FOODON_03311150": "apple drink (canned)",
    "FOODON_03302675": "cambridge diet beverage mix (dry)",
    "CHEBI_25555": "nitrogen atom",
    "FOODON_00001113": "yak dairy food product",
    "FOODON_03400150": "meat or meat product (from mammal) (us cfr)",
    "FOODON_03301033": "royal jelly",
    "FOODON_00003088": "crowberry food product",
    "FOODON_03305265": "cream dressing",
    "FOODON_03540841": "08410 - fenugreek leaves (efsa foodex2)",
    "FOODON_03306293": "wheat and corn macaroni or noodle product",
    "UO_0010047": "united states fda cup",
    "FOODON_03316841": "flour (bromated, enriched)",
    "FOODON_03414633": "river mussel",
    "FOODON_03412796": "arabian mummum plant",
    "NCBITaxon_1549675": "Galloanserae",
    "FOODON_03301505": "evaporated milk",
    "FOODON_03309934": "horse feed",
    "FOODON_00001681": "caper food product",
    "CHEBI_36309": "cyclic tetrapyrrole",
    "FOODON_03411104": "sand seatrout",
    "FOODON_03542760": "27600 - soft-ripened washed-rind cheese (limburger type) (efsa foodex2)",
    "FOODON_03542611": "26110 - processed or preserved fish (including processed offal) (efsa foodex2)",
    "FOODON_00002048": "mushroom pickle food product",
    "FOODON_03315655": "natural extractive",
    "FOODON_03543176": "31760 - juice, pineapple (efsa foodex2)",
    "NCBITaxon_6602": "Myidae",
    "FOODON_03315014": "obsolete: spices seasonings and flavorings",
    "FOODON_03308825": "shrimp (head on, frozen)",
    "NCBITaxon_63459": "Chenopodium quinoa",
    "FOODON_03414846": "kiwiberry",
    "FOODON_03490368": "high density polyethylene container",
    "FOODON_03541292": "12920 - anise seed (efsa foodex2)",
    "FOODON_03401177": "10000587 - chutneys/relishes (perishable) (gs1 gpc)",
    "NCBITaxon_318546": "Pseudocrenilabrinae",
    "FOODON_03541328": "13280 - capers buds and similar- (efsa foodex2)",
    "NCBITaxon_119260": "Cinnamomum aromaticum",
    "FOODON_03306007": "fruit juice (blend, concentrate, frozen)",
    "FOODON_03542675": "26750 - elk milk (efsa foodex2)",
    "FOODON_03316851": "roll or bun (raisin)",
    "CHEBI_53425": "polysorbate 60",
    "NCBITaxon_76912": "Zea mays subsp. parviglumis",
    "FOODON_03412214": "oriental blue crab",
    "FOODON_03411710": "roaster chicken",
    "FOODON_03305285": "breadfruit (whole, raw)",
    "FOODON_03414428": "salt of aspartame-acesulfame",
    "FOODON_03301170": "fish (kippered)",
    "FOODON_03543697": "36970 - leaves used for infusions or hot drinks (efsa foodex2)",
    "NCBITaxon_861760": "Coregonus macrophthalmus",
    "FOODON_03315981": "jam (energy-reduced)",
    "FOODON_03541605": "16050 - currants and similar- (efsa foodex2)",
    "FOODON_03311162": "chocolate milk (raw)",
    "FOODON_03540657": "06570 - aubergines and similar- (efsa foodex2)",
    "NCBITaxon_51383": "Asphodelaceae",
    "CHEBI_48343": "disulfide",
    "FOODON_00002545": "serrano ham",
    "FOODON_03542428": "24280 - swordfish (efsa foodex2)",
    "FOODON_03413316": "tripotassium phosphate",
    "FOODON_03414676": "ximenia plant",
    "FOODON_03310255": "soybean sauce fermented",
    "FOODON_03305961": "huckleberry jelly",
    "FOODON_03412435": "bowfin family",
    "FOODON_03308760": "cockle (cooked, frozen)",
    "FOODON_03543412": "34120 - coffee beans, roasted and decaffeinated (efsa foodex2)",
    "CHEBI_39026": "low-density lipoprotein",
    "FOODON_03542606": "26060 - silkworm (efsa foodex2)",
    "FOODON_03413481": "great atlantic scallop",
    "FOODON_00001929": "grapefruit food product",
    "FOODON_03412320": "atlantic seabob",
    "FOODON_03305953": "grape pulp (concentrated)",
    "FOODON_03413262": "sodium malate",
    "FOODON_03304907": "onion soup (instant)",
    "FOODON_03305184": "rice (enriched)",
    "FOODON_03310764": "obsolete: water ice not further specified",
    "FOODON_03543225": "32250 - mixed juices with added ingredients (efsa foodex2)",
    "NCBITaxon_13428": "Cinnamomum",
    "FOODON_03311412": "beverage (dietetic, not further specified)",
    "FOODON_03307453": "haddock fish stick (frozen)",
    "NCBITaxon_1489869": "Berycimorphaceae",
    "FOODON_03510118": "naturally caffeine free claim or use",
    "NCBITaxon_119261": "Cinnamomum burmannii",
    "FOODON_03411142": "aquatic invertebrate animal (excluding shellfish)",
    "NCBITaxon_316162": "Nematalosa",
    "FOODON_03415160": "peony plant",
    "FOODON_03542113": "21130 - pancetta (efsa foodex2)",
    "FOODON_03543076": "30760 - brittle mass (efsa foodex2)",
    "FOODON_03302783": "imitation catsup mix (artificially sweetened, dry)",
    "FOODON_00001912": "goat milk (pasteurized)",
    "FOODON_03306535": "straw mushroom (raw)",
    "NCBITaxon_9859": "Cervus",
    "FOODON_03308191": "japanese crab (raw)",
    "PATO_0001888": "miscibility",
    "FOODON_03310876": "walnut candy (food product)",
    "FOODON_03301814": "citrus marmalade",
    "FOODON_03400865": "soup (eurofir)",
    "CHEBI_132106": "sodium propionate",
    "FOODON_03305882": "lemon jelly",
    "FOODON_03302538": "butter (individually wrapped in paper carton)",
    "FOODON_03311467": "pork chop (cooked)",
    "FOODON_00001273": "spinach plant",
    "NCBITaxon_1437197": "Petrosaviidae",
    "NCBITaxon_38705": "Phyllostachys edulis",
    "FOODON_03305361": "gelatin dessert (artificially flavored)",
    "CHEBI_28694": "copper atom",
    "FOODON_03311197": "vegetable leaf (raw)",
    "FOODON_03315029": "sugar substitute (dry, free flowing)",
    "FOODON_00003180": "longan fruit food product",
    "NCBITaxon_3744": "Rosales",
    "FOODON_03400970": "10000285 - cereals products - not ready to eat (shelf stable) (gs1 gpc)",
    "FOODON_03540043": "00430 - rice grain, polished (efsa foodex2)",
    "NCBITaxon_13432": "Clerodendrum",
    "PO_0006001": "phyllome",
    "FOODON_03301736": "asiago cheese",
    "FOODON_03543922": "39220 - steak sandwich (efsa foodex2)",
    "FOODON_03316217": "obsolete: jelly (marmalade)",
    "GAZ_00004444": "State of Nevada",
    "FOODON_03544189": "41890 - apricot flavour (efsa foodex2)",
    "FOODON_03311490": "obsolete: pork sausage (link, raw)",
    "CHEBI_30363": "isobutane",
    "FOODON_03309122": "ray's bream (raw)",
    "FOODON_03303397": "currant food product",
    "FOODON_03412888": "sidestriped shrimp",
    "PATO_0045081": "normal viscosity",
    "FOODON_03530263": "fat content, fish",
    "NCBITaxon_8076": "Cyprinodontidae",
    "FOODON_03543688": "36880 - red sandalwood (infusion bark, wood) (efsa foodex2)",
    "FOODON_03543712": "37120 - coffee imitate beverages (efsa foodex2)",
    "FOODON_03400294": "butter product analog (us cfr)",
    "FOODON_03301437": "fowl ova (raw)",
    "FOODON_03470136": "food freezing",
    "FOODON_03307580": "turkey tamale",
    "PO_0025497": "collective plant structure",
    "FOODON_03306824": "doughnut (butter batter)",
    "FOODON_03411727": "cardoon plant",
    "FOODON_03311048": "lemon balm (raw)",
    "FOODON_03315519": "minarine",
    "FOODON_03413683": "long-fin squid",
    "FOODON_03316559": "poppy-seed cake",
    "FOODON_03316400": "garlic (grated)",
    "FOODON_03411480": "soursop plant",
    "FOODON_03317041": "stockfish",
    "FOODON_03310883": "grape juice (red)",
    "NCBITaxon_9749": "Delphinapterus leucas",
    "FOODON_03411226": "sesame plant",
    "FOODON_03401838": "10006090 - sorrel (gs1 gpc)",
    "FOODON_03412342": "land crab family",
    "FOODON_03302180": "ham (smoked)",
    "NCBITaxon_3963": "Loranthaceae",
    "FOODON_03305732": "shrimp sauce (homemade)",
    "FOODON_03542001": "20010 - wild boar, fresh fat tissue (efsa foodex2)",
    "FOODON_00003014": "golden zucchini plant",
    "FOODON_03542515": "25150 - shrimps, common (efsa foodex2)",
    "FOODON_03411011": "pectin-producing plant",
    "FOODON_03541323": "13230 - cloves buds (efsa foodex2)",
    "FOODON_00003119": "salmonberry (whole, raw)",
    "FOODON_00002974": "thalipeeth bhajani",
    "FOODON_03412122": "concord grape (plant)",
    "CHEBI_62196": "polysaccharide acid oxoanion",
    "FOODON_03401693": "10005837 - turkey sausages - prepared/processed (gs1 gpc)",
    "FOODON_03540204": "02040 - ingredient-rich yeast dough (efsa foodex2)",
    "FOODON_03412666": "psettodid family",
    "FOODON_03311589": "french dressing, fat free",
    "FOODON_03400129": "refined or partially-refined food product (us cfr)",
    "FOODON_03315036": "beverage (fruit juice based, frozen, concentrate)",
    "FOODON_03315520": "butter-like edible fat",
    "FOODON_03305373": "gelatin fruit salad",
    "FOODON_00002264": "soybean refined food product",
    "FOODON_03315784": "chickpea (canned)",
    "NCBITaxon_229290": "Anoplopoma fimbria",
    "UBERON_0001690": "ear",
    "NCBITaxon_52838": "Musa balbisiana",
    "FOODON_03304756": "salt (butter-flavored)",
    "FOODON_03304704": "tequila",
    "FOODON_00001842": "field corn cereal food product",
    "CHEBI_36233": "disaccharide",
    "FOODON_03543612": "36120 - safflower infusion flowers (efsa foodex2)",
    "NCBITaxon_185430": "Esox americanus vermiculatus",
    "FOODON_03530153": "wild food harvesting",
    "FOODON_03304892": "herring in spiced sauce (canned)",
    "FOODON_03412571": "pomfret",
    "NCBITaxon_268906": "Salvia fruticosa",
    "FOODON_03540899": "08990 - vietnamese mint (efsa foodex2)",
    "FOODON_03309960": "linseed press cake",
    "FOODON_03412117": "white lepiota",
    "FOODON_03411621": "sika deer",
    "NCBITaxon_75352": "Megalobrama amblycephala",
    "FOODON_03401388": "50132700 - quark products (gs1 gpc)",
    "FOODON_03400851": "alcoholic mixed drink (eurofir)",
    "FOODON_03401623": "10005770 - deer, other than roe deer - prepared/processed (gs1 gpc)",
    "FOODON_03401787": "10006335 - arracacha (gs1 gpc)",
    "FOODON_03490141": "paper bag, sack or pouch, paper liner",
    "FOODON_03305080": "animal bouillon base (liquid)",
    "CHEBI_35505": "hydrate",
    "FOODON_03460182": "candying process",
    "FOODON_03412083": "iceberg lettuce plant",
    "FOODON_00002167": "poultry cured meat",
    "FOODON_03311347": "elderberry (whole, raw)",
    "FOODON_03544002": "40020 - fish soup (efsa foodex2)",
    "FOODON_03543832": "38320 - soya drink (efsa foodex2)",
    "FOODON_03305323": "food (precooked, frozen)",
    "NCBITaxon_32521": "Elopomorpha",
    "CHEBI_26816": "carbohydrate phosphate",
    "FOODON_03543578": "35780 - common chamomile (efsa foodex2)",
    "FOODON_03401211": "unripened (codex)",
    "FOODON_03411337": "peanut plant",
    "FOODON_03544339": "43390 - parsley flavour (efsa foodex2)",
    "NCBITaxon_762772": "Hypsophrys nematopus",
    "FOODON_03303400": "chocolate-covered nut and caramel candy bar (food product)",
    "http://www.geneontology.org/formats/oboInOwl#hasBroadSynonym": "has broad synonym",
    "FOODON_03414024": "sand bass",
    "FOODON_03303175": "carob bean (raw)",
    "FOODON_03303447": "italian dressing",
    "FOODON_03306356": "mustard (prepared, with scotch whiskey)",
    "FOODON_03542379": "23790 - red drum (efsa foodex2)",
    "FOODON_03309706": "granola bar",
    "NCBITaxon_497147": "Scomberesox saurus saurus",
    "FOODON_03412545": "freshwater eel family",
    "FOODON_03303055": "cherry cider",
    "FOODON_00002649": "food (milled)",
    "FOODON_00002889": "black turtle bean (whole)",
    "FOODON_03301399": "yellow variety sweet potato (whole, raw, skin onn)",
    "NCBITaxon_55111": "Notacanthidae",
    "CHEBI_24632": "hydrocarbon",
    "FOODON_03542419": "24190 - tuna, bigeye (efsa foodex2)",
    "FOODON_03411016": "starch-producing plant",
    "FOODON_03541963": "19630 - poultry fresh meat (muscle meat) (efsa foodex2)",
    "NCBITaxon_7780": "Raja",
    "FOODON_03413494": "kuruma prawn",
    "FOODON_03401461": "10006144 - kale (gs1 gpc)",
    "NCBITaxon_4505": "Coix lacryma-jobi",
    "FOODON_03460254": "water addition or removal process",
    "CHEBI_15734": "primary alcohol",
    "FOODON_03401049": "10000279 - yoghurt/yoghurt substitutes (shelf stable) (gs1 gpc)",
    "FOODON_03315823": "food sold in tablet form",
    "FOODON_03541419": "14190 - canned or jarred lentils (efsa foodex2)",
    "FOODON_03308263": "perth herring (raw)",
    "FOODON_03411931": "emperor snapper",
    "FOODON_03412636": "tabasco pepper plant",
    "FOODON_00002195": "redfish perch food product",
    "GAZ_00007112": "Midway Atoll",
    "FOODON_03490340": "paperboard container, untreated",
    "FOODON_03311517": "infant formula (soy-based, ready-to-feed)",
    "FOODON_03543064": "30640 - nougat (efsa foodex2)",
    "FOODON_03540927": "09270 - other marigold flowers (efsa foodex2)",
    "NCBITaxon_40509": "Etelis oculatus",
    "FOODON_03308694": "oyster (in shell, raw)",
    "FOODON_03413424": "curryleaf plant",
    "FOODON_03414929": "monantha vetch plant",
    "FOODON_03306848": "papaya plant (ground)",
    "FOODON_03316673": "sardine-like products (canned)",
    "FOODON_03415005": "apple mint plant",
    "FOODON_03500014": "beer beverage can enamel surface",
    "FOODON_03540703": "07030 - other cucurbits with inedible peel (efsa foodex2)",
    "FOODON_03520498": "humid subtropical climatic zone",
    "UO_0000034": "week",
    "FOODON_03311219": "butter (lowfat)",
    "CHEBI_63043": "potassium nitrate",
    "NCBITaxon_25996": "Elaeagnaceae",
    "FOODON_03541695": "16950 - water berries (efsa foodex2)",
    "FOODON_03510255": "teenager as food consumer",
    "FOODON_03542029": "20290 - foie gras (efsa foodex2)",
    "FOODON_03306698": "swiss chard (raw)",
    "FOODON_03460227": "flavoring, spice or herb",
    "FOODON_03315168": "herbs and seasonings",
    "FOODON_03543623": "36230 - arabian jasmine infusion flowers (efsa foodex2)",
    "NCBITaxon_32100": "Pteridium",
    "FOODON_03414483": "alpine sweetvetch plant",
    "FOODON_03303886": "spaghetti sauce",
    "NCBITaxon_61716": "Hapalochlaena maculosa",
    "FOODON_03540360": "03600 - lettuces and salad plants (efsa foodex2)",
    "FOODON_03411154": "cutlassfish",
    "FOODON_03490389": "phenonile resin container",
    "FOODON_03311064": "oats (cracked)",
    "FOODON_03311155": "cherry filling (aspartame sweetened)",
    "NCBITaxon_7941": "Congridae",
    "FOODON_0002899": "clown featherback",
    "FOODON_03401270": "U.S. code of federal regulations, title 21 food product type",
    "NCBITaxon_38868": "Salvia officinalis",
    "FOODON_03315290": "beverage vegetable",
    "FOODON_03413581": "spiny krill",
    "FOODON_03414566": "northern fulmar",
    "FOODON_00001815": "diluted grape beverage",
    "NCBITaxon_290888": "Metapenaeus joyneri",
    "FOODON_03317061": "sandwich spread with no added sugar, fat-based",
    "FOODON_03302202": "waffled cookie",
    "GAZ_00000909": "Guinea",
    "PATO_0000384": "male",
    "FOODON_03411897": "sturgeon family",
    "FOODON_03414152": "horse mussel",
    "ENVO_00000121": "artificial channel",
    "FOODON_03400317": "preservative (US CFR)",
    "FOODON_03401508": "10005889 - oranges (gs1 gpc)",
    "FOODON_03415170": "lignum-vitae plant",
    "FOODON_03411112": "black skipjack",
    "FOODON_03304489": "pumpernickel flour",
    "FOODON_03411609": "sweet marjoram plant",
    "FOODON_03412948": "european strawberry plant",
    "NCBITaxon_86250": "Oxyeleotris marmorata",
    "FOODON_03305505": "halibut puff",
    "FOODON_03304483": "fish flour",
    "NCBITaxon_4149": "Scrophulariaceae",
    "FOODON_03541811": "18110 - jam, lingonberry (efsa foodex2)",
    "FOODON_03543437": "34370 - hot drinks and infusions composite ingredients (efsa foodex2)",
    "FOODON_03413699": "angolan flying squid",
    "CHEBI_22727": "benzopyran",
    "FOODON_03541285": "12850 - hops (efsa foodex2)",
    "FOODON_03308505": "imitation strawberry beverage syrup",
    "FOODON_03543393": "33930 - herb liqueur (efsa foodex2)",
    "ENVO_01000281": "layer",
    "FOODON_03541554": "15540 - raspberries and similar- (efsa foodex2)",
    "FOODON_00002092": "pasteurized process cheese spread food product",
    "FOODON_00002409": "food physical forming process",
    "FOODON_03460241": "food thawing process",
    "NCBITaxon_7850": "Alopiidae",
    "FOODON_03310228": "green cabbage (whole, raw)",
    "FOODON_03304508": "goat milk (evaporated)",
    "FOODON_03316380": "tangerine (dried)",
    "FOODON_00002476": "pie (whole)",
    "FOODON_03306362": "grape nectar",
    "FOODON_03542289": "22890 - paddle fish (efsa foodex2)",
    "FOODON_03305755": "tomato juice (vitamin c added, canned)",
    "FOODON_03301749": "animal tissue (rendered)",
    "FOODON_03303541": "fynbo cheese",
    "FOODON_03544098": "40980 - tomato-containing cooked sauces (efsa foodex2)",
    "FOODON_03301337": "citrus fruit (whole, raw)",
    "FOODON_03303514": "gouda cheese",
    "FOODON_03308947": "springer fish (raw)",
    "FOODON_03541197": "11970 - mustard seeds (efsa foodex2)",
    "NCBITaxon_3999": "Simmondsia chinensis",
    "FOODON_03413559": "stridulating stone crab",
    "NCBITaxon_8028": "Salmo",
    "FOODON_03304986": "imitation jelly sweetened with sorbitol",
    "FOODON_03413694": "argentine shortfin squid",
    "FOODON_03541149": "11490 - pecans and similar- (efsa foodex2)",
    "FOODON_03308829": "crab (deviled, with cod flakes)",
    "FOODON_03412935": "narrow-barred mackerel",
    "FOODON_03306636": "olive oil (wild)",
    "FOODON_03420245": "mammalian milk curd",
    "FOODON_03302179": "popcorn (popped)",
    "FOODON_03413865": "nile twaite shad",
    "FOODON_03460113": "water removal to reconstitution ratio 2 plus 1",
    "FOODON_03540771": "07710 - sea spaghetti (efsa foodex2)",
    "FOODON_03304879": "catnip tea (dry)",
    "NCBITaxon_246271": "Woodsiaceae",
    "FOODON_03301617": "lemon drink (diluted)",
    "NCBITaxon_171929": "Anacardium occidentale",
    "FOODON_03400967": "10000319 - grains/cereal - ready to eat - (shelf stable) (gs1 gpc)",
    "NCBITaxon_450225": "Nemipterus virgatus",
    "CHEBI_63353": "disaccharide derivative",
    "FOODON_00002803": "banana powder",
    "FOODON_03311283": "fast food",
    "FOODON_03316408": "gelatin (air-dried)",
    "FOODON_03303637": "imitation pasteurized process cheese spread",
    "FOODON_03303661": "cheese (green-colored)",
    "FOODON_00003066": "pomegranate (whole, raw)",
    "CHEBI_23044": "carotenoid",
    "FOODON_03309442": "sauger fillet (raw)",
    "NCBITaxon_110924": "Jasus paulensis",
    "FOODON_03310252": "prickly poppy seed (food product)",
    "FOODON_03543648": "36480 - rhatany infusion roots (efsa foodex2)",
    "FOODON_03302405": "kava tea (steeped)",
    "FOODON_00002375": "food flavoring product",
    "NCBITaxon_7898": "Actinopterygii",
    "FOODON_03413025": "calcium 5'-ribonucleotides",
    "FOODON_03540492": "04920 - stem kale (efsa foodex2)",
    "FOODON_03460252": "enzymatic modification process",
    "FOODON_03543510": "35100 - horse-chestnut infusion leaves (efsa foodex2)",
    "NCBITaxon_133429": "Lepidozamia",
    "CHEBI_46721": "carbonate salt",
    "NCBITaxon_7992": "Characidae",
    "CHEBI_25699": "organic ion",
    "FOODON_03303341": "chocolate custard",
    "FOODON_03460353": "food coating or covering process",
    "CHEBI_35217": "alkaline earth coordination entity",
    "FOODON_03303196": "yellow corn meal (stone ground)",
    "FOODON_03315365": "food (pickled, with vinegar)",
    "FOODON_03400179": "condiment or relish (us cfr)",
    "FOODON_03310176": "corn germ (defatted)",
    "FOODON_03316817": "spaghetti (vegetable)",
    "FOODON_03400389": "colloidal stabilizers (codex)",
    "NCBITaxon_6641": "Eledone moschata",
    "FOODON_03311192": "fenugreek (raw)",
    "NCBITaxon_51239": "Vanilla planifolia",
    "FOODON_00002765": "bean pod",
    "FOODON_03414956": "blue honeysuckle plant",
    "FOODON_03470142": "chilling or freezing",
    "FOODON_03542526": "25260 - abalone (efsa foodex2)",
    "FOODON_03412916": "fathead family",
    "FOODON_03543911": "39110 - mixed vegetables, grilled (efsa foodex2)",
    "FOODON_03540648": "06480 - litchi tomatoes (efsa foodex2)",
    "FOODON_03430122": "divided or disintegrated",
    "FOODON_03310971": "turkey ham",
    "FOODON_03541693": "16930 - surinam cherries (efsa foodex2)",
    "NCBITaxon_8236": "Thunnus albacares",
    "FOODON_03541152": "11520 - pine nut kernels and similar- (efsa foodex2)",
    "FOODON_03307598": "ribbon cane syrup",
    "NCBITaxon_7839": "Triakidae",
    "FOODON_03302160": "grapefruit soda",
    "FOODON_03543631": "36310 - valerian infusion roots and similar- (efsa foodex2)",
    "GAZ_00006254": "State of Colorado",
    "FOODON_03305085": "yogurt (nonfat)",
    "FOODON_03317301": "loaf (nonspecific)",
    "FOODON_03317414": "chewing gum with added sugar",
    "NCBITaxon_181444": "Allocyttus",
    "FOODON_00002572": "cut of beef, british",
    "FOODON_00002666": "almond bark",
    "FOODON_00001593": "animal based dessert food product",
    "FOODON_03480003": "obsolete: no packing medium used",
    "FOODON_03317447": "cream de pruneaux",
    "CHEBI_36976": "nucleotide",
    "FOODON_03412143": "cusk",
    "NCBITaxon_6639": "Eledone",
    "FOODON_03304761": "meat sandwich",
    "HANCESTRO_0460": "South Sudanese",
    "FOODON_00002343": "watermelon food product",
    "FOODON_03310294": "meat (dried)",
    "FOODON_03414418": "magnesium phosphates",
    "FOODON_03542949": "29490 - unprocessed eggs (efsa foodex2)",
    "UO_0000182": "density unit",
    "FOODON_03414672": "bumelia plant",
    "FOODON_03520497": "mediterranean climatic zone",
    "FOODON_03540023": "00230 - job's tears grain (efsa foodex2)",
    "FOODON_03304587": "king salmon (kippered)",
    "FOODON_00003060": "pita bread",
    "FOODON_03413509": "lantern shark family",
    "UBERON_0036016": "honey",
    "FOODON_03411560": "navy bean plant",
    "FOODON_03541203": "12030 - pima cotton seeds (efsa foodex2)",
    "FOODON_03400392": "colour retention agent (codex)",
    "FOODON_03412066": "niger (plant) plant",
    "FOODON_03400001": "obsolete: product type",
    "CHEBI_37175": "organic hydride",
    "FOODON_03412011": "sea kale plant",
    "FOODON_03414076": "bigeye dory family",
    "FOODON_03316251": "dessert topping, whipped",
    "FOODON_00001624": "obsolete: avocado food product",
    "FOODON_03302503": "peach butter",
    "FOODON_03401524": "10006015 - courgettes (gs1 gpc)",
    "FOODON_03413919": "west african goatfish",
    "FOODON_03311144": "enoki mushroom (vacuum-packed)",
    "FOODON_03308531": "fish dinner (frozen)",
    "FOODON_03543273": "32730 - still bottled drinking water (efsa foodex2)",
    "NCBITaxon_4932": "Saccharomyces cerevisiae",
    "FOODON_03412106": "swim crab (portunus spp.)",
    "FOODON_00001168": "obsolete: leguminous food product",
    "FOODON_03412996": "ammonium alginate",
    "CHEBI_64220": "monosodium glutamate",
    "FOODON_03411842": "atlantic cod",
    "PATO_0001776": "increased flexibility",
    "NCBITaxon_9913": "Bos taurus",
    "FOODON_03400693": "03  flour (efg)",
    "FOODON_03305362": "gelatin drink mix (orange-flavored)",
    "NCBITaxon_63812": "Peumus boldus",
    "FOODON_03303038": "chicken gravy",
    "FOODON_03412297": "devilfish",
    "FOODON_03412555": "habanero pepper plant",
    "FOODON_03414618": "magpie goose",
    "FOODON_03542335": "23350 - halibut, greenland (efsa foodex2)",
    "NCBITaxon_93046": "Lycoteuthis lorigera",
    "FOODON_03316692": "obsolete: arachis oil",
    "FOODON_03308621": "scorpionfish (raw)",
    "FOODON_00001862": "flying fish food product",
    "FOODON_03308593": "dungeness crab (raw)",
    "FOODON_03542195": "21950 - pate, goose liver (efsa foodex2)",
    "ENVO_01000925": "abattoir",
    "NCBITaxon_648071": "Oncorhynchus chrysogaster",
    "FOODON_03540217": "02170 - piped shortbread pastry (efsa foodex2)",
    "FOODON_03400885": "10000263 - spirits (gs1 gpc)",
    "FOODON_03301962": "mixed vegetables (pickled)",
    "FOODON_03542280": "22800 - pike-perch (efsa foodex2)",
    "NCBITaxon_153168": "Thelesperma megapotamicum",
    "FOODON_03411085": "buffalofish",
    "FOODON_03315237": "cake filling",
    "NCBITaxon_103373": "Hoplobatrachus tigerinus",
    "FOODON_03541871": "18710 - canned or jarred sour cherry (efsa foodex2)",
    "FOODON_03317562": "cephalopod (unprocessed, frozen)",
    "FOODON_03304728": "malt sprout",
    "FOODON_00002126": "plant-based candy",
    "FOODON_03304253": "beef noodle soup mix",
    "FOODON_03306490": "mushroom (chopped, canned)",
    "FOODON_03302347": "butter bread (artificially colored)",
    "NCBITaxon_72088": "Sebastes mystinus",
    "FOODON_03305206": "western omelet mix",
    "FOODON_03544200": "42000 - beef soup flavour (efsa foodex2)",
    "FOODON_03411289": "pili tree",
    "FOODON_03541817": "18170 - jam, plums (efsa foodex2)",
    "FOODON_03302954": "cherry (red tart, pitted)",
    "CHEBI_49302": "2-hydroxy monocarboxylic acid",
    "FOODON_03414574": "negibacteria",
    "FOODON_03315925": "pate",
    "FOODON_03310130": "mountain ash berry",
    "FOODON_03306177": "elderberry juice",
    "FOODON_03401307": "yeast supplement",
    "FOODON_03309160": "salt water catfish (raw)",
    "FOODON_00001692": "cassava food product",
    "CHEBI_15354": "choline",
    "NCBITaxon_224710": "Opisthonema",
    "FOODON_03401001": "10000235 - nuts/seeds - prepared/processed (perishable) (gs1 gpc)",
    "FOODON_03302845": "sour cream pound cake",
    "FOODON_03400899": "10000116 - tea - bags/loose (gs1 gpc)",
    "NCBITaxon_13675": "Scomber",
    "NCBITaxon_3483": "Cannabis sativa",
    "FOODON_03400909": "10000593 - non alcoholic beverages variety packs - not ready to drink (gs1 gpc)",
    "HANCESTRO_0359": "Danish",
    "FOODON_03543143": "31430 - buffalo milk fat (efsa foodex2)",
    "FOODON_03412601": "greater galangal plant",
    "FOODON_03301594": "alfalfa seed (raw, dry)",
    "FOODON_03306011": "reconstituted orange juice (from concentrate, sweetened)",
    "NCBITaxon_41947": "Santalales",
    "FOODON_03412648": "fringescale sardinella",
    "FOODON_03303898": "potato stick (canned)",
    "FOODON_03303716": "beverage (carbonated, vitamin- and mineral-fortified)",
    "FOODON_03306205": "butter and margarine mixture (whipped)",
    "FOODON_03400752": "049  molluscs (including cephalopods) and other invertebrate animals (im) (ccpr)",
    "FOODON_03315301": "enzyme containing food",
    "FOODON_03316064": "obsolete: jelly extra",
    "CHEBI_139322": "poly(ethylene glycol) derivative",
    "BFO_0000027": "object aggregate",
    "FOODON_03414711": "rocklily plant",
    "FOODON_03302243": "animal-derived flavor (food product)",
    "HANCESTRO_0497": "Burmese",
    "FOODON_03542097": "20970 - rabbit, other slaughtering products (efsa foodex2)",
    "FOODON_03543108": "31080 - grape seed oil (efsa foodex2)",
    "FOODON_03400376": "binder (codex)",
    "FOODON_03308582": "tanner crab (raw)",
    "FOODON_03490372": "low density polyethylene container, treated",
    "FOODON_03317675": "fish cracker (food product)",
    "CHEBI_33318": "main group element atom",
    "FOODON_03310386": "rice beer",
    "FOODON_03400384": "carrier solvent (codex)",
    "FOODON_03316960": "noodle (egg, vegetable, enriched)",
    "FOODON_03317529": "vegetable (white, deep-frozen)",
    "FOODON_03310298": "durum wheat kernel (dried)",
    "FOODON_03544327": "43270 - mushroom flavour (efsa foodex2)",
    "FOODON_03315025": "obsolete: yeast (dry)",
    "FOODON_03540956": "09560 - starchy roots and tubers (efsa foodex2)",
    "FOODON_03311417": "frozen dessert (low sugar)",
    "NCBITaxon_15105": "Xanthosoma",
    "FOODON_00002941": "flatbread wrap",
    "FOODON_03541804": "18040 - fruit / vegetable spreads and similar (efsa foodex2)",
    "NCBITaxon_159425": "Passiflora incarnata",
    "FOODON_03309130": "ocean pike (raw)",
    "NCBITaxon_72076": "Sebastes flavidus",
    "FOODON_03305286": "mangosteen (canned)",
    "FOODON_03317057": "cocoa-based product (with no added sugar)",
    "FOODON_03414617": "tasmanian nativehen",
    "FOODON_03413548": "noahs ark",
    "FOODON_00003237": "skim milk (liquid)",
    "FOODON_03303152": "fig bar cookie",
    "FOODON_03317517": "hen egg product (dehydrated)",
    "FOODON_03540606": "06060 - sword bean (young pods) (efsa foodex2)",
    "BFO_0000003": "occurrent",
    "FOODON_03302720": "hen egg (whole, shell on, hard boiled, colored)",
    "FOODON_03309513": "raspberry spread",
    "FOODON_03310117": "sea cucumber (salted)",
    "FOODON_03540179": "01790 - fresh egg pasta (efsa foodex2)",
    "FOODON_03303519": "cheese fondue",
    "NCBITaxon_70193": "Sepiola atlantica",
    "FOODON_03309492": "pizza (sausage)",
    "FOODON_03541770": "17700 - guavas (efsa foodex2)",
    "FOODON_03412670": "american plum plant",
    "FOODON_03309798": "coconut (grated)",
    "GAZ_00002932": "Peru",
    "FOODON_03542407": "24070 - herring, atlantic (efsa foodex2)",
    "FOODON_03315384": "fruit (canned, artificially sweetened, no sugar added)",
    "FOODON_03315297": "red pepper (finely threaded)",
    "FOODON_03541236": "12360 - melinjo seeds (efsa foodex2)",
    "FOODON_03307302": "ginger-flavored drink",
    "FOODON_00002085": "parsnip food product",
    "FOODON_03400143": "fruit or fruit product (us cfr)",
    "FOODON_03414539": "summer bolete",
    "FOODON_03311620": "cookie, peanut butter",
    "FOODON_03310828": "poultry (processed)",
    "GAZ_00003943": "Mayotte",
    "FOODON_03309642": "peruvian sea bass (raw)",
    "FOODON_03308862": "stone crab (raw)",
    "FOODON_03544262": "42620 - feijoa flavour (efsa foodex2)",
    "FOODON_03414212": "canadian elder plant",
    "FOODON_03303157": "chocolate nut wafer (butter-flavored)",
    "FOODON_03310726": "tea (spiced)",
    "CHEBI_71644": "lantibiotic",
    "FOODON_03543963": "39630 - pasta, cooked, with mixed sauce (efsa foodex2)",
    "FOODON_03316916": "fish (grilled, vacuum packed)",
    "FOODON_03412645": "silver hake",
    "FOODON_03413612": "cape verde spiny lobster",
    "FOODON_03412660": "bigeye scad",
    "FOODON_03414582": "proteobacteria",
    "FOODON_03311239": "infant formula (milk-based, soy-based, liquid)",
    "FOODON_03310700": "cheese soft",
    "FOODON_03309124": "icelandic ocean perch (raw)",
    "FOODON_03401226": "0150000 - berries and small fruit (ec)",
    "FOODON_03310431": "black olive (pitted)",
    "FOODON_03542987": "29870 - refined cane sugar (efsa foodex2)",
    "FOODON_03412289": "hogchoker",
    "FOODON_03305458": "fudge brownie mix (chocolate-flavored)",
    "FOODON_00001232": "vinaigrette dressing food product",
    "HANCESTRO_0339": "Turkmen",
    "FOODON_03542618": "26180 - salted cod (efsa foodex2)",
    "FOODON_03309966": "veal steak (raw)",
    "FOODON_03543261": "32610 - water and water-based beverages (efsa foodex2)",
    "FOODON_03306090": "horchata de chufa",
    "FOODON_03309512": "wheat (ground)",
    "NCBITaxon_933932": "Silurus aristotelis",
    "FOODON_03400727": "04  fish and fish products (eurocode2)",
    "FOODON_03401633": "10006294 - lamb - prepared/processed (gs1 gpc)",
    "FOODON_03541086": "10860 - runner beans (dry) (efsa foodex2)",
    "GAZ_00000564": "Western Sahara",
    "FOODON_03301640": "whiskey sour cocktail (sweetened with saccharin)",
    "FOODON_03413838": "japanese anchovy",
    "FOODON_00002363": "whiting food product",
    "FOODON_03500030": "enamel surface for corn (c-enamel)",
    "FOODON_03412635": "cluster pepper plant",
    "CHEBI_16670": "peptide",
    "FOODON_03414344": "white ginger plant",
    "FOODON_00001106": "camelid dairy food product",
    "FOODON_03413656": "australian mussel",
    "FOODON_03303446": "codfish cake",
    "FOODON_03401521": "10006014 - cucumbers (gs1 gpc)",
    "FOODON_03412323": "hemp plant",
    "FOODON_03301881": "chopped liver (dish)",
    "NCBITaxon_35874": "Dioscorea bulbifera",
    "FOODON_03302500": "corn flour",
    "FOODON_03310191": "pine nut shell extract",
    "UBERON_0009850": "nematode larva",
    "FOODON_03306733": "artichoke (marinated, quartered)",
    "FOODON_03315480": "shiu my pastry case",
    "PECO_0007037": "spring season exposure",
    "CHEBI_18012": "fumaric acid",
    "FOODON_03412026": "highbush blueberry plant",
    "FOODON_03304703": "milk (precultured)",
    "FOODON_03315453": "whale meat (pickled)",
    "FOODON_03302042": "black raspberry (frozen)",
    "FOODON_03400988": "50102000 - fruit - prepared/processed (gs1 gpc)",
    "FOODON_03301053": "oriental noodle",
    "FOODON_03540799": "07990 - snow mushrooms (efsa foodex2)",
    "FOODON_03401715": "10005971 - guavas (gs1 gpc)",
    "FOODON_03510080": "salt free claim or use",
    "FOODON_03305451": "fruit juice supreme fruit punch ice (frozen)",
    "FOODON_03542580": "25800 - frog, agile (efsa foodex2)",
    "FOODON_03315601": "cream cheese (acid coagulated)",
    "FOODON_03541816": "18160 - jam, apricots (efsa foodex2)",
    "FOODON_03540544": "05440 - celeries and similar- (efsa foodex2)",
    "FOODON_03542922": "29220 - cheese, ardrahan (efsa foodex2)",
    "FOODON_03542864": "28640 - cheese, wensleydale (efsa foodex2)",
    "FOODON_03530256": "protected geographical indication (pgi)",
    "FOODON_03540459": "04590 - morning glory (efsa foodex2)",
    "FOODON_03413076": "dicalcium phosphate",
    "FOODON_03470103": "food salting",
    "FOODON_03309735": "turkey white meat (raw)",
    "FOODON_03411901": "labyrinth catfish family",
    "FOODON_03400351": "Codex Alimentarius food additive functional class",
    "FOODON_03310658": "peach juice",
    "FOODON_03315404": "dessert mix",
    "FOODON_03413795": "summer truffle",
    "FOODON_03301830": "papaya (whole, raw)",
    "NCBITaxon_1489940": "Centrarchiformes",
    "FOODON_03309307": "cockle (canned)",
    "FOODON_00001696": "cattle cured meat food product",
    "GAZ_00003762": "Cuba",
    "FOODON_00001034": "harzer cheese food product",
    "FOODON_03302080": "lupine bean (whole, raw)",
    "FOODON_00002437": "elderberry food product",
    "NCBITaxon_195660": "Xystreurys liolepis",
    "FOODON_03301883": "fruit salad (canned)",
    "FOODON_03307547": "fruit and nut cake",
    "FOODON_03311374": "splitnose rockfish (raw)",
    "FOODON_03400302": "vinegar (us cfr)",
    "FOODON_03543147": "31470 - fat emulsions and blended fats (efsa foodex2)",
    "FOODON_03541675": "16750 - purple mombins (efsa foodex2)",
    "FOODON_03301413": "reduced calorie food",
    "FOODON_03304068": "table blend syrup",
    "CHEBI_33909": "metallotetrapyrrole",
    "FOODON_03541089": "10890 - vetches (dry) (efsa foodex2)",
    "FOODON_03308426": "lobster meat (cooked, refrigerated in can)",
    "FOODON_03401499": "10006345 - kumquat (gs1 gpc)",
    "FOODON_03543363": "33630 - ice wine (efsa foodex2)",
    "NCBITaxon_9923": "Capra aegagrus",
    "FOODON_03413624": "yellowleg shrimp",
    "FOODON_03302598": "mushroom (sliced, with butter)",
    "FOODON_03413832": "atlantic anchoveta",
    "FOODON_00003395": "multi-component wheat food product",
    "FOODON_03000000": "vegetable (by legal status)",
    "FOODON_00002100": "pear beverage",
    "FOODON_03304895": "raspberry spread (nutritively sweetened)",
    "FOODON_03316395": "parsnip (dried)",
    "FOODON_03307121": "red bliss potato (whole, raw)",
    "FOODON_03400184": "fruit butter (us cfr)",
    "FOODON_03411135": "water snail",
    "FOODON_03308642": "surimi",
    "FOODON_03311653": "turkey breast (roasted)",
    "FOODON_03304628": "hen egg salad",
    "FOODON_03401590": "10006159 - lemongrass (gs1 gpc)",
    "NCBITaxon_13028": "Cynoscion",
    "NCBITaxon_7746": "Petromyzontidae",
    "NCBITaxon_1463138": "Ranunculoideae",
    "FOODON_03317050": "ice with no added sugar, edible",
    "FOODON_03460207": "food filling process",
    "FOODON_00001753": "cola nut food product",
    "HANCESTRO_0576": "West African",
    "NCBITaxon_50457": "Barbarea",
    "FOODON_03540964": "09640 - tropical root and tuber vegetables (efsa foodex2)",
    "FOODON_03411893": "gar family",
    "FOODON_03541090": "10900 - yardlong beans (dry) (efsa foodex2)",
    "FOODON_03541194": "11940 - soyabeans for oil (efsa foodex2)",
    "FOODON_00003301": "beef loin cut",
    "FOODON_03401205": "food for weight reduction (eurofir)",
    "FOODON_03316805": "vermicelli (enriched with fortified protein)",
    "FOODON_03317499": "fish with red skin (frozen)",
    "FOODON_03401735": "10006337 - corn (indian) (gs1 gpc)",
    "FOODON_03411499": "arrowleaf elephant ear plant",
    "FOODON_03308902": "queenfish (raw)",
    "FOODON_03317293": "hog sausage (whole)",
    "FOODON_03542383": "23830 - sea catfishes (efsa foodex2)",
    "FOODON_03414503": "hedge mustard plant",
    "FOODON_03541529": "15290 - table grapes and similar- (efsa foodex2)",
    "RO_0001020": "is allergic trigger for",
    "FOODON_03510042": "cholesterol free claim or use",
    "FOODON_03542165": "21650 - ripened kolbasz (efsa foodex2)",
    "FOODON_03310923": "tea (ready to drink, artificially sweetened)",
    "FOODON_00001795": "cucumber food product",
    "FOODON_03541801": "18010 - dried pears (efsa foodex2)",
    "NCBITaxon_4054": "Panax ginseng",
    "FOODON_03544443": "44430 - propellent gas (efsa foodex2)",
    "FOODON_03310550": "guacamole (food product)",
    "FOODON_03540764": "07640 - eucheuma (efsa foodex2)",
    "FOODON_03310659": "chicken nugget (raw)",
    "FOODON_03414975": "dwarf elder plant",
    "GAZ_00004442": "State of North Dakota",
    "FOODON_03302102": "ground beef patty (soy-extended, cooked)",
    "NCBITaxon_13427": "Cichorium intybus",
    "FOODON_03460246": "carbonation by fermentation",
    "FOODON_00001038": "pork meat food product",
    "FOODON_03413951": "runner",
    "FOODON_03440023": "heat-treated, multiple components, different degrees of treatment",
    "FOODON_03480042": "packed in broth",
    "FOODON_03401206": "sports food (eurofir)",
    "FOODON_03414608": "blue shark",
    "FOODON_00001931": "gravy or sauce",
    "FOODON_03411403": "european elder plant",
    "FOODON_03541547": "15470 - loganberries (efsa foodex2)",
    "FOODON_03303440": "nova scotia salmon (raw)",
    "FOODON_03541576": "15760 - bog bilberries (efsa foodex2)",
    "FOODON_03317201": "invert sugar solution",
    "FOODON_03401854": "10006129 - asparagus (gs1 gpc)",
    "FOODON_03542364": "23640 - threadfins (efsa foodex2)",
    "ENVO_00003862": "dairy",
    "HANCESTRO_0010": "African",
    "FOODON_03411143": "northern pike",
    "FOODON_03412141": "obsolete cape hake",
    "FOODON_03414704": "potato bush",
    "FOODON_03302713": "bitters",
    "NCBITaxon_6689": "Penaeus vannamei",
    "FOODON_03311258": "margarine (reduced calorie)",
    "FOODON_03316179": "mushroom (processed)",
    "FOODON_03543577": "35770 - chamomile (efsa foodex2)",
    "FOODON_03303914": "salsa casera",
    "FOODON_03317141": "food for invalids, solid",
    "FOODON_03530159": "leg (poultry meat cut)",
    "NCBITaxon_43257": "Sillago",
    "FOODON_03400660": "12  secondary food commodities of plant origin (ccpr)",
    "FOODON_03411198": "broiler or fryer chicken",
    "FOODON_03542692": "26920 - fermented milk products (efsa foodex2)",
    "FOODON_03301672": "margarine",
    "FOODON_03301261": "olive (whole, pitted)",
    "FOODON_03305994": "grapefruit (canned)",
    "FOODON_00002627": "Grenache wine",
    "FOODON_03316814": "spaghetti (nonfat milk, enriched)",
    "FOODON_03540228": "02280 - miscellaneous doughs (efsa foodex2)",
    "FOODON_00003116": "Colorado pinyon pine nut food product",
    "FOODON_03310778": "skim milk (concentrated)",
    "FOODON_03304552": "chicken with rice soup (instant)",
    "FOODON_03306031": "orange juice drink (diluted)",
    "FOODON_03317231": "orange juice for manufacturing",
    "FOODON_03520468": "southeastern states",
    "FOODON_03420279": "pollen",
    "FOODON_03541441": "14410 - chinottos (efsa foodex2)",
    "FOODON_03544415": "44150 - almond essence (efsa foodex2)",
    "NCBITaxon_227725": "Solanum quitoense",
    "FOODON_00002595": "Pinot gris grape plant",
    "NCBITaxon_3859": "Lathyrus odoratus",
    "FOODON_03302622": "butter mix product",
    "FOODON_03542365": "23650 - salmon, threadfin (efsa foodex2)",
    "FOODON_03400900": "10000117 - tea - instant (gs1 gpc)",
    "FOODON_03307090": "prune (pitted, canned)",
    "FOODON_03315828": "dip (unstandardized)",
    "FOODON_03544215": "42150 - bubblegum flavour (efsa foodex2)",
    "FOODON_03302072": "beeswax",
    "FOODON_03306498": "mushroom in butter",
    "FOODON_03305667": "ice cream mix",
    "FOODON_03301507": "fruit butter",
    "FOODON_03302588": "butterscotch candy (artificially-flavored)",
    "FOODON_03542542": "25420 - scallop, great (efsa foodex2)",
    "FOODON_03401667": "10005793 - horse - unprepared/unprocessed (gs1 gpc)",
    "FOODON_00002578": "white grape (whole, raw)",
    "NCBITaxon_6786": "Dromidia antillensis",
    "CHEBI_51336": "metal sulfate",
    "GAZ_00005283": "Oman",
    "FOODON_03317151": "baltic herring fillet (deep-frozen)",
    "PATO_0002366": "intact male",
    "FOODON_03310565": "rye (raw)",
    "FOODON_03315395": "flour product",
    "FOODON_03413495": "western king prawn",
    "FOODON_03530185": "fat content 15-30%",
    "FOODON_03401620": "10006299 - beefalo/cattalo - prepared/processed (gs1 gpc)",
    "FOODON_03540833": "08330 - celery leaves (efsa foodex2)",
    "FOODON_03414537": "caesar's mushroom",
    "FOODON_03540808": "08080 - saffron milk cap (efsa foodex2)",
    "FOODON_03304026": "tomato sauce with tomato chunks",
    "FOODON_03490301": "stainless steel container",
    "FOODON_03413542": "threaded abalone",
    "FOODON_03401822": "10006318 - mayonnaise/mayonnaise substitutes (perishable) (gs1 gpc)",
    "FOODON_03414454": "carboxy methyl cellulose, sodium carboxy methyl cellulose, cellulose gum",
    "FOODON_03308068": "pike perch (raw)",
    "FOODON_03413574": "ribbon crayfish",
    "FOODON_03411083": "pinus genus tree",
    "FOODON_03541468": "14680 - other citrus fruits (efsa foodex2)",
    "FOODON_03541823": "18230 - jam, mixed fruit (efsa foodex2)",
    "FOODON_03302698": "spice oil",
    "FOODON_03450009": "cooked by popping",
    "FOODON_03541831": "18310 - fruit compote, apple (efsa foodex2)",
    "FOODON_03412081": "Anjou pear plant",
    "FOODON_03303561": "blueberry (canned)",
    "FOODON_03308544": "scallop (pacific ocean, raw)",
    "FOODON_03304460": "candied high protein tablet",
    "FOODON_03542349": "23490 - cod, pacific (efsa foodex2)",
    "FOODON_03542188": "21880 - beerwurst (efsa foodex2)",
    "FOODON_03309078": "cape hake (raw)",
    "FOODON_03414130": "guitarfish genus",
    "FOODON_03316345": "citrus peel (grated)",
    "FOODON_00001311": "mum-khai-pla",
    "NCBITaxon_3650": "Cucurbitaceae",
    "NCBITaxon_9102": "Meleagris",
    "PO_0006338": "embryo leaf",
    "FOODON_03311379": "chocolate eclair (frozen)",
    "FOODON_03415152": "common hedgenettle plant",
    "CHEBI_17792": "organohalogen compound",
    "FOODON_03541016": "10160 - mashed potato powder (efsa foodex2)",
    "FOODON_03311559": "trout baked",
    "NCBITaxon_278205": "Myoida",
    "FOODON_00001212": "pastry food product",
    "NCBITaxon_1248172": "Pleuroncodes planipes",
    "FOODON_03411321": "obsolete: mace",
    "FOODON_03490117": "paper bag, sack or pouch, plastic liner",
    "FOODON_03315746": "fruit (glazed)",
    "FOODON_00003098": "lovage leaf",
    "FOODON_00002269": "spinach food product",
    "FOODON_03301454": "tomato juice",
    "FOODON_03412825": "wild grape plant",
    "FOODON_00001685": "carp or minnow family food product",
    "NCBITaxon_3913": "Vigna",
    "FOODON_03303769": "almond bark (artificially sweetened)",
    "FOODON_03544083": "40830 - malt extract (efsa foodex2)",
    "NCBITaxon_4527": "Oryza",
    "FOODON_03401640": "10005780 - pheasant - prepared/processed (gs1 gpc)",
    "FOODON_03430166": "oral drops",
    "FOODON_03311002": "shad raw",
    "FOODON_03310664": "vitamin supplement, prenatal",
    "FOODON_03500057": "food-grade natural-based polymer surface",
    "FOODON_03411046": "california mussel",
    "FOODON_03309738": "beef (cooked)",
    "FOODON_03315445": "fish (pickled)",
    "FOODON_03414778": "leichhardt tree",
    "FOODON_03543405": "34050 - coffee beans and similar- (efsa foodex2)",
    "FOODON_03305186": "macaroni (enriched)",
    "FOODON_03420247": "part of algae or fungus",
    "FOODON_03305117": "coconut milk chocolate candy",
    "FOODON_00002125": "plant based bakery food product",
    "FOODON_00001249": "freshwater fish food product",
    "FOODON_03309402": "frosted mini-wheat cereal",
    "FOODON_00003220": "hazelnut oil",
    "FOODON_03301497": "cow milk (fortified)",
    "FOODON_03540676": "06760 - courgettes and similar- (efsa foodex2)",
    "FOODON_03310121": "sorrel leaf (raw)",
    "FOODON_03302947": "rennet custard",
    "FOODON_00002248": "sockeye salmon food product",
    "NCBITaxon_4678": "Allium",
    "FOODON_00001694": "cattle based pie food product",
    "FOODON_03543761": "37610 - follow-on formulae, powder (efsa foodex2)",
    "FOODON_03411840": "white hake",
    "FOODON_03305255": "honey (whipped)",
    "FOODON_03540855": "08550 - sage and similar- (efsa foodex2)",
    "FOODON_03306757": "dill pickle",
    "FOODON_03310196": "coffee with chicory (instant)",
    "FOODON_03316108": "vegetable protein-based fish analog",
    "FOODON_03307841": "tomato (whole, unpeeled, uncored, canned)",
    "FOODON_03543278": "32780 - soft drinks (efsa foodex2)",
    "GAZ_00005341": "Republic of China",
    "FOODON_03302757": "soybean meal",
    "NCBITaxon_46489": "Collocalia",
    "FOODON_03310756": "obsolete: sausage (smoked)",
    "FOODON_03414789": "nutbush plant",
    "FOODON_03306364": "apple (sliced, dehydrated)",
    "FOODON_03413217": "potassium nitrite",
    "NCBITaxon_3821": "Cajanus cajan",
    "FOODON_03302964": "okra creole",
    "FOODON_03306015": "citrus fruit (frozen)",
    "FOODON_03315497": "vinegar pickle",
    "FOODON_03414018": "spotted grouper",
    "FOODON_03542119": "21190 - corned turkey, uncooked (efsa foodex2)",
    "FOODON_03540104": "01040 - semolina (efsa foodex2)",
    "FOODON_03302604": "vegetable shortening",
    "CHEBI_33257": "secondary amide",
    "FOODON_03316875": "cream (ultrapasteurized)",
    "NCBITaxon_52824": "Brassica carinata",
    "FOODON_03540801": "08010 - other cultivated fungi (efsa foodex2)",
    "FOODON_03301241": "cherry (canned)",
    "FOODON_03542392": "23920 - conger (efsa foodex2)",
    "FOODON_00003058": "grits",
    "FOODON_00001804": "deep sea lobster food product",
    "CHEBI_28940": "calciol",
    "FOODON_03420286": "skeletal meat part, with bone, without skin, without separable fat",
    "NCBITaxon_4630": "Costaceae",
    "FOODON_03530241": "ichthyohepatotoxic poisoning",
    "FOODON_03412890": "venus clam family",
    "FOODON_03316675": "fish stick (breaded, quick-frozen)",
    "FOODON_03543129": "31290 - duck fat, processed (efsa foodex2)",
    "FOODON_03414286": "ridge scaled rattail",
    "FOODON_03541273": "12730 - rosemary, dry (efsa foodex2)",
    "FOODON_03541761": "17610 - ilamas (efsa foodex2)",
    "FOODON_03315518": "whey food product",
    "CHEBI_26208": "polyunsaturated fatty acid",
    "FOODON_03411617": "yellow popcorn plant",
    "FOODON_03307145": "yellow rice mix",
    "FOODON_03315034": "multivitamin food supplement, chewable",
    "FOODON_03316542": "tomato conserve",
    "FOODON_03540237": "02370 - biscuits (efsa foodex2)",
    "FOODON_03310568": "infant formula (canned)",
    "FOODON_00002696": "alpaca meat food product",
    "PO_0006340": "adult vascular leaf",
    "NCBITaxon_119950": "Eugenia",
    "CHEBI_35406": "oxoanion",
    "FOODON_00001914": "gooseberry food product",
    "FOODON_03309718": "flaxseed (whole, raw)",
    "FOODON_03542717": "27170 - cr\u00e9me fraiche and other mild variants of sour cream (efsa foodex2)",
    "FOODON_00001156": "citrus fruit juice",
    "FOODON_03302545": "imitation maple- and butter-flavored table syrup",
    "FOODON_03305541": "vinegar (flavored with herbs)",
    "NCBITaxon_80720": "Gadus macrocephalus",
    "FOODON_03310590": "beef kidney (raw)",
    "FOODON_03307397": "eastern pickerel (raw)",
    "FOODON_00002407": "thickness of 1.5 cm to less than 7.0 cm",
    "FOODON_03301568": "alfalfa meal",
    "NCBITaxon_230391": "Macrobrachium carcinus",
    "FOODON_00002155": "plant soup food product",
    "FOODON_03307789": "imitation cheese-flavored cracker sandwich",
    "NCBITaxon_335027": "Centrophorus squamosus",
    "FOODON_03542869": "28690 - cheese, cacio di fossa (efsa foodex2)",
    "FOODON_03543995": "39950 - mushroom soup, dry (efsa foodex2)",
    "FOODON_03544504": "45040 - omega-6 fatty acids (efsa foodex2)",
    "FOODON_03413183": "pentapotassium triphosphate",
    "FOODON_03306822": "ham broth",
    "FOODON_03301759": "tomato juice made from concentrate",
    "FOODON_03411994": "fish, lepidosireniform",
    "FOODON_03401464": "10006444 - mizuna (gs1 gpc)",
    "FOODON_03306169": "apple and cherry juice (food product)",
    "FOODON_03411990": "pufferfish family",
    "BFO_0000026": "one-dimensional spatial region",
    "FOODON_03316513": "vegetable sauce",
    "FOODON_03306216": "vegetable shortening (hydrogenated)",
    "FOODON_03308071": "fish fillet (with skin, raw, breaded, frozen)",
    "FOODON_03540273": "02730 - chocolate cake with fruits (efsa foodex2)",
    "FOODON_03541255": "12550 - kapok and similar- (efsa foodex2)",
    "FOODON_03400205": "wine, 7-24% alcohol (us cfr)",
    "FOODON_03414392": "extracts of rosemary",
    "FOODON_03401251": "0830000 - spices, bark (ec)",
    "FOODON_03310449": "blood snapper (raw)",
    "FOODON_03414452": "potassium phosphates",
    "FOODON_03316156": "longaniza fresca",
    "FOODON_00002499": "safflower plant food product",
    "CHEBI_24840": "inorganic sulfate salt",
    "NCBITaxon_10184": "Castor",
    "FOODON_03542965": "29650 - egg mixed whole (efsa foodex2)",
    "FOODON_03307100": "rum pudding",
    "FOODON_03303117": "cherry glace",
    "FOODON_03317575": "skim milk (pasteurized)",
    "FOODON_03411233": "garlic plant",
    "NCBITaxon_3620": "Rheum",
    "FOODON_03543010": "30100 - treacle (efsa foodex2)",
    "FOODON_03414360": "dromedary camel",
    "FOODON_03412714": "porcupine fish",
    "NCBITaxon_181185": "Cordia myxa",
    "FOODON_03302260": "imitation flavored fountain syrup base",
    "FOODON_03541128": "11280 - brazil nuts and similar- (efsa foodex2)",
    "FOODON_03316913": "fish (canned, pasteurized)",
    "FOODON_00001683": "cardamom food product",
    "FOODON_03430158": "effervescent tablet",
    "FOODON_03302984": "paddlefish roe (raw)",
    "FOODON_03316530": "fruit puree semi-finished",
    "FOODON_03400416": "foaming agent (codex)",
    "FOODON_03413553": "duck barnacle",
    "NCBITaxon_9705": "Odobenidae",
    "FOODON_03400917": "10000214 - ice (gs1 gpc)",
    "HANCESTRO_0406": "Dominican",
    "FOODON_03304693": "macaroni salad",
    "FOODON_03301642": "pulse bean (whole)",
    "CHEBI_25697": "organic cation",
    "FOODON_00003325": "turkey thigh",
    "FOODON_03530240": "ichthyocrinotoxic poisoning",
    "FOODON_03413977": "monterey spanish mackerel",
    "FOODON_03304877": "senna tea leaf (dry)",
    "FOODON_03310911": "green olive (pickled)",
    "FOODON_03310752": "date (dried)",
    "NCBITaxon_74635": "Rosa canina",
    "FOODON_03303588": "dark chocolate",
    "FOODON_03305174": "topping (pressure-packed)",
    "PO_0008018": "transition vascular leaf",
    "FOODON_03316316": "jellying aid substance",
    "NCBITaxon_8060": "Pollachius virens",
    "FOODON_03414601": "red sea bream",
    "FOODON_03413575": "stone crayfish",
    "FOODON_03415117": "hoary basil plant",
    "FOODON_03540608": "06080 - monantha vetches (with pods) (efsa foodex2)",
    "FOODON_03306604": "naranjilla beverage base",
    "NCBITaxon_9681": "Felidae",
    "FOODON_03542390": "23900 - wolffishes (efsa foodex2)",
    "FOODON_03414197": "wolfberry plant",
    "NCBITaxon_3814": "Papilionoideae",
    "CHEBI_15841": "polypeptide",
    "FOODON_03301367": "nuts (mixed)",
    "NCBITaxon_8241": "Thunnus obesus",
    "FOODON_00003369": "gilt",
    "CHEBI_5686": "heterocyclic compound",
    "FOODON_03542020": "20200 - asses-mules-hinnies liver (efsa foodex2)",
    "FOODON_03302196": "potato (whole, baked)",
    "FOODON_03414343": "vietnamese coriander plant",
    "FOODON_03544119": "41190 - herbs/spices sauces (efsa foodex2)",
    "FOODON_03411815": "red hawaiian porgy",
    "FOODON_03311754": "pear (freeze-dried)",
    "FOODON_03317366": "whey (partially delactosed)",
    "FOODON_03541875": "18750 - canned or jarred pineapple (efsa foodex2)",
    "FOODON_00002773": "asparagus bean food product",
    "FOODON_03541948": "19480 - deer, fallow fresh meat (efsa foodex2)",
    "FOODON_03540280": "02800 - croissant, filled with jam (efsa foodex2)",
    "FOODON_03542512": "25120 - prawn, giant tiger (efsa foodex2)",
    "FOODON_03414876": "cachama",
    "FOODON_00003372": "suckler pig",
    "FOODON_03302306": "sardine fillet",
    "FOODON_03304247": "soup (condensed, canned)",
    "FOODON_00001050": "tempeh food product",
    "FOODON_03412280": "queenfish",
    "HANCESTRO_0544": "Nigerian",
    "FOODON_03316005": "beverage (water-based)",
    "FOODON_00001891": "fruit salad food product",
    "FOODON_03544427": "44270 - emulsifier (efsa foodex2)",
    "FOODON_03413545": "pinto abalone",
    "FOODON_03413580": "northern krill",
    "GAZ_00001092": "Gabon",
    "FOODON_03308146": "pacific oyster (raw)",
    "FOODON_03412166": "cape spiny lobster",
    "FOODON_00002496": "licorice plant food product",
    "CHEBI_53258": "sodium citrate",
    "FOODON_03413250": "sodium erythorbate",
    "FOODON_03414455": "stevia plant",
    "ENVO_01000627": "feedlot",
    "FOODON_03304218": "infant food (dehydrated)",
    "FOODON_03470159": "pasteurization by heat before filling",
    "ENVO_01000408": "environmental zone",
    "FOODON_03413006": "l-ascorbyl palmitate",
    "NCBITaxon_2821": "Palmaria",
    "NCBITaxon_403666": "Zygophyllales",
    "FOODON_00001727": "chicken salad food product",
    "NCBITaxon_64465": "Penaeus canaliculatus",
    "FOODON_03315393": "chewing gum (low joule)",
    "FOODON_03303659": "swiss cheese",
    "GAZ_00003936": "Metropolitan Spain",
    "FOODON_03543941": "39410 - pizza and similar with cheese, and vegetables and fruits (efsa foodex2)",
    "FOODON_03542866": "28660 - mozzarella cheese (specific for pizza) (efsa foodex2)",
    "GAZ_00003857": "Monaco",
    "FOODON_03412761": "strawberry tree",
    "FOODON_00001117": "horse dairy food product",
    "FOODON_03540978": "09780 - yams (efsa foodex2)",
    "FOODON_00001797": "cured cheese food product",
    "GAZ_00001090": "Burundi",
    "FOODON_03316812": "vermicelli (nonfat milk)",
    "FOODON_03307714": "syrup jelly",
    "FOODON_03480013": "packed in lightly sweetened water or juice",
    "NCBITaxon_301862": "Annona reticulata",
    "FOODON_03490223": "multicomponent adhesive, no solvent",
    "CHEBI_33366": "copper group element atom",
    "FOODON_00001059": "apple juice",
    "FOODON_00002314": "tomato based gravy or sauce food product",
    "FOODON_03543070": "30700 - liquorice mass (efsa foodex2)",
    "FOODON_00002684": "mustard greens",
    "FOODON_00001971": "imitation vinegar food product",
    "FOODON_03301768": "pepper (canned)",
    "FOODON_03413066": "obsolete: citric acid",
    "FOODON_03413579": "pygmy krill",
    "FOODON_03308914": "herring in wine sauce",
    "GAZ_00001099": "Swaziland",
    "FOODON_03541898": "18980 - horse msm (efsa foodex2)",
    "FOODON_03302153": "kava beverage (artificially sweetened)",
    "FOODON_03401296": "pie, unsweetened, or pizza (eurofir)",
    "NCBITaxon_13575": "Istiophorus platypterus",
    "FOODON_00002682": "pet food",
    "FOODON_03307115": "grape spread",
    "FOODON_03306999": "banana puree",
    "FOODON_03307031": "sweet potato (candied, canned)",
    "FOODON_00003054": "trail mix",
    "FOODON_00003286": "truffle food product",
    "FOODON_03304174": "beef drippings",
    "FOODON_03411469": "tarragon plant",
    "NCBITaxon_3654": "Citrullus lanatus",
    "FOODON_03301235": "drupelet berry (canned)",
    "FOODON_03309472": "zebra meat (raw)",
    "FOODON_03510162": "label claim separate from food name",
    "FOODON_03400761": "065  cereal grain milling fractions (cf) (ccpr)",
    "CHEBI_34533": "Amaranth",
    "FOODON_03316884": "fish (grilled)",
    "FOODON_03309099": "kippered herring fillet",
    "FOODON_03304417": "jelly (artificially sweetened)",
    "FOODON_03303895": "hen egg (semiliquid, pasteurized, frozen)",
    "CHEBI_22301": "aldonic acid",
    "NCBITaxon_72876": "Varunidae",
    "NCBITaxon_8502": "Crocodylus porosus",
    "FOODON_03308090": "pacific herring (raw)",
    "FOODON_03543919": "39190 - sandwich and sandwich-like dishes (efsa foodex2)",
    "FOODON_03307687": "white sauce (instant bar)",
    "FOODON_03317582": "sage derby cheese",
    "FOODON_03316377": "mango (dried)",
    "FOODON_03542970": "29700 - hen egg white (efsa foodex2)",
    "FOODON_03301492": "half and half (sour)",
    "FOODON_03541978": "19780 - pigeon fresh meat (efsa foodex2)",
    "FOODON_00001899": "gelatin dessert food product",
    "FOODON_03307042": "potato chip (cheddar cheese-flavored)",
    "FOODON_03316175": "shallot pulp",
    "NCBITaxon_3489": "Artocarpus heterophyllus",
    "FOODON_03542154": "21540 - teewurst-type sausage (efsa foodex2)",
    "NCBITaxon_7962": "Cyprinus carpio",
    "FOODON_03401511": "10005879 - sweeties (gs1 gpc)",
    "FOODON_03542388": "23880 - lizardfishes (efsa foodex2)",
    "FOODON_03540931": "09310 - dwarf nasturtium (efsa foodex2)",
    "FOODON_03304837": "imitation spring water (bottled)",
    "FOODON_03304322": "margarine (liquid)",
    "FOODON_03309423": "pollock fillet (with skin, raw)",
    "FOODON_03414384": "weathervane scallop",
    "FOODON_03510245": "high omega-3 fatty acids",
    "FOODON_03316690": "premier jus",
    "FOODON_03303823": "beverage concentrate (frozen)",
    "FOODON_03304612": "ice cream mix (powdered, artificially flavored)",
    "FOODON_03412458": "sataw plant",
    "FOODON_03302861": "butter pecan cake",
    "CHEBI_24583": "hexitol",
    "FOODON_03303210": "cracker sandwich (peanut butter filled)",
    "FOODON_03541790": "17900 - processed fruit products (efsa foodex2)",
    "FOODON_03541384": "13840 - juniper berry (efsa foodex2)",
    "FOODON_03304313": "seed sprout",
    "FOODON_03310390": "flavoring syrup for snow cones",
    "FOODON_03540429": "04290 - bitterleaves (efsa foodex2)",
    "FOODON_03306908": "peanut butter (vitamin a, d and e added)",
    "NCBITaxon_3382": "Gnetum gnemon",
    "NCBITaxon_38413": "Eragrostis",
    "FOODON_03308087": "sardinet (raw)",
    "FOODON_03415088": "chrysanthemum plant",
    "FOODON_03413965": "leatherjacket",
    "FOODON_03430100": "divided into pieces, thickness <0.3 cm.",
    "FOODON_00001218": "bee food product",
    "FOODON_00002361": "white pepper food product",
    "FOODON_03412721": "almond, bitter (plant)",
    "NCBITaxon_94951": "Dentex dentex",
    "FOODON_03413742": "plum tomato plant",
    "FOODON_03544260": "42600 - exotic fruit flavour (efsa foodex2)",
    "FOODON_03305003": "worcestershire sauce",
    "NCBITaxon_43700": "Monopterus albus",
    "FOODON_03543493": "34930 - fumitory infusion leaves (efsa foodex2)",
    "NCBITaxon_163129": "Arripis georgianus",
    "FOODON_03543873": "38730 - egg based dishes (efsa foodex2)",
    "FOODON_03542496": "24960 - swimming crabs (efsa foodex2)",
    "FOODON_03540943": "09430 - pickled / marinated vegetables (efsa foodex2)",
    "FOODON_03301832": "popcorn (unpopped)",
    "FOODON_03400237": "sweetener (us cfr)",
    "FOODON_03541741": "17410 - plantains (efsa foodex2)",
    "FOODON_03543862": "38620 - bouillabaisse (efsa foodex2)",
    "FOODON_03316532": "tomato (raw)",
    "FOODON_03543866": "38660 - prepared fish salad (efsa foodex2)",
    "FOODON_03400984": "10000044 - syrup/treacle/molasses (shelf stable) (gs1 gpc)",
    "FOODON_03543453": "34530 - strawberry infusion leaves (efsa foodex2)",
    "FOODON_00001990": "kumquat food product",
    "FOODON_03302665": "corn (canned)",
    "FOODON_03307432": "orange juice bar (frozen)",
    "HANCESTRO_0561": "Romanian founder",
    "FOODON_03400835": "sugar or sugar product (eurofir)",
    "FOODON_00001587": "almond nut food product",
    "FOODON_03540427": "04270 - green amaranth leaves (efsa foodex2)",
    "NCBITaxon_8229": "Sarda",
    "FOODON_03302977": "grated american cheese product (not further specified)",
    "FOODON_03510210": "source of {name of vitamin/s}  and/or {name of mineral/s} nutrition claim",
    "CHEBI_35150": "calcium hydroxide",
    "FOODON_03414741": "morning-glory family",
    "FOODON_03543512": "35120 - jiaogulan infusion leaves (efsa foodex2)",
    "FOODON_03542543": "25430 - scallop, new zealand (efsa foodex2)",
    "FOODON_03544428": "44280 - raising agents (efsa foodex2)",
    "FOODON_03540894": "08940 - lemon basil (efsa foodex2)",
    "FOODON_03544455": "44550 - yeast cultures (efsa foodex2)",
    "FOODON_03541318": "13180 - other spices seeds (p) (efsa foodex2)",
    "FOODON_03520367": "Codex Alimentarius Commission",
    "FOODON_03542714": "27140 - acidophilus milk (efsa foodex2)",
    "FOODON_03411870": "sand sole",
    "FOODON_03306030": "orange juice blend",
    "FOODON_03400772": "085  animal fats, processed (fa) (ccpr)",
    "FOODON_03540004": "00040 - mixture of grains (efsa foodex2)",
    "FOODON_00002527": "piadina flat bread",
    "FOODON_03310237": "apple brandy (food product)",
    "FOODON_03540153": "01530 - wheat crisp bread (efsa foodex2)",
    "FOODON_03541594": "15940 - cranberries and similar- (efsa foodex2)",
    "FOODON_03543463": "34630 - bearberry infusion leaves (efsa foodex2)",
    "FOODON_03542371": "23710 - snappers (efsa foodex2)",
    "NCBITaxon_8820": "Apterygidae",
    "FOODON_03400414": "flavours solubilizer (codex)",
    "FOODON_00001296": "sheep milk cheese (unpasteurized)",
    "FOODON_03316056": "food (unprocessed)",
    "FOODON_03415087": "honeybush plant",
    "FOODON_03305683": "seafood gumbo",
    "FOODON_03316845": "white corn meal (self-rising)",
    "GAZ_00004094": "Armenia",
    "FOODON_03316398": "onion (grated)",
    "CHEBI_22390": "alpha-D-glucoside",
    "FOODON_03413626": "crystal shrimp",
    "FOODON_03530084": "processed in stone container",
    "FOODON_00002047": "mushroom product flavoring or seasoning",
    "FOODON_03414585": "spirochaetae",
    "FOODON_03301657": "nonfat dry milk",
    "FOODON_03415121": "buchu plant",
    "FOODON_03543295": "32950 - fruit soft drink, pineapple (efsa foodex2)",
    "FOODON_03530058": "dark fish flesh",
    "FOODON_03414736": "lovegrass plant",
    "FOODON_03304771": "artichoke (marinated)",
    "NCBITaxon_58228": "Garcinia mangostana",
    "FOODON_03470104": "obsolete: preservation by fermentation",
    "FOODON_03308119": "wheat germ (enzyme-deactivated)",
    "FOODON_03490201": "vial",
    "FOODON_03316502": "fish product (frozen)",
    "FOODON_03542878": "28780 - cheese, iberico (efsa foodex2)",
    "RO_0000079": "function of",
    "FOODON_03315584": "decoration for plain cakes and wafers",
    "FOODON_03543084": "30840 - water-based sweet desserts (efsa foodex2)",
    "FOODON_03411725": "hyacinth bean plant",
    "FOODON_00003425": "Maize plant",
    "FOODON_03544013": "40130 - mixed soups (efsa foodex2)",
    "FOODON_00001722": "chestnut food product",
    "FOODON_03302516": "bakery product (containing butter)",
    "FOODON_03540846": "08460 - sorrel (efsa foodex2)",
    "FOODON_03308916": "herring tidbit in wine sauce",
    "FOODON_03309206": "hoki (raw)",
    "FOODON_03543845": "38450 - composite dishes (efsa foodex2)",
    "FOODON_00001857": "food flavoring or seasoning product",
    "FOODON_03543041": "30410 - white chocolate (efsa foodex2)",
    "FOODON_03544442": "44420 - bulking agent (efsa foodex2)",
    "FOODON_03413685": "sutchi catfish",
    "FOODON_03400330": "bulking agent (ec)",
    "FOODON_03303142": "marie biscuit cookie",
    "FOODON_03304664": "chopped beef pattie (raw)",
    "NCBITaxon_30872": "Paralabrax",
    "FOODON_03413478": "ruffe",
    "FOODON_03316086": "cow milk (partly dehydrated, more than 28% milk solids)",
    "NCBITaxon_6736": "Panulirus japonicus",
    "FOODON_03413055": "calcium tartrate",
    "UBERON_0019249": "2-cell stage embryo",
    "GAZ_00001105": "Malawi",
    "FOODON_03412172": "balsam apple plant",
    "FOODON_03412282": "obsolete: school shark",
    "FOODON_03542981": "29810 - sugar and similar, confectionery and water-based sweet desserts (efsa foodex2)",
    "FOODON_03544285": "42850 - herb and garlic flavour (efsa foodex2)",
    "FOODON_03543384": "33840 - whisky (efsa foodex2)",
    "FOODON_00002313": "tomato relish food product",
    "FOODON_03540984": "09840 - arrowroots (efsa foodex2)",
    "FOODON_03414411": "calcium citrates",
    "FOODON_03401700": "10006348 - other melons (gs1 gpc)",
    "FOODON_03543895": "38950 - potato puree from flakes or powder (efsa foodex2)",
    "FOODON_03541367": "13670 - other spices roots or rhizome (e) (efsa foodex2)",
    "FOODON_03510189": "infant as food consumer, 0 - 3 months",
    "OBI_0100026": "organism",
    "NCBITaxon_8092": "Cottidae",
    "FOODON_03541903": "19030 - generic poultry msm (efsa foodex2)",
    "FOODON_03311827": "roast beef (cooked, chilled)",
    "GAZ_00002565": "Province of Nova Scotia",
    "FOODON_03302203": "orange drink base (artificially colored)",
    "FOODON_03411981": "five-lined snapper",
    "FOODON_03411194": "head vegetable",
    "FOODON_03544496": "44960 - iodine (efsa foodex2)",
    "FOODON_03411419": "sunfish",
    "FOODON_03542825": "28250 - cheese, kurpianka smoked (efsa foodex2)",
    "FOODON_03305068": "fatty food",
    "FOODON_03530160": "thigh (poultry meat cut)",
    "FOODON_03400166": "color additive (us cfr)",
    "FOODON_03543180": "31800 - juice, blackberry (efsa foodex2)",
    "CHEBI_17045": "dinitrogen oxide",
    "FOODON_03411661": "crenshaw melon plant",
    "FOODON_03542637": "26370 - smoked salmon (efsa foodex2)",
    "FOODON_03315408": "vegetable yogurt",
    "FOODON_03317128": "root vegetable (flakes, powdered)",
    "FOODON_03401454": "10005996 - brussel sprouts (gs1 gpc)",
    "FOODON_03301793": "blackeyed pea (raw, frozen)",
    "FOODON_03304909": "tomato soup",
    "FOODON_03420159": "multicomponent extract, concentrate or isolate",
    "FOODON_03400820": "bread product (eurofir)",
    "NCBITaxon_7671": "Strongylocentrotus droebachiensis",
    "FOODON_03541776": "17760 - pineapples and similar- (efsa foodex2)",
    "FOODON_03413828": "atlantic lizardfish",
    "NCBITaxon_115479": "Hyphaene thebaica",
    "FOODON_03309827": "peanut (whole, skin off, salted, roasted)",
    "FOODON_03311211": "brazilnut oil (roasted)",
    "FOODON_03542489": "24890 - danube crayfish (efsa foodex2)",
    "FOODON_03544027": "40270 - prepared rice salad (efsa foodex2)",
    "FOODON_03412322": "rock shell snail",
    "FOODON_03541266": "12660 - celery leaves, dry (efsa foodex2)",
    "FOODON_03311538": "barley (roasted)",
    "FOODON_03311353": "carrot top (raw)",
    "FOODON_03414930": "parkia plant",
    "FOODON_03411222": "fish",
    "FOODON_03308379": "trout (smoked)",
    "FOODON_03541868": "18680 - canned or jarred apricot (efsa foodex2)",
    "NCBITaxon_1286129": "Mullus auratus",
    "NCBITaxon_120289": "Psidium",
    "NCBITaxon_30840": "Haemulidae",
    "FOODON_03544408": "44080 - wild strawberry flavour (efsa foodex2)",
    "GAZ_00006916": "Tonga",
    "FOODON_03306306": "cow blood",
    "FOODON_03304993": "soybean (whole, roasted)",
    "FOODON_03543679": "36790 - guarana (infusion seeds) (efsa foodex2)",
    "FOODON_03490377": "polystyrene container",
    "FOODON_03308094": "japanese pilchard (raw)",
    "FOODON_03543870": "38700 - fishcakes (efsa foodex2)",
    "FOODON_03460774": "magnesium added",
    "FOODON_03541185": "11850 - sesame seeds (efsa foodex2)",
    "FOODON_00002633": "tortelloni",
    "OBI_0200000": "data transformation",
    "FOODON_03540838": "08380 - culantro leaves (efsa foodex2)",
    "FOODON_00003086": "young jackfruit",
    "FOODON_03301154": "clam (frozen)",
    "FOODON_03304730": "candy (fruit-flavored)",
    "FOODON_03316328": "shrimp product (unsterilized)",
    "FOODON_03309024": "canadian bass (raw)",
    "FOODON_03543998": "39980 - soups (ready-to-eat) (efsa foodex2)",
    "NCBITaxon_303185": "Gentianeae",
    "GAZ_00006889": "Laos",
    "FOODON_03413329": "american persimmon plant",
    "NCBITaxon_282294": "Mesodesmatidae",
    "FOODON_03309842": "morocco bean (whole)",
    "FOODON_03317356": "margarine (dietary)",
    "FOODON_00002668": "alligator meat",
    "NCBITaxon_981071": "Brassiceae",
    "FOODON_03413177": "oxidized polyethylene wax",
    "FOODON_03303630": "vegetable juice cocktail",
    "FOODON_03306864": "peanut butter with rose hips",
    "FOODON_03305195": "ginseng brandy",
    "NCBITaxon_9615": "Canis lupus familiaris",
    "FOODON_03411989": "groper",
    "NCBITaxon_72274": "Pseudomonadales",
    "FOODON_03306997": "pineapple spread",
    "FOODON_03401653": "10006282 - antelope - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03540812": "08120 - truffles (efsa foodex2)",
    "FOODON_03540111": "01110 - wheat bran (efsa foodex2)",
    "FOODON_03530196": "fat content 30-45%",
    "FOODON_03541696": "16960 - water pears (efsa foodex2)",
    "FOODON_03542881": "28810 - cheese, leyden (efsa foodex2)",
    "FOODON_03307749": "tamale wrapper",
    "FOODON_03400260": "nut or nut product (us cfr)",
    "FOODON_03544436": "44360 - anti-foaming agent (efsa foodex2)",
    "FOODON_03310429": "deer meat (smoked)",
    "FOODON_00003132": "sparkleberry plant",
    "FOODON_03401517": "10006310 - coffee substitutes - regular(non-instant) (gs1 gpc)",
    "FOODON_03306642": "sherbet on wooden stick",
    "FOODON_03303726": "chocolate candy (bourbon whiskey-flavored)",
    "FOODON_03311013": "white peppercorn (whole, dried)",
    "FOODON_03316386": "ginger in syrup",
    "FOODON_03317052": "fruit jelly (no added sugar)",
    "FOODON_03510105": "unsweetened claim or use",
    "FOODON_03542600": "26000 - snail, giant (efsa foodex2)",
    "FOODON_03303844": "butter or margarine extender (artificially sweetened)",
    "FOODON_00002842": "Williams bon chr\u00e9tien pear plant",
    "FOODON_03414112": "gulper shark family",
    "FOODON_03317294": "italian sausage",
    "FOODON_03312050": "coffee drink (canned)",
    "NCBITaxon_745122": "Cilus gilberti",
    "FOODON_03307767": "strawberry-flavored candy roll (food product)",
    "FOODON_03400436": "propellant (codex)",
    "FOODON_03414842": "african pearwood plant",
    "FOODON_03541683": "16830 - acerolas (efsa foodex2)",
    "FOODON_03307728": "barley syrup",
    "FOODON_03309554": "bagel",
    "FOODON_03540203": "02030 - fine yeast sweet dough (brioche) (efsa foodex2)",
    "FOODON_03311272": "garlic (chopped, bottled)",
    "FOODON_03413968": "alexandria pompano",
    "FOODON_03303915": "chestnut (glazed)",
    "FOODON_03411719": "gourd plant",
    "FOODON_03306611": "orange and apricot juice drink (diluted)",
    "FOODON_03411703": "castor bean plant",
    "FOODON_03413863": "allis shad",
    "FOODON_03412963": "service tree",
    "FOODON_03307231": "ice cream (flavored with alcoholic beverage)",
    "FOODON_00001202": "winged bean food product",
    "GAZ_00009715": "Tuvalu",
    "FOODON_03401355": "50350400 - single leaf salad greens (gs1 gpc)",
    "FOODON_03309045": "cuttlefish (sliced, seasoned, dried)",
    "FOODON_03304931": "tea (liquid, with cream)",
    "FOODON_03544450": "44500 - preparations for dessert (efsa foodex2)",
    "FOODON_03301442": "obsolete: dairy product analog (not further specified)",
    "FOODON_03317038": "dessert product (milk based, no added sugar)",
    "CHEBI_35352": "organonitrogen compound",
    "FOODON_03420218": "organ meat",
    "PECO_0007027": "seasonal environment exposure",
    "FOODON_03540225": "02250 - common laminated dough (efsa foodex2)",
    "FOODON_03301444": "vegetable juice food product",
    "FOODON_03412076": "magic mushroom",
    "FOODON_03413849": "californian round herring",
    "FOODON_03490403": "polyethylene (low density) - polyethylene (low density) container",
    "FOODON_03411625": "reptile",
    "HANCESTRO_0314": "Sorbian",
    "FOODON_03302070": "marrow bean (whole, dried)",
    "FOODON_03541551": "15510 - thimbleberries (efsa foodex2)",
    "FOODON_03303735": "candy (artificially flavored)",
    "FOODON_03315241": "food recognized as a source of vitamin b1",
    "FOODON_03400267": "seafood or seafood product (us cfr)",
    "FOODON_03540216": "02160 - shortbread pastry (efsa foodex2)",
    "FOODON_03400141": "aerated confectionery (us cfr)",
    "FOODON_00002344": "wax bean food product",
    "FOODON_03413848": "chosa herring",
    "CHEBI_33273": "polyatomic anion",
    "FOODON_03400918": "10000219 - juice - ready to drink (perishable) (gs1 gpc)",
    "FOODON_03541846": "18460 - fruit or fruit-vegetable puree (efsa foodex2)",
    "FOODON_03411221": "cashew plant",
    "GAZ_00002948": "Andorra",
    "FOODON_03308649": "ling (raw)",
    "FOODON_03414840": "blue mallee plant",
    "FOODON_03540917": "09170 - aniseed myrtle (efsa foodex2)",
    "NCBITaxon_41712": "Osteoglossiformes",
    "FOODON_03306039": "krill (whole, peeled)",
    "FOODON_03544300": "43000 - leek flavour (efsa foodex2)",
    "NCBITaxon_394708": "Sebastes viviparus",
    "FOODON_03401711": "10005959 - dates (gs1 gpc)",
    "FOODON_03544367": "43670 - rum-raisin flavour (efsa foodex2)",
    "FOODON_00002675": "Buffalo wing",
    "FOODON_03304923": "chicken-flavored consomm\u00e9 (instant)",
    "FOODON_03316713": "cheese herrgardsost",
    "ENVO_01000932": "nursing home",
    "NCBITaxon_55577": "Dioscorea rotundata",
    "FOODON_03412142": "obsolete argentine hake",
    "NCBITaxon_387743": "Dendrocalamus asper",
    "FOODON_03302745": "rice (curried)",
    "NCBITaxon_8907": "Charadriidae",
    "FOODON_03307657": "sesame ginger stir-fry (frozen)",
    "NCBITaxon_6658": "Branchiopoda",
    "FOODON_00001597": "animal-based sandwich food product",
    "NCBITaxon_19944": "Valerianaceae",
    "FOODON_03411037": "northern horse mussel",
    "FOODON_03543782": "37820 - simple cereals which have to be reconstituted with milk or other appropriate nutritious liquids (efsa foodex2)",
    "FOODON_03303549": "imitation semisoft part skim cheese",
    "FOODON_03542592": "25920 - turtle, loggerhead (efsa foodex2)",
    "FOODON_03414358": "chinese persimmon plant",
    "FOODON_03543330": "33300 - alcoholic beverages (efsa foodex2)",
    "FOODON_03302034": "beet juice",
    "FOODON_03541393": "13930 - long pepper fruit (efsa foodex2)",
    "FOODON_03310838": "pork liver sausage",
    "FOODON_03543483": "34830 - damiana infusion leaves (efsa foodex2)",
    "FOODON_03542207": "22070 - canned-tinned meat (efsa foodex2)",
    "FOODON_00003065": "pomegranate food product",
    "FOODON_03411570": "chub mackerel (Scomber japonicus)",
    "FOODON_03306671": "imitation orange juice (dehydrated)",
    "FOODON_03460128": "multi-component food fermentation",
    "FOODON_03412356": "softshell clam",
    "FOODON_03413404": "bearberry plant",
    "FOODON_03304014": "spaghetti sauce with meat",
    "FOODON_03544433": "44330 - acid (efsa foodex2)",
    "FOODON_00001606": "soup animal component",
    "FOODON_03411281": "kale plant",
    "FOODON_03420117": "pod and full-size seed, mixture",
    "NCBITaxon_30867": "Rachycentridae",
    "FOODON_03411457": "chicken",
    "FOODON_03490259": "metal gasket",
    "FOODON_03309079": "fish fillet (whitemeat, skinless, raw)",
    "NCBITaxon_8790": "Dromaius novaehollandiae",
    "FOODON_03306799": "wrinkled pea (whole, raw)",
    "FOODON_03543905": "39050 - bread- (or similar products) based dishes (efsa foodex2)",
    "FOODON_03301723": "cranberry (whole, raw)",
    "FOODON_00001095": "fermented grape beverage",
    "FOODON_03307086": "orange spread with whiskey",
    "NCBITaxon_13492": "Diospyros",
    "FOODON_03544410": "44100 - woodruff flavour (efsa foodex2)",
    "FOODON_03305680": "apple pie filling",
    "FOODON_03411555": "phaseolus vulgaris plant",
    "FOODON_03310092": "koshou",
    "FOODON_00002755": "food (rehydrated)",
    "FOODON_03540622": "06220 - asparagus peas (with pods) (efsa foodex2)",
    "NCBITaxon_205478": "Pachyrhizus ahipa",
    "FOODON_03401281": "USDA SR vegetables and vegetable products (1100)",
    "FOODON_03541463": "14630 - tangerines (efsa foodex2)",
    "NCBITaxon_16714": "Juglandaceae",
    "FOODON_03304957": "rock lobster soup (food product)",
    "FOODON_03309424": "garfish (raw)",
    "NCBITaxon_21019": "Castanea",
    "FOODON_03308633": "fish block (minced)",
    "FOODON_03304093": "beef tripe (raw)",
    "NCBITaxon_6636": "Todarodes",
    "FOODON_03301953": "marzipan candy",
    "FOODON_03460158": "obsolete: sucrose added",
    "FOODON_03413044": "calcium lactate",
    "FOODON_03411208": "squash plant",
    "FOODON_03413168": "monostarch phosphate",
    "FOODON_03490168": "aluminum tube",
    "FOODON_03302611": "dry food mix (prepared)",
    "NCBITaxon_96776": "Trachichthyidae",
    "FOODON_03543863": "38630 - fish gratin (efsa foodex2)",
    "FOODON_03303868": "cheese (dehydrated)",
    "FOODON_03316381": "lemon (dried)",
    "FOODON_03311201": "wild cherry juice concentrate",
    "FOODON_03544404": "44040 - wasabi flavour (efsa foodex2)",
    "FOODON_03541264": "12640 - bay leaves, dry (efsa foodex2)",
    "FOODON_03311236": "lowfat cow milk (2%, fortified, pasteurized)",
    "FOODON_03415030": "chilgoza pine plant",
    "NCBITaxon_84638": "Menippe nodifrons",
    "FOODON_03316020": "meat product (cured)",
    "CHEBI_32178": "Talc",
    "FOODON_03401266": "1200000 - crops exclusively for animal feed (ec)",
    "FOODON_03541249": "12490 - shea nuts (efsa foodex2)",
    "FOODON_03311229": "popcorn (microwaved)",
    "FOODON_03411162": "pomegranate plant",
    "FOODON_03542309": "23090 - char (efsa foodex2)",
    "FOODON_03543517": "35170 - lime infusion leaves (efsa foodex2)",
    "FOODON_03413515": "fish, carcharhiniform",
    "NCBITaxon_259703": "Atractoscion nobilis",
    "FOODON_03401531": "10005827 - dairy based products / meals - not ready to eat/drink (frozen) (gs1 gpc)",
    "NCBITaxon_9780": "Elephantidae",
    "FOODON_03530207": "food plant cultivation",
    "FOODON_03304667": "sausage and biscuit sandwich",
    "FOODON_03540636": "06360 - plum tomato (efsa foodex2)",
    "NCBITaxon_30475": "Rajidae",
    "FOODON_03490325": "propyonate cellulose film",
    "FOODON_03315055": "topping dairy frozen",
    "FOODON_03400830": "potato dish (eurofir)",
    "FOODON_03305320": "tropical fruit (pulp)",
    "RO_0001000": "derives from",
    "FOODON_03301622": "cottonseed meal (ammoniated)",
    "FOODON_03543294": "32940 - fruit soft drink, pear (efsa foodex2)",
    "FOODON_03301496": "milk (vitamin d added)",
    "PATO_0002041": "anterior-posterior diameter",
    "ENVO_01001125": "ice",
    "FOODON_03544229": "42290 - cheese flavour (efsa foodex2)",
    "FOODON_03309572": "french vanilla ice cream",
    "FOODON_03541883": "18830 - horse carcase (efsa foodex2)",
    "FOODON_03543805": "38050 - formulas for metabolic disorders (efsa foodex2)",
    "FOODON_03302167": "orange-flavored beverage syrup",
    "FOODON_03542937": "29370 - dairy desserts spoonable (efsa foodex2)",
    "FOODON_03430156": "chewable tablet",
    "FOODON_03470166": "drying by infrared heat radiation",
    "FOODON_03317398": "fruit (unprocessed, deep-frozen)",
    "CHEBI_38338": "aminopyrimidine",
    "FOODON_03411933": "california corbina",
    "FOODON_03530178": "fat content > 4%",
    "FOODON_03315493": "seaweed (processed)",
    "CHEBI_90852": "N-sulfonylcarboxamide",
    "FOODON_03510154": "reduced sodium claim or use",
    "FOODON_03305951": "fruit jelly made from hard cider",
    "FOODON_03302178": "trout (raw)",
    "FOODON_03315178": "frozen dessert product",
    "NCBITaxon_273455": "Lutjanus johnii",
    "NCBITaxon_109096": "Chaerophyllum bulbosum",
    "NCBITaxon_1051067": "Doryteuthis pealeii",
    "FOODON_00002879": "somiviki",
    "GAZ_00000462": "Antarctica",
    "FOODON_03304640": "black tea leaf (dry)",
    "FOODON_03307228": "cookie (whiskey-flavored irish coffee bar)",
    "FOODON_03415058": "korean raspberry plant",
    "IAO_0000027": "data item",
    "FOODON_03413663": "escargot",
    "FOODON_03460292": "curing or aging 4 to 6 months",
    "CHEBI_17376": "cystine",
    "FOODON_03301416": "blackberry (canned)",
    "FOODON_03316739": "lobster (quick-frozen)",
    "FOODON_03303094": "coffee with chicory (roasted, ground)",
    "FOODON_03412912": "halfbeak family",
    "FOODON_03540921": "09210 - white ginger (efsa foodex2)",
    "NCBITaxon_508556": "Sprattus sprattus sprattus",
    "FOODON_03306752": "pickle (artificially sweetened)",
    "FOODON_03541602": "16020 - muntries (efsa foodex2)",
    "FOODON_03305242": "pineapple jam",
    "FOODON_00003056": "rice bread",
    "FOODON_03306461": "seal meat (raw)",
    "NCBITaxon_8017": "Oncorhynchus gorbuscha",
    "FOODON_03317295": "pork sausage (smoked)",
    "FOODON_03304292": "spice mixture",
    "CHEBI_23117": "chlorine molecular entity",
    "FOODON_03317392": "wine (high acid)",
    "NCBITaxon_161924": "Penaeus penicillatus",
    "UBERON_0002370": "thymus",
    "FOODON_03301205": "parsley leaf (raw)",
    "FOODON_03309985": "rice cake",
    "FOODON_03542160": "21600 - german salami (efsa foodex2)",
    "FOODON_03543581": "35810 - hibiscus infusion flowers (efsa foodex2)",
    "FOODON_03414205": "chaste tree",
    "FOODON_03400763": "067  vegetable oils, crude (oc) (ccpr)",
    "FOODON_03460357": "carob coating or covering process",
    "FOODON_03303050": "alfalfa juice (food product)",
    "FOODON_03311394": "potato (cylinder, minced, fried, frozen)",
    "CHEBI_25348": "methylxanthine",
    "NCBITaxon_69944": "Lota lota",
    "NCBITaxon_223145": "Diodon hystrix",
    "FOODON_03400892": "10000111 - coffee - beans/ground (gs1 gpc)",
    "FOODON_03414747": "acronychia plant",
    "FOODON_03308291": "hogchoker (raw)",
    "FOODON_03400423": "fungicidal preservative (codex)",
    "FOODON_03307630": "apple (evaporated)",
    "FOODON_03490341": "paperboard container, surface treated",
    "IAO_0000033": "directive information entity",
    "FOODON_03411715": "oak tree",
    "FOODON_03315851": "cooking sauce (prepared, canned, unstandardized)",
    "FOODON_03400157": "poultry product analog (us cfr)",
    "FOODON_03541863": "18630 - canned or jarred mixed fruit (efsa foodex2)",
    "FOODON_03542057": "20570 - sheep edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "UBERON_0001911": "mammary gland",
    "FOODON_03543152": "31520 - functional vegetable margarines/fats (efsa foodex2)",
    "NCBITaxon_3258": "Equisetum arvense",
    "FOODON_03413470": "indian mulberry tree",
    "FOODON_03540491": "04910 - collards (efsa foodex2)",
    "FOODON_03401546": "10006172 - fruits - unprepared/unprocessed (fresh) variety packs (gs1 gpc)",
    "FOODON_03413882": "snake blenny",
    "FOODON_03401509": "10005877 - pummelos (gs1 gpc)",
    "NCBITaxon_34542": "Oegopsina",
    "FOODON_03543433": "34330 - bitter cola nuts (efsa foodex2)",
    "FOODON_03308669": "shrimp pieces (breaded)",
    "FOODON_03470116": "dehydration or drying",
    "CHEBI_35433": "calcium bis(dihydrogenphosphate)",
    "FOODON_03303155": "butter cookie",
    "FOODON_03309141": "alaska pollock (raw)",
    "FOODON_03302096": "soup mix (dry, with beef fat or beef extract)",
    "FOODON_03540928": "09280 - pot marigold (edible flowers) (efsa foodex2)",
    "FOODON_03311818": "white rice food product",
    "FOODON_03420160": "mammalian light cream (18%-30%)",
    "FOODON_03304538": "peanut flour (partially defatted)",
    "FOODON_03420304": "obsolete: petiole",
    "FOODON_03542217": "22170 - freshwater bream - europe (efsa foodex2)",
    "FOODON_03541886": "18860 - wild boar carcase (efsa foodex2)",
    "FOODON_03301912": "gingerbread",
    "FOODON_03413847": "white sea herring",
    "FOODON_03543897": "38970 - legumes based dishes (efsa foodex2)",
    "ENVO_00002018": "sewage",
    "FOODON_03302678": "ice cream (artificially flavored)",
    "FOODON_03307214": "soybean (whole, oil-roasted)",
    "FOODON_03541450": "14500 - limes (efsa foodex2)",
    "FOODON_03542060": "20600 - horse edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "FOODON_03310257": "corn meal",
    "FOODON_00002106": "pecan candy food product",
    "FOODON_00002461": "hen egg (whole, fried)",
    "FOODON_03302539": "butter (artificially flavored)",
    "FOODON_03310380": "grain germ",
    "FOODON_03309558": "egg dressing",
    "FOODON_03401794": "10006113 - ginger (gs1 gpc)",
    "FOODON_03305127": "cream of chicken soup",
    "FOODON_03400637": "CCFAC salts and spices, soups, sauces and salads, protein products etc.",
    "FOODON_03470124": "osmotic dehydration",
    "FOODON_03415127": "downy hemp-nettle plant",
    "FOODON_03411904": "smelt family",
    "FOODON_03310073": "rice starch",
    "NCBITaxon_195640": "Psettodes erumei",
    "FOODON_03310601": "pizza (ground beef and cheese)",
    "FOODON_03401257": "1000000 - 10. products of animal origin - terrestrial animals (ec)",
    "NCBITaxon_3914": "Vigna angularis",
    "FOODON_03543425": "34250 - barley coffee ingredient (efsa foodex2)",
    "NCBITaxon_23066": "Grossulariaceae",
    "FOODON_03315704": "topping mixes",
    "NCBITaxon_1276502": "Paralichthys woolmani",
    "FOODON_03541251": "12510 - oil palms fruits (efsa foodex2)",
    "FOODON_03411100": "blackeyed pea plant",
    "FOODON_03540554": "05540 - leeks and similar- (efsa foodex2)",
    "FOODON_03304337": "cheese (processed)",
    "NCBITaxon_1963083": "Cassia clade",
    "FOODON_03401771": "10006314 - soup additions (frozen) (gs1 gpc)",
    "FOODON_03412116": "cephalopod",
    "FOODON_00001120": "camelid milk beverage",
    "FOODON_03307018": "peach (coconut-flavored, canned)",
    "NCBITaxon_337677": "Cricetidae",
    "FOODON_03414164": "cetacean marine mammal",
    "FOODON_03310830": "sorghum beer (food product)",
    "FOODON_00001298": "unpasteurized camel milk beverage",
    "FOODON_03303835": "anhydrous milk fat",
    "GAZ_00001094": "Republic of South Africa",
    "FOODON_03415139": "blessed thistle plant",
    "GAZ_00003939": "State of Hawaii",
    "FOODON_03540720": "07200 - gentiana roots (efsa foodex2)",
    "GAZ_00002960": "Lithuania",
    "FOODON_03301587": "citrus vinegar (food product)",
    "FOODON_03310852": "fish (smoked, dried)",
    "FOODON_03413485": "new zealand langostino",
    "FOODON_03302756": "beet (freeze-dried)",
    "FOODON_03411543": "beech tree",
    "FOODON_03310541": "tuna pot pie",
    "FOODON_00001660": "bonito food product",
    "FOODON_03401657": "10005788 - chicken - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03307676": "potato soup mix",
    "GAZ_00005682": "Kerguelen Archipelago",
    "FOODON_03317292": "breakfast sausage",
    "FOODON_03540741": "07410 - tigernuts (efsa foodex2)",
    "NCBITaxon_1203427": "Rhombosolea leporina",
    "FOODON_03317564": "crystallized fruit (no added sugar)",
    "FOODON_03316488": "beverage (powdered)",
    "FOODON_03309174": "brazilian catfish (raw)",
    "CHEBI_53422": "polysorbate",
    "FOODON_03415041": "temulawak plant",
    "FOODON_03302571": "soda cracker",
    "FOODON_03309864": "obsolete: food made from almonds (food product)",
    "NCBITaxon_8072": "Lophius",
    "FOODON_00003326": "peanut butter sandwich",
    "NCBITaxon_88662": "Beryx",
    "FOODON_00002231": "semisoft cheese product",
    "FOODON_03412489": "yellow sole",
    "NCBITaxon_300208": "Canarium album",
    "FOODON_00003189": "energy drink",
    "GAZ_00000464": "Europe",
    "FOODON_03414493": "prairie turnip plant",
    "FOODON_03305787": "eggnog ice cream",
    "GAZ_00002955": "Slovenia",
    "FOODON_03315797": "pork butt (prepared)",
    "FOODON_03412152": "flatiron herring",
    "FOODON_03540287": "02870 - flan tart (efsa foodex2)",
    "FOODON_03414613": "sea cow",
    "FOODON_03305086": "lime (whole, raw)",
    "FOODON_03311592": "ham (processed)",
    "FOODON_03310577": "beef frankfurter",
    "FOODON_03413661": "green garden snail",
    "FOODON_03420243": "skeletal meat part, with bone or shell",
    "GAZ_00003961": "British Virgin Islands",
    "FOODON_03316685": "olive oil (refined residue blends)",
    "FOODON_00001063": "millet beer food product",
    "FOODON_03401893": "10006221 - vegetable based products / meals variety packs (gs1 gpc)",
    "FOODON_03543683": "36830 - lapacho (infusion bark) (efsa foodex2)",
    "FOODON_03306118": "lingonberry (frozen)",
    "FOODON_03460250": "protein substitution process",
    "FOODON_03311821": "salmon (ground, cooked)",
    "FOODON_03317256": "sturgeon roe (chilled)",
    "FOODON_03413125": "isomalt",
    "FOODON_03310120": "purslane (raw)",
    "FOODON_03544233": "42330 - chicken flavour (efsa foodex2)",
    "FOODON_03411864": "rex sole",
    "FOODON_03542182": "21820 - thuringian sausage (efsa foodex2)",
    "FOODON_03400364": "alkali (codex)",
    "NCBITaxon_7999": "Pangasiidae",
    "FOODON_00002965": "Kali Jeeri",
    "FOODON_03306621": "dumpling soup",
    "FOODON_03307191": "carrot juice (canned)",
    "FOODON_03401334": "pie, sweetened (eurofir)",
    "FOODON_03542218": "22180 - wuchang bream - china (efsa foodex2)",
    "FOODON_03316198": "concentrate based on comminuted fruit",
    "FOODON_03400854": "baking ingredient (eurofir)",
    "FOODON_03317157": "marmalade (energy-containing sweetener not added)",
    "FOODON_03414624": "flatback turtle",
    "FOODON_03401397": "50330000 - nuts/seeds - unprepared/unprocessed (perishable) (gs1 gpc)",
    "FOODON_03307320": "crab and lobster paste",
    "FOODON_03303921": "spearmint",
    "FOODON_03309184": "brazilian duckbill (raw)",
    "FOODON_03420136": "seed, skin undetermined, germ present",
    "FOODON_00002006": "lychee food product",
    "FOODON_03401462": "10006146 - kohlrabi (gs1 gpc)",
    "FOODON_03543245": "32450 - juice concentrate, sweet cherry (efsa foodex2)",
    "FOODON_00002012": "lupine bean food product",
    "FOODON_03307777": "sausage sandwich",
    "FOODON_03542339": "23390 - plaice, european (efsa foodex2)",
    "FOODON_03413149": "metatartaric acid",
    "FOODON_03412229": "pacific deep sea crab",
    "FOODON_03304560": "rice (polished)",
    "FOODON_03302885": "cheddar cheese-flavored spread",
    "FOODON_03304374": "cow sour milk (powdered)",
    "FOODON_03316697": "dextrose powdered",
    "FOODON_03303092": "salt substitute",
    "FOODON_03303534": "havarti cheese",
    "FOODON_03301976": "crabmeat (canned)",
    "FOODON_03306444": "meatloaf seasoning mix",
    "FOODON_03310055": "apricot seed (food product)",
    "FOODON_03400342": "modified starch (ec)",
    "FOODON_03411099": "black snapper",
    "NCBITaxon_8500": "Crocodylus",
    "FOODON_03304871": "ephedra tea (dry)",
    "FOODON_03301632": "brandy",
    "FOODON_03541641": "16410 - dates and similar- (efsa foodex2)",
    "FOODON_03311886": "apricot juice",
    "FOODON_00003157": "almond milk",
    "FOODON_03305734": "fish fillet (raw)",
    "PATO_0001595": "depth",
    "NCBITaxon_88728": "Pinus koraiensis",
    "PATO_0001596": "increased depth",
    "FOODON_03316652": "meat product (smoked)",
    "NCBITaxon_181181": "Buglossoides arvensis",
    "FOODON_03414792": "arrowgrass plant",
    "FOODON_03302764": "fish (canned)",
    "FOODON_03544347": "43470 - peppermint flavour (efsa foodex2)",
    "FOODON_03310893": "red guinea corn (raw)",
    "RO_0009002": "has substance removed",
    "FOODON_03316359": "jam, jelly or marmalade substitute",
    "FOODON_00002800": "hen egg (whole, boiled)",
    "FOODON_03412696": "snipe",
    "FOODON_03542082": "20820 - pig tongue (efsa foodex2)",
    "FOODON_03301223": "paprika (ground)",
    "FOODON_03510261": "menopaused woman as food consumer",
    "FOODON_03315943": "perry",
    "FOODON_03542348": "23480 - cod, greenland (efsa foodex2)",
    "FOODON_03316860": "cheese food (american, grated)",
    "FOODON_03541162": "11620 - other pine nut kernels (efsa foodex2)",
    "FOODON_03413451": "long-finned eel",
    "FOODON_03311127": "breakfast cereal (presweetened, fruit-flavored)",
    "FOODON_03540062": "00620 - spelt grain (efsa foodex2)",
    "FOODON_03310728": "black vinegar chinese",
    "FOODON_03305103": "meat (cooked)",
    "FOODON_03305877": "apricot and almond jam",
    "FOODON_03305214": "garlic seasoning (liquid)",
    "FOODON_03302929": "fish chowder",
    "FOODON_03308807": "shrimp log",
    "FOODON_03315259": "waffle",
    "FOODON_03541174": "11740 - pachira nut (efsa foodex2)",
    "NCBITaxon_35579": "Stenotomus chrysops",
    "FOODON_00001865": "food coating product",
    "CHEBI_33890": "cobalt coordination entity",
    "CHEBI_134438": "titanium oxides",
    "FOODON_03412051": "linden plant",
    "NCBITaxon_1329961": "Bifurcata",
    "UO_0010026": "fluid ounce",
    "NCBITaxon_99345": "Scomberomorus regalis",
    "NCBITaxon_80379": "Capsicum chinense",
    "FOODON_03400460": "CIAA fish and fish products",
    "FOODON_03520145": "pacific, northwest (fao major fishing area 61)",
    "NCBITaxon_7745": "Petromyzontiformes",
    "FOODON_03543787": "37870 - herbal infusions (beverages) specific for infants and young children, liquid (efsa foodex2)",
    "FOODON_03542026": "20260 - turkey liver (efsa foodex2)",
    "FOODON_00001637": "beet pickle food product",
    "FOODON_03315299": "kim chee",
    "FOODON_03415089": "common daisy plant",
    "FOODON_03414556": "rhea",
    "FOODON_00002598": "Pinotage wine",
    "FOODON_03543680": "36800 - hibiscus (infusion seeds) (efsa foodex2)",
    "FOODON_03309098": "northern flounder (raw)",
    "FOODON_03541461": "14610 - minneolas (efsa foodex2)",
    "FOODON_03415009": "lesser calamint plant",
    "FOODON_03414802": "mud oyster",
    "FOODON_03490165": "aluminum tray or pan",
    "FOODON_03541003": "10030 - blue agave heart (efsa foodex2)",
    "FOODON_03301100": "orange drink",
    "NCBITaxon_9902": "Bison bonasus",
    "FOODON_03540260": "02600 - cream custard sponge cake (efsa foodex2)",
    "FOODON_03543838": "38380 - dairy imitates other than milks (efsa foodex2)",
    "CHEBI_84997": "sodium gluconate",
    "FOODON_03510062": "low sugars food",
    "FOODON_03301711": "obsolete: dairy product (not further specified)",
    "FOODON_03540713": "07130 - coloured carrots varieties (efsa foodex2)",
    "FOODON_03315968": "confectionery (cocoa-based, energy reduced)",
    "FOODON_03315418": "meat (pickled)",
    "FOODON_03304903": "chicken gumbo soup",
    "FOODON_03412712": "barbel",
    "FOODON_03308968": "red snapper fillet (raw)",
    "FOODON_03315707": "peanut spread",
    "FOODON_03303564": "pyracantha berry jelly",
    "NCBITaxon_30851": "Malacanthidae",
    "FOODON_03510225": "food allergen labelling about sulphur dioxide and sulphites",
    "FOODON_03305692": "imitation link sausage",
    "FOODON_03413998": "lowfin pomfret",
    "FOODON_03401147": "10000283 - fish - unprepared/unprocessed (shelf stable) (gs1 gpc)",
    "NCBITaxon_99490": "Loxodonta cyclotis",
    "FOODON_03400964": "10000315 - grains/cereal - not ready to eat - (perishable) (gs1 gpc)",
    "FOODON_03413816": "adriatic sturgeon",
    "FOODON_03490349": "metalized paper laminated with plastic",
    "FOODON_03307969": "strawberry (artificially sweetened)",
    "FOODON_03307486": "filled milk (evaporated)",
    "FOODON_03470135": "pasteurization by heating",
    "FOODON_00002353": "wheat cracker food product",
    "FOODON_00002977": "baby spinach",
    "NCBITaxon_542674": "Phyla dulcis",
    "FOODON_03414853": "silver barb",
    "FOODON_03420167": "fruit part",
    "FOODON_03544226": "42260 - cassis flavour (efsa foodex2)",
    "FOODON_03420168": "bone or shell",
    "FOODON_03401720": "10005969 - mangos (gs1 gpc)",
    "FOODON_03400861": "prepared food product (eurofir)",
    "FOODON_03542880": "28800 - cheese, kefalotyri (efsa foodex2)",
    "UO_0000194": "confluence percentage",
    "ENVO_00000029": "watercourse",
    "PO_0025130": "cigar leaf",
    "FOODON_03520404": "tropical fishing area",
    "UO_0000205": "volume per unit volume",
    "FOODON_00003264": "Burgundy fondue",
    "NCBITaxon_28701": "Fratercula arctica",
    "FOODON_00002586": "Chenin blanc wine",
    "FOODON_03315596": "sugar coated product",
    "FOODON_03316162": "cephalopod (cooked)",
    "FOODON_03317315": "pork loin (cooked, cured)",
    "FOODON_03414403": "calcium malates",
    "PATO_0001546": "quality of a solid",
    "FOODON_03541780": "17800 - jackfruits (efsa foodex2)",
    "FOODON_03542725": "27250 - milk powder (efsa foodex2)",
    "CHEBI_26191": "polyol",
    "FOODON_03414138": "oregoniid family",
    "FOODON_03304457": "rye cracker (artificially cheddar cheese-flavored)",
    "NCBITaxon_118040": "Squalomorphii",
    "FOODON_03305894": "imitation mint-flavored jelly",
    "NCBITaxon_13385": "Calluna vulgaris",
    "NCBITaxon_3931": "Myrtaceae",
    "CHEBI_24669": "hydroxy carboxylic acid",
    "FOODON_03540811": "08110 - morels (efsa foodex2)",
    "FOODON_03542130": "21300 - pastrami, beef (efsa foodex2)",
    "FOODON_03315905": "pineapple juice blended with other fruit juices",
    "NCBITaxon_109716": "Apolemichthys",
    "FOODON_03412768": "eben tree",
    "FOODON_03544372": "43720 - smoke flavour (efsa foodex2)",
    "FOODON_03411518": "billfish family",
    "FOODON_03414122": "bramble shark family",
    "FOODON_03541575": "15750 - bilberries (european blueberries) (efsa foodex2)",
    "FOODON_03307880": "rose black china tea (dry)",
    "FOODON_03306782": "pineapple pulp",
    "FOODON_03311287": "alimentary paste",
    "FOODON_03308646": "sardine larva (semidried, boiled)",
    "NCBITaxon_72648": "Tacca leontopetaloides",
    "FOODON_03544363": "43630 - roast flavour (efsa foodex2)",
    "FOODON_03543659": "36590 - herbal infusion extracts (rpc derivatives) (efsa foodex2)",
    "FOODON_03420308": "obsolete: tuber",
    "ENVO_01001110": "ecosystem",
    "FOODON_03301096": "shad (cured, smoked)",
    "FOODON_03305268": "eclair (whipped creme-filled)",
    "NCBITaxon_210328": "Maclura tricuspidata",
    "NCBITaxon_29962": "Grapsoidea",
    "FOODON_03541896": "18960 - sheep msm (efsa foodex2)",
    "NCBITaxon_117914": "Dalatiidae",
    "FOODON_03542485": "24850 - freshwater crabs (efsa foodex2)",
    "FOODON_03303751": "chocolate-covered mint candy (thin)",
    "NCBITaxon_8570": "Serpentes",
    "FOODON_00001308": "ma yom dong",
    "FOODON_03411836": "southern blue whiting",
    "NCBITaxon_155067": "Vimba vimba",
    "FOODON_03315917": "food (dried, powdered)",
    "FOODON_03490152": "paperboard container, waxed",
    "FOODON_03411691": "roselle plant",
    "FOODON_03315335": "yakjoo",
    "NCBITaxon_101015": "Fragaria virginiana",
    "FOODON_03414568": "black-headed gull",
    "NCBITaxon_3868": "Lotus tetragonolobus",
    "FOODON_03310742": "cacao bean (raw)",
    "FOODON_00002568": "grape seed",
    "FOODON_03543253": "32530 - liquid or gel separated from plant rpcs (efsa foodex2)",
    "FOODON_03412703": "grey gurnard",
    "FOODON_03413178": "oxidized starch",
    "FOODON_03316242": "vegetable protein products",
    "FOODON_03543776": "37760 - ready-to-eat fruit-based meal for children (efsa foodex2)",
    "FOODON_03543269": "32690 - natural mineral water (efsa foodex2)",
    "FOODON_03415114": "greater burnet-saxifrage plant",
    "NCBITaxon_153348": "Lepidium meyenii",
    "FOODON_03305981": "orange juice (canned)",
    "NCBITaxon_8189": "Mugilidae",
    "FOODON_03307180": "mushroom quiche",
    "FOODON_03401375": "50262400 - ferns (gs1 gpc)",
    "NCBITaxon_499858": "Thyrsites atun",
    "FOODON_03414977": "true cinnamon plant",
    "FOODON_03490236": "polyvinyl chloride plug",
    "CHEBI_35436": "D-glucoside",
    "FOODON_03315857": "molasses (fancy)",
    "ENVO_00000026": "well",
    "GAZ_00006912": "Tajikistan",
    "NCBITaxon_9644": "Ursus arctos",
    "CHEBI_39022": "inclusion compound",
    "FOODON_03310708": "noodle (chinese, instant)",
    "FOODON_03541253": "12530 - african oil palm fruits (efsa foodex2)",
    "FOODON_03540281": "02810 - doughnuts-berliner (efsa foodex2)",
    "NCBITaxon_29140": "Gonorynchiformes",
    "FOODON_03316970": "filling (refrigerated, ready-to-serve)",
    "NCBITaxon_45947": "Corbiculidae",
    "FOODON_03305874": "bramble berry jelly (food product)",
    "FOODON_03317233": "white corn meal (bolted)",
    "FOODON_03311062": "white raisin",
    "FOODON_00001924": "grape based low-alcohol wine food product",
    "FOODON_03304624": "brown hen egg (whole, shell on, raw)",
    "FOODON_03543259": "32590 - powdered extract of plant origin (efsa foodex2)",
    "FOODON_00003034": "wild celery plant",
    "FOODON_03317268": "garlic bologna",
    "FOODON_03543974": "39740 - rice and meat meal (efsa foodex2)",
    "CHEBI_33675": "p-block molecular entity",
    "FOODON_03310272": "red wine",
    "FOODON_03412919": "perilla plant",
    "FOODON_03541557": "15570 - black raspberries (efsa foodex2)",
    "FOODON_03306826": "dough (white, enriched, frozen)",
    "FOODON_03412936": "cardinalfish",
    "FOODON_03542751": "27510 - brined cheese (feta-type and similar) (efsa foodex2)",
    "FOODON_03303536": "cheese made from reconstituted milk",
    "FOODON_03311314": "roast beef au jus",
    "FOODON_03311857": "lamb rennet paste (food product)",
    "FOODON_03480030": "packed in slightly sweetened water or juice",
    "FOODON_03520504": "tundra climatic zone",
    "FOODON_00001790": "cream dressing food product",
    "FOODON_03401656": "10005787 - bison/buffalo - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03541033": "10330 - guar beans (without pods) (efsa foodex2)",
    "FOODON_03540668": "06680 - cucurbits with edible peel (efsa foodex2)",
    "FOODON_00003091": "european chestnut (whole, raw)",
    "FOODON_03310576": "chicken frankfurter",
    "NCBITaxon_3542": "Aizoaceae",
    "FOODON_03301211": "sage (dried)",
    "FOODON_03400178": "bread (us cfr)",
    "NCBITaxon_475167": "Lutjanus lutjanus",
    "FOODON_03301504": "sage (ground)",
    "NCBITaxon_59786": "Brachiaria",
    "FOODON_03510014": "sheep or goat as consumer",
    "PATO_0001898": "increased circumference",
    "FOODON_00002267": "special dietry use food product",
    "FOODON_03311867": "domiati cheese",
    "FOODON_03414667": "caqui plant",
    "FOODON_03309076": "ocean sole (raw)",
    "FOODON_03317124": "mushroom (deep-frozen)",
    "FOODON_03414170": "snow fungus",
    "FOODON_00002646": "food (flavored)",
    "CHEBI_39447": "pyrimidines",
    "FOODON_03305955": "obsolete: fruit jelly",
    "FOODON_03401180": "10000239 - olives (shelf stable) (gs1 gpc)",
    "FOODON_03541475": "14750 - tejocotes (efsa foodex2)",
    "FOODON_03302881": "caramel candy (food product)",
    "FOODON_03304619": "chocolate-flavored coating for ice cream bar",
    "FOODON_03316069": "bread malt",
    "FOODON_03308331": "polish herring (raw)",
    "FOODON_03303797": "candy (sugarless)",
    "HANCESTRO_0007": "South East Asian",
    "CHEBI_61459": "silicone polymer",
    "FOODON_03304288": "obsolete: spice blend",
    "FOODON_03411429": "mandarin orange tree",
    "NCBITaxon_6536": "Helix pomatia",
    "FOODON_03316941": "cheese (stirred curd)",
    "FOODON_03420200": "obsolete: leaf",
    "FOODON_03543502": "35020 - hearts ease infusion leaves (efsa foodex2)",
    "FOODON_03411417": "california needlefish",
    "CHEBI_47771": "beta-tocopherol",
    "FOODON_03541923": "19230 - yak fresh meat (efsa foodex2)",
    "FOODON_03541302": "13020 - culantro seed (efsa foodex2)",
    "FOODON_03304385": "skim milk (sweetened, condensed)",
    "FOODON_03305202": "strawberry preserves",
    "FOODON_03304139": "chicken and vegetables in seasoned gravy",
    "FOODON_03311453": "breakfast cereal (hot-type, aspartame sweetened)",
    "FOODON_03411885": "south american silverside",
    "FOODON_03309384": "tilapia (breaded)",
    "FOODON_03301734": "cook cheese",
    "NCBITaxon_150433": "Panulirus penicillatus",
    "NCBITaxon_455045": "Abelmoschus esculentus",
    "FOODON_03305314": "fruit melange in cognac",
    "GAZ_00002639": "Scotland",
    "FOODON_03304906": "beef soup (instant)",
    "FOODON_03413850": "atlantic round herring",
    "FOODON_00002318": "tomato substance",
    "CHEBI_50584": "alkyl alcohol",
    "FOODON_03411926": "spotted chub mackerel",
    "FOODON_03315652": "poultry meat by-product (preserved)",
    "NCBITaxon_458596": "Parona signata",
    "FOODON_03420140": "fruit, peel present, core, pit or seed present",
    "CHEBI_26079": "phosphoric acid derivative",
    "CHEBI_51086": "chemical role",
    "FOODON_03307537": "pudding with fruit topping (artificially flavored)",
    "FOODON_03543954": "39540 - filled canap\u00e9 (efsa foodex2)",
    "FOODON_03490394": "metallized polyester container",
    "FOODON_03311109": "turkey (raw, ground)",
    "FOODON_00002902": "Masago",
    "FOODON_03301388": "corn husk",
    "FOODON_03315099": "cocoa-based sweets (food product)",
    "FOODON_03544137": "41370 - mango chutney (efsa foodex2)",
    "FOODON_03315599": "ice-cream sauce, not including chocolate",
    "FOODON_03304248": "chicken vermicelli seasoning mix (dry)",
    "FOODON_03541263": "12630 - basil, dry (efsa foodex2)",
    "NCBITaxon_71632": "Pinus gerardiana",
    "CHEBI_26912": "oxolanes",
    "FOODON_03412383": "american sand lance",
    "FOODON_03304793": "chocolate milk (low fat)",
    "FOODON_00002172": "poultry stew or hash",
    "FOODON_00002760": "pigeon pea (dried, split)",
    "FOODON_03311721": "corn meal product",
    "NCBITaxon_3745": "Rosaceae",
    "FOODON_03317412": "leaf tea (unflavored)",
    "FOODON_00001999": "light wine",
    "FOODON_00003108": "barley grain (whole, raw)",
    "FOODON_03311343": "orange juice concentrate",
    "FOODON_03401106": "10000254 - sandwiches/filled rolls/wraps (frozen) (gs1 gpc)",
    "FOODON_03302282": "fruit punch beverage base (artificially sweetened, artificially flavored)",
    "FOODON_03309387": "poultry carcass",
    "FOODON_03306754": "cucumber (sliced, raw)",
    "FOODON_03304198": "oyster soup",
    "FOODON_03411938": "pomfret family",
    "FOODON_03304245": "broth from game animal (liquid)",
    "FOODON_03306784": "pineapple cube (canned)",
    "FOODON_03541381": "13810 - marjoram fruit (efsa foodex2)",
    "NCBITaxon_205537": "Solanum caripense",
    "FOODON_03316394": "beetroot (white, dried)",
    "CHEBI_36244": "dicarboxylic acid monoester",
    "FOODON_03309451": "ravioli dough",
    "FOODON_03544258": "42580 - estragon flavour (efsa foodex2)",
    "FOODON_03541765": "17650 - rambutans (efsa foodex2)",
    "FOODON_00002232": "sesame food product",
    "FOODON_03542540": "25400 - scallop, bay (efsa foodex2)",
    "FOODON_00002928": "heirloom tomato (whole, raw)",
    "FOODON_03307663": "tapioca",
    "NCBITaxon_179371": "Trachurus lathami",
    "NCBITaxon_3832": "Cyamopsis tetragonoloba",
    "NCBITaxon_7948": "Clupeinae",
    "CHEBI_33640": "polycyclic cage",
    "FOODON_03303933": "potato chip (shoestring)",
    "FOODON_03412736": "japanese plum plant",
    "FOODON_03309475": "meat scrap",
    "FOODON_03310281": "food made from oil",
    "NCBITaxon_32219": "Amelanchier alnifolia",
    "FOODON_03414048": "japanese huchen",
    "FOODON_03544159": "41590 - collagen (efsa foodex2)",
    "FOODON_03307010": "pilaf",
    "FOODON_03541241": "12410 - oil palms kernels and similar- (efsa foodex2)",
    "FOODON_00001139": "coffee based beverage product",
    "FOODON_03510276": "obsolete: no dietary claim or use",
    "FOODON_03411547": "sunflower plant",
    "FOODON_03542208": "22080 - canned meat (efsa foodex2)",
    "FOODON_03316281": "fish product (cooked)",
    "FOODON_03301692": "lingot cheese (with herbs and garlic)",
    "FOODON_03307720": "maple syrup (dark)",
    "FOODON_03411139": "citrus family",
    "FOODON_03307958": "clam (butter, minced, canned)",
    "FOODON_03543204": "32040 - mixed fruit nectars (efsa foodex2)",
    "FOODON_03307305": "wine biscuit",
    "FOODON_03401429": "10006194 - black currants (gs1 gpc)",
    "FOODON_03544010": "40100 - gazpacho and similar (efsa foodex2)",
    "NCBITaxon_8799": "Struthionidae",
    "FOODON_03302496": "bread (country-style)",
    "FOODON_03302234": "imitation black cherry (artificially sweetened)",
    "FOODON_03542312": "23120 - arctic char (efsa foodex2)",
    "FOODON_03302069": "fordhook lima bean (whole)",
    "FOODON_03308025": "sea trout (raw)",
    "CHEBI_37979": "sulfur-32 atom",
    "FOODON_00000070": "lobster tail food product",
    "FOODON_03544169": "41690 - potato starch (efsa foodex2)",
    "NCBITaxon_115428": "Pseudupeneus",
    "FOODON_03317255": "sturgeon roe semi-preserved",
    "FOODON_00001205": "velvet bean (whole, dried)",
    "FOODON_03415131": "goat's-rue plant",
    "NCBITaxon_109174": "Haliotis asinina",
    "FOODON_00002185": "rainbow trout food product",
    "FOODON_03411258": "trout",
    "FOODON_03316385": "orange peel (candied)",
    "NCBITaxon_3494": "Ficus carica",
    "FOODON_03317187": "lemonade starter and base substances",
    "FOODON_03309471": "ostrich meat (raw)",
    "NCBITaxon_13426": "Cichorium",
    "FOODON_03310831": "obsolete: blood meal",
    "FOODON_03540014": "00140 - kaniwa grain (efsa foodex2)",
    "FOODON_03315813": "instant breakfast",
    "FOODON_03303088": "coconut cream",
    "HANCESTRO_0429": "Uruguayan",
    "HANCESTRO_0533": "Eritrean",
    "PO_0025029": "shoot axis",
    "FOODON_03543969": "39690 - pasta, filled with meat mix, cooked (efsa foodex2)",
    "FOODON_03306055": "fig (preserved in syrup, canned)",
    "FOODON_03304819": "seaweed meal",
    "FOODON_03411003": "southern bluefin tuna",
    "FOODON_03412715": "queen scallop",
    "FOODON_03541822": "18220 - jam, mandarins (efsa foodex2)",
    "FOODON_03310373": "sugee",
    "FOODON_03309015": "bonito (canned)",
    "OBI_0000441": "assay objective",
    "NCBITaxon_6466": "Trochidae",
    "FOODON_03540311": "03110 - mixed cereal rolled grains (efsa foodex2)",
    "FOODON_03315582": "tongue food product",
    "FOODON_03304782": "iced tea mix (mint-flavored)",
    "FOODON_03304251": "pea and ham soup mix",
    "FOODON_03401574": "10006457 - celery leaves (gs1 gpc)",
    "NCBITaxon_43522": "Morinda citrifolia",
    "FOODON_03413516": "cat shark family",
    "FOODON_03309541": "dairy drink (sterilized)",
    "FOODON_03414974": "guelder-rose plant",
    "FOODON_03303151": "vanilla cookie (artificially flavored)",
    "FOODON_03413555": "warty crab",
    "FOODON_03401654": "10005786 - beef - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03310223": "chicken thigh (retorted in gravy)",
    "FOODON_03541142": "11420 - hazelnuts (efsa foodex2)",
    "FOODON_03542157": "21570 - salami-type sausage (efsa foodex2)",
    "FOODON_03413464": "marsh frog",
    "FOODON_03317011": "sodium caseinate",
    "FOODON_03412958": "brasilian guava plant",
    "FOODON_00003343": "filet mignon",
    "FOODON_03316571": "beverage syrup cola type",
    "NCBITaxon_8057": "Merlangius",
    "FOODON_03311769": "hen egg liquid (decholesterolized)",
    "FOODON_03414438": "microcrystalline wax",
    "FOODON_00001321": "pak sean dong",
    "NCBITaxon_51238": "Vanilla",
    "FOODON_03309749": "hyacinth bean (whole)",
    "FOODON_03543543": "35430 - st. john\u00b4s wort infusion leaves (efsa foodex2)",
    "NCBITaxon_6780": "Menippe",
    "FOODON_03413393": "canistel plant",
    "FOODON_03543040": "30400 - couverture chocolate (efsa foodex2)",
    "FOODON_03542697": "26970 - yoghurt, sheep milk (efsa foodex2)",
    "FOODON_03308610": "crabmeat (shredded)",
    "FOODON_03411227": "carrot plant",
    "FOODON_03304960": "asparagus soup",
    "NCBITaxon_4004": "Linaceae",
    "FOODON_03411169": "green olive plant",
    "FOODON_03542764": "27640 - cheese, munster (efsa foodex2)",
    "FOODON_03543256": "32560 - extracts of plant origin (efsa foodex2)",
    "FOODON_03520365": "obsolete: geopolitical designation",
    "CHEBI_24431": "chemical entity",
    "FOODON_03311350": "filbert nut in shell",
    "FOODON_03420161": "mammalian heavy cream (36%+)",
    "FOODON_03540680": "06800 - chayote fruits (efsa foodex2)",
    "FOODON_03303860": "cheese (smoked)",
    "FOODON_03308711": "tuna (light meat, canned)",
    "FOODON_03311024": "evaporated milk (canned, sterilized)",
    "PATO_0002365": "intact female",
    "NCBITaxon_405322": "Piper cubeba",
    "FOODON_03306884": "cake doughnut",
    "FOODON_03301236": "blackberry (whole, raw)",
    "NCBITaxon_13580": "Katsuwonus",
    "FOODON_03470165": "drying by microwave radiation",
    "FOODON_03302619": "butter and sugar mix",
    "FOODON_03541584": "15840 - native currant (efsa foodex2)",
    "FOODON_03541756": "17560 - granate apples and similar- (efsa foodex2)",
    "FOODON_03415135": "hairy rupturewort plant",
    "FOODON_03543320": "33200 - cola mix, flavoured cola (efsa foodex2)",
    "FOODON_00001611": "apple food product",
    "FOODON_03315934": "fruit in vinegar brine or oil",
    "PO_0030101": "loment fruit",
    "FOODON_03414791": "trianthema plant",
    "FOODON_00002210": "rock cornish fowl meat food product",
    "FOODON_00002220": "salmon food product",
    "FOODON_03540896": "08960 - lizard tail (efsa foodex2)",
    "FOODON_03307348": "vanilla wafer",
    "FOODON_03307485": "milkshake",
    "FOODON_00003161": "corn mint plant",
    "FOODON_03540033": "00330 - indian corn grain (efsa foodex2)",
    "FOODON_03316463": "soup powder mix",
    "HANCESTRO_0345": "Andorran",
    "FOODON_03308355": "lobster (whole, frozen)",
    "FOODON_00001179": "amaranthaceous inflorescence food product",
    "FOODON_03540018": "00180 - black fonio grain (efsa foodex2)",
    "FOODON_03543048": "30480 - chocolate substitutes (efsa foodex2)",
    "FOODON_03490337": "grease proof paper container",
    "FOODON_03540954": "09540 - french beans canned (efsa foodex2)",
    "FOODON_03541467": "14670 - other hybrids of citrus reticulata, not elsewhere mentioned (efsa foodex2)",
    "FOODON_03411927": "white pomfret",
    "FOODON_03401748": "10005984 - peas (gs1 gpc)",
    "FOODON_00002138": "plant dessert food product",
    "FOODON_03414445": "processed euchema seaweed",
    "NCBITaxon_30949": "Psettodidae",
    "FOODON_03543944": "39440 - savoury pies and tarts (efsa foodex2)",
    "FOODON_03460109": "artificial carbonation process",
    "FOODON_03413500": "amur pike",
    "FOODON_03311193": "fenugreek (dried)",
    "FOODON_03316914": "meat product (whole, cold smoked)",
    "FOODON_03540862": "08620 - rosemary and similar- (efsa foodex2)",
    "FOODON_03401019": "obsolete: 10000014 - meat/poultry/game/batrachian - prepared/processed (shelf stable) (gs1 gpc)",
    "FOODON_03541199": "11990 - white mustard seeds (efsa foodex2)",
    "FOODON_03542641": "26410 - processed or preserved seafood (efsa foodex2)",
    "FOODON_03315057": "frozen nondairy frosting",
    "FOODON_03413655": "mediterranean mussel",
    "FOODON_03541934": "19340 - equine fresh meat (efsa foodex2)",
    "NCBITaxon_43850": "Schinus",
    "FOODON_03530101": "processed in teflon-coated container",
    "FOODON_03543215": "32150 - juice, turnip (efsa foodex2)",
    "CHEBI_33290": "food",
    "FOODON_03304041": "sweet and sour sauce mix (dry)",
    "FOODON_03316379": "papaya (dried)",
    "FOODON_03540206": "02060 - quick bread dough (efsa foodex2)",
    "FOODON_03413593": "formosa lobster",
    "FOODON_03303558": "pineapple juice (concentrated)",
    "FOODON_03542661": "26610 - gayal milk (efsa foodex2)",
    "FOODON_03544078": "40780 - hydrolysed animal proteins (efsa foodex2)",
    "CHEBI_72813": "exopolysaccharide",
    "FOODON_00002440": "mullet fish food product",
    "CEPH_0000285": "aquatic animal ink",
    "FOODON_03305789": "strawberries in vanilla ice cream",
    "FOODON_03510127": "kosher claim or use",
    "NCBITaxon_424551": "Solanoideae",
    "FOODON_03543457": "34570 - roman wormwood infusion leaves (efsa foodex2)",
    "FOODON_03302590": "mushroom sauce",
    "FOODON_03411712": "stag chicken",
    "FOODON_03411978": "porbeagle",
    "FOODON_03302967": "haddock (flaked)",
    "FOODON_03310559": "corn bran (raw)",
    "FOODON_03413027": "calcium alginate",
    "RO_0002162": "in taxon",
    "FOODON_03401422": "10005981 - jack beans (gs1 gpc)",
    "FOODON_03307186": "raisin jam",
    "FOODON_03541153": "11530 - pine nut kernels (efsa foodex2)",
    "NCBITaxon_9766": "Balaenoptera",
    "FOODON_03308074": "ocean perch fillet (with skin, breaded, raw)",
    "FOODON_03544374": "43740 - sour flavour (efsa foodex2)",
    "FOODON_03306996": "apricot spread (food product)",
    "FOODON_03542065": "20650 - camel edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "FOODON_03308224": "bear crab (raw)",
    "FOODON_03400681": "016  root and tuber vegetables (vr) (ccpr)",
    "FOODON_03541912": "19120 - bovine and pig, minced meat (efsa foodex2)",
    "FOODON_03542595": "25950 - terrestrial invertebrates (efsa foodex2)",
    "NCBITaxon_6577": "Placopecten magellanicus",
    "FOODON_03460169": "food instantizing",
    "FOODON_00003162": "egg soup",
    "FOODON_03315273": "milk product (whipped)",
    "FOODON_03543633": "36330 - blue flag infusion roots (efsa foodex2)",
    "NCBITaxon_454142": "Lutjanus purpureus",
    "FOODON_03401808": "10006367 - salsify (gs1 gpc)",
    "NCBITaxon_9989": "Rodentia",
    "FOODON_03306123": "fish oil",
    "FOODON_03304741": "imitation truffle",
    "CHEBI_18237": "glutamic acid",
    "FOODON_03412991": "aluminium sodium sulphate",
    "FOODON_03540433": "04330 - new zealand spinaches (efsa foodex2)",
    "FOODON_03311126": "food (raw)",
    "FOODON_03540417": "04170 - mallow leaves (efsa foodex2)",
    "NCBITaxon_1548725": "Serripes groenlandicus",
    "FOODON_03301394": "cauliflower (pickled, canned)",
    "FOODON_03316866": "pasteurized process cheese with fruits vegetables or meats",
    "FOODON_03401890": "10006164 - tomatoes - ribbed (gs1 gpc)",
    "FOODON_03309566": "tomato soup mix",
    "FOODON_03530037": "fat back",
    "FOODON_03544514": "45140 - bee-produced fortifying agents (efsa foodex2)",
    "FOODON_03307022": "passion fruit pulp",
    "FOODON_00002543": "oaxaca cheese",
    "FOODON_03301762": "cottonseed",
    "FOODON_03401256": "0900000 - 9. sugar plants (ec)",
    "FOODON_03306871": "peanut (whole, skin off, partially defatted)",
    "FOODON_03540652": "06520 - capsicum annuum hot cultivars (efsa foodex2)",
    "FOODON_03414910": "witloof plant",
    "NCBITaxon_697225": "Lutjanus colorado",
    "UBERON_0018385": "metacercaria",
    "FOODON_03541604": "16040 - small cranberries (efsa foodex2)",
    "FOODON_03310825": "savory snack food",
    "FOODON_03310119": "lamb's quarter (raw)",
    "FOODON_03304748": "freestone peach (halves in light syrup)",
    "FOODON_03306594": "sausage seasoning",
    "FOODON_03401457": "10006446 - choi sum (gs1 gpc)",
    "FOODON_03307806": "frankfurter (cooked, in toasted bun, frozen)",
    "NCBITaxon_69930": "Schilbe mystus",
    "FOODON_03470154": "preservation by adding inorganic acids or salts",
    "FOODON_03304580": "salad sauce",
    "FOODON_03401146": "10000282 - fish - unprepared/unprocessed (perishable) (gs1 gpc)",
    "FOODON_03543806": "38060 - oral rehydration products (efsa foodex2)",
    "FOODON_03311100": "carrot (cooked)",
    "FOODON_03309237": "trench mullet (raw)",
    "FOODON_03542975": "29750 - hen egg white, dried (efsa foodex2)",
    "FOODON_03317389": "citrus wine (food product)",
    "FOODON_03540623": "06230 - chickling vetches (with pods) (efsa foodex2)",
    "FOODON_03542852": "28520 - cheese, tete de moine (efsa foodex2)",
    "FOODON_03302434": "root beer (sugar free)",
    "FOODON_03540254": "02540 - cakes (efsa foodex2)",
    "FOODON_03303882": "mixed vegetables (canned)",
    "FOODON_03309994": "peanut feed",
    "FOODON_03304516": "rabbit liver (raw)",
    "FOODON_03315421": "prawn (frozen, cooked)",
    "FOODON_00001579": "alcoholic beverage",
    "FOODON_00001905": "ginseng plant food product",
    "FOODON_03308072": "cod fillet (skinless, raw)",
    "FOODON_03311451": "frosting or filling (frozen)",
    "FOODON_03401293": "USDA SR snacks (2500)",
    "FOODON_03316290": "pastry (gluten-free)",
    "FOODON_03306352": "shrimp (fried, tv dinner, frozen)",
    "FOODON_03307965": "seafood fillet with shrimp and crabmeat",
    "FOODON_03303009": "chicken skin (raw)",
    "FOODON_03309886": "cream of wheat (dry)",
    "FOODON_03542737": "27370 - cheese curd (efsa foodex2)",
    "FOODON_00002038": "millet food product",
    "FOODON_03301192": "basil leaf (whole, raw)",
    "FOODON_03414573": "antarctic minke whale",
    "FOODON_03302309": "roll or bun (brown and serve)",
    "FOODON_03401481": "10006009 - shallots (gs1 gpc)",
    "FOODON_03541281": "12810 - woodruff, dry (efsa foodex2)",
    "FOODON_03401408": "10005940 - sugar apples (gs1 gpc)",
    "FOODON_03542907": "29070 - cheese, zamorano (efsa foodex2)",
    "PATO_0001305": "increased temperature",
    "FOODON_03315565": "wine (reduced alcohol)",
    "NCBITaxon_294739": "Mentha pulegium",
    "FOODON_03510271": "shoshone bannock food claim or use",
    "NCBITaxon_490591": "Metanephrops formosanus",
    "FOODON_03309662": "soybean (finely ground)",
    "FOODON_03310383": "olive oil press cake",
    "FOODON_03315249": "vitamin and mineral tablet, chewable",
    "FOODON_03400701": "11  margarine and lipids of mixed origin (efg)",
    "FOODON_03306434": "imitation beef-flavored seasoning",
    "FOODON_03308627": "shrimp (peeled, cooked)",
    "FOODON_03304421": "custard mix (artificially sweetened)",
    "FOODON_03316422": "crayfish (cooked)",
    "FOODON_03311682": "mortadella",
    "FOODON_03305478": "bubble gum in plastic container",
    "FOODON_03306328": "mussel powder (freeze-dried)",
    "FOODON_03400341": "humectant (ec)",
    "FOODON_03307355": "cheese enchilada (frozen)",
    "NCBITaxon_257723": "Ninnigobius canestrinii",
    "NCBITaxon_8038": "Salvelinus fontinalis",
    "FOODON_03308098": "maine herring (raw)",
    "FOODON_03413435": "tangelolo plant",
    "NCBITaxon_195632": "Platichthys stellatus",
    "FOODON_03413647": "common cockle",
    "CHEBI_17234": "glucose",
    "FOODON_00003149": "Canadian bacon",
    "FOODON_03305277": "vegetable (creamed with whole milk solids)",
    "GAZ_00001539": "Channel Islands",
    "FOODON_00002745": "hen egg liquid",
    "FOODON_03303925": "macaroni (long)",
    "FOODON_03544413": "44130 - mastic gum flavour (efsa foodex2)",
    "FOODON_03316674": "fungus product (edible)",
    "NCBITaxon_75065": "Rubus caesius",
    "FOODON_00001181": "food (cooked)",
    "FOODON_03315284": "tanmooji",
    "FOODON_03311055": "vegetable and meat infant food",
    "FOODON_00003168": "longan (whole, raw)",
    "FOODON_03415063": "zhe berry plant",
    "FOODON_03304473": "fruit squash juice drink",
    "FOODON_03414389": "enzymatically hydrolysed carboxy methyl cellulose, enzymatically hydrolysed cellulose gum",
    "FOODON_03414533": "white beech mushroom",
    "FOODON_03401437": "10006429 - goji berries (gs1 gpc)",
    "NCBITaxon_1203511": "Aspleniineae",
    "FOODON_03415054": "klamath plum plant",
    "FOODON_03401237": "0400000 - 4. oilseeds and oilfruits (ec)",
    "FOODON_03315089": "frozen dairy dessert mix",
    "FOODON_00002325": "turtle egg food product",
    "FOODON_03413914": "croceine croaker",
    "FOODON_03414100": "softnose skate family",
    "BFO_0000009": "two-dimensional spatial region",
    "FOODON_00003018": "cheese soup",
    "FOODON_03544472": "44720 - advantame (efsa foodex2)",
    "FOODON_03307135": "spanish olive (stuffed with anchovy)",
    "FOODON_03311102": "chocolate syrup canned",
    "FOODON_03411188": "angostura tree",
    "FOODON_00001166": "plant inflorescence food product",
    "FOODON_03414647": "bloodwood apple",
    "FOODON_00002743": "roll or bun",
    "FOODON_03411315": "radish plant",
    "FOODON_03412651": "trevally",
    "FOODON_03510128": "organic food claim or use",
    "FOODON_03303907": "cow milk (acidified)",
    "FOODON_03301828": "okra (whole, raw)",
    "FOODON_00002631": "tagliatelle",
    "FOODON_03413820": "boyer's sandsmelt",
    "FOODON_03303171": "nut (whole)",
    "FOODON_03307167": "mangosteen preserves (food product)",
    "FOODON_03400363": "acidifier (codex)",
    "FOODON_03303382": "cashew butter",
    "FOODON_03411220": "insect",
    "FOODON_03412980": "acetylated distarch phosphate",
    "FOODON_03460138": "water removal process",
    "NCBITaxon_157914": "Ziziphus mauritiana",
    "FOODON_03412535": "blacktail pike-conger",
    "FOODON_03316657": "flour moulding",
    "FOODON_03302195": "fruit (canned)",
    "NCBITaxon_30843": "Kyphosidae",
    "NCBITaxon_69109": "Adansonia digitata",
    "FOODON_03540923": "09230 - aromatic flowers (efsa foodex2)",
    "FOODON_03305512": "hush puppy",
    "FOODON_03311140": "chicken breast (cooked)",
    "FOODON_03308269": "pompano (raw)",
    "FOODON_00001013": "cheese food product",
    "FOODON_03542483": "24830 - crustaceans (efsa foodex2)",
    "HANCESTRO_0022": "Korean",
    "PATO_0002043": "increased anterior-posterior diameter",
    "FOODON_03309051": "cod fillet in dill butter sauce",
    "FOODON_03302765": "whipped cream cake (frozen)",
    "FOODON_03490328": "regenerated cellulose film, coloured",
    "GAZ_00003988": "Montserrat",
    "CHEBI_17202": "IMP",
    "FOODON_00002354": "wheat pasta food product",
    "NCBITaxon_4027": "Geraniaceae",
    "FOODON_03414547": "bearded tooth mushroom",
    "FOODON_03412065": "sarsaparilla plant",
    "FOODON_03310299": "winged bean (whole)",
    "FOODON_03316416": "soft taffy",
    "FOODON_03401503": "10006441 - mandarin hybrids (gs1 gpc)",
    "FOODON_03303830": "imitation acidified sour cream",
    "FOODON_03401455": "10005987 - cauliflower (gs1 gpc)",
    "FOODON_03530248": "scombrotoxic",
    "CHEBI_33653": "aliphatic compound",
    "FOODON_03412080": "Bosc pear plant",
    "FOODON_03540705": "07050 - sweet corn (efsa foodex2)",
    "CHEBI_24839": "inorganic salt",
    "FOODON_03303593": "chocolate cream cake mix",
    "FOODON_03414049": "taimen",
    "FOODON_03530285": "purple skin",
    "FOODON_03490365": "polyester container, glass fibre strengthened",
    "FOODON_03308749": "mussel (on half shell, frozen)",
    "FOODON_03306944": "noodle",
    "FOODON_03543674": "36740 - condurango (infusion bark) (efsa foodex2)",
    "FOODON_00003012": "yellow bell pepper (whole, raw)",
    "NCBITaxon_214929": "Bombacoideae",
    "FOODON_03544064": "40640 - indian spice mixes and similar (other than curry powder) (efsa foodex2)",
    "FOODON_03540286": "02860 - shortcrust (pies -tarts) (efsa foodex2)",
    "FOODON_03400118": "nutritive sweetener (us cfr)",
    "CHEBI_60892": "polyamino carboxylic acid",
    "FOODON_03308337": "great lakes sardine (raw)",
    "FOODON_03543868": "38680 - fish and rice meal (efsa foodex2)",
    "HANCESTRO_0523": "Beninese",
    "PO_0030107": "achene fruit",
    "FOODON_03541282": "12820 - wormwoods, dry (efsa foodex2)",
    "FOODON_03315633": "milk with added milk solids (partly skimmed)",
    "NCBITaxon_37007": "Mullus barbatus",
    "FOODON_03301317": "chocolate syrup",
    "FOODON_03301184": "spice (leafy)",
    "FOODON_03311628": "beverage syrup (fruit juice-based)",
    "FOODON_03308987": "canary rockfish (raw)",
    "FOODON_03543996": "39960 - mixed vegetables soup, dry (efsa foodex2)",
    "FOODON_03411488": "sweet crabapple plant",
    "FOODON_03413931": "sand goby",
    "FOODON_03304176": "shortening with freshness preserver",
    "BFO_0000023": "role",
    "NCBITaxon_3700": "Brassicaceae",
    "FOODON_03413439": "arracacha plant",
    "FOODON_03411708": "hawthorn plant",
    "FOODON_00001789": "crayfish food product",
    "NCBITaxon_30950": "Umbridae",
    "FOODON_03415179": "tarovine plant",
    "FOODON_03308849": "crabmeat (lump)",
    "FOODON_03302750": "grape juice (carbonated)",
    "FOODON_03302749": "hard cider (artificially carbonated)",
    "CHEBI_26558": "ribonucleoside monophosphate",
    "FOODON_03308367": "cantonese lobster (dish)",
    "NCBITaxon_13336": "Annona",
    "FOODON_03315936": "salmon substitute",
    "FOODON_00002819": "liver food product",
    "FOODON_03304448": "ham cheddarton dinner",
    "FOODON_03413505": "emmer plant",
    "NCBITaxon_133890": "Xiphopenaeus kroyeri",
    "NCBITaxon_40503": "Lutjanus griseus",
    "FOODON_03400683": "020  cereal grains (gc) (ccpr)",
    "FOODON_03302620": "butter flavor (naturally- and artificially-flavored, dry)",
    "FOODON_03411492": "watercress plant",
    "PATO_0045021": "normal flexibility",
    "FOODON_03302251": "pineapple and grapefruit juice drink (diluted)",
    "FOODON_03412421": "gai lan plant",
    "FOODON_03317594": "meat ball stew",
    "FOODON_03301244": "cranberry sauce",
    "NCBITaxon_46478": "Aerodramus fuciphagus",
    "NCBITaxon_224705": "Harengula jaguana",
    "FOODON_03510215": "food allergen labelling about crustaceans and products thereof",
    "FOODON_03303450": "rice (butter-flavored, canned)",
    "FOODON_03411597": "white vegetable corn plant",
    "FOODON_03414822": "ampelocissus frutescens plant",
    "FOODON_03411064": "huckleberry plant",
    "FOODON_03411983": "fish, beryciform",
    "FOODON_03306289": "tubeti macaroni",
    "FOODON_03413943": "barred grunt",
    "FOODON_03315472": "bean (simmered)",
    "FOODON_03500003": "obsolete: no food contact surface present",
    "FOODON_03413623": "guinea shrimp",
    "FOODON_00003113": "lotus plant food product",
    "FOODON_03310957": "madeira wine",
    "FOODON_03542680": "26800 - cream and cream products (efsa foodex2)",
    "FOODON_03315705": "filling mix",
    "FOODON_03542882": "28820 - cheese, lincolnshire poacher (efsa foodex2)",
    "FOODON_03510198": "diabetic or suitable for diabetics claim or use",
    "FOODON_03544038": "40380 - potato crisps from dough (efsa foodex2)",
    "FOODON_03411152": "white perch",
    "FOODON_03316079": "herbal infusion",
    "FOODON_03543317": "33170 - cola-type drinks (efsa foodex2)",
    "FOODON_03542085": "20850 - pig marrowbone (efsa foodex2)",
    "NCBITaxon_51331": "Rana dalmatina",
    "FOODON_03413378": "straw, fodder or forage of cereal grains and grasses",
    "FOODON_03306653": "soy lecithin spread (food product)",
    "FOODON_03400213": "fudge (us cfr)",
    "FOODON_03311093": "infant formula casein-based",
    "FOODON_03304639": "green tea leaf (dry)",
    "FOODON_03401495": "10005876 - grapefruits (gs1 gpc)",
    "FOODON_03317170": "meat (whole or parts)",
    "FOODON_03414591": "african savannah elephant",
    "FOODON_03309878": "oat straw",
    "FOODON_03411835": "cod family",
    "FOODON_03542722": "27220 - condensed milk (sometimes with added sugars) (efsa foodex2)",
    "NCBITaxon_309349": "Pyrus ussuriensis",
    "FOODON_03413969": "parastromateus",
    "FOODON_03305728": "candy (rum-flavored)",
    "FOODON_03315270": "shortening, made with emulsifiers",
    "FOODON_03306418": "veal cube steak (raw)",
    "FOODON_03400138": "soft cheese (us cfr)",
    "FOODON_03411140": "fruit-producing plant",
    "FOODON_03401564": "10006085 - romaine (cos) lettuce (gs1 gpc)",
    "FOODON_03309867": "peanut shell",
    "FOODON_03541598": "15980 - purple crowberries (efsa foodex2)",
    "RO_0000087": "has role",
    "NCBITaxon_334878": "Rastrelliger brachysoma",
    "NCBITaxon_462889": "Leukoma staminea",
    "FOODON_03540643": "06430 - dwarf cape gooseberries (efsa foodex2)",
    "FOODON_03304792": "tit koon yum tea (dry)",
    "NCBITaxon_490593": "Metanephrops neptunus",
    "FOODON_00003309": "dog bone",
    "FOODON_03413799": "american alligator",
    "FOODON_03540551": "05510 - banana flowers - acuminata cultivars (efsa foodex2)",
    "FOODON_03302204": "honey cake (sliced, reduced-salt)",
    "FOODON_03544261": "42610 - extra hot flavour (efsa foodex2)",
    "FOODON_03412803": "garcinia plant",
    "CHEBI_59999": "chemical substance",
    "PO_0020103": "flag leaf",
    "FOODON_03543470": "34700 - buckwheat infusion leaves (efsa foodex2)",
    "FOODON_03301282": "prune (pitted, dehydrated)",
    "FOODON_03542249": "22490 - chinese longsmout catfish (efsa foodex2)",
    "FOODON_03311516": "turkey white meat (cooked)",
    "FOODON_03308149": "oyster stew mix (food product)",
    "FOODON_03413009": "azorubine, carmoisine",
    "FOODON_00002737": "beef hamburger (dish)",
    "FOODON_03317235": "yellow corn meal (bolted)",
    "FOODON_00001118": "cattle dairy food product",
    "FOODON_03490295": "aluminium foil wrapper, coated for heat sealing",
    "FOODON_00002400": "carob food product",
    "FOODON_03543536": "35360 - raspberry (red and yellow) infusion leaves (efsa foodex2)",
    "FOODON_03302446": "margarine (vitamin-fortified)",
    "FOODON_03302727": "chicory (whole, raw)",
    "NCBITaxon_289765": "Sclerocarya",
    "FOODON_03460849": "obsolete caffeine",
    "FOODON_03430136": "disintegrated or ground",
    "ENVO_00005747": "compost soil",
    "FOODON_03302406": "kava root (raw)",
    "FOODON_03541227": "12270 - ruderalis hemp seeds (efsa foodex2)",
    "FOODON_00003069": "asian pear (whole, raw)",
    "FOODON_03304339": "pigeon (raw)",
    "NCBITaxon_30993": "Pangasianodon gigas",
    "FOODON_03412467": "sugar snap pea plant",
    "FOODON_03301951": "apple pomace",
    "CHEBI_35692": "dicarboxylic acid",
    "FOODON_03414657": "buchanania plant",
    "FOODON_03317598": "poultry stew",
    "NCBITaxon_99343": "Scomberomorus guttatus",
    "PO_0030098": "schizocarp fruit",
    "FOODON_03490335": "bleached paper container",
    "FOODON_03304946": "chicken stock base (meatless)",
    "UBERON_0007023": "adult organism",
    "FOODON_03306533": "tomato catsup with mushrooms",
    "FOODON_03302110": "beer (made from concentrate)",
    "FOODON_03542798": "27980 - cheese, beaufort (efsa foodex2)",
    "FOODON_03304423": "french dressing (low sodium, sugar-free)",
    "FOODON_03307476": "strawberry milk (artificially flavored)",
    "FOODON_03541751": "17510 - langsats (efsa foodex2)",
    "FOODON_03544040": "40400 - tortilla chips (efsa foodex2)",
    "FOODON_03414509": "oarweed",
    "FOODON_00001851": "fig food product",
    "FOODON_03401167": "10000050 - extracts/salt/meat tenderisers (shelf stable) (gs1 gpc)",
    "NCBITaxon_490589": "Metanephrops boschmai",
    "FOODON_03411470": "avocado plant",
    "FOODON_03541102": "11020 - pigeon peas (dry) (efsa foodex2)",
    "CHEBI_85046": "skin lightening agent",
    "FOODON_03520138": "mediterranean and black sea (fao major fishing area 37)",
    "FOODON_03310365": "wheat germ meal",
    "NCBITaxon_283033": "Sander",
    "NCBITaxon_38860": "Mentha suaveolens",
    "FOODON_03306437": "ham (chopped)",
    "FOODON_03307478": "cow milk beverage (flavored)",
    "FOODON_03411579": "vegetable-producing plant",
    "FOODON_03316656": "obsolete: cheese",
    "FOODON_03303427": "caramel chip cookie",
    "FOODON_03414181": "shaggy inc cap",
    "FOODON_03414621": "water python",
    "FOODON_03304326": "apple beverage syrup",
    "FOODON_03308851": "crabmeat (special)",
    "NCBITaxon_9825": "Sus scrofa domesticus",
    "NCBITaxon_8013": "Osmerus",
    "FOODON_03315524": "oil grill",
    "FOODON_03400224": "heavy wine, 14-24% alcohol (us cfr)",
    "FOODON_03311809": "sausage crumbles with salami flavoring frozen",
    "FOODON_03542762": "27620 - cheese, langres (efsa foodex2)",
    "GENEPIO_0001655": "obsolete: categorical tree specification",
    "CHEBI_17548": "alginic acid",
    "CHEBI_28793": "beta-D-glucan",
    "NCBITaxon_549588": "Lophius vomerinus",
    "FOODON_03401335": "mushroom dish (eurofir)",
    "FOODON_03544091": "40910 - savoury sauces (efsa foodex2)",
    "FOODON_03311214": "cashew nut (shell off, roasted)",
    "FOODON_03542785": "27850 - soft-ripened cheese with white and blue mould (cambozola type) (efsa foodex2)",
    "FOODON_03401817": "10006365 - mamey (gs1 gpc)",
    "FOODON_03302122": "holly berry brandy",
    "FOODON_03413215": "potassium metabisulphite",
    "FOODON_03309775": "white corn grits",
    "FOODON_03306482": "buffalo jerky",
    "FOODON_03308573": "shrimp flour",
    "FOODON_03411516": "king mackerel",
    "FOODON_03316666": "palmito (canned)",
    "FOODON_03413033": "calcium cyclamate",
    "FOODON_03541829": "18290 - fruit preparations for fillings and/or flavouring (efsa foodex2)",
    "FOODON_00001725": "chicken product based flavoring or seasoning",
    "FOODON_03305892": "apple jelly made with sugar and honey",
    "FOODON_03542456": "24560 - liveroil shark (efsa foodex2)",
    "FOODON_03310945": "corn (whole kernel, canned)",
    "FOODON_03530216": "obsolete: production environment other",
    "FOODON_03414516": "buttercup squash plant",
    "FOODON_03302771": "dietetic fruitcake",
    "FOODON_03302976": "quince (whole, raw)",
    "NCBITaxon_163112": "Molva molva",
    "FOODON_00002772": "cranberry bean food product",
    "FOODON_03414920": "jersey kale plant",
    "FOODON_00001780": "cow milk product based dressing",
    "NCBITaxon_102818": "Cardueae",
    "NCBITaxon_490245": "Anisotremus virginicus",
    "FOODON_03411390": "lettuce plant",
    "FOODON_03306983": "soda water (unflavored, in polyvinyl chloride bottle)",
    "GAZ_00003922": "Papua New Guinea",
    "CHEBI_33299": "alkaline earth molecular entity",
    "FOODON_03543599": "35990 - hawthorn infusion flowers (efsa foodex2)",
    "FOODON_00002366": "wolffish food product",
    "FOODON_03542465": "24650 - fish offal (efsa foodex2)",
    "NCBITaxon_445361": "Saurida tumbil",
    "ENVO_01000934": "restaurant",
    "FOODON_00002987": "tuna steak",
    "NCBITaxon_48668": "Rutilus rutilus",
    "FOODON_00002299": "sweet sauce or topping food product",
    "FOODON_03315798": "ham picnic (prepared)",
    "FOODON_03316464": "gravy powder",
    "FOODON_03541488": "14880 - loquats (efsa foodex2)",
    "FOODON_03411598": "fish, siluriform",
    "FOODON_03450002": "food cooking",
    "FOODON_03414540": "pale chanterelle",
    "FOODON_03306386": "orange, lemon and grapefruit marmalade",
    "FOODON_03401350": "50310100 - fruits - unprepared/unprocessed (shelf stable) (gs1 gpc)",
    "FOODON_03541793": "17930 - fruit chips (efsa foodex2)",
    "FOODON_00001237": "natural (animal-derived) rennet food product",
    "FOODON_00001701": "cattle soup food product",
    "FOODON_03317597": "vegetable stew with poultry meat",
    "FOODON_03541334": "13340 - other bud spices (efsa foodex2)",
    "FOODON_00001577": "akee fruit food product",
    "PATO_0000992": "viscosity",
    "FOODON_03415100": "sweet violet plant",
    "FOODON_03520193": "climatic zone",
    "FOODON_03542197": "21970 - pate, pork liver (efsa foodex2)",
    "FOODON_03544059": "40590 - sea salt (efsa foodex2)",
    "FOODON_03414705": "sand pea plant",
    "FOODON_03303179": "color additive (natural)",
    "RO_0002354": "formed as result of",
    "FOODON_03412386": "japanese hard clam",
    "FOODON_03316874": "swiss cheese (for manufacturing)",
    "NCBITaxon_9783": "Elephas maximus",
    "FOODON_03315087": "topping (whipped, vegetable oil)",
    "FOODON_03316554": "cow milk (powdered, instant, with coffee flavoring)",
    "FOODON_03311527": "cocktail drink (mixed, ready-prepared)",
    "NCBITaxon_55500": "Triglochin",
    "FOODON_03542088": "20880 - pig head (efsa foodex2)",
    "FOODON_00002397": "tuna scrape",
    "NCBITaxon_255560": "Clidoderma asperrimum",
    "FOODON_03308546": "scallop (cape, raw)",
    "FOODON_03540447": "04470 - beetroot leaves (efsa foodex2)",
    "FOODON_00001710": "chamomile tea",
    "FOODON_03303596": "chocolate (artificially sweetened)",
    "FOODON_03413688": "shortbarbel pangasius",
    "FOODON_00003277": "rooibos tea (steeped)",
    "NCBITaxon_50458": "Barbarea verna",
    "FOODON_03307482": "fruit juice (sweetened)",
    "FOODON_03414106": "sleeper shark family",
    "FOODON_03401684": "10005804 - veal - unprepared/unprocessed (gs1 gpc)",
    "CHEBI_33262": "elemental oxygen",
    "FOODON_03306109": "cranberry preserves (food product)",
    "FOODON_03305482": "candy (grape sour, artificially-flavored)",
    "NCBITaxon_1489872": "Percomorphaceae",
    "FOODON_03543174": "31740 - juice, apricot (efsa foodex2)",
    "FOODON_03490218": "jug or demijohn",
    "FOODON_03315904": "sausage (formed)",
    "FOODON_00002590": "Merlot wine",
    "FOODON_03401370": "50262200 - chickpeas (gs1 gpc)",
    "FOODON_03301586": "grape drink (canned)",
    "FOODON_03315481": "spring roll pastry case",
    "FOODON_03316303": "liqueur (flavored with fruit aromas)",
    "FOODON_03543011": "30110 - honey (efsa foodex2)",
    "FOODON_03411303": "sage plant",
    "FOODON_03316449": "dough raising agent",
    "FOODON_03317382": "mammalian milk (pastuerized, fresh)",
    "FOODON_03317665": "fillings for flour confectionery (fruit based)",
    "FOODON_03310696": "meat croquette (raw)",
    "FOODON_03311114": "yellowfin tuna (packed in oil)",
    "FOODON_03317029": "tomato puree (for further processing)",
    "FOODON_03414916": "waterclover plant",
    "FOODON_00002930": "ground round",
    "FOODON_03310224": "hen egg white (boiled)",
    "FOODON_03414028": "common sunfish",
    "FOODON_03304467": "obsolete: cow milk (sterilized)",
    "GAZ_00004443": "State of South Dakota",
    "FOODON_03401275": "USDA SR poultry products (0500)",
    "FOODON_03309627": "clam (minced, breaded, frozen)",
    "NCBITaxon_72402": "Senna alexandrina",
    "ENVO_01000938": "hot tub",
    "FOODON_03542983": "29830 - sugars (mono- and di-saccharides) (efsa foodex2)",
    "FOODON_03302896": "dietetic cake",
    "FOODON_03317551": "fruit wine (aromatized)",
    "FOODON_03303705": "banana passionfruit pulp",
    "FOODON_03540136": "01360 - rye-wheat bread, wholemeal (efsa foodex2)",
    "FOODON_03544351": "43510 - plum flavour (efsa foodex2)",
    "CHEBI_26400": "purine ribonucleotide",
    "FOODON_03307232": "scotch whiskey",
    "FOODON_03413196": "polyoxyethylene (40) stearate",
    "FOODON_00002095": "peach food product",
    "FOODON_00002439": "endive",
    "FOODON_03540641": "06410 - alkekengi (efsa foodex2)",
    "FOODON_03413092": "dodecyl gallate",
    "FOODON_03306368": "fruit pulp (unsweetened)",
    "FOODON_03414486": "beluga whale",
    "FOODON_03310662": "bakery product (not further specified)",
    "FOODON_03301724": "pear (whole, raw)",
    "FOODON_03411663": "horse bean plant",
    "FOODON_00001596": "animal based salad food product",
    "FOODON_03303546": "cottage cheese (creamed, artificially flavored)",
    "FOODON_03413522": "mackerel shark",
    "NCBITaxon_30458": "Strigiformes",
    "CHEBI_52625": "inorganic hydroxy compound",
    "FOODON_03541307": "13070 - fennel seed and similar- (efsa foodex2)",
    "FOODON_03413499": "rainbow smelt",
    "FOODON_03414787": "exocarpos plant",
    "CHEBI_25235": "monomethoxybenzene",
    "FOODON_03303509": "cream cheese (whipped)",
    "FOODON_03412751": "garden orach plant",
    "FOODON_03304357": "strawberry (canned)",
    "FOODON_00003062": "robusta coffee (liquid)",
    "FOODON_03411586": "atlantic herring",
    "FOODON_03304414": "chocolate chip cookie (artificially sweetened)",
    "FOODON_03542382": "23820 - bream, silver (efsa foodex2)",
    "FOODON_03541623": "16230 - elderberries (efsa foodex2)",
    "FOODON_03411696": "fenugreek plant",
    "FOODON_03305460": "halibut steak (raw)",
    "FOODON_03309410": "bourbon whiskey",
    "FOODON_03316445": "sugar cube",
    "FOODON_03303532": "tybo cheese",
    "FOODON_03307845": "spiced cheese (part-skim)",
    "FOODON_03413994": "mountain mullet",
    "FOODON_03413364": "porpoise family",
    "FOODON_00002808": "olive oil (extra-virgin)",
    "CHEBI_138675": "gas molecular entity",
    "FOODON_00002530": "mulligatawny",
    "FOODON_00002854": "hydrogenated corn oil",
    "FOODON_03401112": "50192400 - sweet spreads (gs1 gpc)",
    "FOODON_03401136": "10000628 - aquatic invertebrates/fish/shellfish/seafood mixes - prepared/processed (shelf stable) (gs1 gpc)",
    "FOODON_03316807": "macaroni (milk)",
    "FOODON_03413496": "deep-water rose shrimp",
    "FOODON_03304888": "tree tomato sauce",
    "FOODON_03412887": "scamp",
    "FOODON_03543906": "39060 - mushroom based dishes (efsa foodex2)",
    "FOODON_03301335": "olive oil (extracted from pomace and pits, refined)",
    "FOODON_03411900": "blue catfish",
    "NCBITaxon_8397": "Ranidae",
    "FOODON_03302415": "beverage (artifically sweetened, vitamin and mineral fortified)",
    "FOODON_03412256": "blood snapper",
    "FOODON_03311563": "bramble berry (whole, raw)",
    "FOODON_03544306": "43060 - malaga / raisins flavour (efsa foodex2)",
    "CHEBI_86222": "borax",
    "FOODON_00003229": "absinthe",
    "FOODON_03413585": "small european locust lobster",
    "FOODON_03543892": "38920 - french fries from dough (efsa foodex2)",
    "FOODON_03412538": "pacific geoduck",
    "FOODON_03541597": "15970 - crowberries (efsa foodex2)",
    "FOODON_00001172": "nut food product",
    "FOODON_03412091": "squash, gourd or pumpkin plant",
    "CHEBI_29377": "sodium carbonate",
    "FOODON_03401134": "10000626 - aquatic invertebrates/fish/shellfish/seafood mixes - prepared/processed (frozen) (gs1 gpc)",
    "FOODON_03308795": "pacific crayfish (raw)",
    "FOODON_03306075": "jalapeno jelly",
    "FOODON_03301699": "candy (filled)",
    "FOODON_03310908": "cream (raw)",
    "FOODON_03414154": "american bison",
    "FOODON_03414035": "five-rayed threadfin",
    "FOODON_03540970": "09700 - taros (efsa foodex2)",
    "FOODON_03305160": "fruit jelly (carbonated)",
    "FOODON_03542951": "29510 - hen eggs (efsa foodex2)",
    "FOODON_03543759": "37590 - infant formula, based on protein hydrolysates, liquid (efsa foodex2)",
    "FOODON_00003103": "red crowberry (whole)",
    "NCBITaxon_143895": "Notacanthus chemnitzii",
    "NCBITaxon_4270": "Byrsonima crassifolia",
    "FOODON_03307281": "star apple (canned)",
    "FOODON_03401349": "50270100 - fruits - unprepared/unprocessed (frozen) (gs1 gpc)",
    "FOODON_03310856": "mustard seed (whole, raw)",
    "FOODON_00001742": "citrus preserve or jam food product",
    "FOODON_03315838": "food (sugar-free)",
    "NCBITaxon_6564": "Crassostrea",
    "FOODON_03520360": "europe, nordic countries",
    "FOODON_03543917": "39170 - ratatouille (efsa foodex2)",
    "FOODON_03308747": "scallop roe (raw)",
    "FOODON_03541878": "18780 - bovine carcase (efsa foodex2)",
    "FOODON_03540308": "03080 - breakfast cereals (efsa foodex2)",
    "FOODON_03304521": "rabbit (skinned, dressed, frozen)",
    "FOODON_03304099": "sourdough starter",
    "NCBITaxon_154498": "Vicia ervilia",
    "FOODON_03490110": "laminate tube, ends lined with foil",
    "FOODON_03411750": "tree fern plant",
    "CHEBI_25017": "leucine",
    "FOODON_03460103": "component substitution process",
    "FOODON_03544134": "41340 - tomato chutney (efsa foodex2)",
    "FOODON_03400116": "cold-pack cheese product (us cfr)",
    "UBERON_0002048": "lung",
    "FOODON_03460189": "iodized",
    "FOODON_03530244": "sodium tripolyphosphate",
    "FOODON_03544000": "40000 - meat soup, with pieces (efsa foodex2)",
    "FOODON_03542582": "25820 - other frog meat from frogs not belonging to the genus rana (efsa foodex2)",
    "CHEBI_51069": "organic halide salt",
    "FOODON_03302285": "imitation lemon beverage base (vitamin-fortified, artificially sweetened)",
    "FOODON_00003057": "Pan dulce",
    "FOODON_03543520": "35200 - silver linden infusion leaves (efsa foodex2)",
    "FOODON_03301517": "hominy feed",
    "NCBITaxon_6726": "Procambarus",
    "FOODON_03310381": "dairy concentrate",
    "FOODON_03304481": "flour (bromated)",
    "FOODON_03307318": "haddock fillet (skinless, frozen)",
    "FOODON_03306278": "macaroni (instant)",
    "FOODON_03401668": "10006278 - lamb - unprepared/unprocessed (gs1 gpc)",
    "NCBITaxon_117924": "Centrophoridae",
    "FOODON_03543134": "31340 - fish oil (efsa foodex2)",
    "FOODON_03316754": "crystaline fructose",
    "FOODON_00003059": "piki",
    "FOODON_03411674": "nettle plant",
    "FOODON_03304778": "macaroni and mince (meat)",
    "FOODON_00003063": "arabica coffee (liquid)",
    "FOODON_03543716": "37160 - rye coffee infusion (efsa foodex2)",
    "PATO_0001648": "circumference",
    "FOODON_03308058": "pollock fillet (frozen)",
    "FOODON_03317621": "butterbur (food product)",
    "FOODON_03480032": "packed in gas mixture",
    "FOODON_03304949": "soup (concentrated)",
    "FOODON_03401526": "10006356 - squash (choko) (gs1 gpc)",
    "FOODON_03304324": "apple-flavored beverage syrup",
    "PATO_0001711": "perimeter",
    "FOODON_03401254": "0860000 - spices, flower stigma (ec)",
    "FOODON_03400390": "colour adjunct (codex)",
    "FOODON_03543590": "35900 - cinnamon infusion flowers (efsa foodex2)",
    "FOODON_03310479": "fruit juice artificially sweetened",
    "FOODON_03411224": "oyster",
    "FOODON_03400921": "10000223 - juice drinks - ready to drink (shelf stable) (gs1 gpc)",
    "GAZ_00003203": "Hong Kong",
    "FOODON_03414733": "king orchid plant",
    "FOODON_03304590": "cheddar cheese (sharp)",
    "NCBITaxon_171251": "Citrus medica",
    "CHEBI_36093": "inorganic chloride",
    "NCBITaxon_34774": "Alosa pseudoharengus",
    "FOODON_03304048": "sauce chasseur",
    "FOODON_03400455": "CIAA fruits and vegetables",
    "FOODON_03400989": "10000204 - fruit - prepared/processed (frozen) (gs1 gpc)",
    "FOODON_03412832": "sourplum plant",
    "FOODON_03544170": "41700 - tapioca starch (efsa foodex2)",
    "FOODON_03411788": "cabezon",
    "ENVO_01000174": "forest biome",
    "FOODON_03301645": "brazilnut (shell on)",
    "FOODON_00001136": "distilled fermented beverage",
    "FOODON_03310617": "scallop (boiled)",
    "GAZ_00281547": "British Isles",
    "FOODON_03460134": "protein removal process",
    "FOODON_03304032": "thousand island dressing",
    "FOODON_00002582": "giant water bug",
    "FOODON_03301178": "pork liver (whole, raw)",
    "FOODON_03301405": "herring (pickled)",
    "FOODON_03411789": "sculpin family",
    "FOODON_03307785": "anchovy fillet in oil",
    "FOODON_03303197": "corn cob flour",
    "FOODON_03411972": "green sturgeon",
    "FOODON_03307431": "fruit pie",
    "FOODON_03414199": "boldo plant",
    "FOODON_03311528": "malt cooler",
    "FOODON_03413336": "garden strawberry plant",
    "FOODON_03540143": "01430 - tortilla (efsa foodex2)",
    "FOODON_03541314": "13140 - nutmeg seed (efsa foodex2)",
    "FOODON_03305441": "grasshopper (raw)",
    "NCBITaxon_113210": "Capsicum pubescens",
    "FOODON_03542080": "20800 - bovine trotters and feet (efsa foodex2)",
    "FOODON_03400825": "vegetable or vegetable product (eurofir)",
    "FOODON_03401480": "10006006 - onions (gs1 gpc)",
    "FOODON_03310767": "vegetable-flavored beverage (noncarbonated)",
    "FOODON_03413347": "european crabapple plant",
    "FOODON_03401306": "dietary supplement, herbal or botanical",
    "FOODON_03411943": "red deepsea crab",
    "FOODON_03307970": "imitation milk chocolate (artifically sweetened)",
    "FOODON_03308059": "kipper (frozen)",
    "FOODON_03542894": "28940 - cheese, bitto della valtellina (efsa foodex2)",
    "FOODON_03413415": "sowthistle plant",
    "FOODON_03303530": "cheese spread with meat flavoring",
    "FOODON_03311213": "pecan (whole, oil roasted)",
    "FOODON_03414638": "telescope snail",
    "FOODON_03530133": "jumeau",
    "GAZ_00009571": "Gaza Strip",
    "NCBITaxon_37176": "Ovibos moschatus",
    "FOODON_03304443": "seafood dinner",
    "FOODON_00002342": "water chestnut food product",
    "FOODON_03303066": "fruit cider",
    "FOODON_03543575": "35750 - flowers used for herbal infusions (efsa foodex2)",
    "FOODON_03401522": "10006449 - gherkins (gs1 gpc)",
    "FOODON_03305356": "chicken (artificially colored)",
    "FOODON_03401416": "10005898 - plantain bananas (gs1 gpc)",
    "FOODON_03401618": "10006298 - antelope - prepared/processed (gs1 gpc)",
    "FOODON_03401131": "10000149 - aquatic invertebrates - unprepared/unprocessed (perishable) (gs1 gpc)",
    "FOODON_03311351": "crabmeat (fresh, raw)",
    "FOODON_03308805": "creole base (shrimp-flavored)",
    "FOODON_03311446": "red wheat kernel",
    "FOODON_03510048": "high fiber food",
    "FOODON_03542569": "25690 - sea squirts (efsa foodex2)",
    "FOODON_03401505": "10005883 - mexican limes (gs1 gpc)",
    "FOODON_03306605": "golden fruit juice drink",
    "NCBITaxon_627230": "Ostrea lurida",
    "FOODON_03311460": "soybean grits",
    "FOODON_03305511": "hayflower tea (steeped)",
    "HANCESTRO_0313": "Old Order Amish",
    "FOODON_03308154": "oyster croquette",
    "FOODON_03414092": "cuckoo ray",
    "FOODON_03304925": "soup (condensed)",
    "FOODON_03309422": "saithe fillet (with skin, raw)",
    "FOODON_03542457": "24570 - blue shark (efsa foodex2)",
    "FOODON_03411682": "bocaccio",
    "FOODON_03411078": "globe tomato plant",
    "FOODON_03510233": "\"no trans fat\" claim or use",
    "FOODON_03412616": "chinese walnut tree",
    "FOODON_03315955": "milk-based preparation (desserts and similar products) energy reduced",
    "NCBITaxon_38149": "Menippe adina",
    "FOODON_03412483": "stickleback family",
    "FOODON_00002767": "food (blanched)",
    "FOODON_03302379": "garlic bread",
    "FOODON_03541071": "10710 - black eyed peas (dry) (efsa foodex2)",
    "FOODON_03303777": "pastille (sugarless)",
    "FOODON_03414645": "beetle",
    "FOODON_03304817": "seaweed (dried)",
    "FOODON_03317305": "spaghetti with meat sauce",
    "FOODON_03414875": "characin",
    "FOODON_03414766": "tasselflower plant",
    "FOODON_03540267": "02670 - meringue tart (efsa foodex2)",
    "FOODON_03310184": "butter (reduced fat)",
    "GAZ_00001104": "Somalia",
    "HANCESTRO_0413": "Honduran",
    "FOODON_03541944": "19440 - kangaroo fresh meat (efsa foodex2)",
    "FOODON_03305372": "gelatin dessert (fruit-flavored)",
    "NCBITaxon_111783": "Reinhardtius",
    "NCBITaxon_8015": "Salmonidae",
    "FOODON_00001049": "pork chop food product",
    "FOODON_03510055": "energy free food claim or use",
    "FOODON_03543710": "37100 - coffee drink, caf\u00e9 macchiato (efsa foodex2)",
    "NCBITaxon_8100": "Cottioidei",
    "FOODON_03543371": "33710 - mixed alcoholic drinks (efsa foodex2)",
    "FOODON_03303107": "beverage base (artificially coffee-flavored)",
    "FOODON_03530090": "dry mix",
    "FOODON_03317407": "mollusc (unprocessed, deep-frozen)",
    "FOODON_03542831": "28310 - cheese, marechal (efsa foodex2)",
    "FOODON_00003328": "turkey thigh (with skin)",
    "FOODON_03311500": "obsolete: fish product marinated not further specified",
    "CHEBI_24278": "glucoside",
    "FOODON_03541483": "14830 - chinese quinces (efsa foodex2)",
    "FOODON_03541691": "16910 - otaheite gooseberries (efsa foodex2)",
    "FOODON_03543404": "34040 - coffee ingredients (efsa foodex2)",
    "FOODON_03316382": "fruit (semi-dried, glazed)",
    "HANCESTRO_0573": "Native Hawaiian",
    "FOODON_03541965": "19650 - chicken fresh meat (efsa foodex2)",
    "FOODON_00001194": "dry pea food product",
    "FOODON_03480020": "food packing medium",
    "FOODON_03310199": "tropical fruit juice with pulp (pasteurized, frozen)",
    "FOODON_03316520": "paste based on herb extract (edible)",
    "FOODON_00001564": "blood meal",
    "FOODON_00001872": "food product type (to be processed)",
    "NCBITaxon_4631": "Costus",
    "FOODON_03308698": "mussel (stuffed)",
    "FOODON_03540384": "03840 - wall rocket (efsa foodex2)",
    "FOODON_03317438": "fruit (unprocessed, frozen)",
    "FOODON_03414116": "darkie charlie",
    "FOODON_03412652": "angelfish family",
    "FOODON_03307826": "pimiento cheese sandwich spread (low calorie)",
    "FOODON_03315597": "fruit cocktail",
    "FOODON_03414636": "nerite",
    "FOODON_03302743": "pork chitterlings",
    "FOODON_03542576": "25760 - crocodiles (efsa foodex2)",
    "FOODON_03305149": "blackberry (frozen)",
    "FOODON_03311520": "infant formula (milk-based, liquid, iron-fortified, ready-to-feed)",
    "FOODON_03301326": "cabbage (whole, raw)",
    "FOODON_03304302": "sugar (liquid)",
    "FOODON_03413458": "pepper leaves plant",
    "FOODON_03490179": "wood barrel, cask or wheel",
    "FOODON_03305854": "strawberry ice cream",
    "FOODON_03305081": "butter drop candy",
    "FOODON_03413970": "skipjack trevally",
    "FOODON_00001642": "betel nut food product",
    "NCBITaxon_106175": "Microstomus kitt",
    "FOODON_03400897": "10000210 - fruit herbal infusions - instant (gs1 gpc)",
    "FOODON_03544498": "44980 - selenium (efsa foodex2)",
    "FOODON_03543842": "38420 - soya yoghurt (efsa foodex2)",
    "FOODON_03411782": "mullet family",
    "FOODON_03414841": "desert caper plant",
    "FOODON_00002592": "Pinot blanc wine",
    "GAZ_00006881": "State of Alabama",
    "FOODON_03306846": "papaya drink base (food product)",
    "FOODON_03400944": "10000163 - bread (frozen) (gs1 gpc)",
    "HANCESTRO_0506": "Ethiopian",
    "FOODON_00001809": "dietary or therapeutic formulation food product",
    "FOODON_03490222": "multicomponent adhesive",
    "FOODON_03311758": "salsify (raw)",
    "FOODON_03316678": "fish portion (in batter, quick-frozen)",
    "FOODON_00002144": "obsolete: plant product based dressing",
    "FOODON_03401380": "50261000 - other vegetables (gs1 gpc)",
    "FOODON_03306853": "yellow potato (canned)",
    "FOODON_03414811": "horn snail",
    "FOODON_03541191": "11910 - turnip rape seeds (efsa foodex2)",
    "FOODON_03315940": "collagen casing edible",
    "NCBITaxon_30521": "Bos grunniens",
    "FOODON_00001717": "cherry food product",
    "FOODON_03301008": "liqueur",
    "FOODON_03415163": "blueflag plant",
    "FOODON_03304753": "pasteurized process cheese food with ham",
    "FOODON_03413158": "monocalcium citrate",
    "FOODON_03315612": "fish roe (sugar treated)",
    "NCBITaxon_184440": "Centropristis striata",
    "FOODON_03490246": "metal screw cap/pilfer proof",
    "FOODON_03317660": "vitamin oils and concentration containing less than 100,000 i.u. of vitamin a per gram",
    "FOODON_03304684": "spiced pickle",
    "FOODON_03308971": "spotted rose snapper (raw)",
    "FOODON_03316849": "cheddar cheese (low sodium)",
    "FOODON_03310824": "bread (enriched)",
    "FOODON_00003238": "risotto",
    "FOODON_03543515": "35150 - lemon myrtle infusion leaves (efsa foodex2)",
    "NCBITaxon_58031": "Cycas rumphii",
    "FOODON_03412486": "langostino lobster",
    "FOODON_03309623": "dromia-eliza snow crab (raw)",
    "FOODON_03414291": "pyropia columbina",
    "FOODON_03542938": "29380 - custard (efsa foodex2)",
    "FOODON_03316999": "mitsumame (packed in plastic)",
    "NCBITaxon_1003242": "Ximeniaceae",
    "FOODON_03541503": "15030 - sour cherries dark red (efsa foodex2)",
    "FOODON_00002131": "plant based refined or partially-refined food product",
    "FOODON_03305017": "nonfat dry milk (artificially sweetened)",
    "FOODON_03302259": "orange-flavored beverage base (artificially sweetened)",
    "NCBITaxon_3624": "Actinidia",
    "FOODON_03315167": "rice (precooked, instant)",
    "FOODON_03541596": "15960 - cloudberries (efsa foodex2)",
    "FOODON_03306113": "lingonberry syrup (food product)",
    "NCBITaxon_84621": "Ammodytes tobianus",
    "NCBITaxon_3754": "Prunus",
    "FOODON_03412039": "spirulina",
    "FOODON_03401402": "50251400 - avocados (gs1 gpc)",
    "FOODON_03303035": "chicken head (frozen, ground for feed)",
    "CHEBI_38313": "diazines",
    "FOODON_03307363": "oatmeal and raspberry soft snack cookie",
    "FOODON_03543115": "31150 - palm kernel oil, edible (efsa foodex2)",
    "FOODON_03311767": "shirataki noodle (food product)",
    "FOODON_03309736": "coconut custard",
    "FOODON_03510223": "food allergen labelling about mustard and products thereof",
    "FOODON_03412273": "lemon grass plant",
    "FOODON_03413484": "garden pea plant",
    "FOODON_03541103": "11030 - lupins (dry) and similar- (efsa foodex2)",
    "GAZ_00004126": "Metropolitan Portugal",
    "UO_0000187": "percent",
    "FOODON_03308793": "snapper fillet (raw)",
    "FOODON_03540083": "00830 - sorghum flour (efsa foodex2)",
    "PO_0006342": "infructescence",
    "FOODON_03301381": "pimiento (canned)",
    "FOODON_03540511": "05110 - sunflower shoots and sprouts (efsa foodex2)",
    "FOODON_03308342": "lobster (precooked, frozen)",
    "FOODON_03411588": "black gram bean plant",
    "FOODON_03401449": "10005922 - wood strawberries (gs1 gpc)",
    "FOODON_03400775": "090  manufactured milk products (single ingredient) of animal origin (li) (ccpr)",
    "FOODON_03302520": "butter with garlic",
    "FOODON_03490143": "glass container, tin-plated steel lid",
    "NCBITaxon_6447": "Mollusca",
    "PATO_0001712": "increased perimeter",
    "FOODON_03304053": "grouse in port wine jelly",
    "NCBITaxon_6565": "Crassostrea virginica",
    "FOODON_03543849": "38490 - goulash (efsa foodex2)",
    "FOODON_03411783": "flathead grey mullet",
    "FOODON_03316517": "confectionery dragees",
    "FOODON_00001801": "dairy product analog",
    "FOODON_03308745": "clam (hard, raw)",
    "FOODON_03309117": "john dory (raw)",
    "NCBITaxon_4568": "Triticum monococcum",
    "FOODON_03317446": "gnocchi",
    "FOODON_03414548": "wood hedgehog",
    "FOODON_03540222": "02220 - sponge cake dough (g\u00e9noise) (efsa foodex2)",
    "FOODON_03420162": "heart (plant)",
    "FOODON_00003118": "opium poppy seed food product",
    "NCBITaxon_16739": "Piperaceae",
    "FOODON_03401174": "10000615 - herbs/spices/extracts variety packs (gs1 gpc)",
    "NCBITaxon_4725": "Pandanus",
    "CHEBI_87659": "dodecanoate ester",
    "FOODON_03411131": "english sole",
    "FOODON_03401007": "10000270 - vegetables - prepared/processed (frozen) (gs1 gpc)",
    "FOODON_03311063": "peppermint leaf (whole)",
    "FOODON_00001284": "duck meat food product",
    "FOODON_03543837": "38370 - spelt drink (efsa foodex2)",
    "NCBITaxon_1010633": "Digitaria exilis",
    "FOODON_03413963": "japanese scad",
    "FOODON_03303841": "pear (in fruit juice, canned)",
    "FOODON_03311513": "banana (whole, ripe)",
    "FOODON_00002848": "enchilada",
    "FOODON_03311295": "rice (medium grain, raw)",
    "HANCESTRO_0332": "Sahrawi",
    "FOODON_03306528": "onion (pickled)",
    "FOODON_03310082": "mushroom (whole, dried)",
    "FOODON_03542244": "22440 - channel catfish (efsa foodex2)",
    "FOODON_03420152": "carbohydrate extract, concentrate, or isolate",
    "CHEBI_33892": "iron coordination entity",
    "FOODON_03542933": "29330 - other processed cheese (efsa foodex2)",
    "FOODON_03541672": "16720 - natal plums (efsa foodex2)",
    "FOODON_03540869": "08690 - lemon savory (efsa foodex2)",
    "FOODON_03542979": "29790 - poached eggs (efsa foodex2)",
    "FOODON_03301173": "bay leaf (dried)",
    "FOODON_03543709": "37090 - coffee drink, cappuccino (efsa foodex2)",
    "FOODON_03301539": "apricot kernel",
    "NCBITaxon_39257": "Verbascum",
    "FOODON_03411129": "trout and salmon family",
    "FOODON_03412078": "dace",
    "FOODON_03316008": "herbal infusion concentrate (liquid)",
    "FOODON_03414244": "green foxtail millet plant",
    "FOODON_03306029": "tangerine juice (frozen concentrate)",
    "FOODON_03315468": "shellfish meat (whole or parts)",
    "FOODON_03316085": "cow milk (partly dehydrated, less than 28% solids)",
    "FOODON_03309277": "devilfish fillet (breaded)",
    "FOODON_03400961": "50221000 - grains/flour (gs1 gpc)",
    "FOODON_03315375": "vegetable (preserved)",
    "FOODON_03541658": "16580 - limequats (efsa foodex2)",
    "FOODON_03303936": "blueberry muffin mix",
    "FOODON_03309365": "fruitcake mix",
    "NCBITaxon_102876": "Eledone cirrhosa",
    "NCBITaxon_3660": "Cucurbita",
    "NCBITaxon_2706": "Citrus",
    "FOODON_03309845": "china bean (whole)",
    "FOODON_03542472": "24720 - dolphinfish roe (efsa foodex2)",
    "FOODON_03315291": "ginseng product",
    "FOODON_03543833": "38330 - almond drink (efsa foodex2)",
    "FOODON_03414749": "atalaya plant",
    "FOODON_00002039": "mineral substance as food supplement product category",
    "FOODON_03305113": "japanese candy",
    "FOODON_03315574": "mousse food product",
    "FOODON_03307412": "spring mineral water (artificially carbonated, bottled)",
    "FOODON_03301128": "obsolete: blue cheese",
    "FOODON_03542463": "24630 - rays (efsa foodex2)",
    "FOODON_03542158": "21580 - italian-type salami (efsa foodex2)",
    "FOODON_03316625": "sausage (smoked, raw, salami-type)",
    "FOODON_00002488": "pear (whole or parts)",
    "FOODON_03309510": "apple wine (carbonated)",
    "NCBITaxon_7796": "Squalus",
    "FOODON_03401606": "10005938 - kiwiberries (gs1 gpc)",
    "FOODON_03540723": "07230 - crosnes (efsa foodex2)",
    "FOODON_03311354": "green bean (seasoned)",
    "FOODON_03401280": "USDA SR pork products (1000)",
    "FOODON_00002509": "Bosc pear (whole, raw)",
    "HANCESTRO_0550": "Zimbabweian",
    "PO_0030108": "berry fruit",
    "FOODON_00002778": "jack bean (whole)",
    "CHEBI_131526": "potassium carbonate",
    "FOODON_03411176": "black cumin plant",
    "HANCESTRO_0397": "Argentine",
    "FOODON_03450021": "cooking in steam",
    "FOODON_03543559": "35590 - wood betony infusion leaves (efsa foodex2)",
    "NCBITaxon_160718": "Epinephelus fasciatus",
    "FOODON_03301219": "cardamom (whole, dried)",
    "FOODON_03311298": "red grape (whole, raw)",
    "FOODON_03305629": "honey glaze for candy (food product)",
    "FOODON_03414551": "common morel",
    "FOODON_03400200": "distinctive distilled spirits (us cfr)",
    "FOODON_00002196": "refined or partially-refined food product",
    "FOODON_03304668": "tomato (comminuted, canned)",
    "FOODON_03302348": "apple bread",
    "FOODON_03541919": "19190 - buffalo, water fresh meat (efsa foodex2)",
    "FOODON_03540017": "00170 - common millet grain (efsa foodex2)",
    "FOODON_03316840": "vermicelli (egg, wheat, and soy)",
    "FOODON_03307166": "fruit spread (frozen)",
    "FOODON_03304059": "water (canned)",
    "FOODON_03309536": "salt (fortified)",
    "FOODON_03304234": "coconut peanut butter log",
    "FOODON_03413232": "red 2g",
    "FOODON_03412086": "boston lettuce plant",
    "FOODON_03315996": "food supplement or dietary integrator, liquid",
    "FOODON_00001138": "tea based beverage product",
    "FOODON_00003195": "cupua\u00e7u fruit (whole, raw)",
    "FOODON_03307758": "cheese cracker sandwich (peanut butter-filled)",
    "FOODON_03541148": "11480 - macadamia tetraphylla (efsa foodex2)",
    "NCBITaxon_258209": "Berberis vulgaris",
    "FOODON_00002617": "Zinfandel wine",
    "FOODON_03305575": "shellfish (canned)",
    "FOODON_03413946": "southeast pacific grunt",
    "FOODON_00001840": "field corn based bakery food product",
    "FOODON_03315118": "crabmeat (cooked, canned)",
    "GAZ_00000914": "Sierra Leone",
    "FOODON_03309062": "red cod (raw)",
    "FOODON_03543339": "33390 - pale ale beer (efsa foodex2)",
    "FOODON_03480046": "packed in animal fat or oil",
    "FOODON_03304685": "red cabbage (whole, raw)",
    "FOODON_03414632": "shipworm",
    "FOODON_03400798": "sausage or similar meat product (eurofir)",
    "CHEBI_33833": "heteroarene",
    "FOODON_03541539": "15390 - musky strawberries (efsa foodex2)",
    "FOODON_03302671": "fruit and grain beverage (caffeine-free)",
    "FOODON_03541195": "11950 - moringa (efsa foodex2)",
    "FOODON_03304077": "onion-flavored broth (instant)",
    "FOODON_03401504": "10006440 - mediterranean (willowleaf) mandarins (gs1 gpc)",
    "FOODON_00002585": "Cabernet Sauvignon wine",
    "FOODON_03400215": "flavoring (us cfr)",
    "NCBITaxon_8240": "Thunnus maccoyii",
    "FOODON_03400873": "food for infants (eurofir)",
    "FOODON_00003047": "hardneck garlic",
    "CHEBI_33620": "aluminium molecular entity",
    "CHEBI_17087": "ketone",
    "FOODON_03411157": "fish, gadiform",
    "HANCESTRO_0371": "Latvian",
    "FOODON_03411299": "olive plant",
    "FOODON_03304229": "halibut a la king",
    "FOODON_03414032": "lateolabracidae",
    "FOODON_00002016": "malabar snapper food product",
    "FOODON_03304568": "rose hip in sugar syrup (fermented)",
    "FOODON_03307888": "hen egg (dried, fumigated)",
    "FOODON_03411459": "saffron plant",
    "FOODON_03302323": "buttermilk doughnut",
    "FOODON_00001216": "cream food product",
    "FOODON_00003239": "ratatouille",
    "FOODON_03305888": "crabapple jelly",
    "FOODON_03317468": "fruit spread (low-calorie)",
    "OBI_0000659": "specimen collection process",
    "FOODON_03542478": "24780 - salmon roe, atlantic (efsa foodex2)",
    "FOODON_03308820": "shrimp (spring water, raw)",
    "FOODON_00002213": "rye based bakery food product",
    "FOODON_03540166": "01660 - gluten free bread (efsa foodex2)",
    "GAZ_02000610": "Papua Province",
    "FOODON_00002731": "snapper fillet",
    "FOODON_03305803": "goat milk (raw)",
    "FOODON_03411787": "frigate tuna",
    "FOODON_03301558": "marjoram leaf (whole)",
    "FOODON_00003285": "multi-component seafood product",
    "FOODON_03400841": "juice or nectar (eurofir)",
    "FOODON_03310168": "chicken thigh (microwaved)",
    "FOODON_03413488": "angled loofah plant",
    "FOODON_03412408": "jellyfish",
    "FOODON_03414462": "morrito plant",
    "FOODON_03460161": "fat removal process",
    "FOODON_03414464": "Crateva religiosa tree",
    "FOODON_03542069": "20690 - duck edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "FOODON_03310160": "meadow fescue fodder silage",
    "PATO_0000386": "hard",
    "FOODON_03542397": "23970 - dories (efsa foodex2)",
    "FOODON_03540450": "04500 - goosefoot (efsa foodex2)",
    "NCBITaxon_3749": "Malus",
    "FOODON_03414745": "goosefoot family",
    "FOODON_00003231": "tarte trop\u00e9zienne",
    "FOODON_03308318": "chum salmon (frozen)",
    "FOODON_03309503": "hen egg extender (artificially colored)",
    "FOODON_03401539": "10006213 - eggs imitations (gs1 gpc)",
    "CHEBI_24963": "ketoaldonic acid",
    "FOODON_03309830": "coconut ice",
    "FOODON_03520352": "atlantic ocean islands",
    "FOODON_03400754": "051  straw, fodder and forage of cereal grains and grasses, except grasses for sugar production (including buckwheat fooder) (as/af) (ccpr)",
    "FOODON_03544350": "43500 - pistachio flavour (efsa foodex2)",
    "FOODON_03411268": "lentil plant",
    "FOODON_03540101": "01010 - rye groats (efsa foodex2)",
    "NCBITaxon_87088": "Vigna umbellata",
    "FOODON_03305769": "pecan (whole, raw, shell off)",
    "FOODON_03412492": "barberry plant",
    "FOODON_03413007": "ascorbyl stearate",
    "FOODON_00001107": "bovine dairy food product",
    "FOODON_03302181": "meat (charcoal-broiled)",
    "FOODON_03400793": "meat or meat product (eurofir)",
    "FOODON_03530242": "ichthyootoxic poisoning",
    "IAO_0000028": "symbol",
    "FOODON_03304795": "apple juice (from cores and peels)",
    "FOODON_03311324": "pecan (ground)",
    "FOODON_03542795": "27950 - cheese, arzua ulloa (efsa foodex2)",
    "NCBITaxon_85232": "Morus nigra",
    "NCBITaxon_131282": "Linospadix monostachyos",
    "FOODON_03303877": "mozzarella cheese (part-skim)",
    "FOODON_03414788": "twintip plant",
    "FOODON_03301129": "apple cider (non-alcoholic)",
    "FOODON_03311180": "corn puff",
    "FOODON_03490136": "glass container, plastic lid, plastic lining",
    "FOODON_03317495": "coconut beverage (non-alcoholic)",
    "FOODON_03544509": "45090 - carotenoids (efsa foodex2)",
    "FOODON_03401563": "10006267 - iceberg lettuce (gs1 gpc)",
    "ENVO_00000091": "beach",
    "FOODON_03543940": "39400 - pizza and similar with cheese, and vegetables (efsa foodex2)",
    "NCBITaxon_31022": "Tetraodontiformes",
    "FOODON_00001307": "ma kham dong",
    "FOODON_03541019": "10190 - canned starchy root products (efsa foodex2)",
    "FOODON_03311179": "baking mix for chicken",
    "FOODON_03304720": "french dressing (italian-style)",
    "IAO_0000416": "time measurement datum",
    "FOODON_00002981": "butternut squash (whole, raw)",
    "FOODON_03401153": "10000020 - shellfish - unprepared/unprocessed (frozen) (gs1 gpc)",
    "FOODON_03308040": "fish (defrosted)",
    "NCBITaxon_31029": "Molidae",
    "NCBITaxon_3298": "Zamiaceae",
    "FOODON_03304426": "vanilla filled wafer (artificially sweetened)",
    "NCBITaxon_224715": "Etrumeus",
    "FOODON_03316220": "breakfast cereal (energy reduced)",
    "FOODON_03412830": "water berry plant",
    "NCBITaxon_163128": "Arripis",
    "FOODON_03315426": "yeast extract",
    "FOODON_03411312": "wheat plant",
    "FOODON_03540625": "06250 - moringa (with pods) (efsa foodex2)",
    "FOODON_03316244": "spread, very low fat",
    "FOODON_03310173": "oatmeal (instant, with apples, with raisins, with walnuts, dry)",
    "FOODON_03544287": "42870 - herbs flavour (efsa foodex2)",
    "BFO_0000031": "generically dependent continuant",
    "NCBITaxon_64107": "Zeus",
    "FOODON_03301889": "cream cheese",
    "FOODON_03311403": "codfish frozen",
    "FOODON_03310122": "sesame meal",
    "NCBITaxon_56268": "Bubo virginianus",
    "FOODON_00001636": "beef product based flavoring or seasoning",
    "FOODON_03400123": "cream product analog (us cfr)",
    "FOODON_03414815": "spinose chiton",
    "FOODON_03303631": "fruit juice cocktail",
    "FOODON_00002850": "frybread",
    "FOODON_03543039": "30390 - cream chocolate (efsa foodex2)",
    "FOODON_00002991": "baklava",
    "FOODON_03306013": "orange juice (sweetened, canned)",
    "FOODON_03302341": "bread (unsalted, enriched)",
    "FOODON_03543098": "30980 - seed oils (efsa foodex2)",
    "NCBITaxon_4890": "Ascomycota",
    "NCBITaxon_490594": "Metanephrops sagamiensis",
    "FOODON_03541002": "10020 - agave leaves (efsa foodex2)",
    "FOODON_03540790": "07900 - jew's ears (efsa foodex2)",
    "FOODON_03411633": "whelk",
    "NCBITaxon_8234": "Thunnus",
    "NCBITaxon_117571": "Euteleostomi",
    "NCBITaxon_89636": "Ipomoea aquatica",
    "FOODON_03541731": "17310 - miscellaneous fruits with inedible peel, large (efsa foodex2)",
    "GAZ_00000905": "Burkina Faso",
    "NCBITaxon_8203": "Anarhichas",
    "NCBITaxon_3623": "Actinidiaceae",
    "NCBITaxon_1489904": "Carangaria",
    "FOODON_03414884": "clearhead icefish",
    "CHEBI_50047": "organic amino compound",
    "FOODON_03317385": "corn germ",
    "FOODON_00003146": "tapioca pearls",
    "FOODON_00001027": "cheddar cheese food product",
    "FOODON_03542777": "27770 - cheese, pouligny-saint-pierre (efsa foodex2)",
    "FOODON_03411351": "wax bean plant",
    "FOODON_00003320": "lemon (whole or parts)",
    "FOODON_03316044": "frying oil",
    "FOODON_03307979": "meat (ground, raw)",
    "FOODON_03490343": "paperboard container, surface treated inside",
    "FOODON_03310016": "cow skim milk (powdered)",
    "FOODON_03414882": "kapenta",
    "FOODON_03400325": "acid (food additive, EC)",
    "GAZ_00007116": "Kingman Reef",
    "FOODON_03543545": "35450 - sweet orange infusion leaves (efsa foodex2)",
    "FOODON_03316249": "topping for dessert",
    "NCBITaxon_274805": "Cheilodactylus variegatus",
    "FOODON_03303744": "candy cigarette",
    "FOODON_03413278": "sodium, potassium and calcium salts of fatty acids",
    "NCBITaxon_36212": "Trachurus trachurus",
    "CHEBI_50699": "oligosaccharide",
    "FOODON_03411646": "lappa plant",
    "NCBITaxon_8252": "Pleuronectiformes",
    "FOODON_03305967": "jam (artificially sweetened)",
    "FOODON_03540690": "06900 - loofah, smooth (efsa foodex2)",
    "FOODON_03411068": "northern quahog",
    "FOODON_03413187": "plain caramel",
    "HANCESTRO_0567": "Afro-Caribbean",
    "FOODON_03542990": "29900 - brown cane sugar (efsa foodex2)",
    "FOODON_03414176": "shimeji mushroom",
    "FOODON_03311462": "tomato paste (powdered, dehydrated, canned)",
    "FOODON_03301667": "instant beverage",
    "NCBITaxon_112230": "Mustelus mustelus",
    "FOODON_03544122": "41220 - curry sauce (efsa foodex2)",
    "FOODON_03540064": "00640 - other species of genus triticum, not elsewhere mentioned (efsa foodex2)",
    "FOODON_03304613": "sukiyaki vegetables (raw)",
    "FOODON_03304585": "rice (steamed)",
    "FOODON_03542817": "28170 - cheese, gjetost (efsa foodex2)",
    "NCBITaxon_30496": "Lamniformes",
    "FOODON_03316640": "confectionery cake",
    "NCBITaxon_6760": "Scylla",
    "NCBITaxon_1329911": "Toxicofera",
    "FOODON_03302532": "butter flavoring (food product)",
    "NCBITaxon_5204": "Basidiomycota",
    "FOODON_03414230": "tibetian rhubarb plant",
    "FOODON_03542043": "20430 - deer kidney (efsa foodex2)",
    "CHEBI_3310": "calcium acetate",
    "FOODON_03544257": "42570 - eggnog flavour (efsa foodex2)",
    "FOODON_03401144": "50121500 - fish - unprepared/unprocessed (gs1 gpc)",
    "FOODON_00001838": "fermented cereal beverage",
    "FOODON_03541688": "16880 - grumichamas (efsa foodex2)",
    "FOODON_03413911": "angel croaker",
    "FOODON_03301314": "shortening (food product)",
    "FOODON_03315963": "snack (prepacked)",
    "FOODON_03311529": "peanut spread (heat treated)",
    "FOODON_03306445": "pork (uncooked, cured)",
    "CHEBI_35381": "monosaccharide",
    "FOODON_03306669": "russian dressing",
    "FOODON_03301451": "sweet potato (syrup-packed)",
    "FOODON_03401605": "10006214 - extracts/seasonings/flavour enhancers (shelf stable) (gs1 gpc)",
    "FOODON_03310738": "navy bean (whole, dried)",
    "FOODON_00002891": "hen egg (whole, baked)",
    "FOODON_03413202": "potassium alginate",
    "FOODON_03470182": "low-temperature-long-time (ltlt) pasteurization",
    "FOODON_03414093": "winter skate",
    "FOODON_03541220": "12200 - perilla seeds (efsa foodex2)",
    "FOODON_03460750": "gluten removal process",
    "NCBITaxon_4019": "Tropaeolum",
    "FOODON_03540328": "03280 - mixed roasted flours for porridge-like food (efsa foodex2)",
    "FOODON_03530186": "fat content < 15%",
    "FOODON_03541930": "19300 - lamb fresh meat (efsa foodex2)",
    "FOODON_03310614": "walnut meat (moisture-tempered)",
    "FOODON_00001146": "solanaceous root food product",
    "NCBITaxon_10066": "Muridae",
    "FOODON_03306818": "ham (raw)",
    "FOODON_03315423": "obsolete: fruit wine product",
    "FOODON_03412287": "scrawled sole",
    "FOODON_03303513": "cheese (canned)",
    "ECOCORE_00000008": "trophic interaction",
    "FOODON_03401743": "10005951 - sweet granadilla (gs1 gpc)",
    "FOODON_03301059": "tea (decaffeinated, dry)",
    "FOODON_03540152": "01520 - crisp bread, rye, refined flour (efsa foodex2)",
    "GAZ_00004940": "South Caucasus",
    "FOODON_03302050": "boysenberry (whole, raw)",
    "FOODON_03316405": "malto dextrin (food product)",
    "FOODON_00002589": "Malbec grape plant",
    "FOODON_03307157": "brown rice (whole, enriched, precooked)",
    "FOODON_03306037": "krill (antarctic, raw)",
    "FOODON_03302642": "vegetable shortening (artificially-colored)",
    "FOODON_03304930": "coffee (instant with coffee creamer)",
    "FOODON_03540883": "08830 - gingermint (efsa foodex2)",
    "FOODON_03544218": "42180 - butterscotch flavour (efsa foodex2)",
    "FOODON_03306720": "pea (early june, canned)",
    "FOODON_03544022": "40220 - mixed vegetable salad (efsa foodex2)",
    "FOODON_03460135": "alkaloid or purine removal process",
    "FOODON_00002075": "pacific salmon food product",
    "NCBITaxon_428033": "Atheresthes",
    "FOODON_03540975": "09750 - sweet potatoes and similar- (efsa foodex2)",
    "NCBITaxon_349641": "Plectorhinchus",
    "FOODON_03540300": "03000 - scones and similar (efsa foodex2)",
    "FOODON_03400382": "carbonating agent (codex)",
    "FOODON_03304939": "chicken vegetable noodle soup mix",
    "NCBITaxon_445362": "Sphyraena jello",
    "FOODON_03317425": "vegetable (candied)",
    "NCBITaxon_198233": "Palinurus delagoae",
    "FOODON_03312035": "bread product",
    "FOODON_03315257": "obsolete: filling",
    "FOODON_00001055": "sea water fish food product",
    "FOODON_03310736": "moreton bay chestnut black bean (dried)",
    "FOODON_03304698": "milk substitute (sweetened, condensed)",
    "FOODON_00003117": "surinam cherry",
    "FOODON_03520505": "ice cap climatic zone",
    "FOODON_03412823": "ficus platyphylla plant",
    "FOODON_03401182": "10000616 - pickles/relishes/chutneys/olives variety packs (gs1 gpc)",
    "FOODON_03412168": "japanese spiny lobster",
    "FOODON_03400636": "CCFAC sweeteners",
    "FOODON_03308909": "eel bone (fried)",
    "CHEBI_37217": "titanium molecular entity",
    "NCBITaxon_94229": "Balistes",
    "FOODON_03542614": "26140 - fish paste or surimi (efsa foodex2)",
    "FOODON_03542824": "28240 - cheese, kasseri (efsa foodex2)",
    "FOODON_03309358": "filbert nut (shell off)",
    "FOODON_00002063": "obsolete: octopus food product",
    "FOODON_03308625": "shrimp (headless, raw, frozen)",
    "FOODON_03413445": "skirrit plant",
    "FOODON_03400905": "10000202 - drinks flavoured - not ready to drink (gs1 gpc)",
    "NCBITaxon_1158980": "Mobulinae",
    "FOODON_03542534": "25340 - mussels (efsa foodex2)",
    "FOODON_00001270": "water buffalo milk beverage",
    "FOODON_03411720": "calabash gourd plant",
    "FOODON_03308095": "atlantic sardine (raw)",
    "FOODON_03543116": "31160 - wheat germ oil (efsa foodex2)",
    "FOODON_03414159": "fallow deer",
    "NCBITaxon_41937": "Sapindales",
    "FOODON_03400318": "antioxidant (us cfr)",
    "FOODON_03414275": "splendid alfonsino",
    "FOODON_03317148": "food packaged in aerosol container",
    "FOODON_03304331": "guava beverage syrup",
    "FOODON_03411399": "pike perch",
    "NCBITaxon_241806": "Polypodiopsida",
    "FOODON_03412208": "royal spiny lobster",
    "FOODON_03541705": "17050 - litchis (efsa foodex2)",
    "FOODON_03530170": "alcohol content > 9%",
    "FOODON_03311651": "bubod (food product)",
    "FOODON_03306141": "shiso",
    "FOODON_03510012": "pet fish as consumer",
    "FOODON_03530198": "fat content > 80%, > 25% pufa",
    "FOODON_03543401": "34010 - edible alcohol (efsa foodex2)",
    "FOODON_03543561": "35610 - yellow bedstraw infusion leaves (efsa foodex2)",
    "FOODON_03304800": "imitation eggnog",
    "FOODON_03414256": "ahipa plant",
    "FOODON_00001151": "citrus fruit food product",
    "FOODON_03306243": "lemonade-flavored drink",
    "FOODON_03540935": "09350 - preserved tomato, whole or pieces (efsa foodex2)",
    "FOODON_03304242": "chicken soup stix",
    "FOODON_03412144": "ling",
    "FOODON_03530024": "round or leg (meat cut)",
    "CHEBI_22698": "benzaldehydes",
    "FOODON_03542508": "25080 - king crabs, squat-lobsters (efsa foodex2)",
    "ENVO_00002040": "wood",
    "FOODON_03310190": "pine nut extract",
    "FOODON_03316021": "meat product (dried)",
    "FOODON_03302205": "bird seed",
    "FOODON_03544220": "42200 - cappuccino flavour (efsa foodex2)",
    "FOODON_03540802": "08020 - wild fungi and similar- (efsa foodex2)",
    "FOODON_03542045": "20450 - poultry kidney (efsa foodex2)",
    "NCBITaxon_8467": "Caretta caretta",
    "GAZ_00053798": "Cook Islands",
    "RO_0001022": "has allergic trigger",
    "NCBITaxon_99568": "Curcuma",
    "http://urigen_local_uri/ae920f6d-eda5-40ab-8ec9-c5c08b7649af/Punjabi_Sikh": "Punjabi Sikh",
    "FOODON_03316218": "confectionery chocolate based",
    "NCBITaxon_4265": "Cynara cardunculus",
    "FOODON_03544417": "44170 - vanilla pods extract (efsa foodex2)",
    "FOODON_03302780": "safflower oil",
    "FOODON_03520258": "indian ocean fishing area",
    "FOODON_03413771": "pteroylmonoglutamic acid",
    "FOODON_03414900": "silkmoth",
    "FOODON_00002193": "red kidney bean soup food product",
    "FOODON_03306222": "seasoning salt",
    "FOODON_03414771": "grevillea plant",
    "FOODON_03310640": "corn (dried)",
    "NCBITaxon_8071": "Lophiidae",
    "FOODON_03412801": "fadogiella plant",
    "FOODON_03540446": "04460 - chards (efsa foodex2)",
    "FOODON_03544461": "44610 - other ingredients (efsa foodex2)",
    "FOODON_03412511": "hubbard squash plant",
    "FOODON_03302805": "cantaloupe (whole, raw)",
    "FOODON_03310980": "leafy vegetable (cooked)",
    "FOODON_03411047": "grain or seed-producing plant",
    "FOODON_03316774": "shrimp (raw, lightly breaded, frozen)",
    "FOODON_03413954": "pacific jack mackerel",
    "FOODON_03540030": "00300 - popcorn kernels (efsa foodex2)",
    "FOODON_03304479": "protein flour (blended)",
    "FOODON_03413427": "lavender plant",
    "FOODON_00003051": "arepa (dish)",
    "FOODON_03306585": "barley sprout",
    "FOODON_03544431": "44310 - gelling agent (efsa foodex2)",
    "FOODON_03301083": "fish (frozen)",
    "GAZ_00002646": "Germany",
    "FOODON_03308382": "kipper",
    "FOODON_00002150": "plant root vegetable food product",
    "FOODON_03309913": "snakehead (raw)",
    "FOODON_03305233": "fruit punch",
    "CHEBI_33304": "chalcogen molecular entity",
    "FOODON_03315213": "mango (fresh)",
    "FOODON_03500033": "polyester surface",
    "FOODON_03304649": "sweet green relish",
    "FOODON_03541364": "13640 - horseradish roots spice and similar- (efsa foodex2)",
    "FOODON_00001755": "collard vegetable food product",
    "FOODON_03401403": "10006327 - apple/pear alcoholic beverage - still (gs1 gpc)",
    "NCBITaxon_186747": "Scomberomorini",
    "FOODON_03307407": "coon oyster (raw)",
    "NCBITaxon_216718": "Mentheae",
    "NCBITaxon_1545897": "Centrarchoidei",
    "FOODON_03510093": "no modified food starch added claim or use",
    "FOODON_03401891": "10006165 - tomatoes - round (gs1 gpc)",
    "FOODON_03540583": "05830 - silverskin onions (efsa foodex2)",
    "FOODON_03306764": "cherry pie (baked)",
    "FOODON_03414563": "narwhal",
    "FOODON_03414738": "tanglehead plant",
    "FOODON_03412001": "fox grape plant",
    "FOODON_03414310": "silver perch",
    "FOODON_03541382": "13820 - star anise fruit (efsa foodex2)",
    "FOODON_03543233": "32330 - juice concentrate, blueberry (efsa foodex2)",
    "CHEBI_59549": "essential fatty acid",
    "FOODON_03309649": "cod (semiboneless fillet, raw)",
    "HANCESTRO_0434": "Bahraini",
    "FOODON_03420244": "mammalian milk whey",
    "FOODON_03415052": "flat peach plant",
    "ENVO_01000181": "mangrove biome",
    "FOODON_03401713": "10006160 - feijoas (gs1 gpc)",
    "NCBITaxon_335011": "Etmopterus",
    "FOODON_03540926": "09260 - signet marigold (efsa foodex2)",
    "FOODON_03543325": "33250 - fermented functional drinks (including fermented infusions) (efsa foodex2)",
    "FOODON_03400198": "soup (us cfr)",
    "NCBITaxon_289767": "Semecarpus anacardium",
    "FOODON_03307929": "yam (precooked, frozen)",
    "FOODON_03490207": "capsule",
    "OBI_0000658": "data representational model",
    "FOODON_03301665": "herring (canned)",
    "FOODON_03302420": "ginseng beverage",
    "CHEBI_53423": "polysorbate 40",
    "FOODON_00003255": "mascarpone",
    "NCBITaxon_1489922": "Eupercaria",
    "FOODON_03316837": "vermicelli (egg, vegetable, enriched)",
    "FOODON_03540734": "07340 - turnip-rooted chervil (efsa foodex2)",
    "FOODON_03400670": "003  stone fruits (fs) (ccpr)",
    "FOODON_03540288": "02880 - rhubarb flan (efsa foodex2)",
    "NCBITaxon_55670": "Stevia rebaudiana",
    "FOODON_03311191": "haddock (raw, breaded)",
    "FOODON_03315324": "cereal product (solid)",
    "FOODON_00003044": "basil food product",
    "NCBITaxon_75085": "Rubus phoenicolasius",
    "CHEBI_38104": "oxacycle",
    "FOODON_03414108": "greenland shark",
    "FOODON_03411834": "nile tilapia",
    "FOODON_03301283": "raisin (whole)",
    "FOODON_03440011": "extent of food heat treatment",
    "NCBITaxon_309310": "Ficus thonningii",
    "FOODON_03540371": "03710 - escaroles and similar- (efsa foodex2)",
    "FOODON_03540587": "05870 - persian shallots (efsa foodex2)",
    "FOODON_03540404": "04040 - plantain leaves (efsa foodex2)",
    "FOODON_00001602": "animal product based flavoring or seasoning",
    "NCBITaxon_23207": "Prunus serotina",
    "NCBITaxon_27772": "Coregonus",
    "FOODON_03317032": "fruit juice drink (from extract)",
    "FOODON_03415156": "pussytoes plant",
    "FOODON_03470156": "preservation by adding antibiotics",
    "FOODON_03460393": "acid reduction process",
    "FOODON_03307992": "turbot (raw)",
    "FOODON_03315650": "meat by-product (preserved)",
    "FOODON_03317068": "cake mix",
    "NCBITaxon_60423": "Fagus grandifolia",
    "FOODON_03308253": "chinchard (raw)",
    "FOODON_03542175": "21750 - blood-type sausage (efsa foodex2)",
    "FOODON_03540740": "07400 - small radishes (efsa foodex2)",
    "FOODON_03430139": "food (liquid, high viscosity, with no visible particles)",
    "FOODON_03310654": "rice (boiled)",
    "FOODON_03540517": "05170 - fenugreek sprouts (efsa foodex2)",
    "FOODON_03412826": "obsolete: belwisia",
    "FOODON_00002030": "microbial refined food product",
    "FOODON_03544232": "42320 - chestnut flavour (efsa foodex2)",
    "FOODON_03413218": "potassium polyphosphate",
    "FOODON_00002207": "rice flour food product",
    "NCBITaxon_86306": "Artemisia abrotanum",
    "FOODON_03541479": "14790 - wild pears (efsa foodex2)",
    "NCBITaxon_1204718": "Lateolabracidae",
    "FOODON_03306668": "imitation salad dressing",
    "FOODON_03543109": "31090 - linseed oil (efsa foodex2)",
    "FOODON_03414292": "puffin",
    "FOODON_03490121": "glass container, cork stopper",
    "FOODON_03302032": "taco sauce",
    "FOODON_03401185": "10000199 - dressings/dips (perishable) (gs1 gpc)",
    "FOODON_03544507": "45070 - phytosterols (efsa foodex2)",
    "FOODON_03316332": "gelatinous coating for meat products edible",
    "FOODON_00003342": "fillet",
    "FOODON_03414968": "gandaria plant",
    "FOODON_03301078": "black fungus (food product)",
    "CHEBI_83982": "L-glutamic acid derivative",
    "FOODON_03316243": "spread, low fat",
    "FOODON_03316727": "cheese harzer",
    "FOODON_03401249": "0810000 - spices, seeds (ec)",
    "GAZ_00004435": "State of Kansas",
    "FOODON_03316538": "obsolete: tomato (tinned)",
    "FOODON_03308884": "flying fish (frozen)",
    "FOODON_03412266": "seaweed",
    "FOODON_03303164": "sweet chocolate-coated snap cookie",
    "FOODON_03310802": "licorice-type candy",
    "FOODON_03543831": "38310 - milk imitates (efsa foodex2)",
    "FOODON_03302971": "edam cheese",
    "FOODON_03302045": "blueberry (whole, raw)",
    "FOODON_03315362": "bean paste",
    "FOODON_03316204": "fermentation vinegar",
    "FOODON_03490399": "polyethylene (low density) - polyamide container",
    "FOODON_03413243": "sodium aluminium silicate",
    "FOODON_03301165": "albacore (canned)",
    "FOODON_03308929": "mullet (canned)",
    "FOODON_03414405": "ammonium carbonates",
    "NCBITaxon_1224": "Proteobacteria",
    "FOODON_03316572": "cheese (hard, maturing)",
    "FOODON_03305159": "margarita mix",
    "FOODON_03302374": "scallop (raw)",
    "GAZ_00007120": "Howland Island",
    "FOODON_03541552": "15520 - youngberries (efsa foodex2)",
    "ENVO_01000937": "impromptu campground",
    "FOODON_03302669": "tomato (peeled, canned)",
    "FOODON_03413622": "shiba shrimp",
    "NCBITaxon_4675": "Curculigo",
    "FOODON_03400191": "bakery product (us cfr)",
    "FOODON_03540728": "07280 - angelica roots (efsa foodex2)",
    "NCBITaxon_13450": "Corylus",
    "FOODON_03413109": "glyceryl triacetate (triacetin)",
    "FOODON_03541167": "11670 - eastern black walnuts (efsa foodex2)",
    "FOODON_03401316": "single vitamin and single mineral supplement",
    "FOODON_03411369": "kohlrabi plant",
    "FOODON_03411118": "lake herring",
    "FOODON_03420198": "obsolete: pectin",
    "NCBITaxon_169291": "Phractolaemus ansorgii",
    "FOODON_03401643": "10005782 - rabbit - prepared/processed (gs1 gpc)",
    "FOODON_03540530": "05300 - cauliflowers and similar- (efsa foodex2)",
    "FOODON_03307471": "nonfat dry milk (fortified)",
    "FOODON_03411761": "peruvian sea bass",
    "FOODON_00001329": "tai-pla",
    "FOODON_00002450": "multi-component honey product",
    "FOODON_03411168": "gray snapper",
    "FOODON_03412564": "thai pepper plant",
    "FOODON_03401099": "10000240 - pasta/noodles - ready to eat (perishable) (gs1 gpc)",
    "FOODON_03540424": "04240 - red amaranth leaves (efsa foodex2)",
    "FOODON_03460373": "obsolete: microcrystalline cellulose",
    "FOODON_03411460": "pheasant",
    "FOODON_03544484": "44840 - vitamin d     (cholecalciferol) (efsa foodex2)",
    "FOODON_03413114": "guar gum",
    "FOODON_03306590": "peanut (canned)",
    "FOODON_03541512": "15120 - american plums (efsa foodex2)",
    "FOODON_03310656": "peanut butter (low calorie)",
    "FOODON_03412033": "steinpilz",
    "FOODON_03302920": "curry paste",
    "FOODON_03414976": "palestine sweet lime plant",
    "NCBITaxon_43364": "Aesculus hippocastanum",
    "FOODON_00002821": "kidney food product",
    "HANCESTRO_0286": "Central Asian",
    "FOODON_03308870": "gray snapper (raw)",
    "FOODON_03301258": "water (bottled)",
    "FOODON_03315377": "pea (common, canned)",
    "FOODON_03400645": "b.  primary food commodities of animal origin (ccpr)",
    "FOODON_03414333": "common glasswort plant",
    "FOODON_03316154": "burger meat (minimum vegetable and/or cereal content of 4%)",
    "FOODON_03401415": "10005897 - bananas (gs1 gpc)",
    "NCBITaxon_417012": "Livistoneae",
    "FOODON_03307643": "strawberry pie",
    "FOODON_00002404": "meat roasting",
    "FOODON_03510221": "food allergen labelling about nuts and products thereof",
    "FOODON_03311604": "black currant (whole, raw)",
    "FOODON_03311025": "skim milk (sterilized)",
    "FOODON_03540481": "04810 - chinese cabbages and similar- (efsa foodex2)",
    "NCBITaxon_526618": "Pelotretis flavilatus",
    "FOODON_03302385": "obsolete: orange beverage",
    "NCBITaxon_9090": "Coturnix",
    "FOODON_03309669": "tuna (solid pack, canned in water)",
    "FOODON_03312067": "salami",
    "FOODON_03542262": "22620 - pacu (piaractus mesopotamicus) (efsa foodex2)",
    "CHEBI_25187": "p-menthan-3-ol",
    "FOODON_03401514": "10005881 - ugli (gs1 gpc)",
    "FOODON_03309487": "greengage plum (candied)",
    "CHEBI_39437": "tocol",
    "FOODON_00002153": "plant seed vegetable food product",
    "FOODON_03401734": "10005986 - carobs (gs1 gpc)",
    "FOODON_03490395": "polyethylene (high density) - polyamide container",
    "FOODON_03542909": "29090 - cheese, bleu d'auvergne (efsa foodex2)",
    "FOODON_03306796": "blue plum (canned)",
    "FOODON_03401607": "10005937 - kiwifruits (gs1 gpc)",
    "FOODON_03542539": "25390 - scallop, australian (efsa foodex2)",
    "FOODON_03540443": "04430 - sea lavanders (efsa foodex2)",
    "FOODON_03542532": "25320 - oyster, sydney rock (efsa foodex2)",
    "FOODON_03301941": "cereal grain",
    "FOODON_03316173": "onion pulp",
    "NCBITaxon_203582": "Sisymbrium officinale",
    "NCBITaxon_3536": "Nyctaginaceae",
    "FOODON_03543861": "38610 - fish and seafood based dishes (efsa foodex2)",
    "FOODON_03542184": "21840 - frankfurt-type sausage (efsa foodex2)",
    "FOODON_03460775": "copper added",
    "FOODON_03543574": "35740 - other herbal infusion materials from leaves and herbs (efsa foodex2)",
    "UBERON_0002113": "kidney",
    "NCBITaxon_58885": "Parkinsonia",
    "FOODON_03302104": "confection (made in part from dehydrated beef)",
    "FOODON_03490161": "aluminum tray or pan, cardboard cover",
    "FOODON_03413629": "banana prawn",
    "FOODON_03542401": "24010 - herrings, sardines, anchovies (efsa foodex2)",
    "FOODON_03413440": "bulbous chervil plant",
    "FOODON_03430143": "crystal",
    "NCBITaxon_348708": "Coregonus oxyrinchus",
    "FOODON_03307403": "japanese oyster (raw)",
    "FOODON_03310729": "mirin japanese",
    "FOODON_03301116": "wheat flour",
    "NCBITaxon_9831": "Hippopotamidae",
    "FOODON_03411797": "peruvian croaker",
    "FOODON_03411002": "archaeogastropod",
    "NCBITaxon_381635": "Cirrhinus cirrhosus",
    "FOODON_00001810": "dietetic food product",
    "FOODON_03306023": "lemonade (colored)",
    "FOODON_03311265": "red chili pepper (raw, fresh)",
    "FOODON_03311449": "spice oleoresins",
    "NCBITaxon_9632": "Ursidae",
    "PO_0004709": "axillary bud",
    "FOODON_00002007": "lobster food product",
    "FOODON_03413789": "arctic cod",
    "FOODON_03414514": "choy sum plant",
    "HANCESTRO_0430": "Venezuelan",
    "FOODON_03480031": "packed in nitrogen",
    "FOODON_00002245": "snake meat food product",
    "FOODON_03315815": "flour (white, vitamin b enriched)",
    "FOODON_03305812": "raisin (finely chopped)",
    "NCBITaxon_3839": "Dolichos",
    "FOODON_03316348": "paprika puree",
    "NCBITaxon_1874399": "Boraginoideae",
    "FOODON_03450025": "cooking with added fat or oil",
    "FOODON_03303111": "coffee (instant, freeze-dried)",
    "FOODON_03430144": "food (semisolid)",
    "NCBITaxon_39090": "Phoca largha",
    "FOODON_03305656": "fruit (dried)",
    "FOODON_03540230": "02300 - quark oil dough (efsa foodex2)",
    "FOODON_00001893": "fudge food product",
    "NCBITaxon_8225": "Euthynnus",
    "FOODON_03309527": "herring fillet in lemon-flavored sauce",
    "NCBITaxon_3659": "Cucumis sativus",
    "FOODON_03303826": "raisin butter",
    "FOODON_03303653": "cheddar cheese (wine-cured)",
    "FOODON_00002846": "cream soda",
    "FOODON_03309244": "pollock fillet (skinless, raw)",
    "FOODON_00002973": "Tango apple",
    "FOODON_03542556": "25560 - little cuttle (efsa foodex2)",
    "FOODON_03305524": "brandy snap cookie",
    "CHEBI_64708": "one-carbon compound",
    "FOODON_03415147": "rockrose plant",
    "NCBITaxon_4072": "Capsicum annuum",
    "FOODON_03500020": "enamel surface for meat",
    "FOODON_03542815": "28150 - cheese, esrom (efsa foodex2)",
    "FOODON_03411263": "giant freshwater prawn",
    "FOODON_03543643": "36430 - golden root infusion roots (efsa foodex2)",
    "FOODON_03308371": "louisiana spiny lobster (raw)",
    "NCBITaxon_115666": "Solanum macrocarpon",
    "FOODON_03414102": "long-nosed skate (genus)",
    "FOODON_03316738": "flat fish fillets (quick-frozen)",
    "FOODON_03401390": "50262600 - sugar canes (gs1 gpc)",
    "FOODON_03540548": "05480 - globe artichokes and similar- (efsa foodex2)",
    "FOODON_03542728": "27280 - cream powder (efsa foodex2)",
    "FOODON_03542562": "25620 - squid, common (efsa foodex2)",
    "FOODON_03309084": "pacific halibut (raw)",
    "FOODON_03530223": "amnesic shellfish poisoning",
    "FOODON_03542183": "21830 - weisswurst (efsa foodex2)",
    "FOODON_03460334": "vegetable fat or oil coated",
    "FOODON_03400282": "processed cheese product (us cfr)",
    "FOODON_00002475": "apple pie",
    "FOODON_03414631": "mud mussel",
    "FOODON_03303207": "couscous",
    "FOODON_03543650": "36500 - seneca snakeroot infusion roots (efsa foodex2)",
    "FOODON_03305191": "ginseng liquor",
    "NCBITaxon_129068": "Strongylura marina",
    "FOODON_03542552": "25520 - cockles (efsa foodex2)",
    "FOODON_03412002": "century plant",
    "FOODON_03543277": "32770 - water based beverages (efsa foodex2)",
    "FOODON_03542176": "21760 - miscellaneous cooked sausages (efsa foodex2)",
    "NCBITaxon_103349": "Vitis rotundifolia",
    "FOODON_03316011": "spirits with not more than 15% alcohol",
    "FOODON_03311323": "black walnut (ground)",
    "FOODON_03543177": "31770 - other fruit juices (efsa foodex2)",
    "FOODON_03542649": "26490 - milk and dairy products (efsa foodex2)",
    "FOODON_03317299": "braunschweiger",
    "FOODON_00001922": "grape based alcoholic beverage",
    "FOODON_03414156": "african buffalo",
    "FOODON_03412950": "hyssop plant",
    "FOODON_03520124": "fishing area",
    "FOODON_03307581": "honey cake",
    "FOODON_03308168": "spanish lobster (raw)",
    "FOODON_03541126": "11260 - canarium nuts (indicum) (efsa foodex2)",
    "FOODON_03542341": "23410 - yellowfin sole (efsa foodex2)",
    "FOODON_03309269": "sand sole (raw)",
    "FOODON_03301580": "plum (whole, raw)",
    "FOODON_03540326": "03260 - rye porridge (efsa foodex2)",
    "NCBITaxon_29960": "Penaeus indicus",
    "PECO_0007033": "rabi season exposure",
    "FOODON_00002982": "hass avocado",
    "FOODON_03303648": "candy (nutritively and nonnutritively sweetened)",
    "FOODON_03401785": "10006752 - ready-made combination meals - ready to eat (shelf stable) (gs1 gpc)",
    "FOODON_03400747": "042  marine fish (ws) (ccpr)",
    "FOODON_03317572": "bagaceira velha",
    "FOODON_03412274": "spotted stargazer",
    "FOODON_03412515": "ajowan plant",
    "FOODON_00000000": "foodon ontology data specification",
    "FOODON_03316806": "half-and-half (sour, acidified)",
    "FOODON_03543065": "30650 - caramel, hard (efsa foodex2)",
    "FOODON_03543673": "36730 - cocoa (infusion husks) (efsa foodex2)",
    "NCBITaxon_84619": "Ammodytidae",
    "FOODON_03301263": "olive (salad, pitted, broken)",
    "FOODON_03317214": "cheese product (processed)",
    "FOODON_03308608": "oriental blue crab (raw)",
    "FOODON_03400217": "meat, poultry, seafood or related product (us cfr)",
    "FOODON_00001002": "food product",
    "FOODON_00002853": "Granny Smith apple",
    "FOODON_03311123": "Chablis wine",
    "FOODON_03304209": "chicken noodle soup (condensed)",
    "FOODON_03543736": "37360 - elderflowers infusion (efsa foodex2)",
    "CHEBI_23341": "cobamides",
    "FOODON_03544039": "40390 - corn chips (efsa foodex2)",
    "FOODON_03530203": "fat content < 50%, < 35% pufa",
    "FOODON_03311424": "bean (frozen)",
    "FOODON_03310384": "olive meal",
    "FOODON_03308405": "fish fillet (breaded, precooked)",
    "FOODON_00003439": "rutabaga food product",
    "FOODON_03541498": "14980 - capulins (efsa foodex2)",
    "FOODON_03541907": "19070 - turkey msm (efsa foodex2)",
    "FOODON_03400415": "flour treatment agent (codex)",
    "FOODON_03310070": "peppercorn",
    "FOODON_03541556": "15560 - arctic brambles (efsa foodex2)",
    "FOODON_03543592": "35920 - cornflower infusion flowers (efsa foodex2)",
    "FOODON_03303349": "soy protein granules",
    "FOODON_03311577": "soup (japanese style)",
    "FOODON_03304943": "chicken-flavored soup mix",
    "BFO_0000035": "process boundary",
    "FOODON_03303180": "pear preserves",
    "FOODON_03303772": "chocolate (vitamin-fortified)",
    "FOODON_03304520": "imitation orgeat syrup",
    "FOODON_03412786": "senegal date palm plant",
    "NCBITaxon_74900": "Allium schoenoprasum",
    "FOODON_03480043": "packed in cream or milk",
    "HANCESTRO_0415": "Mexican",
    "NCBITaxon_29780": "Mangifera indica",
    "FOODON_03304688": "linden tea (dry)",
    "FOODON_03309606": "canadian sardine (raw)",
    "NCBITaxon_66718": "Paralichthys dentatus",
    "FOODON_03490217": "three-part can",
    "FOODON_03303667": "leicester cheese",
    "FOODON_03413834": "rat-tail anchovy",
    "FOODON_03308105": "alewife (raw)",
    "FOODON_03540220": "02200 - choux pastry dough (efsa foodex2)",
    "FOODON_03411229": "horse",
    "FOODON_03540090": "00900 - graham flour (efsa foodex2)",
    "FOODON_03401325": "obsolete: dietary supplement, combination, other",
    "FOODON_03412929": "salacia plant",
    "FOODON_03306506": "poultry sausage (food product)",
    "NCBITaxon_7844": "Lamninae",
    "NCBITaxon_4437": "Plumbaginaceae",
    "FOODON_03316974": "fig (preserved, canned)",
    "FOODON_03412251": "green jack",
    "FOODON_00001300": "unpasteurized milk beverage",
    "FOODON_03401635": "10005777 - llama/alpaca - prepared/processed (gs1 gpc)",
    "NCBITaxon_59687": "Sardinops neopilchardus",
    "FOODON_03411319": "sucker",
    "FOODON_03301641": "rice grain food product",
    "FOODON_03301151": "mussel (canned)",
    "FOODON_03309133": "white trevally (raw)",
    "NCBITaxon_4233": "Helianthus tuberosus",
    "FOODON_03490142": "paperboard container with laminate liner",
    "FOODON_03316284": "horseradish",
    "NCIT_C14238": "Mouse",
    "PATO_0001694": "decreased viscosity",
    "NCBITaxon_462873": "Galium verum",
    "NCBITaxon_83716": "Grevillea",
    "FOODON_03542524": "25240 - freshwater molluscs (efsa foodex2)",
    "FOODON_03301023": "honey (black)",
    "NCBITaxon_40128": "Donacidae",
    "FOODON_00001732": "chive food product",
    "FOODON_03315410": "fruit yogurt (reduced fat or skim milk)",
    "FOODON_03412903": "lookdown dory",
    "FOODON_03413171": "neohesperidine dc",
    "FOODON_03302308": "roll or bun (enriched)",
    "FOODON_03301526": "pepper (ground)",
    "GAZ_00012579": "Sint Maarten",
    "FOODON_03544376": "43760 - sour cream cherry flavour (efsa foodex2)",
    "FOODON_03540242": "02420 - biscuits, oat meal (efsa foodex2)",
    "FOODON_03400401": "dough conditioner (codex)",
    "FOODON_03310848": "gelatin dessert mix artificially-flavored and -colored",
    "FOODON_00001619": "asian water buffalo meat food product",
    "NCBITaxon_147387": "Poeae",
    "FOODON_03305467": "grape beverage (fermented)",
    "FOODON_03541508": "15080 - nectarines (efsa foodex2)",
    "FOODON_03540897": "08970 - rice paddy herb (efsa foodex2)",
    "FOODON_03413830": "striped anchovy",
    "FOODON_03420274": "obsolete: whole egg",
    "FOODON_03401676": "10005800 - pork - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03304108": "chicken (whole, uncooked, frozen)",
    "FOODON_03544180": "41800 - flavourings (efsa foodex2)",
    "FOODON_03305826": "beef suet (raw)",
    "FOODON_03309731": "brewers maize",
    "PATO_0045053": "normal height",
    "NCBITaxon_670802": "Ponticolini",
    "FOODON_03307056": "sugar (lump)",
    "CHEBI_53550": "poly(propylene)",
    "FOODON_03301937": "petit four",
    "FOODON_03304944": "kangaroo tail soup",
    "FOODON_03310351": "butter",
    "FOODON_03308999": "thornyhead (raw)",
    "FOODON_03414052": "pollan",
    "CHEBI_25903": "peptide antibiotic",
    "FOODON_03411265": "ginger plant",
    "FOODON_00001198": "broad bean (whole, dried)",
    "CHEBI_33854": "aromatic alcohol",
    "FOODON_03400663": "15  manufactured foods (multi-ingredient) of plant origin (ccpr)",
    "FOODON_03413745": "cocktail tomato plant",
    "FOODON_03543698": "36980 - seeds (coffee, cocoa and similar) used for infusions or hot drinks (efsa foodex2)",
    "FOODON_00002221": "salt product",
    "FOODON_03315535": "fish product (alkali-treated)",
    "NCBITaxon_27602": "Balaena mysticetus",
    "FOODON_03302358": "breading mix for frying",
    "FOODON_03301333": "herb jelly",
    "FOODON_03309043": "delta crayfish (raw)",
    "NCBITaxon_161925": "Penaeus latisulcatus",
    "FOODON_03306867": "peanut butter",
    "NCBITaxon_2786": "Porphyra umbilicalis",
    "FOODON_03317224": "cod roe fully preserved",
    "FOODON_03543329": "33290 - powdered drink bases (efsa foodex2)",
    "FOODON_03543751": "37510 - infant formula, milk-based, powder (efsa foodex2)",
    "FOODON_03450037": "food reheating",
    "FOODON_03541665": "16650 - bilimbis (efsa foodex2)",
    "FOODON_03310860": "tender wheat (raw)",
    "FOODON_03310988": "peanut (shell off, flour-coated)",
    "FOODON_03401468": "10006196 - romanesco (gs1 gpc)",
    "FOODON_03412038": "corinth grape plant",
    "FOODON_03540907": "09070 - tarragon (efsa foodex2)",
    "FOODON_03309671": "oyster stew base",
    "NCBITaxon_182854": "Dipturus oxyrinchus",
    "FOODON_03305360": "chicken gravy mix",
    "FOODON_03316184": "grape juice (concentrated for home wine making)",
    "FOODON_03543584": "35840 - almond infusion flowers (efsa foodex2)",
    "FOODON_03304924": "beef noodle soup",
    "NCBITaxon_30948": "Soleidae",
    "FOODON_03309417": "garlic oil",
    "FOODON_03304889": "tomato pomace",
    "FOODON_03316370": "snack (grain-based)",
    "FOODON_03541306": "13060 - dill seed (efsa foodex2)",
    "FOODON_03311356": "pole bean pod",
    "FOODON_03400277": "distilled spirits (us cfr)",
    "FOODON_03541945": "19450 - llama or lama fresh meat (efsa foodex2)",
    "FOODON_03510183": "enriched claim or use",
    "CHEBI_39025": "high-density lipoprotein",
    "FOODON_03311450": "cake frozen aspartame sweetened",
    "FOODON_03541305": "13050 - dill seed and similar- (efsa foodex2)",
    "FOODON_03412452": "radicchio plant",
    "NCBITaxon_8157": "Carangidae",
    "FOODON_00001261": "vegetable food product",
    "FOODON_03311065": "red snapper (smoked)",
    "FOODON_03543670": "36700 - china (infusion bark) (efsa foodex2)",
    "NCBITaxon_191678": "Lophius budegassa",
    "FOODON_03310113": "ryegrass",
    "FOODON_03309208": "milker herring",
    "FOODON_03303375": "egg roll",
    "FOODON_03304701": "kefir (lowfat)",
    "FOODON_03401579": "10006198 - curled parsley (gs1 gpc)",
    "FOODON_03543161": "31610 - juice, mixed fruit (efsa foodex2)",
    "FOODON_00002157": "plant sweetener",
    "FOODON_03412406": "bear",
    "FOODON_03303604": "chocolate fudge topping",
    "FOODON_03412018": "pummelo plant",
    "FOODON_03310574": "tea made from instant mix",
    "FOODON_03308895": "persian grouper (raw)",
    "FOODON_03543541": "35410 - silverweed infusion leaves (efsa foodex2)",
    "NCBITaxon_137456": "Sanguisorba minor",
    "FOODON_03540383": "03830 - roman rocket (efsa foodex2)",
    "NCBITaxon_1489388": "Euteleosteomorpha",
    "NCBITaxon_96887": "Sardinella fimbriata",
    "FOODON_03413859": "short-body sardinella",
    "FOODON_03302847": "cherry fruit filling (artificially sweetened)",
    "FOODON_03543232": "32320 - juice concentrate, blackberry (efsa foodex2)",
    "NCBITaxon_6774": "Portunoidea",
    "FOODON_03304167": "shortening (hydrogenated)",
    "HANCESTRO_0539": "Mosotho",
    "NCBITaxon_338571": "Amaranthus blitum",
    "FOODON_03401115": "10000217 - jams/marmalades (shelf stable) (gs1 gpc)",
    "FOODON_03306903": "peanut butter (creamy)",
    "FOODON_03302864": "johnnycake",
    "FOODON_03400306": "nut or seed product (us cfr)",
    "CHEBI_28383": "alpha,omega-dicarboxylic acid",
    "FOODON_03316451": "dessert (aerated)",
    "FOODON_03411175": "chard plant",
    "NCBITaxon_319755": "Ophidion scrippsae",
    "GO_0045333": "cellular respiration",
    "FOODON_00002392": "Huangjiu",
    "FOODON_03414515": "tatsoi plant",
    "FOODON_03530293": "shank (meat)",
    "FOODON_03309149": "porgy fillet (raw)",
    "FOODON_03309355": "triticale pancake",
    "FOODON_03317595": "specialty meat stew",
    "FOODON_03306613": "beverage (nutritively and nonnutritively sweetened)",
    "CHEBI_33958": "halide salt",
    "NCBITaxon_304449": "Parachanna obscura",
    "FOODON_03401121": "10000289 - vegetable based products / meals - ready to eat (perishable) (gs1 gpc)",
    "FOODON_03411062": "temperate-zone nut producing plant",
    "FOODON_03544015": "40150 - mixed vegetables soup, with puree or pieces (efsa foodex2)",
    "FOODON_03316229": "beverage powder for home preparation of drinks",
    "NCBITaxon_6459": "Haliotis walallensis",
    "FOODON_03541077": "10770 - navy beans (dry seeds) (efsa foodex2)",
    "FOODON_03309155": "tarakihi (raw)",
    "FOODON_03401165": "50170000 - seasonings/preservatives/extracts (gs1 gpc)",
    "BFO_0000148": "zero-dimensional temporal region",
    "NCBITaxon_3715": "Brassica oleracea var. botrytis",
    "FOODON_03305738": "grape juice (frozen concentrate)",
    "FOODON_03301671": "cranberry juice",
    "NCBITaxon_263718": "Squatina squatina",
    "FOODON_03510264": "qualified health claim",
    "FOODON_03415021": "american chestnut tree",
    "FOODON_03310498": "octopus (raw)",
    "FOODON_03317230": "corn grits (quick)",
    "PATO_0001317": "severe increased temperature",
    "GAZ_00004428": "State of New Hampshire",
    "FOODON_00002419": "food evaporation process",
    "FOODON_03415115": "redvein dock plant",
    "FOODON_03315701": "fish (frozen, comminuted)",
    "NCBITaxon_57943": "Alchemilla alpina",
    "NCBITaxon_349645": "Pseudocaranx",
    "FOODON_03543222": "32220 - juice, apple-carrot (efsa foodex2)",
    "FOODON_00002376": "food seasoning product",
    "FOODON_03306400": "grapefruit marmalade (food product)",
    "CHEBI_79020": "alpha,beta-unsaturated monocarboxylic acid",
    "FOODON_03305144": "rainbow trout (frozen)",
    "FOODON_03302761": "fruitcake (containing alcohol)",
    "FOODON_03302726": "chili seed oil",
    "GAZ_00004429": "State of Vermont",
    "NCBITaxon_112728": "Polyprion americanus",
    "NCBITaxon_117921": "Etmopteridae",
    "FOODON_03303173": "cocoa (dutch-processed)",
    "FOODON_03542982": "29820 - sugar and other sweetening ingredients (excluding intensive sweeteners) (efsa foodex2)",
    "CHEBI_16966": "heteroglycan",
    "FOODON_00002142": "plant head vegetable food product",
    "FOODON_00002820": "kidney bean substance",
    "FOODON_03310447": "goat milk cheese (marinated in olive oil)",
    "FOODON_03400327": "anticaking agent (ec)",
    "FOODON_03305196": "ginseng tea (dry)",
    "FOODON_03411261": "fungus",
    "FOODON_03303889": "soft drink concentrate",
    "FOODON_03460198": "debittering process",
    "FOODON_03304470": "lowfat cow milk (fortified)",
    "GAZ_00002476": "Israel",
    "FOODON_03302696": "bread (reduced calorie)",
    "FOODON_03510112": "no sulfite added claim or use",
    "FOODON_03309726": "wine cooler popsicle",
    "FOODON_03306966": "noodle (frozen)",
    "FOODON_03301888": "obsolete: gluten",
    "FOODON_03316430": "fruit syrup calorie-reduced",
    "FOODON_03401677": "10006291 - quail - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03541057": "10570 - lentils (without pods) (efsa foodex2)",
    "FOODON_03411816": "wolffish family",
    "FOODON_03543110": "31100 - pumpkin seed oil (efsa foodex2)",
    "FOODON_03540409": "04090 - taro leaves (efsa foodex2)",
    "FOODON_03544418": "44180 - orange essence (efsa foodex2)",
    "FOODON_03542360": "23600 - blue whitings (efsa foodex2)",
    "FOODON_03305671": "ice cream novelty",
    "FOODON_03315132": "multivitamin preparation, liquid",
    "FOODON_03311121": "white rice (raw)",
    "FOODON_03413587": "arafura lobster",
    "FOODON_00002707": "food cleaning process",
    "FOODON_03415132": "roseroot stonecrop plant",
    "HANCESTRO_0525": "Burkinabe",
    "FOODON_03305534": "honey jelly",
    "FOODON_00002260": "soybean based meat product analog",
    "FOODON_03304551": "rice buds",
    "NCBITaxon_349649": "Auxis rochei rochei",
    "FOODON_03541481": "14810 - quinces and similar- (efsa foodex2)",
    "FOODON_03543059": "30590 - marzipan (efsa foodex2)",
    "FOODON_03530288": "brown skin",
    "FOODON_03401356": "50350500 - spinach (fresh) (gs1 gpc)",
    "HANCESTRO_0014": "Hispanic or Latin American",
    "FOODON_03401097": "10000317 - pasta/noodles - not ready to eat (perishable) (gs1 gpc)",
    "NCBITaxon_120427": "Ensis ensis",
    "FOODON_03542644": "26440 - dried seafood (efsa foodex2)",
    "FOODON_03310759": "wine (sparkling)",
    "CHEBI_32063": "propylparaben",
    "FOODON_03307968": "cisco (smoked)",
    "NCBITaxon_34585": "Mopaliidae",
    "FOODON_03542845": "28450 - cheese, raclette (efsa foodex2)",
    "NCBITaxon_9688": "Panthera",
    "FOODON_03310229": "burdock root tea (dry)",
    "CHEBI_26932": "tetrapyrrole",
    "FOODON_03308431": "atlantic thread herring (raw)",
    "FOODON_03540834": "08340 - angelica (leaves and stems) (efsa foodex2)",
    "FOODON_03311634": "kale greens (canned)",
    "FOODON_03414225": "muskmelon, crossbred varieties (plant)",
    "FOODON_03543681": "36810 - horse-chestnut (infusion seeds, bark) (efsa foodex2)",
    "FOODON_03414475": "narrowleaf cattail plant",
    "FOODON_03414553": "pink oyster mushroom",
    "FOODON_03543923": "39230 - doner kebab (efsa foodex2)",
    "NCBITaxon_8795": "Pterocnemia pennata",
    "FOODON_03542334": "23340 - halibut, atlantic (efsa foodex2)",
    "FOODON_03542739": "27390 - skyr (efsa foodex2)",
    "FOODON_03541812": "18120 - jam, gooseberries (efsa foodex2)",
    "FOODON_03401343": "50251600 - passionfruits (gs1 gpc)",
    "FOODON_03412923": "pseudospondias plant",
    "FOODON_03308014": "groper (raw)",
    "FOODON_03412523": "red kuri squash plant",
    "NCBITaxon_82528": "Crocus sativus",
    "FOODON_03541670": "16700 - malayan mombins (efsa foodex2)",
    "FOODON_03540825": "08250 - aromatic herbs (efsa foodex2)",
    "FOODON_03412952": "lovage plant",
    "FOODON_03305044": "pudding (instant)",
    "FOODON_03400934": "10000069 - baking/cooking supplies (perishable) (gs1 gpc)",
    "FOODON_03306140": "soursop leaf tea (dry)",
    "FOODON_03430159": "edible capsule",
    "FOODON_03542443": "24430 - dolphinfishes (efsa foodex2)",
    "NCBITaxon_1137871": "Herniaria hirsuta",
    "FOODON_03543989": "39890 - dairy/egg soup, dry (efsa foodex2)",
    "FOODON_03305165": "breadnut tree seed",
    "FOODON_03540305": "03050 - lebkuchen (efsa foodex2)",
    "FOODON_03311576": "bean soup",
    "FOODON_03307707": "smelt (raw)",
    "FOODON_03316719": "potato (french-fried, quick-frozen)",
    "FOODON_03307286": "obsolete: tap water",
    "FOODON_03400261": "egg or egg product (us cfr)",
    "FOODON_03543239": "32390 - juice concentrate, mandarin (efsa foodex2)",
    "FOODON_03307229": "walnut juice",
    "FOODON_03541347": "13470 - other bark spices (efsa foodex2)",
    "FOODON_03317019": "casein, edible",
    "FOODON_00002503": "cocoa flavanol",
    "FOODON_03310674": "fruit drink",
    "FOODON_03542705": "27050 - traditional sour milk products (efsa foodex2)",
    "FOODON_03315658": "head cheese",
    "FOODON_03308581": "kegani crab (raw)",
    "NCBITaxon_8260": "Platichthys flesus",
    "FOODON_03401843": "10006452 - antroewa (gs1 gpc)",
    "GAZ_00001096": "Namibia",
    "IAO_0000300": "textual entity",
    "ENVO_00003927": "stable manure",
    "FOODON_03305663": "orange juice (pasteurized)",
    "FOODON_03308666": "shrimp (wet-pack, canned)",
    "FOODON_03414246": "manchurian wild rice plant",
    "ENVO_01001477": "liquid astronomical body part",
    "FOODON_03301690": "poil de carotte cheese",
    "FOODON_00001985": "kelp food product",
    "NCBITaxon_8830": "Anatidae",
    "FOODON_03316148": "semihard cheese",
    "FOODON_03412576": "oreo dory family",
    "FOODON_03306107": "lingonberry jam",
    "NCBITaxon_36622": "Chaenomeles sinensis",
    "PATO_0045056": "normal anterior-posterior diameter",
    "FOODON_03309857": "peanut oil",
    "FOODON_03412310": "betel plant",
    "FOODON_03541906": "19060 - goose msm (efsa foodex2)",
    "FOODON_00001144": "yeast food product",
    "GAZ_00003730": "Province (Indonesia)",
    "FOODON_03310084": "quiche with imitation bacon bits",
    "FOODON_03414505": "scallop squash plant",
    "FOODON_03414965": "plumcot plant",
    "FOODON_03490339": "tissue paper container",
    "FOODON_03308654": "shellfish (cooked, frozen)",
    "HANCESTRO_0502": "Vietnamese",
    "FOODON_03310903": "crab salad (dish)",
    "FOODON_03304189": "pepper pot soup with meat",
    "FOODON_03400823": "nut, seed or kernel (eurofir)",
    "FOODON_03530187": "fat content > 3%",
    "FOODON_03400925": "10000266 - stimulants/energy drinks - ready to drink (gs1 gpc)",
    "FOODON_03305963": "prickly pear jelly",
    "FOODON_03308084": "river sardine (raw)",
    "FOODON_00003143": "bulgur",
    "FOODON_00003124": "squashberry (whole, raw)",
    "FOODON_03301514": "cheese (unpasteurized)",
    "FOODON_03310414": "obsolete: water as food product",
    "FOODON_03303673": "pasteurized process cheese spread flavored with grape pits",
    "FOODON_03540227": "02270 - phyllo dough (efsa foodex2)",
    "FOODON_03540898": "08980 - thai basil (efsa foodex2)",
    "FOODON_03411005": "stem or spear vegetable",
    "FOODON_03414157": "european roe deer",
    "FOODON_03542568": "25680 - sea-squirts and other tunicates (efsa foodex2)",
    "NCBITaxon_1211602": "Prunus cerasifera var. pissardii",
    "FOODON_00001571": "corn stover",
    "NCBITaxon_97158": "Latridae",
    "FOODON_03304020": "hamburger sauce",
    "FOODON_03430106": "finely ground",
    "NCBITaxon_8127": "Oreochromis mossambicus",
    "NCBITaxon_30996": "Schilbeidae",
    "FOODON_03543150": "31500 - traditional margarine (efsa foodex2)",
    "FOODON_03460180": "obsolete: food added",
    "FOODON_03309468": "deer meat steak (chopped, raw)",
    "FOODON_03415125": "clubmoss plant",
    "FOODON_03411482": "natal plum plant",
    "FOODON_03401404": "10006433 - annona other (gs1 gpc)",
    "FOODON_03304803": "imitation fried chicken with gravy",
    "FOODON_03543195": "31950 - fruit nectars (min. 25-50% fruit as defined in eu legislation) (efsa foodex2)",
    "FOODON_03305062": "beef bouillon (granulated)",
    "PO_0025335": "phyllode leaf",
    "FOODON_03401095": "50192900 - pasta/noodles  (gs1 gpc)",
    "FOODON_03412709": "thickback sole",
    "FOODON_03541063": "10630 - other legume vegetables (efsa foodex2)",
    "FOODON_03413399": "yellow guinea yam plant",
    "FOODON_03415045": "bourbon vanilla plant",
    "FOODON_00002485": "peach (whole or parts)",
    "FOODON_03317183": "fungi (edible, dried)",
    "FOODON_03401448": "10005918 - table grapes (gs1 gpc)",
    "FOODON_00001969": "imitation fruit preserve or jam food product",
    "FOODON_03411354": "sand lance",
    "FOODON_03305676": "obsolete: sweetener (artificial)",
    "FOODON_03412947": "zedoary plant",
    "FOODON_03307812": "fenugreek seed",
    "FOODON_03412502": "green algae",
    "FOODON_03543287": "32870 - fruit soft drink, grapefruit (efsa foodex2)",
    "FOODON_03413528": "night shark",
    "FOODON_03316702": "cocoa nib",
    "FOODON_03302318": "cinnamon roll",
    "FOODON_03490114": "ceramic or earthenware bottle",
    "FOODON_00002317": "tomato soup food product",
    "FOODON_03510040": "reduced fat food",
    "FOODON_03541645": "16450 - doum palm fruits (efsa foodex2)",
    "NCBITaxon_9774": "Sirenia",
    "FOODON_03303139": "swiss-style cream cookie",
    "FOODON_03530021": "chuck",
    "FOODON_03542083": "20830 - pig heart (efsa foodex2)",
    "FOODON_03413154": "mixed carotenes",
    "FOODON_00002753": "bean (whole)",
    "FOODON_03316863": "cheese (muenster, for manufacturing)",
    "FOODON_03303678": "creole cheese (creamed)",
    "FOODON_03316007": "fruit concentrate liquid",
    "FOODON_00001153": "round melon (cucumis melo) fruit food product",
    "FOODON_03543130": "31300 - goose fat, processed (efsa foodex2)",
    "FOODON_03309494": "cherry nectar (food product)",
    "NCBITaxon_8556": "Varanus",
    "FOODON_03401297": "pancake or waffle (eurofir)",
    "FOODON_03544086": "40860 - condiments (including table-top formats) (efsa foodex2)",
    "FOODON_03306265": "hen egg liquid (pasteurized, frozen)",
    "FOODON_03411826": "pike family",
    "FOODON_03415134": "miracle fruit",
    "FOODON_03541146": "11460 - macadamias (efsa foodex2)",
    "FOODON_03401178": "10000180 - chutneys/relishes (shelf stable) (gs1 gpc)",
    "FOODON_00002278": "stone fruit juice",
    "FOODON_03542667": "26670 - mouflon (farmed) milk (efsa foodex2)",
    "FOODON_03304042": "cheese sauce",
    "FOODON_03541296": "12960 - celery seed and similar- (efsa foodex2)",
    "FOODON_03415075": "cluster mallow plant",
    "CHEBI_24838": "inorganic phosphate",
    "FOODON_03541632": "16320 - riberries (efsa foodex2)",
    "FOODON_03316423": "egg substitute based on milk protein",
    "UBERON_0008897": "fin",
    "FOODON_03307327": "perch (raw)",
    "FOODON_03530230": "hazard 2",
    "FOODON_03311200": "reconstituted orange juice (pasteurized, from frozen concentrate)",
    "FOODON_03302844": "pumpkin and pecan cake",
    "FOODON_03308102": "atlantic herring (raw)",
    "FOODON_00001173": "plant seed food product",
    "FOODON_03316441": "fish (semi-preserved)",
    "CHEBI_26421": "pyridines",
    "NCBITaxon_630221": "Cyprinus carpio carpio",
    "CHEBI_37585": "sodium dihydrogenphosphate",
    "FOODON_03542214": "22140 - carps, barbels and other cyprinids (efsa foodex2)",
    "FOODON_03304461": "soy malt high protein powder",
    "NCBITaxon_685122": "Dicroglossidae",
    "NCBITaxon_58220": "Decapterus maruadsi",
    "NCBITaxon_8509": "Squamata",
    "FOODON_03412068": "field mustard plant",
    "FOODON_03401171": "10000580 - stock/bones (frozen) (gs1 gpc)",
    "FOODON_03302570": "imitation lime juice",
    "FOODON_03541163": "11630 - pistachios and similar- (efsa foodex2)",
    "FOODON_03480023": "packed in sweetened liquid",
    "FOODON_03543049": "30490 - candies (soft and hard) (efsa foodex2)",
    "FOODON_03301102": "orange juice solids",
    "FOODON_03309793": "fruit juice drink (carbonated)",
    "FOODON_03316082": "malt dairy based drink",
    "FOODON_03301113": "obsolete: sausage (raw)",
    "FOODON_03310987": "liver (cooked)",
    "FOODON_03400293": "soft candy (us cfr)",
    "FOODON_03311597": "wood apple cream (canned)",
    "FOODON_03310587": "pizza (beef)",
    "FOODON_03520394": "french southern territories",
    "FOODON_03310471": "peanut meal (ammoniated)",
    "FOODON_03544522": "45220 - other edible ingredients from animal and plant commodities (efsa foodex2)",
    "FOODON_03411205": "squid",
    "GAZ_00002525": "Suriname",
    "FOODON_03308636": "imitation scallop (breaded)",
    "FOODON_03304227": "shrimp curry (dish)",
    "FOODON_03305743": "apple juice (concentrated, sweetened)",
    "CHEBI_33582": "carbon group molecular entity",
    "CHEBI_32988": "amide",
    "FOODON_03542849": "28490 - cheese, sao jorge (efsa foodex2)",
    "FOODON_03307921": "vinegar (instant)",
    "FOODON_00002688": "food (boiled)",
    "FOODON_03413748": "red onion plant",
    "CHEBI_33671": "heteropolycyclic compound",
    "NCBITaxon_7829": "Scyliorhinus",
    "FOODON_00002552": "triticale food product",
    "FOODON_03310303": "castor bean (whole)",
    "HANCESTRO_0565": "Split founder",
    "FOODON_03490426": "peel-off lid",
    "FOODON_03315756": "hop extract",
    "FOODON_03541069": "10690 - beans (dry) and similar- (efsa foodex2)",
    "FOODON_03308176": "burger's spiny lobster (raw)",
    "ECOCORE_00000016": "fungivory",
    "FOODON_00003283": "citrus fruit zest",
    "HANCESTRO_0569": "Talana",
    "FOODON_03542332": "23320 - yellowtail flounder (efsa foodex2)",
    "FOODON_03310623": "pork sausage (raw)",
    "FOODON_03304608": "wheat bran",
    "NCBITaxon_8851": "Anseranas semipalmata",
    "FOODON_03540549": "05490 - globe artichokes (efsa foodex2)",
    "FOODON_03543390": "33900 - gin (efsa foodex2)",
    "FOODON_03306180": "coconut milk (concentrated)",
    "FOODON_03411908": "shiner",
    "FOODON_03302982": "cream cheese (french-type)",
    "FOODON_03541803": "18030 - dried mangoes (efsa foodex2)",
    "FOODON_03316476": "fruit marinade",
    "FOODON_03540168": "01680 - gluten free bread, brown (efsa foodex2)",
    "FOODON_00002462": "pan frying",
    "FOODON_03542203": "22030 - pig meat, dried (efsa foodex2)",
    "FOODON_00003224": "ucuhuba seed oil",
    "FOODON_03544419": "44190 - lemon essence (efsa foodex2)",
    "FOODON_03540880": "08800 - apple mint (efsa foodex2)",
    "NCBITaxon_1446378": "Araucariales",
    "FOODON_03307730": "sorghum-flavored syrup",
    "FOODON_03311075": "breakfast cereal",
    "HANCESTRO_0004": "ancestry category",
    "FOODON_03411317": "cockle",
    "FOODON_03414175": "spring mushroom",
    "FOODON_03541187": "11870 - sunflower seeds (efsa foodex2)",
    "FOODON_03310022": "soybean-koji",
    "FOODON_03315173": "fish product (unspecified species)",
    "NCBITaxon_47309": "Proterorhinus",
    "FOODON_03542194": "21940 - liver based spreadable-textured specialities (efsa foodex2)",
    "FOODON_03414917": "ostrich fern plant",
    "FOODON_03540889": "08890 - asiatic pennywort (efsa foodex2)",
    "FOODON_00001067": "buttermilk food product",
    "NCBITaxon_107245": "Lepidopus caudatus",
    "RO_0002234": "has output",
    "FOODON_03309003": "tuna (white, solid pack, canned in water)",
    "FOODON_03306046": "cinnamon jelly",
    "FOODON_03315890": "oil topping mix",
    "FOODON_03302404": "kava beer (food product)",
    "UBERON_0002106": "spleen",
    "FOODON_03401017": "obsolete: 10000013 - meat/poultry/game/batrachian - prepared/processed (frozen) (gs1 gpc)",
    "FOODON_03542826": "28260 - cheese, lancashire (efsa foodex2)",
    "CHEBI_25900": "aldopentose phosphate",
    "FOODON_03413907": "african weakfish",
    "FOODON_03412154": "south american catfish",
    "FOODON_03315913": "topping for fine bakery goods",
    "FOODON_03542079": "20790 - bovine tail (efsa foodex2)",
    "FOODON_03543798": "37980 - carbohydrate-electrolyte solutions for sports people (efsa foodex2)",
    "FOODON_03308173": "painted spiny lobster (raw)",
    "FOODON_03304866": "papaya syrup concentrate",
    "HANCESTRO_0361": "Faroese",
    "FOODON_03401520": "10006450 - crooked cucumber (gs1 gpc)",
    "FOODON_03543358": "33580 - perry (efsa foodex2)",
    "FOODON_03309625": "tuna (light meat, raw)",
    "FOODON_03307531": "asadero cheese",
    "FOODON_03301308": "tonka bean (raw)",
    "FOODON_03510231": "food allergen labelling about carrot and products thereof",
    "FOODON_03316889": "berry (quick-frozen)",
    "FOODON_03412343": "golden king crab",
    "FOODON_03430121": "food (liquid, high viscosity, with small particles)",
    "FOODON_03308067": "fish spread",
    "FOODON_03310703": "tomato herb sauce",
    "NCBITaxon_160730": "Mycteroperca phenax",
    "FOODON_00002929": "ground chuck",
    "FOODON_03411430": "argentine",
    "FOODON_03310751": "Rhine wine",
    "FOODON_03301214": "tarragon (dried)",
    "FOODON_03400940": "10000596 - biscuits/cookies variety packs (gs1 gpc)",
    "FOODON_03310704": "apple and grape drink",
    "FOODON_03412870": "pond smelt",
    "FOODON_00001847": "field corn snack food product",
    "FOODON_03490282": "glass container, coloured, covered/protected",
    "GAZ_00001264": "Bermuda",
    "NCBITaxon_80836": "Portunus pelagicus",
    "FOODON_00002351": "wheat bread food product",
    "FOODON_03303713": "cake (liquor added)",
    "CHEBI_59202": "straight-chain fatty acid",
    "FOODON_03307416": "distilled water (bottled)",
    "FOODON_03301054": "bread loaf containing wheat",
    "FOODON_00003256": "pale ale",
    "FOODON_03308188": "hanasaki crab (raw)",
    "CHEBI_24997": "lactate salt",
    "FOODON_03302198": "challah",
    "FOODON_03307710": "grapefruit and orange segments in syrup (canned)",
    "FOODON_03301439": "hen egg yolk (raw)",
    "FOODON_03308976": "widow rockfish (raw)",
    "FOODON_00003197": "shea fruit food product",
    "FOODON_03411439": "plantain (musa) plant",
    "FOODON_00002818": "broad bean (whole, raw)",
    "FOODON_03414506": "beaked hazel plant",
    "FOODON_03311116": "pacific mackerel canned",
    "FOODON_03309822": "squash (strained)",
    "FOODON_03309840": "ginger root (whole, raw)",
    "FOODON_03400263": "condiment sauce (us cfr)",
    "FOODON_03540900": "09000 - laurel and similar- (efsa foodex2)",
    "NCBITaxon_9940": "Ovis aries",
    "FOODON_00001088": "flaxseed oil",
    "FOODON_03411004": "longtail tuna",
    "FOODON_03311501": "crumpet frozen",
    "FOODON_03412139": "sago palm plant",
    "FOODON_03541895": "18950 - pig msm (efsa foodex2)",
    "FOODON_03540844": "08440 - pimpernel (efsa foodex2)",
    "FOODON_03303076": "citrus fiber flour (food product)",
    "FOODON_03543523": "35230 - meadowsweet infusion leaves (efsa foodex2)",
    "FOODON_03316203": "fruit wine (sparkling)",
    "FOODON_03413609": "southern rock lobster",
    "FOODON_00002091": "pasteurized process cheese food product",
    "FOODON_03401004": "10000007 - nuts/seeds - unprepared/unprocessed (perishable) (gs1 gpc)",
    "FOODON_03541030": "10300 - kidney bean (fresh seeds) (efsa foodex2)",
    "ENVO_00000508": "terrace",
    "CHEBI_15040": "retinyl palmitate",
    "FOODON_00001560": "obsolete: has substance added",
    "FOODON_03317103": "berry (canned)",
    "FOODON_03544047": "40470 - tapioca starch-based snacks (efsa foodex2)",
    "PATO_0000119": "height",
    "FOODON_03316979": "fruit (dried, rehydrated, bottled)",
    "FOODON_00002807": "black gram bean (whole, dried)",
    "FOODON_03315598": "cherry cocktail",
    "FOODON_03309550": "soda water (artificially flavored)",
    "FOODON_03308124": "clam (hard shell, shucked, raw)",
    "NCBITaxon_162300": "Epinephelus malabaricus",
    "FOODON_03306783": "pineapple (crushed, canned)",
    "FOODON_03301253": "black currant jam",
    "FOODON_03420108": "sugar",
    "FOODON_03317613": "beverage (fruit juice based, effervescent)",
    "FOODON_03510054": "fat free food",
    "UO_0000021": "gram",
    "FOODON_03400158": "cacao or chocolate product analog (us cfr)",
    "FOODON_00002259": "soy based formula food product",
    "FOODON_03510202": "protein special claim or use",
    "NCBITaxon_29142": "Chanidae",
    "FOODON_03310918": "infant food (canned)",
    "FOODON_03543212": "32120 - juice, white cabbage (efsa foodex2)",
    "FOODON_00002222": "sandwich food product",
    "FOODON_03308165": "bluff oyster (raw)",
    "FOODON_03430113": "food physical quality",
    "FOODON_03310769": "cocoa bean (ground)",
    "FOODON_03308091": "american sardine in oil (canned)",
    "FOODON_03490209": "wax container",
    "FOODON_03543228": "32280 - concentrated or dehydrated fruit/vegetables juices (efsa foodex2)",
    "FOODON_03310545": "scombroid fish (raw)",
    "NCBITaxon_30454": "Fulmarus",
    "FOODON_03305740": "tomato juice concentrate",
    "FOODON_00002227": "scallop food product",
    "FOODON_03540634": "06340 - globe tomato (efsa foodex2)",
    "FOODON_03412298": "manta family",
    "FOODON_03308019": "school shark (raw)",
    "FOODON_03303842": "vegetable oil cooking spray in pressurized container",
    "FOODON_03401267": "0160000 - miscellaneous fruit (ec)",
    "FOODON_00002687": "romaine lettuce",
    "FOODON_00001894": "fungus vegetable food product",
    "FOODON_03315196": "pasteurized process cheese spread with fruits vegetables or meats",
    "FOODON_03304683": "sauerkraut in wine",
    "FOODON_00002768": "pink bean food product",
    "FOODON_03401587": "10006058 - laurel (gs1 gpc)",
    "NCBITaxon_396893": "Brachyplatystoma vaillantii",
    "NCBITaxon_2315723": "Lepetellida",
    "FOODON_00003402": "pre-harvest food material",
    "FOODON_00002202": "rhubarb food product",
    "FOODON_03301421": "lentil (whole, dried)",
    "FOODON_03544360": "43600 - red fruit flavour (efsa foodex2)",
    "FOODON_00002804": "snow pea pod (edible, fresh)",
    "FOODON_03414889": "varunidae",
    "FOODON_03317135": "artificial sweetener, tablet form",
    "FOODON_03401650": "10006302 - water buffalo - prepared/processed (gs1 gpc)",
    "FOODON_03315554": "obsolete: fruit pulped",
    "FOODON_03315841": "chocolate flavored confectionery coating, unstandardized",
    "FOODON_03412578": "black oreo dory",
    "FOODON_03310770": "obsolete: alcoholic beverage",
    "FOODON_00002750": "cranberry bean substance",
    "FOODON_03400729": "06  grains and grain products (eurocode2)",
    "FOODON_03315063": "cheese spread analog",
    "FOODON_03317607": "dairy product (fruit flavored)",
    "NCBITaxon_9788": "Equidae",
    "CHEBI_36981": "flavin nucleotide",
    "ENVO_01000277": "water ice",
    "FOODON_03541056": "10560 - pigeon peas (without pods) (efsa foodex2)",
    "FOODON_03303610": "bitter chocolate",
    "FOODON_03541830": "18300 - compote of fruit / vegetables (efsa foodex2)",
    "NCBITaxon_180767": "Vaccinium reticulatum",
    "FOODON_03304464": "black raspberry essence (food product)",
    "FOODON_03413888": "southern hake",
    "FOODON_00001228": "rennet food product",
    "FOODON_03400808": "butter or other animal fat (eurofir)",
    "FOODON_03305121": "coffee fudge sauce",
    "ENVO_01001116": "bovine dairy liquid manure",
    "FOODON_03307195": "tonic mixer beverage base",
    "FOODON_03303430": "cooking brandy",
    "FOODON_03411347": "obsolete: plant",
    "FOODON_03412693": "shortnose cisco",
    "FOODON_03543746": "37460 - ginseng root infusion (efsa foodex2)",
    "FOODON_03543829": "38290 - tempeh (all types) (efsa foodex2)",
    "NCBITaxon_13574": "Istiophorus",
    "FOODON_03305757": "raspberry juice",
    "FOODON_03530224": "ciguatoxic",
    "FOODON_03309740": "mustard oil press cake",
    "FOODON_03304472": "mushroom (marinated, canned)",
    "FOODON_00003332": "chicken breast (skinless)",
    "FOODON_03310840": "beef (raw, lean)",
    "FOODON_03307142": "olives (canned)",
    "NCBITaxon_320667": "Trichosanthes dioica",
    "FOODON_03413953": "offshore jack mackerel",
    "FOODON_03307119": "raspberry (whole, raw)",
    "FOODON_00001966": "illipe refined food product",
    "FOODON_03301761": "grass (animal feed)",
    "FOODON_03400674": "009  bulb vegetables (va) (ccpr)",
    "FOODON_03543063": "30630 - toffee (efsa foodex2)",
    "FOODON_03310548": "infant formula (milk-based, liquid, concentrated, canned)",
    "FOODON_03306988": "popcorn (pizza-flavored)",
    "CHEBI_18067": "phylloquinone",
    "FOODON_03303369": "sweetener (liquid)",
    "FOODON_03510230": "food allergen labelling about pod fruits and products thereof",
    "FOODON_03411383": "swordfish family",
    "NCBITaxon_121175": "Rana <subgenus>",
    "FOODON_03413449": "catadromous fish",
    "FOODON_03411245": "apple tree",
    "FOODON_03411491": "blueberry plant",
    "FOODON_03460752": "sourdough addition process",
    "UO_0000005": "temperature unit",
    "NCBITaxon_4679": "Allium cepa",
    "FOODON_03401320": "botanical supplement with vitamin(s)",
    "FOODON_03400219": "custard, cooked (us cfr)",
    "GAZ_00002475": "Palestinian Territories",
    "FOODON_03317209": "infant food based on soy protein",
    "FOODON_03420246": "obsolete: ink, aquatic animal",
    "FOODON_03401586": "10006077 - hyssop (gs1 gpc)",
    "NCBITaxon_7797": "Squalus acanthias",
    "ENVO_01000002": "water well",
    "FOODON_03302787": "cranberry catsup (food product)",
    "FOODON_00002734": "roast beef",
    "IAO_0000123": "metadata incomplete",
    "FOODON_03544213": "42130 - brittle flavour (efsa foodex2)",
    "NCBITaxon_119720": "Lethrinus",
    "FOODON_03544052": "40520 - seasonings (efsa foodex2)",
    "FOODON_00002835": "paratha",
    "FOODON_03480026": "packed in fat or oil",
    "FOODON_03401796": "10006363 - gobo root/burdock (gs1 gpc)",
    "FOODON_03544499": "44990 - molybdenum (efsa foodex2)",
    "FOODON_03411076": "european bittersweet plant",
    "FOODON_03315687": "wine (honey)",
    "FOODON_03316813": "macaroni (nonfat milk, enriched)",
    "FOODON_03543480": "34800 - currant (black, red and white) infusion leaves (efsa foodex2)",
    "FOODON_03411147": "american shad",
    "FOODON_03412445": "water mimosa plant",
    "FOODON_03303140": "cookie wafer",
    "FOODON_03540122": "01220 - wheat bread and rolls, white with rice (efsa foodex2)",
    "PO_0030115": "raceme inflorescence",
    "ENVO_01000813": "astronomical body part",
    "FOODON_03315320": "vitamin-mineral preparation containing calcium caseinate and fat-soluble vitamins",
    "FOODON_03542310": "23100 - lake trout (efsa foodex2)",
    "FOODON_03315162": "fruit juice (dehydrated)",
    "ENVO_01001787": "aquatic ecosystem",
    "FOODON_00001176": "invertebrate animal food product",
    "FOODON_00003234": "brochette",
    "FOODON_03316270": "milk-based product with non-fruit preparations (calorie reduced)",
    "FOODON_03304794": "tomato juice concentrate (frozen)",
    "FOODON_03316796": "fig (canned)",
    "GAZ_00001453": "Bouvet Island",
    "RO_0002473": "composed primarily of",
    "FOODON_03542756": "27560 - firm brined cheese (ricotta salata type) (efsa foodex2)",
    "FOODON_03302882": "chocolate cookie",
    "NCBITaxon_186802": "Clostridiales",
    "FOODON_03413726": "maitake mushroom",
    "FOODON_03490292": "aluminium can, drum or barrel, varnished",
    "FOODON_03540624": "06240 - chickpeas (with pods) (efsa foodex2)",
    "GAZ_00002606": "State of Montana",
    "FOODON_03411293": "pike",
    "FOODON_03411314": "endive plant",
    "FOODON_03306545": "meat (canned)",
    "FOODON_03316778": "mammalian milk (lowfat, cultured)",
    "FOODON_03401804": "10006127 - parsley root (hamburg) (gs1 gpc)",
    "FOODON_03311777": "codfish cake canned",
    "CHEBI_24407": "glycosyl glycoside",
    "FOODON_03317311": "chili (canned)",
    "FOODON_03540621": "06210 - podded pea (young pods) (efsa foodex2)",
    "FOODON_03315786": "banana (dehydrated)",
    "FOODON_03301073": "sugar (granulated)",
    "FOODON_03304566": "rose hip (whole, raw)",
    "FOODON_03540693": "06930 - melons and similar- (efsa foodex2)",
    "NCBITaxon_106549": "Malus baccata",
    "FOODON_03311622": "grape jelly low-sugar",
    "FOODON_00002356": "wheat based snack food product",
    "FOODON_03315343": "milk (formulated, powdered)",
    "FOODON_03414827": "pine-leaved geebung plant",
    "FOODON_03316764": "vanilla bean extract",
    "NCBITaxon_8406": "Pelophylax ridibundus",
    "FOODON_03530264": "fat content <=3%",
    "FOODON_03400296": "seafood-based sausage or luncheon meat (us cfr)",
    "FOODON_03315986": "sweet-sour fruit preserves",
    "FOODON_03308821": "emperor shrimp (raw)",
    "FOODON_03401703": "10006259 - seedlings - ready to eat (gs1 gpc)",
    "GAZ_00006905": "Palau",
    "FOODON_03542832": "28320 - cheese, mimolette (efsa foodex2)",
    "FOODON_03543037": "30370 - milk chocolate (efsa foodex2)",
    "FOODON_03315727": "potato product (dehydrated)",
    "FOODON_03414196": "perforate st. john's-wort plant",
    "NCBITaxon_241800": "Scandicinae",
    "PO_0000014": "rosette leaf",
    "FOODON_00001855": "fish refined food product",
    "FOODON_00001210": "wheat flour food product",
    "ENVO_01000176": "shrubland biome",
    "GAZ_00005863": "Australasia",
    "FOODON_03306940": "sweet pickle",
    "FOODON_03540859": "08590 - greek sage (efsa foodex2)",
    "IAO_0000078": "curation status specification",
    "FOODON_03540426": "04260 - chinese amaranth leaves (efsa foodex2)",
    "FOODON_03304694": "gelatin fruit salad (artificially flavored and colored)",
    "FOODON_03308985": "bocaccio rockfish (raw)",
    "FOODON_03307686": "white sauce",
    "NCBITaxon_8008": "Esocidae",
    "FOODON_03303650": "diabetic candy",
    "FOODON_03303126": "pineapple (immature, raw)",
    "NCBITaxon_180118": "Mammea",
    "FOODON_03307063": "poultry (new york dressed, raw)",
    "FOODON_03490184": "plastic container, rigid or semirigid",
    "FOODON_03311578": "celery (dried)",
    "FOODON_03315513": "milk product (fermented)",
    "FOODON_03307681": "iced tea mix (lemon-flavored)",
    "FOODON_03305506": "shrimp puff",
    "FOODON_03306987": "popcorn (buttered)",
    "NCBITaxon_3853": "Lathyrus",
    "NCBITaxon_115816": "Mercenaria campechiensis",
    "CHEBI_15366": "acetic acid",
    "FOODON_03414819": "kangaroo vine plant",
    "HANCESTRO_0435": "Cypriote",
    "ENVO_00003895": "paper product",
    "FOODON_03317182": "beverage (carbonated, artificially flavored)",
    "FOODON_03400269": "icing or frosting (us cfr)",
    "FOODON_03543965": "39650 - pasta, cooked, with cheese/cream (efsa foodex2)",
    "FOODON_03304509": "imitation honey",
    "FOODON_03308274": "silver pomfret (raw)",
    "FOODON_03311842": "mayonnaise (reduced calorie, reduced fat)",
    "FOODON_03316848": "cheddar cheese (for manufacturing)",
    "FOODON_03311259": "scallop (battered, frozen, whole)",
    "FOODON_03315298": "fish paste product",
    "FOODON_03542066": "20660 - poultry edible offal, non-muscle, other than liver and kidney (efsa foodex2)",
    "FOODON_03401233": "0260000 - legume vegetables (ec)",
    "FOODON_03543960": "39600 - pasta based dishes, cooked (efsa foodex2)",
    "FOODON_03415102": "cestrum plant",
    "FOODON_03306742": "apricot half (unpeeled, artificially sweetened)",
    "FOODON_03310672": "breakfast cereal (ready-to-eat, colored)",
    "NCBITaxon_36103": "Haliotis tuberculata",
    "FOODON_03542689": "26890 - traditional buttermilk (churning) (efsa foodex2)",
    "FOODON_03316029": "bread (pre-packed, sliced)",
    "FOODON_03411687": "cherimoya tree",
    "FOODON_03302149": "bouillabaisse",
    "FOODON_03544523": "45230 - bird nest (edible part) (efsa foodex2)",
    "GAZ_00025355": "Borneo",
    "NCBITaxon_9791": "Equus zebra",
    "FOODON_03414103": "stout skate",
    "FOODON_03540820": "08200 - field mushroom (efsa foodex2)",
    "FOODON_03315659": "fruit jelly with pectin",
    "FOODON_03401193": "10000057 - sauces - cooking (shelf stable) (gs1 gpc)",
    "FOODON_03412646": "asian clam",
    "FOODON_03315881": "dendritic salt",
    "FOODON_03304002": "newburg sauce",
    "FOODON_03510171": "lactose free food",
    "NCBITaxon_29153": "Micropogonias",
    "FOODON_03414803": "pearly freshwater mussel",
    "FOODON_03401874": "10005917 - plums (gs1 gpc)",
    "FOODON_03413851": "red-eyed round herring",
    "FOODON_03540678": "06780 - angled luffas (efsa foodex2)",
    "NCBITaxon_81638": "Brosme brosme",
    "FOODON_03309154": "trevally (raw)",
    "FOODON_03460267": "obsolete: carob added",
    "NCBITaxon_9103": "Meleagris gallopavo",
    "BFO_0000054": "realized in",
    "FOODON_03305236": "avocado (whole, raw)",
    "FOODON_00002386": "breakfast food",
    "FOODON_03306395": "lemon marmalade",
    "NCBITaxon_6734": "Panulirus",
    "FOODON_03414478": "squashberry plant",
    "FOODON_03413744": "brown beech mushroom",
    "FOODON_03311870": "leaf sauce",
    "FOODON_03543377": "33770 - sangria (efsa foodex2)",
    "FOODON_03316253": "burger meat (starch content of more than 6%)",
    "FOODON_03541407": "14070 - other spices fruit and berries (e) (efsa foodex2)",
    "FOODON_00001803": "date food product",
    "FOODON_03311366": "buffalo burger",
    "FOODON_03411267": "mint plant",
    "FOODON_03540344": "03440 - oat high-bran flakes (efsa foodex2)",
    "FOODON_03490390": "polyester resin container",
    "FOODON_03316717": "cheese amsterdam",
    "FOODON_03316859": "granular cheese (for manufacturing)",
    "FOODON_03401250": "0820000 - spices, fruits and berries (ec)",
    "CHEBI_51570": "biotins",
    "FOODON_03302059": "rice bean (whole, dried)",
    "FOODON_03540688": "06880 - balsam apple (efsa foodex2)",
    "FOODON_03411888": "saury family",
    "FOODON_03542851": "28510 - cheese, smoked gouda (efsa foodex2)",
    "FOODON_03500013": "carbonated beverage can enamel surface",
    "FOODON_03302676": "imitation maple sweetener",
    "FOODON_03315646": "cold-pack cheese food with added ingredients",
    "FOODON_03304648": "relish",
    "FOODON_03309660": "rock lobster (whole, cooked, frozen)",
    "FOODON_03413646": "violet bittersweet",
    "NCBITaxon_202622": "Boscia",
    "NCBITaxon_1075419": "Genypterus chilensis",
    "FOODON_03540872": "08720 - mastic thyme (efsa foodex2)",
    "FOODON_03540815": "08150 - summer truffles (efsa foodex2)",
    "UO_0010041": "united states customary teaspoon",
    "FOODON_03307041": "potato (crinkle-cut style, bagged)",
    "FOODON_03302792": "imitation catsup mix (dry)",
    "FOODON_03541775": "17750 - par\u00e0 guavas (efsa foodex2)",
    "FOODON_03544495": "44950 - copper (efsa foodex2)",
    "FOODON_03544020": "40200 - salads (efsa foodex2)",
    "FOODON_03490298": "aluminum combined with paper and plastic",
    "FOODON_03412387": "obsolete: zander",
    "FOODON_00002912": "mutton",
    "FOODON_03311021": "swordfish steak (frozen)",
    "FOODON_03412188": "indian threadfin",
    "FOODON_03310723": "shrimp (fried)",
    "FOODON_00003035": "greater burdock root",
    "FOODON_03414057": "big powan",
    "FOODON_03315052": "fruit topping frozen ready-to-thaw-and-eat",
    "FOODON_03542447": "24470 - horse mackerels (efsa foodex2)",
    "FOODON_03544483": "44830 - vitamin c     (ascorbic acid) (efsa foodex2)",
    "FOODON_03543454": "34540 - wormwoods infusion leaves (efsa foodex2)",
    "FOODON_03543154": "31540 - blended frying oil/fats (efsa foodex2)",
    "FOODON_00003100": "black crowberry (whole)",
    "FOODON_03310844": "breakfast beverage",
    "FOODON_03304257": "mussel soup (food product)",
    "NCBITaxon_6647": "Octopodidae",
    "NCBITaxon_3041": "Chlorophyta",
    "FOODON_03541580": "15800 - huckleberries (efsa foodex2)",
    "FOODON_00001846": "field corn refined food product",
    "CHEBI_59601": "patent blue V",
    "FOODON_03400454": "CIAA edible ices",
    "FOODON_03414228": "garden rhubarb plant",
    "FOODON_03312031": "wheat cereal",
    "NCBITaxon_3712": "Brassica oleracea",
    "FOODON_03414301": "obsolete: mustard and cress",
    "FOODON_03315560": "acetic acid (diluted)",
    "FOODON_03540208": "02080 - waffle dough/mixture (efsa foodex2)",
    "FOODON_03541337": "13370 - mace aril and similar- (efsa foodex2)",
    "NCBITaxon_6629": "Illex illecebrosus",
    "FOODON_03510201": "no beef added claim",
    "FOODON_03413835": "australian anchovy",
    "FOODON_00002081": "papaya food product",
    "FOODON_03401615": "10005825 - meat substitutes (shelf stable) (gs1 gpc)",
    "FOODON_03540299": "02990 - pancakes (efsa foodex2)",
    "FOODON_03304820": "seaweed byproduct",
    "FOODON_03411874": "starry flounder",
    "FOODON_03411453": "butternut tree",
    "FOODON_03304504": "meat (frozen)",
    "FOODON_03304222": "infant food (meat)",
    "FOODON_03306136": "mayonnaise with smoked salmon",
    "FOODON_03317060": "sandwich spread (no added sugar, dried-fruit-based)",
    "FOODON_00001649": "black or white pepper product",
    "FOODON_03306817": "field pea (whole, raw)",
    "FOODON_03414492": "plains pricklypear plant",
    "FOODON_03311225": "swordfish (freeze-dried)",
    "FOODON_03520129": "europe - inland waters (fao major fishing areas 05)",
    "FOODON_00002014": "mace food product",
    "FOODON_03460360": "carmelized sugar",
    "FOODON_03311817": "chicken leg (raw)",
    "FOODON_03541084": "10840 - mung beans (dry) (efsa foodex2)",
    "FOODON_00002393": "unrefined chinese wine",
    "FOODON_03542284": "22840 - african bonytongue (efsa foodex2)",
    "NCBITaxon_3432": "Laurales",
    "FOODON_03306173": "fruit juice (reconstituted)",
    "FOODON_00002581": "aquatic invertebrate",
    "FOODON_03542003": "20030 - birds fat tissue (efsa foodex2)",
    "FOODON_03306632": "nut (whole or part)",
    "FOODON_03309570": "neufchatal cheese",
    "FOODON_03541506": "15060 - common peaches (efsa foodex2)",
    "FOODON_03308433": "flatiron herring (raw)",
    "FOODON_00002078": "palm fat or oil refined food product",
    "FOODON_03412128": "cirriped",
    "FOODON_03316150": "sausage (dried, cured)",
    "FOODON_03308992": "john's snapper (raw)",
    "PECO_0007285": "rainy season exposure",
    "FOODON_03414204": "garden valerian plant",
    "FOODON_00002715": "herring fillet",
    "FOODON_03303083": "chewing gum (artificially colored)",
    "FOODON_00002189": "raspberry preserve or jam",
    "FOODON_03412058": "mexican tea plant",
    "FOODON_00002748": "tinfoil barb",
    "NCBITaxon_9108": "Gruiformes",
    "NCBITaxon_112509": "Hordeum vulgare subsp. vulgare",
    "FOODON_03544079": "40790 - hydrolysed vegetable proteins (efsa foodex2)",
    "FOODON_03411476": "buffalo",
    "NCBITaxon_4558": "Sorghum bicolor",
    "FOODON_03401681": "10006394 - roe deer - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03302471": "whole wheat crispbread",
    "FOODON_03414641": "spiny chiton",
    "NCBITaxon_9721": "Cetacea",
    "CHEBI_35274": "ammonium ion derivative",
    "PATO_0000068": "qualitative",
    "FOODON_03307495": "dairy spread (low calorie)",
    "FOODON_03306840": "papaya nectar",
    "FOODON_03401228": "0210000 - root and tuber vegetables (ec)",
    "ENVO_00000037": "ditch",
    "FOODON_03542502": "25020 - lobsters (efsa foodex2)",
    "FOODON_03302421": "spring mineral water (carbonated)",
    "IAO_0000116": "editor note",
    "NCBITaxon_63672": "Turbo <genus>",
    "FOODON_03308553": "brown trout (raw)",
    "FOODON_03401154": "10000019 - shellfish - unprepared/unprocessed (perishable) (gs1 gpc)",
    "FOODON_03305984": "reconstituted orange juice (from concentrate)",
    "FOODON_03540533": "05330 - other flowering brassica (p) (efsa foodex2)",
    "FOODON_03311365": "chewing gum with caffeine added",
    "NCBITaxon_80723": "Trisopterus esmarkii",
    "FOODON_03411857": "black kingklip",
    "NCBITaxon_3750": "Malus domestica",
    "FOODON_03308557": "salmon (low sodium)",
    "FOODON_03540934": "09340 - preserved tomatoes not concentrated (efsa foodex2)",
    "FOODON_03541525": "15250 - other stone fruits (efsa foodex2)",
    "FOODON_03401277": "USDA SR sausages and luncheon meats (0700)",
    "NCBITaxon_4204": "Viburnum",
    "FOODON_03302051": "lard",
    "FOODON_03413876": "pollock",
    "FOODON_03414918": "vegetable fern plant",
    "NCBITaxon_345395": "Macrocallista maculata",
    "FOODON_03310995": "lake michigan chub ground",
    "FOODON_03411111": "spotted tunny",
    "FOODON_03540356": "03560 - rye popped (efsa foodex2)",
    "FOODON_00001297": "unpasteurized cow milk cheese food product",
    "FOODON_03316093": "bread (partially baked, packed)",
    "FOODON_03530237": "hazard 9",
    "FOODON_03544018": "40180 - meat and vegetable soup, with puree or pieces (efsa foodex2)",
    "FOODON_03307183": "honey and apple cider vinegar mixture",
    "NCBITaxon_197562": "Pancrustacea",
    "NCBITaxon_245697": "Cyttus traversi",
    "CHEBI_16997": "propane-1,2-diol",
    "FOODON_00002557": "black pudding",
    "FOODON_03317095": "ice, edible, no sugar added except lactose",
    "HANCESTRO_0324": "Ashkenazi Jew",
    "FOODON_03411252": "frog",
    "FOODON_03510272": "pacific food claim or use",
    "NCBITaxon_109379": "Brassica oleracea var. gongylodes",
    "NCBITaxon_7748": "Lampetra fluviatilis",
    "FOODON_00002698": "barramundi food product",
    "NCBITaxon_95461": "Jasus edwardsii",
    "FOODON_03305574": "seafood (canned)",
    "FOODON_03400985": "10000603 - sugars/sugar substitute products variety packs (gs1 gpc)",
    "FOODON_03541267": "12670 - fennel, dry (efsa foodex2)",
    "FOODON_03310558": "infant formula (milk-based, powdered)",
    "CHEBI_16247": "phospholipid",
    "FOODON_03315457": "fruit (smoked)",
    "FOODON_03306277": "macaroni flour",
    "NCBITaxon_173343": "Oligoplites",
    "FOODON_03317330": "pork (carcass, previously frozen cut)",
    "FOODON_03412582": "flathead catfish species",
    "FOODON_03304157": "salmon (whole, raw)",
    "FOODON_03415162": "ylang-ylang plant",
    "FOODON_03311097": "orange-flavored soft drink",
    "FOODON_03317561": "cephalopod (unprocessed, deep-frozen)",
    "NCBITaxon_9443": "Primates",
    "FOODON_03316188": "jellying fruit extract",
    "FOODON_03400778": "milk, milk product or milk substitute (eurofir)",
    "FOODON_03304086": "imitation ham soup base",
    "FOODON_03540257": "02570 - sponge cake roll (efsa foodex2)",
    "FOODON_03309058": "australian cod (raw)",
    "FOODON_03308046": "clam strip (fried)",
    "FOODON_03530200": "fat content 50-80%, < 25% pufa",
    "FOODON_03305796": "imitation ice milk mix",
    "FOODON_03542681": "26810 - cream, plain (efsa foodex2)",
    "FOODON_00002726": "parrot",
    "NCBITaxon_480971": "Caryocar brasiliense",
    "FOODON_03401396": "50350000 - leaf vegetables - unprepared/unprocessed (fresh) (gs1 gpc)",
    "FOODON_03317513": "meat product (jelly coated, dried)",
    "FOODON_03308042": "flounder (frozen)",
    "FOODON_03414859": "loaches",
    "FOODON_03540295": "02950 - cream-cheese strudel (efsa foodex2)",
    "FOODON_03316792": "gooseberry (canned)",
    "HANCESTRO_0536": "Ghanaian",
    "FOODON_03542863": "28630 - cheese, vignerons (efsa foodex2)",
    "FOODON_03544403": "44030 - walnut flavour (efsa foodex2)",
    "FOODON_03306544": "turkey breast (raw)",
    "FOODON_00002008": "loganberry food product",
    "FOODON_03401512": "10005888 - tangerines (gs1 gpc)",
    "FOODON_00002839": "akutaq",
    "FOODON_03530127": "plat-de-cote",
    "ENVO_01000418": "human house",
    "FOODON_03316732": "tomato (whole and pieces, canned)",
    "FOODON_03460232": "alcohol fermentation",
    "FOODON_03541995": "19950 - equine fat tissue (efsa foodex2)",
    "FOODON_03400379": "brown salt: nutrient, dietary supplement (codex)",
    "FOODON_03315402": "dairy ice mix",
    "HANCESTRO_0026": "Hong Kong Chinese",
    "FOODON_03316072": "pastirma",
    "FOODON_03542902": "29020 - cheese, pecorino romano (efsa foodex2)",
    "FOODON_00002934": "green sea urchin",
    "FOODON_03411401": "loganberry plant",
    "FOODON_03411707": "babassu palm plant",
    "FOODON_03520144": "antarctic and southern indian ocean (fao major fishing area 58)",
    "FOODON_03305015": "imitation jam (artificially sweetened)",
    "NCBITaxon_768507": "Cytophagales",
    "NCBITaxon_9836": "Camelus",
    "FOODON_03315553": "nectar (food product)",
    "FOODON_00002810": "winged bean (whole, raw)",
    "FOODON_03301629": "ice cream (vanilla-flavored)",
    "FOODON_03540870": "08700 - lemon thyme (efsa foodex2)",
    "FOODON_03303779": "candy (artificially grape-flavored)",
    "NCBITaxon_34869": "Rupicapra rupicapra",
    "FOODON_03315960": "cereal-based dessert energy reduced",
    "FOODON_03315818": "mammalian milk (malted, flavored)",
    "FOODON_03411397": "lima bean plant",
    "FOODON_03307169": "cranberry sauce made with whole cranberries",
    "FOODON_03460218": "obsolete: cellulose added 2",
    "FOODON_03412966": "littleleaf linden plant",
    "FOODON_03401406": "10005939 - cherimoya (gs1 gpc)",
    "FOODON_03304836": "eggplant (stuffed)",
    "FOODON_03301166": "skipjack tuna (canned)",
    "FOODON_03541715": "17150 - monstera fruits (efsa foodex2)",
    "FOODON_03305258": "full cream",
    "FOODON_03304807": "cheese (sliced)",
    "FOODON_03401842": "10006747 - salt sticks / mini pretzels (gs1 gpc)",
    "FOODON_00003327": "turkey leg",
    "NCBITaxon_183218": "Abelmoschus",
    "FOODON_03315702": "sweetener (table-top)",
    "FOODON_03411685": "mammea americana tree",
    "FOODON_00002555": "wagyu cattle",
    "FOODON_03311566": "kamu",
    "FOODON_03540215": "02150 - short sweet pastry dough (pate sucree) (efsa foodex2)",
    "FOODON_03316988": "sea urchin product",
    "FOODON_00002489": "fowl food product",
    "FOODON_00002391": "apple must",
    "FOODON_00001708": "cereal dessert food product",
    "FOODON_03304677": "darjeeling black tea (dry)",
    "FOODON_03411867": "gray sole",
    "NCBITaxon_40674": "Mammalia",
    "FOODON_03543271": "32710 - carbonated natural mineral water (efsa foodex2)",
    "FOODON_03415180": "saguaro plant",
    "FOODON_03480034": "packed in gravy or sauce",
    "FOODON_00002701": "chamomile food product",
    "NCBITaxon_55363": "Diospyros lotus",
    "FOODON_03412556": "cherry pepper plant",
    "FOODON_03316321": "shellfish product (marinated)",
    "FOODON_03420103": "meat part of animal",
    "NCBITaxon_469659": "Alosa mediocris",
    "NCBITaxon_7742": "Vertebrata <vertebrates>",
    "FOODON_03542480": "24800 - sturgeon roe (efsa foodex2)",
    "FOODON_03411628": "longan tree",
    "FOODON_03306181": "pear and apple juice (reconstituted)",
    "FOODON_03311723": "milkfish in oil canned",
    "FOODON_03412239": "northern puffer",
    "FOODON_03315733": "vitamin a liquid for addition to food",
    "FOODON_03304862": "pineapple drink",
    "FOODON_03315218": "edible pea pod (fresh)",
    "FOODON_03400692": "02  breakfast cereals (efg)",
    "FOODON_00002112": "peppermint food product",
    "FOODON_03414931": "winged pea plant",
    "NCBITaxon_27046": "Surianaceae",
    "FOODON_03541029": "10290 - flageolet (fresh seeds) (efsa foodex2)",
    "FOODON_03316867": "pasteurized process pimento cheese",
    "FOODON_03309136": "pacific ocean perch fillet (raw)",
    "FOODON_00001269": "reindeer milk beverage",
    "NCBITaxon_598664": "Odontesthes regia",
    "FOODON_03400744": "039  eggs (pe) (ccpr)",
    "FOODON_03400920": "10000222 - juice drinks - ready to drink (perishable) (gs1 gpc)",
    "NCBITaxon_184215": "Ammodytes americanus",
    "NCBITaxon_64466": "Penaeus duorarum",
    "FOODON_03542632": "26320 - canned sprats (efsa foodex2)",
    "FOODON_03412522": "wood blewit",
    "FOODON_03413878": "hake",
    "FOODON_03307390": "kummamoto oyster (raw)",
    "FOODON_03302036": "sugar beet (whole, raw)",
    "FOODON_03305790": "vanilla fudge ice cream",
    "FOODON_03311392": "rice (canned)",
    "FOODON_03304565": "palm sugar",
    "FOODON_00001073": "vinegar food product",
    "NCBITaxon_1206913": "Bembrops anatirostris",
    "FOODON_03307456": "cow milk (concentrated, frozen)",
    "FOODON_03302296": "sheep intestine casing",
    "FOODON_03316985": "kampyo (dried gourd strip)",
    "FOODON_03400369": "antimicrobial preservative (codex)",
    "FOODON_03544172": "41720 - maltodextrin (efsa foodex2)",
    "FOODON_03540065": "00650 - cereals and cereal-like grains not separately listed (efsa foodex2)",
    "FOODON_03308388": "fish bouillon with fish balls",
    "FOODON_03541157": "11570 - korean pine nut kernels (efsa foodex2)",
    "FOODON_03401473": "10006117 - turnip tops (gs1 gpc)",
    "FOODON_03460327": "food surface bacterial curing",
    "FOODON_00002513": "blue corn mush (dish)",
    "FOODON_03542820": "28200 - cheese, herrgardost (efsa foodex2)",
    "FOODON_03305122": "chocolate candy (hollow)",
    "FOODON_03411501": "mulberry plant",
    "NCBITaxon_4235": "Lactuca",
    "FOODON_03304465": "cow milk (sterilized, yogurt-flavored)",
    "FOODON_03413588": "armoured lobster",
    "FOODON_03307047": "panela",
    "NCBITaxon_49314": "Annona cherimola",
    "FOODON_03305973": "marmalade (alcohol-flavored)",
    "FOODON_03413643": "new zealand cockle",
    "FOODON_03541087": "10870 - soyabeans for consumption (dry) (efsa foodex2)",
    "FOODON_03541070": "10700 - azuki beans (dry) (efsa foodex2)",
    "FOODON_03415040": "kencur plant",
    "NCBITaxon_4641": "Musa acuminata",
    "FOODON_00001108": "buffalo dairy food product",
    "NCBITaxon_30871": "Serranidae",
    "FOODON_00003154": "spelt",
    "FOODON_03413902": "gulf kingfish",
    "FOODON_00002061": "nutmeg food product",
    "FOODON_03317687": "aperitif beverage without alcohol, emulsified",
    "ENVO_00000002": "anthropogenic geographic feature",
    "FOODON_03470139": "food dry salting",
    "FOODON_03542075": "20750 - bovine tongue (efsa foodex2)",
    "FOODON_03307961": "clam strip (breaded, fried)",
    "FOODON_03541189": "11890 - rapeseeds (efsa foodex2)",
    "FOODON_03413293": "sucrose esters of fatty acids",
    "FOODON_03542892": "28920 - extra hard cheese (parmesan, grana type) (efsa foodex2)",
    "FOODON_03305136": "sour cream (cultured, with vegetable stabilizers)",
    "FOODON_03400445": "sweetening agent (codex)",
    "FOODON_03310667": "mineral water sparkling minerals added",
    "FOODON_00001058": "fruit extract food product",
    "CHEBI_50126": "tetrasaccharide",
    "FOODON_03309956": "white lupine (whole, raw)",
    "HANCESTRO_0333": "Anguillan",
    "NCBITaxon_4201": "Sambucus",
    "FOODON_03400960": "50220000 - cereal/grain/pulse products (gs1 gpc)",
    "FOODON_03542286": "22860 - diadromous fish (efsa foodex2)",
    "FOODON_03544248": "42480 - crab flavour (efsa foodex2)",
    "FOODON_03412911": "new zealand garfish",
    "FOODON_03540809": "08090 - honey mushroom (efsa foodex2)",
    "NCBITaxon_170927": "Primula veris",
    "FOODON_03414490": "typical owl family",
    "FOODON_03308036": "mackerel (raw)",
    "FOODON_03412358": "giant keyhole limpet",
    "FOODON_00003144": "caff\u00e8 mocha",
    "FOODON_03305452": "strawberry fruit juice bar (frozen)",
    "FOODON_03414002": "congo dentex",
    "FOODON_03306247": "licorice root tea (dry)",
    "GAZ_00000910": "Guinea-Bissau",
    "NCBITaxon_4410": "Nymphaeaceae",
    "FOODON_03302454": "enrichment wafer (food product)",
    "HANCESTRO_0584": "Sri Lankan Sinhalese",
    "FOODON_03305705": "lobster (whole, raw)",
    "FOODON_03542128": "21280 - pastrami, pork (efsa foodex2)",
    "FOODON_03304621": "bar mix",
    "FOODON_03316742": "fungus (sterilized)",
    "FOODON_03301039": "soft-ripened cheese",
    "FOODON_03400788": "imitation milk products (eurofir)",
    "FOODON_03301340": "rice sheet",
    "FOODON_03401498": "10006439 - king mandarins (gs1 gpc)",
    "FOODON_03412305": "kanda",
    "FOODON_03303791": "candy (artificially sweetened)",
    "FOODON_03412056": "senna plant",
    "NCBITaxon_88663": "Beryx splendens",
    "FOODON_03430130": "food (liquid)",
    "FOODON_03303362": "orange and lemon marmalade",
    "FOODON_03543096": "30960 - olive oil, refined (efsa foodex2)",
    "NCBITaxon_106975": "Opuntia",
    "FOODON_03310570": "imitation grape jelly (artificially sweetened)",
    "FOODON_03317300": "bockwurst",
    "FOODON_03304529": "cake roll",
    "FOODON_03401207": "Codex Alimentarius general standard for cheese",
    "FOODON_03541137": "11370 - sweet chestnut (efsa foodex2)",
    "NCBITaxon_334483": "Syzygium jambos",
    "FOODON_03543491": "34910 - eyebright infusion leaves (efsa foodex2)",
    "FOODON_03304506": "date (whole, raw)",
    "FOODON_03307054": "chocolate-covered hard candy",
    "FOODON_03305377": "wheat bread crumbs (enriched)",
    "FOODON_03309603": "prune whip yogurt",
    "FOODON_00002630": "Barbera grape plant",
    "FOODON_03542790": "27900 - cheese, robiola (efsa foodex2)",
    "FOODON_03303364": "cayenne pepper (ground)",
    "FOODON_03304896": "fudge (vanilla and chocolate marble top)",
    "NCBITaxon_199623": "Alpinia officinarum",
    "FOODON_03543490": "34900 - eucalyptus infusion leaves (efsa foodex2)",
    "FOODON_03302113": "beer (light)",
    "FOODON_03414229": "chinese rhubarb plant",
    "FOODON_03411976": "skate family",
    "FOODON_03311823": "sole ground raw",
    "FOODON_03540609": "06090 - mung beans (with pods) (efsa foodex2)",
    "FOODON_03309247": "turbot (frozen)",
    "FOODON_03307301": "imitation raspberry-flavored drink",
    "FOODON_03304104": "sfogliatelle (food product)",
    "FOODON_03411052": "sour cherry plant",
    "FOODON_03307793": "tit low hon tea (dry)",
    "FOODON_03542002": "20020 - hare fresh fat tissue (efsa foodex2)",
    "FOODON_03544305": "43050 - macadamia flavour (efsa foodex2)",
    "FOODON_03543565": "35650 - honeybush (efsa foodex2)",
    "FOODON_03411833": "mozambique tilapia",
    "FOODON_03400891": "50201700 - coffee/tea/substitutes (gs1 gpc)",
    "FOODON_03530176": "food content range (europe)",
    "FOODON_03541046": "10460 - black gram (fresh seeds) (efsa foodex2)",
    "FOODON_03400161": "fruit or nut candy (us cfr)",
    "FOODON_03306192": "imitation lemon juice (dehydrated)",
    "FOODON_00001667": "broiler or fryer chicken meat food product",
    "FOODON_03302875": "cod roe spread (smoked)",
    "FOODON_03302818": "sweet milk cocoa",
    "FOODON_00001010": "processed meat food product",
    "NCBITaxon_723540": "Mobula hypostoma",
    "FOODON_03305578": "mahi mahi fillet (raw)",
    "FOODON_03414398": "invertase",
    "FOODON_03308910": "argentine grouper (raw)",
    "FOODON_03400233": "ice milk (us cfr)",
    "FOODON_00002456": "food (baked)",
    "CHEBI_23016": "carbonates",
    "FOODON_03310366": "dextrin",
    "FOODON_03543274": "32740 - carbonated bottled drinking water (efsa foodex2)",
    "FOODON_03305793": "ice milk made from goat milk",
    "FOODON_03543088": "30880 - water-based ice creams (efsa foodex2)",
    "FOODON_03316683": "fish fillets and minced fish (quick-frozen in blocks)",
    "FOODON_03541809": "18090 - jam, currants (red) (efsa foodex2)",
    "FOODON_03304905": "chicken soup mix (instant)",
    "FOODON_03412085": "bibb lettuce plant",
    "NCBITaxon_1051063": "Doryteuthis",
    "FOODON_03411859": "red kingklip",
    "FOODON_03544307": "43070 - malt flavour (efsa foodex2)",
    "CHEBI_37971": "phosphorus-31 atom",
    "FOODON_03306644": "pea vine silage",
    "FOODON_03400331": "carrier, including carrier solvent (ec)",
    "FOODON_03309267": "rock sole (raw)",
    "FOODON_03401126": "10000145 - aquatic invertebrates - prepared/processed (frozen) (gs1 gpc)",
    "BFO_0000011": "spatiotemporal region",
    "PO_0025066": "stalk",
    "FOODON_03301836": "shrimp (raw, breaded, frozen)",
    "FOODON_03306766": "pie filling",
    "FOODON_03304425": "mayonnaise (low sodium)",
    "NCBITaxon_866800": "Cactineae",
    "FOODON_03307226": "fruitcake (bourbon whiskey added)",
    "FOODON_00002742": "tuna fillet",
    "FOODON_03401705": "10000607 - milk/butter/cream/yogurts/cheese/eggs/substitutes variety packs (gs1 gpc)",
    "FOODON_03303699": "smoked seasoning salt",
    "FOODON_03542389": "23890 - miscellaneous demersal marine fishes (efsa foodex2)",
    "FOODON_03414770": "cranesbill plant",
    "FOODON_03311149": "potato (cubed in brine)",
    "FOODON_03315280": "bacon (pump-cured)",
    "CHEBI_33583": "noble gas molecular entity",
    "FOODON_03303853": "gruenland cheese",
    "FOODON_03303712": "bread (high fiber)",
    "FOODON_03401882": "10006461 - agretti (gs1 gpc)",
    "FOODON_03301669": "orange-flavored drink",
    "CHEBI_3136": "bixin",
    "FOODON_03540120": "01200 - wheat bread and rolls, white with maize (efsa foodex2)",
    "FOODON_03400709": "19  non-alcoholic beverages (efg)",
    "FOODON_03420265": "skeletal meat part, with bone, with skin",
    "CHEBI_82519": "Nylon 6",
    "FOODON_03413872": "grass pickerel",
    "FOODON_03301359": "chestnut (baked)",
    "FOODON_00001093": "cereal grain food product",
    "NCBITaxon_6696": "Macrobrachium",
    "CHEBI_50211": "retinol",
    "FOODON_03420253": "fat trimmings",
    "FOODON_03304233": "coconut haystacks candy (food product)",
    "FOODON_03490186": "plastic container, flexible or film",
    "FOODON_03307185": "raisin (soaked in liquor)",
    "FOODON_03412596": "smalleye hammerhead",
    "FOODON_03306376": "sweet orange marmalade",
    "FOODON_03541244": "12440 - african oil palm kernels (efsa foodex2)",
    "FOODON_03308312": "fish (raw, breaded)",
    "FOODON_03302899": "fruit cocktail (canned)",
    "NCBITaxon_8186": "Lates",
    "FOODON_03311458": "soybean bran",
    "CHEBI_93909": "2,5,7,8-tetramethyl-2-(4,8,12-trimethyltridecyl)-3,4-dihydro-2H-1-benzopyran-6-ol",
    "FOODON_03510260": "bodybuilder as food consumer",
    "FOODON_03412800": "fadogia plant",
    "FOODON_03541505": "15050 - peaches and similar- (efsa foodex2)",
    "FOODON_03530139": "tranche (meat cut)",
    "FOODON_03316776": "lowfat cow milk (acidified)",
    "FOODON_00003151": "heart food product",
    "FOODON_03413879": "hake family",
    "FOODON_03305813": "apple (finely chopped)",
    "FOODON_03544269": "42690 - fruits of the forest flavour (efsa foodex2)",
    "FOODON_03544024": "40240 - greek salad (efsa foodex2)",
    "NCBITaxon_217035": "Ericoideae",
    "FOODON_00001230": "mustard food product",
    "FOODON_03540483": "04830 - chinese flat cabbages (efsa foodex2)",
    "FOODON_03510027": "pig as consumer",
    "FOODON_03303878": "caraway cheese",
    "FOODON_03308746": "scallop (queen, raw)",
    "FOODON_03306162": "apple and black raspberry juice drink (diluted)",
    "FOODON_03306808": "pea (whole, frozen)",
    "NCBITaxon_6581": "Mactridae",
    "FOODON_03500031": "cellophane",
    "FOODON_03540137": "01370 - multigrain (not only rye-wheat) bread and rolls (efsa foodex2)",
    "FOODON_03308109": "herring in tomato sauce (canned)",
    "FOODON_03470176": "controlled atmosphere storage process",
    "FOODON_03414561": "goldeye",
    "FOODON_03302220": "orange drink (artificially colored)",
    "FOODON_03302283": "grape beverage base (vitamin-fortified, artificially sweetened,-flavored and colored)",
    "FOODON_03414031": "wreckfish family",
    "FOODON_03411595": "yellow vegetable corn plant",
    "FOODON_03540566": "05660 - coconut palm hearts (efsa foodex2)",
    "FOODON_03540770": "07700 - hijiki (efsa foodex2)",
    "HANCESTRO_0521": "Ugandan",
    "CHEBI_33837": "conjugated protein",
    "FOODON_03309514": "imitation wild cherry drop",
    "FOODON_03311621": "imitation grape jelly",
    "FOODON_03306703": "cottage cheese (powdered)",
    "FOODON_03412849": "actinomycetales",
    "FOODON_03315511": "beverage (fruit juice base, preserved, for infants and young children)",
    "OBI_0001931": "scalar value specification",
    "FOODON_03414055": "large-bottom pollan",
    "FOODON_03543830": "38300 - dairy imitates (efsa foodex2)",
    "FOODON_03412763": "coco plum plant",
    "FOODON_03305768": "chocolate chip cookie (chocolate liquor added)",
    "FOODON_00003038": "borage food product",
    "NCBITaxon_680237": "Crescentia alata",
    "NCBITaxon_178616": "Brassica oleracea var. gemmifera",
    "FOODON_03411378": "sugar cane plant",
    "CHEBI_17097": "biphenyl",
    "FOODON_00001222": "sausage (raw)",
    "PATO_0001340": "hermaphrodite",
    "GAZ_00002472": "South Asia",
    "FOODON_00002148": "plant product flavoring or seasoning",
    "FOODON_00001918": "grain based distilled spirit",
    "FOODON_03544456": "44560 - baking yeast (efsa foodex2)",
    "FOODON_03412105": "new zealand spider crab",
    "FOODON_03544268": "42680 - fruit cocktail flavour (efsa foodex2)",
    "FOODON_00003121": "durian (whole, raw)",
    "FOODON_00003190": "adobo",
    "FOODON_03400347": "sequestrant (ec)",
    "FOODON_03305759": "ice cream (artificially sweetened)",
    "FOODON_03540487": "04870 - pak-choi (efsa foodex2)",
    "CHEBI_26666": "short-chain fatty acid",
    "NCBITaxon_3766": "Pyrus",
    "FOODON_00002730": "turkey liver",
    "CHEBI_33575": "carboxylic acid",
    "FOODON_03302200": "wheat bread",
    "FOODON_03542089": "20890 - sheep other slaughtering products (efsa foodex2)",
    "ENVO_01001873": "hatchery",
    "FOODON_03311222": "plaice fillet (coated, partially cooked)",
    "FOODON_03401886": "10006262 - tidal sea vegetables other (gs1 gpc)",
    "FOODON_03308350": "rock lobster tail meat (cooked)",
    "FOODON_03544409": "44090 - wine flavour (efsa foodex2)",
    "FOODON_00001590": "angelica candy food product",
    "FOODON_03303538": "tilsiter cheese",
    "FOODON_03307760": "meat sandwich (cooked, frozen)",
    "FOODON_03541726": "17260 - black sapotes (efsa foodex2)",
    "NCBITaxon_65739": "Anarhichas minor",
    "FOODON_03411117": "coho salmon",
    "NCBITaxon_184445": "Paralabrax callaensis",
    "FOODON_00002451": "food transformation process",
    "FOODON_00002129": "plant based meat product analog",
    "FOODON_03411462": "zucchini plant",
    "FOODON_03542976": "29760 - hardened egg products (efsa foodex2)",
    "CHEBI_33729": "tetritol",
    "FOODON_00001236": "fresh sea water fish food product",
    "FOODON_03302269": "soda water",
    "FOODON_03540800": "08000 - wood blewits (efsa foodex2)",
    "FOODON_00003165": "scarlet runner bean pod",
    "FOODON_03542418": "24180 - albacore (efsa foodex2)",
    "FOODON_03412344": "devils tongue plant",
    "FOODON_03541840": "18400 - fruit compote, sour cherry (efsa foodex2)",
    "FOODON_03413945": "bigeye grunt",
    "NCBITaxon_300936": "Valerianella dentata",
    "NCBITaxon_85552": "Scylla paramamosain",
    "FOODON_03310967": "cheese (made from buffalo milk)",
    "FOODON_03315931": "coating and decoration",
    "FOODON_03411050": "sea scallop",
    "FOODON_03302908": "ricotta cheese",
    "FOODON_03308420": "langostino soup",
    "FOODON_03306622": "noodle soup",
    "FOODON_03306074": "pepper jelly",
    "GAZ_00024432": "Sumatra",
    "NCBITaxon_365050": "Sardinella zunasi",
    "FOODON_03307338": "watermelon preserve (food product)",
    "FOODON_03530190": "fat content < 3.5%",
    "FOODON_03307717": "maple and cane syrup",
    "FOODON_03540653": "06530 - capsicum baccatum (efsa foodex2)",
    "FOODON_03401565": "10006043 - american basil (gs1 gpc)",
    "FOODON_00002424": "roquefort cheese",
    "FOODON_03414851": "gayal",
    "FOODON_03309629": "lake trout fillet (raw)",
    "FOODON_03305243": "strawberry conserve",
    "GAZ_00005862": "Micronesia",
    "NCBITaxon_117867": "Arhynchobatidae",
    "FOODON_03415175": "chinese white pear plant",
    "ENVO_00003032": "fresh animal manure",
    "GAZ_00010831": "Spratly Islands",
    "FOODON_03302046": "huckleberry (whole, raw)",
    "FOODON_03541530": "15300 - table grapes (efsa foodex2)",
    "GAZ_00001227": "Cape Verde",
    "FOODON_03540348": "03480 - wheat germs rolled flakes (efsa foodex2)",
    "FOODON_03543939": "39390 - pizza and similar with vegetable topping (efsa foodex2)",
    "FOODON_03411475": "pompano",
    "UO_0000033": "day",
    "NCBITaxon_74940": "Oncorhynchus tshawytscha",
    "FOODON_00003257": "india pale ale",
    "NCBITaxon_466544": "Perdicinae",
    "FOODON_03490128": "plastic wrapper",
    "FOODON_03401122": "10000288 - vegetable based products / meals - ready to eat (shelf stable) (gs1 gpc)",
    "FOODON_03302533": "buttermilk-flavored doughnut",
    "NCBITaxon_28380": "Sardinops",
    "FOODON_00001301": "has food substance analog",
    "FOODON_03543361": "33610 - ice wine and raisin wine (efsa foodex2)",
    "FOODON_03315781": "sauce (unstandardized)",
    "FOODON_03401595": "10006062 - peppermint (gs1 gpc)",
    "NCBITaxon_4136": "Lamiaceae",
    "FOODON_03413913": "larimichthys",
    "FOODON_03317545": "crustacean (pre-cooked)",
    "NCBITaxon_443792": "Lotella rhacina",
    "FOODON_03306880": "duck (processed)",
    "FOODON_03542405": "24050 - anchovies (efsa foodex2)",
    "ENVO_01001311": "solid surface layer",
    "FOODON_03510247": "unsaturated fat claim or use",
    "FOODON_03401088": "10000299 - dough based products / meals - ready to eat - savoury (shelf stable) (gs1 gpc)",
    "FOODON_03401723": "10005967 - prickly pears (barbary figs) (gs1 gpc)",
    "FOODON_03420110": "peel, core or seed",
    "FOODON_03401701": "10006037 - watermelons (gs1 gpc)",
    "FOODON_03540041": "00410 - rice grain, mixed (efsa foodex2)",
    "FOODON_03542004": "20040 - poultry fat tissue (efsa foodex2)",
    "NCBITaxon_33114": "Capsicum baccatum",
    "FOODON_00001122": "cervid milk beverage",
    "FOODON_03305231": "romano cheese (pecorino-style)",
    "FOODON_03301075": "hen egg (whole, shell off, raw)",
    "BFO_0000055": "realizes",
    "FOODON_03309573": "green tomato (whole, raw)",
    "NCBITaxon_311790": "Afrotheria",
    "FOODON_03305109": "candy made with rum",
    "PATO_0000051": "morphology",
    "FOODON_03415151": "common toadflax plant",
    "FOODON_03308170": "ornate spiny lobster (raw)",
    "FOODON_03311688": "shallots chopped in oil",
    "NCBITaxon_59296": "Stenodus leucichthys",
    "FOODON_03542231": "22310 - crucian carp (efsa foodex2)",
    "FOODON_03305187": "farina (enriched)",
    "NCBITaxon_1003799": "Scomberomorus plurilineatus",
    "FOODON_03301316": "obsolete: coffee (decaffeinated)",
    "FOODON_03316931": "cheese mix (substitute or imitation)",
    "BFO_0000015": "process",
    "FOODON_00002242": "smelt food product",
    "FOODON_03400935": "10000158 - baking/cooking supplies (shelf stable) (gs1 gpc)",
    "FOODON_03540874": "08740 - summer savory (efsa foodex2)",
    "FOODON_00002099": "peanut food product",
    "FOODON_03411995": "silver moonfish",
    "FOODON_03311692": "tomato (dried in olive oil)",
    "FOODON_03302199": "potato bread",
    "FOODON_03316564": "fruit produce in sour pickle",
    "FOODON_03413660": "kerguelen mussel",
    "NCBITaxon_97160": "Latridopsis ciliaris",
    "FOODON_03315662": "meatloaf",
    "FOODON_03307883": "citrus puree (frozen)",
    "FOODON_03401400": "50320000 - vegetables - unprepared/unprocessed (shelf stable) (gs1 gpc)",
    "FOODON_03301873": "chestnut (dried)",
    "FOODON_03316706": "chocolate filled",
    "FOODON_03411608": "miniature tomato plant",
    "CHEBI_18219": "ammonium hydroxide",
    "FOODON_03317277": "mixture of rendered animal fat and vegetable fat",
    "FOODON_03306977": "blackeyed pea (green, shell off, blanched)",
    "FOODON_00003031": "savoy cabbage (whole, raw)",
    "FOODON_03307458": "cow milk (semi-skimmed)",
    "FOODON_03490361": "nylon 11 container",
    "FOODON_03305304": "fruit preserves",
    "FOODON_03542518": "25180 - metapenaeus shrimps (efsa foodex2)",
    "FOODON_03307147": "rice (milled)",
    "PATO_0000569": "decreased height",
    "HANCESTRO_0513": "Namibian",
    "FOODON_03460119": "microbial/enzymatic modification process",
    "FOODON_03460154": "obsolete: dextrose added",
    "GAZ_00004025": "Aruba",
    "FOODON_03520513": "marine water fishing area",
    "NCBITaxon_22299": "Eupomatiaceae",
    "FOODON_03542955": "29550 - common quail eggs (efsa foodex2)",
    "FOODON_03307406": "mexican oyster (raw)",
    "FOODON_03414214": "mandarin lime plant",
    "NCBITaxon_197574": "Selar boops",
    "FOODON_03510072": "no animal fat added claim or use",
    "HANCESTRO_0487": "Indian",
    "FOODON_03543678": "36780 - fragrant sumac (infusion bark) (efsa foodex2)",
    "NCBITaxon_4539": "Panicum",
    "FOODON_03315246": "shortening for cake mix",
    "FOODON_00002118": "pimiento pepper food product",
    "FOODON_03543687": "36870 - quassia (infusion bark, wood) (efsa foodex2)",
    "FOODON_03316143": "coating for fine bakery wares",
    "UBERON_0004455": "neurula embryo",
    "CHEBI_63299": "carbohydrate derivative",
    "FOODON_03315252": "cod liver oil emulsion (food product)",
    "FOODON_03301422": "sweet corn (raw)",
    "NCBITaxon_445221": "Penaeus brevirostris",
    "FOODON_03302321": "german chocolate cake (whole)",
    "FOODON_03302278": "imitation lemon drink mix (vitamin-fortified, artificially sweetened)",
    "NCBITaxon_89949": "Merluccius hubbsi",
    "FOODON_03304913": "fruit mix soup",
    "FOODON_03308517": "reindeer sausage",
    "FOODON_03308435": "spanish sardine (raw)",
    "FOODON_03307019": "pancake or waffle mix",
    "FOODON_03544049": "40490 - other desserts spoonable (efsa foodex2)",
    "FOODON_03411058": "vegetable-producing plant, most parts",
    "FOODON_03309103": "greenland turbot (frozen)",
    "FOODON_03310499": "cow milk (high temperature short time)",
    "FOODON_03414541": "horn of plenty",
    "FOODON_03401778": "10006757 - quark products (perishable) (gs1 gpc)",
    "FOODON_03541078": "10780 - ervils (dry) (efsa foodex2)",
    "FOODON_00002460": "lime fruit food product",
    "FOODON_03308919": "jurel (green jack) (raw)",
    "FOODON_03311357": "imitation beef jerky",
    "FOODON_03540327": "03270 - wheat semolina porridge (efsa foodex2)",
    "GAZ_00003953": "Haiti",
    "FOODON_03542073": "20730 - mammals other slaughtering products (efsa foodex2)",
    "FOODON_03414615": "dugong",
    "FOODON_03542626": "26260 - ling, dried (efsa foodex2)",
    "FOODON_03309800": "pineapple (dried)",
    "FOODON_03542274": "22740 - silver perch (efsa foodex2)",
    "NCBITaxon_349646": "Pseudocaranx dentex",
    "FOODON_03303872": "bone marrow broth",
    "FOODON_03311680": "potato (cooked, dehydrated, refrigerated)",
    "FOODON_03510066": "no or reduced energy claim or use",
    "FOODON_03305288": "sugar cane juice (pure)",
    "FOODON_03544337": "43370 - papaya flavour (efsa foodex2)",
    "HANCESTRO_0418": "Panamanian",
    "FOODON_03413320": "vegetable carbon",
    "FOODON_03414425": "sodium sulphates",
    "FOODON_03401114": "10000213 - honey (shelf stable) (gs1 gpc)",
    "FOODON_03308537": "rock lobster meat (cooked)",
    "FOODON_03542926": "29260 - cheese, pont l'eveque (efsa foodex2)",
    "FOODON_03415026": "canarium plant",
    "FOODON_03412201": "obsolete: panulirus rissore",
    "FOODON_03400438": "residue (codex)",
    "FOODON_03541326": "13260 - chinese cassia buds (efsa foodex2)",
    "FOODON_03541832": "18320 - fruit compote, apricot (efsa foodex2)",
    "NCBITaxon_72332": "Artemisia absinthium",
    "FOODON_03302183": "orange drink (artificially sweetened)",
    "FOODON_03315844": "vegetable oil topping mix (food product)",
    "NCBITaxon_745121": "Cilus",
    "FOODON_03543690": "36900 - sour cherry (infusion stems) (efsa foodex2)",
    "FOODON_03301056": "malt extract",
    "FOODON_03302859": "genoa cake",
    "FOODON_03413428": "marigold plant (Calendula)",
    "NCBITaxon_446348": "Malva verticillata",
    "FOODON_03400405": "emulsion stabilizer (codex)",
    "FOODON_03317236": "shrimp (fully preserved)",
    "FOODON_03540434": "04340 - oraches leaves (efsa foodex2)",
    "FOODON_03412951": "prickly lettuce plant",
    "FOODON_03542104": "21040 - turkey, other slaughtering products (efsa foodex2)",
    "FOODON_03542718": "27180 - flavoured sour cream (efsa foodex2)",
    "FOODON_03311763": "roasted chicory beverage (food product)",
    "FOODON_03544259": "42590 - eucalyptus flavour (efsa foodex2)",
    "FOODON_03304501": "imitation egg",
    "NCBITaxon_7972": "Ictiobus",
    "FOODON_03308643": "pufferfish (raw)",
    "FOODON_03543624": "36240 - lime infusion flowers and similar- (efsa foodex2)",
    "NCBITaxon_79574": "Lecythis",
    "FOODON_03304186": "green pea with ham soup (condensed, frozen)",
    "GAZ_00003731": "Bali Province",
    "CHEBI_26873": "terpenoid",
    "FOODON_03544380": "43800 - stracciatella flavour (efsa foodex2)",
    "FOODON_03304161": "beef shortening (homogenized)",
    "FOODON_03308402": "smelt (frozen)",
    "FOODON_00002654": "food (pasteurized)",
    "FOODON_03540170": "01700 - additional bread products (efsa foodex2)",
    "FOODON_03540234": "02340 - cake pre-mixes (dry) (efsa foodex2)",
    "PO_0025522": "tuber",
    "FOODON_03543061": "30610 - nuts-seeds based halva (efsa foodex2)",
    "FOODON_03414531": "atlantic bobtail",
    "FOODON_03540125": "01250 - wheat bread and rolls, brown or wholemeal (efsa foodex2)",
    "FOODON_03542616": "26160 - marinated / pickled fish (efsa foodex2)",
    "FOODON_03540304": "03040 - spice cakes (efsa foodex2)",
    "FOODON_03542872": "28720 - cheese, cheddar (efsa foodex2)",
    "FOODON_00003281": "whitefish (fisheries term)",
    "FOODON_03316337": "fruit drink beverage base",
    "FOODON_03540596": "05960 - azuki beans (with pods) (efsa foodex2)",
    "FOODON_00003300": "sweet and sour pork",
    "HANCESTRO_0375": "Maltese",
    "FOODON_03540502": "05020 - alfalfa sprouts (efsa foodex2)",
    "FOODON_03315180": "capsules and tablets containing food for special dietary uses",
    "FOODON_03311452": "breakfast cereal (hot-type, instant, aspartame sweetened)",
    "FOODON_03400955": "10000245 - pies/pastries - sweet (frozen) (gs1 gpc)",
    "GAZ_00007119": "Navassa Island",
    "GAZ_00002516": "Guyane",
    "FOODON_03302126": "betel nut powder",
    "FOODON_03411876": "pacific halibut",
    "NCBITaxon_174393": "Lithodes maja",
    "FOODON_03306597": "kumquat (whole, raw)",
    "FOODON_03411032": "obsolete: sole, species not known",
    "FOODON_03414864": "bagrid catfish",
    "NCBITaxon_9874": "Odocoileus virginianus",
    "CHEBI_33232": "application",
    "FOODON_03306559": "vegetable oil (partially hydrogenated)",
    "FOODON_03542266": "22660 - gourami (asia) (efsa foodex2)",
    "FOODON_03307781": "chicken and turkey salad sandwich",
    "FOODON_00001331": "pla-ra",
    "FOODON_03303870": "stilton cheese",
    "FOODON_03420114": "seed, skin undetermined, germ removed",
    "FOODON_03315812": "breakfast, ready",
    "FOODON_03308223": "salmon steak (raw)",
    "FOODON_03307716": "black currant syrup",
    "FOODON_03307194": "waffle (frozen)",
    "NCBITaxon_58486": "Genipa americana",
    "FOODON_03401851": "10006091 - spinach (gs1 gpc)",
    "FOODON_00002097": "peanut candy food product",
    "FOODON_03400165": "frozen custard (us cfr)",
    "NCBITaxon_52152": "Elymus repens",
    "FOODON_03412311": "betel nut palm plant",
    "FOODON_03315123": "mushroom (cooked, canned)",
    "FOODON_00003436": "brown rice",
    "HANCESTRO_0450": "Tunisian",
    "FOODON_03415068": "southernwood plant",
    "FOODON_03401341": "50251900 - miscellaneous fruit (gs1 gpc)",
    "FOODON_03542691": "26910 - fermented milk or cream (efsa foodex2)",
    "NCBITaxon_225102": "Stemodia",
    "NCBITaxon_163487": "Mimoseae",
    "FOODON_03305455": "red currant (frozen)",
    "FOODON_03413534": "blacklip abalone",
    "FOODON_03316089": "vegetable fat analog of whipped cream",
    "FOODON_00001277": "orange juice (unpasteurized)",
    "FOODON_03304581": "mayonnaise (low calorie)",
    "FOODON_03401824": "10006320 - mustard (frozen) (gs1 gpc)",
    "GAZ_00000556": "East Africa",
    "NCBITaxon_1111464": "Moolgarda engeli",
    "ENVO_00000873": "freshwater biome",
    "FOODON_03301511": "chili con carne (dish)",
    "NCBITaxon_92050": "Macruronus magellanicus",
    "CHEBI_78802": "diarylheptanoid",
    "FOODON_03412319": "calico clam",
    "FOODON_00002918": "chickpea plant",
    "FOODON_03541412": "14120 - nut/seeds paste/emulsion/mass (efsa foodex2)",
    "FOODON_00001704": "celery food product",
    "FOODON_03308842": "western pacific crab (raw)",
    "FOODON_03317155": "fruit jelly (no energy-containing sweetener added)",
    "PO_0025361": "leaf tendril",
    "FOODON_03304413": "coconut bar cookie (artificially sweetened)",
    "FOODON_03490415": "polymer base textile container",
    "FOODON_03540390": "03900 - baby leaf indian mustard leaves (efsa foodex2)",
    "FOODON_03316835": "macaroni (egg, vegetable, enriched)",
    "HANCESTRO_0420": "Peruvian",
    "FOODON_03401077": "10000196 - desserts (frozen) (gs1 gpc)",
    "FOODON_03450010": "food toasting",
    "FOODON_03308288": "atlantic sole (raw)",
    "FOODON_00001584": "alfalfa vegetable food product",
    "CHEBI_36916": "cation",
    "FOODON_03306402": "imitation lemon marmalade",
    "FOODON_03315523": "fat or oil (vegetable)",
    "FOODON_03401783": "10006754 - ready-made combination meals - not ready to eat variety packs (gs1 gpc)",
    "NCBITaxon_33789": "Channa",
    "FOODON_03311475": "wheat-based infant cereal iron-fortified",
    "FOODON_03412346": "iceland moss",
    "FOODON_03316644": "cheese (specialty)",
    "FOODON_03303200": "corn (sweet, cream-style, canned)",
    "NCBITaxon_102810": "Anthemideae",
    "FOODON_03305513": "cheddar cheese bread",
    "NCBITaxon_45623": "Pelophylax lessonae",
    "FOODON_03541935": "19350 - horse fresh meat (efsa foodex2)",
    "FOODON_03541548": "15480 - olallieberries (efsa foodex2)",
    "FOODON_03413817": "daggertooth pike-conger",
    "NCBITaxon_52570": "Trachyspermum ammi",
    "NCBITaxon_933138": "Salvia leucantha",
    "FOODON_03541202": "12020 - cotton seeds (efsa foodex2)",
    "FOODON_03411387": "truffle",
    "NCBITaxon_7845": "Isurus",
    "NCBITaxon_91721": "Heterotis niloticus",
    "FOODON_03317671": "coconut (desiccated)",
    "FOODON_03306452": "flaxseed (defatted)",
    "FOODON_03315625": "malt liquor",
    "FOODON_03401292": "USDA SR meals, entrees, and sidedishes (2200)",
    "FOODON_03540177": "01770 - pasta wholemeal (efsa foodex2)",
    "FOODON_03316458": "food based on cereals",
    "FOODON_03400906": "10000307 - juice - not ready to drink (frozen) (gs1 gpc)",
    "FOODON_03305087": "grapefruit juice (debittered)",
    "FOODON_03401800": "10006109 - lilac tannia (gs1 gpc)",
    "FOODON_03306546": "nahrzucker",
    "NCBITaxon_124943": "Azadirachta indica",
    "FOODON_00002525": "rhinoceros beetle",
    "FOODON_03302983": "cheese (natural with margarine)",
    "FOODON_03311070": "orange juice concentrate (frozen, high pulp)",
    "FOODON_03414588": "asiatic elephant",
    "FOODON_03542749": "27490 - cheese, triple creme (efsa foodex2)",
    "FOODON_00003375": "sustainable agriculture food product",
    "FOODON_03420234": "testis, milt or soft roe",
    "FOODON_03307122": "potato (whipped, vitamin c enriched, instant)",
    "FOODON_03304061": "cocoa-flavored powder",
    "FOODON_00002073": "oregano food product",
    "FOODON_03480028": "packed in carbon dioxide",
    "FOODON_03542659": "26590 - banteng milk (efsa foodex2)",
    "FOODON_03413079": "dipotassium diphosphate",
    "FOODON_03412942": "broadleaved endive plant",
    "FOODON_03317393": "still wine",
    "FOODON_03310934": "turkey frankfurter",
    "FOODON_03400785": "cured cheese (eurofir)",
    "FOODON_03310465": "hemp oil",
    "FOODON_03540133": "01330 - multigrain bread and rolls (efsa foodex2)",
    "FOODON_03304213": "chicken soup base and seasoning with chicken fat",
    "FOODON_03542980": "29800 - manufactured solid egg roll (efsa foodex2)",
    "FOODON_03543205": "32050 - nectar, mango (efsa foodex2)",
    "FOODON_03316568": "jam (in thermally formed packaging)",
    "FOODON_03307179": "cheese quiche",
    "FOODON_00003213": "coconut oil (hydrogenated)",
    "FOODON_03413897": "rough-head grenadier",
    "FOODON_03414897": "squillid",
    "FOODON_03310683": "fish cake (raw)",
    "FOODON_03310872": "wheat porridge (instant)",
    "FOODON_03301582": "grain product (uncooked)",
    "FOODON_00002774": "garbanzo bean (whole)",
    "FOODON_03412567": "red mullet",
    "FOODON_03307415": "spring mineral water (bottled)",
    "FOODON_03540479": "04790 - other head brassica (p) (efsa foodex2)",
    "FOODON_00003127": "crab apple (whole, raw)",
    "FOODON_03543422": "34220 - minor imitate coffee ingredients (efsa foodex2)",
    "FOODON_03315869": "cheese varietal (pressed)",
    "CHEBI_35131": "aldose phosphate",
    "FOODON_03510180": "reduced saturated fat food",
    "FOODON_03400187": "natural cheese (us cfr)",
    "FOODON_03316363": "animal broth (dried)",
    "FOODON_03412265": "fish, scorpaeniform",
    "CHEBI_17113": "erythritol",
    "FOODON_03302357": "pumpernickel bread",
    "FOODON_03415019": "manna ash plant",
    "CHEBI_22313": "alkaline earth metal atom",
    "HANCESTRO_0369": "Icelandic",
    "FOODON_03304115": "hollandaise sauce mix",
    "FOODON_03411673": "ginseng plant",
    "FOODON_03411921": "carp or minnow family",
    "FOODON_03304731": "coconut cream (canned)",
    "NCBITaxon_7807": "Carcharhinus obscurus",
    "NCBITaxon_4056": "Apocynaceae",
    "FOODON_03317363": "cane sugar liquor",
    "FOODON_03308565": "shrimp cocktail",
    "PATO_0001829": "female pseudohermaphrodite",
    "FOODON_00002319": "trout food product",
    "FOODON_03303398": "kiwifruit (whole, raw)",
    "FOODON_03480038": "packed in olive oil",
    "FOODON_03308887": "sheepshead (raw)",
    "FOODON_03400218": "sandwich (us cfr)",
    "FOODON_03414554": "wood cauliflower",
    "FOODON_03400168": "cured cheese (us cfr)",
    "FOODON_03543788": "37880 - herbal infusions specific for infants and young children, dry (efsa foodex2)",
    "NCBITaxon_146146": "Selar crumenophthalmus",
    "FOODON_03414940": "golden thistle plant",
    "FOODON_03411966": "oil sardine",
    "FOODON_03412701": "iguana",
    "FOODON_03490281": "glass container, coloured, strengthened",
    "FOODON_03500010": "food product contact surface",
    "FOODON_03411415": "asparagus plant",
    "NCBITaxon_218798": "Scomberomorus commerson",
    "FOODON_03302596": "butter and orange conserve",
    "FOODON_03315467": "konnyaku",
    "FOODON_03315482": "wonton pastry (case)",
    "FOODON_00001926": "grape juice food product",
    "FOODON_03307920": "cider vinegar and distilled cider vinegar mixture",
    "FOODON_03540212": "02120 - fine dough without yeast (efsa foodex2)",
    "FOODON_03411353": "hungarian wax pepper plant",
    "FOODON_03541339": "13390 - other aril spices (efsa foodex2)",
    "FOODON_03413922": "goldsaddle goatfish",
    "FOODON_03414895": "akiami paste shrimp",
    "FOODON_03400396": "defoaming agent (codex)",
    "ENVO_00000112": "area of tundra",
    "CHEBI_36587": "organic oxo compound",
    "NCBITaxon_3362": "Podocarpaceae",
    "FOODON_03317055": "confectionery (dried fruit-based, no added sugar)",
    "FOODON_03306191": "lemonade concentrate (liquid)",
    "FOODON_03542713": "27130 - probiotic milk-like drinks (efsa foodex2)",
    "FOODON_03305335": "brown sauce mix",
    "FOODON_03543381": "33810 - tequila and similar spirits (efsa foodex2)",
    "FOODON_03310364": "wheat chaff meal",
    "FOODON_00001832": "emulsified food product",
    "FOODON_03544142": "41420 - lime pickle (efsa foodex2)",
    "FOODON_03307516": "strawberry-flavored beverage syrup",
    "FOODON_03544117": "41170 - bean curd sauce (efsa foodex2)",
    "FOODON_03543992": "39920 - legume (beans) soup, dry (efsa foodex2)",
    "CHEBI_37929": "xanthene dye",
    "NCBITaxon_59291": "Coregonus lavaretus",
    "FOODON_03530071": "food rind or crust",
    "FOODON_03304162": "shortening (white)",
    "FOODON_00002787": "vetch food product",
    "FOODON_03413749": "food supplements, vitamin and mineral substances (ec)",
    "FOODON_03000003": "brown shrimp",
    "FOODON_03303018": "chicken and noodles",
    "FOODON_03542077": "20770 - bovine stomach (efsa foodex2)",
    "NCBITaxon_260976": "Scardinius graecus",
    "FOODON_03413721": "sweet onion plant",
    "PATO_0000592": "decreased thickness",
    "FOODON_03317554": "beverage (aromatized, wine-based)",
    "NCBITaxon_109272": "Ambloplites",
    "FOODON_00002225": "saurel food product",
    "FOODON_03543891": "38910 - french fries from cut potato (efsa foodex2)",
    "FOODON_03304937": "cream of chicken soup mix",
    "FOODON_03311248": "oat bran (raw)",
    "FOODON_03414222": "north american cantaloupe plant",
    "FOODON_03543119": "31190 - animal fats and oils (processed fat from animal tissue) (efsa foodex2)",
    "FOODON_03310032": "sour curry (dish)",
    "NCBITaxon_443752": "Bidyanus bidyanus",
    "FOODON_03308400": "cockle in brine",
    "FOODON_00001751": "codling food product",
    "FOODON_03414033": "four-finger threadfin",
    "FOODON_03414294": "atlantic puffin",
    "NCBITaxon_50459": "Barbarea vulgaris",
    "FOODON_03411814": "chilean croaker",
    "FOODON_03311638": "fish broth",
    "FOODON_03540072": "00720 - maize, milled (efsa foodex2)",
    "NCBITaxon_34256": "Mentha x piperita",
    "FOODON_03308324": "northern anchovy (raw)",
    "FOODON_03401691": "10005836 - mixed species sausages - prepared/processed (gs1 gpc)",
    "FOODON_03541666": "16660 - cashew apples (efsa foodex2)",
    "FOODON_03543744": "37440 - gingko infusion (efsa foodex2)",
    "FOODON_03541175": "11750 - tropical almond (efsa foodex2)",
    "FOODON_03541928": "19280 - sheep fresh meat (efsa foodex2)",
    "FOODON_03544332": "43320 - nutty flavour (efsa foodex2)",
    "FOODON_03542939": "29390 - starchy pudding (efsa foodex2)",
    "FOODON_03543105": "31050 - sesame seed oil, edible (efsa foodex2)",
    "FOODON_03544344": "43440 - peanut butter flavour (efsa foodex2)",
    "FOODON_03317636": "rakugan (food product)",
    "FOODON_03309371": "cheese filling",
    "FOODON_00002776": "lima bean substance",
    "FOODON_03542784": "27840 - cheese, cashel blue (efsa foodex2)",
    "FOODON_03542014": "20140 - veal liver (efsa foodex2)",
    "FOODON_03543290": "32900 - fruit soft drink, nectarine (efsa foodex2)",
    "FOODON_03315387": "chocolate (carbohydrate modified)",
    "FOODON_03315635": "stout (fish, food product)",
    "FOODON_03540599": "05990 - slicing bean (young pods) (efsa foodex2)",
    "CHEBI_30805": "dodecanoic acid",
    "FOODON_03309388": "carrot root (raw, baby, whole)",
    "FOODON_03306267": "soybean powder",
    "FOODON_03540803": "08030 - ceps (efsa foodex2)",
    "FOODON_03411726": "winged bean plant",
    "FOODON_03413286": "sorbitol syrup",
    "NCBITaxon_260673": "Citrullus lanatus var. citroides",
    "FOODON_03315950": "drink (flavored, water-based, energy reduced)",
    "NCBITaxon_4615": "Ananas comosus",
    "FOODON_03543618": "36180 - white deadnettle infusion flowers (efsa foodex2)",
    "FOODON_03316466": "walnut (whole or parts)",
    "FOODON_03414005": "morocco dentex",
    "NCBITaxon_57576": "Hedysarum alpinum",
    "FOODON_03401344": "50251500 - persimmon (gs1 gpc)",
    "FOODON_03412037": "mangosteen tree",
    "FOODON_03311689": "walnut (in oil)",
    "FOODON_03303183": "fruit juice punch beverage base",
    "FOODON_03302271": "gatorade soft drink",
    "FOODON_03413628": "brown tiger prawn",
    "FOODON_03412738": "rough stemmed boletus",
    "FOODON_00003219": "apricot kernel oil",
    "FOODON_03304007": "enchilada sauce",
    "FOODON_03308088": "maine sardine (raw)",
    "FOODON_03460395": "artificial fruit flavoring added",
    "FOODON_00003182": "jojoba bean food product",
    "FOODON_03400765": "069  miscellaneous derived edible products of plant origin (dm) (ccpr)",
    "FOODON_03308396": "cod steak (raw)",
    "FOODON_03530177": "fat content (eurocode2)",
    "NCBITaxon_161926": "Penaeus plebejus",
    "FOODON_03400309": "dietary or therapeutic formulation (us cfr)",
    "FOODON_00000074": "tortoise",
    "FOODON_03309379": "colorado perch (raw)",
    "FOODON_03541656": "16560 - marumi kumquats (efsa foodex2)",
    "FOODON_03543696": "36960 - unspecified hot drink ingredients (efsa foodex2)",
    "FOODON_03413330": "african oil palm plant",
    "FOODON_03301932": "icing (food product)",
    "FOODON_03414932": "strawberry-tomato plant",
    "FOODON_00002894": "rock lobster tail",
    "NCBITaxon_111111": "Melophorus",
    "ENVO_01000658": "dense settlement",
    "FOODON_00002261": "doujiang",
    "FOODON_03541472": "14720 - apples and similar- (efsa foodex2)",
    "FOODON_03542449": "24490 - mackerel (efsa foodex2)",
    "FOODON_03310853": "peanut paste",
    "HANCESTRO_0586": "Bashkir",
    "CHEBI_37021": "purine ribonucleoside 5'-monophosphate",
    "FOODON_03310213": "chocolate drink (thermally processed)",
    "FOODON_03309252": "sturgeon with tomato",
    "FOODON_03309721": "surgeonfish (raw)",
    "NCBITaxon_9938": "Ovis aries musimon",
    "FOODON_03302123": "roselle (dried, ground)",
    "NCBITaxon_31097": "Zeiformes",
    "FOODON_03414030": "spotted bass",
    "FOODON_03302905": "breakfast cereal (presweetened)",
    "GAZ_00007192": "Wallis and Futuna islands",
    "FOODON_03304659": "seltzer water (flavored and sweetened)",
    "FOODON_03542011": "20110 - mammals liver (efsa foodex2)",
    "FOODON_03414481": "mudminnow family",
    "FOODON_03317388": "infant formula (liquid)",
    "FOODON_03500038": "food-grade ceramic surface",
    "ENVO_01001813": "construction",
    "FOODON_00002478": "cherry (whole or parts)",
    "FOODON_00003393": "aquaculture closed containment pen rearing",
    "FOODON_03303223": "salad dressing (standardized)",
    "FOODON_03412906": "smooth rattail",
    "FOODON_03414272": "snow banana plant",
    "FOODON_03541027": "10270 - borlotti or other common beans (without pods) (efsa foodex2)",
    "FOODON_03543691": "36910 - sweet corn (stigmas styles) (efsa foodex2)",
    "FOODON_03317400": "vegetable (unprocessed, deep-frozen)",
    "NCBITaxon_27768": "Istiophoridae",
    "NCBITaxon_443715": "Pseudocaranx wrighti",
    "FOODON_03401881": "10006837 - jams/marmalades/fruit spreads (perishable) (gs1 gpc)",
    "FOODON_03401080": "10000215 - ice cream/ice novelties (frozen) (gs1 gpc)",
    "FOODON_03311266": "stripetail rockfish (raw)",
    "FOODON_03541513": "15130 - beach plums (efsa foodex2)",
    "FOODON_03301848": "maple syrup",
    "NCBITaxon_4671": "Dioscoreaceae",
    "FOODON_03311497": "imitation egg noodle",
    "FOODON_00002616": "avian animal",
    "FOODON_03543589": "35890 - chrysanthemum infusion flowers (efsa foodex2)",
    "FOODON_03401209": "ripened (codex)",
    "FOODON_03411647": "coltsfoot plant",
    "FOODON_03307873": "mexican tea leaf (dry)",
    "FOODON_03541815": "18150 - jam, rose hips (efsa foodex2)",
    "FOODON_03540333": "03330 - cereal bars plain (efsa foodex2)",
    "FOODON_03401686": "10006280 - wild boar - unprepared/unprocessed (gs1 gpc)",
    "NCBITaxon_38578": "Lamna ditropis",
    "NCBITaxon_3564": "Amaranthus",
    "FOODON_03307483": "whole milk curd",
    "FOODON_03307967": "trout (whole, frozen)",
    "FOODON_03302441": "fruit spread",
    "NCBITaxon_210350": "Canarium pimela",
    "FOODON_03306065": "candy (low calorie)",
    "NCBITaxon_3801": "Ribes",
    "FOODON_03543297": "32970 - fruit soft drink, pomegranate (efsa foodex2)",
    "FOODON_03316543": "meat product (tinned)",
    "FOODON_00003404": "common bean pod",
    "FOODON_03411655": "sodium chloride",
    "FOODON_03303096": "cappuccino",
    "FOODON_03411248": "rapeseed plant",
    "FOODON_03542213": "22130 - freshwater fish (efsa foodex2)",
    "FOODON_03540440": "04400 - glassworts (efsa foodex2)",
    "FOODON_03415057": "arctic bramble plant",
    "NCIT_C80251": "Supper",
    "FOODON_03412316": "silver catfish",
    "NCBITaxon_61886": "Cucumis metulifer",
    "FOODON_03305573": "nonfat dry milk (instant, artificially sweetened)",
    "FOODON_03401425": "10006359 - tamarindo (gs1 gpc)",
    "FOODON_03520465": "middle atlantic states",
    "FOODON_03413479": "verbena plant",
    "FOODON_03541178": "11780 - linseeds and similar- (efsa foodex2)",
    "FOODON_03310556": "breakfast cereal (high sugar)",
    "FOODON_03412519": "ground cherry plant",
    "FOODON_03400426": "gelling agent (codex)",
    "NCBITaxon_4710": "Arecaceae",
    "NCBITaxon_42330": "Acipenser naccarii",
    "FOODON_03542776": "27760 - cheese, garrotxa (efsa foodex2)",
    "FOODON_00001831": "emulsified cheese product",
    "NCBITaxon_89947": "Merluccius capensis",
    "FOODON_03412017": "cinnamon fern plant",
    "HANCESTRO_0467": "French Polynesian",
    "FOODON_03303866": "bone meal wafer",
    "FOODON_03305251": "imitation blue cheese dressing (artificially sweetened)",
    "ENVO_01001319": "saline water body",
    "FOODON_03460325": "partial fat removal process, less than 50% remaining",
    "FOODON_03317146": "meringue topping",
    "FOODON_03413800": "chinese alligator",
    "FOODON_03401340": "50251200 - kiwifruits (gs1 gpc)",
    "FOODON_03411651": "Syzygium cumini plant",
    "FOODON_03316110": "vegetable protein-based crustacean analog",
    "FOODON_03543799": "37990 - protein and protein components for sports people (efsa foodex2)",
    "FOODON_03413605": "tristan rock lobster",
    "ENVO_0010003": "agricultural environmental material",
    "FOODON_03309666": "grouper fillet (frozen)",
    "FOODON_03415004": "oregano, syrian (plant)",
    "FOODON_00002959": "macaroni and cheese mix (dried)",
    "GAZ_00004019": "Netherlands Antilles",
    "FOODON_03542621": "26210 - halibut, dried (efsa foodex2)",
    "NCBITaxon_75015": "Caranx latus",
    "FOODON_03307356": "imitation cherry juice",
    "GAZ_00002918": "French Polynesia",
    "FOODON_00001984": "kegani crab food product",
    "FOODON_03307924": "vinegar (made from pear and peach waste, distilled)",
    "FOODON_03540595": "05950 - beans (with pods) and similar- (efsa foodex2)",
    "FOODON_03305409": "nondairy whipped cream topping",
    "FOODON_03315714": "citrus fruit marmalade with pectin",
    "FOODON_03543947": "39470 - veggie pot pie (efsa foodex2)",
    "FOODON_03411772": "bank rockfish",
    "FOODON_03540567": "05670 - devil rattan hearts (efsa foodex2)",
    "CHEBI_38297": "thiabicycloalkane",
    "FOODON_03414966": "saskatoon plant",
    "FOODON_03309305": "magellan smelt (raw)",
    "FOODON_03303102": "espresso coffee bean (roasted, medium ground)",
    "FOODON_03413348": "bastard medic plant",
    "FOODON_03543285": "32850 - fruit soft drink, grape red (efsa foodex2)",
    "NCBITaxon_102329": "Pinctada margaritifera",
    "FOODON_03540226": "02260 - strudel dough (efsa foodex2)",
    "FOODON_03302948": "beans in chili sauce with turtle meat (dish)",
    "FOODON_03415024": "oblique onion plant",
    "FOODON_03304050": "cumberland rum butter",
    "FOODON_03543443": "34430 - tea leaves and stalks decaffeinated (efsa foodex2)",
    "FOODON_03309216": "tilapia (raw)",
    "FOODON_03543549": "35490 - tea tree infusion leaves (efsa foodex2)",
    "FOODON_03460102": "proteolytic fermentation",
    "FOODON_03544177": "41770 - natural food colour (efsa foodex2)",
    "FOODON_03308126": "clam (hard shell, frozen)",
    "GAZ_00005246": "Pakistan",
    "NCBITaxon_61359": "Hiatellidae",
    "FOODON_03401589": "10006078 - lemon verbena (gs1 gpc)",
    "FOODON_03304717": "cheese salad dressing",
    "FOODON_03317433": "breakfast cereal (extruded)",
    "FOODON_00000071": "food cutting process",
    "FOODON_03317174": "drink (sweetened)",
    "FOODON_03415064": "burnet-saxifrage plant",
    "FOODON_03311470": "starch jelly candy",
    "FOODON_03541404": "14040 - other fruit spices (efsa foodex2)",
    "NCBITaxon_1071199": "Pterocarpus santalinus",
    "NCBITaxon_397964": "Pandalus dispar",
    "FOODON_03308802": "shrimp (western-style, breaded)",
    "FOODON_03541636": "16360 - sorb berries (efsa foodex2)",
    "FOODON_00002567": "frog leg",
    "FOODON_03411536": "coconut palm plant",
    "FOODON_03413958": "rough scad",
    "NCBITaxon_3708": "Brassica napus",
    "FOODON_03311855": "fruit juice (powdered)",
    "FOODON_00001871": "food product analog",
    "FOODON_03540362": "03620 - lamb's lettuces (efsa foodex2)",
    "FOODON_03411174": "edible seed producing plant",
    "FOODON_00002782": "soybean pod",
    "FOODON_03544494": "44940 - manganese (efsa foodex2)",
    "FOODON_03510177": "kosher milchlig claim or use",
    "FOODON_03542446": "24460 - jack mackerel (efsa foodex2)",
    "FOODON_03542962": "29620 - ostrich eggs (efsa foodex2)",
    "FOODON_03450029": "deep-frying process",
    "NCBITaxon_49212": "Salvia hispanica",
    "FOODON_03412853": "mycoplasmatales",
    "FOODON_03411752": "eppaw plant",
    "FOODON_03315466": "weaning food",
    "FOODON_03541395": "13950 - sumac fruit (efsa foodex2)",
    "CHEBI_25696": "organic anion",
    "FOODON_03315401": "blancmange powder",
    "FOODON_03415109": "green amaranth plant",
    "FOODON_03304854": "muscadine grape (whole, raw)",
    "FOODON_03310442": "blackberry preserve sweetened with fruit juice",
    "FOODON_03530043": "shoulder (meat cut)",
    "FOODON_03301318": "fish (smoked)",
    "HANCESTRO_0559": "Italian founder",
    "FOODON_03413692": "common squid",
    "GAZ_00000586": "Chad",
    "FOODON_03304510": "strawberry fines (artificially sweetened)",
    "FOODON_03542363": "23630 - mullets (efsa foodex2)",
    "FOODON_03401815": "10006112 - yams (gs1 gpc)",
    "FOODON_00002798": "white hen egg (whole, shell on, raw)",
    "NCBITaxon_23222": "Sorbus",
    "FOODON_03310333": "glacier water",
    "NCBITaxon_426030": "Gratioleae",
    "NCBITaxon_186749": "Thunnini",
    "FOODON_03305795": "ice cream cake roll",
    "NCBITaxon_3602": "Vitaceae",
    "FOODON_03540989": "09890 - alocasia (efsa foodex2)",
    "FOODON_00002187": "rapeseed food product",
    "NCIT_C80248": "Meal",
    "FOODON_03480039": "packed in fruit juice",
    "FOODON_03541136": "11360 - chinese chestnut (efsa foodex2)",
    "FOODON_00001234": "mayonnaise food product",
    "FOODON_03544470": "44700 - neotame (efsa foodex2)",
    "NCBITaxon_273748": "Paralithodes platypus",
    "FOODON_03414578": "bifidobacteriales",
    "FOODON_03309719": "moth bean (whole)",
    "NCBITaxon_305658": "Panicum sumatrense",
    "FOODON_03544446": "44460 - preparations for raising and flavouring home-made bakery (efsa foodex2)",
    "FOODON_03400671": "004  berries and other small fruits (fb) (ccpr)",
    "FOODON_03542578": "25780 - frog meat (rana genus) (efsa foodex2)",
    "FOODON_03305960": "elderberry jelly",
    "FOODON_00001980": "jewfish food product",
    "FOODON_03543318": "33180 - cola beverages, caffeinic (efsa foodex2)",
    "FOODON_03317511": "meat product (jelly coated, cooked)",
    "FOODON_03304540": "whole wheat pita bread",
    "FOODON_03301259": "cloudberry (canned)",
    "FOODON_03309903": "sausage (fermented)",
    "FOODON_03540779": "07790 - other algae (efsa foodex2)",
    "FOODON_03530208": "outdoor/open-air plant cultivation",
    "FOODON_03400149": "milled grain or starch product (us cfr)",
    "FOODON_03542538": "25380 - scallops, pectens (efsa foodex2)",
    "FOODON_03413556": "cuban stone crab",
    "UBERON_0010895": "sequential hermaphroditic organism",
    "FOODON_03541392": "13920 - grain of paradise fruit (efsa foodex2)",
    "FOODON_03411578": "santa claus melon plant",
    "FOODON_03311146": "sauce",
    "FOODON_03540301": "03010 - macaroons (efsa foodex2)",
    "FOODON_03400240": "liqueur (us cfr)",
    "FOODON_03541210": "12100 - safflower seeds (efsa foodex2)",
    "FOODON_03315258": "pancake",
    "FOODON_03311515": "jalapeno pepper (green)",
    "FOODON_03543151": "31510 - blended margarine (efsa foodex2)",
    "FOODON_03413640": "smooth venus",
    "FOODON_03311361": "fruit juice (blended)",
    "NCBITaxon_59499": "Rubus spectabilis",
    "FOODON_03542372": "23720 - dentex (efsa foodex2)",
    "FOODON_00001589": "anchovy food product",
    "FOODON_03414202": "saw palmetto plant",
    "CHEBI_24174": "galacturonan",
    "FOODON_03411275": "lemon plant",
    "FOODON_00003114": "Colorado pinyon tree",
    "FOODON_03413831": "bay anchovy",
    "FOODON_03542988": "29880 - brown sugar (efsa foodex2)",
    "FOODON_03412778": "eugenia capensis plant",
    "FOODON_03317210": "grain-based food",
    "FOODON_03401467": "10005997 - red cabbages (gs1 gpc)",
    "FOODON_03411348": "river herring",
    "FOODON_03460112": "water removal to reconstitution ratio 3 plus 1 or higher",
    "FOODON_03414728": "pandan plant",
    "FOODON_03307177": "quiche",
    "FOODON_00003400": "robusta coffee bean (whole)",
    "NCBITaxon_58219": "Decapterus",
    "FOODON_03315725": "pan coating, lecithin-based, edible",
    "FOODON_03308050": "clam bouillon (food product)",
    "FOODON_03540614": "06140 - vetches (with pods) (efsa foodex2)",
    "FOODON_03413636": "hardshell clam",
    "FOODON_03543000": "30000 - syrups (molasses and other syrups) (efsa foodex2)",
    "FOODON_03413365": "yak",
    "FOODON_03305612": "hen egg white (dried)",
    "FOODON_03316266": "cream dessert",
    "FOODON_03310788": "apple (whole or parts)",
    "FOODON_03542738": "27380 - ricotta (efsa foodex2)",
    "FOODON_03306820": "blackeyed pea (cooked)",
    "FOODON_03310060": "pink bean (whole)",
    "FOODON_03542565": "25650 - squid, short finned (efsa foodex2)",
    "FOODON_03307053": "frankfurter (in bun)",
    "FOODON_00001024": "pickled cabbage food product",
    "FOODON_03302325": "shrimp ball (dish, frozen)",
    "FOODON_03316708": "cheese leidse",
    "FOODON_03310561": "infant formula (soy-based)",
    "NCBITaxon_42891": "Engraulis",
    "FOODON_03305772": "lime juice (sweetened, diluted)",
    "FOODON_03303662": "spiced cheese",
    "ENVO_01000480": "glass",
    "NCBITaxon_34815": "Morone",
    "FOODON_03315978": "ice, edible, energy reduced",
    "FOODON_03413331": "benjamin tree",
    "HANCESTRO_0337": "Jamaican",
    "NCBITaxon_93297": "Metroxylon sagu",
    "NCBITaxon_30942": "Pleuronectoidei",
    "FOODON_03411167": "sugar maple plant",
    "FOODON_00002177": "prune juice food product",
    "FOODON_03316602": "fruit ice",
    "FOODON_03309096": "halibut steak (breaded)",
    "FOODON_03412656": "squirrelfish",
    "NCBITaxon_91214": "Juglans cinerea",
    "FOODON_03310652": "canola and olive oil blend",
    "FOODON_03540633": "06330 - tomatoes (efsa foodex2)",
    "FOODON_03413011": "beetroot red, betanin",
    "CHEBI_31608": "Ferrous gluconate",
    "FOODON_03315496": "an (rice-based)",
    "GAZ_00001551": "Jersey",
    "FOODON_03544457": "44570 - sourdough starter (efsa foodex2)",
    "FOODON_00003159": "seafood sandwich",
    "FOODON_03540593": "05930 - other bulb vegetables (efsa foodex2)",
    "FOODON_03541240": "12400 - olives for oil production (efsa foodex2)",
    "FOODON_03543933": "39330 - pizza and similar with processed meat topping (efsa foodex2)",
    "FOODON_03542256": "22560 - indonesian snakehead (efsa foodex2)",
    "FOODON_03315649": "meat (preserved)",
    "FOODON_03303535": "cottage cheese with fruit added",
    "NCBITaxon_4335": "Primulaceae",
    "FOODON_03542651": "26510 - milk (efsa foodex2)",
    "FOODON_03490102": "plastic squeeze bottle or tube",
    "FOODON_03310033": "beef curry",
    "FOODON_03542190": "21900 - cervelat (swiss type) (efsa foodex2)",
    "FOODON_03305331": "vegetable goulash (hungarian-style)",
    "FOODON_03544135": "41350 - apple chutney (efsa foodex2)",
    "FOODON_03316527": "beverage with added fruit juice",
    "FOODON_03400975": "50221300 - cereal/grain/pulse products variety packs (gs1 gpc)",
    "FOODON_03412380": "striped weakfish",
    "FOODON_03311499": "lemon breezer wine-based beverage",
    "FOODON_03301176": "clove (whole, dried)",
    "FOODON_03414964": "buffaloberry plant",
    "FOODON_00001091": "dried milk food product",
    "FOODON_03414902": "earthworm",
    "FOODON_03307567": "shake mix (artificially sweetened, dry)",
    "FOODON_03305294": "banana (canned)",
    "FOODON_03311268": "grape drink",
    "NCBITaxon_197794": "Plantago indica",
    "FOODON_03301159": "lobster (raw)",
    "FOODON_03540232": "02320 - pre-mixes (dry) for baked products (efsa foodex2)",
    "FOODON_03510032": "dietary use/label claim",
    "FOODON_03411514": "octopus",
    "NCBITaxon_4674": "Hypoxidaceae",
    "NCBITaxon_349654": "Epigonus telescopus",
    "GAZ_00003902": "Malaysia",
    "FOODON_03401885": "10006459 - sea lavender (gs1 gpc)",
    "NCBITaxon_41492": "Bellis perennis",
    "FOODON_03302505": "fudge bar (double walnut)",
    "FOODON_03543658": "36580 - other herbal infusion materials from roots (efsa foodex2)",
    "FOODON_00003347": "slightly ripe",
    "FOODON_03301856": "boysenberry (unsweetened, frozen)",
    "NCBITaxon_6764": "Gecarcinidae",
    "FOODON_03315125": "pecan pie filling",
    "NCBITaxon_23513": "Rutaceae",
    "NCBITaxon_2870": "Phaeophyceae",
    "FOODON_00002980": "kelp gull",
    "FOODON_03309709": "eggplant (whole, raw)",
    "FOODON_03412087": "loose leaf lettuce plant",
    "FOODON_03311875": "rice (unhulled)",
    "FOODON_03490193": "plastic container, blow-molded",
    "NCBITaxon_3747": "Fragaria x ananassa",
    "FOODON_03316905": "prune (whole or parts)",
    "FOODON_03315108": "tangerine",
    "FOODON_03310188": "belgian carrot (raw, whole)",
    "FOODON_03542374": "23740 - emperors (efsa foodex2)",
    "FOODON_03310043": "rapeseed meal",
    "FOODON_03401755": "10006195 - pepper variety packs (gs1 gpc)",
    "FOODON_00003107": "sea buckthorn berry",
    "FOODON_03414180": "green oyster",
    "FOODON_03414020": "dusky sea perch",
    "FOODON_03308075": "fish flesh (comminuted)",
    "FOODON_00001843": "field corn custard food product",
    "CHEBI_33457": "phosphorus oxoacid",
    "FOODON_00001199": "chickpea food product",
    "FOODON_03308108": "saury (canned)",
    "GENEPIO_0002751": "chicken leg",
    "FOODON_03413960": "mackerel scads (Decapterus spp)",
    "FOODON_03542246": "22460 - clarias catfish (generic) (efsa foodex2)",
    "ENVO_01000320": "marine environment",
    "FOODON_00003344": "chicken fillet",
    "FOODON_03543495": "34950 - golden root infusion leaves (efsa foodex2)",
    "FOODON_03541298": "12980 - angelica seed (efsa foodex2)",
    "FOODON_03316106": "vegetable protein-based meat analog",
    "FOODON_03460287": "partial alcohol removal process",
    "FOODON_03308192": "king crab (raw)",
    "FOODON_03308194": "clam (pacific coast littleneck, raw)",
    "FOODON_00002311": "tarragon food product",
    "FOODON_03310715": "obsolete: confectionery, not further specified",
    "FOODON_03541250": "12500 - oil palms fruits and similar- (efsa foodex2)",
    "FOODON_03315713": "sweetened coating mix for snack food",
    "NCBITaxon_121718": "Tilia tomentosa",
    "FOODON_03543785": "37850 - pasta for children (dry, to be cooked) (efsa foodex2)",
    "FOODON_03304874": "sesame seed (roasted)",
    "FOODON_03306869": "peanut butter with smoky crisps",
    "FOODON_03544089": "40890 - balsamic vinegar and similar (efsa foodex2)",
    "FOODON_03543383": "33830 - vodka and vodka-like spirits (efsa foodex2)",
    "FOODON_03414329": "sugar loaf chicory plant",
    "FOODON_03542226": "22260 - carp, indian (generic) (efsa foodex2)",
    "FOODON_03401729": "10006251 - vegetable juice - ready to drink (perishable) (gs1 gpc)",
    "FOODON_03301076": "obsolete: cheese (not further specified)",
    "NCBITaxon_72087": "Sebastes miniatus",
    "FOODON_03302478": "multigrain bread",
    "FOODON_03311440": "peach kernel oil",
    "FOODON_03430109": "food (liquid, low viscosity)",
    "FOODON_00002381": "food product by organism",
    "FOODON_03302981": "fish byproduct for animal feed",
    "NCBITaxon_377473": "Bunium bulbocastanum",
    "NCBITaxon_6563": "Ostreidae",
    "FOODON_03308209": "japanese red salmon (raw)",
    "FOODON_03306941": "cherry dill pickle",
    "FOODON_03542016": "20160 - sheep liver (efsa foodex2)",
    "CHEBI_51143": "nitrogen molecular entity",
    "CHEBI_32588": "potassium chloride",
    "FOODON_03411474": "comello plant",
    "FOODON_03304270": "apple wine (sparkling)",
    "PATO_0001713": "decreased perimeter",
    "FOODON_03303161": "cookie mix (low calorie)",
    "FOODON_03302525": "flour (hydrolyzed)",
    "FOODON_03310906": "compressed yeast (fresh, refrigerated)",
    "FOODON_03543305": "33050 - soft drink, banana flavour (efsa foodex2)",
    "NCBITaxon_166755": "Periophthalmus barbarus",
    "CHEBI_29347": "monocarboxylic acid amide",
    "FOODON_03542567": "25670 - seafood offal (efsa foodex2)",
    "FOODON_03305773": "passion fruit juice (frozen)",
    "FOODON_03311106": "konnyaku-ko",
    "NCBITaxon_3709": "Brassica napus subsp. rapifera",
    "FOODON_03540151": "01510 - crisp bread, rye wholemeal (efsa foodex2)",
    "NCBITaxon_290983": "Paullinia",
    "FOODON_03306401": "imitation marmalade",
    "FOODON_03315001": "beverage base, dry, instant tea",
    "FOODON_03317602": "meat product (low sodium)",
    "NCBITaxon_45918": "Empetrum",
    "FOODON_03316393": "cauliflower (dried)",
    "FOODON_03430155": "edible tablet",
    "FOODON_03541985": "19850 - animal fresh fat tissues (efsa foodex2)",
    "HANCESTRO_0582": "Tibetan",
    "FOODON_03400456": "CIAA confectionary",
    "FOODON_03542985": "29850 - white sugar (efsa foodex2)",
    "FOODON_03490353": "laminated paper-aluminium-plastic wrapper",
    "FOODON_03540474": "04740 - head cabbages (efsa foodex2)",
    "FOODON_03303652": "cheese (alcohol added)",
    "FOODON_03543302": "33020 - soft drink with bitter principle (efsa foodex2)",
    "FOODON_03308897": "tauvina grouper (raw)",
    "NCBITaxon_6533": "Helicidae",
    "FOODON_03414482": "alaska blackfish",
    "FOODON_03412964": "spanish plum plant",
    "FOODON_03316906": "berry (impregnated with sugar)",
    "NCBITaxon_3010": "Fucaceae",
    "FOODON_03530045": "breast (meat cut)",
    "FOODON_03316302": "invert sugar cream",
    "NCBITaxon_7968": "Catostomidae",
    "FOODON_03400688": "027  herbs (hh) (ccpr)",
    "FOODON_03307089": "prune (whole, cooked)",
    "FOODON_03510076": "naturally rich in fiber claim or use",
    "FOODON_03543264": "32640 - tap water (efsa foodex2)",
    "FOODON_03301706": "mussel (raw)",
    "NCBITaxon_1609961": "Chrysophylloideae",
    "FOODON_03543060": "30600 - fudge (efsa foodex2)",
    "FOODON_03412529": "climbing perch",
    "FOODON_03305979": "orange juice drink beverage base (frozen, artificially colored)",
    "CHEBI_33989": "alkaline earth hydroxide",
    "FOODON_03306503": "bologna",
    "CHEBI_24873": "iron molecular entity",
    "NCBITaxon_119830": "Solanum torvum",
    "FOODON_03543719": "37190 - fig coffee infusion (efsa foodex2)",
    "FOODON_03540826": "08260 - chervil and similar- (efsa foodex2)",
    "FOODON_03400450": "wetting agent (codex)",
    "FOODON_03303220": "dessert food",
    "FOODON_03306619": "dumpling",
    "FOODON_00002932": "hazelnut food product",
    "FOODON_03307523": "coconut syrup",
    "CHEBI_73155": "trienoic fatty acid",
    "FOODON_03541487": "14870 - loquats and similar- (efsa foodex2)",
    "FOODON_03317507": "potato (pre-fried, sliced)",
    "FOODON_03308345": "lobster tomalley (raw)",
    "FOODON_03306734": "white peppercorn (whole, raw)",
    "FOODON_03543583": "35830 - rose infusion flowers (efsa foodex2)",
    "NCBITaxon_76917": "Cheilodactylidae",
    "GAZ_00001251": "Barbados",
    "FOODON_03301153": "clam (raw)",
    "FOODON_03490147": "paperboard container with aluminum foil liner",
    "FOODON_03541678": "16780 - kaki and similar- (efsa foodex2)",
    "NCBITaxon_1489739": "Characoidei",
    "FOODON_03308521": "cod fillet (smoked)",
    "FOODON_03400992": "50101600 - fruit - unprepared/unprocessed (gs1 gpc)",
    "NCBITaxon_3346": "Pinus pinea",
    "FOODON_03412395": "brown algae",
    "NCBITaxon_278729": "Micropogonias furnieri",
    "FOODON_03542874": "28740 - cheese, emmental (efsa foodex2)",
    "NCBITaxon_169705": "Cocoseae",
    "FOODON_00002931": "halva",
    "FOODON_03414963": "Myrica",
    "FOODON_03540053": "00530 - durra grain (efsa foodex2)",
    "FOODON_03304712": "english dressing",
    "FOODON_03317475": "vegetable protein drink",
    "FOODON_03412869": "cutthroat trout",
    "FOODON_00001937": "greenland halibut food product",
    "FOODON_03303862": "spiced cheese (frisian clove)",
    "HANCESTRO_0519": "South African",
    "FOODON_03412178": "horse-eye jack",
    "FOODON_03305576": "fish roe",
    "NCBITaxon_134615": "Alepocephalidae",
    "FOODON_03316483": "jelly powder",
    "FOODON_00001177": "insect food product",
    "FOODON_03315502": "peach (whole)",
    "FOODON_03414518": "common chokeberry plant",
    "FOODON_03307807": "ham sandwich",
    "FOODON_03305861": "imitation black raspberry jam",
    "FOODON_03302930": "chocolate sandwich cookie (cream-filled)",
    "FOODON_03311194": "whole wheat kernel (dried)",
    "FOODON_03544161": "41610 - gluten (efsa foodex2)",
    "NCBITaxon_33554": "Carnivora",
    "FOODON_03420268": "skeletal meat part, without bone, without skin",
    "FOODON_00002358": "whey based formula food product",
    "FOODON_03470141": "natural heat drying",
    "FOODON_03304841": "cow milk (eggnog-flavored)",
    "FOODON_03413018": "brilliant black bn, black pn",
    "CHEBI_77868": "potassium sorbate",
    "FOODON_03544485": "44850 - vitamin e      (tocopherols, tocotrienols) (efsa foodex2)",
    "FOODON_03308536": "langostino colorado (raw)",
    "FOODON_03302926": "fish patty",
    "FOODON_03317008": "oyster (fresh)",
    "FOODON_03309630": "brook trout (raw)",
    "FOODON_03543021": "30210 - lactitol (efsa foodex2)",
    "NCBITaxon_115442": "Arenga",
    "FOODON_03411025": "sole family",
    "FOODON_03413387": "tropical or subtropical fruit - edible peel plant",
    "FOODON_03310193": "quinoa seed (dried)",
    "FOODON_03303208": "durum wheat (ground)",
    "FOODON_03541431": "14310 - tangelos (except minneolas) (efsa foodex2)",
    "FOODON_03542441": "24410 - barracudas (efsa foodex2)",
    "NCBITaxon_1428164": "Sorghum sudanense",
    "FOODON_03541779": "17790 - breadfruits (efsa foodex2)",
    "FOODON_03543083": "30830 - caramel, soft (efsa foodex2)",
    "FOODON_03544487": "44870 - chemical elements (efsa foodex2)",
    "FOODON_03543145": "31450 - goat milk fat (efsa foodex2)",
    "FOODON_03309610": "chilean langostino newberg (dish)",
    "FOODON_03310225": "hen egg white (fried)",
    "NCBITaxon_3493": "Ficus <eudicots>",
    "FOODON_03540534": "05340 - flowers used as vegetables (efsa foodex2)",
    "FOODON_03490324": "butyrate cellulose film",
    "FOODON_03543044": "30440 - chocolate spread (efsa foodex2)",
    "GAZ_00004439": "State of Indiana",
    "FOODON_03543596": "35960 - elder infusion flowers (efsa foodex2)",
    "FOODON_03411941": "australian ruff",
    "FOODON_03302668": "wine (canned)",
    "FOODON_03301847": "cane syrup",
    "FOODON_03316496": "ices (commercial, packed)",
    "FOODON_03309681": "salmon (tips and tails, raw)",
    "FOODON_03413986": "cero",
    "FOODON_03414796": "northern brushtail possum",
    "FOODON_03310486": "palm kernel oil",
    "FOODON_03309952": "cattle feed",
    "FOODON_03400329": "antioxidant (ec)",
    "FOODON_03541127": "11270 - pili nuts (efsa foodex2)",
    "FOODON_03309620": "bonito (raw)",
    "FOODON_03400288": "chocolate candy",
    "FOODON_03414111": "leopard shark",
    "FOODON_03304135": "dog food (chicken-flavored)",
    "FOODON_03303178": "cocoa mass (fat-free)",
    "NCBITaxon_8573": "Boa",
    "FOODON_03413690": "giant pangasius",
    "FOODON_03543521": "35210 - mallow infusion leaves (efsa foodex2)",
    "NCBITaxon_6451": "Haliotidae",
    "FOODON_03413562": "bigtooth rock crab",
    "NCBITaxon_13225": "Pomatoschistus minutus",
    "FOODON_03414937": "spine gourd plant",
    "FOODON_03412512": "african rice plant",
    "FOODON_03543112": "31120 - other plant oils (efsa foodex2)",
    "FOODON_00002789": "chickpea (whole, dried)",
    "FOODON_03430152": "divided into pieces",
    "FOODON_03411244": "loquat plant",
    "FOODON_03307222": "watermelon rind (preserved in syrup)",
    "FOODON_03311757": "leek (whole, raw)",
    "FOODON_03400448": "texturizer (codex)",
    "FOODON_03304372": "gummy mice candy",
    "FOODON_03543080": "30800 - macaroon mass (efsa foodex2)",
    "FOODON_03541213": "12130 - borage seeds and similar- (efsa foodex2)",
    "FOODON_03400151": "sweet roll or sweet bun (us cfr)",
    "FOODON_03544208": "42080 - blueberry flavour (efsa foodex2)",
    "FOODON_03302143": "bourbon ball",
    "FOODON_03411338": "pea plant",
    "FOODON_03413885": "patagonian grenadier",
    "PO_0030093": "septicidal capsule fruit",
    "CHEBI_37734": "phosphoric ester",
    "FOODON_03317304": "chili con carne with beans (dish, vegetarian)",
    "FOODON_03316472": "candy gum-type",
    "GAZ_00006909": "Saint Lucia",
    "UBERON_0009097": "gravid organism",
    "HANCESTRO_0309": "Sardinian",
    "FOODON_03401138": "10000630 - aquatic invertebrates/fish/shellfish/seafood mixes - unprepared/unprocessed (perishable) (gs1 gpc)",
    "FOODON_00002049": "mushroom soup food product",
    "FOODON_03490266": "ceramic or earthenware jar, coloured",
    "FOODON_03401764": "10006338 - crabapples (gs1 gpc)",
    "FOODON_03305531": "comb honey",
    "CHEBI_25000": "lactone",
    "FOODON_03400659": "11  primary food commodities of plant origin (ccpr)",
    "FOODON_03315056": "filling dairy (frozen)",
    "FOODON_03312038": "vegetable pie (baked)",
    "NCBITaxon_613112": "Boswellia serrata",
    "FOODON_03414743": "maloga bean plant",
    "NCBITaxon_72046": "Hippocampus",
    "FOODON_03401271": "USDA SR dairy and egg products (0100)",
    "FOODON_03543554": "35540 - white deadnettle infusion leaves (efsa foodex2)",
    "ENVO_00000016": "sea",
    "FOODON_03307170": "cranberry (pressed)",
    "FOODON_03541805": "18050 - jam of fruit / vegetables (efsa foodex2)",
    "FOODON_03541720": "17200 - red pitayas (efsa foodex2)",
    "NCBITaxon_169191": "Schinus terebinthifolia",
    "FOODON_03301234": "vinegar made from dried apple cores and skins",
    "FOODON_03308680": "oyster stew",
    "FOODON_03301886": "ground beef (raw)",
    "FOODON_03543019": "30190 - polyols (efsa foodex2)",
    "FOODON_03307475": "cream (sterilized, frozen)",
    "FOODON_03301703": "oyster (raw)",
    "FOODON_03309500": "anchovy paste (colored with iron oxide)",
    "NCBITaxon_162743": "Dialium guineense",
    "FOODON_03490174": "wood container",
    "UO_0010046": "united states customary cup",
    "FOODON_03311826": "chicken (ground or minced)",
    "NCBITaxon_3589": "Basella alba",
    "FOODON_03530128": "poitrine",
    "NCBITaxon_477864": "Eryngium foetidum",
    "FOODON_03304808": "corn puff (cheese-coated)",
    "FOODON_03401611": "10006268 - loose leaf/multileaf lettuce other (gs1 gpc)",
    "FOODON_03401221": "0100000 - 1. fruit fresh or frozen; nuts (ec)",
    "FOODON_03543104": "31040 - safflower seed oil, edible (efsa foodex2)",
    "FOODON_03315454": "tonkatsu sauce",
    "FOODON_00001069": "fermented fruit food product",
    "FOODON_03316160": "cephalopod (raw)",
    "FOODON_00002519": "chicken (boneless, cooked)",
    "FOODON_03305595": "lemon grass tea (steeped)",
    "FOODON_03309215": "nile perch (raw)",
    "FOODON_00001709": "cereal food product",
    "FOODON_03307358": "herring tidbit in port wine sauce",
    "FOODON_03541888": "18880 - duck carcase (efsa foodex2)",
    "FOODON_03316557": "confectionery (commercial, individually packed)",
    "FOODON_03304344": "tempura batter",
    "UO_0010042": "tablespoon",
    "NCBITaxon_9922": "Capra",
    "FOODON_03304708": "potato salad",
    "FOODON_00002628": "Grenache grape plant",
    "FOODON_03411396": "menhaden",
    "FOODON_03460195": "potassium added",
    "FOODON_03540886": "08860 - spearmint (efsa foodex2)",
    "FOODON_03530017": "cull grade",
    "FOODON_03544519": "45190 - carnitine (efsa foodex2)",
    "GAZ_00005812": "Ile Tromelin",
    "FOODON_03413477": "rudd",
    "FOODON_03411246": "obsolete: pineapple and grapefruit",
    "FOODON_03317175": "butter (concentrated)",
    "FOODON_03413108": "glycerol esters of wood rosins",
    "FOODON_03302305": "fish paste made from salmon and other fish",
    "NCBITaxon_48106": "Centella asiatica",
    "FOODON_03412413": "diamondback terrapin",
    "FOODON_03541427": "14270 - shaddocks (efsa foodex2)",
    "NCBITaxon_1234273": "Tachysurus fulvidraco",
    "FOODON_03414813": "belitong snail",
    "GAZ_00000584": "Mali",
    "FOODON_03543087": "30870 - gelatine dessert (efsa foodex2)",
    "NCBITaxon_6608": "Sepiidae",
    "FOODON_03413833": "pacific anchoveta",
    "NCBITaxon_34819": "Glyptocephalus cynoglossus",
    "NCBITaxon_171249": "Citrus limonia",
    "FOODON_03308832": "crab (deviled, shrimp added, in aluminum shell)",
    "FOODON_03307491": "evaporated skim milk",
    "GAZ_00000553": "South Africa",
    "CHEBI_35276": "ammonium compound",
    "FOODON_03414570": "great black-backed gull",
    "FOODON_03308369": "louisiana lobster (raw)",
    "FOODON_03305852": "chocolate and cocoa ice cream",
    "FOODON_03415033": "corn gromwell plant",
    "FOODON_00002052": "mustard condiment food product",
    "FOODON_03542573": "25730 - jellyfishes and similar (efsa foodex2)",
    "FOODON_03543916": "39160 - vegetable souffl\u00e9 (efsa foodex2)",
    "NCBITaxon_59757": "Metanephrops mozambicus",
    "CHEBI_25107": "magnesium atom",
    "FOODON_03411323": "rabbit",
    "FOODON_03400169": "gelatin dessert (us cfr)",
    "FOODON_03400412": "flavour enhancer (codex)",
    "FOODON_03412296": "devil ray",
    "NCBITaxon_308558": "Echinacea angustifolia",
    "CHEBI_22563": "anion",
    "FOODON_03530189": "fat content >= 3.5%",
    "FOODON_03307326": "fish (salted)",
    "FOODON_03307083": "diabetic preserves",
    "FOODON_03311506": "pork kidney",
    "FOODON_03317402": "fish (unprocessed, frozen)",
    "FOODON_03309329": "whiting (frozen)",
    "FOODON_03414829": "black plum plant",
    "FOODON_00001015": "plant food product",
    "FOODON_03544511": "45110 - caffeine (efsa foodex2)",
    "HANCESTRO_0495": "Lao",
    "FOODON_03310739": "bilberry juice (food product)",
    "NCBITaxon_1294634": "Crocodylia",
    "FOODON_03308539": "lobster leg meat (raw)",
    "FOODON_03542329": "23290 - dab or common dab (efsa foodex2)",
    "FOODON_03305342": "gelatin dessert",
    "FOODON_03306770": "pineapple pie",
    "FOODON_03542148": "21480 - breakfast-type sausage (efsa foodex2)",
    "FOODON_03413381": "sainfoin plant",
    "FOODON_03309474": "tomato product (canned)",
    "GAZ_00002650": "Italy",
    "FOODON_03315918": "dietary food supplement",
    "FOODON_00003203": "food harvesting",
    "FOODON_03315053": "fruit topping",
    "FOODON_03307277": "cold-pack blue cheese",
    "FOODON_00001226": "fruit preserve or jam food product",
    "NCBITaxon_65351": "Lepidium campestre",
    "FOODON_03412676": "silver gemfish",
    "FOODON_03301744": "grunt (raw)",
    "NCBITaxon_43238": "Exocarpos",
    "CHEBI_38264": "2-amino-3-methylpentanoic acid",
    "FOODON_03310035": "chinaberry leaf (raw)",
    "FOODON_03541742": "17420 - plantains - acuminata cultivars (efsa foodex2)",
    "CHEBI_25701": "organic oxide",
    "FOODON_03413420": "winter-purslane plant",
    "FOODON_03315889": "oil topping",
    "FOODON_03304514": "mint-flavored beverage syrup",
    "FOODON_03315954": "dessert (flavored, water-based, energy reduced)",
    "FOODON_03412824": "chinese banyan plant",
    "FOODON_03544462": "44620 - artificial sweeteners (e.g., aspartam, saccharine) (efsa foodex2)",
    "NCBITaxon_934694": "Squalus blainville",
    "FOODON_03308503": "imitation stew beef",
    "FOODON_03412531": "duckbill flathead",
    "FOODON_03301474": "corn oil",
    "FOODON_03311411": "english walnut meat",
    "FOODON_03316627": "caramel hard",
    "FOODON_03460253": "curing or aging",
    "FOODON_03540392": "03920 - baby leaf spinaches (efsa foodex2)",
    "FOODON_00001133": "condiment food product",
    "FOODON_00002924": "green cardamom",
    "FOODON_03412711": "grayling",
    "GAZ_00002846": "Northeast Asia",
    "FOODON_03317249": "horseradish (grated, frozen, blanched)",
    "FOODON_03308280": "sea catfish (raw)",
    "FOODON_03540118": "01180 - wheat bread and rolls (efsa foodex2)",
    "FOODON_0002000": "apple (peeled)",
    "FOODON_00001823": "durum wheat flour food product",
    "FOODON_03413787": "d-alpha-tocopheryl succinate",
    "NCBITaxon_172269": "Argyrosomus regius",
    "FOODON_03308587": "blue king crab (raw)",
    "FOODON_03316172": "horseradish pulp",
    "FOODON_03316955": "macaroni product (wheat and soy)",
    "FOODON_03401409": "10006168 - avocados - pebbled peel (hass-type) (gs1 gpc)",
    "FOODON_03315567": "cream powder-like product",
    "FOODON_03413318": "trisodium diphosphate",
    "FOODON_03542887": "28870 - cheese, murcia (efsa foodex2)",
    "FOODON_03317077": "potato product",
    "FOODON_03400954": "10000172 - cakes - sweet (shelf stable) (gs1 gpc)",
    "FOODON_03401665": "10006290 - guinea fowl - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03309429": "flying squid (raw)",
    "NCBITaxon_182129": "Ficus sycomorus",
    "FOODON_03316763": "vanilla extract (concentrated)",
    "UO_0000010": "second",
    "FOODON_03315115": "soft drink (carbonated, canned)",
    "FOODON_03412920": "black plum plant",
    "FOODON_03301357": "cashew nut (whole, raw)",
    "FOODON_00001077": "salt pork meat food product",
    "FOODON_03306040": "barley malt",
    "FOODON_03540294": "02940 - apple strudel (efsa foodex2)",
    "FOODON_03310443": "black cherry yogurt",
    "NCBITaxon_1174713": "Acacia cf. aneura 'Pilbara'",
    "FOODON_03530175": "oil content < 25%",
    "FOODON_03301630": "lemonade",
    "FOODON_03400824": "nut or seed product (eurofir)",
    "FOODON_03400303": "reptile, amphibian, insect, etc. meat or meat product (us cfr)",
    "FOODON_00002108": "pectin producing plant fruit food product",
    "FOODON_03309465": "pheasant consomme with sherry wine (food product)",
    "FOODON_03401797": "10006124 - horseradish (gs1 gpc)",
    "FOODON_00001158": "pomaceous fruit food product",
    "CHEBI_27363": "zinc atom",
    "FOODON_03303583": "parmesan cheese (uncured)",
    "FOODON_00002359": "cow whey food product",
    "FOODON_03308761": "belon oyster (raw)",
    "FOODON_03311277": "ribier grape (whole, raw)",
    "NCBITaxon_445212": "Pleoticus",
    "FOODON_03301206": "century plant juice",
    "FOODON_03412671": "antarctic cutlerfish",
    "FOODON_03306104": "lingonberry (whole, raw)",
    "FOODON_00001687": "carrot food product",
    "CHEBI_33917": "aldohexose",
    "FOODON_03302176": "grape jam",
    "CHEBI_27007": "tin atom",
    "NCBITaxon_167484": "Asclepiadoideae",
    "FOODON_03412040": "juniper plant",
    "FOODON_03412369": "vendace",
    "FOODON_03540385": "03850 - red mustard leaves and similar- (efsa foodex2)",
    "NCBITaxon_85415": "Gobius auratus",
    "FOODON_03510130": "\"high\" label claim",
    "HANCESTRO_0490": "Pakistani",
    "FOODON_03306321": "marrow (ginger added)",
    "FOODON_03400732": "09  fruit and fruit products (eurocode2)",
    "FOODON_03520470": "u.s. protectorates",
    "FOODON_03301277": "wheat (polished)",
    "NCBITaxon_281464": "Plecoglossus altivelis altivelis",
    "FOODON_00002994": "ancho pepper",
    "FOODON_03304777": "rice and peas (frozen)",
    "FOODON_03401191": "10000056 - sauces - cooking (frozen) (gs1 gpc)",
    "FOODON_03309036": "stockfish (soaked)",
    "FOODON_03413571": "dana swimming crab",
    "CHEBI_26401": "purines",
    "FOODON_03542327": "23270 - marine fish (efsa foodex2)",
    "FOODON_00001609": "apple based alcoholic beverage",
    "FOODON_03541784": "17840 - soursops and similar- (efsa foodex2)",
    "FOODON_03430171": "solution for infusion",
    "FOODON_03311623": "grape spread low-sugar",
    "FOODON_03541999": "19990 - camel fat tissue (efsa foodex2)",
    "FOODON_03304351": "catfish (smoked with sodium nitrate and sodium nitrite)",
    "FOODON_03400922": "10000594 - non alcoholic beverages variety packs - ready to drink (gs1 gpc)",
    "FOODON_03401799": "10006344 - jicama bean (gs1 gpc)",
    "ENVO_01001780": "desert ecosystem",
    "FOODON_03305504": "green bean (french-style, quick-frozen)",
    "FOODON_03308844": "golden king crab (raw)",
    "FOODON_03413334": "sweet fennel plant",
    "FOODON_03543397": "33970 - cream liqueur (efsa foodex2)",
    "FOODON_03413711": "hartwort plant",
    "FOODON_03311464": "imitation soy sauce from rapeseed meal",
    "CHEBI_22660": "aspartic acid",
    "FOODON_03302008": "vegetable (raw)",
    "FOODON_03412402": "white sucker",
    "FOODON_03544486": "44860 - vitamin k     (phylloquinone, menaquinones) (efsa foodex2)",
    "FOODON_03415036": "great pignut plant",
    "FOODON_00001781": "cow milk sherbet food product",
    "FOODON_03306178": "fruit juice (artificially sweetened)",
    "FOODON_00002579": "fryer-roaster turkey",
    "FOODON_03308212": "sockeye salmon (raw)",
    "FOODON_03544144": "41440 - mixed pickle (efsa foodex2)",
    "FOODON_03308310": "langostino imperial (deviled, frozen)",
    "FOODON_03542694": "26940 - yoghurt, cow milk (efsa foodex2)",
    "FOODON_03307882": "sour cream topping",
    "NCBITaxon_5270": "Ustilago maydis",
    "RO_0002221": "surrounds",
    "FOODON_03310732": "pomegranate wine (food product)",
    "FOODON_03306829": "fish (salted, dried)",
    "FOODON_03530028": "short plate",
    "FOODON_00002704": "chicken (whole)",
    "FOODON_03308675": "shrimp (undeveined, raw)",
    "FOODON_03315508": "gruel or porridge for infants and young children",
    "FOODON_03307033": "idaho potato (whole, raw)",
    "FOODON_03542367": "23670 - japanese seabass (efsa foodex2)",
    "FOODON_03317593": "irish stew",
    "FOODON_03306381": "jelly marmalade",
    "FOODON_03413492": "brown prawn",
    "FOODON_03414927": "salak palm plant",
    "FOODON_00002347": "wheat based bakery food product",
    "FOODON_03309854": "beef (baked)",
    "UBERON_0001723": "tongue",
    "FOODON_03303563": "boysenberry (in light syrup, canned)",
    "FOODON_03302411": "lemon soda",
    "FOODON_03412790": "gambeya plant",
    "FOODON_03414691": "mistletoe plant",
    "FOODON_03530209": "conventional outdoor/open-air cultivation",
    "FOODON_03412664": "obsolete: corvina",
    "NCBITaxon_4538": "Oryza glaberrima",
    "FOODON_03540911": "09110 - lemongrass (efsa foodex2)",
    "FOODON_03400446": "tableting aid (codex)",
    "FOODON_03544518": "45180 - co-factors to metabolism (efsa foodex2)",
    "FOODON_03304787": "lung so tea (dry)",
    "FOODON_03316009": "grape juice (unfermented, for sacramental use)",
    "FOODON_03414216": "italian tangerine plant",
    "GAZ_00067143": "Martinique Region",
    "FOODON_00001995": "lemon food product",
    "FOODON_03311166": "celery leaf (whole, raw)",
    "ENVO_01000923": "petting zoo",
    "NCBITaxon_75080": "Rubus odoratus",
    "FOODON_03540351": "03510 - popped cereals (efsa foodex2)",
    "FOODON_03302424": "grape juice drink",
    "NCBITaxon_89951": "Merluccius polli",
    "FOODON_03311125": "sour-mash whiskey",
    "FOODON_00003364": "chicken breast (skinless, boneless)",
    "FOODON_03400842": "non alcoholic beverage (eurofir)",
    "FOODON_00002305": "swine sandwich",
    "FOODON_03541295": "12950 - nigella seed (efsa foodex2)",
    "FOODON_03315592": "pear (dried)",
    "NCBITaxon_8517": "Iguana iguana",
    "FOODON_03414960": "partridge berry plant",
    "FOODON_03315919": "obsolete: chocolate product",
    "FOODON_03542426": "24260 - tuna, yellowfin (efsa foodex2)",
    "FOODON_03315953": "beverage (fruit juice based, energy reduced)",
    "FOODON_03303794": "lollipop (liquor-flavored)",
    "FOODON_03510133": "\"more\" label claim",
    "FOODON_03309037": "ocean fillet (raw)",
    "FOODON_03412581": "yellowfin sole",
    "FOODON_03540520": "05200 - mustard sprouts (efsa foodex2)",
    "FOODON_03304716": "tarragon dressing",
    "FOODON_03544343": "43430 - peanut flavour (efsa foodex2)",
    "FOODON_03543645": "36450 - marshmallow infusion roots (efsa foodex2)",
    "FOODON_03401647": "10006309 - squab/pigeon - prepared/processed (gs1 gpc)",
    "FOODON_03411585": "peach, freestone (plant)",
    "FOODON_03414194": "bishop's hat species",
    "FOODON_03460270": "food distillation process",
    "FOODON_03305446": "apple drink (artificially flavored, frozen concentrate)",
    "FOODON_03303581": "fynbo cheese (mini)",
    "GAZ_00000583": "Mauritania",
    "FOODON_03401541": "10006210 - in shell table eggs (gs1 gpc)",
    "FOODON_03304494": "semisoft cheese",
    "FOODON_03541188": "11880 - rapeseeds and similar- (efsa foodex2)",
    "NCBITaxon_8012": "Osmeridae",
    "FOODON_03400212": "stew or hash (us cfr)",
    "NCBITaxon_119203": "Selachii",
    "FOODON_03542774": "27740 - cheese, coulommiers (efsa foodex2)",
    "FOODON_03543489": "34890 - elder infusion leaves (efsa foodex2)",
    "FOODON_00002493": "sassafras food product",
    "FOODON_03510207": "contains {name of the nutrient or other substance} nutrition claim",
    "FOODON_03309433": "rainbow smelt (dressed)",
    "FOODON_03309559": "sauce for meat",
    "NCBITaxon_101007": "Fragaria chiloensis",
    "FOODON_00003150": "back bacon",
    "FOODON_03530041": "foot (meat cut)",
    "FOODON_03304141": "hamburger seasoning mix",
    "FOODON_03302151": "beverage tablet (fruit-flavored, artificially sweetened)",
    "UO_0000098": "milliliter",
    "FOODON_03413813": "sevruga",
    "CHEBI_23229": "chromanol",
    "FOODON_00002387": "an",
    "FOODON_00001224": "sausage (cooked)",
    "FOODON_00002256": "soup base product",
    "FOODON_03311819": "chocolate bits (sugar syrup coated)",
    "NCBITaxon_43860": "Spondias",
    "FOODON_00001944": "hard candy food product",
    "FOODON_03530135": "quartier arriere",
    "FOODON_03412070": "vetch plant",
    "CHEBI_25216": "metalloporphyrin",
    "FOODON_03541478": "14780 - nashi pears (efsa foodex2)",
    "FOODON_03309685": "tua tua (raw)",
    "FOODON_03542656": "26560 - cow milk, semi skimmed (half fat) (efsa foodex2)",
    "FOODON_03542408": "24080 - herring, baltic (efsa foodex2)",
    "FOODON_03541045": "10450 - mat bean (fresh seeds) (efsa foodex2)",
    "FOODON_00003389": "industrial livestock production",
    "NCBITaxon_4567": "Triticum turgidum subsp. durum",
    "NCBITaxon_1648017": "Hordeinae",
    "FOODON_03306371": "flavoring concentrate for soft drink",
    "FOODON_03401319": "botanical supplement with multi-vitamin/mineral",
    "FOODON_03540578": "05780 - onions and similar- (efsa foodex2)",
    "CHEBI_53248": "poly(vinylpyrrolidone)",
    "FOODON_03306318": "asparagus pulp",
    "FOODON_03543915": "39150 - vegetables, gratinated (efsa foodex2)",
    "FOODON_03311557": "kenkey",
    "FOODON_00001188": "obsolete: milet food product",
    "FOODON_03308241": "spring lobster (raw)",
    "CHEBI_3309": "Calcium Gluconate",
    "FOODON_03307213": "spanish vetch",
    "FOODON_03311580": "beaufort cheese",
    "NCBITaxon_182853": "Raja miraletus",
    "FOODON_03303165": "sugar cookie",
    "FOODON_03316278": "dressing for fish",
    "FOODON_03414581": "tenericutes",
    "FOODON_03301605": "cottage cheese",
    "FOODON_03543208": "32080 - juice, carrot (efsa foodex2)",
    "FOODON_03307005": "cashew nut (shell on, raw)",
    "FOODON_03316748": "black currant nectar (non-pulpy)",
    "FOODON_03430146": "whole, shape achieved by forming, thickness bigger than 7 cm.",
    "FOODON_03306883": "doughnut (powdered)",
    "FOODON_03541874": "18740 - canned or jarred cranberry (efsa foodex2)",
    "FOODON_03540020": "00200 - finger millet grain (efsa foodex2)",
    "FOODON_03316487": "dinner concentrate (powdered)",
    "FOODON_03307922": "imitation vinegar (tablet)",
    "FOODON_03411786": "white mullet",
    "FOODON_03411282": "celery plant",
    "FOODON_03310567": "nondairy topping frozen",
    "FOODON_03309694": "fish paste (phillipine)",
    "FOODON_03541933": "19330 - goat, minced meat (efsa foodex2)",
    "FOODON_00001018": "cheese starter culture food product",
    "FOODON_03306687": "golden oriental grapefruit",
    "FOODON_03542924": "29240 - cheese, gubbeen (efsa foodex2)",
    "NCBITaxon_30853": "Monodactylidae",
    "FOODON_00003346": "overripe or decaying",
    "FOODON_03541515": "15150 - chickasaw plums (efsa foodex2)",
    "FOODON_03310467": "yogurt (nonfat, sweetened with aspartame)",
    "FOODON_03490364": "polyester container",
    "FOODON_03308031": "trumpeter (raw)",
    "NCBITaxon_31009": "Clariidae",
    "FOODON_03490429": "recycled paperboard container",
    "FOODON_00002464": "lobster meat (shell off)",
    "NCBITaxon_27717": "Tinca tinca",
    "FOODON_03309382": "atlantic steelhead (raw)",
    "FOODON_03543478": "34780 - cornflower infusion leaves (efsa foodex2)",
    "FOODON_03301250": "fig paste",
    "FOODON_03317359": "poultry (boneless, canned)",
    "FOODON_03307340": "watermelon juice (food product)",
    "FOODON_03316901": "vegetable fat ice (food product)",
    "FOODON_03542996": "29960 - galactose (efsa foodex2)",
    "ENVO_01000626": "drylot",
    "NCBITaxon_102976": "Euphausia pacifica",
    "FOODON_03307488": "filled milk mix (dry)",
    "FOODON_03304390": "cow milk (whole, reconstituted)",
    "FOODON_03305378": "white graham bread",
    "FOODON_03317523": "fat emulsion with a fat content less than 60%",
    "HANCESTRO_0558": "French Canadian founder",
    "FOODON_03542114": "21140 - corned pork, uncooked (efsa foodex2)",
    "GAZ_00007113": "United States Minor Outlying Islands",
    "FOODON_00003134": "mulberry food product",
    "FOODON_03541601": "16010 - red crowberries (efsa foodex2)",
    "FOODON_00001892": "fruit spread or sauce",
    "FOODON_03414082": "blue skate",
    "CHEBI_26712": "sodium molecular entity",
    "FOODON_03301446": "mung bean sprout (raw)",
    "FOODON_03306078": "bourbon-flavored jelly",
    "FOODON_03542782": "27820 - cheese, blue castello (efsa foodex2)",
    "FOODON_03541642": "16420 - dates (efsa foodex2)",
    "FOODON_03304750": "cheddar cheese sandwich",
    "CHEBI_83501": "acesulfame",
    "FOODON_03304451": "rice dinner",
    "FOODON_03414703": "bush raisin plant",
    "FOODON_00001225": "smoked meat food product",
    "FOODON_03411409": "crappie",
    "FOODON_03308273": "indian pompano (raw)",
    "FOODON_03316287": "vegetable (canned, sour)",
    "FOODON_03302656": "candy bar (with added caffeine)",
    "PATO_0001781": "irregular thickness",
    "FOODON_03301750": "forage (animal feed)",
    "FOODON_03317335": "beef (chopped)",
    "NCBITaxon_73102": "Gaultheria shallon",
    "FOODON_03316798": "grape (seedless, canned)",
    "FOODON_03401518": "10006390 - chewing gum (gs1 gpc)",
    "FOODON_03311698": "lobster tail (shell off)",
    "FOODON_03301908": "lemon tea (dry)",
    "NCBITaxon_1465300": "Diospyros sintenisii",
    "FOODON_03301538": "apricot paste",
    "FOODON_03302182": "beverage (artificially sweetened)",
    "FOODON_03310955": "mustard greens (frozen)",
    "FOODON_03540478": "04780 - white cabbage (efsa foodex2)",
    "FOODON_03490265": "ceramic or earthenware bottle, uncoloured",
    "FOODON_03400807": "margarine or lipid of mixed origin (eurofir)",
    "FOODON_00003284": "lemon zest",
    "FOODON_03308960": "blackfin snapper (raw)",
    "CHEBI_17621": "FMN",
    "FOODON_03311540": "breakfast cereal (cooked)",
    "FOODON_03541880": "18800 - asses-mules-hinnies carcase (efsa foodex2)",
    "FOODON_03544284": "42840 - hazelnut flavour (efsa foodex2)",
    "FOODON_03310448": "sweet chocolate",
    "HANCESTRO_0462": "British",
    "FOODON_03490346": "impregnated/micro waxed paper",
    "FOODON_03541918": "19180 - buffalo fresh meat (efsa foodex2)",
    "FOODON_03301670": "sake (food product)",
    "FOODON_03541193": "11930 - soyabeans and similar- (efsa foodex2)",
    "FOODON_03540106": "01060 - wheat semolina (efsa foodex2)",
    "FOODON_03315794": "goat milk (evaporated, skimmed)",
    "FOODON_00002623": "Gew\u00fcrztraminer wine",
    "FOODON_03541004": "10040 - sweet sorghum canes (efsa foodex2)",
    "FOODON_03401387": "50261600 - stem vegetables (gs1 gpc)",
    "CHEBI_78870": "sodium nitrite",
    "FOODON_03306332": "meat byproduct",
    "FOODON_03316725": "blue-veined cheese",
    "FOODON_03543138": "31380 - dairy fats (efsa foodex2)",
    "FOODON_03542624": "26240 - cod, dried (efsa foodex2)",
    "FOODON_03411823": "lumpfish",
    "FOODON_03544235": "42350 - chives flavour (efsa foodex2)",
    "FOODON_03541749": "17490 - akee apples (efsa foodex2)",
    "NCBITaxon_224717": "Anchoa",
    "FOODON_03414177": "grey oyster mushroom",
    "FOODON_03420190": "fat or oil",
    "CHEBI_36938": "nitrogen-14 atom",
    "FOODON_03544244": "42440 - cola flavour (efsa foodex2)",
    "HANCESTRO_0557": "Costa Rican founder",
    "FOODON_03306925": "pineapple tidbits (artificially sweetened, canned)",
    "FOODON_03450034": "cooking in water bath",
    "FOODON_03303568": "lime juice cordial",
    "NCBITaxon_89056": "Microstomus",
    "FOODON_03302912": "cheese flavoring (artificial)",
    "FOODON_03412269": "elephant fish",
    "FOODON_03302637": "buttercream frosting mix",
    "FOODON_03412315": "summer orange plant",
    "PATO_0045058": "normal circumference",
    "FOODON_03542516": "25160 - natantian decapods (efsa foodex2)",
    "FOODON_03400343": "packaging gas (ec)",
    "FOODON_03411466": "artichoke plant",
    "FOODON_03304594": "pickle (canned)",
    "UBERON_0000978": "leg",
    "FOODON_03303865": "blue cheese (dehydrated)",
    "FOODON_03541910": "19100 - mammals meat (efsa foodex2)",
    "FOODON_00001097": "fermented sugar cane beverage",
    "FOODON_03490178": "wood drum",
    "FOODON_03510254": "senior as food consumer",
    "FOODON_03411054": "blue ring octopus",
    "FOODON_03401438": "10005932 - gooseberries (gs1 gpc)",
    "FOODON_03470174": "vaccume storage process",
    "HANCESTRO_0410": "Grenadian",
    "FOODON_00002303": "obsolete: swine meat food product",
    "ENVO_00000295": "fish hatchery",
    "FOODON_03543427": "34270 - sugar beet coffee ingredient (efsa foodex2)",
    "FOODON_03530094": "edible sausage casing",
    "FOODON_03412579": "smooth oreo dory",
    "GAZ_00005328": "Tahiti",
    "FOODON_03510122": "unpurified or unrefined claim or use",
    "FOODON_03316221": "cereal-based product (energy reduced)",
    "FOODON_03301300": "pea (whole)",
    "FOODON_03400741": "036  poultry meat (including pigeon meat) (pm) (ccpr)",
    "FOODON_03412914": "black slickhead",
    "FOODON_03543818": "38180 - probiotic or prebiotic formulations (efsa foodex2)",
    "FOODON_03400105": "dressing, condiment, gravy or sauce (us cfr)",
    "FOODON_00002277": "stone fruit food product",
    "FOODON_03411102": "casaba melon plant",
    "FOODON_03315350": "starch syrup (concentrated solid form)",
    "FOODON_00003390": "controlled environment agriculture (CEA) production",
    "RO_0002608": "process has causal agent",
    "FOODON_00001702": "cauliflower (pickled) food product",
    "FOODON_03413433": "wormwood plant",
    "FOODON_03303425": "sugar raisin cookie",
    "FOODON_03412909": "slickhead family",
    "NCBITaxon_64142": "Anabantidae",
    "FOODON_03302020": "beef bouillon (reconstituted)",
    "FOODON_03400378": "bodying agent (codex)",
    "FOODON_03544176": "41760 - food colours (efsa foodex2)",
    "FOODON_00001802": "dairy product based dressing",
    "FOODON_03413563": "red rock crab",
    "FOODON_03412595": "smooth hammerhead",
    "PECO_0007036": "summer season exposure",
    "FOODON_03541124": "11240 - canarium nuts (efsa foodex2)",
    "FOODON_03415035": "buko plant",
    "FOODON_00002564": "chowder",
    "FOODON_03400844": "water (eurofir)",
    "FOODON_03542995": "29950 - lactose (efsa foodex2)",
    "FOODON_03303204": "corn sweetener",
    "FOODON_03315706": "breath-freshener product",
    "NCBITaxon_8164": "Lateolabrax japonicus",
    "FOODON_03414978": "melientha plant",
    "FOODON_03542643": "26430 - salted seafood (efsa foodex2)",
    "FOODON_03541436": "14360 - oranges, sweet (efsa foodex2)",
    "FOODON_03414885": "hilsa shad",
    "FOODON_03541362": "13620 - temulawak roots (efsa foodex2)",
    "FOODON_03542808": "28080 - cheese, cornish yarg (efsa foodex2)",
    "FOODON_03414995": "santolina plant",
    "FOODON_03412212": "swimming crab family",
    "NCBITaxon_82423": "Tilia platyphyllos",
    "FOODON_03414625": "australian snapping turtle",
    "FOODON_03530232": "hazard 4",
    "FOODON_03414423": "sodium malates",
    "FOODON_03315084": "vegetable (processed)",
    "FOODON_03540076": "00760 - oat flour (efsa foodex2)",
    "FOODON_03420287": "seed aril",
    "FOODON_03307808": "vermouth",
    "FOODON_03305215": "venetian garlic",
    "FOODON_03317611": "balanced diet for special dietary use (teenagers and adults)",
    "FOODON_03304775": "akee and saltfish",
    "NCBITaxon_428034": "Atheresthes stomias",
    "BFO_0000034": "function",
    "FOODON_03305340": "raisin rye bread",
    "FOODON_03412988": "aluminium ammonium sulphate",
    "FOODON_03401774": "10006216 - soups - prepared variety packs (gs1 gpc)",
    "FOODON_03311630": "baking mix",
    "FOODON_03543987": "39870 - meat and vegetable soup, dry (efsa foodex2)",
    "FOODON_03543821": "38210 - coenzyme q10 formulations (efsa foodex2)",
    "FOODON_03530158": "breast (poultry meat cut)",
    "FOODON_03544193": "41930 - bacon flavour (efsa foodex2)",
    "FOODON_03400439": "salt substitute (codex)",
    "FOODON_03413560": "jonah crab",
    "FOODON_03304197": "oyster stew (condensed)",
    "FOODON_03315355": "kyungyook",
    "FOODON_03303913": "strawberry marmalade",
    "FOODON_03414145": "mactra surf shell family",
    "FOODON_03540132": "01320 - single grain bread and rolls (efsa foodex2)",
    "FOODON_03306513": "nut (roasted in vegetable oil)",
    "FOODON_03541009": "10090 - palms (trunk sap) (efsa foodex2)",
    "FOODON_03540397": "03970 - other lettuces and salad plants (efsa foodex2)",
    "NCBITaxon_27592": "Bovinae",
    "FOODON_03309087": "cod tail (raw)",
    "FOODON_03540034": "00340 - oat and similar- (efsa foodex2)",
    "FOODON_03413905": "spot",
    "FOODON_03543388": "33880 - spirits made from stone fruits (efsa foodex2)",
    "FOODON_03401339": "50252000 - fruits - unprepared/unprocessed (fresh) variety packs (gs1 gpc)",
    "FOODON_03304965": "imitation ice cream (sweetened with nutritive sweetener)",
    "FOODON_03412625": "calamondin plant",
    "FOODON_00001021": "acifified beer wort food product",
    "FOODON_03411196": "crowder pea plant",
    "FOODON_03411619": "obsolete: reindeer",
    "FOODON_03543909": "39090 - vegetable casserole (efsa foodex2)",
    "FOODON_03302213": "carrot juice",
    "FOODON_03540992": "09920 - roots used as sugar source (efsa foodex2)",
    "FOODON_03309488": "bushberry (whole, raw)",
    "FOODON_03412488": "silverfish",
    "GAZ_00005284": "Yemen",
    "FOODON_03530108": "food facility preparation process",
    "FOODON_03310221": "lowfat cow milk (calcium added)",
    "FOODON_03315536": "groats prepared from cereals",
    "FOODON_03305175": "gingerbread mix (dry)",
    "FOODON_03540861": "08610 - other species and hybrids of genus salvia, not elsewhere mentioned (efsa foodex2)",
    "FOODON_03411946": "new zealand commercial scallop",
    "FOODON_03412600": "broccoflower plant",
    "UBERON_0008979": "carcass",
    "FOODON_03302630": "butternut (whole, raw)",
    "FOODON_00002042": "miracle food product",
    "FOODON_03309703": "velvet bean (whole, raw)",
    "FOODON_03412583": "cubanelle pepper plant",
    "FOODON_03542877": "28770 - cheese, hoch ybrig (efsa foodex2)",
    "FOODON_03541021": "10210 - legumes (efsa foodex2)",
    "FOODON_03542436": "24360 - pomfret, indo-pacific (efsa foodex2)",
    "FOODON_03316791": "dewberry (canned)",
    "FOODON_03306587": "milk (spray-dried)",
    "FOODON_03412678": "silver warehou",
    "FOODON_03411377": "angelica plant",
    "FOODON_03309567": "marlin (raw)",
    "FOODON_03401673": "10006279 - mutton - unprepared/unprocessed (gs1 gpc)",
    "FOODON_03303736": "candy (artificially and naturally flavored)",
    "FOODON_03414517": "common cattail plant",
    "FOODON_03414580": "cytophagia",
    "FOODON_03412839": "bridelia plant",
    "FOODON_03540957": "09570 - potatoes and similar- (efsa foodex2)",
    "FOODON_03420109": "thymus or pancreas",
    "NCBITaxon_8788": "Dromaiidae",
    "FOODON_03400315": "cheese hardness class (codex)",
    "FOODON_03305577": "mahi mahi (frozen)",
    "FOODON_03310965": "artichoke heart (frozen)",
    "FOODON_03401262": "1050000 - amphibians and reptiles (ec)",
    "GAZ_00006883": "Antigua and Barbuda",
    "FOODON_03543332": "33320 - beer (efsa foodex2)",
    "FOODON_03301816": "chocolate milk (whole)",
    "NCBITaxon_39556": "Grapsidae",
    "FOODON_00003029": "beef steak",
    "FOODON_00001617": "artichoke vegetable food product",
    "FOODON_03316599": "crystalized invert sugar",
    "FOODON_03414285": "moonfish",
    "FOODON_03544075": "40750 - stock cube or granulate, beef (efsa foodex2)",
    "FOODON_03311242": "obsolete: food, low calorie",
    "FOODON_03540748": "07480 - spanish salsifies (efsa foodex2)"
};

export default foodOn;